export default [
  {
    level: 0,
    code: 'A00-B99',
    description: 'Ciertas enfermedades infecciosas y parasitarias'
  },
  { level: 0, code: 'C00-D49', description: 'Tumores [neoplasias]' },
  {
    level: 0,
    code: 'D50-D89',
    description:
      'Enfermedades de la sangre y de los \u00f3rganos hematopoy\u00e9ticos, y ciertos trastornos que afectan el mecanismo de la inmunidad'
  },
  {
    level: 0,
    code: 'E00-E89',
    description: 'Enfermedades endocrinas, nutricionales y metabolicas'
  },
  {
    level: 0,
    code: 'F01-F99',
    description: 'Trastornos mentales y del comportamiento'
  },
  {
    level: 0,
    code: 'G00-G99',
    description: 'Enfermedades del sistema nervioso'
  },
  {
    level: 0,
    code: 'H00-H59',
    description: 'Enfermedades del ojo y sus anexos'
  },
  {
    level: 0,
    code: 'H60-H95',
    description: 'Enfermedades del o\u00eddo y de la ap\u00f3fisis mastoides'
  },
  {
    level: 0,
    code: 'I00-I99',
    description: 'Enfermedades del sistema circulatorio'
  },
  {
    level: 0,
    code: 'J00-J99',
    description: 'Enfermedades del sistema respiratorio'
  },
  {
    level: 0,
    code: 'K00-K95',
    description: 'Enfermedades del sistema digestivo'
  },
  {
    level: 0,
    code: 'L00-L99',
    description: 'Enfermedades de la piel y del tejido subcut\u00e1neo'
  },
  {
    level: 0,
    code: 'M00-M99',
    description:
      'Enfermedades del sistema osteomuscular y del tejido conjuntivo'
  },
  {
    level: 0,
    code: 'N00-N99',
    description: 'Enfermedades del sistema genitourinario'
  },
  { level: 0, code: 'O00-O9A', description: 'Embarazo, parto y puerperio' },
  {
    level: 0,
    code: 'P00-P96',
    description: 'Ciertas afecciones originadas en el per\u00edodo perinatal'
  },
  {
    level: 0,
    code: 'Q00-Q99',
    description:
      'Malformaciones cong\u00e9nitas, deformidades y anomal\u00edas cromos\u00f3micas'
  },
  {
    level: 0,
    code: 'R00-R99',
    description:
      ' S\u00edntomas, signos y hallazgos anormales cl\u00ednicos y de laboratorio, no clasificados en otra parte'
  },
  {
    level: 0,
    code: 'S00-T88',
    description:
      'Traumatismos, envenenamientos y algunas otras consecuencias de causas externas'
  },
  {
    level: 0,
    code: 'V01-Y99',
    description: 'Causas externas de morbilidad y de mortalidad'
  },
  {
    level: 0,
    code: 'Z00-Z99',
    description:
      'Factores que influyen en el estado de salud y contacto con los servicios de salud'
  },
  {
    code: 'H60-H62',
    level: 1,
    description: 'Enfermedades del o\u00eddo externo',
    code_0: 'H60-H95'
  },
  {
    code: 'H65-H75',
    level: 1,
    description: 'Enfermedades del o\u00eddo medio y de la mastoides',
    code_0: 'H60-H95'
  },
  {
    code: 'H80-H83',
    level: 1,
    description: 'Enfermedades del o\u00eddo interno',
    code_0: 'H60-H95'
  },
  {
    code: 'H90-H95',
    level: 1,
    description: 'Otros trastornos del o\u00eddo',
    code_0: 'H60-H95'
  },
  {
    code: 'H00-H06',
    level: 1,
    description: 'Trastornos del p\u00e1rpado, aparato lagrimal y \u00f3rbita',
    code_0: 'H00-H59'
  },
  {
    code: 'H10-H13',
    level: 1,
    description: 'Trastornos de la conjuntiva',
    code_0: 'H00-H59'
  },
  {
    code: 'H15-H22',
    level: 1,
    description:
      'Trastornos de la escler\u00f3tica, c\u00f3rnea, iris y cuerpo ciliar',
    code_0: 'H00-H59'
  },
  {
    code: 'G00-G09',
    level: 1,
    description: 'Enfermedades inflamatorias del sistema nervioso central',
    code_0: 'G00-G99'
  },
  {
    code: 'G10-G13',
    level: 1,
    description:
      'Atrofias sist\u00e9micas que afectan principalmente el sistema nervioso central',
    code_0: 'G00-G99'
  },
  {
    code: 'G20-G26',
    level: 1,
    description: 'Trastornos extrapiramidales y del movimiento',
    code_0: 'G00-G99'
  },
  {
    code: 'H25-H28',
    level: 1,
    description: 'Trastornos del cristalino',
    code_0: 'H00-H59'
  },
  {
    code: 'H30-H36',
    level: 1,
    description: 'Trastornos de la coroides y de la retina',
    code_0: 'H00-H59'
  },
  { code: 'H40-H42', level: 1, description: 'Glaucoma', code_0: 'H00-H59' },
  {
    code: 'H43-H45',
    level: 1,
    description: 'Trastornos del cuerpo v\u00edtreo y del globo ocular',
    code_0: 'H00-H59'
  },
  {
    code: 'H46-H48',
    level: 1,
    description:
      'Trastornos del nervio \u00f3ptico y de las v\u00edas \u00f3pticas',
    code_0: 'H00-H59'
  },
  {
    code: 'H49-H52',
    level: 1,
    description: 'binocular, de la acomodaci\u00f3n y de la refracci\u00f3n',
    code_0: 'H00-H59'
  },
  {
    code: 'H53-H54',
    level: 1,
    description: 'Alteraciones de la visi\u00f3n y ceguera',
    code_0: 'H00-H59'
  },
  {
    code: 'F00-F09',
    level: 1,
    description:
      'Trastornos mentales org\u00e1nicos, incluidos los trastornos sintom\u00e1ticos',
    code_0: 'F01-F99'
  },
  {
    code: 'F10-F19',
    level: 1,
    description:
      'Trastornos mentales y del comportamiento debidos al uso de sustancias psicoactivas',
    code_0: 'F01-F99'
  },
  {
    code: 'F20-F29',
    level: 1,
    description:
      'Esquizofrenia, trastornos esquizot\u00edpicos y trastornos delirantes',
    code_0: 'F01-F99'
  },
  {
    code: 'F30-F39',
    level: 1,
    description: 'Trastornos del humor [afectivos]',
    code_0: 'F01-F99'
  },
  {
    code: 'F40-F48',
    level: 1,
    description:
      'Trastornos neur\u00f3ticos, trastornos relacionados con el estr\u00e9s y trastornos somatomorfos',
    code_0: 'F01-F99'
  },
  {
    code: 'E00-E07',
    level: 1,
    description: 'Trastornos de la gl\u00e1ndula tiroides',
    code_0: 'E00-E89'
  },
  {
    code: 'E10-E14',
    level: 1,
    description: 'Diabetes mellitus',
    code_0: 'E00-E89'
  },
  {
    code: 'E15-E16',
    level: 1,
    description:
      'Otros trastornos de la regulaci\u00f3n de la glucosa y de la secreci\u00f3n interna del p\u00e1ncreas',
    code_0: 'E00-E89'
  },
  {
    code: 'E20-E35',
    level: 1,
    description: 'Trastornos de otras gl\u00e1ndulas endocrinas',
    code_0: 'E00-E89'
  },
  {
    code: 'D50-D53',
    level: 1,
    description: 'Anemias nutricionales',
    code_0: 'D50-D89'
  },
  {
    code: 'D55-D59',
    level: 1,
    description: 'Anemias hemol\u00edticas',
    code_0: 'D50-D89'
  },
  {
    code: 'D60-D64',
    level: 1,
    description: 'Anemias apl\u00e1sticas y otras anemias',
    code_0: 'D50-D89'
  },
  {
    code: 'D65-D69',
    level: 1,
    description:
      'Defectos de la coagulaci\u00f3n, p\u00farpura y otras afecciones hemorr\u00e1gicas',
    code_0: 'D50-D89'
  },
  {
    code: 'D70-D77',
    level: 1,
    description:
      'Otras enfermedades de la sangre y de los \u00f3rganos hematopoy\u00e9ticos',
    code_0: 'D50-D89'
  },
  {
    code: 'C00-C97',
    level: 1,
    description: 'Tumores [neoplasias] malignos',
    code_0: 'C00-D49'
  },
  {
    code: 'D00-D09',
    level: 1,
    description: 'Tumores [neoplasias] in situ',
    code_0: 'C00-D49'
  },
  {
    code: 'D10-D36',
    level: 1,
    description: 'Tumores [neoplasias] benignos',
    code_0: 'C00-D49'
  },
  {
    code: 'D37-D48',
    level: 1,
    description:
      'Tumores [neoplasias] de comportamiento incierto o desconocido',
    code_0: 'C00-D49'
  },
  {
    code: 'G30-G32',
    level: 1,
    description: 'Otras enfermedades degenerativas del sistema nervioso',
    code_0: 'G00-G99'
  },
  {
    code: 'G35-G37',
    level: 1,
    description: 'Enfermedades desmielinizantes del sistema nervioso central',
    code_0: 'G00-G99'
  },
  {
    code: 'G40-G47',
    level: 1,
    description: 'Trastornos epis\u00f3dicos y parox\u00edsticos',
    code_0: 'G00-G99'
  },
  {
    code: 'G50-G59',
    level: 1,
    description:
      'Trastornos de los nervios, de las ra\u00edces y de los plexos nerviosos',
    code_0: 'G00-G99'
  },
  {
    code: 'G60-G64',
    level: 1,
    description:
      'Polineuropat\u00edas y otros trastornos del sistema nervioso perif\u00e9rico',
    code_0: 'G00-G99'
  },
  {
    code: 'G70-G73',
    level: 1,
    description: 'Enfermedades musculares y de la uni\u00f3n neuromuscular',
    code_0: 'G00-G99'
  },
  {
    code: 'G80-G83',
    level: 1,
    description:
      'Par\u00e1lisis cerebral y otros s\u00edndromes paral\u00edticos',
    code_0: 'G00-G99'
  },
  {
    code: 'G90-G99',
    level: 1,
    description: 'Otros trastornos del sistema nervioso',
    code_0: 'G00-G99'
  },
  {
    code: 'A00-A09',
    level: 1,
    description: 'Enfermedades infecciosas intestinales',
    code_0: 'A00-B99'
  },
  { code: 'A15-A19', level: 1, description: 'Tuberculosis', code_0: 'A00-B99' },
  {
    code: 'H55-H59',
    level: 1,
    description: 'Otros trastornos del ojo y sus anexos',
    code_0: 'H00-H59'
  },
  {
    code: 'F50-F59',
    level: 1,
    description:
      'S\u00edndromes del comportamiento asociados con alteraciones fisiol\u00f3gicas y factores f\u00edsicos',
    code_0: 'F01-F99'
  },
  {
    code: 'F60-F69',
    level: 1,
    description:
      'Trastornos de la personalidad y del comportamiento en adultos',
    code_0: 'F01-F99'
  },
  {
    code: 'F70-F79',
    level: 1,
    description: 'Retraso mental',
    code_0: 'F01-F99'
  },
  {
    code: 'F80-F89',
    level: 1,
    description: 'Trastornos del desarrollo psicol\u00f3gico',
    code_0: 'F01-F99'
  },
  {
    code: 'F90-F98',
    level: 1,
    description:
      'Trastornos emocionales y del comportamiento que aparecen habitualmente en la ni\u00f1ez y en la adolescencia',
    code_0: 'F01-F99'
  },
  {
    code: 'F99',
    level: 1,
    description: 'Trastorno mental, no especificado',
    code_0: 'F01-F99'
  },
  {
    code: 'S00-S09',
    level: 1,
    description: 'Traumatismos de la cabeza',
    code_0: 'S00-T88'
  },
  {
    code: 'S10-S19',
    level: 1,
    description: 'Traumatismos del cuello',
    code_0: 'S00-T88'
  },
  {
    code: 'S20-S29',
    level: 1,
    description: 'Traumatismos del t\u00f3rax',
    code_0: 'S00-T88'
  },
  {
    code: 'S30-S39',
    level: 1,
    description:
      'Traumatismos del abdomen, de la regi\u00f3n lumbosacra, de la columna lumbar y de la pelvis',
    code_0: 'S00-T88'
  },
  {
    code: 'R00-R09',
    level: 1,
    description:
      'S\u00edntomas y signos que involucran los sistemas circulatorio y respiratorio',
    code_0: 'R00-R99'
  },
  {
    code: 'R10-R19',
    level: 1,
    description:
      'S\u00edntomas y signos que involucran el sistema digestivo y el abdomen',
    code_0: 'R00-R99'
  },
  {
    code: 'R20-R23',
    level: 1,
    description:
      'S\u00edntomas y signos que involucran la piel y el tejido subcut\u00e1neo',
    code_0: 'R00-R99'
  },
  {
    code: 'R25-R29',
    level: 1,
    description:
      'S\u00edntomas y signos que involucran los sistemas nervioso y osteomuscular',
    code_0: 'R00-R99'
  },
  {
    code: 'R30-R39',
    level: 1,
    description: 'S\u00edntomas y signos que involucran el sistema urinario',
    code_0: 'R00-R99'
  },
  {
    code: 'R40-R46',
    level: 1,
    description:
      'S\u00edntomas y signos que involucran el conocimiento, la percepci\u00f3n, el estado emocional y la conducta',
    code_0: 'R00-R99'
  },
  {
    code: 'R47-R49',
    level: 1,
    description: 'S\u00edntomas y signos que involucran el habla y la voz',
    code_0: 'R00-R99'
  },
  {
    code: 'Q00-Q07',
    level: 1,
    description: 'Malformaciones cong\u00e9nitas del sistema nervioso',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q10-Q18',
    level: 1,
    description:
      'Malformaciones cong\u00e9nitas del ojo, del o\u00eddo, de la cara y del cuello',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q20-Q28',
    level: 1,
    description: 'Malformaciones cong\u00e9nitas del sistema circulatorio',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q30-Q34',
    level: 1,
    description: 'Malformaciones cong\u00e9nitas del sistema respiratorio',
    code_0: 'Q00-Q99'
  },
  {
    code: 'E40-E46',
    level: 1,
    description: 'Desnutrici\u00f3n',
    code_0: 'E00-E89'
  },
  {
    code: 'E50-E64',
    level: 1,
    description: 'Otras deficiencias nutricionales',
    code_0: 'E00-E89'
  },
  {
    code: 'E65-E68',
    level: 1,
    description: 'Obesidad y otros tipos de hiperalimentaci\u00f3n',
    code_0: 'E00-E89'
  },
  {
    code: 'E70-E90',
    level: 1,
    description: 'Trastornos metab\u00f3licos',
    code_0: 'E00-E89'
  },
  {
    code: 'P00-P04',
    level: 1,
    description:
      'Feto y reci\u00e9n nacido afectados por factores maternos y por complicaciones del embarazo, del trabajo de parto y del parto',
    code_0: 'P00-P96'
  },
  {
    code: 'P05-P08',
    level: 1,
    description:
      'Trastornos relacionados con la duraci\u00f3n de la gestaci\u00f3n y el crecimiento fetal',
    code_0: 'P00-P96'
  },
  {
    code: 'P10-P15',
    level: 1,
    description: 'Traumatismo del nacimiento',
    code_0: 'P00-P96'
  },
  {
    code: 'P20-P29',
    level: 1,
    description:
      'Trastornos respiratorios y cardiovasculares espec\u00edficos del per\u00edodo perinatal',
    code_0: 'P00-P96'
  },
  {
    code: 'P35-P39',
    level: 1,
    description: 'Infecciones espec\u00edficas del per\u00edodo perinatal',
    code_0: 'P00-P96'
  },
  {
    code: 'P50-P61',
    level: 1,
    description:
      'Trastornos hemorr\u00e1gicos y hematol\u00f3gicos del feto y del reci\u00e9n nacido',
    code_0: 'P00-P96'
  },
  {
    code: 'P70-P74',
    level: 1,
    description:
      'Trastornos endocrinos y metab\u00f3licos transitorios espec\u00edficos del feto y del reci\u00e9n nacido',
    code_0: 'P00-P96'
  },
  {
    code: 'D80-D89',
    level: 1,
    description: 'Ciertos trastornos que afectan el mecanismo de la inmunidad',
    code_0: 'D50-D89'
  },
  {
    code: 'O00-O08',
    level: 1,
    description: 'Embarazo terminado en aborto',
    code_0: 'O00-O9A'
  },
  {
    code: 'O10-O16',
    level: 1,
    description:
      'Edema, proteinuria y trastornos hipertensivos en el embarazo, el parto y el puerperio',
    code_0: 'O00-O9A'
  },
  {
    code: 'O20-O29',
    level: 1,
    description:
      'Otros trastornos maternos relacionados principalmente con el embarazo',
    code_0: 'O00-O9A'
  },
  {
    code: 'O30-O48',
    level: 1,
    description:
      'Atenci\u00f3n materna relacionada con el feto y la cavidad amni\u00f3tica y con posibles problemas del parto',
    code_0: 'O00-O9A'
  },
  {
    code: 'N00-N08',
    level: 1,
    description: 'Enfermedades glomerulares',
    code_0: 'N00-N99'
  },
  {
    code: 'N10-N16',
    level: 1,
    description: 'Enfermedad renal tubulointersticial',
    code_0: 'N00-N99'
  },
  {
    code: 'N17-N19',
    level: 1,
    description: 'Insuficiencia renal',
    code_0: 'N00-N99'
  },
  {
    code: 'N20-N23',
    level: 1,
    description: 'Litiasis urinaria',
    code_0: 'N00-N99'
  },
  {
    code: 'N25-N29',
    level: 1,
    description: 'Otros trastornos del ri\u00f1\u00f3n y del ur\u00e9ter',
    code_0: 'N00-N99'
  },
  {
    code: 'A20-A28',
    level: 1,
    description: 'Ciertas zoonosis bacterianas',
    code_0: 'A00-B99'
  },
  {
    code: 'A30-A49',
    level: 1,
    description: 'Otras enfermedades bacterianas',
    code_0: 'A00-B99'
  },
  {
    code: 'A50-A64',
    level: 1,
    description: 'predominantemente sexual',
    code_0: 'A00-B99'
  },
  {
    code: 'A65-A69',
    level: 1,
    description: 'Otras enfermedades debidas a espiroquetas',
    code_0: 'A00-B99'
  },
  {
    code: 'A70-A74',
    level: 1,
    description: 'Otras enfermedades causadas por clamidias',
    code_0: 'A00-B99'
  },
  {
    code: 'A75-A79',
    level: 1,
    description: 'Rickettsiosis',
    code_0: 'A00-B99'
  },
  {
    code: 'A80-A89',
    level: 1,
    description: 'Infecciones virales del sistema nervioso central',
    code_0: 'A00-B99'
  },
  {
    code: 'A90-A99',
    level: 1,
    description:
      'Fiebres virales transmitidas por artr\u00f3podos y fiebres virales hemorr\u00e1gicas',
    code_0: 'A00-B99'
  },
  {
    code: 'B00-B09',
    level: 1,
    description:
      'Infecciones virales caracterizadas por lesiones de la piel y de las membranas mucosas',
    code_0: 'A00-B99'
  },
  {
    code: 'M00-M25',
    level: 1,
    description: 'Artropat\u00edas',
    code_0: 'M00-M99'
  },
  {
    code: 'M30-M36',
    level: 1,
    description: 'Trastornos sist\u00e9micos del tejido conjuntivo',
    code_0: 'M00-M99'
  },
  {
    code: 'M40-M54',
    level: 1,
    description: 'Dorsopat\u00edas',
    code_0: 'M00-M99'
  },
  {
    code: 'M60-M79',
    level: 1,
    description: 'Trastornos de los tejidos blandos',
    code_0: 'M00-M99'
  },
  {
    code: 'M80-M94',
    level: 1,
    description: 'Osteopat\u00edas y condropat\u00edas',
    code_0: 'M00-M99'
  },
  {
    code: 'L00-L08',
    level: 1,
    description: 'Infecciones de la piel y del tejido subcut\u00e1neo',
    code_0: 'L00-L99'
  },
  {
    code: 'L10-L14',
    level: 1,
    description: 'Trastornos flictenulares',
    code_0: 'L00-L99'
  },
  {
    code: 'L20-L30',
    level: 1,
    description: 'Dermatitis y eczema',
    code_0: 'L00-L99'
  },
  {
    code: 'L40-L45',
    level: 1,
    description: 'Trastornos papuloescamosos',
    code_0: 'L00-L99'
  },
  {
    code: 'L50-L54',
    level: 1,
    description: 'Urticaria y eritema',
    code_0: 'L00-L99'
  },
  {
    code: 'K00-K14',
    level: 1,
    description:
      'Enfermedades de la cavidad bucal, de las gl\u00e1ndulas salivales y de los maxilares',
    code_0: 'K00-K95'
  },
  {
    code: 'K20-K31',
    level: 1,
    description:
      'Enfermedades del es\u00f3fago, del est\u00f3mago y del duodeno',
    code_0: 'K00-K95'
  },
  {
    code: 'K35-K38',
    level: 1,
    description: 'Enfermedades del ap\u00e9ndice',
    code_0: 'K00-K95'
  },
  { code: 'K40-K46', level: 1, description: 'Hernia', code_0: 'K00-K95' },
  {
    code: 'K50-K52',
    level: 1,
    description: 'Enteritis y colitis no infecciosas',
    code_0: 'K00-K95'
  },
  {
    code: 'K55-K63',
    level: 1,
    description: 'Otras enfermedades de los intestinos',
    code_0: 'K00-K95'
  },
  {
    code: 'J00-J06',
    level: 1,
    description: 'Infecciones agudas de las v\u00edas respiratorias superiores',
    code_0: 'J00-J99'
  },
  {
    code: 'J09-J18 ',
    level: 1,
    description: 'Influenza [gripe] y neumon\u00eda ',
    code_0: 'J00-J99'
  },
  {
    code: 'J20-J22',
    level: 1,
    description:
      'Otras infecciones agudas de las v\u00edas respiratorias inferiores',
    code_0: 'J00-J99'
  },
  {
    code: 'J30-J39 ',
    level: 1,
    description: 'Otras enfermedades de las v\u00edas respiratorias superiores',
    code_0: 'J00-J99'
  },
  {
    code: 'I00-I02',
    level: 1,
    description: 'Fiebre reum\u00e1tica aguda',
    code_0: 'I00-I99'
  },
  {
    code: 'I05-I09',
    level: 1,
    description: 'Enfermedades card\u00edacas reum\u00e1ticas cr\u00f3nicas',
    code_0: 'I00-I99'
  },
  {
    code: 'I10-I15',
    level: 1,
    description: 'Enfermedades hipertensivas',
    code_0: 'I00-I99'
  },
  {
    code: 'I20-I25',
    level: 1,
    description: 'Enfermedades isqu\u00e9micas del coraz\u00f3n',
    code_0: 'I00-I99'
  },
  {
    code: 'S40-S49',
    level: 1,
    description: 'Traumatismos del hombro y del brazo',
    code_0: 'S00-T88'
  },
  {
    code: 'S50-S59',
    level: 1,
    description: 'Traumatismos del antebrazo y del codo',
    code_0: 'S00-T88'
  },
  {
    code: 'S60-S69',
    level: 1,
    description: 'Traumatismos de la mu\u00f1eca y de la mano',
    code_0: 'S00-T88'
  },
  {
    code: 'S70-S79',
    level: 1,
    description: 'Traumatismos de la cadera y del muslo',
    code_0: 'S00-T88'
  },
  {
    code: 'S80-S89',
    level: 1,
    description: 'Traumatismos de la rodilla y de la pierna',
    code_0: 'S00-T88'
  },
  {
    code: 'S90-S99',
    level: 1,
    description: 'Traumatismos del tobillo y del pie',
    code_0: 'S00-T88'
  },
  {
    code: 'T00-T07',
    level: 1,
    description: 'Traumatismos que afectan m\u00faltiples regiones del cuerpo',
    code_0: 'S00-T88'
  },
  {
    code: 'Z00-Z13',
    level: 1,
    description:
      'Personas en contacto con los servicios de salud para investigaci\u00f3n y ex\u00e1menes',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z20-Z29',
    level: 1,
    description:
      'Personas con riesgos potenciales para su salud, relacionados con enfermedades transmisibles',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z30-Z39',
    level: 1,
    description:
      'Personas en contacto con los servicios de salud en circunstancias relacionadas con la reproducci\u00f3n',
    code_0: 'Z00-Z99'
  },
  { code: 'V01-X59', level: 1, description: 'Accidentes', code_0: 'V01-Y99' },
  {
    code: 'X60-X84',
    level: 1,
    description: 'Lesiones autoinfligidas intencionalmente',
    code_0: 'V01-Y99'
  },
  { code: 'X85-Y09', level: 1, description: 'Agresiones', code_0: 'V01-Y99' },
  {
    code: 'Y10-Y34',
    level: 1,
    description: 'Eventos de intenci\u00f3n no determinada',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y35-Y36',
    level: 1,
    description: 'Intervenci\u00f3n legal y operaciones de guerra',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y40-Y84',
    level: 1,
    description:
      'Complicaciones de la atenci\u00f3n m\u00e9dica y quir\u00fargica',
    code_0: 'V01-Y99'
  },
  {
    code: 'H90',
    level: 2,
    description: 'Hipoacusia conductiva y neurosensorial',
    code_1: 'H90-H95',
    code_0: 'H60-H95'
  },
  {
    code: 'H91',
    level: 2,
    description: 'Otras hipoacusias',
    code_1: 'H90-H95',
    code_0: 'H60-H95'
  },
  {
    code: 'H92',
    level: 2,
    description: 'Otalgia y secreci\u00f3n del o\u00eddo',
    code_1: 'H90-H95',
    code_0: 'H60-H95'
  },
  {
    code: 'H80',
    level: 2,
    description: 'Otosclerosis',
    code_1: 'H80-H83',
    code_0: 'H60-H95'
  },
  {
    code: 'H81',
    level: 2,
    description: 'Trastornos de la funci\u00f3n vestibular',
    code_1: 'H80-H83',
    code_0: 'H60-H95'
  },
  {
    code: 'H82',
    level: 2,
    description:
      'S\u00edndromes vertiginosos en enfermedades clasificadas en otra parte',
    code_1: 'H80-H83',
    code_0: 'H60-H95'
  },
  {
    code: 'H83',
    level: 2,
    description: 'Otros trastornos del o\u00eddo interno',
    code_1: 'H80-H83',
    code_0: 'H60-H95'
  },
  {
    code: 'H65',
    level: 2,
    description: 'Otitis media no supurativa',
    code_1: 'H65-H75',
    code_0: 'H60-H95'
  },
  {
    code: 'H66',
    level: 2,
    description: 'Otitis media supurativa y la no especificada',
    code_1: 'H65-H75',
    code_0: 'H60-H95'
  },
  {
    code: 'H67',
    level: 2,
    description: 'Otitis media en enfermedades clasificadas en otra parte',
    code_1: 'H65-H75',
    code_0: 'H60-H95'
  },
  {
    code: 'H60',
    level: 2,
    description: 'Otitis externa',
    code_1: 'H60-H62',
    code_0: 'H60-H95'
  },
  {
    code: 'H61',
    level: 2,
    description: 'Otros trastornos del o\u00eddo externo',
    code_1: 'H60-H62',
    code_0: 'H60-H95'
  },
  {
    code: 'H62',
    level: 2,
    description:
      'Trastornos del o\u00eddo externo en enfermedades clasificadas en otra parte',
    code_1: 'H60-H62',
    code_0: 'H60-H95'
  },
  {
    code: 'H15',
    level: 2,
    description: 'Trastornos de la escler\u00f3tica',
    code_1: 'H15-H22',
    code_0: 'H00-H59'
  },
  {
    code: 'H16',
    level: 2,
    description: 'Queratitis',
    code_1: 'H15-H22',
    code_0: 'H00-H59'
  },
  {
    code: 'H17',
    level: 2,
    description: 'Opacidades y cicatrices corneales',
    code_1: 'H15-H22',
    code_0: 'H00-H59'
  },
  {
    code: 'H18',
    level: 2,
    description: 'Otros trastornos de la c\u00f3rnea',
    code_1: 'H15-H22',
    code_0: 'H00-H59'
  },
  {
    code: 'H19',
    level: 2,
    description:
      'Trastornos de la escler\u00f3tica y de la c\u00f3rnea en enfermedades clasificadas en otra parte',
    code_1: 'H15-H22',
    code_0: 'H00-H59'
  },
  {
    code: 'H20',
    level: 2,
    description: 'Iridociclitis',
    code_1: 'H15-H22',
    code_0: 'H00-H59'
  },
  {
    code: 'H21',
    level: 2,
    description: 'Otros trastornos del iris y del cuerpo ciliar',
    code_1: 'H15-H22',
    code_0: 'H00-H59'
  },
  {
    code: 'H22',
    level: 2,
    description:
      'Trastornos del iris y del cuerpo ciliar en enfermedades clasificadas en otra parte',
    code_1: 'H15-H22',
    code_0: 'H00-H59'
  },
  {
    code: 'R50-R69',
    level: 1,
    description: 'S\u00edntomas y signos generales',
    code_0: 'R00-R99'
  },
  {
    code: 'R70-R79',
    level: 1,
    description: 'sin diagn\u00f3stico',
    code_0: 'R00-R99'
  },
  {
    code: 'R80-R82',
    level: 1,
    description:
      'Hallazgos anormales en el examen de orina, sin diagn\u00f3stico',
    code_0: 'R00-R99'
  },
  {
    code: 'R83-R89',
    level: 1,
    description:
      'Hallazgos anormales en el examen de otros l\u00edquidos, sustancias y tejidos corporales, sin diagn\u00f3stico',
    code_0: 'R00-R99'
  },
  {
    code: 'R90-R94',
    level: 1,
    description:
      'Hallazgos anormales en diagn\u00f3stico por im\u00e1genes y en estudios funcionales, sin diagn\u00f3stico',
    code_0: 'R00-R99'
  },
  {
    code: 'R95-R99',
    level: 1,
    description: 'Causas de mortalidad mal definidas y desconocidas',
    code_0: 'R00-R99'
  },
  {
    code: 'H10',
    level: 2,
    description: 'Conjuntivitis',
    code_1: 'H10-H13',
    code_0: 'H00-H59'
  },
  {
    code: 'H11',
    level: 2,
    description: 'Otros trastornos de la conjuntiva',
    code_1: 'H10-H13',
    code_0: 'H00-H59'
  },
  {
    code: 'H13',
    level: 2,
    description:
      'Trastornos de la conjuntiva en enfermedades clasificadas en otra parte',
    code_1: 'H10-H13',
    code_0: 'H00-H59'
  },
  {
    code: 'Q35-Q37',
    level: 1,
    description: 'Fisura del paladar y labio leporino',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q38-Q45',
    level: 1,
    description: 'Otras malformaciones cong\u00e9nitas del sistema digestivo',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q50-Q56',
    level: 1,
    description: 'Malformaciones cong\u00e9nitas de los \u00f3rganos genitales',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q60-Q64',
    level: 1,
    description: 'Malformaciones cong\u00e9nitas del sistema urinario',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q65-Q79',
    level: 1,
    description:
      'Malformaciones y deformidades cong\u00e9nitas del sistema osteomuscular',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q80-Q89',
    level: 1,
    description: 'Otras malformaciones cong\u00e9nitas',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q90-Q99',
    level: 1,
    description:
      'Anomal\u00edas cromos\u00f3micas, no clasificadas en otra parte',
    code_0: 'Q00-Q99'
  },
  {
    code: 'H00',
    level: 2,
    description: 'Orzuelo y calacio',
    code_1: 'H00-H06',
    code_0: 'H00-H59'
  },
  {
    code: 'H01',
    level: 2,
    description: 'Otras inflamaciones del p\u00e1rpado',
    code_1: 'H00-H06',
    code_0: 'H00-H59'
  },
  {
    code: 'H02',
    level: 2,
    description: 'Otros trastornos de los p\u00e1rpados',
    code_1: 'H00-H06',
    code_0: 'H00-H59'
  },
  {
    code: 'H03',
    level: 2,
    description:
      'Trastornos del p\u00e1rpado en enfermedades clasificadas en otra parte',
    code_1: 'H00-H06',
    code_0: 'H00-H59'
  },
  {
    code: 'H04',
    level: 2,
    description: 'Trastornos del aparato lagrimal',
    code_1: 'H00-H06',
    code_0: 'H00-H59'
  },
  {
    code: 'H05',
    level: 2,
    description: 'Trastornos de la \u00f3rbita',
    code_1: 'H00-H06',
    code_0: 'H00-H59'
  },
  {
    code: 'H06',
    level: 2,
    description:
      'Trastornos del aparato lagrimal y de la \u00f3rbita en enfermedades clasificadas en otra parte',
    code_1: 'H00-H06',
    code_0: 'H00-H59'
  },
  {
    code: 'P75-P78',
    level: 1,
    description:
      'Trastornos del sistema digestivo del feto y del reci\u00e9n nacido',
    code_0: 'P00-P96'
  },
  {
    code: 'P80-P83',
    level: 1,
    description:
      'Afecciones asociadas con la regulaci\u00f3n tegumentaria y la temperatura del feto y del reci\u00e9n nacido',
    code_0: 'P00-P96'
  },
  {
    code: 'P90-P96',
    level: 1,
    description: 'Otros trastornos originados en el per\u00edodo perinatal',
    code_0: 'P00-P96'
  },
  {
    code: 'O60-O75',
    level: 1,
    description: 'Complicaciones del trabajo de parto y del parto',
    code_0: 'O00-O9A'
  },
  { code: 'O80-O84', level: 1, description: 'Parto', code_0: 'O00-O9A' },
  {
    code: 'O85-O92',
    level: 1,
    description: 'Complicaciones principalmente relacionadas con el puerperio',
    code_0: 'O00-O9A'
  },
  {
    code: 'O94-O99',
    level: 1,
    description:
      'Otras afecciones obst\u00e9tricas no clasificadas en otra parte',
    code_0: 'O00-O9A'
  },
  {
    code: 'F40',
    level: 2,
    description: 'Trastornos f\u00f3bicos de ansiedad',
    code_1: 'F40-F48',
    code_0: 'F01-F99'
  },
  {
    code: 'F41',
    level: 2,
    description: 'Otros trastornos de ansiedad',
    code_1: 'F40-F48',
    code_0: 'F01-F99'
  },
  {
    code: 'F42',
    level: 2,
    description: 'Trastorno obsesivo-compulsivo',
    code_1: 'F40-F48',
    code_0: 'F01-F99'
  },
  {
    code: 'F43',
    level: 2,
    description:
      'Reacci\u00f3n al estr\u00e9s grave y trastornos de adaptaci\u00f3n',
    code_1: 'F40-F48',
    code_0: 'F01-F99'
  },
  {
    code: 'F44',
    level: 2,
    description: 'Trastornos disociativos [de conversi\u00f3n]',
    code_1: 'F40-F48',
    code_0: 'F01-F99'
  },
  {
    code: 'F45',
    level: 2,
    description: 'Trastornos somatomorfos',
    code_1: 'F40-F48',
    code_0: 'F01-F99'
  },
  {
    code: 'F48',
    level: 2,
    description: 'Otros trastornos neur\u00f3ticos',
    code_1: 'F40-F48',
    code_0: 'F01-F99'
  },
  {
    code: 'N30-N39',
    level: 1,
    description: 'Otras enfermedades del sistema urinario',
    code_0: 'N00-N99'
  },
  {
    code: 'N40-N51',
    level: 1,
    description: 'Enfermedades de los \u00f3rganos genitales masculinos',
    code_0: 'N00-N99'
  },
  {
    code: 'N60-N64',
    level: 1,
    description: 'Trastornos de la mama',
    code_0: 'N00-N99'
  },
  {
    code: 'N70-N77',
    level: 1,
    description:
      'Enfermedades inflamatorias de los \u00f3rganos p\u00e9lvicos femeninos',
    code_0: 'N00-N99'
  },
  {
    code: 'N80-N98',
    level: 1,
    description:
      'Trastornos no inflamatorios de los \u00f3rganos genitales femeninos',
    code_0: 'N00-N99'
  },
  {
    code: 'N99',
    level: 1,
    description:
      'Trastornos del sistema genitourinario consecutivos a procedimientos, no clasificados en otra parte',
    code_0: 'N00-N99'
  },
  {
    code: 'F30',
    level: 2,
    description: 'Episodio man\u00edaco',
    code_1: 'F30-F39',
    code_0: 'F01-F99'
  },
  {
    code: 'F31',
    level: 2,
    description: 'Trastorno afectivo bipolar',
    code_1: 'F30-F39',
    code_0: 'F01-F99'
  },
  {
    code: 'F32',
    level: 2,
    description: 'Episodio depresivo',
    code_1: 'F30-F39',
    code_0: 'F01-F99'
  },
  {
    code: 'F33',
    level: 2,
    description: 'Trastorno depresivo recurrente',
    code_1: 'F30-F39',
    code_0: 'F01-F99'
  },
  {
    code: 'F34',
    level: 2,
    description: 'Trastornos del humor [afectivos] persistentes',
    code_1: 'F30-F39',
    code_0: 'F01-F99'
  },
  {
    code: 'F38',
    level: 2,
    description: 'Otros trastornos del humor [afectivos]',
    code_1: 'F30-F39',
    code_0: 'F01-F99'
  },
  {
    code: 'F39',
    level: 2,
    description: 'Trastorno del humor [afectivo], no especificado',
    code_1: 'F30-F39',
    code_0: 'F01-F99'
  },
  {
    code: 'F20',
    level: 2,
    description: 'Esquizofrenia',
    code_1: 'F20-F29',
    code_0: 'F01-F99'
  },
  {
    code: 'F21',
    level: 2,
    description: 'Trastorno esquizot\u00edpico',
    code_1: 'F20-F29',
    code_0: 'F01-F99'
  },
  {
    code: 'F22',
    level: 2,
    description: 'Trastornos delirantes persistentes',
    code_1: 'F20-F29',
    code_0: 'F01-F99'
  },
  {
    code: 'F23',
    level: 2,
    description: 'Trastornos psic\u00f3ticos agudos y transitorios',
    code_1: 'F20-F29',
    code_0: 'F01-F99'
  },
  {
    code: 'F24',
    level: 2,
    description: 'Trastorno delirante inducido',
    code_1: 'F20-F29',
    code_0: 'F01-F99'
  },
  {
    code: 'B15-B19',
    level: 1,
    description: 'Hepatitis viral',
    code_0: 'A00-B99'
  },
  {
    code: 'B20-B24',
    level: 1,
    description:
      'Enfermedad por virus de la inmunodeficiencia \u00adhumana [VIH]',
    code_0: 'A00-B99'
  },
  {
    code: 'B25-B34',
    level: 1,
    description: 'Otras enfermedades virales',
    code_0: 'A00-B99'
  },
  { code: 'B35-B49', level: 1, description: 'Micosis', code_0: 'A00-B99' },
  {
    code: 'B50-B64',
    level: 1,
    description: 'Enfermedades debidas a protozoarios',
    code_0: 'A00-B99'
  },
  { code: 'B65-B83', level: 1, description: 'Helmintiasis', code_0: 'A00-B99' },
  {
    code: 'B85-B89',
    level: 1,
    description: 'Pediculosis, acariasis y otras infestaciones',
    code_0: 'A00-B99'
  },
  {
    code: 'B90-B94',
    level: 1,
    description: 'Secuelas de enfermedades infecciosas y parasitarias',
    code_0: 'A00-B99'
  },
  {
    code: 'B95-B97',
    level: 1,
    description: 'Bacterias, virus y otros agentes infecciosos',
    code_0: 'A00-B99'
  },
  {
    code: 'B99',
    level: 1,
    description: 'Otras enfermedades infecciosas y las no especificadas',
    code_0: 'A00-B99'
  },
  {
    code: 'F10',
    level: 2,
    description:
      'Trastornos mentales y del comportamiento \u00addebidos al uso de alcohol',
    code_1: 'F10-F19',
    code_0: 'F01-F99'
  },
  {
    code: 'F11',
    level: 2,
    description:
      'Trastornos mentales y del comportamiento \u00addebidos al uso de opi\u00e1ceos',
    code_1: 'F10-F19',
    code_0: 'F01-F99'
  },
  {
    code: 'F12',
    level: 2,
    description:
      'Trastornos mentales y del comportamiento debidos al uso de cannabinoides',
    code_1: 'F10-F19',
    code_0: 'F01-F99'
  },
  {
    code: 'F13',
    level: 2,
    description:
      'Trastornos mentales y del comportamiento debidos al uso de sedantes o hipn\u00f3ticos',
    code_1: 'F10-F19',
    code_0: 'F01-F99'
  },
  {
    code: 'F14',
    level: 2,
    description:
      'Trastornos mentales y del comportamiento debidos al uso de coca\u00edna',
    code_1: 'F10-F19',
    code_0: 'F01-F99'
  },
  {
    code: 'F15',
    level: 2,
    description:
      'Trastornos mentales y del comportamiento debidos al uso de otros estimulantes, incluida la cafe\u00edna',
    code_1: 'F10-F19',
    code_0: 'F01-F99'
  },
  {
    code: 'M95-M99',
    level: 1,
    description:
      'Otros trastornos del sistema osteomuscular y del tejido conjuntivo',
    code_0: 'M00-M99'
  },
  {
    code: 'F00',
    level: 2,
    description: 'Demencia en la enfermedad de Alzheimer (G30.\u2013)',
    code_1: 'F00-F09',
    code_0: 'F01-F99'
  },
  {
    code: 'F01',
    level: 2,
    description: 'Demencia vascular',
    code_1: 'F00-F09',
    code_0: 'F01-F99'
  },
  {
    code: 'F02',
    level: 2,
    description: 'Demencia en otras enfermedades clasificadas en otra parte',
    code_1: 'F00-F09',
    code_0: 'F01-F99'
  },
  {
    code: 'L55-L59',
    level: 1,
    description:
      'Trastornos de la piel y del tejido subcut\u00e1neo relacionados con radiaci\u00f3n',
    code_0: 'L00-L99'
  },
  {
    code: 'L60-L75',
    level: 1,
    description: 'Trastornos de las faneras',
    code_0: 'L00-L99'
  },
  {
    code: 'L80-L99',
    level: 1,
    description: 'Otros trastornos de la piel y del tejido subcut\u00e1neo',
    code_0: 'L00-L99'
  },
  {
    code: 'H53',
    level: 2,
    description: 'Alteraciones de la visi\u00f3n',
    code_1: 'H53-H54',
    code_0: 'H00-H59'
  },
  {
    code: 'H54',
    level: 2,
    description: 'Ceguera y disminuci\u00f3n de la agudeza visual',
    code_1: 'H53-H54',
    code_0: 'H00-H59'
  },
  {
    code: 'K65-K67',
    level: 1,
    description: 'Enfermedades del peritoneo',
    code_0: 'K00-K95'
  },
  {
    code: 'K70-K77',
    level: 1,
    description: 'Enfermedades del h\u00edgado',
    code_0: 'K00-K95'
  },
  {
    code: 'K80-K87',
    level: 1,
    description:
      'Trastornos de la ves\u00edcula biliar, de las v\u00edas biliares y del p\u00e1ncreas',
    code_0: 'K00-K95'
  },
  {
    code: 'K90-K93',
    level: 1,
    description: 'Otras enfermedades del sistema digestivo',
    code_0: 'K00-K95'
  },
  {
    code: 'J40-J47',
    level: 1,
    description:
      'Enfermedades cr\u00f3nicas de las v\u00edas respiratorias inferiores',
    code_0: 'J00-J99'
  },
  {
    code: 'J60-J70',
    level: 1,
    description: 'Enfermedades del pulm\u00f3n debidas a agentes externos',
    code_0: 'J00-J99'
  },
  {
    code: 'J80-J84',
    level: 1,
    description:
      'Otras enfermedades respiratorias que afectan principalmente al intersticio',
    code_0: 'J00-J99'
  },
  {
    code: 'J85-J86',
    level: 1,
    description:
      'Afecciones supurativas y necr\u00f3ticas de las v\u00edas respiratorias inferiores',
    code_0: 'J00-J99'
  },
  { code: 'J90-J94 ', level: 1, description: 'Otras', code_0: 'J00-J99' },
  {
    code: 'J95-J99',
    level: 1,
    description: 'Otras enfermedades del sistema respiratorio',
    code_0: 'J00-J99'
  },
  {
    code: 'H49',
    level: 2,
    description: 'Estrabismo paral\u00edtico',
    code_1: 'H49-H52',
    code_0: 'H00-H59'
  },
  {
    code: 'H50',
    level: 2,
    description: 'Otros estrabismos',
    code_1: 'H49-H52',
    code_0: 'H00-H59'
  },
  {
    code: 'H51',
    level: 2,
    description: 'Otros trastornos de los movimientos binoculares',
    code_1: 'H49-H52',
    code_0: 'H00-H59'
  },
  {
    code: 'H52',
    level: 2,
    description: 'Trastornos de la acomodaci\u00f3n y de la refracci\u00f3n',
    code_1: 'H49-H52',
    code_0: 'H00-H59'
  },
  {
    code: 'I26-I28',
    level: 1,
    description:
      'Enfermedad cardiopulmonar y enfermedades de la circulaci\u00f3n pulmonar',
    code_0: 'I00-I99'
  },
  {
    code: 'I30-I52',
    level: 1,
    description: 'Otras formas de enfermedad del coraz\u00f3n',
    code_0: 'I00-I99'
  },
  {
    code: 'I60-I69',
    level: 1,
    description: 'Enfermedades cerebrovasculares',
    code_0: 'I00-I99'
  },
  {
    code: 'I70-I79',
    level: 1,
    description:
      'Enfermedades de las arterias, de las arteriolas y de los vasos capilares',
    code_0: 'I00-I99'
  },
  {
    code: 'I80-I89',
    level: 1,
    description:
      'Enfermedades de las venas y de los vasos y ganglios linf\u00e1ticos, no clasificadas en otra parte',
    code_0: 'I00-I99'
  },
  {
    code: 'I95-I99',
    level: 1,
    description:
      'Otros trastornos y los no especificados del sistema circulatorio',
    code_0: 'I00-I99'
  },
  {
    code: 'H46',
    level: 2,
    description: 'Neuritis \u00f3ptica',
    code_1: 'H46-H48',
    code_0: 'H00-H59'
  },
  {
    code: 'H47',
    level: 2,
    description:
      'Otros trastornos del nervio \u00f3ptico [II par] y de las v\u00edas \u00f3pticas',
    code_1: 'H46-H48',
    code_0: 'H00-H59'
  },
  {
    code: 'H48',
    level: 2,
    description:
      'Trastornos del nervio \u00f3ptico [II par] y de las v\u00edas \u00f3pticas en enfermedades clasificadas en otra parte',
    code_1: 'H46-H48',
    code_0: 'H00-H59'
  },
  {
    code: 'H43',
    level: 2,
    description: 'Trastornos del cuerpo v\u00edtreo',
    code_1: 'H43-H45',
    code_0: 'H00-H59'
  },
  {
    code: 'H44',
    level: 2,
    description: 'Trastornos del globo ocular',
    code_1: 'H43-H45',
    code_0: 'H00-H59'
  },
  {
    code: 'H45',
    level: 2,
    description:
      'Trastornos del cuerpo v\u00edtreo y del globo ocular en enfermedades clasificadas en otra parte',
    code_1: 'H43-H45',
    code_0: 'H00-H59'
  },
  {
    code: 'H40',
    level: 2,
    description: 'Glaucoma',
    code_1: 'H40-H42',
    code_0: 'H00-H59'
  },
  {
    code: 'H42',
    level: 2,
    description: 'Glaucoma en enfermedades clasificadas en otra parte',
    code_1: 'H40-H42',
    code_0: 'H00-H59'
  },
  {
    code: 'H30',
    level: 2,
    description: 'Inflamaci\u00f3n coriorretiniana',
    code_1: 'H30-H36',
    code_0: 'H00-H59'
  },
  {
    code: 'H31',
    level: 2,
    description: 'Otros trastornos de la coroides',
    code_1: 'H30-H36',
    code_0: 'H00-H59'
  },
  {
    code: 'H32',
    level: 2,
    description:
      'Trastornos coriorretinianos en enfermedades clasificadas en otra parte',
    code_1: 'H30-H36',
    code_0: 'H00-H59'
  },
  {
    code: 'T08-T14',
    level: 1,
    description:
      'Traumatismos de parte no especificada del tronco, miembro o regi\u00f3n del cuerpo',
    code_0: 'S00-T88'
  },
  {
    code: 'T15-T19',
    level: 1,
    description:
      'Efectos de cuerpos extra\u00f1os que penetran por orificios naturales',
    code_0: 'S00-T88'
  },
  {
    code: 'T20-T32',
    level: 1,
    description: 'Quemaduras y corrosiones',
    code_0: 'S00-T88'
  },
  {
    code: 'T33-T35',
    level: 1,
    description: 'Congelamiento',
    code_0: 'S00-T88'
  },
  {
    code: 'T36-T50',
    level: 1,
    description:
      'Envenenamiento por drogas, medicamentos y sustancias biol\u00f3gicas',
    code_0: 'S00-T88'
  },
  {
    code: 'T51-T65',
    level: 1,
    description:
      'Efectos t\u00f3xicos de sustancias de procedencia principalmente no medicinal',
    code_0: 'S00-T88'
  },
  {
    code: 'T66-T78',
    level: 1,
    description: 'Otros efectos y los no especificados de causas externas',
    code_0: 'S00-T88'
  },
  {
    code: 'T79',
    level: 1,
    description:
      'Algunas complicaciones precoces de traumatismos, no clasificadas en otra parte',
    code_0: 'S00-T88'
  },
  {
    code: 'T80-T88',
    level: 1,
    description:
      'Complicaciones de la atenci\u00f3n m\u00e9dica y quir\u00fargica, no clasificadas en otra parte',
    code_0: 'S00-T88'
  },
  {
    code: 'H25',
    level: 2,
    description: 'Catarata senil',
    code_1: 'H25-H28',
    code_0: 'H00-H59'
  },
  {
    code: 'H26',
    level: 2,
    description: 'Otras cataratas',
    code_1: 'H25-H28',
    code_0: 'H00-H59'
  },
  {
    code: 'H27',
    level: 2,
    description: 'Otros trastornos del cristalino',
    code_1: 'H25-H28',
    code_0: 'H00-H59'
  },
  {
    code: 'H28',
    level: 2,
    description:
      'Catarata y otros trastornos del cristalino en enfermedades clasificadas en otra parte',
    code_1: 'H25-H28',
    code_0: 'H00-H59'
  },
  {
    code: 'Z40-Z54',
    level: 1,
    description:
      'Personas en contacto con los servicios de salud para procedimientos espec\u00edficos y cuidados de salud',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z55-Z65',
    level: 1,
    description:
      'Personas con riesgos potenciales para su salud, relacionados con circunstancias socioecon\u00f3micas y psicosociales',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z70-Z76',
    level: 1,
    description:
      'Personas en contacto con los servicios de salud por otras circunstancias',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z80-Z99',
    level: 1,
    description:
      'Personas con riesgos potenciales para su salud, relacionados con su historia familiar y personal, y algunas condiciones que influyen sobre su estado de salud',
    code_0: 'Z00-Z99'
  },
  {
    code: 'G20',
    level: 2,
    description: 'Enfermedad de Parkinson',
    code_1: 'G20-G26',
    code_0: 'G00-G99'
  },
  {
    code: 'G21',
    level: 2,
    description: 'Parkinsonismo secundario',
    code_1: 'G20-G26',
    code_0: 'G00-G99'
  },
  {
    code: 'G22',
    level: 2,
    description: 'Parkinsonismo en enfermedades clasificadas en otra parte',
    code_1: 'G20-G26',
    code_0: 'G00-G99'
  },
  {
    code: 'G23',
    level: 2,
    description:
      'Otras enfermedades degenerativas de los n\u00facleos de la base',
    code_1: 'G20-G26',
    code_0: 'G00-G99'
  },
  {
    code: 'G24',
    level: 2,
    description: 'Diston\u00eda',
    code_1: 'G20-G26',
    code_0: 'G00-G99'
  },
  {
    code: 'G25',
    level: 2,
    description: 'Otros trastornos extrapiramidales y del movimiento',
    code_1: 'G20-G26',
    code_0: 'G00-G99'
  },
  {
    code: 'G10',
    level: 2,
    description: 'Enfermedad de Huntington',
    code_1: 'G10-G13',
    code_0: 'G00-G99'
  },
  {
    code: 'G11',
    level: 2,
    description: 'Ataxia hereditaria',
    code_1: 'G10-G13',
    code_0: 'G00-G99'
  },
  {
    code: 'G12',
    level: 2,
    description: 'Atrofia muscular espinal y s\u00edndromes afines',
    code_1: 'G10-G13',
    code_0: 'G00-G99'
  },
  {
    code: 'G13',
    level: 2,
    description:
      'Atrofias sist\u00e9micas que afectan primariamente el sistema nervioso central en enfermedades clasificadas en otra parte',
    code_1: 'G10-G13',
    code_0: 'G00-G99'
  },
  {
    code: 'G00',
    level: 2,
    description: 'Meningitis bacteriana, no clasificada en otra parte',
    code_1: 'G00-G09',
    code_0: 'G00-G99'
  },
  {
    code: 'G01',
    level: 2,
    description:
      'Meningitis en enfermedades bacterianas clasificadas en otra parte',
    code_1: 'G00-G09',
    code_0: 'G00-G99'
  },
  {
    code: 'G02',
    level: 2,
    description:
      'Meningitis en otras enfermedades infecciosas y parasitarias clasificadas en otra parte',
    code_1: 'G00-G09',
    code_0: 'G00-G99'
  },
  {
    code: 'G03',
    level: 2,
    description: 'Meningitis debida a otras causas y a las no especificadas',
    code_1: 'G00-G09',
    code_0: 'G00-G99'
  },
  {
    code: 'G04',
    level: 2,
    description: 'Encefalitis, mielitis y encefalomielitis',
    code_1: 'G00-G09',
    code_0: 'G00-G99'
  },
  {
    code: 'G05',
    level: 2,
    description:
      'Encefalitis, mielitis y encefalomielitis en enfermedades clasificadas en otra parte',
    code_1: 'G00-G09',
    code_0: 'G00-G99'
  },
  {
    code: 'S30',
    level: 2,
    description:
      'Traumatismo superficial del abdomen, de la regi\u00f3n lumbosacra y de la pelvis',
    code_1: 'S30-S39',
    code_0: 'S00-T88'
  },
  {
    code: 'S31',
    level: 2,
    description:
      'Herida del abdomen, de la regi\u00f3n lumbosacra y de la pelvis',
    code_1: 'S30-S39',
    code_0: 'S00-T88'
  },
  {
    code: 'S20',
    level: 2,
    description: 'Traumatismo superficial del t\u00f3rax',
    code_1: 'S20-S29',
    code_0: 'S00-T88'
  },
  {
    code: 'S21',
    level: 2,
    description: 'Herida del t\u00f3rax',
    code_1: 'S20-S29',
    code_0: 'S00-T88'
  },
  {
    code: 'S22',
    level: 2,
    description:
      'Fractura de las costillas, del estern\u00f3n y de la columna tor\u00e1cica [dorsal]',
    code_1: 'S20-S29',
    code_0: 'S00-T88'
  },
  {
    code: 'S23',
    level: 2,
    description:
      'Luxaci\u00f3n, esguince y torcedura de articulaciones y ligamentos del t\u00f3rax',
    code_1: 'S20-S29',
    code_0: 'S00-T88'
  },
  {
    code: 'S24',
    level: 2,
    description:
      'Traumatismo de nervios y de la m\u00e9dula espinal a nivel del t\u00f3rax',
    code_1: 'S20-S29',
    code_0: 'S00-T88'
  },
  {
    code: 'S10',
    level: 2,
    description: 'Traumatismo superficial del cuello',
    code_1: 'S10-S19',
    code_0: 'S00-T88'
  },
  {
    code: 'S11',
    level: 2,
    description: 'Herida del cuello',
    code_1: 'S10-S19',
    code_0: 'S00-T88'
  },
  {
    code: 'S12',
    level: 2,
    description: 'Fractura del cuello',
    code_1: 'S10-S19',
    code_0: 'S00-T88'
  },
  {
    code: 'S00',
    level: 2,
    description: 'Traumatismo superficial de la cabeza',
    code_1: 'S00-S09',
    code_0: 'S00-T88'
  },
  {
    code: 'S01',
    level: 2,
    description: 'Herida de la cabeza',
    code_1: 'S00-S09',
    code_0: 'S00-T88'
  },
  {
    code: 'S02',
    level: 2,
    description: 'Fractura de huesos del cr\u00e1neo y de la cara',
    code_1: 'S00-S09',
    code_0: 'S00-T88'
  },
  {
    code: 'S03',
    level: 2,
    description:
      'Luxaci\u00f3n, esguince y torcedura de articulaciones y de ligamentos de la cabeza',
    code_1: 'S00-S09',
    code_0: 'S00-T88'
  },
  {
    code: 'S04',
    level: 2,
    description: 'Traumatismo de nervios craneales',
    code_1: 'S00-S09',
    code_0: 'S00-T88'
  },
  {
    code: 'F90',
    level: 2,
    description: 'Trastornos hipercin\u00e9ticos',
    code_1: 'F90-F98',
    code_0: 'F01-F99'
  },
  {
    code: 'F91',
    level: 2,
    description: 'Trastornos de la conducta',
    code_1: 'F90-F98',
    code_0: 'F01-F99'
  },
  {
    code: 'F92',
    level: 2,
    description: 'Trastornos mixtos de la conducta y de las emociones',
    code_1: 'F90-F98',
    code_0: 'F01-F99'
  },
  {
    code: 'F93',
    level: 2,
    description:
      'Trastornos emocionales de comienzo espec\u00edfico en la ni\u00f1ez',
    code_1: 'F90-F98',
    code_0: 'F01-F99'
  },
  {
    code: 'F94',
    level: 2,
    description:
      'Trastornos del comportamiento social de comienzo espec\u00edfico en la ni\u00f1ez y en la adolescencia',
    code_1: 'F90-F98',
    code_0: 'F01-F99'
  },
  {
    code: 'F95',
    level: 2,
    description: 'Trastornos por tics',
    code_1: 'F90-F98',
    code_0: 'F01-F99'
  },
  {
    code: 'F98',
    level: 2,
    description:
      'Otros trastornos emocionales y del comportamiento que aparecen habitualmente en la ni\u00f1ez y en la adolescencia',
    code_1: 'F90-F98',
    code_0: 'F01-F99'
  },
  {
    code: 'F80',
    level: 2,
    description:
      'Trastornos espec\u00edficos del desarrollo del habla y del lenguaje',
    code_1: 'F80-F89',
    code_0: 'F01-F99'
  },
  {
    code: 'F81',
    level: 2,
    description:
      'Trastornos espec\u00edficos del desarrollo de las habilidades escolares',
    code_1: 'F80-F89',
    code_0: 'F01-F99'
  },
  {
    code: 'F82',
    level: 2,
    description:
      'Trastorno espec\u00edfico del desarrollo de la funci\u00f3n motriz',
    code_1: 'F80-F89',
    code_0: 'F01-F99'
  },
  {
    code: 'F83',
    level: 2,
    description: 'Trastornos espec\u00edficos mixtos del desarrollo',
    code_1: 'F80-F89',
    code_0: 'F01-F99'
  },
  {
    code: 'F84',
    level: 2,
    description: 'Trastornos generalizados del desarrollo',
    code_1: 'F80-F89',
    code_0: 'F01-F99'
  },
  {
    code: 'Y85-Y89',
    level: 1,
    description: 'Secuelas de causas externas de morbilidad y de mortalidad',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y90-Y98',
    level: 1,
    description:
      'Factores suplementarios relacionados con causas de morbilidad y de mortalidad clasificadas en otra parte',
    code_0: 'V01-Y99'
  },
  {
    code: 'H93',
    level: 2,
    description:
      'Otros trastornos del o\u00eddo, no clasificados en otra parte',
    code_1: 'H90-H95',
    code_0: 'H60-H95'
  },
  {
    code: 'H94',
    level: 2,
    description:
      'Otros trastornos del o\u00eddo en enfermedades clasificadas en otra parte',
    code_1: 'H90-H95',
    code_0: 'H60-H95'
  },
  {
    code: 'H95',
    level: 2,
    description:
      'Trastornos del o\u00eddo y de la ap\u00f3fisis mastoides consecutivos a procedimientos, no clasificados en otra parte',
    code_1: 'H90-H95',
    code_0: 'H60-H95'
  },
  {
    code: 'F70',
    level: 2,
    description: 'Retraso mental leve',
    code_1: 'F70-F79',
    code_0: 'F01-F99'
  },
  {
    code: 'F71',
    level: 2,
    description: 'Retraso mental moderado',
    code_1: 'F70-F79',
    code_0: 'F01-F99'
  },
  {
    code: 'F72',
    level: 2,
    description: 'Retraso mental grave',
    code_1: 'F70-F79',
    code_0: 'F01-F99'
  },
  {
    code: 'F73',
    level: 2,
    description: 'Retraso mental profundo',
    code_1: 'F70-F79',
    code_0: 'F01-F99'
  },
  {
    code: 'F78',
    level: 2,
    description: 'Otros tipos de retraso mental',
    code_1: 'F70-F79',
    code_0: 'F01-F99'
  },
  {
    code: 'F60',
    level: 2,
    description: 'Trastornos espec\u00edficos de la personalidad',
    code_1: 'F60-F69',
    code_0: 'F01-F99'
  },
  {
    code: 'F61',
    level: 2,
    description: 'Trastornos mixtos y otros trastornos de la personalidad',
    code_1: 'F60-F69',
    code_0: 'F01-F99'
  },
  {
    code: 'F62',
    level: 2,
    description:
      'Cambios perdurables de la personalidad, no atribuibles a lesi\u00f3n o a enfermedad cerebral',
    code_1: 'F60-F69',
    code_0: 'F01-F99'
  },
  {
    code: 'F50',
    level: 2,
    description: 'Trastornos de la ingesti\u00f3n de alimentos',
    code_1: 'F50-F59',
    code_0: 'F01-F99'
  },
  {
    code: 'F51',
    level: 2,
    description: 'Trastornos no org\u00e1nicos del sue\u00f1o',
    code_1: 'F50-F59',
    code_0: 'F01-F99'
  },
  {
    code: 'F52',
    level: 2,
    description:
      'Disfunci\u00f3n sexual no ocasionada por trastorno ni enfermedad org\u00e1nicos',
    code_1: 'F50-F59',
    code_0: 'F01-F99'
  },
  {
    code: 'F53',
    level: 2,
    description:
      'Trastornos mentales y del comportamiento asociados con el puerperio, no clasificados en otra parte',
    code_1: 'F50-F59',
    code_0: 'F01-F99'
  },
  {
    code: 'F54',
    level: 2,
    description:
      'Factores psicol\u00f3gicos y del comportamiento asociados con trastornos o enfermedades clasificados en otra parte',
    code_1: 'F50-F59',
    code_0: 'F01-F99'
  },
  {
    code: 'F55',
    level: 2,
    description: 'Abuso de sustancias que no producen dependencia',
    code_1: 'F50-F59',
    code_0: 'F01-F99'
  },
  {
    code: 'H55',
    level: 2,
    description: 'Nistagmo y otros movimientos oculares irregulares',
    code_1: 'H55-H59',
    code_0: 'H00-H59'
  },
  {
    code: 'H57',
    level: 2,
    description: 'Otros trastornos del ojo y sus anexos',
    code_1: 'H55-H59',
    code_0: 'H00-H59'
  },
  {
    code: 'H58',
    level: 2,
    description:
      'Otros trastornos del ojo y sus anexos en enfermedades clasificadas en otra parte',
    code_1: 'H55-H59',
    code_0: 'H00-H59'
  },
  {
    code: 'H59',
    level: 2,
    description:
      'Trastornos del ojo y sus anexos consecutivos a procedimientos, no clasificados en otra parte',
    code_1: 'H55-H59',
    code_0: 'H00-H59'
  },
  {
    code: 'A00',
    level: 2,
    description: 'C\u00f3lera',
    code_1: 'A00-A09',
    code_0: 'A00-B99'
  },
  {
    code: 'A01',
    level: 2,
    description: 'Fiebres tifoidea y paratifoidea',
    code_1: 'A00-A09',
    code_0: 'A00-B99'
  },
  {
    code: 'A02',
    level: 2,
    description: 'Otras infecciones debidas a Salmonella',
    code_1: 'A00-A09',
    code_0: 'A00-B99'
  },
  {
    code: 'A03',
    level: 2,
    description: 'Shigelosis',
    code_1: 'A00-A09',
    code_0: 'A00-B99'
  },
  {
    code: 'A04',
    level: 2,
    description: 'Otras infecciones intestinales bacterianas',
    code_1: 'A00-A09',
    code_0: 'A00-B99'
  },
  {
    code: 'A05',
    level: 2,
    description:
      'Otras intoxicaciones alimentarias bacterianas, no clasificadas en otra parte',
    code_1: 'A00-A09',
    code_0: 'A00-B99'
  },
  {
    code: 'A06',
    level: 2,
    description: 'Amebiasis',
    code_1: 'A00-A09',
    code_0: 'A00-B99'
  },
  {
    code: 'G90',
    level: 2,
    description: 'Trastornos del sistema nervioso aut\u00f3nomo',
    code_1: 'G90-G99',
    code_0: 'G00-G99'
  },
  {
    code: 'G91',
    level: 2,
    description: 'Hidroc\u00e9falo',
    code_1: 'G90-G99',
    code_0: 'G00-G99'
  },
  {
    code: 'G92',
    level: 2,
    description: 'Encefalopat\u00eda t\u00f3xica',
    code_1: 'G90-G99',
    code_0: 'G00-G99'
  },
  {
    code: 'G93',
    level: 2,
    description: 'Otros trastornos del enc\u00e9falo',
    code_1: 'G90-G99',
    code_0: 'G00-G99'
  },
  {
    code: 'G94',
    level: 2,
    description:
      'Otros trastornos del enc\u00e9falo en enfermedades clasificadas en otra parte',
    code_1: 'G90-G99',
    code_0: 'G00-G99'
  },
  {
    code: 'G95',
    level: 2,
    description: 'Otras enfermedades de la m\u00e9dula espinal',
    code_1: 'G90-G99',
    code_0: 'G00-G99'
  },
  {
    code: 'G96',
    level: 2,
    description: 'Otros trastornos del sistema nervioso central',
    code_1: 'G90-G99',
    code_0: 'G00-G99'
  },
  {
    code: 'G80',
    level: 2,
    description: 'Par\u00e1lisis cerebral',
    code_1: 'G80-G83',
    code_0: 'G00-G99'
  },
  {
    code: 'G81',
    level: 2,
    description: 'Hemiplej\u00eda',
    code_1: 'G80-G83',
    code_0: 'G00-G99'
  },
  {
    code: 'G82',
    level: 2,
    description: 'Paraplej\u00eda y cuadriplej\u00eda',
    code_1: 'G80-G83',
    code_0: 'G00-G99'
  },
  {
    code: 'G83',
    level: 2,
    description: 'Otros s\u00edndromes paral\u00edticos',
    code_1: 'G80-G83',
    code_0: 'G00-G99'
  },
  {
    code: 'G70',
    level: 2,
    description: 'Miastenia gravis y otros trastornos neuromusculares',
    code_1: 'G70-G73',
    code_0: 'G00-G99'
  },
  {
    code: 'G71',
    level: 2,
    description: 'Trastornos musculares primarios',
    code_1: 'G70-G73',
    code_0: 'G00-G99'
  },
  {
    code: 'G72',
    level: 2,
    description: 'Otras miopat\u00edas',
    code_1: 'G70-G73',
    code_0: 'G00-G99'
  },
  {
    code: 'G60',
    level: 2,
    description: 'Neuropat\u00eda hereditaria e idiop\u00e1tica',
    code_1: 'G60-G64',
    code_0: 'G00-G99'
  },
  {
    code: 'G61',
    level: 2,
    description: 'Polineuropat\u00eda inflamatoria',
    code_1: 'G60-G64',
    code_0: 'G00-G99'
  },
  {
    code: 'G62',
    level: 2,
    description: 'Otras polineuropat\u00edas',
    code_1: 'G60-G64',
    code_0: 'G00-G99'
  },
  {
    code: 'G63',
    level: 2,
    description:
      'Polineuropat\u00edas en enfermedades clasificadas en otra parte',
    code_1: 'G60-G64',
    code_0: 'G00-G99'
  },
  {
    code: 'G64',
    level: 2,
    description: 'Otros trastornos del sistema nervioso perif\u00e9rico',
    code_1: 'G60-G64',
    code_0: 'G00-G99'
  },
  {
    code: 'G50',
    level: 2,
    description: 'Trastornos del nervio trig\u00e9mino',
    code_1: 'G50-G59',
    code_0: 'G00-G99'
  },
  {
    code: 'G51',
    level: 2,
    description: 'Trastornos del nervio facial',
    code_1: 'G50-G59',
    code_0: 'G00-G99'
  },
  {
    code: 'G52',
    level: 2,
    description: 'Trastornos de otros nervios craneales',
    code_1: 'G50-G59',
    code_0: 'G00-G99'
  },
  {
    code: 'G53',
    level: 2,
    description:
      'Trastornos de los nervios craneales en enfermedades clasificadas en otra parte',
    code_1: 'G50-G59',
    code_0: 'G00-G99'
  },
  {
    code: 'G40',
    level: 2,
    description: 'Epilepsia',
    code_1: 'G40-G47',
    code_0: 'G00-G99'
  },
  {
    code: 'G41',
    level: 2,
    description: 'Estado de mal epil\u00e9ptico',
    code_1: 'G40-G47',
    code_0: 'G00-G99'
  },
  {
    code: 'G43',
    level: 2,
    description: 'Migra\u00f1a',
    code_1: 'G40-G47',
    code_0: 'G00-G99'
  },
  {
    code: 'H68',
    level: 2,
    description:
      'Inflamaci\u00f3n y obstrucci\u00f3n de la trompa de Eustaquio',
    code_1: 'H65-H75',
    code_0: 'H60-H95'
  },
  {
    code: 'H69',
    level: 2,
    description: 'Otros trastornos de la trompa de Eustaquio',
    code_1: 'H65-H75',
    code_0: 'H60-H95'
  },
  {
    code: 'H70',
    level: 2,
    description: 'Mastoiditis y afecciones relacionadas',
    code_1: 'H65-H75',
    code_0: 'H60-H95'
  },
  {
    code: 'H71',
    level: 2,
    description: 'Colesteatoma del o\u00eddo medio',
    code_1: 'H65-H75',
    code_0: 'H60-H95'
  },
  {
    code: 'H72',
    level: 2,
    description: 'Perforaci\u00f3n de la membrana timp\u00e1nica',
    code_1: 'H65-H75',
    code_0: 'H60-H95'
  },
  {
    code: 'H73',
    level: 2,
    description: 'Otros trastornos de la membrana timp\u00e1nica',
    code_1: 'H65-H75',
    code_0: 'H60-H95'
  },
  {
    code: 'H74',
    level: 2,
    description:
      'Otros trastornos del o\u00eddo medio y de la ap\u00f3fisis mastoides',
    code_1: 'H65-H75',
    code_0: 'H60-H95'
  },
  {
    code: 'H75',
    level: 2,
    description:
      'Otros trastornos del o\u00eddo medio y de la ap\u00f3fisis mastoides en enfermedades clasificadas en otra parte',
    code_1: 'H65-H75',
    code_0: 'H60-H95'
  },
  {
    code: 'G35',
    level: 2,
    description: 'Esclerosis m\u00faltiple',
    code_1: 'G35-G37',
    code_0: 'G00-G99'
  },
  {
    code: 'G36',
    level: 2,
    description: 'Otras desmielinizaciones diseminadas agudas',
    code_1: 'G35-G37',
    code_0: 'G00-G99'
  },
  {
    code: 'G37',
    level: 2,
    description:
      'Otras enfermedades desmielinizantes del sistema nervioso central',
    code_1: 'G35-G37',
    code_0: 'G00-G99'
  },
  {
    code: 'G30',
    level: 2,
    description: 'Enfermedad de Alzheimer',
    code_1: 'G30-G32',
    code_0: 'G00-G99'
  },
  {
    code: 'G31',
    level: 2,
    description:
      'Otras enfermedades degenerativas del sistema nervioso, no clasificadas en otra parte',
    code_1: 'G30-G32',
    code_0: 'G00-G99'
  },
  {
    code: 'G32',
    level: 2,
    description:
      'Otros trastornos degenerativos del sistema nervioso en enfermedades clasificadas en otra parte',
    code_1: 'G30-G32',
    code_0: 'G00-G99'
  },
  {
    code: 'D37',
    level: 2,
    description:
      'Tumor de comportamiento incierto o desconocido de la cavidad bucal y de los \u00f3rganos digestivos',
    code_1: 'D37-D48',
    code_0: 'C00-D49'
  },
  {
    code: 'D38',
    level: 2,
    description:
      'Tumor de comportamiento incierto o desconocido del o\u00eddo medio y de los \u00f3rganos respiratorios e intrator\u00e1cicos',
    code_1: 'D37-D48',
    code_0: 'C00-D49'
  },
  {
    code: 'D39',
    level: 2,
    description:
      'Tumor de comportamiento incierto o desconocido de los \u00f3rganos genitales femeninos',
    code_1: 'D37-D48',
    code_0: 'C00-D49'
  },
  {
    code: 'D40',
    level: 2,
    description:
      'Tumor de comportamiento incierto o desconocido de los \u00f3rganos genitales masculinos',
    code_1: 'D37-D48',
    code_0: 'C00-D49'
  },
  {
    code: 'D41',
    level: 2,
    description:
      'Tumor de comportamiento incierto o desconocido de los \u00f3rganos urinarios',
    code_1: 'D37-D48',
    code_0: 'C00-D49'
  },
  {
    code: 'D42',
    level: 2,
    description:
      'Tumor de comportamiento incierto o desconocido de las meninges',
    code_1: 'D37-D48',
    code_0: 'C00-D49'
  },
  {
    code: 'D43',
    level: 2,
    description:
      'Tumor de comportamiento incierto o desconocido del enc\u00e9falo y del sistema nervioso central',
    code_1: 'D37-D48',
    code_0: 'C00-D49'
  },
  {
    code: 'D10',
    level: 2,
    description: 'Tumor benigno de la boca y de la faringe',
    code_1: 'D10-D36',
    code_0: 'C00-D49'
  },
  {
    code: 'D11',
    level: 2,
    description: 'Tumor benigno de las gl\u00e1ndulas salivales mayores',
    code_1: 'D10-D36',
    code_0: 'C00-D49'
  },
  {
    code: 'D12',
    level: 2,
    description:
      'Tumor benigno del colon, del recto, del conducto anal y del ano',
    code_1: 'D10-D36',
    code_0: 'C00-D49'
  },
  {
    code: 'D00',
    level: 2,
    description:
      'Carcinoma in situ de la cavidad bucal, del es\u00f3fago y del est\u00f3mago',
    code_1: 'D00-D09',
    code_0: 'C00-D49'
  },
  {
    code: 'D01',
    level: 2,
    description:
      'Carcinoma in situ de otros \u00f3rganos digestivos y de los no especificados',
    code_1: 'D00-D09',
    code_0: 'C00-D49'
  },
  {
    code: 'D02',
    level: 2,
    description:
      'Carcinoma in situ del sistema respiratorio y del o\u00eddo medio',
    code_1: 'D00-D09',
    code_0: 'C00-D49'
  },
  {
    code: 'D03',
    level: 2,
    description: 'Melanoma in situ',
    code_1: 'D00-D09',
    code_0: 'C00-D49'
  },
  {
    code: 'D04',
    level: 2,
    description: 'Carcinoma in situ de la piel',
    code_1: 'D00-D09',
    code_0: 'C00-D49'
  },
  {
    code: 'D05',
    level: 2,
    description: 'Carcinoma in situ de la mama',
    code_1: 'D00-D09',
    code_0: 'C00-D49'
  },
  {
    code: 'D06',
    level: 2,
    description: 'Carcinoma in situ del cuello del \u00fatero',
    code_1: 'D00-D09',
    code_0: 'C00-D49'
  },
  {
    code: 'C00-C75',
    level: 2,
    description: 'y afines',
    code_1: 'C00-C97',
    code_0: 'C00-D49'
  },
  {
    code: 'C76-C80',
    level: 2,
    description:
      'Tumores [neoplasias] malignos de sitios mal definidos, secundarios y de sitios no especificados',
    code_1: 'C00-C97',
    code_0: 'C00-D49'
  },
  {
    code: 'C81-C96',
    level: 2,
    description:
      'Tumores [neoplasias] malignos del tejido linf\u00e1tico, de los \u00f3rganos hematopoy\u00e9ticos y de tejidos afines',
    code_1: 'C00-C97',
    code_0: 'C00-D49'
  },
  {
    code: 'C97',
    level: 2,
    description:
      'Tumores malignos (primarios) de sitios m\u00faltiples independientes',
    code_1: 'C00-C97',
    code_0: 'C00-D49'
  },
  {
    code: 'D70',
    level: 2,
    description: 'Agranulocitosis',
    code_1: 'D70-D77',
    code_0: 'D50-D89'
  },
  {
    code: 'D71',
    level: 2,
    description:
      'Trastornos funcionales de los polimorfonucleares neutr\u00f3filos',
    code_1: 'D70-D77',
    code_0: 'D50-D89'
  },
  {
    code: 'D72',
    level: 2,
    description: 'Otros trastornos de los leucocitos',
    code_1: 'D70-D77',
    code_0: 'D50-D89'
  },
  {
    code: 'D73',
    level: 2,
    description: 'Enfermedades del bazo',
    code_1: 'D70-D77',
    code_0: 'D50-D89'
  },
  {
    code: 'D74',
    level: 2,
    description: 'Metahemoglobinemia',
    code_1: 'D70-D77',
    code_0: 'D50-D89'
  },
  {
    code: 'D65',
    level: 2,
    description:
      'Coagulaci\u00f3n intravascular diseminada [s\u00edndrome de desfibrinaci\u00f3n]',
    code_1: 'D65-D69',
    code_0: 'D50-D89'
  },
  {
    code: 'D66',
    level: 2,
    description: 'Deficiencia hereditaria del factor VIII',
    code_1: 'D65-D69',
    code_0: 'D50-D89'
  },
  {
    code: 'D67',
    level: 2,
    description: 'Deficiencia hereditaria del factor IX',
    code_1: 'D65-D69',
    code_0: 'D50-D89'
  },
  {
    code: 'D68',
    level: 2,
    description: 'Otros defectos de la coagulaci\u00f3n',
    code_1: 'D65-D69',
    code_0: 'D50-D89'
  },
  {
    code: 'D69',
    level: 2,
    description: 'P\u00farpura y otras afecciones hemorr\u00e1gicas',
    code_1: 'D65-D69',
    code_0: 'D50-D89'
  },
  {
    code: 'D60',
    level: 2,
    description:
      'Aplasia adquirida, exclusiva de la serie roja [eritroblastopenia]',
    code_1: 'D60-D64',
    code_0: 'D50-D89'
  },
  {
    code: 'D61',
    level: 2,
    description: 'Otras anemias apl\u00e1sticas',
    code_1: 'D60-D64',
    code_0: 'D50-D89'
  },
  {
    code: 'D62',
    level: 2,
    description: 'Anemia posthemorr\u00e1gica aguda',
    code_1: 'D60-D64',
    code_0: 'D50-D89'
  },
  {
    code: 'D63',
    level: 2,
    description:
      'Anemia en enfermedades cr\u00f3nicas clasificadas en otra parte',
    code_1: 'D60-D64',
    code_0: 'D50-D89'
  },
  {
    code: 'D64',
    level: 2,
    description: 'Otras anemias',
    code_1: 'D60-D64',
    code_0: 'D50-D89'
  },
  {
    code: 'D55',
    level: 2,
    description: 'Anemia debida a trastornos enzim\u00e1ticos',
    code_1: 'D55-D59',
    code_0: 'D50-D89'
  },
  {
    code: 'D56',
    level: 2,
    description: 'Talasemia',
    code_1: 'D55-D59',
    code_0: 'D50-D89'
  },
  {
    code: 'D57',
    level: 2,
    description: 'Trastornos falciformes',
    code_1: 'D55-D59',
    code_0: 'D50-D89'
  },
  {
    code: 'D58',
    level: 2,
    description: 'Otras anemias hemol\u00edticas hereditarias',
    code_1: 'D55-D59',
    code_0: 'D50-D89'
  },
  {
    code: 'D59',
    level: 2,
    description: 'Anemia hemol\u00edtica adquirida',
    code_1: 'D55-D59',
    code_0: 'D50-D89'
  },
  {
    code: 'D50',
    level: 2,
    description: 'Anemias por deficiencia de hierro',
    code_1: 'D50-D53',
    code_0: 'D50-D89'
  },
  {
    code: 'D51',
    level: 2,
    description: 'Anemia por deficiencia de vitamina B12',
    code_1: 'D50-D53',
    code_0: 'D50-D89'
  },
  {
    code: 'D52',
    level: 2,
    description: 'Anemia por deficiencia de folatos',
    code_1: 'D50-D53',
    code_0: 'D50-D89'
  },
  {
    code: 'D53',
    level: 2,
    description: 'Otras anemias nutricionales',
    code_1: 'D50-D53',
    code_0: 'D50-D89'
  },
  {
    code: 'E20',
    level: 2,
    description: 'Hipoparatiroidismo',
    code_1: 'E20-E35',
    code_0: 'E00-E89'
  },
  {
    code: 'E21',
    level: 2,
    description:
      'Hiperparatiroidismo y otros trastornos de la gl\u00e1ndula paratiroides',
    code_1: 'E20-E35',
    code_0: 'E00-E89'
  },
  {
    code: 'E22',
    level: 2,
    description: 'Hiperfunci\u00f3n de la gl\u00e1ndula hip\u00f3fisis',
    code_1: 'E20-E35',
    code_0: 'E00-E89'
  },
  {
    code: 'E23',
    level: 2,
    description:
      'Hipofunci\u00f3n y otros trastornos de la gl\u00e1ndula hip\u00f3fisis',
    code_1: 'E20-E35',
    code_0: 'E00-E89'
  },
  {
    code: 'E24',
    level: 2,
    description: 'S\u00edndrome de Cushing',
    code_1: 'E20-E35',
    code_0: 'E00-E89'
  },
  {
    code: 'E15',
    level: 2,
    description: 'Coma hipoglic\u00e9mico no diab\u00e9tico',
    code_1: 'E15-E16',
    code_0: 'E00-E89'
  },
  {
    code: 'E16',
    level: 2,
    description:
      'Otros trastornos de la secreci\u00f3n interna del p\u00e1ncreas',
    code_1: 'E15-E16',
    code_0: 'E00-E89'
  },
  {
    code: 'E10',
    level: 2,
    description: 'Diabetes mellitus insulinodependiente',
    code_1: 'E10-E14',
    code_0: 'E00-E89'
  },
  {
    code: 'E11',
    level: 2,
    description: 'Diabetes mellitus no insulinodependiente',
    code_1: 'E10-E14',
    code_0: 'E00-E89'
  },
  {
    code: 'E12',
    level: 2,
    description: 'Diabetes mellitus asociada con desnutrici\u00f3n',
    code_1: 'E10-E14',
    code_0: 'E00-E89'
  },
  {
    code: 'E13',
    level: 2,
    description: 'Otras diabetes mellitus especificadas',
    code_1: 'E10-E14',
    code_0: 'E00-E89'
  },
  {
    code: 'E00',
    level: 2,
    description: 'S\u00edndrome cong\u00e9nito de deficiencia de yodo',
    code_1: 'E00-E07',
    code_0: 'E00-E89'
  },
  {
    code: 'E01',
    level: 2,
    description:
      'Trastornos tiroideos vinculados a deficiencia de yodo y afecciones relacionadas',
    code_1: 'E00-E07',
    code_0: 'E00-E89'
  },
  {
    code: 'E02',
    level: 2,
    description: 'Hipotiroidismo subcl\u00ednico por deficiencia de yodo',
    code_1: 'E00-E07',
    code_0: 'E00-E89'
  },
  {
    code: 'E03',
    level: 2,
    description: 'Otros hipotiroidismos',
    code_1: 'E00-E07',
    code_0: 'E00-E89'
  },
  {
    code: 'E04',
    level: 2,
    description: 'Otros bocios no t\u00f3xicos',
    code_1: 'E00-E07',
    code_0: 'E00-E89'
  },
  {
    code: 'E05',
    level: 2,
    description: 'Tirotoxicosis [hipertiroidismo]',
    code_1: 'E00-E07',
    code_0: 'E00-E89'
  },
  {
    code: 'E06',
    level: 2,
    description: 'Tiroiditis',
    code_1: 'E00-E07',
    code_0: 'E00-E89'
  },
  {
    code: 'F25',
    level: 2,
    description: 'Trastornos esquizoafectivos',
    code_1: 'F20-F29',
    code_0: 'F01-F99'
  },
  {
    code: 'F28',
    level: 2,
    description: 'Otros trastornos psic\u00f3ticos de origen no org\u00e1nico',
    code_1: 'F20-F29',
    code_0: 'F01-F99'
  },
  {
    code: 'F29',
    level: 2,
    description: 'Psicosis de origen no org\u00e1nico, no especificada',
    code_1: 'F20-F29',
    code_0: 'F01-F99'
  },
  {
    code: 'F16',
    level: 2,
    description:
      'Trastornos mentales y del comportamiento debidos al uso de alucin\u00f3genos',
    code_1: 'F10-F19',
    code_0: 'F01-F99'
  },
  {
    code: 'F17',
    level: 2,
    description:
      'Trastornos mentales y del comportamiento debidos al uso de tabaco',
    code_1: 'F10-F19',
    code_0: 'F01-F99'
  },
  {
    code: 'F18',
    level: 2,
    description:
      'Trastornos mentales y del comportamiento debidos al uso de disolventes vol\u00e1tiles',
    code_1: 'F10-F19',
    code_0: 'F01-F99'
  },
  {
    code: 'F19',
    level: 2,
    description:
      'Trastornos mentales y del comportamiento debidos al uso de m\u00faltiples drogas y al uso de otras sustancias psicoactivas',
    code_1: 'F10-F19',
    code_0: 'F01-F99'
  },
  {
    code: 'F03',
    level: 2,
    description: 'Demencia, no especificada',
    code_1: 'F00-F09',
    code_0: 'F01-F99'
  },
  {
    code: 'F04',
    level: 2,
    description:
      'S\u00edndrome amn\u00e9sico org\u00e1nico, no inducido por \u00adalcohol o por otras sustancias psicoactivas',
    code_1: 'F00-F09',
    code_0: 'F01-F99'
  },
  {
    code: 'F05',
    level: 2,
    description:
      'Delirio, no inducido por alcohol o por otras \u00adsustancias psicoactivas',
    code_1: 'F00-F09',
    code_0: 'F01-F99'
  },
  {
    code: 'F06',
    level: 2,
    description:
      'Otros trastornos mentales debidos a lesi\u00f3n y disfunci\u00f3n cerebral, y a enfermedad f\u00edsica',
    code_1: 'F00-F09',
    code_0: 'F01-F99'
  },
  {
    code: 'F07',
    level: 2,
    description:
      'Trastornos de la personalidad y del comportamiento debidos a enfermedad, lesi\u00f3n o disfunci\u00f3n cerebral',
    code_1: 'F00-F09',
    code_0: 'F01-F99'
  },
  {
    code: 'F09',
    level: 2,
    description:
      'Trastorno mental org\u00e1nico o sintom\u00e1tico, no especificado',
    code_1: 'F00-F09',
    code_0: 'F01-F99'
  },
  {
    code: 'H33',
    level: 2,
    description: 'Desprendimiento y desgarro de la retina',
    code_1: 'H30-H36',
    code_0: 'H00-H59'
  },
  {
    code: 'H34',
    level: 2,
    description: 'Oclusi\u00f3n vascular de la retina',
    code_1: 'H30-H36',
    code_0: 'H00-H59'
  },
  {
    code: 'H35',
    level: 2,
    description: 'Otros trastornos de la retina',
    code_1: 'H30-H36',
    code_0: 'H00-H59'
  },
  {
    code: 'H36',
    level: 2,
    description:
      'Trastornos de la retina en enfermedades clasificadas en otra parte',
    code_1: 'H30-H36',
    code_0: 'H00-H59'
  },
  {
    code: 'T90-T98',
    level: 1,
    description:
      'Secuelas de traumatismos, de envenenamientos y de otras consecuencias de causas externas',
    code_0: 'S00-T88'
  },
  {
    code: 'G26',
    level: 2,
    description:
      'Trastornos extrapiramidales y del movimiento en enfermedades clasificadas en otra parte',
    code_1: 'G20-G26',
    code_0: 'G00-G99'
  },
  {
    code: 'Z30',
    level: 2,
    description: 'Atenci\u00f3n para la anticoncepci\u00f3n',
    code_1: 'Z30-Z39',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z31',
    level: 2,
    description: 'Atenci\u00f3n para la procreaci\u00f3n',
    code_1: 'Z30-Z39',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z32',
    level: 2,
    description: 'Examen y prueba del embarazo',
    code_1: 'Z30-Z39',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z33',
    level: 2,
    description: 'Estado de embarazo, incidental',
    code_1: 'Z30-Z39',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z34',
    level: 2,
    description: 'Supervisi\u00f3n de embarazo normal',
    code_1: 'Z30-Z39',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z35',
    level: 2,
    description: 'Supervisi\u00f3n de embarazo de alto riesgo',
    code_1: 'Z30-Z39',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z20',
    level: 2,
    description: 'Contacto con y exposici\u00f3n a enfermedades transmisibles',
    code_1: 'Z20-Z29',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z21',
    level: 2,
    description:
      'Estado de infecci\u00f3n asintom\u00e1tica por el virus de la inmunodeficiencia humana [VIH]',
    code_1: 'Z20-Z29',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z22',
    level: 2,
    description: 'Portador de agente de enfermedad infecciosa',
    code_1: 'Z20-Z29',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z00',
    level: 2,
    description:
      'Examen general e investigaci\u00f3n de personas sin quejas o sin diagn\u00f3stico informado',
    code_1: 'Z00-Z13',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z01',
    level: 2,
    description:
      'Otros ex\u00e1menes especiales e investigaciones en personas sin quejas o sin diagn\u00f3stico informado',
    code_1: 'Z00-Z13',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z02',
    level: 2,
    description: 'Ex\u00e1menes y contactos para fines administrativos',
    code_1: 'Z00-Z13',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z03',
    level: 2,
    description:
      'Observaci\u00f3n y evaluaci\u00f3n m\u00e9dicas por sospecha de enfermedades y afecciones',
    code_1: 'Z00-Z13',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z04',
    level: 2,
    description: 'Examen y observaci\u00f3n por otras razones',
    code_1: 'Z00-Z13',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z08',
    level: 2,
    description:
      'Examen de seguimiento consecutivo al tratamiento por tumor maligno',
    code_1: 'Z00-Z13',
    code_0: 'Z00-Z99'
  },
  {
    code: 'T00',
    level: 2,
    description:
      'Traumatismos superficiales que afectan m\u00faltiples regiones del cuerpo',
    code_1: 'T00-T07',
    code_0: 'S00-T88'
  },
  {
    code: 'T01',
    level: 2,
    description: 'Heridas que afectan m\u00faltiples regiones del cuerpo',
    code_1: 'T00-T07',
    code_0: 'S00-T88'
  },
  {
    code: 'S90',
    level: 2,
    description: 'Traumatismo superficial del tobillo y del pie',
    code_1: 'S90-S99',
    code_0: 'S00-T88'
  },
  {
    code: 'S91',
    level: 2,
    description: 'Herida del tobillo y del pie',
    code_1: 'S90-S99',
    code_0: 'S00-T88'
  },
  {
    code: 'S92',
    level: 2,
    description: 'Fractura del pie, excepto del tobillo',
    code_1: 'S90-S99',
    code_0: 'S00-T88'
  },
  {
    code: 'S93',
    level: 2,
    description:
      'Luxaci\u00f3n, esguince y torcedura de articulaciones y ligamentos del tobillo y del pie',
    code_1: 'S90-S99',
    code_0: 'S00-T88'
  },
  {
    code: 'S94',
    level: 2,
    description: 'Traumatismo de nervios a nivel del pie y del tobillo',
    code_1: 'S90-S99',
    code_0: 'S00-T88'
  },
  {
    code: 'S80',
    level: 2,
    description: 'Traumatismo superficial de la pierna',
    code_1: 'S80-S89',
    code_0: 'S00-T88'
  },
  {
    code: 'S81',
    level: 2,
    description: 'Herida de la pierna',
    code_1: 'S80-S89',
    code_0: 'S00-T88'
  },
  {
    code: 'S82',
    level: 2,
    description: 'Fractura de la pierna, inclusive el tobillo',
    code_1: 'S80-S89',
    code_0: 'S00-T88'
  },
  {
    code: 'S83',
    level: 2,
    description:
      'Luxaci\u00f3n, esguince y torcedura de articulaciones y ligamentos de la rodilla',
    code_1: 'S80-S89',
    code_0: 'S00-T88'
  },
  {
    code: 'S70',
    level: 2,
    description: 'Traumatismo superficial de la cadera y del muslo',
    code_1: 'S70-S79',
    code_0: 'S00-T88'
  },
  {
    code: 'S71',
    level: 2,
    description: 'Herida de la cadera y del muslo',
    code_1: 'S70-S79',
    code_0: 'S00-T88'
  },
  {
    code: 'S72',
    level: 2,
    description: 'Fractura del f\u00e9mur',
    code_1: 'S70-S79',
    code_0: 'S00-T88'
  },
  {
    code: 'S73',
    level: 2,
    description:
      'Luxaci\u00f3n, esguince y torcedura de la articulaci\u00f3n y de los ligamentos de la cadera',
    code_1: 'S70-S79',
    code_0: 'S00-T88'
  },
  {
    code: 'S60',
    level: 2,
    description: 'Traumatismo superficial de la mu\u00f1eca y de la mano',
    code_1: 'S60-S69',
    code_0: 'S00-T88'
  },
  {
    code: 'S61',
    level: 2,
    description: 'Herida de la mu\u00f1eca y de la mano',
    code_1: 'S60-S69',
    code_0: 'S00-T88'
  },
  {
    code: 'S62',
    level: 2,
    description: 'Fractura a nivel de la mu\u00f1eca y de la mano',
    code_1: 'S60-S69',
    code_0: 'S00-T88'
  },
  {
    code: 'S50',
    level: 2,
    description: 'Traumatismo superficial del antebrazo y del codo',
    code_1: 'S50-S59',
    code_0: 'S00-T88'
  },
  {
    code: 'S51',
    level: 2,
    description: 'Herida del antebrazo y del codo',
    code_1: 'S50-S59',
    code_0: 'S00-T88'
  },
  {
    code: 'S52',
    level: 2,
    description: 'Fractura del antebrazo',
    code_1: 'S50-S59',
    code_0: 'S00-T88'
  },
  {
    code: 'S53',
    level: 2,
    description:
      'Luxaci\u00f3n, esguince y torcedura de articulaciones y ligamentos del codo',
    code_1: 'S50-S59',
    code_0: 'S00-T88'
  },
  {
    code: 'S54',
    level: 2,
    description: 'Traumatismo de nervios a nivel del antebrazo',
    code_1: 'S50-S59',
    code_0: 'S00-T88'
  },
  {
    code: 'S40',
    level: 2,
    description: 'Traumatismo superficial del hombro y del brazo',
    code_1: 'S40-S49',
    code_0: 'S00-T88'
  },
  {
    code: 'S41',
    level: 2,
    description: 'Herida del hombro y del brazo',
    code_1: 'S40-S49',
    code_0: 'S00-T88'
  },
  {
    code: 'S42',
    level: 2,
    description: 'Fractura del hombro y del brazo',
    code_1: 'S40-S49',
    code_0: 'S00-T88'
  },
  {
    code: 'S43',
    level: 2,
    description:
      'Luxaci\u00f3n, esguince y torcedura de articulaciones y ligamentos de la cintura escapular',
    code_1: 'S40-S49',
    code_0: 'S00-T88'
  },
  {
    code: 'S44',
    level: 2,
    description: 'Traumatismo de nervios a nivel del hombro y del brazo',
    code_1: 'S40-S49',
    code_0: 'S00-T88'
  },
  {
    code: 'I20',
    level: 2,
    description: 'Angina de pecho',
    code_1: 'I20-I25',
    code_0: 'I00-I99'
  },
  {
    code: 'I21',
    level: 2,
    description: 'Infarto agudo del miocardio',
    code_1: 'I20-I25',
    code_0: 'I00-I99'
  },
  {
    code: 'I22',
    level: 2,
    description: 'Infarto subsecuente del miocardio',
    code_1: 'I20-I25',
    code_0: 'I00-I99'
  },
  {
    code: 'I23',
    level: 2,
    description:
      'Ciertas complicaciones presentes posteriores al infarto agudo del miocardio',
    code_1: 'I20-I25',
    code_0: 'I00-I99'
  },
  {
    code: 'I10',
    level: 2,
    description: 'Hipertensi\u00f3n esencial (primaria)',
    code_1: 'I10-I15',
    code_0: 'I00-I99'
  },
  {
    code: 'I11',
    level: 2,
    description: 'Enfermedad card\u00edaca hipertensiva',
    code_1: 'I10-I15',
    code_0: 'I00-I99'
  },
  {
    code: 'I12',
    level: 2,
    description: 'Enfermedad renal hipertensiva',
    code_1: 'I10-I15',
    code_0: 'I00-I99'
  },
  {
    code: 'I05',
    level: 2,
    description: 'Enfermedades reum\u00e1ticas de la v\u00e1lvula mitral',
    code_1: 'I05-I09',
    code_0: 'I00-I99'
  },
  {
    code: 'I06',
    level: 2,
    description: 'Enfermedades reum\u00e1ticas de la v\u00e1lvula a\u00f3rtica',
    code_1: 'I05-I09',
    code_0: 'I00-I99'
  },
  {
    code: 'I07',
    level: 2,
    description:
      'Enfermedades reum\u00e1ticas de la v\u00e1lvula tric\u00faspide',
    code_1: 'I05-I09',
    code_0: 'I00-I99'
  },
  {
    code: 'I08',
    level: 2,
    description: 'Enfermedades valvulares m\u00faltiples',
    code_1: 'I05-I09',
    code_0: 'I00-I99'
  },
  {
    code: 'I09',
    level: 2,
    description: 'Otras enfermedades reum\u00e1ticas del coraz\u00f3n',
    code_1: 'I05-I09',
    code_0: 'I00-I99'
  },
  {
    code: 'I00',
    level: 2,
    description:
      'Fiebre reum\u00e1tica sin menci\u00f3n de complicaci\u00f3n card\u00edaca',
    code_1: 'I00-I02',
    code_0: 'I00-I99'
  },
  {
    code: 'I01',
    level: 2,
    description: 'Fiebre reum\u00e1tica con complicaci\u00f3n card\u00edaca',
    code_1: 'I00-I02',
    code_0: 'I00-I99'
  },
  {
    code: 'I02',
    level: 2,
    description: 'Corea reum\u00e1tica',
    code_1: 'I00-I02',
    code_0: 'I00-I99'
  },
  {
    code: 'J30',
    level: 2,
    description: 'Rinitis al\u00e9rgica y vasomotora',
    code_1: 'J30\u2013J39 ',
    code_0: 'J00-J99'
  },
  {
    code: 'J31',
    level: 2,
    description: 'Rinitis, rinofaringitis y faringitis cr\u00f3nicas',
    code_1: 'J30\u2013J39 ',
    code_0: 'J00-J99'
  },
  {
    code: 'J32',
    level: 2,
    description: 'Sinusitis cr\u00f3nica',
    code_1: 'J30\u2013J39 ',
    code_0: 'J00-J99'
  },
  {
    code: 'J33',
    level: 2,
    description: 'P\u00f3lipo nasal',
    code_1: 'J30\u2013J39 ',
    code_0: 'J00-J99'
  },
  {
    code: 'J20',
    level: 2,
    description: 'Bronquitis aguda',
    code_1: 'J20-J22',
    code_0: 'J00-J99'
  },
  {
    code: 'J21',
    level: 2,
    description: 'Bronquiolitis aguda',
    code_1: 'J20-J22',
    code_0: 'J00-J99'
  },
  {
    code: 'J22',
    level: 2,
    description:
      'Infecci\u00f3n aguda no especificada de las v\u00edas respiratorias inferiores',
    code_1: 'J20-J22',
    code_0: 'J00-J99'
  },
  {
    code: 'J09',
    level: 2,
    description: 'Influenza debida a virus de la influenza aviar identificado',
    code_1: 'J09\u2013J18 ',
    code_0: 'J00-J99'
  },
  {
    code: 'J10',
    level: 2,
    description: 'Influenza debida a otro virus de la influenza identificado',
    code_1: 'J09\u2013J18 ',
    code_0: 'J00-J99'
  },
  {
    code: 'J11',
    level: 2,
    description: 'Influenza debida a virus no identificado',
    code_1: 'J09\u2013J18 ',
    code_0: 'J00-J99'
  },
  {
    code: 'J12',
    level: 2,
    description: 'Neumon\u00eda viral, no clasificada en otra parte',
    code_1: 'J09\u2013J18 ',
    code_0: 'J00-J99'
  },
  {
    code: 'J00',
    level: 2,
    description: 'Rinofaringitis aguda [resfriado com\u00fan]',
    code_1: 'J00-J06',
    code_0: 'J00-J99'
  },
  {
    code: 'J01',
    level: 2,
    description: 'Sinusitis aguda',
    code_1: 'J00-J06',
    code_0: 'J00-J99'
  },
  {
    code: 'J02',
    level: 2,
    description: 'Faringitis aguda',
    code_1: 'J00-J06',
    code_0: 'J00-J99'
  },
  {
    code: 'J03',
    level: 2,
    description: 'Amigdalitis aguda',
    code_1: 'J00-J06',
    code_0: 'J00-J99'
  },
  {
    code: 'J04',
    level: 2,
    description: 'Laringitis y traque\u00edtis agudas',
    code_1: 'J00-J06',
    code_0: 'J00-J99'
  },
  {
    code: 'J05',
    level: 2,
    description: 'Laringitis obstructiva aguda [crup] y epiglotitis',
    code_1: 'J00-J06',
    code_0: 'J00-J99'
  },
  {
    code: 'K55',
    level: 2,
    description: 'Trastornos vasculares de los intestinos',
    code_1: 'K55-K63',
    code_0: 'K00-K95'
  },
  {
    code: 'K56',
    level: 2,
    description:
      '\u00cdleo paral\u00edtico y obstrucci\u00f3n intestinal sin hernia',
    code_1: 'K55-K63',
    code_0: 'K00-K95'
  },
  {
    code: 'K57',
    level: 2,
    description: 'Enfermedad diverticular del intestino',
    code_1: 'K55-K63',
    code_0: 'K00-K95'
  },
  {
    code: 'K58',
    level: 2,
    description: 'S\u00edndrome del colon irritable',
    code_1: 'K55-K63',
    code_0: 'K00-K95'
  },
  {
    code: 'K59',
    level: 2,
    description: 'Otros trastornos funcionales del intestino',
    code_1: 'K55-K63',
    code_0: 'K00-K95'
  },
  {
    code: 'K60',
    level: 2,
    description: 'Fisura y f\u00edstula de las regiones anal y rectal',
    code_1: 'K55-K63',
    code_0: 'K00-K95'
  },
  {
    code: 'K61',
    level: 2,
    description: 'Absceso de las regiones anal y rectal',
    code_1: 'K55-K63',
    code_0: 'K00-K95'
  },
  {
    code: 'K50',
    level: 2,
    description: 'Enfermedad de Crohn [enteritis regional]',
    code_1: 'K50-K52',
    code_0: 'K00-K95'
  },
  {
    code: 'K51',
    level: 2,
    description: 'Colitis ulcerativa',
    code_1: 'K50-K52',
    code_0: 'K00-K95'
  },
  {
    code: 'K52',
    level: 2,
    description: 'Otras colitis y gastroenteritis no infecciosas',
    code_1: 'K50-K52',
    code_0: 'K00-K95'
  },
  {
    code: 'K40',
    level: 2,
    description: 'Hernia inguinal',
    code_1: 'K40-K46',
    code_0: 'K00-K95'
  },
  {
    code: 'K41',
    level: 2,
    description: 'Hernia femoral',
    code_1: 'K40-K46',
    code_0: 'K00-K95'
  },
  {
    code: 'K42',
    level: 2,
    description: 'Hernia umbilical',
    code_1: 'K40-K46',
    code_0: 'K00-K95'
  },
  {
    code: 'K43',
    level: 2,
    description: 'Hernia ventral',
    code_1: 'K40-K46',
    code_0: 'K00-K95'
  },
  {
    code: 'K35',
    level: 2,
    description: 'Apendicitis aguda',
    code_1: 'K35-K38',
    code_0: 'K00-K95'
  },
  {
    code: 'K36',
    level: 2,
    description: 'Otros tipos de apendicitis',
    code_1: 'K35-K38',
    code_0: 'K00-K95'
  },
  {
    code: 'K37',
    level: 2,
    description: 'Apendicitis, no especificada',
    code_1: 'K35-K38',
    code_0: 'K00-K95'
  },
  {
    code: 'K38',
    level: 2,
    description: 'Otras enfermedades del ap\u00e9ndice',
    code_1: 'K35-K38',
    code_0: 'K00-K95'
  },
  {
    code: 'K20',
    level: 2,
    description: 'Esofagitis',
    code_1: 'K20-K31',
    code_0: 'K00-K95'
  },
  {
    code: 'K21',
    level: 2,
    description: 'Enfermedad del reflujo gastroesof\u00e1gico',
    code_1: 'K20-K31',
    code_0: 'K00-K95'
  },
  {
    code: 'K22',
    level: 2,
    description: 'Otras enfermedades del es\u00f3fago',
    code_1: 'K20-K31',
    code_0: 'K00-K95'
  },
  {
    code: 'K00',
    level: 2,
    description:
      'Trastornos del desarrollo y de la erupci\u00f3n de los dientes',
    code_1: 'K00-K14',
    code_0: 'K00-K95'
  },
  {
    code: 'K01',
    level: 2,
    description: 'Dientes incluidos e impactados',
    code_1: 'K00-K14',
    code_0: 'K00-K95'
  },
  {
    code: 'K02',
    level: 2,
    description: 'Caries dental',
    code_1: 'K00-K14',
    code_0: 'K00-K95'
  },
  {
    code: 'K03',
    level: 2,
    description: 'Otras enfermedades de los tejidos duros de los dientes',
    code_1: 'K00-K14',
    code_0: 'K00-K95'
  },
  {
    code: 'K04',
    level: 2,
    description: 'Enfermedades de la pulpa y de los tejidos periapicales',
    code_1: 'K00-K14',
    code_0: 'K00-K95'
  },
  {
    code: 'K05',
    level: 2,
    description: 'Gingivitis y enfermedades periodontales',
    code_1: 'K00-K14',
    code_0: 'K00-K95'
  },
  {
    code: 'L40',
    level: 2,
    description: 'Psoriasis',
    code_1: 'L40-L45',
    code_0: 'L00-L99'
  },
  {
    code: 'L41',
    level: 2,
    description: 'Parapsoriasis',
    code_1: 'L40-L45',
    code_0: 'L00-L99'
  },
  {
    code: 'L42',
    level: 2,
    description: 'Pitiriasis rosada',
    code_1: 'L40-L45',
    code_0: 'L00-L99'
  },
  {
    code: 'L43',
    level: 2,
    description: 'Liquen plano',
    code_1: 'L40-L45',
    code_0: 'L00-L99'
  },
  {
    code: 'L44',
    level: 2,
    description: 'Otros trastornos papuloescamosos',
    code_1: 'L40-L45',
    code_0: 'L00-L99'
  },
  {
    code: 'L20',
    level: 2,
    description: 'Dermatitis at\u00f3pica',
    code_1: 'L20-L30',
    code_0: 'L00-L99'
  },
  {
    code: 'L21',
    level: 2,
    description: 'Dermatitis seborreica',
    code_1: 'L20-L30',
    code_0: 'L00-L99'
  },
  {
    code: 'L22',
    level: 2,
    description: 'Dermatitis del pa\u00f1al',
    code_1: 'L20-L30',
    code_0: 'L00-L99'
  },
  {
    code: 'L23',
    level: 2,
    description: 'Dermatitis al\u00e9rgica de contacto',
    code_1: 'L20-L30',
    code_0: 'L00-L99'
  },
  {
    code: 'L24',
    level: 2,
    description: 'Dermatitis de contacto por irritantes',
    code_1: 'L20-L30',
    code_0: 'L00-L99'
  },
  {
    code: 'L25',
    level: 2,
    description: 'Dermatitis de contacto, forma no especificada',
    code_1: 'L20-L30',
    code_0: 'L00-L99'
  },
  {
    code: 'L26',
    level: 2,
    description: 'Dermatitis exfoliativa',
    code_1: 'L20-L30',
    code_0: 'L00-L99'
  },
  {
    code: 'L10',
    level: 2,
    description: 'P\u00e9nfigo',
    code_1: 'L10-L14',
    code_0: 'L00-L99'
  },
  {
    code: 'L11',
    level: 2,
    description: 'Otros trastornos acantol\u00edticos',
    code_1: 'L10-L14',
    code_0: 'L00-L99'
  },
  {
    code: 'L12',
    level: 2,
    description: 'Penfigoide',
    code_1: 'L10-L14',
    code_0: 'L00-L99'
  },
  {
    code: 'L00',
    level: 2,
    description: 'S\u00edndrome estafiloc\u00f3cico de la piel escaldada',
    code_1: 'L00-L08',
    code_0: 'L00-L99'
  },
  {
    code: 'L01',
    level: 2,
    description: 'Imp\u00e9tigo',
    code_1: 'L00-L08',
    code_0: 'L00-L99'
  },
  {
    code: 'L02',
    level: 2,
    description: 'Absceso cut\u00e1neo, fur\u00fanculo y carbunco',
    code_1: 'L00-L08',
    code_0: 'L00-L99'
  },
  {
    code: 'L03',
    level: 2,
    description: 'Celulitis',
    code_1: 'L00-L08',
    code_0: 'L00-L99'
  },
  {
    code: 'L04',
    level: 2,
    description: 'Linfadenitis aguda',
    code_1: 'L00-L08',
    code_0: 'L00-L99'
  },
  {
    code: 'M80-M85',
    level: 2,
    description: 'Trastornos de la densidad y de la estructura \u00f3seas',
    code_1: 'M80-M94',
    code_0: 'M00-M99'
  },
  {
    code: 'M86-M90',
    level: 2,
    description: 'Otras osteopat\u00edas',
    code_1: 'M80-M94',
    code_0: 'M00-M99'
  },
  {
    code: 'M91-M94',
    level: 2,
    description: 'Condropat\u00edas',
    code_1: 'M80-M94',
    code_0: 'M00-M99'
  },
  {
    code: 'M60-M63',
    level: 2,
    description: 'Trastornos de los m\u00fasculos',
    code_1: 'M60-M79',
    code_0: 'M00-M99'
  },
  {
    code: 'M65-M68',
    level: 2,
    description: 'Trastornos de los tendones y de la sinovia',
    code_1: 'M60-M79',
    code_0: 'M00-M99'
  },
  {
    code: 'M70-M79',
    level: 2,
    description: 'Otros trastornos de los tejidos blandos',
    code_1: 'M60-M79',
    code_0: 'M00-M99'
  },
  {
    code: 'M40-M43',
    level: 2,
    description: 'Dorsopat\u00edas deformantes',
    code_1: 'M40-M54',
    code_0: 'M00-M99'
  },
  {
    code: 'M45-M49',
    level: 2,
    description: 'Espondilopat\u00edas',
    code_1: 'M40-M54',
    code_0: 'M00-M99'
  },
  {
    code: 'M50-M54',
    level: 2,
    description: 'Otras dorsopat\u00edas',
    code_1: 'M40-M54',
    code_0: 'M00-M99'
  },
  {
    code: 'M30',
    level: 2,
    description: 'Poliarteritis nudosa y afecciones relacionadas',
    code_1: 'M30-M36',
    code_0: 'M00-M99'
  },
  {
    code: 'M31',
    level: 2,
    description: 'Otras vasculopat\u00edas necrotizantes',
    code_1: 'M30-M36',
    code_0: 'M00-M99'
  },
  {
    code: 'M32',
    level: 2,
    description: 'Lupus eritematoso sist\u00e9mico',
    code_1: 'M30-M36',
    code_0: 'M00-M99'
  },
  {
    code: 'M33',
    level: 2,
    description: 'Dermatopolimiositis',
    code_1: 'M30-M36',
    code_0: 'M00-M99'
  },
  {
    code: 'M34',
    level: 2,
    description: 'Esclerosis sist\u00e9mica',
    code_1: 'M30-M36',
    code_0: 'M00-M99'
  },
  {
    code: 'M35',
    level: 2,
    description: 'Otro compromiso sist\u00e9mico del tejido conjuntivo',
    code_1: 'M30-M36',
    code_0: 'M00-M99'
  },
  {
    code: 'M36',
    level: 2,
    description:
      'Trastornos sist\u00e9micos del tejido conjuntivo en enfermedades clasificadas en otra parte',
    code_1: 'M30-M36',
    code_0: 'M00-M99'
  },
  {
    code: 'M00-M03',
    level: 2,
    description: 'Artropat\u00edas infecciosas',
    code_1: 'M00-M25',
    code_0: 'M00-M99'
  },
  {
    code: 'M05-M14',
    level: 2,
    description: 'Poliartropat\u00edas inflamatorias',
    code_1: 'M00-M25',
    code_0: 'M00-M99'
  },
  {
    code: 'M15-M19',
    level: 2,
    description: 'Artrosis',
    code_1: 'M00-M25',
    code_0: 'M00-M99'
  },
  {
    code: 'M20-M25',
    level: 2,
    description: 'Otros trastornos articulares',
    code_1: 'M00-M25',
    code_0: 'M00-M99'
  },
  {
    code: 'A90',
    level: 2,
    description: 'Fiebre del dengue [dengue cl\u00e1sico]',
    code_1: 'A90-A99',
    code_0: 'A00-B99'
  },
  {
    code: 'A91',
    level: 2,
    description: 'Fiebre del dengue hemorr\u00e1gico',
    code_1: 'A90-A99',
    code_0: 'A00-B99'
  },
  {
    code: 'A92',
    level: 2,
    description: 'Otras fiebres virales transmitidas por mosquitos',
    code_1: 'A90-A99',
    code_0: 'A00-B99'
  },
  {
    code: 'A93',
    level: 2,
    description:
      'Otras fiebres virales transmitidas por artr\u00f3podos, no clasificadas en otra parte',
    code_1: 'A90-A99',
    code_0: 'A00-B99'
  },
  {
    code: 'A80',
    level: 2,
    description: 'Poliomielitis aguda',
    code_1: 'A80-A89',
    code_0: 'A00-B99'
  },
  {
    code: 'A81',
    level: 2,
    description:
      'Infecciones del sistema nervioso central por virus at\u00edpico',
    code_1: 'A80-A89',
    code_0: 'A00-B99'
  },
  {
    code: 'A82',
    level: 2,
    description: 'Rabia',
    code_1: 'A80-A89',
    code_0: 'A00-B99'
  },
  {
    code: 'A83',
    level: 2,
    description: 'Encefalitis viral transmitida por mosquitos',
    code_1: 'A80-A89',
    code_0: 'A00-B99'
  },
  {
    code: 'A84',
    level: 2,
    description: 'Encefalitis viral transmitida por garrapatas',
    code_1: 'A80-A89',
    code_0: 'A00-B99'
  },
  {
    code: 'A85',
    level: 2,
    description: 'Otras encefalitis virales, no clasificadas en otra parte',
    code_1: 'A80-A89',
    code_0: 'A00-B99'
  },
  {
    code: 'A75',
    level: 2,
    description: 'Tifus',
    code_1: 'A75-A79',
    code_0: 'A00-B99'
  },
  {
    code: 'A77',
    level: 2,
    description: 'Fiebre maculosa [rickettsiosis transmitida por garrapatas]',
    code_1: 'A75-A79',
    code_0: 'A00-B99'
  },
  {
    code: 'A78',
    level: 2,
    description: 'Fiebre Q',
    code_1: 'A75-A79',
    code_0: 'A00-B99'
  },
  {
    code: 'A79',
    level: 2,
    description: 'Otras rickettsiosis',
    code_1: 'A75-A79',
    code_0: 'A00-B99'
  },
  {
    code: 'A70',
    level: 2,
    description: 'Infecci\u00f3n debida a Chlamydia psittaci',
    code_1: 'A70-A74',
    code_0: 'A00-B99'
  },
  {
    code: 'A71',
    level: 2,
    description: 'Tracoma',
    code_1: 'A70-A74',
    code_0: 'A00-B99'
  },
  {
    code: 'A74',
    level: 2,
    description: 'Otras enfermedades causadas por clamidias',
    code_1: 'A70-A74',
    code_0: 'A00-B99'
  },
  {
    code: 'A65',
    level: 2,
    description: 'S\u00edfilis no ven\u00e9rea',
    code_1: 'A65-A69',
    code_0: 'A00-B99'
  },
  {
    code: 'A66',
    level: 2,
    description: 'Frambesia',
    code_1: 'A65-A69',
    code_0: 'A00-B99'
  },
  {
    code: 'A67',
    level: 2,
    description: 'Pinta [carate]',
    code_1: 'A65-A69',
    code_0: 'A00-B99'
  },
  {
    code: 'A68',
    level: 2,
    description: 'Fiebres recurrentes',
    code_1: 'A65-A69',
    code_0: 'A00-B99'
  },
  {
    code: 'A69',
    level: 2,
    description: 'Otras infecciones causadas por espiroquetas',
    code_1: 'A65-A69',
    code_0: 'A00-B99'
  },
  {
    code: 'A50',
    level: 2,
    description: 'S\u00edfilis cong\u00e9nita',
    code_1: 'A50-A64',
    code_0: 'A00-B99'
  },
  {
    code: 'A51',
    level: 2,
    description: 'S\u00edfilis precoz',
    code_1: 'A50-A64',
    code_0: 'A00-B99'
  },
  {
    code: 'A52',
    level: 2,
    description: 'S\u00edfilis tard\u00eda',
    code_1: 'A50-A64',
    code_0: 'A00-B99'
  },
  {
    code: 'A53',
    level: 2,
    description: 'Otras s\u00edfilis y las no especificadas',
    code_1: 'A50-A64',
    code_0: 'A00-B99'
  },
  {
    code: 'A30',
    level: 2,
    description: 'Lepra [enfermedad de Hansen]',
    code_1: 'A30-A49',
    code_0: 'A00-B99'
  },
  {
    code: 'A31',
    level: 2,
    description: 'Infecciones debidas a otras micobacterias',
    code_1: 'A30-A49',
    code_0: 'A00-B99'
  },
  {
    code: 'A32',
    level: 2,
    description: 'Listeriosis',
    code_1: 'A30-A49',
    code_0: 'A00-B99'
  },
  {
    code: 'A33',
    level: 2,
    description: 'T\u00e9tanos neonatal',
    code_1: 'A30-A49',
    code_0: 'A00-B99'
  },
  {
    code: 'A34',
    level: 2,
    description: 'T\u00e9tanos obst\u00e9trico',
    code_1: 'A30-A49',
    code_0: 'A00-B99'
  },
  {
    code: 'A35',
    level: 2,
    description: 'Otros t\u00e9tanos',
    code_1: 'A30-A49',
    code_0: 'A00-B99'
  },
  {
    code: 'A20',
    level: 2,
    description: 'Peste',
    code_1: 'A20-A28',
    code_0: 'A00-B99'
  },
  {
    code: 'A21',
    level: 2,
    description: 'Tularemia',
    code_1: 'A20-A28',
    code_0: 'A00-B99'
  },
  {
    code: 'A22',
    level: 2,
    description: 'Carbunco [\u00e1ntrax]',
    code_1: 'A20-A28',
    code_0: 'A00-B99'
  },
  {
    code: 'A23',
    level: 2,
    description: 'Brucelosis',
    code_1: 'A20-A28',
    code_0: 'A00-B99'
  },
  {
    code: 'A24',
    level: 2,
    description: 'Muermo y melioidosis',
    code_1: 'A20-A28',
    code_0: 'A00-B99'
  },
  {
    code: 'A15',
    level: 2,
    description:
      'Tuberculosis respiratoria, confirmada bacteriol\u00f3gica e histol\u00f3gicamente',
    code_1: 'A15-A19',
    code_0: 'A00-B99'
  },
  {
    code: 'A16',
    level: 2,
    description:
      'Tuberculosis respiratoria, no confirmada bacteriol\u00f3gica o histol\u00f3gicamente',
    code_1: 'A15-A19',
    code_0: 'A00-B99'
  },
  {
    code: 'A17',
    level: 2,
    description: 'Tuberculosis del sistema nervioso',
    code_1: 'A15-A19',
    code_0: 'A00-B99'
  },
  {
    code: 'A18',
    level: 2,
    description: 'Tuberculosis de otros \u00f3rganos',
    code_1: 'A15-A19',
    code_0: 'A00-B99'
  },
  {
    code: 'A19',
    level: 2,
    description: 'Tuberculosis miliar',
    code_1: 'A15-A19',
    code_0: 'A00-B99'
  },
  {
    code: 'N20',
    level: 2,
    description: 'C\u00e1lculo del ri\u00f1\u00f3n y del ur\u00e9ter',
    code_1: 'N20-N23',
    code_0: 'N00-N99'
  },
  {
    code: 'N21',
    level: 2,
    description: 'C\u00e1lculo de las v\u00edas urinarias inferiores',
    code_1: 'N20-N23',
    code_0: 'N00-N99'
  },
  {
    code: 'N22',
    level: 2,
    description:
      'C\u00e1lculo de las v\u00edas urinarias en enfermedades clasificadas en otra parte',
    code_1: 'N20-N23',
    code_0: 'N00-N99'
  },
  {
    code: 'N23',
    level: 2,
    description: 'C\u00f3lico renal, no especificado',
    code_1: 'N20-N23',
    code_0: 'N00-N99'
  },
  {
    code: 'N17',
    level: 2,
    description: 'Insuficiencia renal aguda',
    code_1: 'N17-N19',
    code_0: 'N00-N99'
  },
  {
    code: 'N18',
    level: 2,
    description: 'Insuficiencia renal cr\u00f3nica',
    code_1: 'N17-N19',
    code_0: 'N00-N99'
  },
  {
    code: 'N19',
    level: 2,
    description: 'Insuficiencia renal no especificada',
    code_1: 'N17-N19',
    code_0: 'N00-N99'
  },
  {
    code: 'N10',
    level: 2,
    description: 'Nefritis tubulointersticial aguda',
    code_1: 'N10-N16',
    code_0: 'N00-N99'
  },
  {
    code: 'N11',
    level: 2,
    description: 'Nefritis tubulointersticial cr\u00f3nica',
    code_1: 'N10-N16',
    code_0: 'N00-N99'
  },
  {
    code: 'N12',
    level: 2,
    description:
      'Nefritis tubulointersticial, no especificada como aguda o cr\u00f3nica',
    code_1: 'N10-N16',
    code_0: 'N00-N99'
  },
  {
    code: 'N13',
    level: 2,
    description: 'Uropat\u00eda obstructiva y por reflujo',
    code_1: 'N10-N16',
    code_0: 'N00-N99'
  },
  {
    code: 'N14',
    level: 2,
    description:
      'Afecciones tubulares y tubulointersticiales inducidas por drogas y por metales pesados',
    code_1: 'N10-N16',
    code_0: 'N00-N99'
  },
  {
    code: 'N00',
    level: 2,
    description: 'S\u00edndrome nefr\u00edtico agudo',
    code_1: 'N00-N08',
    code_0: 'N00-N99'
  },
  {
    code: 'N01',
    level: 2,
    description: 'S\u00edndrome nefr\u00edtico r\u00e1pidamente progresivo',
    code_1: 'N00-N08',
    code_0: 'N00-N99'
  },
  {
    code: 'N02',
    level: 2,
    description: 'Hematuria recurrente y persistente',
    code_1: 'N00-N08',
    code_0: 'N00-N99'
  },
  {
    code: 'N03',
    level: 2,
    description: 'S\u00edndrome nefr\u00edtico cr\u00f3nico',
    code_1: 'N00-N08',
    code_0: 'N00-N99'
  },
  {
    code: 'N04',
    level: 2,
    description: 'S\u00edndrome nefr\u00f3tico',
    code_1: 'N00-N08',
    code_0: 'N00-N99'
  },
  {
    code: 'N05',
    level: 2,
    description: 'S\u00edndrome nefr\u00edtico no especificado',
    code_1: 'N00-N08',
    code_0: 'N00-N99'
  },
  {
    code: 'N06',
    level: 2,
    description:
      'Proteinuria aislada con lesi\u00f3n morfol\u00f3gica especificada',
    code_1: 'N00-N08',
    code_0: 'N00-N99'
  },
  {
    code: 'O30',
    level: 2,
    description: 'Embarazo m\u00faltiple',
    code_1: 'O30\u2013O48',
    code_0: 'O00-O9A'
  },
  {
    code: 'O31',
    level: 2,
    description: 'Complicaciones espec\u00edficas del embarazo m\u00faltiple',
    code_1: 'O30\u2013O48',
    code_0: 'O00-O9A'
  },
  {
    code: 'O32',
    level: 2,
    description:
      'Atenci\u00f3n materna por presentaci\u00f3n anormal del feto, conocida o presunta',
    code_1: 'O30\u2013O48',
    code_0: 'O00-O9A'
  },
  {
    code: 'O33',
    level: 2,
    description:
      'Atenci\u00f3n materna por desproporci\u00f3n conocida o presunta',
    code_1: 'O30\u2013O48',
    code_0: 'O00-O9A'
  },
  {
    code: 'O34',
    level: 2,
    description:
      'Atenci\u00f3n materna por anormalidades conocidas o presuntas de los \u00f3rganos pelvianos de la madre',
    code_1: 'O30\u2013O48',
    code_0: 'O00-O9A'
  },
  {
    code: 'G06',
    level: 2,
    description: 'Absceso y granuloma intracraneal e intrarraqu\u00eddeo',
    code_1: 'G00-G09',
    code_0: 'G00-G99'
  },
  {
    code: 'G07',
    level: 2,
    description:
      'Absceso y granuloma intracraneal e intrarraqu\u00eddeo en enfermedades clasificadas en otra parte',
    code_1: 'G00-G09',
    code_0: 'G00-G99'
  },
  {
    code: 'G08',
    level: 2,
    description: 'Flebitis y tromboflebitis intracraneal e intrarraqu\u00eddea',
    code_1: 'G00-G09',
    code_0: 'G00-G99'
  },
  {
    code: 'G09',
    level: 2,
    description:
      'Secuelas de enfermedades inflamatorias del sistema nervioso central',
    code_1: 'G00-G09',
    code_0: 'G00-G99'
  },
  {
    code: 'S32',
    level: 2,
    description: 'Fractura de la columna lumbar y de la pelvis',
    code_1: 'S30-S39',
    code_0: 'S00-T88'
  },
  {
    code: 'S33',
    level: 2,
    description:
      'Luxaci\u00f3n, esguince y torcedura de articulaciones y ligamentos de la columna lumbar y de la pelvis',
    code_1: 'S30-S39',
    code_0: 'S00-T88'
  },
  {
    code: 'S34',
    level: 2,
    description:
      'Traumatismo de los nervios y de la m\u00e9dula espinal lumbar, a nivel del abdomen, de la regi\u00f3n lumbosacra y de la pelvis',
    code_1: 'S30-S39',
    code_0: 'S00-T88'
  },
  {
    code: 'S35',
    level: 2,
    description:
      'Traumatismo de vasos sangu\u00edneos a nivel del abdomen, de la regi\u00f3n lumbosacra y de la pelvis',
    code_1: 'S30-S39',
    code_0: 'S00-T88'
  },
  {
    code: 'S36',
    level: 2,
    description: 'Traumatismo de \u00f3rganos intraabdominales',
    code_1: 'S30-S39',
    code_0: 'S00-T88'
  },
  {
    code: 'S37',
    level: 2,
    description:
      'Traumatismo del aparato urinario y de los \u00f3rganos p\u00e9lvicos',
    code_1: 'S30-S39',
    code_0: 'S00-T88'
  },
  {
    code: 'S38',
    level: 2,
    description:
      'Traumatismo por aplastamiento y amputaci\u00f3n traum\u00e1tica de parte del abdomen, de la regi\u00f3n lumbosacra y de la pelvis',
    code_1: 'S30-S39',
    code_0: 'S00-T88'
  },
  {
    code: 'S39',
    level: 2,
    description:
      'Otros traumatismos y los no especificados del abdomen, de la regi\u00f3n lumbosacra y de la pelvis',
    code_1: 'S30-S39',
    code_0: 'S00-T88'
  },
  {
    code: 'S25',
    level: 2,
    description: 'Traumatismo de vasos sangu\u00edneos del t\u00f3rax',
    code_1: 'S20-S29',
    code_0: 'S00-T88'
  },
  {
    code: 'S26',
    level: 2,
    description: 'Traumatismo del coraz\u00f3n',
    code_1: 'S20-S29',
    code_0: 'S00-T88'
  },
  {
    code: 'S27',
    level: 2,
    description:
      'Traumatismo de otros \u00f3rganos intrator\u00e1cicos y de los no especificados',
    code_1: 'S20-S29',
    code_0: 'S00-T88'
  },
  {
    code: 'S28',
    level: 2,
    description:
      'Traumatismo por aplastamiento del t\u00f3rax y amputaci\u00f3n traum\u00e1tica de parte del t\u00f3rax',
    code_1: 'S20-S29',
    code_0: 'S00-T88'
  },
  {
    code: 'S29',
    level: 2,
    description: 'Otros traumatismos y los no especificados del t\u00f3rax',
    code_1: 'S20-S29',
    code_0: 'S00-T88'
  },
  {
    code: 'O20',
    level: 2,
    description: 'Hemorragia precoz del embarazo',
    code_1: 'O20-O29',
    code_0: 'O00-O9A'
  },
  {
    code: 'O21',
    level: 2,
    description: 'V\u00f3mitos excesivos en el embarazo',
    code_1: 'O20-O29',
    code_0: 'O00-O9A'
  },
  {
    code: 'O22',
    level: 2,
    description: 'Complicaciones venosas en el embarazo',
    code_1: 'O20-O29',
    code_0: 'O00-O9A'
  },
  {
    code: 'O23',
    level: 2,
    description:
      'Infecci\u00f3n de las v\u00edas genitourinarias en el embarazo',
    code_1: 'O20-O29',
    code_0: 'O00-O9A'
  },
  {
    code: 'O24',
    level: 2,
    description: 'Diabetes mellitus en el embarazo',
    code_1: 'O20-O29',
    code_0: 'O00-O9A'
  },
  {
    code: 'O25',
    level: 2,
    description: 'Desnutrici\u00f3n en el embarazo',
    code_1: 'O20-O29',
    code_0: 'O00-O9A'
  },
  {
    code: 'O26',
    level: 2,
    description:
      'Atenci\u00f3n a la madre por otras complicaciones principalmente relacionadas con el embarazo',
    code_1: 'O20-O29',
    code_0: 'O00-O9A'
  },
  {
    code: 'S13',
    level: 2,
    description:
      'Luxaci\u00f3n, esguince y torcedura de articulaciones y ligamentos del cuello',
    code_1: 'S10-S19',
    code_0: 'S00-T88'
  },
  {
    code: 'S14',
    level: 2,
    description:
      'Traumatismo de la m\u00e9dula espinal y de nervios a nivel del cuello',
    code_1: 'S10-S19',
    code_0: 'S00-T88'
  },
  {
    code: 'S15',
    level: 2,
    description: 'Traumatismo de vasos sangu\u00edneos a nivel del cuello',
    code_1: 'S10-S19',
    code_0: 'S00-T88'
  },
  {
    code: 'S16',
    level: 2,
    description:
      'Traumatismo de tend\u00f3n y m\u00fasculos a nivel del cuello',
    code_1: 'S10-S19',
    code_0: 'S00-T88'
  },
  {
    code: 'S17',
    level: 2,
    description: 'Traumatismo por aplastamiento del cuello',
    code_1: 'S10-S19',
    code_0: 'S00-T88'
  },
  {
    code: 'S18',
    level: 2,
    description: 'Amputaci\u00f3n traum\u00e1tica a nivel del cuello',
    code_1: 'S10-S19',
    code_0: 'S00-T88'
  },
  {
    code: 'S19',
    level: 2,
    description: 'Otros traumatismos y los no especificados del cuello',
    code_1: 'S10-S19',
    code_0: 'S00-T88'
  },
  {
    code: 'S05',
    level: 2,
    description: 'Traumatismo del ojo y de la \u00f3rbita',
    code_1: 'S00-S09',
    code_0: 'S00-T88'
  },
  {
    code: 'S06',
    level: 2,
    description: 'Traumatismo intracraneal',
    code_1: 'S00-S09',
    code_0: 'S00-T88'
  },
  {
    code: 'S07',
    level: 2,
    description: 'Traumatismo por aplastamiento de la cabeza',
    code_1: 'S00-S09',
    code_0: 'S00-T88'
  },
  {
    code: 'S08',
    level: 2,
    description: 'Amputaci\u00f3n traum\u00e1tica de parte de la cabeza',
    code_1: 'S00-S09',
    code_0: 'S00-T88'
  },
  {
    code: 'S09',
    level: 2,
    description: 'Otros traumatismos y los no especificados de la cabeza',
    code_1: 'S00-S09',
    code_0: 'S00-T88'
  },
  {
    code: 'O10',
    level: 2,
    description:
      'Hipertensi\u00f3n preexistente que complica el embarazo, el parto y el puerperio',
    code_1: 'O10-O16',
    code_0: 'O00-O9A'
  },
  {
    code: 'O11',
    level: 2,
    description:
      'Trastornos hipertensivos preexistentes, con proteinuria agregada',
    code_1: 'O10-O16',
    code_0: 'O00-O9A'
  },
  {
    code: 'O12',
    level: 2,
    description:
      'Edema y proteinuria gestacionales [inducidos por el embarazo] sin hipertensi\u00f3n',
    code_1: 'O10-O16',
    code_0: 'O00-O9A'
  },
  {
    code: 'O13',
    level: 2,
    description:
      'Hipertensi\u00f3n gestacional [inducida por el embarazo] sin proteinuria significativa',
    code_1: 'O10-O16',
    code_0: 'O00-O9A'
  },
  {
    code: 'O14',
    level: 2,
    description:
      'Hipertensi\u00f3n gestacional [inducida por el embarazo] con proteinuria significativa',
    code_1: 'O10-O16',
    code_0: 'O00-O9A'
  },
  {
    code: 'F88',
    level: 2,
    description: 'Otros trastornos del desarrollo psicol\u00f3gico',
    code_1: 'F80-F89',
    code_0: 'F01-F99'
  },
  {
    code: 'F89',
    level: 2,
    description: 'Trastorno del desarrollo psicol\u00f3gico, no especificado',
    code_1: 'F80-F89',
    code_0: 'F01-F99'
  },
  {
    code: 'O00',
    level: 2,
    description: 'Embarazo ect\u00f3pico',
    code_1: 'O00-O08',
    code_0: 'O00-O9A'
  },
  {
    code: 'O01',
    level: 2,
    description: 'Mola hidatiforme',
    code_1: 'O00-O08',
    code_0: 'O00-O9A'
  },
  {
    code: 'O02',
    level: 2,
    description: 'Otros productos anormales de la concepci\u00f3n',
    code_1: 'O00-O08',
    code_0: 'O00-O9A'
  },
  {
    code: 'O03',
    level: 2,
    description: 'Aborto espont\u00e1neo',
    code_1: 'O00-O08',
    code_0: 'O00-O9A'
  },
  {
    code: 'O04',
    level: 2,
    description: 'Aborto m\u00e9dico',
    code_1: 'O00-O08',
    code_0: 'O00-O9A'
  },
  {
    code: 'O05',
    level: 2,
    description: 'Otro aborto',
    code_1: 'O00-O08',
    code_0: 'O00-O9A'
  },
  {
    code: 'O06',
    level: 2,
    description: 'Aborto no especificado',
    code_1: 'O00-O08',
    code_0: 'O00-O9A'
  },
  {
    code: 'O07',
    level: 2,
    description: 'Intento fallido de aborto',
    code_1: 'O00-O08',
    code_0: 'O00-O9A'
  },
  {
    code: 'D80',
    level: 2,
    description:
      'Inmunodeficiencia con predominio de defectos de los anticuerpos',
    code_1: 'D80-D89',
    code_0: 'D50-D89'
  },
  {
    code: 'D81',
    level: 2,
    description: 'Inmunodeficiencias combinadas',
    code_1: 'D80-D89',
    code_0: 'D50-D89'
  },
  {
    code: 'D82',
    level: 2,
    description: 'Inmunodeficiencia asociada con otros defectos mayores',
    code_1: 'D80-D89',
    code_0: 'D50-D89'
  },
  {
    code: 'D83',
    level: 2,
    description: 'Inmunodeficiencia variable com\u00fan',
    code_1: 'D80-D89',
    code_0: 'D50-D89'
  },
  {
    code: 'D84',
    level: 2,
    description: 'Otras inmunodeficiencias',
    code_1: 'D80-D89',
    code_0: 'D50-D89'
  },
  {
    code: 'D86',
    level: 2,
    description: 'Sarcoidosis',
    code_1: 'D80-D89',
    code_0: 'D50-D89'
  },
  {
    code: 'D89',
    level: 2,
    description:
      'Otros trastornos que afectan el mecanismo de la inmunidad, no clasificados en otra parte',
    code_1: 'D80-D89',
    code_0: 'D50-D89'
  },
  {
    code: 'P70',
    level: 2,
    description:
      'Trastornos transitorios del metabolismo de los carbohidratos espec\u00edficos del feto y del reci\u00e9n nacido',
    code_1: 'P70-P74',
    code_0: 'P00-P96'
  },
  {
    code: 'P71',
    level: 2,
    description:
      'Trastornos neonatales transitorios del metabolismo del calcio y del magnesio',
    code_1: 'P70-P74',
    code_0: 'P00-P96'
  },
  {
    code: 'P72',
    level: 2,
    description: 'Otros trastornos endocrinos neonatales transitorios',
    code_1: 'P70-P74',
    code_0: 'P00-P96'
  },
  {
    code: 'P74',
    level: 2,
    description:
      'Otras alteraciones metab\u00f3licas y electrol\u00edticas neonatales transitorias',
    code_1: 'P70-P74',
    code_0: 'P00-P96'
  },
  {
    code: 'P50',
    level: 2,
    description: 'P\u00e9rdida de sangre fetal',
    code_1: 'P50-P61',
    code_0: 'P00-P96'
  },
  {
    code: 'P51',
    level: 2,
    description: 'Hemorragia umbilical del reci\u00e9n nacido',
    code_1: 'P50-P61',
    code_0: 'P00-P96'
  },
  {
    code: 'P52',
    level: 2,
    description:
      'Hemorragia intracraneal no traum\u00e1tica del feto y del reci\u00e9n nacido',
    code_1: 'P50-P61',
    code_0: 'P00-P96'
  },
  {
    code: 'P53',
    level: 2,
    description:
      'Enfermedad hemorr\u00e1gica del feto y del reci\u00e9n nacido',
    code_1: 'P50-P61',
    code_0: 'P00-P96'
  },
  {
    code: 'P35',
    level: 2,
    description: 'Enfermedades virales cong\u00e9nitas',
    code_1: 'P35-P39',
    code_0: 'P00-P96'
  },
  {
    code: 'P36',
    level: 2,
    description: 'Sepsis bacteriana del reci\u00e9n nacido',
    code_1: 'P35-P39',
    code_0: 'P00-P96'
  },
  {
    code: 'P37',
    level: 2,
    description:
      'Otras enfermedades infecciosas y parasitarias cong\u00e9nitas',
    code_1: 'P35-P39',
    code_0: 'P00-P96'
  },
  {
    code: 'P38',
    level: 2,
    description: 'Onfalitis del reci\u00e9n nacido con o sin hemorragia leve',
    code_1: 'P35-P39',
    code_0: 'P00-P96'
  },
  {
    code: 'P39',
    level: 2,
    description:
      'Otras infecciones espec\u00edficas del per\u00edodo perinatal',
    code_1: 'P35-P39',
    code_0: 'P00-P96'
  },
  {
    code: 'F79',
    level: 2,
    description: 'Retraso mental, no especificado',
    code_1: 'F70-F79',
    code_0: 'F01-F99'
  },
  {
    code: 'P20',
    level: 2,
    description: 'Hipoxia intrauterina',
    code_1: 'P20-P29',
    code_0: 'P00-P96'
  },
  {
    code: 'P21',
    level: 2,
    description: 'Asfixia del nacimiento',
    code_1: 'P20-P29',
    code_0: 'P00-P96'
  },
  {
    code: 'P22',
    level: 2,
    description: 'Dificultad respiratoria del reci\u00e9n nacido',
    code_1: 'P20-P29',
    code_0: 'P00-P96'
  },
  {
    code: 'P23',
    level: 2,
    description: 'Neumon\u00eda cong\u00e9nita',
    code_1: 'P20-P29',
    code_0: 'P00-P96'
  },
  {
    code: 'F63',
    level: 2,
    description: 'Trastornos de los h\u00e1bitos y de los impulsos',
    code_1: 'F60-F69',
    code_0: 'F01-F99'
  },
  {
    code: 'F64',
    level: 2,
    description: 'Trastornos de la identidad de g\u00e9nero',
    code_1: 'F60-F69',
    code_0: 'F01-F99'
  },
  {
    code: 'F65',
    level: 2,
    description: 'Trastornos de la preferencia sexual',
    code_1: 'F60-F69',
    code_0: 'F01-F99'
  },
  {
    code: 'F66',
    level: 2,
    description:
      'Trastornos psicol\u00f3gicos y del comportamiento asociados con el desarrollo y con la orientaci\u00f3n sexuales',
    code_1: 'F60-F69',
    code_0: 'F01-F99'
  },
  {
    code: 'F68',
    level: 2,
    description:
      'Otros trastornos de la personalidad y del comportamiento en adultos',
    code_1: 'F60-F69',
    code_0: 'F01-F99'
  },
  {
    code: 'F69',
    level: 2,
    description:
      'Trastorno de la personalidad y del comportamiento en adultos, no especificado',
    code_1: 'F60-F69',
    code_0: 'F01-F99'
  },
  {
    code: 'F59',
    level: 2,
    description:
      'S\u00edndromes del comportamiento asociados con alteraciones fisiol\u00f3gicas y factores f\u00edsicos, no especificados',
    code_1: 'F50-F59',
    code_0: 'F01-F99'
  },
  {
    code: 'P10',
    level: 2,
    description:
      'Hemorragia y laceraci\u00f3n intracraneal debidas a traumatismo del nacimiento',
    code_1: 'P10-P15',
    code_0: 'P00-P96'
  },
  {
    code: 'P11',
    level: 2,
    description:
      'Otros traumatismos del nacimiento en el sistema nervioso central',
    code_1: 'P10-P15',
    code_0: 'P00-P96'
  },
  {
    code: 'P12',
    level: 2,
    description: 'Traumatismo del nacimiento en el cuero cabelludo',
    code_1: 'P10-P15',
    code_0: 'P00-P96'
  },
  {
    code: 'P13',
    level: 2,
    description: 'Traumatismo del esqueleto durante el nacimiento',
    code_1: 'P10-P15',
    code_0: 'P00-P96'
  },
  {
    code: 'P14',
    level: 2,
    description:
      'Traumatismo del sistema nervioso perif\u00e9rico durante el nacimiento',
    code_1: 'P10-P15',
    code_0: 'P00-P96'
  },
  {
    code: 'P15',
    level: 2,
    description: 'Otros traumatismos del nacimiento',
    code_1: 'P10-P15',
    code_0: 'P00-P96'
  },
  {
    code: 'A07',
    level: 2,
    description: 'Otras enfermedades intestinales debidas a protozoarios',
    code_1: 'A00-A09',
    code_0: 'A00-B99'
  },
  {
    code: 'A08',
    level: 2,
    description:
      'Infecciones intestinales debidas a virus y otros organismos especificados',
    code_1: 'A00-A09',
    code_0: 'A00-B99'
  },
  {
    code: 'A09',
    level: 2,
    description: 'Diarrea y gastroenteritis de presunto origen infeccioso',
    code_1: 'A00-A09',
    code_0: 'A00-B99'
  },
  {
    code: 'G97',
    level: 2,
    description:
      'Trastornos del sistema nervioso consecutivos a procedimientos, no clasificados en otra parte',
    code_1: 'G90-G99',
    code_0: 'G00-G99'
  },
  {
    code: 'G98',
    level: 2,
    description:
      'Otros trastornos del sistema nervioso, no clasificados en otra parte',
    code_1: 'G90-G99',
    code_0: 'G00-G99'
  },
  {
    code: 'G99',
    level: 2,
    description:
      'Otros trastornos del sistema nervioso en enfermedades clasificadas en otra parte',
    code_1: 'G90-G99',
    code_0: 'G00-G99'
  },
  {
    code: 'P05',
    level: 2,
    description: 'Retardo del crecimiento fetal y desnutrici\u00f3n fetal',
    code_1: 'P05-P08',
    code_0: 'P00-P96'
  },
  {
    code: 'P00',
    level: 2,
    description:
      'Feto y reci\u00e9n nacido afectados por condiciones de la madre no necesariamente relacionadas con el embarazo presente',
    code_1: 'P00-P04',
    code_0: 'P00-P96'
  },
  {
    code: 'P01',
    level: 2,
    description:
      'Feto y reci\u00e9n nacido afectados por complicaciones maternas del embarazo',
    code_1: 'P00-P04',
    code_0: 'P00-P96'
  },
  {
    code: 'P02',
    level: 2,
    description:
      'Feto y reci\u00e9n nacido afectados por complicaciones de la placenta, del cord\u00f3n umbilical y de las membranas',
    code_1: 'P00-P04',
    code_0: 'P00-P96'
  },
  {
    code: 'P03',
    level: 2,
    description:
      'Feto y reci\u00e9n nacido afectados por otras complicaciones del trabajo de parto y del parto',
    code_1: 'P00-P04',
    code_0: 'P00-P96'
  },
  {
    code: 'P04',
    level: 2,
    description:
      'Feto y reci\u00e9n nacido afectados por influencias nocivas transmitidas a trav\u00e9s de la placenta o de la leche materna',
    code_1: 'P00-P04',
    code_0: 'P00-P96'
  },
  {
    code: 'G54',
    level: 2,
    description: 'Trastornos de las ra\u00edces y de los plexos nerviosos',
    code_1: 'G50-G59',
    code_0: 'G00-G99'
  },
  {
    code: 'G55',
    level: 2,
    description:
      'Compresiones de las ra\u00edces y de los plexos nerviosos en enfermedades clasificadas en otra parte',
    code_1: 'G50-G59',
    code_0: 'G00-G99'
  },
  {
    code: 'G56',
    level: 2,
    description: 'Mononeuropat\u00edas del miembro superior',
    code_1: 'G50-G59',
    code_0: 'G00-G99'
  },
  {
    code: 'G57',
    level: 2,
    description: 'Mononeuropat\u00edas del miembro inferior',
    code_1: 'G50-G59',
    code_0: 'G00-G99'
  },
  {
    code: 'G58',
    level: 2,
    description: 'Otras mononeuropat\u00edas',
    code_1: 'G50-G59',
    code_0: 'G00-G99'
  },
  {
    code: 'G59',
    level: 2,
    description:
      'Mononeuropat\u00eda en enfermedades clasificadas en otra parte',
    code_1: 'G50-G59',
    code_0: 'G00-G99'
  },
  {
    code: 'E70',
    level: 2,
    description:
      'Trastornos del metabolismo de los amino\u00e1cidos arom\u00e1ticos',
    code_1: 'E70-E90',
    code_0: 'E00-E89'
  },
  {
    code: 'E71',
    level: 2,
    description:
      'Trastornos del metabolismo de los amino\u00e1cidos de cadena ramificada y de los \u00e1cidos grasos',
    code_1: 'E70-E90',
    code_0: 'E00-E89'
  },
  {
    code: 'E72',
    level: 2,
    description: 'Otros trastornos del metabolismo de los amino\u00e1cidos',
    code_1: 'E70-E90',
    code_0: 'E00-E89'
  },
  {
    code: 'E65',
    level: 2,
    description: 'Adiposidad localizada',
    code_1: 'E65-E68',
    code_0: 'E00-E89'
  },
  {
    code: 'E66',
    level: 2,
    description: 'Obesidad',
    code_1: 'E65-E68',
    code_0: 'E00-E89'
  },
  {
    code: 'E67',
    level: 2,
    description: 'Otros tipos de hiperalimentaci\u00f3n',
    code_1: 'E65-E68',
    code_0: 'E00-E89'
  },
  {
    code: 'E68',
    level: 2,
    description: 'Secuelas de hiperalimentaci\u00f3n',
    code_1: 'E65-E68',
    code_0: 'E00-E89'
  },
  {
    code: 'E50',
    level: 2,
    description: 'Deficiencia de vitamina A',
    code_1: 'E50-E64',
    code_0: 'E00-E89'
  },
  {
    code: 'E51',
    level: 2,
    description: 'Deficiencia de tiamina',
    code_1: 'E50-E64',
    code_0: 'E00-E89'
  },
  {
    code: 'E52',
    level: 2,
    description: 'Deficiencia de niacina [pelagra]',
    code_1: 'E50-E64',
    code_0: 'E00-E89'
  },
  {
    code: 'E53',
    level: 2,
    description: 'Deficiencias de otras vitaminas del grupo B',
    code_1: 'E50-E64',
    code_0: 'E00-E89'
  },
  {
    code: 'E54',
    level: 2,
    description: 'Deficiencia de \u00e1cido asc\u00f3rbico',
    code_1: 'E50-E64',
    code_0: 'E00-E89'
  },
  {
    code: 'E55',
    level: 2,
    description: 'Deficiencia de vitamina D',
    code_1: 'E50-E64',
    code_0: 'E00-E89'
  },
  {
    code: 'E56',
    level: 2,
    description: 'Otras deficiencias de vitaminas',
    code_1: 'E50-E64',
    code_0: 'E00-E89'
  },
  {
    code: 'G44',
    level: 2,
    description: 'Otros s\u00edndromes de cefalea',
    code_1: 'G40-G47',
    code_0: 'G00-G99'
  },
  {
    code: 'G45',
    level: 2,
    description:
      'Ataques de isquemia cerebral transitoria y s\u00edndromes afines',
    code_1: 'G40-G47',
    code_0: 'G00-G99'
  },
  {
    code: 'G46',
    level: 2,
    description:
      'S\u00edndromes vasculares encef\u00e1licos en enfermedades cerebrovasculares (I60\u2013I67)',
    code_1: 'G40-G47',
    code_0: 'G00-G99'
  },
  {
    code: 'G47',
    level: 2,
    description: 'Trastornos del sue\u00f1o',
    code_1: 'G40-G47',
    code_0: 'G00-G99'
  },
  {
    code: 'E40',
    level: 2,
    description: 'Kwashiorkor',
    code_1: 'E40-E46',
    code_0: 'E00-E89'
  },
  {
    code: 'E41',
    level: 2,
    description: 'Marasmo nutricional',
    code_1: 'E40-E46',
    code_0: 'E00-E89'
  },
  {
    code: 'E42',
    level: 2,
    description: 'Kwashiorkor marasm\u00e1tico',
    code_1: 'E40-E46',
    code_0: 'E00-E89'
  },
  {
    code: 'Q20',
    level: 2,
    description:
      'Malformaciones cong\u00e9nitas de las c\u00e1maras card\u00edacas y sus conexiones',
    code_1: 'Q20-Q28',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q21',
    level: 2,
    description:
      'Malformaciones cong\u00e9nitas de los tabiques card\u00edacos',
    code_1: 'Q20-Q28',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q22',
    level: 2,
    description:
      'Malformaciones cong\u00e9nitas de las v\u00e1lvulas pulmonar y tric\u00faspide',
    code_1: 'Q20-Q28',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q23',
    level: 2,
    description:
      'Malformaciones cong\u00e9nitas de las v\u00e1lvulas a\u00f3rtica y mitral',
    code_1: 'Q20-Q28',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q24',
    level: 2,
    description: 'Otras malformaciones cong\u00e9nitas del coraz\u00f3n',
    code_1: 'Q20-Q28',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q25',
    level: 2,
    description: 'Malformaciones cong\u00e9nitas de las grandes arterias',
    code_1: 'Q20-Q28',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q10',
    level: 2,
    description:
      'Malformaciones cong\u00e9nitas de los p\u00e1rpados, del aparato lagrimal y de la \u00f3rbita',
    code_1: 'Q10-Q18',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q11',
    level: 2,
    description: 'Anoftalm\u00eda, microftalm\u00eda y macroftalm\u00eda',
    code_1: 'Q10-Q18',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q12',
    level: 2,
    description: 'Malformaciones cong\u00e9nitas del cristalino',
    code_1: 'Q10-Q18',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q00',
    level: 2,
    description: 'Anencefalia y malformaciones cong\u00e9nitas similares',
    code_1: 'Q00-Q07',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q01',
    level: 2,
    description: 'Encefalocele',
    code_1: 'Q00-Q07',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q02',
    level: 2,
    description: 'Microcefalia',
    code_1: 'Q00-Q07',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q03',
    level: 2,
    description: 'Hidroc\u00e9falo cong\u00e9nito',
    code_1: 'Q00-Q07',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q04',
    level: 2,
    description: 'Otras malformaciones cong\u00e9nitas del enc\u00e9falo',
    code_1: 'Q00-Q07',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q05',
    level: 2,
    description: 'Espina b\u00edfida',
    code_1: 'Q00-Q07',
    code_0: 'Q00-Q99'
  },
  {
    code: 'R47',
    level: 2,
    description: 'Alteraciones del habla, no clasificadas en otra parte',
    code_1: 'R47-R49',
    code_0: 'R00-R99'
  },
  {
    code: 'R48',
    level: 2,
    description:
      'Dislexia y otras disfunciones simb\u00f3licas, no clasificadas en otra parte',
    code_1: 'R47-R49',
    code_0: 'R00-R99'
  },
  {
    code: 'R49',
    level: 2,
    description: 'Alteraciones de la voz',
    code_1: 'R47-R49',
    code_0: 'R00-R99'
  },
  {
    code: 'R40',
    level: 2,
    description: 'Somnolencia, estupor y coma',
    code_1: 'R40-R46',
    code_0: 'R00-R99'
  },
  {
    code: 'R41',
    level: 2,
    description:
      'Otros s\u00edntomas y signos que involucran la funci\u00f3n cognoscitiva y la conciencia',
    code_1: 'R40-R46',
    code_0: 'R00-R99'
  },
  {
    code: 'R42',
    level: 2,
    description: 'Mareo y desvanecimiento',
    code_1: 'R40-R46',
    code_0: 'R00-R99'
  },
  {
    code: 'R43',
    level: 2,
    description: 'Trastornos del olfato y del gusto',
    code_1: 'R40-R46',
    code_0: 'R00-R99'
  },
  {
    code: 'R30',
    level: 2,
    description: 'Dolor asociado con la micci\u00f3n',
    code_1: 'R30-R39',
    code_0: 'R00-R99'
  },
  {
    code: 'R31',
    level: 2,
    description: 'Hematuria, no especificada',
    code_1: 'R30-R39',
    code_0: 'R00-R99'
  },
  {
    code: 'R32',
    level: 2,
    description: 'Incontinencia urinaria, no especificada',
    code_1: 'R30-R39',
    code_0: 'R00-R99'
  },
  {
    code: 'R25',
    level: 2,
    description: 'Movimientos involuntarios anormales',
    code_1: 'R25-R29',
    code_0: 'R00-R99'
  },
  {
    code: 'R26',
    level: 2,
    description: 'Anormalidades de la marcha y de la movilidad',
    code_1: 'R25-R29',
    code_0: 'R00-R99'
  },
  {
    code: 'R27',
    level: 2,
    description: 'Otras fallas de coordinaci\u00f3n',
    code_1: 'R25-R29',
    code_0: 'R00-R99'
  },
  {
    code: 'R29',
    level: 2,
    description:
      'Otros s\u00edntomas y signos que involucran los sistemas nervioso y osteomuscular',
    code_1: 'R25-R29',
    code_0: 'R00-R99'
  },
  {
    code: 'R20',
    level: 2,
    description: 'Alteraciones de la sensibilidad cut\u00e1nea',
    code_1: 'R20-R23',
    code_0: 'R00-R99'
  },
  {
    code: 'R21',
    level: 2,
    description: 'Salpullido y otras erupciones cut\u00e1neas no especificadas',
    code_1: 'R20-R23',
    code_0: 'R00-R99'
  },
  {
    code: 'R22',
    level: 2,
    description:
      'Tumefacci\u00f3n, masa o prominencia de la piel y del tejido subcut\u00e1neo localizadas',
    code_1: 'R20-R23',
    code_0: 'R00-R99'
  },
  {
    code: 'R23',
    level: 2,
    description: 'Otros cambios en la piel',
    code_1: 'R20-R23',
    code_0: 'R00-R99'
  },
  {
    code: 'R10',
    level: 2,
    description: 'Dolor abdominal y p\u00e9lvico',
    code_1: 'R10-R19',
    code_0: 'R00-R99'
  },
  {
    code: 'R11',
    level: 2,
    description: 'N\u00e1usea y v\u00f3mito',
    code_1: 'R10-R19',
    code_0: 'R00-R99'
  },
  {
    code: 'R12',
    level: 2,
    description: 'Acidez',
    code_1: 'R10-R19',
    code_0: 'R00-R99'
  },
  {
    code: 'R13',
    level: 2,
    description: 'Disfagia',
    code_1: 'R10-R19',
    code_0: 'R00-R99'
  },
  {
    code: 'R00',
    level: 2,
    description: 'Anormalidades del latido card\u00edaco',
    code_1: 'R00-R09',
    code_0: 'R00-R99'
  },
  {
    code: 'D44',
    level: 2,
    description:
      'Tumor de comportamiento incierto o desconocido de las gl\u00e1ndulas endocrinas',
    code_1: 'D37-D48',
    code_0: 'C00-D49'
  },
  {
    code: 'D45',
    level: 2,
    description: 'Policitemia vera',
    code_1: 'D37-D48',
    code_0: 'C00-D49'
  },
  {
    code: 'D46',
    level: 2,
    description: 'S\u00edndromes mielodispl\u00e1sicos',
    code_1: 'D37-D48',
    code_0: 'C00-D49'
  },
  {
    code: 'D47',
    level: 2,
    description:
      'Otros tumores de comportamiento incierto o desconocido del tejido linf\u00e1tico, de los \u00f3rganos hematopoy\u00e9ticos y de tejidos afines',
    code_1: 'D37-D48',
    code_0: 'C00-D49'
  },
  {
    code: 'D48',
    level: 2,
    description:
      'Tumor de comportamiento incierto o desconocido de otros sitios y de los no especificados',
    code_1: 'D37-D48',
    code_0: 'C00-D49'
  },
  {
    code: 'D13',
    level: 2,
    description:
      'Tumor benigno de otras partes y de las mal definidas del sistema digestivo',
    code_1: 'D10-D36',
    code_0: 'C00-D49'
  },
  {
    code: 'D14',
    level: 2,
    description: 'Tumor benigno del o\u00eddo medio y del sistema respiratorio',
    code_1: 'D10-D36',
    code_0: 'C00-D49'
  },
  {
    code: 'D15',
    level: 2,
    description:
      'Tumor benigno de otros \u00f3rganos intrator\u00e1cicos y de los no especificados',
    code_1: 'D10-D36',
    code_0: 'C00-D49'
  },
  {
    code: 'D16',
    level: 2,
    description: 'Tumor benigno del hueso y del cart\u00edlago articular',
    code_1: 'D10-D36',
    code_0: 'C00-D49'
  },
  {
    code: 'D17',
    level: 2,
    description: 'Tumores benignos lipomatosos',
    code_1: 'D10-D36',
    code_0: 'C00-D49'
  },
  {
    code: 'D18',
    level: 2,
    description: 'Hemangioma y linfangioma de cualquier sitio',
    code_1: 'D10-D36',
    code_0: 'C00-D49'
  },
  {
    code: 'D19',
    level: 2,
    description: 'Tumores benignos del tejido mesotelial',
    code_1: 'D10-D36',
    code_0: 'C00-D49'
  },
  {
    code: 'D20',
    level: 2,
    description:
      'Tumor benigno del tejido blando del peritoneo y del retroperitoneo',
    code_1: 'D10-D36',
    code_0: 'C00-D49'
  },
  {
    code: 'D07',
    level: 2,
    description:
      'Carcinoma in situ de otros \u00f3rganos genitales y de los no especificados',
    code_1: 'D00-D09',
    code_0: 'C00-D49'
  },
  {
    code: 'D09',
    level: 2,
    description: 'Carcinoma in situ de otros sitios y de los no especificados',
    code_1: 'D00-D09',
    code_0: 'C00-D49'
  },
  {
    code: 'D75',
    level: 2,
    description:
      'Otras enfermedades de la sangre y de los \u00f3rganos hematopoy\u00e9ticos',
    code_1: 'D70-D77',
    code_0: 'D50-D89'
  },
  {
    code: 'D76',
    level: 2,
    description:
      'Ciertas enfermedades que afectan al tejido linforreticular y al sistema reticuloendotelial',
    code_1: 'D70-D77',
    code_0: 'D50-D89'
  },
  {
    code: 'D77',
    level: 2,
    description:
      'Otros trastornos de la sangre y de los \u00f3rganos hematopoy\u00e9ticos en enfermedades clasificadas en otra parte',
    code_1: 'D70-D77',
    code_0: 'D50-D89'
  },
  {
    code: 'E25',
    level: 2,
    description: 'Trastornos adrenogenitales',
    code_1: 'E20-E35',
    code_0: 'E00-E89'
  },
  {
    code: 'E26',
    level: 2,
    description: 'Hiperaldosteronismo',
    code_1: 'E20-E35',
    code_0: 'E00-E89'
  },
  {
    code: 'E27',
    level: 2,
    description: 'Otros trastornos de la gl\u00e1ndula suprarrenal',
    code_1: 'E20-E35',
    code_0: 'E00-E89'
  },
  {
    code: 'E28',
    level: 2,
    description: 'Disfunci\u00f3n ov\u00e1rica',
    code_1: 'E20-E35',
    code_0: 'E00-E89'
  },
  {
    code: 'E29',
    level: 2,
    description: 'Disfunci\u00f3n testicular',
    code_1: 'E20-E35',
    code_0: 'E00-E89'
  },
  {
    code: 'E30',
    level: 2,
    description: 'Trastornos de la pubertad, no clasificados en otra parte',
    code_1: 'E20-E35',
    code_0: 'E00-E89'
  },
  {
    code: 'E31',
    level: 2,
    description: 'Disfunci\u00f3n poliglandular',
    code_1: 'E20-E35',
    code_0: 'E00-E89'
  },
  {
    code: 'E32',
    level: 2,
    description: 'Enfermedades del timo',
    code_1: 'E20-E35',
    code_0: 'E00-E89'
  },
  {
    code: 'E14',
    level: 2,
    description: 'Diabetes mellitus, no especificada',
    code_1: 'E10-E14',
    code_0: 'E00-E89'
  },
  {
    code: 'E07',
    level: 2,
    description: 'Otros trastornos tiroideos',
    code_1: 'E00-E07',
    code_0: 'E00-E89'
  },
  {
    code: 'G130',
    level: 3,
    description: 'Neuromiopat\u00eda y neuropat\u00eda paraneopl\u00e1sica',
    code_2: 'G13',
    code_0: 'G00-G99',
    code_1: 'G10-G13'
  },
  {
    code: 'G131',
    level: 3,
    description:
      'Otras atrofias sist\u00e9micas que afectan el sistema nervioso central en enfermedad neopl\u00e1sica',
    code_2: 'G13',
    code_0: 'G00-G99',
    code_1: 'G10-G13'
  },
  {
    code: 'G132',
    level: 3,
    description:
      'Atrofia sist\u00e9mica que afecta primariamente el sistema nervioso central en el mixedema (E00.1, E03.\u2013)',
    code_2: 'G13',
    code_0: 'G00-G99',
    code_1: 'G10-G13'
  },
  {
    code: 'G138',
    level: 3,
    description:
      'Atrofia sist\u00e9mica que afecta primariamente el sistema nervioso central en otras enfermedades clasificadas en otra parte',
    code_2: 'G13',
    code_0: 'G00-G99',
    code_1: 'G10-G13'
  },
  {
    code: 'G120',
    level: 3,
    description:
      'Atrofia muscular espinal infantil, tipo I [Werdnig\u2013Hoffman]',
    code_2: 'G12',
    code_0: 'G00-G99',
    code_1: 'G10-G13'
  },
  {
    code: 'G121',
    level: 3,
    description: 'Otras atrofias musculares espinales hereditarias',
    code_2: 'G12',
    code_0: 'G00-G99',
    code_1: 'G10-G13'
  },
  {
    code: 'G122',
    level: 3,
    description: 'Enfermedades de las neuronas motoras',
    code_2: 'G12',
    code_0: 'G00-G99',
    code_1: 'G10-G13'
  },
  {
    code: 'G128',
    level: 3,
    description: 'Otras atrofias musculares espinales y sindromes afines',
    code_2: 'G12',
    code_0: 'G00-G99',
    code_1: 'G10-G13'
  },
  {
    code: 'G129',
    level: 3,
    description: 'Atrofia muscular espinal, sin otra especificaci\u00f3n',
    code_2: 'G12',
    code_0: 'G00-G99',
    code_1: 'G10-G13'
  },
  {
    code: 'G110',
    level: 3,
    description: 'Ataxia cong\u00e9nita no progresiva',
    code_2: 'G11',
    code_0: 'G00-G99',
    code_1: 'G10-G13'
  },
  {
    code: 'G111',
    level: 3,
    description: 'Ataxia cerebelosa de iniciaci\u00f3n temprana',
    code_2: 'G11',
    code_0: 'G00-G99',
    code_1: 'G10-G13'
  },
  {
    code: 'G112',
    level: 3,
    description: 'Ataxia cerebelosa de iniciaci\u00f3n tard\u00eda',
    code_2: 'G11',
    code_0: 'G00-G99',
    code_1: 'G10-G13'
  },
  {
    code: 'G113',
    level: 3,
    description: 'Ataxia cerebelosa con reparaci\u00f3n defectuosa del ADN',
    code_2: 'G11',
    code_0: 'G00-G99',
    code_1: 'G10-G13'
  },
  {
    code: 'G114',
    level: 3,
    description: 'Paraplej\u00eda esp\u00e1stica hereditaria',
    code_2: 'G11',
    code_0: 'G00-G99',
    code_1: 'G10-G13'
  },
  {
    code: 'G118',
    level: 3,
    description: 'Otras ataxias hereditarias',
    code_2: 'G11',
    code_0: 'G00-G99',
    code_1: 'G10-G13'
  },
  {
    code: 'G119',
    level: 3,
    description: 'Ataxia hereditaria, no especificada',
    code_2: 'G11',
    code_0: 'G00-G99',
    code_1: 'G10-G13'
  },
  {
    code: 'G250',
    level: 3,
    description: 'Temblor esencial',
    code_2: 'G25',
    code_0: 'G00-G99',
    code_1: 'G20-G26'
  },
  {
    code: 'G251',
    level: 3,
    description: 'Temblor inducido por drogas',
    code_2: 'G25',
    code_0: 'G00-G99',
    code_1: 'G20-G26'
  },
  {
    code: 'G252',
    level: 3,
    description: 'Otras formas especificadas de temblor',
    code_2: 'G25',
    code_0: 'G00-G99',
    code_1: 'G20-G26'
  },
  {
    code: 'G253',
    level: 3,
    description: 'Mioclon\u00eda',
    code_2: 'G25',
    code_0: 'G00-G99',
    code_1: 'G20-G26'
  },
  {
    code: 'G254',
    level: 3,
    description: 'Corea inducida por drogas',
    code_2: 'G25',
    code_0: 'G00-G99',
    code_1: 'G20-G26'
  },
  {
    code: 'G255',
    level: 3,
    description: 'Otras coreas',
    code_2: 'G25',
    code_0: 'G00-G99',
    code_1: 'G20-G26'
  },
  {
    code: 'G256',
    level: 3,
    description:
      'Tics inducidos por drogas y otros tics de origen org\u00e1nico',
    code_2: 'G25',
    code_0: 'G00-G99',
    code_1: 'G20-G26'
  },
  {
    code: 'G258',
    level: 3,
    description: 'Otros trastornos extrapiramidales y del movimiento',
    code_2: 'G25',
    code_0: 'G00-G99',
    code_1: 'G20-G26'
  },
  {
    code: 'G259',
    level: 3,
    description: 'Trastorno extrapiramidal y del movimiento, no especificado',
    code_2: 'G25',
    code_0: 'G00-G99',
    code_1: 'G20-G26'
  },
  {
    code: 'G240',
    level: 3,
    description: 'Diston\u00eda inducida por drogas',
    code_2: 'G24',
    code_0: 'G00-G99',
    code_1: 'G20-G26'
  },
  {
    code: 'G241',
    level: 3,
    description: 'Diston\u00eda idiop\u00e1tica familiar',
    code_2: 'G24',
    code_0: 'G00-G99',
    code_1: 'G20-G26'
  },
  {
    code: 'G242',
    level: 3,
    description: 'Diston\u00eda idiop\u00e1tica no familiar',
    code_2: 'G24',
    code_0: 'G00-G99',
    code_1: 'G20-G26'
  },
  {
    code: 'G243',
    level: 3,
    description: 'Tort\u00edcolis espasm\u00f3dica',
    code_2: 'G24',
    code_0: 'G00-G99',
    code_1: 'G20-G26'
  },
  {
    code: 'G244',
    level: 3,
    description: 'Diston\u00eda bucofacial idiop\u00e1tica',
    code_2: 'G24',
    code_0: 'G00-G99',
    code_1: 'G20-G26'
  },
  {
    code: 'G245',
    level: 3,
    description: 'Blefarospasmo',
    code_2: 'G24',
    code_0: 'G00-G99',
    code_1: 'G20-G26'
  },
  {
    code: 'G248',
    level: 3,
    description: 'Otras diston\u00edas',
    code_2: 'G24',
    code_0: 'G00-G99',
    code_1: 'G20-G26'
  },
  {
    code: 'G230',
    level: 3,
    description: 'Enfermedad de Hallervorden\u2013Spatz',
    code_2: 'G23',
    code_0: 'G00-G99',
    code_1: 'G20-G26'
  },
  {
    code: 'G231',
    level: 3,
    description:
      'Oftalmoplejia supranuclear progresiva [Steele-Richardson- Olszewski]',
    code_2: 'G23',
    code_0: 'G00-G99',
    code_1: 'G20-G26'
  },
  {
    code: 'G232',
    level: 3,
    description: 'Degeneraci\u00f3n nigroestriada',
    code_2: 'G23',
    code_0: 'G00-G99',
    code_1: 'G20-G26'
  },
  {
    code: 'G238',
    level: 3,
    description:
      'Otras enfermedades degenerativas espec\u00edficas de los n\u00facleos de la base',
    code_2: 'G23',
    code_0: 'G00-G99',
    code_1: 'G20-G26'
  },
  {
    code: 'G239',
    level: 3,
    description:
      'Enfermedad degenerativa de los n\u00facleos de la base, no especificada',
    code_2: 'G23',
    code_0: 'G00-G99',
    code_1: 'G20-G26'
  },
  {
    code: 'G210',
    level: 3,
    description: 'S\u00edndrome neurol\u00e9ptico maligno',
    code_2: 'G21',
    code_0: 'G00-G99',
    code_1: 'G20-G26'
  },
  {
    code: 'G211',
    level: 3,
    description: 'Otro parkinsonismo secundario inducido por drogas',
    code_2: 'G21',
    code_0: 'G00-G99',
    code_1: 'G20-G26'
  },
  {
    code: 'G212',
    level: 3,
    description: 'Parkinsonismo secundario debido a otros agentes externos',
    code_2: 'G21',
    code_0: 'G00-G99',
    code_1: 'G20-G26'
  },
  {
    code: 'G213',
    level: 3,
    description: 'Parkinsonismo postencefal\u00edtico',
    code_2: 'G21',
    code_0: 'G00-G99',
    code_1: 'G20-G26'
  },
  {
    code: 'G218',
    level: 3,
    description: 'Otros tipos de parkinsonismo secundario',
    code_2: 'G21',
    code_0: 'G00-G99',
    code_1: 'G20-G26'
  },
  {
    code: 'G219',
    level: 3,
    description: 'Parkinsonismo secundario, no especificado',
    code_2: 'G21',
    code_0: 'G00-G99',
    code_1: 'G20-G26'
  },
  {
    code: 'Z80',
    level: 2,
    description: 'Historia familiar de tumor maligno',
    code_1: 'Z80-Z99',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z81',
    level: 2,
    description:
      'Historia familiar de trastornos mentales y del comportamiento',
    code_1: 'Z80-Z99',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z82',
    level: 2,
    description:
      'Historia familiar de ciertas discapacidades y enfermedades cr\u00f3nicas incapacitantes',
    code_1: 'Z80-Z99',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z83',
    level: 2,
    description: 'Historia familiar de otros trastornos espec\u00edficos',
    code_1: 'Z80-Z99',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z84',
    level: 2,
    description: 'Historia familiar de otras afecciones',
    code_1: 'Z80-Z99',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z70',
    level: 2,
    description:
      'Consulta relacionada con actitud, conducta u orientaci\u00f3n sexual',
    code_1: 'Z70-Z76',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z71',
    level: 2,
    description:
      'Personas en contacto con los servicios de salud por otras consultas y consejos m\u00e9dicos, no clasificados en otra parte',
    code_1: 'Z70-Z76',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z72',
    level: 2,
    description: 'Problemas relacionados con el estilo de vida',
    code_1: 'Z70-Z76',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z73',
    level: 2,
    description: 'Problemas relacionados con dificultades con el modo de vida',
    code_1: 'Z70-Z76',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z74',
    level: 2,
    description:
      'Problemas relacionados con dependencia del prestador de servicios',
    code_1: 'Z70-Z76',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z75',
    level: 2,
    description:
      'Problemas relacionados con facilidades de atenci\u00f3n m\u00e9dica u otros servicios de salud',
    code_1: 'Z70-Z76',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z76',
    level: 2,
    description:
      'Personas en contacto con los servicios de salud por otras circunstancias',
    code_1: 'Z70-Z76',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z55',
    level: 2,
    description:
      'Problemas relacionados con la educaci\u00f3n y la alfabetizaci\u00f3n',
    code_1: 'Z55-Z65',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z56',
    level: 2,
    description: 'Problemas relacionados con el empleo y el desempleo',
    code_1: 'Z55-Z65',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z57',
    level: 2,
    description: 'Exposici\u00f3n a factores de riesgo ocupacional',
    code_1: 'Z55-Z65',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z58',
    level: 2,
    description: 'Problemas relacionados con el ambiente f\u00edsico',
    code_1: 'Z55-Z65',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z59',
    level: 2,
    description:
      'Problemas relacionados con la vivienda y las circunstancias econ\u00f3micas',
    code_1: 'Z55-Z65',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z60',
    level: 2,
    description: 'Problemas relacionados con el ambiente social',
    code_1: 'Z55-Z65',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z40',
    level: 2,
    description: 'Cirug\u00eda profil\u00e1ctica',
    code_1: 'Z40-Z54',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z41',
    level: 2,
    description:
      'Procedimientos para otros prop\u00f3sitos que no sean los de mejorar el estado de salud',
    code_1: 'Z40-Z54',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z42',
    level: 2,
    description: 'Cuidados posteriores a la cirug\u00eda pl\u00e1stica',
    code_1: 'Z40-Z54',
    code_0: 'Z00-Z99'
  },
  {
    code: 'H280',
    level: 3,
    description:
      'Catarata diab\u00e9tica (E10\u2013E14 con cuarto car\u00e1cter com\u00fan .3)',
    code_2: 'H28',
    code_0: 'H00-H59',
    code_1: 'H25-H28'
  },
  {
    code: 'H281',
    level: 3,
    description:
      'Catarata en otras enfermedades endocrinas, nutricionales y metab\u00f3licas clasificadas en otra parte',
    code_2: 'H28',
    code_0: 'H00-H59',
    code_1: 'H25-H28'
  },
  {
    code: 'H282',
    level: 3,
    description: 'Catarata en otras enfermedades clasificadas en otra parte',
    code_2: 'H28',
    code_0: 'H00-H59',
    code_1: 'H25-H28'
  },
  {
    code: 'H288',
    level: 3,
    description:
      'Otros trastornos del cristalino en enfermedades clasificadas en otra parte',
    code_2: 'H28',
    code_0: 'H00-H59',
    code_1: 'H25-H28'
  },
  {
    code: 'H270',
    level: 3,
    description: 'Afaquia',
    code_2: 'H27',
    code_0: 'H00-H59',
    code_1: 'H25-H28'
  },
  {
    code: 'H271',
    level: 3,
    description: 'Luxaci\u00f3n del cristalino',
    code_2: 'H27',
    code_0: 'H00-H59',
    code_1: 'H25-H28'
  },
  {
    code: 'H278',
    level: 3,
    description: 'Otros trastornos especificados del cristalino',
    code_2: 'H27',
    code_0: 'H00-H59',
    code_1: 'H25-H28'
  },
  {
    code: 'H279',
    level: 3,
    description: 'Trastorno del cristalino, no especificado',
    code_2: 'H27',
    code_0: 'H00-H59',
    code_1: 'H25-H28'
  },
  {
    code: 'H260',
    level: 3,
    description: 'Catarata infantil, juvenil y presenil',
    code_2: 'H26',
    code_0: 'H00-H59',
    code_1: 'H25-H28'
  },
  {
    code: 'H261',
    level: 3,
    description: 'Catarata traum\u00e1tica',
    code_2: 'H26',
    code_0: 'H00-H59',
    code_1: 'H25-H28'
  },
  {
    code: 'H262',
    level: 3,
    description: 'Catarata complicada',
    code_2: 'H26',
    code_0: 'H00-H59',
    code_1: 'H25-H28'
  },
  {
    code: 'H263',
    level: 3,
    description: 'Catarata inducida por drogas',
    code_2: 'H26',
    code_0: 'H00-H59',
    code_1: 'H25-H28'
  },
  {
    code: 'H264',
    level: 3,
    description: 'Catarata residual',
    code_2: 'H26',
    code_0: 'H00-H59',
    code_1: 'H25-H28'
  },
  {
    code: 'H268',
    level: 3,
    description: 'Otras formas especificadas de catarata',
    code_2: 'H26',
    code_0: 'H00-H59',
    code_1: 'H25-H28'
  },
  {
    code: 'H269',
    level: 3,
    description: 'Catarata, no especificada',
    code_2: 'H26',
    code_0: 'H00-H59',
    code_1: 'H25-H28'
  },
  {
    code: 'H250',
    level: 3,
    description: 'Catarata senil incipiente',
    code_2: 'H25',
    code_0: 'H00-H59',
    code_1: 'H25-H28'
  },
  {
    code: 'H251',
    level: 3,
    description: 'Catarata senil nuclear',
    code_2: 'H25',
    code_0: 'H00-H59',
    code_1: 'H25-H28'
  },
  {
    code: 'H252',
    level: 3,
    description: 'Catarata senil, tipo morgagnian',
    code_2: 'H25',
    code_0: 'H00-H59',
    code_1: 'H25-H28'
  },
  {
    code: 'H258',
    level: 3,
    description: 'Otras cataratas seniles',
    code_2: 'H25',
    code_0: 'H00-H59',
    code_1: 'H25-H28'
  },
  {
    code: 'H259',
    level: 3,
    description: 'Catarata senil, no especificada',
    code_2: 'H25',
    code_0: 'H00-H59',
    code_1: 'H25-H28'
  },
  {
    code: 'T790',
    level: 2,
    description: 'Embolia gaseosa (traum\u00e1tica)',
    code_1: 'T79',
    code_0: 'S00-T88'
  },
  {
    code: 'T791',
    level: 2,
    description: 'Embolia grasa (traum\u00e1tica)',
    code_1: 'T79',
    code_0: 'S00-T88'
  },
  {
    code: 'T792',
    level: 2,
    description: 'Hemorragia traum\u00e1tica secundaria y recurrente',
    code_1: 'T79',
    code_0: 'S00-T88'
  },
  {
    code: 'T793',
    level: 2,
    description:
      'Infecci\u00f3n postraum\u00e1tica de herida, no clasificada en otra parte',
    code_1: 'T79',
    code_0: 'S00-T88'
  },
  {
    code: 'T66',
    level: 2,
    description: 'Efectos no especificados de la radiaci\u00f3n',
    code_1: 'T66-T78',
    code_0: 'S00-T88'
  },
  {
    code: 'T67',
    level: 2,
    description: 'Efectos del calor y de la luz',
    code_1: 'T66-T78',
    code_0: 'S00-T88'
  },
  {
    code: 'T68',
    level: 2,
    description: 'Hipotermia',
    code_1: 'T66-T78',
    code_0: 'S00-T88'
  },
  {
    code: 'T69',
    level: 2,
    description: 'Otros efectos de la reducci\u00f3n de la temperatura',
    code_1: 'T66-T78',
    code_0: 'S00-T88'
  },
  {
    code: 'T70',
    level: 2,
    description:
      'Efectos de la presi\u00f3n del aire y de la presi\u00f3n del agua',
    code_1: 'T66-T78',
    code_0: 'S00-T88'
  },
  {
    code: 'T51',
    level: 2,
    description: 'Efecto t\u00f3xico del alcohol',
    code_1: 'T51-T65',
    code_0: 'S00-T88'
  },
  {
    code: 'T52',
    level: 2,
    description: 'Efecto t\u00f3xico de disolventes org\u00e1nicos',
    code_1: 'T51-T65',
    code_0: 'S00-T88'
  },
  {
    code: 'T53',
    level: 2,
    description:
      'Efecto t\u00f3xico de los derivados halogenados de los hidrocarburos alif\u00e1ticos y arom\u00e1ticos',
    code_1: 'T51-T65',
    code_0: 'S00-T88'
  },
  {
    code: 'T54',
    level: 2,
    description: 'Efecto t\u00f3xico de sustancias corrosivas',
    code_1: 'T51-T65',
    code_0: 'S00-T88'
  },
  {
    code: 'T55',
    level: 2,
    description: 'Efecto t\u00f3xico de detergentes y jabones',
    code_1: 'T51-T65',
    code_0: 'S00-T88'
  },
  {
    code: 'T36',
    level: 2,
    description: 'Envenenamiento por antibi\u00f3ticos sist\u00e9micos',
    code_1: 'T36-T50',
    code_0: 'S00-T88'
  },
  {
    code: 'T37',
    level: 2,
    description:
      'Envenenamiento por otros antiinfecciosos y antiparasitarios sist\u00e9micos',
    code_1: 'T36-T50',
    code_0: 'S00-T88'
  },
  {
    code: 'T38',
    level: 2,
    description:
      'Envenenamiento por hormonas y sus sustitutos y antagonistas sint\u00e9ticos, no clasificados en otra parte',
    code_1: 'T36-T50',
    code_0: 'S00-T88'
  },
  {
    code: 'T33',
    level: 2,
    description: 'Congelamiento superficial',
    code_1: 'T33-T35',
    code_0: 'S00-T88'
  },
  {
    code: 'T34',
    level: 2,
    description: 'Congelamiento con necrosis tisular',
    code_1: 'T33-T35',
    code_0: 'S00-T88'
  },
  {
    code: 'T35',
    level: 2,
    description:
      'Congelamiento que afecta m\u00faltiples regiones del cuerpo y congelamiento no especificado',
    code_1: 'T33-T35',
    code_0: 'S00-T88'
  },
  {
    code: 'T20-T25',
    level: 2,
    description:
      'Quemaduras y corrosiones de la superficie externa del cuerpo, especificadas por sitio',
    code_1: 'T20-T32',
    code_0: 'S00-T88'
  },
  {
    code: 'T26-T28',
    level: 2,
    description:
      'Quemaduras y corrosiones limitadas al ojo y \u00f3rganos internos',
    code_1: 'T20-T32',
    code_0: 'S00-T88'
  },
  {
    code: 'T29-T32',
    level: 2,
    description:
      'Quemaduras y corrosiones de m\u00faltiples regiones del cuerpo y las no especificadas',
    code_1: 'T20-T32',
    code_0: 'S00-T88'
  },
  {
    code: 'T15',
    level: 2,
    description: 'Cuerpo extra\u00f1o en parte externa del ojo',
    code_1: 'T15-T19',
    code_0: 'S00-T88'
  },
  {
    code: 'T16',
    level: 2,
    description: 'Cuerpo extra\u00f1o en el o\u00eddo',
    code_1: 'T15-T19',
    code_0: 'S00-T88'
  },
  {
    code: 'T17',
    level: 2,
    description: 'Cuerpo extra\u00f1o en las v\u00edas respiratorias',
    code_1: 'T15-T19',
    code_0: 'S00-T88'
  },
  {
    code: 'T18',
    level: 2,
    description: 'Cuerpo extra\u00f1o en el tubo digestivo',
    code_1: 'T15-T19',
    code_0: 'S00-T88'
  },
  {
    code: 'T08',
    level: 2,
    description: 'Fractura de la columna vertebral, nivel no especificado',
    code_1: 'T08-T14',
    code_0: 'S00-T88'
  },
  {
    code: 'T09',
    level: 2,
    description:
      'Otros traumatismos de la columna vertebral y del tronco, nivel no especificado',
    code_1: 'T08-T14',
    code_0: 'S00-T88'
  },
  {
    code: 'T10',
    level: 2,
    description: 'Fractura de miembro superior, nivel no especificado',
    code_1: 'T08-T14',
    code_0: 'S00-T88'
  },
  {
    code: 'T11',
    level: 2,
    description:
      'Otros traumatismos de miembro superior, nivel no especificado',
    code_1: 'T08-T14',
    code_0: 'S00-T88'
  },
  {
    code: 'T12',
    level: 2,
    description: 'Fractura de miembro inferior, nivel no especificado',
    code_1: 'T08-T14',
    code_0: 'S00-T88'
  },
  {
    code: 'T13',
    level: 2,
    description:
      'Otros traumatismos de miembro inferior, nivel no especificado',
    code_1: 'T08-T14',
    code_0: 'S00-T88'
  },
  {
    code: 'T14',
    level: 2,
    description: 'Traumatismo de regiones no especificadas del cuerpo',
    code_1: 'T08-T14',
    code_0: 'S00-T88'
  },
  {
    code: 'H320',
    level: 3,
    description:
      'Inflamaci\u00f3n coriorretiniana en enfermedades infecciosas y parasitarias clasificadas en otra parte',
    code_2: 'H32',
    code_0: 'H00-H59',
    code_1: 'H30-H36'
  },
  {
    code: 'H328',
    level: 3,
    description:
      'Otros trastornos coriorretinianos en enfermedades clasificadas en otra parte',
    code_2: 'H32',
    code_0: 'H00-H59',
    code_1: 'H30-H36'
  },
  {
    code: 'H310',
    level: 3,
    description: 'Cicatrices coriorretinianas',
    code_2: 'H31',
    code_0: 'H00-H59',
    code_1: 'H30-H36'
  },
  {
    code: 'H311',
    level: 3,
    description: 'Degeneraci\u00f3n coroidea',
    code_2: 'H31',
    code_0: 'H00-H59',
    code_1: 'H30-H36'
  },
  {
    code: 'H312',
    level: 3,
    description: 'Distrofia coroidea hereditaria',
    code_2: 'H31',
    code_0: 'H00-H59',
    code_1: 'H30-H36'
  },
  {
    code: 'H313',
    level: 3,
    description: 'Hemorragia y ruptura de la coroides',
    code_2: 'H31',
    code_0: 'H00-H59',
    code_1: 'H30-H36'
  },
  {
    code: 'H314',
    level: 3,
    description: 'Desprendimiento de la coroides',
    code_2: 'H31',
    code_0: 'H00-H59',
    code_1: 'H30-H36'
  },
  {
    code: 'H318',
    level: 3,
    description: 'Otros trastornos especificados de la coroides',
    code_2: 'H31',
    code_0: 'H00-H59',
    code_1: 'H30-H36'
  },
  {
    code: 'H319',
    level: 3,
    description: 'Trastorno de la coroides, no especificado',
    code_2: 'H31',
    code_0: 'H00-H59',
    code_1: 'H30-H36'
  },
  {
    code: 'H300',
    level: 3,
    description: 'Coriorretinitis focal',
    code_2: 'H30',
    code_0: 'H00-H59',
    code_1: 'H30-H36'
  },
  {
    code: 'H301',
    level: 3,
    description: 'Coriorretinitis diseminada',
    code_2: 'H30',
    code_0: 'H00-H59',
    code_1: 'H30-H36'
  },
  {
    code: 'H302',
    level: 3,
    description: 'Ciclitis posterior',
    code_2: 'H30',
    code_0: 'H00-H59',
    code_1: 'H30-H36'
  },
  {
    code: 'H308',
    level: 3,
    description: 'Otras coriorretinitis',
    code_2: 'H30',
    code_0: 'H00-H59',
    code_1: 'H30-H36'
  },
  {
    code: 'H309',
    level: 3,
    description: 'Coriorretinitis, no especificada',
    code_2: 'H30',
    code_0: 'H00-H59',
    code_1: 'H30-H36'
  },
  {
    code: 'H420',
    level: 3,
    description:
      'Glaucoma en enfermedades endocrinas, nutricionales y metab\u00f3licas, clasificadas en otra parte',
    code_2: 'H42',
    code_0: 'H00-H59',
    code_1: 'H40-H42'
  },
  {
    code: 'H428',
    level: 3,
    description: 'Glaucoma en otras enfermedades clasificadas en otra parte',
    code_2: 'H42',
    code_0: 'H00-H59',
    code_1: 'H40-H42'
  },
  {
    code: 'H400',
    level: 3,
    description: 'Sospecha de glaucoma',
    code_2: 'H40',
    code_0: 'H00-H59',
    code_1: 'H40-H42'
  },
  {
    code: 'H401',
    level: 3,
    description: 'Glaucoma primario de \u00e1ngulo abierto',
    code_2: 'H40',
    code_0: 'H00-H59',
    code_1: 'H40-H42'
  },
  {
    code: 'H402',
    level: 3,
    description: 'Glaucoma primario de \u00e1ngulo cerrado',
    code_2: 'H40',
    code_0: 'H00-H59',
    code_1: 'H40-H42'
  },
  {
    code: 'H403',
    level: 3,
    description: 'Glaucoma secundario a traumatismo ocular',
    code_2: 'H40',
    code_0: 'H00-H59',
    code_1: 'H40-H42'
  },
  {
    code: 'H404',
    level: 3,
    description: 'Glaucoma secundario a inflamaci\u00f3n ocular',
    code_2: 'H40',
    code_0: 'H00-H59',
    code_1: 'H40-H42'
  },
  {
    code: 'H405',
    level: 3,
    description: 'Glaucoma secundario a otros trastornos del ojo',
    code_2: 'H40',
    code_0: 'H00-H59',
    code_1: 'H40-H42'
  },
  {
    code: 'H450',
    level: 3,
    description:
      'Hemorragia del v\u00edtreo en enfermedades clasificadas en otra parte',
    code_2: 'H45',
    code_0: 'H00-H59',
    code_1: 'H43-H45'
  },
  {
    code: 'H451',
    level: 3,
    description: 'Endoftalmitis en enfermedades clasificadas en otra parte',
    code_2: 'H45',
    code_0: 'H00-H59',
    code_1: 'H43-H45'
  },
  {
    code: 'H458',
    level: 3,
    description:
      'Otros trastornos del cuerpo v\u00edtreo y del globo ocular en enfermedades clasificadas en otra parte',
    code_2: 'H45',
    code_0: 'H00-H59',
    code_1: 'H43-H45'
  },
  {
    code: 'H440',
    level: 3,
    description: 'Endoftalmitis purulenta',
    code_2: 'H44',
    code_0: 'H00-H59',
    code_1: 'H43-H45'
  },
  {
    code: 'H441',
    level: 3,
    description: 'Otras endoftalmitis',
    code_2: 'H44',
    code_0: 'H00-H59',
    code_1: 'H43-H45'
  },
  {
    code: 'H442',
    level: 3,
    description: 'Miop\u00eda degenerativa',
    code_2: 'H44',
    code_0: 'H00-H59',
    code_1: 'H43-H45'
  },
  {
    code: 'H443',
    level: 3,
    description: 'Otros trastornos degenerativos del globo ocular',
    code_2: 'H44',
    code_0: 'H00-H59',
    code_1: 'H43-H45'
  },
  {
    code: 'H430',
    level: 3,
    description: 'Prolapso del v\u00edtreo',
    code_2: 'H43',
    code_0: 'H00-H59',
    code_1: 'H43-H45'
  },
  {
    code: 'H431',
    level: 3,
    description: 'Hemorragia del v\u00edtreo',
    code_2: 'H43',
    code_0: 'H00-H59',
    code_1: 'H43-H45'
  },
  {
    code: 'H432',
    level: 3,
    description: 'Dep\u00f3sitos cristalinos en el cuerpo v\u00edtreo',
    code_2: 'H43',
    code_0: 'H00-H59',
    code_1: 'H43-H45'
  },
  {
    code: 'H433',
    level: 3,
    description: 'Otras opacidades v\u00edtreas',
    code_2: 'H43',
    code_0: 'H00-H59',
    code_1: 'H43-H45'
  },
  {
    code: 'H438',
    level: 3,
    description: 'Otros trastornos del cuerpo v\u00edtreo',
    code_2: 'H43',
    code_0: 'H00-H59',
    code_1: 'H43-H45'
  },
  {
    code: 'H439',
    level: 3,
    description: 'Trastorno del cuerpo v\u00edtreo, no especificado',
    code_2: 'H43',
    code_0: 'H00-H59',
    code_1: 'H43-H45'
  },
  {
    code: 'H480',
    level: 3,
    description:
      'Atrofia \u00f3ptica en enfermedades clasificadas en otra parte',
    code_2: 'H48',
    code_0: 'H00-H59',
    code_1: 'H46-H48'
  },
  {
    code: 'H481',
    level: 3,
    description:
      'Neuritis retrobulbar en enfermedades clasificadas en otra parte',
    code_2: 'H48',
    code_0: 'H00-H59',
    code_1: 'H46-H48'
  },
  {
    code: 'H488',
    level: 3,
    description:
      'Otros trastornos del nervio \u00f3ptico y de las v\u00edas \u00f3pticas en enfermedades clasificadas en otra parte',
    code_2: 'H48',
    code_0: 'H00-H59',
    code_1: 'H46-H48'
  },
  {
    code: 'H470',
    level: 3,
    description:
      'Trastornos del nervio \u00f3ptico, no clasificados en otra parte',
    code_2: 'H47',
    code_0: 'H00-H59',
    code_1: 'H46-H48'
  },
  {
    code: 'H471',
    level: 3,
    description: 'Papiledema, no especificado',
    code_2: 'H47',
    code_0: 'H00-H59',
    code_1: 'H46-H48'
  },
  {
    code: 'H472',
    level: 3,
    description: 'Atrofia \u00f3ptica',
    code_2: 'H47',
    code_0: 'H00-H59',
    code_1: 'H46-H48'
  },
  {
    code: 'H473',
    level: 3,
    description: 'Otros trastornos del disco \u00f3ptico',
    code_2: 'H47',
    code_0: 'H00-H59',
    code_1: 'H46-H48'
  },
  {
    code: 'H474',
    level: 3,
    description: 'Trastornos del quiasma \u00f3ptico',
    code_2: 'H47',
    code_0: 'H00-H59',
    code_1: 'H46-H48'
  },
  {
    code: 'H475',
    level: 3,
    description: 'Trastornos de otras v\u00edas \u00f3pticas',
    code_2: 'H47',
    code_0: 'H00-H59',
    code_1: 'H46-H48'
  },
  {
    code: 'H476',
    level: 3,
    description: 'Trastornos de la corteza visual',
    code_2: 'H47',
    code_0: 'H00-H59',
    code_1: 'H46-H48'
  },
  {
    code: 'H477',
    level: 3,
    description: 'Trastorno de las v\u00edas \u00f3pticas, no especificado',
    code_2: 'H47',
    code_0: 'H00-H59',
    code_1: 'H46-H48'
  },
  {
    code: 'I95',
    level: 2,
    description: 'Hipotensi\u00f3n',
    code_1: 'I95-I99',
    code_0: 'I00-I99'
  },
  {
    code: 'I97',
    level: 2,
    description:
      'Trastornos del sistema circulatorio consecutivos a procedimientos, no clasificados en otra parte',
    code_1: 'I95-I99',
    code_0: 'I00-I99'
  },
  {
    code: 'I98',
    level: 2,
    description:
      'Otros trastornos del sistema circulatorio en enfermedades clasificadas en otra parte',
    code_1: 'I95-I99',
    code_0: 'I00-I99'
  },
  {
    code: 'I99',
    level: 2,
    description:
      'Otros trastornos y los no especificados del sistema circulatorio',
    code_1: 'I95-I99',
    code_0: 'I00-I99'
  },
  {
    code: 'I80',
    level: 2,
    description: 'Flebitis y tromboflebitis',
    code_1: 'I80-I89',
    code_0: 'I00-I99'
  },
  {
    code: 'I81',
    level: 2,
    description: 'Trombosis de la vena porta',
    code_1: 'I80-I89',
    code_0: 'I00-I99'
  },
  {
    code: 'I82',
    level: 2,
    description: 'Otras embolias y trombosis venosas',
    code_1: 'I80-I89',
    code_0: 'I00-I99'
  },
  {
    code: 'I83',
    level: 2,
    description: 'Venas varicosas de los miembros inferiores',
    code_1: 'I80-I89',
    code_0: 'I00-I99'
  },
  {
    code: 'I84',
    level: 2,
    description: 'Hemorroides',
    code_1: 'I80-I89',
    code_0: 'I00-I99'
  },
  {
    code: 'I85',
    level: 2,
    description: 'V\u00e1rices esof\u00e1gicas',
    code_1: 'I80-I89',
    code_0: 'I00-I99'
  },
  {
    code: 'I70',
    level: 2,
    description: 'Aterosclerosis',
    code_1: 'I70-I79',
    code_0: 'I00-I99'
  },
  {
    code: 'I71',
    level: 2,
    description: 'Aneurisma y disecci\u00f3n a\u00f3rticos',
    code_1: 'I70-I79',
    code_0: 'I00-I99'
  },
  {
    code: 'I72',
    level: 2,
    description: 'Otros aneurismas',
    code_1: 'I70-I79',
    code_0: 'I00-I99'
  },
  {
    code: 'I73',
    level: 2,
    description: 'Otras enfermedades vasculares perif\u00e9ricas',
    code_1: 'I70-I79',
    code_0: 'I00-I99'
  },
  {
    code: 'I74',
    level: 2,
    description: 'Embolia y trombosis arteriales',
    code_1: 'I70-I79',
    code_0: 'I00-I99'
  },
  {
    code: 'I60',
    level: 2,
    description: 'Hemorragia subaracnoidea',
    code_1: 'I60-I69',
    code_0: 'I00-I99'
  },
  {
    code: 'I61',
    level: 2,
    description: 'Hemorragia intraencef\u00e1lica',
    code_1: 'I60-I69',
    code_0: 'I00-I99'
  },
  {
    code: 'I62',
    level: 2,
    description: 'Otras hemorragias intracraneales no traum\u00e1ticas',
    code_1: 'I60-I69',
    code_0: 'I00-I99'
  },
  {
    code: 'I63',
    level: 2,
    description: 'Infarto cerebral',
    code_1: 'I60-I69',
    code_0: 'I00-I99'
  },
  {
    code: 'I64',
    level: 2,
    description:
      'Accidente vascular encef\u00e1lico agudo, no especificado como hemorr\u00e1gico o isqu\u00e9mico',
    code_1: 'I60-I69',
    code_0: 'I00-I99'
  },
  {
    code: 'I65',
    level: 2,
    description:
      'Oclusi\u00f3n y estenosis de las arterias precerebrales sin ocasionar infarto cerebral',
    code_1: 'I60-I69',
    code_0: 'I00-I99'
  },
  {
    code: 'I30',
    level: 2,
    description: 'Pericarditis aguda',
    code_1: 'I30-I52',
    code_0: 'I00-I99'
  },
  {
    code: 'I31',
    level: 2,
    description: 'Otras enfermedades del pericardio',
    code_1: 'I30-I52',
    code_0: 'I00-I99'
  },
  {
    code: 'I32',
    level: 2,
    description: 'Pericarditis en enfermedades clasificadas en otra parte',
    code_1: 'I30-I52',
    code_0: 'I00-I99'
  },
  {
    code: 'I26',
    level: 2,
    description: 'Embolia pulmonar',
    code_1: 'I26-I28',
    code_0: 'I00-I99'
  },
  {
    code: 'I27',
    level: 2,
    description: 'Otras enfermedades cardiopulmonares',
    code_1: 'I26-I28',
    code_0: 'I00-I99'
  },
  {
    code: 'I28',
    level: 2,
    description: 'Otras enfermedades de los vasos pulmonares',
    code_1: 'I26-I28',
    code_0: 'I00-I99'
  },
  {
    code: 'H520',
    level: 3,
    description: 'Hipermetrop\u00eda',
    code_2: 'H52',
    code_0: 'H00-H59',
    code_1: 'H49-H52'
  },
  {
    code: 'H521',
    level: 3,
    description: 'Miop\u00eda',
    code_2: 'H52',
    code_0: 'H00-H59',
    code_1: 'H49-H52'
  },
  {
    code: 'H522',
    level: 3,
    description: 'Astigmatismo',
    code_2: 'H52',
    code_0: 'H00-H59',
    code_1: 'H49-H52'
  },
  {
    code: 'H523',
    level: 3,
    description: 'Anisometrop\u00eda y aniseicon\u00eda',
    code_2: 'H52',
    code_0: 'H00-H59',
    code_1: 'H49-H52'
  },
  {
    code: 'H524',
    level: 3,
    description: 'Presbicia',
    code_2: 'H52',
    code_0: 'H00-H59',
    code_1: 'H49-H52'
  },
  {
    code: 'H525',
    level: 3,
    description: 'Trastornos de la acomodaci\u00f3n',
    code_2: 'H52',
    code_0: 'H00-H59',
    code_1: 'H49-H52'
  },
  {
    code: 'H526',
    level: 3,
    description: 'Otros trastornos de la refracci\u00f3n',
    code_2: 'H52',
    code_0: 'H00-H59',
    code_1: 'H49-H52'
  },
  {
    code: 'H527',
    level: 3,
    description: 'Trastorno de la refracci\u00f3n, no especificado',
    code_2: 'H52',
    code_0: 'H00-H59',
    code_1: 'H49-H52'
  },
  {
    code: 'H510',
    level: 3,
    description: 'Par\u00e1lisis de la conjugaci\u00f3n de la mirada',
    code_2: 'H51',
    code_0: 'H00-H59',
    code_1: 'H49-H52'
  },
  {
    code: 'H511',
    level: 3,
    description: 'Exceso e insuficiencia de la convergencia ocular',
    code_2: 'H51',
    code_0: 'H00-H59',
    code_1: 'H49-H52'
  },
  {
    code: 'H512',
    level: 3,
    description: 'Oftalmoplej\u00eda internuclear',
    code_2: 'H51',
    code_0: 'H00-H59',
    code_1: 'H49-H52'
  },
  {
    code: 'H518',
    level: 3,
    description:
      'Otros trastornos especificados de los movimientos binoculares',
    code_2: 'H51',
    code_0: 'H00-H59',
    code_1: 'H49-H52'
  },
  {
    code: 'H519',
    level: 3,
    description: 'Trastorno del movimiento binocular, no especificado',
    code_2: 'H51',
    code_0: 'H00-H59',
    code_1: 'H49-H52'
  },
  {
    code: 'H500',
    level: 3,
    description: 'Estrabismo concomitante convergente',
    code_2: 'H50',
    code_0: 'H00-H59',
    code_1: 'H49-H52'
  },
  {
    code: 'H501',
    level: 3,
    description: 'Estrabismo concomitante divergente',
    code_2: 'H50',
    code_0: 'H00-H59',
    code_1: 'H49-H52'
  },
  {
    code: 'H502',
    level: 3,
    description: 'Estrabismo vertical',
    code_2: 'H50',
    code_0: 'H00-H59',
    code_1: 'H49-H52'
  },
  {
    code: 'H503',
    level: 3,
    description: 'Heterotrop\u00eda intermitente',
    code_2: 'H50',
    code_0: 'H00-H59',
    code_1: 'H49-H52'
  },
  {
    code: 'H504',
    level: 3,
    description: 'Otras heterotrop\u00edas o las no especificadas',
    code_2: 'H50',
    code_0: 'H00-H59',
    code_1: 'H49-H52'
  },
  {
    code: 'H505',
    level: 3,
    description: 'Heteroforia',
    code_2: 'H50',
    code_0: 'H00-H59',
    code_1: 'H49-H52'
  },
  {
    code: 'H506',
    level: 3,
    description: 'Estrabismo mec\u00e1nico',
    code_2: 'H50',
    code_0: 'H00-H59',
    code_1: 'H49-H52'
  },
  {
    code: 'H508',
    level: 3,
    description: 'Otros estrabismos especificados',
    code_2: 'H50',
    code_0: 'H00-H59',
    code_1: 'H49-H52'
  },
  {
    code: 'H509',
    level: 3,
    description: 'Estrabismo, no especificado',
    code_2: 'H50',
    code_0: 'H00-H59',
    code_1: 'H49-H52'
  },
  {
    code: 'H490',
    level: 3,
    description: 'Par\u00e1lisis del nervio motor ocular com\u00fan [III par]',
    code_2: 'H49',
    code_0: 'H00-H59',
    code_1: 'H49-H52'
  },
  {
    code: 'H491',
    level: 3,
    description: 'Par\u00e1lisis del nervio pat\u00e9tico [IV par]',
    code_2: 'H49',
    code_0: 'H00-H59',
    code_1: 'H49-H52'
  },
  {
    code: 'H492',
    level: 3,
    description: 'Par\u00e1lisis del nervio motor ocular externo [VI par]',
    code_2: 'H49',
    code_0: 'H00-H59',
    code_1: 'H49-H52'
  },
  {
    code: 'J95',
    level: 2,
    description:
      'Trastornos del sistema respiratorio consecutivos a procedimientos, no clasificados en otra parte',
    code_1: 'J95-J99',
    code_0: 'J00-J99'
  },
  {
    code: 'J96',
    level: 2,
    description: 'Insuficiencia respiratoria, no clasificada en otra parte',
    code_1: 'J95-J99',
    code_0: 'J00-J99'
  },
  {
    code: 'J98',
    level: 2,
    description: 'Otros trastornos respiratorios',
    code_1: 'J95-J99',
    code_0: 'J00-J99'
  },
  {
    code: 'J90',
    level: 2,
    description: 'Derrame pleural no clasificado en otra parte',
    code_1: 'J90\u2013J94 ',
    code_0: 'J00-J99'
  },
  {
    code: 'J91',
    level: 2,
    description: 'Derrame pleural en afecciones clasificadas en otra parte',
    code_1: 'J90\u2013J94 ',
    code_0: 'J00-J99'
  },
  {
    code: 'J92',
    level: 2,
    description: 'Paquipleuritis',
    code_1: 'J90\u2013J94 ',
    code_0: 'J00-J99'
  },
  {
    code: 'J93',
    level: 2,
    description: 'Neumot\u00f3rax',
    code_1: 'J90\u2013J94 ',
    code_0: 'J00-J99'
  },
  {
    code: 'J94',
    level: 2,
    description: 'Otras afecciones de la pleura',
    code_1: 'J90\u2013J94 ',
    code_0: 'J00-J99'
  },
  {
    code: 'J85',
    level: 2,
    description: 'Absceso del pulm\u00f3n y del mediastino',
    code_1: 'J85-J86',
    code_0: 'J00-J99'
  },
  {
    code: 'J86',
    level: 2,
    description: 'Piot\u00f3rax',
    code_1: 'J85-J86',
    code_0: 'J00-J99'
  },
  {
    code: 'J80',
    level: 2,
    description: 'S\u00edndrome de dificultad respiratoria del adulto',
    code_1: 'J80-J84',
    code_0: 'J00-J99'
  },
  {
    code: 'J81',
    level: 2,
    description: 'Edema pulmonar',
    code_1: 'J80-J84',
    code_0: 'J00-J99'
  },
  {
    code: 'J82',
    level: 2,
    description: 'Eosinofilia pulmonar, no clasificada en otra parte',
    code_1: 'J80-J84',
    code_0: 'J00-J99'
  },
  {
    code: 'J84',
    level: 2,
    description: 'Otras enfermedades pulmonares intersticiales',
    code_1: 'J80-J84',
    code_0: 'J00-J99'
  },
  {
    code: 'J60',
    level: 2,
    description: 'Neumoconiosis de los mineros del carb\u00f3n',
    code_1: 'J60-J70',
    code_0: 'J00-J99'
  },
  {
    code: 'J61',
    level: 2,
    description: 'Neumoconiosis debida al asbesto y a otras fibras minerales',
    code_1: 'J60-J70',
    code_0: 'J00-J99'
  },
  {
    code: 'J40',
    level: 2,
    description: 'Bronquitis, no especificada como aguda o cr\u00f3nica',
    code_1: 'J40-J47',
    code_0: 'J00-J99'
  },
  {
    code: 'J41',
    level: 2,
    description: 'Bronquitis cr\u00f3nica simple y mucopurulenta',
    code_1: 'J40-J47',
    code_0: 'J00-J99'
  },
  {
    code: 'J42',
    level: 2,
    description: 'Bronquitis cr\u00f3nica no especificada',
    code_1: 'J40-J47',
    code_0: 'J00-J99'
  },
  {
    code: 'J43',
    level: 2,
    description: 'Enfisema',
    code_1: 'J40-J47',
    code_0: 'J00-J99'
  },
  {
    code: 'J44',
    level: 2,
    description: 'Otras enfermedades pulmonares obstructivas cr\u00f3nicas',
    code_1: 'J40-J47',
    code_0: 'J00-J99'
  },
  {
    code: 'K90',
    level: 2,
    description: 'Malabsorci\u00f3n intestinal',
    code_1: 'K90-K93',
    code_0: 'K00-K95'
  },
  {
    code: 'K91',
    level: 2,
    description:
      'Trastornos del sistema digestivo consecutivos a procedimientos, no clasificados en otra parte',
    code_1: 'K90-K93',
    code_0: 'K00-K95'
  },
  {
    code: 'K92',
    level: 2,
    description: 'Otras enfermedades del sistema digestivo',
    code_1: 'K90-K93',
    code_0: 'K00-K95'
  },
  {
    code: 'K93',
    level: 2,
    description:
      'Trastornos de otros \u00f3rganos digestivos en enfermedades clasificadas en otra parte',
    code_1: 'K90-K93',
    code_0: 'K00-K95'
  },
  {
    code: 'K80',
    level: 2,
    description: 'Colelitiasis',
    code_1: 'K80-K87',
    code_0: 'K00-K95'
  },
  {
    code: 'K81',
    level: 2,
    description: 'Colecistitis',
    code_1: 'K80-K87',
    code_0: 'K00-K95'
  },
  {
    code: 'K82',
    level: 2,
    description: 'Otras enfermedades de la ves\u00edcula biliar',
    code_1: 'K80-K87',
    code_0: 'K00-K95'
  },
  {
    code: 'K83',
    level: 2,
    description: 'Otras enfermedades de las v\u00edas biliares',
    code_1: 'K80-K87',
    code_0: 'K00-K95'
  },
  {
    code: 'K70',
    level: 2,
    description: 'Enfermedad alcoh\u00f3lica del h\u00edgado',
    code_1: 'K70-K77',
    code_0: 'K00-K95'
  },
  {
    code: 'K71',
    level: 2,
    description: 'Enfermedad t\u00f3xica del h\u00edgado',
    code_1: 'K70-K77',
    code_0: 'K00-K95'
  },
  {
    code: 'K72',
    level: 2,
    description: 'Insuficiencia hep\u00e1tica, no clasificada en otra parte',
    code_1: 'K70-K77',
    code_0: 'K00-K95'
  },
  {
    code: 'K73',
    level: 2,
    description: 'Hepatitis cr\u00f3nica, no clasificada en otra parte',
    code_1: 'K70-K77',
    code_0: 'K00-K95'
  },
  {
    code: 'K74',
    level: 2,
    description: 'Fibrosis y cirrosis del h\u00edgado',
    code_1: 'K70-K77',
    code_0: 'K00-K95'
  },
  {
    code: 'K75',
    level: 2,
    description: 'Otras enfermedades inflamatorias del h\u00edgado',
    code_1: 'K70-K77',
    code_0: 'K00-K95'
  },
  {
    code: 'K76',
    level: 2,
    description: 'Otras enfermedades del h\u00edgado',
    code_1: 'K70-K77',
    code_0: 'K00-K95'
  },
  {
    code: 'K65',
    level: 2,
    description: 'Peritonitis',
    code_1: 'K65-K67',
    code_0: 'K00-K95'
  },
  {
    code: 'K66',
    level: 2,
    description: 'Otros trastornos del peritoneo',
    code_1: 'K65-K67',
    code_0: 'K00-K95'
  },
  {
    code: 'K67',
    level: 2,
    description:
      'Trastornos del peritoneo en enfermedades infecciosas clasificadas en otra parte',
    code_1: 'K65-K67',
    code_0: 'K00-K95'
  },
  {
    code: 'H540',
    level: 3,
    description: 'Ceguera de ambos ojos',
    code_2: 'H54',
    code_0: 'H00-H59',
    code_1: 'H53-H54'
  },
  {
    code: 'H541',
    level: 3,
    description: 'Ceguera de un ojo, visi\u00f3n subnormal del otro',
    code_2: 'H54',
    code_0: 'H00-H59',
    code_1: 'H53-H54'
  },
  {
    code: 'H542',
    level: 3,
    description: 'Visi\u00f3n subnormal de ambos ojos',
    code_2: 'H54',
    code_0: 'H00-H59',
    code_1: 'H53-H54'
  },
  {
    code: 'H543',
    level: 3,
    description:
      'Disminuci\u00f3n indeterminada de la agudeza visual en ambos ojos',
    code_2: 'H54',
    code_0: 'H00-H59',
    code_1: 'H53-H54'
  },
  {
    code: 'H530',
    level: 3,
    description: 'Ambliop\u00eda ex anopsia',
    code_2: 'H53',
    code_0: 'H00-H59',
    code_1: 'H53-H54'
  },
  {
    code: 'H531',
    level: 3,
    description: 'Alteraciones visuales subjetivas',
    code_2: 'H53',
    code_0: 'H00-H59',
    code_1: 'H53-H54'
  },
  {
    code: 'H532',
    level: 3,
    description: 'Diplop\u00eda',
    code_2: 'H53',
    code_0: 'H00-H59',
    code_1: 'H53-H54'
  },
  {
    code: 'H533',
    level: 3,
    description: 'Otros trastornos de la visi\u00f3n binocular',
    code_2: 'H53',
    code_0: 'H00-H59',
    code_1: 'H53-H54'
  },
  {
    code: 'H534',
    level: 3,
    description: 'Defectos del campo visual',
    code_2: 'H53',
    code_0: 'H00-H59',
    code_1: 'H53-H54'
  },
  {
    code: 'H535',
    level: 3,
    description: 'Deficiencia de la visi\u00f3n crom\u00e1tica',
    code_2: 'H53',
    code_0: 'H00-H59',
    code_1: 'H53-H54'
  },
  {
    code: 'H536',
    level: 3,
    description: 'Ceguera nocturna',
    code_2: 'H53',
    code_0: 'H00-H59',
    code_1: 'H53-H54'
  },
  {
    code: 'H538',
    level: 3,
    description: 'Otras alteraciones visuales',
    code_2: 'H53',
    code_0: 'H00-H59',
    code_1: 'H53-H54'
  },
  {
    code: 'H539',
    level: 3,
    description: 'Alteraci\u00f3n visual, no especificada',
    code_2: 'H53',
    code_0: 'H00-H59',
    code_1: 'H53-H54'
  },
  {
    code: 'L80',
    level: 2,
    description: 'Vit\u00edligo',
    code_1: 'L80-L99',
    code_0: 'L00-L99'
  },
  {
    code: 'L81',
    level: 2,
    description: 'Otros trastornos de la pigmentaci\u00f3n',
    code_1: 'L80-L99',
    code_0: 'L00-L99'
  },
  {
    code: 'L82',
    level: 2,
    description: 'Queratosis seborreica',
    code_1: 'L80-L99',
    code_0: 'L00-L99'
  },
  {
    code: 'L60',
    level: 2,
    description: 'Trastornos de las u\u00f1as',
    code_1: 'L60-L75',
    code_0: 'L00-L99'
  },
  {
    code: 'L62',
    level: 2,
    description:
      'Trastornos de las u\u00f1as en enfermedades clasificadas en otra parte',
    code_1: 'L60-L75',
    code_0: 'L00-L99'
  },
  {
    code: 'L63',
    level: 2,
    description: 'Alopecia areata',
    code_1: 'L60-L75',
    code_0: 'L00-L99'
  },
  {
    code: 'L64',
    level: 2,
    description: 'Alopecia andr\u00f3gena',
    code_1: 'L60-L75',
    code_0: 'L00-L99'
  },
  {
    code: 'L55',
    level: 2,
    description: 'Quemadura solar',
    code_1: 'L55-L59',
    code_0: 'L00-L99'
  },
  {
    code: 'L56',
    level: 2,
    description:
      'Otros cambios agudos de la piel debidos a radiaci\u00f3n ultravioleta',
    code_1: 'L55-L59',
    code_0: 'L00-L99'
  },
  {
    code: 'L57',
    level: 2,
    description:
      'Cambios de la piel debidos a exposici\u00f3n cr\u00f3nica a radiaci\u00f3n no ionizante',
    code_1: 'L55-L59',
    code_0: 'L00-L99'
  },
  {
    code: 'L58',
    level: 2,
    description: 'Radiodermatitis',
    code_1: 'L55-L59',
    code_0: 'L00-L99'
  },
  {
    code: 'L59',
    level: 2,
    description:
      'Otros trastornos de la piel y del tejido subcut\u00e1neo relacionados con radiaci\u00f3n',
    code_1: 'L55-L59',
    code_0: 'L00-L99'
  },
  {
    code: 'L50',
    level: 2,
    description: 'Urticaria',
    code_1: 'L50-L54',
    code_0: 'L00-L99'
  },
  {
    code: 'L51',
    level: 2,
    description: 'Eritema multiforme',
    code_1: 'L50-L54',
    code_0: 'L00-L99'
  },
  {
    code: 'L52',
    level: 2,
    description: 'Eritema nudoso',
    code_1: 'L50-L54',
    code_0: 'L00-L99'
  },
  {
    code: 'L53',
    level: 2,
    description: 'Otras afecciones eritematosas',
    code_1: 'L50-L54',
    code_0: 'L00-L99'
  },
  {
    code: 'L54',
    level: 2,
    description: 'Eritema en enfermedades clasificadas en otra parte',
    code_1: 'L50-L54',
    code_0: 'L00-L99'
  },
  {
    code: 'F010',
    level: 3,
    description: 'Demencia vascular de comienzo agudo',
    code_2: 'F01',
    code_0: 'F01-F99',
    code_1: 'F00-F09'
  },
  {
    code: 'F011',
    level: 3,
    description: 'Demencia vascular por infartos m\u00faltiples',
    code_2: 'F01',
    code_0: 'F01-F99',
    code_1: 'F00-F09'
  },
  {
    code: 'F012',
    level: 3,
    description: 'Demencia vascular subcortical',
    code_2: 'F01',
    code_0: 'F01-F99',
    code_1: 'F00-F09'
  },
  {
    code: 'F013',
    level: 3,
    description: 'Demencia vascular mixta, cortical y subcortical',
    code_2: 'F01',
    code_0: 'F01-F99',
    code_1: 'F00-F09'
  },
  {
    code: 'F018',
    level: 3,
    description: 'Otras demencias vasculares',
    code_2: 'F01',
    code_0: 'F01-F99',
    code_1: 'F00-F09'
  },
  {
    code: 'F000',
    level: 3,
    description:
      'Demencia en la enfermedad de Alzheimer, de comienzo temprano (G30.0)',
    code_2: 'F00',
    code_0: 'F01-F99',
    code_1: 'F00-F09'
  },
  {
    code: 'F001',
    level: 3,
    description:
      'Demencia en la enfermedad de Alzheimer, de comienzo tard\u00edo (G30.1)',
    code_2: 'F00',
    code_0: 'F01-F99',
    code_1: 'F00-F09'
  },
  {
    code: 'F002',
    level: 3,
    description:
      'Demencia en la enfermedad de Alzheimer, at\u00edpica o de tipo mixto (G30.8)',
    code_2: 'F00',
    code_0: 'F01-F99',
    code_1: 'F00-F09'
  },
  {
    code: 'F009',
    level: 3,
    description:
      'Demencia en la enfermedad de Alzheimer, no especificada (G30.9)',
    code_2: 'F00',
    code_0: 'F01-F99',
    code_1: 'F00-F09'
  },
  {
    code: 'M95',
    level: 2,
    description:
      'Otras deformidades adquiridas del sistema osteomuscular y del tejido conjuntivo',
    code_1: 'M95-M99',
    code_0: 'M00-M99'
  },
  {
    code: 'M96',
    level: 2,
    description:
      'Trastornos osteomusculares consecutivos a procedimientos, no clasificados en otra parte',
    code_1: 'M95-M99',
    code_0: 'M00-M99'
  },
  {
    code: 'M99',
    level: 2,
    description: 'Lesiones biomec\u00e1nicas, no clasificadas en otra parte',
    code_1: 'M95-M99',
    code_0: 'M00-M99'
  },
  {
    code: 'B95',
    level: 2,
    description:
      'Estreptococos y estafilococos como causa de enfermedades clasificadas en otros cap\u00edtulos',
    code_1: 'B95-B97',
    code_0: 'A00-B99'
  },
  {
    code: 'B96',
    level: 2,
    description:
      'Otros agentes bacterianos como causa de enfermedades clasificadas en otros cap\u00edtulos',
    code_1: 'B95-B97',
    code_0: 'A00-B99'
  },
  {
    code: 'B97',
    level: 2,
    description:
      'Agentes virales como causa de enfermedades clasificadas en otros cap\u00edtulos',
    code_1: 'B95-B97',
    code_0: 'A00-B99'
  },
  {
    code: 'B90',
    level: 2,
    description: 'Secuelas de tuberculosis',
    code_1: 'B90-B94',
    code_0: 'A00-B99'
  },
  {
    code: 'B91',
    level: 2,
    description: 'Secuelas de poliomielitis',
    code_1: 'B90-B94',
    code_0: 'A00-B99'
  },
  {
    code: 'B92',
    level: 2,
    description: 'Secuelas de lepra',
    code_1: 'B90-B94',
    code_0: 'A00-B99'
  },
  {
    code: 'B94',
    level: 2,
    description:
      'Secuelas de otras enfermedades infecciosas y parasitarias y de las no especificadas',
    code_1: 'B90-B94',
    code_0: 'A00-B99'
  },
  {
    code: 'B85',
    level: 2,
    description: 'Pediculosis y phthiriasis',
    code_1: 'B85-B89',
    code_0: 'A00-B99'
  },
  {
    code: 'B86',
    level: 2,
    description: 'Escabiosis',
    code_1: 'B85-B89',
    code_0: 'A00-B99'
  },
  {
    code: 'B87',
    level: 2,
    description: 'Miasis',
    code_1: 'B85-B89',
    code_0: 'A00-B99'
  },
  {
    code: 'B88',
    level: 2,
    description: 'Otras infestaciones',
    code_1: 'B85-B89',
    code_0: 'A00-B99'
  },
  {
    code: 'B65',
    level: 2,
    description: 'Esquistosomiasis [bilharziasis]',
    code_1: 'B65-B83',
    code_0: 'A00-B99'
  },
  {
    code: 'B66',
    level: 2,
    description: 'Otras infecciones debidas a trematodos',
    code_1: 'B65-B83',
    code_0: 'A00-B99'
  },
  {
    code: 'B67',
    level: 2,
    description: 'Equinococosis',
    code_1: 'B65-B83',
    code_0: 'A00-B99'
  },
  {
    code: 'B68',
    level: 2,
    description: 'Teniasis',
    code_1: 'B65-B83',
    code_0: 'A00-B99'
  },
  {
    code: 'B69',
    level: 2,
    description: 'Cisticercosis',
    code_1: 'B65-B83',
    code_0: 'A00-B99'
  },
  {
    code: 'B50',
    level: 2,
    description: 'Paludismo [malaria] debido a Plasmodium falciparum',
    code_1: 'B50-B64',
    code_0: 'A00-B99'
  },
  {
    code: 'B51',
    level: 2,
    description: 'Paludismo [malaria] debido a Plasmodium vivax',
    code_1: 'B50-B64',
    code_0: 'A00-B99'
  },
  {
    code: 'B52',
    level: 2,
    description: 'Paludismo [malaria] debido a Plasmodium malariae',
    code_1: 'B50-B64',
    code_0: 'A00-B99'
  },
  {
    code: 'B53',
    level: 2,
    description: 'Otro paludismo [malaria] confirmado parasitol\u00f3gicamente',
    code_1: 'B50-B64',
    code_0: 'A00-B99'
  },
  {
    code: 'B54',
    level: 2,
    description: 'Paludismo [malaria] no especificado',
    code_1: 'B50-B64',
    code_0: 'A00-B99'
  },
  {
    code: 'B35',
    level: 2,
    description: 'Dermatofitosis',
    code_1: 'B35-B49',
    code_0: 'A00-B99'
  },
  {
    code: 'B36',
    level: 2,
    description: 'Otras micosis superficiales',
    code_1: 'B35-B49',
    code_0: 'A00-B99'
  },
  {
    code: 'B37',
    level: 2,
    description: 'Candidiasis',
    code_1: 'B35-B49',
    code_0: 'A00-B99'
  },
  {
    code: 'B25',
    level: 2,
    description: 'Enfermedad debida a virus citomeg\u00e1lico',
    code_1: 'B25-B34',
    code_0: 'A00-B99'
  },
  {
    code: 'Z36',
    level: 2,
    description: 'Pesquisas prenatales',
    code_1: 'Z30-Z39',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z37',
    level: 2,
    description: 'Producto del parto',
    code_1: 'Z30-Z39',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z38',
    level: 2,
    description: 'Nacidos vivos seg\u00fan lugar de nacimiento',
    code_1: 'Z30-Z39',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z39',
    level: 2,
    description: 'Examen y atenci\u00f3n del postparto',
    code_1: 'Z30-Z39',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z23',
    level: 2,
    description:
      'Necesidad de inmunizaci\u00f3n contra enfermedad bacteriana \u00fanica',
    code_1: 'Z20-Z29',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z24',
    level: 2,
    description:
      'Necesidad de inmunizaci\u00f3n contra ciertas enfermedades virales',
    code_1: 'Z20-Z29',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z25',
    level: 2,
    description:
      'Necesidad de inmunizaci\u00f3n contra otras enfermedades virales \u00fanicas',
    code_1: 'Z20-Z29',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z26',
    level: 2,
    description:
      'Necesidad de inmunizaci\u00f3n contra otras enfermedades infecciosas \u00fanicas',
    code_1: 'Z20-Z29',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z27',
    level: 2,
    description:
      'Necesidad de inmunizaci\u00f3n contra combinaciones de enfermedades infecciosas',
    code_1: 'Z20-Z29',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z28',
    level: 2,
    description: 'Inmunizaci\u00f3n no realizada',
    code_1: 'Z20-Z29',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z29',
    level: 2,
    description: 'Necesidad de otras medidas profil\u00e1cticas',
    code_1: 'Z20-Z29',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z09',
    level: 2,
    description:
      'Examen de seguimiento consecutivo a tratamiento por otras afecciones diferentes a tumores malignos',
    code_1: 'Z00-Z13',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z10',
    level: 2,
    description:
      'Control general de salud de rutina de subpoblaciones definidas',
    code_1: 'Z00-Z13',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z11',
    level: 2,
    description:
      'Examen de pesquisa especial para enfermedades infecciosas y parasitarias',
    code_1: 'Z00-Z13',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z12',
    level: 2,
    description: 'Examen de pesquisa especial para tumores',
    code_1: 'Z00-Z13',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z13',
    level: 2,
    description:
      'Examen de pesquisa especial para otras enfermedades y trastornos',
    code_1: 'Z00-Z13',
    code_0: 'Z00-Z99'
  },
  {
    code: 'B20',
    level: 2,
    description:
      'Enfermedad por virus de la inmunodeficiencia humana [VIH], resultante en enfermedades \u00adinfecciosas y parasitarias',
    code_1: 'B20-B24',
    code_0: 'A00-B99'
  },
  {
    code: 'B21',
    level: 2,
    description:
      'Enfermedad por virus de la inmunodeficiencia humana [VIH], resultante en tumores malignos',
    code_1: 'B20-B24',
    code_0: 'A00-B99'
  },
  {
    code: 'B22',
    level: 2,
    description:
      'Enfermedad por virus de la inmunodeficiencia humana [VIH], resultante en otras enfermedades especificadas',
    code_1: 'B20-B24',
    code_0: 'A00-B99'
  },
  {
    code: 'B23',
    level: 2,
    description:
      'Enfermedad por virus de la inmunodeficiencia humana [VIH], resultante en otras afecciones',
    code_1: 'B20-B24',
    code_0: 'A00-B99'
  },
  {
    code: 'B24',
    level: 2,
    description:
      'Enfermedad por virus de la inmunodeficiencia humana [VIH], sin otra especificaci\u00f3n',
    code_1: 'B20-B24',
    code_0: 'A00-B99'
  },
  {
    code: 'T02',
    level: 2,
    description: 'Fracturas que afectan m\u00faltiples regiones del cuerpo',
    code_1: 'T00-T07',
    code_0: 'S00-T88'
  },
  {
    code: 'T03',
    level: 2,
    description:
      'Luxaciones, torceduras y esguinces que afectan m\u00faltiples regiones del cuerpo',
    code_1: 'T00-T07',
    code_0: 'S00-T88'
  },
  {
    code: 'T04',
    level: 2,
    description:
      'Traumatismos por aplastamiento que afectan m\u00faltiples regiones del cuerpo',
    code_1: 'T00-T07',
    code_0: 'S00-T88'
  },
  {
    code: 'T05',
    level: 2,
    description:
      'Amputaciones traum\u00e1ticas que afectan m\u00faltiples regiones del cuerpo',
    code_1: 'T00-T07',
    code_0: 'S00-T88'
  },
  {
    code: 'T06',
    level: 2,
    description:
      'Otros traumatismos que afectan m\u00faltiples regiones del cuerpo, no clasificados en otra parte',
    code_1: 'T00-T07',
    code_0: 'S00-T88'
  },
  {
    code: 'T07',
    level: 2,
    description: 'Traumatismos m\u00faltiples, no especificados',
    code_1: 'T00-T07',
    code_0: 'S00-T88'
  },
  {
    code: 'S95',
    level: 2,
    description:
      'Traumatismo de vasos sangu\u00edneos a nivel del pie y del tobillo',
    code_1: 'S90-S99',
    code_0: 'S00-T88'
  },
  {
    code: 'S96',
    level: 2,
    description:
      'Traumatismo de tend\u00f3n y m\u00fasculo a nivel del pie y del tobillo',
    code_1: 'S90-S99',
    code_0: 'S00-T88'
  },
  {
    code: 'S97',
    level: 2,
    description: 'Traumatismo por aplastamiento del pie y del tobillo',
    code_1: 'S90-S99',
    code_0: 'S00-T88'
  },
  {
    code: 'S98',
    level: 2,
    description: 'Amputaci\u00f3n traum\u00e1tica del pie y del tobillo',
    code_1: 'S90-S99',
    code_0: 'S00-T88'
  },
  {
    code: 'S99',
    level: 2,
    description:
      'Otros traumatismos y los no especificados del pie y del tobillo',
    code_1: 'S90-S99',
    code_0: 'S00-T88'
  },
  {
    code: 'B15',
    level: 2,
    description: 'Hepatitis aguda tipo A',
    code_1: 'B15-B19',
    code_0: 'A00-B99'
  },
  {
    code: 'B16',
    level: 2,
    description: 'Hepatitis aguda tipo B',
    code_1: 'B15-B19',
    code_0: 'A00-B99'
  },
  {
    code: 'B17',
    level: 2,
    description: 'Otras hepatitis virales agudas',
    code_1: 'B15-B19',
    code_0: 'A00-B99'
  },
  {
    code: 'B18',
    level: 2,
    description: 'Hepatitis viral cr\u00f3nica',
    code_1: 'B15-B19',
    code_0: 'A00-B99'
  },
  {
    code: 'B19',
    level: 2,
    description: 'Hepatitis viral, sin otra especificaci\u00f3n',
    code_1: 'B15-B19',
    code_0: 'A00-B99'
  },
  {
    code: 'S84',
    level: 2,
    description: 'Traumatismo de nervios a nivel de la pierna',
    code_1: 'S80-S89',
    code_0: 'S00-T88'
  },
  {
    code: 'S85',
    level: 2,
    description: 'Traumatismo de vasos sangu\u00edneos a nivel de la pierna',
    code_1: 'S80-S89',
    code_0: 'S00-T88'
  },
  {
    code: 'S86',
    level: 2,
    description:
      'Traumatismo de tend\u00f3n y m\u00fasculo a nivel de la pierna',
    code_1: 'S80-S89',
    code_0: 'S00-T88'
  },
  {
    code: 'S87',
    level: 2,
    description: 'Traumatismo por aplastamiento de la pierna',
    code_1: 'S80-S89',
    code_0: 'S00-T88'
  },
  {
    code: 'S88',
    level: 2,
    description: 'Amputaci\u00f3n traum\u00e1tica de la pierna',
    code_1: 'S80-S89',
    code_0: 'S00-T88'
  },
  {
    code: 'S89',
    level: 2,
    description: 'Otros traumatismos y los no especificados de la pierna',
    code_1: 'S80-S89',
    code_0: 'S00-T88'
  },
  {
    code: 'S74',
    level: 2,
    description: 'Traumatismo de nervios a nivel de la cadera y del muslo',
    code_1: 'S70-S79',
    code_0: 'S00-T88'
  },
  {
    code: 'S75',
    level: 2,
    description:
      'Traumatismo de vasos sangu\u00edneos a nivel de la cadera y del muslo',
    code_1: 'S70-S79',
    code_0: 'S00-T88'
  },
  {
    code: 'S76',
    level: 2,
    description:
      'Traumatismo de tend\u00f3n y m\u00fasculo a nivel de la cadera y del muslo',
    code_1: 'S70-S79',
    code_0: 'S00-T88'
  },
  {
    code: 'S77',
    level: 2,
    description: 'Traumatismo por aplastamiento de la cadera y del muslo',
    code_1: 'S70-S79',
    code_0: 'S00-T88'
  },
  {
    code: 'S78',
    level: 2,
    description: 'Amputaci\u00f3n traum\u00e1tica de la cadera y del muslo',
    code_1: 'S70-S79',
    code_0: 'S00-T88'
  },
  {
    code: 'S79',
    level: 2,
    description:
      'Otros traumatismos y los no especificados de la cadera y del muslo',
    code_1: 'S70-S79',
    code_0: 'S00-T88'
  },
  {
    code: 'S63',
    level: 2,
    description:
      'Luxaci\u00f3n, esguince y torcedura de articulaciones y ligamentos a nivel de la mu\u00f1eca y de la mano',
    code_1: 'S60-S69',
    code_0: 'S00-T88'
  },
  {
    code: 'S64',
    level: 2,
    description:
      'Traumatismo de nervios a nivel de la mu\u00f1eca y de la mano',
    code_1: 'S60-S69',
    code_0: 'S00-T88'
  },
  {
    code: 'S65',
    level: 2,
    description:
      'Traumatismo de vasos sangu\u00edneos a nivel de la mu\u00f1eca y de la mano',
    code_1: 'S60-S69',
    code_0: 'S00-T88'
  },
  {
    code: 'S66',
    level: 2,
    description:
      'Traumatismo de tend\u00f3n y m\u00fasculo a nivel de la mu\u00f1eca y de la mano',
    code_1: 'S60-S69',
    code_0: 'S00-T88'
  },
  {
    code: 'S67',
    level: 2,
    description: 'Traumatismo por aplastamiento de la mu\u00f1eca y de la mano',
    code_1: 'S60-S69',
    code_0: 'S00-T88'
  },
  {
    code: 'S68',
    level: 2,
    description:
      'Amputaci\u00f3n traum\u00e1tica de la mu\u00f1eca y de la mano',
    code_1: 'S60-S69',
    code_0: 'S00-T88'
  },
  {
    code: 'B00',
    level: 2,
    description: 'Infecciones herp\u00e9ticas [herpes simple]',
    code_1: 'B00-B09',
    code_0: 'A00-B99'
  },
  {
    code: 'B01',
    level: 2,
    description: 'Varicela',
    code_1: 'B00-B09',
    code_0: 'A00-B99'
  },
  {
    code: 'B02',
    level: 2,
    description: 'Herpes zoster',
    code_1: 'B00-B09',
    code_0: 'A00-B99'
  },
  {
    code: 'B03',
    level: 2,
    description: 'Viruela1',
    code_1: 'B00-B09',
    code_0: 'A00-B99'
  },
  {
    code: 'B04',
    level: 2,
    description: 'Viruela de los monos',
    code_1: 'B00-B09',
    code_0: 'A00-B99'
  },
  {
    code: 'S55',
    level: 2,
    description:
      'Traumatismo de los vasos sangu\u00edneos a nivel del antebrazo',
    code_1: 'S50-S59',
    code_0: 'S00-T88'
  },
  {
    code: 'S56',
    level: 2,
    description:
      'Traumatismo de tend\u00f3n y m\u00fasculo a nivel del antebrazo',
    code_1: 'S50-S59',
    code_0: 'S00-T88'
  },
  {
    code: 'S57',
    level: 2,
    description: 'Traumatismo por aplastamiento del antebrazo',
    code_1: 'S50-S59',
    code_0: 'S00-T88'
  },
  {
    code: 'S58',
    level: 2,
    description: 'Amputaci\u00f3n traum\u00e1tica del antebrazo',
    code_1: 'S50-S59',
    code_0: 'S00-T88'
  },
  {
    code: 'S59',
    level: 2,
    description: 'Otros traumatismos y los no especificados del antebrazo',
    code_1: 'S50-S59',
    code_0: 'S00-T88'
  },
  {
    code: 'S45',
    level: 2,
    description:
      'Traumatismo de vasos sangu\u00edneos a nivel del hombro y del brazo',
    code_1: 'S40-S49',
    code_0: 'S00-T88'
  },
  {
    code: 'S46',
    level: 2,
    description:
      'Traumatismo de tend\u00f3n y m\u00fasculo a nivel del hombro y del brazo',
    code_1: 'S40-S49',
    code_0: 'S00-T88'
  },
  {
    code: 'S47',
    level: 2,
    description: 'Traumatismo por aplastamiento del hombro y del brazo',
    code_1: 'S40-S49',
    code_0: 'S00-T88'
  },
  {
    code: 'S48',
    level: 2,
    description: 'Amputaci\u00f3n traum\u00e1tica del hombro y del brazo',
    code_1: 'S40-S49',
    code_0: 'S00-T88'
  },
  {
    code: 'S49',
    level: 2,
    description:
      'Otros traumatismos y los no especificados del hombro y del brazo',
    code_1: 'S40-S49',
    code_0: 'S00-T88'
  },
  {
    code: 'F230',
    level: 3,
    description:
      'Trastorno psic\u00f3tico agudo polimorfo, sin s\u00edntomas de esquizofrenia',
    code_2: 'F23',
    code_0: 'F01-F99',
    code_1: 'F20-F29'
  },
  {
    code: 'F231',
    level: 3,
    description:
      'Trastorno psic\u00f3tico agudo polimorfo, con s\u00edntomas de esquizofrenia',
    code_2: 'F23',
    code_0: 'F01-F99',
    code_1: 'F20-F29'
  },
  {
    code: 'F232',
    level: 3,
    description: 'Trastorno psic\u00f3tico agudo de tipo esquizofr\u00e9nico',
    code_2: 'F23',
    code_0: 'F01-F99',
    code_1: 'F20-F29'
  },
  {
    code: 'F233',
    level: 3,
    description:
      'Otro trastorno psic\u00f3tico agudo, con predominio de ideas delirantes',
    code_2: 'F23',
    code_0: 'F01-F99',
    code_1: 'F20-F29'
  },
  {
    code: 'F238',
    level: 3,
    description: 'Otros trastornos psic\u00f3ticos agudos y transitorios',
    code_2: 'F23',
    code_0: 'F01-F99',
    code_1: 'F20-F29'
  },
  {
    code: 'F239',
    level: 3,
    description:
      'Trastorno psic\u00f3tico agudo y transitorio, no especificado',
    code_2: 'F23',
    code_0: 'F01-F99',
    code_1: 'F20-F29'
  },
  {
    code: 'I24',
    level: 2,
    description: 'Otras enfermedades isqu\u00e9micas agudas del coraz\u00f3n',
    code_1: 'I20-I25',
    code_0: 'I00-I99'
  },
  {
    code: 'I25',
    level: 2,
    description: 'Enfermedad isqu\u00e9mica cr\u00f3nica del coraz\u00f3n',
    code_1: 'I20-I25',
    code_0: 'I00-I99'
  },
  {
    code: 'I13',
    level: 2,
    description: 'Enfermedad cardiorrenal hipertensiva',
    code_1: 'I10-I15',
    code_0: 'I00-I99'
  },
  {
    code: 'I15',
    level: 2,
    description: 'Hipertensi\u00f3n secundaria',
    code_1: 'I10-I15',
    code_0: 'I00-I99'
  },
  {
    code: 'F220',
    level: 3,
    description: 'Trastorno delirante',
    code_2: 'F22',
    code_0: 'F01-F99',
    code_1: 'F20-F29'
  },
  {
    code: 'F228',
    level: 3,
    description: 'Otros trastornos delirantes persistentes',
    code_2: 'F22',
    code_0: 'F01-F99',
    code_1: 'F20-F29'
  },
  {
    code: 'F229',
    level: 3,
    description: 'Trastorno delirante persistente, no especificado',
    code_2: 'F22',
    code_0: 'F01-F99',
    code_1: 'F20-F29'
  },
  {
    code: 'J34',
    level: 2,
    description: 'Otros trastornos de la nariz y de los senos paranasales',
    code_1: 'J30\u2013J39 ',
    code_0: 'J00-J99'
  },
  {
    code: 'J35',
    level: 2,
    description:
      'Enfermedades cr\u00f3nicas de las am\u00edgdalas y de las adenoides',
    code_1: 'J30\u2013J39 ',
    code_0: 'J00-J99'
  },
  {
    code: 'J36',
    level: 2,
    description: 'Absceso periamigdalino',
    code_1: 'J30\u2013J39 ',
    code_0: 'J00-J99'
  },
  {
    code: 'J37',
    level: 2,
    description: 'Laringitis y laringotraque\u00edtis cr\u00f3nicas',
    code_1: 'J30\u2013J39 ',
    code_0: 'J00-J99'
  },
  {
    code: 'J38',
    level: 2,
    description:
      'Enfermedades de las cuerdas vocales y de la laringe, no clasificadas en otra parte',
    code_1: 'J30\u2013J39 ',
    code_0: 'J00-J99'
  },
  {
    code: 'J39',
    level: 2,
    description: 'Otras enfermedades de las v\u00edas respiratorias superiores',
    code_1: 'J30\u2013J39 ',
    code_0: 'J00-J99'
  },
  {
    code: 'J13',
    level: 2,
    description: 'Neumon\u00eda debida a Streptococcus pneumoniae',
    code_1: 'J09\u2013J18 ',
    code_0: 'J00-J99'
  },
  {
    code: 'J14',
    level: 2,
    description: 'Neumon\u00eda debida a Haemophilus influenzae',
    code_1: 'J09\u2013J18 ',
    code_0: 'J00-J99'
  },
  {
    code: 'J15',
    level: 2,
    description: 'Neumon\u00eda bacteriana, no clasificada en otra parte',
    code_1: 'J09\u2013J18 ',
    code_0: 'J00-J99'
  },
  {
    code: 'J16',
    level: 2,
    description:
      'Neumon\u00eda debida a otros microorganismos infecciosos, no clasificados en otra parte',
    code_1: 'J09\u2013J18 ',
    code_0: 'J00-J99'
  },
  {
    code: 'J17',
    level: 2,
    description: 'Neumon\u00eda en enfermedades clasificadas en otra parte',
    code_1: 'J09\u2013J18 ',
    code_0: 'J00-J99'
  },
  {
    code: 'J18',
    level: 2,
    description: 'Neumon\u00eda, organismo no especificado',
    code_1: 'J09\u2013J18 ',
    code_0: 'J00-J99'
  },
  {
    code: 'J06',
    level: 2,
    description:
      'Infecciones agudas de las v\u00edas respiratorias superiores, de sitios m\u00faltiples o no especificados',
    code_1: 'J00-J06',
    code_0: 'J00-J99'
  },
  {
    code: 'F200',
    level: 3,
    description: 'Esquizofrenia paranoide',
    code_2: 'F20',
    code_0: 'F01-F99',
    code_1: 'F20-F29'
  },
  {
    code: 'F201',
    level: 3,
    description: 'Esquizofrenia hebefr\u00e9nica',
    code_2: 'F20',
    code_0: 'F01-F99',
    code_1: 'F20-F29'
  },
  {
    code: 'F202',
    level: 3,
    description: 'Esquizofrenia catat\u00f3nica',
    code_2: 'F20',
    code_0: 'F01-F99',
    code_1: 'F20-F29'
  },
  {
    code: 'F203',
    level: 3,
    description: 'Esquizofrenia indiferenciada',
    code_2: 'F20',
    code_0: 'F01-F99',
    code_1: 'F20-F29'
  },
  {
    code: 'F204',
    level: 3,
    description: 'Depresi\u00f3n postesquizofr\u00e9nica',
    code_2: 'F20',
    code_0: 'F01-F99',
    code_1: 'F20-F29'
  },
  {
    code: 'F205',
    level: 3,
    description: 'Esquizofrenia residual',
    code_2: 'F20',
    code_0: 'F01-F99',
    code_1: 'F20-F29'
  },
  {
    code: 'F206',
    level: 3,
    description: 'Esquizofrenia simple',
    code_2: 'F20',
    code_0: 'F01-F99',
    code_1: 'F20-F29'
  },
  {
    code: 'F208',
    level: 3,
    description: 'Otras esquizofrenias',
    code_2: 'F20',
    code_0: 'F01-F99',
    code_1: 'F20-F29'
  },
  {
    code: 'F209',
    level: 3,
    description: 'Esquizofrenia, no especificada',
    code_2: 'F20',
    code_0: 'F01-F99',
    code_1: 'F20-F29'
  },
  {
    code: 'K62',
    level: 2,
    description: 'Otras enfermedades del ano y del recto',
    code_1: 'K55-K63',
    code_0: 'K00-K95'
  },
  {
    code: 'K63',
    level: 2,
    description: 'Otras enfermedades de los intestinos',
    code_1: 'K55-K63',
    code_0: 'K00-K95'
  },
  {
    code: 'K44',
    level: 2,
    description: 'Hernia diafragm\u00e1tica',
    code_1: 'K40-K46',
    code_0: 'K00-K95'
  },
  {
    code: 'K45',
    level: 2,
    description: 'Otras hernias de la cavidad abdominal',
    code_1: 'K40-K46',
    code_0: 'K00-K95'
  },
  {
    code: 'K46',
    level: 2,
    description: 'Hernia no especificada de la cavidad abdominal',
    code_1: 'K40-K46',
    code_0: 'K00-K95'
  },
  {
    code: 'F380',
    level: 3,
    description: 'Otros trastornos del humor [afectivos], aislados',
    code_2: 'F38',
    code_0: 'F01-F99',
    code_1: 'F30-F39'
  },
  {
    code: 'F381',
    level: 3,
    description: 'Otros trastornos del humor [afectivos], recurrentes',
    code_2: 'F38',
    code_0: 'F01-F99',
    code_1: 'F30-F39'
  },
  {
    code: 'F388',
    level: 3,
    description: 'Otros trastornos del humor [afectivos], especificados',
    code_2: 'F38',
    code_0: 'F01-F99',
    code_1: 'F30-F39'
  },
  {
    code: 'K23',
    level: 2,
    description:
      'Trastornos del es\u00f3fago en enfermedades clasificadas en otra parte',
    code_1: 'K20-K31',
    code_0: 'K00-K95'
  },
  {
    code: 'K25',
    level: 2,
    description: '\u00dalcera g\u00e1strica',
    code_1: 'K20-K31',
    code_0: 'K00-K95'
  },
  {
    code: 'K26',
    level: 2,
    description: '\u00dalcera duodenal',
    code_1: 'K20-K31',
    code_0: 'K00-K95'
  },
  {
    code: 'K27',
    level: 2,
    description: '\u00dalcera p\u00e9ptica, de sitio no especificado',
    code_1: 'K20-K31',
    code_0: 'K00-K95'
  },
  {
    code: 'K28',
    level: 2,
    description: '\u00dalcera gastroyeyunal',
    code_1: 'K20-K31',
    code_0: 'K00-K95'
  },
  {
    code: 'K29',
    level: 2,
    description: 'Gastritis y duodenitis',
    code_1: 'K20-K31',
    code_0: 'K00-K95'
  },
  {
    code: 'K30',
    level: 2,
    description: 'Dispepsia',
    code_1: 'K20-K31',
    code_0: 'K00-K95'
  },
  {
    code: 'K31',
    level: 2,
    description: 'Otras enfermedades del est\u00f3mago y del duodeno',
    code_1: 'K20-K31',
    code_0: 'K00-K95'
  },
  {
    code: 'F340',
    level: 3,
    description: 'Ciclotimia',
    code_2: 'F34',
    code_0: 'F01-F99',
    code_1: 'F30-F39'
  },
  {
    code: 'F341',
    level: 3,
    description: 'Distimia',
    code_2: 'F34',
    code_0: 'F01-F99',
    code_1: 'F30-F39'
  },
  {
    code: 'F348',
    level: 3,
    description: 'Otros trastornos del humor [afectivos] persistentes',
    code_2: 'F34',
    code_0: 'F01-F99',
    code_1: 'F30-F39'
  },
  {
    code: 'F349',
    level: 3,
    description: 'Trastorno persistente del humor [afectivo], no especificado',
    code_2: 'F34',
    code_0: 'F01-F99',
    code_1: 'F30-F39'
  },
  {
    code: 'K06',
    level: 2,
    description: 'Otros trastornos de la enc\u00eda y de la zona ed\u00e9ntula',
    code_1: 'K00-K14',
    code_0: 'K00-K95'
  },
  {
    code: 'K07',
    level: 2,
    description: 'Anomal\u00edas dentofaciales [incluso la maloclusi\u00f3n]',
    code_1: 'K00-K14',
    code_0: 'K00-K95'
  },
  {
    code: 'K08',
    level: 2,
    description:
      'Otros trastornos de los dientes y de sus estructuras de sost\u00e9n',
    code_1: 'K00-K14',
    code_0: 'K00-K95'
  },
  {
    code: 'K09',
    level: 2,
    description:
      'Quistes de la regi\u00f3n bucal, no clasificados en otra parte',
    code_1: 'K00-K14',
    code_0: 'K00-K95'
  },
  {
    code: 'K10',
    level: 2,
    description: 'Otras enfermedades de los maxilares',
    code_1: 'K00-K14',
    code_0: 'K00-K95'
  },
  {
    code: 'K11',
    level: 2,
    description: 'Enfermedades de las gl\u00e1ndulas salivales',
    code_1: 'K00-K14',
    code_0: 'K00-K95'
  },
  {
    code: 'K12',
    level: 2,
    description: 'Estomatitis y lesiones afines',
    code_1: 'K00-K14',
    code_0: 'K00-K95'
  },
  {
    code: 'K13',
    level: 2,
    description: 'Otras enfermedades de los labios y de la mucosa bucal',
    code_1: 'K00-K14',
    code_0: 'K00-K95'
  },
  {
    code: 'K14',
    level: 2,
    description: 'Enfermedades de la lengua',
    code_1: 'K00-K14',
    code_0: 'K00-K95'
  },
  {
    code: 'L45',
    level: 2,
    description:
      'Trastornos papuloescamosos en enfermedades clasificadas en otra parte',
    code_1: 'L40-L45',
    code_0: 'L00-L99'
  },
  {
    code: 'L27',
    level: 2,
    description: 'Dermatitis debida a sustancias ingeridas',
    code_1: 'L20-L30',
    code_0: 'L00-L99'
  },
  {
    code: 'L28',
    level: 2,
    description: 'Liquen simple cr\u00f3nico y prurigo',
    code_1: 'L20-L30',
    code_0: 'L00-L99'
  },
  {
    code: 'L29',
    level: 2,
    description: 'Prurito',
    code_1: 'L20-L30',
    code_0: 'L00-L99'
  },
  {
    code: 'L30',
    level: 2,
    description: 'Otras dermatitis',
    code_1: 'L20-L30',
    code_0: 'L00-L99'
  },
  {
    code: 'F330',
    level: 3,
    description: 'Trastorno depresivo recurrente, episodio leve presente',
    code_2: 'F33',
    code_0: 'F01-F99',
    code_1: 'F30-F39'
  },
  {
    code: 'F331',
    level: 3,
    description: 'Trastorno depresivo recurrente, episodio moderado presente',
    code_2: 'F33',
    code_0: 'F01-F99',
    code_1: 'F30-F39'
  },
  {
    code: 'F332',
    level: 3,
    description:
      'Trastorno depresivo recurrente, episodio depresivo grave presente sin s\u00edntomas psic\u00f3ticos',
    code_2: 'F33',
    code_0: 'F01-F99',
    code_1: 'F30-F39'
  },
  {
    code: 'F333',
    level: 3,
    description:
      'Trastorno depresivo recurrente, episodio depresivo grave presente, con s\u00edntomas psic\u00f3ticos',
    code_2: 'F33',
    code_0: 'F01-F99',
    code_1: 'F30-F39'
  },
  {
    code: 'F334',
    level: 3,
    description: 'Trastorno depresivo recurrente actualmente en remisi\u00f3n',
    code_2: 'F33',
    code_0: 'F01-F99',
    code_1: 'F30-F39'
  },
  {
    code: 'F338',
    level: 3,
    description: 'Otros trastornos depresivos recurrentes',
    code_2: 'F33',
    code_0: 'F01-F99',
    code_1: 'F30-F39'
  },
  {
    code: 'F339',
    level: 3,
    description: 'Trastorno depresivo recurrente, no especificado',
    code_2: 'F33',
    code_0: 'F01-F99',
    code_1: 'F30-F39'
  },
  {
    code: 'L13',
    level: 2,
    description: 'Otros trastornos flictenulares',
    code_1: 'L10-L14',
    code_0: 'L00-L99'
  },
  {
    code: 'L14',
    level: 2,
    description:
      'Trastornos flictenulares en enfermedades clasificadas en otra parte',
    code_1: 'L10-L14',
    code_0: 'L00-L99'
  },
  {
    code: 'L05',
    level: 2,
    description: 'Quiste pilonidal',
    code_1: 'L00-L08',
    code_0: 'L00-L99'
  },
  {
    code: 'L08',
    level: 2,
    description:
      'Otras infecciones locales de la piel y del tejido subcut\u00e1neo',
    code_1: 'L00-L08',
    code_0: 'L00-L99'
  },
  {
    code: 'F320',
    level: 3,
    description: 'Episodio depresivo leve',
    code_2: 'F32',
    code_0: 'F01-F99',
    code_1: 'F30-F39'
  },
  {
    code: 'F321',
    level: 3,
    description: 'Episodio depresivo moderado',
    code_2: 'F32',
    code_0: 'F01-F99',
    code_1: 'F30-F39'
  },
  {
    code: 'F322',
    level: 3,
    description: 'Episodio depresivo grave sin s\u00edntomas psic\u00f3ticos',
    code_2: 'F32',
    code_0: 'F01-F99',
    code_1: 'F30-F39'
  },
  {
    code: 'F323',
    level: 3,
    description: 'Episodio depresivo grave con s\u00edntomas psic\u00f3ticos',
    code_2: 'F32',
    code_0: 'F01-F99',
    code_1: 'F30-F39'
  },
  {
    code: 'F328',
    level: 3,
    description: 'Otros episodios depresivos',
    code_2: 'F32',
    code_0: 'F01-F99',
    code_1: 'F30-F39'
  },
  {
    code: 'F329',
    level: 3,
    description: 'Episodio depresivo, no especificado',
    code_2: 'F32',
    code_0: 'F01-F99',
    code_1: 'F30-F39'
  },
  {
    code: 'F310',
    level: 3,
    description:
      'Trastorno afectivo bipolar, episodio hipoman\u00edaco presente',
    code_2: 'F31',
    code_0: 'F01-F99',
    code_1: 'F30-F39'
  },
  {
    code: 'F311',
    level: 3,
    description:
      'Trastorno afectivo bipolar, episodio man\u00edaco presente sin s\u00edntomas psic\u00f3ticos',
    code_2: 'F31',
    code_0: 'F01-F99',
    code_1: 'F30-F39'
  },
  {
    code: 'F312',
    level: 3,
    description:
      'Trastorno afectivo bipolar, episodio man\u00edaco presente con s\u00edntomas psic\u00f3ticos',
    code_2: 'F31',
    code_0: 'F01-F99',
    code_1: 'F30-F39'
  },
  {
    code: 'F313',
    level: 3,
    description:
      'Trastorno afectivo bipolar, episodio depresivo presente leve o moderado',
    code_2: 'F31',
    code_0: 'F01-F99',
    code_1: 'F30-F39'
  },
  {
    code: 'F314',
    level: 3,
    description:
      'Trastorno afectivo bipolar, episodio depresivo grave presente sin s\u00edntomas psic\u00f3ticos',
    code_2: 'F31',
    code_0: 'F01-F99',
    code_1: 'F30-F39'
  },
  {
    code: 'F315',
    level: 3,
    description:
      'Trastorno afectivo bipolar, episodio depresivo grave presente con s\u00edntomas psic\u00f3ticos',
    code_2: 'F31',
    code_0: 'F01-F99',
    code_1: 'F30-F39'
  },
  {
    code: 'F316',
    level: 3,
    description: 'Trastorno afectivo bipolar, episodio mixto presente',
    code_2: 'F31',
    code_0: 'F01-F99',
    code_1: 'F30-F39'
  },
  {
    code: 'F317',
    level: 3,
    description: 'Trastorno afectivo bipolar, actualmente en remisi\u00f3n',
    code_2: 'F31',
    code_0: 'F01-F99',
    code_1: 'F30-F39'
  },
  {
    code: 'F300',
    level: 3,
    description: 'Hipoman\u00eda',
    code_2: 'F30',
    code_0: 'F01-F99',
    code_1: 'F30-F39'
  },
  {
    code: 'F301',
    level: 3,
    description: 'Man\u00eda sin s\u00edntomas psic\u00f3ticos',
    code_2: 'F30',
    code_0: 'F01-F99',
    code_1: 'F30-F39'
  },
  {
    code: 'F302',
    level: 3,
    description: 'Man\u00eda con s\u00edntomas psic\u00f3ticos',
    code_2: 'F30',
    code_0: 'F01-F99',
    code_1: 'F30-F39'
  },
  {
    code: 'F308',
    level: 3,
    description: 'Otros episodios man\u00edacos',
    code_2: 'F30',
    code_0: 'F01-F99',
    code_1: 'F30-F39'
  },
  {
    code: 'F309',
    level: 3,
    description: 'Episodio man\u00edaco, no especificado',
    code_2: 'F30',
    code_0: 'F01-F99',
    code_1: 'F30-F39'
  },
  {
    code: 'N990',
    level: 2,
    description: 'Insuficiencia renal consecutiva a procedimientos',
    code_1: 'N99',
    code_0: 'N00-N99'
  },
  {
    code: 'N991',
    level: 2,
    description: 'Estrechez uretral consecutiva a procedimientos',
    code_1: 'N99',
    code_0: 'N00-N99'
  },
  {
    code: 'N992',
    level: 2,
    description: 'Adherencias postoperatorias de la vagina',
    code_1: 'N99',
    code_0: 'N00-N99'
  },
  {
    code: 'N993',
    level: 2,
    description:
      'Prolapso de la c\u00fapula vaginal despu\u00e9s de histerectom\u00eda',
    code_1: 'N99',
    code_0: 'N00-N99'
  },
  {
    code: 'N994',
    level: 2,
    description:
      'Adherencias peritoneales p\u00e9lvicas consecutivas a procedimientos',
    code_1: 'N99',
    code_0: 'N00-N99'
  },
  {
    code: 'N995',
    level: 2,
    description: 'Mal funcionamiento de estoma externo de v\u00edas urinarias',
    code_1: 'N99',
    code_0: 'N00-N99'
  },
  {
    code: 'N80',
    level: 2,
    description: 'Endometriosis',
    code_1: 'N80-N98',
    code_0: 'N00-N99'
  },
  {
    code: 'N81',
    level: 2,
    description: 'Prolapso genital femenino',
    code_1: 'N80-N98',
    code_0: 'N00-N99'
  },
  {
    code: 'N82',
    level: 2,
    description: 'F\u00edstulas que afectan el tracto genital femenino',
    code_1: 'N80-N98',
    code_0: 'N00-N99'
  },
  {
    code: 'N83',
    level: 2,
    description:
      'Trastornos no inflamatorios del ovario, de la trompa de Falopio y del ligamento ancho',
    code_1: 'N80-N98',
    code_0: 'N00-N99'
  },
  {
    code: 'N84',
    level: 2,
    description: 'P\u00f3lipo del tracto genital femenino',
    code_1: 'N80-N98',
    code_0: 'N00-N99'
  },
  {
    code: 'N70',
    level: 2,
    description: 'Salpingitis y ooforitis',
    code_1: 'N70-N77',
    code_0: 'N00-N99'
  },
  {
    code: 'N71',
    level: 2,
    description:
      'Enfermedad inflamatoria del \u00fatero, excepto del cuello uterino',
    code_1: 'N70-N77',
    code_0: 'N00-N99'
  },
  {
    code: 'N72',
    level: 2,
    description: 'Enfermedad inflamatoria del cuello uterino',
    code_1: 'N70-N77',
    code_0: 'N00-N99'
  },
  {
    code: 'N73',
    level: 2,
    description: 'Otras enfermedades p\u00e9lvicas inflamatorias femeninas',
    code_1: 'N70-N77',
    code_0: 'N00-N99'
  },
  {
    code: 'N74',
    level: 2,
    description:
      'Trastornos inflamatorios de la pelvis femenina en enfermedades clasificadas en otra parte',
    code_1: 'N70-N77',
    code_0: 'N00-N99'
  },
  {
    code: 'N75',
    level: 2,
    description: 'Enfermedades de la gl\u00e1ndula de Bartholin',
    code_1: 'N70-N77',
    code_0: 'N00-N99'
  },
  {
    code: 'N60',
    level: 2,
    description: 'Displasia mamaria benigna',
    code_1: 'N60-N64',
    code_0: 'N00-N99'
  },
  {
    code: 'N61',
    level: 2,
    description: 'Trastornos inflamatorios de la mama',
    code_1: 'N60-N64',
    code_0: 'N00-N99'
  },
  {
    code: 'N62',
    level: 2,
    description: 'Hipertrofia de la mama',
    code_1: 'N60-N64',
    code_0: 'N00-N99'
  },
  {
    code: 'N63',
    level: 2,
    description: 'Masa no especificada en la mama',
    code_1: 'N60-N64',
    code_0: 'N00-N99'
  },
  {
    code: 'N64',
    level: 2,
    description: 'Otros trastornos de la mama',
    code_1: 'N60-N64',
    code_0: 'N00-N99'
  },
  {
    code: 'N40',
    level: 2,
    description: 'Hiperplasia de la pr\u00f3stata',
    code_1: 'N40-N51',
    code_0: 'N00-N99'
  },
  {
    code: 'N41',
    level: 2,
    description: 'Enfermedades inflamatorias de la pr\u00f3stata',
    code_1: 'N40-N51',
    code_0: 'N00-N99'
  },
  {
    code: 'N42',
    level: 2,
    description: 'Otros trastornos de la pr\u00f3stata',
    code_1: 'N40-N51',
    code_0: 'N00-N99'
  },
  {
    code: 'N43',
    level: 2,
    description: 'Hidrocele y espermatocele',
    code_1: 'N40-N51',
    code_0: 'N00-N99'
  },
  {
    code: 'N44',
    level: 2,
    description: 'Torsi\u00f3n del test\u00edculo',
    code_1: 'N40-N51',
    code_0: 'N00-N99'
  },
  {
    code: 'N45',
    level: 2,
    description: 'Orquitis y epididimitis',
    code_1: 'N40-N51',
    code_0: 'N00-N99'
  },
  {
    code: 'N30',
    level: 2,
    description: 'Cistitis',
    code_1: 'N30-N39',
    code_0: 'N00-N99'
  },
  {
    code: 'N31',
    level: 2,
    description:
      'Disfunci\u00f3n neuromuscular de la vejiga, no clasificada en otra parte',
    code_1: 'N30-N39',
    code_0: 'N00-N99'
  },
  {
    code: 'N32',
    level: 2,
    description: 'Otros trastornos de la vejiga',
    code_1: 'N30-N39',
    code_0: 'N00-N99'
  },
  {
    code: 'N33',
    level: 2,
    description:
      'Trastornos de la vejiga en enfermedades clasificadas en otra parte',
    code_1: 'N30-N39',
    code_0: 'N00-N99'
  },
  {
    code: 'N34',
    level: 2,
    description: 'Uretritis y s\u00edndrome uretral',
    code_1: 'N30-N39',
    code_0: 'N00-N99'
  },
  {
    code: 'N25',
    level: 2,
    description:
      'Trastornos resultantes de la funci\u00f3n tubular renal alterada',
    code_1: 'N25-N29',
    code_0: 'N00-N99'
  },
  {
    code: 'N26',
    level: 2,
    description: 'Ri\u00f1\u00f3n contra\u00eddo, no especificado',
    code_1: 'N25-N29',
    code_0: 'N00-N99'
  },
  {
    code: 'N27',
    level: 2,
    description: 'Ri\u00f1\u00f3n peque\u00f1o de causa desconocida',
    code_1: 'N25-N29',
    code_0: 'N00-N99'
  },
  {
    code: 'N28',
    level: 2,
    description:
      'Otros trastornos del ri\u00f1\u00f3n y del ur\u00e9ter, no clasificados en otra parte',
    code_1: 'N25-N29',
    code_0: 'N00-N99'
  },
  {
    code: 'N29',
    level: 2,
    description:
      'Otros trastornos del ri\u00f1\u00f3n y del ur\u00e9ter en enfermedades clasificadas en otra parte',
    code_1: 'N25-N29',
    code_0: 'N00-N99'
  },
  {
    code: 'F480',
    level: 3,
    description: 'Neurastenia',
    code_2: 'F48',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F481',
    level: 3,
    description:
      'S\u00edndrome de despersonalizaci\u00f3n y desvinculaci\u00f3n de la realidad',
    code_2: 'F48',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F488',
    level: 3,
    description: 'Otros trastornos neur\u00f3ticos especificados',
    code_2: 'F48',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F489',
    level: 3,
    description: 'Trastorno neur\u00f3tico, no especificado',
    code_2: 'F48',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F450',
    level: 3,
    description: 'Trastorno de somatizaci\u00f3n',
    code_2: 'F45',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F451',
    level: 3,
    description: 'Trastorno somatomorfo indiferenciado',
    code_2: 'F45',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F452',
    level: 3,
    description: 'Trastorno hipocondr\u00edaco',
    code_2: 'F45',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F453',
    level: 3,
    description: 'Disfunci\u00f3n auton\u00f3mica somatomorfa',
    code_2: 'F45',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F454',
    level: 3,
    description: 'Trastorno de dolor persistente somatomorfo',
    code_2: 'F45',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F458',
    level: 3,
    description: 'Otros trastornos somatomorfos',
    code_2: 'F45',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F459',
    level: 3,
    description: 'Trastorno somatomorfo, no especificado',
    code_2: 'F45',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F440',
    level: 3,
    description: 'Amnesia disociativa',
    code_2: 'F44',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F441',
    level: 3,
    description: 'Fuga disociativa',
    code_2: 'F44',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F442',
    level: 3,
    description: 'Estupor disociativo',
    code_2: 'F44',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F443',
    level: 3,
    description: 'Trastornos de trance y de posesi\u00f3n',
    code_2: 'F44',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F444',
    level: 3,
    description: 'Trastornos disociativos del movimiento',
    code_2: 'F44',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F445',
    level: 3,
    description: 'Convulsiones disociativas',
    code_2: 'F44',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F446',
    level: 3,
    description: 'Anestesia disociativa y p\u00e9rdida sensorial',
    code_2: 'F44',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F447',
    level: 3,
    description: 'Trastornos disociativos mixtos [y de conversi\u00f3n]',
    code_2: 'F44',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F448',
    level: 3,
    description: 'Otros trastornos disociativos [de conversi\u00f3n]',
    code_2: 'F44',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F449',
    level: 3,
    description: 'Trastorno disociativo [de conversi\u00f3n], no especificado',
    code_2: 'F44',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F430',
    level: 3,
    description: 'Reacci\u00f3n al estr\u00e9s agudo',
    code_2: 'F43',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F431',
    level: 3,
    description: 'Trastorno de estr\u00e9s postraum\u00e1tico',
    code_2: 'F43',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F432',
    level: 3,
    description: 'Trastornos de adaptaci\u00f3n',
    code_2: 'F43',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F438',
    level: 3,
    description: 'Otras reacciones al estr\u00e9s grave',
    code_2: 'F43',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F439',
    level: 3,
    description: 'Reacci\u00f3n al estr\u00e9s grave, no especificada',
    code_2: 'F43',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F420',
    level: 3,
    description: 'Predominio de pensamientos o rumiaciones obsesivas',
    code_2: 'F42',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F421',
    level: 3,
    description: 'Predominio de actos compulsivos [rituales obsesivos]',
    code_2: 'F42',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F422',
    level: 3,
    description: 'Actos e ideas obsesivas mixtos',
    code_2: 'F42',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F428',
    level: 3,
    description: 'Otros trastornos obsesivo-compulsivos',
    code_2: 'F42',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F429',
    level: 3,
    description: 'Trastorno obsesivo-compulsivo, no especificado',
    code_2: 'F42',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F410',
    level: 3,
    description:
      'Trastorno de p\u00e1nico [ansiedad parox\u00edstica epis\u00f3dica]',
    code_2: 'F41',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F411',
    level: 3,
    description: 'Trastorno de ansiedad generalizada',
    code_2: 'F41',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F412',
    level: 3,
    description: 'Trastorno mixto de ansiedad y depresi\u00f3n',
    code_2: 'F41',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F413',
    level: 3,
    description: 'Otros trastornos de ansiedad mixtos',
    code_2: 'F41',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F418',
    level: 3,
    description: 'Otros trastornos de ansiedad especificados',
    code_2: 'F41',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F419',
    level: 3,
    description: 'Trastorno de ansiedad, no especificado',
    code_2: 'F41',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'A94',
    level: 2,
    description:
      'Fiebre viral transmitida por artr\u00f3podos, no \u00adespecificada',
    code_1: 'A90-A99',
    code_0: 'A00-B99'
  },
  {
    code: 'A95',
    level: 2,
    description: 'Fiebre amarilla',
    code_1: 'A90-A99',
    code_0: 'A00-B99'
  },
  {
    code: 'A96',
    level: 2,
    description: 'Fiebre hemorr\u00e1gica por arenavirus',
    code_1: 'A90-A99',
    code_0: 'A00-B99'
  },
  {
    code: 'A98',
    level: 2,
    description:
      'Otras fiebres virales hemorr\u00e1gicas, no clasificadas en otra parte',
    code_1: 'A90-A99',
    code_0: 'A00-B99'
  },
  {
    code: 'A99',
    level: 2,
    description: 'Fiebre viral hemorr\u00e1gica, no especificada',
    code_1: 'A90-A99',
    code_0: 'A00-B99'
  },
  {
    code: 'A86',
    level: 2,
    description: 'Encefalitis viral, no especificada',
    code_1: 'A80-A89',
    code_0: 'A00-B99'
  },
  {
    code: 'A87',
    level: 2,
    description: 'Meningitis viral',
    code_1: 'A80-A89',
    code_0: 'A00-B99'
  },
  {
    code: 'A88',
    level: 2,
    description:
      'Otras infecciones virales del sistema nervioso central, no clasificadas en otra parte',
    code_1: 'A80-A89',
    code_0: 'A00-B99'
  },
  {
    code: 'A89',
    level: 2,
    description:
      'Infecci\u00f3n viral del sistema nervioso central, no especificada',
    code_1: 'A80-A89',
    code_0: 'A00-B99'
  },
  {
    code: 'A54',
    level: 2,
    description: 'Infecci\u00f3n gonoc\u00f3cica',
    code_1: 'A50-A64',
    code_0: 'A00-B99'
  },
  {
    code: 'A55',
    level: 2,
    description: 'Linfogranuloma (ven\u00e9reo) por clamidias',
    code_1: 'A50-A64',
    code_0: 'A00-B99'
  },
  {
    code: 'A56',
    level: 2,
    description:
      'Otras enfermedades de transmisi\u00f3n sexual debidas a clamidias',
    code_1: 'A50-A64',
    code_0: 'A00-B99'
  },
  {
    code: 'A57',
    level: 2,
    description: 'Chancro blando',
    code_1: 'A50-A64',
    code_0: 'A00-B99'
  },
  {
    code: 'A58',
    level: 2,
    description: 'Granuloma inguinal',
    code_1: 'A50-A64',
    code_0: 'A00-B99'
  },
  {
    code: 'A59',
    level: 2,
    description: 'Tricomoniasis',
    code_1: 'A50-A64',
    code_0: 'A00-B99'
  },
  {
    code: 'A60',
    level: 2,
    description:
      'Infecci\u00f3n anogenital debida a virus del herpes [herpes simple]',
    code_1: 'A50-A64',
    code_0: 'A00-B99'
  },
  {
    code: 'A63',
    level: 2,
    description:
      'Otras enfermedades de transmisi\u00f3n predominantemente sexual, no clasificadas en otra parte',
    code_1: 'A50-A64',
    code_0: 'A00-B99'
  },
  {
    code: 'A64',
    level: 2,
    description: 'Enfermedad de transmisi\u00f3n sexual no \u00adespecificada',
    code_1: 'A50-A64',
    code_0: 'A00-B99'
  },
  {
    code: 'A36',
    level: 2,
    description: 'Difteria',
    code_1: 'A30-A49',
    code_0: 'A00-B99'
  },
  {
    code: 'A37',
    level: 2,
    description: 'Tos ferina [tos convulsiva]',
    code_1: 'A30-A49',
    code_0: 'A00-B99'
  },
  {
    code: 'A38',
    level: 2,
    description: 'Escarlatina',
    code_1: 'A30-A49',
    code_0: 'A00-B99'
  },
  {
    code: 'A39',
    level: 2,
    description: 'Enfermedad meningoc\u00f3cica',
    code_1: 'A30-A49',
    code_0: 'A00-B99'
  },
  {
    code: 'A40',
    level: 2,
    description: 'Septicemia estreptoc\u00f3cica',
    code_1: 'A30-A49',
    code_0: 'A00-B99'
  },
  {
    code: 'A41',
    level: 2,
    description: 'Otras septicemias',
    code_1: 'A30-A49',
    code_0: 'A00-B99'
  },
  {
    code: 'A42',
    level: 2,
    description: 'Actinomicosis',
    code_1: 'A30-A49',
    code_0: 'A00-B99'
  },
  {
    code: 'A43',
    level: 2,
    description: 'Nocardiosis',
    code_1: 'A30-A49',
    code_0: 'A00-B99'
  },
  {
    code: 'A44',
    level: 2,
    description: 'Bartonelosis',
    code_1: 'A30-A49',
    code_0: 'A00-B99'
  },
  {
    code: 'A25',
    level: 2,
    description: 'Fiebres por mordedura de rata',
    code_1: 'A20-A28',
    code_0: 'A00-B99'
  },
  {
    code: 'A26',
    level: 2,
    description: 'Erisipeloide',
    code_1: 'A20-A28',
    code_0: 'A00-B99'
  },
  {
    code: 'A27',
    level: 2,
    description: 'Leptospirosis',
    code_1: 'A20-A28',
    code_0: 'A00-B99'
  },
  {
    code: 'A28',
    level: 2,
    description:
      'Otras enfermedades zoon\u00f3ticas bacterianas, no clasificadas en otra parte',
    code_1: 'A20-A28',
    code_0: 'A00-B99'
  },
  {
    code: 'N15',
    level: 2,
    description: 'Otras enfermedades renales tubulointersticiales',
    code_1: 'N10-N16',
    code_0: 'N00-N99'
  },
  {
    code: 'N16',
    level: 2,
    description:
      'Trastornos renales tubulointersticiales en enfermedades clasificadas en otra parte',
    code_1: 'N10-N16',
    code_0: 'N00-N99'
  },
  {
    code: 'N07',
    level: 2,
    description: 'Nefropat\u00eda hereditaria, no clasificada en otra parte',
    code_1: 'N00-N08',
    code_0: 'N00-N99'
  },
  {
    code: 'N08',
    level: 2,
    description:
      'Trastornos glomerulares en enfermedades clasificadas en otra parte',
    code_1: 'N00-N08',
    code_0: 'N00-N99'
  },
  {
    code: 'O35',
    level: 2,
    description:
      'Atenci\u00f3n materna por anormalidad o lesi\u00f3n fetal, conocida o presunta',
    code_1: 'O30\u2013O48',
    code_0: 'O00-O9A'
  },
  {
    code: 'O36',
    level: 2,
    description:
      'Atenci\u00f3n materna por otros problemas fetales conocidos o presuntos',
    code_1: 'O30\u2013O48',
    code_0: 'O00-O9A'
  },
  {
    code: 'O40',
    level: 2,
    description: 'Polihidramnios',
    code_1: 'O30\u2013O48',
    code_0: 'O00-O9A'
  },
  {
    code: 'O41',
    level: 2,
    description:
      'Otros trastornos del l\u00edquido amni\u00f3tico y de las membranas',
    code_1: 'O30\u2013O48',
    code_0: 'O00-O9A'
  },
  {
    code: 'O42',
    level: 2,
    description: 'Ruptura prematura de las membranas',
    code_1: 'O30\u2013O48',
    code_0: 'O00-O9A'
  },
  {
    code: 'O43',
    level: 2,
    description: 'Trastornos placentarios',
    code_1: 'O30\u2013O48',
    code_0: 'O00-O9A'
  },
  {
    code: 'O44',
    level: 2,
    description: 'Placenta previa',
    code_1: 'O30\u2013O48',
    code_0: 'O00-O9A'
  },
  {
    code: 'O45',
    level: 2,
    description:
      'Desprendimiento prematuro de la placenta [abruptio placentae]',
    code_1: 'O30\u2013O48',
    code_0: 'O00-O9A'
  },
  {
    code: 'O46',
    level: 2,
    description: 'Hemorragia anteparto, no clasificada en otra parte',
    code_1: 'O30\u2013O48',
    code_0: 'O00-O9A'
  },
  {
    code: 'O28',
    level: 2,
    description: 'Hallazgos anormales en el examen prenatal de la madre',
    code_1: 'O20-O29',
    code_0: 'O00-O9A'
  },
  {
    code: 'O29',
    level: 2,
    description:
      'Complicaciones de la anestesia administrada durante el embarazo',
    code_1: 'O20-O29',
    code_0: 'O00-O9A'
  },
  {
    code: 'O15',
    level: 2,
    description: 'Eclampsia',
    code_1: 'O10-O16',
    code_0: 'O00-O9A'
  },
  {
    code: 'O16',
    level: 2,
    description: 'Hipertensi\u00f3n materna, no especificada',
    code_1: 'O10-O16',
    code_0: 'O00-O9A'
  },
  {
    code: 'O08',
    level: 2,
    description:
      'Complicaciones consecutivas al aborto, al embarazo ect\u00f3pico y al embarazomolar',
    code_1: 'O00-O08',
    code_0: 'O00-O9A'
  },
  {
    code: 'P54',
    level: 2,
    description: 'Otras hemorragias neonatales',
    code_1: 'P50-P61',
    code_0: 'P00-P96'
  },
  {
    code: 'P55',
    level: 2,
    description: 'Enfermedad hemol\u00edtica del feto y del reci\u00e9n nacido',
    code_1: 'P50-P61',
    code_0: 'P00-P96'
  },
  {
    code: 'P56',
    level: 2,
    description: 'Hidropes\u00eda fetal debida a enfermedad hemol\u00edtica',
    code_1: 'P50-P61',
    code_0: 'P00-P96'
  },
  {
    code: 'P57',
    level: 2,
    description: 'Kernicterus',
    code_1: 'P50-P61',
    code_0: 'P00-P96'
  },
  {
    code: 'P58',
    level: 2,
    description: 'Ictericia neonatal debida a otras hem\u00f3lisis excesivas',
    code_1: 'P50-P61',
    code_0: 'P00-P96'
  },
  {
    code: 'P59',
    level: 2,
    description:
      'Ictericia neonatal por otras causas y por las no especificadas',
    code_1: 'P50-P61',
    code_0: 'P00-P96'
  },
  {
    code: 'P60',
    level: 2,
    description:
      'Coagulaci\u00f3n intravascular diseminada en el feto y el reci\u00e9n nacido',
    code_1: 'P50-P61',
    code_0: 'P00-P96'
  },
  {
    code: 'P61',
    level: 2,
    description: 'Otros trastornos hematol\u00f3gicos perinatales',
    code_1: 'P50-P61',
    code_0: 'P00-P96'
  },
  {
    code: 'P24',
    level: 2,
    description: 'S\u00edndromes de aspiraci\u00f3n neonatal',
    code_1: 'P20-P29',
    code_0: 'P00-P96'
  },
  {
    code: 'P25',
    level: 2,
    description:
      'Enfisema intersticial y afecciones relacionadas, originadas en el per\u00edodo perinatal',
    code_1: 'P20-P29',
    code_0: 'P00-P96'
  },
  {
    code: 'P26',
    level: 2,
    description: 'Hemorragia pulmonar originada en el per\u00edodo perinatal',
    code_1: 'P20-P29',
    code_0: 'P00-P96'
  },
  {
    code: 'P27',
    level: 2,
    description:
      'Enfermedad respiratoria cr\u00f3nica originada en el per\u00edodo perinatal',
    code_1: 'P20-P29',
    code_0: 'P00-P96'
  },
  {
    code: 'P28',
    level: 2,
    description:
      'Otros problemas respiratorios del reci\u00e9n nacido, originados en el per\u00edodo perinatal',
    code_1: 'P20-P29',
    code_0: 'P00-P96'
  },
  {
    code: 'P29',
    level: 2,
    description:
      'Trastornos cardiovasculares originados en el per\u00edodo perinatal',
    code_1: 'P20-P29',
    code_0: 'P00-P96'
  },
  {
    code: 'P07',
    level: 2,
    description:
      'Trastornos relacionados con duraci\u00f3n corta de la gestaci\u00f3n y con bajo peso al nacer, no clasificados en otra parte',
    code_1: 'P05-P08',
    code_0: 'P00-P96'
  },
  {
    code: 'P08',
    level: 2,
    description:
      'Trastornos relacionados con el embarazo prolongado y con sobrepeso al nacer',
    code_1: 'P05-P08',
    code_0: 'P00-P96'
  },
  {
    code: 'E73',
    level: 2,
    description: 'Intolerancia a la lactosa',
    code_1: 'E70-E90',
    code_0: 'E00-E89'
  },
  {
    code: 'E74',
    level: 2,
    description: 'Otros trastornos del metabolismo de los carbohidratos',
    code_1: 'E70-E90',
    code_0: 'E00-E89'
  },
  {
    code: 'E75',
    level: 2,
    description:
      'Trastornos del metabolismo de los esfingol\u00edpidos y otros trastornos por almacenamiento de l\u00edpidos',
    code_1: 'E70-E90',
    code_0: 'E00-E89'
  },
  {
    code: 'E76',
    level: 2,
    description: 'Trastornos del metabolismo de los glucosaminoglicanos',
    code_1: 'E70-E90',
    code_0: 'E00-E89'
  },
  {
    code: 'E77',
    level: 2,
    description: 'Trastornos del metabolismo de las glucoprote\u00ednas',
    code_1: 'E70-E90',
    code_0: 'E00-E89'
  },
  {
    code: 'E78',
    level: 2,
    description:
      'Trastornos del metabolismo de las lipoprote\u00ednas y otras lipidemias',
    code_1: 'E70-E90',
    code_0: 'E00-E89'
  },
  {
    code: 'E79',
    level: 2,
    description:
      'Trastornos del metabolismo de las purinas y de las pirimidinas',
    code_1: 'E70-E90',
    code_0: 'E00-E89'
  },
  {
    code: 'E80',
    level: 2,
    description:
      'Trastornos del metabolismo de las porfirinas y de la bilirrubina',
    code_1: 'E70-E90',
    code_0: 'E00-E89'
  },
  {
    code: 'E83',
    level: 2,
    description: 'Trastornos del metabolismo de los minerales',
    code_1: 'E70-E90',
    code_0: 'E00-E89'
  },
  {
    code: 'E58',
    level: 2,
    description: 'Deficiencia diet\u00e9tica de calcio',
    code_1: 'E50-E64',
    code_0: 'E00-E89'
  },
  {
    code: 'E59',
    level: 2,
    description: 'Deficiencia diet\u00e9tica de selenio',
    code_1: 'E50-E64',
    code_0: 'E00-E89'
  },
  {
    code: 'E60',
    level: 2,
    description: 'Deficiencia diet\u00e9tica de zinc',
    code_1: 'E50-E64',
    code_0: 'E00-E89'
  },
  {
    code: 'E61',
    level: 2,
    description: 'Deficiencias de otros elementos nutricionales',
    code_1: 'E50-E64',
    code_0: 'E00-E89'
  },
  {
    code: 'E63',
    level: 2,
    description: 'Otras deficiencias nutricionales',
    code_1: 'E50-E64',
    code_0: 'E00-E89'
  },
  {
    code: 'E64',
    level: 2,
    description:
      'Secuelas de la desnutrici\u00f3n y de otras deficiencias nutricionales',
    code_1: 'E50-E64',
    code_0: 'E00-E89'
  },
  {
    code: 'E43',
    level: 2,
    description:
      'Desnutrici\u00f3n proteicocal\u00f3rica severa, no especificada',
    code_1: 'E40-E46',
    code_0: 'E00-E89'
  },
  {
    code: 'E44',
    level: 2,
    description:
      'Desnutrici\u00f3n proteicocal\u00f3rica de grado moderado y leve',
    code_1: 'E40-E46',
    code_0: 'E00-E89'
  },
  {
    code: 'E45',
    level: 2,
    description:
      'Retardo del desarrollo debido a desnutrici\u00f3n proteicocal\u00f3rica',
    code_1: 'E40-E46',
    code_0: 'E00-E89'
  },
  {
    code: 'E46',
    level: 2,
    description: 'Desnutrici\u00f3n proteicocal\u00f3rica, no especificada',
    code_1: 'E40-E46',
    code_0: 'E00-E89'
  },
  {
    code: 'Q26',
    level: 2,
    description: 'Malformaciones cong\u00e9nitas de las grandes venas',
    code_1: 'Q20-Q28',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q27',
    level: 2,
    description:
      'Otras malformaciones cong\u00e9nitas del sistema vascular perif\u00e9rico',
    code_1: 'Q20-Q28',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q28',
    level: 2,
    description:
      'Otras malformaciones cong\u00e9nitas del sistema circulatorio',
    code_1: 'Q20-Q28',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q13',
    level: 2,
    description: 'Malformaciones cong\u00e9nitas del segmento anterior del ojo',
    code_1: 'Q10-Q18',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q14',
    level: 2,
    description:
      'Malformaciones cong\u00e9nitas del segmento posterior del ojo',
    code_1: 'Q10-Q18',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q15',
    level: 2,
    description: 'Otras malformaciones cong\u00e9nitas del ojo',
    code_1: 'Q10-Q18',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q16',
    level: 2,
    description:
      'Malformaciones cong\u00e9nitas del o\u00eddo que causan alteraci\u00f3n de la audici\u00f3n',
    code_1: 'Q10-Q18',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q17',
    level: 2,
    description: 'Otras malformaciones cong\u00e9nitas del o\u00eddo',
    code_1: 'Q10-Q18',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q18',
    level: 2,
    description: 'Otras malformaciones cong\u00e9nitas de la cara y del cuello',
    code_1: 'Q10-Q18',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q06',
    level: 2,
    description:
      'Otras malformaciones cong\u00e9nitas de la m\u00e9dula espinal',
    code_1: 'Q00-Q07',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q07',
    level: 2,
    description: 'Otras malformaciones cong\u00e9nitas del sistema nervioso',
    code_1: 'Q00-Q07',
    code_0: 'Q00-Q99'
  },
  {
    code: 'R44',
    level: 2,
    description:
      'Otros s\u00edntomas y signos que involucran las sensaciones y percepciones generales',
    code_1: 'R40-R46',
    code_0: 'R00-R99'
  },
  {
    code: 'R45',
    level: 2,
    description: 'S\u00edntomas y signos que involucran el estado emocional',
    code_1: 'R40-R46',
    code_0: 'R00-R99'
  },
  {
    code: 'R46',
    level: 2,
    description:
      'S\u00edntomas y signos que involucran la apariencia y el comportamiento',
    code_1: 'R40-R46',
    code_0: 'R00-R99'
  },
  {
    code: 'R33',
    level: 2,
    description: 'Retenci\u00f3n de orina',
    code_1: 'R30-R39',
    code_0: 'R00-R99'
  },
  {
    code: 'R34',
    level: 2,
    description: 'Anuria y oliguria',
    code_1: 'R30-R39',
    code_0: 'R00-R99'
  },
  {
    code: 'R35',
    level: 2,
    description: 'Poliuria',
    code_1: 'R30-R39',
    code_0: 'R00-R99'
  },
  {
    code: 'R36',
    level: 2,
    description: 'Descarga uretral',
    code_1: 'R30-R39',
    code_0: 'R00-R99'
  },
  {
    code: 'R39',
    level: 2,
    description:
      'Otros s\u00edntomas y signos que involucran el sistema urinario',
    code_1: 'R30-R39',
    code_0: 'R00-R99'
  },
  {
    code: 'R14',
    level: 2,
    description: 'Flatulencia y afecciones afines',
    code_1: 'R10-R19',
    code_0: 'R00-R99'
  },
  {
    code: 'R15',
    level: 2,
    description: 'Incontinencia fecal',
    code_1: 'R10-R19',
    code_0: 'R00-R99'
  },
  {
    code: 'R16',
    level: 2,
    description:
      'Hepatomegalia y esplenomegalia, no clasificadas en otra parte',
    code_1: 'R10-R19',
    code_0: 'R00-R99'
  },
  {
    code: 'R17',
    level: 2,
    description: 'Ictericia no especificada',
    code_1: 'R10-R19',
    code_0: 'R00-R99'
  },
  {
    code: 'R18',
    level: 2,
    description: 'Ascitis',
    code_1: 'R10-R19',
    code_0: 'R00-R99'
  },
  {
    code: 'R19',
    level: 2,
    description:
      'Otros s\u00edntomas y signos que involucran el sistema digestivo y el abdomen',
    code_1: 'R10-R19',
    code_0: 'R00-R99'
  },
  {
    code: 'R01',
    level: 2,
    description: 'Soplos y otros sonidos card\u00edacos',
    code_1: 'R00-R09',
    code_0: 'R00-R99'
  },
  {
    code: 'R02',
    level: 2,
    description: 'Gangrena, no clasificada en otra parte',
    code_1: 'R00-R09',
    code_0: 'R00-R99'
  },
  {
    code: 'R03',
    level: 2,
    description:
      'Lectura de presi\u00f3n sangu\u00ednea anormal, sin diagn\u00f3stico',
    code_1: 'R00-R09',
    code_0: 'R00-R99'
  },
  {
    code: 'R04',
    level: 2,
    description: 'Hemorragias de las v\u00edas respiratorias',
    code_1: 'R00-R09',
    code_0: 'R00-R99'
  },
  {
    code: 'R05',
    level: 2,
    description: 'Tos',
    code_1: 'R00-R09',
    code_0: 'R00-R99'
  },
  {
    code: 'R06',
    level: 2,
    description: 'Anormalidades de la respiraci\u00f3n',
    code_1: 'R00-R09',
    code_0: 'R00-R99'
  },
  {
    code: 'D21',
    level: 2,
    description:
      'Otros tumores benignos del tejido conjuntivo y de los tejidos blandos',
    code_1: 'D10-D36',
    code_0: 'C00-D49'
  },
  {
    code: 'D22',
    level: 2,
    description: 'Nevo melanoc\u00edtico',
    code_1: 'D10-D36',
    code_0: 'C00-D49'
  },
  {
    code: 'D23',
    level: 2,
    description: 'Otros tumores benignos de la piel',
    code_1: 'D10-D36',
    code_0: 'C00-D49'
  },
  {
    code: 'D24',
    level: 2,
    description: 'Tumor benigno de la mama',
    code_1: 'D10-D36',
    code_0: 'C00-D49'
  },
  {
    code: 'D25',
    level: 2,
    description: 'Leiomioma del \u00fatero',
    code_1: 'D10-D36',
    code_0: 'C00-D49'
  },
  {
    code: 'D26',
    level: 2,
    description: 'Otros tumores benignos del \u00fatero',
    code_1: 'D10-D36',
    code_0: 'C00-D49'
  },
  {
    code: 'D27',
    level: 2,
    description: 'Tumor benigno del ovario',
    code_1: 'D10-D36',
    code_0: 'C00-D49'
  },
  {
    code: 'E34',
    level: 2,
    description: 'Otros trastornos endocrinos',
    code_1: 'E20-E35',
    code_0: 'E00-E89'
  },
  {
    code: 'E35',
    level: 2,
    description:
      'Trastornos endocrinos en enfermedades clasificadas en otra parte',
    code_1: 'E20-E35',
    code_0: 'E00-E89'
  },
  {
    code: 'T90',
    level: 2,
    description: 'Secuelas de traumatismos de la cabeza',
    code_1: 'T90-T98',
    code_0: 'S00-T88'
  },
  {
    code: 'T91',
    level: 2,
    description: 'Secuelas de traumatismos del cuello y del tronco',
    code_1: 'T90-T98',
    code_0: 'S00-T88'
  },
  {
    code: 'T92',
    level: 2,
    description: 'Secuelas de traumatismos de miembro superior',
    code_1: 'T90-T98',
    code_0: 'S00-T88'
  },
  {
    code: 'T93',
    level: 2,
    description: 'Secuelas de traumatismos de miembro inferior',
    code_1: 'T90-T98',
    code_0: 'S00-T88'
  },
  {
    code: 'T80',
    level: 2,
    description:
      'Complicaciones consecutivas a infusi\u00f3n, transfusi\u00f3n e inyecci\u00f3n terap\u00e9utica',
    code_1: 'T80-T88',
    code_0: 'S00-T88'
  },
  {
    code: 'T81',
    level: 2,
    description:
      'Complicaciones de procedimientos, no clasificadas en otra parte',
    code_1: 'T80-T88',
    code_0: 'S00-T88'
  },
  {
    code: 'T82',
    level: 2,
    description:
      'Complicaciones de dispositivos prot\u00e9sicos, implantes e injertos cardiovasculares',
    code_1: 'T80-T88',
    code_0: 'S00-T88'
  },
  {
    code: 'T83',
    level: 2,
    description:
      'Complicaciones de dispositivos, implantes e injertos genitourinarios',
    code_1: 'T80-T88',
    code_0: 'S00-T88'
  },
  {
    code: 'T84',
    level: 2,
    description:
      'Complicaciones de dispositivos prot\u00e9sicos, implantes e injertos ortop\u00e9dicos internos',
    code_1: 'T80-T88',
    code_0: 'S00-T88'
  },
  {
    code: 'G249',
    level: 3,
    description: 'Diston\u00eda, no especificada',
    code_2: 'G24',
    code_0: 'G00-G99',
    code_1: 'G20-G26'
  },
  {
    code: 'H360',
    level: 3,
    description:
      'Retinopat\u00eda diab\u00e9tica (E10\u2013E14 con cuarto car\u00e1cter com\u00fan .3)',
    code_2: 'H36',
    code_0: 'H00-H59',
    code_1: 'H30-H36'
  },
  {
    code: 'H368',
    level: 3,
    description:
      'Otros trastornos de la retina en enfermedades clasificadas en otra parte',
    code_2: 'H36',
    code_0: 'H00-H59',
    code_1: 'H30-H36'
  },
  {
    code: 'H350',
    level: 3,
    description: 'Retinopat\u00edas del fondo y cambios vasculares retinianos',
    code_2: 'H35',
    code_0: 'H00-H59',
    code_1: 'H30-H36'
  },
  {
    code: 'H351',
    level: 3,
    description: 'Retinopat\u00eda de la prematuridad',
    code_2: 'H35',
    code_0: 'H00-H59',
    code_1: 'H30-H36'
  },
  {
    code: 'H352',
    level: 3,
    description: 'Otras retinopat\u00edas proliferativas',
    code_2: 'H35',
    code_0: 'H00-H59',
    code_1: 'H30-H36'
  },
  {
    code: 'H353',
    level: 3,
    description:
      'Degeneraci\u00f3n de la m\u00e1cula y del polo posterior del ojo',
    code_2: 'H35',
    code_0: 'H00-H59',
    code_1: 'H30-H36'
  },
  {
    code: 'H354',
    level: 3,
    description: 'Degeneraci\u00f3n perif\u00e9rica de la retina',
    code_2: 'H35',
    code_0: 'H00-H59',
    code_1: 'H30-H36'
  },
  {
    code: 'H355',
    level: 3,
    description: 'Distrofia hereditaria de la retina',
    code_2: 'H35',
    code_0: 'H00-H59',
    code_1: 'H30-H36'
  },
  {
    code: 'H356',
    level: 3,
    description: 'Hemorragia retiniana',
    code_2: 'H35',
    code_0: 'H00-H59',
    code_1: 'H30-H36'
  },
  {
    code: 'H357',
    level: 3,
    description: 'Separaci\u00f3n de las capas de la retina',
    code_2: 'H35',
    code_0: 'H00-H59',
    code_1: 'H30-H36'
  },
  {
    code: 'H358',
    level: 3,
    description: 'Otros trastornos especificados de la retina',
    code_2: 'H35',
    code_0: 'H00-H59',
    code_1: 'H30-H36'
  },
  {
    code: 'H340',
    level: 3,
    description: 'Oclusi\u00f3n arterial transitoria de la retina',
    code_2: 'H34',
    code_0: 'H00-H59',
    code_1: 'H30-H36'
  },
  {
    code: 'H341',
    level: 3,
    description: 'Oclusi\u00f3n de la arteria central de la retina',
    code_2: 'H34',
    code_0: 'H00-H59',
    code_1: 'H30-H36'
  },
  {
    code: 'H342',
    level: 3,
    description: 'Otras formas de oclusi\u00f3n de la arteria de la retina',
    code_2: 'H34',
    code_0: 'H00-H59',
    code_1: 'H30-H36'
  },
  {
    code: 'H348',
    level: 3,
    description: 'Otras oclusiones vasculares retinianas',
    code_2: 'H34',
    code_0: 'H00-H59',
    code_1: 'H30-H36'
  },
  {
    code: 'H349',
    level: 3,
    description:
      'Oclusi\u00f3n vascular retiniana, sin otra especificaci\u00f3n',
    code_2: 'H34',
    code_0: 'H00-H59',
    code_1: 'H30-H36'
  },
  {
    code: 'H330',
    level: 3,
    description: 'Desprendimiento de la retina con ruptura',
    code_2: 'H33',
    code_0: 'H00-H59',
    code_1: 'H30-H36'
  },
  {
    code: 'H331',
    level: 3,
    description: 'Retinosquisis y quistes de la retina',
    code_2: 'H33',
    code_0: 'H00-H59',
    code_1: 'H30-H36'
  },
  {
    code: 'H332',
    level: 3,
    description: 'Desprendimiento seroso de la retina',
    code_2: 'H33',
    code_0: 'H00-H59',
    code_1: 'H30-H36'
  },
  {
    code: 'H333',
    level: 3,
    description: 'Desgarro de la retina sin desprendimiento',
    code_2: 'H33',
    code_0: 'H00-H59',
    code_1: 'H30-H36'
  },
  {
    code: 'H334',
    level: 3,
    description: 'Desprendimiento de la retina por tracci\u00f3n',
    code_2: 'H33',
    code_0: 'H00-H59',
    code_1: 'H30-H36'
  },
  {
    code: 'H335',
    level: 3,
    description: 'Otros desprendimientos de la retina',
    code_2: 'H33',
    code_0: 'H00-H59',
    code_1: 'H30-H36'
  },
  {
    code: 'F070',
    level: 3,
    description: 'Trastorno de la personalidad, org\u00e1nico',
    code_2: 'F07',
    code_0: 'F01-F99',
    code_1: 'F00-F09'
  },
  {
    code: 'F071',
    level: 3,
    description: 'S\u00edndrome postencefal\u00edtico',
    code_2: 'F07',
    code_0: 'F01-F99',
    code_1: 'F00-F09'
  },
  {
    code: 'F072',
    level: 3,
    description: 'S\u00edndrome postconcusional',
    code_2: 'F07',
    code_0: 'F01-F99',
    code_1: 'F00-F09'
  },
  {
    code: 'F078',
    level: 3,
    description:
      'Otros trastornos org\u00e1nicos de la personalidad y del comportamiento debidos a enfermedad, lesi\u00f3n y disfunci\u00f3n cerebrales',
    code_2: 'F07',
    code_0: 'F01-F99',
    code_1: 'F00-F09'
  },
  {
    code: 'F079',
    level: 3,
    description:
      'Trastorno org\u00e1nico de la personalidad y del comportamiento, no especificado, debido a enfermedad, lesi\u00f3n y disfunci\u00f3n cerebral',
    code_2: 'F07',
    code_0: 'F01-F99',
    code_1: 'F00-F09'
  },
  {
    code: 'F060',
    level: 3,
    description: 'Alucinosis org\u00e1nica',
    code_2: 'F06',
    code_0: 'F01-F99',
    code_1: 'F00-F09'
  },
  {
    code: 'F061',
    level: 3,
    description: 'Trastorno catat\u00f3nico, org\u00e1nico',
    code_2: 'F06',
    code_0: 'F01-F99',
    code_1: 'F00-F09'
  },
  {
    code: 'F062',
    level: 3,
    description: 'Trastorno delirante [esquizofreniforme], org\u00e1nico',
    code_2: 'F06',
    code_0: 'F01-F99',
    code_1: 'F00-F09'
  },
  {
    code: 'F063',
    level: 3,
    description: 'Trastornos del humor [afectivos], org\u00e1nicos',
    code_2: 'F06',
    code_0: 'F01-F99',
    code_1: 'F00-F09'
  },
  {
    code: 'F064',
    level: 3,
    description: 'Trastorno de ansiedad, org\u00e1nico',
    code_2: 'F06',
    code_0: 'F01-F99',
    code_1: 'F00-F09'
  },
  {
    code: 'F058',
    level: 3,
    description: 'Otros delirios',
    code_2: 'F05',
    code_0: 'F01-F99',
    code_1: 'F00-F09'
  },
  {
    code: 'F059',
    level: 3,
    description: 'Delirio, no especificado',
    code_2: 'F05',
    code_0: 'F01-F99',
    code_1: 'F00-F09'
  },
  {
    code: 'F020',
    level: 3,
    description: 'Demencia en la enfermedad de Pick (G3l.0)',
    code_2: 'F02',
    code_0: 'F01-F99',
    code_1: 'F00-F09'
  },
  {
    code: 'F021',
    level: 3,
    description: 'Demencia en la enfermedad de Creutzfeldt\u2013Jakob (A81.0)',
    code_2: 'F02',
    code_0: 'F01-F99',
    code_1: 'F00-F09'
  },
  {
    code: 'F022',
    level: 3,
    description: 'Demencia en la enfermedad de Huntington (Gl0)',
    code_2: 'F02',
    code_0: 'F01-F99',
    code_1: 'F00-F09'
  },
  {
    code: 'F250',
    level: 3,
    description: 'Trastorno esquizoafectivo de tipo man\u00edaco',
    code_2: 'F25',
    code_0: 'F01-F99',
    code_1: 'F20-F29'
  },
  {
    code: 'F251',
    level: 3,
    description: 'Trastorno esquizoafectivo de tipo depresivo',
    code_2: 'F25',
    code_0: 'F01-F99',
    code_1: 'F20-F29'
  },
  {
    code: 'F252',
    level: 3,
    description: 'Trastorno esquizoafectivo de tipo mixto',
    code_2: 'F25',
    code_0: 'F01-F99',
    code_1: 'F20-F29'
  },
  {
    code: 'F258',
    level: 3,
    description: 'Otros trastornos esquizoafectivos',
    code_2: 'F25',
    code_0: 'F01-F99',
    code_1: 'F20-F29'
  },
  {
    code: 'E050',
    level: 3,
    description: 'Tirotoxicosis con bocio difuso',
    code_2: 'E05',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E051',
    level: 3,
    description: 'Tirotoxicosis con n\u00f3dulo solitario tiroideo t\u00f3xico',
    code_2: 'E05',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E052',
    level: 3,
    description: 'Tirotoxicosis con bocio multinodular t\u00f3xico',
    code_2: 'E05',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E053',
    level: 3,
    description: 'Tirotoxicosis por tejido tiroideo ect\u00f3pico',
    code_2: 'E05',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E054',
    level: 3,
    description: 'Tirotoxicosis facticia',
    code_2: 'E05',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E055',
    level: 3,
    description: 'Crisis o tormenta tirot\u00f3xica',
    code_2: 'E05',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E058',
    level: 3,
    description: 'Otras tirotoxicosis',
    code_2: 'E05',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E059',
    level: 3,
    description: 'Tirotoxicosis, no especificada',
    code_2: 'E05',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E040',
    level: 3,
    description: 'Bocio difuso no t\u00f3xico',
    code_2: 'E04',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E041',
    level: 3,
    description: 'N\u00f3dulo tiroideo solitario no t\u00f3xico',
    code_2: 'E04',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E042',
    level: 3,
    description: 'Bocio multinodular no t\u00f3xico',
    code_2: 'E04',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E048',
    level: 3,
    description: 'Otros bocios no t\u00f3xicos especificados',
    code_2: 'E04',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E049',
    level: 3,
    description: 'Bocio no t\u00f3xico, no especificado',
    code_2: 'E04',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'Z85',
    level: 2,
    description: 'Historia personal de tumor maligno',
    code_1: 'Z80-Z99',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z86',
    level: 2,
    description: 'Historia personal de algunas otras enfermedades',
    code_1: 'Z80-Z99',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z87',
    level: 2,
    description: 'Historia personal de otras enfermedades y afecciones',
    code_1: 'Z80-Z99',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z88',
    level: 2,
    description:
      'Historia personal de alergia a drogas, medicamentos y sustancias biol\u00f3gicas',
    code_1: 'Z80-Z99',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z89',
    level: 2,
    description: 'Ausencia adquirida de miembros',
    code_1: 'Z80-Z99',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z90',
    level: 2,
    description:
      'Ausencia adquirida de \u00f3rganos, no clasificada en otra parte',
    code_1: 'Z80-Z99',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z91',
    level: 2,
    description:
      'Historia personal de factores de riesgo, no clasificados en otra parte',
    code_1: 'Z80-Z99',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z92',
    level: 2,
    description: 'Historia personal de tratamiento m\u00e9dico',
    code_1: 'Z80-Z99',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z61',
    level: 2,
    description: 'Problemas relacionados con hechos negativos en la ni\u00f1ez',
    code_1: 'Z55-Z65',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z62',
    level: 2,
    description: 'Otros problemas relacionados con la crianza del ni\u00f1o',
    code_1: 'Z55-Z65',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z63',
    level: 2,
    description:
      'Otros problemas relacionados con el grupo primario de apoyo, inclusive circunstancias familiares',
    code_1: 'Z55-Z65',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z64',
    level: 2,
    description:
      'Problemas relacionados con ciertas circunstancias psicosociales',
    code_1: 'Z55-Z65',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z65',
    level: 2,
    description:
      'Problemas relacionados con otras circunstancias psicosociales',
    code_1: 'Z55-Z65',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z43',
    level: 2,
    description: 'Atenci\u00f3n de orificios artificiales',
    code_1: 'Z40-Z54',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z44',
    level: 2,
    description: 'Prueba y ajuste de dispositivos prot\u00e9sicos externos',
    code_1: 'Z40-Z54',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z45',
    level: 2,
    description: 'Asistencia y ajuste de dispositivos implantados',
    code_1: 'Z40-Z54',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z46',
    level: 2,
    description: 'Prueba y ajuste de otros dispositivos',
    code_1: 'Z40-Z54',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z47',
    level: 2,
    description: 'Otros cuidados posteriores a la ortopedia',
    code_1: 'Z40-Z54',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z48',
    level: 2,
    description: 'Otros cuidados posteriores a la cirug\u00eda',
    code_1: 'Z40-Z54',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z49',
    level: 2,
    description: 'Cuidados relativos al procedimiento de di\u00e1lisis',
    code_1: 'Z40-Z54',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z50',
    level: 2,
    description:
      'Atenci\u00f3n por el uso de procedimientos de rehabilitaci\u00f3n',
    code_1: 'Z40-Z54',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z51',
    level: 2,
    description: 'Otra atenci\u00f3n m\u00e9dica',
    code_1: 'Z40-Z54',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z52',
    level: 2,
    description: 'Donantes de \u00f3rganos y tejidos',
    code_1: 'Z40-Z54',
    code_0: 'Z00-Z99'
  },
  {
    code: 'T794',
    level: 2,
    description: 'Choque traum\u00e1tico',
    code_1: 'T79',
    code_0: 'S00-T88'
  },
  {
    code: 'T795',
    level: 2,
    description: 'Anuria traum\u00e1tica',
    code_1: 'T79',
    code_0: 'S00-T88'
  },
  {
    code: 'T796',
    level: 2,
    description: 'Isquemia traum\u00e1tica de m\u00fasculo',
    code_1: 'T79',
    code_0: 'S00-T88'
  },
  {
    code: 'T797',
    level: 2,
    description: 'Enfisema subcut\u00e1neo traum\u00e1tico',
    code_1: 'T79',
    code_0: 'S00-T88'
  },
  {
    code: 'T798',
    level: 2,
    description: 'Otras complicaciones precoces de los traumatismos',
    code_1: 'T79',
    code_0: 'S00-T88'
  },
  {
    code: 'T799',
    level: 2,
    description: 'Complicaciones precoces no especificadas de los traumatismos',
    code_1: 'T79',
    code_0: 'S00-T88'
  },
  {
    code: 'T71',
    level: 2,
    description: 'Asfixia',
    code_1: 'T66-T78',
    code_0: 'S00-T88'
  },
  {
    code: 'T73',
    level: 2,
    description: 'Efectos de otras privaciones',
    code_1: 'T66-T78',
    code_0: 'S00-T88'
  },
  {
    code: 'T74',
    level: 2,
    description: 'S\u00edndromes del maltrato',
    code_1: 'T66-T78',
    code_0: 'S00-T88'
  },
  {
    code: 'T75',
    level: 2,
    description: 'Efectos de otras causas externas',
    code_1: 'T66-T78',
    code_0: 'S00-T88'
  },
  {
    code: 'T78',
    level: 2,
    description: 'Efectos adversos, no clasificados en otra parte',
    code_1: 'T66-T78',
    code_0: 'S00-T88'
  },
  {
    code: 'T56',
    level: 2,
    description: 'Efecto t\u00f3xico de metales',
    code_1: 'T51-T65',
    code_0: 'S00-T88'
  },
  {
    code: 'T57',
    level: 2,
    description: 'Efecto t\u00f3xico de otras sustancias inorg\u00e1nicas',
    code_1: 'T51-T65',
    code_0: 'S00-T88'
  },
  {
    code: 'T58',
    level: 2,
    description: 'Efecto t\u00f3xico del mon\u00f3xido de carbono',
    code_1: 'T51-T65',
    code_0: 'S00-T88'
  },
  {
    code: 'T59',
    level: 2,
    description: 'Efecto t\u00f3xico de otros gases, humos y vapores',
    code_1: 'T51-T65',
    code_0: 'S00-T88'
  },
  {
    code: 'T60',
    level: 2,
    description: 'Efecto t\u00f3xico de plaguicidas [pesticidas]',
    code_1: 'T51-T65',
    code_0: 'S00-T88'
  },
  {
    code: 'T61',
    level: 2,
    description:
      'Efecto t\u00f3xico de sustancias nocivas ingeridas como alimentos marinos',
    code_1: 'T51-T65',
    code_0: 'S00-T88'
  },
  {
    code: 'T62',
    level: 2,
    description:
      'Efecto t\u00f3xico de otras sustancias nocivas ingeridas como alimento',
    code_1: 'T51-T65',
    code_0: 'S00-T88'
  },
  {
    code: 'T63',
    level: 2,
    description: 'Efecto t\u00f3xico del contacto con animales venenosos',
    code_1: 'T51-T65',
    code_0: 'S00-T88'
  },
  {
    code: 'T39',
    level: 2,
    description:
      'Envenenamiento por analg\u00e9sicos no narc\u00f3ticos, antipir\u00e9ticos y antirreum\u00e1ticos',
    code_1: 'T36-T50',
    code_0: 'S00-T88'
  },
  {
    code: 'T40',
    level: 2,
    description:
      'Envenenamiento por narc\u00f3ticos y psicodisl\u00e9pticos [alucin\u00f3genos]',
    code_1: 'T36-T50',
    code_0: 'S00-T88'
  },
  {
    code: 'T41',
    level: 2,
    description:
      'Envenenamiento por anest\u00e9sicos y gases terap\u00e9uticos',
    code_1: 'T36-T50',
    code_0: 'S00-T88'
  },
  {
    code: 'T42',
    level: 2,
    description:
      'Envenenamiento por antiepil\u00e9pticos, hipn\u00f3ticos-sedantes y drogas antiparkinsonianas',
    code_1: 'T36-T50',
    code_0: 'S00-T88'
  },
  {
    code: 'T43',
    level: 2,
    description:
      'Envenenamiento por psicotr\u00f3picos, no clasificados en otra parte',
    code_1: 'T36-T50',
    code_0: 'S00-T88'
  },
  {
    code: 'T44',
    level: 2,
    description:
      'Envenenamiento por drogas que afectan principalmente el sistema nervioso aut\u00f3nomo',
    code_1: 'T36-T50',
    code_0: 'S00-T88'
  },
  {
    code: 'T19',
    level: 2,
    description: 'Cuerpo extra\u00f1o en las v\u00edas genitourinarias',
    code_1: 'T15-T19',
    code_0: 'S00-T88'
  },
  {
    code: 'H406',
    level: 3,
    description: 'Glaucoma secundario a drogas',
    code_2: 'H40',
    code_0: 'H00-H59',
    code_1: 'H40-H42'
  },
  {
    code: 'H408',
    level: 3,
    description: 'Otros glaucomas',
    code_2: 'H40',
    code_0: 'H00-H59',
    code_1: 'H40-H42'
  },
  {
    code: 'H409',
    level: 3,
    description: 'Glaucoma, no especificado',
    code_2: 'H40',
    code_0: 'H00-H59',
    code_1: 'H40-H42'
  },
  {
    code: 'H444',
    level: 3,
    description: 'Hipoton\u00eda ocular',
    code_2: 'H44',
    code_0: 'H00-H59',
    code_1: 'H43-H45'
  },
  {
    code: 'H445',
    level: 3,
    description: 'Afecciones degenerativas del globo ocular',
    code_2: 'H44',
    code_0: 'H00-H59',
    code_1: 'H43-H45'
  },
  {
    code: 'H446',
    level: 3,
    description:
      'Retenci\u00f3n intraocular de cuerpo extra\u00f1o magn\u00e9tico (antiguo)',
    code_2: 'H44',
    code_0: 'H00-H59',
    code_1: 'H43-H45'
  },
  {
    code: 'H447',
    level: 3,
    description:
      'Retenci\u00f3n intraocular de cuerpo extra\u00f1o no magn\u00e9tico (antiguo)',
    code_2: 'H44',
    code_0: 'H00-H59',
    code_1: 'H43-H45'
  },
  {
    code: 'H448',
    level: 3,
    description: 'Otros trastornos del globo ocular',
    code_2: 'H44',
    code_0: 'H00-H59',
    code_1: 'H43-H45'
  },
  {
    code: 'H449',
    level: 3,
    description: 'Trastorno del globo ocular, no especificado',
    code_2: 'H44',
    code_0: 'H00-H59',
    code_1: 'H43-H45'
  },
  {
    code: 'I86',
    level: 2,
    description: 'V\u00e1rices de otros sitios',
    code_1: 'I80-I89',
    code_0: 'I00-I99'
  },
  {
    code: 'I87',
    level: 2,
    description: 'Otros trastornos de las venas',
    code_1: 'I80-I89',
    code_0: 'I00-I99'
  },
  {
    code: 'I88',
    level: 2,
    description: 'Linfadenitis inespec\u00edfica',
    code_1: 'I80-I89',
    code_0: 'I00-I99'
  },
  {
    code: 'I89',
    level: 2,
    description:
      'Otros trastornos no infecciosos de los vasos y ganglios linf\u00e1ticos',
    code_1: 'I80-I89',
    code_0: 'I00-I99'
  },
  {
    code: 'I77',
    level: 2,
    description: 'Otros trastornos arteriales o arteriolares',
    code_1: 'I70-I79',
    code_0: 'I00-I99'
  },
  {
    code: 'I78',
    level: 2,
    description: 'Enfermedades de los vasos capilares',
    code_1: 'I70-I79',
    code_0: 'I00-I99'
  },
  {
    code: 'I79',
    level: 2,
    description:
      'Trastornos de las arterias, de las arteriolas y de los vasos capilares en enfermedades clasificadas en otra parte',
    code_1: 'I70-I79',
    code_0: 'I00-I99'
  },
  {
    code: 'I66',
    level: 2,
    description:
      'Oclusi\u00f3n y estenosis de las arterias cerebrales sin ocasionar infarto cerebral',
    code_1: 'I60-I69',
    code_0: 'I00-I99'
  },
  {
    code: 'I67',
    level: 2,
    description: 'Otras enfermedades cerebrovasculares',
    code_1: 'I60-I69',
    code_0: 'I00-I99'
  },
  {
    code: 'I68',
    level: 2,
    description:
      'Trastornos cerebrovasculares en enfermedades clasificadas en otra parte',
    code_1: 'I60-I69',
    code_0: 'I00-I99'
  },
  {
    code: 'I69',
    level: 2,
    description: 'Secuelas de enfermedad cerebrovascular',
    code_1: 'I60-I69',
    code_0: 'I00-I99'
  },
  {
    code: 'I33',
    level: 2,
    description: 'Endocarditis aguda y subaguda',
    code_1: 'I30-I52',
    code_0: 'I00-I99'
  },
  {
    code: 'I34',
    level: 2,
    description: 'Trastornos no reum\u00e1ticos de la v\u00e1lvula mitral',
    code_1: 'I30-I52',
    code_0: 'I00-I99'
  },
  {
    code: 'I35',
    level: 2,
    description:
      'Trastornos no reum\u00e1ticos de la v\u00e1lvula a\u00f3rtica',
    code_1: 'I30-I52',
    code_0: 'I00-I99'
  },
  {
    code: 'I36',
    level: 2,
    description:
      'Trastornos no reum\u00e1ticos de la v\u00e1lvula tric\u00faspide',
    code_1: 'I30-I52',
    code_0: 'I00-I99'
  },
  {
    code: 'I37',
    level: 2,
    description: 'Trastornos de la v\u00e1lvula pulmonar',
    code_1: 'I30-I52',
    code_0: 'I00-I99'
  },
  {
    code: 'I38',
    level: 2,
    description: 'Endocarditis, v\u00e1lvula no especificada',
    code_1: 'I30-I52',
    code_0: 'I00-I99'
  },
  {
    code: 'H493',
    level: 3,
    description: 'Oftalmoplej\u00eda total (externa)',
    code_2: 'H49',
    code_0: 'H00-H59',
    code_1: 'H49-H52'
  },
  {
    code: 'H494',
    level: 3,
    description: 'Oftalmoplej\u00eda externa progresiva',
    code_2: 'H49',
    code_0: 'H00-H59',
    code_1: 'H49-H52'
  },
  {
    code: 'H498',
    level: 3,
    description: 'Otros estrabismos paral\u00edticos',
    code_2: 'H49',
    code_0: 'H00-H59',
    code_1: 'H49-H52'
  },
  {
    code: 'H499',
    level: 3,
    description: 'Estrabismo paral\u00edtico, no especificado',
    code_2: 'H49',
    code_0: 'H00-H59',
    code_1: 'H49-H52'
  },
  {
    code: 'J99',
    level: 2,
    description:
      'Trastornos respiratorios en enfermedades clasificadas en otra parte',
    code_1: 'J95-J99',
    code_0: 'J00-J99'
  },
  {
    code: 'J62',
    level: 2,
    description: 'Neumoconiosis debida a polvo de s\u00edlice',
    code_1: 'J60-J70',
    code_0: 'J00-J99'
  },
  {
    code: 'J63',
    level: 2,
    description: 'Neumoconiosis debida a otros polvos inorg\u00e1nicos',
    code_1: 'J60-J70',
    code_0: 'J00-J99'
  },
  {
    code: 'J64',
    level: 2,
    description: 'Neumoconiosis, no especificada',
    code_1: 'J60-J70',
    code_0: 'J00-J99'
  },
  {
    code: 'J65',
    level: 2,
    description: 'Neumoconiosis asociada con tuberculosis',
    code_1: 'J60-J70',
    code_0: 'J00-J99'
  },
  {
    code: 'J66',
    level: 2,
    description:
      'Enfermedades de las v\u00edas a\u00e9reas debidas a polvos org\u00e1nicos espec\u00edficos',
    code_1: 'J60-J70',
    code_0: 'J00-J99'
  },
  {
    code: 'J67',
    level: 2,
    description: 'Neumonitis debida a hipersensibilidad al polvo org\u00e1nico',
    code_1: 'J60-J70',
    code_0: 'J00-J99'
  },
  {
    code: 'J45',
    level: 2,
    description: 'Asma',
    code_1: 'J40-J47',
    code_0: 'J00-J99'
  },
  {
    code: 'J46',
    level: 2,
    description: 'Estado asm\u00e1tico',
    code_1: 'J40-J47',
    code_0: 'J00-J99'
  },
  {
    code: 'J47',
    level: 2,
    description: 'Bronquiectasia',
    code_1: 'J40-J47',
    code_0: 'J00-J99'
  },
  {
    code: 'K85',
    level: 2,
    description: 'Pancreatitis aguda',
    code_1: 'K80-K87',
    code_0: 'K00-K95'
  },
  {
    code: 'K86',
    level: 2,
    description: 'Otras enfermedades del p\u00e1ncreas',
    code_1: 'K80-K87',
    code_0: 'K00-K95'
  },
  {
    code: 'K87',
    level: 2,
    description:
      'Trastornos de la ves\u00edcula biliar, de las v\u00edas biliares y del p\u00e1ncreas en enfermedades clasificadas en otra parte',
    code_1: 'K80-K87',
    code_0: 'K00-K95'
  },
  {
    code: 'K77',
    level: 2,
    description:
      'Trastornos del h\u00edgado en enfermedades clasificadas en otra parte',
    code_1: 'K70-K77',
    code_0: 'K00-K95'
  },
  {
    code: 'H544',
    level: 3,
    description: 'Ceguera de un ojo',
    code_2: 'H54',
    code_0: 'H00-H59',
    code_1: 'H53-H54'
  },
  {
    code: 'H545',
    level: 3,
    description: 'Visi\u00f3n subnormal de un ojo',
    code_2: 'H54',
    code_0: 'H00-H59',
    code_1: 'H53-H54'
  },
  {
    code: 'H546',
    level: 3,
    description:
      'Disminuci\u00f3n indeterminada de la agudeza visual de un ojo',
    code_2: 'H54',
    code_0: 'H00-H59',
    code_1: 'H53-H54'
  },
  {
    code: 'H547',
    level: 3,
    description:
      'Disminuci\u00f3n de la agudeza visual, sin especificaci\u00f3n',
    code_2: 'H54',
    code_0: 'H00-H59',
    code_1: 'H53-H54'
  },
  {
    code: 'L83',
    level: 2,
    description: 'Acantosis nigricans',
    code_1: 'L80-L99',
    code_0: 'L00-L99'
  },
  {
    code: 'L84',
    level: 2,
    description: 'Callos y callosidades',
    code_1: 'L80-L99',
    code_0: 'L00-L99'
  },
  {
    code: 'L85',
    level: 2,
    description: 'Otros tipos de engrosamiento epid\u00e9rmico',
    code_1: 'L80-L99',
    code_0: 'L00-L99'
  },
  {
    code: 'L86',
    level: 2,
    description: 'Queratoderma en enfermedades clasificadas en otra parte',
    code_1: 'L80-L99',
    code_0: 'L00-L99'
  },
  {
    code: 'L87',
    level: 2,
    description: 'Trastornos de la eliminaci\u00f3n transepid\u00e9rmica',
    code_1: 'L80-L99',
    code_0: 'L00-L99'
  },
  {
    code: 'L88',
    level: 2,
    description: 'Pioderma gangrenoso',
    code_1: 'L80-L99',
    code_0: 'L00-L99'
  },
  {
    code: 'L89',
    level: 2,
    description: '\u00dalcera de dec\u00fabito',
    code_1: 'L80-L99',
    code_0: 'L00-L99'
  },
  {
    code: 'L90',
    level: 2,
    description: 'Trastornos atr\u00f3ficos de la piel',
    code_1: 'L80-L99',
    code_0: 'L00-L99'
  },
  {
    code: 'L91',
    level: 2,
    description: 'Trastornos hipertr\u00f3ficos de la piel',
    code_1: 'L80-L99',
    code_0: 'L00-L99'
  },
  {
    code: 'L92',
    level: 2,
    description:
      'Trastornos granulomatosos de la piel y del tejido subcut\u00e1neo',
    code_1: 'L80-L99',
    code_0: 'L00-L99'
  },
  {
    code: 'L65',
    level: 2,
    description: 'Otra p\u00e9rdida no cicatricial del pelo',
    code_1: 'L60-L75',
    code_0: 'L00-L99'
  },
  {
    code: 'L66',
    level: 2,
    description: 'Alopecia cicatricial [p\u00e9rdida cicatricial del pelo]',
    code_1: 'L60-L75',
    code_0: 'L00-L99'
  },
  {
    code: 'L67',
    level: 2,
    description: 'Anormalidades del tallo y del color del pelo',
    code_1: 'L60-L75',
    code_0: 'L00-L99'
  },
  {
    code: 'L68',
    level: 2,
    description: 'Hipertricosis',
    code_1: 'L60-L75',
    code_0: 'L00-L99'
  },
  {
    code: 'L70',
    level: 2,
    description: 'Acn\u00e9',
    code_1: 'L60-L75',
    code_0: 'L00-L99'
  },
  {
    code: 'F019',
    level: 3,
    description: 'Demencia vascular, no especificada',
    code_2: 'F01',
    code_0: 'F01-F99',
    code_1: 'F00-F09'
  },
  {
    code: 'B89',
    level: 2,
    description: 'Enfermedad parasitaria, no especificada',
    code_1: 'B85-B89',
    code_0: 'A00-B99'
  },
  {
    code: 'B70',
    level: 2,
    description: 'Difilobotriasis y esparganosis',
    code_1: 'B65-B83',
    code_0: 'A00-B99'
  },
  {
    code: 'B71',
    level: 2,
    description: 'Otras infecciones debidas a cestodos',
    code_1: 'B65-B83',
    code_0: 'A00-B99'
  },
  {
    code: 'B72',
    level: 2,
    description: 'Dracontiasis',
    code_1: 'B65-B83',
    code_0: 'A00-B99'
  },
  {
    code: 'B73',
    level: 2,
    description: 'Oncocercosis',
    code_1: 'B65-B83',
    code_0: 'A00-B99'
  },
  {
    code: 'B74',
    level: 2,
    description: 'Filariasis',
    code_1: 'B65-B83',
    code_0: 'A00-B99'
  },
  {
    code: 'B75',
    level: 2,
    description: 'Triquinosis',
    code_1: 'B65-B83',
    code_0: 'A00-B99'
  },
  {
    code: 'B76',
    level: 2,
    description: 'Anquilostomiasis y necatoriasis',
    code_1: 'B65-B83',
    code_0: 'A00-B99'
  },
  {
    code: 'B77',
    level: 2,
    description: 'Ascariasis',
    code_1: 'B65-B83',
    code_0: 'A00-B99'
  },
  {
    code: 'B55',
    level: 2,
    description: 'Leishmaniasis',
    code_1: 'B50-B64',
    code_0: 'A00-B99'
  },
  {
    code: 'B56',
    level: 2,
    description: 'Tripanosomiasis africana',
    code_1: 'B50-B64',
    code_0: 'A00-B99'
  },
  {
    code: 'B57',
    level: 2,
    description: 'Enfermedad de Chagas',
    code_1: 'B50-B64',
    code_0: 'A00-B99'
  },
  {
    code: 'B58',
    level: 2,
    description: 'Toxoplasmosis',
    code_1: 'B50-B64',
    code_0: 'A00-B99'
  },
  {
    code: 'B59',
    level: 2,
    description: 'Neumocistosis (J17.3)',
    code_1: 'B50-B64',
    code_0: 'A00-B99'
  },
  {
    code: 'B38',
    level: 2,
    description: 'Coccidioidomicosis',
    code_1: 'B35-B49',
    code_0: 'A00-B99'
  },
  {
    code: 'B39',
    level: 2,
    description: 'Histoplasmosis',
    code_1: 'B35-B49',
    code_0: 'A00-B99'
  },
  {
    code: 'B40',
    level: 2,
    description: 'Blastomicosis',
    code_1: 'B35-B49',
    code_0: 'A00-B99'
  },
  {
    code: 'B41',
    level: 2,
    description: 'Paracoccidioidomicosis',
    code_1: 'B35-B49',
    code_0: 'A00-B99'
  },
  {
    code: 'B42',
    level: 2,
    description: 'Esporotricosis',
    code_1: 'B35-B49',
    code_0: 'A00-B99'
  },
  {
    code: 'B43',
    level: 2,
    description: 'Cromomicosis y absceso feomic\u00f3tico',
    code_1: 'B35-B49',
    code_0: 'A00-B99'
  },
  {
    code: 'B44',
    level: 2,
    description: 'Aspergilosis',
    code_1: 'B35-B49',
    code_0: 'A00-B99'
  },
  {
    code: 'B26',
    level: 2,
    description: 'Parotiditis infecciosa',
    code_1: 'B25-B34',
    code_0: 'A00-B99'
  },
  {
    code: 'B27',
    level: 2,
    description: 'Mononucleosis infecciosa',
    code_1: 'B25-B34',
    code_0: 'A00-B99'
  },
  {
    code: 'B30',
    level: 2,
    description: 'Conjuntivitis viral',
    code_1: 'B25-B34',
    code_0: 'A00-B99'
  },
  {
    code: 'B33',
    level: 2,
    description: 'Otras enfermedades virales, no clasificadas en otra parte',
    code_1: 'B25-B34',
    code_0: 'A00-B99'
  },
  {
    code: 'B34',
    level: 2,
    description: 'Infecci\u00f3n viral de sitio no especificado',
    code_1: 'B25-B34',
    code_0: 'A00-B99'
  },
  {
    code: 'S69',
    level: 2,
    description:
      'Otros traumatismos y los no especificados de la mu\u00f1eca y de la mano',
    code_1: 'S60-S69',
    code_0: 'S00-T88'
  },
  {
    code: 'B05',
    level: 2,
    description: 'Sarampi\u00f3n',
    code_1: 'B00-B09',
    code_0: 'A00-B99'
  },
  {
    code: 'B06',
    level: 2,
    description: 'Rub\u00e9ola [sarampi\u00f3n alem\u00e1n]',
    code_1: 'B00-B09',
    code_0: 'A00-B99'
  },
  {
    code: 'B07',
    level: 2,
    description: 'Verrugas v\u00edricas',
    code_1: 'B00-B09',
    code_0: 'A00-B99'
  },
  {
    code: 'B08',
    level: 2,
    description:
      'Otras infecciones v\u00edricas caracterizadas por lesiones de la piel y de las membranas mucosas, no clasificadas en otra parte',
    code_1: 'B00-B09',
    code_0: 'A00-B99'
  },
  {
    code: 'B09',
    level: 2,
    description:
      'Infecci\u00f3n viral no especificada, caracterizada por lesiones de la piel y de las membranas mucosas',
    code_1: 'B00-B09',
    code_0: 'A00-B99'
  },
  {
    code: 'F318',
    level: 3,
    description: 'Otros trastornos afectivos bipolares',
    code_2: 'F31',
    code_0: 'F01-F99',
    code_1: 'F30-F39'
  },
  {
    code: 'F319',
    level: 3,
    description: 'Trastorno afectivo bipolar, no especificado',
    code_2: 'F31',
    code_0: 'F01-F99',
    code_1: 'F30-F39'
  },
  {
    code: 'N998',
    level: 2,
    description:
      'Otros trastornos del sistema genitourinario consecutivos a procedimientos',
    code_1: 'N99',
    code_0: 'N00-N99'
  },
  {
    code: 'N999',
    level: 2,
    description:
      'Trastorno no especificado del sistema genitourinario consecutivo a procedimientos',
    code_1: 'N99',
    code_0: 'N00-N99'
  },
  {
    code: 'N85',
    level: 2,
    description:
      'Otros trastornos no inflamatorios del \u00fatero, excepto del cuello',
    code_1: 'N80-N98',
    code_0: 'N00-N99'
  },
  {
    code: 'N86',
    level: 2,
    description: 'Erosi\u00f3n y ectropi\u00f3n del cuello del \u00fatero',
    code_1: 'N80-N98',
    code_0: 'N00-N99'
  },
  {
    code: 'N87',
    level: 2,
    description: 'Displasia del cuello uterino',
    code_1: 'N80-N98',
    code_0: 'N00-N99'
  },
  {
    code: 'N88',
    level: 2,
    description: 'Otros trastornos no inflamatorios del cuello del \u00fatero',
    code_1: 'N80-N98',
    code_0: 'N00-N99'
  },
  {
    code: 'N89',
    level: 2,
    description: 'Otros trastornos no inflamatorios de la vagina',
    code_1: 'N80-N98',
    code_0: 'N00-N99'
  },
  {
    code: 'N90',
    level: 2,
    description: 'Otros trastornos no inflamatorios de la vulva y del perineo',
    code_1: 'N80-N98',
    code_0: 'N00-N99'
  },
  {
    code: 'N91',
    level: 2,
    description: 'Menstruaci\u00f3n ausente, escasa o rara',
    code_1: 'N80-N98',
    code_0: 'N00-N99'
  },
  {
    code: 'N92',
    level: 2,
    description: 'Menstruaci\u00f3n excesiva, frecuente e irregular',
    code_1: 'N80-N98',
    code_0: 'N00-N99'
  },
  {
    code: 'N76',
    level: 2,
    description: 'Otras afecciones inflamatorias de la vagina y de la vulva',
    code_1: 'N70-N77',
    code_0: 'N00-N99'
  },
  {
    code: 'N77',
    level: 2,
    description:
      'Ulceraci\u00f3n e inflamaci\u00f3n vulvovaginal en enfermedades clasificadas en otra parte',
    code_1: 'N70-N77',
    code_0: 'N00-N99'
  },
  {
    code: 'N46',
    level: 2,
    description: 'Esterilidad en el var\u00f3n',
    code_1: 'N40-N51',
    code_0: 'N00-N99'
  },
  {
    code: 'N47',
    level: 2,
    description: 'Prepucio redundante, fimosis y parafimosis',
    code_1: 'N40-N51',
    code_0: 'N00-N99'
  },
  {
    code: 'N48',
    level: 2,
    description: 'Otros trastornos del pene',
    code_1: 'N40-N51',
    code_0: 'N00-N99'
  },
  {
    code: 'N49',
    level: 2,
    description:
      'Trastornos inflamatorios de \u00f3rganos genitales masculinos, no clasificados en otra parte',
    code_1: 'N40-N51',
    code_0: 'N00-N99'
  },
  {
    code: 'N50',
    level: 2,
    description: 'Otros trastornos de los \u00f3rganos genitales masculinos',
    code_1: 'N40-N51',
    code_0: 'N00-N99'
  },
  {
    code: 'N51',
    level: 2,
    description:
      'Trastornos de los \u00f3rganos genitales masculinos en enfermedades clasificadas en otra parte',
    code_1: 'N40-N51',
    code_0: 'N00-N99'
  },
  {
    code: 'N35',
    level: 2,
    description: 'Estrechez uretral',
    code_1: 'N30-N39',
    code_0: 'N00-N99'
  },
  {
    code: 'N36',
    level: 2,
    description: 'Otros trastornos de la uretra',
    code_1: 'N30-N39',
    code_0: 'N00-N99'
  },
  {
    code: 'N37',
    level: 2,
    description:
      'Trastornos de la uretra en enfermedades clasificadas en otra parte',
    code_1: 'N30-N39',
    code_0: 'N00-N99'
  },
  {
    code: 'N39',
    level: 2,
    description: 'Otros trastornos del sistema urinario',
    code_1: 'N30-N39',
    code_0: 'N00-N99'
  },
  {
    code: 'A46',
    level: 2,
    description: 'Erisipela',
    code_1: 'A30-A49',
    code_0: 'A00-B99'
  },
  {
    code: 'A48',
    level: 2,
    description:
      'Otras enfermedades bacterianas, no clasificadas en otra parte',
    code_1: 'A30-A49',
    code_0: 'A00-B99'
  },
  {
    code: 'A49',
    level: 2,
    description: 'Infecci\u00f3n bacteriana de sitio no especificado',
    code_1: 'A30-A49',
    code_0: 'A00-B99'
  },
  {
    code: 'O47',
    level: 2,
    description: 'Falso trabajo de parto',
    code_1: 'O30\u2013O48',
    code_0: 'O00-O9A'
  },
  {
    code: 'O48',
    level: 2,
    description: 'Embarazo prolongado',
    code_1: 'O30\u2013O48',
    code_0: 'O00-O9A'
  },
  {
    code: 'E84',
    level: 2,
    description: 'Fibrosis qu\u00edstica',
    code_1: 'E70-E90',
    code_0: 'E00-E89'
  },
  {
    code: 'E85',
    level: 2,
    description: 'Amiloidosis',
    code_1: 'E70-E90',
    code_0: 'E00-E89'
  },
  {
    code: 'E86',
    level: 2,
    description: 'Depleci\u00f3n del volumen',
    code_1: 'E70-E90',
    code_0: 'E00-E89'
  },
  {
    code: 'E87',
    level: 2,
    description:
      'Otros trastornos de los l\u00edquidos, de los electr\u00f3litos y del equilibrio \u00e1cido-b\u00e1sico',
    code_1: 'E70-E90',
    code_0: 'E00-E89'
  },
  {
    code: 'E88',
    level: 2,
    description: 'Otros trastornos metab\u00f3licos',
    code_1: 'E70-E90',
    code_0: 'E00-E89'
  },
  {
    code: 'E89',
    level: 2,
    description:
      'Trastornos endocrinos y metab\u00f3licos consecutivos a procedimientos, no clasificados en otra parte',
    code_1: 'E70-E90',
    code_0: 'E00-E89'
  },
  {
    code: 'E90',
    level: 2,
    description:
      'Trastornos nutricionales y metab\u00f3licos en enfermedades clasificadas en otra parte',
    code_1: 'E70-E90',
    code_0: 'E00-E89'
  },
  {
    code: 'R07',
    level: 2,
    description: 'Dolor de garganta y en el pecho',
    code_1: 'R00-R09',
    code_0: 'R00-R99'
  },
  {
    code: 'R09',
    level: 2,
    description:
      'Otros s\u00edntomas y signos que involucran los sistemas circulatorio y respiratorio',
    code_1: 'R00-R09',
    code_0: 'R00-R99'
  },
  {
    code: 'D28',
    level: 2,
    description:
      'Tumor benigno de otros \u00f3rganos genitales femeninos y de los no especificados',
    code_1: 'D10-D36',
    code_0: 'C00-D49'
  },
  {
    code: 'D29',
    level: 2,
    description: 'Tumor benigno de los \u00f3rganos genitales masculinos',
    code_1: 'D10-D36',
    code_0: 'C00-D49'
  },
  {
    code: 'D30',
    level: 2,
    description: 'Tumor benigno de los \u00f3rganos urinarios',
    code_1: 'D10-D36',
    code_0: 'C00-D49'
  },
  {
    code: 'D31',
    level: 2,
    description: 'Tumor benigno del ojo y sus anexos',
    code_1: 'D10-D36',
    code_0: 'C00-D49'
  },
  {
    code: 'D32',
    level: 2,
    description: 'Tumores benignos de las meninges',
    code_1: 'D10-D36',
    code_0: 'C00-D49'
  },
  {
    code: 'D33',
    level: 2,
    description:
      'Tumor benigno del enc\u00e9falo y de otras partes del sistema nervioso central',
    code_1: 'D10-D36',
    code_0: 'C00-D49'
  },
  {
    code: 'D34',
    level: 2,
    description: 'Tumor benigno de la gl\u00e1ndula tiroides',
    code_1: 'D10-D36',
    code_0: 'C00-D49'
  },
  {
    code: 'D35',
    level: 2,
    description:
      'Tumor benigno de otras gl\u00e1ndulas endocrinas y de las no especificadas',
    code_1: 'D10-D36',
    code_0: 'C00-D49'
  },
  {
    code: 'E070',
    level: 3,
    description: 'Hipersecreci\u00f3n de calcitonina',
    code_2: 'E07',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E071',
    level: 3,
    description: 'Bocio dishormogen\u00e9tico',
    code_2: 'E07',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E078',
    level: 3,
    description: 'Otros trastornos especificados de la gl\u00e1ndula tiroides',
    code_2: 'E07',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E079',
    level: 3,
    description: 'Trastorno de la gl\u00e1ndula tiroides, no especificado',
    code_2: 'E07',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E060',
    level: 3,
    description: 'Tiroiditis aguda',
    code_2: 'E06',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E061',
    level: 3,
    description: 'Tiroiditis subaguda',
    code_2: 'E06',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E062',
    level: 3,
    description: 'Tiroiditis cr\u00f3nica con tirotoxicosis transitoria',
    code_2: 'E06',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E063',
    level: 3,
    description: 'Tiroiditis autoinmune',
    code_2: 'E06',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E064',
    level: 3,
    description: 'Tiroiditis inducida por drogas',
    code_2: 'E06',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E065',
    level: 3,
    description: 'Otras tiroiditis cr\u00f3nicas',
    code_2: 'E06',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E069',
    level: 3,
    description: 'Tiroiditis, no especificada',
    code_2: 'E06',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E310',
    level: 3,
    description: 'Insuficiencia poliglandular autoinmune',
    code_2: 'E31',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E311',
    level: 3,
    description: 'Hiperfunci\u00f3n poliglandular',
    code_2: 'E31',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E318',
    level: 3,
    description: 'Otras disfunciones poliglandulares',
    code_2: 'E31',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E319',
    level: 3,
    description: 'Disfunci\u00f3n poliglandular, no especificada',
    code_2: 'E31',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E300',
    level: 3,
    description: 'Pubertad retardada',
    code_2: 'E30',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E301',
    level: 3,
    description: 'Pubertad precoz',
    code_2: 'E30',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E308',
    level: 3,
    description: 'Otros trastornos de la pubertad',
    code_2: 'E30',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E309',
    level: 3,
    description: 'Trastorno de la pubertad, no especificado',
    code_2: 'E30',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E290',
    level: 3,
    description: 'Hiperfunci\u00f3n testicular',
    code_2: 'E29',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E291',
    level: 3,
    description: 'Hipofunci\u00f3n testicular',
    code_2: 'E29',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E298',
    level: 3,
    description: 'Otras disfunciones testiculares',
    code_2: 'E29',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E299',
    level: 3,
    description: 'Disfunci\u00f3n testicular, no especificada',
    code_2: 'E29',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E280',
    level: 3,
    description: 'Exceso de estr\u00f3genos',
    code_2: 'E28',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E281',
    level: 3,
    description: 'Exceso de andr\u00f3genos',
    code_2: 'E28',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E282',
    level: 3,
    description: 'S\u00edndrome de ovario poliqu\u00edstico',
    code_2: 'E28',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E283',
    level: 3,
    description: 'Insuficiencia ov\u00e1rica primaria',
    code_2: 'E28',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E288',
    level: 3,
    description: 'Otras disfunciones ov\u00e1ricas',
    code_2: 'E28',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E289',
    level: 3,
    description: 'Disfunci\u00f3n ov\u00e1rica, no especificada',
    code_2: 'E28',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E270',
    level: 3,
    description: 'Otra hiperactividad corticosuprarrenal',
    code_2: 'E27',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E271',
    level: 3,
    description: 'Insuficiencia corticosuprarrenal primaria',
    code_2: 'E27',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E272',
    level: 3,
    description: 'Crisis addisoniana',
    code_2: 'E27',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E273',
    level: 3,
    description: 'Insuficiencia corticosuprarrenal inducida por drogas',
    code_2: 'E27',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E274',
    level: 3,
    description:
      'Otras insuficiencias corticosuprarrenales y las no especificadas',
    code_2: 'E27',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E275',
    level: 3,
    description: 'Hiperfunci\u00f3n de la m\u00e9dula suprarrenal',
    code_2: 'E27',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E278',
    level: 3,
    description:
      'Otros trastornos especificados de la gl\u00e1ndula suprarrenal',
    code_2: 'E27',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E279',
    level: 3,
    description: 'Trastorno de la gl\u00e1ndula suprarrenal, no especificado',
    code_2: 'E27',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E260',
    level: 3,
    description: 'Hiperaldosteronismo primario',
    code_2: 'E26',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E261',
    level: 3,
    description: 'Hiperaldosteronismo secundario',
    code_2: 'E26',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E268',
    level: 3,
    description: 'Otros tipos de hiperaldosteronismo',
    code_2: 'E26',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E269',
    level: 3,
    description: 'Hiperaldosteronismo, no especificado',
    code_2: 'E26',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E250',
    level: 3,
    description:
      'Trastornos adrenogenitales cong\u00e9nitos con deficiencia enzim\u00e1tica',
    code_2: 'E25',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E258',
    level: 3,
    description: 'Otros trastornos adrenogenitales',
    code_2: 'E25',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E259',
    level: 3,
    description: 'Trastorno adrenogenital, no especificado',
    code_2: 'E25',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'D760',
    level: 3,
    description:
      'Histiocitosis de las c\u00e9lulas de Langerhans, no clasificada en otra parte',
    code_2: 'D76',
    code_0: 'D50-D89',
    code_1: 'D70-D77'
  },
  {
    code: 'D761',
    level: 3,
    description: 'Linfohistiocitosis hemofagoc\u00edtica',
    code_2: 'D76',
    code_0: 'D50-D89',
    code_1: 'D70-D77'
  },
  {
    code: 'D762',
    level: 3,
    description: 'S\u00edndrome hemofagoc\u00edtico asociado a infecci\u00f3n',
    code_2: 'D76',
    code_0: 'D50-D89',
    code_1: 'D70-D77'
  },
  {
    code: 'D763',
    level: 3,
    description: 'Otros s\u00edndromes histioc\u00edticos',
    code_2: 'D76',
    code_0: 'D50-D89',
    code_1: 'D70-D77'
  },
  {
    code: 'T94',
    level: 2,
    description:
      'Secuelas de traumatismos que afectan m\u00faltiples regiones del cuerpo y las no especificadas',
    code_1: 'T90-T98',
    code_0: 'S00-T88'
  },
  {
    code: 'T95',
    level: 2,
    description: 'Secuelas de quemaduras, corrosiones y congelamientos',
    code_1: 'T90-T98',
    code_0: 'S00-T88'
  },
  {
    code: 'T96',
    level: 2,
    description:
      'Secuelas de envenenamientos por drogas, medicamentos y sustancias biol\u00f3gicas',
    code_1: 'T90-T98',
    code_0: 'S00-T88'
  },
  {
    code: 'T97',
    level: 2,
    description:
      'Secuelas de efectos t\u00f3xicos de sustancias de procedencia principalmente no medicinal',
    code_1: 'T90-T98',
    code_0: 'S00-T88'
  },
  {
    code: 'T98',
    level: 2,
    description:
      'Secuelas de otros efectos y los no especificados de causas externas',
    code_1: 'T90-T98',
    code_0: 'S00-T88'
  },
  {
    code: 'D750',
    level: 3,
    description: 'Eritrocitosis familiar',
    code_2: 'D75',
    code_0: 'D50-D89',
    code_1: 'D70-D77'
  },
  {
    code: 'D751',
    level: 3,
    description: 'Policitemia secundaria',
    code_2: 'D75',
    code_0: 'D50-D89',
    code_1: 'D70-D77'
  },
  {
    code: 'D752',
    level: 3,
    description: 'Trombocitosis esencial',
    code_2: 'D75',
    code_0: 'D50-D89',
    code_1: 'D70-D77'
  },
  {
    code: 'D758',
    level: 3,
    description:
      'Otras enfermedades especificadas de la sangre y de los \u00f3rganos hematopoy\u00e9ticos',
    code_2: 'D75',
    code_0: 'D50-D89',
    code_1: 'D70-D77'
  },
  {
    code: 'D759',
    level: 3,
    description:
      'Enfermedad de la sangre y de los \u00f3rganos hematopoy\u00e9ticos, no especificada',
    code_2: 'D75',
    code_0: 'D50-D89',
    code_1: 'D70-D77'
  },
  {
    code: 'D740',
    level: 3,
    description: 'Metahemoglobinemia cong\u00e9nita',
    code_2: 'D74',
    code_0: 'D50-D89',
    code_1: 'D70-D77'
  },
  {
    code: 'D748',
    level: 3,
    description: 'Otras metahemoglobinemias',
    code_2: 'D74',
    code_0: 'D50-D89',
    code_1: 'D70-D77'
  },
  {
    code: 'D749',
    level: 3,
    description: 'Metahemoglobinemia, no especificada',
    code_2: 'D74',
    code_0: 'D50-D89',
    code_1: 'D70-D77'
  },
  {
    code: 'D090',
    level: 3,
    description: 'Carcinoma in situ de la vejiga',
    code_2: 'D09',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D091',
    level: 3,
    description:
      'Carcinoma in situ de otros \u00f3rganos urinarios y de los no especificados',
    code_2: 'D09',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D092',
    level: 3,
    description: 'Carcinoma in situ del ojo',
    code_2: 'D09',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D093',
    level: 3,
    description:
      'Carcinoma in situ de la gl\u00e1ndula tiroides y de otras gl\u00e1ndulas endocrinas',
    code_2: 'D09',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D097',
    level: 3,
    description: 'Carcinoma in situ de otros sitios especificados',
    code_2: 'D09',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D099',
    level: 3,
    description: 'Carcinoma in situ, sitio no especificado',
    code_2: 'D09',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D070',
    level: 3,
    description: 'Carcinoma in situ del endometrio',
    code_2: 'D07',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D071',
    level: 3,
    description: 'Carcinoma in situ de la vulva',
    code_2: 'D07',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D072',
    level: 3,
    description: 'Carcinoma in situ de la vagina',
    code_2: 'D07',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D073',
    level: 3,
    description:
      'Carcinoma in situ de otros sitios de \u00f3rganos genitales femeninos y de los no especificados',
    code_2: 'D07',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D074',
    level: 3,
    description: 'Carcinoma in situ del pene',
    code_2: 'D07',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D075',
    level: 3,
    description: 'Carcinoma in situ de la pr\u00f3stata',
    code_2: 'D07',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D190',
    level: 3,
    description: 'Tumor benigno del tejido mesotelial de la pleura',
    code_2: 'D19',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D191',
    level: 3,
    description: 'Tumor benigno del tejido mesotelial del peritoneo',
    code_2: 'D19',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D197',
    level: 3,
    description:
      'Tumor benigno del tejido mesotelial de otros sitios especificados',
    code_2: 'D19',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D199',
    level: 3,
    description:
      'Tumor benigno del tejido mesotelial, de sitio no especificado',
    code_2: 'D19',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D180',
    level: 3,
    description: 'Hemangioma, de cualquier sitio',
    code_2: 'D18',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D181',
    level: 3,
    description: 'Linfangioma, de cualquier sitio',
    code_2: 'D18',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D170',
    level: 3,
    description:
      'Tumor benigno lipomatoso de piel y de tejido subcut\u00e1neo de cabeza, cara y cuello',
    code_2: 'D17',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D171',
    level: 3,
    description:
      'Tumor benigno lipomatoso de piel y de tejido subcut\u00e1neo del tronco',
    code_2: 'D17',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D172',
    level: 3,
    description:
      'Tumor benigno lipomatoso de piel y de tejido subcut\u00e1neo de miembros',
    code_2: 'D17',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D173',
    level: 3,
    description:
      'Tumor benigno lipomatoso de piel y de tejido subcut\u00e1neo de otros sitios y de los no especificados',
    code_2: 'D17',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D174',
    level: 3,
    description:
      'Tumor benigno lipomatoso de los \u00f3rganos intrator\u00e1cicos',
    code_2: 'D17',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D175',
    level: 3,
    description:
      'Tumor benigno lipomatoso de los \u00f3rganos intraabdominales',
    code_2: 'D17',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D176',
    level: 3,
    description: 'Tumor benigno lipomatoso del cord\u00f3n esperm\u00e1tico',
    code_2: 'D17',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D177',
    level: 3,
    description: 'Tumor benigno lipomatoso de otros sitios especificados',
    code_2: 'D17',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D179',
    level: 3,
    description: 'Tumor benigno lipomatoso, de sitio no especificado',
    code_2: 'D17',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D160',
    level: 3,
    description:
      'Tumor benigno del om\u00f3plato y huesos largos del miembro superior',
    code_2: 'D16',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D161',
    level: 3,
    description: 'Tumor benigno de los huesos cortos del miembro superior',
    code_2: 'D16',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D162',
    level: 3,
    description: 'Tumor benigno de los huesos largos del miembro inferior',
    code_2: 'D16',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D163',
    level: 3,
    description: 'Tumor benigno de los huesos cortos del miembro inferior',
    code_2: 'D16',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D164',
    level: 3,
    description: 'Tumor benigno de los huesos del cr\u00e1neo y de la cara',
    code_2: 'D16',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D165',
    level: 3,
    description: 'Tumor benigno del maxilar inferior',
    code_2: 'D16',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D166',
    level: 3,
    description: 'Tumor benigno de la columna vertebral',
    code_2: 'D16',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D167',
    level: 3,
    description:
      'Tumor benigno de las costillas, estern\u00f3n y clav\u00edcula',
    code_2: 'D16',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D168',
    level: 3,
    description:
      'Tumor benigno de los huesos p\u00e9lvicos, sacro y c\u00f3ccix',
    code_2: 'D16',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'T85',
    level: 2,
    description:
      'Complicaciones de otros dispositivos prot\u00e9sicos, implantes e injertos internos',
    code_1: 'T80-T88',
    code_0: 'S00-T88'
  },
  {
    code: 'T86',
    level: 2,
    description: 'Falla y rechazo del trasplante de \u00f3rganos y tejidos',
    code_1: 'T80-T88',
    code_0: 'S00-T88'
  },
  {
    code: 'T87',
    level: 2,
    description:
      'Complicaciones peculiares de la reinserci\u00f3n y amputaci\u00f3n',
    code_1: 'T80-T88',
    code_0: 'S00-T88'
  },
  {
    code: 'T88',
    level: 2,
    description:
      'Otras complicaciones de la atenci\u00f3n m\u00e9dica y quir\u00fargica, no clasificadas en otra parte',
    code_1: 'T80-T88',
    code_0: 'S00-T88'
  },
  {
    code: 'D150',
    level: 3,
    description: 'Tumor benigno del timo',
    code_2: 'D15',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D151',
    level: 3,
    description: 'Tumor benigno del coraz\u00f3n',
    code_2: 'D15',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D152',
    level: 3,
    description: 'Tumor benigno del mediastino',
    code_2: 'D15',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D157',
    level: 3,
    description:
      'Tumor benigno de otros \u00f3rganos intrator\u00e1cicos especificados',
    code_2: 'D15',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D159',
    level: 3,
    description:
      'Tumor benigno de \u00f3rgano intrator\u00e1cico no especificado',
    code_2: 'D15',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D140',
    level: 3,
    description:
      'Tumor benigno del o\u00eddo medio, de la cavidad nasal y de los senos paranasales',
    code_2: 'D14',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D141',
    level: 3,
    description: 'Tumor benigno de la laringe',
    code_2: 'D14',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D142',
    level: 3,
    description: 'Tumor benigno de la tr\u00e1quea',
    code_2: 'D14',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D143',
    level: 3,
    description: 'Tumor benigno de los bronquios y del pulm\u00f3n',
    code_2: 'D14',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D144',
    level: 3,
    description:
      'Tumor benigno del sistema respiratorio, sitio no especificado',
    code_2: 'D14',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D130',
    level: 3,
    description: 'Tumor benigno del es\u00f3fago',
    code_2: 'D13',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D131',
    level: 3,
    description: 'Tumor benigno del est\u00f3mago',
    code_2: 'D13',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D132',
    level: 3,
    description: 'Tumor benigno del duodeno',
    code_2: 'D13',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D133',
    level: 3,
    description:
      'Tumor benigno de otras partes y de las no especificadas del intestino delgado',
    code_2: 'D13',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D134',
    level: 3,
    description: 'Tumor benigno del h\u00edgado',
    code_2: 'D13',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D135',
    level: 3,
    description: 'Tumor benigno de las v\u00edas biliares extrahep\u00e1ticas',
    code_2: 'D13',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D136',
    level: 3,
    description: 'Tumor benigno del p\u00e1ncreas',
    code_2: 'D13',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D137',
    level: 3,
    description: 'Tumor benigno del p\u00e1ncreas endocrino',
    code_2: 'D13',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D139',
    level: 3,
    description: 'Tumor benigno de sitios mal definidos del sistema digestivo',
    code_2: 'D13',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D480',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido del hueso y cart\u00edlago articular',
    code_2: 'D48',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D481',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido del tejido conjuntivo y otro tejido blando',
    code_2: 'D48',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D482',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido de los nervios perif\u00e9ricos y del sistema nervioso aut\u00f3nomo',
    code_2: 'D48',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D483',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido del retroperitoneo',
    code_2: 'D48',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D484',
    level: 3,
    description: 'Tumor de comportamiento incierto o desconocido del peritoneo',
    code_2: 'D48',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D485',
    level: 3,
    description: 'Tumor de comportamiento incierto o desconocido de la piel',
    code_2: 'D48',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D486',
    level: 3,
    description: 'Tumor de comportamiento incierto o desconocido de la mama',
    code_2: 'D48',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D487',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido de otros sitios especificados',
    code_2: 'D48',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D489',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido, de sitio no especificado',
    code_2: 'D48',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D470',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido de los mastocitos e histiocitos',
    code_2: 'D47',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D471',
    level: 3,
    description: 'Enfermedad mieloproliferativa cr\u00f3nica',
    code_2: 'D47',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D472',
    level: 3,
    description: 'Gammopat\u00eda monoclonal',
    code_2: 'D47',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D473',
    level: 3,
    description: 'Trombocitopenia (hemorr\u00e1gica) esencial',
    code_2: 'D47',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D477',
    level: 3,
    description:
      'Otros tumores especificados de comportamiento incierto o desconocido del tejido linf\u00e1tico, de los \u00f3rganos hematopoy\u00e9ticos y de tejidos afines',
    code_2: 'D47',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D479',
    level: 3,
    description:
      'Tumores de comportamiento incierto o desconocido del tejido linf\u00e1tico, de los \u00f3rganos hematopoy\u00e9ticos y de tejidos afines, no especificados',
    code_2: 'D47',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D460',
    level: 3,
    description: 'Anemia refractaria sin sideroblastos, as\u00ed descrita',
    code_2: 'D46',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D461',
    level: 3,
    description: 'Anemia refractaria con sideroblastos',
    code_2: 'D46',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D462',
    level: 3,
    description: 'Anemia refractaria con exceso de blastos',
    code_2: 'D46',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D463',
    level: 3,
    description:
      'Anemia refractaria con exceso de blastos con transformaci\u00f3n',
    code_2: 'D46',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D464',
    level: 3,
    description: 'Anemia refractaria, sin otra especificaci\u00f3n',
    code_2: 'D46',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D467',
    level: 3,
    description: 'Otros s\u00edndromes mielodispl\u00e1sicos',
    code_2: 'D46',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D469',
    level: 3,
    description:
      'S\u00edndrome mielodispl\u00e1sico, sin otra especificaci\u00f3n',
    code_2: 'D46',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D440',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido de la gl\u00e1ndula tiroides',
    code_2: 'D44',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D441',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido de la gl\u00e1ndula suprarrenal',
    code_2: 'D44',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D442',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido de la gl\u00e1ndula paratiroides',
    code_2: 'D44',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D443',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido de la gl\u00e1ndula hip\u00f3fisis',
    code_2: 'D44',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D444',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido del conducto craneofar\u00edngeo',
    code_2: 'D44',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D445',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido de la gl\u00e1ndula pineal',
    code_2: 'D44',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D446',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido del cuerpo carot\u00eddeo',
    code_2: 'D44',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D447',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido del cuerpo a\u00f3rtico y otros cuerpos cromafines',
    code_2: 'D44',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D430',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido del enc\u00e9falo, supratentorial',
    code_2: 'D43',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D431',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido del enc\u00e9falo, infratentorial',
    code_2: 'D43',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D432',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido del enc\u00e9falo, parte no especificada',
    code_2: 'D43',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D433',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido de los nervios craneales',
    code_2: 'D43',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D434',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido de la m\u00e9dula espinal',
    code_2: 'D43',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D437',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido de otras partes especificadas del sistema nervioso central',
    code_2: 'D43',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D439',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido del sistema nervioso central, sitio no especificado',
    code_2: 'D43',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'H359',
    level: 3,
    description: 'Trastorno de la retina, no especificado',
    code_2: 'H35',
    code_0: 'H00-H59',
    code_1: 'H30-H36'
  },
  {
    code: 'F065',
    level: 3,
    description: 'Trastorno disociativo, org\u00e1nico',
    code_2: 'F06',
    code_0: 'F01-F99',
    code_1: 'F00-F09'
  },
  {
    code: 'F066',
    level: 3,
    description:
      'Trastorno de labilidad emocional [ast\u00e9nico], org\u00e1nico',
    code_2: 'F06',
    code_0: 'F01-F99',
    code_1: 'F00-F09'
  },
  {
    code: 'F067',
    level: 3,
    description: 'Trastorno cognoscitivo leve',
    code_2: 'F06',
    code_0: 'F01-F99',
    code_1: 'F00-F09'
  },
  {
    code: 'F068',
    level: 3,
    description:
      'Otros trastornos mentales especificados debidos a lesi\u00f3n y disfunci\u00f3n cerebral y a enfermedad f\u00edsica',
    code_2: 'F06',
    code_0: 'F01-F99',
    code_1: 'F00-F09'
  },
  {
    code: 'F069',
    level: 3,
    description:
      'Trastorno mental no especificado debido a lesi\u00f3n y disfunci\u00f3n cerebral y a enfermedad f\u00edsica',
    code_2: 'F06',
    code_0: 'F01-F99',
    code_1: 'F00-F09'
  },
  {
    code: 'R100',
    level: 3,
    description: 'Abdomen agudo',
    code_2: 'R10',
    code_0: 'R00-R99',
    code_1: 'R10-R19'
  },
  {
    code: 'R101',
    level: 3,
    description: 'Dolor abdominal localizado en parte superior',
    code_2: 'R10',
    code_0: 'R00-R99',
    code_1: 'R10-R19'
  },
  {
    code: 'R102',
    level: 3,
    description: 'Dolor p\u00e9lvico y perineal',
    code_2: 'R10',
    code_0: 'R00-R99',
    code_1: 'R10-R19'
  },
  {
    code: 'R103',
    level: 3,
    description: 'Dolor localizado en otras partes inferiores del abdomen',
    code_2: 'R10',
    code_0: 'R00-R99',
    code_1: 'R10-R19'
  },
  {
    code: 'R104',
    level: 3,
    description: 'Otros dolores abdominales y los no especificados',
    code_2: 'R10',
    code_0: 'R00-R99',
    code_1: 'R10-R19'
  },
  {
    code: 'R220',
    level: 3,
    description: 'Tumefacci\u00f3n, masa o prominencia localizada en la cabeza',
    code_2: 'R22',
    code_0: 'R00-R99',
    code_1: 'R20-R23'
  },
  {
    code: 'R221',
    level: 3,
    description: 'Tumefacci\u00f3n, masa o prominencia localizada en el cuello',
    code_2: 'R22',
    code_0: 'R00-R99',
    code_1: 'R20-R23'
  },
  {
    code: 'R222',
    level: 3,
    description: 'Tumefacci\u00f3n, masa o prominencia localizada en el tronco',
    code_2: 'R22',
    code_0: 'R00-R99',
    code_1: 'R20-R23'
  },
  {
    code: 'R223',
    level: 3,
    description:
      'Tumefacci\u00f3n, masa o prominencia localizada en el miembro superior',
    code_2: 'R22',
    code_0: 'R00-R99',
    code_1: 'R20-R23'
  },
  {
    code: 'R224',
    level: 3,
    description:
      'Tumefacci\u00f3n, masa o prominencia localizada en el miembro inferior',
    code_2: 'R22',
    code_0: 'R00-R99',
    code_1: 'R20-R23'
  },
  {
    code: 'R227',
    level: 3,
    description:
      'Tumefacci\u00f3n, masa o prominencia localizada en sitios m\u00faltiples',
    code_2: 'R22',
    code_0: 'R00-R99',
    code_1: 'R20-R23'
  },
  {
    code: 'R229',
    level: 3,
    description:
      'Tumefacci\u00f3n, masa o prominencia localizada en parte no especificada',
    code_2: 'R22',
    code_0: 'R00-R99',
    code_1: 'R20-R23'
  },
  {
    code: 'F023',
    level: 3,
    description: 'Demencia en la enfermedad de Parkinson (G20)',
    code_2: 'F02',
    code_0: 'F01-F99',
    code_1: 'F00-F09'
  },
  {
    code: 'F024',
    level: 3,
    description:
      'Demencia en la enfermedad por virus de la inmunodeficiencia humana [VIH] (B22.0)',
    code_2: 'F02',
    code_0: 'F01-F99',
    code_1: 'F00-F09'
  },
  {
    code: 'F028',
    level: 3,
    description:
      'Demencia en otras enfermedades especificadas clasificadas en otra parte',
    code_2: 'F02',
    code_0: 'F01-F99',
    code_1: 'F00-F09'
  },
  {
    code: 'F259',
    level: 3,
    description: 'Trastorno esquizoafectivo, no especificado',
    code_2: 'F25',
    code_0: 'F01-F99',
    code_1: 'F20-F29'
  },
  {
    code: 'Z93',
    level: 2,
    description: 'Aberturas artificiales',
    code_1: 'Z80-Z99',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z94',
    level: 2,
    description: '\u00d3rganos y tejidos trasplantados',
    code_1: 'Z80-Z99',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z95',
    level: 2,
    description: 'Presencia de implantes e injertos cardiovasculares',
    code_1: 'Z80-Z99',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z96',
    level: 2,
    description: 'Presencia de otros implantes funcionales',
    code_1: 'Z80-Z99',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z97',
    level: 2,
    description: 'Presencia de otros dispositivos',
    code_1: 'Z80-Z99',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z98',
    level: 2,
    description: 'Otros estados postquir\u00fargicos',
    code_1: 'Z80-Z99',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z99',
    level: 2,
    description:
      'Dependencia de m\u00e1quinas y dispositivos capacitantes, no clasificada en otra parte',
    code_1: 'Z80-Z99',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z53',
    level: 2,
    description:
      'Persona en contacto con los servicios de salud para procedimientos espec\u00edficos no realizados',
    code_1: 'Z40-Z54',
    code_0: 'Z00-Z99'
  },
  {
    code: 'Z54',
    level: 2,
    description: 'Convalecencia',
    code_1: 'Z40-Z54',
    code_0: 'Z00-Z99'
  },
  {
    code: 'T64',
    level: 2,
    description:
      'Efecto t\u00f3xico de aflatoxina y otras micotoxinas contaminantes de alimentos',
    code_1: 'T51-T65',
    code_0: 'S00-T88'
  },
  {
    code: 'T65',
    level: 2,
    description:
      'Efecto t\u00f3xico de otras sustancias y las no especificadas',
    code_1: 'T51-T65',
    code_0: 'S00-T88'
  },
  {
    code: 'T45',
    level: 2,
    description:
      'Envenenamiento por agentes principalmente sist\u00e9micos y hematol\u00f3gicos, no clasificados en otra parte',
    code_1: 'T36-T50',
    code_0: 'S00-T88'
  },
  {
    code: 'T46',
    level: 2,
    description:
      'Envenenamiento por agentes que afectan principalmente el sistema cardiovascular',
    code_1: 'T36-T50',
    code_0: 'S00-T88'
  },
  {
    code: 'T47',
    level: 2,
    description:
      'Envenenamiento por agentes que afectan principalmente el sistema gastrointestinal',
    code_1: 'T36-T50',
    code_0: 'S00-T88'
  },
  {
    code: 'T48',
    level: 2,
    description:
      'Envenenamiento por agentes con acci\u00f3n principal sobre los m\u00fasculos lisos y esquel\u00e9ticos y sobre el sistema respiratorio',
    code_1: 'T36-T50',
    code_0: 'S00-T88'
  },
  {
    code: 'T49',
    level: 2,
    description:
      'Envenenamiento por agentes t\u00f3picos que afectan principalmente la piel y las membranas mucosas y por drogas oftalmol\u00f3gicas, otorrinolaringol\u00f3gicas y dentales',
    code_1: 'T36-T50',
    code_0: 'S00-T88'
  },
  {
    code: 'T50',
    level: 2,
    description:
      'Envenenamiento por diur\u00e9ticos y otras drogas, medicamentos y sustancias biol\u00f3gicas no especificadas',
    code_1: 'T36-T50',
    code_0: 'S00-T88'
  },
  {
    code: 'I39',
    level: 2,
    description:
      'Endocarditis y trastornos valvulares en enfermedades clasificadas en otra parte',
    code_1: 'I30-I52',
    code_0: 'I00-I99'
  },
  {
    code: 'I40',
    level: 2,
    description: 'Miocarditis aguda',
    code_1: 'I30-I52',
    code_0: 'I00-I99'
  },
  {
    code: 'I41',
    level: 2,
    description: 'Miocarditis en enfermedades clasificadas en otra parte',
    code_1: 'I30-I52',
    code_0: 'I00-I99'
  },
  {
    code: 'I42',
    level: 2,
    description: 'Cardiomiopat\u00eda',
    code_1: 'I30-I52',
    code_0: 'I00-I99'
  },
  {
    code: 'I43',
    level: 2,
    description:
      'Cardiomiopat\u00eda en enfermedades clasificadas en otra parte',
    code_1: 'I30-I52',
    code_0: 'I00-I99'
  },
  {
    code: 'I44',
    level: 2,
    description: 'Bloqueo auriculoventricular y de rama izquierda del haz',
    code_1: 'I30-I52',
    code_0: 'I00-I99'
  },
  {
    code: 'I45',
    level: 2,
    description: 'Otros trastornos de la conducci\u00f3n',
    code_1: 'I30-I52',
    code_0: 'I00-I99'
  },
  {
    code: 'I46',
    level: 2,
    description: 'Paro card\u00edaco',
    code_1: 'I30-I52',
    code_0: 'I00-I99'
  },
  {
    code: 'I47',
    level: 2,
    description: 'Taquicardia parox\u00edstica',
    code_1: 'I30-I52',
    code_0: 'I00-I99'
  },
  {
    code: 'J68',
    level: 2,
    description:
      'Afecciones respiratorias debidas a inhalaci\u00f3n de gases, humos, vapores y sustancias qu\u00edmicas',
    code_1: 'J60-J70',
    code_0: 'J00-J99'
  },
  {
    code: 'J69',
    level: 2,
    description: 'Neumonitis debida a s\u00f3lidos y l\u00edquidos',
    code_1: 'J60-J70',
    code_0: 'J00-J99'
  },
  {
    code: 'J70',
    level: 2,
    description: 'Afecciones respiratorias debidas a otros agentes externos',
    code_1: 'J60-J70',
    code_0: 'J00-J99'
  },
  {
    code: 'L93',
    level: 2,
    description: 'Lupus eritematoso',
    code_1: 'L80-L99',
    code_0: 'L00-L99'
  },
  {
    code: 'L94',
    level: 2,
    description: 'Otros trastornos localizados del tejido conjuntivo',
    code_1: 'L80-L99',
    code_0: 'L00-L99'
  },
  {
    code: 'L95',
    level: 2,
    description: 'Vasculitis limitada a la piel, no clasificada en otra parte',
    code_1: 'L80-L99',
    code_0: 'L00-L99'
  },
  {
    code: 'L97',
    level: 2,
    description:
      '\u00dalcera de miembro inferior, no clasificada en otra parte',
    code_1: 'L80-L99',
    code_0: 'L00-L99'
  },
  {
    code: 'L98',
    level: 2,
    description:
      'Otros trastornos de la piel y del tejido subcut\u00e1neo, no clasificados en otra par',
    code_1: 'L80-L99',
    code_0: 'L00-L99'
  },
  {
    code: 'L99',
    level: 2,
    description:
      'Otros trastornos de la piel y del tejido subcut\u00e1neo en enfermedades clasificadas en otra parte',
    code_1: 'L80-L99',
    code_0: 'L00-L99'
  },
  {
    code: 'L71',
    level: 2,
    description: 'Ros\u00e1cea',
    code_1: 'L60-L75',
    code_0: 'L00-L99'
  },
  {
    code: 'L72',
    level: 2,
    description: 'Quiste folicular de la piel y del tejido subcut\u00e1neo',
    code_1: 'L60-L75',
    code_0: 'L00-L99'
  },
  {
    code: 'L73',
    level: 2,
    description: 'Otros trastornos foliculares',
    code_1: 'L60-L75',
    code_0: 'L00-L99'
  },
  {
    code: 'L74',
    level: 2,
    description: 'Trastornos sudor\u00edparos ecrinos',
    code_1: 'L60-L75',
    code_0: 'L00-L99'
  },
  {
    code: 'L75',
    level: 2,
    description: 'Trastornos sudor\u00edparos apocrinos',
    code_1: 'L60-L75',
    code_0: 'L00-L99'
  },
  {
    code: 'B78',
    level: 2,
    description: 'Estrongiloidiasis',
    code_1: 'B65-B83',
    code_0: 'A00-B99'
  },
  {
    code: 'B79',
    level: 2,
    description: 'Tricuriasis',
    code_1: 'B65-B83',
    code_0: 'A00-B99'
  },
  {
    code: 'B80',
    level: 2,
    description: 'Enterobiasis',
    code_1: 'B65-B83',
    code_0: 'A00-B99'
  },
  {
    code: 'B81',
    level: 2,
    description:
      'Otras helmintiasis intestinales, no clasificadas en otra parte',
    code_1: 'B65-B83',
    code_0: 'A00-B99'
  },
  {
    code: 'B82',
    level: 2,
    description: 'Parasitosis intestinales, sin otra especificaci\u00f3n',
    code_1: 'B65-B83',
    code_0: 'A00-B99'
  },
  {
    code: 'B83',
    level: 2,
    description: 'Otras helmintiasis',
    code_1: 'B65-B83',
    code_0: 'A00-B99'
  },
  {
    code: 'B60',
    level: 2,
    description:
      'Otras enfermedades debidas a protozoarios, no clasificadas en otra parte',
    code_1: 'B50-B64',
    code_0: 'A00-B99'
  },
  {
    code: 'B64',
    level: 2,
    description: 'Enfermedad debida a protozoarios, no especificada',
    code_1: 'B50-B64',
    code_0: 'A00-B99'
  },
  {
    code: 'B45',
    level: 2,
    description: 'Criptococosis',
    code_1: 'B35-B49',
    code_0: 'A00-B99'
  },
  {
    code: 'B46',
    level: 2,
    description: 'Cigomicosis',
    code_1: 'B35-B49',
    code_0: 'A00-B99'
  },
  {
    code: 'B47',
    level: 2,
    description: 'Micetoma',
    code_1: 'B35-B49',
    code_0: 'A00-B99'
  },
  {
    code: 'B48',
    level: 2,
    description: 'Otras micosis, no clasificadas en otra parte',
    code_1: 'B35-B49',
    code_0: 'A00-B99'
  },
  {
    code: 'B49',
    level: 2,
    description: 'Micosis, no especificada',
    code_1: 'B35-B49',
    code_0: 'A00-B99'
  },
  {
    code: 'N93',
    level: 2,
    description: 'Otras hemorragias uterinas o vaginales anormales',
    code_1: 'N80-N98',
    code_0: 'N00-N99'
  },
  {
    code: 'N94',
    level: 2,
    description:
      'Dolor y otras afecciones relacionadas con los \u00f3rganos genitales femeninos y con el ciclo menstrual',
    code_1: 'N80-N98',
    code_0: 'N00-N99'
  },
  {
    code: 'N95',
    level: 2,
    description: 'Otros trastornos menop\u00e1usicos y perimenop\u00e1usicos',
    code_1: 'N80-N98',
    code_0: 'N00-N99'
  },
  {
    code: 'N96',
    level: 2,
    description: 'Abortadora habitual',
    code_1: 'N80-N98',
    code_0: 'N00-N99'
  },
  {
    code: 'N97',
    level: 2,
    description: 'Infertilidad femenina',
    code_1: 'N80-N98',
    code_0: 'N00-N99'
  },
  {
    code: 'N98',
    level: 2,
    description: 'Complicaciones asociadas con la fecundaci\u00f3n artificial',
    code_1: 'N80-N98',
    code_0: 'N00-N99'
  },
  {
    code: 'D36',
    level: 2,
    description: 'Tumor benigno de otros sitios y de los no especificados',
    code_1: 'D10-D36',
    code_0: 'C00-D49'
  },
  {
    code: 'E350',
    level: 3,
    description:
      'Trastornos de la gl\u00e1ndula tiroides en enfermedades clasificadas en otra parte',
    code_2: 'E35',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E351',
    level: 3,
    description:
      'Trastornos de las gl\u00e1ndulas suprarrenales en enfermedades clasificadas en otra parte',
    code_2: 'E35',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E358',
    level: 3,
    description:
      'Trastornos de otras gl\u00e1ndulas endocrinas en enfermedades clasificadas en otra parte',
    code_2: 'E35',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E340',
    level: 3,
    description: 'S\u00edndrome carcinoide',
    code_2: 'E34',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E341',
    level: 3,
    description: 'Otras hipersecreciones de hormonas intestinales',
    code_2: 'E34',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E342',
    level: 3,
    description:
      'Secreci\u00f3n hormonal ect\u00f3pica, no clasificada en otra parte',
    code_2: 'E34',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E343',
    level: 3,
    description: 'Enanismo, no clasificado en otra parte',
    code_2: 'E34',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E344',
    level: 3,
    description: 'Estatura alta constitucional',
    code_2: 'E34',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E345',
    level: 3,
    description: 'S\u00edndrome de resistencia androg\u00e9nica',
    code_2: 'E34',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E348',
    level: 3,
    description: 'Otros trastornos endocrinos especificados',
    code_2: 'E34',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E349',
    level: 3,
    description: 'Trastorno endocrino, no especificado',
    code_2: 'E34',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E320',
    level: 3,
    description: 'Hiperplasia persistente del timo',
    code_2: 'E32',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E321',
    level: 3,
    description: 'Absceso del timo',
    code_2: 'E32',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E328',
    level: 3,
    description: 'Otras enfermedades del timo',
    code_2: 'E32',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E329',
    level: 3,
    description: 'Enfermedad del timo, no especificada',
    code_2: 'E32',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'D260',
    level: 3,
    description: 'Tumor benigno del cuello del \u00fatero',
    code_2: 'D26',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D261',
    level: 3,
    description: 'Tumor benigno del cuerpo del \u00fatero',
    code_2: 'D26',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D267',
    level: 3,
    description: 'Tumor benigno de otras partes especificadas del \u00fatero',
    code_2: 'D26',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D269',
    level: 3,
    description: 'Tumor benigno del \u00fatero, parte no especificada',
    code_2: 'D26',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D250',
    level: 3,
    description: 'Leiomioma submucoso del \u00fatero',
    code_2: 'D25',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D251',
    level: 3,
    description: 'Leiomioma intramural del \u00fatero',
    code_2: 'D25',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D252',
    level: 3,
    description: 'Leiomioma subseroso del \u00fatero',
    code_2: 'D25',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D259',
    level: 3,
    description: 'Leiomioma del \u00fatero, sin otra especificaci\u00f3n',
    code_2: 'D25',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D230',
    level: 3,
    description: 'Tumor benigno de la piel del labio',
    code_2: 'D23',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D231',
    level: 3,
    description:
      'Tumor benigno de la piel del p\u00e1rpado, incluida la comisura palpebral',
    code_2: 'D23',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D232',
    level: 3,
    description:
      'Tumor benigno de la piel de la oreja y del conducto auditivo externo',
    code_2: 'D23',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D233',
    level: 3,
    description:
      'Tumor benigno de la piel de otras partes y de las no especificadas de la cara',
    code_2: 'D23',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D234',
    level: 3,
    description: 'Tumor benigno de la piel del cuero cabelludo y del cuello',
    code_2: 'D23',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D235',
    level: 3,
    description: 'Tumor benigno de la piel del tronco',
    code_2: 'D23',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D236',
    level: 3,
    description:
      'Tumor benigno de la piel del miembro superior, incluido el hombro',
    code_2: 'D23',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D237',
    level: 3,
    description:
      'Tumor benigno de la piel del miembro inferior, incluida la cadera',
    code_2: 'D23',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D239',
    level: 3,
    description: 'Tumor benigno de la piel, sitio no especificado',
    code_2: 'D23',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D220',
    level: 3,
    description: 'Nevo melanoc\u00edtico del labio',
    code_2: 'D22',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D221',
    level: 3,
    description:
      'Nevo melanoc\u00edtico del p\u00e1rpado, incluida la comisura palpebral',
    code_2: 'D22',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D222',
    level: 3,
    description:
      'Nevo melanoc\u00edtico de la oreja y del conducto auditivo externo',
    code_2: 'D22',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D223',
    level: 3,
    description:
      'Nevo melanoc\u00edtico de otras partes y de las no especificadas de la cara',
    code_2: 'D22',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D224',
    level: 3,
    description: 'Nevo melanoc\u00edtico del cuero cabelludo y del cuello',
    code_2: 'D22',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D225',
    level: 3,
    description: 'Nevo melanoc\u00edtico del tronco',
    code_2: 'D22',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D226',
    level: 3,
    description:
      'Nevo melanoc\u00edtico del miembro superior, incluido el hombro',
    code_2: 'D22',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D227',
    level: 3,
    description:
      'Nevo melanoc\u00edtico del miembro inferior, incluida la cadera',
    code_2: 'D22',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D229',
    level: 3,
    description: 'Nevo melanoc\u00edtico, sitio no especificado',
    code_2: 'D22',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D210',
    level: 3,
    description:
      'Tumor benigno del tejido conjuntivo y de otros tejidos blandos de cabeza, cara y cuello',
    code_2: 'D21',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D211',
    level: 3,
    description:
      'Tumor benigno del tejido conjuntivo y de otros tejidos blandos del miembro superior, incluido el hombro',
    code_2: 'D21',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D212',
    level: 3,
    description:
      'Tumor benigno del tejido conjuntivo y de otros tejidos blandos del miembro inferior, incluida la cadera',
    code_2: 'D21',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D213',
    level: 3,
    description:
      'Tumor benigno del tejido conjuntivo y de otros tejidos blandos del t\u00f3rax',
    code_2: 'D21',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D214',
    level: 3,
    description:
      'Tumor benigno del tejido conjuntivo y otros tejidos blandos del abdomen',
    code_2: 'D21',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D215',
    level: 3,
    description:
      'Tumor benigno del tejido conjuntivo y otros tejidos blandos de la pelvis',
    code_2: 'D21',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D216',
    level: 3,
    description:
      'Tumor benigno del tejido conjuntivo y otros tejidos blandos del tronco, sin otra especificaci\u00f3n',
    code_2: 'D21',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D200',
    level: 3,
    description: 'Tumor benigno del retroperitoneo',
    code_2: 'D20',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D201',
    level: 3,
    description: 'Tumor benigno del peritoneo',
    code_2: 'D20',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'R040',
    level: 3,
    description: 'Epistaxis',
    code_2: 'R04',
    code_0: 'R00-R99',
    code_1: 'R00-R09'
  },
  {
    code: 'R041',
    level: 3,
    description: 'Hemorragia de la garganta',
    code_2: 'R04',
    code_0: 'R00-R99',
    code_1: 'R00-R09'
  },
  {
    code: 'R042',
    level: 3,
    description: 'Hemoptisis',
    code_2: 'R04',
    code_0: 'R00-R99',
    code_1: 'R00-R09'
  },
  {
    code: 'R048',
    level: 3,
    description: 'Hemorragia de otros sitios de las v\u00edas respiratorias',
    code_2: 'R04',
    code_0: 'R00-R99',
    code_1: 'R00-R09'
  },
  {
    code: 'R049',
    level: 3,
    description: 'Hemorragia de las v\u00edas respiratorias, no especificada',
    code_2: 'R04',
    code_0: 'R00-R99',
    code_1: 'R00-R09'
  },
  {
    code: 'R030',
    level: 3,
    description:
      'Lectura elevada de la presi\u00f3n sangu\u00ednea, sin diagn\u00f3stico de hipertensi\u00f3n',
    code_2: 'R03',
    code_0: 'R00-R99',
    code_1: 'R00-R09'
  },
  {
    code: 'R031',
    level: 3,
    description: 'Lectura de presi\u00f3n baja no espec\u00edfica',
    code_2: 'R03',
    code_0: 'R00-R99',
    code_1: 'R00-R09'
  },
  {
    code: 'R010',
    level: 3,
    description: 'Soplos card\u00edacos benignos o inocentes',
    code_2: 'R01',
    code_0: 'R00-R99',
    code_1: 'R00-R09'
  },
  {
    code: 'R011',
    level: 3,
    description: 'Soplo card\u00edaco, no especificado',
    code_2: 'R01',
    code_0: 'R00-R99',
    code_1: 'R00-R09'
  },
  {
    code: 'R012',
    level: 3,
    description: 'Otros sonidos card\u00edacos',
    code_2: 'R01',
    code_0: 'R00-R99',
    code_1: 'R00-R09'
  },
  {
    code: 'R000',
    level: 3,
    description: 'Taquicardia, no especificada',
    code_2: 'R00',
    code_0: 'R00-R99',
    code_1: 'R00-R09'
  },
  {
    code: 'R001',
    level: 3,
    description: 'Bradicardia, no especificada',
    code_2: 'R00',
    code_0: 'R00-R99',
    code_1: 'R00-R09'
  },
  {
    code: 'R190',
    level: 3,
    description:
      'Tumefacci\u00f3n, masa o prominencia intraabdominal y p\u00e9lvica',
    code_2: 'R19',
    code_0: 'R00-R99',
    code_1: 'R10-R19'
  },
  {
    code: 'R191',
    level: 3,
    description: 'Sonidos intestinales anormales',
    code_2: 'R19',
    code_0: 'R00-R99',
    code_1: 'R10-R19'
  },
  {
    code: 'R192',
    level: 3,
    description: 'Peristalsis visible',
    code_2: 'R19',
    code_0: 'R00-R99',
    code_1: 'R10-R19'
  },
  {
    code: 'R193',
    level: 3,
    description: 'Rigidez abdominal',
    code_2: 'R19',
    code_0: 'R00-R99',
    code_1: 'R10-R19'
  },
  {
    code: 'R194',
    level: 3,
    description: 'Cambios en los h\u00e1bitos intestinales',
    code_2: 'R19',
    code_0: 'R00-R99',
    code_1: 'R10-R19'
  },
  {
    code: 'R195',
    level: 3,
    description: 'Otras anormalidades fecales',
    code_2: 'R19',
    code_0: 'R00-R99',
    code_1: 'R10-R19'
  },
  {
    code: 'R160',
    level: 3,
    description: 'Hepatomegalia, no clasificada en otra parte',
    code_2: 'R16',
    code_0: 'R00-R99',
    code_1: 'R10-R19'
  },
  {
    code: 'R161',
    level: 3,
    description: 'Esplenomegalia, no clasificada en otra parte',
    code_2: 'R16',
    code_0: 'R00-R99',
    code_1: 'R10-R19'
  },
  {
    code: 'R162',
    level: 3,
    description:
      'Hepatomegalia con esplenomegalia, no clasificadas en otra parte',
    code_2: 'R16',
    code_0: 'R00-R99',
    code_1: 'R10-R19'
  },
  {
    code: 'R230',
    level: 3,
    description: 'Cianosis',
    code_2: 'R23',
    code_0: 'R00-R99',
    code_1: 'R20-R23'
  },
  {
    code: 'R231',
    level: 3,
    description: 'Palidez',
    code_2: 'R23',
    code_0: 'R00-R99',
    code_1: 'R20-R23'
  },
  {
    code: 'R232',
    level: 3,
    description: 'Rubor',
    code_2: 'R23',
    code_0: 'R00-R99',
    code_1: 'R20-R23'
  },
  {
    code: 'R233',
    level: 3,
    description: 'Equimosis espont\u00e1nea',
    code_2: 'R23',
    code_0: 'R00-R99',
    code_1: 'R20-R23'
  },
  {
    code: 'R234',
    level: 3,
    description: 'Cambios en la textura de la piel',
    code_2: 'R23',
    code_0: 'R00-R99',
    code_1: 'R20-R23'
  },
  {
    code: 'R238',
    level: 3,
    description: 'Otros cambios de la piel y los no especificados',
    code_2: 'R23',
    code_0: 'R00-R99',
    code_1: 'R20-R23'
  },
  {
    code: 'R390',
    level: 3,
    description: 'Extravasaci\u00f3n de la orina',
    code_2: 'R39',
    code_0: 'R00-R99',
    code_1: 'R30-R39'
  },
  {
    code: 'R391',
    level: 3,
    description: 'Otras dificultades de la micci\u00f3n',
    code_2: 'R39',
    code_0: 'R00-R99',
    code_1: 'R30-R39'
  },
  {
    code: 'R392',
    level: 3,
    description: 'Uremia extrarrenal',
    code_2: 'R39',
    code_0: 'R00-R99',
    code_1: 'R30-R39'
  },
  {
    code: 'R398',
    level: 3,
    description:
      'Otros s\u00edntomas y signos que involucran el sistema urinario y los no especificados',
    code_2: 'R39',
    code_0: 'R00-R99',
    code_1: 'R30-R39'
  },
  {
    code: 'R460',
    level: 3,
    description: 'Muy bajo nivel de higiene personal',
    code_2: 'R46',
    code_0: 'R00-R99',
    code_1: 'R40-R46'
  },
  {
    code: 'R461',
    level: 3,
    description: 'Apariencia personal extra\u00f1a',
    code_2: 'R46',
    code_0: 'R00-R99',
    code_1: 'R40-R46'
  },
  {
    code: 'R462',
    level: 3,
    description: 'Conducta extra\u00f1a e inexplicable',
    code_2: 'R46',
    code_0: 'R00-R99',
    code_1: 'R40-R46'
  },
  {
    code: 'R463',
    level: 3,
    description: 'Hiperactividad',
    code_2: 'R46',
    code_0: 'R00-R99',
    code_1: 'R40-R46'
  },
  {
    code: 'R464',
    level: 3,
    description: 'Lentitud y pobre respuesta',
    code_2: 'R46',
    code_0: 'R00-R99',
    code_1: 'R40-R46'
  },
  {
    code: 'R465',
    level: 3,
    description: 'Suspicacia y evasividad marcadas',
    code_2: 'R46',
    code_0: 'R00-R99',
    code_1: 'R40-R46'
  },
  {
    code: 'R466',
    level: 3,
    description:
      'Preocupaci\u00f3n indebida por sucesos que causan tensi\u00f3n',
    code_2: 'R46',
    code_0: 'R00-R99',
    code_1: 'R40-R46'
  },
  {
    code: 'R450',
    level: 3,
    description: 'Nerviosismo',
    code_2: 'R45',
    code_0: 'R00-R99',
    code_1: 'R40-R46'
  },
  {
    code: 'R451',
    level: 3,
    description: 'Inquietud y agitaci\u00f3n',
    code_2: 'R45',
    code_0: 'R00-R99',
    code_1: 'R40-R46'
  },
  {
    code: 'R452',
    level: 3,
    description: 'Infelicidad',
    code_2: 'R45',
    code_0: 'R00-R99',
    code_1: 'R40-R46'
  },
  {
    code: 'R453',
    level: 3,
    description: 'Desmoralizaci\u00f3n y apat\u00eda',
    code_2: 'R45',
    code_0: 'R00-R99',
    code_1: 'R40-R46'
  },
  {
    code: 'R454',
    level: 3,
    description: 'Irritabilidad y enojo',
    code_2: 'R45',
    code_0: 'R00-R99',
    code_1: 'R40-R46'
  },
  {
    code: 'R455',
    level: 3,
    description: 'Hostilidad',
    code_2: 'R45',
    code_0: 'R00-R99',
    code_1: 'R40-R46'
  },
  {
    code: 'R456',
    level: 3,
    description: 'Violencia f\u00edsica',
    code_2: 'R45',
    code_0: 'R00-R99',
    code_1: 'R40-R46'
  },
  {
    code: 'R457',
    level: 3,
    description: 'Tensi\u00f3n y estado de choque emocional, no especificado',
    code_2: 'R45',
    code_0: 'R00-R99',
    code_1: 'R40-R46'
  },
  {
    code: 'R458',
    level: 3,
    description:
      'Otros s\u00edntomas y signos que involucran el estado emocional',
    code_2: 'R45',
    code_0: 'R00-R99',
    code_1: 'R40-R46'
  },
  {
    code: 'R440',
    level: 3,
    description: 'Alucinaciones auditivas',
    code_2: 'R44',
    code_0: 'R00-R99',
    code_1: 'R40-R46'
  },
  {
    code: 'R430',
    level: 3,
    description: 'Anosmia',
    code_2: 'R43',
    code_0: 'R00-R99',
    code_1: 'R40-R46'
  },
  {
    code: 'R431',
    level: 3,
    description: 'Parosmia',
    code_2: 'R43',
    code_0: 'R00-R99',
    code_1: 'R40-R46'
  },
  {
    code: 'R432',
    level: 3,
    description: 'Parageusia',
    code_2: 'R43',
    code_0: 'R00-R99',
    code_1: 'R40-R46'
  },
  {
    code: 'R438',
    level: 3,
    description:
      'Otras alteraciones del gusto y del olfato y las no especificadas',
    code_2: 'R43',
    code_0: 'R00-R99',
    code_1: 'R40-R46'
  },
  {
    code: 'Q070',
    level: 3,
    description: 'S\u00edndrome de Arnold\u2013Chiari',
    code_2: 'Q07',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q078',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas del sistema nervioso, especificadas',
    code_2: 'Q07',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q079',
    level: 3,
    description:
      'Malformaci\u00f3n cong\u00e9nita del sistema nervioso, no especificada',
    code_2: 'Q07',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q060',
    level: 3,
    description: 'Amielia',
    code_2: 'Q06',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q061',
    level: 3,
    description: 'Hipoplasia y displasia de la m\u00e9dula espinal',
    code_2: 'Q06',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q062',
    level: 3,
    description: 'Diastematomielia',
    code_2: 'Q06',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q063',
    level: 3,
    description: 'Otras anomal\u00edas cong\u00e9nitas de la cola de caballo',
    code_2: 'Q06',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q064',
    level: 3,
    description: 'Hidromielia',
    code_2: 'Q06',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q068',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas especificadas de la m\u00e9dula espinal',
    code_2: 'Q06',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q069',
    level: 3,
    description:
      'Malformaci\u00f3n cong\u00e9nita de la m\u00e9dula espinal, no especificada',
    code_2: 'Q06',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q170',
    level: 3,
    description: 'Oreja supernumeraria',
    code_2: 'Q17',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q171',
    level: 3,
    description: 'Macrotia',
    code_2: 'Q17',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q172',
    level: 3,
    description: 'Microtia',
    code_2: 'Q17',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q173',
    level: 3,
    description: 'Otras deformidades del pabell\u00f3n auricular',
    code_2: 'Q17',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q174',
    level: 3,
    description: 'Anomal\u00eda de la posici\u00f3n de la oreja',
    code_2: 'Q17',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q175',
    level: 3,
    description: 'Oreja prominente',
    code_2: 'Q17',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q178',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas del o\u00eddo, especificadas',
    code_2: 'Q17',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q179',
    level: 3,
    description:
      'Malformaci\u00f3n cong\u00e9nita del o\u00eddo, no especificada',
    code_2: 'Q17',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q160',
    level: 3,
    description: 'Ausencia cong\u00e9nita del pabell\u00f3n (de la oreja)',
    code_2: 'Q16',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q161',
    level: 3,
    description:
      'Ausencia cong\u00e9nita, atresia o estrechez del conducto auditivo (externo)',
    code_2: 'Q16',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q162',
    level: 3,
    description: 'Ausencia de la trompa de Eustaquio',
    code_2: 'Q16',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q163',
    level: 3,
    description:
      'Malformaci\u00f3n cong\u00e9nita de los huesecillos del o\u00eddo',
    code_2: 'Q16',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q164',
    level: 3,
    description: 'Otras malformaciones cong\u00e9nitas del o\u00eddo medio',
    code_2: 'Q16',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q165',
    level: 3,
    description: 'Malformaci\u00f3n cong\u00e9nita del o\u00eddo interno',
    code_2: 'Q16',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q169',
    level: 3,
    description:
      'Malformaci\u00f3n cong\u00e9nita del o\u00eddo que causa alteraci\u00f3n de la audici\u00f3n, sin otra especificaci\u00f3n',
    code_2: 'Q16',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q150',
    level: 3,
    description: 'Glaucoma cong\u00e9nito',
    code_2: 'Q15',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q158',
    level: 3,
    description: 'Otras malformaciones cong\u00e9nitas del ojo, especificadas',
    code_2: 'Q15',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q159',
    level: 3,
    description: 'Malformaciones cong\u00e9nitas del ojo, no especificadas',
    code_2: 'Q15',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q140',
    level: 3,
    description: 'Malformaci\u00f3n cong\u00e9nita del humor v\u00edtreo',
    code_2: 'Q14',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q141',
    level: 3,
    description: 'Malformaci\u00f3n cong\u00e9nita de la retina',
    code_2: 'Q14',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q142',
    level: 3,
    description: 'Malformaci\u00f3n cong\u00e9nita del disco \u00f3ptico',
    code_2: 'Q14',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q143',
    level: 3,
    description: 'Malformaci\u00f3n cong\u00e9nita de la coroides',
    code_2: 'Q14',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q148',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas del segmento posterior del ojo',
    code_2: 'Q14',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q149',
    level: 3,
    description:
      'Malformaci\u00f3n cong\u00e9nita del segmento posterior del ojo, no especificada',
    code_2: 'Q14',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q130',
    level: 3,
    description: 'Coloboma del iris',
    code_2: 'Q13',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q131',
    level: 3,
    description: 'Ausencia del iris',
    code_2: 'Q13',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q132',
    level: 3,
    description: 'Otras malformaciones cong\u00e9nitas del iris',
    code_2: 'Q13',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q133',
    level: 3,
    description: 'Opacidad corneal cong\u00e9nita',
    code_2: 'Q13',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q134',
    level: 3,
    description: 'Otras malformaciones cong\u00e9nitas de la c\u00f3rnea',
    code_2: 'Q13',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q135',
    level: 3,
    description: 'Escler\u00f3tica azul',
    code_2: 'Q13',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q138',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas del segmento anterior del ojo',
    code_2: 'Q13',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q139',
    level: 3,
    description:
      'Malformaci\u00f3n cong\u00e9nita del segmento anterior del ojo, no especificada',
    code_2: 'Q13',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q280',
    level: 3,
    description: 'Malformaci\u00f3n arteriovenosa de los vasos precerebrales',
    code_2: 'Q28',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q281',
    level: 3,
    description: 'Otras malformaciones de los vasos precerebrales',
    code_2: 'Q28',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q282',
    level: 3,
    description: 'Malformaci\u00f3n arteriovenosa de los vasos cerebrales',
    code_2: 'Q28',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q283',
    level: 3,
    description: 'Otras malformaciones de los vasos cerebrales',
    code_2: 'Q28',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q288',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas del sistema circulatorio, especificadas',
    code_2: 'Q28',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q289',
    level: 3,
    description:
      'Malformaci\u00f3n cong\u00e9nita del sistema circulatorio, no especificada',
    code_2: 'Q28',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q270',
    level: 3,
    description: 'Ausencia e hipoplasia cong\u00e9nita de la arteria umbilical',
    code_2: 'Q27',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q271',
    level: 3,
    description: 'Estenosis cong\u00e9nita de la arteria renal',
    code_2: 'Q27',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q272',
    level: 3,
    description: 'Otras malformaciones cong\u00e9nitas de la arteria renal',
    code_2: 'Q27',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q273',
    level: 3,
    description: 'Malformaci\u00f3n arteriovenosa perif\u00e9rica',
    code_2: 'Q27',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q274',
    level: 3,
    description: 'Flebectasia cong\u00e9nita',
    code_2: 'Q27',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q278',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas del sistema vascular perif\u00e9rico, especificadas',
    code_2: 'Q27',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q279',
    level: 3,
    description:
      'Malformaci\u00f3n cong\u00e9nita del sistema vascular perif\u00e9rico, no especificada',
    code_2: 'Q27',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q260',
    level: 3,
    description: 'Estenosis cong\u00e9nita de la vena cava',
    code_2: 'Q26',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q261',
    level: 3,
    description: 'Persistencia de la vena cava superior izquierda',
    code_2: 'Q26',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q262',
    level: 3,
    description: 'Conexi\u00f3n an\u00f3mala total de las venas pulmonares',
    code_2: 'Q26',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q263',
    level: 3,
    description: 'Conexi\u00f3n an\u00f3mala parcial de las venas pulmonares',
    code_2: 'Q26',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q264',
    level: 3,
    description:
      'Conexi\u00f3n an\u00f3mala de las venas pulmonares, sin otra especificaci\u00f3n',
    code_2: 'Q26',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q265',
    level: 3,
    description: 'Conexi\u00f3n an\u00f3mala de la vena porta',
    code_2: 'Q26',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q266',
    level: 3,
    description: 'F\u00edstula arteria hep\u00e1tica\u2013vena porta',
    code_2: 'Q26',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q268',
    level: 3,
    description: 'Otras malformaciones cong\u00e9nitas de las grandes venas',
    code_2: 'Q26',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q269',
    level: 3,
    description:
      'Malformaci\u00f3n cong\u00e9nita de las grandes venas, no especificada',
    code_2: 'Q26',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'E440',
    level: 3,
    description: 'Desnutrici\u00f3n proteicocal\u00f3rica moderada',
    code_2: 'E44',
    code_0: 'E00-E89',
    code_1: 'E40-E46'
  },
  {
    code: 'E441',
    level: 3,
    description: 'Desnutrici\u00f3n proteicocal\u00f3rica leve',
    code_2: 'E44',
    code_0: 'E00-E89',
    code_1: 'E40-E46'
  },
  {
    code: 'E640',
    level: 3,
    description: 'Secuelas de la desnutrici\u00f3n proteicocal\u00f3rica',
    code_2: 'E64',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E641',
    level: 3,
    description: 'Secuelas de la deficiencia de vitamina A',
    code_2: 'E64',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E642',
    level: 3,
    description: 'Secuelas de la deficiencia de vitamina C',
    code_2: 'E64',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E643',
    level: 3,
    description: 'Secuelas del raquitismo',
    code_2: 'E64',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E648',
    level: 3,
    description: 'Secuelas de otras deficiencias nutricionales',
    code_2: 'E64',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E649',
    level: 3,
    description: 'Secuelas de la deficiencia nutricional no especificada',
    code_2: 'E64',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E630',
    level: 3,
    description: 'Deficiencia de \u00e1cidos grasos esenciales [AGE]',
    code_2: 'E63',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E631',
    level: 3,
    description: 'Desequilibrio de los constituyentes en la dieta',
    code_2: 'E63',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E638',
    level: 3,
    description: 'Otras deficiencias nutricionales especificadas',
    code_2: 'E63',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E639',
    level: 3,
    description: 'Deficiencia nutricional, no especificada',
    code_2: 'E63',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E610',
    level: 3,
    description: 'Deficiencia de cobre',
    code_2: 'E61',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E611',
    level: 3,
    description: 'Deficiencia de hierro',
    code_2: 'E61',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E612',
    level: 3,
    description: 'Deficiencia de magnesio',
    code_2: 'E61',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E613',
    level: 3,
    description: 'Deficiencia de manganeso',
    code_2: 'E61',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E614',
    level: 3,
    description: 'Deficiencia de cromo',
    code_2: 'E61',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E560',
    level: 3,
    description: 'Deficiencia de vitamina E',
    code_2: 'E56',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E561',
    level: 3,
    description: 'Deficiencia de vitamina K',
    code_2: 'E56',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E568',
    level: 3,
    description: 'Deficiencia de otras vitaminas',
    code_2: 'E56',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E569',
    level: 3,
    description: 'Deficiencia de vitamina, no especificada',
    code_2: 'E56',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E830',
    level: 3,
    description: 'Trastornos del metabolismo del cobre',
    code_2: 'E83',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E831',
    level: 3,
    description: 'Trastornos del metabolismo del hierro',
    code_2: 'E83',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E832',
    level: 3,
    description: 'Trastornos del metabolismo del zinc',
    code_2: 'E83',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E833',
    level: 3,
    description: 'Trastornos del metabolismo del f\u00f3sforo',
    code_2: 'E83',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E834',
    level: 3,
    description: 'Trastornos del metabolismo del magnesio',
    code_2: 'E83',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E835',
    level: 3,
    description: 'Trastornos del metabolismo del calcio',
    code_2: 'E83',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E838',
    level: 3,
    description: 'Otros trastornos del metabolismo de los minerales',
    code_2: 'E83',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E839',
    level: 3,
    description: 'Trastorno del metabolismo de los minerales, no especificado',
    code_2: 'E83',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E800',
    level: 3,
    description: 'Porfiria eritropoy\u00e9tica hereditaria',
    code_2: 'E80',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E801',
    level: 3,
    description: 'Porfiria cut\u00e1nea tard\u00eda',
    code_2: 'E80',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E802',
    level: 3,
    description: 'Otras porfirias:',
    code_2: 'E80',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E803',
    level: 3,
    description: 'Defectos de catalasa y peroxidasa',
    code_2: 'E80',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E804',
    level: 3,
    description: 'S\u00edndrome de Gilbert',
    code_2: 'E80',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E805',
    level: 3,
    description: 'S\u00edndrome de Crigler\u2013Najjar',
    code_2: 'E80',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E806',
    level: 3,
    description: 'Otros trastornos del metabolismo de la bilirrubina',
    code_2: 'E80',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E807',
    level: 3,
    description: 'Trastorno del metabolismo de la bilirrubina, no especificado',
    code_2: 'E80',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E790',
    level: 3,
    description:
      'Hiperuricemia sin signos de artritis inflamatoria y enfermedad tof\u00e1cea',
    code_2: 'E79',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E791',
    level: 3,
    description: 'S\u00edndrome de Lesch\u2013Nyhan',
    code_2: 'E79',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E798',
    level: 3,
    description:
      'Otros trastornos del metabolismo de las purinas y de las pirimidinas',
    code_2: 'E79',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E799',
    level: 3,
    description:
      'Trastorno del metabolismo de las purinas y de las pirimidinas, no especificado',
    code_2: 'E79',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E780',
    level: 3,
    description: 'Hipercolesterolemia pura',
    code_2: 'E78',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E781',
    level: 3,
    description: 'Hipergliceridemia pura',
    code_2: 'E78',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E782',
    level: 3,
    description: 'Hiperlipidemia mixta',
    code_2: 'E78',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E783',
    level: 3,
    description: 'Hiperquilomicronemia',
    code_2: 'E78',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E784',
    level: 3,
    description: 'Otra hiperlipidemia',
    code_2: 'E78',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E785',
    level: 3,
    description: 'Hiperlipidemia no especificada',
    code_2: 'E78',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E786',
    level: 3,
    description: 'Deficiencia de lipoprote\u00ednas',
    code_2: 'E78',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E788',
    level: 3,
    description: 'Otros trastornos del metabolismo de las lipoprote\u00ednas',
    code_2: 'E78',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E789',
    level: 3,
    description:
      'Trastorno del metabolismo de las lipoprote\u00ednas, no especificado',
    code_2: 'E78',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E770',
    level: 3,
    description:
      'Defectos en la modificaci\u00f3n postraslacional de enzimas lisosomales',
    code_2: 'E77',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E771',
    level: 3,
    description: 'Defectos de la degradaci\u00f3n de glucoprote\u00ednas',
    code_2: 'E77',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E778',
    level: 3,
    description: 'Otros trastornos del metabolismo de las glucoprote\u00ednas',
    code_2: 'E77',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E779',
    level: 3,
    description:
      'Trastorno del metabolismo de las glucoprote\u00ednas, no especificado',
    code_2: 'E77',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E760',
    level: 3,
    description: 'Mucopolisacaridosis tipo I',
    code_2: 'E76',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E761',
    level: 3,
    description: 'Mucopolisacaridosis tipo II',
    code_2: 'E76',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E762',
    level: 3,
    description: 'Otras mucopolisacaridosis',
    code_2: 'E76',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E763',
    level: 3,
    description: 'Mucopolisacaridosis no especificada',
    code_2: 'E76',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E768',
    level: 3,
    description: 'Otros trastornos del metabolismo de los glucosaminoglicanos',
    code_2: 'E76',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E769',
    level: 3,
    description:
      'Trastorno del metabolismo de los glucosaminoglicanos, no especificado',
    code_2: 'E76',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E750',
    level: 3,
    description: 'Gangliosidosis GM2',
    code_2: 'E75',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E751',
    level: 3,
    description: 'Otras gangliosidosis',
    code_2: 'E75',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E752',
    level: 3,
    description: 'Otras esfingolipidosis',
    code_2: 'E75',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E753',
    level: 3,
    description: 'Esfingolipidosis, no especificada',
    code_2: 'E75',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E754',
    level: 3,
    description: 'Lipofuscinosis ceroide neuronal',
    code_2: 'E75',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E755',
    level: 3,
    description: 'Otros trastornos del almacenamiento de l\u00edpidos',
    code_2: 'E75',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E756',
    level: 3,
    description:
      'Trastorno del almacenamiento de l\u00edpidos, no especificado',
    code_2: 'E75',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E740',
    level: 3,
    description: 'Enfermedad del almacenamiento de gluc\u00f3geno',
    code_2: 'E74',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E741',
    level: 3,
    description: 'Trastornos del metabolismo de la fructosa',
    code_2: 'E74',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E742',
    level: 3,
    description: 'Trastorno del metabolismo de la galactosa',
    code_2: 'E74',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E743',
    level: 3,
    description:
      'Otros trastornos de la absorci\u00f3n intestinal de carbohidratos',
    code_2: 'E74',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E744',
    level: 3,
    description:
      'Trastornos del metabolismo del piruvato y de la gluconeog\u00e9nesis',
    code_2: 'E74',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E748',
    level: 3,
    description:
      'Otros trastornos especificados del metabolismo de los carbohidratos',
    code_2: 'E74',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E749',
    level: 3,
    description:
      'Trastorno del metabolismo de los carbohidratos, no especificado',
    code_2: 'E74',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E730',
    level: 3,
    description: 'Deficiencia cong\u00e9nita de lactasa',
    code_2: 'E73',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E731',
    level: 3,
    description: 'Deficiencia secundaria de lactasa',
    code_2: 'E73',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E738',
    level: 3,
    description: 'Otros tipos de intolerancia a la lactosa',
    code_2: 'E73',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E739',
    level: 3,
    description: 'Intolerancia a la lactosa, no especificada',
    code_2: 'E73',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E720',
    level: 3,
    description: 'Trastornos del transporte de los amino\u00e1cidos',
    code_2: 'E72',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E721',
    level: 3,
    description: 'Trastornos del metabolismo de los amino\u00e1cidos azufrados',
    code_2: 'E72',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E722',
    level: 3,
    description: 'Trastornos del metabolismo del ciclo de la urea',
    code_2: 'E72',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E723',
    level: 3,
    description: 'Trastornos del metabolismo de la lisina y la hidroxilisina',
    code_2: 'E72',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E724',
    level: 3,
    description: 'Trastornos del metabolismo de la ornitina',
    code_2: 'E72',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E725',
    level: 3,
    description: 'Trastornos del metabolismo de la glicina',
    code_2: 'E72',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E728',
    level: 3,
    description:
      'Otros trastornos especificados del metabolismo de los amino\u00e1cidos',
    code_2: 'E72',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E729',
    level: 3,
    description:
      'Trastorno del metabolismo de los amino\u00e1cidos, no especificado',
    code_2: 'E72',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'P080',
    level: 3,
    description: 'Reci\u00e9n nacido excepcionalmente grande',
    code_2: 'P08',
    code_0: 'P00-P96',
    code_1: 'P05-P08'
  },
  {
    code: 'P081',
    level: 3,
    description:
      'Otros reci\u00e9n nacidos con sobrepeso para la edad gestacional',
    code_2: 'P08',
    code_0: 'P00-P96',
    code_1: 'P05-P08'
  },
  {
    code: 'P082',
    level: 3,
    description:
      'Reci\u00e9n nacido post\u00e9rmino sin sobrepeso para su edad gestacional',
    code_2: 'P08',
    code_0: 'P00-P96',
    code_1: 'P05-P08'
  },
  {
    code: 'P070',
    level: 3,
    description: 'Peso extremadamente bajo al nacer',
    code_2: 'P07',
    code_0: 'P00-P96',
    code_1: 'P05-P08'
  },
  {
    code: 'P071',
    level: 3,
    description: 'Otro peso bajo al nacer',
    code_2: 'P07',
    code_0: 'P00-P96',
    code_1: 'P05-P08'
  },
  {
    code: 'P072',
    level: 3,
    description: 'Inmaturidad extrema',
    code_2: 'P07',
    code_0: 'P00-P96',
    code_1: 'P05-P08'
  },
  {
    code: 'P073',
    level: 3,
    description: 'Otros reci\u00e9n nacidos pret\u00e9rmino',
    code_2: 'P07',
    code_0: 'P00-P96',
    code_1: 'P05-P08'
  },
  {
    code: 'P290',
    level: 3,
    description: 'Insuficiencia card\u00edaca neonatal',
    code_2: 'P29',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P291',
    level: 3,
    description: 'Disritmia card\u00edaca neonatal',
    code_2: 'P29',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P292',
    level: 3,
    description: 'Hipertensi\u00f3n neonatal',
    code_2: 'P29',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P293',
    level: 3,
    description: 'Persistencia de la circulaci\u00f3n fetal',
    code_2: 'P29',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P294',
    level: 3,
    description: 'Isquemia mioc\u00e1rdica transitoria del reci\u00e9n nacido',
    code_2: 'P29',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P298',
    level: 3,
    description:
      'Otros trastornos cardiovasculares originados en el per\u00edodo perinatal',
    code_2: 'P29',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P299',
    level: 3,
    description:
      'Trastorno cardiovascular no especificado, originado en el per\u00edodo perinatal',
    code_2: 'P29',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P280',
    level: 3,
    description: 'Atelectasia primaria del reci\u00e9n nacido',
    code_2: 'P28',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P281',
    level: 3,
    description:
      'Otras atelectasias del reci\u00e9n nacido y las no especificadas',
    code_2: 'P28',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P282',
    level: 3,
    description: 'Ataque cian\u00f3tico del reci\u00e9n nacido',
    code_2: 'P28',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P283',
    level: 3,
    description: 'Apnea primaria del sue\u00f1o del reci\u00e9n nacido',
    code_2: 'P28',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P284',
    level: 3,
    description: 'Otras apneas del reci\u00e9n nacido',
    code_2: 'P28',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P285',
    level: 3,
    description: 'Insuficiencia respiratoria del reci\u00e9n nacido',
    code_2: 'P28',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P288',
    level: 3,
    description:
      'Otros problemas respiratorios especificados del reci\u00e9n nacido',
    code_2: 'P28',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P289',
    level: 3,
    description:
      'Afecci\u00f3n respiratoria no especificada del reci\u00e9n nacido',
    code_2: 'P28',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P270',
    level: 3,
    description: 'S\u00edndrome de Wilson\u2013Mikity',
    code_2: 'P27',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P271',
    level: 3,
    description:
      'Displasia broncopulmonar originada en el per\u00edodo perinatal',
    code_2: 'P27',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P278',
    level: 3,
    description:
      'Otras enfermedades respiratorias cr\u00f3nicas originadas en el per\u00edodo perinatal',
    code_2: 'P27',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P279',
    level: 3,
    description:
      'Enfermedad respiratoria cr\u00f3nica no especificada originada en el per\u00edodo perinatal',
    code_2: 'P27',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P260',
    level: 3,
    description:
      'Hemorragia traqueobronquial originada en el per\u00edodo perinatal',
    code_2: 'P26',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P261',
    level: 3,
    description:
      'Hemorragia pulmonar masiva originada en el per\u00edodo perinatal',
    code_2: 'P26',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P268',
    level: 3,
    description:
      'Otras hemorragias pulmonares originadas en el per\u00edodo perinatal',
    code_2: 'P26',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P269',
    level: 3,
    description:
      'Hemorragia pulmonar no especificada, originada en el per\u00edodo perinatal',
    code_2: 'P26',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P250',
    level: 3,
    description: 'Enfisema intersticial originado en el per\u00edodo perinatal',
    code_2: 'P25',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P240',
    level: 3,
    description: 'Aspiraci\u00f3n neonatal de meconio',
    code_2: 'P24',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P230',
    level: 3,
    description: 'Neumon\u00eda cong\u00e9nita debida a agente viral',
    code_2: 'P23',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P610',
    level: 3,
    description: 'Trombocitopenia neonatal transitoria',
    code_2: 'P61',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P590',
    level: 3,
    description:
      'Ictericia neonatal asociada con el parto antes de t\u00e9rmino',
    code_2: 'P59',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P580',
    level: 3,
    description: 'Ictericia neonatal debida a contusi\u00f3n',
    code_2: 'P58',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'D076',
    level: 3,
    description:
      'Carcinoma in situ de otros \u00f3rganos genitales masculinos y de los no especificados',
    code_2: 'D07',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'P570',
    level: 3,
    description: 'Kernicterus debido a incompatibilidad',
    code_2: 'P57',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P578',
    level: 3,
    description: 'Kernicterus debido a otras causas especificadas',
    code_2: 'P57',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P579',
    level: 3,
    description: 'Kernicterus, no especificado',
    code_2: 'P57',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'D169',
    level: 3,
    description:
      'Tumor benigno del hueso y del cart\u00edlago articular, sitio no especificado',
    code_2: 'D16',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'P560',
    level: 3,
    description: 'Hidropes\u00eda fetal debida a incompatibilidad',
    code_2: 'P56',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P569',
    level: 3,
    description:
      'Hidropes\u00eda fetal debida a otras enfermedades hemol\u00edticas especificadas y a las no especificadas',
    code_2: 'P56',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P550',
    level: 3,
    description: 'Incompatibilidad Rh del feto y del reci\u00e9n nacido',
    code_2: 'P55',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P540',
    level: 3,
    description: 'Hematemesis neonatal',
    code_2: 'P54',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'O080',
    level: 3,
    description:
      'Infecci\u00f3n genital y pelviana consecutiva al aborto, al embarazo ect\u00f3pico y al embarazo molar',
    code_2: 'O08',
    code_0: 'O00-O9A',
    code_1: 'O00-O08'
  },
  {
    code: 'O081',
    level: 3,
    description:
      'Hemorragia excesiva o tard\u00eda consecutiva al aborto, al embarazo ect\u00f3pico y al embarazo molar',
    code_2: 'O08',
    code_0: 'O00-O9A',
    code_1: 'O00-O08'
  },
  {
    code: 'O082',
    level: 3,
    description:
      'Embolia consecutiva al aborto, al embarazo ect\u00f3pico y al embarazo molar',
    code_2: 'O08',
    code_0: 'O00-O9A',
    code_1: 'O00-O08'
  },
  {
    code: 'O083',
    level: 3,
    description:
      'Choque consecutivo al aborto, al embarazo ect\u00f3pico y al embarazo molar',
    code_2: 'O08',
    code_0: 'O00-O9A',
    code_1: 'O00-O08'
  },
  {
    code: 'O070',
    level: 3,
    description:
      'Falla de la inducci\u00f3n m\u00e9dica del aborto, complicado por infecci\u00f3n genital y pelviana',
    code_2: 'O07',
    code_0: 'O00-O9A',
    code_1: 'O00-O08'
  },
  {
    code: 'O150',
    level: 3,
    description: 'Eclampsia en el embarazo',
    code_2: 'O15',
    code_0: 'O00-O9A',
    code_1: 'O10-O16'
  },
  {
    code: 'O151',
    level: 3,
    description: 'Eclampsia durante el trabajo de parto',
    code_2: 'O15',
    code_0: 'O00-O9A',
    code_1: 'O10-O16'
  },
  {
    code: 'O290',
    level: 3,
    description:
      'Complicaciones pulmonares de la anestesia administrada durante el embarazo',
    code_2: 'O29',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O280',
    level: 3,
    description:
      'Hallazgo hematol\u00f3gico anormal en el examen prenatal de la madre',
    code_2: 'O28',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O281',
    level: 3,
    description:
      'Hallazgo bioqu\u00edmico anormal en el examen prenatal de la madre',
    code_2: 'O28',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O282',
    level: 3,
    description:
      'Hallazgo citol\u00f3gico anormal en el examen prenatal de la madre',
    code_2: 'O28',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O283',
    level: 3,
    description:
      'Hallazgo ultras\u00f3nico anormal en el examen prenatal de la madre',
    code_2: 'O28',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O284',
    level: 3,
    description:
      'Hallazgo radiol\u00f3gico anormal en el examen prenatal de la madre',
    code_2: 'O28',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'S390',
    level: 3,
    description:
      'Traumatismo de tend\u00f3n y de m\u00fasculos del abdomen, de la regi\u00f3n lumbosacra y de la pelvis',
    code_2: 'S39',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'O460',
    level: 3,
    description: 'Hemorragia anteparto con defecto de la coagulaci\u00f3n',
    code_2: 'O46',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O468',
    level: 3,
    description: 'Otras hemorragias anteparto',
    code_2: 'O46',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O469',
    level: 3,
    description: 'Hemorragia anteparto, no especificada',
    code_2: 'O46',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O450',
    level: 3,
    description:
      'Desprendimiento prematuro de la placenta con defecto de la coagulaci\u00f3n',
    code_2: 'O45',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O458',
    level: 3,
    description: 'Otros desprendimientos prematuros de la placenta',
    code_2: 'O45',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O459',
    level: 3,
    description:
      'Desprendimiento prematuro de la placenta, sin otra especificaci\u00f3n',
    code_2: 'O45',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O440',
    level: 3,
    description:
      'Placenta previa con especificaci\u00f3n de que no hubo hemorragia',
    code_2: 'O44',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O441',
    level: 3,
    description: 'Placenta previa con hemorragia',
    code_2: 'O44',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'D448',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido con afectaci\u00f3n pluriglandular',
    code_2: 'D44',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D449',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido de gl\u00e1ndula endocrina no especificada',
    code_2: 'D44',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'I48',
    level: 2,
    description: 'Fibrilaci\u00f3n y aleteo auricular',
    code_1: 'I30-I52',
    code_0: 'I00-I99'
  },
  {
    code: 'I49',
    level: 2,
    description: 'Otras arritmias card\u00edacas',
    code_1: 'I30-I52',
    code_0: 'I00-I99'
  },
  {
    code: 'I50',
    level: 2,
    description: 'Insuficiencia card\u00edaca',
    code_1: 'I30-I52',
    code_0: 'I00-I99'
  },
  {
    code: 'I51',
    level: 2,
    description:
      'Complicaciones y descripciones mal definidas de enfermedad card\u00edaca',
    code_1: 'I30-I52',
    code_0: 'I00-I99'
  },
  {
    code: 'I52',
    level: 2,
    description:
      'Otros trastornos card\u00edacos en enfermedades clasificadas en otra parte',
    code_1: 'I30-I52',
    code_0: 'I00-I99'
  },
  {
    code: 'D330',
    level: 3,
    description: 'Tumor benigno del enc\u00e9falo, supratentorial',
    code_2: 'D33',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D331',
    level: 3,
    description: 'Tumor benigno del enc\u00e9falo, infratentorial',
    code_2: 'D33',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D332',
    level: 3,
    description: 'Tumor benigno del enc\u00e9falo, parte no especificada',
    code_2: 'D33',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D333',
    level: 3,
    description: 'Tumor benigno de los nervios craneales',
    code_2: 'D33',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D334',
    level: 3,
    description: 'Tumor benigno de la m\u00e9dula espinal',
    code_2: 'D33',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D337',
    level: 3,
    description:
      'Tumor benigno de otras partes especificadas del sistema nervioso central',
    code_2: 'D33',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D339',
    level: 3,
    description:
      'Tumor benigno del sistema nervioso central, sitio no especificado',
    code_2: 'D33',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D320',
    level: 3,
    description: 'Tumor benigno de las meninges cerebrales',
    code_2: 'D32',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D321',
    level: 3,
    description: 'Tumor benigno de las meninges raqu\u00eddeas',
    code_2: 'D32',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D329',
    level: 3,
    description: 'Tumor benigno de las meninges, parte no especificada',
    code_2: 'D32',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D310',
    level: 3,
    description: 'Tumor benigno de la conjuntiva',
    code_2: 'D31',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D311',
    level: 3,
    description: 'Tumor benigno de la c\u00f3rnea',
    code_2: 'D31',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D312',
    level: 3,
    description: 'Tumor benigno de la retina',
    code_2: 'D31',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D313',
    level: 3,
    description: 'Tumor benigno de la coroides',
    code_2: 'D31',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D314',
    level: 3,
    description: 'Tumor benigno del cuerpo ciliar',
    code_2: 'D31',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D315',
    level: 3,
    description:
      'Tumor benigno de las gl\u00e1ndulas y de los conductos lagrimales',
    code_2: 'D31',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D316',
    level: 3,
    description: 'Tumor benigno de la \u00f3rbita, parte no especificada',
    code_2: 'D31',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D319',
    level: 3,
    description: 'Tumor benigno del ojo, parte no especificada',
    code_2: 'D31',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D300',
    level: 3,
    description: 'Tumor benigno del ri\u00f1\u00f3n',
    code_2: 'D30',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D301',
    level: 3,
    description: 'Tumor benigno de la pelvis renal',
    code_2: 'D30',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D302',
    level: 3,
    description: 'Tumor benigno del ur\u00e9ter',
    code_2: 'D30',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D303',
    level: 3,
    description: 'Tumor benigno de la vejiga',
    code_2: 'D30',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D304',
    level: 3,
    description: 'Tumor benigno de la uretra',
    code_2: 'D30',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D307',
    level: 3,
    description: 'Tumor benigno de otros \u00f3rganos urinarios',
    code_2: 'D30',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D309',
    level: 3,
    description: 'Tumor benigno de \u00f3rgano urinario no especificado',
    code_2: 'D30',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D290',
    level: 3,
    description: 'Tumor benigno del pene',
    code_2: 'D29',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D291',
    level: 3,
    description: 'Tumor benigno de la pr\u00f3stata',
    code_2: 'D29',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D292',
    level: 3,
    description: 'Tumor benigno de los test\u00edculos',
    code_2: 'D29',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D293',
    level: 3,
    description: 'Tumor benigno del epid\u00eddimo',
    code_2: 'D29',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D294',
    level: 3,
    description: 'Tumor benigno del escroto',
    code_2: 'D29',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D297',
    level: 3,
    description: 'Tumor benigno de otros \u00f3rganos genitales masculinos',
    code_2: 'D29',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D299',
    level: 3,
    description:
      'Tumor benigno de \u00f3rgano genital masculino, sitio no especificado',
    code_2: 'D29',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D280',
    level: 3,
    description: 'Tumor benigno de la vulva',
    code_2: 'D28',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D281',
    level: 3,
    description: 'Tumor benigno de la vagina',
    code_2: 'D28',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D282',
    level: 3,
    description:
      'Tumor benigno de la trompa de Falopio y de los ligamentos uterinos',
    code_2: 'D28',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D287',
    level: 3,
    description:
      'Tumor benigno de otros sitios especificados de los \u00f3rganos genitales femeninos',
    code_2: 'D28',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D289',
    level: 3,
    description:
      'Tumor benigno de \u00f3rgano genital femenino, sitio no especificado',
    code_2: 'D28',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'R090',
    level: 3,
    description: 'Asfixia',
    code_2: 'R09',
    code_0: 'R00-R99',
    code_1: 'R00-R09'
  },
  {
    code: 'R091',
    level: 3,
    description: 'Pleures\u00eda',
    code_2: 'R09',
    code_0: 'R00-R99',
    code_1: 'R00-R09'
  },
  {
    code: 'R092',
    level: 3,
    description: 'Paro respiratorio',
    code_2: 'R09',
    code_0: 'R00-R99',
    code_1: 'R00-R09'
  },
  {
    code: 'R093',
    level: 3,
    description: 'Esputo anormal',
    code_2: 'R09',
    code_0: 'R00-R99',
    code_1: 'R00-R09'
  },
  {
    code: 'R098',
    level: 3,
    description:
      'Otros s\u00edntomas y signos especificados que involucran los sistemas circulatorio y respiratorio',
    code_2: 'R09',
    code_0: 'R00-R99',
    code_1: 'R00-R09'
  },
  {
    code: 'R070',
    level: 3,
    description: 'Dolor de garganta',
    code_2: 'R07',
    code_0: 'R00-R99',
    code_1: 'R00-R09'
  },
  {
    code: 'R071',
    level: 3,
    description: 'Dolor en el pecho al respirar',
    code_2: 'R07',
    code_0: 'R00-R99',
    code_1: 'R00-R09'
  },
  {
    code: 'R072',
    level: 3,
    description: 'Dolor precordial',
    code_2: 'R07',
    code_0: 'R00-R99',
    code_1: 'R00-R09'
  },
  {
    code: 'R073',
    level: 3,
    description: 'Otros dolores en el pecho',
    code_2: 'R07',
    code_0: 'R00-R99',
    code_1: 'R00-R09'
  },
  {
    code: 'R074',
    level: 3,
    description: 'Dolor en el pecho, no especificado',
    code_2: 'R07',
    code_0: 'R00-R99',
    code_1: 'R00-R09'
  },
  {
    code: 'R060',
    level: 3,
    description: 'Disnea',
    code_2: 'R06',
    code_0: 'R00-R99',
    code_1: 'R00-R09'
  },
  {
    code: 'R061',
    level: 3,
    description: 'Estridor',
    code_2: 'R06',
    code_0: 'R00-R99',
    code_1: 'R00-R09'
  },
  {
    code: 'R062',
    level: 3,
    description: 'Silbido',
    code_2: 'R06',
    code_0: 'R00-R99',
    code_1: 'R00-R09'
  },
  {
    code: 'R063',
    level: 3,
    description: 'Respiraci\u00f3n peri\u00f3dica',
    code_2: 'R06',
    code_0: 'R00-R99',
    code_1: 'R00-R09'
  },
  {
    code: 'R064',
    level: 3,
    description: 'Hiperventilaci\u00f3n',
    code_2: 'R06',
    code_0: 'R00-R99',
    code_1: 'R00-R09'
  },
  {
    code: 'R065',
    level: 3,
    description: 'Respiraci\u00f3n con la boca',
    code_2: 'R06',
    code_0: 'R00-R99',
    code_1: 'R00-R09'
  },
  {
    code: 'R066',
    level: 3,
    description: 'Hipo',
    code_2: 'R06',
    code_0: 'R00-R99',
    code_1: 'R00-R09'
  },
  {
    code: 'R067',
    level: 3,
    description: 'Estornudo',
    code_2: 'R06',
    code_0: 'R00-R99',
    code_1: 'R00-R09'
  },
  {
    code: 'R068',
    level: 3,
    description:
      'Otras anormalidades de la respiraci\u00f3n y las no especificadas',
    code_2: 'R06',
    code_0: 'R00-R99',
    code_1: 'R00-R09'
  },
  {
    code: 'Q180',
    level: 3,
    description: 'Seno, f\u00edstula o quiste de la hendidura branquial',
    code_2: 'Q18',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q181',
    level: 3,
    description: 'Seno y quiste preauricular',
    code_2: 'Q18',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q182',
    level: 3,
    description: 'Otras malformaciones de las hendiduras branquiales',
    code_2: 'Q18',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q183',
    level: 3,
    description: 'Pterigi\u00f3n del cuello',
    code_2: 'Q18',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q184',
    level: 3,
    description: 'Macrostom\u00eda',
    code_2: 'Q18',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q185',
    level: 3,
    description: 'Microstom\u00eda',
    code_2: 'Q18',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q186',
    level: 3,
    description: 'Macroqueilia',
    code_2: 'Q18',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q187',
    level: 3,
    description: 'Microqueilia',
    code_2: 'Q18',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q188',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas especificadas de cara y cuello',
    code_2: 'Q18',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q189',
    level: 3,
    description:
      'Malformaci\u00f3n cong\u00e9nita de la cara y del cuello, no especificada',
    code_2: 'Q18',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'E890',
    level: 3,
    description: 'Hipotiroidismo consecutivo a procedimientos',
    code_2: 'E89',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E891',
    level: 3,
    description: 'Hipoinsulinemia consecutiva a procedimientos',
    code_2: 'E89',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E892',
    level: 3,
    description: 'Hipoparatiroidismo consecutivo a procedimientos',
    code_2: 'E89',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E893',
    level: 3,
    description: 'Hipopituitarismo consecutivo a procedimientos',
    code_2: 'E89',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E894',
    level: 3,
    description: 'Insuficiencia ov\u00e1rica consecutiva a procedimientos',
    code_2: 'E89',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E895',
    level: 3,
    description: 'Hipofunci\u00f3n testicular consecutiva a procedimientos',
    code_2: 'E89',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E896',
    level: 3,
    description:
      'Hipofunci\u00f3n adrenocortical [m\u00e9dula suprarrenal] consecutiva a procedimientos',
    code_2: 'E89',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E898',
    level: 3,
    description:
      'Otros trastornos metab\u00f3licos y endocrinos consecutivos a procedimientos',
    code_2: 'E89',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E880',
    level: 3,
    description:
      'Trastornos del metabolismo de las prote\u00ednas plasm\u00e1ticas, no clasificados en otra parte',
    code_2: 'E88',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E881',
    level: 3,
    description: 'Lipodistrofia, no clasificada en otra parte',
    code_2: 'E88',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E882',
    level: 3,
    description: 'Lipomatosis, no clasificada en otra parte',
    code_2: 'E88',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E888',
    level: 3,
    description: 'Otros trastornos especificados del metabolismo',
    code_2: 'E88',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E889',
    level: 3,
    description: 'Trastorno metab\u00f3lico, no especificado',
    code_2: 'E88',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E870',
    level: 3,
    description: 'Hiperosmolaridad e hipernatremia',
    code_2: 'E87',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E871',
    level: 3,
    description: 'Hiposmolaridad e hiponatremia',
    code_2: 'E87',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E872',
    level: 3,
    description: 'Acidosis',
    code_2: 'E87',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E873',
    level: 3,
    description: 'Alcalosis:',
    code_2: 'E87',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E874',
    level: 3,
    description: 'Trastornos mixtos del balance \u00e1cido-b\u00e1sico',
    code_2: 'E87',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E875',
    level: 3,
    description: 'Hiperpotasemia',
    code_2: 'E87',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E876',
    level: 3,
    description: 'Hipopotasmia',
    code_2: 'E87',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E877',
    level: 3,
    description: 'Sobrecarga de l\u00edquidos',
    code_2: 'E87',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E850',
    level: 3,
    description: 'Amiloidosis heredofamiliar no neurop\u00e1tica',
    code_2: 'E85',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E851',
    level: 3,
    description: 'Amiloidosis heredofamiliar neurop\u00e1tica',
    code_2: 'E85',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E852',
    level: 3,
    description: 'Amiloidosis heredofamiliar no especificada',
    code_2: 'E85',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E853',
    level: 3,
    description: 'Amiloidosis sist\u00e9mica secundaria',
    code_2: 'E85',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E854',
    level: 3,
    description: 'Amiloidosis limitada a un \u00f3rgano',
    code_2: 'E85',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E858',
    level: 3,
    description: 'Otras amiloidosis',
    code_2: 'E85',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E859',
    level: 3,
    description: 'Amiloidosis, no especificada',
    code_2: 'E85',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E840',
    level: 3,
    description: 'Fibrosis qu\u00edstica con manifestaciones pulmonares',
    code_2: 'E84',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E841',
    level: 3,
    description: 'Fibrosis qu\u00edstica con manifestaciones intestinales',
    code_2: 'E84',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E848',
    level: 3,
    description: 'Fibrosis qu\u00edstica con otras manifestaciones',
    code_2: 'E84',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E849',
    level: 3,
    description: 'Fibrosis qu\u00edstica, sin otra especificaci\u00f3n',
    code_2: 'E84',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'O470',
    level: 3,
    description:
      'Falso trabajo de parto antes de las 37 semanas completas de gestaci\u00f3n',
    code_2: 'O47',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O471',
    level: 3,
    description:
      'Falso trabajo de parto a las 37 y m\u00e1s semanas completas de gestaci\u00f3n',
    code_2: 'O47',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O479',
    level: 3,
    description: 'Falso trabajo de parto, sin otra especificaci\u00f3n',
    code_2: 'O47',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'A490',
    level: 3,
    description: 'Infecci\u00f3n estafiloc\u00f3cica, de sitio no especificado',
    code_2: 'A49',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A491',
    level: 3,
    description: 'Infecci\u00f3n estreptoc\u00f3cica, de sitio no especificado',
    code_2: 'A49',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A492',
    level: 3,
    description:
      'Infecci\u00f3n por Haemophilus influenzae, de sitio no especificado',
    code_2: 'A49',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A493',
    level: 3,
    description: 'Infecci\u00f3n por micoplasma, de sitio no especificado',
    code_2: 'A49',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A498',
    level: 3,
    description: 'Otras infecciones bacterianas, de sitio no especificado',
    code_2: 'A49',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A499',
    level: 3,
    description: 'Infecci\u00f3n bacteriana, no especificada',
    code_2: 'A49',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A480',
    level: 3,
    description: 'Gangrena gaseosa',
    code_2: 'A48',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A440',
    level: 3,
    description: 'Bartonelosis sist\u00e9mica',
    code_2: 'A44',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A441',
    level: 3,
    description: 'Bartonelosis cut\u00e1nea y mucocut\u00e1nea',
    code_2: 'A44',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A448',
    level: 3,
    description: 'Otras formas de bartonelosis',
    code_2: 'A44',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A449',
    level: 3,
    description: 'Bartonelosis, no especificada',
    code_2: 'A44',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'N390',
    level: 3,
    description: 'Infecci\u00f3n de v\u00edas urinarias, sitio no especificado',
    code_2: 'N39',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N391',
    level: 3,
    description: 'Proteinuria persistente, no especificada',
    code_2: 'N39',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N392',
    level: 3,
    description: 'Proteinuria ortost\u00e1tica, no especificada',
    code_2: 'N39',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N393',
    level: 3,
    description: 'Incontinencia urinaria por tensi\u00f3n',
    code_2: 'N39',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N394',
    level: 3,
    description: 'Otras incontinencias urinarias especificadas',
    code_2: 'N39',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N370',
    level: 3,
    description: 'Uretritis en enfermedades clasificadas en otra parte',
    code_2: 'N37',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N378',
    level: 3,
    description:
      'Otros trastornos uretrales en enfermedades clasificadas en otra parte',
    code_2: 'N37',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N361',
    level: 3,
    description: 'Divert\u00edculo de la uretra',
    code_2: 'N36',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N362',
    level: 3,
    description: 'Car\u00fancula uretral',
    code_2: 'N36',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N363',
    level: 3,
    description: 'Prolapso de la mucosa uretral',
    code_2: 'N36',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N368',
    level: 3,
    description: 'Otros trastornos especificados de la uretra',
    code_2: 'N36',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N369',
    level: 3,
    description: 'Trastorno de la uretra, no especificado',
    code_2: 'N36',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N350',
    level: 3,
    description: 'Estrechez uretral postraum\u00e1tica',
    code_2: 'N35',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N351',
    level: 3,
    description:
      'Estrechez uretral postinfecci\u00f3n, no clasificada en otra parte',
    code_2: 'N35',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N358',
    level: 3,
    description: 'Otras estrecheces uretrales',
    code_2: 'N35',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N359',
    level: 3,
    description: 'Estrechez uretral, no especificada',
    code_2: 'N35',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N340',
    level: 3,
    description: 'Absceso uretral',
    code_2: 'N34',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N341',
    level: 3,
    description: 'Uretritis no espec\u00edfica',
    code_2: 'N34',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N342',
    level: 3,
    description: 'Otras uretritis',
    code_2: 'N34',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N343',
    level: 3,
    description: 'S\u00edndrome uretral, no especificado',
    code_2: 'N34',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N510',
    level: 3,
    description:
      'Trastornos de pr\u00f3stata en enfermedades clasificadas en otra parte',
    code_2: 'N51',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N511',
    level: 3,
    description:
      'Trastornos del test\u00edculo y del epid\u00eddimo en enfermedades clasificadas en otra parte',
    code_2: 'N51',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N512',
    level: 3,
    description: 'Balanitis en enfermedades clasificadas en otra parte',
    code_2: 'N51',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N518',
    level: 3,
    description:
      'Otros trastornos de los \u00f3rganos genitales masculinos en enfermedades clasificadas en otra parte',
    code_2: 'N51',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N500',
    level: 3,
    description: 'Atrofia del test\u00edculo',
    code_2: 'N50',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N501',
    level: 3,
    description:
      'Trastornos vasculares de los \u00f3rganos genitales masculinos',
    code_2: 'N50',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N508',
    level: 3,
    description:
      'Otros trastornos especificados de los \u00f3rganos genitales masculinos',
    code_2: 'N50',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N509',
    level: 3,
    description:
      'Trastorno no especificado de los \u00f3rganos genitales masculinos',
    code_2: 'N50',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N490',
    level: 3,
    description: 'Trastornos inflamatorios de ves\u00edcula seminal',
    code_2: 'N49',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N491',
    level: 3,
    description:
      'Trastornos inflamatorios del cord\u00f3n esperm\u00e1tico, t\u00fanica vaginal y conducto deferente',
    code_2: 'N49',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N492',
    level: 3,
    description: 'Trastornos inflamatorios del escroto',
    code_2: 'N49',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N498',
    level: 3,
    description:
      'Otros trastornos inflamatorios de los \u00f3rganos genitales masculinos',
    code_2: 'N49',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N499',
    level: 3,
    description:
      'Trastorno inflamatorio de \u00f3rgano genital masculino, no especificado',
    code_2: 'N49',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N480',
    level: 3,
    description: 'Leucoplasia del pene',
    code_2: 'N48',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N481',
    level: 3,
    description: 'Balanopostitis',
    code_2: 'N48',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N482',
    level: 3,
    description: 'Otros trastornos inflamatorios del pene',
    code_2: 'N48',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N483',
    level: 3,
    description: 'Priapismo',
    code_2: 'N48',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N484',
    level: 3,
    description: 'Impotencia de origen org\u00e1nico',
    code_2: 'N48',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N485',
    level: 3,
    description: '\u00dalcera del pene',
    code_2: 'N48',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N486',
    level: 3,
    description: 'Induraci\u00f3n pl\u00e1stica del pene',
    code_2: 'N48',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N640',
    level: 3,
    description: 'Fisura y f\u00edstula del pez\u00f3n',
    code_2: 'N64',
    code_0: 'N00-N99',
    code_1: 'N60-N64'
  },
  {
    code: 'N641',
    level: 3,
    description: 'Necrosis grasa de la mama',
    code_2: 'N64',
    code_0: 'N00-N99',
    code_1: 'N60-N64'
  },
  {
    code: 'N642',
    level: 3,
    description: 'Atrofia de la mama',
    code_2: 'N64',
    code_0: 'N00-N99',
    code_1: 'N60-N64'
  },
  {
    code: 'N643',
    level: 3,
    description: 'Galactorrea no asociada con el parto',
    code_2: 'N64',
    code_0: 'N00-N99',
    code_1: 'N60-N64'
  },
  {
    code: 'N644',
    level: 3,
    description: 'Mastodinia',
    code_2: 'N64',
    code_0: 'N00-N99',
    code_1: 'N60-N64'
  },
  {
    code: 'N645',
    level: 3,
    description: 'Otros signos y s\u00edntomas relativos a la mama',
    code_2: 'N64',
    code_0: 'N00-N99',
    code_1: 'N60-N64'
  },
  {
    code: 'N648',
    level: 3,
    description: 'Otros trastornos especificados de la mama',
    code_2: 'N64',
    code_0: 'N00-N99',
    code_1: 'N60-N64'
  },
  {
    code: 'N649',
    level: 3,
    description: 'Trastorno de la mama, no especificado',
    code_2: 'N64',
    code_0: 'N00-N99',
    code_1: 'N60-N64'
  },
  {
    code: 'N770',
    level: 3,
    description:
      'Ulceraci\u00f3n de la vulva en enfermedades infecciosas y parasitarias clasificadas en otra parte',
    code_2: 'N77',
    code_0: 'N00-N99',
    code_1: 'N70-N77'
  },
  {
    code: 'N771',
    level: 3,
    description:
      'Vaginitis, vulvitis y vulvovaginitis en enfermedades infecciosas y parasitarias clasificadas en otra parte',
    code_2: 'N77',
    code_0: 'N00-N99',
    code_1: 'N70-N77'
  },
  {
    code: 'N778',
    level: 3,
    description:
      'Ulceraci\u00f3n e inflamaci\u00f3n vulvovaginal en otras enfermedades clasificadas en otra parte',
    code_2: 'N77',
    code_0: 'N00-N99',
    code_1: 'N70-N77'
  },
  {
    code: 'N760',
    level: 3,
    description: 'Vaginitis aguda',
    code_2: 'N76',
    code_0: 'N00-N99',
    code_1: 'N70-N77'
  },
  {
    code: 'N761',
    level: 3,
    description: 'Vaginitis subaguda y cr\u00f3nica',
    code_2: 'N76',
    code_0: 'N00-N99',
    code_1: 'N70-N77'
  },
  {
    code: 'N762',
    level: 3,
    description: 'Vulvitis aguda',
    code_2: 'N76',
    code_0: 'N00-N99',
    code_1: 'N70-N77'
  },
  {
    code: 'N763',
    level: 3,
    description: 'Vulvitis subaguda y cr\u00f3nica',
    code_2: 'N76',
    code_0: 'N00-N99',
    code_1: 'N70-N77'
  },
  {
    code: 'N764',
    level: 3,
    description: 'Absceso vulvar',
    code_2: 'N76',
    code_0: 'N00-N99',
    code_1: 'N70-N77'
  },
  {
    code: 'N765',
    level: 3,
    description: 'Ulceraci\u00f3n de la vagina',
    code_2: 'N76',
    code_0: 'N00-N99',
    code_1: 'N70-N77'
  },
  {
    code: 'N766',
    level: 3,
    description: 'Ulceraci\u00f3n de la vulva',
    code_2: 'N76',
    code_0: 'N00-N99',
    code_1: 'N70-N77'
  },
  {
    code: 'N750',
    level: 3,
    description: 'Quiste de la gl\u00e1ndula de Bartholin',
    code_2: 'N75',
    code_0: 'N00-N99',
    code_1: 'N70-N77'
  },
  {
    code: 'N751',
    level: 3,
    description: 'Absceso de la gl\u00e1ndula de Bartholin',
    code_2: 'N75',
    code_0: 'N00-N99',
    code_1: 'N70-N77'
  },
  {
    code: 'N758',
    level: 3,
    description: 'Otras enfermedades de la gl\u00e1ndula de Bartholin',
    code_2: 'N75',
    code_0: 'N00-N99',
    code_1: 'N70-N77'
  },
  {
    code: 'N759',
    level: 3,
    description: 'Enfermedad de la gl\u00e1ndula de Bartholin, no especificada',
    code_2: 'N75',
    code_0: 'N00-N99',
    code_1: 'N70-N77'
  },
  {
    code: 'N910',
    level: 3,
    description: 'Amenorrea primaria',
    code_2: 'N91',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N911',
    level: 3,
    description: 'Amenorrea secundaria',
    code_2: 'N91',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N912',
    level: 3,
    description: 'Amenorrea, sin otra especificaci\u00f3n',
    code_2: 'N91',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N913',
    level: 3,
    description: 'Oligomenorrea primaria',
    code_2: 'N91',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N914',
    level: 3,
    description: 'Oligomenorrea secundaria',
    code_2: 'N91',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N915',
    level: 3,
    description: 'Oligomenorrea, no especificada',
    code_2: 'N91',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N900',
    level: 3,
    description: 'Displasia vulvar leve',
    code_2: 'N90',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N901',
    level: 3,
    description: 'Displasia vulvar moderada',
    code_2: 'N90',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N902',
    level: 3,
    description: 'Displasia vulvar severa, no clasificada en otra parte',
    code_2: 'N90',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N903',
    level: 3,
    description: 'Displasia de la vulva, no especificada',
    code_2: 'N90',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N904',
    level: 3,
    description: 'Leucoplasia de la vulva',
    code_2: 'N90',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N905',
    level: 3,
    description: 'Atrofia de la vulva',
    code_2: 'N90',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N906',
    level: 3,
    description: 'Hipertrofia de la vulva',
    code_2: 'N90',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N907',
    level: 3,
    description: 'Quiste de la vulva',
    code_2: 'N90',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N890',
    level: 3,
    description: 'Displasia vaginal leve',
    code_2: 'N89',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N891',
    level: 3,
    description: 'Displasia vaginal moderada',
    code_2: 'N89',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N892',
    level: 3,
    description: 'Displasia vaginal severa, no clasificada en otra parte',
    code_2: 'N89',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N893',
    level: 3,
    description: 'Displasia de la vagina, no especificada',
    code_2: 'N89',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N894',
    level: 3,
    description: 'Leucoplasia de la vagina',
    code_2: 'N89',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N895',
    level: 3,
    description: 'Estrechez y atresia de la vagina',
    code_2: 'N89',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N896',
    level: 3,
    description: 'Anillo de himen estrecho',
    code_2: 'N89',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N880',
    level: 3,
    description: 'Leucoplasia del cuello del \u00fatero',
    code_2: 'N88',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N881',
    level: 3,
    description: 'Laceraci\u00f3n antigua del cuello del \u00fatero',
    code_2: 'N88',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N882',
    level: 3,
    description: 'Estrechez y estenosis del cuello del \u00fatero',
    code_2: 'N88',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N883',
    level: 3,
    description: 'Incompetencia del cuello del \u00fatero',
    code_2: 'N88',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N884',
    level: 3,
    description: 'Elongaci\u00f3n hipertr\u00f3fica del cuello del \u00fatero',
    code_2: 'N88',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N888',
    level: 3,
    description:
      'Otros trastornos no inflamatorios especificados del cuello del \u00fatero',
    code_2: 'N88',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N889',
    level: 3,
    description:
      'Trastorno no inflamatorio del cuello del \u00fatero, no especificado',
    code_2: 'N88',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N870',
    level: 3,
    description: 'Displasia cervical leve',
    code_2: 'N87',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N871',
    level: 3,
    description: 'Displasia cervical moderada',
    code_2: 'N87',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N872',
    level: 3,
    description: 'Displasia cervical severa, no clasificada en otra parte',
    code_2: 'N87',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N879',
    level: 3,
    description: 'Displasia del cuello del \u00fatero, no especificada',
    code_2: 'N87',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N850',
    level: 3,
    description: 'Hiperplasia de gl\u00e1ndula del endometrio:',
    code_2: 'N85',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N851',
    level: 3,
    description: 'Hiperplasia adenomatosa del endometrio',
    code_2: 'N85',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N852',
    level: 3,
    description: 'Hipertrofia del \u00fatero',
    code_2: 'N85',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N853',
    level: 3,
    description: 'Subinvoluci\u00f3n del \u00fatero',
    code_2: 'N85',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N854',
    level: 3,
    description: 'Mala posici\u00f3n del \u00fatero',
    code_2: 'N85',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N855',
    level: 3,
    description: 'Inversi\u00f3n del \u00fatero',
    code_2: 'N85',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N856',
    level: 3,
    description: 'Sinequias intrauterinas',
    code_2: 'N85',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N857',
    level: 3,
    description: 'Hemat\u00f3metra',
    code_2: 'N85',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N858',
    level: 3,
    description:
      'Otros trastornos no inflamatorios especificados del \u00fatero',
    code_2: 'N85',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N859',
    level: 3,
    description: 'Trastorno no inflamatorio del \u00fatero, no especificado',
    code_2: 'N85',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N840',
    level: 3,
    description: 'P\u00f3lipo del cuerpo del \u00fatero',
    code_2: 'N84',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N841',
    level: 3,
    description: 'P\u00f3lipo del cuello del \u00fatero',
    code_2: 'N84',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N842',
    level: 3,
    description: 'P\u00f3lipo de la vagina',
    code_2: 'N84',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N843',
    level: 3,
    description: 'P\u00f3lipo de la vulva',
    code_2: 'N84',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N848',
    level: 3,
    description: 'P\u00f3lipos de otras partes del tracto genital femenino',
    code_2: 'N84',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N849',
    level: 3,
    description: 'P\u00f3lipo del tracto genital femenino, no especificado',
    code_2: 'N84',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'K140',
    level: 3,
    description: 'Glositis',
    code_2: 'K14',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K141',
    level: 3,
    description: 'Lengua geogr\u00e1fica',
    code_2: 'K14',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K142',
    level: 3,
    description: 'Glositis romboidea mediana',
    code_2: 'K14',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K143',
    level: 3,
    description: 'Hipertrofia de las papilas linguales',
    code_2: 'K14',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K144',
    level: 3,
    description: 'Atrofia de las papilas linguales',
    code_2: 'K14',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K145',
    level: 3,
    description: 'Lengua plegada',
    code_2: 'K14',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K146',
    level: 3,
    description: 'Glosodinia',
    code_2: 'K14',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K148',
    level: 3,
    description: 'Otras enfermedades de la lengua',
    code_2: 'K14',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K149',
    level: 3,
    description: 'Enfermedad de la lengua, no especificada',
    code_2: 'K14',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'B080',
    level: 3,
    description: 'Otras infecciones debidas a ortopoxvirus',
    code_2: 'B08',
    code_0: 'A00-B99',
    code_1: 'B00-B09'
  },
  {
    code: 'B081',
    level: 3,
    description: 'Molusco contagioso',
    code_2: 'B08',
    code_0: 'A00-B99',
    code_1: 'B00-B09'
  },
  {
    code: 'B082',
    level: 3,
    description: 'Exantema s\u00fabito [sexta enfermedad]',
    code_2: 'B08',
    code_0: 'A00-B99',
    code_1: 'B00-B09'
  },
  {
    code: 'B083',
    level: 3,
    description: 'Eritema infeccioso [quinta enfermedad]',
    code_2: 'B08',
    code_0: 'A00-B99',
    code_1: 'B00-B09'
  },
  {
    code: 'B084',
    level: 3,
    description: 'Estomatitis vesicular enteroviral con exantema',
    code_2: 'B08',
    code_0: 'A00-B99',
    code_1: 'B00-B09'
  },
  {
    code: 'B085',
    level: 3,
    description: 'Faringitis vesicular enterov\u00edrica',
    code_2: 'B08',
    code_0: 'A00-B99',
    code_1: 'B00-B09'
  },
  {
    code: 'B088',
    level: 3,
    description:
      'Otras infecciones virales especificadas, caracterizadas por lesiones de la piel y de las membranas mucosas',
    code_2: 'B08',
    code_0: 'A00-B99',
    code_1: 'B00-B09'
  },
  {
    code: 'B060',
    level: 3,
    description: 'Rub\u00e9ola con complicaciones neurol\u00f3gicas',
    code_2: 'B06',
    code_0: 'A00-B99',
    code_1: 'B00-B09'
  },
  {
    code: 'B068',
    level: 3,
    description: 'Rub\u00e9ola con otras complicaciones',
    code_2: 'B06',
    code_0: 'A00-B99',
    code_1: 'B00-B09'
  },
  {
    code: 'B069',
    level: 3,
    description: 'Rub\u00e9ola sin complicaciones',
    code_2: 'B06',
    code_0: 'A00-B99',
    code_1: 'B00-B09'
  },
  {
    code: 'B050',
    level: 3,
    description: 'Sarampi\u00f3n complicado con encefalitis (G05.1)',
    code_2: 'B05',
    code_0: 'A00-B99',
    code_1: 'B00-B09'
  },
  {
    code: 'B051',
    level: 3,
    description: 'Sarampi\u00f3n complicado con meningitis (G02.0)',
    code_2: 'B05',
    code_0: 'A00-B99',
    code_1: 'B00-B09'
  },
  {
    code: 'B052',
    level: 3,
    description: 'Sarampi\u00f3n complicado con neumon\u00eda (J17.1)',
    code_2: 'B05',
    code_0: 'A00-B99',
    code_1: 'B00-B09'
  },
  {
    code: 'B053',
    level: 3,
    description: 'Sarampi\u00f3n complicado con otitis media (H67.1)',
    code_2: 'B05',
    code_0: 'A00-B99',
    code_1: 'B00-B09'
  },
  {
    code: 'B054',
    level: 3,
    description: 'Sarampi\u00f3n con complicaciones intestinales',
    code_2: 'B05',
    code_0: 'A00-B99',
    code_1: 'B00-B09'
  },
  {
    code: 'B058',
    level: 3,
    description: 'Sarampi\u00f3n con otras complicaciones',
    code_2: 'B05',
    code_0: 'A00-B99',
    code_1: 'B00-B09'
  },
  {
    code: 'B059',
    level: 3,
    description: 'Sarampi\u00f3n sin complicaciones',
    code_2: 'B05',
    code_0: 'A00-B99',
    code_1: 'B00-B09'
  },
  {
    code: 'S697',
    level: 3,
    description: 'Traumatismos m\u00faltiples de la mu\u00f1eca y de la mano',
    code_2: 'S69',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S698',
    level: 3,
    description:
      'Otros traumatismos especificados de la mu\u00f1eca y de la mano',
    code_2: 'S69',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S699',
    level: 3,
    description: 'Traumatismo no especificado de la mu\u00f1eca y de la mano',
    code_2: 'S69',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'B340',
    level: 3,
    description: 'Infecci\u00f3n debida a adenovirus, de sitio no especificado',
    code_2: 'B34',
    code_0: 'A00-B99',
    code_1: 'B25-B34'
  },
  {
    code: 'B341',
    level: 3,
    description:
      'Infecci\u00f3n debida a enterovirus, de sitio no especificado',
    code_2: 'B34',
    code_0: 'A00-B99',
    code_1: 'B25-B34'
  },
  {
    code: 'B342',
    level: 3,
    description:
      'Infecci\u00f3n debida a Coronavirus, de sitio no especificado',
    code_2: 'B34',
    code_0: 'A00-B99',
    code_1: 'B25-B34'
  },
  {
    code: 'B343',
    level: 3,
    description: 'Infecci\u00f3n debida a Parvovirus, de sitio no especificado',
    code_2: 'B34',
    code_0: 'A00-B99',
    code_1: 'B25-B34'
  },
  {
    code: 'B344',
    level: 3,
    description:
      'Infecci\u00f3n debida a Papovavirus, de sitio no especificado',
    code_2: 'B34',
    code_0: 'A00-B99',
    code_1: 'B25-B34'
  },
  {
    code: 'B348',
    level: 3,
    description: 'Otras infecciones virales, de sitio no especificado',
    code_2: 'B34',
    code_0: 'A00-B99',
    code_1: 'B25-B34'
  },
  {
    code: 'B349',
    level: 3,
    description: 'Infecci\u00f3n viral, no especificada',
    code_2: 'B34',
    code_0: 'A00-B99',
    code_1: 'B25-B34'
  },
  {
    code: 'B330',
    level: 3,
    description: 'Mialgia epid\u00e9mica',
    code_2: 'B33',
    code_0: 'A00-B99',
    code_1: 'B25-B34'
  },
  {
    code: 'B331',
    level: 3,
    description: 'Enfermedad del r\u00edo Ross',
    code_2: 'B33',
    code_0: 'A00-B99',
    code_1: 'B25-B34'
  },
  {
    code: 'B332',
    level: 3,
    description: 'Carditis viral',
    code_2: 'B33',
    code_0: 'A00-B99',
    code_1: 'B25-B34'
  },
  {
    code: 'B333',
    level: 3,
    description:
      'Infecciones debidas a retrovirus, no clasificadas en otra parte',
    code_2: 'B33',
    code_0: 'A00-B99',
    code_1: 'B25-B34'
  },
  {
    code: 'B334',
    level: 3,
    description:
      'S\u00edndrome (cardio)-pulmonar por hantavirus [SPH] [SCPH] (J17.1)',
    code_2: 'B33',
    code_0: 'A00-B99',
    code_1: 'B25-B34'
  },
  {
    code: 'B338',
    level: 3,
    description: 'Otras enfermedades virales especificadas',
    code_2: 'B33',
    code_0: 'A00-B99',
    code_1: 'B25-B34'
  },
  {
    code: 'B300',
    level: 3,
    description: 'Queratoconjuntivitis debida a adenovirus (H19.2)',
    code_2: 'B30',
    code_0: 'A00-B99',
    code_1: 'B25-B34'
  },
  {
    code: 'B301',
    level: 3,
    description: 'Conjuntivitis debida a adenovirus (H13.1)',
    code_2: 'B30',
    code_0: 'A00-B99',
    code_1: 'B25-B34'
  },
  {
    code: 'B302',
    level: 3,
    description: 'Faringoconjuntivitis viral',
    code_2: 'B30',
    code_0: 'A00-B99',
    code_1: 'B25-B34'
  },
  {
    code: 'B303',
    level: 3,
    description:
      'Conjuntivitis epid\u00e9mica aguda hemorr\u00e1gica (enterov\u00edrica) (H13.1)',
    code_2: 'B30',
    code_0: 'A00-B99',
    code_1: 'B25-B34'
  },
  {
    code: 'B308',
    level: 3,
    description: 'Otras conjuntivitis virales (H13.1)',
    code_2: 'B30',
    code_0: 'A00-B99',
    code_1: 'B25-B34'
  },
  {
    code: 'B309',
    level: 3,
    description: 'Conjuntivitis viral, sin otra especificaci\u00f3n',
    code_2: 'B30',
    code_0: 'A00-B99',
    code_1: 'B25-B34'
  },
  {
    code: 'B270',
    level: 3,
    description: 'Mononucleosis debida a herpes virus gamma',
    code_2: 'B27',
    code_0: 'A00-B99',
    code_1: 'B25-B34'
  },
  {
    code: 'B271',
    level: 3,
    description: 'Mononucleosis por citomegalovirus',
    code_2: 'B27',
    code_0: 'A00-B99',
    code_1: 'B25-B34'
  },
  {
    code: 'B278',
    level: 3,
    description: 'Otras mononucleosis infecciosas',
    code_2: 'B27',
    code_0: 'A00-B99',
    code_1: 'B25-B34'
  },
  {
    code: 'B279',
    level: 3,
    description: 'Mononucleosis infecciosa, no especificada',
    code_2: 'B27',
    code_0: 'A00-B99',
    code_1: 'B25-B34'
  },
  {
    code: 'B260',
    level: 3,
    description: 'Orquitis por parotiditis (N51.1)',
    code_2: 'B26',
    code_0: 'A00-B99',
    code_1: 'B25-B34'
  },
  {
    code: 'B261',
    level: 3,
    description: 'Meningitis por parotiditis (G02.0)',
    code_2: 'B26',
    code_0: 'A00-B99',
    code_1: 'B25-B34'
  },
  {
    code: 'B262',
    level: 3,
    description: 'Encefalitis por parotiditis (G05.1)',
    code_2: 'B26',
    code_0: 'A00-B99',
    code_1: 'B25-B34'
  },
  {
    code: 'B263',
    level: 3,
    description: 'Pancreatitis por parotiditis (K87.1)',
    code_2: 'B26',
    code_0: 'A00-B99',
    code_1: 'B25-B34'
  },
  {
    code: 'B268',
    level: 3,
    description: 'Parotiditis infecciosa con otras complicaciones',
    code_2: 'B26',
    code_0: 'A00-B99',
    code_1: 'B25-B34'
  },
  {
    code: 'B269',
    level: 3,
    description: 'Parotiditis, sin complicaciones',
    code_2: 'B26',
    code_0: 'A00-B99',
    code_1: 'B25-B34'
  },
  {
    code: 'B250',
    level: 3,
    description: 'Neumonitis debida a virus citomeg\u00e1lico (J17.1)',
    code_2: 'B25',
    code_0: 'A00-B99',
    code_1: 'B25-B34'
  },
  {
    code: 'B251',
    level: 3,
    description: 'Hepatitis debida a virus citomeg\u00e1lico ((K77.0)',
    code_2: 'B25',
    code_0: 'A00-B99',
    code_1: 'B25-B34'
  },
  {
    code: 'B252',
    level: 3,
    description: 'Pancreatitis debida a virus citomeg\u00e1lico (K87.1)',
    code_2: 'B25',
    code_0: 'A00-B99',
    code_1: 'B25-B34'
  },
  {
    code: 'B440',
    level: 3,
    description: 'Aspergilosis pulmonar invasiva',
    code_2: 'B44',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B441',
    level: 3,
    description: 'Otras aspergilosis pulmonares',
    code_2: 'B44',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B442',
    level: 3,
    description: 'Aspergilosis amigdalina',
    code_2: 'B44',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B430',
    level: 3,
    description: 'Cromomicosis cut\u00e1nea',
    code_2: 'B43',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B431',
    level: 3,
    description: 'Absceso cerebral feomic\u00f3tico',
    code_2: 'B43',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B432',
    level: 3,
    description: 'Absceso y quiste subcut\u00e1neo feomic\u00f3tico',
    code_2: 'B43',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'D219',
    level: 3,
    description:
      'Tumor benigno del tejido conjuntivo y otros tejidos blandos, de sitio no especificado',
    code_2: 'D21',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'B420',
    level: 3,
    description: 'Esporotricosis pulmonar (J99.8)',
    code_2: 'B42',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B421',
    level: 3,
    description: 'Esporotricosis linfocut\u00e1nea',
    code_2: 'B42',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B427',
    level: 3,
    description: 'Esporotricosis diseminada',
    code_2: 'B42',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B428',
    level: 3,
    description: 'Otras formas de esporotricosis',
    code_2: 'B42',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B429',
    level: 3,
    description: 'Esporotricosis, no especificada',
    code_2: 'B42',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B410',
    level: 3,
    description: 'Paracoccidioidomicosis pulmonar',
    code_2: 'B41',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B417',
    level: 3,
    description: 'Paracoccidioidomicosis diseminada',
    code_2: 'B41',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B418',
    level: 3,
    description: 'Otras formas de paracoccidioidomicosis',
    code_2: 'B41',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B419',
    level: 3,
    description: 'Paracoccidioidomicosis, no especificada',
    code_2: 'B41',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B400',
    level: 3,
    description: 'Blastomicosis pulmonar aguda',
    code_2: 'B40',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B401',
    level: 3,
    description: 'Blastomicosis pulmonar cr\u00f3nica',
    code_2: 'B40',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B402',
    level: 3,
    description: 'Blastomicosis pulmonar, sin otra especificaci\u00f3n',
    code_2: 'B40',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B403',
    level: 3,
    description: 'Blastomicosis cut\u00e1nea',
    code_2: 'B40',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B407',
    level: 3,
    description: 'Blastomicosis diseminada',
    code_2: 'B40',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'R002',
    level: 3,
    description: 'Palpitaciones',
    code_2: 'R00',
    code_0: 'R00-R99',
    code_1: 'R00-R09'
  },
  {
    code: 'R008',
    level: 3,
    description:
      'Otras anormalidades del latido card\u00edaco y las no especificadas',
    code_2: 'R00',
    code_0: 'R00-R99',
    code_1: 'R00-R09'
  },
  {
    code: 'R196',
    level: 3,
    description: 'Halitosis',
    code_2: 'R19',
    code_0: 'R00-R99',
    code_1: 'R10-R19'
  },
  {
    code: 'R198',
    level: 3,
    description:
      'Otros s\u00edntomas y signos especificados que involucran el sistema digestivo y el abdomen',
    code_2: 'R19',
    code_0: 'R00-R99',
    code_1: 'R10-R19'
  },
  {
    code: 'B390',
    level: 3,
    description:
      'Infecci\u00f3n pulmonar aguda debida a Histoplasma capsulatum',
    code_2: 'B39',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B391',
    level: 3,
    description:
      'Infecci\u00f3n pulmonar cr\u00f3nica debida a Histoplasma capsulatum',
    code_2: 'B39',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B392',
    level: 3,
    description:
      'Infecci\u00f3n pulmonar debida a Histoplasma capsulatum, sin otra especificaci\u00f3n',
    code_2: 'B39',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B393',
    level: 3,
    description: 'Infecci\u00f3n diseminada debida a Histoplasma capsulatum',
    code_2: 'B39',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B380',
    level: 3,
    description: 'Coccidioidomicosis pulmonar aguda',
    code_2: 'B38',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B381',
    level: 3,
    description: 'Coccidioidomicosis pulmonar cr\u00f3nica',
    code_2: 'B38',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B382',
    level: 3,
    description: 'Coccidioidomicosis pulmonar, sin otra especificaci\u00f3n',
    code_2: 'B38',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B383',
    level: 3,
    description: 'Coccidioidomicosis cut\u00e1nea',
    code_2: 'B38',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B384',
    level: 3,
    description: 'Meningitis debida a coccidioidomicosis (G02.1)',
    code_2: 'B38',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B370',
    level: 3,
    description: 'Estomatitis candidi\u00e1sica',
    code_2: 'B37',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B371',
    level: 3,
    description: 'Candidiasis pulmonar',
    code_2: 'B37',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B372',
    level: 3,
    description: 'Candidiasis de la piel y las u\u00f1as',
    code_2: 'B37',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B373',
    level: 3,
    description: 'Candidiasis de la vulva y de la vagina (N77.1)',
    code_2: 'B37',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B374',
    level: 3,
    description: 'Candidiasis de otras localizaciones urogenitales',
    code_2: 'B37',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B375',
    level: 3,
    description: 'Meningitis debida a candida (G02.1)',
    code_2: 'B37',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B376',
    level: 3,
    description: 'Endocarditis debida a candida (I39.8)',
    code_2: 'B37',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'R467',
    level: 3,
    description:
      'Verbosidad y detalles circunstanciales que oscurecen la raz\u00f3n de la consulta o el contacto',
    code_2: 'R46',
    code_0: 'R00-R99',
    code_1: 'R40-R46'
  },
  {
    code: 'R468',
    level: 3,
    description:
      'Otros s\u00edntomas y signos que involucran la apariencia y el comportamiento',
    code_2: 'R46',
    code_0: 'R00-R99',
    code_1: 'R40-R46'
  },
  {
    code: 'B580',
    level: 3,
    description: 'Oculopat\u00eda debida a toxoplasma',
    code_2: 'B58',
    code_0: 'A00-B99',
    code_1: 'B50-B64'
  },
  {
    code: 'B581',
    level: 3,
    description: 'Hepatitis debida a toxoplasma (K77.0)',
    code_2: 'B58',
    code_0: 'A00-B99',
    code_1: 'B50-B64'
  },
  {
    code: 'B582',
    level: 3,
    description: 'Meningoencefalitis debida a toxoplasma (G05.2)',
    code_2: 'B58',
    code_0: 'A00-B99',
    code_1: 'B50-B64'
  },
  {
    code: 'B583',
    level: 3,
    description: 'Toxoplasmosis pulmonar (J17.3)',
    code_2: 'B58',
    code_0: 'A00-B99',
    code_1: 'B50-B64'
  },
  {
    code: 'B588',
    level: 3,
    description: 'Toxoplasmosis con otro \u00f3rgano afectado',
    code_2: 'B58',
    code_0: 'A00-B99',
    code_1: 'B50-B64'
  },
  {
    code: 'B570',
    level: 3,
    description:
      'Enfermedad de Chagas aguda que afecta al coraz\u00f3n (I41.2, I98.1)',
    code_2: 'B57',
    code_0: 'A00-B99',
    code_1: 'B50-B64'
  },
  {
    code: 'B571',
    level: 3,
    description: 'Enfermedad de Chagas aguda que no afecta al coraz\u00f3n',
    code_2: 'B57',
    code_0: 'A00-B99',
    code_1: 'B50-B64'
  },
  {
    code: 'B572',
    level: 3,
    description:
      'Enfermedad de Chagas (cr\u00f3nica) que afecta al coraz\u00f3n',
    code_2: 'B57',
    code_0: 'A00-B99',
    code_1: 'B50-B64'
  },
  {
    code: 'B573',
    level: 3,
    description:
      'Enfermedad de Chagas (cr\u00f3nica) que afecta al sistema digestivo',
    code_2: 'B57',
    code_0: 'A00-B99',
    code_1: 'B50-B64'
  },
  {
    code: 'B574',
    level: 3,
    description:
      'Enfermedad de Chagas (cr\u00f3nica) que afecta al sistema nervioso',
    code_2: 'B57',
    code_0: 'A00-B99',
    code_1: 'B50-B64'
  },
  {
    code: 'B575',
    level: 3,
    description:
      'Enfermedad de Chagas (cr\u00f3nica) que afecta otros \u00f3rganos',
    code_2: 'B57',
    code_0: 'A00-B99',
    code_1: 'B50-B64'
  },
  {
    code: 'B560',
    level: 3,
    description: 'Tripanosomiasis gambiense',
    code_2: 'B56',
    code_0: 'A00-B99',
    code_1: 'B50-B64'
  },
  {
    code: 'B561',
    level: 3,
    description: 'Tripanosomiasis rhodesiense',
    code_2: 'B56',
    code_0: 'A00-B99',
    code_1: 'B50-B64'
  },
  {
    code: 'B569',
    level: 3,
    description: 'Tripanosomiasis africana, sin otra especificaci\u00f3n',
    code_2: 'B56',
    code_0: 'A00-B99',
    code_1: 'B50-B64'
  },
  {
    code: 'B550',
    level: 3,
    description: 'Leishmaniasis visceral',
    code_2: 'B55',
    code_0: 'A00-B99',
    code_1: 'B50-B64'
  },
  {
    code: 'B551',
    level: 3,
    description: 'Leishmaniasis cut\u00e1nea',
    code_2: 'B55',
    code_0: 'A00-B99',
    code_1: 'B50-B64'
  },
  {
    code: 'B552',
    level: 3,
    description: 'Leishmaniasis mucocut\u00e1nea',
    code_2: 'B55',
    code_0: 'A00-B99',
    code_1: 'B50-B64'
  },
  {
    code: 'B559',
    level: 3,
    description: 'Leishmaniasis, no especificada',
    code_2: 'B55',
    code_0: 'A00-B99',
    code_1: 'B50-B64'
  },
  {
    code: 'B770',
    level: 3,
    description: 'Ascariasis con complicaciones intestinales',
    code_2: 'B77',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B778',
    level: 3,
    description: 'Ascariasis con otras complicaciones',
    code_2: 'B77',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B779',
    level: 3,
    description: 'Ascariasis, no especificada',
    code_2: 'B77',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B760',
    level: 3,
    description: 'Anquilostomiasis',
    code_2: 'B76',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B761',
    level: 3,
    description: 'Necatoriasis',
    code_2: 'B76',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B768',
    level: 3,
    description: 'Otras enfermedades debidas a anquilostomas',
    code_2: 'B76',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B769',
    level: 3,
    description: 'Enfermedad debida a anquilostomas, no especificada',
    code_2: 'B76',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B740',
    level: 3,
    description: 'Filariasis debida a Wuchereria bancrofti',
    code_2: 'B74',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B741',
    level: 3,
    description: 'Filariasis debida a Brugia malayi',
    code_2: 'B74',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B742',
    level: 3,
    description: 'Filariasis debida a Brugia timori',
    code_2: 'B74',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B743',
    level: 3,
    description: 'Loaiasis',
    code_2: 'B74',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B744',
    level: 3,
    description: 'Mansoneliasis',
    code_2: 'B74',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B748',
    level: 3,
    description: 'Otras filariasis',
    code_2: 'B74',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B749',
    level: 3,
    description: 'Filariasis, no especificada',
    code_2: 'B74',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B710',
    level: 3,
    description: 'Himenolepiasis',
    code_2: 'B71',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B711',
    level: 3,
    description: 'Dipilidiasis',
    code_2: 'B71',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B718',
    level: 3,
    description: 'Otras infecciones debidas a cestodos especificadas',
    code_2: 'B71',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B719',
    level: 3,
    description: 'Infecci\u00f3n debida a cestodos, no especificada',
    code_2: 'B71',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B700',
    level: 3,
    description: 'Difilobotriasis intestinal',
    code_2: 'B70',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B701',
    level: 3,
    description: 'Esparganosis',
    code_2: 'B70',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B690',
    level: 3,
    description: 'Cisticercosis del sistema nervioso central',
    code_2: 'B69',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B691',
    level: 3,
    description: 'Cisticercosis del ojo',
    code_2: 'B69',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B698',
    level: 3,
    description: 'Cisticercosis de otros sitios',
    code_2: 'B69',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B699',
    level: 3,
    description: 'Cisticercosis, no especificada',
    code_2: 'B69',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'L700',
    level: 3,
    description: 'Acn\u00e9 vulgar',
    code_2: 'L70',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L701',
    level: 3,
    description: 'Acn\u00e9 conglobado',
    code_2: 'L70',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L702',
    level: 3,
    description: 'Acn\u00e9 varioliforme',
    code_2: 'L70',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L703',
    level: 3,
    description: 'Acn\u00e9 tropical',
    code_2: 'L70',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L704',
    level: 3,
    description: 'Acn\u00e9 infantil',
    code_2: 'L70',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L705',
    level: 3,
    description: 'Acn\u00e9 excoriado de la mujer joven',
    code_2: 'L70',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L708',
    level: 3,
    description: 'Otros acn\u00e9s',
    code_2: 'L70',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L709',
    level: 3,
    description: 'Acn\u00e9, no especificado',
    code_2: 'L70',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'R441',
    level: 3,
    description: 'Alucinaciones visuales',
    code_2: 'R44',
    code_0: 'R00-R99',
    code_1: 'R40-R46'
  },
  {
    code: 'R442',
    level: 3,
    description: 'Otras alucinaciones',
    code_2: 'R44',
    code_0: 'R00-R99',
    code_1: 'R40-R46'
  },
  {
    code: 'R443',
    level: 3,
    description: 'Alucinaciones, no especificadas',
    code_2: 'R44',
    code_0: 'R00-R99',
    code_1: 'R40-R46'
  },
  {
    code: 'R448',
    level: 3,
    description:
      'Otros s\u00edntomas y signos que involucran las sensaciones y percepciones generales y los no especificados',
    code_2: 'R44',
    code_0: 'R00-R99',
    code_1: 'R40-R46'
  },
  {
    code: 'E615',
    level: 3,
    description: 'Deficiencia de molibdeno',
    code_2: 'E61',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E616',
    level: 3,
    description: 'Deficiencia de vanadio',
    code_2: 'E61',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E617',
    level: 3,
    description: 'Deficiencia de m\u00faltiples elementos nutricionales',
    code_2: 'E61',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E618',
    level: 3,
    description: 'Deficiencia de otros elementos nutricionales especificados',
    code_2: 'E61',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E619',
    level: 3,
    description: 'Deficiencia de otro elemento nutricional, no especificado',
    code_2: 'E61',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'P251',
    level: 3,
    description: 'Neumot\u00f3rax originado en el per\u00edodo perinatal',
    code_2: 'P25',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P252',
    level: 3,
    description: 'Neumomediastino originado en el per\u00edodo perinatal',
    code_2: 'P25',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P253',
    level: 3,
    description: 'Neumopericardio originado en el per\u00edodo perinatal',
    code_2: 'P25',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P258',
    level: 3,
    description:
      'Otras afecciones relacionadas con el enfisema intersticial, originadas en el per\u00edodo perinatal',
    code_2: 'P25',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P241',
    level: 3,
    description:
      'Aspiraci\u00f3n neonatal de l\u00edquido amni\u00f3tico y de moco',
    code_2: 'P24',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P242',
    level: 3,
    description: 'Aspiraci\u00f3n neonatal de sangre',
    code_2: 'P24',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P243',
    level: 3,
    description: 'Aspiraci\u00f3n neonatal de leche y alimento regurgitado',
    code_2: 'P24',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P248',
    level: 3,
    description: 'Otros s\u00edndromes de aspiraci\u00f3n neonatal',
    code_2: 'P24',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P249',
    level: 3,
    description:
      'S\u00edndrome de aspiraci\u00f3n neonatal, sin otra especificaci\u00f3n',
    code_2: 'P24',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P231',
    level: 3,
    description: 'Neumon\u00eda cong\u00e9nita debida a Chlamydia',
    code_2: 'P23',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P232',
    level: 3,
    description: 'Neumon\u00eda cong\u00e9nita debida a estafilococos',
    code_2: 'P23',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P233',
    level: 3,
    description:
      'Neumon\u00eda cong\u00e9nita debida a estreptococos del grupo B',
    code_2: 'P23',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P234',
    level: 3,
    description: 'Neumon\u00eda cong\u00e9nita debida a Escherichia coli',
    code_2: 'P23',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P235',
    level: 3,
    description: 'Neumon\u00eda cong\u00e9nita debida a Pseudomonas',
    code_2: 'P23',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P236',
    level: 3,
    description:
      'Neumon\u00eda cong\u00e9nita debida a otros agentes bacterianos',
    code_2: 'P23',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P238',
    level: 3,
    description: 'Neumon\u00eda cong\u00e9nita debida a otros organismos',
    code_2: 'P23',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P239',
    level: 3,
    description: 'Neumon\u00eda cong\u00e9nita, organismo no especificado',
    code_2: 'P23',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P611',
    level: 3,
    description: 'Policitemia neonatal',
    code_2: 'P61',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P612',
    level: 3,
    description: 'Anemia de la prematuridad',
    code_2: 'P61',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P613',
    level: 3,
    description: 'Anemia cong\u00e9nita debida a p\u00e9rdida de sangre fetal',
    code_2: 'P61',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P614',
    level: 3,
    description: 'Otras anemias cong\u00e9nitas, no clasificadas en otra parte',
    code_2: 'P61',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P615',
    level: 3,
    description: 'Neutropenia neonatal transitoria',
    code_2: 'P61',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P616',
    level: 3,
    description:
      'Otros trastornos neonatales transitorios de la coagulaci\u00f3n',
    code_2: 'P61',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P618',
    level: 3,
    description:
      'Otros trastornos hematol\u00f3gicos perinatales especificados',
    code_2: 'P61',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P619',
    level: 3,
    description: 'Trastorno hemat\u00f3logico perinatal, no especificado',
    code_2: 'P61',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P591',
    level: 3,
    description: 'S\u00edndrome de la bilis espesa',
    code_2: 'P59',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P592',
    level: 3,
    description:
      'Ictericia neonatal debida a otra lesi\u00f3n hep\u00e1tica especificada o no',
    code_2: 'P59',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P593',
    level: 3,
    description: 'Ictericia neonatal por inhibidor de la leche materna',
    code_2: 'P59',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P598',
    level: 3,
    description: 'Ictericia neonatal por otras causas especificadas',
    code_2: 'P59',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P599',
    level: 3,
    description: 'Ictericia neonatal, no especificada',
    code_2: 'P59',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P581',
    level: 3,
    description: 'Ictericia neonatal debida a hemorragia',
    code_2: 'P58',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P582',
    level: 3,
    description: 'Ictericia neonatal debida a infecci\u00f3n',
    code_2: 'P58',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P583',
    level: 3,
    description: 'Ictericia neonatal debida a policitemia',
    code_2: 'P58',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P584',
    level: 3,
    description:
      'Ictericia neonatal debida a drogas o toxinas transmitidas por la madre o administradas al reci\u00e9n nacido',
    code_2: 'P58',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P585',
    level: 3,
    description: 'Ictericia neonatal debida a degluci\u00f3n de sangre materna',
    code_2: 'P58',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P588',
    level: 3,
    description:
      'Ictericia neonatal debida a otras hem\u00f3lisis excesivas especificadas',
    code_2: 'P58',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P589',
    level: 3,
    description:
      'Ictericia neonatal debida a hem\u00f3lisis excesiva, sin otra especificaci\u00f3n',
    code_2: 'P58',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P551',
    level: 3,
    description: 'Incompatibilidad ABO del feto y del reci\u00e9n nacido',
    code_2: 'P55',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P558',
    level: 3,
    description:
      'Otras enfermedades hemol\u00edticas del feto y del reci\u00e9n nacido',
    code_2: 'P55',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P559',
    level: 3,
    description:
      'Enfermedad hemol\u00edtica del feto y del reci\u00e9n nacido, no especificada',
    code_2: 'P55',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P541',
    level: 3,
    description: 'Melena neonatal',
    code_2: 'P54',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P542',
    level: 3,
    description: 'Hemorragia rectal neonatal',
    code_2: 'P54',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P543',
    level: 3,
    description: 'Otras hemorragias gastrointestinales neonatales',
    code_2: 'P54',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P544',
    level: 3,
    description: 'Hemorragia suprarrenal neonatal',
    code_2: 'P54',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P545',
    level: 3,
    description: 'Hemorragia cut\u00e1nea neonatal',
    code_2: 'P54',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P546',
    level: 3,
    description: 'Hemorragia vaginal neonatal',
    code_2: 'P54',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P548',
    level: 3,
    description: 'Otras hemorragias fetales y neonatales especificadas',
    code_2: 'P54',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P549',
    level: 3,
    description: 'Hemorragia neonatal, no especificada',
    code_2: 'P54',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'O084',
    level: 3,
    description:
      'Insuficiencia renal consecutiva al aborto, al embarazo ect\u00f3pico y al embarazo molar',
    code_2: 'O08',
    code_0: 'O00-O9A',
    code_1: 'O00-O08'
  },
  {
    code: 'O085',
    level: 3,
    description:
      'Trastorno metab\u00f3lico consecutivo al aborto, al embarazo ect\u00f3pico y al embarazo molar',
    code_2: 'O08',
    code_0: 'O00-O9A',
    code_1: 'O00-O08'
  },
  {
    code: 'O086',
    level: 3,
    description:
      'Lesi\u00f3n de \u00f3rganos o tejidos de la pelvis consecutivo al aborto, al embarazo ect\u00f3pico y al embarazo molar',
    code_2: 'O08',
    code_0: 'O00-O9A',
    code_1: 'O00-O08'
  },
  {
    code: 'O087',
    level: 3,
    description:
      'Otras complicaciones venosas consecutivas al aborto, al embarazo ect\u00f3pico y al embarazo molar',
    code_2: 'O08',
    code_0: 'O00-O9A',
    code_1: 'O00-O08'
  },
  {
    code: 'O088',
    level: 3,
    description:
      'Otras complicaciones consecutivas al aborto, al embarazo ect\u00f3pico y al embarazo molar',
    code_2: 'O08',
    code_0: 'O00-O9A',
    code_1: 'O00-O08'
  },
  {
    code: 'O089',
    level: 3,
    description:
      'Complicaci\u00f3n no especificada consecutiva al aborto, al embarazo ect\u00f3pico y al embarazo molar',
    code_2: 'O08',
    code_0: 'O00-O9A',
    code_1: 'O00-O08'
  },
  {
    code: 'O071',
    level: 3,
    description:
      'Falla de la inducci\u00f3n m\u00e9dica del aborto, complicado por hemorragia excesiva o tard\u00eda',
    code_2: 'O07',
    code_0: 'O00-O9A',
    code_1: 'O00-O08'
  },
  {
    code: 'O072',
    level: 3,
    description:
      'Falla de la inducci\u00f3n m\u00e9dica del aborto, complicado por embolia',
    code_2: 'O07',
    code_0: 'O00-O9A',
    code_1: 'O00-O08'
  },
  {
    code: 'O073',
    level: 3,
    description:
      'Falla de la inducci\u00f3n m\u00e9dica del aborto, con otras complicaciones y las no especificadas',
    code_2: 'O07',
    code_0: 'O00-O9A',
    code_1: 'O00-O08'
  },
  {
    code: 'O074',
    level: 3,
    description:
      'Falla de la inducci\u00f3n m\u00e9dica del aborto, sin complicaci\u00f3n',
    code_2: 'O07',
    code_0: 'O00-O9A',
    code_1: 'O00-O08'
  },
  {
    code: 'O075',
    level: 3,
    description:
      'Otros intentos fallidos de aborto y los no especificados, complicados por infecci\u00f3n genital y pelviana',
    code_2: 'O07',
    code_0: 'O00-O9A',
    code_1: 'O00-O08'
  },
  {
    code: 'O076',
    level: 3,
    description:
      'Otros intentos fallidos de aborto y los no especificados, complicados por hemorragia excesiva o tard\u00eda',
    code_2: 'O07',
    code_0: 'O00-O9A',
    code_1: 'O00-O08'
  },
  {
    code: 'O077',
    level: 3,
    description:
      'Otros intentos fallidos de aborto y los no especificados, complicados por embolia',
    code_2: 'O07',
    code_0: 'O00-O9A',
    code_1: 'O00-O08'
  },
  {
    code: 'O078',
    level: 3,
    description:
      'Otros intentos fallidos de aborto y los no especificados, con otras complicaciones y las no especificadas',
    code_2: 'O07',
    code_0: 'O00-O9A',
    code_1: 'O00-O08'
  },
  {
    code: 'O079',
    level: 3,
    description:
      'Otros intentos fallidos de aborto y los no especificados, sin complicaci\u00f3n',
    code_2: 'O07',
    code_0: 'O00-O9A',
    code_1: 'O00-O08'
  },
  {
    code: 'O152',
    level: 3,
    description: 'Eclampsia en el puerperio',
    code_2: 'O15',
    code_0: 'O00-O9A',
    code_1: 'O10-O16'
  },
  {
    code: 'O159',
    level: 3,
    description: 'Eclampsia, en per\u00edodo no especificado',
    code_2: 'O15',
    code_0: 'O00-O9A',
    code_1: 'O10-O16'
  },
  {
    code: 'O291',
    level: 3,
    description:
      'Complicaciones card\u00edacas de la anestesia administrada durante el embarazo',
    code_2: 'O29',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O292',
    level: 3,
    description:
      'Complicaciones del sistema nervioso central debidas a la anestesia administrada durante el embarazo',
    code_2: 'O29',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O293',
    level: 3,
    description:
      'Reacci\u00f3n t\u00f3xica a la anestesia local administrada durante el embarazo',
    code_2: 'O29',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O294',
    level: 3,
    description:
      'Cefalalgia inducida por la anestesia espinal o epidural administradas durante el embarazo',
    code_2: 'O29',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O295',
    level: 3,
    description:
      'Otras complicaciones de la anestesia espinal o epidural administradas durante el embarazo',
    code_2: 'O29',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O296',
    level: 3,
    description: 'Falla o dificultad en la intubaci\u00f3n durante el embarazo',
    code_2: 'O29',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O298',
    level: 3,
    description:
      'Otras complicaciones de la anestesia administrada durante el embarazo',
    code_2: 'O29',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O299',
    level: 3,
    description:
      'Complicaci\u00f3n no especificada de la anestesia administrada durante el embarazo',
    code_2: 'O29',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O285',
    level: 3,
    description:
      'Hallazgo cromos\u00f3mico o gen\u00e9tico anormal en el examen prenatal de la madre',
    code_2: 'O28',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O288',
    level: 3,
    description: 'Otros hallazgos anormales en el examen prenatal de la madre',
    code_2: 'O28',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O289',
    level: 3,
    description:
      'Hallazgo anormal no especificado en el examen prenatal de la madre',
    code_2: 'O28',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'S396',
    level: 3,
    description:
      'Traumatismo de \u00f3rgano(s) intraabdominal(es) con \u00f3rgano(s) p\u00e9lvico(s)',
    code_2: 'S39',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S397',
    level: 3,
    description:
      'Otros traumatismos m\u00faltiples del abdomen, de la regi\u00f3n lumbosacra y de la pelvis',
    code_2: 'S39',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S398',
    level: 3,
    description:
      'Otros traumatismos especificados del abdomen, de la regi\u00f3n lumbosacra y de la pelvis',
    code_2: 'S39',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S399',
    level: 3,
    description:
      'Traumatismo no especificado del abdomen, de la regi\u00f3n lumbosacra y de la pelvis',
    code_2: 'S39',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'D360',
    level: 3,
    description: 'Tumor benigno de los ganglios linf\u00e1ticos',
    code_2: 'D36',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D361',
    level: 3,
    description:
      'Tumor benigno de los nervios perif\u00e9ricos y del sistema nervioso aut\u00f3nomo',
    code_2: 'D36',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D367',
    level: 3,
    description: 'Tumor benigno de otros sitios especificados',
    code_2: 'D36',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D369',
    level: 3,
    description: 'Tumor benigno de sitio no especificado',
    code_2: 'D36',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D350',
    level: 3,
    description: 'Tumor benigno de la gl\u00e1ndula suprarrenal',
    code_2: 'D35',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D351',
    level: 3,
    description: 'Tumor benigno de la gl\u00e1ndula paratiroides',
    code_2: 'D35',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D352',
    level: 3,
    description: 'Tumor benigno de la hip\u00f3fisis',
    code_2: 'D35',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D353',
    level: 3,
    description: 'Tumor benigno del conducto craneofar\u00edngeo',
    code_2: 'D35',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D354',
    level: 3,
    description: 'Tumor benigno de la gl\u00e1ndula pineal',
    code_2: 'D35',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D355',
    level: 3,
    description: 'Tumor benigno del cuerpo carot\u00eddeo',
    code_2: 'D35',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D356',
    level: 3,
    description:
      'Tumor benigno del cuerpo a\u00f3rtico y de otros cuerpos cromafines',
    code_2: 'D35',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D357',
    level: 3,
    description:
      'Tumor benigno de otras gl\u00e1ndulas endocrinas especificadas',
    code_2: 'D35',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D358',
    level: 3,
    description: 'Tumor benigno pluriglandular',
    code_2: 'D35',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D359',
    level: 3,
    description: 'Tumor benigno de gl\u00e1ndula endocrina no especificada',
    code_2: 'D35',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'N980',
    level: 3,
    description: 'Infecci\u00f3n asociada con inseminaci\u00f3n artificial',
    code_2: 'N98',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N981',
    level: 3,
    description: 'Hiperestimulaci\u00f3n de ovarios',
    code_2: 'N98',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N982',
    level: 3,
    description:
      'Complicaciones en el intento de introducci\u00f3n del huevo fecundado en la fertilizaci\u00f3n in vitro',
    code_2: 'N98',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N983',
    level: 3,
    description:
      'Complicaciones en el intento de introducci\u00f3n del embri\u00f3n en la transferencia de embriones',
    code_2: 'N98',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N970',
    level: 3,
    description: 'Infertilidad femenina asociada con falta de ovulaci\u00f3n',
    code_2: 'N97',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N971',
    level: 3,
    description: 'Infertilidad femenina de origen tub\u00e1rico',
    code_2: 'N97',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N972',
    level: 3,
    description: 'Infertilidad femenina de origen uterino',
    code_2: 'N97',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N973',
    level: 3,
    description: 'Infertilidad femenina de origen cervical',
    code_2: 'N97',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N974',
    level: 3,
    description: 'Infertilidad femenina asociada con factores masculinos',
    code_2: 'N97',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N978',
    level: 3,
    description: 'Infertilidad femenina de otro origen',
    code_2: 'N97',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N979',
    level: 3,
    description: 'Infertilidad femenina, no especificada',
    code_2: 'N97',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N950',
    level: 3,
    description: 'Hemorragia postmenop\u00e1usica',
    code_2: 'N95',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N951',
    level: 3,
    description: 'Estados menop\u00e1usicos y climat\u00e9ricos femeninos',
    code_2: 'N95',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N952',
    level: 3,
    description: 'Vaginitis atr\u00f3fica postmenop\u00e1usica',
    code_2: 'N95',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N953',
    level: 3,
    description: 'Estados asociados con menopausia artificial',
    code_2: 'N95',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N958',
    level: 3,
    description:
      'Otros trastornos menop\u00e1usicos y perimenop\u00e1usicos especificados',
    code_2: 'N95',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N940',
    level: 3,
    description: 'Dolor intermenstrual',
    code_2: 'N94',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N941',
    level: 3,
    description: 'Dispareunia',
    code_2: 'N94',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N942',
    level: 3,
    description: 'Vaginismo',
    code_2: 'N94',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N943',
    level: 3,
    description: 'S\u00edndrome de tensi\u00f3n premenstrual',
    code_2: 'N94',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N944',
    level: 3,
    description: 'Dismenorrea primaria',
    code_2: 'N94',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N945',
    level: 3,
    description: 'Dismenorrea secundaria',
    code_2: 'N94',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N946',
    level: 3,
    description: 'Dismenorrea, no especificada',
    code_2: 'N94',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N948',
    level: 3,
    description:
      'Otras afecciones especificadas asociadas con los \u00f3rganos genitales femeninos y el ciclo menstrual',
    code_2: 'N94',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N949',
    level: 3,
    description:
      'Afecciones no especificadas asociadas con los \u00f3rganos genitales femeninos y el ciclo menstrual',
    code_2: 'N94',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N930',
    level: 3,
    description: 'Hemorragia postcoito y postcontacto',
    code_2: 'N93',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N938',
    level: 3,
    description:
      'Otras hemorragias uterinas o vaginales anormales especificadas',
    code_2: 'N93',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N939',
    level: 3,
    description: 'Hemorragia vaginal y uterina anormal, no especificada',
    code_2: 'N93',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N920',
    level: 3,
    description: 'Menstruaci\u00f3n excesiva y frecuente con ciclo regular',
    code_2: 'N92',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N921',
    level: 3,
    description: 'Menstruaci\u00f3n excesiva y frecuente con ciclo irregular',
    code_2: 'N92',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N922',
    level: 3,
    description: 'Menstruaci\u00f3n excesiva en la pubertad',
    code_2: 'N92',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N923',
    level: 3,
    description: 'Hemorragia por ovulaci\u00f3n',
    code_2: 'N92',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N924',
    level: 3,
    description: 'Hemorragia excesiva en per\u00edodo premenop\u00e1usico',
    code_2: 'N92',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N925',
    level: 3,
    description: 'Otras menstruaciones irregulares especificadas',
    code_2: 'N92',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N926',
    level: 3,
    description: 'Menstruaci\u00f3n irregular, no especificada',
    code_2: 'N92',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'B480',
    level: 3,
    description: 'Lobomicosis',
    code_2: 'B48',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B481',
    level: 3,
    description: 'Rinosporidiosis',
    code_2: 'B48',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B482',
    level: 3,
    description: 'Alesqueriasis',
    code_2: 'B48',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B483',
    level: 3,
    description: 'Geotricosis',
    code_2: 'B48',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B484',
    level: 3,
    description: 'Penicilosis',
    code_2: 'B48',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B487',
    level: 3,
    description: 'Micosis oportunistas',
    code_2: 'B48',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B488',
    level: 3,
    description: 'Otras micosis especificadas',
    code_2: 'B48',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B470',
    level: 3,
    description: 'Eumicetoma',
    code_2: 'B47',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B471',
    level: 3,
    description: 'Actinomicetoma',
    code_2: 'B47',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B479',
    level: 3,
    description: 'Micetoma, no especificado',
    code_2: 'B47',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B460',
    level: 3,
    description: 'Mucormicosis pulmonar',
    code_2: 'B46',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B461',
    level: 3,
    description: 'Mucormicosis rinocerebral',
    code_2: 'B46',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B462',
    level: 3,
    description: 'Mucormicosis gastrointestinal',
    code_2: 'B46',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B463',
    level: 3,
    description: 'Mucormicosis cut\u00e1nea',
    code_2: 'B46',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B464',
    level: 3,
    description: 'Mucormicosis diseminada',
    code_2: 'B46',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B450',
    level: 3,
    description: 'Criptococosis pulmonar',
    code_2: 'B45',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B451',
    level: 3,
    description: 'Criptococosis cerebral',
    code_2: 'B45',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B452',
    level: 3,
    description: 'Criptococosis cut\u00e1nea',
    code_2: 'B45',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B453',
    level: 3,
    description: 'Criptococosis \u00f3sea',
    code_2: 'B45',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B457',
    level: 3,
    description: 'Criptococosis diseminada',
    code_2: 'B45',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B458',
    level: 3,
    description: 'Otras formas de criptococosis',
    code_2: 'B45',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B459',
    level: 3,
    description: 'Criptococosis, no especificada',
    code_2: 'B45',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B600',
    level: 3,
    description: 'Babesiosis',
    code_2: 'B60',
    code_0: 'A00-B99',
    code_1: 'B50-B64'
  },
  {
    code: 'B601',
    level: 3,
    description: 'Acantamebiasis',
    code_2: 'B60',
    code_0: 'A00-B99',
    code_1: 'B50-B64'
  },
  {
    code: 'B602',
    level: 3,
    description: 'Naegleriasis',
    code_2: 'B60',
    code_0: 'A00-B99',
    code_1: 'B50-B64'
  },
  {
    code: 'B608',
    level: 3,
    description: 'Otras enfermedades especificadas debidas a protozarios',
    code_2: 'B60',
    code_0: 'A00-B99',
    code_1: 'B50-B64'
  },
  {
    code: 'B830',
    level: 3,
    description: 'Larva migrans visceral',
    code_2: 'B83',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B831',
    level: 3,
    description: 'Gnatostomiasis',
    code_2: 'B83',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B832',
    level: 3,
    description: 'Angioestrongiliasis debida a Parastrongylus cantonensis',
    code_2: 'B83',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B833',
    level: 3,
    description: 'Singamiasis',
    code_2: 'B83',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B834',
    level: 3,
    description: 'Hirudiniasis interna',
    code_2: 'B83',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B838',
    level: 3,
    description: 'Otras helmintiasis especificadas',
    code_2: 'B83',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B820',
    level: 3,
    description: 'Helmintiasis intestinal, sin otra especificaci\u00f3n',
    code_2: 'B82',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B829',
    level: 3,
    description: 'Parasitosis intestinal, sin otra especificaci\u00f3n',
    code_2: 'B82',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B810',
    level: 3,
    description: 'Anisaquiasis',
    code_2: 'B81',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B811',
    level: 3,
    description: 'Capilariasis intestinal',
    code_2: 'B81',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B812',
    level: 3,
    description: 'Tricoestrongiliasis',
    code_2: 'B81',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B813',
    level: 3,
    description: 'Angioestrongiliasis intestinal',
    code_2: 'B81',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B814',
    level: 3,
    description: 'Helmintiasis intestinal mixta',
    code_2: 'B81',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B818',
    level: 3,
    description: 'Otras helmintiasis intestinales especificadas',
    code_2: 'B81',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B780',
    level: 3,
    description: 'Estrongiloidiasis intestinal',
    code_2: 'B78',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B781',
    level: 3,
    description: 'Estrongiloidiasis cut\u00e1nea',
    code_2: 'B78',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B787',
    level: 3,
    description: 'Estrongiloidiasis diseminada',
    code_2: 'B78',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B789',
    level: 3,
    description: 'Estrongiloidiasis, no especificada',
    code_2: 'B78',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'L750',
    level: 3,
    description: 'Bromhidrosis',
    code_2: 'L75',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L751',
    level: 3,
    description: 'Cromhidrosis',
    code_2: 'L75',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L752',
    level: 3,
    description: 'Miliaria apocrina',
    code_2: 'L75',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L758',
    level: 3,
    description: 'Otros trastornos sudor\u00edparos apocrinos',
    code_2: 'L75',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L759',
    level: 3,
    description: 'Trastorno sudor\u00edparo apocrino, no especificado',
    code_2: 'L75',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L740',
    level: 3,
    description: 'Miliaria rubra',
    code_2: 'L74',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L741',
    level: 3,
    description: 'Miliaria cristalina',
    code_2: 'L74',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L742',
    level: 3,
    description: 'Miliaria profunda',
    code_2: 'L74',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L743',
    level: 3,
    description: 'Miliaria, no especificada',
    code_2: 'L74',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L744',
    level: 3,
    description: 'Anhidrosis',
    code_2: 'L74',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L748',
    level: 3,
    description: 'Otros trastornos sudor\u00edparos ecrinos',
    code_2: 'L74',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L749',
    level: 3,
    description: 'Trastorno sudor\u00edparo ecrino, no especificado',
    code_2: 'L74',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L730',
    level: 3,
    description: 'Acn\u00e9 queloide',
    code_2: 'L73',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L731',
    level: 3,
    description: 'Seudofoliculitis de la barba',
    code_2: 'L73',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L732',
    level: 3,
    description: 'Hidradenitis supurativa',
    code_2: 'L73',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L738',
    level: 3,
    description: 'Otros trastornos foliculares especificados',
    code_2: 'L73',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L739',
    level: 3,
    description: 'Trastorno folicular, no especificado',
    code_2: 'L73',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L720',
    level: 3,
    description: 'Quiste epid\u00e9rmico',
    code_2: 'L72',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L721',
    level: 3,
    description: 'Quiste tricod\u00e9rmico',
    code_2: 'L72',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L722',
    level: 3,
    description: 'Esteatocistoma m\u00faltiple',
    code_2: 'L72',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L728',
    level: 3,
    description:
      'Otros quistes foliculares de la piel y del tejido subcut\u00e1neo',
    code_2: 'L72',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L729',
    level: 3,
    description:
      'Quiste folicular de la piel y del tejido subcut\u00e1neo, sin otra especificaci\u00f3n',
    code_2: 'L72',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'E899',
    level: 3,
    description:
      'Trastorno endocrino y metab\u00f3lico consecutivo a procedimientos, no especificado',
    code_2: 'E89',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'L710',
    level: 3,
    description: 'Dermatitis peribucal',
    code_2: 'L71',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L711',
    level: 3,
    description: 'Rinofima',
    code_2: 'L71',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L718',
    level: 3,
    description: 'Otras ros\u00e1ceas',
    code_2: 'L71',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L719',
    level: 3,
    description: 'Ros\u00e1cea, no especificada',
    code_2: 'L71',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'E878',
    level: 3,
    description:
      'Otros trastornos del equilibrio de los electr\u00f3litos y de los l\u00edquidos, no clasificados en otra parte',
    code_2: 'E87',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'L990',
    level: 3,
    description: 'Amiloidosis de la piel (E85.\u2013)',
    code_2: 'L99',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L998',
    level: 3,
    description:
      'Otros trastornos de la piel y del tejido subcut\u00e1neo en enfermedades clasificadas en otra parte',
    code_2: 'L99',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'A481',
    level: 3,
    description: 'Enfermedad de los legionarios',
    code_2: 'A48',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A482',
    level: 3,
    description:
      'Enfermedad de los legionarios no neum\u00f3nica [fiebre de Pontiac]',
    code_2: 'A48',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A483',
    level: 3,
    description: 'S\u00edndrome del choque t\u00f3xico',
    code_2: 'A48',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A484',
    level: 3,
    description: 'Fiebre purp\u00farica brasile\u00f1a',
    code_2: 'A48',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A488',
    level: 3,
    description: 'Otras enfermedades bacterianas especificadas',
    code_2: 'A48',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'L980',
    level: 3,
    description: 'Granuloma pi\u00f3geno',
    code_2: 'L98',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L981',
    level: 3,
    description: 'Dermatitis facticia',
    code_2: 'L98',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L982',
    level: 3,
    description: 'Dermatosis neutr\u00f3fila febril [Sweet]',
    code_2: 'L98',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L983',
    level: 3,
    description: 'Celulitis eosin\u00f3fila [Wells]',
    code_2: 'L98',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L984',
    level: 3,
    description:
      '\u00dalcera cr\u00f3nica de la piel, no clasificada en otra parte',
    code_2: 'L98',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L985',
    level: 3,
    description: 'Mucinosis de la piel',
    code_2: 'L98',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L986',
    level: 3,
    description:
      'Otros trastornos infiltrativos de la piel y del tejido subcut\u00e1neo',
    code_2: 'L98',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L988',
    level: 3,
    description:
      'Otros trastornos especificados de la piel y del tejido subcut\u00e1neo',
    code_2: 'L98',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L989',
    level: 3,
    description:
      'Trastorno de la piel y del tejido subcut\u00e1neo, no especificado',
    code_2: 'L98',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'N398',
    level: 3,
    description: 'Otros trastornos especificados del sistema urinario',
    code_2: 'N39',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N399',
    level: 3,
    description: 'Trastorno del sistema urinario, no especificado',
    code_2: 'N39',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'L950',
    level: 3,
    description: 'Vasculitis livedoide',
    code_2: 'L95',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L951',
    level: 3,
    description: 'Eritema elevatum diutinum',
    code_2: 'L95',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L958',
    level: 3,
    description: 'Otras vasculitis limitadas a la piel',
    code_2: 'L95',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L959',
    level: 3,
    description: 'Vasculitis limitada a la piel, sin otra especificaci\u00f3n',
    code_2: 'L95',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'N488',
    level: 3,
    description: 'Otros trastornos especificados del pene',
    code_2: 'N48',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N489',
    level: 3,
    description: 'Trastorno del pene, no especificado',
    code_2: 'N48',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'L940',
    level: 3,
    description: 'Escleroderma localizado [morfea]',
    code_2: 'L94',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L941',
    level: 3,
    description: 'Escleroderma lineal',
    code_2: 'L94',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L942',
    level: 3,
    description: 'Calcinosis de la piel',
    code_2: 'L94',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L943',
    level: 3,
    description: 'Esclerodactilia',
    code_2: 'L94',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L944',
    level: 3,
    description: 'P\u00e1pulas de Gottron',
    code_2: 'L94',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L945',
    level: 3,
    description: 'Poiquilodermia vascular atr\u00f3fica',
    code_2: 'L94',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L946',
    level: 3,
    description: 'Ainhum',
    code_2: 'L94',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L930',
    level: 3,
    description: 'Lupus eritematoso discoide',
    code_2: 'L93',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L931',
    level: 3,
    description: 'Lupus eritematoso cut\u00e1neo subagudo',
    code_2: 'L93',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L932',
    level: 3,
    description: 'Otros lupus eritematosos localizados',
    code_2: 'L93',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L920',
    level: 3,
    description: 'Granuloma anular',
    code_2: 'L92',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L921',
    level: 3,
    description: 'Necrobiosis lip\u00eddica, no clasificada en otra parte',
    code_2: 'L92',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L922',
    level: 3,
    description: 'Granuloma facial [granuloma eosin\u00f3filo de la piel]',
    code_2: 'L92',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L923',
    level: 3,
    description:
      'Granuloma por cuerpo extra\u00f1o en la piel y en el tejido subcut\u00e1neo',
    code_2: 'L92',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L928',
    level: 3,
    description:
      'Otros trastornos granulomatosos de la piel y del tejido subcut\u00e1neo',
    code_2: 'L92',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L929',
    level: 3,
    description:
      'Trastorno granulomatoso de la piel y del tejido subcut\u00e1neo, no especificado',
    code_2: 'L92',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'J700',
    level: 3,
    description: 'Manifestaciones pulmonares agudas debidas a radiaci\u00f3n',
    code_2: 'J70',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'J701',
    level: 3,
    description:
      'Manifestaciones pulmonares cr\u00f3nicas y otras manifestaciones debidas a radiaci\u00f3n',
    code_2: 'J70',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'J702',
    level: 3,
    description:
      'Trastornos pulmonares intersticiales agudos inducidos por drogas',
    code_2: 'J70',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'J703',
    level: 3,
    description:
      'Trastornos pulmonares intersticiales cr\u00f3nicos inducidos por drogas',
    code_2: 'J70',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'J704',
    level: 3,
    description:
      'Trastornos pulmonares intersticiales no especificados inducidos por drogas',
    code_2: 'J70',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'J708',
    level: 3,
    description:
      'Afecciones respiratorias debidas a otros agentes externos especificados',
    code_2: 'J70',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'J709',
    level: 3,
    description:
      'Afecciones respiratorias debidas a agentes externos no especificados',
    code_2: 'J70',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'J690',
    level: 3,
    description:
      'Neumonitis debida a aspiraci\u00f3n de alimento o v\u00f3mito',
    code_2: 'J69',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'J691',
    level: 3,
    description: 'Neumonitis debida a aspiraci\u00f3n de aceites y esencias',
    code_2: 'J69',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'J698',
    level: 3,
    description:
      'Neumonitis debida a aspiraci\u00f3n de otros s\u00f3lidos y l\u00edquidos',
    code_2: 'J69',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'J680',
    level: 3,
    description:
      'Bronquitis y neumonitis debidas a inhalaci\u00f3n de gases, humos, vapores y sustancias qu\u00edmicas',
    code_2: 'J68',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'J681',
    level: 3,
    description:
      'Edema pulmonar debido a inhalaci\u00f3n de gases, humos, vapores y sustancias qu\u00edmicas',
    code_2: 'J68',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'J682',
    level: 3,
    description:
      'Inflamaci\u00f3n respiratoria superior debida a inhalaci\u00f3n de gases, humos, vapores y sustancias qu\u00edmicas, no clasificadas en otra parte',
    code_2: 'J68',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'J683',
    level: 3,
    description:
      'Otras afecciones respiratorias agudas y subagudas debidas a inhalaci\u00f3n de gases, humos, vapores y sustancias qu\u00edmicas',
    code_2: 'J68',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'J684',
    level: 3,
    description:
      'Afecciones respiratorias cr\u00f3nicas debidas a inhalaci\u00f3n de gases, humos, vapores y sustancias qu\u00edmicas',
    code_2: 'J68',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'J688',
    level: 3,
    description:
      'Otras afecciones respiratorias debidas a inhalaci\u00f3n de gases, humos, vapores y sustancias qu\u00edmicas',
    code_2: 'J68',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'J689',
    level: 3,
    description:
      'Afecci\u00f3n respiratoria no especificada, debida a inhalaci\u00f3n de gases, humos, vapores y sustancias qu\u00edmicas',
    code_2: 'J68',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'I470',
    level: 3,
    description: 'Arritmia por reentrada ventricular',
    code_2: 'I47',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I471',
    level: 3,
    description: 'Taquicardia supraventricular',
    code_2: 'I47',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I472',
    level: 3,
    description: 'Taquicardia ventricular',
    code_2: 'I47',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I479',
    level: 3,
    description: 'Taquicardia parox\u00edstica, no especificada',
    code_2: 'I47',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I460',
    level: 3,
    description: 'Paro card\u00edaco con resucitaci\u00f3n exitosa',
    code_2: 'I46',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I461',
    level: 3,
    description: 'Muerte card\u00edaca s\u00fabita, as\u00ed descrita',
    code_2: 'I46',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I469',
    level: 3,
    description: 'Paro card\u00edaco, no especificado',
    code_2: 'I46',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I450',
    level: 3,
    description: 'Bloqueo fascicular derecho',
    code_2: 'I45',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I451',
    level: 3,
    description:
      'Otros tipos de bloqueo de rama derecha del haz y los no especificados',
    code_2: 'I45',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I452',
    level: 3,
    description: 'Bloqueo bifascicular',
    code_2: 'I45',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I453',
    level: 3,
    description: 'Bloqueo trifascicular',
    code_2: 'I45',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I454',
    level: 3,
    description: 'Bloqueo intraventricular no especificado',
    code_2: 'I45',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I455',
    level: 3,
    description: 'Otros tipos especificados de bloqueo del coraz\u00f3n',
    code_2: 'I45',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I456',
    level: 3,
    description: 'S\u00edndrome de preexcitaci\u00f3n',
    code_2: 'I45',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I458',
    level: 3,
    description: 'Otros trastornos especificados de la conducci\u00f3n',
    code_2: 'I45',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I459',
    level: 3,
    description: 'Trastorno de la conducci\u00f3n, no especificado',
    code_2: 'I45',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I440',
    level: 3,
    description: 'Bloqueo auriculoventricular de primer grado',
    code_2: 'I44',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I441',
    level: 3,
    description: 'Bloqueo auriculoventricular de segundo grado',
    code_2: 'I44',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I442',
    level: 3,
    description: 'Bloqueo auriculoventricular completo',
    code_2: 'I44',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I443',
    level: 3,
    description:
      'Otros tipos de bloqueo auriculoventricular y los no especificados',
    code_2: 'I44',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I444',
    level: 3,
    description: 'Bloqueo fascicular anterior izquierdo',
    code_2: 'I44',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I445',
    level: 3,
    description: 'Bloqueo fascicular posterior izquierdo',
    code_2: 'I44',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I446',
    level: 3,
    description: 'Otros tipos de bloqueo fascicular y los no especificados',
    code_2: 'I44',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I447',
    level: 3,
    description:
      'Bloqueo de rama izquierda del haz, sin otra especificaci\u00f3n',
    code_2: 'I44',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I430',
    level: 3,
    description:
      'Cardiomiopat\u00eda en enfermedades infecciosas y parasitarias clasificadas en otra parte',
    code_2: 'I43',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I431',
    level: 3,
    description: 'Cardiomiopat\u00eda en enfermedades metab\u00f3licas',
    code_2: 'I43',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I432',
    level: 3,
    description: 'Cardiomiopat\u00eda en enfermedades nutricionales',
    code_2: 'I43',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I438',
    level: 3,
    description:
      'Cardiomiopat\u00eda en otras enfermedades clasificadas en otra parte',
    code_2: 'I43',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I420',
    level: 3,
    description: 'Cardiomiopat\u00eda dilatada',
    code_2: 'I42',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I421',
    level: 3,
    description: 'Cardiomiopat\u00eda hipertr\u00f3fica obstructiva',
    code_2: 'I42',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I422',
    level: 3,
    description: 'Otras cardiomiopat\u00edas hipertr\u00f3ficas',
    code_2: 'I42',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I423',
    level: 3,
    description: 'Enfermedad endomioc\u00e1rdica (eosinof\u00edlica)',
    code_2: 'I42',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I424',
    level: 3,
    description:
      'Fibroelastosis endoc\u00e1rdica Cardiomiopat\u00eda cong\u00e9nita',
    code_2: 'I42',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I425',
    level: 3,
    description: 'Otras cardiomiopat\u00edas restrictivas',
    code_2: 'I42',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I426',
    level: 3,
    description: 'Cardiomiopat\u00eda alcoh\u00f3lica',
    code_2: 'I42',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I427',
    level: 3,
    description: 'Cardiomiopat\u00eda debida a drogas y otros agentes externos',
    code_2: 'I42',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I428',
    level: 3,
    description: 'Otras cardiomiopat\u00edas',
    code_2: 'I42',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I410',
    level: 3,
    description:
      'Miocarditis en enfermedades bacterianas clasificadas en otra parte',
    code_2: 'I41',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I411',
    level: 3,
    description:
      'Miocarditis en enfermedades virales clasificadas en otra parte',
    code_2: 'I41',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I412',
    level: 3,
    description:
      'Miocarditis en otras enfermedades infecciosas y parasitarias clasificadas en otra parte',
    code_2: 'I41',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I418',
    level: 3,
    description: 'Miocarditis en otras enfermedades clasificadas en otra parte',
    code_2: 'I41',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I400',
    level: 3,
    description: 'Miocarditis infecciosa',
    code_2: 'I40',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I401',
    level: 3,
    description: 'Miocarditis aislada',
    code_2: 'I40',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I408',
    level: 3,
    description: 'Otras miocarditis agudas',
    code_2: 'I40',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I409',
    level: 3,
    description: 'Miocarditis aguda, no especificada',
    code_2: 'I40',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I390',
    level: 3,
    description:
      'Trastornos de la v\u00e1lvula mitral en enfermedades clasificadas en otra parte',
    code_2: 'I39',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I391',
    level: 3,
    description:
      'Trastornos de la v\u00e1lvula a\u00f3rtica en enfermedades clasificadas en otra parte',
    code_2: 'I39',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I392',
    level: 3,
    description:
      'Trastornos de la v\u00e1lvula tric\u00faspide en enfermedades clasificadas en otra parte',
    code_2: 'I39',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I393',
    level: 3,
    description:
      'Trastornos de la v\u00e1lvula pulmonar en enfermedades clasificadas en otra parte',
    code_2: 'I39',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I394',
    level: 3,
    description:
      'Trastornos valvulares m\u00faltiples en enfermedades clasificadas en otra parte',
    code_2: 'I39',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I398',
    level: 3,
    description:
      'Endocarditis, v\u00e1lvula no especificada, en enfermedades clasificadas en otra parte',
    code_2: 'I39',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'N768',
    level: 3,
    description: 'Otras inflamaciones especificadas de la vagina y de la vulva',
    code_2: 'N76',
    code_0: 'N00-N99',
    code_1: 'N70-N77'
  },
  {
    code: 'N908',
    level: 3,
    description:
      'Otros trastornos no inflamatorios especificados de la vulva y del perineo',
    code_2: 'N90',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N909',
    level: 3,
    description:
      'Trastorno no inflamatorio de la vulva y del perineo, no especificado',
    code_2: 'N90',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N897',
    level: 3,
    description: 'Hematocolpos',
    code_2: 'N89',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N898',
    level: 3,
    description: 'Otros trastornos especificados no inflamatorios de la vagina',
    code_2: 'N89',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N899',
    level: 3,
    description: 'Trastorno no inflamatorio de la vagina, no especificado',
    code_2: 'N89',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'B258',
    level: 3,
    description: 'Otras enfermedades debidas a virus citomeg\u00e1lico',
    code_2: 'B25',
    code_0: 'A00-B99',
    code_1: 'B25-B34'
  },
  {
    code: 'B259',
    level: 3,
    description: 'Enfermedad por virus citomeg\u00e1lico, no especificada',
    code_2: 'B25',
    code_0: 'A00-B99',
    code_1: 'B25-B34'
  },
  {
    code: 'B447',
    level: 3,
    description: 'Aspergilosis diseminada',
    code_2: 'B44',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B448',
    level: 3,
    description: 'Otras formas de aspergilosis',
    code_2: 'B44',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B449',
    level: 3,
    description: 'Aspergilosis, no especificada',
    code_2: 'B44',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B438',
    level: 3,
    description: 'Otras formas de cromomicosis',
    code_2: 'B43',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B439',
    level: 3,
    description: 'Cromomicosis, no especificada',
    code_2: 'B43',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B408',
    level: 3,
    description: 'Otras formas de blastomicosis',
    code_2: 'B40',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B409',
    level: 3,
    description: 'Blastomicosis, no especificada',
    code_2: 'B40',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B394',
    level: 3,
    description:
      'Histoplasmosis debida a Histoplasma capsulatum, sin otra especificaci\u00f3n',
    code_2: 'B39',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B395',
    level: 3,
    description: 'Infecci\u00f3n debida a Histoplasma duboisii',
    code_2: 'B39',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B399',
    level: 3,
    description: 'Histoplasmosis, no especificada',
    code_2: 'B39',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B387',
    level: 3,
    description: 'Coccidioidomicosis diseminada',
    code_2: 'B38',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B388',
    level: 3,
    description: 'Otras formas de coccidioidomicosis',
    code_2: 'B38',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B389',
    level: 3,
    description: 'Coccidioidomicosis, no especificada',
    code_2: 'B38',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B377',
    level: 3,
    description: 'Septicemia debida a candida',
    code_2: 'B37',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B378',
    level: 3,
    description: 'Candidiasis de otros sitios',
    code_2: 'B37',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B379',
    level: 3,
    description: 'Candidiasis, no especificada',
    code_2: 'B37',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B589',
    level: 3,
    description: 'Toxoplasmosis, no especificada',
    code_2: 'B58',
    code_0: 'A00-B99',
    code_1: 'B50-B64'
  },
  {
    code: 'I520',
    level: 3,
    description:
      'Otros trastornos card\u00edacos en enfermedades bacterianas clasificadas en otra parte',
    code_2: 'I52',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I521',
    level: 3,
    description:
      'Otros trastornos card\u00edacos en otras enfermedades infecciosas y parasitarias clasificadas en otra parte',
    code_2: 'I52',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I528',
    level: 3,
    description:
      'Otros trastornos card\u00edacos en otras enfermedades clasificadas en otra parte',
    code_2: 'I52',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I510',
    level: 3,
    description: 'Defecto del tabique card\u00edaco, adquirido',
    code_2: 'I51',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I511',
    level: 3,
    description: 'Ruptura de cuerda tendinosa, no clasificada en otra parte',
    code_2: 'I51',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I512',
    level: 3,
    description:
      'Ruptura de m\u00fasculo papilar, no clasificada en otra parte',
    code_2: 'I51',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I513',
    level: 3,
    description: 'Trombosis intracard\u00edaca, no clasificada en otra parte',
    code_2: 'I51',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I514',
    level: 3,
    description: 'Miocarditis, no especificada',
    code_2: 'I51',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I515',
    level: 3,
    description: 'Degeneraci\u00f3n mioc\u00e1rdica',
    code_2: 'I51',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I516',
    level: 3,
    description: 'Enfermedad cardiovascular, no especificada',
    code_2: 'I51',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I517',
    level: 3,
    description: 'Cardiomegalia',
    code_2: 'I51',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I518',
    level: 3,
    description: 'Otras enfermedades card\u00edacas mal definidas',
    code_2: 'I51',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I519',
    level: 3,
    description: 'Enfermedad card\u00edaca, no especificada',
    code_2: 'I51',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I500',
    level: 3,
    description: 'Insuficiencia card\u00edaca congestiva',
    code_2: 'I50',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I501',
    level: 3,
    description: 'Insuficiencia ventricular izquierda',
    code_2: 'I50',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I509',
    level: 3,
    description: 'Insuficiencia card\u00edaca, no especificada',
    code_2: 'I50',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I490',
    level: 3,
    description: 'Fibrilaci\u00f3n y aleteo ventricular',
    code_2: 'I49',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I491',
    level: 3,
    description: 'Despolarizaci\u00f3n auricular prematura',
    code_2: 'I49',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I492',
    level: 3,
    description: 'Despolarizaci\u00f3n prematura nodal',
    code_2: 'I49',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I493',
    level: 3,
    description: 'Despolarizaci\u00f3n ventricular prematura',
    code_2: 'I49',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I494',
    level: 3,
    description:
      'Otros tipos de despolarizaci\u00f3n prematura y los no especificados',
    code_2: 'I49',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I495',
    level: 3,
    description: 'S\u00edndrome del seno enfermo',
    code_2: 'I49',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I498',
    level: 3,
    description: 'Otras arritmias card\u00edacas especificadas',
    code_2: 'I49',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I499',
    level: 3,
    description: 'Arritmia card\u00edaca, no especificada',
    code_2: 'I49',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'T500',
    level: 3,
    description: 'Mineralocorticoides y sus antagonistas',
    code_2: 'T50',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T501',
    level: 3,
    description: 'Diur\u00e9ticos del asa [dintel alto]',
    code_2: 'T50',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T502',
    level: 3,
    description:
      'Inhibidores de la anhidrasa del \u00e1cido carb\u00f3nico, benzotiazidas y otros diur\u00e9ticos',
    code_2: 'T50',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T503',
    level: 3,
    description:
      'Agentes del equilibrio hidrol\u00edtico, electrol\u00edtico y cal\u00f3rico',
    code_2: 'T50',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T504',
    level: 3,
    description: 'Drogas que afectan el metabolismo del \u00e1cido \u00farico',
    code_2: 'T50',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T505',
    level: 3,
    description: 'Depresores del apetito',
    code_2: 'T50',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T506',
    level: 3,
    description:
      'Ant\u00eddotos y agentes quelantes, no clasificados en otra parte',
    code_2: 'T50',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T507',
    level: 3,
    description: 'Anal\u00e9pticos y antagonistas del opio',
    code_2: 'T50',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T508',
    level: 3,
    description: 'Agentes diagn\u00f3sticos',
    code_2: 'T50',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T490',
    level: 3,
    description:
      'Drogas locales antimic\u00f3ticas, antiinfecciosas y antiinflamatorias, no clasificadas en otra parte',
    code_2: 'T49',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T491',
    level: 3,
    description: 'Antiprur\u00edticos',
    code_2: 'T49',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T492',
    level: 3,
    description: 'Astringentes y detergentes locales',
    code_2: 'T49',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T493',
    level: 3,
    description: 'Emolientes, demulcentes y protectores',
    code_2: 'T49',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T494',
    level: 3,
    description:
      'Queratol\u00edticos, queratopl\u00e1sticos, drogas y otras preparaciones para el tratamiento del cabello',
    code_2: 'T49',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T495',
    level: 3,
    description: 'Drogas y preparaciones oftalmol\u00f3gicas',
    code_2: 'T49',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T496',
    level: 3,
    description: 'Drogas y preparaciones otorrinolaringol\u00f3gicas',
    code_2: 'T49',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T480',
    level: 3,
    description: 'Drogas oxit\u00f3cicas',
    code_2: 'T48',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T481',
    level: 3,
    description:
      'Relajantes musculoesquel\u00e9ticos [agentes bloqueadores neuromusculares]',
    code_2: 'T48',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T482',
    level: 3,
    description:
      'Otros medicamentos y los no especificados de acci\u00f3n principal sobre los m\u00fasculos',
    code_2: 'T48',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T483',
    level: 3,
    description: 'Antitus\u00edgenos',
    code_2: 'T48',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T484',
    level: 3,
    description: 'Expectorantes',
    code_2: 'T48',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T485',
    level: 3,
    description: 'Drogas contra el catarro com\u00fan',
    code_2: 'T48',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T486',
    level: 3,
    description: 'Antiasm\u00e1ticos, no clasificados en otra parte',
    code_2: 'T48',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T487',
    level: 3,
    description:
      'Otros agentes y los no especificados de acci\u00f3n principal sobre el sistema respiratorio',
    code_2: 'T48',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T470',
    level: 3,
    description: 'Antagonistas del receptor H2 de histamina',
    code_2: 'T47',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T471',
    level: 3,
    description:
      'Otras drogas anti\u00e1cidas y que inhiben la secreci\u00f3n g\u00e1strica',
    code_2: 'T47',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T472',
    level: 3,
    description: 'Laxantes estimulantes',
    code_2: 'T47',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T473',
    level: 3,
    description: 'Laxantes salinos y osm\u00f3ticos',
    code_2: 'T47',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T474',
    level: 3,
    description: 'Otros laxantes',
    code_2: 'T47',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T475',
    level: 3,
    description: 'Digestivos',
    code_2: 'T47',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T476',
    level: 3,
    description: 'Drogas antidiarreicas',
    code_2: 'T47',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T477',
    level: 3,
    description: 'Em\u00e9ticos',
    code_2: 'T47',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T478',
    level: 3,
    description:
      'Otros agentes que afectan principalmente el sistema gastrointestinal',
    code_2: 'T47',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T479',
    level: 3,
    description:
      'Agentes no especificados que afectan principalmente el sistema gastrointestinal',
    code_2: 'T47',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T460',
    level: 3,
    description:
      'Gluc\u00f3sidos cardiot\u00f3nicos y medicamentos de acci\u00f3n similar',
    code_2: 'T46',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T461',
    level: 3,
    description: 'Bloqueadores del canal del calcio',
    code_2: 'T46',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T462',
    level: 3,
    description:
      'Otras drogas antiarr\u00edtmicas, no clasificadas en otra parte',
    code_2: 'T46',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T463',
    level: 3,
    description: 'Vasodilatadores coronarios, no clasificados en otra parte',
    code_2: 'T46',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T464',
    level: 3,
    description: 'Inhibidores de la enzima convertidora de la angiotensina',
    code_2: 'T46',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T465',
    level: 3,
    description:
      'Otras drogas antihipertensivas, no clasificadas en otra parte',
    code_2: 'T46',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T466',
    level: 3,
    description: 'Drogas antilip\u00e9micas y antiarterioscler\u00f3ticas',
    code_2: 'T46',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T467',
    level: 3,
    description: 'Vasodilatadores perif\u00e9ricos',
    code_2: 'T46',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T468',
    level: 3,
    description: 'Drogas antivaricosas, inclusive agentes esclerosantes',
    code_2: 'T46',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T469',
    level: 3,
    description:
      'Otros agentes y los no especificados que afectan principalmente el sistema cardiovascular',
    code_2: 'T46',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T450',
    level: 3,
    description: 'Drogas antial\u00e9rgicas y antiem\u00e9ticas',
    code_2: 'T45',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T451',
    level: 3,
    description: 'Drogas antineopl\u00e1sicas e inmunosupresoras',
    code_2: 'T45',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T452',
    level: 3,
    description: 'Vitaminas, no clasificadas en otra parte',
    code_2: 'T45',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T453',
    level: 3,
    description: 'Enzimas, no clasificadas en otra parte',
    code_2: 'T45',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T454',
    level: 3,
    description: 'Hierro y sus compuestos',
    code_2: 'T45',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T455',
    level: 3,
    description: 'Anticoagulantes',
    code_2: 'T45',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T456',
    level: 3,
    description: 'Drogas que afectan la fibrin\u00f3lisis',
    code_2: 'T45',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T457',
    level: 3,
    description:
      'Antagonistas de anticoagulantes, vitamina K y otros coagulantes',
    code_2: 'T45',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T458',
    level: 3,
    description:
      'Otros agentes principalmente sist\u00e9micos y hematol\u00f3gicos',
    code_2: 'T45',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T459',
    level: 3,
    description:
      'Agentes principalmente sist\u00e9micos y hematol\u00f3gicos, no especificados',
    code_2: 'T45',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T650',
    level: 3,
    description: 'Cianuro',
    code_2: 'T65',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T651',
    level: 3,
    description: 'Estricnina y sus sales',
    code_2: 'T65',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T652',
    level: 3,
    description: 'Tabaco y nicotina',
    code_2: 'T65',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T653',
    level: 3,
    description:
      'Nitroderivados y aminoderivados del benceno y sus hom\u00f3logos',
    code_2: 'T65',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T654',
    level: 3,
    description: 'Bisulfuro de carbono',
    code_2: 'T65',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T655',
    level: 3,
    description:
      'Nitroglicerina y otros \u00e1cidos y \u00e9steres n\u00edtricos',
    code_2: 'T65',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T656',
    level: 3,
    description: 'Pinturas y colorantes, no clasificados en otra parte',
    code_2: 'T65',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T630',
    level: 3,
    description: 'Veneno de serpiente',
    code_2: 'T63',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T631',
    level: 3,
    description: 'Veneno de otros reptiles',
    code_2: 'T63',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T632',
    level: 3,
    description: 'Veneno de escorpi\u00f3n',
    code_2: 'T63',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T633',
    level: 3,
    description: 'Veneno de ara\u00f1as',
    code_2: 'T63',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T634',
    level: 3,
    description: 'Veneno de otros artr\u00f3podos',
    code_2: 'T63',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T635',
    level: 3,
    description: 'Efecto t\u00f3xico del contacto con peces',
    code_2: 'T63',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T636',
    level: 3,
    description: 'Efecto t\u00f3xico del contacto con otros animales marinos',
    code_2: 'T63',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T638',
    level: 3,
    description:
      'Efectos t\u00f3xicos del contacto con otros animales venenosos',
    code_2: 'T63',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T639',
    level: 3,
    description:
      'Efecto t\u00f3xico del contacto con animal venenoso no especificado',
    code_2: 'T63',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'Z540',
    level: 3,
    description: 'Convalecencia consecutiva a cirug\u00eda',
    code_2: 'Z54',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z541',
    level: 3,
    description: 'Convalecencia consecutiva a radioterapia',
    code_2: 'Z54',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z542',
    level: 3,
    description: 'Convalecencia consecutiva a quimioterapia',
    code_2: 'Z54',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z543',
    level: 3,
    description: 'Convalecencia consecutiva a psicoterapia',
    code_2: 'Z54',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z544',
    level: 3,
    description: 'Convalecencia consecutiva a tratamiento de fractura',
    code_2: 'Z54',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z547',
    level: 3,
    description: 'Convalecencia consecutiva a tratamiento combinado',
    code_2: 'Z54',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z548',
    level: 3,
    description: 'Convalecencia consecutiva a otros tratamientos',
    code_2: 'Z54',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z549',
    level: 3,
    description: 'Convalecencia consecutiva a tratamiento no especificado',
    code_2: 'Z54',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z530',
    level: 3,
    description: 'Procedimiento no realizado por contraindicaci\u00f3n',
    code_2: 'Z53',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z531',
    level: 3,
    description:
      'Procedimiento no realizado por decisi\u00f3n del paciente, por razones de creencia o presi\u00f3n de grupo',
    code_2: 'Z53',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z532',
    level: 3,
    description:
      'Procedimiento no realizado por decisi\u00f3n del paciente, por otras razones y las no especificadas',
    code_2: 'Z53',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z538',
    level: 3,
    description: 'Procedimiento no realizado por otras razones',
    code_2: 'Z53',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z539',
    level: 3,
    description: 'Procedimiento no realizado por raz\u00f3n no especificada',
    code_2: 'Z53',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z990',
    level: 3,
    description: 'Dependencia de aspirador',
    code_2: 'Z99',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z991',
    level: 3,
    description: 'Dependencia de respirador',
    code_2: 'Z99',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z992',
    level: 3,
    description: 'Dependencia de di\u00e1lisis renal',
    code_2: 'Z99',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z993',
    level: 3,
    description: 'Dependencia de silla de ruedas',
    code_2: 'Z99',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z998',
    level: 3,
    description:
      'Dependencia de otras m\u00e1quinas y dispositivos capacitantes',
    code_2: 'Z99',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z999',
    level: 3,
    description:
      'Dependencia de m\u00e1quina y dispositivo capacitante, no especificada',
    code_2: 'Z99',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z980',
    level: 3,
    description: 'Estado de derivaci\u00f3n intestinal o anastomosis',
    code_2: 'Z98',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z981',
    level: 3,
    description: 'Estado de artrodesis',
    code_2: 'Z98',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z982',
    level: 3,
    description:
      'Presencia de dispositivo para drenaje de l\u00edquido cefalorraqu\u00eddeo',
    code_2: 'Z98',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z988',
    level: 3,
    description: 'Otros estados postquir\u00fargicos especificados',
    code_2: 'Z98',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z970',
    level: 3,
    description: 'Presencia de ojo artificial',
    code_2: 'Z97',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z971',
    level: 3,
    description: 'Presencia de miembro artificial (completo) (parcial)',
    code_2: 'Z97',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z972',
    level: 3,
    description:
      'Presencia de dispositivo prot\u00e9sico dental (completo) (parcial)',
    code_2: 'Z97',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z973',
    level: 3,
    description: 'Presencia de anteojos y lentes de contacto',
    code_2: 'Z97',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z974',
    level: 3,
    description: 'Presencia de aud\u00edfono externo',
    code_2: 'Z97',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z975',
    level: 3,
    description: 'Presencia de dispositivo anticonceptivo (intrauterino)',
    code_2: 'Z97',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z978',
    level: 3,
    description: 'Presencia de otros dispositivos especificados',
    code_2: 'Z97',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z960',
    level: 3,
    description: 'Presencia de implante urogenital',
    code_2: 'Z96',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z961',
    level: 3,
    description: 'Presencia de lentes intraoculares',
    code_2: 'Z96',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z962',
    level: 3,
    description: 'Presencia de implantes \u00f3ticos y auditivos',
    code_2: 'Z96',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z963',
    level: 3,
    description: 'Presencia de laringe artificial',
    code_2: 'Z96',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z964',
    level: 3,
    description: 'Presencia de implantes endocrinos',
    code_2: 'Z96',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z965',
    level: 3,
    description:
      'Presencia de implantes de ra\u00edz de diente y de mand\u00edbula',
    code_2: 'Z96',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z966',
    level: 3,
    description: 'Presencia de implante ortop\u00e9dico articular',
    code_2: 'Z96',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z967',
    level: 3,
    description: 'Presencia de otros implantes de tendones y huesos',
    code_2: 'Z96',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z950',
    level: 3,
    description: 'Presencia de marcapaso card\u00edaco',
    code_2: 'Z95',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z951',
    level: 3,
    description: 'Presencia de derivaci\u00f3n aortocoronaria',
    code_2: 'Z95',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z952',
    level: 3,
    description: 'Presencia de v\u00e1lvula card\u00edaca prot\u00e9sica',
    code_2: 'Z95',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z953',
    level: 3,
    description: 'Presencia de v\u00e1lvula card\u00edaca xenog\u00e9nica',
    code_2: 'Z95',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z954',
    level: 3,
    description: 'Presencia de otros reemplazos de v\u00e1lvula card\u00edaca',
    code_2: 'Z95',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z955',
    level: 3,
    description:
      'Presencia de angioplastia, injertos y pr\u00f3tesis coronarias',
    code_2: 'Z95',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z958',
    level: 3,
    description: 'Presencia de otros injertos y pr\u00f3tesis cardiovasculares',
    code_2: 'Z95',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z959',
    level: 3,
    description:
      'Presencia de injertos e implantes cardiovasculares no especificados',
    code_2: 'Z95',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z940',
    level: 3,
    description: 'Trasplante de ri\u00f1\u00f3n',
    code_2: 'Z94',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z941',
    level: 3,
    description: 'Trasplante de coraz\u00f3n',
    code_2: 'Z94',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z942',
    level: 3,
    description: 'Trasplante de pulm\u00f3n',
    code_2: 'Z94',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z943',
    level: 3,
    description: 'Trasplante de coraz\u00f3n y pulmones',
    code_2: 'Z94',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z944',
    level: 3,
    description: 'Trasplante de h\u00edgado',
    code_2: 'Z94',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z945',
    level: 3,
    description: 'Trasplante de piel',
    code_2: 'Z94',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z946',
    level: 3,
    description: 'Trasplante de hueso',
    code_2: 'Z94',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z947',
    level: 3,
    description: 'Trasplante de c\u00f3rnea',
    code_2: 'Z94',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z948',
    level: 3,
    description: 'Otros \u00f3rganos y tejidos trasplantados',
    code_2: 'Z94',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z949',
    level: 3,
    description: '\u00d3rgano o tejido trasplantado no especificado',
    code_2: 'Z94',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z930',
    level: 3,
    description: 'Traqueostom\u00eda',
    code_2: 'Z93',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z931',
    level: 3,
    description: 'Gastrostom\u00eda',
    code_2: 'Z93',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z932',
    level: 3,
    description: 'Ileostom\u00eda',
    code_2: 'Z93',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z933',
    level: 3,
    description: 'Colostom\u00eda',
    code_2: 'Z93',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z934',
    level: 3,
    description: 'Otros orificios artificiales del tubo gastrointestinal',
    code_2: 'Z93',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z935',
    level: 3,
    description: 'Cistostom\u00eda',
    code_2: 'Z93',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z936',
    level: 3,
    description: 'Otros orificios artificiales de las v\u00edas urinarias',
    code_2: 'Z93',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z938',
    level: 3,
    description: 'Otras aberturas artificiales',
    code_2: 'Z93',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z939',
    level: 3,
    description: 'Abertura artificial, no especificada',
    code_2: 'Z93',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'T880',
    level: 3,
    description: 'Infecci\u00f3n consecutiva a inmunizaci\u00f3n',
    code_2: 'T88',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T881',
    level: 3,
    description:
      'Otras complicaciones consecutivas a inmunizaci\u00f3n, no clasificadas en otra parte',
    code_2: 'T88',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T882',
    level: 3,
    description: 'Choque debido a la anestesia',
    code_2: 'T88',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T883',
    level: 3,
    description: 'Hipertermia maligna debida a la anestesia',
    code_2: 'T88',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T870',
    level: 3,
    description:
      'Complicaciones de la reinserci\u00f3n (de parte) de extremidad superior',
    code_2: 'T87',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T871',
    level: 3,
    description:
      'Complicaciones de la reinserci\u00f3n (de parte) de extremidad inferior',
    code_2: 'T87',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T872',
    level: 3,
    description: 'Complicaciones de otras partes del cuerpo reinsertadas',
    code_2: 'T87',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T873',
    level: 3,
    description: 'Neuroma de mu\u00f1\u00f3n de amputaci\u00f3n',
    code_2: 'T87',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T874',
    level: 3,
    description: 'Infecci\u00f3n de mu\u00f1\u00f3n de amputaci\u00f3n',
    code_2: 'T87',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T875',
    level: 3,
    description: 'Necrosis de mu\u00f1\u00f3n de amputaci\u00f3n',
    code_2: 'T87',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T876',
    level: 3,
    description:
      'Otras complicaciones y las no especificadas de mu\u00f1\u00f3n de amputaci\u00f3n',
    code_2: 'T87',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T860',
    level: 3,
    description: 'Rechazo de trasplante de m\u00e9dula \u00f3sea',
    code_2: 'T86',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T861',
    level: 3,
    description: 'Falla y rechazo de trasplante de ri\u00f1\u00f3n',
    code_2: 'T86',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T862',
    level: 3,
    description: 'Falla y rechazo de trasplante de coraz\u00f3n',
    code_2: 'T86',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T863',
    level: 3,
    description: 'Falla y rechazo de trasplante de pulm\u00f3n-coraz\u00f3n',
    code_2: 'T86',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T864',
    level: 3,
    description: 'Falla y rechazo de trasplante de h\u00edgado',
    code_2: 'T86',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T868',
    level: 3,
    description:
      'Falla y rechazo de otros \u00f3rganos y tejidos trasplantados',
    code_2: 'T86',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T869',
    level: 3,
    description:
      'Falla y rechazo de trasplante de \u00f3rgano y tejido no especificado',
    code_2: 'T86',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T850',
    level: 3,
    description:
      'Complicaci\u00f3n mec\u00e1nica de derivaci\u00f3n (anastom\u00f3tica) ventricular intracraneal',
    code_2: 'T85',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T851',
    level: 3,
    description:
      'Complicaci\u00f3n mec\u00e1nica de implante de estimulador electr\u00f3nico del sistema nervioso',
    code_2: 'T85',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T852',
    level: 3,
    description: 'Complicaci\u00f3n mec\u00e1nica de lentes intraoculares',
    code_2: 'T85',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T853',
    level: 3,
    description:
      'Complicaci\u00f3n mec\u00e1nica de otros dispositivos prot\u00e9sicos, implantes e injertos oculares',
    code_2: 'T85',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T854',
    level: 3,
    description:
      'Complicaci\u00f3n mec\u00e1nica de pr\u00f3tesis e implante de mama',
    code_2: 'T85',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T855',
    level: 3,
    description:
      'Complicaci\u00f3n mec\u00e1nica de dispositivo prot\u00e9sico, implante e injerto gastrointestinal',
    code_2: 'T85',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T856',
    level: 3,
    description:
      'Complicaci\u00f3n mec\u00e1nica de otros dispositivos prot\u00e9sicos, implantes e injertos internos especificados',
    code_2: 'T85',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T857',
    level: 3,
    description:
      'Infecci\u00f3n y reacci\u00f3n inflamatoria debidas a otros dispositivos prot\u00e9sicos, implantes e injertos internos',
    code_2: 'T85',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T858',
    level: 3,
    description:
      'Otras complicaciones de dispositivos prot\u00e9sicos, implantes e injertos internos, no clasificadas en otra parte',
    code_2: 'T85',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T859',
    level: 3,
    description:
      'Complicaci\u00f3n no especificada de dispositivo prot\u00e9sico, implante e injerto interno',
    code_2: 'T85',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T980',
    level: 3,
    description:
      'Secuelas de efectos de cuerpos extra\u00f1os que penetran en orificios naturales',
    code_2: 'T98',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T981',
    level: 3,
    description:
      'Secuelas de otros efectos y los no especificados de causas externas',
    code_2: 'T98',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T982',
    level: 3,
    description:
      'Secuelas de ciertas complicaciones precoces de los traumatismos',
    code_2: 'T98',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T983',
    level: 3,
    description:
      'Secuelas de complicaciones de la atenci\u00f3n m\u00e9dica y quir\u00fargica, no clasificadas en otra parte',
    code_2: 'T98',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'N988',
    level: 3,
    description:
      'Otras complicaciones asociadas con la fecundaci\u00f3n artificial',
    code_2: 'N98',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N989',
    level: 3,
    description:
      'Complicaci\u00f3n no especificada asociada con la fecundaci\u00f3n artificial',
    code_2: 'N98',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N959',
    level: 3,
    description:
      'Trastorno menop\u00e1usico y perimenop\u00e1usico, no especificado',
    code_2: 'N95',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'T950',
    level: 3,
    description:
      'Secuelas de quemadura, corrosi\u00f3n y congelamiento de la cabeza y del cuello',
    code_2: 'T95',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T951',
    level: 3,
    description:
      'Secuelas de quemadura, corrosi\u00f3n y congelamiento del tronco',
    code_2: 'T95',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T952',
    level: 3,
    description:
      'Secuelas de quemadura, corrosi\u00f3n y congelamiento de miembro superior',
    code_2: 'T95',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T953',
    level: 3,
    description:
      'Secuelas de quemadura, corrosi\u00f3n y congelamiento de miembro inferior',
    code_2: 'T95',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T954',
    level: 3,
    description:
      'Secuelas de quemadura y corrosi\u00f3n clasificables s\u00f3lo de acuerdo con la extensi\u00f3n de la superficie del cuerpo afectada',
    code_2: 'T95',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T958',
    level: 3,
    description:
      'Secuelas de otras quemaduras, corrosiones y congelamientos especificados',
    code_2: 'T95',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T959',
    level: 3,
    description:
      'Secuelas de quemadura, corrosi\u00f3n y congelamiento no especificados',
    code_2: 'T95',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T940',
    level: 3,
    description:
      'Secuelas de traumatismos que afectan m\u00faltiples regiones del cuerpo',
    code_2: 'T94',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T941',
    level: 3,
    description:
      'Secuelas de traumatismos de regiones no especificadas del cuerpo',
    code_2: 'T94',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'B465',
    level: 3,
    description: 'Mucormicosis, sin otra especificaci\u00f3n',
    code_2: 'B46',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B468',
    level: 3,
    description: 'Otras cigomicosis',
    code_2: 'B46',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B469',
    level: 3,
    description: 'Cigomicosis, no especificada',
    code_2: 'B46',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'L680',
    level: 3,
    description: 'Hirsutismo',
    code_2: 'L68',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L681',
    level: 3,
    description: 'Hipertricosis lanuginosa adquirida',
    code_2: 'L68',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L682',
    level: 3,
    description: 'Hipertricosis localizada',
    code_2: 'L68',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L683',
    level: 3,
    description: 'Politriquia',
    code_2: 'L68',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L688',
    level: 3,
    description: 'Otras hipertricosis',
    code_2: 'L68',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L689',
    level: 3,
    description: 'Hipertricosis, no especificada',
    code_2: 'L68',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'B839',
    level: 3,
    description: 'Helmintiasis, no especificada',
    code_2: 'B83',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'L670',
    level: 3,
    description: 'Tricorrexis nudosa',
    code_2: 'L67',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L671',
    level: 3,
    description: 'Variaci\u00f3n del color del pelo',
    code_2: 'L67',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L678',
    level: 3,
    description: 'Otras anormalidades del tallo y del color del pelo',
    code_2: 'L67',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L679',
    level: 3,
    description: 'Anormalidad no especificada del tallo y del color del pelo',
    code_2: 'L67',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L660',
    level: 3,
    description: 'Seudopelada',
    code_2: 'L66',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L661',
    level: 3,
    description: 'Liquen plano pilaris',
    code_2: 'L66',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L662',
    level: 3,
    description: 'Foliculitis decalvante',
    code_2: 'L66',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L663',
    level: 3,
    description: 'Perifoliculitis capitis abscedens',
    code_2: 'L66',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L650',
    level: 3,
    description: 'P\u00e9rdida capilar tel\u00f3gena',
    code_2: 'L65',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L651',
    level: 3,
    description: 'P\u00e9rdida capilar an\u00e1gena',
    code_2: 'L65',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L652',
    level: 3,
    description: 'Alopecia mucinosa',
    code_2: 'L65',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L658',
    level: 3,
    description: 'Otras p\u00e9rdidas especificadas no cicatriciales del pelo',
    code_2: 'L65',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L659',
    level: 3,
    description:
      'P\u00e9rdida no cicatricial del pelo, sin otra especificaci\u00f3n',
    code_2: 'L65',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L640',
    level: 3,
    description: 'Alopecia andr\u00f3gena, inducida por drogas',
    code_2: 'L64',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L648',
    level: 3,
    description: 'Otras alopecias andr\u00f3genas',
    code_2: 'L64',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L649',
    level: 3,
    description: 'Alopecia andr\u00f3gena, no especificada',
    code_2: 'L64',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L910',
    level: 3,
    description: 'Cicatriz queloide',
    code_2: 'L91',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L918',
    level: 3,
    description: 'Otros trastornos hipertr\u00f3ficos de la piel',
    code_2: 'L91',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L919',
    level: 3,
    description: 'Trastorno hipertr\u00f3fico de la piel, no especificado',
    code_2: 'L91',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L900',
    level: 3,
    description: 'Liquen escleroso y atr\u00f3fico',
    code_2: 'L90',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L901',
    level: 3,
    description: 'Anetodermia de Schweninger\u2013Buzzi',
    code_2: 'L90',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L902',
    level: 3,
    description: 'Anetodermia de Jadassohn\u2013Pellizzari',
    code_2: 'L90',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L903',
    level: 3,
    description: 'Atrofoderma de Pasini y Pierini',
    code_2: 'L90',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L904',
    level: 3,
    description: 'Acrodermatitis cr\u00f3nica atr\u00f3fica',
    code_2: 'L90',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L905',
    level: 3,
    description: 'Fibrosis y afecciones cicatriciales de la piel',
    code_2: 'L90',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L906',
    level: 3,
    description: 'Estr\u00edas atr\u00f3ficas',
    code_2: 'L90',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L908',
    level: 3,
    description: 'Otros trastornos atr\u00f3ficos de la piel',
    code_2: 'L90',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L909',
    level: 3,
    description: 'Trastorno atr\u00f3fico de la piel, no especificado',
    code_2: 'L90',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L870',
    level: 3,
    description:
      'Queratosis folicular y parafolicular penetrante del cutis [Kyrle]',
    code_2: 'L87',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L871',
    level: 3,
    description: 'Colagenosis perforante reactiva',
    code_2: 'L87',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L872',
    level: 3,
    description: 'Elastosis serpiginosa perforante',
    code_2: 'L87',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L878',
    level: 3,
    description: 'Otros trastornos de la eliminaci\u00f3n transepid\u00e9rmica',
    code_2: 'L87',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L879',
    level: 3,
    description:
      'Trastorno de la eliminaci\u00f3n transepid\u00e9rmica, no especificado',
    code_2: 'L87',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L850',
    level: 3,
    description: 'Ictiosis adquirida',
    code_2: 'L85',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L851',
    level: 3,
    description: 'Queratosis [queratodermia] palmar y plantar adquirida',
    code_2: 'L85',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L852',
    level: 3,
    description: 'Queratosis punctata (palmar y plantar)',
    code_2: 'L85',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L853',
    level: 3,
    description: 'Xerosis del cutis',
    code_2: 'L85',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L858',
    level: 3,
    description: 'Otros engrosamientos epid\u00e9rmicos especificados',
    code_2: 'L85',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L859',
    level: 3,
    description: 'Engrosamiento epid\u00e9rmico, no especificado',
    code_2: 'L85',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'K770',
    level: 3,
    description:
      'Trastornos del h\u00edgado en enfermedades infecciosas y parasitarias clasificadas en otra parte',
    code_2: 'K77',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K778',
    level: 3,
    description:
      'Trastornos del h\u00edgado en otras enfermedades clasificadas en otra parte',
    code_2: 'K77',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K870',
    level: 3,
    description:
      'Trastornos de la ves\u00edcula biliar y de las v\u00edas biliares en enfermedades clasificadas en otra parte',
    code_2: 'K87',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'K871',
    level: 3,
    description:
      'Trastornos del p\u00e1ncreas en enfermedades clasificadas en otra parte',
    code_2: 'K87',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'K860',
    level: 3,
    description: 'Pancreatitis cr\u00f3nica inducida por el alcohol',
    code_2: 'K86',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'K861',
    level: 3,
    description: 'Otras pancreatitis cr\u00f3nicas',
    code_2: 'K86',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'K862',
    level: 3,
    description: 'Quiste del p\u00e1ncreas',
    code_2: 'K86',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'K863',
    level: 3,
    description: 'Seudoquiste del p\u00e1ncreas',
    code_2: 'K86',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'K868',
    level: 3,
    description: 'Otras enfermedades especificadas del p\u00e1ncreas',
    code_2: 'K86',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'K850',
    level: 3,
    description: 'Pancreatitis idiop\u00e1tica aguda',
    code_2: 'K85',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'K851',
    level: 3,
    description: 'Pancreatitis biliar aguda',
    code_2: 'K85',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'K852',
    level: 3,
    description: 'Pancreatitis aguda inducida por alcohol',
    code_2: 'K85',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'K853',
    level: 3,
    description: 'Pancreatitis aguda inducida por drogas',
    code_2: 'K85',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'K858',
    level: 3,
    description: 'Otras pancreatitis agudas',
    code_2: 'K85',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'K859',
    level: 3,
    description: 'Pancreatitis aguda, no especificada',
    code_2: 'K85',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'K830',
    level: 3,
    description: 'Colangitis',
    code_2: 'K83',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'K831',
    level: 3,
    description: 'Obstrucci\u00f3n del conducto biliar',
    code_2: 'K83',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'K832',
    level: 3,
    description: 'Perforaci\u00f3n del conducto biliar',
    code_2: 'K83',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'K833',
    level: 3,
    description: 'F\u00edstula del conducto biliar',
    code_2: 'K83',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'L948',
    level: 3,
    description:
      'Otros trastornos localizados especificados del tejido conjuntivo',
    code_2: 'L94',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L949',
    level: 3,
    description: 'Trastorno localizado del tejido conjuntivo, no especificado',
    code_2: 'L94',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'I429',
    level: 3,
    description: 'Cardiomiopat\u00eda, no especificada',
    code_2: 'I42',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'J450',
    level: 3,
    description: 'Asma predominantemente al\u00e9rgica',
    code_2: 'J45',
    code_0: 'J00-J99',
    code_1: 'J40-J47'
  },
  {
    code: 'J451',
    level: 3,
    description: 'Asma no al\u00e9rgica',
    code_2: 'J45',
    code_0: 'J00-J99',
    code_1: 'J40-J47'
  },
  {
    code: 'J458',
    level: 3,
    description: 'Asma mixta',
    code_2: 'J45',
    code_0: 'J00-J99',
    code_1: 'J40-J47'
  },
  {
    code: 'J459',
    level: 3,
    description: 'Asma, no especificada',
    code_2: 'J45',
    code_0: 'J00-J99',
    code_1: 'J40-J47'
  },
  {
    code: 'J440',
    level: 3,
    description:
      'Enfermedad pulmonar obstructiva cr\u00f3nica con infecci\u00f3n aguda de las v\u00edas respiratorias inferiores',
    code_2: 'J44',
    code_0: 'J00-J99',
    code_1: 'J40-J47'
  },
  {
    code: 'J441',
    level: 3,
    description:
      'Enfermedad pulmonar obstructiva cr\u00f3nica con exacerbaci\u00f3n aguda, no especificada',
    code_2: 'J44',
    code_0: 'J00-J99',
    code_1: 'J40-J47'
  },
  {
    code: 'J448',
    level: 3,
    description:
      'Otras enfermedades pulmonares obstructivas cr\u00f3nicas especificadas',
    code_2: 'J44',
    code_0: 'J00-J99',
    code_1: 'J40-J47'
  },
  {
    code: 'J449',
    level: 3,
    description:
      'Enfermedad pulmonar obstructiva cr\u00f3nica, no especificada',
    code_2: 'J44',
    code_0: 'J00-J99',
    code_1: 'J40-J47'
  },
  {
    code: 'J670',
    level: 3,
    description: 'Pulm\u00f3n del granjero',
    code_2: 'J67',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'J671',
    level: 3,
    description: 'Bagazosis',
    code_2: 'J67',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'J672',
    level: 3,
    description: 'Pulm\u00f3n del ornit\u00f3filo',
    code_2: 'J67',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'J673',
    level: 3,
    description: 'Suberosis',
    code_2: 'J67',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'J674',
    level: 3,
    description: 'Pulm\u00f3n del manipulador de malta',
    code_2: 'J67',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'J660',
    level: 3,
    description: 'Bisinosis',
    code_2: 'J66',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'J661',
    level: 3,
    description: 'Enfermedad de los trabajadores del lino',
    code_2: 'J66',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'J662',
    level: 3,
    description: 'Canabinosis',
    code_2: 'J66',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'J668',
    level: 3,
    description:
      'Enfermedad de las v\u00edas a\u00e9reas debida a otros polvos org\u00e1nicos espec\u00edficos',
    code_2: 'J66',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'J630',
    level: 3,
    description: 'Aluminosis (del pulm\u00f3n)',
    code_2: 'J63',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'J631',
    level: 3,
    description: 'Fibrosis (del pulm\u00f3n) debida a bauxita',
    code_2: 'J63',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'J632',
    level: 3,
    description: 'Beriliosis',
    code_2: 'J63',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'J633',
    level: 3,
    description: 'Fibrosis (del pulm\u00f3n) debida a grafito',
    code_2: 'J63',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'J634',
    level: 3,
    description: 'Siderosis',
    code_2: 'J63',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'J635',
    level: 3,
    description: 'Esta\u00f1osis',
    code_2: 'J63',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'J638',
    level: 3,
    description:
      'Neumoconiosis debida a otros polvos inorg\u00e1nicos especificados',
    code_2: 'J63',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'J620',
    level: 3,
    description: 'Neumoconiosis debida a polvo de talco',
    code_2: 'J62',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'J628',
    level: 3,
    description:
      'Neumoconiosis debida a otros polvos que contienen s\u00edlice',
    code_2: 'J62',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'J990',
    level: 3,
    description: 'Enfermedad pulmonar reumatoide (M05.1)',
    code_2: 'J99',
    code_0: 'J00-J99',
    code_1: 'J95-J99'
  },
  {
    code: 'J991',
    level: 3,
    description:
      'Trastornos respiratorios en otros trastornos difusos del tejido conjuntivo',
    code_2: 'J99',
    code_0: 'J00-J99',
    code_1: 'J95-J99'
  },
  {
    code: 'J998',
    level: 3,
    description:
      'Trastornos respiratorios en otras enfermedades clasificadas en otra parte',
    code_2: 'J99',
    code_0: 'J00-J99',
    code_1: 'J95-J99'
  },
  {
    code: 'I370',
    level: 3,
    description: 'Estenosis de la v\u00e1lvula pulmonar',
    code_2: 'I37',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I371',
    level: 3,
    description: 'Insuficiencia de la v\u00e1lvula pulmonar',
    code_2: 'I37',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I372',
    level: 3,
    description: 'Estenosis de la v\u00e1lvula pulmonar con insuficiencia',
    code_2: 'I37',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I378',
    level: 3,
    description: 'Otros trastornos de la v\u00e1lvula pulmonar',
    code_2: 'I37',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I379',
    level: 3,
    description: 'Trastorno de la v\u00e1lvula pulmonar, no especificado',
    code_2: 'I37',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I360',
    level: 3,
    description:
      'Estenosis no reum\u00e1tica (de la v\u00e1lvula) tric\u00faspide',
    code_2: 'I36',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I361',
    level: 3,
    description:
      'Insuficiencia no reum\u00e1tica (de la v\u00e1lvula) tric\u00faspide',
    code_2: 'I36',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I362',
    level: 3,
    description:
      'Estenosis con insuficiencia no reum\u00e1tica (de la v\u00e1lvula) tric\u00faspide',
    code_2: 'I36',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I368',
    level: 3,
    description:
      'Otros trastornos no reum\u00e1ticos de la v\u00e1lvula tric\u00faspide',
    code_2: 'I36',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I369',
    level: 3,
    description:
      'Trastorno no reum\u00e1tico de la v\u00e1lvula tric\u00faspide, no especificado',
    code_2: 'I36',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I350',
    level: 3,
    description: 'Estenosis (de la v\u00e1lvula) a\u00f3rtica',
    code_2: 'I35',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I351',
    level: 3,
    description: 'Insuficiencia (de la v\u00e1lvula) a\u00f3rtica',
    code_2: 'I35',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I352',
    level: 3,
    description:
      'Estenosis (de la v\u00e1lvula) a\u00f3rtica con insuficiencia',
    code_2: 'I35',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I358',
    level: 3,
    description: 'Otros trastornos de la v\u00e1lvula a\u00f3rtica',
    code_2: 'I35',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I340',
    level: 3,
    description: 'Insuficiencia (de la v\u00e1lvula) mitral',
    code_2: 'I34',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I341',
    level: 3,
    description: 'Prolapso (de la v\u00e1lvula) mitral',
    code_2: 'I34',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I342',
    level: 3,
    description: 'Estenosis (de la v\u00e1lvula) mitral, no reum\u00e1tica',
    code_2: 'I34',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I348',
    level: 3,
    description:
      'Otros trastornos no reum\u00e1ticos de la v\u00e1lvula mitral',
    code_2: 'I34',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I349',
    level: 3,
    description: 'Trastorno mitral no reum\u00e1tico, no especificado',
    code_2: 'I34',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I330',
    level: 3,
    description: 'Endocarditis infecciosa aguda y subaguda',
    code_2: 'I33',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I339',
    level: 3,
    description: 'Endocarditis aguda, no especificada',
    code_2: 'I33',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I320',
    level: 3,
    description:
      'Pericarditis en enfermedades bacterianas clasificadas en otra parte',
    code_2: 'I32',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I321',
    level: 3,
    description:
      'Pericarditis en otras enfermedades infecciosas y parasitarias clasificadas en otra parte',
    code_2: 'I32',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I328',
    level: 3,
    description:
      'Pericarditis en otras enfermedades clasificadas en otra parte',
    code_2: 'I32',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I690',
    level: 3,
    description: 'Secuelas de hemorragia subaracnoidea',
    code_2: 'I69',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I691',
    level: 3,
    description: 'Secuelas de hemorragia intraencef\u00e1lica',
    code_2: 'I69',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I692',
    level: 3,
    description:
      'Secuelas de otras hemorragias intracraneales no traum\u00e1ticas',
    code_2: 'I69',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I693',
    level: 3,
    description: 'Secuelas de infarto cerebral',
    code_2: 'I69',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I694',
    level: 3,
    description:
      'Secuelas de accidente vascular encef\u00e1lico, no especificado como hemorr\u00e1gico o isqu\u00e9mico',
    code_2: 'I69',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I698',
    level: 3,
    description:
      'Secuelas de otras enfermedades cerebrovasculares y de las no especificadas',
    code_2: 'I69',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I680',
    level: 3,
    description: 'Angiopat\u00eda cerebral amiloide (E85.\u2013)',
    code_2: 'I68',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I681',
    level: 3,
    description:
      'Arteritis cerebral en enfermedades infecciosas y parasitarias clasificadas en otra parte',
    code_2: 'I68',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I682',
    level: 3,
    description:
      'Arteritis cerebral en otras enfermedades clasificadas en otra parte',
    code_2: 'I68',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I688',
    level: 3,
    description:
      'Otros trastornos cerebrovasculares en enfermedades clasificadas en otra parte',
    code_2: 'I68',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I670',
    level: 3,
    description: 'Disecci\u00f3n de arterias cerebrales, sin ruptura',
    code_2: 'I67',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I671',
    level: 3,
    description: 'Aneurisma cerebral, sin ruptura',
    code_2: 'I67',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I672',
    level: 3,
    description: 'Aterosclerosis cerebral',
    code_2: 'I67',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I673',
    level: 3,
    description: 'Leucoencefalopat\u00eda vascular progresiva',
    code_2: 'I67',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I674',
    level: 3,
    description: 'Encefalopat\u00eda hipertensiva',
    code_2: 'I67',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I675',
    level: 3,
    description: 'Enfermedad de Moyamoya',
    code_2: 'I67',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I676',
    level: 3,
    description: 'Trombosis api\u00f3gena del sistema venoso intracraneal',
    code_2: 'I67',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I677',
    level: 3,
    description: 'Arteritis cerebral, no clasificada en otra parte',
    code_2: 'I67',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I678',
    level: 3,
    description: 'Otras enfermedades cerebrovasculares especificadas',
    code_2: 'I67',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I679',
    level: 3,
    description: 'Enfermedad cerebrovascular, no especificada',
    code_2: 'I67',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I660',
    level: 3,
    description: 'Oclusi\u00f3n y estenosis de la arteria cerebral media',
    code_2: 'I66',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I661',
    level: 3,
    description: 'Oclusi\u00f3n y estenosis de la arteria cerebral anterior',
    code_2: 'I66',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I662',
    level: 3,
    description: 'Oclusi\u00f3n y estenosis de la arteria cerebral posterior',
    code_2: 'I66',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I663',
    level: 3,
    description: 'Oclusi\u00f3n y estenosis de arterias cerebelosas',
    code_2: 'I66',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I664',
    level: 3,
    description:
      'Oclusi\u00f3n y estenosis m\u00faltiple bilateral de arterias cerebrales',
    code_2: 'I66',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I668',
    level: 3,
    description: 'Oclusi\u00f3n y estenosis de otras arterias cerebrales',
    code_2: 'I66',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I669',
    level: 3,
    description:
      'Oclusi\u00f3n y estenosis de arteria cerebral no especificada',
    code_2: 'I66',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I650',
    level: 3,
    description: 'Oclusi\u00f3n y estenosis de arteria vertebral',
    code_2: 'I65',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I651',
    level: 3,
    description: 'Oclusi\u00f3n y estenosis de arteria basilar',
    code_2: 'I65',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I652',
    level: 3,
    description: 'Oclusi\u00f3n y estenosis de arteria car\u00f3tida',
    code_2: 'I65',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I653',
    level: 3,
    description:
      'Oclusi\u00f3n y estenosis m\u00faltiple bilateral de arterias precerebrales',
    code_2: 'I65',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I658',
    level: 3,
    description: 'Oclusi\u00f3n y estenosis de otras arterias precerebrales',
    code_2: 'I65',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I659',
    level: 3,
    description:
      'Oclusi\u00f3n y estenosis de arteria precerebral no especificada',
    code_2: 'I65',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I790',
    level: 3,
    description:
      'Aneurisma de la aorta en enfermedades clasificadas en otra parte',
    code_2: 'I79',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I791',
    level: 3,
    description: 'Aortitis en enfermedades clasificadas en otra parte',
    code_2: 'I79',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I792',
    level: 3,
    description:
      'Angiopat\u00eda perif\u00e9rica en enfermedades clasificadas en otra parte',
    code_2: 'I79',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I798',
    level: 3,
    description:
      'Otros trastornos de arterias, arteriolas y vasos capilares en enfermedades clasificadas en otra parte',
    code_2: 'I79',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I780',
    level: 3,
    description: 'Telangiectasia hemorr\u00e1gica hereditaria',
    code_2: 'I78',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I781',
    level: 3,
    description: 'Nevo, no neopl\u00e1sico',
    code_2: 'I78',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I788',
    level: 3,
    description: 'Otras enfermedades de los capilares',
    code_2: 'I78',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I789',
    level: 3,
    description: 'Enfermedad de los vasos capilares, no especificada',
    code_2: 'I78',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I770',
    level: 3,
    description: 'F\u00edstula arteriovenosa, adquirida',
    code_2: 'I77',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I771',
    level: 3,
    description: 'Estrechez arterial',
    code_2: 'I77',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I772',
    level: 3,
    description: 'Ruptura arterial',
    code_2: 'I77',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I773',
    level: 3,
    description: 'Displasia fibromuscular arterial',
    code_2: 'I77',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I774',
    level: 3,
    description: 'S\u00edndrome de compresi\u00f3n del tronco cel\u00edaco',
    code_2: 'I77',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I775',
    level: 3,
    description: 'Necrosis arterial',
    code_2: 'I77',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I776',
    level: 3,
    description: 'Arteritis, no especificada',
    code_2: 'I77',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I778',
    level: 3,
    description: 'Otros trastornos especificados de arterias y arteriolas',
    code_2: 'I77',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I779',
    level: 3,
    description: 'Trastorno de arterias y arteriolas, no especificado',
    code_2: 'I77',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I890',
    level: 3,
    description: 'Linfedema, no clasificado en otra parte',
    code_2: 'I89',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I891',
    level: 3,
    description: 'Linfangitis',
    code_2: 'I89',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I898',
    level: 3,
    description:
      'Otros trastornos especificados no infecciosos de los vasos y ganglios linf\u00e1ticos',
    code_2: 'I89',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I899',
    level: 3,
    description:
      'Trastorno no infeccioso de vasos y ganglios linf\u00e1ticos, no especificado',
    code_2: 'I89',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I880',
    level: 3,
    description: 'Linfadenitis mesent\u00e9rica inespec\u00edfica',
    code_2: 'I88',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I881',
    level: 3,
    description: 'Linfadenitis cr\u00f3nica, excepto la mesent\u00e9rica',
    code_2: 'I88',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I888',
    level: 3,
    description: 'Otras linfadenitis inespec\u00edficas',
    code_2: 'I88',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I889',
    level: 3,
    description: 'Linfadenitis inespec\u00edfica no especificada',
    code_2: 'I88',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I870',
    level: 3,
    description: 'S\u00edndrome postfleb\u00edtico',
    code_2: 'I87',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I871',
    level: 3,
    description: 'Compresi\u00f3n de vena',
    code_2: 'I87',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I872',
    level: 3,
    description: 'Insuficiencia venosa (cr\u00f3nica) (perif\u00e9rica)',
    code_2: 'I87',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I878',
    level: 3,
    description: 'Otros trastornos venosos especificados',
    code_2: 'I87',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I879',
    level: 3,
    description: 'Trastorno venoso, no especificado',
    code_2: 'I87',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I860',
    level: 3,
    description: 'V\u00e1rices sublinguales',
    code_2: 'I86',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I861',
    level: 3,
    description: 'V\u00e1rices escrotales',
    code_2: 'I86',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I862',
    level: 3,
    description: 'V\u00e1rices p\u00e9lvicas',
    code_2: 'I86',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I863',
    level: 3,
    description: 'V\u00e1rices de la vulva',
    code_2: 'I86',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I864',
    level: 3,
    description: 'V\u00e1rices g\u00e1stricas',
    code_2: 'I86',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I868',
    level: 3,
    description: 'V\u00e1rices en otros sitios especificados',
    code_2: 'I86',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I850',
    level: 3,
    description: 'V\u00e1rices esof\u00e1gicas con hemorragia',
    code_2: 'I85',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I859',
    level: 3,
    description: 'V\u00e1rices esof\u00e1gicas sin hemorragia',
    code_2: 'I85',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'T140',
    level: 3,
    description:
      'Traumatismo superficial de regi\u00f3n no especificada del cuerpo',
    code_2: 'T14',
    code_0: 'S00-T88',
    code_1: 'T08-T14'
  },
  {
    code: 'T141',
    level: 3,
    description: 'Herida de regi\u00f3n no especificada del cuerpo',
    code_2: 'T14',
    code_0: 'S00-T88',
    code_1: 'T08-T14'
  },
  {
    code: 'T142',
    level: 3,
    description: 'Fractura de regi\u00f3n no especificada del cuerpo',
    code_2: 'T14',
    code_0: 'S00-T88',
    code_1: 'T08-T14'
  },
  {
    code: 'T143',
    level: 3,
    description:
      'Luxaci\u00f3n, esguince y torcedura de regi\u00f3n no especificada del cuerpo',
    code_2: 'T14',
    code_0: 'S00-T88',
    code_1: 'T08-T14'
  },
  {
    code: 'T144',
    level: 3,
    description:
      'Traumatismo de nervio(s) de regi\u00f3n no especificada del cuerpo',
    code_2: 'T14',
    code_0: 'S00-T88',
    code_1: 'T08-T14'
  },
  {
    code: 'T145',
    level: 3,
    description:
      'Traumatismo de vaso(s) sangu\u00edneo(s) de regi\u00f3n no especificada del cuerpo',
    code_2: 'T14',
    code_0: 'S00-T88',
    code_1: 'T08-T14'
  },
  {
    code: 'T146',
    level: 3,
    description:
      'Traumatismo de tendones y m\u00fasculos de regi\u00f3n no especificada del cuerpo',
    code_2: 'T14',
    code_0: 'S00-T88',
    code_1: 'T08-T14'
  },
  {
    code: 'T190',
    level: 3,
    description: 'Cuerpo extra\u00f1o en la uretra/span>',
    code_2: 'T19',
    code_0: 'S00-T88',
    code_1: 'T15-T19'
  },
  {
    code: 'T191',
    level: 3,
    description: 'Cuerpo extra\u00f1o en la vejiga',
    code_2: 'T19',
    code_0: 'S00-T88',
    code_1: 'T15-T19'
  },
  {
    code: 'T192',
    level: 3,
    description: 'Cuerpo extra\u00f1o en la vulva y en la vagina',
    code_2: 'T19',
    code_0: 'S00-T88',
    code_1: 'T15-T19'
  },
  {
    code: 'T193',
    level: 3,
    description: 'Cuerpo extra\u00f1o en el \u00fatero [cualquier parte]',
    code_2: 'T19',
    code_0: 'S00-T88',
    code_1: 'T15-T19'
  },
  {
    code: 'T198',
    level: 3,
    description:
      'Cuerpo extra\u00f1o en otras y en m\u00faltiples partes de las v\u00edas genitourinarias',
    code_2: 'T19',
    code_0: 'S00-T88',
    code_1: 'T15-T19'
  },
  {
    code: 'T199',
    level: 3,
    description:
      'Cuerpo extra\u00f1o en las v\u00edas genitourinarias, parte no especificada',
    code_2: 'T19',
    code_0: 'S00-T88',
    code_1: 'T15-T19'
  },
  {
    code: 'T180',
    level: 3,
    description: 'Cuerpo extra\u00f1o en la boca',
    code_2: 'T18',
    code_0: 'S00-T88',
    code_1: 'T15-T19'
  },
  {
    code: 'T181',
    level: 3,
    description: 'Cuerpo extra\u00f1o en el es\u00f3fago',
    code_2: 'T18',
    code_0: 'S00-T88',
    code_1: 'T15-T19'
  },
  {
    code: 'T182',
    level: 3,
    description: 'Cuerpo extra\u00f1o en el est\u00f3mago',
    code_2: 'T18',
    code_0: 'S00-T88',
    code_1: 'T15-T19'
  },
  {
    code: 'T183',
    level: 3,
    description: 'Cuerpo extra\u00f1o en el intestino delgado',
    code_2: 'T18',
    code_0: 'S00-T88',
    code_1: 'T15-T19'
  },
  {
    code: 'T184',
    level: 3,
    description: 'Cuerpo extra\u00f1o en el colon',
    code_2: 'T18',
    code_0: 'S00-T88',
    code_1: 'T15-T19'
  },
  {
    code: 'T185',
    level: 3,
    description: 'Cuerpo extra\u00f1o en el ano y en el recto',
    code_2: 'T18',
    code_0: 'S00-T88',
    code_1: 'T15-T19'
  },
  {
    code: 'T188',
    level: 3,
    description:
      'Cuerpo extra\u00f1o en otras y en m\u00faltiples partes del tubo digestivo',
    code_2: 'T18',
    code_0: 'S00-T88',
    code_1: 'T15-T19'
  },
  {
    code: 'T189',
    level: 3,
    description:
      'Cuerpo extra\u00f1o en el tubo digestivo, parte no especificada',
    code_2: 'T18',
    code_0: 'S00-T88',
    code_1: 'T15-T19'
  },
  {
    code: 'T440',
    level: 3,
    description: 'Agentes anticolinesterasa',
    code_2: 'T44',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T441',
    level: 3,
    description: 'Otros parasimpaticomim\u00e9ticos [colin\u00e9rgicos]',
    code_2: 'T44',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T442',
    level: 3,
    description:
      'Drogas bloqueadoras ganglionares, no clasificadas en otra parte',
    code_2: 'T44',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T443',
    level: 3,
    description:
      'Otros parasimpaticol\u00edticos [anticolin\u00e9rgicos y antimuscar\u00ednicos] y espasmol\u00edticos, no clasificados en otra parte',
    code_2: 'T44',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T444',
    level: 3,
    description:
      'Agonistas, predominantemente alfa-adren\u00e9rgicos, no clasificados en otra parte',
    code_2: 'T44',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T430',
    level: 3,
    description: 'Antidepresivos tric\u00edclicos y tetrac\u00edclicos',
    code_2: 'T43',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T431',
    level: 3,
    description: 'Antidepresivos inhibidores de la monoaminoxidasa',
    code_2: 'T43',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T432',
    level: 3,
    description: 'Otros antidepresivos y los no especificados',
    code_2: 'T43',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T433',
    level: 3,
    description: 'Antipsic\u00f3ticos y neurol\u00e9pticos fenotiac\u00ednicos',
    code_2: 'T43',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T434',
    level: 3,
    description: 'Butirofenona y neurol\u00e9pticos tioxant\u00e9nicos',
    code_2: 'T43',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T435',
    level: 3,
    description:
      'Otros antipsic\u00f3ticos y neurol\u00e9pticos y los no especificados',
    code_2: 'T43',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T436',
    level: 3,
    description: 'Psicoestimulantes con abuso potencial',
    code_2: 'T43',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T438',
    level: 3,
    description:
      'Otras drogas psicotr\u00f3picas, no clasificadas en otra parte',
    code_2: 'T43',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T439',
    level: 3,
    description: 'Droga psicotr\u00f3pica, no especificada',
    code_2: 'T43',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T420',
    level: 3,
    description: 'Derivados de la hidanto\u00edna',
    code_2: 'T42',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T421',
    level: 3,
    description: 'Iminostilbenos',
    code_2: 'T42',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T422',
    level: 3,
    description: 'Succinamidas y derivados de la oxazolidina',
    code_2: 'T42',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T423',
    level: 3,
    description: 'Barbit\u00faricos',
    code_2: 'T42',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T424',
    level: 3,
    description: 'Benzodiazepinas',
    code_2: 'T42',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T425',
    level: 3,
    description: 'Antiepil\u00e9pticos mixtos, no clasificados en otra parte',
    code_2: 'T42',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T426',
    level: 3,
    description:
      'Otros antiepil\u00e9pticos y drogas hipn\u00f3tico\u2013sedantes',
    code_2: 'T42',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T427',
    level: 3,
    description:
      'Antiepil\u00e9pticos y drogas hipn\u00f3tico\u2013sedantes, no especificados',
    code_2: 'T42',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T428',
    level: 3,
    description:
      'Drogas antiparkinsonianas y otros depresores del tono muscular central',
    code_2: 'T42',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T410',
    level: 3,
    description: 'Anest\u00e9sicos por inhalaci\u00f3n',
    code_2: 'T41',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T411',
    level: 3,
    description: 'Anest\u00e9sicos intravenosos',
    code_2: 'T41',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T412',
    level: 3,
    description: 'Otros anest\u00e9sicos generales y los no especificados',
    code_2: 'T41',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T413',
    level: 3,
    description: 'Anest\u00e9sicos locales',
    code_2: 'T41',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T414',
    level: 3,
    description: 'Anest\u00e9sicos, no especificados',
    code_2: 'T41',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T415',
    level: 3,
    description: 'Gases terap\u00e9uticos',
    code_2: 'T41',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T400',
    level: 3,
    description: 'Opio',
    code_2: 'T40',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T401',
    level: 3,
    description: 'Hero\u00edna',
    code_2: 'T40',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T402',
    level: 3,
    description: 'Otros opi\u00e1ceos',
    code_2: 'T40',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T403',
    level: 3,
    description: 'Metadona',
    code_2: 'T40',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T404',
    level: 3,
    description: 'Otros narc\u00f3ticos sint\u00e9ticos',
    code_2: 'T40',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T405',
    level: 3,
    description: 'Coca\u00edna',
    code_2: 'T40',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T390',
    level: 3,
    description: 'Salicilatos',
    code_2: 'T39',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T391',
    level: 3,
    description: 'Derivados del paraaminofenol',
    code_2: 'T39',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T392',
    level: 3,
    description: 'Derivados de la pirazolona',
    code_2: 'T39',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T393',
    level: 3,
    description: 'Otras drogas antiinflamatorias no esteroideas [DAINE]',
    code_2: 'T39',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T394',
    level: 3,
    description: 'Antirreum\u00e1ticos, no clasificados en otra parte',
    code_2: 'T39',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T398',
    level: 3,
    description:
      'Otros analg\u00e9sicos no narc\u00f3ticos y antipir\u00e9ticos, no clasificados en otra parte',
    code_2: 'T39',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T399',
    level: 3,
    description:
      'Analg\u00e9sicos no narc\u00f3ticos, antipir\u00e9ticos y antirreum\u00e1ticos, no especificados',
    code_2: 'T39',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T620',
    level: 3,
    description: 'Hongos ingeridos',
    code_2: 'T62',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T621',
    level: 3,
    description: 'Bayas ingeridas',
    code_2: 'T62',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T622',
    level: 3,
    description: 'Otra(s) (partes de) planta(s) ingerida(s)',
    code_2: 'T62',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T628',
    level: 3,
    description:
      'Otras sustancias nocivas especificadas ingeridas como alimento',
    code_2: 'T62',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T629',
    level: 3,
    description: 'Sustancia nociva ingerida como alimento, no especificada',
    code_2: 'T62',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T610',
    level: 3,
    description: 'Envenenamiento ciguatero por pescado',
    code_2: 'T61',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T611',
    level: 3,
    description: 'Envenenamiento escombroideo por pescado',
    code_2: 'T61',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T612',
    level: 3,
    description: 'Otros envenenamientos por pescados y mariscos',
    code_2: 'T61',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T618',
    level: 3,
    description: 'Efecto t\u00f3xico de otros alimentos marinos',
    code_2: 'T61',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T619',
    level: 3,
    description: 'Efecto t\u00f3xico de alimentos marinos no especificados',
    code_2: 'T61',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T600',
    level: 3,
    description: 'Insecticidas organofosforados y carbamatos',
    code_2: 'T60',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T601',
    level: 3,
    description: 'Insecticidas halogenados',
    code_2: 'T60',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T602',
    level: 3,
    description: 'Otros insecticidas',
    code_2: 'T60',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T603',
    level: 3,
    description: 'Herbicidas y fungicidas',
    code_2: 'T60',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T604',
    level: 3,
    description: 'Rodenticidas',
    code_2: 'T60',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T608',
    level: 3,
    description: 'Otros plaguicidas',
    code_2: 'T60',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T609',
    level: 3,
    description: 'Plaguicida, no especificado',
    code_2: 'T60',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T590',
    level: 3,
    description: '\u00d3xidos de nitr\u00f3geno',
    code_2: 'T59',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T591',
    level: 3,
    description: 'Di\u00f3xido de sulfuro',
    code_2: 'T59',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T592',
    level: 3,
    description: 'Formaldeh\u00eddo',
    code_2: 'T59',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T593',
    level: 3,
    description: 'Gas lacrim\u00f3geno',
    code_2: 'T59',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T594',
    level: 3,
    description: 'Cloro gaseoso',
    code_2: 'T59',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T595',
    level: 3,
    description: 'Gas de fl\u00faor y fluoruro de hidr\u00f3geno',
    code_2: 'T59',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T596',
    level: 3,
    description: 'Sulfuro de hidr\u00f3geno',
    code_2: 'T59',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T597',
    level: 3,
    description: 'Di\u00f3xido de carbono',
    code_2: 'T59',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T598',
    level: 3,
    description: 'Otros gases, humos y vapores especificados',
    code_2: 'T59',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T570',
    level: 3,
    description: 'Ars\u00e9nico y sus compuestos',
    code_2: 'T57',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T571',
    level: 3,
    description: 'F\u00f3sforo y sus compuestos',
    code_2: 'T57',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T572',
    level: 3,
    description: 'Manganeso y sus compuestos',
    code_2: 'T57',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T573',
    level: 3,
    description: '\u00c1cido cianh\u00eddrico',
    code_2: 'T57',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T578',
    level: 3,
    description: 'Otras sustancias inorg\u00e1nicas, especificadas',
    code_2: 'T57',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T579',
    level: 3,
    description: 'Sustancia inorg\u00e1nica, no especificada',
    code_2: 'T57',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T560',
    level: 3,
    description: 'Plomo y sus compuestos',
    code_2: 'T56',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T561',
    level: 3,
    description: 'Mercurio y sus compuestos',
    code_2: 'T56',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T562',
    level: 3,
    description: 'Cromo y sus compuestos',
    code_2: 'T56',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T563',
    level: 3,
    description: 'Cadmio y sus compuestos',
    code_2: 'T56',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T564',
    level: 3,
    description: 'Cobre y sus compuestos',
    code_2: 'T56',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T565',
    level: 3,
    description: 'Zinc y sus compuestos',
    code_2: 'T56',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T566',
    level: 3,
    description: 'Esta\u00f1o y sus compuestos',
    code_2: 'T56',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T567',
    level: 3,
    description: 'Berilio y sus compuestos',
    code_2: 'T56',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T568',
    level: 3,
    description: 'Otros metales',
    code_2: 'T56',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T569',
    level: 3,
    description: 'Metal, no especificado',
    code_2: 'T56',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T780',
    level: 3,
    description:
      'Choque anafil\u00e1ctico debido a reacci\u00f3n adversa a alimentos',
    code_2: 'T78',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T781',
    level: 3,
    description:
      'Otra reacci\u00f3n adversa a alimentos, no clasificada en otra parte',
    code_2: 'T78',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T782',
    level: 3,
    description: 'Choque anafil\u00e1ctico, no especificado',
    code_2: 'T78',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T783',
    level: 3,
    description: 'Edema angioneur\u00f3tico',
    code_2: 'T78',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T784',
    level: 3,
    description: 'Alergia no especificada',
    code_2: 'T78',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T788',
    level: 3,
    description: 'Otros efectos adversos, no clasificados en otra parte',
    code_2: 'T78',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T789',
    level: 3,
    description: 'Efecto adverso no especificado',
    code_2: 'T78',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T750',
    level: 3,
    description: 'Efectos del rayo',
    code_2: 'T75',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T751',
    level: 3,
    description: 'Ahogamiento y sumersi\u00f3n no mortal',
    code_2: 'T75',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T752',
    level: 3,
    description: 'Efectos de la vibraci\u00f3n',
    code_2: 'T75',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T753',
    level: 3,
    description: 'Mal del movimiento',
    code_2: 'T75',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T754',
    level: 3,
    description: 'Efectos de la corriente el\u00e9ctrica',
    code_2: 'T75',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T758',
    level: 3,
    description: 'Otros efectos especificados de causas externas',
    code_2: 'T75',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T740',
    level: 3,
    description: 'Negligencia o abandono',
    code_2: 'T74',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T741',
    level: 3,
    description: 'Abuso f\u00edsico',
    code_2: 'T74',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T742',
    level: 3,
    description: 'Abuso sexual',
    code_2: 'T74',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T743',
    level: 3,
    description: 'Abuso psicol\u00f3gico',
    code_2: 'T74',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T748',
    level: 3,
    description: 'Otros s\u00edndromes del maltrato',
    code_2: 'T74',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T749',
    level: 3,
    description: 'S\u00edndrome del maltrato, no especificado',
    code_2: 'T74',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T730',
    level: 3,
    description: 'Efectos del hambre',
    code_2: 'T73',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T731',
    level: 3,
    description: 'Efectos de la sed',
    code_2: 'T73',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T732',
    level: 3,
    description: 'Agotamiento debido a exposici\u00f3n a la intemperie',
    code_2: 'T73',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T733',
    level: 3,
    description: 'Agotamiento debido a esfuerzo excesivo',
    code_2: 'T73',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T738',
    level: 3,
    description: 'Otros efectos de privaci\u00f3n',
    code_2: 'T73',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T739',
    level: 3,
    description: 'Efectos de privaci\u00f3n, no especificados',
    code_2: 'T73',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'Z520',
    level: 3,
    description: 'Donante de sangre',
    code_2: 'Z52',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z521',
    level: 3,
    description: 'Donante de piel',
    code_2: 'Z52',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z522',
    level: 3,
    description: 'Donante de hueso',
    code_2: 'Z52',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z523',
    level: 3,
    description: 'Donante de m\u00e9dula osea',
    code_2: 'Z52',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z524',
    level: 3,
    description: 'Donante de ri\u00f1\u00f3n',
    code_2: 'Z52',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z525',
    level: 3,
    description: 'Donante de c\u00f3rnea',
    code_2: 'Z52',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z526',
    level: 3,
    description: 'Donante de h\u00edgado',
    code_2: 'Z52',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z527',
    level: 3,
    description: 'Donante de coraz\u00f3n',
    code_2: 'Z52',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z528',
    level: 3,
    description: 'Donante de otros \u00f3rganos o tejidos',
    code_2: 'Z52',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z529',
    level: 3,
    description: 'Donante de \u00f3rgano o tejido no especificado',
    code_2: 'Z52',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z510',
    level: 3,
    description: 'Sesi\u00f3n de radioterapia',
    code_2: 'Z51',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z511',
    level: 3,
    description: 'Sesi\u00f3n de quimioterapia por tumor',
    code_2: 'Z51',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z512',
    level: 3,
    description: 'Otra quimioterapia',
    code_2: 'Z51',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z513',
    level: 3,
    description: 'Transfusi\u00f3n de sangre, sin diagn\u00f3stico informado',
    code_2: 'Z51',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z514',
    level: 3,
    description:
      'Atenci\u00f3n preparatoria para tratamiento subsecuente, no clasificado en otra parte',
    code_2: 'Z51',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z515',
    level: 3,
    description: 'Atenci\u00f3n paliativa',
    code_2: 'Z51',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z516',
    level: 3,
    description: 'Desensibilizaci\u00f3n a al\u00e9rgenos',
    code_2: 'Z51',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z518',
    level: 3,
    description: 'Otras atenciones m\u00e9dicas especificadas',
    code_2: 'Z51',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z519',
    level: 3,
    description: 'Atenci\u00f3n m\u00e9dica, no especificada',
    code_2: 'Z51',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z500',
    level: 3,
    description: 'Rehabilitaci\u00f3n card\u00edaca',
    code_2: 'Z50',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z501',
    level: 3,
    description: 'Otras terapias f\u00edsicas',
    code_2: 'Z50',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z502',
    level: 3,
    description: 'Rehabilitaci\u00f3n del alcoh\u00f3lico',
    code_2: 'Z50',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z503',
    level: 3,
    description: 'Rehabilitaci\u00f3n del drogadicto',
    code_2: 'Z50',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z504',
    level: 3,
    description: 'Psicoterapia, no clasificada en otra parte',
    code_2: 'Z50',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z505',
    level: 3,
    description: 'Terapia del lenguaje',
    code_2: 'Z50',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z506',
    level: 3,
    description: 'Adiestramiento ort\u00f3ptico',
    code_2: 'Z50',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z507',
    level: 3,
    description:
      'Terapia ocupacional y rehabilitaci\u00f3n vocacional, no clasificada en otra parte',
    code_2: 'Z50',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z490',
    level: 3,
    description: 'Cuidados preparatorios para di\u00e1lisis',
    code_2: 'Z49',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z491',
    level: 3,
    description: 'Di\u00e1lisis extracorp\u00f3rea',
    code_2: 'Z49',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z492',
    level: 3,
    description: 'Otras di\u00e1lisis',
    code_2: 'Z49',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z480',
    level: 3,
    description: 'Atenci\u00f3n de los ap\u00f3sitos y suturas',
    code_2: 'Z48',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z488',
    level: 3,
    description: 'Otros cuidados especificados posteriores a la cirug\u00eda',
    code_2: 'Z48',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z489',
    level: 3,
    description: 'Cuidado posterior a la cirug\u00eda, no especificado',
    code_2: 'Z48',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z470',
    level: 3,
    description:
      'Cuidados posteriores a la extracci\u00f3n de placa u otro dispositivo de fijaci\u00f3n interna en fractura',
    code_2: 'Z47',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z478',
    level: 3,
    description: 'Otros cuidados especificados posteriores a la ortopedia',
    code_2: 'Z47',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z479',
    level: 3,
    description: 'Cuidado posterior a la ortopedia, no especificado',
    code_2: 'Z47',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z460',
    level: 3,
    description: 'Prueba y ajuste de anteojos y lentes de contacto',
    code_2: 'Z46',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z461',
    level: 3,
    description: 'Prueba y ajuste de aud\u00edfonos',
    code_2: 'Z46',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z462',
    level: 3,
    description:
      'Prueba y ajuste de otros dispositivos relacionados con el sistema nervioso y los sentidos especiales',
    code_2: 'Z46',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z463',
    level: 3,
    description: 'Prueba y ajuste de pr\u00f3tesis dental',
    code_2: 'Z46',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z464',
    level: 3,
    description: 'Prueba y ajuste de dispositivo ortod\u00f3ncico',
    code_2: 'Z46',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z465',
    level: 3,
    description:
      'Prueba y ajuste de ileostom\u00eda u otro dispositivo intestinal',
    code_2: 'Z46',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z466',
    level: 3,
    description: 'Prueba y ajuste de dispositivo urinario',
    code_2: 'Z46',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z467',
    level: 3,
    description: 'Prueba y ajuste de dispositivo ortop\u00e9dico',
    code_2: 'Z46',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z468',
    level: 3,
    description: 'Prueba y ajuste de otros dispositivos especificados',
    code_2: 'Z46',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z469',
    level: 3,
    description: 'Prueba y ajuste de dispositivo no especificado',
    code_2: 'Z46',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z450',
    level: 3,
    description: 'Asistencia y ajuste de marcapaso card\u00edaco',
    code_2: 'Z45',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z451',
    level: 3,
    description: 'Asistencia y ajuste de bomba de infusi\u00f3n',
    code_2: 'Z45',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z452',
    level: 3,
    description: 'Asistencia y ajuste de dispositivos de acceso vascular',
    code_2: 'Z45',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z453',
    level: 3,
    description: 'Asistencia y ajuste de dispositivo auditivo implantado',
    code_2: 'Z45',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z458',
    level: 3,
    description: 'Asistencia y ajuste de otros dispositivos implantados',
    code_2: 'Z45',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z459',
    level: 3,
    description:
      'Asistencia y ajuste de dispositivo implantado no especificado',
    code_2: 'Z45',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z440',
    level: 3,
    description: 'Prueba y ajuste de brazo artificial (completo) (parcial)',
    code_2: 'Z44',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z441',
    level: 3,
    description: 'Prueba y ajuste de pierna artificial (completa) (parcial)',
    code_2: 'Z44',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z442',
    level: 3,
    description: 'Prueba y ajuste de ojo artificial',
    code_2: 'Z44',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z443',
    level: 3,
    description: 'Prueba y ajuste de pr\u00f3tesis mamaria externa',
    code_2: 'Z44',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z448',
    level: 3,
    description:
      'Prueba y ajuste de otros dispositivos prot\u00e9sicos externos',
    code_2: 'Z44',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z430',
    level: 3,
    description: 'Atenci\u00f3n de traqueostom\u00eda',
    code_2: 'Z43',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z431',
    level: 3,
    description: 'Atenci\u00f3n de gastrostom\u00eda',
    code_2: 'Z43',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z432',
    level: 3,
    description: 'Atenci\u00f3n de ileostom\u00eda',
    code_2: 'Z43',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z433',
    level: 3,
    description: 'Atenci\u00f3n de colostom\u00eda',
    code_2: 'Z43',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z434',
    level: 3,
    description:
      'Atenci\u00f3n de otros orificios artificiales de las v\u00edas digestivas',
    code_2: 'Z43',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z420',
    level: 3,
    description:
      'Cuidados posteriores a la cirug\u00eda pl\u00e1stica de la cabeza y del cuello',
    code_2: 'Z42',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z421',
    level: 3,
    description:
      'Cuidados posteriores a la cirug\u00eda pl\u00e1stica de la mama',
    code_2: 'Z42',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z422',
    level: 3,
    description:
      'Cuidados posteriores a la cirug\u00eda pl\u00e1stica de otras partes especificadas del tronco',
    code_2: 'Z42',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z423',
    level: 3,
    description:
      'Cuidados posteriores a la cirug\u00eda pl\u00e1stica de las extremidades superiores',
    code_2: 'Z42',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z424',
    level: 3,
    description:
      'Cuidados posteriores a la cirug\u00eda pl\u00e1stica de las extremidades inferiores',
    code_2: 'Z42',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z650',
    level: 3,
    description:
      'Problemas relacionados con culpabilidad en procedimientos civiles o criminales sin prisi\u00f3n',
    code_2: 'Z65',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z651',
    level: 3,
    description:
      'Problemas relacionados con prisi\u00f3n y otro encarcelamiento',
    code_2: 'Z65',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z652',
    level: 3,
    description:
      'Problemas relacionados con la liberaci\u00f3n de la prisi\u00f3n',
    code_2: 'Z65',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z653',
    level: 3,
    description: 'Problemas relacionados con otras circunstancias legales',
    code_2: 'Z65',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z654',
    level: 3,
    description:
      'Problemas relacionados con v\u00edctima de crimen o terrorismo',
    code_2: 'Z65',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z655',
    level: 3,
    description:
      'Problemas relacionados con la exposici\u00f3n a desastre, guerra u otras hostilidades',
    code_2: 'Z65',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z640',
    level: 3,
    description: 'Problemas relacionados con embarazo no deseado',
    code_2: 'Z64',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z641',
    level: 3,
    description: 'Problemas relacionados con la multiparidad',
    code_2: 'Z64',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z642',
    level: 3,
    description:
      'Problemas relacionados con la solicitud o aceptaci\u00f3n de intervenciones f\u00edsicas, nutricionales y qu\u00edmicas, conociendo su riesgo y peligro',
    code_2: 'Z64',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z643',
    level: 3,
    description:
      'Problemas relacionados con la solicitud o aceptaci\u00f3n de intervenciones psicol\u00f3gicas o de la conducta, conociendo su riesgo y peligro',
    code_2: 'Z64',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z644',
    level: 3,
    description: 'Problemas relacionados con el desacuerdo con consejeros',
    code_2: 'Z64',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z630',
    level: 3,
    description: 'Problemas en la relaci\u00f3n entre esposos o pareja',
    code_2: 'Z63',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z631',
    level: 3,
    description:
      'Problemas en la relaci\u00f3n con los padres y los familiares pol\u00edticos',
    code_2: 'Z63',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z632',
    level: 3,
    description: 'Problemas relacionados con el apoyo familiar inadecuado',
    code_2: 'Z63',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z633',
    level: 3,
    description:
      'Problemas relacionados con la ausencia de un miembro de la familia',
    code_2: 'Z63',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z634',
    level: 3,
    description:
      'Problemas relacionados con la desaparici\u00f3n o muerte de un miembro de la familia',
    code_2: 'Z63',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z620',
    level: 3,
    description:
      'Problemas relacionados con la supervisi\u00f3n o el control inadecuados de los padres',
    code_2: 'Z62',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z621',
    level: 3,
    description:
      'Problemas relacionados con la sobreprotecci\u00f3n de los padres',
    code_2: 'Z62',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z622',
    level: 3,
    description: 'Problemas relacionados con la crianza en instituci\u00f3n',
    code_2: 'Z62',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z623',
    level: 3,
    description:
      'Problemas relacionados con hostilidad y reprobaci\u00f3n al ni\u00f1o',
    code_2: 'Z62',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z624',
    level: 3,
    description:
      'Problemas relacionados con el abandono emocional del ni\u00f1o',
    code_2: 'Z62',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z625',
    level: 3,
    description:
      'Otros problemas relacionados con negligencia en la crianza del ni\u00f1o',
    code_2: 'Z62',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z610',
    level: 3,
    description:
      'Problemas relacionados con la p\u00e9rdida de relaci\u00f3n afectiva en la infancia',
    code_2: 'Z61',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z611',
    level: 3,
    description:
      'Problemas relacionados con el alejamiento del hogar en la infancia',
    code_2: 'Z61',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z612',
    level: 3,
    description:
      'Problemas relacionados con alteraci\u00f3n en el patr\u00f3n de la relaci\u00f3n familiar en la infancia',
    code_2: 'Z61',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z613',
    level: 3,
    description:
      'Problemas relacionados con eventos que llevaron a la p\u00e9rdida de la autoestima en la infancia',
    code_2: 'Z61',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z614',
    level: 3,
    description:
      'Problemas relacionados con el abuso sexual del ni\u00f1o por persona dentro del grupo de apoyo primario',
    code_2: 'Z61',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z615',
    level: 3,
    description:
      'Problemas relacionados con el abuso sexual del ni\u00f1o por persona ajena al grupo de apoyo primario',
    code_2: 'Z61',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z616',
    level: 3,
    description: 'Problemas relacionados con abuso f\u00edsico del ni\u00f1o',
    code_2: 'Z61',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z617',
    level: 3,
    description:
      'Problemas relacionados con experiencias personales atemorizantes en la infancia',
    code_2: 'Z61',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z920',
    level: 3,
    description: 'Historia personal de anticoncepci\u00f3n',
    code_2: 'Z92',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z921',
    level: 3,
    description:
      'Historia personal de uso (presente) de anticoagulantes por largo tiempo',
    code_2: 'Z92',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z922',
    level: 3,
    description:
      'Historia personal de uso (presente) de otros medicamentos por largo tiempo',
    code_2: 'Z92',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z923',
    level: 3,
    description: 'Historia personal de irradiaci\u00f3n',
    code_2: 'Z92',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z924',
    level: 3,
    description:
      'Historia personal de cirug\u00eda mayor, no clasificada en otra parte',
    code_2: 'Z92',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z925',
    level: 3,
    description: 'Historia personal de medidas de rehabilitaci\u00f3n',
    code_2: 'Z92',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z926',
    level: 3,
    description:
      'Historia personal de quimioterapia para enfermedad neopl\u00e1sica',
    code_2: 'Z92',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z928',
    level: 3,
    description: 'Historia personal de otros tratamientos m\u00e9dicos',
    code_2: 'Z92',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z910',
    level: 3,
    description:
      'Historia personal de alergia, no debida a drogas ni a sustancias biol\u00f3gicas',
    code_2: 'Z91',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z911',
    level: 3,
    description:
      'Historia personal de incumplimiento del r\u00e9gimen o tratamiento m\u00e9dico',
    code_2: 'Z91',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z912',
    level: 3,
    description: 'Historia personal de higiene personal deficiente',
    code_2: 'Z91',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z913',
    level: 3,
    description:
      'Historia personal de ciclo sue\u00f1o\u2013vigilia no saludable',
    code_2: 'Z91',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z914',
    level: 3,
    description:
      'Historia personal de trauma psicol\u00f3gico, no clasificado en otra parte',
    code_2: 'Z91',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z915',
    level: 3,
    description:
      'Historia personal de lesi\u00f3n autoinfligida intencionalmente',
    code_2: 'Z91',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z916',
    level: 3,
    description: 'Historia personal de otro trauma f\u00edsico',
    code_2: 'Z91',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z918',
    level: 3,
    description:
      'Historia personal de otros factores de riesgo, no clasificados en otra parte',
    code_2: 'Z91',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z900',
    level: 3,
    description: 'Ausencia adquirida de parte de la cabeza y del cuello',
    code_2: 'Z90',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z901',
    level: 3,
    description: 'Ausencia adquirida de mama(s)',
    code_2: 'Z90',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z902',
    level: 3,
    description: 'Ausencia adquirida (de parte) del pulm\u00f3n',
    code_2: 'Z90',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z903',
    level: 3,
    description: 'Ausencia adquirida de parte del est\u00f3mago',
    code_2: 'Z90',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z904',
    level: 3,
    description: 'Ausencia adquirida de otras partes del tubo digestivo',
    code_2: 'Z90',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z905',
    level: 3,
    description: 'Ausencia adquirida de ri\u00f1\u00f3n',
    code_2: 'Z90',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z906',
    level: 3,
    description:
      'Ausencia adquirida de otras partes de las v\u00edas urinarias',
    code_2: 'Z90',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z890',
    level: 3,
    description:
      'Ausencia adquirida de dedo(s), [incluido el pulgar], unilateral',
    code_2: 'Z89',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z891',
    level: 3,
    description: 'Ausencia adquirida de mano y mu\u00f1eca',
    code_2: 'Z89',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z892',
    level: 3,
    description:
      'Ausencia adquirida de miembro superior por arriba de la mu\u00f1eca',
    code_2: 'Z89',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z893',
    level: 3,
    description:
      'Ausencia adquirida de ambos miembros superiores [cualquier nivel]',
    code_2: 'Z89',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z894',
    level: 3,
    description: 'Ausencia adquirida de pie y tobillo',
    code_2: 'Z89',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z895',
    level: 3,
    description:
      'Ausencia adquirida de pierna a nivel de o debajo de la rodilla',
    code_2: 'Z89',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z896',
    level: 3,
    description: 'Ausencia adquirida de pierna por arriba de la rodilla',
    code_2: 'Z89',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z880',
    level: 3,
    description: 'Historia personal de alergia a penicilina',
    code_2: 'Z88',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z881',
    level: 3,
    description:
      'Historia personal de alergia a otros agentes antibi\u00f3ticos',
    code_2: 'Z88',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z882',
    level: 3,
    description: 'Historia personal de alergia a sulfonamidas',
    code_2: 'Z88',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z883',
    level: 3,
    description: 'Historia personal de alergia a otros agentes antiinfecciosos',
    code_2: 'Z88',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z884',
    level: 3,
    description: 'Historia personal de alergia a agente anest\u00e9sico',
    code_2: 'Z88',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z885',
    level: 3,
    description: 'Historia personal de alergia a agente narc\u00f3tico',
    code_2: 'Z88',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z886',
    level: 3,
    description: 'Historia personal de alergia a agente analg\u00e9sico',
    code_2: 'Z88',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z887',
    level: 3,
    description: 'Historia personal de alergia a suero o vacuna',
    code_2: 'Z88',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z888',
    level: 3,
    description:
      'Historia personal de alergia a otras drogas, medicamentos y sustancias biol\u00f3gicas',
    code_2: 'Z88',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z870',
    level: 3,
    description: 'Historia personal de enfermedades del sistema respiratorio',
    code_2: 'Z87',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z871',
    level: 3,
    description: 'Historia personal de enfermedades del sistema digestivo',
    code_2: 'Z87',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z872',
    level: 3,
    description:
      'Historia personal de enfermedades de la piel y del tejido subcut\u00e1neo',
    code_2: 'Z87',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z873',
    level: 3,
    description:
      'Historia personal de enfermedades del sistema osteomuscular y del tejido conjuntivo',
    code_2: 'Z87',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z874',
    level: 3,
    description: 'Historia personal de enfermedades del sistema genitourinario',
    code_2: 'Z87',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z875',
    level: 3,
    description:
      'Historia personal de complicaciones del embarazo, del parto y del puerperio',
    code_2: 'Z87',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z876',
    level: 3,
    description:
      'Historia personal de ciertas afecciones originadas en el per\u00edodo perinatal',
    code_2: 'Z87',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z877',
    level: 3,
    description:
      'Historia personal de malformaciones cong\u00e9nitas, deformidades y anomal\u00edas cromos\u00f3micas',
    code_2: 'Z87',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z878',
    level: 3,
    description: 'Historia personal de otras afecciones especificadas',
    code_2: 'Z87',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z860',
    level: 3,
    description: 'Historia personal de otros tumores',
    code_2: 'Z86',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z861',
    level: 3,
    description: 'Historia personal de enfermedades infecciosas y parasitarias',
    code_2: 'Z86',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z862',
    level: 3,
    description:
      'Historia personal de enfermedades de la sangre y de los \u00f3rganos hematopoy\u00e9ticos y de ciertos trastornos del mecanismo inmunol\u00f3gico',
    code_2: 'Z86',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z863',
    level: 3,
    description:
      'Historia personal de enfermedades endocrinas, nutricionales y metab\u00f3licas',
    code_2: 'Z86',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z864',
    level: 3,
    description: 'Historia personal de abuso de sustancias psicoactivas',
    code_2: 'Z86',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z865',
    level: 3,
    description:
      'Historia personal de otros trastornos mentales o del comportamiento',
    code_2: 'Z86',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z866',
    level: 3,
    description:
      'Historia personal de enfermedades del sistema nervioso y de los \u00f3rganos de los sentidos',
    code_2: 'Z86',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z867',
    level: 3,
    description: 'Historia personal de enfermedades del sistema circulatorio',
    code_2: 'Z86',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z850',
    level: 3,
    description:
      'Historia personal de tumor maligno de \u00f3rganos digestivos',
    code_2: 'Z85',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z851',
    level: 3,
    description:
      'Historia personal de tumor maligno de tr\u00e1quea, bronquios y pulm\u00f3n',
    code_2: 'Z85',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z852',
    level: 3,
    description:
      'Historia personal de tumor maligno de otros \u00f3rganos respiratorios e intrator\u00e1cicos',
    code_2: 'Z85',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z853',
    level: 3,
    description: 'Historia personal de tumor maligno de mama',
    code_2: 'Z85',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z854',
    level: 3,
    description: 'Historia personal de tumor maligno de \u00f3rganos genitales',
    code_2: 'Z85',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z855',
    level: 3,
    description: 'Historia personal de tumor maligno de v\u00edas urinarias',
    code_2: 'Z85',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z856',
    level: 3,
    description: 'Historia personal de leucemia',
    code_2: 'Z85',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z857',
    level: 3,
    description:
      'Historia personal de otros tumores malignos del tejido linfoide, hematopoy\u00e9tico y tejidos relacionados',
    code_2: 'Z85',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z858',
    level: 3,
    description:
      'Historia personal de tumor maligno de otros \u00f3rganos y sistemas',
    code_2: 'Z85',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'T840',
    level: 3,
    description:
      'Complicaci\u00f3n mec\u00e1nica de pr\u00f3tesis articular interna',
    code_2: 'T84',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T841',
    level: 3,
    description:
      'Complicaci\u00f3n mec\u00e1nica de dispositivo de fijaci\u00f3n interna de huesos de un miembro',
    code_2: 'T84',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T842',
    level: 3,
    description:
      'Complicaci\u00f3n mec\u00e1nica de dispositivo de fijaci\u00f3n interna de otros huesos',
    code_2: 'T84',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T843',
    level: 3,
    description:
      'Complicaci\u00f3n mec\u00e1nica de otros dispositivos \u00f3seos, implantes e injertos',
    code_2: 'T84',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T844',
    level: 3,
    description:
      'Complicaci\u00f3n mec\u00e1nica de otros dispositivos prot\u00e9sicos, implantes e injertos ortop\u00e9dicos internos',
    code_2: 'T84',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T845',
    level: 3,
    description:
      'Infecci\u00f3n y reacci\u00f3n inflamatoria debidas a pr\u00f3tesis articular interna',
    code_2: 'T84',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T846',
    level: 3,
    description:
      'Infecci\u00f3n y reacci\u00f3n inflamatoria debidas a dispositivo de fijaci\u00f3n interna [cualquier sitio]',
    code_2: 'T84',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T830',
    level: 3,
    description:
      'Complicaci\u00f3n mec\u00e1nica de cat\u00e9ter urinario (fijo)',
    code_2: 'T83',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T831',
    level: 3,
    description:
      'Complicaci\u00f3n mec\u00e1nica de otros dispositivos e implantes urinarios',
    code_2: 'T83',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T832',
    level: 3,
    description:
      'Complicaci\u00f3n mec\u00e1nica de injerto en \u00f3rgano urinario',
    code_2: 'T83',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T833',
    level: 3,
    description:
      'Complicaci\u00f3n mec\u00e1nica de dispositivo anticonceptivo intrauterino',
    code_2: 'T83',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T834',
    level: 3,
    description:
      'Complicaci\u00f3n mec\u00e1nica de otros dispositivos, implantes e injertos en el tracto genital',
    code_2: 'T83',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T835',
    level: 3,
    description:
      'Infecci\u00f3n y reacci\u00f3n inflamatoria debidas a dispositivo prot\u00e9sico, implante e injerto en el sistema urinario',
    code_2: 'T83',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T836',
    level: 3,
    description:
      'Infecci\u00f3n y reacci\u00f3n inflamatoria debidas a dispositivo prot\u00e9sico, implante e injerto en el tracto genital',
    code_2: 'T83',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T838',
    level: 3,
    description:
      'Otras complicaciones de dispositivos prot\u00e9sicos, implantes e injertos genitourinarios',
    code_2: 'T83',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T839',
    level: 3,
    description:
      'Complicaci\u00f3n no especificada de dispositivo prot\u00e9sico, implante e injerto genitourinario',
    code_2: 'T83',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T820',
    level: 3,
    description:
      'Complicaci\u00f3n mec\u00e1nica de pr\u00f3tesis de v\u00e1lvula card\u00edaca',
    code_2: 'T82',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T821',
    level: 3,
    description:
      'Complicaci\u00f3n mec\u00e1nica de dispositivo electr\u00f3nico card\u00edaco',
    code_2: 'T82',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T822',
    level: 3,
    description:
      'Complicaci\u00f3n mec\u00e1nica de derivaci\u00f3n de arteria coronaria e injerto valvular',
    code_2: 'T82',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T823',
    level: 3,
    description: 'Complicaci\u00f3n mec\u00e1nica de otros injertos vasculares',
    code_2: 'T82',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T824',
    level: 3,
    description:
      'Complicaci\u00f3n mec\u00e1nica de cat\u00e9ter para di\u00e1lisis vascular',
    code_2: 'T82',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T825',
    level: 3,
    description:
      'Complicaci\u00f3n mec\u00e1nica de otros dispositivos e implantes cardiovasculares',
    code_2: 'T82',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T826',
    level: 3,
    description:
      'Infecci\u00f3n y reacci\u00f3n inflamatoria debidas a pr\u00f3tesis de v\u00e1lvula card\u00edaca',
    code_2: 'T82',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T827',
    level: 3,
    description:
      'Infecci\u00f3n y reacci\u00f3n inflamatoria debidas a otros dispositivos, implantes e injertos cardiovasculares',
    code_2: 'T82',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T828',
    level: 3,
    description:
      'Otras complicaciones de dispositivos prot\u00e9sicos, implantes e injertos cardiovasculares',
    code_2: 'T82',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T829',
    level: 3,
    description:
      'Complicaci\u00f3n no especificada de dispositivo prot\u00e9sico, implante e injerto cardiovascular',
    code_2: 'T82',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T810',
    level: 3,
    description:
      'Hemorragia y hematoma que complican un procedimiento, no clasificados en otra parte',
    code_2: 'T81',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T811',
    level: 3,
    description:
      'Choque durante o resultante de un procedimiento, no clasificado en otra parte',
    code_2: 'T81',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T812',
    level: 3,
    description:
      'Punci\u00f3n o laceraci\u00f3n accidental durante un procedimiento, no clasificadas en otra parte',
    code_2: 'T81',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T813',
    level: 3,
    description: 'Desgarro de herida operatoria, no clasificado en otra parte',
    code_2: 'T81',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T800',
    level: 3,
    description:
      'Embolia gaseosa consecutiva a infusi\u00f3n, transfusi\u00f3n e inyecci\u00f3n terap\u00e9utica',
    code_2: 'T80',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T801',
    level: 3,
    description:
      'Complicaciones vasculares consecutivas a infusi\u00f3n, transfusi\u00f3n e inyecci\u00f3n terap\u00e9utica',
    code_2: 'T80',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T802',
    level: 3,
    description:
      'Infecciones consecutivas a infusi\u00f3n, transfusi\u00f3n e inyecci\u00f3n terap\u00e9utica',
    code_2: 'T80',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T803',
    level: 3,
    description: 'Reacci\u00f3n de incompatibilidad al grupo ABO',
    code_2: 'T80',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T804',
    level: 3,
    description: 'Reacci\u00f3n de incompatibilidad a Rh',
    code_2: 'T80',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T805',
    level: 3,
    description: 'Choque anafil\u00e1ctico debido a suero',
    code_2: 'T80',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T806',
    level: 3,
    description: 'Otras reacciones al suero',
    code_2: 'T80',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T808',
    level: 3,
    description:
      'Otras complicaciones consecutivas a infusi\u00f3n, transfusi\u00f3n, e inyecci\u00f3n terap\u00e9utica',
    code_2: 'T80',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T930',
    level: 3,
    description: 'Secuelas de herida de miembro inferior',
    code_2: 'T93',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T931',
    level: 3,
    description: 'Secuelas de fractura del f\u00e9mur',
    code_2: 'T93',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T932',
    level: 3,
    description: 'Secuelas de otras fracturas de miembro inferior',
    code_2: 'T93',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T933',
    level: 3,
    description:
      'Secuelas de luxaci\u00f3n, torcedura y esguince de miembro inferior',
    code_2: 'T93',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T934',
    level: 3,
    description: 'Secuelas de traumatismo de nervio de miembro inferior',
    code_2: 'T93',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T935',
    level: 3,
    description:
      'Secuelas de traumatismo de tend\u00f3n y m\u00fasculo de miembro inferior',
    code_2: 'T93',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T936',
    level: 3,
    description:
      'Secuelas de aplastamiento y amputaci\u00f3n traum\u00e1ticas de miembro inferior',
    code_2: 'T93',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T920',
    level: 3,
    description: 'Secuelas de herida de miembro superior',
    code_2: 'T92',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T921',
    level: 3,
    description: 'Secuelas de fractura del brazo',
    code_2: 'T92',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T922',
    level: 3,
    description: 'Secuelas de fractura de la mu\u00f1eca y de la mano',
    code_2: 'T92',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T923',
    level: 3,
    description:
      'Secuelas de luxaci\u00f3n, torcedura y esguince de miembro superior',
    code_2: 'T92',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T924',
    level: 3,
    description: 'Secuelas de traumatismo de nervio de miembro superior',
    code_2: 'T92',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T925',
    level: 3,
    description:
      'Secuelas de traumatismo de tend\u00f3n y m\u00fasculo de miembro superior',
    code_2: 'T92',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T926',
    level: 3,
    description:
      'Secuelas de aplastamiento y amputaci\u00f3n traum\u00e1ticas de miembro superior',
    code_2: 'T92',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T910',
    level: 3,
    description:
      'Secuelas de traumatismo superficial y de heridas del cuello y del tronco',
    code_2: 'T91',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T911',
    level: 3,
    description: 'Secuelas de fractura de la columna vertebral',
    code_2: 'T91',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T912',
    level: 3,
    description: 'Secuelas de otra fractura del t\u00f3rax y de la pelvis',
    code_2: 'T91',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T913',
    level: 3,
    description: 'Secuelas de traumatismo de la m\u00e9dula espinal',
    code_2: 'T91',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T914',
    level: 3,
    description: 'Secuelas de traumatismo de \u00f3rganos intrator\u00e1cicos',
    code_2: 'T91',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T915',
    level: 3,
    description:
      'Secuelas de traumatismo de \u00f3rganos intraabdominales y p\u00e9lvicos',
    code_2: 'T91',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T918',
    level: 3,
    description:
      'Secuelas de otros traumatismos especificados del cuello y del tronco',
    code_2: 'T91',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T900',
    level: 3,
    description: 'Secuelas de traumatismo superficial de la cabeza',
    code_2: 'T90',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T901',
    level: 3,
    description: 'Secuelas de herida de la cabeza',
    code_2: 'T90',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T902',
    level: 3,
    description: 'Secuelas de fractura del cr\u00e1neo y de huesos faciales',
    code_2: 'T90',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T903',
    level: 3,
    description: 'Secuelas de traumatismo de nervios craneales',
    code_2: 'T90',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T904',
    level: 3,
    description: 'Secuelas de traumatismo del ojo y de la \u00f3rbita',
    code_2: 'T90',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T905',
    level: 3,
    description: 'Secuelas de traumatismo intracraneal',
    code_2: 'T90',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T908',
    level: 3,
    description: 'Secuelas de otros traumatismos especificados de la cabeza',
    code_2: 'T90',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T909',
    level: 3,
    description: 'Secuelas de traumatismo no especificado de la cabeza',
    code_2: 'T90',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'O430',
    level: 3,
    description: 'S\u00edndrome de transfusi\u00f3n placentaria',
    code_2: 'O43',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O431',
    level: 3,
    description: 'Malformaci\u00f3n de la placenta',
    code_2: 'O43',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O438',
    level: 3,
    description: 'Otros trastornos placentarios',
    code_2: 'O43',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O439',
    level: 3,
    description: 'Trastorno de la placenta, no especificado',
    code_2: 'O43',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O420',
    level: 3,
    description:
      'Ruptura prematura de las membranas, e inicio del trabajo de parto dentro de las 24 horas',
    code_2: 'O42',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O421',
    level: 3,
    description:
      'Ruptura prematura de las membranas, e inicio del trabajo de parto despu\u00e9s de las 24 horas',
    code_2: 'O42',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O422',
    level: 3,
    description:
      'Ruptura prematura de las membranas, trabajo de parto retrasado por la terap\u00e9utica',
    code_2: 'O42',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O429',
    level: 3,
    description:
      'Ruptura prematura de las membranas, sin otra especificaci\u00f3n',
    code_2: 'O42',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'T509',
    level: 3,
    description:
      'Otras drogas y sustancias biol\u00f3gicas, y las no especificadas',
    code_2: 'T50',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T497',
    level: 3,
    description: 'Drogas dentales, aplicadas t\u00f3picamente',
    code_2: 'T49',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T498',
    level: 3,
    description: 'Otros agentes t\u00f3picos',
    code_2: 'T49',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T499',
    level: 3,
    description: 'Agentes t\u00f3picos, no especificados',
    code_2: 'T49',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T658',
    level: 3,
    description: 'Efectos t\u00f3xicos de otras sustancias especificadas',
    code_2: 'T65',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T659',
    level: 3,
    description: 'Efecto t\u00f3xico de sustancia no especificada',
    code_2: 'T65',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'Z968',
    level: 3,
    description: 'Presencia de otros implantes funcionales especificados',
    code_2: 'Z96',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z969',
    level: 3,
    description: 'Presencia de implantes funcionales no especificados',
    code_2: 'Z96',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'T884',
    level: 3,
    description: 'Falla o dificultad de la intubaci\u00f3n',
    code_2: 'T88',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T885',
    level: 3,
    description: 'Otras complicaciones de la anestesia',
    code_2: 'T88',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T886',
    level: 3,
    description:
      'Choque anafil\u00e1ctico debido a efecto adverso de droga o medicamento correcto administrado apropiadamente',
    code_2: 'T88',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T887',
    level: 3,
    description: 'Efecto adverso no especificado de droga o medicamento',
    code_2: 'T88',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T888',
    level: 3,
    description:
      'Otras complicaciones especificadas de la atenci\u00f3n m\u00e9dica y quir\u00fargica, no clasificadas en otra parte',
    code_2: 'T88',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T889',
    level: 3,
    description:
      'Complicaciones no especificadas de la atenci\u00f3n m\u00e9dica y quir\u00fargica',
    code_2: 'T88',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'L664',
    level: 3,
    description: 'Foliculitis uleritematosa reticulada',
    code_2: 'L66',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L668',
    level: 3,
    description: 'Otras alopecias cicatriciales',
    code_2: 'L66',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L669',
    level: 3,
    description: 'Alopecia cicatricial, no especificada',
    code_2: 'L66',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'K869',
    level: 3,
    description: 'Enfermedad del p\u00e1ncreas, no especificada',
    code_2: 'K86',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'K834',
    level: 3,
    description: 'Espasmo del esf\u00ednter de Oddi',
    code_2: 'K83',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'K835',
    level: 3,
    description: 'Quiste biliar',
    code_2: 'K83',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'K838',
    level: 3,
    description: 'Otras enfermedades especificadas de las v\u00edas biliares',
    code_2: 'K83',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'K839',
    level: 3,
    description: 'Enfermedad de las v\u00edas biliares, no especificada',
    code_2: 'K83',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'O410',
    level: 3,
    description: 'Oligohidramnios',
    code_2: 'O41',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O411',
    level: 3,
    description: 'Infecci\u00f3n de la bolsa amni\u00f3tica o de las membranas',
    code_2: 'O41',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O418',
    level: 3,
    description:
      'Otros trastornos especificados del l\u00edquido amni\u00f3tico y de las membranas',
    code_2: 'O41',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O419',
    level: 3,
    description:
      'Trastorno del l\u00edquido amni\u00f3tico y de las membranas, no especificado',
    code_2: 'O41',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O360',
    level: 3,
    description: 'Atenci\u00f3n materna por isoinmunizaci\u00f3n rhesus',
    code_2: 'O36',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O361',
    level: 3,
    description: 'Atenci\u00f3n materna por otra isoinmunizaci\u00f3n',
    code_2: 'O36',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O362',
    level: 3,
    description: 'Atenci\u00f3n materna por hidropes\u00eda fetal',
    code_2: 'O36',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O363',
    level: 3,
    description: 'Atenci\u00f3n materna por signos de hipoxia fetal',
    code_2: 'O36',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O364',
    level: 3,
    description: 'Atenci\u00f3n materna por muerte intrauterina',
    code_2: 'O36',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O350',
    level: 3,
    description:
      'Atenci\u00f3n materna por (presunta) malformaci\u00f3n del sistema nervioso central en el feto',
    code_2: 'O35',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O351',
    level: 3,
    description:
      'Atenci\u00f3n materna por (presunta) anormalidad cromos\u00f3mica en el feto',
    code_2: 'O35',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O352',
    level: 3,
    description:
      'Atenci\u00f3n materna por (presunta) enfermedad hereditaria en el feto',
    code_2: 'O35',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O353',
    level: 3,
    description:
      'Atenci\u00f3n materna por (presunta) lesi\u00f3n fetal debida a enfermedad v\u00edrica en la madre',
    code_2: 'O35',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O354',
    level: 3,
    description:
      'Atenci\u00f3n materna por (presunta) lesi\u00f3n al feto debida al alcohol',
    code_2: 'O35',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O355',
    level: 3,
    description:
      'Atenci\u00f3n materna por (presunta) lesi\u00f3n fetal debida a drogas',
    code_2: 'O35',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O356',
    level: 3,
    description:
      'Atenci\u00f3n materna por (presunta) lesi\u00f3n al feto debida a radiaci\u00f3n',
    code_2: 'O35',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O357',
    level: 3,
    description:
      'Atenci\u00f3n materna por (presunta) lesi\u00f3n fetal debida a otros procedimientos m\u00e9dicos',
    code_2: 'O35',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O358',
    level: 3,
    description:
      'Atenci\u00f3n materna por otras (presuntas) anormalidades y lesiones fetales',
    code_2: 'O35',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O359',
    level: 3,
    description:
      'Atenci\u00f3n materna por (presunta) anormalidad y lesi\u00f3n fetal no especificada',
    code_2: 'O35',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'N080',
    level: 3,
    description:
      'Trastornos glomerulares en enfermedades infecciosas y parasitarias clasificadas en otra parte',
    code_2: 'N08',
    code_0: 'N00-N99',
    code_1: 'N00-N08'
  },
  {
    code: 'N081',
    level: 3,
    description: 'Trastornos glomerulares en enfermedades neopl\u00e1sicas',
    code_2: 'N08',
    code_0: 'N00-N99',
    code_1: 'N00-N08'
  },
  {
    code: 'N082',
    level: 3,
    description:
      'Trastornos glomerulares en enfermedades de la sangre y otros trastornos que afectan al mecanismo inmunitario',
    code_2: 'N08',
    code_0: 'N00-N99',
    code_1: 'N00-N08'
  },
  {
    code: 'N083',
    level: 3,
    description:
      'Trastornos glomerulares en diabetes mellitus (E10\u2013E14 con cuarto car\u00e1cter com\u00fan .2)',
    code_2: 'N08',
    code_0: 'N00-N99',
    code_1: 'N00-N08'
  },
  {
    code: 'N084',
    level: 3,
    description:
      'Trastornos glomerulares en otras enfermedades endocrinas, nutricionales y metab\u00f3licas',
    code_2: 'N08',
    code_0: 'N00-N99',
    code_1: 'N00-N08'
  },
  {
    code: 'N085',
    level: 3,
    description:
      'Trastornos glomerulares en trastornos sist\u00e9micos del tejido conjuntivo',
    code_2: 'N08',
    code_0: 'N00-N99',
    code_1: 'N00-N08'
  },
  {
    code: 'N088',
    level: 3,
    description:
      'Trastornos glomerulares en otras enfermedades clasificadas en otra parte',
    code_2: 'N08',
    code_0: 'N00-N99',
    code_1: 'N00-N08'
  },
  {
    code: 'N160',
    level: 3,
    description:
      'Trastornos renales tubulointersticiales en enfermedades infecciosas y parasitarias clasificadas en otra parte',
    code_2: 'N16',
    code_0: 'N00-N99',
    code_1: 'N10-N16'
  },
  {
    code: 'N161',
    level: 3,
    description:
      'Trastornos renales tubulointersticiales en enfermedades neopl\u00e1sicas',
    code_2: 'N16',
    code_0: 'N00-N99',
    code_1: 'N10-N16'
  },
  {
    code: 'N162',
    level: 3,
    description:
      'Trastornos renales tubulointersticiales en enfermedades de la sangre y en trastornos que afectan el mecanismo inmunitario',
    code_2: 'N16',
    code_0: 'N00-N99',
    code_1: 'N10-N16'
  },
  {
    code: 'N163',
    level: 3,
    description:
      'Trastornos renales tubulointersticiales en enfermedades metab\u00f3licas',
    code_2: 'N16',
    code_0: 'N00-N99',
    code_1: 'N10-N16'
  },
  {
    code: 'N164',
    level: 3,
    description:
      'Trastornos renales tubulointersticiales en enfermedades del tejido conjuntivo',
    code_2: 'N16',
    code_0: 'N00-N99',
    code_1: 'N10-N16'
  },
  {
    code: 'N165',
    level: 3,
    description:
      'Trastornos renales tubulointersticiales en rechazo de trasplante (T86.\u2013)',
    code_2: 'N16',
    code_0: 'N00-N99',
    code_1: 'N10-N16'
  },
  {
    code: 'N168',
    level: 3,
    description:
      'Trastornos renales tubulointersticiales en otras enfermedades clasificadas en otra parte',
    code_2: 'N16',
    code_0: 'N00-N99',
    code_1: 'N10-N16'
  },
  {
    code: 'N150',
    level: 3,
    description: 'Nefropat\u00eda de los Balcanes',
    code_2: 'N15',
    code_0: 'N00-N99',
    code_1: 'N10-N16'
  },
  {
    code: 'N151',
    level: 3,
    description: 'Absceso renal y perirrenal',
    code_2: 'N15',
    code_0: 'N00-N99',
    code_1: 'N10-N16'
  },
  {
    code: 'N158',
    level: 3,
    description:
      'Otras enfermedades renales tubulointersticiales especificadas',
    code_2: 'N15',
    code_0: 'N00-N99',
    code_1: 'N10-N16'
  },
  {
    code: 'N159',
    level: 3,
    description: 'Enfermedad renal tubulointersticial, no especificada',
    code_2: 'N15',
    code_0: 'N00-N99',
    code_1: 'N10-N16'
  },
  {
    code: 'N140',
    level: 3,
    description: 'Nefropat\u00eda inducida por analg\u00e9sicos',
    code_2: 'N14',
    code_0: 'N00-N99',
    code_1: 'N10-N16'
  },
  {
    code: 'N141',
    level: 3,
    description:
      'Nefropat\u00eda inducida por otras drogas, medicamentos y sustancias biol\u00f3gicas',
    code_2: 'N14',
    code_0: 'N00-N99',
    code_1: 'N10-N16'
  },
  {
    code: 'N142',
    level: 3,
    description:
      'Nefropat\u00eda inducida por drogas, medicamentos y sustancias biol\u00f3gicas no especificadas',
    code_2: 'N14',
    code_0: 'N00-N99',
    code_1: 'N10-N16'
  },
  {
    code: 'N143',
    level: 3,
    description: 'Nefropat\u00eda inducida por metales pesados',
    code_2: 'N14',
    code_0: 'N00-N99',
    code_1: 'N10-N16'
  },
  {
    code: 'N144',
    level: 3,
    description: 'Nefropat\u00eda t\u00f3xica, no clasificada en otra parte',
    code_2: 'N14',
    code_0: 'N00-N99',
    code_1: 'N10-N16'
  },
  {
    code: 'A280',
    level: 3,
    description: 'Pasteurelosis',
    code_2: 'A28',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A281',
    level: 3,
    description: 'Enfermedad por rasgu\u00f1o de gato',
    code_2: 'A28',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A282',
    level: 3,
    description: 'Yersiniosis extraintestinal',
    code_2: 'A28',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A288',
    level: 3,
    description:
      'Otras enfermedades zoon\u00f3ticas bacterianas especificadas, no clasificadas en otra parte',
    code_2: 'A28',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A289',
    level: 3,
    description:
      'Enfermedad zoon\u00f3tica bacteriana, sin otra especificaci\u00f3n',
    code_2: 'A28',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A270',
    level: 3,
    description: 'Leptospirosis icterohemorr\u00e1gica',
    code_2: 'A27',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A278',
    level: 3,
    description: 'Otras formas de leptospirosis',
    code_2: 'A27',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A279',
    level: 3,
    description: 'Leptospirosis, no especificada',
    code_2: 'A27',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A260',
    level: 3,
    description: 'Erisipeloide cut\u00e1neo',
    code_2: 'A26',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A267',
    level: 3,
    description: 'Septicemia por Erysipelothrix',
    code_2: 'A26',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A268',
    level: 3,
    description: 'Otras formas de erisipeloide',
    code_2: 'A26',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A269',
    level: 3,
    description: 'Erisipeloide, no especificada',
    code_2: 'A26',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A250',
    level: 3,
    description: 'Espirilosis',
    code_2: 'A25',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A251',
    level: 3,
    description: 'Estreptobacilosis',
    code_2: 'A25',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A259',
    level: 3,
    description: 'Fiebre por mordedura de rata, no especificada',
    code_2: 'A25',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A240',
    level: 3,
    description: 'Muermo',
    code_2: 'A24',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A241',
    level: 3,
    description: 'Melioidosis aguda y fulminante',
    code_2: 'A24',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A242',
    level: 3,
    description: 'Melioidosis subaguda y cr\u00f3nica',
    code_2: 'A24',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A243',
    level: 3,
    description: 'Otras melioidosis',
    code_2: 'A24',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A244',
    level: 3,
    description: 'Melioidosis, no especificada',
    code_2: 'A24',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A430',
    level: 3,
    description: 'Nocardiosis pulmonar',
    code_2: 'A43',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A431',
    level: 3,
    description: 'Nocardiosis cut\u00e1nea',
    code_2: 'A43',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A438',
    level: 3,
    description: 'Otras formas de nocardiosis',
    code_2: 'A43',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A439',
    level: 3,
    description: 'Nocardiosis, no especificada',
    code_2: 'A43',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A420',
    level: 3,
    description: 'Actinomicosis pulmonar',
    code_2: 'A42',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A421',
    level: 3,
    description: 'Actinomicosis abdominal',
    code_2: 'A42',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A422',
    level: 3,
    description: 'Actinomicosis cervicofacial',
    code_2: 'A42',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A427',
    level: 3,
    description: 'Septicemia actinomic\u00f3tica',
    code_2: 'A42',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A428',
    level: 3,
    description: 'Otras formas de actinomicosis',
    code_2: 'A42',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A429',
    level: 3,
    description: 'Actinomicosis, sin otra especificaci\u00f3n',
    code_2: 'A42',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A410',
    level: 3,
    description: 'Septicemia debida a Staphylococcus aureus',
    code_2: 'A41',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A411',
    level: 3,
    description: 'Septicemia debida a otro estafilococo especificado',
    code_2: 'A41',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A412',
    level: 3,
    description: 'Septicemia debida a estafilococo no especificado',
    code_2: 'A41',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A413',
    level: 3,
    description: 'Septicemia debida a Haemophilus influenzae',
    code_2: 'A41',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A414',
    level: 3,
    description: 'Septicemia debida a anaerobios',
    code_2: 'A41',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A415',
    level: 3,
    description: 'Septicemia debida a otros organismos gramnegativos',
    code_2: 'A41',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A418',
    level: 3,
    description: 'Otras septicemias especificadas',
    code_2: 'A41',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A419',
    level: 3,
    description: 'Septicemia, no especificada',
    code_2: 'A41',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A400',
    level: 3,
    description: 'Septicemia debida a estreptococo, grupo A',
    code_2: 'A40',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A401',
    level: 3,
    description: 'Septicemia debida a estreptococo, grupo B',
    code_2: 'A40',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A402',
    level: 3,
    description: 'Septicemia debida a estreptococo, grupo D',
    code_2: 'A40',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A403',
    level: 3,
    description: 'Septicemia debida a Streptococcus pneumoniae',
    code_2: 'A40',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A408',
    level: 3,
    description: 'Otras septicemias estreptoc\u00f3cicas',
    code_2: 'A40',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A409',
    level: 3,
    description: 'Septicemia estreptoc\u00f3cica, no especificada',
    code_2: 'A40',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A390',
    level: 3,
    description: 'Meningitis meningoc\u00f3cica (G01)',
    code_2: 'A39',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A391',
    level: 3,
    description: 'S\u00edndrome de Waterhouse-Friderichsen (E35.1)',
    code_2: 'A39',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A392',
    level: 3,
    description: 'Meningococemia aguda',
    code_2: 'A39',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A393',
    level: 3,
    description: 'Meningococemia cr\u00f3nica',
    code_2: 'A39',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A394',
    level: 3,
    description: 'Meningococemia, no especificada',
    code_2: 'A39',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A395',
    level: 3,
    description: 'Enfermedad card\u00edaca debida a meningococo',
    code_2: 'A39',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A398',
    level: 3,
    description: 'Otras formas de enfermedad meningoc\u00f3cica:',
    code_2: 'A39',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A399',
    level: 3,
    description: 'Enfermedad meningoc\u00f3cica, no especificada',
    code_2: 'A39',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A370',
    level: 3,
    description: 'Tos ferina debida a Bordetella pertussis',
    code_2: 'A37',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A371',
    level: 3,
    description: 'Tos ferina debida a Bordetella parapertussis',
    code_2: 'A37',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A378',
    level: 3,
    description: 'Tos ferina debida a otras especies de Bordetella',
    code_2: 'A37',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A379',
    level: 3,
    description: 'Tos ferina, no especificada',
    code_2: 'A37',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A360',
    level: 3,
    description: 'Difteria far\u00edngea',
    code_2: 'A36',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A361',
    level: 3,
    description: 'Difteria nasofar\u00edngea',
    code_2: 'A36',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A362',
    level: 3,
    description: 'Difteria lar\u00edngea',
    code_2: 'A36',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A630',
    level: 3,
    description: 'Verrugas (ven\u00e9reas) anogenitales',
    code_2: 'A63',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A638',
    level: 3,
    description:
      'Otras enfermedades de transmisi\u00f3n predominantemente sexual, especificadas',
    code_2: 'A63',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A600',
    level: 3,
    description:
      'Infecci\u00f3n de genitales y trayecto urogenital debida a virus del herpes [herpes simple]',
    code_2: 'A60',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A601',
    level: 3,
    description:
      'Infecci\u00f3n de la piel perianal y recto por virus del herpes simple',
    code_2: 'A60',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A609',
    level: 3,
    description:
      'Infecci\u00f3n anogenital por virus del herpes simple, sin otra especificaci\u00f3n',
    code_2: 'A60',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A590',
    level: 3,
    description: 'Tricomoniasis urogenital',
    code_2: 'A59',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A598',
    level: 3,
    description: 'Tricomoniasis de otros sitios',
    code_2: 'A59',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A599',
    level: 3,
    description: 'Tricomoniasis, no especificada',
    code_2: 'A59',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A560',
    level: 3,
    description:
      'Infecci\u00f3n del tracto genitourinario inferior debida a clamidias',
    code_2: 'A56',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A561',
    level: 3,
    description:
      'Infecci\u00f3n del pelviperitoneo y otros \u00f3rganos genitourinarios debida a clamidias',
    code_2: 'A56',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A562',
    level: 3,
    description:
      'Infecciones del tracto genitourinario debidas a clamidias, sin otra especificaci\u00f3n',
    code_2: 'A56',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A563',
    level: 3,
    description: 'Infecci\u00f3n del ano y del recto debida a clamidias',
    code_2: 'A56',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A564',
    level: 3,
    description: 'Infecci\u00f3n de faringe debida a clamidias',
    code_2: 'A56',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A568',
    level: 3,
    description:
      'Infecci\u00f3n de transmisi\u00f3n sexual de otros sitios debida a clamidias',
    code_2: 'A56',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A540',
    level: 3,
    description:
      'Infecci\u00f3n gonoc\u00f3cica del tracto genitourinario inferior sin absceso periuretral o de gl\u00e1ndula accesoria',
    code_2: 'A54',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A541',
    level: 3,
    description:
      'Infecci\u00f3n gonoc\u00f3cica del tracto genitourinario inferior con absceso periuretral y de gl\u00e1ndulas accesorias',
    code_2: 'A54',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A542',
    level: 3,
    description:
      'Pelviperitonitis gonoc\u00f3cica y otras infecciones gonoc\u00f3cicas genitourinarias',
    code_2: 'A54',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A543',
    level: 3,
    description: 'Infecci\u00f3n gonoc\u00f3cica del ojo',
    code_2: 'A54',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A544',
    level: 3,
    description: 'Infecci\u00f3n gonoc\u00f3cica del sistema osteomuscular',
    code_2: 'A54',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A545',
    level: 3,
    description: 'Faringitis gonoc\u00f3cica',
    code_2: 'A54',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A880',
    level: 3,
    description: 'Fiebre exantem\u00e1tica enteroviral [exantema de Boston]',
    code_2: 'A88',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A881',
    level: 3,
    description: 'V\u00e9rtigo epid\u00e9mico',
    code_2: 'A88',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A888',
    level: 3,
    description:
      'Otras infecciones virales especificadas del sistema nervioso central',
    code_2: 'A88',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A870',
    level: 3,
    description: 'Meningitis enteroviral (G02.0)',
    code_2: 'A87',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A871',
    level: 3,
    description: 'Meningitis debida a adenovirus (G02.0)',
    code_2: 'A87',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A872',
    level: 3,
    description: 'Coriomeningitis linfoc\u00edtica',
    code_2: 'A87',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A878',
    level: 3,
    description: 'Otras meningitis virales',
    code_2: 'A87',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A879',
    level: 3,
    description: 'Meningitis viral, sin otra especificaci\u00f3n',
    code_2: 'A87',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A980',
    level: 3,
    description: 'Fiebre hemorr\u00e1gica de Crimea-Congo',
    code_2: 'A98',
    code_0: 'A00-B99',
    code_1: 'A90-A99'
  },
  {
    code: 'A981',
    level: 3,
    description: 'Fiebre hemorr\u00e1gica de Omsk',
    code_2: 'A98',
    code_0: 'A00-B99',
    code_1: 'A90-A99'
  },
  {
    code: 'A982',
    level: 3,
    description: 'Enfermedad de la selva de Kyasanur',
    code_2: 'A98',
    code_0: 'A00-B99',
    code_1: 'A90-A99'
  },
  {
    code: 'A983',
    level: 3,
    description: 'Enfermedad por el virus de Marburg',
    code_2: 'A98',
    code_0: 'A00-B99',
    code_1: 'A90-A99'
  },
  {
    code: 'A984',
    level: 3,
    description: 'Enfermedad por el virus de Ebola',
    code_2: 'A98',
    code_0: 'A00-B99',
    code_1: 'A90-A99'
  },
  {
    code: 'A985',
    level: 3,
    description: 'Fiebres hemorr\u00e1gicas con s\u00edndrome renal',
    code_2: 'A98',
    code_0: 'A00-B99',
    code_1: 'A90-A99'
  },
  {
    code: 'A988',
    level: 3,
    description: 'Otras fiebres hemorr\u00e1gicas virales especificadas',
    code_2: 'A98',
    code_0: 'A00-B99',
    code_1: 'A90-A99'
  },
  {
    code: 'A960',
    level: 3,
    description: 'Fiebre hemorr\u00e1gica de Jun\u00edn',
    code_2: 'A96',
    code_0: 'A00-B99',
    code_1: 'A90-A99'
  },
  {
    code: 'A961',
    level: 3,
    description: 'Fiebre hemorr\u00e1gica de Machupo',
    code_2: 'A96',
    code_0: 'A00-B99',
    code_1: 'A90-A99'
  },
  {
    code: 'A962',
    level: 3,
    description: 'Fiebre de Lassa',
    code_2: 'A96',
    code_0: 'A00-B99',
    code_1: 'A90-A99'
  },
  {
    code: 'A968',
    level: 3,
    description: 'Otras fiebres hemorr\u00e1gicas por arenavirus',
    code_2: 'A96',
    code_0: 'A00-B99',
    code_1: 'A90-A99'
  },
  {
    code: 'A969',
    level: 3,
    description:
      'Fiebre hemorr\u00e1gica por arenavirus, sin otra especificaci\u00f3n',
    code_2: 'A96',
    code_0: 'A00-B99',
    code_1: 'A90-A99'
  },
  {
    code: 'A950',
    level: 3,
    description: 'Fiebre amarilla selv\u00e1tica',
    code_2: 'A95',
    code_0: 'A00-B99',
    code_1: 'A90-A99'
  },
  {
    code: 'A951',
    level: 3,
    description: 'Fiebre amarilla urbana',
    code_2: 'A95',
    code_0: 'A00-B99',
    code_1: 'A90-A99'
  },
  {
    code: 'A959',
    level: 3,
    description: 'Fiebre amarilla, no especificada',
    code_2: 'A95',
    code_0: 'A00-B99',
    code_1: 'A90-A99'
  },
  {
    code: 'A930',
    level: 3,
    description: 'Enfermedad por virus de Oropouche',
    code_2: 'A93',
    code_0: 'A00-B99',
    code_1: 'A90-A99'
  },
  {
    code: 'A931',
    level: 3,
    description: 'Fiebre transmitida por fleb\u00f3tomos',
    code_2: 'A93',
    code_0: 'A00-B99',
    code_1: 'A90-A99'
  },
  {
    code: 'A932',
    level: 3,
    description: 'Fiebre de Colorado transmitida por garrapatas',
    code_2: 'A93',
    code_0: 'A00-B99',
    code_1: 'A90-A99'
  },
  {
    code: 'A938',
    level: 3,
    description:
      'Otras fiebres virales especificadas transmitidas por artr\u00f3podos',
    code_2: 'A93',
    code_0: 'A00-B99',
    code_1: 'A90-A99'
  },
  {
    code: 'M360',
    level: 3,
    description:
      'Dermato(poli)miositis en enfermedad neopl\u00e1sica (C00\u2013D48)',
    code_2: 'M36',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M361',
    level: 3,
    description: 'Artropat\u00eda en enfermedad neopl\u00e1sica (C00\u2013D48)',
    code_2: 'M36',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M362',
    level: 3,
    description: 'Artropat\u00eda hemof\u00edlica (D66\u2013D68)',
    code_2: 'M36',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M363',
    level: 3,
    description:
      'Artropat\u00eda en otros trastornos de la sangre (D50\u2013D76)',
    code_2: 'M36',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M364',
    level: 3,
    description:
      'Artropat\u00eda en reacciones de hipersensibilidad clasificadas en otra parte',
    code_2: 'M36',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M368',
    level: 3,
    description:
      'Trastornos sist\u00e9micos del tejido conjuntivo en otras enfermedades clasificadas en otra parte',
    code_2: 'M36',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'N290',
    level: 3,
    description: 'S\u00edfilis renal tard\u00eda',
    code_2: 'N29',
    code_0: 'N00-N99',
    code_1: 'N25-N29'
  },
  {
    code: 'N291',
    level: 3,
    description:
      'Otros trastornos del ri\u00f1\u00f3n y del ur\u00e9ter en enfermedades infecciosas y parasitarias clasificadas en otra parte',
    code_2: 'N29',
    code_0: 'N00-N99',
    code_1: 'N25-N29'
  },
  {
    code: 'N298',
    level: 3,
    description:
      'Otros trastornos del ri\u00f1\u00f3n y del ur\u00e9ter en otras enfermedades clasificadas en otra parte',
    code_2: 'N29',
    code_0: 'N00-N99',
    code_1: 'N25-N29'
  },
  {
    code: 'N280',
    level: 3,
    description: 'Isquemia e infarto del ri\u00f1\u00f3n',
    code_2: 'N28',
    code_0: 'N00-N99',
    code_1: 'N25-N29'
  },
  {
    code: 'N281',
    level: 3,
    description: 'Quiste de ri\u00f1\u00f3n, adquirido',
    code_2: 'N28',
    code_0: 'N00-N99',
    code_1: 'N25-N29'
  },
  {
    code: 'N288',
    level: 3,
    description:
      'Otros trastornos especificados del ri\u00f1\u00f3n y del ur\u00e9ter',
    code_2: 'N28',
    code_0: 'N00-N99',
    code_1: 'N25-N29'
  },
  {
    code: 'N289',
    level: 3,
    description:
      'Trastorno del ri\u00f1\u00f3n y del ur\u00e9ter, no especificado',
    code_2: 'N28',
    code_0: 'N00-N99',
    code_1: 'N25-N29'
  },
  {
    code: 'N270',
    level: 3,
    description: 'Ri\u00f1\u00f3n peque\u00f1o, unilateral',
    code_2: 'N27',
    code_0: 'N00-N99',
    code_1: 'N25-N29'
  },
  {
    code: 'N271',
    level: 3,
    description: 'Ri\u00f1\u00f3n peque\u00f1o, bilateral',
    code_2: 'N27',
    code_0: 'N00-N99',
    code_1: 'N25-N29'
  },
  {
    code: 'N279',
    level: 3,
    description: 'Ri\u00f1\u00f3n peque\u00f1o, no especificado',
    code_2: 'N27',
    code_0: 'N00-N99',
    code_1: 'N25-N29'
  },
  {
    code: 'N250',
    level: 3,
    description: 'Osteodistrofia renal',
    code_2: 'N25',
    code_0: 'N00-N99',
    code_1: 'N25-N29'
  },
  {
    code: 'N251',
    level: 3,
    description: 'Diabetes ins\u00edpida nefr\u00f3gena',
    code_2: 'N25',
    code_0: 'N00-N99',
    code_1: 'N25-N29'
  },
  {
    code: 'N258',
    level: 3,
    description:
      'Otros trastornos resultantes de la funci\u00f3n tubular renal alterada',
    code_2: 'N25',
    code_0: 'N00-N99',
    code_1: 'N25-N29'
  },
  {
    code: 'N259',
    level: 3,
    description:
      'Trastorno no especificado, resultante de la funci\u00f3n tubular renal alterada',
    code_2: 'N25',
    code_0: 'N00-N99',
    code_1: 'N25-N29'
  },
  {
    code: 'N330',
    level: 3,
    description: 'Cistitis tuberculosa (A18.1)',
    code_2: 'N33',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N338',
    level: 3,
    description:
      'Trastornos de la vejiga en otras enfermedades clasificadas en otra parte',
    code_2: 'N33',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N320',
    level: 3,
    description: 'Obstrucci\u00f3n de cuello de la vejiga',
    code_2: 'N32',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N321',
    level: 3,
    description: 'F\u00edstula vesicointestinal',
    code_2: 'N32',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N322',
    level: 3,
    description: 'F\u00edstula de la vejiga, no clasificada en otra parte',
    code_2: 'N32',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N323',
    level: 3,
    description: 'Divert\u00edculo de la vejiga',
    code_2: 'N32',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N324',
    level: 3,
    description: 'Ruptura de la vejiga, no traum\u00e1tica',
    code_2: 'N32',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N328',
    level: 3,
    description: 'Otros trastornos especificados de la vejiga',
    code_2: 'N32',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N329',
    level: 3,
    description: 'Trastorno de la vejiga, no especificado',
    code_2: 'N32',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N310',
    level: 3,
    description:
      'Vejiga neurop\u00e1tica no inhibida, no clasificada en otra parte',
    code_2: 'N31',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N311',
    level: 3,
    description:
      'Vejiga neurop\u00e1tica refleja, no clasificada en otra parte',
    code_2: 'N31',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N312',
    level: 3,
    description:
      'Vejiga neurop\u00e1tica fl\u00e1cida, no clasificada en otra parte',
    code_2: 'N31',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N318',
    level: 3,
    description: 'Otras disfunciones neuromusculares de la vejiga',
    code_2: 'N31',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N319',
    level: 3,
    description: 'Disfunci\u00f3n neuromuscular de la vejiga, no especificada',
    code_2: 'N31',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N300',
    level: 3,
    description: 'Cistitis aguda',
    code_2: 'N30',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N301',
    level: 3,
    description: 'Cistitis intersticial (cr\u00f3nica)',
    code_2: 'N30',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N302',
    level: 3,
    description: 'Otras cistitis cr\u00f3nicas',
    code_2: 'N30',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N303',
    level: 3,
    description: 'Trigonitis',
    code_2: 'N30',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N304',
    level: 3,
    description: 'Cistitis por irradiaci\u00f3n',
    code_2: 'N30',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N308',
    level: 3,
    description: 'Otras cistitis',
    code_2: 'N30',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N450',
    level: 3,
    description: 'Orquitis, epididimitis y orquiepididimitis con absceso',
    code_2: 'N45',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N459',
    level: 3,
    description: 'Orquitis, epididimitis y orquiepididimitis sin absceso',
    code_2: 'N45',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N430',
    level: 3,
    description: 'Hidrocele enquistado',
    code_2: 'N43',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N431',
    level: 3,
    description: 'Hidrocele infectado',
    code_2: 'N43',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N432',
    level: 3,
    description: 'Otros hidroceles',
    code_2: 'N43',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N433',
    level: 3,
    description: 'Hidrocele, no especificado',
    code_2: 'N43',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N434',
    level: 3,
    description: 'Espermatocele',
    code_2: 'N43',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N420',
    level: 3,
    description: 'C\u00e1lculo de la pr\u00f3stata',
    code_2: 'N42',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N421',
    level: 3,
    description: 'Congesti\u00f3n y hemorragia de la pr\u00f3stata',
    code_2: 'N42',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N422',
    level: 3,
    description: 'Atrofia de la pr\u00f3stata',
    code_2: 'N42',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N428',
    level: 3,
    description: 'Otros trastornos especificados de la pr\u00f3stata',
    code_2: 'N42',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N429',
    level: 3,
    description: 'Trastorno de la pr\u00f3stata, no especificado',
    code_2: 'N42',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N410',
    level: 3,
    description: 'Prostatitis aguda',
    code_2: 'N41',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N411',
    level: 3,
    description: 'Prostatitis cr\u00f3nica',
    code_2: 'N41',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N412',
    level: 3,
    description: 'Absceso de la pr\u00f3stata',
    code_2: 'N41',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N413',
    level: 3,
    description: 'Prostatocistitis',
    code_2: 'N41',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N418',
    level: 3,
    description: 'Otras enfermedades inflamatorias de la pr\u00f3stata',
    code_2: 'N41',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N419',
    level: 3,
    description: 'Enfermedad inflamatoria de la pr\u00f3stata, no especificada',
    code_2: 'N41',
    code_0: 'N00-N99',
    code_1: 'N40-N51'
  },
  {
    code: 'N600',
    level: 3,
    description: 'Quiste solitario de la mama',
    code_2: 'N60',
    code_0: 'N00-N99',
    code_1: 'N60-N64'
  },
  {
    code: 'N601',
    level: 3,
    description: 'Mastopat\u00eda qu\u00edstica difusa',
    code_2: 'N60',
    code_0: 'N00-N99',
    code_1: 'N60-N64'
  },
  {
    code: 'N602',
    level: 3,
    description: 'Fibroadenosis de mama',
    code_2: 'N60',
    code_0: 'N00-N99',
    code_1: 'N60-N64'
  },
  {
    code: 'N603',
    level: 3,
    description: 'Fibroesclerosis de mama',
    code_2: 'N60',
    code_0: 'N00-N99',
    code_1: 'N60-N64'
  },
  {
    code: 'N604',
    level: 3,
    description: 'Ectasia de conducto mamario',
    code_2: 'N60',
    code_0: 'N00-N99',
    code_1: 'N60-N64'
  },
  {
    code: 'N608',
    level: 3,
    description: 'Otras displasias mamarias benignas',
    code_2: 'N60',
    code_0: 'N00-N99',
    code_1: 'N60-N64'
  },
  {
    code: 'N609',
    level: 3,
    description: 'Displasia mamaria benigna, sin otra especificaci\u00f3n',
    code_2: 'N60',
    code_0: 'N00-N99',
    code_1: 'N60-N64'
  },
  {
    code: 'N740',
    level: 3,
    description: 'Infecci\u00f3n tuberculosa del cuello del \u00fatero (A18.1)',
    code_2: 'N74',
    code_0: 'N00-N99',
    code_1: 'N70-N77'
  },
  {
    code: 'N741',
    level: 3,
    description:
      'Enfermedad inflamatoria p\u00e9lvica femenina por tuberculosis (A18.1)',
    code_2: 'N74',
    code_0: 'N00-N99',
    code_1: 'N70-N77'
  },
  {
    code: 'N742',
    level: 3,
    description:
      'Enfermedad inflamatoria p\u00e9lvica femenina por s\u00edfilis (A51.4, A52.7)',
    code_2: 'N74',
    code_0: 'N00-N99',
    code_1: 'N70-N77'
  },
  {
    code: 'N743',
    level: 3,
    description:
      'Enfermedad inflamatoria p\u00e9lvica femenina por gonococos (A54.2)',
    code_2: 'N74',
    code_0: 'N00-N99',
    code_1: 'N70-N77'
  },
  {
    code: 'N744',
    level: 3,
    description:
      'Enfermedad inflamatoria p\u00e9lvica femenina por clamidias (A56.1)',
    code_2: 'N74',
    code_0: 'N00-N99',
    code_1: 'N70-N77'
  },
  {
    code: 'N748',
    level: 3,
    description:
      'Trastornos inflamatorios p\u00e9lvicos femeninos en otras enfermedades clasificadas en otra parte',
    code_2: 'N74',
    code_0: 'N00-N99',
    code_1: 'N70-N77'
  },
  {
    code: 'N730',
    level: 3,
    description: 'Parametritis y celulitis p\u00e9lvica aguda',
    code_2: 'N73',
    code_0: 'N00-N99',
    code_1: 'N70-N77'
  },
  {
    code: 'N731',
    level: 3,
    description: 'Parametritis y celulitis p\u00e9lvica cr\u00f3nica',
    code_2: 'N73',
    code_0: 'N00-N99',
    code_1: 'N70-N77'
  },
  {
    code: 'N732',
    level: 3,
    description: 'Parametritis y celulitis p\u00e9lvica no especificada',
    code_2: 'N73',
    code_0: 'N00-N99',
    code_1: 'N70-N77'
  },
  {
    code: 'N733',
    level: 3,
    description: 'Peritonitis p\u00e9lvica aguda, femenina',
    code_2: 'N73',
    code_0: 'N00-N99',
    code_1: 'N70-N77'
  },
  {
    code: 'N734',
    level: 3,
    description: 'Peritonitis p\u00e9lvica cr\u00f3nica, femenina',
    code_2: 'N73',
    code_0: 'N00-N99',
    code_1: 'N70-N77'
  },
  {
    code: 'N735',
    level: 3,
    description: 'Peritonitis p\u00e9lvica femenina, no especificada',
    code_2: 'N73',
    code_0: 'N00-N99',
    code_1: 'N70-N77'
  },
  {
    code: 'N736',
    level: 3,
    description: 'Adherencias peritoneales p\u00e9lvicas femeninas',
    code_2: 'N73',
    code_0: 'N00-N99',
    code_1: 'N70-N77'
  },
  {
    code: 'N738',
    level: 3,
    description: 'Otras enfermedades inflamatorias p\u00e9lvicas femeninas',
    code_2: 'N73',
    code_0: 'N00-N99',
    code_1: 'N70-N77'
  },
  {
    code: 'N739',
    level: 3,
    description:
      'Enfermedad inflamatoria p\u00e9lvica femenina, no especificada',
    code_2: 'N73',
    code_0: 'N00-N99',
    code_1: 'N70-N77'
  },
  {
    code: 'N710',
    level: 3,
    description: 'Enfermedad inflamatoria aguda del \u00fatero',
    code_2: 'N71',
    code_0: 'N00-N99',
    code_1: 'N70-N77'
  },
  {
    code: 'N711',
    level: 3,
    description: 'Enfermedad inflamatoria cr\u00f3nica del \u00fatero',
    code_2: 'N71',
    code_0: 'N00-N99',
    code_1: 'N70-N77'
  },
  {
    code: 'N719',
    level: 3,
    description: 'Enfermedad inflamatoria del \u00fatero, no especificada',
    code_2: 'N71',
    code_0: 'N00-N99',
    code_1: 'N70-N77'
  },
  {
    code: 'N700',
    level: 3,
    description: 'Salpingitis y ooforitis aguda',
    code_2: 'N70',
    code_0: 'N00-N99',
    code_1: 'N70-N77'
  },
  {
    code: 'N701',
    level: 3,
    description: 'Salpingitis y ooforitis cr\u00f3nica',
    code_2: 'N70',
    code_0: 'N00-N99',
    code_1: 'N70-N77'
  },
  {
    code: 'N709',
    level: 3,
    description: 'Salpingitis y ooforitis, no especificadas',
    code_2: 'N70',
    code_0: 'N00-N99',
    code_1: 'N70-N77'
  },
  {
    code: 'N830',
    level: 3,
    description: 'Quiste folicular del ovario',
    code_2: 'N83',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N831',
    level: 3,
    description: 'Quiste del cuerpo amarillo',
    code_2: 'N83',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N832',
    level: 3,
    description: 'Otros quistes ov\u00e1ricos y los no especificados',
    code_2: 'N83',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N833',
    level: 3,
    description: 'Atrofia adquirida del ovario y de la trompa de Falopio',
    code_2: 'N83',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N834',
    level: 3,
    description: 'Prolapso y hernia del ovario y de la trompa de Falopio',
    code_2: 'N83',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N835',
    level: 3,
    description:
      'Torsi\u00f3n de ovario, ped\u00edculo de ovario y trompa de Falopio',
    code_2: 'N83',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N836',
    level: 3,
    description: 'Hematosalpinx',
    code_2: 'N83',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N837',
    level: 3,
    description: 'Hematoma del ligamento ancho',
    code_2: 'N83',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N838',
    level: 3,
    description:
      'Otros trastornos no inflamatorios del ovario, de la trompa de Falopio y del ligamento ancho',
    code_2: 'N83',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N820',
    level: 3,
    description: 'F\u00edstula vesicovaginal',
    code_2: 'N82',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N821',
    level: 3,
    description:
      'Otras f\u00edstulas de las v\u00edas genitourinarias femeninas',
    code_2: 'N82',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N822',
    level: 3,
    description: 'F\u00edstula de la vagina al intestino delgado',
    code_2: 'N82',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N823',
    level: 3,
    description: 'F\u00edstula de la vagina al intestino grueso',
    code_2: 'N82',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N824',
    level: 3,
    description:
      'Otras f\u00edstulas del tracto genital femenino al tracto intestinal',
    code_2: 'N82',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N825',
    level: 3,
    description: 'F\u00edstula del tracto genital femenino a la piel',
    code_2: 'N82',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N828',
    level: 3,
    description: 'Otras f\u00edstulas del tracto genital femenino',
    code_2: 'N82',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N829',
    level: 3,
    description:
      'F\u00edstula del tracto genital femenino, sin otra especificaci\u00f3n',
    code_2: 'N82',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N810',
    level: 3,
    description: 'Uretrocele femenino',
    code_2: 'N81',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N811',
    level: 3,
    description: 'Cistocele',
    code_2: 'N81',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N812',
    level: 3,
    description: 'Prolapso uterovaginal incompleto',
    code_2: 'N81',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N813',
    level: 3,
    description: 'Prolapso uterovaginal completo',
    code_2: 'N81',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N814',
    level: 3,
    description: 'Prolapso uterovaginal, sin otra especificaci\u00f3n',
    code_2: 'N81',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N815',
    level: 3,
    description: 'Enterocele vaginal',
    code_2: 'N81',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N816',
    level: 3,
    description: 'Rectocele',
    code_2: 'N81',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N818',
    level: 3,
    description: 'Otros prolapsos genitales femeninos',
    code_2: 'N81',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N819',
    level: 3,
    description: 'Prolapso genital femenino, no especificado',
    code_2: 'N81',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N800',
    level: 3,
    description: 'Endometriosis del \u00fatero',
    code_2: 'N80',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N801',
    level: 3,
    description: 'Endometriosis del ovario',
    code_2: 'N80',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N802',
    level: 3,
    description: 'Endometriosis de la trompa de Falopio',
    code_2: 'N80',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N803',
    level: 3,
    description: 'Endometriosis del peritoneo p\u00e9lvico',
    code_2: 'N80',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N804',
    level: 3,
    description: 'Endometriosis del tabique rectovaginal y de la vagina',
    code_2: 'N80',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N805',
    level: 3,
    description: 'Endometriosis del intestino',
    code_2: 'N80',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N806',
    level: 3,
    description: 'Endometriosis en cicatriz cut\u00e1nea',
    code_2: 'N80',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N808',
    level: 3,
    description: 'Otras endometriosis',
    code_2: 'N80',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'N809',
    level: 3,
    description: 'Endometriosis, no especificada',
    code_2: 'N80',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'L080',
    level: 3,
    description: 'Pioderma',
    code_2: 'L08',
    code_0: 'L00-L99',
    code_1: 'L00-L08'
  },
  {
    code: 'L081',
    level: 3,
    description: 'Eritrasma',
    code_2: 'L08',
    code_0: 'L00-L99',
    code_1: 'L00-L08'
  },
  {
    code: 'L088',
    level: 3,
    description:
      'Otras infecciones locales especificadas de la piel y del tejido subcut\u00e1neo',
    code_2: 'L08',
    code_0: 'L00-L99',
    code_1: 'L00-L08'
  },
  {
    code: 'L089',
    level: 3,
    description:
      'Infecci\u00f3n local de la piel y del tejido subcut\u00e1neo, no especificada',
    code_2: 'L08',
    code_0: 'L00-L99',
    code_1: 'L00-L08'
  },
  {
    code: 'L050',
    level: 3,
    description: 'Quiste pilonidal con absceso',
    code_2: 'L05',
    code_0: 'L00-L99',
    code_1: 'L00-L08'
  },
  {
    code: 'L059',
    level: 3,
    description: 'Quiste pilonidal sin absceso',
    code_2: 'L05',
    code_0: 'L00-L99',
    code_1: 'L00-L08'
  },
  {
    code: 'L130',
    level: 3,
    description: 'Dermatitis herpetiforme',
    code_2: 'L13',
    code_0: 'L00-L99',
    code_1: 'L10-L14'
  },
  {
    code: 'L131',
    level: 3,
    description: 'Dermatitis pustulosa subcorneal',
    code_2: 'L13',
    code_0: 'L00-L99',
    code_1: 'L10-L14'
  },
  {
    code: 'L138',
    level: 3,
    description: 'Otros trastornos flictenulares especificados',
    code_2: 'L13',
    code_0: 'L00-L99',
    code_1: 'L10-L14'
  },
  {
    code: 'L139',
    level: 3,
    description: 'Trastorno flictenular, no especificado',
    code_2: 'L13',
    code_0: 'L00-L99',
    code_1: 'L10-L14'
  },
  {
    code: 'L300',
    level: 3,
    description: 'Dermatitis numular',
    code_2: 'L30',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L301',
    level: 3,
    description: 'Dishidrosis [ponf\u00f3lix]',
    code_2: 'L30',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L302',
    level: 3,
    description: 'Autosensibilizaci\u00f3n cut\u00e1nea',
    code_2: 'L30',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'J675',
    level: 3,
    description: 'Pulm\u00f3n del manipulador de hongos',
    code_2: 'J67',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'J676',
    level: 3,
    description: 'Pulm\u00f3n del descortezador del arce',
    code_2: 'J67',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'J677',
    level: 3,
    description:
      'Neumonitis de la ventilaci\u00f3n debida al acondicionador y humidificador del aire',
    code_2: 'J67',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'J678',
    level: 3,
    description:
      'SNeumonitis debidas a hipersensibilidad a otros polvos org\u00e1nicos',
    code_2: 'J67',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'J679',
    level: 3,
    description:
      'Neumonitis debida a hipersensibilidad a polvo org\u00e1nico no especificado',
    code_2: 'J67',
    code_0: 'J00-J99',
    code_1: 'J60-J70'
  },
  {
    code: 'I359',
    level: 3,
    description: 'Trastorno de la v\u00e1lvula a\u00f3rtica, no especificado',
    code_2: 'I35',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'T147',
    level: 3,
    description:
      'Traumatismo por aplastamiento y amputaci\u00f3n traum\u00e1tica de regiones no especificadas del cuerpo',
    code_2: 'T14',
    code_0: 'S00-T88',
    code_1: 'T08-T14'
  },
  {
    code: 'T148',
    level: 3,
    description: 'Otros traumatismos de regi\u00f3n no especificada del cuerpo',
    code_2: 'T14',
    code_0: 'S00-T88',
    code_1: 'T08-T14'
  },
  {
    code: 'T149',
    level: 3,
    description: 'Traumatismo, no especificado',
    code_2: 'T14',
    code_0: 'S00-T88',
    code_1: 'T08-T14'
  },
  {
    code: 'T445',
    level: 3,
    description:
      'Agonistas, predominantemente beta-adren\u00e9rgicos, no clasificados en otra parte',
    code_2: 'T44',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T446',
    level: 3,
    description:
      'Antagonistas alfa-adren\u00e9rgicos, no clasificados en otra parte',
    code_2: 'T44',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T447',
    level: 3,
    description:
      'Antagonistas beta-adren\u00e9rgicos, no clasificados en otra parte',
    code_2: 'T44',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T448',
    level: 3,
    description:
      'Agentes de acci\u00f3n central y bloqueadores neuronales adren\u00e9rgicos, no clasificados en otra parte',
    code_2: 'T44',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T449',
    level: 3,
    description:
      'Otras drogas y las no especificadas que afectan principalmente el sistema nervioso aut\u00f3nomo',
    code_2: 'T44',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T406',
    level: 3,
    description: 'Otros narc\u00f3ticos y los no especificados',
    code_2: 'T40',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T407',
    level: 3,
    description: 'Cannabis (derivados)',
    code_2: 'T40',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T408',
    level: 3,
    description: 'Acido lis\u00e9rgico [LSD]',
    code_2: 'T40',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T409',
    level: 3,
    description:
      'Otros psicodisl\u00e9pticos y los no especificados [alucin\u00f3genos]',
    code_2: 'T40',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T599',
    level: 3,
    description: 'Gases, humos y vapores no especificados',
    code_2: 'T59',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'Z508',
    level: 3,
    description:
      'Atenci\u00f3n por otros procedimientos de rehabilitaci\u00f3n',
    code_2: 'Z50',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z509',
    level: 3,
    description:
      'Atenci\u00f3n por procedimiento de rehabilitaci\u00f3n, no especificada',
    code_2: 'Z50',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z449',
    level: 3,
    description:
      'Prueba y ajuste de dispositivo prot\u00e9sico externo no especificado',
    code_2: 'Z44',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z435',
    level: 3,
    description: 'Atenci\u00f3n de cistostom\u00eda',
    code_2: 'Z43',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z436',
    level: 3,
    description:
      'Atenci\u00f3n de otros orificios artificiales de las v\u00edas urinarias',
    code_2: 'Z43',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z437',
    level: 3,
    description: 'Atenci\u00f3n de vagina artificial',
    code_2: 'Z43',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z438',
    level: 3,
    description: 'Atenci\u00f3n de otros orificios artificiales',
    code_2: 'Z43',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z439',
    level: 3,
    description: 'Atenci\u00f3n de orificio artificial no especificado',
    code_2: 'Z43',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z428',
    level: 3,
    description:
      'Cuidados posteriores a la cirug\u00eda pl\u00e1stica de otras partes especificadas del cuerpo',
    code_2: 'Z42',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z429',
    level: 3,
    description:
      'Cuidados posteriores a la cirug\u00eda pl\u00e1stica no especificada',
    code_2: 'Z42',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z658',
    level: 3,
    description:
      'Otros problemas especificados relacionados con circunstancias psicosociales',
    code_2: 'Z65',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z659',
    level: 3,
    description:
      'Problemas relacionados con circunstancias psicosociales no especificadas',
    code_2: 'Z65',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z635',
    level: 3,
    description:
      'Problemas relacionados con la ruptura familiar por separaci\u00f3n o divorcio',
    code_2: 'Z63',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z636',
    level: 3,
    description:
      'Problemas relacionados con familiar dependiente, necesitado de cuidado en la casa',
    code_2: 'Z63',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z637',
    level: 3,
    description:
      'Problemas relacionados con otros hechos estresantes que afectan a la familia y al hogar',
    code_2: 'Z63',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z638',
    level: 3,
    description:
      'Otros problemas especificados relacionados con el grupo primario de apoyo',
    code_2: 'Z63',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z639',
    level: 3,
    description:
      'Problema no especificado relacionado con el grupo primario de apoyo',
    code_2: 'Z63',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z626',
    level: 3,
    description:
      'Problemas relacionados con presiones inapropiadas de los padres y otras anormalidades en la calidad de la crianza',
    code_2: 'Z62',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z628',
    level: 3,
    description:
      'Otros problemas especificados y relacionados con la crianza del ni\u00f1o',
    code_2: 'Z62',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z629',
    level: 3,
    description:
      'Problema no especificado relacionado con la crianza del ni\u00f1o',
    code_2: 'Z62',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z618',
    level: 3,
    description:
      'Problemas relacionados con otras experiencias negativas en la infancia',
    code_2: 'Z61',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z619',
    level: 3,
    description:
      'Problemas relacionados con experiencia negativa no especificada en la infancia',
    code_2: 'Z61',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z929',
    level: 3,
    description: 'Historia personal de tratamiento m\u00e9dico no especificado',
    code_2: 'Z92',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z907',
    level: 3,
    description: 'Ausencia adquirida de \u00f3rgano(s) genital(es)',
    code_2: 'Z90',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z908',
    level: 3,
    description: 'Ausencia adquirida de otros \u00f3rganos',
    code_2: 'Z90',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z897',
    level: 3,
    description:
      'Ausencia adquirida de ambos miembros inferiores [cualquier nivel, excepto dedos del pie solamente]',
    code_2: 'Z89',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z898',
    level: 3,
    description:
      'Ausencia adquirida de miembros superiores e inferiores [cualquier nivel]',
    code_2: 'Z89',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z899',
    level: 3,
    description: 'Ausencia adquirida de miembros no especificados',
    code_2: 'Z89',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z889',
    level: 3,
    description:
      'Historia personal de alergia a drogas, medicamentos y sustancias biol\u00f3gicas no especificadas',
    code_2: 'Z88',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z859',
    level: 3,
    description: 'Historia personal de tumor maligno, de sitio no especificado',
    code_2: 'Z85',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'T847',
    level: 3,
    description:
      'Infecci\u00f3n y reacci\u00f3n inflamatoria debidas a otros disposi\u00adtivos prot\u00e9sicos, implantes e injertos ortop\u00e9dicos internos',
    code_2: 'T84',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T848',
    level: 3,
    description:
      'Otras complicaciones de dispositivos prot\u00e9sicos, implantes e injertos ortop\u00e9dicos internos',
    code_2: 'T84',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T849',
    level: 3,
    description:
      'Complicaciones no especificadas de dispositivos prot\u00e9sicos, implantes e injertos ortop\u00e9dicos internos',
    code_2: 'T84',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T814',
    level: 3,
    description:
      'Infecci\u00f3n consecutiva a procedimiento, no clasificada en otra parte',
    code_2: 'T81',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T815',
    level: 3,
    description:
      'Cuerpo extra\u00f1o dejado accidentalmente en cavidad corporal o en herida operatoria consecutiva a procedimiento',
    code_2: 'T81',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T816',
    level: 3,
    description:
      'Reacci\u00f3n aguda a sustancia extra\u00f1a dejada accidentalmente durante un procedimiento',
    code_2: 'T81',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T817',
    level: 3,
    description:
      'Complicaciones vasculares consecutivas a procedimiento, no clasificadas en otra parte',
    code_2: 'T81',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T818',
    level: 3,
    description:
      'Otras complicaciones de procedimientos, no clasificadas en otra parte',
    code_2: 'T81',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T819',
    level: 3,
    description: 'Complicaci\u00f3n de procedimientos, no especificada',
    code_2: 'T81',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T809',
    level: 3,
    description:
      'Complicaciones no especificadas consecutivas a infusi\u00f3n, transfusi\u00f3n e inyecci\u00f3n terap\u00e9utica',
    code_2: 'T80',
    code_0: 'S00-T88',
    code_1: 'T80-T88'
  },
  {
    code: 'T938',
    level: 3,
    description:
      'Secuelas de otros traumatismos especificados de miembro inferior',
    code_2: 'T93',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T939',
    level: 3,
    description: 'Secuelas de traumatismo no especificado de miembro inferior',
    code_2: 'T93',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T928',
    level: 3,
    description:
      'Secuelas de otros traumatismos especificados de miembro superior',
    code_2: 'T92',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T929',
    level: 3,
    description: 'Secuelas de traumatismo no especificado de miembro superior',
    code_2: 'T92',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'T919',
    level: 3,
    description:
      'Secuelas de traumatismo no especificado del cuello y del tronco',
    code_2: 'T91',
    code_0: 'S00-T88',
    code_1: 'T90-T98'
  },
  {
    code: 'L290',
    level: 3,
    description: 'Prurito anal',
    code_2: 'L29',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L291',
    level: 3,
    description: 'Prurito escrotal',
    code_2: 'L29',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L292',
    level: 3,
    description: 'Prurito vulvar',
    code_2: 'L29',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L293',
    level: 3,
    description: 'Prurito anogenital, no especificado',
    code_2: 'L29',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L298',
    level: 3,
    description: 'Otros pruritos',
    code_2: 'L29',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L299',
    level: 3,
    description: 'Prurito, no especificado',
    code_2: 'L29',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L280',
    level: 3,
    description: 'Liquen simple cr\u00f3nico',
    code_2: 'L28',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L281',
    level: 3,
    description: 'Prurigo nodular',
    code_2: 'L28',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L282',
    level: 3,
    description: 'Otros prurigos',
    code_2: 'L28',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L270',
    level: 3,
    description:
      'Erupci\u00f3n cut\u00e1nea generalizada debida a drogas y medicamentos',
    code_2: 'L27',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L271',
    level: 3,
    description:
      'Erupci\u00f3n cut\u00e1nea localizada debida a drogas y medicamentos',
    code_2: 'L27',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L272',
    level: 3,
    description: 'Dermatitis debida a ingesti\u00f3n de alimentos',
    code_2: 'L27',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L278',
    level: 3,
    description: 'Dermatitis debida a otras sustancias ingeridas',
    code_2: 'L27',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L279',
    level: 3,
    description: 'Dermatitis debida a sustancias ingeridas no especificadas',
    code_2: 'L27',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'K130',
    level: 3,
    description: 'Enfermedades de los labios',
    code_2: 'K13',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K131',
    level: 3,
    description: 'Mordedura del labio y de la mejilla',
    code_2: 'K13',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K132',
    level: 3,
    description:
      'Leucoplasia y otras alteraciones del epitelio bucal, incluyendo la lengua',
    code_2: 'K13',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K133',
    level: 3,
    description: 'Leucoplasia pilosa',
    code_2: 'K13',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K134',
    level: 3,
    description: 'Granuloma y lesiones semejantes de la mucosa bucal',
    code_2: 'K13',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K135',
    level: 3,
    description: 'Fibrosis de la submucosa bucal',
    code_2: 'K13',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K136',
    level: 3,
    description: 'Hiperplasia irrritativa de la mucosa bucal',
    code_2: 'K13',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K137',
    level: 3,
    description: 'Otras lesiones y las no especificadas de la mucosa bucal',
    code_2: 'K13',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K120',
    level: 3,
    description: 'Estomatitis aftosa recurrente',
    code_2: 'K12',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K121',
    level: 3,
    description: 'Otras formas de estomatitis',
    code_2: 'K12',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K122',
    level: 3,
    description: 'Celulitis y absceso de boca',
    code_2: 'K12',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K110',
    level: 3,
    description: 'Atrofia de gl\u00e1ndula salival',
    code_2: 'K11',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K111',
    level: 3,
    description: 'Hipertrofia de gl\u00e1ndula salival',
    code_2: 'K11',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K112',
    level: 3,
    description: 'Sialadenitis',
    code_2: 'K11',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K113',
    level: 3,
    description: 'Absceso de gl\u00e1ndula salival',
    code_2: 'K11',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K114',
    level: 3,
    description: 'F\u00edstula de gl\u00e1ndula salival',
    code_2: 'K11',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K115',
    level: 3,
    description: 'Sialolitiasis',
    code_2: 'K11',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K116',
    level: 3,
    description: 'Mucocele de gl\u00e1ndula salival',
    code_2: 'K11',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K117',
    level: 3,
    description: 'Alteraciones de la secreci\u00f3n salival',
    code_2: 'K11',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K118',
    level: 3,
    description: 'Otras enfermedades de las gl\u00e1ndulas salivales',
    code_2: 'K11',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K119',
    level: 3,
    description: 'Enfermedad de gl\u00e1ndula salival, no especificada',
    code_2: 'K11',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K100',
    level: 3,
    description: 'Trastornos del desarrollo de los maxilares',
    code_2: 'K10',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K101',
    level: 3,
    description: 'Granuloma central de c\u00e9lulas gigantes',
    code_2: 'K10',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K102',
    level: 3,
    description: 'Afecciones inflamatorias de los maxilares',
    code_2: 'K10',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K103',
    level: 3,
    description: 'Alveolitis del maxilar',
    code_2: 'K10',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K108',
    level: 3,
    description: 'Otras enfermedades especificadas de los maxilares',
    code_2: 'K10',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K109',
    level: 3,
    description: 'Enfermedad de los maxilares, no especificada',
    code_2: 'K10',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K090',
    level: 3,
    description: 'Quistes originados por el desarrollo de los dientes',
    code_2: 'K09',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K091',
    level: 3,
    description: 'Quistes de las fisuras (no odontog\u00e9nicos)',
    code_2: 'K09',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K092',
    level: 3,
    description: 'Otros quistes de los maxilares',
    code_2: 'K09',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K098',
    level: 3,
    description:
      'Otros quistes de la regi\u00f3n bucal, no clasificados en otra parte',
    code_2: 'K09',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K099',
    level: 3,
    description: 'Quiste de la regi\u00f3n bucal, sin otra especificaci\u00f3n',
    code_2: 'K09',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K080',
    level: 3,
    description:
      'Exfoliaci\u00f3n de los dientes debida a causas sist\u00e9micas',
    code_2: 'K08',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K081',
    level: 3,
    description:
      'P\u00e9rdida de dientes debida a accidente, extracci\u00f3n o enfermedad periodontal local',
    code_2: 'K08',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K082',
    level: 3,
    description: 'Atrofia del reborde alveolar desdentado',
    code_2: 'K08',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K083',
    level: 3,
    description: 'Ra\u00edz dental retenida',
    code_2: 'K08',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K088',
    level: 3,
    description:
      'Otras afecciones especificadas de los dientes y de sus estructuras de sost\u00e9n',
    code_2: 'K08',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K089',
    level: 3,
    description:
      'Trastorno de los dientes y de sus estructuras de sost\u00e9n, no especificado',
    code_2: 'K08',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K070',
    level: 3,
    description: 'Anomal\u00edas evidentes del tama\u00f1o de los maxilares',
    code_2: 'K07',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K071',
    level: 3,
    description: 'Anomal\u00edas de la relaci\u00f3n maxilobasilar',
    code_2: 'K07',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K072',
    level: 3,
    description: 'Anomal\u00edas de la relaci\u00f3n entre los arcos dentarios',
    code_2: 'K07',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K073',
    level: 3,
    description: 'Anomal\u00edas de la posici\u00f3n del diente',
    code_2: 'K07',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K074',
    level: 3,
    description: 'Maloclusi\u00f3n de tipo no especificado',
    code_2: 'K07',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K075',
    level: 3,
    description: 'Anomal\u00edas dentofaciales funcionales',
    code_2: 'K07',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K060',
    level: 3,
    description: 'Retracci\u00f3n gingival',
    code_2: 'K06',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K061',
    level: 3,
    description: 'Hiperplasia gingival',
    code_2: 'K06',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K062',
    level: 3,
    description:
      'Lesiones de la enc\u00eda y de la zona ed\u00e9ntula asociadas con traumatismo',
    code_2: 'K06',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K068',
    level: 3,
    description:
      'Otros trastornos especificados de la enc\u00eda y de la zona ed\u00e9ntula',
    code_2: 'K06',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K069',
    level: 3,
    description:
      'Trastorno no especificado de la enc\u00eda y de la zona ed\u00e9ntula',
    code_2: 'K06',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K310',
    level: 3,
    description: 'Dilataci\u00f3n aguda del est\u00f3mago',
    code_2: 'K31',
    code_0: 'K00-K95',
    code_1: 'K20-K31'
  },
  {
    code: 'K311',
    level: 3,
    description: 'Estenosis pil\u00f3rica hipertr\u00f3fica del adulto',
    code_2: 'K31',
    code_0: 'K00-K95',
    code_1: 'K20-K31'
  },
  {
    code: 'K312',
    level: 3,
    description: 'Estrechez o estenosis del est\u00f3mago en reloj de arena',
    code_2: 'K31',
    code_0: 'K00-K95',
    code_1: 'K20-K31'
  },
  {
    code: 'K313',
    level: 3,
    description: 'Espasmo del p\u00edloro, no clasificado en otra parte',
    code_2: 'K31',
    code_0: 'K00-K95',
    code_1: 'K20-K31'
  },
  {
    code: 'K314',
    level: 3,
    description: 'Divert\u00edculo g\u00e1strico',
    code_2: 'K31',
    code_0: 'K00-K95',
    code_1: 'K20-K31'
  },
  {
    code: 'K290',
    level: 3,
    description: 'Gastritis aguda hemorr\u00e1gica',
    code_2: 'K29',
    code_0: 'K00-K95',
    code_1: 'K20-K31'
  },
  {
    code: 'K291',
    level: 3,
    description: 'Otras gastritis agudas',
    code_2: 'K29',
    code_0: 'K00-K95',
    code_1: 'K20-K31'
  },
  {
    code: 'K292',
    level: 3,
    description: 'Gastritis alcoh\u00f3lica',
    code_2: 'K29',
    code_0: 'K00-K95',
    code_1: 'K20-K31'
  },
  {
    code: 'K293',
    level: 3,
    description: 'Gastritis cr\u00f3nica superficial',
    code_2: 'K29',
    code_0: 'K00-K95',
    code_1: 'K20-K31'
  },
  {
    code: 'K294',
    level: 3,
    description: 'Gastritis cr\u00f3nica atr\u00f3fica',
    code_2: 'K29',
    code_0: 'K00-K95',
    code_1: 'K20-K31'
  },
  {
    code: 'K295',
    level: 3,
    description: 'Gastritis cr\u00f3nica, no especificada',
    code_2: 'K29',
    code_0: 'K00-K95',
    code_1: 'K20-K31'
  },
  {
    code: 'K296',
    level: 3,
    description: 'Otras gastritis',
    code_2: 'K29',
    code_0: 'K00-K95',
    code_1: 'K20-K31'
  },
  {
    code: 'K297',
    level: 3,
    description: 'Gastritis, no especificada',
    code_2: 'K29',
    code_0: 'K00-K95',
    code_1: 'K20-K31'
  },
  {
    code: 'K298',
    level: 3,
    description: 'Duodenitis',
    code_2: 'K29',
    code_0: 'K00-K95',
    code_1: 'K20-K31'
  },
  {
    code: 'K299',
    level: 3,
    description: 'Gastroduodenitis, no especificada',
    code_2: 'K29',
    code_0: 'K00-K95',
    code_1: 'K20-K31'
  },
  {
    code: 'O365',
    level: 3,
    description: 'Atenci\u00f3n materna por d\u00e9ficit del crecimiento fetal',
    code_2: 'O36',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O366',
    level: 3,
    description: 'Atenci\u00f3n materna por crecimiento fetal excesivo',
    code_2: 'O36',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O367',
    level: 3,
    description: 'Atenci\u00f3n materna por feto viable en embarazo abdominal',
    code_2: 'O36',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O368',
    level: 3,
    description:
      'Atenci\u00f3n materna por otros problemas fetales especificados',
    code_2: 'O36',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O369',
    level: 3,
    description: 'Atenci\u00f3n materna por problemas fetales no especificados',
    code_2: 'O36',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'K230',
    level: 3,
    description: 'Esofagitis tuberculosa (A18.8)',
    code_2: 'K23',
    code_0: 'K00-K95',
    code_1: 'K20-K31'
  },
  {
    code: 'K231',
    level: 3,
    description: 'Megaes\u00f3fago en la enfermedad de Chagas (B57.3)',
    code_2: 'K23',
    code_0: 'K00-K95',
    code_1: 'K20-K31'
  },
  {
    code: 'K238',
    level: 3,
    description:
      'Trastornos del es\u00f3fago en otras enfermedades clasificadas en otra parte',
    code_2: 'K23',
    code_0: 'K00-K95',
    code_1: 'K20-K31'
  },
  {
    code: 'K460',
    level: 3,
    description:
      'Hernia abdominal no especificada, con obstrucci\u00f3n, sin gangrena',
    code_2: 'K46',
    code_0: 'K00-K95',
    code_1: 'K40-K46'
  },
  {
    code: 'K461',
    level: 3,
    description: 'Hernia abdominal no especificada, con gangrena',
    code_2: 'K46',
    code_0: 'K00-K95',
    code_1: 'K40-K46'
  },
  {
    code: 'K469',
    level: 3,
    description:
      'Hernia abdominal no especificada, sin obstrucci\u00f3n ni gangrena',
    code_2: 'K46',
    code_0: 'K00-K95',
    code_1: 'K40-K46'
  },
  {
    code: 'K450',
    level: 3,
    description:
      'Otras hernias de la cavidad abdominal especificadas, con obstrucci\u00f3n, sin gangrena',
    code_2: 'K45',
    code_0: 'K00-K95',
    code_1: 'K40-K46'
  },
  {
    code: 'K451',
    level: 3,
    description:
      'Otras hernias de la cavidad abdominal especificadas, con gangrena',
    code_2: 'K45',
    code_0: 'K00-K95',
    code_1: 'K40-K46'
  },
  {
    code: 'K458',
    level: 3,
    description:
      'Otras hernias de la cavidad abdominal especificadas, sin obstrucci\u00f3n ni gangrena',
    code_2: 'K45',
    code_0: 'K00-K95',
    code_1: 'K40-K46'
  },
  {
    code: 'K440',
    level: 3,
    description: 'Hernia diafragm\u00e1tica con obstrucci\u00f3n, sin gangrena',
    code_2: 'K44',
    code_0: 'K00-K95',
    code_1: 'K40-K46'
  },
  {
    code: 'K441',
    level: 3,
    description: 'Hernia diafragm\u00e1tica con gangrena',
    code_2: 'K44',
    code_0: 'K00-K95',
    code_1: 'K40-K46'
  },
  {
    code: 'K449',
    level: 3,
    description: 'Hernia diafragm\u00e1tica sin obstrucci\u00f3n ni gangrena',
    code_2: 'K44',
    code_0: 'K00-K95',
    code_1: 'K40-K46'
  },
  {
    code: 'K630',
    level: 3,
    description: 'Absceso del intestino',
    code_2: 'K63',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K631',
    level: 3,
    description: 'Perforaci\u00f3n del intestino (no traum\u00e1tica)',
    code_2: 'K63',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K632',
    level: 3,
    description: 'F\u00edstula del intestino',
    code_2: 'K63',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K633',
    level: 3,
    description: '\u00dalcera del intestino',
    code_2: 'K63',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K634',
    level: 3,
    description: 'Enteroptosis',
    code_2: 'K63',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K635',
    level: 3,
    description: 'P\u00f3lipo del colon',
    code_2: 'K63',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K638',
    level: 3,
    description: 'Otras enfermedades especificadas del intestino',
    code_2: 'K63',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K639',
    level: 3,
    description: 'Enfermedad del intestino, no especificada',
    code_2: 'K63',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K620',
    level: 3,
    description: 'P\u00f3lipo anal',
    code_2: 'K62',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K621',
    level: 3,
    description: 'P\u00f3lipo rectal',
    code_2: 'K62',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K622',
    level: 3,
    description: 'Prolapso anal',
    code_2: 'K62',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K623',
    level: 3,
    description: 'Prolapso rectal',
    code_2: 'K62',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K624',
    level: 3,
    description: 'Estenosis del ano y del recto',
    code_2: 'K62',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K625',
    level: 3,
    description: 'Hemorragia del ano y del recto',
    code_2: 'K62',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K626',
    level: 3,
    description: '\u00dalcera del ano y del recto',
    code_2: 'K62',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K627',
    level: 3,
    description: 'Proctitis por radiaci\u00f3n',
    code_2: 'K62',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'J060',
    level: 3,
    description: 'Laringofaringitis aguda',
    code_2: 'J06',
    code_0: 'J00-J99',
    code_1: 'J00-J06'
  },
  {
    code: 'J068',
    level: 3,
    description:
      'Otras infecciones agudas de sitios m\u00faltiples de las v\u00edas respiratorias superiores',
    code_2: 'J06',
    code_0: 'J00-J99',
    code_1: 'J00-J06'
  },
  {
    code: 'J069',
    level: 3,
    description:
      'Infecci\u00f3n aguda de las v\u00edas respiratorias superiores, no especificada',
    code_2: 'J06',
    code_0: 'J00-J99',
    code_1: 'J00-J06'
  },
  {
    code: 'J050',
    level: 3,
    description: 'Laringitis obstructiva, aguda [crup]',
    code_2: 'J05',
    code_0: 'J00-J99',
    code_1: 'J00-J06'
  },
  {
    code: 'J051',
    level: 3,
    description: 'Epiglotitis aguda',
    code_2: 'J05',
    code_0: 'J00-J99',
    code_1: 'J00-J06'
  },
  {
    code: 'J180',
    level: 3,
    description: 'Bronconeumon\u00eda, no especificada',
    code_2: 'J18',
    code_0: 'J00-J99',
    code_1: 'J09-J18 '
  },
  {
    code: 'J181',
    level: 3,
    description: 'Neumon\u00eda lobar, no especificada',
    code_2: 'J18',
    code_0: 'J00-J99',
    code_1: 'J09-J18 '
  },
  {
    code: 'J182',
    level: 3,
    description: 'Neumon\u00eda hipost\u00e1tica, no especificada',
    code_2: 'J18',
    code_0: 'J00-J99',
    code_1: 'J09-J18 '
  },
  {
    code: 'J188',
    level: 3,
    description: 'Otras neumon\u00edas, de microorganismo no especificado',
    code_2: 'J18',
    code_0: 'J00-J99',
    code_1: 'J09-J18 '
  },
  {
    code: 'J189',
    level: 3,
    description: 'Neumon\u00eda, no especificada',
    code_2: 'J18',
    code_0: 'J00-J99',
    code_1: 'J09-J18 '
  },
  {
    code: 'J170',
    level: 3,
    description:
      'Neumon\u00eda en enfermedades bacterianas clasificadas en otra parte',
    code_2: 'J17',
    code_0: 'J00-J99',
    code_1: 'J09-J18 '
  },
  {
    code: 'J171',
    level: 3,
    description:
      'Neumon\u00eda en enfermedades virales clasificadas en otra parte',
    code_2: 'J17',
    code_0: 'J00-J99',
    code_1: 'J09-J18 '
  },
  {
    code: 'J172',
    level: 3,
    description: 'Neumon\u00eda en micosis',
    code_2: 'J17',
    code_0: 'J00-J99',
    code_1: 'J09-J18 '
  },
  {
    code: 'J173',
    level: 3,
    description: 'Neumon\u00eda en enfermedades parasitarias',
    code_2: 'J17',
    code_0: 'J00-J99',
    code_1: 'J09-J18 '
  },
  {
    code: 'J178',
    level: 3,
    description:
      'Neumon\u00eda en otras enfermedades clasificadas en otra parte',
    code_2: 'J17',
    code_0: 'J00-J99',
    code_1: 'J09-J18 '
  },
  {
    code: 'J160',
    level: 3,
    description: 'Neumon\u00eda debida a clamidias',
    code_2: 'J16',
    code_0: 'J00-J99',
    code_1: 'J09-J18 '
  },
  {
    code: 'J168',
    level: 3,
    description:
      'Neumon\u00eda debida a otros microorganismos infecciosos especificados',
    code_2: 'J16',
    code_0: 'J00-J99',
    code_1: 'J09-J18 '
  },
  {
    code: 'J150',
    level: 3,
    description: 'Neumon\u00eda debida a Klebsiella pneumoniae',
    code_2: 'J15',
    code_0: 'J00-J99',
    code_1: 'J09-J18 '
  },
  {
    code: 'J151',
    level: 3,
    description: 'Neumon\u00eda debida a Pseudomonas',
    code_2: 'J15',
    code_0: 'J00-J99',
    code_1: 'J09-J18 '
  },
  {
    code: 'J152',
    level: 3,
    description: 'Neumon\u00eda debida a estafilococos',
    code_2: 'J15',
    code_0: 'J00-J99',
    code_1: 'J09-J18 '
  },
  {
    code: 'J153',
    level: 3,
    description: 'Neumon\u00eda debida a estreptococos del grupo B',
    code_2: 'J15',
    code_0: 'J00-J99',
    code_1: 'J09-J18 '
  },
  {
    code: 'J154',
    level: 3,
    description: 'Neumon\u00eda debida a otros estreptococos',
    code_2: 'J15',
    code_0: 'J00-J99',
    code_1: 'J09-J18 '
  },
  {
    code: 'J155',
    level: 3,
    description: 'Neumon\u00eda debida a Escherichia coli',
    code_2: 'J15',
    code_0: 'J00-J99',
    code_1: 'J09-J18 '
  },
  {
    code: 'J156',
    level: 3,
    description:
      'Neumon\u00eda debida a otras bacterias aer\u00f3bicas gramnegativas',
    code_2: 'J15',
    code_0: 'J00-J99',
    code_1: 'J09-J18 '
  },
  {
    code: 'J157',
    level: 3,
    description: 'Neumon\u00eda debida a Mycoplasma pneumoniae',
    code_2: 'J15',
    code_0: 'J00-J99',
    code_1: 'J09-J18 '
  },
  {
    code: 'J158',
    level: 3,
    description: 'Otras neumon\u00edas bacterianas',
    code_2: 'J15',
    code_0: 'J00-J99',
    code_1: 'J09-J18 '
  },
  {
    code: 'J159',
    level: 3,
    description: 'Neumon\u00eda bacteriana, no especificada',
    code_2: 'J15',
    code_0: 'J00-J99',
    code_1: 'J09-J18 '
  },
  {
    code: 'J120',
    level: 3,
    description: 'Neumon\u00eda debida a adenovirus',
    code_2: 'J12',
    code_0: 'J00-J99',
    code_1: 'J09-J18 '
  },
  {
    code: 'J121',
    level: 3,
    description: 'Neumon\u00eda debida a virus sincitial respiratorio',
    code_2: 'J12',
    code_0: 'J00-J99',
    code_1: 'J09-J18 '
  },
  {
    code: 'J122',
    level: 3,
    description: 'Neumon\u00eda debida a virus parainfluenza',
    code_2: 'J12',
    code_0: 'J00-J99',
    code_1: 'J09-J18 '
  },
  {
    code: 'J128',
    level: 3,
    description: 'Neumon\u00eda debida a otros virus',
    code_2: 'J12',
    code_0: 'J00-J99',
    code_1: 'J09-J18 '
  },
  {
    code: 'J129',
    level: 3,
    description: 'Neumon\u00eda viral, no especificada',
    code_2: 'J12',
    code_0: 'J00-J99',
    code_1: 'J09-J18 '
  },
  {
    code: 'J390',
    level: 3,
    description: 'Absceso retrofar\u00edngeo y parafar\u00edngeo',
    code_2: 'J39',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J391',
    level: 3,
    description: 'Otros abscesos de la faringe',
    code_2: 'J39',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J392',
    level: 3,
    description: 'Otras enfermedades de la faringe',
    code_2: 'J39',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J393',
    level: 3,
    description:
      'Reacci\u00f3n de hipersensibilidad de las v\u00edas respiratorias superiores, sitio no especificado',
    code_2: 'J39',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J398',
    level: 3,
    description:
      'Otras enfermedades especificadas de las v\u00edas respiratorias superiores',
    code_2: 'J39',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J399',
    level: 3,
    description:
      'Enfermedad de las v\u00edas respiratorias superiores, no especificada',
    code_2: 'J39',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J380',
    level: 3,
    description: 'Par\u00e1lisis de las cuerdas vocales y de la laringe',
    code_2: 'J38',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J381',
    level: 3,
    description: 'P\u00f3lipo de las cuerdas vocales y de la laringe',
    code_2: 'J38',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J382',
    level: 3,
    description: 'N\u00f3dulos de las cuerdas vocales',
    code_2: 'J38',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J383',
    level: 3,
    description: 'Otras enfermedades de las cuerdas vocales',
    code_2: 'J38',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J384',
    level: 3,
    description: 'Edema de laringe',
    code_2: 'J38',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J385',
    level: 3,
    description: 'Espasmo lar\u00edngeo',
    code_2: 'J38',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J386',
    level: 3,
    description: 'Estenosis lar\u00edngea',
    code_2: 'J38',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J387',
    level: 3,
    description: 'Otras enfermedades de la laringe',
    code_2: 'J38',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J370',
    level: 3,
    description: 'Laringitis cr\u00f3nica',
    code_2: 'J37',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J371',
    level: 3,
    description: 'Laringotraque\u00edtis cr\u00f3nica',
    code_2: 'J37',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J350',
    level: 3,
    description: 'Amigdalitis cr\u00f3nica',
    code_2: 'J35',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J351',
    level: 3,
    description: 'Hipertrofia de las am\u00edgdalas',
    code_2: 'J35',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J352',
    level: 3,
    description: 'Hipertrofia de las adenoides',
    code_2: 'J35',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J353',
    level: 3,
    description:
      'Hipertrofia de las am\u00edgdalas con hipertrofia de las adenoides',
    code_2: 'J35',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J358',
    level: 3,
    description:
      'Otras enfermedades cr\u00f3nicas de las am\u00edgdalas y de las adenoides',
    code_2: 'J35',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J359',
    level: 3,
    description:
      'Enfermedad cr\u00f3nica de las am\u00edgdalas y de las adenoides, no especificada',
    code_2: 'J35',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J340',
    level: 3,
    description: 'Absceso, fur\u00fanculo y \u00e1ntrax de la nariz',
    code_2: 'J34',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J341',
    level: 3,
    description: 'Quiste y mucocele de la nariz y del seno paranasal',
    code_2: 'J34',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J342',
    level: 3,
    description: 'Desviaci\u00f3n del tabique nasal',
    code_2: 'J34',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J343',
    level: 3,
    description: 'Hipertrofia de los cornetes nasales',
    code_2: 'J34',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J348',
    level: 3,
    description:
      'Otros trastornos especificados de la nariz y de los senos paranasales',
    code_2: 'J34',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J330',
    level: 3,
    description: 'P\u00f3lipo de la cavidad nasal',
    code_2: 'J33',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J331',
    level: 3,
    description: 'Degeneraci\u00f3n polipoide de seno paranasal',
    code_2: 'J33',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J338',
    level: 3,
    description: 'Otros p\u00f3lipos de los senos paranasales',
    code_2: 'J33',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J339',
    level: 3,
    description: 'P\u00f3lipo nasal, no especificado',
    code_2: 'J33',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'I090',
    level: 3,
    description: 'Miocarditis reum\u00e1tica',
    code_2: 'I09',
    code_0: 'I00-I99',
    code_1: 'I05-I09'
  },
  {
    code: 'I091',
    level: 3,
    description:
      'Enfermedades reum\u00e1ticas del endocardio, v\u00e1lvula no especificada',
    code_2: 'I09',
    code_0: 'I00-I99',
    code_1: 'I05-I09'
  },
  {
    code: 'I092',
    level: 3,
    description: 'Pericarditis reum\u00e1tica cr\u00f3nica',
    code_2: 'I09',
    code_0: 'I00-I99',
    code_1: 'I05-I09'
  },
  {
    code: 'I098',
    level: 3,
    description:
      'Otras enfermedades reum\u00e1ticas especificadas del coraz\u00f3n',
    code_2: 'I09',
    code_0: 'I00-I99',
    code_1: 'I05-I09'
  },
  {
    code: 'I099',
    level: 3,
    description: 'Enfermedad reum\u00e1tica del coraz\u00f3n, no especificada',
    code_2: 'I09',
    code_0: 'I00-I99',
    code_1: 'I05-I09'
  },
  {
    code: 'A363',
    level: 3,
    description: 'Difteria cut\u00e1nea',
    code_2: 'A36',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A368',
    level: 3,
    description: 'Otras difterias',
    code_2: 'A36',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A369',
    level: 3,
    description: 'Difteria, no especificada',
    code_2: 'A36',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A546',
    level: 3,
    description: 'Infecci\u00f3n gonoc\u00f3cica del ano y del recto',
    code_2: 'A54',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A548',
    level: 3,
    description: 'Otras infecciones gonoc\u00f3cicas',
    code_2: 'A54',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A549',
    level: 3,
    description: 'Infecci\u00f3n gonoc\u00f3cica, no especificada',
    code_2: 'A54',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'N309',
    level: 3,
    description: 'Cistitis, no especificada',
    code_2: 'N30',
    code_0: 'N00-N99',
    code_1: 'N30-N39'
  },
  {
    code: 'N839',
    level: 3,
    description:
      'Enfermedad no inflamatoria del ovario, de la trompa de Falopio y del ligamento ancho, no especificada',
    code_2: 'N83',
    code_0: 'N00-N99',
    code_1: 'N80-N98'
  },
  {
    code: 'L303',
    level: 3,
    description: 'Dermatitis infecciosa',
    code_2: 'L30',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L304',
    level: 3,
    description: 'Eritema intertrigo',
    code_2: 'L30',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L305',
    level: 3,
    description: 'Pitiriasis alba',
    code_2: 'L30',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L308',
    level: 3,
    description: 'Otras dermatitis especificadas',
    code_2: 'L30',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L309',
    level: 3,
    description: 'Dermatitis, no especificada',
    code_2: 'L30',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'I150',
    level: 3,
    description: 'Hipertensi\u00f3n renovascular',
    code_2: 'I15',
    code_0: 'I00-I99',
    code_1: 'I10-I15'
  },
  {
    code: 'I151',
    level: 3,
    description: 'Hipertensi\u00f3n secundaria a otros trastornos renales',
    code_2: 'I15',
    code_0: 'I00-I99',
    code_1: 'I10-I15'
  },
  {
    code: 'I152',
    level: 3,
    description: 'Hipertensi\u00f3n secundaria a trastornos endocrinos',
    code_2: 'I15',
    code_0: 'I00-I99',
    code_1: 'I10-I15'
  },
  {
    code: 'I158',
    level: 3,
    description: 'Otros tipos de hipertensi\u00f3n secundaria',
    code_2: 'I15',
    code_0: 'I00-I99',
    code_1: 'I10-I15'
  },
  {
    code: 'I159',
    level: 3,
    description: 'Hipertensi\u00f3n secundaria, no especificada',
    code_2: 'I15',
    code_0: 'I00-I99',
    code_1: 'I10-I15'
  },
  {
    code: 'I130',
    level: 3,
    description:
      'Enfermedad cardiorrenal hipertensiva con insuficiencia card\u00edaca (congestiva)',
    code_2: 'I13',
    code_0: 'I00-I99',
    code_1: 'I10-I15'
  },
  {
    code: 'I131',
    level: 3,
    description: 'Enfermedad cardiorrenal hipertensiva con insuficiencia renal',
    code_2: 'I13',
    code_0: 'I00-I99',
    code_1: 'I10-I15'
  },
  {
    code: 'I132',
    level: 3,
    description:
      'Enfermedad cardiorrenal hipertensiva con insuficiencia card\u00edaca (congestiva) e insuficiencia renal',
    code_2: 'I13',
    code_0: 'I00-I99',
    code_1: 'I10-I15'
  },
  {
    code: 'I139',
    level: 3,
    description: 'Enfermedad cardiorrenal hipertensiva, no especificada',
    code_2: 'I13',
    code_0: 'I00-I99',
    code_1: 'I10-I15'
  },
  {
    code: 'I120',
    level: 3,
    description: 'Enfermedad renal hipertensiva con insuficiencia renal',
    code_2: 'I12',
    code_0: 'I00-I99',
    code_1: 'I10-I15'
  },
  {
    code: 'I129',
    level: 3,
    description: 'Enfermedad renal hipertensiva sin insuficiencia renal',
    code_2: 'I12',
    code_0: 'I00-I99',
    code_1: 'I10-I15'
  },
  {
    code: 'I250',
    level: 3,
    description:
      'Enfermedad cardiovascular ateroscler\u00f3tica, as\u00ed descrita',
    code_2: 'I25',
    code_0: 'I00-I99',
    code_1: 'I20-I25'
  },
  {
    code: 'I251',
    level: 3,
    description: 'Enfermedad ateroscler\u00f3tica del coraz\u00f3n',
    code_2: 'I25',
    code_0: 'I00-I99',
    code_1: 'I20-I25'
  },
  {
    code: 'I252',
    level: 3,
    description: 'Infarto antiguo del miocardio',
    code_2: 'I25',
    code_0: 'I00-I99',
    code_1: 'I20-I25'
  },
  {
    code: 'I253',
    level: 3,
    description: 'Aneurisma card\u00edaco',
    code_2: 'I25',
    code_0: 'I00-I99',
    code_1: 'I20-I25'
  },
  {
    code: 'I254',
    level: 3,
    description: 'Aneurisma de arteria coronaria',
    code_2: 'I25',
    code_0: 'I00-I99',
    code_1: 'I20-I25'
  },
  {
    code: 'I255',
    level: 3,
    description: 'Cardiomiopat\u00eda isqu\u00e9mica',
    code_2: 'I25',
    code_0: 'I00-I99',
    code_1: 'I20-I25'
  },
  {
    code: 'I256',
    level: 3,
    description: 'Isquemia silente del miocardio',
    code_2: 'I25',
    code_0: 'I00-I99',
    code_1: 'I20-I25'
  },
  {
    code: 'I240',
    level: 3,
    description: 'Trombosis coronaria que no resulta en infarto del miocardio',
    code_2: 'I24',
    code_0: 'I00-I99',
    code_1: 'I20-I25'
  },
  {
    code: 'I241',
    level: 3,
    description: 'S\u00edndrome de Dressler',
    code_2: 'I24',
    code_0: 'I00-I99',
    code_1: 'I20-I25'
  },
  {
    code: 'I248',
    level: 3,
    description:
      'Otras formas de enfermedad isqu\u00e9mica aguda del coraz\u00f3n',
    code_2: 'I24',
    code_0: 'I00-I99',
    code_1: 'I20-I25'
  },
  {
    code: 'I249',
    level: 3,
    description:
      'Enfermedad isqu\u00e9mica aguda del coraz\u00f3n, no especificada',
    code_2: 'I24',
    code_0: 'I00-I99',
    code_1: 'I20-I25'
  },
  {
    code: 'I230',
    level: 3,
    description:
      'Hemopericardio como complicaci\u00f3n presente posterior al infarto agudo del miocardio',
    code_2: 'I23',
    code_0: 'I00-I99',
    code_1: 'I20-I25'
  },
  {
    code: 'I231',
    level: 3,
    description:
      'Defecto del tabique auricular como complicaci\u00f3n presente posterior al infarto del miocardio',
    code_2: 'I23',
    code_0: 'I00-I99',
    code_1: 'I20-I25'
  },
  {
    code: 'I232',
    level: 3,
    description:
      'Defecto del tabique ventricular como complicaci\u00f3n presente posterior al infarto del miocardio',
    code_2: 'I23',
    code_0: 'I00-I99',
    code_1: 'I20-I25'
  },
  {
    code: 'I233',
    level: 3,
    description:
      'Ruptura de la pared card\u00edaca sin hemopericardio como complicaci\u00f3n presente posterior al infarto agudo del miocardio',
    code_2: 'I23',
    code_0: 'I00-I99',
    code_1: 'I20-I25'
  },
  {
    code: 'I234',
    level: 3,
    description:
      'Ruptura de las cuerdas tendinosas como complicaci\u00f3n presente posterior al infarto agudo del miocardio',
    code_2: 'I23',
    code_0: 'I00-I99',
    code_1: 'I20-I25'
  },
  {
    code: 'I235',
    level: 3,
    description:
      'Ruptura de m\u00fasculo papilar como complicaci\u00f3n presente posterior al infarto agudo del miocardio',
    code_2: 'I23',
    code_0: 'I00-I99',
    code_1: 'I20-I25'
  },
  {
    code: 'I236',
    level: 3,
    description:
      'Trombosis de la aur\u00edcula, ap\u00e9ndice auricular y ventr\u00edculo como complicaci\u00f3n presente posterior al infarto agudo del miocardio',
    code_2: 'I23',
    code_0: 'I00-I99',
    code_1: 'I20-I25'
  },
  {
    code: 'I238',
    level: 3,
    description:
      'Otras complicaciones presentes posteriores al infarto agudo del miocardio',
    code_2: 'I23',
    code_0: 'I00-I99',
    code_1: 'I20-I25'
  },
  {
    code: 'S497',
    level: 3,
    description: 'Traumatismos m\u00faltiples del hombro y del brazo',
    code_2: 'S49',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S498',
    level: 3,
    description: 'Otros traumatismos especificados del hombro y del brazo',
    code_2: 'S49',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S499',
    level: 3,
    description: 'Traumatismos no especificados del hombro y del brazo',
    code_2: 'S49',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S480',
    level: 3,
    description:
      'Amputaci\u00f3n traum\u00e1tica en la articulaci\u00f3n del hombro',
    code_2: 'S48',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S481',
    level: 3,
    description:
      'Amputaci\u00f3n traum\u00e1tica a nivel entre el hombro y el codo',
    code_2: 'S48',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S489',
    level: 3,
    description:
      'Amputaci\u00f3n traum\u00e1tica del hombro y del brazo, nivel no especificado',
    code_2: 'S48',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S460',
    level: 3,
    description:
      'Traumatismo del tend\u00f3n del manguito rotatorio del hombro',
    code_2: 'S46',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S461',
    level: 3,
    description:
      'Traumatismo del tend\u00f3n y m\u00fasculo de la cabeza larga del b\u00edceps',
    code_2: 'S46',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S462',
    level: 3,
    description:
      'Traumatismo del tend\u00f3n y m\u00fasculo de otras partes del b\u00edceps',
    code_2: 'S46',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S463',
    level: 3,
    description: 'Traumatismo del tend\u00f3n y m\u00fasculo del tr\u00edceps',
    code_2: 'S46',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S467',
    level: 3,
    description:
      'Traumatismo de m\u00faltiples tendones y m\u00fasculos a nivel del hombro y del brazo',
    code_2: 'S46',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S468',
    level: 3,
    description:
      'Traumatismo de otros tendones y m\u00fasculos a nivel del hombro y del brazo',
    code_2: 'S46',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S469',
    level: 3,
    description:
      'Traumatismo de tend\u00f3n y m\u00fasculo no especificado, a nivel del hombro y del brazo',
    code_2: 'S46',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S450',
    level: 3,
    description: 'Traumatismo de la arteria axilar',
    code_2: 'S45',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S451',
    level: 3,
    description: 'Traumatismo de la arteria braquial',
    code_2: 'S45',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S452',
    level: 3,
    description: 'Traumatismo de la vena axilar o braquial',
    code_2: 'S45',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S453',
    level: 3,
    description:
      'Traumatismo de vena superficial a nivel del hombro y del brazo',
    code_2: 'S45',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S457',
    level: 3,
    description:
      'Traumatismo de m\u00faltiples vasos sangu\u00edneos a nivel del hombro y del brazo',
    code_2: 'S45',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S458',
    level: 3,
    description:
      'Traumatismo de otros vasos sangu\u00edneos a nivel del hombro y del brazo',
    code_2: 'S45',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S459',
    level: 3,
    description:
      'Traumatismo de vaso sangu\u00edneo no especificado a nivel del hombro y del brazo',
    code_2: 'S45',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S440',
    level: 3,
    description: 'Traumatismo del nervio cubital a nivel del brazo',
    code_2: 'S44',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S441',
    level: 3,
    description: 'Traumatismo del nervio mediano a nivel del brazo',
    code_2: 'S44',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S442',
    level: 3,
    description: 'Traumatismo del nervio radial a nivel del brazo',
    code_2: 'S44',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S443',
    level: 3,
    description: 'Traumatismo del nervio axilar',
    code_2: 'S44',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S444',
    level: 3,
    description: 'Traumatismo del nervio musculocut\u00e1neo',
    code_2: 'S44',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S445',
    level: 3,
    description:
      'Traumatismo del nervio sensitivo cut\u00e1neo a nivel del hombro y del brazo',
    code_2: 'S44',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S447',
    level: 3,
    description:
      'Traumatismo de m\u00faltiples nervios a nivel del hombro y del brazo',
    code_2: 'S44',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S597',
    level: 3,
    description: 'Traumatismos m\u00faltiples del antebrazo',
    code_2: 'S59',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S598',
    level: 3,
    description: 'Otros traumatismos especificados del antebrazo',
    code_2: 'S59',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S599',
    level: 3,
    description: 'Traumatismo no especificado del antebrazo',
    code_2: 'S59',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S580',
    level: 3,
    description: 'Amputaci\u00f3n traum\u00e1tica a nivel del codo',
    code_2: 'S58',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S581',
    level: 3,
    description:
      'Amputaci\u00f3n traum\u00e1tica nivel entre el codo y la mu\u00f1eca',
    code_2: 'S58',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S589',
    level: 3,
    description:
      'Amputaci\u00f3n traum\u00e1tica del antebrazo, nivel no especificado',
    code_2: 'S58',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S570',
    level: 3,
    description: 'Traumatismo por aplastamiento del codo',
    code_2: 'S57',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S578',
    level: 3,
    description: 'Traumatismo por aplastamiento de otras partes del antebrazo',
    code_2: 'S57',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S579',
    level: 3,
    description:
      'Traumatismo por aplastamiento del antebrazo, parte no especificada',
    code_2: 'S57',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S560',
    level: 3,
    description:
      'Traumatismo del tend\u00f3n y m\u00fasculo flexor del pulgar a nivel del antebrazo',
    code_2: 'S56',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S561',
    level: 3,
    description:
      'Traumatismo del tend\u00f3n y m\u00fasculo flexor de otro(s) dedo(s) a nivel del antebrazo',
    code_2: 'S56',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S562',
    level: 3,
    description:
      'Traumatismo de otro tend\u00f3n y m\u00fasculo flexor a nivel del antebrazo',
    code_2: 'S56',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S563',
    level: 3,
    description:
      'Traumatismo de tendones y m\u00fasculos abductores y extensores del pulgar a nivel del antebrazo',
    code_2: 'S56',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S564',
    level: 3,
    description:
      'Traumatismo del tend\u00f3n y m\u00fasculo extensor de otro(s) dedo(s) a nivel del antebrazo',
    code_2: 'S56',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S565',
    level: 3,
    description:
      'Traumatismo de otro tend\u00f3n y m\u00fasculo extensor a nivel del antebrazo',
    code_2: 'S56',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S567',
    level: 3,
    description:
      'Traumatismo de m\u00faltiples tendones y m\u00fasculos a nivel del antebrazo',
    code_2: 'S56',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S568',
    level: 3,
    description:
      'Traumatismo de otros tendones y m\u00fasculos y de los no especificados, a nivel del antebrazo',
    code_2: 'S56',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S550',
    level: 3,
    description: 'Traumatismo de la arteria cubital a nivel del antebrazo',
    code_2: 'S55',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S551',
    level: 3,
    description: 'Traumatismo de la arteria radial a nivel del antebrazo',
    code_2: 'S55',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S552',
    level: 3,
    description: 'Traumatismo de vena a nivel del antebrazo',
    code_2: 'S55',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S557',
    level: 3,
    description:
      'Traumatismo de m\u00faltiples vasos sangu\u00edneos a nivel del antebrazo',
    code_2: 'S55',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S558',
    level: 3,
    description:
      'Traumatismo de otros vasos sangu\u00edneos a nivel del antebrazo',
    code_2: 'S55',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S559',
    level: 3,
    description:
      'Traumatismo de vaso sangu\u00edneo no especificado a nivel del antebrazo',
    code_2: 'S55',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'B020',
    level: 3,
    description: 'Encefalitis debida a herpes zoster (G05.1)',
    code_2: 'B02',
    code_0: 'A00-B99',
    code_1: 'B00-B09'
  },
  {
    code: 'B021',
    level: 3,
    description: 'Meningitis debida a herpes zoster (G02.0)',
    code_2: 'B02',
    code_0: 'A00-B99',
    code_1: 'B00-B09'
  },
  {
    code: 'B022',
    level: 3,
    description: 'Herpes zoster con otros compromisos del sistema nervioso',
    code_2: 'B02',
    code_0: 'A00-B99',
    code_1: 'B00-B09'
  },
  {
    code: 'B023',
    level: 3,
    description: 'Herpes zoster ocular',
    code_2: 'B02',
    code_0: 'A00-B99',
    code_1: 'B00-B09'
  },
  {
    code: 'B027',
    level: 3,
    description: 'Herpes zoster diseminado',
    code_2: 'B02',
    code_0: 'A00-B99',
    code_1: 'B00-B09'
  },
  {
    code: 'B028',
    level: 3,
    description: 'Herpes zoster con otras complicaciones',
    code_2: 'B02',
    code_0: 'A00-B99',
    code_1: 'B00-B09'
  },
  {
    code: 'B010',
    level: 3,
    description: 'Meningitis debida a varicela (G02.0)',
    code_2: 'B01',
    code_0: 'A00-B99',
    code_1: 'B00-B09'
  },
  {
    code: 'B011',
    level: 3,
    description: 'Encefalitis debida a varicela (G05.1)',
    code_2: 'B01',
    code_0: 'A00-B99',
    code_1: 'B00-B09'
  },
  {
    code: 'B012',
    level: 3,
    description: 'Neumon\u00eda debida a varicela (J17.1)',
    code_2: 'B01',
    code_0: 'A00-B99',
    code_1: 'B00-B09'
  },
  {
    code: 'B018',
    level: 3,
    description: 'Varicela con otras complicaciones',
    code_2: 'B01',
    code_0: 'A00-B99',
    code_1: 'B00-B09'
  },
  {
    code: 'B019',
    level: 3,
    description: 'Varicela sin complicaciones',
    code_2: 'B01',
    code_0: 'A00-B99',
    code_1: 'B00-B09'
  },
  {
    code: 'B000',
    level: 3,
    description: 'Eczema herp\u00e9tico',
    code_2: 'B00',
    code_0: 'A00-B99',
    code_1: 'B00-B09'
  },
  {
    code: 'B001',
    level: 3,
    description: 'Dermatitis vesicular herp\u00e9tica',
    code_2: 'B00',
    code_0: 'A00-B99',
    code_1: 'B00-B09'
  },
  {
    code: 'B002',
    level: 3,
    description: 'Gingivoestomatitis y faringoamigdalitis herp\u00e9tica',
    code_2: 'B00',
    code_0: 'A00-B99',
    code_1: 'B00-B09'
  },
  {
    code: 'B003',
    level: 3,
    description: 'Meningitis herp\u00e9tica (G02.0)',
    code_2: 'B00',
    code_0: 'A00-B99',
    code_1: 'B00-B09'
  },
  {
    code: 'B004',
    level: 3,
    description: 'Encefalitis herp\u00e9tica (G05.1)',
    code_2: 'B00',
    code_0: 'A00-B99',
    code_1: 'B00-B09'
  },
  {
    code: 'B005',
    level: 3,
    description: 'Oculopat\u00eda herp\u00e9tica',
    code_2: 'B00',
    code_0: 'A00-B99',
    code_1: 'B00-B09'
  },
  {
    code: 'B007',
    level: 3,
    description: 'Enfermedad herp\u00e9tica diseminada',
    code_2: 'B00',
    code_0: 'A00-B99',
    code_1: 'B00-B09'
  },
  {
    code: 'B008',
    level: 3,
    description: 'Otras formas de infecciones herp\u00e9ticas',
    code_2: 'B00',
    code_0: 'A00-B99',
    code_1: 'B00-B09'
  },
  {
    code: 'B009',
    level: 3,
    description: 'Infecci\u00f3n debida al virus del herpes, no especificada',
    code_2: 'B00',
    code_0: 'A00-B99',
    code_1: 'B00-B09'
  },
  {
    code: 'S680',
    level: 3,
    description:
      'Amputaci\u00f3n traum\u00e1tica del pulgar (completa) (parcial)',
    code_2: 'S68',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S681',
    level: 3,
    description:
      'Amputaci\u00f3n traum\u00e1tica de otro dedo \u00fanico (completa) (parcial)',
    code_2: 'S68',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S682',
    level: 3,
    description:
      'Amputaci\u00f3n traum\u00e1tica de dos o m\u00e1s dedos solamente (completa) (parcial)',
    code_2: 'S68',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S683',
    level: 3,
    description:
      'Amputaci\u00f3n traum\u00e1tica combinada (de parte) de dedo(s) con otras partes de la mu\u00f1eca y de la mano',
    code_2: 'S68',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S684',
    level: 3,
    description:
      'Amputaci\u00f3n traum\u00e1tica de la mano a nivel de la mu\u00f1eca',
    code_2: 'S68',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S688',
    level: 3,
    description:
      'Amputaci\u00f3n traum\u00e1tica de otras partes de la mu\u00f1eca y de la mano',
    code_2: 'S68',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S689',
    level: 3,
    description:
      'Amputaci\u00f3n traum\u00e1tica de la mu\u00f1eca y de la mano, nivel no especificado',
    code_2: 'S68',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S670',
    level: 3,
    description: 'Traumatismo por aplastamiento del pulgar y otro(s) dedo(s)',
    code_2: 'S67',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S678',
    level: 3,
    description:
      'Traumatismo por aplastamiento de otras partes y de las no especificadas de la mu\u00f1eca y de la mano',
    code_2: 'S67',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S660',
    level: 3,
    description:
      'Traumatismo del tend\u00f3n y m\u00fasculo flexor largo del pulgar a nivel de la mu\u00f1eca y de la mano',
    code_2: 'S66',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S661',
    level: 3,
    description:
      'Traumatismo del tend\u00f3n y m\u00fasculo flexor de otro dedo a nivel de la mu\u00f1eca y de la mano',
    code_2: 'S66',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S662',
    level: 3,
    description:
      'Traumatismo del tend\u00f3n y m\u00fasculo extensor del pulgar a nivel de la mu\u00f1eca y de la mano',
    code_2: 'S66',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S663',
    level: 3,
    description:
      'Traumatismo del tend\u00f3n y m\u00fasculo extensor de otro(s) dedo(s) a nivel de la mu\u00f1eca y de la mano',
    code_2: 'S66',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S664',
    level: 3,
    description:
      'Traumatismo del m\u00fasculo y tend\u00f3n intr\u00ednseco del pulgar a nivel de la mu\u00f1eca y de la mano',
    code_2: 'S66',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S665',
    level: 3,
    description:
      'Traumatismo del m\u00fasculo y tend\u00f3n intr\u00ednseco de otro(s) dedo(s) a nivel de la mu\u00f1eca y de la mano',
    code_2: 'S66',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S666',
    level: 3,
    description:
      'Traumatismo de m\u00faltiples tendones y m\u00fasculos flexores a nivel de la mu\u00f1eca y de la mano',
    code_2: 'S66',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S667',
    level: 3,
    description:
      'Traumatismo de m\u00faltiples tendones y m\u00fasculos extensores a nivel de la mu\u00f1eca y de la mano',
    code_2: 'S66',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S668',
    level: 3,
    description:
      'Traumatismo de otros tendones y m\u00fasculos a nivel de la mu\u00f1eca y de la mano',
    code_2: 'S66',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S669',
    level: 3,
    description:
      'Traumatismo de tend\u00f3n y m\u00fasculo no especificado, a nivel de la mu\u00f1eca y de la mano',
    code_2: 'S66',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S650',
    level: 3,
    description:
      'Traumatismo de la arteria cubital a nivel de la mu\u00f1eca y de la mano',
    code_2: 'S65',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S651',
    level: 3,
    description:
      'Traumatismo de la arteria radial a nivel de la mu\u00f1eca y de la mano',
    code_2: 'S65',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S652',
    level: 3,
    description: 'Traumatismo del arco palmar superficial',
    code_2: 'S65',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S653',
    level: 3,
    description: 'Traumatismo del arco palmar profundo',
    code_2: 'S65',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S654',
    level: 3,
    description: 'Traumatismo de vaso(s) sangu\u00edneo(s) del pulgar',
    code_2: 'S65',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S655',
    level: 3,
    description: 'Traumatismo de vaso(s) sangu\u00edneo(s) de otro dedo',
    code_2: 'S65',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S657',
    level: 3,
    description:
      'Traumatismo de m\u00faltiples vasos sangu\u00edneos a nivel de la mu\u00f1eca y de la mano',
    code_2: 'S65',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S658',
    level: 3,
    description:
      'Traumatismo de otros vasos sangu\u00edneos a nivel de la mu\u00f1eca y de la mano',
    code_2: 'S65',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S659',
    level: 3,
    description:
      'Traumatismo de vaso sangu\u00edneo no especificado, a nivel de la mu\u00f1eca y de la mano',
    code_2: 'S65',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S640',
    level: 3,
    description:
      'Traumatismo del nervio cubital a nivel de la mu\u00f1eca y de la mano',
    code_2: 'S64',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S641',
    level: 3,
    description:
      'Traumatismo del nervio mediano a nivel de la mu\u00f1eca y de la mano',
    code_2: 'S64',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S642',
    level: 3,
    description:
      'Traumatismo del nervio radial a nivel de la mu\u00f1eca y de la mano',
    code_2: 'S64',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S643',
    level: 3,
    description: 'Traumatismo del nervio digital del pulgar',
    code_2: 'S64',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S644',
    level: 3,
    description: 'Traumatismo del nervio digital de otro dedo',
    code_2: 'S64',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S647',
    level: 3,
    description:
      'Traumatismo de m\u00faltiples nervios a nivel de la mu\u00f1eca y de la mano',
    code_2: 'S64',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S648',
    level: 3,
    description:
      'Traumatismo de otros nervios a nivel de la mu\u00f1eca y de la mano',
    code_2: 'S64',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S649',
    level: 3,
    description:
      'Traumatismo de nervio no especificado a nivel de la mu\u00f1eca y de la mano',
    code_2: 'S64',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S630',
    level: 3,
    description: 'Luxaci\u00f3n de la mu\u00f1eca',
    code_2: 'S63',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S631',
    level: 3,
    description: 'Luxaci\u00f3n de dedos de la mano',
    code_2: 'S63',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S632',
    level: 3,
    description: 'Luxaciones m\u00faltiples de dedos de la mano',
    code_2: 'S63',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S633',
    level: 3,
    description:
      'Ruptura traum\u00e1tica de ligamentos de la mu\u00f1eca y del carpo',
    code_2: 'S63',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S634',
    level: 3,
    description:
      'Ruptura traum\u00e1tica de ligamentos del dedo de la mano en la(s) articulaci\u00f3n(es) metacarpofal\u00e1ngica e interfal\u00e1ngica',
    code_2: 'S63',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S635',
    level: 3,
    description: 'Esguince y torcedura de la mu\u00f1eca',
    code_2: 'S63',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S636',
    level: 3,
    description: 'Esguinces y torceduras de dedo(s) de la mano',
    code_2: 'S63',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S637',
    level: 3,
    description:
      'Esguinces y torceduras de otras partes y de las no especificadas de la mu\u00f1eca y de la mano',
    code_2: 'S63',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S620',
    level: 3,
    description: 'Fractura del hueso escafoides [navicular] de la mano',
    code_2: 'S62',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S621',
    level: 3,
    description: 'Fractura de otro(s) hueso(s) del carpo',
    code_2: 'S62',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S622',
    level: 3,
    description: 'Fractura del primer metacarpiano',
    code_2: 'S62',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S623',
    level: 3,
    description: 'Fractura de otros huesos metacarpianos',
    code_2: 'S62',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S624',
    level: 3,
    description: 'Fracturas m\u00faltiples de huesos metacarpianos',
    code_2: 'S62',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S625',
    level: 3,
    description: 'Fractura del pulgar',
    code_2: 'S62',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S626',
    level: 3,
    description: 'Fractura de otro dedo de la mano',
    code_2: 'S62',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S627',
    level: 3,
    description: 'Fracturas m\u00faltiples de los dedos de la mano',
    code_2: 'S62',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S628',
    level: 3,
    description:
      'Fractura de otras partes y de las no especificadas de la mu\u00f1eca y de la mano',
    code_2: 'S62',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S797',
    level: 3,
    description: 'Traumatismos m\u00faltiples de la cadera y del muslo',
    code_2: 'S79',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S798',
    level: 3,
    description: 'Otros traumatismos especificados de la cadera y del muslo',
    code_2: 'S79',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S799',
    level: 3,
    description: 'Traumatismo no especificado de la cadera y del muslo',
    code_2: 'S79',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S780',
    level: 3,
    description:
      'Amputaci\u00f3n traum\u00e1tica de la articulaci\u00f3n de la cadera',
    code_2: 'S78',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S781',
    level: 3,
    description:
      'Amputaci\u00f3n traum\u00e1tica en alg\u00fan nivel entre la cadera y la rodilla',
    code_2: 'S78',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S789',
    level: 3,
    description:
      'Amputaci\u00f3n traum\u00e1tica de cadera y muslo, nivel no especificado',
    code_2: 'S78',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S770',
    level: 3,
    description: 'Traumatismo por aplastamiento de la cadera',
    code_2: 'S77',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S771',
    level: 3,
    description: 'Traumatismo por aplastamiento del muslo',
    code_2: 'S77',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S772',
    level: 3,
    description: 'Traumatismo por aplastamiento de la cadera con el muslo',
    code_2: 'S77',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S760',
    level: 3,
    description: 'Traumatismo del tend\u00f3n y m\u00fasculo de la cadera',
    code_2: 'S76',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S761',
    level: 3,
    description: 'Traumatismo del tend\u00f3n y m\u00fasculo cu\u00e1driceps',
    code_2: 'S76',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S762',
    level: 3,
    description:
      'Traumatismo del tend\u00f3n y m\u00fasculo aductor mayor del muslo',
    code_2: 'S76',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S763',
    level: 3,
    description:
      'Traumatismo de tend\u00f3n y m\u00fasculo del grupo muscular posterior a nivel del muslo',
    code_2: 'S76',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S764',
    level: 3,
    description:
      'Traumatismo de otros tendones y m\u00fasculos y los no especificados a nivel del muslo',
    code_2: 'S76',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S767',
    level: 3,
    description:
      'Traumatismo de m\u00faltiples tendones y m\u00fasculos a nivel de la cadera y del muslo',
    code_2: 'S76',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S750',
    level: 3,
    description: 'Traumatismo de la arteria femoral',
    code_2: 'S75',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S751',
    level: 3,
    description:
      'Traumatismo de la vena femoral a nivel de la cadera y del muslo',
    code_2: 'S75',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S752',
    level: 3,
    description:
      'Traumatismo de la gran vena safena a nivel de la cadera y del muslo',
    code_2: 'S75',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S757',
    level: 3,
    description:
      'Traumatismo de m\u00faltiples vasos sangu\u00edneos a nivel de la cadera y del muslo',
    code_2: 'S75',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S758',
    level: 3,
    description:
      'Traumatismo de otros vasos sangu\u00edneos a nivel de la cadera y del muslo',
    code_2: 'S75',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S759',
    level: 3,
    description:
      'Traumatismo de vaso sangu\u00edneo no especificado a nivel de la cadera y del muslo',
    code_2: 'S75',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S740',
    level: 3,
    description:
      'Traumatismo del nervio ci\u00e1tico a nivel de la cadera y del muslo',
    code_2: 'S74',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S741',
    level: 3,
    description:
      'Traumatismo del nervio femorocut\u00e1neo a nivel de la cadera y del muslo',
    code_2: 'S74',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S742',
    level: 3,
    description:
      'Traumatismo del nervio sensorial cut\u00e1neo a nivel de la cadera y del muslo',
    code_2: 'S74',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S747',
    level: 3,
    description:
      'Traumatismo de nervios m\u00faltiples a nivel de la cadera y del muslo',
    code_2: 'S74',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S748',
    level: 3,
    description:
      'Traumatismo de otros nervios a nivel de la cadera y del muslo',
    code_2: 'S74',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S749',
    level: 3,
    description:
      'Traumatismo de nervio no especificado a nivel de la cadera y del muslo',
    code_2: 'S74',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S730',
    level: 3,
    description: 'Luxaci\u00f3n de la cadera',
    code_2: 'S73',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S731',
    level: 3,
    description: 'Esguinces y torceduras de la cadera',
    code_2: 'S73',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S897',
    level: 3,
    description: 'Traumatismos m\u00faltiples de la pierna',
    code_2: 'S89',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S898',
    level: 3,
    description: 'Otros traumatismos de la pierna, especificados',
    code_2: 'S89',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S899',
    level: 3,
    description: 'Traumatismo de la pierna, no especificado',
    code_2: 'S89',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S880',
    level: 3,
    description: 'Amputaci\u00f3n traum\u00e1tica a nivel de la rodilla',
    code_2: 'S88',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S881',
    level: 3,
    description:
      'Amputaci\u00f3n traum\u00e1tica en alg\u00fan nivel entre la rodilla y el tobillo',
    code_2: 'S88',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S889',
    level: 3,
    description:
      'Amputaci\u00f3n traum\u00e1tica de la pierna, nivel no especificado',
    code_2: 'S88',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S870',
    level: 3,
    description: 'Traumatismo por aplastamiento de la rodilla',
    code_2: 'S87',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S878',
    level: 3,
    description:
      'Traumatismo por aplastamiento de otras partes y de las no especificadas de la pierna',
    code_2: 'S87',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S860',
    level: 3,
    description: 'Traumatismo del tend\u00f3n de Aquiles',
    code_2: 'S86',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S861',
    level: 3,
    description:
      'Traumatismo de otro(s) tend\u00f3n(es) y m\u00fasculo(s) del grupo muscular posterior a nivel de la pierna',
    code_2: 'S86',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S862',
    level: 3,
    description:
      'Traumatismo de tend\u00f3n(es) y m\u00fasculo(s) del grupo muscular anterior a nivel de la pierna',
    code_2: 'S86',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S863',
    level: 3,
    description:
      'Traumatismo de tend\u00f3n(es) y m\u00fasculo(s) del grupo muscular peroneo a nivel de la pierna',
    code_2: 'S86',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S867',
    level: 3,
    description:
      'Traumatismo de m\u00faltiples tendones y m\u00fasculos a nivel de la pierna',
    code_2: 'S86',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S868',
    level: 3,
    description:
      'Traumatismo de otros tendones y m\u00fasculos a nivel de la pierna',
    code_2: 'S86',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S869',
    level: 3,
    description:
      'Traumatismo de tend\u00f3n y m\u00fasculo no especificado a nivel de la pierna',
    code_2: 'S86',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S850',
    level: 3,
    description: 'Traumatismo de la arteria popl\u00edtea',
    code_2: 'S85',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S851',
    level: 3,
    description: 'Traumatismo de la arteria tibial (anterior) (posterior)',
    code_2: 'S85',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S852',
    level: 3,
    description: 'Traumatismo de la arteria peronea',
    code_2: 'S85',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S853',
    level: 3,
    description: 'Traumatismo de la gran vena safena a nivel de la pierna',
    code_2: 'S85',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S854',
    level: 3,
    description: 'Traumatismo de la vena safena externa a nivel de la pierna',
    code_2: 'S85',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S855',
    level: 3,
    description: 'Traumatismo de la vena popl\u00edtea',
    code_2: 'S85',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S857',
    level: 3,
    description:
      'Traumatismo de vasos sangu\u00edneos m\u00faltiples a nivel de la pierna',
    code_2: 'S85',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S840',
    level: 3,
    description: 'Traumatismo del nervio tibial a nivel de la pierna',
    code_2: 'S84',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S841',
    level: 3,
    description: 'Traumatismo del nervio peroneo a nivel de la pierna',
    code_2: 'S84',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S842',
    level: 3,
    description:
      'Traumatismo del nervio sensorial cut\u00e1neo a nivel de la pierna',
    code_2: 'S84',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S847',
    level: 3,
    description: 'Traumatismo de nervios m\u00faltiples a nivel de la pierna',
    code_2: 'S84',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S848',
    level: 3,
    description: 'Traumatismo de otros nervios a nivel de la pierna',
    code_2: 'S84',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S849',
    level: 3,
    description: 'Traumatismo de nervio no especificado a nivel de la pierna',
    code_2: 'S84',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'B190',
    level: 3,
    description: 'Hepatitis viral no especificada con coma',
    code_2: 'B19',
    code_0: 'A00-B99',
    code_1: 'B15-B19'
  },
  {
    code: 'B199',
    level: 3,
    description: 'Hepatitis viral no especificada sin coma',
    code_2: 'B19',
    code_0: 'A00-B99',
    code_1: 'B15-B19'
  },
  {
    code: 'K076',
    level: 3,
    description: 'Trastornos de la articulaci\u00f3n temporomaxilar',
    code_2: 'K07',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K078',
    level: 3,
    description: 'Otras anomal\u00edas dentofaciales',
    code_2: 'K07',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K079',
    level: 3,
    description: 'Anomal\u00eda dentofacial, no especificada',
    code_2: 'K07',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'B180',
    level: 3,
    description: 'Hepatitis viral tipo B cr\u00f3nica, con agente delta',
    code_2: 'B18',
    code_0: 'A00-B99',
    code_1: 'B15-B19'
  },
  {
    code: 'B181',
    level: 3,
    description: 'Hepatitis viral tipo B cr\u00f3nica, sin agente delta',
    code_2: 'B18',
    code_0: 'A00-B99',
    code_1: 'B15-B19'
  },
  {
    code: 'B182',
    level: 3,
    description: 'Hepatitis viral tipo C cr\u00f3nica',
    code_2: 'B18',
    code_0: 'A00-B99',
    code_1: 'B15-B19'
  },
  {
    code: 'B188',
    level: 3,
    description: 'Otras hepatitis virales cr\u00f3nicas',
    code_2: 'B18',
    code_0: 'A00-B99',
    code_1: 'B15-B19'
  },
  {
    code: 'B189',
    level: 3,
    description: 'Hepatitis viral cr\u00f3nica, sin otra especificaci\u00f3n',
    code_2: 'B18',
    code_0: 'A00-B99',
    code_1: 'B15-B19'
  },
  {
    code: 'K315',
    level: 3,
    description: 'Obstrucci\u00f3n del duodeno',
    code_2: 'K31',
    code_0: 'K00-K95',
    code_1: 'K20-K31'
  },
  {
    code: 'K316',
    level: 3,
    description: 'F\u00edstula del est\u00f3mago y del duodeno',
    code_2: 'K31',
    code_0: 'K00-K95',
    code_1: 'K20-K31'
  },
  {
    code: 'K317',
    level: 3,
    description: 'P\u00f3lipo del est\u00f3mago y del duodeno',
    code_2: 'K31',
    code_0: 'K00-K95',
    code_1: 'K20-K31'
  },
  {
    code: 'K318',
    level: 3,
    description:
      'Otras enfermedades especificadas del est\u00f3mago y del duodeno',
    code_2: 'K31',
    code_0: 'K00-K95',
    code_1: 'K20-K31'
  },
  {
    code: 'K319',
    level: 3,
    description: 'Enfermedad del est\u00f3mago y del duodeno, no especificada',
    code_2: 'K31',
    code_0: 'K00-K95',
    code_1: 'K20-K31'
  },
  {
    code: 'B170',
    level: 3,
    description:
      'Infecci\u00f3n (superinfecci\u00f3n) aguda por agente delta en el portador de hepatitis B',
    code_2: 'B17',
    code_0: 'A00-B99',
    code_1: 'B15-B19'
  },
  {
    code: 'B171',
    level: 3,
    description: 'Hepatitis aguda tipo C',
    code_2: 'B17',
    code_0: 'A00-B99',
    code_1: 'B15-B19'
  },
  {
    code: 'B172',
    level: 3,
    description: 'Hepatitis aguda tipo E',
    code_2: 'B17',
    code_0: 'A00-B99',
    code_1: 'B15-B19'
  },
  {
    code: 'B178',
    level: 3,
    description: 'Otras hepatitis virales agudas especificadas',
    code_2: 'B17',
    code_0: 'A00-B99',
    code_1: 'B15-B19'
  },
  {
    code: 'B160',
    level: 3,
    description:
      'Hepatitis aguda tipo B, con agente delta (coinfecci\u00f3n), con coma hep\u00e1tico',
    code_2: 'B16',
    code_0: 'A00-B99',
    code_1: 'B15-B19'
  },
  {
    code: 'B161',
    level: 3,
    description:
      'Hepatitis aguda tipo B, con agente delta (coinfecci\u00f3n), sin coma hep\u00e1tico',
    code_2: 'B16',
    code_0: 'A00-B99',
    code_1: 'B15-B19'
  },
  {
    code: 'B162',
    level: 3,
    description:
      'Hepatitis aguda tipo B, sin agente delta, con coma hep\u00e1tico',
    code_2: 'B16',
    code_0: 'A00-B99',
    code_1: 'B15-B19'
  },
  {
    code: 'B169',
    level: 3,
    description:
      'Hepatitis aguda tipo B, sin agente delta y sin coma hep\u00e1tico',
    code_2: 'B16',
    code_0: 'A00-B99',
    code_1: 'B15-B19'
  },
  {
    code: 'B150',
    level: 3,
    description: 'Hepatitis aguda tipo A, con coma hep\u00e1tico',
    code_2: 'B15',
    code_0: 'A00-B99',
    code_1: 'B15-B19'
  },
  {
    code: 'B159',
    level: 3,
    description: 'Hepatitis aguda tipo A, sin coma hep\u00e1tico',
    code_2: 'B15',
    code_0: 'A00-B99',
    code_1: 'B15-B19'
  },
  {
    code: 'S997',
    level: 3,
    description: 'Traumatismos m\u00faltiples del pie y del tobillo',
    code_2: 'S99',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S998',
    level: 3,
    description: 'Otros traumatismos del pie y del tobillo, especificados',
    code_2: 'S99',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S999',
    level: 3,
    description: 'Traumatismo del pie y del tobillo, no especificado',
    code_2: 'S99',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S980',
    level: 3,
    description: 'Amputaci\u00f3n traum\u00e1tica del pie a nivel del tobillo',
    code_2: 'S98',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S981',
    level: 3,
    description: 'Amputaci\u00f3n traum\u00e1tica de un dedo del pie',
    code_2: 'S98',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S982',
    level: 3,
    description:
      'Amputaci\u00f3n traum\u00e1tica de dos o m\u00e1s dedos del pie',
    code_2: 'S98',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S983',
    level: 3,
    description: 'Amputaci\u00f3n traum\u00e1tica de otras partes del pie',
    code_2: 'S98',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S984',
    level: 3,
    description: 'Amputaci\u00f3n del pie, nivel no especificado',
    code_2: 'S98',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S970',
    level: 3,
    description: 'Traumatismo por aplastamiento del tobillo',
    code_2: 'S97',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S971',
    level: 3,
    description: 'Traumatismo por aplastamiento de dedo(s) del pie',
    code_2: 'S97',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S978',
    level: 3,
    description:
      'Traumatismo por aplastamiento de otras partes del pie y del tobillo',
    code_2: 'S97',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S960',
    level: 3,
    description:
      'Traumatismo del tend\u00f3n y m\u00fasculo del flexor largo del dedo a nivel del pie y del tobillo',
    code_2: 'S96',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S961',
    level: 3,
    description:
      'Traumatismo del tend\u00f3n y m\u00fasculo del extensor largo del (de los) dedo(s) a nivel del pie y del tobillo',
    code_2: 'S96',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S962',
    level: 3,
    description:
      'Traumatismo de tendones y m\u00fasculos intr\u00ednsecos a nivel del pie y del tobillo',
    code_2: 'S96',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S967',
    level: 3,
    description:
      'Traumatismo de m\u00faltiples tendones y m\u00fasculos a nivel del pie y del tobillo',
    code_2: 'S96',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S968',
    level: 3,
    description:
      'Traumatismo de otros tendones y m\u00fasculos a nivel del pie y del tobillo',
    code_2: 'S96',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S969',
    level: 3,
    description:
      'Traumatismo de tendones y m\u00fasculos no especificados a nivel del pie y del tobillo',
    code_2: 'S96',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S950',
    level: 3,
    description: 'Traumatismo de la arteria dorsal del pie',
    code_2: 'S95',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S951',
    level: 3,
    description: 'Traumatismo de la arteria plantar del pie',
    code_2: 'S95',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S952',
    level: 3,
    description: 'Traumatismo de la vena dorsal del pie',
    code_2: 'S95',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S957',
    level: 3,
    description:
      'Traumatismo de m\u00faltiples vasos sangu\u00edneos a nivel del pie y del tobillo',
    code_2: 'S95',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S958',
    level: 3,
    description:
      'Traumatismo de otros vasos sangu\u00edneos a nivel del pie y del tobillo',
    code_2: 'S95',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S959',
    level: 3,
    description:
      'Traumatismo de vaso sangu\u00edneo no especificado a nivel del pie y del tobillo',
    code_2: 'S95',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S940',
    level: 3,
    description: 'Traumatismo del nervio plantar externo',
    code_2: 'S94',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S941',
    level: 3,
    description: 'Traumatismo del nervio plantar interno',
    code_2: 'S94',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S942',
    level: 3,
    description:
      'Traumatismo del nervio peroneal profundo a nivel del pie y del tobillo',
    code_2: 'S94',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S943',
    level: 3,
    description:
      'Traumatismo de nervio sensorial cut\u00e1neo a nivel del pie y del tobillo',
    code_2: 'S94',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S947',
    level: 3,
    description:
      'Traumatismo de m\u00faltiples nervios a nivel del pie y del tobillo',
    code_2: 'S94',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S948',
    level: 3,
    description: 'Traumatismo de otros nervios a nivel del pie y del tobillo',
    code_2: 'S94',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S949',
    level: 3,
    description:
      'Traumatismo de nervio no especificado a nivel del pie y del tobillo',
    code_2: 'S94',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'T060',
    level: 3,
    description:
      'Traumatismos del enc\u00e9falo y de nervios craneales con traumatismo de nervios y m\u00e9dula espinal a nivel del cuello',
    code_2: 'T06',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T061',
    level: 3,
    description:
      'Traumatismos de nervios y m\u00e9dula espinal que afectan otras m\u00faltiples regiones del cuerpo',
    code_2: 'T06',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T062',
    level: 3,
    description:
      'Traumatismos de nervios que afectan m\u00faltiples regiones del cuerpo',
    code_2: 'T06',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T063',
    level: 3,
    description:
      'Traumatismos de vasos sangu\u00edneos que afectan m\u00faltiples regiones del cuerpo',
    code_2: 'T06',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T064',
    level: 3,
    description:
      'Traumatismos de tendones y m\u00fasculos que afectan m\u00faltiples regiones del cuerpo',
    code_2: 'T06',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T065',
    level: 3,
    description:
      'Traumatismos de \u00f3rganos intrator\u00e1cicos con \u00f3rganos intraabdominales y p\u00e9lvicos',
    code_2: 'T06',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T068',
    level: 3,
    description:
      'Otros traumatismos especificados que afectan m\u00faltiples regiones del cuerpo',
    code_2: 'T06',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T050',
    level: 3,
    description: 'Amputaci\u00f3n traum\u00e1tica de ambas manos',
    code_2: 'T05',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T051',
    level: 3,
    description:
      'Amputaci\u00f3n traum\u00e1tica de una mano y el otro brazo [cualquier nivel, excepto mano]',
    code_2: 'T05',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T052',
    level: 3,
    description:
      'Amputaci\u00f3n traum\u00e1tica de ambos brazos [cualquier nivel]',
    code_2: 'T05',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T040',
    level: 3,
    description:
      'Traumatismos por aplastamiento que afectan la cabeza con el cuello',
    code_2: 'T04',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T030',
    level: 3,
    description:
      'Luxaciones, torceduras y esguinces que afectan la cabeza con el cuello',
    code_2: 'T03',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T020',
    level: 3,
    description: 'Fracturas que afectan la cabeza con el cuello',
    code_2: 'T02',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'B230',
    level: 3,
    description: 'S\u00edndrome de infecci\u00f3n aguda debida a VIH',
    code_2: 'B23',
    code_0: 'A00-B99',
    code_1: 'B20-B24'
  },
  {
    code: 'B231',
    level: 3,
    description:
      'Enfermedad por VIH, resultante en linfadenopat\u00eda generalizada (persistente)',
    code_2: 'B23',
    code_0: 'A00-B99',
    code_1: 'B20-B24'
  },
  {
    code: 'K628',
    level: 3,
    description: 'Otras enfermedades especificadas del ano y del recto',
    code_2: 'K62',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K629',
    level: 3,
    description: 'Enfermedad del ano y del recto, no especificada',
    code_2: 'K62',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'B220',
    level: 3,
    description: 'Enfermedad por VIH, resultante en encefalopat\u00eda',
    code_2: 'B22',
    code_0: 'A00-B99',
    code_1: 'B20-B24'
  },
  {
    code: 'B221',
    level: 3,
    description:
      'Enfermedad por VIH, resultante en neumonitis linfoide intersticial',
    code_2: 'B22',
    code_0: 'A00-B99',
    code_1: 'B20-B24'
  },
  {
    code: 'B222',
    level: 3,
    description:
      'Enfermedad por VIH, resultante en s\u00edndrome caqu\u00e9ctico',
    code_2: 'B22',
    code_0: 'A00-B99',
    code_1: 'B20-B24'
  },
  {
    code: 'B227',
    level: 3,
    description:
      'Enfermedad por VIH, resultante en enfermedades m\u00faltiples clasificadas en otra parte',
    code_2: 'B22',
    code_0: 'A00-B99',
    code_1: 'B20-B24'
  },
  {
    code: 'B210',
    level: 3,
    description: 'Enfermedad por VIH, resultante en sarcoma de Kaposi',
    code_2: 'B21',
    code_0: 'A00-B99',
    code_1: 'B20-B24'
  },
  {
    code: 'B211',
    level: 3,
    description: 'Enfermedad por VIH, resultante en linfoma de Burkitt',
    code_2: 'B21',
    code_0: 'A00-B99',
    code_1: 'B20-B24'
  },
  {
    code: 'B212',
    level: 3,
    description:
      'Enfermedad por VIH, resultante en otros tipos de linfoma no Hodgkin',
    code_2: 'B21',
    code_0: 'A00-B99',
    code_1: 'B20-B24'
  },
  {
    code: 'B213',
    level: 3,
    description:
      'Enfermedad por VIH, resultante en otros tumores malignos del tejido linfoide, hematopoy\u00e9tico y tejidos relacionados',
    code_2: 'B21',
    code_0: 'A00-B99',
    code_1: 'B20-B24'
  },
  {
    code: 'B217',
    level: 3,
    description:
      'Enfermedad por VIH, resultante en tumores malignos m\u00faltiples',
    code_2: 'B21',
    code_0: 'A00-B99',
    code_1: 'B20-B24'
  },
  {
    code: 'B218',
    level: 3,
    description: 'Enfermedad por VIH, resultante en otros tumores malignos',
    code_2: 'B21',
    code_0: 'A00-B99',
    code_1: 'B20-B24'
  },
  {
    code: 'B219',
    level: 3,
    description:
      'Enfermedad por VIH, resultante en tumores malignos no especificados',
    code_2: 'B21',
    code_0: 'A00-B99',
    code_1: 'B20-B24'
  },
  {
    code: 'B200',
    level: 3,
    description:
      'Enfermedad por VIH, resultante en infecci\u00f3n por micobacterias',
    code_2: 'B20',
    code_0: 'A00-B99',
    code_1: 'B20-B24'
  },
  {
    code: 'B201',
    level: 3,
    description:
      'Enfermedad por VIH, resultante en otras infecciones bacterianas',
    code_2: 'B20',
    code_0: 'A00-B99',
    code_1: 'B20-B24'
  },
  {
    code: 'B202',
    level: 3,
    description:
      'Enfermedad por VIH, resultante en enfermedad por citomegalovirus',
    code_2: 'B20',
    code_0: 'A00-B99',
    code_1: 'B20-B24'
  },
  {
    code: 'B203',
    level: 3,
    description: 'Enfermedad por VIH, resultante en otras infecciones virales',
    code_2: 'B20',
    code_0: 'A00-B99',
    code_1: 'B20-B24'
  },
  {
    code: 'B204',
    level: 3,
    description: 'Enfermedad por VIH, resultante en candidiasis',
    code_2: 'B20',
    code_0: 'A00-B99',
    code_1: 'B20-B24'
  },
  {
    code: 'B205',
    level: 3,
    description: 'Enfermedad por VIH, resultante en otras micosis',
    code_2: 'B20',
    code_0: 'A00-B99',
    code_1: 'B20-B24'
  },
  {
    code: 'B206',
    level: 3,
    description:
      'Enfermedad por VIH, resultante en neumon\u00eda por Pneumocystis jirovecii',
    code_2: 'B20',
    code_0: 'A00-B99',
    code_1: 'B20-B24'
  },
  {
    code: 'B207',
    level: 3,
    description: 'Enfermedad por VIH, resultante en infecciones m\u00faltiples',
    code_2: 'B20',
    code_0: 'A00-B99',
    code_1: 'B20-B24'
  },
  {
    code: 'B208',
    level: 3,
    description:
      'Enfermedad por VIH, resultante en otras enfermedades infecciosas o parasitarias',
    code_2: 'B20',
    code_0: 'A00-B99',
    code_1: 'B20-B24'
  },
  {
    code: 'B209',
    level: 3,
    description:
      'Enfermedad por VIH, resultante en enfermedad infecciosa o parasitaria no especificada',
    code_2: 'B20',
    code_0: 'A00-B99',
    code_1: 'B20-B24'
  },
  {
    code: 'Z130',
    level: 3,
    description:
      'Examen de pesquisa especial para enfermedades de la sangre y \u00f3rganos hematopoy\u00e9ticos y ciertos trastornos del mecanismo de la inmunidad',
    code_2: 'Z13',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z131',
    level: 3,
    description: 'Examen de pesquisa especial para diabetes mellitus',
    code_2: 'Z13',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z132',
    level: 3,
    description:
      'Examen de pesquisa especial para trastornos de la nutrici\u00f3n',
    code_2: 'Z13',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z133',
    level: 3,
    description:
      'Examen de pesquisa especial para trastornos mentales y del comportamiento',
    code_2: 'Z13',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z134',
    level: 3,
    description:
      'Examen de pesquisa especial para ciertos trastornos del desarrollo en el ni\u00f1o',
    code_2: 'Z13',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z135',
    level: 3,
    description:
      'Examen de pesquisa especial para trastornos del ojo y del o\u00eddo',
    code_2: 'Z13',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z136',
    level: 3,
    description: 'Examen de pesquisa especial para trastornos cardiovasculares',
    code_2: 'Z13',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z137',
    level: 3,
    description:
      'Examen de pesquisa especial para malformaciones cong\u00e9nitas, deformidades y anomal\u00edas cromos\u00f3micas',
    code_2: 'Z13',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z120',
    level: 3,
    description: 'Examen de pesquisa especial para tumor de est\u00f3mago',
    code_2: 'Z12',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z121',
    level: 3,
    description: 'Examen de pesquisa especial para tumor del intestino',
    code_2: 'Z12',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z122',
    level: 3,
    description:
      'Examen de pesquisa especial para tumores de \u00f3rganos respiratorios',
    code_2: 'Z12',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z123',
    level: 3,
    description: 'Examen de pesquisa especial para tumor de la mama',
    code_2: 'Z12',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z124',
    level: 3,
    description: 'Examen de pesquisa especial para tumor del cuello uterino',
    code_2: 'Z12',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z125',
    level: 3,
    description: 'Examen de pesquisa especial para tumor de la pr\u00f3stata',
    code_2: 'Z12',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z110',
    level: 3,
    description:
      'Examen de pesquisa especial para enfermedades infecciosas intestinales',
    code_2: 'Z11',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z111',
    level: 3,
    description: 'Examen de pesquisa especial para tuberculosis respiratoria',
    code_2: 'Z11',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z112',
    level: 3,
    description:
      'Examen de pesquisa especial para otras enfermedades bacterianas',
    code_2: 'Z11',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z113',
    level: 3,
    description:
      'Examen de pesquisa especial para infecciones de transmisi\u00f3n predominantemente sexual',
    code_2: 'Z11',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z114',
    level: 3,
    description:
      'Examen de pesquisa especial para el virus de la inmunodeficiencia humana [VIH]',
    code_2: 'Z11',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z115',
    level: 3,
    description: 'Examen de pesquisa especial para otras enfermedades virales',
    code_2: 'Z11',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z116',
    level: 3,
    description:
      'Examen de pesquisa especial para otras enfermedades debidas a protozoarios y helmintos',
    code_2: 'Z11',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z118',
    level: 3,
    description:
      'Examen de pesquisa especial para otras enfermedades infecciosas y parasitarias especificadas',
    code_2: 'Z11',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z119',
    level: 3,
    description:
      'Examen de pesquisa especial para enfermedades infecciosas y parasitarias no especificadas',
    code_2: 'Z11',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z100',
    level: 3,
    description: 'Examen de salud ocupacional',
    code_2: 'Z10',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z101',
    level: 3,
    description:
      'Control general de salud de rutina de residentes de instituciones',
    code_2: 'Z10',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z102',
    level: 3,
    description:
      'Control general de salud de rutina a miembros de las fuerzas armadas',
    code_2: 'Z10',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z103',
    level: 3,
    description:
      'Control general de salud de rutina a integrantes de equipos deportivos',
    code_2: 'Z10',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z108',
    level: 3,
    description:
      'Otros controles generales de salud de rutina de otras subpoblaciones definidas',
    code_2: 'Z10',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z090',
    level: 3,
    description:
      'Examen de seguimiento consecutivo a cirug\u00eda por otras afecciones',
    code_2: 'Z09',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z091',
    level: 3,
    description:
      'Examen de seguimiento consecutivo a radioterapia por otras afecciones',
    code_2: 'Z09',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z092',
    level: 3,
    description:
      'Examen de seguimiento consecutivo a quimioterapia por otras afecciones',
    code_2: 'Z09',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z093',
    level: 3,
    description: 'Examen de seguimiento consecutivo a psicoterapia',
    code_2: 'Z09',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z094',
    level: 3,
    description: 'Examen de seguimiento consecutivo a tratamiento de fractura',
    code_2: 'Z09',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z290',
    level: 3,
    description: 'Aislamiento',
    code_2: 'Z29',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z291',
    level: 3,
    description: 'Inmunoterapia profil\u00e1ctica',
    code_2: 'Z29',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z292',
    level: 3,
    description: 'Otra quimioterapia profil\u00e1ctica',
    code_2: 'Z29',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z298',
    level: 3,
    description: 'Otras medidas profil\u00e1ticas especificadas',
    code_2: 'Z29',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z299',
    level: 3,
    description: 'Medida profil\u00e1ctica no especificada',
    code_2: 'Z29',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z280',
    level: 3,
    description: 'Inmunizaci\u00f3n no realizada por contraindicaci\u00f3n',
    code_2: 'Z28',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z281',
    level: 3,
    description:
      'Inmunizaci\u00f3n no realizada por decisi\u00f3n del paciente, por motivos de creencia o presi\u00f3n de grupo',
    code_2: 'Z28',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z282',
    level: 3,
    description:
      'Inmunizaci\u00f3n no realizada por decisi\u00f3n del paciente, por otras razones y las no especificadas',
    code_2: 'Z28',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z288',
    level: 3,
    description: 'Inmunizaci\u00f3n no realizada por otras razones',
    code_2: 'Z28',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z289',
    level: 3,
    description:
      'Inmunizaci\u00f3n no realizada por raz\u00f3n no especificada',
    code_2: 'Z28',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z270',
    level: 3,
    description:
      'Necesidad de inmunizaci\u00f3n contra el c\u00f3lera y la tifoidea\u2013paratifoidea [c\u00f3lera + TAB]',
    code_2: 'Z27',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z271',
    level: 3,
    description:
      'Necesidad de inmunizaci\u00f3n contra difteria\u2013pertussis\u2013t\u00e9tanos combinados [DPT]',
    code_2: 'Z27',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z272',
    level: 3,
    description:
      'Necesidad de inmunizaci\u00f3n contra difteria\u2013pertussis\u2013t\u00e9tanos y tifoidea\u2013paratifoidea [DPT + TAB]',
    code_2: 'Z27',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z273',
    level: 3,
    description:
      'Necesidad de inmunizaci\u00f3n contra difteria\u2013pertussis\u2013t\u00e9tanos y poliomielitis [DPT + polio]',
    code_2: 'Z27',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z274',
    level: 3,
    description:
      'Necesidad de inmunizaci\u00f3n contra sarampi\u00f3n\u2013parotiditis\u2013rub\u00e9ola [SPR] [MMR]',
    code_2: 'Z27',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z278',
    level: 3,
    description:
      'Necesidad de inmunizaci\u00f3n contra otras combinaciones de enfermedades infecciosas',
    code_2: 'Z27',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z279',
    level: 3,
    description:
      'Necesidad de inmunizaci\u00f3n contra combinaciones no especificadas de enfermedades infecciosas',
    code_2: 'Z27',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z260',
    level: 3,
    description: 'Necesidad de inmunizaci\u00f3n contra la leishmaniasis',
    code_2: 'Z26',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z268',
    level: 3,
    description:
      'Necesidad de inmunizaci\u00f3n contra otras enfermedades infecciosas \u00fanicas especificadas',
    code_2: 'Z26',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z269',
    level: 3,
    description:
      'Necesidad de inmunizaci\u00f3n contra enfermedad infecciosa no especificada',
    code_2: 'Z26',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z250',
    level: 3,
    description:
      'Necesidad de inmunizaci\u00f3n s\u00f3lo contra la parotiditis',
    code_2: 'Z25',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z251',
    level: 3,
    description: 'Necesidad de inmunizaci\u00f3n contra la influenza [gripe]',
    code_2: 'Z25',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z258',
    level: 3,
    description:
      'Necesidad de inmunizaci\u00f3n contra otras enfermedades virales \u00fanicas especificadas',
    code_2: 'Z25',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z240',
    level: 3,
    description: 'Necesidad de inmunizaci\u00f3n contra la poliomielitis',
    code_2: 'Z24',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z241',
    level: 3,
    description:
      'Necesidad de inmunizaci\u00f3n contra la encefalitis viral transmitida por artr\u00f3podos',
    code_2: 'Z24',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z242',
    level: 3,
    description: 'Necesidad de inmunizaci\u00f3n contra la rabia',
    code_2: 'Z24',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z243',
    level: 3,
    description: 'Necesidad de inmunizaci\u00f3n contra la fiebre amarilla',
    code_2: 'Z24',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z244',
    level: 3,
    description:
      'Necesidad de inmunizaci\u00f3n s\u00f3lo contra el sarampi\u00f3n',
    code_2: 'Z24',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z245',
    level: 3,
    description:
      'Necesidad de inmunizaci\u00f3n s\u00f3lo contra la rub\u00e9ola',
    code_2: 'Z24',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z246',
    level: 3,
    description: 'Necesidad de inmunizaci\u00f3n contra la hepatitis viral',
    code_2: 'Z24',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z230',
    level: 3,
    description:
      'Necesidad de inmunizaci\u00f3n s\u00f3lo contra el c\u00f3lera',
    code_2: 'Z23',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z231',
    level: 3,
    description:
      'Necesidad de inmunizaci\u00f3n s\u00f3lo contra la tifoidea\u2013paratifoidea [TAB]',
    code_2: 'Z23',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z232',
    level: 3,
    description: 'Necesidad de inmunizaci\u00f3n contra la tuberculosis [BCG]',
    code_2: 'Z23',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z233',
    level: 3,
    description: 'Necesidad de inmunizaci\u00f3n contra la peste',
    code_2: 'Z23',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z234',
    level: 3,
    description: 'Necesidad de inmunizaci\u00f3n contra la tularemia',
    code_2: 'Z23',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z235',
    level: 3,
    description:
      'Necesidad de inmunizaci\u00f3n s\u00f3lo contra el t\u00e9tanos',
    code_2: 'Z23',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z236',
    level: 3,
    description: 'Necesidad de inmunizaci\u00f3n s\u00f3lo contra la difteria',
    code_2: 'Z23',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z237',
    level: 3,
    description:
      'Necesidad de inmunizaci\u00f3n s\u00f3lo contra la tos ferina',
    code_2: 'Z23',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z238',
    level: 3,
    description:
      'Necesidad de inmunizaci\u00f3n s\u00f3lo contra otra enfermedad bacteriana',
    code_2: 'Z23',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z390',
    level: 3,
    description: 'Atenci\u00f3n y examen inmediatamente despu\u00e9s del parto',
    code_2: 'Z39',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z391',
    level: 3,
    description: 'Atenci\u00f3n y examen de madre en per\u00edodo de lactancia',
    code_2: 'Z39',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z392',
    level: 3,
    description: 'Seguimiento postparto, de rutina',
    code_2: 'Z39',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z380',
    level: 3,
    description: 'Producto \u00fanico, nacido en hospital',
    code_2: 'Z38',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z381',
    level: 3,
    description: 'Producto \u00fanico, nacido fuera de hospital',
    code_2: 'Z38',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z382',
    level: 3,
    description: 'Producto \u00fanico, lugar de nacimiento no especificado',
    code_2: 'Z38',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z383',
    level: 3,
    description: 'Gemelos, nacidos en hospital',
    code_2: 'Z38',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z384',
    level: 3,
    description: 'Gemelos, nacidos fuera de hospital',
    code_2: 'Z38',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z385',
    level: 3,
    description: 'Gemelos, lugar de nacimiento no especificado',
    code_2: 'Z38',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z386',
    level: 3,
    description: 'Otros nacimientos m\u00faltiples, en hospital',
    code_2: 'Z38',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z370',
    level: 3,
    description: 'Nacido vivo, \u00fanico',
    code_2: 'Z37',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z371',
    level: 3,
    description: 'Nacido muerto, \u00fanico',
    code_2: 'Z37',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z372',
    level: 3,
    description: 'Gemelos, ambos nacidos vivos',
    code_2: 'Z37',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z373',
    level: 3,
    description: 'Gemelos, un nacido vivo y un nacido muerto',
    code_2: 'Z37',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z374',
    level: 3,
    description: 'Gemelos, ambos nacidos muertos',
    code_2: 'Z37',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z375',
    level: 3,
    description: 'Otros nacimientos m\u00faltiples, todos nacidos vivos',
    code_2: 'Z37',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z376',
    level: 3,
    description: 'Otros nacimientos m\u00faltiples, algunos nacidos vivos',
    code_2: 'Z37',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z377',
    level: 3,
    description: 'Otros nacimientos m\u00faltiples, todos nacidos muertos',
    code_2: 'Z37',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z360',
    level: 3,
    description: 'Pesquisa prenatal para anomal\u00edas cromos\u00f3micas',
    code_2: 'Z36',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z361',
    level: 3,
    description:
      'Pesquisa prenatal para medir niveles elevados de alfafetoprote\u00ednas',
    code_2: 'Z36',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z362',
    level: 3,
    description: 'Otras pesquisas prenatales basadas en amniocentesis',
    code_2: 'Z36',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z363',
    level: 3,
    description:
      'Pesquisa prenatal de malformaciones usando ultrasonido y otros m\u00e9todos f\u00edsicos',
    code_2: 'Z36',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z364',
    level: 3,
    description:
      'Pesquisa prenatal del retardo del crecimiento fetal usando ultrasonido y otros m\u00e9todos f\u00edsicos',
    code_2: 'Z36',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z365',
    level: 3,
    description: 'Pesquisa prenatal para isoinmunizaci\u00f3n',
    code_2: 'Z36',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z368',
    level: 3,
    description: 'Otras pesquisas prenatales espec\u00edficas',
    code_2: 'Z36',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z350',
    level: 3,
    description: 'Supervisi\u00f3n de embarazo con historia de esterilidad',
    code_2: 'Z35',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z351',
    level: 3,
    description: 'Supervisi\u00f3n de embarazo con historia de aborto',
    code_2: 'Z35',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z352',
    level: 3,
    description:
      'Supervisi\u00f3n de embarazo con otro riesgo en la historia obst\u00e9trica o reproductiva',
    code_2: 'Z35',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z353',
    level: 3,
    description:
      'Supervisi\u00f3n de embarazo con historia de insuficiente atenci\u00f3n prenatal',
    code_2: 'Z35',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z354',
    level: 3,
    description: 'Supervisi\u00f3n de embarazo con gran multiparidad',
    code_2: 'Z35',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z355',
    level: 3,
    description: 'Supervisi\u00f3n de primigesta a\u00f1osa',
    code_2: 'Z35',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z356',
    level: 3,
    description: 'Supervisi\u00f3n de primigesta muy joven',
    code_2: 'Z35',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z357',
    level: 3,
    description:
      'Supervisi\u00f3n de embarazo de alto riesgo debido a problemas sociales',
    code_2: 'Z35',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'B360',
    level: 3,
    description: 'Pitiriasis versicolor',
    code_2: 'B36',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B361',
    level: 3,
    description: 'Ti\u00f1a negra',
    code_2: 'B36',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B362',
    level: 3,
    description: 'Piedra blanca',
    code_2: 'B36',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B363',
    level: 3,
    description: 'Piedra negra',
    code_2: 'B36',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B368',
    level: 3,
    description: 'Otras micosis superficiales especificadas',
    code_2: 'B36',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B369',
    level: 3,
    description: 'Micosis superficial, sin otra especificaci\u00f3n',
    code_2: 'B36',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B350',
    level: 3,
    description: 'Ti\u00f1a de la barba y del cuero cabelludo',
    code_2: 'B35',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B351',
    level: 3,
    description: 'Ti\u00f1a de las u\u00f1as',
    code_2: 'B35',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B352',
    level: 3,
    description: 'Ti\u00f1a de la mano',
    code_2: 'B35',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B353',
    level: 3,
    description: 'Ti\u00f1a del pie [Tinea pedis]',
    code_2: 'B35',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B354',
    level: 3,
    description: 'Ti\u00f1a del cuerpo [Tinea corporis]',
    code_2: 'B35',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B355',
    level: 3,
    description: 'Ti\u00f1a imbricada [Tinea imbricata]',
    code_2: 'B35',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B356',
    level: 3,
    description: 'Ti\u00f1a inguinal [Tinea cruris]',
    code_2: 'B35',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B358',
    level: 3,
    description: 'Otras dermatofitosis',
    code_2: 'B35',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B359',
    level: 3,
    description: 'Dermatofitosis, no especificada',
    code_2: 'B35',
    code_0: 'A00-B99',
    code_1: 'B35-B49'
  },
  {
    code: 'B530',
    level: 3,
    description: 'Paludismo debido a Plasmodium ovale',
    code_2: 'B53',
    code_0: 'A00-B99',
    code_1: 'B50-B64'
  },
  {
    code: 'B531',
    level: 3,
    description: 'Paludismo debido a plasmodios de los simios',
    code_2: 'B53',
    code_0: 'A00-B99',
    code_1: 'B50-B64'
  },
  {
    code: 'B538',
    level: 3,
    description:
      'Otro paludismo confirmado parasitol\u00f3gicamente, no clasificado en otra parte',
    code_2: 'B53',
    code_0: 'A00-B99',
    code_1: 'B50-B64'
  },
  {
    code: 'B520',
    level: 3,
    description: 'Paludismo debido a Plasmodium malariae con nefropat\u00eda',
    code_2: 'B52',
    code_0: 'A00-B99',
    code_1: 'B50-B64'
  },
  {
    code: 'B528',
    level: 3,
    description:
      'Paludismo debido a Plasmodium malariae con otras complicaciones',
    code_2: 'B52',
    code_0: 'A00-B99',
    code_1: 'B50-B64'
  },
  {
    code: 'B529',
    level: 3,
    description: 'Paludismo debido a Plasmodium malariae, sin complicaciones',
    code_2: 'B52',
    code_0: 'A00-B99',
    code_1: 'B50-B64'
  },
  {
    code: 'B510',
    level: 3,
    description:
      'Paludismo debido a Plasmodium vivax con ruptura espl\u00e9nica',
    code_2: 'B51',
    code_0: 'A00-B99',
    code_1: 'B50-B64'
  },
  {
    code: 'B518',
    level: 3,
    description: 'Paludismo debido a Plasmodium vivax con otras',
    code_2: 'B51',
    code_0: 'A00-B99',
    code_1: 'B50-B64'
  },
  {
    code: 'B519',
    level: 3,
    description: 'Paludismo debido a Plasmodium vivax, sin complicaciones',
    code_2: 'B51',
    code_0: 'A00-B99',
    code_1: 'B50-B64'
  },
  {
    code: 'B500',
    level: 3,
    description:
      'Paludismo debido a Plasmodium falciparum con complicaciones cerebrales',
    code_2: 'B50',
    code_0: 'A00-B99',
    code_1: 'B50-B64'
  },
  {
    code: 'B508',
    level: 3,
    description:
      'Otro paludismo grave y complicado debido a Plasmodium falciparum',
    code_2: 'B50',
    code_0: 'A00-B99',
    code_1: 'B50-B64'
  },
  {
    code: 'B509',
    level: 3,
    description:
      'Paludismo debido a Plasmodium falciparum, sin otra especificaci\u00f3n',
    code_2: 'B50',
    code_0: 'A00-B99',
    code_1: 'B50-B64'
  },
  {
    code: 'B680',
    level: 3,
    description: 'Teniasis debida a Taenia solium',
    code_2: 'B68',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B681',
    level: 3,
    description: 'Infecci\u00f3n debida a Taenia saginata',
    code_2: 'B68',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B689',
    level: 3,
    description: 'Teniasis, no especificada',
    code_2: 'B68',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B670',
    level: 3,
    description:
      'Infecci\u00f3n del h\u00edgado debida a Echinococcus granulosus',
    code_2: 'B67',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B671',
    level: 3,
    description:
      'Infecci\u00f3n del pulm\u00f3n debida a Echinococcus granulosus',
    code_2: 'B67',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B672',
    level: 3,
    description: 'Infecci\u00f3n de hueso debida a Echinococcus granulosus',
    code_2: 'B67',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B673',
    level: 3,
    description:
      'Infecci\u00f3n de otro \u00f3rgano y de sitios m\u00faltiples debida a Echinococcus granulosus',
    code_2: 'B67',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B674',
    level: 3,
    description:
      'Infecci\u00f3n debida a Echinococcus granulosus, sin otra especificaci\u00f3n',
    code_2: 'B67',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B675',
    level: 3,
    description:
      'Infecci\u00f3n del h\u00edgado debida a Echinococcus multilocularis',
    code_2: 'B67',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B676',
    level: 3,
    description:
      'Infecci\u00f3n de otro \u00f3rgano y de sitios m\u00faltiples debida a Echinococcus multilocularis',
    code_2: 'B67',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B677',
    level: 3,
    description:
      'Infecci\u00f3n debida a Echinococcus multilocularis, sin otra especificaci\u00f3n',
    code_2: 'B67',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B678',
    level: 3,
    description: 'Equinococosis del h\u00edgado, no especificada',
    code_2: 'B67',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B679',
    level: 3,
    description: 'Equinococosis, otra y la no especificada',
    code_2: 'B67',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B660',
    level: 3,
    description: 'Opistorquiasis',
    code_2: 'B66',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B661',
    level: 3,
    description: 'Clonorquiasis',
    code_2: 'B66',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B662',
    level: 3,
    description: 'Dicrocoeliasis',
    code_2: 'B66',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B663',
    level: 3,
    description: 'Fascioliasis',
    code_2: 'B66',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B664',
    level: 3,
    description: 'Paragonimiasis',
    code_2: 'B66',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B665',
    level: 3,
    description: 'Fasciolopsiasis',
    code_2: 'B66',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B668',
    level: 3,
    description: 'Otras infecciones especificadas debidas a trematodos',
    code_2: 'B66',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B669',
    level: 3,
    description: 'Infecci\u00f3n debida a trematodos, no especificada',
    code_2: 'B66',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B650',
    level: 3,
    description: 'Esquistosomiasis debida a Schistosoma haematobium',
    code_2: 'B65',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B651',
    level: 3,
    description:
      'Esquistosomiasis debida a Schistosoma mansoni [esquistosomiasis intestinal]',
    code_2: 'B65',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B652',
    level: 3,
    description: 'Esquistosomiasis debida a Schistosoma japonicum',
    code_2: 'B65',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B653',
    level: 3,
    description: 'Dermatitis por cercarias',
    code_2: 'B65',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B658',
    level: 3,
    description: 'Otras esquistosomiasis',
    code_2: 'B65',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B659',
    level: 3,
    description: 'Esquistosomiasis, no especificada',
    code_2: 'B65',
    code_0: 'A00-B99',
    code_1: 'B65-B83'
  },
  {
    code: 'B880',
    level: 3,
    description: 'Otras acariasis',
    code_2: 'B88',
    code_0: 'A00-B99',
    code_1: 'B85-B89'
  },
  {
    code: 'B881',
    level: 3,
    description: 'Tungiasis [infecci\u00f3n debida a pulga de arena]',
    code_2: 'B88',
    code_0: 'A00-B99',
    code_1: 'B85-B89'
  },
  {
    code: 'B882',
    level: 3,
    description: 'Otras infestaciones debidas a artr\u00f3podos',
    code_2: 'B88',
    code_0: 'A00-B99',
    code_1: 'B85-B89'
  },
  {
    code: 'B883',
    level: 3,
    description: 'Hirudiniasis externa',
    code_2: 'B88',
    code_0: 'A00-B99',
    code_1: 'B85-B89'
  },
  {
    code: 'B888',
    level: 3,
    description: 'Otras infestaciones especificadas',
    code_2: 'B88',
    code_0: 'A00-B99',
    code_1: 'B85-B89'
  },
  {
    code: 'B889',
    level: 3,
    description: 'Infestaci\u00f3n, no especificada',
    code_2: 'B88',
    code_0: 'A00-B99',
    code_1: 'B85-B89'
  },
  {
    code: 'B870',
    level: 3,
    description: 'Miasis cut\u00e1nea',
    code_2: 'B87',
    code_0: 'A00-B99',
    code_1: 'B85-B89'
  },
  {
    code: 'B871',
    level: 3,
    description: 'Miasis en heridas',
    code_2: 'B87',
    code_0: 'A00-B99',
    code_1: 'B85-B89'
  },
  {
    code: 'B872',
    level: 3,
    description: 'Miasis ocular',
    code_2: 'B87',
    code_0: 'A00-B99',
    code_1: 'B85-B89'
  },
  {
    code: 'B873',
    level: 3,
    description: 'Miasis nasofar\u00edngea',
    code_2: 'B87',
    code_0: 'A00-B99',
    code_1: 'B85-B89'
  },
  {
    code: 'B874',
    level: 3,
    description: 'Miasis aural',
    code_2: 'B87',
    code_0: 'A00-B99',
    code_1: 'B85-B89'
  },
  {
    code: 'B850',
    level: 3,
    description: 'Pediculosis debida a Pediculus humanus capitis',
    code_2: 'B85',
    code_0: 'A00-B99',
    code_1: 'B85-B89'
  },
  {
    code: 'B851',
    level: 3,
    description: 'Pediculosis debida a Pediculus humanus corporis',
    code_2: 'B85',
    code_0: 'A00-B99',
    code_1: 'B85-B89'
  },
  {
    code: 'B852',
    level: 3,
    description: 'Pediculosis, sin otra especificaci\u00f3n',
    code_2: 'B85',
    code_0: 'A00-B99',
    code_1: 'B85-B89'
  },
  {
    code: 'B853',
    level: 3,
    description: 'Phthiriasis',
    code_2: 'B85',
    code_0: 'A00-B99',
    code_1: 'B85-B89'
  },
  {
    code: 'B854',
    level: 3,
    description: 'Pediculosis y phthiriasis mixtas',
    code_2: 'B85',
    code_0: 'A00-B99',
    code_1: 'B85-B89'
  },
  {
    code: 'B940',
    level: 3,
    description: 'Secuelas de tracoma',
    code_2: 'B94',
    code_0: 'A00-B99',
    code_1: 'B90-B94'
  },
  {
    code: 'B941',
    level: 3,
    description: 'Secuelas de encefalitis viral',
    code_2: 'B94',
    code_0: 'A00-B99',
    code_1: 'B90-B94'
  },
  {
    code: 'B942',
    level: 3,
    description: 'Secuelas de hepatitis viral',
    code_2: 'B94',
    code_0: 'A00-B99',
    code_1: 'B90-B94'
  },
  {
    code: 'B900',
    level: 3,
    description: 'Secuelas de tuberculosis del sistema nervioso central',
    code_2: 'B90',
    code_0: 'A00-B99',
    code_1: 'B90-B94'
  },
  {
    code: 'B901',
    level: 3,
    description: 'Secuelas de tuberculosis genitourinaria',
    code_2: 'B90',
    code_0: 'A00-B99',
    code_1: 'B90-B94'
  },
  {
    code: 'B902',
    level: 3,
    description: 'Secuelas de tuberculosis de huesos y articulaciones',
    code_2: 'B90',
    code_0: 'A00-B99',
    code_1: 'B90-B94'
  },
  {
    code: 'B908',
    level: 3,
    description: 'Secuelas de tuberculosis de otros \u00f3rganos especificados',
    code_2: 'B90',
    code_0: 'A00-B99',
    code_1: 'B90-B94'
  },
  {
    code: 'B970',
    level: 3,
    description:
      'Adenovirus como causa de enfermedades clasificadas en otros cap\u00edtulos',
    code_2: 'B97',
    code_0: 'A00-B99',
    code_1: 'B95-B97'
  },
  {
    code: 'B971',
    level: 3,
    description:
      'Enterovirus como causa de enfermedades clasificadas en otros cap\u00edtulos',
    code_2: 'B97',
    code_0: 'A00-B99',
    code_1: 'B95-B97'
  },
  {
    code: 'B972',
    level: 3,
    description:
      'Coronavirus como causa de enfermedades clasificadas en otros cap\u00edtulos',
    code_2: 'B97',
    code_0: 'A00-B99',
    code_1: 'B95-B97'
  },
  {
    code: 'B973',
    level: 3,
    description:
      'Retrovirus como causa de enfermedades clasificadas en otros cap\u00edtulos',
    code_2: 'B97',
    code_0: 'A00-B99',
    code_1: 'B95-B97'
  },
  {
    code: 'B960',
    level: 3,
    description:
      'Mycoplasma pneumoniae [M. pneumoniae] como causa de enfermedades clasificadas en otros cap\u00edtulos',
    code_2: 'B96',
    code_0: 'A00-B99',
    code_1: 'B95-B97'
  },
  {
    code: 'B961',
    level: 3,
    description:
      'Klebsiella pneumoniae [K. pneumoniae] como causa de enfermedades clasificadas en otros cap\u00edtulos',
    code_2: 'B96',
    code_0: 'A00-B99',
    code_1: 'B95-B97'
  },
  {
    code: 'B962',
    level: 3,
    description:
      'Escherichia coli [E. coli] como causa de enfermedades clasificadas en otros cap\u00edtulos',
    code_2: 'B96',
    code_0: 'A00-B99',
    code_1: 'B95-B97'
  },
  {
    code: 'B963',
    level: 3,
    description:
      'Haemophilus influenzae [H. influenzae] como causa de enfermedades clasificadas en otros cap\u00edtulos',
    code_2: 'B96',
    code_0: 'A00-B99',
    code_1: 'B95-B97'
  },
  {
    code: 'B964',
    level: 3,
    description:
      'Proteus (mirabilis) (morganii) como causa de enfermedades clasificadas en otros cap\u00edtulos',
    code_2: 'B96',
    code_0: 'A00-B99',
    code_1: 'B95-B97'
  },
  {
    code: 'B950',
    level: 3,
    description:
      'Estreptococo, grupo A, como causa de enfermedades clasificadas en otros cap\u00edtulos',
    code_2: 'B95',
    code_0: 'A00-B99',
    code_1: 'B95-B97'
  },
  {
    code: 'B951',
    level: 3,
    description:
      'Estreptococo, grupo B, como causa de enfermedades clasificadas en otros cap\u00edtulos',
    code_2: 'B95',
    code_0: 'A00-B99',
    code_1: 'B95-B97'
  },
  {
    code: 'B952',
    level: 3,
    description:
      'Estreptococo, grupo D, como causa de enfermedades clasificadas en otros cap\u00edtulos',
    code_2: 'B95',
    code_0: 'A00-B99',
    code_1: 'B95-B97'
  },
  {
    code: 'B953',
    level: 3,
    description:
      'Streptococcus pneumoniae como causa de enfermedades clasificadas en otros cap\u00edtulos',
    code_2: 'B95',
    code_0: 'A00-B99',
    code_1: 'B95-B97'
  },
  {
    code: 'B954',
    level: 3,
    description:
      'Otros estreptococos como causa de enfermedades clasificadas en otros cap\u00edtulos',
    code_2: 'B95',
    code_0: 'A00-B99',
    code_1: 'B95-B97'
  },
  {
    code: 'M990',
    level: 3,
    description: 'Disfunci\u00f3n segmental o som\u00e1tica',
    code_2: 'M99',
    code_0: 'M00-M99',
    code_1: 'M95-M99'
  },
  {
    code: 'M991',
    level: 3,
    description: 'Complejo de subluxaci\u00f3n (vertebral)',
    code_2: 'M99',
    code_0: 'M00-M99',
    code_1: 'M95-M99'
  },
  {
    code: 'M992',
    level: 3,
    description: 'Subluxaci\u00f3n con estenosis del canal neural',
    code_2: 'M99',
    code_0: 'M00-M99',
    code_1: 'M95-M99'
  },
  {
    code: 'M993',
    level: 3,
    description: 'Estenosis \u00f3sea del canal neural',
    code_2: 'M99',
    code_0: 'M00-M99',
    code_1: 'M95-M99'
  },
  {
    code: 'M994',
    level: 3,
    description: 'Estenosis del canal neural por tejido conjuntivo',
    code_2: 'M99',
    code_0: 'M00-M99',
    code_1: 'M95-M99'
  },
  {
    code: 'M995',
    level: 3,
    description: 'Estenosis del canal neural por disco intervertebral',
    code_2: 'M99',
    code_0: 'M00-M99',
    code_1: 'M95-M99'
  },
  {
    code: 'M960',
    level: 3,
    description: 'Seudoartrosis consecutiva a fusi\u00f3n o artrodesis',
    code_2: 'M96',
    code_0: 'M00-M99',
    code_1: 'M95-M99'
  },
  {
    code: 'M961',
    level: 3,
    description:
      'S\u00edndrome postlaminectom\u00eda, no clasificado en otra parte',
    code_2: 'M96',
    code_0: 'M00-M99',
    code_1: 'M95-M99'
  },
  {
    code: 'M962',
    level: 3,
    description: 'Cifosis postradiaci\u00f3n',
    code_2: 'M96',
    code_0: 'M00-M99',
    code_1: 'M95-M99'
  },
  {
    code: 'M963',
    level: 3,
    description: 'Cifosis postlaminectom\u00eda',
    code_2: 'M96',
    code_0: 'M00-M99',
    code_1: 'M95-M99'
  },
  {
    code: 'M964',
    level: 3,
    description: 'Lordosis postquir\u00fargica',
    code_2: 'M96',
    code_0: 'M00-M99',
    code_1: 'M95-M99'
  },
  {
    code: 'M965',
    level: 3,
    description: 'Escoliosis postradiaci\u00f3n',
    code_2: 'M96',
    code_0: 'M00-M99',
    code_1: 'M95-M99'
  },
  {
    code: 'M950',
    level: 3,
    description: 'Deformidad adquirida de la nariz',
    code_2: 'M95',
    code_0: 'M00-M99',
    code_1: 'M95-M99'
  },
  {
    code: 'M951',
    level: 3,
    description: 'Oreja en coliflor',
    code_2: 'M95',
    code_0: 'M00-M99',
    code_1: 'M95-M99'
  },
  {
    code: 'M952',
    level: 3,
    description: 'Otras deformidades adquiridas de la cabeza',
    code_2: 'M95',
    code_0: 'M00-M99',
    code_1: 'M95-M99'
  },
  {
    code: 'M953',
    level: 3,
    description: 'Deformidad adquirida del cuello',
    code_2: 'M95',
    code_0: 'M00-M99',
    code_1: 'M95-M99'
  },
  {
    code: 'M954',
    level: 3,
    description: 'Deformidad adquirida de costillas y t\u00f3rax',
    code_2: 'M95',
    code_0: 'M00-M99',
    code_1: 'M95-M99'
  },
  {
    code: 'L540',
    level: 3,
    description: 'Eritema marginado en la fiebre reum\u00e1tica aguda (I00)',
    code_2: 'L54',
    code_0: 'L00-L99',
    code_1: 'L50-L54'
  },
  {
    code: 'L548',
    level: 3,
    description: 'Eritema en otras enfermedades clasificadas en otra parte',
    code_2: 'L54',
    code_0: 'L00-L99',
    code_1: 'L50-L54'
  },
  {
    code: 'L530',
    level: 3,
    description: 'Eritema t\u00f3xico',
    code_2: 'L53',
    code_0: 'L00-L99',
    code_1: 'L50-L54'
  },
  {
    code: 'L531',
    level: 3,
    description: 'Eritema anular centr\u00edfugo',
    code_2: 'L53',
    code_0: 'L00-L99',
    code_1: 'L50-L54'
  },
  {
    code: 'L532',
    level: 3,
    description: 'Eritema marginado',
    code_2: 'L53',
    code_0: 'L00-L99',
    code_1: 'L50-L54'
  },
  {
    code: 'L533',
    level: 3,
    description: 'Otros eritemas figurados cr\u00f3nicos',
    code_2: 'L53',
    code_0: 'L00-L99',
    code_1: 'L50-L54'
  },
  {
    code: 'L538',
    level: 3,
    description: 'Otras afecciones eritematosas especificadas',
    code_2: 'L53',
    code_0: 'L00-L99',
    code_1: 'L50-L54'
  },
  {
    code: 'L539',
    level: 3,
    description: 'Afecci\u00f3n eritematosa, no especificada',
    code_2: 'L53',
    code_0: 'L00-L99',
    code_1: 'L50-L54'
  },
  {
    code: 'L510',
    level: 3,
    description: 'Eritema multiforme no flictenular',
    code_2: 'L51',
    code_0: 'L00-L99',
    code_1: 'L50-L54'
  },
  {
    code: 'L511',
    level: 3,
    description: 'Eritema multiforme flictenular',
    code_2: 'L51',
    code_0: 'L00-L99',
    code_1: 'L50-L54'
  },
  {
    code: 'L512',
    level: 3,
    description: 'Necr\u00f3lisis epid\u00e9rmica t\u00f3xica [Lyell]',
    code_2: 'L51',
    code_0: 'L00-L99',
    code_1: 'L50-L54'
  },
  {
    code: 'L518',
    level: 3,
    description: 'Otros eritemas multiformes',
    code_2: 'L51',
    code_0: 'L00-L99',
    code_1: 'L50-L54'
  },
  {
    code: 'L519',
    level: 3,
    description: 'Eritema multiforme, no especificado',
    code_2: 'L51',
    code_0: 'L00-L99',
    code_1: 'L50-L54'
  },
  {
    code: 'L500',
    level: 3,
    description: 'Urticaria al\u00e9rgica',
    code_2: 'L50',
    code_0: 'L00-L99',
    code_1: 'L50-L54'
  },
  {
    code: 'L501',
    level: 3,
    description: 'Urticaria idiop\u00e1tica',
    code_2: 'L50',
    code_0: 'L00-L99',
    code_1: 'L50-L54'
  },
  {
    code: 'L502',
    level: 3,
    description: 'Urticaria debida al calor y al fr\u00edo',
    code_2: 'L50',
    code_0: 'L00-L99',
    code_1: 'L50-L54'
  },
  {
    code: 'L503',
    level: 3,
    description: 'Urticaria dermatogr\u00e1fica',
    code_2: 'L50',
    code_0: 'L00-L99',
    code_1: 'L50-L54'
  },
  {
    code: 'L504',
    level: 3,
    description: 'Urticaria vibratoria',
    code_2: 'L50',
    code_0: 'L00-L99',
    code_1: 'L50-L54'
  },
  {
    code: 'L505',
    level: 3,
    description: 'Urticaria colin\u00e9rgica',
    code_2: 'L50',
    code_0: 'L00-L99',
    code_1: 'L50-L54'
  },
  {
    code: 'L506',
    level: 3,
    description: 'Urticaria por contacto',
    code_2: 'L50',
    code_0: 'L00-L99',
    code_1: 'L50-L54'
  },
  {
    code: 'L508',
    level: 3,
    description: 'Otras urticarias',
    code_2: 'L50',
    code_0: 'L00-L99',
    code_1: 'L50-L54'
  },
  {
    code: 'L509',
    level: 3,
    description: 'Urticaria, no especificada',
    code_2: 'L50',
    code_0: 'L00-L99',
    code_1: 'L50-L54'
  },
  {
    code: 'L590',
    level: 3,
    description: 'Eritema ab igne [dermatitis ab igne]',
    code_2: 'L59',
    code_0: 'L00-L99',
    code_1: 'L55-L59'
  },
  {
    code: 'L598',
    level: 3,
    description:
      'Otros trastornos especificados de la piel y del tejido subcut\u00e1neo relacionados con radiaci\u00f3n',
    code_2: 'L59',
    code_0: 'L00-L99',
    code_1: 'L55-L59'
  },
  {
    code: 'L599',
    level: 3,
    description:
      'Trastornos no especificados de la piel y del tejido subcut\u00e1neo relacionados con radiaci\u00f3n',
    code_2: 'L59',
    code_0: 'L00-L99',
    code_1: 'L55-L59'
  },
  {
    code: 'L580',
    level: 3,
    description: 'Radiodermatitis aguda',
    code_2: 'L58',
    code_0: 'L00-L99',
    code_1: 'L55-L59'
  },
  {
    code: 'L581',
    level: 3,
    description: 'Radiodermatitis cr\u00f3nica',
    code_2: 'L58',
    code_0: 'L00-L99',
    code_1: 'L55-L59'
  },
  {
    code: 'L589',
    level: 3,
    description: 'Radiodermatitis, no especificada',
    code_2: 'L58',
    code_0: 'L00-L99',
    code_1: 'L55-L59'
  },
  {
    code: 'L570',
    level: 3,
    description: 'Queratosis act\u00ednica',
    code_2: 'L57',
    code_0: 'L00-L99',
    code_1: 'L55-L59'
  },
  {
    code: 'L571',
    level: 3,
    description: 'Reticuloide act\u00ednico',
    code_2: 'L57',
    code_0: 'L00-L99',
    code_1: 'L55-L59'
  },
  {
    code: 'L572',
    level: 3,
    description: 'Piel romboidal de la nuca',
    code_2: 'L57',
    code_0: 'L00-L99',
    code_1: 'L55-L59'
  },
  {
    code: 'L573',
    level: 3,
    description: 'Poiquilodermia de Civatte',
    code_2: 'L57',
    code_0: 'L00-L99',
    code_1: 'L55-L59'
  },
  {
    code: 'L574',
    level: 3,
    description: 'Piel laxa senil',
    code_2: 'L57',
    code_0: 'L00-L99',
    code_1: 'L55-L59'
  },
  {
    code: 'L575',
    level: 3,
    description: 'Granuloma act\u00ednico',
    code_2: 'L57',
    code_0: 'L00-L99',
    code_1: 'L55-L59'
  },
  {
    code: 'L578',
    level: 3,
    description:
      'Otros cambios de la piel debidos a exposici\u00f3n cr\u00f3nica a radiaci\u00f3n no ionizante',
    code_2: 'L57',
    code_0: 'L00-L99',
    code_1: 'L55-L59'
  },
  {
    code: 'L579',
    level: 3,
    description:
      'Cambios de la piel debidos a exposici\u00f3n cr\u00f3nica a radiaci\u00f3n no ionizante, sin otra especificaci\u00f3n',
    code_2: 'L57',
    code_0: 'L00-L99',
    code_1: 'L55-L59'
  },
  {
    code: 'L560',
    level: 3,
    description: 'Respuesta fotot\u00f3xica a drogas',
    code_2: 'L56',
    code_0: 'L00-L99',
    code_1: 'L55-L59'
  },
  {
    code: 'L561',
    level: 3,
    description: 'Respuesta fotoal\u00e9rgica a drogas',
    code_2: 'L56',
    code_0: 'L00-L99',
    code_1: 'L55-L59'
  },
  {
    code: 'L562',
    level: 3,
    description: 'Dermatitis por fotocontacto [dermatitis de berloque]',
    code_2: 'L56',
    code_0: 'L00-L99',
    code_1: 'L55-L59'
  },
  {
    code: 'L563',
    level: 3,
    description: 'Urticaria solar',
    code_2: 'L56',
    code_0: 'L00-L99',
    code_1: 'L55-L59'
  },
  {
    code: 'L564',
    level: 3,
    description: 'Erupci\u00f3n polimorfa a la luz',
    code_2: 'L56',
    code_0: 'L00-L99',
    code_1: 'L55-L59'
  },
  {
    code: 'L568',
    level: 3,
    description:
      'Otros cambios agudos especificados de la piel debidos a radiaci\u00f3n ultravioleta',
    code_2: 'L56',
    code_0: 'L00-L99',
    code_1: 'L55-L59'
  },
  {
    code: 'L569',
    level: 3,
    description:
      'Cambio agudo de la piel debido a radiaci\u00f3n ultravioleta, sin otra especificaci\u00f3n',
    code_2: 'L56',
    code_0: 'L00-L99',
    code_1: 'L55-L59'
  },
  {
    code: 'L550',
    level: 3,
    description: 'Quemadura solar de primer grado',
    code_2: 'L55',
    code_0: 'L00-L99',
    code_1: 'L55-L59'
  },
  {
    code: 'L551',
    level: 3,
    description: 'Quemadura solar de segundo grado',
    code_2: 'L55',
    code_0: 'L00-L99',
    code_1: 'L55-L59'
  },
  {
    code: 'L552',
    level: 3,
    description: 'Quemadura solar de tercer grado',
    code_2: 'L55',
    code_0: 'L00-L99',
    code_1: 'L55-L59'
  },
  {
    code: 'L558',
    level: 3,
    description: 'Otras quemaduras solares',
    code_2: 'L55',
    code_0: 'L00-L99',
    code_1: 'L55-L59'
  },
  {
    code: 'L630',
    level: 3,
    description: 'Alopecia (capitis) total',
    code_2: 'L63',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L631',
    level: 3,
    description: 'Alopecia universal',
    code_2: 'L63',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L632',
    level: 3,
    description: 'Ofiasis',
    code_2: 'L63',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L638',
    level: 3,
    description: 'Otras alopecias areatas',
    code_2: 'L63',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L639',
    level: 3,
    description: 'Alopecia areata, no especificada',
    code_2: 'L63',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L620',
    level: 3,
    description: 'U\u00f1a deforme de la paquidermoperiostosis (M89.4)',
    code_2: 'L62',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L628',
    level: 3,
    description:
      'Trastornos de las u\u00f1as en otras enfermedades clasificadas en otra parte',
    code_2: 'L62',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L600',
    level: 3,
    description: 'U\u00f1a encarnada',
    code_2: 'L60',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L601',
    level: 3,
    description: 'Onic\u00f3lisis',
    code_2: 'L60',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L602',
    level: 3,
    description: 'Onicogriposis',
    code_2: 'L60',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L603',
    level: 3,
    description: 'Distrofia ungueal',
    code_2: 'L60',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L604',
    level: 3,
    description: 'L\u00edneas de Beau',
    code_2: 'L60',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L605',
    level: 3,
    description: 'S\u00edndrome de la u\u00f1a amarilla',
    code_2: 'L60',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L608',
    level: 3,
    description: 'Otros trastornos de las u\u00f1as',
    code_2: 'L60',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L609',
    level: 3,
    description: 'Trastorno de la u\u00f1a, no especificado',
    code_2: 'L60',
    code_0: 'L00-L99',
    code_1: 'L60-L75'
  },
  {
    code: 'L810',
    level: 3,
    description: 'Hiperpigmentaci\u00f3n postinflamatoria',
    code_2: 'L81',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L811',
    level: 3,
    description: 'Cloasma',
    code_2: 'L81',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L812',
    level: 3,
    description: 'Ef\u00e9lide',
    code_2: 'L81',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L813',
    level: 3,
    description: 'Manchas caf\u00e9 con leche',
    code_2: 'L81',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L814',
    level: 3,
    description: 'Otros tipos de hiperpigmentaci\u00f3n melanod\u00e9rmica',
    code_2: 'L81',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'K670',
    level: 3,
    description: 'Peritonitis por clamidias (A74.8)',
    code_2: 'K67',
    code_0: 'K00-K95',
    code_1: 'K65-K67'
  },
  {
    code: 'K671',
    level: 3,
    description: 'Peritonitis gonoc\u00f3cica (A54.8)',
    code_2: 'K67',
    code_0: 'K00-K95',
    code_1: 'K65-K67'
  },
  {
    code: 'K672',
    level: 3,
    description: 'Peritonitis sifil\u00edtica (A52.7)',
    code_2: 'K67',
    code_0: 'K00-K95',
    code_1: 'K65-K67'
  },
  {
    code: 'K673',
    level: 3,
    description: 'Peritonitis tuberculosa (A18.3)',
    code_2: 'K67',
    code_0: 'K00-K95',
    code_1: 'K65-K67'
  },
  {
    code: 'K678',
    level: 3,
    description:
      'Otros trastornos del peritoneo en enfermedades infecciosas clasificadas en otra parte',
    code_2: 'K67',
    code_0: 'K00-K95',
    code_1: 'K65-K67'
  },
  {
    code: 'K660',
    level: 3,
    description: 'Adherencias peritoneales',
    code_2: 'K66',
    code_0: 'K00-K95',
    code_1: 'K65-K67'
  },
  {
    code: 'K661',
    level: 3,
    description: 'Hemoperitoneo',
    code_2: 'K66',
    code_0: 'K00-K95',
    code_1: 'K65-K67'
  },
  {
    code: 'K668',
    level: 3,
    description: 'Otros trastornos especificados del peritoneo',
    code_2: 'K66',
    code_0: 'K00-K95',
    code_1: 'K65-K67'
  },
  {
    code: 'K669',
    level: 3,
    description: 'Trastorno del peritoneo, no especificado',
    code_2: 'K66',
    code_0: 'K00-K95',
    code_1: 'K65-K67'
  },
  {
    code: 'K650',
    level: 3,
    description: 'Peritonitis aguda',
    code_2: 'K65',
    code_0: 'K00-K95',
    code_1: 'K65-K67'
  },
  {
    code: 'K658',
    level: 3,
    description: 'Otras peritonitis',
    code_2: 'K65',
    code_0: 'K00-K95',
    code_1: 'K65-K67'
  },
  {
    code: 'K659',
    level: 3,
    description: 'Peritonitis, no especificada',
    code_2: 'K65',
    code_0: 'K00-K95',
    code_1: 'K65-K67'
  },
  {
    code: 'K760',
    level: 3,
    description:
      'Degeneraci\u00f3n grasa del h\u00edgado, no clasificada en otra parte',
    code_2: 'K76',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K761',
    level: 3,
    description: 'Congesti\u00f3n pasiva cr\u00f3nica del h\u00edgado',
    code_2: 'K76',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K762',
    level: 3,
    description: 'Necrosis hemorr\u00e1gica central del h\u00edgado',
    code_2: 'K76',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K763',
    level: 3,
    description: 'Infarto del h\u00edgado',
    code_2: 'K76',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K764',
    level: 3,
    description: 'Peliosis hep\u00e1tica',
    code_2: 'K76',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K765',
    level: 3,
    description: 'Enfermedad veno\u2013oclusiva del h\u00edgado',
    code_2: 'K76',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K766',
    level: 3,
    description: 'Hipertensi\u00f3n portal',
    code_2: 'K76',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K767',
    level: 3,
    description: 'S\u00edndrome hepatorrenal',
    code_2: 'K76',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K768',
    level: 3,
    description: 'Otras enfermedades especificadas del h\u00edgado',
    code_2: 'K76',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K769',
    level: 3,
    description: 'Enfermedad del h\u00edgado, no especificada',
    code_2: 'K76',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K750',
    level: 3,
    description: 'Absceso del h\u00edgado',
    code_2: 'K75',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K751',
    level: 3,
    description: 'Flebitis de la vena porta',
    code_2: 'K75',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K752',
    level: 3,
    description: 'Hepatitis reactiva no espec\u00edfica',
    code_2: 'K75',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K753',
    level: 3,
    description: 'Hepatitis granulomatosa, no clasificada en otra parte',
    code_2: 'K75',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K754',
    level: 3,
    description: 'Hepatitis autoinmune',
    code_2: 'K75',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K758',
    level: 3,
    description:
      'Otras enfermedades inflamatorias del h\u00edgado, especificadas',
    code_2: 'K75',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K759',
    level: 3,
    description: 'Enfermedad inflamatoria del h\u00edgado, no especificada',
    code_2: 'K75',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K740',
    level: 3,
    description: 'Fibrosis hep\u00e1tica',
    code_2: 'K74',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K741',
    level: 3,
    description: 'Esclerosis hep\u00e1tica',
    code_2: 'K74',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K742',
    level: 3,
    description: 'Fibrosis hep\u00e1tica con esclerosis hep\u00e1tica',
    code_2: 'K74',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K743',
    level: 3,
    description: 'Cirrosis biliar primaria',
    code_2: 'K74',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K744',
    level: 3,
    description: 'Cirrosis biliar secundaria',
    code_2: 'K74',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K745',
    level: 3,
    description: 'Cirrosis biliar, no especificada',
    code_2: 'K74',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K746',
    level: 3,
    description: 'Otras cirrosis del h\u00edgado y las no especificadas',
    code_2: 'K74',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K730',
    level: 3,
    description:
      'Hepatitis cr\u00f3nica persistente, no clasificada en otra parte',
    code_2: 'K73',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K731',
    level: 3,
    description: 'Hepatitis cr\u00f3nica lobular, no clasificada en otra parte',
    code_2: 'K73',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K732',
    level: 3,
    description: 'Hepatitis cr\u00f3nica activa, no clasificada en otra parte',
    code_2: 'K73',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K738',
    level: 3,
    description: 'Otras hepatitis cr\u00f3nicas, no clasificadas en otra parte',
    code_2: 'K73',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K739',
    level: 3,
    description: 'Hepatitis cr\u00f3nica, no especificada',
    code_2: 'K73',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K720',
    level: 3,
    description: 'Insuficiencia hep\u00e1tica aguda o subaguda',
    code_2: 'K72',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K721',
    level: 3,
    description: 'Insuficiencia hep\u00e1tica cr\u00f3nica',
    code_2: 'K72',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K729',
    level: 3,
    description: 'Insuficiencia hep\u00e1tica, no especificada',
    code_2: 'K72',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K710',
    level: 3,
    description: 'Enfermedad t\u00f3xica del h\u00edgado, con colestasis',
    code_2: 'K71',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K711',
    level: 3,
    description:
      'Enfermedad t\u00f3xica del h\u00edgado con necrosis hep\u00e1tica',
    code_2: 'K71',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K712',
    level: 3,
    description: 'Enfermedad t\u00f3xica del h\u00edgado con hepatitis aguda',
    code_2: 'K71',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K700',
    level: 3,
    description: 'H\u00edgado alcoh\u00f3lico adiposo',
    code_2: 'K70',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K701',
    level: 3,
    description: 'Hepatitis alcoh\u00f3lica',
    code_2: 'K70',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K702',
    level: 3,
    description: 'Fibrosis y esclerosis del h\u00edgado, alcoh\u00f3lica',
    code_2: 'K70',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K820',
    level: 3,
    description: 'Obstrucci\u00f3n de la ves\u00edcula biliar',
    code_2: 'K82',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'K821',
    level: 3,
    description: 'Hidropes\u00eda de la ves\u00edcula biliar',
    code_2: 'K82',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'K822',
    level: 3,
    description: 'Perforaci\u00f3n de la ves\u00edcula biliar',
    code_2: 'K82',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'K810',
    level: 3,
    description: 'Colecistitis aguda',
    code_2: 'K81',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'K811',
    level: 3,
    description: 'Colecistitis cr\u00f3nica',
    code_2: 'K81',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'K818',
    level: 3,
    description: 'Otras colecistitis',
    code_2: 'K81',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'K819',
    level: 3,
    description: 'Colecistitis, no especificada',
    code_2: 'K81',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'K800',
    level: 3,
    description:
      'C\u00e1lculo de la ves\u00edcula biliar con colecistitis aguda',
    code_2: 'K80',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'K801',
    level: 3,
    description:
      'C\u00e1lculo de la ves\u00edcula biliar con otra colecistitis',
    code_2: 'K80',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'K802',
    level: 3,
    description: 'C\u00e1lculo de la ves\u00edcula biliar sin colecistitis',
    code_2: 'K80',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'K803',
    level: 3,
    description: 'C\u00e1lculo de conducto biliar con colangitis',
    code_2: 'K80',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'K804',
    level: 3,
    description: 'C\u00e1lculo de conducto biliar con colecistitis',
    code_2: 'K80',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'K930',
    level: 3,
    description:
      'Trastornos tuberculosos del intestino, peritoneo y ganglios mesent\u00e9ricos (A18.3)',
    code_2: 'K93',
    code_0: 'K00-K95',
    code_1: 'K90-K93'
  },
  {
    code: 'K931',
    level: 3,
    description: 'Megacolon en la enfermedad de Chagas (B57.3)',
    code_2: 'K93',
    code_0: 'K00-K95',
    code_1: 'K90-K93'
  },
  {
    code: 'K938',
    level: 3,
    description:
      'Trastornos de otros \u00f3rganos digestivos especificados en enfermedades clasificadas en otra parte',
    code_2: 'K93',
    code_0: 'K00-K95',
    code_1: 'K90-K93'
  },
  {
    code: 'K920',
    level: 3,
    description: 'Hematemesis',
    code_2: 'K92',
    code_0: 'K00-K95',
    code_1: 'K90-K93'
  },
  {
    code: 'K921',
    level: 3,
    description: 'Melena',
    code_2: 'K92',
    code_0: 'K00-K95',
    code_1: 'K90-K93'
  },
  {
    code: 'K922',
    level: 3,
    description: 'Hemorragia gastrointestinal, no especificada',
    code_2: 'K92',
    code_0: 'K00-K95',
    code_1: 'K90-K93'
  },
  {
    code: 'K928',
    level: 3,
    description: 'Otras enfermedades especificadas del sistema digestivo',
    code_2: 'K92',
    code_0: 'K00-K95',
    code_1: 'K90-K93'
  },
  {
    code: 'K929',
    level: 3,
    description: 'Enfermedad del sistema digestivo, no especificada',
    code_2: 'K92',
    code_0: 'K00-K95',
    code_1: 'K90-K93'
  },
  {
    code: 'K910',
    level: 3,
    description: 'V\u00f3mito postcirug\u00eda gastrointestinal',
    code_2: 'K91',
    code_0: 'K00-K95',
    code_1: 'K90-K93'
  },
  {
    code: 'K911',
    level: 3,
    description: 'S\u00edndromes consecutivos a la cirug\u00eda g\u00e1strica',
    code_2: 'K91',
    code_0: 'K00-K95',
    code_1: 'K90-K93'
  },
  {
    code: 'K912',
    level: 3,
    description:
      'Malabsorci\u00f3n postquir\u00fargica, no clasificada en otra parte',
    code_2: 'K91',
    code_0: 'K00-K95',
    code_1: 'K90-K93'
  },
  {
    code: 'K913',
    level: 3,
    description: 'Obstrucci\u00f3n intestinal postoperatoria',
    code_2: 'K91',
    code_0: 'K00-K95',
    code_1: 'K90-K93'
  },
  {
    code: 'K900',
    level: 3,
    description: 'Enfermedad cel\u00edaca',
    code_2: 'K90',
    code_0: 'K00-K95',
    code_1: 'K90-K93'
  },
  {
    code: 'K901',
    level: 3,
    description: 'Esprue tropical',
    code_2: 'K90',
    code_0: 'K00-K95',
    code_1: 'K90-K93'
  },
  {
    code: 'K902',
    level: 3,
    description: 'S\u00edndrome del asa ciega, no clasificado en otra parte',
    code_2: 'K90',
    code_0: 'K00-K95',
    code_1: 'K90-K93'
  },
  {
    code: 'K903',
    level: 3,
    description: 'Esteatorrea pancre\u00e1tica',
    code_2: 'K90',
    code_0: 'K00-K95',
    code_1: 'K90-K93'
  },
  {
    code: 'K904',
    level: 3,
    description:
      'Malabsorci\u00f3n debida a intolerancia, no clasificada en otra parte',
    code_2: 'K90',
    code_0: 'K00-K95',
    code_1: 'K90-K93'
  },
  {
    code: 'K908',
    level: 3,
    description: 'Otros tipos de malabsorci\u00f3n intestinal',
    code_2: 'K90',
    code_0: 'K00-K95',
    code_1: 'K90-K93'
  },
  {
    code: 'I258',
    level: 3,
    description:
      'Otras formas de enfermedad isqu\u00e9mica cr\u00f3nica del coraz\u00f3n',
    code_2: 'I25',
    code_0: 'I00-I99',
    code_1: 'I20-I25'
  },
  {
    code: 'I259',
    level: 3,
    description:
      'Enfermedad isqu\u00e9mica cr\u00f3nica del coraz\u00f3n, no especificada',
    code_2: 'I25',
    code_0: 'I00-I99',
    code_1: 'I20-I25'
  },
  {
    code: 'J430',
    level: 3,
    description: 'S\u00edndrome de MacLeod',
    code_2: 'J43',
    code_0: 'J00-J99',
    code_1: 'J40-J47'
  },
  {
    code: 'J431',
    level: 3,
    description: 'Enfisema panlobular',
    code_2: 'J43',
    code_0: 'J00-J99',
    code_1: 'J40-J47'
  },
  {
    code: 'J432',
    level: 3,
    description: 'Enfisema centrolobular',
    code_2: 'J43',
    code_0: 'J00-J99',
    code_1: 'J40-J47'
  },
  {
    code: 'J438',
    level: 3,
    description: 'Otros tipos de enfisema',
    code_2: 'J43',
    code_0: 'J00-J99',
    code_1: 'J40-J47'
  },
  {
    code: 'J439',
    level: 3,
    description: 'Enfisema, no especificado',
    code_2: 'J43',
    code_0: 'J00-J99',
    code_1: 'J40-J47'
  },
  {
    code: 'J410',
    level: 3,
    description: 'Bronquitis cr\u00f3nica simple',
    code_2: 'J41',
    code_0: 'J00-J99',
    code_1: 'J40-J47'
  },
  {
    code: 'J411',
    level: 3,
    description: 'Bronquitis cr\u00f3nica mucopurulenta',
    code_2: 'J41',
    code_0: 'J00-J99',
    code_1: 'J40-J47'
  },
  {
    code: 'J418',
    level: 3,
    description: 'Bronquitis cr\u00f3nica mixta simple y mucopurulenta',
    code_2: 'J41',
    code_0: 'J00-J99',
    code_1: 'J40-J47'
  },
  {
    code: 'S448',
    level: 3,
    description: 'Traumatismo de otros nervios a nivel del hombro y del brazo',
    code_2: 'S44',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S449',
    level: 3,
    description:
      'Traumatismo de nervio no especificado a nivel del hombro y del brazo',
    code_2: 'S44',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'B029',
    level: 3,
    description: 'Herpes zoster sin complicaciones',
    code_2: 'B02',
    code_0: 'A00-B99',
    code_1: 'B00-B09'
  },
  {
    code: 'J840',
    level: 3,
    description: 'Afecciones alveolares y alveoloparietales',
    code_2: 'J84',
    code_0: 'J00-J99',
    code_1: 'J80-J84'
  },
  {
    code: 'J841',
    level: 3,
    description: 'Otras enfermedades pulmonares intersticiales con fibrosis',
    code_2: 'J84',
    code_0: 'J00-J99',
    code_1: 'J80-J84'
  },
  {
    code: 'J848',
    level: 3,
    description: 'Otras enfermedades pulmonares intersticiales especificadas',
    code_2: 'J84',
    code_0: 'J00-J99',
    code_1: 'J80-J84'
  },
  {
    code: 'J849',
    level: 3,
    description: 'Enfermedad pulmonar intersticial, no especificada',
    code_2: 'J84',
    code_0: 'J00-J99',
    code_1: 'J80-J84'
  },
  {
    code: 'J860',
    level: 3,
    description: 'Piot\u00f3rax con f\u00edstula',
    code_2: 'J86',
    code_0: 'J00-J99',
    code_1: 'J85-J86'
  },
  {
    code: 'J869',
    level: 3,
    description: 'Piot\u00f3rax sin f\u00edstula',
    code_2: 'J86',
    code_0: 'J00-J99',
    code_1: 'J85-J86'
  },
  {
    code: 'J850',
    level: 3,
    description: 'Gangrena y necrosis del pulm\u00f3n',
    code_2: 'J85',
    code_0: 'J00-J99',
    code_1: 'J85-J86'
  },
  {
    code: 'J851',
    level: 3,
    description: 'Absceso del pulm\u00f3n con neumon\u00eda',
    code_2: 'J85',
    code_0: 'J00-J99',
    code_1: 'J85-J86'
  },
  {
    code: 'J852',
    level: 3,
    description: 'Absceso del pulm\u00f3n sin neumon\u00eda',
    code_2: 'J85',
    code_0: 'J00-J99',
    code_1: 'J85-J86'
  },
  {
    code: 'J853',
    level: 3,
    description: 'Absceso del mediastino',
    code_2: 'J85',
    code_0: 'J00-J99',
    code_1: 'J85-J86'
  },
  {
    code: 'J940',
    level: 3,
    description: 'Quilot\u00f3rax',
    code_2: 'J94',
    code_0: 'J00-J99',
    code_1: 'J90-J94 '
  },
  {
    code: 'J941',
    level: 3,
    description: 'Fibrot\u00f3rax',
    code_2: 'J94',
    code_0: 'J00-J99',
    code_1: 'J90-J94 '
  },
  {
    code: 'J942',
    level: 3,
    description: 'Hemot\u00f3rax',
    code_2: 'J94',
    code_0: 'J00-J99',
    code_1: 'J90-J94 '
  },
  {
    code: 'J948',
    level: 3,
    description: 'Otras afecciones especificadas de la pleura',
    code_2: 'J94',
    code_0: 'J00-J99',
    code_1: 'J90-J94 '
  },
  {
    code: 'J949',
    level: 3,
    description: 'Afecci\u00f3n pleural, no especificada',
    code_2: 'J94',
    code_0: 'J00-J99',
    code_1: 'J90-J94 '
  },
  {
    code: 'J930',
    level: 3,
    description: 'Neumot\u00f3rax espont\u00e1neo a presi\u00f3n',
    code_2: 'J93',
    code_0: 'J00-J99',
    code_1: 'J90-J94 '
  },
  {
    code: 'J931',
    level: 3,
    description: 'Otros tipos de neumot\u00f3rax espont\u00e1neo',
    code_2: 'J93',
    code_0: 'J00-J99',
    code_1: 'J90-J94 '
  },
  {
    code: 'J938',
    level: 3,
    description: 'Otros neumot\u00f3rax',
    code_2: 'J93',
    code_0: 'J00-J99',
    code_1: 'J90-J94 '
  },
  {
    code: 'J939',
    level: 3,
    description: 'Neumot\u00f3rax, no especificado',
    code_2: 'J93',
    code_0: 'J00-J99',
    code_1: 'J90-J94 '
  },
  {
    code: 'J920',
    level: 3,
    description: 'Paquipleuritis con asbestosis',
    code_2: 'J92',
    code_0: 'J00-J99',
    code_1: 'J90-J94 '
  },
  {
    code: 'J929',
    level: 3,
    description: 'Paquipleuritis sin asbestosis',
    code_2: 'J92',
    code_0: 'J00-J99',
    code_1: 'J90-J94 '
  },
  {
    code: 'J980',
    level: 3,
    description:
      'Enfermedades de la tr\u00e1quea y de los bronquios, no clasificadas en otra parte',
    code_2: 'J98',
    code_0: 'J00-J99',
    code_1: 'J95-J99'
  },
  {
    code: 'J981',
    level: 3,
    description: 'Colapso pulmonar',
    code_2: 'J98',
    code_0: 'J00-J99',
    code_1: 'J95-J99'
  },
  {
    code: 'J982',
    level: 3,
    description: 'Enfisema intersticial',
    code_2: 'J98',
    code_0: 'J00-J99',
    code_1: 'J95-J99'
  },
  {
    code: 'J983',
    level: 3,
    description: 'Enfisema compensatorio',
    code_2: 'J98',
    code_0: 'J00-J99',
    code_1: 'J95-J99'
  },
  {
    code: 'J984',
    level: 3,
    description: 'Otros trastornos del pulm\u00f3n',
    code_2: 'J98',
    code_0: 'J00-J99',
    code_1: 'J95-J99'
  },
  {
    code: 'J985',
    level: 3,
    description: 'Enfermedades del mediastino, no clasificadas en otra parte',
    code_2: 'J98',
    code_0: 'J00-J99',
    code_1: 'J95-J99'
  },
  {
    code: 'J986',
    level: 3,
    description: 'Trastornos del diafragma',
    code_2: 'J98',
    code_0: 'J00-J99',
    code_1: 'J95-J99'
  },
  {
    code: 'J960',
    level: 3,
    description: 'Insuficiencia respiratoria aguda',
    code_2: 'J96',
    code_0: 'J00-J99',
    code_1: 'J95-J99'
  },
  {
    code: 'J961',
    level: 3,
    description: 'Insuficiencia respiratoria cr\u00f3nica',
    code_2: 'J96',
    code_0: 'J00-J99',
    code_1: 'J95-J99'
  },
  {
    code: 'J969',
    level: 3,
    description: 'Insuficiencia respiratoria, no especificada',
    code_2: 'J96',
    code_0: 'J00-J99',
    code_1: 'J95-J99'
  },
  {
    code: 'J950',
    level: 3,
    description: 'Funcionamiento defectuoso de la traqueostom\u00eda',
    code_2: 'J95',
    code_0: 'J00-J99',
    code_1: 'J95-J99'
  },
  {
    code: 'J951',
    level: 3,
    description:
      'Insuficiencia pulmonar aguda consecutiva a cirug\u00eda tor\u00e1cica',
    code_2: 'J95',
    code_0: 'J00-J99',
    code_1: 'J95-J99'
  },
  {
    code: 'J952',
    level: 3,
    description:
      'Insuficiencia pulmonar aguda consecutiva a cirug\u00eda extrator\u00e1cica',
    code_2: 'J95',
    code_0: 'J00-J99',
    code_1: 'J95-J99'
  },
  {
    code: 'J953',
    level: 3,
    description:
      'Insuficiencia pulmonar cr\u00f3nica consecutiva a cirug\u00eda',
    code_2: 'J95',
    code_0: 'J00-J99',
    code_1: 'J95-J99'
  },
  {
    code: 'J954',
    level: 3,
    description: 'S\u00edndrome de Mendelson',
    code_2: 'J95',
    code_0: 'J00-J99',
    code_1: 'J95-J99'
  },
  {
    code: 'J955',
    level: 3,
    description: 'Estenosis subgl\u00f3tica consecutiva a procedimientos',
    code_2: 'J95',
    code_0: 'J00-J99',
    code_1: 'J95-J99'
  },
  {
    code: 'I280',
    level: 3,
    description: 'F\u00edstula arteriovenosa de los vasos pulmonares',
    code_2: 'I28',
    code_0: 'I00-I99',
    code_1: 'I26-I28'
  },
  {
    code: 'I281',
    level: 3,
    description: 'Aneurisma de la arteria pulmonar',
    code_2: 'I28',
    code_0: 'I00-I99',
    code_1: 'I26-I28'
  },
  {
    code: 'I288',
    level: 3,
    description: 'Otras enfermedades especificadas de los vasos pulmonares ',
    code_2: 'I28',
    code_0: 'I00-I99',
    code_1: 'I26-I28'
  },
  {
    code: 'I289',
    level: 3,
    description: 'Enfermedad de los vasos pulmonares, no especificada',
    code_2: 'I28',
    code_0: 'I00-I99',
    code_1: 'I26-I28'
  },
  {
    code: 'I271',
    level: 3,
    description: 'Enfermedad cifoscoli\u00f3tica del coraz\u00f3n',
    code_2: 'I27',
    code_0: 'I00-I99',
    code_1: 'I26-I28'
  },
  {
    code: 'I272',
    level: 3,
    description: 'Otras hipertensiones pulmonares secundarias',
    code_2: 'I27',
    code_0: 'I00-I99',
    code_1: 'I26-I28'
  },
  {
    code: 'I278',
    level: 3,
    description: 'Otras enfermedades cardiopulmonares especificadas',
    code_2: 'I27',
    code_0: 'I00-I99',
    code_1: 'I26-I28'
  },
  {
    code: 'I279',
    level: 3,
    description: 'Enfermedad pulmonar del coraz\u00f3n, no especificada',
    code_2: 'I27',
    code_0: 'I00-I99',
    code_1: 'I26-I28'
  },
  {
    code: 'I260',
    level: 3,
    description:
      'Embolia pulmonar con menci\u00f3n de coraz\u00f3n pulmonar agudo',
    code_2: 'I26',
    code_0: 'I00-I99',
    code_1: 'I26-I28'
  },
  {
    code: 'I269',
    level: 3,
    description:
      'Embolia pulmonar sin menci\u00f3n de coraz\u00f3n pulmonar agudo',
    code_2: 'I26',
    code_0: 'I00-I99',
    code_1: 'I26-I28'
  },
  {
    code: 'I310',
    level: 3,
    description: 'Pericarditis cr\u00f3nica adhesiva',
    code_2: 'I31',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I311',
    level: 3,
    description: 'Pericarditis constrictiva cr\u00f3nica',
    code_2: 'I31',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I312',
    level: 3,
    description: 'Hemopericardio, no clasificado en otra parte',
    code_2: 'I31',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I313',
    level: 3,
    description: 'Derrame peric\u00e1rdico (no inflamatorio)',
    code_2: 'I31',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I318',
    level: 3,
    description: 'Otras enfermedades especificadas del pericardio',
    code_2: 'I31',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I319',
    level: 3,
    description: 'Enfermedad del pericardio, no especificada',
    code_2: 'I31',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I300',
    level: 3,
    description: 'Pericarditis idiop\u00e1tica aguda inespec\u00edfica',
    code_2: 'I30',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I301',
    level: 3,
    description: 'Pericarditis infecciosa',
    code_2: 'I30',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I308',
    level: 3,
    description: 'Otras formas de pericarditis aguda',
    code_2: 'I30',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'I309',
    level: 3,
    description: 'Pericarditis aguda, no especificada',
    code_2: 'I30',
    code_0: 'I00-I99',
    code_1: 'I30-I52'
  },
  {
    code: 'S858',
    level: 3,
    description:
      'Traumatismo de otros vasos sangu\u00edneos a nivel de la pierna',
    code_2: 'S85',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S859',
    level: 3,
    description:
      'Traumatismo de vaso sangu\u00edneo no especificado a nivel de la pierna',
    code_2: 'S85',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'T053',
    level: 3,
    description: 'Amputaci\u00f3n traum\u00e1tica de ambos pies',
    code_2: 'T05',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T054',
    level: 3,
    description:
      'Amputaci\u00f3n traum\u00e1tica de un pie y la otra pierna [cualquier nivel, excepto pie]',
    code_2: 'T05',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T055',
    level: 3,
    description:
      'Amputaci\u00f3n traum\u00e1tica de ambas piernas [cualquier nivel]',
    code_2: 'T05',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T056',
    level: 3,
    description:
      'Amputaci\u00f3n traum\u00e1tica de miembros superior(es) e inferior(es), cualquier combinaci\u00f3n [cualquier nivel]',
    code_2: 'T05',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T058',
    level: 3,
    description:
      'Amputaci\u00f3n traum\u00e1tica que afecta otras combinaciones de regiones del cuerpo',
    code_2: 'T05',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T059',
    level: 3,
    description:
      'Amputaciones traum\u00e1ticas m\u00faltiples, no especificadas',
    code_2: 'T05',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T041',
    level: 3,
    description:
      'Traumatismos por aplastamiento que afectan el t\u00f3rax con el abdomen, la regi\u00f3n lumbosacra y la pelvis',
    code_2: 'T04',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T042',
    level: 3,
    description:
      'Traumatismos por aplastamiento que afectan m\u00faltiples regiones del (de los) miembro(s) superior(es)',
    code_2: 'T04',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T043',
    level: 3,
    description:
      'Traumatismos por aplastamiento que afectan m\u00faltiples regiones del (de los) miembro(s) inferior(es)',
    code_2: 'T04',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T044',
    level: 3,
    description:
      'Traumatismos por aplastamiento que afectan m\u00faltiples regiones del (de los) miembro(s) superior(es) con miembros inferior(es)',
    code_2: 'T04',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T047',
    level: 3,
    description:
      'Traumatismos por aplastamiento del t\u00f3rax, del abdomen, de la regi\u00f3n lumbosacra y de la pelvis con miembro(s)',
    code_2: 'T04',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T048',
    level: 3,
    description:
      'Traumatismos por aplastamiento que afectan otras combinaciones de regiones del cuerpo',
    code_2: 'T04',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T049',
    level: 3,
    description:
      'Traumatismos por aplastamiento m\u00faltiple, no especificados',
    code_2: 'T04',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T031',
    level: 3,
    description:
      'Luxaciones, torceduras y esguinces que afectan el t\u00f3rax con la regi\u00f3n lumbosacra y la pelvis',
    code_2: 'T03',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T032',
    level: 3,
    description:
      'Luxaciones, torceduras y esguinces que afectan m\u00faltiples regiones del (de los) miembros(s) superior(es)',
    code_2: 'T03',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T033',
    level: 3,
    description:
      'Luxaciones, torceduras y esguinces que afectan m\u00faltiples regiones del (de los) miembros(s) inferior(es)',
    code_2: 'T03',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T034',
    level: 3,
    description:
      'Luxaciones, torceduras y esguinces que afectan m\u00faltiples regiones del (de los) miembro(s) superior(es) con miembro(s) inferior(es)',
    code_2: 'T03',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T038',
    level: 3,
    description:
      'Luxaciones, torceduras y esguinces que afectan otras combinaciones de regiones del cuerpo',
    code_2: 'T03',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T039',
    level: 3,
    description:
      'Luxaciones, torceduras y esguinces m\u00faltiples, no especificados',
    code_2: 'T03',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T021',
    level: 3,
    description:
      'Fracturas que afectan el t\u00f3rax con la regi\u00f3n lumbosacra y la pelvis',
    code_2: 'T02',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T022',
    level: 3,
    description:
      'Fracturas que afectan m\u00faltiples regiones de un miembro superior',
    code_2: 'T02',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T023',
    level: 3,
    description:
      'Fracturas que afectan m\u00faltiples regiones de un miembro inferior',
    code_2: 'T02',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T024',
    level: 3,
    description:
      'Fracturas que afectan m\u00faltiples regiones de ambos miembros superiores',
    code_2: 'T02',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T025',
    level: 3,
    description:
      'Fracturas que afectan m\u00faltiples regiones de ambos miembros inferiores',
    code_2: 'T02',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T026',
    level: 3,
    description:
      'Fracturas que afectan m\u00faltiples regiones de miembro(s) superior(es) con miembro(s) inferior(es)',
    code_2: 'T02',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T027',
    level: 3,
    description:
      'Fracturas que afectan el t\u00f3rax con la regi\u00f3n lumbosacra y la pelvis con miembro(s)',
    code_2: 'T02',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T028',
    level: 3,
    description:
      'Fracturas que afectan otras combinaciones de las regiones del cuerpo',
    code_2: 'T02',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T029',
    level: 3,
    description: 'Fracturas m\u00faltiples, no especificadas',
    code_2: 'T02',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'B232',
    level: 3,
    description:
      'Enfermedad por VIH, resultante en anormalidades inmuno\u00adl\u00f3gicas y hematol\u00f3gicas, no clasificadas en otra parte',
    code_2: 'B23',
    code_0: 'A00-B99',
    code_1: 'B20-B24'
  },
  {
    code: 'B238',
    level: 3,
    description:
      'Enfermedad por VIH, resultante en otras afecciones especificadas',
    code_2: 'B23',
    code_0: 'A00-B99',
    code_1: 'B20-B24'
  },
  {
    code: 'I630',
    level: 3,
    description:
      'Infarto cerebral debido a trombosis de arterias precerebrales',
    code_2: 'I63',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I631',
    level: 3,
    description: 'Infarto cerebral debido a embolia de arterias precerebrales',
    code_2: 'I63',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I632',
    level: 3,
    description:
      'Infarto cerebral debido a oclusi\u00f3n o estenosis no especificada de arterias precerebrales',
    code_2: 'I63',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I633',
    level: 3,
    description: 'Infarto cerebral debido a trombosis de arterias cerebrales',
    code_2: 'I63',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I634',
    level: 3,
    description: 'Infarto cerebral debido a embolia de arterias cerebrales',
    code_2: 'I63',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I635',
    level: 3,
    description:
      'Infarto cerebral debido a oclusi\u00f3n o estenosis no especificada de arterias cerebrales',
    code_2: 'I63',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I636',
    level: 3,
    description:
      'Infarto cerebral debido a trombosis de venas cerebrales, no pi\u00f3geno',
    code_2: 'I63',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I638',
    level: 3,
    description: 'Otros infartos cerebrales',
    code_2: 'I63',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I639',
    level: 3,
    description: 'Infarto cerebral, no especificado',
    code_2: 'I63',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I620',
    level: 3,
    description: 'Hemorragia subdural (aguda) (no traum\u00e1tica)',
    code_2: 'I62',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I621',
    level: 3,
    description: 'Hemorragia extradural no traum\u00e1tica',
    code_2: 'I62',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I629',
    level: 3,
    description:
      'Hemorragia intracraneal (no traum\u00e1tica), no especificada',
    code_2: 'I62',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I610',
    level: 3,
    description: 'Hemorragia intracerebral en hemisferio, subcortical',
    code_2: 'I61',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I611',
    level: 3,
    description: 'Hemorragia intracerebral en hemisferio, cortical',
    code_2: 'I61',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I612',
    level: 3,
    description: 'Hemorragia intracerebral en hemisferio, no especificada',
    code_2: 'I61',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I613',
    level: 3,
    description: 'Hemorragia intraencef\u00e1lica en tallo cerebral',
    code_2: 'I61',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I614',
    level: 3,
    description: 'Hemorragia intraencef\u00e1lica en cerebelo',
    code_2: 'I61',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I615',
    level: 3,
    description: 'Hemorragia intraencef\u00e1lica, intraventricular',
    code_2: 'I61',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I616',
    level: 3,
    description:
      'Hemorragia intraencef\u00e1lica de localizaciones m\u00faltiples',
    code_2: 'I61',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I618',
    level: 3,
    description: 'Otras hemorragias intraencef\u00e1licas',
    code_2: 'I61',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I619',
    level: 3,
    description: 'Hemorragia intraencef\u00e1lica, no especificada',
    code_2: 'I61',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I600',
    level: 3,
    description:
      'Hemorragia subaracnoidea de sif\u00f3n y bifurcaci\u00f3n carot\u00eddea',
    code_2: 'I60',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I601',
    level: 3,
    description: 'Hemorragia subaracnoidea de arteria cerebral media',
    code_2: 'I60',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I602',
    level: 3,
    description: 'Hemorragia subaracnoidea de arteria comunicante anterior',
    code_2: 'I60',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I603',
    level: 3,
    description: 'Hemorragia subaracnoidea de arteria comunicante posterior',
    code_2: 'I60',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I604',
    level: 3,
    description: 'Hemorragia subaracnoidea de arteria basilar',
    code_2: 'I60',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I605',
    level: 3,
    description: 'Hemorragia subaracnoidea de arteria vertebral',
    code_2: 'I60',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I606',
    level: 3,
    description: 'Hemorragia subaracnoidea de otras arterias intracraneales',
    code_2: 'I60',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I607',
    level: 3,
    description:
      'Hemorragia subaracnoidea de arteria intracraneal no especificada',
    code_2: 'I60',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I608',
    level: 3,
    description: 'Otras hemorragias subaracnoideas',
    code_2: 'I60',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I609',
    level: 3,
    description: 'Hemorragia subaracnoidea, no especificada',
    code_2: 'I60',
    code_0: 'I00-I99',
    code_1: 'I60-I69'
  },
  {
    code: 'I740',
    level: 3,
    description: 'Embolia y trombosis de la aorta abdominal',
    code_2: 'I74',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I741',
    level: 3,
    description:
      'Embolia y trombosis de otras porciones y las no especificadas de la aorta',
    code_2: 'I74',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I742',
    level: 3,
    description: 'Embolia y trombosis de arterias de los miembros superiores',
    code_2: 'I74',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I743',
    level: 3,
    description: 'Embolia y trombosis de arterias de los miembros inferiores',
    code_2: 'I74',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I744',
    level: 3,
    description:
      'Embolia y trombosis de arterias de los miembros, no especificadas',
    code_2: 'I74',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I745',
    level: 3,
    description: 'Embolia y trombosis de arteria iliaca',
    code_2: 'I74',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I748',
    level: 3,
    description: 'Embolia y trombosis de otras arterias',
    code_2: 'I74',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I749',
    level: 3,
    description: 'Embolia y trombosis de arteria no especificada',
    code_2: 'I74',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I730',
    level: 3,
    description: 'S\u00edndrome de Raynaud',
    code_2: 'I73',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I731',
    level: 3,
    description: 'Tromboange\u00edtis obliterante [Buerger]',
    code_2: 'I73',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I738',
    level: 3,
    description: 'Otras enfermedades vasculares perif\u00e9ricas especificadas',
    code_2: 'I73',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I739',
    level: 3,
    description: 'Enfermedad vascular perif\u00e9rica, no especificada',
    code_2: 'I73',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I720',
    level: 3,
    description: 'Aneurisma de la arteria car\u00f3tida',
    code_2: 'I72',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I721',
    level: 3,
    description: 'Aneurisma de arteria del miembro superior',
    code_2: 'I72',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I722',
    level: 3,
    description: 'Aneurisma de arteria renal',
    code_2: 'I72',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I723',
    level: 3,
    description: 'Aneurisma de arteria iliaca',
    code_2: 'I72',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I724',
    level: 3,
    description: 'Aneurisma de arteria del miembro inferior',
    code_2: 'I72',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I710',
    level: 3,
    description: 'Disecci\u00f3n de aorta (cualquier parte)',
    code_2: 'I71',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I711',
    level: 3,
    description: 'Ruptura de aneurisma de la aorta tor\u00e1cica',
    code_2: 'I71',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I712',
    level: 3,
    description:
      'Aneurisma de la aorta tor\u00e1cica, sin menci\u00f3n de ruptura',
    code_2: 'I71',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I713',
    level: 3,
    description: 'Ruptura de aneurisma de la aorta abdominal',
    code_2: 'I71',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I714',
    level: 3,
    description: 'Aneurisma de la aorta abdominal, sin menci\u00f3n de ruptura',
    code_2: 'I71',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I715',
    level: 3,
    description: 'Ruptura de aneurisma de la aorta toracoabdominal',
    code_2: 'I71',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I716',
    level: 3,
    description:
      'Aneurisma de la aorta toracoabdominal, sin menci\u00f3n de ruptura',
    code_2: 'I71',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I718',
    level: 3,
    description: 'Ruptura de aneurisma a\u00f3rtico, sitio no especificado',
    code_2: 'I71',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I719',
    level: 3,
    description:
      'Aneurisma de la aorta, sitio no especificado, sin menci\u00f3n de ruptura',
    code_2: 'I71',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I700',
    level: 3,
    description: 'Aterosclerosis de la aorta',
    code_2: 'I70',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I701',
    level: 3,
    description: 'Aterosclerosis de la arteria renal',
    code_2: 'I70',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I702',
    level: 3,
    description: 'Aterosclerosis de las arterias de los miembros',
    code_2: 'I70',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I708',
    level: 3,
    description: 'Aterosclerosis de otras arterias',
    code_2: 'I70',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I709',
    level: 3,
    description: 'Aterosclerosis generalizada y la no especificada',
    code_2: 'I70',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I840',
    level: 3,
    description: 'Hemorroides internas trombosadas',
    code_2: 'I84',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I841',
    level: 3,
    description: 'Hemorroides internas con otras complicaciones',
    code_2: 'I84',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I842',
    level: 3,
    description: 'Hemorroides internas sin complicaci\u00f3n',
    code_2: 'I84',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I843',
    level: 3,
    description: 'Hemorroides externas trombosadas',
    code_2: 'I84',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I844',
    level: 3,
    description: 'Hemorroides externas con otras complicaciones',
    code_2: 'I84',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I845',
    level: 3,
    description: 'Hemorroides externas sin complicaci\u00f3n',
    code_2: 'I84',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I846',
    level: 3,
    description: 'Prominencias cut\u00e1neas, residuo de hemorroides',
    code_2: 'I84',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I847',
    level: 3,
    description: 'Hemorroides trombosadas no especificadas',
    code_2: 'I84',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I848',
    level: 3,
    description: 'Hemorroides no especificadas, con otras complicaciones',
    code_2: 'I84',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I849',
    level: 3,
    description: 'Hemorroides no especificadas, sin complicaci\u00f3n',
    code_2: 'I84',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I830',
    level: 3,
    description: 'Venas varicosas de los miembros inferiores con \u00falcera',
    code_2: 'I83',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I831',
    level: 3,
    description:
      'Venas varicosas de los miembros inferiores con inflamaci\u00f3n',
    code_2: 'I83',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I832',
    level: 3,
    description:
      'Venas varicosas de los miembros inferiores con \u00falcera e inflamaci\u00f3n',
    code_2: 'I83',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I839',
    level: 3,
    description:
      'Venas varicosas de los miembros inferiores sin \u00falcera ni inflamaci\u00f3n',
    code_2: 'I83',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I820',
    level: 3,
    description: 'S\u00edndrome de Budd\u2013Chiari',
    code_2: 'I82',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I821',
    level: 3,
    description: 'Tromboflebitis migratoria',
    code_2: 'I82',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I822',
    level: 3,
    description: 'Embolia y trombosis de vena cava',
    code_2: 'I82',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I823',
    level: 3,
    description: 'Embolia y trombosis de vena renal',
    code_2: 'I82',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I828',
    level: 3,
    description: 'Embolia y trombosis de otras venas especificadas',
    code_2: 'I82',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I829',
    level: 3,
    description: 'Embolia y trombosis de vena no especificada',
    code_2: 'I82',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I800',
    level: 3,
    description:
      'Flebitis y tromboflebitis de vasos superficiales de los miembros inferiores',
    code_2: 'I80',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I801',
    level: 3,
    description: 'Flebitis y tromboflebitis de la vena femoral',
    code_2: 'I80',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I802',
    level: 3,
    description:
      'Flebitis y tromboflebitis de otros vasos profundos de los miembros inferiores',
    code_2: 'I80',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I803',
    level: 3,
    description:
      'Flebitis y tromboflebitis de los miembros inferiores, no especificada',
    code_2: 'I80',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I808',
    level: 3,
    description: 'Flebitis y tromboflebitis de otros sitios',
    code_2: 'I80',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I809',
    level: 3,
    description: 'Flebitis y tromboflebitis de sitio no especificado',
    code_2: 'I80',
    code_0: 'I00-I99',
    code_1: 'I80-I89'
  },
  {
    code: 'I980',
    level: 3,
    description: 'S\u00edfilis cardiovascular',
    code_2: 'I98',
    code_0: 'I00-I99',
    code_1: 'I95-I99'
  },
  {
    code: 'I981',
    level: 3,
    description:
      'Trastornos cardiovasculares en otras enfermedades infecciosas y parasitarias clasificadas en otra parte',
    code_2: 'I98',
    code_0: 'I00-I99',
    code_1: 'I95-I99'
  },
  {
    code: 'I982',
    level: 3,
    description:
      'V\u00e1rices esof\u00e1gicas en enfermedades clasificadas en otra parte',
    code_2: 'I98',
    code_0: 'I00-I99',
    code_1: 'I95-I99'
  },
  {
    code: 'I988',
    level: 3,
    description:
      'Otros trastornos especificados del aparato circulatorio en enfermedades clasificadas en otra parte',
    code_2: 'I98',
    code_0: 'I00-I99',
    code_1: 'I95-I99'
  },
  {
    code: 'I970',
    level: 3,
    description: 'S\u00edndrome de postcardiotom\u00eda',
    code_2: 'I97',
    code_0: 'I00-I99',
    code_1: 'I95-I99'
  },
  {
    code: 'I971',
    level: 3,
    description:
      'Otras alteraciones funcionales consecutivas a cirug\u00eda card\u00edaca',
    code_2: 'I97',
    code_0: 'I00-I99',
    code_1: 'I95-I99'
  },
  {
    code: 'I972',
    level: 3,
    description: 'S\u00edndrome de linfedema postmastectom\u00eda',
    code_2: 'I97',
    code_0: 'I00-I99',
    code_1: 'I95-I99'
  },
  {
    code: 'I978',
    level: 3,
    description:
      'Otros trastornos del sistema circulatorio consecutivos a procedimientos, no clasificados en otra parte',
    code_2: 'I97',
    code_0: 'I00-I99',
    code_1: 'I95-I99'
  },
  {
    code: 'I979',
    level: 3,
    description:
      'Trastorno no especificado del sistema circulatorio consecutivo a procedimientos',
    code_2: 'I97',
    code_0: 'I00-I99',
    code_1: 'I95-I99'
  },
  {
    code: 'I950',
    level: 3,
    description: 'Hipotensi\u00f3n idiop\u00e1tica',
    code_2: 'I95',
    code_0: 'I00-I99',
    code_1: 'I95-I99'
  },
  {
    code: 'I951',
    level: 3,
    description: 'Hipotensi\u00f3n ortost\u00e1tica',
    code_2: 'I95',
    code_0: 'I00-I99',
    code_1: 'I95-I99'
  },
  {
    code: 'I952',
    level: 3,
    description: 'Hipotensi\u00f3n debida a drogas',
    code_2: 'I95',
    code_0: 'I00-I99',
    code_1: 'I95-I99'
  },
  {
    code: 'I958',
    level: 3,
    description: 'Otros tipos de hipotensi\u00f3n',
    code_2: 'I95',
    code_0: 'I00-I99',
    code_1: 'I95-I99'
  },
  {
    code: 'I959',
    level: 3,
    description: 'Hipotensi\u00f3n, no especificada',
    code_2: 'I95',
    code_0: 'I00-I99',
    code_1: 'I95-I99'
  },
  {
    code: 'T130',
    level: 3,
    description:
      'Traumatismo superficial de miembro inferior, nivel no especificado',
    code_2: 'T13',
    code_0: 'S00-T88',
    code_1: 'T08-T14'
  },
  {
    code: 'T131',
    level: 3,
    description: 'Herida de miembro inferior, nivel no especificado',
    code_2: 'T13',
    code_0: 'S00-T88',
    code_1: 'T08-T14'
  },
  {
    code: 'T132',
    level: 3,
    description:
      'Luxaci\u00f3n, esguince o torcedura de articulaci\u00f3n y ligamentos no especificados de miembro inferior, nivel no especificado',
    code_2: 'T13',
    code_0: 'S00-T88',
    code_1: 'T08-T14'
  },
  {
    code: 'T133',
    level: 3,
    description:
      'Traumatismo de nervios no especificados de miembro inferior, nivel no especificado',
    code_2: 'T13',
    code_0: 'S00-T88',
    code_1: 'T08-T14'
  },
  {
    code: 'T134',
    level: 3,
    description:
      'Traumatismo de vasos sangu\u00edneos no especificados de miembro inferior, nivel no especificado',
    code_2: 'T13',
    code_0: 'S00-T88',
    code_1: 'T08-T14'
  },
  {
    code: 'T135',
    level: 3,
    description:
      'Traumatismo de tendones y m\u00fasculos no especificados de miembro inferior, nivel no especificado',
    code_2: 'T13',
    code_0: 'S00-T88',
    code_1: 'T08-T14'
  },
  {
    code: 'T136',
    level: 3,
    description:
      'Amputaci\u00f3n traum\u00e1tica de miembro inferior, nivel no especificado',
    code_2: 'T13',
    code_0: 'S00-T88',
    code_1: 'T08-T14'
  },
  {
    code: 'T138',
    level: 3,
    description:
      'Otros traumatismos especificados de miembro inferior, nivel no especificado',
    code_2: 'T13',
    code_0: 'S00-T88',
    code_1: 'T08-T14'
  },
  {
    code: 'T110',
    level: 3,
    description:
      'Traumatismo superficial de miembro superior, nivel no especificado',
    code_2: 'T11',
    code_0: 'S00-T88',
    code_1: 'T08-T14'
  },
  {
    code: 'T111',
    level: 3,
    description: 'Herida de miembro superior, nivel no especificado',
    code_2: 'T11',
    code_0: 'S00-T88',
    code_1: 'T08-T14'
  },
  {
    code: 'T112',
    level: 3,
    description:
      'Luxaci\u00f3n, esguince o torcedura de articulaci\u00f3n o ligamento no especificado de miembro superior, nivel no especificado',
    code_2: 'T11',
    code_0: 'S00-T88',
    code_1: 'T08-T14'
  },
  {
    code: 'T113',
    level: 3,
    description:
      'Traumatismo de nervio no especificado de miembro superior, nivel no especificado',
    code_2: 'T11',
    code_0: 'S00-T88',
    code_1: 'T08-T14'
  },
  {
    code: 'T114',
    level: 3,
    description:
      'Traumatismo de vasos sangu\u00edneos no especificados de miembro superior, nivel no especificado',
    code_2: 'T11',
    code_0: 'S00-T88',
    code_1: 'T08-T14'
  },
  {
    code: 'T115',
    level: 3,
    description:
      'Traumatismo de tend\u00f3n y m\u00fasculo no especificados de miembro superior, nivel no especificado',
    code_2: 'T11',
    code_0: 'S00-T88',
    code_1: 'T08-T14'
  },
  {
    code: 'T116',
    level: 3,
    description:
      'Amputaci\u00f3n traum\u00e1tica de miembro superior, nivel no especificado',
    code_2: 'T11',
    code_0: 'S00-T88',
    code_1: 'T08-T14'
  },
  {
    code: 'T118',
    level: 3,
    description:
      'Otros traumatismos especificados de miembro superior, nivel no especificado',
    code_2: 'T11',
    code_0: 'S00-T88',
    code_1: 'T08-T14'
  },
  {
    code: 'T119',
    level: 3,
    description:
      'Traumatismo no especificado de miembro superior, nivel no especificado',
    code_2: 'T11',
    code_0: 'S00-T88',
    code_1: 'T08-T14'
  },
  {
    code: 'T090',
    level: 3,
    description: 'Traumatismo superficial del tronco, nivel no especificado',
    code_2: 'T09',
    code_0: 'S00-T88',
    code_1: 'T08-T14'
  },
  {
    code: 'T091',
    level: 3,
    description: 'Herida del tronco, nivel no especificado',
    code_2: 'T09',
    code_0: 'S00-T88',
    code_1: 'T08-T14'
  },
  {
    code: 'T092',
    level: 3,
    description:
      'Luxaci\u00f3n, esguince o torcedura de articulaci\u00f3n y ligamentos del tronco, no especificado',
    code_2: 'T09',
    code_0: 'S00-T88',
    code_1: 'T08-T14'
  },
  {
    code: 'T093',
    level: 3,
    description: 'Traumatismo de la m\u00e9dula espinal, nivel no especificado',
    code_2: 'T09',
    code_0: 'S00-T88',
    code_1: 'T08-T14'
  },
  {
    code: 'T094',
    level: 3,
    description:
      'Traumatismo de nervios, ra\u00edz de nervio espinal y plexos del tronco no especificados',
    code_2: 'T09',
    code_0: 'S00-T88',
    code_1: 'T08-T14'
  },
  {
    code: 'T095',
    level: 3,
    description:
      'Traumatismo de tendones y m\u00fasculos del tronco no especificados',
    code_2: 'T09',
    code_0: 'S00-T88',
    code_1: 'T08-T14'
  },
  {
    code: 'T096',
    level: 3,
    description:
      'Amputaci\u00f3n traum\u00e1tica del tronco, nivel no especificado',
    code_2: 'T09',
    code_0: 'S00-T88',
    code_1: 'T08-T14'
  },
  {
    code: 'T098',
    level: 3,
    description:
      'Otros traumatismos especificados del tronco, nivel no especificado',
    code_2: 'T09',
    code_0: 'S00-T88',
    code_1: 'T08-T14'
  },
  {
    code: 'T099',
    level: 3,
    description:
      'Traumatismo no especificado del tronco, nivel no especificado',
    code_2: 'T09',
    code_0: 'S00-T88',
    code_1: 'T08-T14'
  },
  {
    code: 'T170',
    level: 3,
    description: 'Cuerpo extra\u00f1o en seno paranasal',
    code_2: 'T17',
    code_0: 'S00-T88',
    code_1: 'T15-T19'
  },
  {
    code: 'T171',
    level: 3,
    description: 'Cuerpo extra\u00f1o en el orificio nasal',
    code_2: 'T17',
    code_0: 'S00-T88',
    code_1: 'T15-T19'
  },
  {
    code: 'T172',
    level: 3,
    description: 'Cuerpo extra\u00f1o en la faringe',
    code_2: 'T17',
    code_0: 'S00-T88',
    code_1: 'T15-T19'
  },
  {
    code: 'T173',
    level: 3,
    description: 'Cuerpo extra\u00f1o en la laringe',
    code_2: 'T17',
    code_0: 'S00-T88',
    code_1: 'T15-T19'
  },
  {
    code: 'T174',
    level: 3,
    description: 'Cuerpo extra\u00f1o en la tr\u00e1quea',
    code_2: 'T17',
    code_0: 'S00-T88',
    code_1: 'T15-T19'
  },
  {
    code: 'T175',
    level: 3,
    description: 'Cuerpo extra\u00f1o en bronquios',
    code_2: 'T17',
    code_0: 'S00-T88',
    code_1: 'T15-T19'
  },
  {
    code: 'T178',
    level: 3,
    description:
      'Cuerpo extra\u00f1o en otras y en m\u00faltiples partes de las v\u00edas respiratorias',
    code_2: 'T17',
    code_0: 'S00-T88',
    code_1: 'T15-T19'
  },
  {
    code: 'T179',
    level: 3,
    description:
      'Cuerpo extra\u00f1o en las v\u00edas respiratorias, parte no especificada',
    code_2: 'T17',
    code_0: 'S00-T88',
    code_1: 'T15-T19'
  },
  {
    code: 'T150',
    level: 3,
    description: 'Cuerpo extra\u00f1o en la c\u00f3rnea',
    code_2: 'T15',
    code_0: 'S00-T88',
    code_1: 'T15-T19'
  },
  {
    code: 'T151',
    level: 3,
    description: 'Cuerpo extra\u00f1o en el saco conjuntival',
    code_2: 'T15',
    code_0: 'S00-T88',
    code_1: 'T15-T19'
  },
  {
    code: 'T158',
    level: 3,
    description:
      'Cuerpo extra\u00f1o en otras y en m\u00faltiples partes de la parte externa del ojo',
    code_2: 'T15',
    code_0: 'S00-T88',
    code_1: 'T15-T19'
  },
  {
    code: 'T159',
    level: 3,
    description:
      'Cuerpo extra\u00f1o en parte externa del ojo, sitio no especificado',
    code_2: 'T15',
    code_0: 'S00-T88',
    code_1: 'T15-T19'
  },
  {
    code: 'T29',
    level: 3,
    description:
      'Quemaduras y corrosiones de m\u00faltiples regiones del cuerpo',
    code_2: 'T29-T32',
    code_0: 'S00-T88',
    code_1: 'T20-T32'
  },
  {
    code: 'T30',
    level: 3,
    description:
      'Quemadura y corrosi\u00f3n, regi\u00f3n del cuerpo no especificada',
    code_2: 'T29-T32',
    code_0: 'S00-T88',
    code_1: 'T20-T32'
  },
  {
    code: 'T26',
    level: 3,
    description: 'Quemadura y corrosi\u00f3n limitada al ojo y sus anexos',
    code_2: 'T26-T28',
    code_0: 'S00-T88',
    code_1: 'T20-T32'
  },
  {
    code: 'T27',
    level: 3,
    description: 'Quemadura y corrosi\u00f3n de las v\u00edas respiratorias',
    code_2: 'T26-T28',
    code_0: 'S00-T88',
    code_1: 'T20-T32'
  },
  {
    code: 'T28',
    level: 3,
    description: 'Quemadura y corrosi\u00f3n de otros \u00f3rganos internos',
    code_2: 'T26-T28',
    code_0: 'S00-T88',
    code_1: 'T20-T32'
  },
  {
    code: 'T20',
    level: 3,
    description: 'Quemadura y corrosi\u00f3n de la cabeza y del cuello',
    code_2: 'T20-T25',
    code_0: 'S00-T88',
    code_1: 'T20-T32'
  },
  {
    code: 'T21',
    level: 3,
    description: 'Quemadura y corrosi\u00f3n del tronco',
    code_2: 'T20-T25',
    code_0: 'S00-T88',
    code_1: 'T20-T32'
  },
  {
    code: 'T22',
    level: 3,
    description:
      'Quemadura y corrosi\u00f3n del hombro y miembro superior, excepto de la mu\u00f1eca y de la mano',
    code_2: 'T20-T25',
    code_0: 'S00-T88',
    code_1: 'T20-T32'
  },
  {
    code: 'T23',
    level: 3,
    description: 'Quemadura y corrosi\u00f3n de la mu\u00f1eca y de la mano',
    code_2: 'T20-T25',
    code_0: 'S00-T88',
    code_1: 'T20-T32'
  },
  {
    code: 'T350',
    level: 3,
    description:
      'Congelamiento superficial que afecta m\u00faltiples regiones del cuerpo',
    code_2: 'T35',
    code_0: 'S00-T88',
    code_1: 'T33-T35'
  },
  {
    code: 'T351',
    level: 3,
    description:
      'Congelamiento con necrosis tisular que afecta m\u00faltiples regiones del cuerpo',
    code_2: 'T35',
    code_0: 'S00-T88',
    code_1: 'T33-T35'
  },
  {
    code: 'T352',
    level: 3,
    description: 'Congelamiento no especificado de la cabeza y del cuello',
    code_2: 'T35',
    code_0: 'S00-T88',
    code_1: 'T33-T35'
  },
  {
    code: 'T353',
    level: 3,
    description:
      'Congelamiento no especificado del t\u00f3rax, del abdomen, de la regi\u00f3n lumbosacra y de la pelvis',
    code_2: 'T35',
    code_0: 'S00-T88',
    code_1: 'T33-T35'
  },
  {
    code: 'T354',
    level: 3,
    description: 'Congelamiento no especificado del miembro superior',
    code_2: 'T35',
    code_0: 'S00-T88',
    code_1: 'T33-T35'
  },
  {
    code: 'T355',
    level: 3,
    description: 'Congelamiento no especificado del miembro inferior',
    code_2: 'T35',
    code_0: 'S00-T88',
    code_1: 'T33-T35'
  },
  {
    code: 'T356',
    level: 3,
    description:
      'Congelamiento no especificado que afecta m\u00faltiples regiones del cuerpo',
    code_2: 'T35',
    code_0: 'S00-T88',
    code_1: 'T33-T35'
  },
  {
    code: 'T357',
    level: 3,
    description: 'Congelamiento no especificado, de sitio no especificado',
    code_2: 'T35',
    code_0: 'S00-T88',
    code_1: 'T33-T35'
  },
  {
    code: 'T340',
    level: 3,
    description: 'Congelamiento con necrosis tisular de la cabeza',
    code_2: 'T34',
    code_0: 'S00-T88',
    code_1: 'T33-T35'
  },
  {
    code: 'T341',
    level: 3,
    description: 'Congelamiento con necrosis tisular del cuello',
    code_2: 'T34',
    code_0: 'S00-T88',
    code_1: 'T33-T35'
  },
  {
    code: 'T342',
    level: 3,
    description: 'Congelamiento con necrosis tisular del t\u00f3rax',
    code_2: 'T34',
    code_0: 'S00-T88',
    code_1: 'T33-T35'
  },
  {
    code: 'T343',
    level: 3,
    description:
      'Congelamiento con necrosis tisular de la pared abdominal, regi\u00f3n lumbosacra y pelvis',
    code_2: 'T34',
    code_0: 'S00-T88',
    code_1: 'T33-T35'
  },
  {
    code: 'T344',
    level: 3,
    description: 'Congelamiento con necrosis tisular del brazo',
    code_2: 'T34',
    code_0: 'S00-T88',
    code_1: 'T33-T35'
  },
  {
    code: 'T345',
    level: 3,
    description:
      'Congelamiento con necrosis tisular de la mu\u00f1eca y de la mano',
    code_2: 'T34',
    code_0: 'S00-T88',
    code_1: 'T33-T35'
  },
  {
    code: 'T346',
    level: 3,
    description: 'Congelamiento con necrosis tisular de la cadera y del muslo',
    code_2: 'T34',
    code_0: 'S00-T88',
    code_1: 'T33-T35'
  },
  {
    code: 'T347',
    level: 3,
    description:
      'Congelamiento con necrosis tisular de la rodilla y de la pierna',
    code_2: 'T34',
    code_0: 'S00-T88',
    code_1: 'T33-T35'
  },
  {
    code: 'T348',
    level: 3,
    description: 'Congelamiento con necrosis tisular del tobillo y del pie',
    code_2: 'T34',
    code_0: 'S00-T88',
    code_1: 'T33-T35'
  },
  {
    code: 'T349',
    level: 3,
    description:
      'Congelamiento con necrosis tisular de otros sitios y de los no especificados',
    code_2: 'T34',
    code_0: 'S00-T88',
    code_1: 'T33-T35'
  },
  {
    code: 'T330',
    level: 3,
    description: 'Congelamiento superficial de la cabeza',
    code_2: 'T33',
    code_0: 'S00-T88',
    code_1: 'T33-T35'
  },
  {
    code: 'T331',
    level: 3,
    description: 'Congelamiento superficial del cuello',
    code_2: 'T33',
    code_0: 'S00-T88',
    code_1: 'T33-T35'
  },
  {
    code: 'T332',
    level: 3,
    description: 'Congelamiento superficial del t\u00f3rax',
    code_2: 'T33',
    code_0: 'S00-T88',
    code_1: 'T33-T35'
  },
  {
    code: 'T333',
    level: 3,
    description:
      'Congelamiento superficial de la pared abdominal, regi\u00f3n lumbosacra y pelvis',
    code_2: 'T33',
    code_0: 'S00-T88',
    code_1: 'T33-T35'
  },
  {
    code: 'T334',
    level: 3,
    description: 'Congelamiento superficial del brazo',
    code_2: 'T33',
    code_0: 'S00-T88',
    code_1: 'T33-T35'
  },
  {
    code: 'T380',
    level: 3,
    description: 'Glucocorticoides y an\u00e1logos sint\u00e9ticos',
    code_2: 'T38',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T381',
    level: 3,
    description: 'Hormonas tiroideas y sustitutos',
    code_2: 'T38',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T382',
    level: 3,
    description: 'Drogas antitiroideas',
    code_2: 'T38',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T383',
    level: 3,
    description:
      'Insulina y drogas hipoglucemiantes orales [antidiab\u00e9ticas]',
    code_2: 'T38',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T384',
    level: 3,
    description: 'Anticonceptivos orales',
    code_2: 'T38',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T370',
    level: 3,
    description: 'Sulfonamidas',
    code_2: 'T37',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T371',
    level: 3,
    description: 'Drogas antimicobacterianas',
    code_2: 'T37',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T372',
    level: 3,
    description:
      'Antipal\u00fadicos y drogas de acci\u00f3n contra otros protozoarios sangu\u00edneos',
    code_2: 'T37',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T373',
    level: 3,
    description: 'Otras drogas antiprotozoarias',
    code_2: 'T37',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T374',
    level: 3,
    description: 'Antihelm\u00ednticos',
    code_2: 'T37',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T375',
    level: 3,
    description: 'Drogas antivirales',
    code_2: 'T37',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T378',
    level: 3,
    description:
      'Otros antiinfecciosos y antiparasitarios sist\u00e9micos especificados',
    code_2: 'T37',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T379',
    level: 3,
    description:
      'Antiinfecciosos y antiparasitarios sist\u00e9micos, no especificados',
    code_2: 'T37',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'Z138',
    level: 3,
    description:
      'Examen de pesquisa especial para otras enfermedades y trastornos especificados',
    code_2: 'Z13',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z139',
    level: 3,
    description: 'Examen de pesquisa especial, no especificado',
    code_2: 'Z13',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z126',
    level: 3,
    description: 'Examen de pesquisa especial para tumor de la vejiga',
    code_2: 'Z12',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z128',
    level: 3,
    description: 'Examen de pesquisa especial para tumores de otros sitios',
    code_2: 'Z12',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z129',
    level: 3,
    description:
      'Examen de pesquisa especial para tumor de sitio no especificado',
    code_2: 'Z12',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'T360',
    level: 3,
    description: 'Penicilinas',
    code_2: 'T36',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T361',
    level: 3,
    description:
      'Cefalosporinas y otros antibi\u00f3ticos beta-lact\u00e1micos',
    code_2: 'T36',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T362',
    level: 3,
    description: 'Grupo del cloramfenicol',
    code_2: 'T36',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T363',
    level: 3,
    description: 'Macr\u00f3lidos',
    code_2: 'T36',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T364',
    level: 3,
    description: 'Tetraciclinas',
    code_2: 'T36',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T365',
    level: 3,
    description: 'Aminogluc\u00f3sidos',
    code_2: 'T36',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T366',
    level: 3,
    description: 'Rifamicinas',
    code_2: 'T36',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T367',
    level: 3,
    description:
      'Antibi\u00f3ticos antimic\u00f3ticos usados sist\u00e9micamente',
    code_2: 'T36',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T368',
    level: 3,
    description: 'Otros antibi\u00f3ticos sist\u00e9micos',
    code_2: 'T36',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T369',
    level: 3,
    description: 'Antibi\u00f3ticos sist\u00e9micos, no especificados',
    code_2: 'T36',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'Z097',
    level: 3,
    description:
      'Examen de seguimiento consecutivo a tratamiento combinado por otras afecciones',
    code_2: 'Z09',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z098',
    level: 3,
    description:
      'Examen de seguimiento consecutivo a otro tratamiento por otras afecciones',
    code_2: 'Z09',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z099',
    level: 3,
    description:
      'Examen de seguimiento consecutivo a tratamiento no especificado por otras afecciones',
    code_2: 'Z09',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'T540',
    level: 3,
    description: 'Fenol y hom\u00f3logos del fenol',
    code_2: 'T54',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T541',
    level: 3,
    description: 'Otros compuestos org\u00e1nicos corrosivos',
    code_2: 'T54',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T542',
    level: 3,
    description: '\u00c1cidos corrosivos y sustancias \u00e1cidas similares',
    code_2: 'T54',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T543',
    level: 3,
    description: '\u00c1lcalis c\u00e1usticos y sustancias alcalinas similares',
    code_2: 'T54',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T549',
    level: 3,
    description: 'Efecto t\u00f3xico de sustancia corrosiva, no especificada',
    code_2: 'T54',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T530',
    level: 3,
    description: 'Tetracloruro de carbono',
    code_2: 'T53',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T531',
    level: 3,
    description: 'Cloroformo',
    code_2: 'T53',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T532',
    level: 3,
    description: 'Tricloroetileno',
    code_2: 'T53',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T533',
    level: 3,
    description: 'Tetracloroetileno',
    code_2: 'T53',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T534',
    level: 3,
    description: 'Dicloroetano',
    code_2: 'T53',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T535',
    level: 3,
    description: 'Clorofluorocarburos',
    code_2: 'T53',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T536',
    level: 3,
    description: 'Otros derivados halogenados de hidrocarburos alif\u00e1ticos',
    code_2: 'T53',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T537',
    level: 3,
    description: 'Otros derivados halogenados de hidrocarburos arom\u00e1ticos',
    code_2: 'T53',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T539',
    level: 3,
    description:
      'Derivados halogenados de hidrocarburos alif\u00e1ticos y arom\u00e1ticos, no especificados',
    code_2: 'T53',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T520',
    level: 3,
    description: 'Productos del petr\u00f3leo',
    code_2: 'T52',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T521',
    level: 3,
    description: 'Benceno',
    code_2: 'T52',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T522',
    level: 3,
    description: 'Hom\u00f3logos del benceno',
    code_2: 'T52',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T523',
    level: 3,
    description: 'Glicoles',
    code_2: 'T52',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T524',
    level: 3,
    description: 'Cetonas',
    code_2: 'T52',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T528',
    level: 3,
    description: 'Otros disolventes org\u00e1nicos',
    code_2: 'T52',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T529',
    level: 3,
    description: 'Disolventes org\u00e1nicos, no especificados',
    code_2: 'T52',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'Z387',
    level: 3,
    description: 'Otros nacimientos m\u00faltiples, fuera del hospital',
    code_2: 'Z38',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z388',
    level: 3,
    description:
      'Otros nacimientos m\u00faltiples, lugar de nacimiento no especificado',
    code_2: 'Z38',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z379',
    level: 3,
    description: 'Producto del parto no especificado',
    code_2: 'Z37',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'T510',
    level: 3,
    description: 'Etanol',
    code_2: 'T51',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T511',
    level: 3,
    description: 'Metanol',
    code_2: 'T51',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T512',
    level: 3,
    description: 'Propanol\u20132',
    code_2: 'T51',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T513',
    level: 3,
    description: 'Licor de alcohol insuficientemente destilado',
    code_2: 'T51',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T518',
    level: 3,
    description: 'Otros alcoholes',
    code_2: 'T51',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'T519',
    level: 3,
    description: 'Alcohol, no especificado',
    code_2: 'T51',
    code_0: 'S00-T88',
    code_1: 'T51-T65'
  },
  {
    code: 'Z369',
    level: 3,
    description: 'Pesquisa prenatal, sin otra especificaci\u00f3n',
    code_2: 'Z36',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'T700',
    level: 3,
    description: 'Barotrauma ot\u00edtico',
    code_2: 'T70',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T701',
    level: 3,
    description: 'Barotrauma sinusal',
    code_2: 'T70',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T702',
    level: 3,
    description: 'Otros efectos y los no especificados de la gran altitud',
    code_2: 'T70',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T703',
    level: 3,
    description:
      'Enfermedad por descompresi\u00f3n [de los cajones sumergidos]',
    code_2: 'T70',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T704',
    level: 3,
    description: 'Efectos de l\u00edquidos con alta presi\u00f3n',
    code_2: 'T70',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T708',
    level: 3,
    description: 'Otros efectos de la presi\u00f3n del aire y del agua',
    code_2: 'T70',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T709',
    level: 3,
    description:
      'Efecto de la presi\u00f3n del aire y del agua, no especificado',
    code_2: 'T70',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T690',
    level: 3,
    description: 'Mano y pie de inmersi\u00f3n',
    code_2: 'T69',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T691',
    level: 3,
    description: 'Saba\u00f1\u00f3n(es)',
    code_2: 'T69',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T698',
    level: 3,
    description:
      'Otros efectos especificados de la reducci\u00f3n de la temperatura',
    code_2: 'T69',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T699',
    level: 3,
    description:
      'Efecto de la reducci\u00f3n de la temperatura, no especificado',
    code_2: 'T69',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T670',
    level: 3,
    description: 'Golpe de calor e insolaci\u00f3n',
    code_2: 'T67',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T671',
    level: 3,
    description: 'S\u00edncope por calor',
    code_2: 'T67',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T672',
    level: 3,
    description: 'Calambre por calor',
    code_2: 'T67',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T673',
    level: 3,
    description: 'Agotamiento por calor, anhidr\u00f3tico',
    code_2: 'T67',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T674',
    level: 3,
    description: 'Agotamiento por calor debido a depleci\u00f3n de sal',
    code_2: 'T67',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T675',
    level: 3,
    description: 'Agotamiento por calor, no especificado',
    code_2: 'T67',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'Z410',
    level: 3,
    description: 'Trasplante de pelo',
    code_2: 'Z41',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z411',
    level: 3,
    description:
      'Otras cirug\u00edas pl\u00e1sticas por razones est\u00e9ticas',
    code_2: 'Z41',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z412',
    level: 3,
    description: 'Circuncisi\u00f3n ritual o de rutina',
    code_2: 'Z41',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z400',
    level: 3,
    description:
      'Cirug\u00eda profil\u00e1ctica por factores de riesgo relacionados con tumores malignos',
    code_2: 'Z40',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z408',
    level: 3,
    description: 'Otra cirug\u00eda profil\u00e1ctica',
    code_2: 'Z40',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z409',
    level: 3,
    description: 'Cirug\u00eda profil\u00e1ctica no especificada',
    code_2: 'Z40',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z600',
    level: 3,
    description:
      'Problemas relacionados con el ajuste a las transiciones del ciclo vital',
    code_2: 'Z60',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z601',
    level: 3,
    description:
      'Problemas relacionados con situaci\u00f3n familiar at\u00edpica',
    code_2: 'Z60',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z602',
    level: 3,
    description: 'Problemas relacionados con persona que vive sola',
    code_2: 'Z60',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z603',
    level: 3,
    description: 'Problemas relacionados con la adaptaci\u00f3n cultural',
    code_2: 'Z60',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z590',
    level: 3,
    description: 'Problemas relacionados con la falta de vivienda',
    code_2: 'Z59',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z591',
    level: 3,
    description: 'Problemas relacionados con vivienda inadecuada',
    code_2: 'Z59',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z592',
    level: 3,
    description: 'Problemas caseros y con vecinos e inquilinos',
    code_2: 'Z59',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z593',
    level: 3,
    description:
      'Problemas relacionados con persona que reside en una instituci\u00f3n',
    code_2: 'Z59',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z580',
    level: 3,
    description: 'Exposici\u00f3n al ruido',
    code_2: 'Z58',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z581',
    level: 3,
    description: 'Exposici\u00f3n al aire contaminado',
    code_2: 'Z58',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z570',
    level: 3,
    description: 'Exposici\u00f3n ocupacional al ruido',
    code_2: 'Z57',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z571',
    level: 3,
    description: 'Exposici\u00f3n ocupacional a la radiaci\u00f3n',
    code_2: 'Z57',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z572',
    level: 3,
    description: 'Exposici\u00f3n ocupacional al polvo',
    code_2: 'Z57',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z573',
    level: 3,
    description: 'Exposici\u00f3n ocupacional a otro contaminante del aire',
    code_2: 'Z57',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z574',
    level: 3,
    description:
      'Exposici\u00f3n ocupacional a agentes t\u00f3xicos en agricultura',
    code_2: 'Z57',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z560',
    level: 3,
    description: 'Problemas relacionados con el desempleo, no especificados',
    code_2: 'Z56',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z561',
    level: 3,
    description: 'Problemas relacionados con el cambio de empleo',
    code_2: 'Z56',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z562',
    level: 3,
    description:
      'Problemas relacionados con amenaza de p\u00e9rdida del empleo',
    code_2: 'Z56',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z563',
    level: 3,
    description: 'Problemas relacionados con horario estresante de trabajo',
    code_2: 'Z56',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z564',
    level: 3,
    description:
      'Problemas relacionados con desavenencias con el jefe y los compa\u00f1eros de trabajo',
    code_2: 'Z56',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z550',
    level: 3,
    description:
      'Problemas relacionados con el analfabetismo o bajo nivel de instrucci\u00f3n',
    code_2: 'Z55',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z551',
    level: 3,
    description:
      'Problemas relacionados con la educaci\u00f3n no disponible o inaccesible',
    code_2: 'Z55',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z552',
    level: 3,
    description: 'Problemas relacionados con la falla en los ex\u00e1menes',
    code_2: 'Z55',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z553',
    level: 3,
    description: 'Problemas relacionados con el bajo rendimiento escolar',
    code_2: 'Z55',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z554',
    level: 3,
    description:
      'Problemas relacionados con la inadaptaci\u00f3n educacional y desavenencias con maestros y compa\u00f1eros',
    code_2: 'Z55',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z558',
    level: 3,
    description:
      'Otros problemas relacionados con la educaci\u00f3n y la alfabetizaci\u00f3n',
    code_2: 'Z55',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z559',
    level: 3,
    description:
      'Problema no especificado relacionado con la educaci\u00f3n y la alfabetizaci\u00f3n',
    code_2: 'Z55',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z760',
    level: 3,
    description: 'Consulta para repetici\u00f3n de receta',
    code_2: 'Z76',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z761',
    level: 3,
    description:
      'Consulta para atenci\u00f3n y supervisi\u00f3n de la salud del ni\u00f1o abandonado',
    code_2: 'Z76',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z762',
    level: 3,
    description:
      'Consulta para atenci\u00f3n y supervisi\u00f3n de la salud de otros ni\u00f1os o lactantes sanos',
    code_2: 'Z76',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z763',
    level: 3,
    description: 'Persona sana que acompa\u00f1a al enfermo',
    code_2: 'Z76',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z764',
    level: 3,
    description: 'Otro hu\u00e9sped en servicios de salud',
    code_2: 'Z76',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z765',
    level: 3,
    description:
      'Persona que consulta con simulaci\u00f3n consciente [simulador]',
    code_2: 'Z76',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z750',
    level: 3,
    description:
      'Problemas relacionados con servicio m\u00e9dico no disponible en el domicilio',
    code_2: 'Z75',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z751',
    level: 3,
    description:
      'Problemas relacionados con persona esperando admisi\u00f3n en una instituci\u00f3n apropiada en otro lugar',
    code_2: 'Z75',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z752',
    level: 3,
    description:
      'Problemas relacionados con persona en otro per\u00edodo de espera para investigaci\u00f3n y tratamiento',
    code_2: 'Z75',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z753',
    level: 3,
    description:
      'Problemas relacionados con atenci\u00f3n de salud no disponible o inaccesible',
    code_2: 'Z75',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z754',
    level: 3,
    description:
      'Problemas relacionados con otros servicios asistenciales no disponibles o inaccesibles',
    code_2: 'Z75',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z755',
    level: 3,
    description:
      'Problemas relacionados con la atenci\u00f3n durante vacaciones de la familia',
    code_2: 'Z75',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z758',
    level: 3,
    description:
      'Otros problemas relacionados con servicios m\u00e9dicos y de salud',
    code_2: 'Z75',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z759',
    level: 3,
    description:
      'Problema no especificado relacionado con servicios m\u00e9dicos y de salud',
    code_2: 'Z75',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z740',
    level: 3,
    description: 'Problemas relacionados con movilidad reducida',
    code_2: 'Z74',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z741',
    level: 3,
    description:
      'Problemas relacionados con la necesidad de ayuda para el cuidado personal',
    code_2: 'Z74',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z742',
    level: 3,
    description:
      'Problemas relacionados con la necesidad de asistencia domiciliaria y que ning\u00fan otro miembro del hogar puede proporcionar',
    code_2: 'Z74',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z743',
    level: 3,
    description:
      'Problemas relacionados con la necesidad de supervisi\u00f3n continua',
    code_2: 'Z74',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z748',
    level: 3,
    description:
      'Otros problemas relacionados con dependencia del prestador de servicios',
    code_2: 'Z74',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z749',
    level: 3,
    description:
      'Problema no especificado relacionado con dependencia del prestador de servicios',
    code_2: 'Z74',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z730',
    level: 3,
    description: 'Problemas relacionados con la enfermedad consuntiva',
    code_2: 'Z73',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z731',
    level: 3,
    description:
      'Problemas relacionados con la acentuaci\u00f3n de rasgos de la personalidad',
    code_2: 'Z73',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z732',
    level: 3,
    description:
      'Problemas relacionados con la falta de relajaci\u00f3n y descanso',
    code_2: 'Z73',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z733',
    level: 3,
    description:
      'Problemas relacionados con el estr\u00e9s, no clasificados en otra parte',
    code_2: 'Z73',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z720',
    level: 3,
    description: 'Problemas relacionados con el uso del tabaco',
    code_2: 'Z72',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z721',
    level: 3,
    description: 'Problemas relacionados con el uso del alcohol',
    code_2: 'Z72',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z722',
    level: 3,
    description: 'Problemas relacionados con el uso de drogas',
    code_2: 'Z72',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z723',
    level: 3,
    description: 'Problemas relacionados con la falta de ejercicio f\u00edsico',
    code_2: 'Z72',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z724',
    level: 3,
    description:
      'Problemas relacionados con la dieta y h\u00e1bitos alimentarios inapropiados',
    code_2: 'Z72',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z725',
    level: 3,
    description: 'Problemas relacionados con la conducta sexual de alto riesgo',
    code_2: 'Z72',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z726',
    level: 3,
    description: 'Problemas relacionados con el juego y las apuestas',
    code_2: 'Z72',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z710',
    level: 3,
    description: 'Persona que consulta en nombre de otra persona',
    code_2: 'Z71',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z711',
    level: 3,
    description:
      'Persona que teme estar enferma, a quien no se hace diagn\u00f3stico',
    code_2: 'Z71',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z712',
    level: 3,
    description:
      'Persona que consulta para la explicaci\u00f3n de hallazgos de investigaci\u00f3n',
    code_2: 'Z71',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z713',
    level: 3,
    description: 'Consulta para instrucci\u00f3n y vigilancia de la dieta',
    code_2: 'Z71',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z714',
    level: 3,
    description:
      'Consulta para asesor\u00eda y vigilancia por abuso de alcohol',
    code_2: 'Z71',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z715',
    level: 3,
    description: 'Consulta para asesor\u00eda y vigilancia por abuso de drogas',
    code_2: 'Z71',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z716',
    level: 3,
    description: 'Consulta para asesor\u00eda por abuso de tabaco',
    code_2: 'Z71',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z358',
    level: 3,
    description: 'Supervisi\u00f3n de otros embarazos de alto riesgo',
    code_2: 'Z35',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z359',
    level: 3,
    description:
      'Supervisi\u00f3n de embarazo de alto riesgo, sin otra especificaci\u00f3n',
    code_2: 'Z35',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'B878',
    level: 3,
    description: 'Miasis de otros sitios',
    code_2: 'B87',
    code_0: 'A00-B99',
    code_1: 'B85-B89'
  },
  {
    code: 'B879',
    level: 3,
    description: 'Miasis, no especificada',
    code_2: 'B87',
    code_0: 'A00-B99',
    code_1: 'B85-B89'
  },
  {
    code: 'B948',
    level: 3,
    description:
      'Secuelas de otras enfermedades infecciosas y parasitarias especificadas',
    code_2: 'B94',
    code_0: 'A00-B99',
    code_1: 'B90-B94'
  },
  {
    code: 'B949',
    level: 3,
    description:
      'Secuelas de enfermedades infecciosas y parasitarias no especificadas',
    code_2: 'B94',
    code_0: 'A00-B99',
    code_1: 'B90-B94'
  },
  {
    code: 'B909',
    level: 3,
    description:
      'Secuelas de tuberculosis respiratoria y de tuberculosis no especificada',
    code_2: 'B90',
    code_0: 'A00-B99',
    code_1: 'B90-B94'
  },
  {
    code: 'B974',
    level: 3,
    description:
      'Virus sincicial respiratorio como causa de enfermedades clasificadas en otros cap\u00edtulos',
    code_2: 'B97',
    code_0: 'A00-B99',
    code_1: 'B95-B97'
  },
  {
    code: 'B975',
    level: 3,
    description:
      'Reovirus como causa de enfermedades clasificadas en otros cap\u00edtulos',
    code_2: 'B97',
    code_0: 'A00-B99',
    code_1: 'B95-B97'
  },
  {
    code: 'B976',
    level: 3,
    description:
      'Parvovirus como causa de enfermedades clasificadas en otros cap\u00edtulos',
    code_2: 'B97',
    code_0: 'A00-B99',
    code_1: 'B95-B97'
  },
  {
    code: 'B977',
    level: 3,
    description:
      'Papilomavirus como causa de enfermedades clasificadas en otros cap\u00edtulos',
    code_2: 'B97',
    code_0: 'A00-B99',
    code_1: 'B95-B97'
  },
  {
    code: 'B978',
    level: 3,
    description:
      'Otros agentes virales como causa de enfermedades clasificadas en otros cap\u00edtulos',
    code_2: 'B97',
    code_0: 'A00-B99',
    code_1: 'B95-B97'
  },
  {
    code: 'B965',
    level: 3,
    description:
      'Pseudomonas (aeruginosa) (mallei) (pseudomallei) como causa de enfermedades clasificadas en otros cap\u00edtulos',
    code_2: 'B96',
    code_0: 'A00-B99',
    code_1: 'B95-B97'
  },
  {
    code: 'B966',
    level: 3,
    description: 'Bacillus fragilis [B. fragilis] como causa de enfermedades',
    code_2: 'B96',
    code_0: 'A00-B99',
    code_1: 'B95-B97'
  },
  {
    code: 'B967',
    level: 3,
    description:
      'Clostridium perfringens [C. perfringens] como causa de enfermedades clasificadas en otros cap\u00edtulos',
    code_2: 'B96',
    code_0: 'A00-B99',
    code_1: 'B95-B97'
  },
  {
    code: 'B968',
    level: 3,
    description:
      'Otros agentes bacterianos especificados como causa de enfermedades clasificadas en otros cap\u00edtulos',
    code_2: 'B96',
    code_0: 'A00-B99',
    code_1: 'B95-B97'
  },
  {
    code: 'B955',
    level: 3,
    description:
      'Estreptococo no especificado como causa de enfermedades clasificadas en otros cap\u00edtulos',
    code_2: 'B95',
    code_0: 'A00-B99',
    code_1: 'B95-B97'
  },
  {
    code: 'B956',
    level: 3,
    description:
      'Staphylococcus aureus como causa de enfermedades clasificadas en otros cap\u00edtulos',
    code_2: 'B95',
    code_0: 'A00-B99',
    code_1: 'B95-B97'
  },
  {
    code: 'B957',
    level: 3,
    description:
      'Otros estafilococos como causa de enfermedades clasificadas en otros cap\u00edtulos',
    code_2: 'B95',
    code_0: 'A00-B99',
    code_1: 'B95-B97'
  },
  {
    code: 'B958',
    level: 3,
    description:
      'Estafilococo no especificado, como causa de enfermedades clasificadas en otros cap\u00edtulos',
    code_2: 'B95',
    code_0: 'A00-B99',
    code_1: 'B95-B97'
  },
  {
    code: 'M996',
    level: 3,
    description:
      'Estenosis \u00f3sea y subluxaci\u00f3n de los agujeros intervertebrales',
    code_2: 'M99',
    code_0: 'M00-M99',
    code_1: 'M95-M99'
  },
  {
    code: 'M997',
    level: 3,
    description:
      'Estenosis de los agujeros intervertebrales por tejido conjuntivo o por disco intervertebral',
    code_2: 'M99',
    code_0: 'M00-M99',
    code_1: 'M95-M99'
  },
  {
    code: 'M998',
    level: 3,
    description: 'Otras lesiones biomec\u00e1nicas',
    code_2: 'M99',
    code_0: 'M00-M99',
    code_1: 'M95-M99'
  },
  {
    code: 'M999',
    level: 3,
    description: 'Lesi\u00f3n biomec\u00e1nica, no especificada',
    code_2: 'M99',
    code_0: 'M00-M99',
    code_1: 'M95-M99'
  },
  {
    code: 'M966',
    level: 3,
    description:
      'Fractura de hueso posterior a inserci\u00f3n o implante ortop\u00e9dico, pr\u00f3tesis articular o placa \u00f3sea',
    code_2: 'M96',
    code_0: 'M00-M99',
    code_1: 'M95-M99'
  },
  {
    code: 'M968',
    level: 3,
    description:
      'Otros trastornos osteomusculares consecutivos a procedimientos',
    code_2: 'M96',
    code_0: 'M00-M99',
    code_1: 'M95-M99'
  },
  {
    code: 'M969',
    level: 3,
    description:
      'Trastornos osteomusculares no especificados consecutivos a procedimientos',
    code_2: 'M96',
    code_0: 'M00-M99',
    code_1: 'M95-M99'
  },
  {
    code: 'M955',
    level: 3,
    description: 'Deformidad adquirida de la pelvis',
    code_2: 'M95',
    code_0: 'M00-M99',
    code_1: 'M95-M99'
  },
  {
    code: 'M958',
    level: 3,
    description:
      'Otras deformidades adquiridas especificadas del sistema osteomuscular',
    code_2: 'M95',
    code_0: 'M00-M99',
    code_1: 'M95-M99'
  },
  {
    code: 'M959',
    level: 3,
    description:
      'Deformidad adquirida del sistema osteomuscular, no especificada',
    code_2: 'M95',
    code_0: 'M00-M99',
    code_1: 'M95-M99'
  },
  {
    code: 'L559',
    level: 3,
    description: 'Quemadura solar, no especificada',
    code_2: 'L55',
    code_0: 'L00-L99',
    code_1: 'L55-L59'
  },
  {
    code: 'L815',
    level: 3,
    description: 'Leucodermia, no clasificada en otra parte',
    code_2: 'L81',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L816',
    level: 3,
    description:
      'Otros trastornos de disminuci\u00f3n de la formaci\u00f3n de la melanina',
    code_2: 'L81',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L817',
    level: 3,
    description: 'Dermatosis purp\u00farica pigmentada',
    code_2: 'L81',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L818',
    level: 3,
    description: 'Otros trastornos especificados de la pigmentaci\u00f3n',
    code_2: 'L81',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'L819',
    level: 3,
    description: 'Trastorno de la pigmentaci\u00f3n, no especificado',
    code_2: 'L81',
    code_0: 'L00-L99',
    code_1: 'L80-L99'
  },
  {
    code: 'K713',
    level: 3,
    description:
      'Enfermedad t\u00f3xica del h\u00edgado con hepatitis cr\u00f3nica persistente',
    code_2: 'K71',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K714',
    level: 3,
    description:
      'Enfermedad t\u00f3xica del h\u00edgado con hepatitis cr\u00f3nica lobular',
    code_2: 'K71',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K715',
    level: 3,
    description:
      'Enfermedad t\u00f3xica del h\u00edgado con hepatitis cr\u00f3nica activa',
    code_2: 'K71',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K716',
    level: 3,
    description:
      'Enfermedad t\u00f3xica del h\u00edgado con hepatitis no clasificada en otra parte',
    code_2: 'K71',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K717',
    level: 3,
    description:
      'Enfermedad t\u00f3xica del h\u00edgado con cirrosis y fibrosis del h\u00edgado',
    code_2: 'K71',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K718',
    level: 3,
    description:
      'Enfermedad t\u00f3xica del h\u00edgado con otros trastornos hep\u00e1ticos',
    code_2: 'K71',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K719',
    level: 3,
    description: 'Enfermedad t\u00f3xica del h\u00edgado, no especificada',
    code_2: 'K71',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K703',
    level: 3,
    description: 'Cirrosis hep\u00e1tica alcoh\u00f3lica',
    code_2: 'K70',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K704',
    level: 3,
    description: 'Insuficiencia hep\u00e1tica alcoh\u00f3lica',
    code_2: 'K70',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K709',
    level: 3,
    description: 'Enfermedad hep\u00e1tica alcoh\u00f3lica, no especificada',
    code_2: 'K70',
    code_0: 'K00-K95',
    code_1: 'K70-K77'
  },
  {
    code: 'K823',
    level: 3,
    description: 'F\u00edstula de la ves\u00edcula biliar',
    code_2: 'K82',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'K824',
    level: 3,
    description: 'Colesterolosis de la ves\u00edcula biliar',
    code_2: 'K82',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'K828',
    level: 3,
    description: 'Otras enfermedades especificadas de la ves\u00edcula biliar',
    code_2: 'K82',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'K829',
    level: 3,
    description: 'Enfermedad de la ves\u00edcula biliar, no especificada',
    code_2: 'K82',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'K805',
    level: 3,
    description:
      'C\u00e1lculo de conducto biliar sin colangitis ni colecistitis',
    code_2: 'K80',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'K808',
    level: 3,
    description: 'Otras colelitiasis',
    code_2: 'K80',
    code_0: 'K00-K95',
    code_1: 'K80-K87'
  },
  {
    code: 'K914',
    level: 3,
    description: 'Disfunci\u00f3n de colostom\u00eda o enterostom\u00eda',
    code_2: 'K91',
    code_0: 'K00-K95',
    code_1: 'K90-K93'
  },
  {
    code: 'K915',
    level: 3,
    description: 'S\u00edndrome postcolecistectom\u00eda',
    code_2: 'K91',
    code_0: 'K00-K95',
    code_1: 'K90-K93'
  },
  {
    code: 'K918',
    level: 3,
    description:
      'Otros trastornos del sistema digestivo consecutivos a procedimientos, no clasificados en otra parte',
    code_2: 'K91',
    code_0: 'K00-K95',
    code_1: 'K90-K93'
  },
  {
    code: 'K919',
    level: 3,
    description:
      'Trastorno no especificado del sistema digestivo consecutivo a procedimientos',
    code_2: 'K91',
    code_0: 'K00-K95',
    code_1: 'K90-K93'
  },
  {
    code: 'K909',
    level: 3,
    description: 'Malabsorci\u00f3n intestinal, no especificada',
    code_2: 'K90',
    code_0: 'K00-K95',
    code_1: 'K90-K93'
  },
  {
    code: 'J988',
    level: 3,
    description: 'Otros trastornos respiratorios especificados',
    code_2: 'J98',
    code_0: 'J00-J99',
    code_1: 'J95-J99'
  },
  {
    code: 'J989',
    level: 3,
    description: 'Trastorno respiratorio, no especificado',
    code_2: 'J98',
    code_0: 'J00-J99',
    code_1: 'J95-J99'
  },
  {
    code: 'J958',
    level: 3,
    description: 'Otros trastornos respiratorios consecutivos a procedimientos',
    code_2: 'J95',
    code_0: 'J00-J99',
    code_1: 'J95-J99'
  },
  {
    code: 'J959',
    level: 3,
    description:
      'Trastorno no especificado del sistema respiratorio, consecutivo a procedimientos',
    code_2: 'J95',
    code_0: 'J00-J99',
    code_1: 'J95-J99'
  },
  {
    code: 'Z700',
    level: 3,
    description: 'Consulta relacionada con la actitud sexual',
    code_2: 'Z70',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z701',
    level: 3,
    description:
      'Consulta relacionada con la orientaci\u00f3n y conducta sexual del paciente',
    code_2: 'Z70',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z702',
    level: 3,
    description:
      'Consulta relacionada con la orientaci\u00f3n y conducta sexual de una tercera persona',
    code_2: 'Z70',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z703',
    level: 3,
    description:
      'Consulta relacionada con preocupaciones combinadas sobre la actitud, la conducta y la orientaci\u00f3n sexuales',
    code_2: 'Z70',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z708',
    level: 3,
    description: 'Otras consultas sexuales espec\u00edficas',
    code_2: 'Z70',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z709',
    level: 3,
    description: 'Consulta sexual, no especificada',
    code_2: 'Z70',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z840',
    level: 3,
    description:
      'Historia familiar de enfermedades de la piel y del tejido subcut\u00e1neo',
    code_2: 'Z84',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z841',
    level: 3,
    description:
      'Historia familiar de trastornos del ri\u00f1\u00f3n y del ur\u00e9ter',
    code_2: 'Z84',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z842',
    level: 3,
    description:
      'Historia familiar de otras enfermedades del sistema genitourinario',
    code_2: 'Z84',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z843',
    level: 3,
    description: 'Historia familiar de consanguinidad',
    code_2: 'Z84',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z848',
    level: 3,
    description: 'Historia familiar de otras afecciones especificadas',
    code_2: 'Z84',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z830',
    level: 3,
    description:
      'Historia familiar de infecci\u00f3n por el virus de la inmunodeficiencia humana [VIH]',
    code_2: 'Z83',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z831',
    level: 3,
    description:
      'Historia familiar de otras enfermedades infecciosas y parasitarias',
    code_2: 'Z83',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z832',
    level: 3,
    description:
      'Historia familiar de enfermedades de la sangre y de los \u00f3rganos hematopoy\u00e9ticos y de ciertos trastornos del mecanismo inmunol\u00f3gico',
    code_2: 'Z83',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z833',
    level: 3,
    description: 'Historia familiar de diabetes mellitus',
    code_2: 'Z83',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z834',
    level: 3,
    description:
      'Historia familiar de otras enfermedades endocrinas, nutricionales y metab\u00f3licas',
    code_2: 'Z83',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z835',
    level: 3,
    description:
      'Historia familiar de trastornos de los ojos y de los o\u00eddos',
    code_2: 'Z83',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z836',
    level: 3,
    description: 'Historia familiar de enfermedades del sistema respiratorio',
    code_2: 'Z83',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z837',
    level: 3,
    description: 'Historia familiar de enfermedades del sistema digestivo',
    code_2: 'Z83',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z820',
    level: 3,
    description:
      'Historia familiar de epilepsia y otras enfermedades del sistema nervioso',
    code_2: 'Z82',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z821',
    level: 3,
    description:
      'Historia familiar de ceguera o p\u00e9rdida de la visi\u00f3n',
    code_2: 'Z82',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z822',
    level: 3,
    description:
      'Historia familiar de sordera o p\u00e9rdida de la audici\u00f3n',
    code_2: 'Z82',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z823',
    level: 3,
    description: 'Historia familiar de apoplej\u00eda',
    code_2: 'Z82',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z824',
    level: 3,
    description:
      'Historia familiar de enfermedad isqu\u00e9mica del coraz\u00f3n y otras enfermedades del sistema circulatorio',
    code_2: 'Z82',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z825',
    level: 3,
    description:
      'Historia familiar de asma y de otras enfermedades cr\u00f3nicas de las v\u00edas respiratorias inferiores',
    code_2: 'Z82',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z826',
    level: 3,
    description:
      'Historia familiar de artritis y otras enfermedades del sistema osteomuscular y tejido conjuntivo',
    code_2: 'Z82',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z827',
    level: 3,
    description:
      'Historia familiar de malformaciones cong\u00e9nitas, deformidades y otras anomal\u00edas cromos\u00f3micas',
    code_2: 'Z82',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z828',
    level: 3,
    description:
      'Historia familiar de otras discapacidades y enfermedades cr\u00f3nicas incapacitantes no clasificadas en otra parte',
    code_2: 'Z82',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z810',
    level: 3,
    description: 'Historia familiar de retardo mental',
    code_2: 'Z81',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z811',
    level: 3,
    description: 'Historia familiar de abuso de alcohol',
    code_2: 'Z81',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z812',
    level: 3,
    description: 'Historia familiar de abuso del tabaco',
    code_2: 'Z81',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z813',
    level: 3,
    description: 'Historia familiar de abuso de otras sustancias psicoactivas',
    code_2: 'Z81',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z814',
    level: 3,
    description: 'Historia familiar de abuso de otras sustancias',
    code_2: 'Z81',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z818',
    level: 3,
    description:
      'Historia familiar de otros trastornos mentales y del comportamiento',
    code_2: 'Z81',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z800',
    level: 3,
    description:
      'Historia familiar de tumor maligno de \u00f3rganos digestivos',
    code_2: 'Z80',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z801',
    level: 3,
    description:
      'Historia familiar de tumor maligno de tr\u00e1quea, bronquios y pulm\u00f3n',
    code_2: 'Z80',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z802',
    level: 3,
    description:
      'Historia familiar de tumor maligno de otros \u00f3rganos respiratorios e intrator\u00e1cicos',
    code_2: 'Z80',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z803',
    level: 3,
    description: 'Historia familiar de tumor maligno de mama',
    code_2: 'Z80',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z804',
    level: 3,
    description: 'Historia familiar de tumor maligno de \u00f3rganos genitales',
    code_2: 'Z80',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z805',
    level: 3,
    description: 'Historia familiar de tumor maligno de v\u00edas urinarias',
    code_2: 'Z80',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z806',
    level: 3,
    description: 'Historia familiar de leucemia',
    code_2: 'Z80',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z807',
    level: 3,
    description:
      'Historia familiar de otros tumores malignos del tejido linfoide, hematopoy\u00e9tico y tejidos relacionados',
    code_2: 'Z80',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z808',
    level: 3,
    description:
      'Historia familiar de tumor maligno de otros \u00f3rganos o sistemas especificados',
    code_2: 'Z80',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'Z809',
    level: 3,
    description: 'Historia familiar de tumor maligno, de sitio no especificado',
    code_2: 'Z80',
    code_0: 'Z00-Z99',
    code_1: 'Z80-Z99'
  },
  {
    code: 'R200',
    level: 3,
    description: 'Anestesia de la piel',
    code_2: 'R20',
    code_0: 'R00-R99',
    code_1: 'R20-R23'
  },
  {
    code: 'R201',
    level: 3,
    description: 'Hipoestesia de la piel',
    code_2: 'R20',
    code_0: 'R00-R99',
    code_1: 'R20-R23'
  },
  {
    code: 'R202',
    level: 3,
    description: 'Parestesia de la piel',
    code_2: 'R20',
    code_0: 'R00-R99',
    code_1: 'R20-R23'
  },
  {
    code: 'R203',
    level: 3,
    description: 'Hiperestesia',
    code_2: 'R20',
    code_0: 'R00-R99',
    code_1: 'R20-R23'
  },
  {
    code: 'R208',
    level: 3,
    description:
      'Otras alteraciones de la sensibilidad cut\u00e1nea y las no especificadas',
    code_2: 'R20',
    code_0: 'R00-R99',
    code_1: 'R20-R23'
  },
  {
    code: 'R290',
    level: 3,
    description: 'Tetania',
    code_2: 'R29',
    code_0: 'R00-R99',
    code_1: 'R25-R29'
  },
  {
    code: 'R291',
    level: 3,
    description: 'Meningismo',
    code_2: 'R29',
    code_0: 'R00-R99',
    code_1: 'R25-R29'
  },
  {
    code: 'R292',
    level: 3,
    description: 'Reflejos anormales',
    code_2: 'R29',
    code_0: 'R00-R99',
    code_1: 'R25-R29'
  },
  {
    code: 'R293',
    level: 3,
    description: 'Postura anormal',
    code_2: 'R29',
    code_0: 'R00-R99',
    code_1: 'R25-R29'
  },
  {
    code: 'R294',
    level: 3,
    description: 'Chasquido de la cadera',
    code_2: 'R29',
    code_0: 'R00-R99',
    code_1: 'R25-R29'
  },
  {
    code: 'R270',
    level: 3,
    description: 'Ataxia, no especificada',
    code_2: 'R27',
    code_0: 'R00-R99',
    code_1: 'R25-R29'
  },
  {
    code: 'R278',
    level: 3,
    description: 'Otras fallas de la coordinaci\u00f3n y las no especificadas',
    code_2: 'R27',
    code_0: 'R00-R99',
    code_1: 'R25-R29'
  },
  {
    code: 'R260',
    level: 3,
    description: 'Marcha at\u00e1xica',
    code_2: 'R26',
    code_0: 'R00-R99',
    code_1: 'R25-R29'
  },
  {
    code: 'R261',
    level: 3,
    description: 'Marcha paral\u00edtica',
    code_2: 'R26',
    code_0: 'R00-R99',
    code_1: 'R25-R29'
  },
  {
    code: 'R262',
    level: 3,
    description: 'Dificultad para caminar, no clasificada en otra parte',
    code_2: 'R26',
    code_0: 'R00-R99',
    code_1: 'R25-R29'
  },
  {
    code: 'R268',
    level: 3,
    description:
      'Otras anormalidades de la marcha y de la movilidad y las no especificadas',
    code_2: 'R26',
    code_0: 'R00-R99',
    code_1: 'R25-R29'
  },
  {
    code: 'R250',
    level: 3,
    description: 'Movimientos anormales de la cabeza',
    code_2: 'R25',
    code_0: 'R00-R99',
    code_1: 'R25-R29'
  },
  {
    code: 'R251',
    level: 3,
    description: 'Temblor no especificado',
    code_2: 'R25',
    code_0: 'R00-R99',
    code_1: 'R25-R29'
  },
  {
    code: 'R252',
    level: 3,
    description: 'Calambres y espasmos',
    code_2: 'R25',
    code_0: 'R00-R99',
    code_1: 'R25-R29'
  },
  {
    code: 'R253',
    level: 3,
    description: 'Fasciculaci\u00f3n',
    code_2: 'R25',
    code_0: 'R00-R99',
    code_1: 'R25-R29'
  },
  {
    code: 'R258',
    level: 3,
    description:
      'Otros movimientos anormales involuntarios y los no especificados',
    code_2: 'R25',
    code_0: 'R00-R99',
    code_1: 'R25-R29'
  },
  {
    code: 'R300',
    level: 3,
    description: 'Disuria',
    code_2: 'R30',
    code_0: 'R00-R99',
    code_1: 'R30-R39'
  },
  {
    code: 'R301',
    level: 3,
    description: 'Tenesmo vesical',
    code_2: 'R30',
    code_0: 'R00-R99',
    code_1: 'R30-R39'
  },
  {
    code: 'R309',
    level: 3,
    description: 'Micci\u00f3n dolorosa, no especificada',
    code_2: 'R30',
    code_0: 'R00-R99',
    code_1: 'R30-R39'
  },
  {
    code: 'R410',
    level: 3,
    description: 'Desorientaci\u00f3n no especificada',
    code_2: 'R41',
    code_0: 'R00-R99',
    code_1: 'R40-R46'
  },
  {
    code: 'R411',
    level: 3,
    description: 'Amnesia anter\u00f3grada',
    code_2: 'R41',
    code_0: 'R00-R99',
    code_1: 'R40-R46'
  },
  {
    code: 'R412',
    level: 3,
    description: 'Amnesia retr\u00f3grada',
    code_2: 'R41',
    code_0: 'R00-R99',
    code_1: 'R40-R46'
  },
  {
    code: 'R413',
    level: 3,
    description: 'Otra amnesia',
    code_2: 'R41',
    code_0: 'R00-R99',
    code_1: 'R40-R46'
  },
  {
    code: 'R418',
    level: 3,
    description:
      'Otros s\u00edntomas y signos que involucran la funci\u00f3n cognoscitiva y la conciencia y los no especificados',
    code_2: 'R41',
    code_0: 'R00-R99',
    code_1: 'R40-R46'
  },
  {
    code: 'R400',
    level: 3,
    description: 'Somnolencia',
    code_2: 'R40',
    code_0: 'R00-R99',
    code_1: 'R40-R46'
  },
  {
    code: 'R401',
    level: 3,
    description: 'Estupor',
    code_2: 'R40',
    code_0: 'R00-R99',
    code_1: 'R40-R46'
  },
  {
    code: 'R402',
    level: 3,
    description: 'Coma, no especificado',
    code_2: 'R40',
    code_0: 'R00-R99',
    code_1: 'R40-R46'
  },
  {
    code: 'R490',
    level: 3,
    description: 'Disfon\u00eda',
    code_2: 'R49',
    code_0: 'R00-R99',
    code_1: 'R47-R49'
  },
  {
    code: 'R491',
    level: 3,
    description: 'Afon\u00eda',
    code_2: 'R49',
    code_0: 'R00-R99',
    code_1: 'R47-R49'
  },
  {
    code: 'R492',
    level: 3,
    description: 'Hipernasalidad e hiponasalidad',
    code_2: 'R49',
    code_0: 'R00-R99',
    code_1: 'R47-R49'
  },
  {
    code: 'R498',
    level: 3,
    description: 'Otras alteraciones de la voz y las no especificadas',
    code_2: 'R49',
    code_0: 'R00-R99',
    code_1: 'R47-R49'
  },
  {
    code: 'R480',
    level: 3,
    description: 'Dislexia y alexia',
    code_2: 'R48',
    code_0: 'R00-R99',
    code_1: 'R47-R49'
  },
  {
    code: 'R481',
    level: 3,
    description: 'Agnosia',
    code_2: 'R48',
    code_0: 'R00-R99',
    code_1: 'R47-R49'
  },
  {
    code: 'R482',
    level: 3,
    description: 'Apraxia',
    code_2: 'R48',
    code_0: 'R00-R99',
    code_1: 'R47-R49'
  },
  {
    code: 'R488',
    level: 3,
    description: 'Otras disfunciones simb\u00f3licas y las no especificadas',
    code_2: 'R48',
    code_0: 'R00-R99',
    code_1: 'R47-R49'
  },
  {
    code: 'R470',
    level: 3,
    description: 'Disfasia y afasia',
    code_2: 'R47',
    code_0: 'R00-R99',
    code_1: 'R47-R49'
  },
  {
    code: 'R471',
    level: 3,
    description: 'Disartria y anartria',
    code_2: 'R47',
    code_0: 'R00-R99',
    code_1: 'R47-R49'
  },
  {
    code: 'R478',
    level: 3,
    description: 'Otras alteraciones del habla y las no especificadas',
    code_2: 'R47',
    code_0: 'R00-R99',
    code_1: 'R47-R49'
  },
  {
    code: 'Q050',
    level: 3,
    description: 'Espina b\u00edfida cervical con hidroc\u00e9falo',
    code_2: 'Q05',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q051',
    level: 3,
    description: 'Espina b\u00edfida tor\u00e1cica con hidroc\u00e9falo',
    code_2: 'Q05',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q052',
    level: 3,
    description: 'Espina b\u00edfida lumbar con hidroc\u00e9falo',
    code_2: 'Q05',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q053',
    level: 3,
    description: 'Espina b\u00edfida sacra con hidroc\u00e9falo',
    code_2: 'Q05',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q054',
    level: 3,
    description:
      'Espina b\u00edfida con hidroc\u00e9falo, sin otra especificaci\u00f3n',
    code_2: 'Q05',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q055',
    level: 3,
    description: 'Espina b\u00edfida cervical sin hidroc\u00e9falo',
    code_2: 'Q05',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q056',
    level: 3,
    description: 'Espina b\u00edfida tor\u00e1cica sin hidroc\u00e9falo',
    code_2: 'Q05',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q057',
    level: 3,
    description: 'Espina b\u00edfida lumbar sin hidroc\u00e9falo',
    code_2: 'Q05',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q058',
    level: 3,
    description: 'Espina b\u00edfida sacra sin hidroc\u00e9falo',
    code_2: 'Q05',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q059',
    level: 3,
    description: 'Espina b\u00edfida, no especificada',
    code_2: 'Q05',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q040',
    level: 3,
    description: 'Malformaciones cong\u00e9nitas del cuerpo calloso',
    code_2: 'Q04',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q041',
    level: 3,
    description: 'Arrinencefalia',
    code_2: 'Q04',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q042',
    level: 3,
    description: 'Holoprosencefalia',
    code_2: 'Q04',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q043',
    level: 3,
    description: 'Otras anomal\u00edas hipopl\u00e1sicas del enc\u00e9falo',
    code_2: 'Q04',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q030',
    level: 3,
    description: 'Malformaciones del acueducto de Silvio',
    code_2: 'Q03',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q031',
    level: 3,
    description: 'Atresia de los agujeros de Magendie y de Luschka',
    code_2: 'Q03',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q038',
    level: 3,
    description: 'Otros hidroc\u00e9falos cong\u00e9nitos',
    code_2: 'Q03',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q039',
    level: 3,
    description: 'Hidroc\u00e9falo cong\u00e9nito, no especificado',
    code_2: 'Q03',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q010',
    level: 3,
    description: 'Encefalocele frontal',
    code_2: 'Q01',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q011',
    level: 3,
    description: 'Encefalocele nasofrontal',
    code_2: 'Q01',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q012',
    level: 3,
    description: 'Encefalocele occipital',
    code_2: 'Q01',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q018',
    level: 3,
    description: 'Encefalocele de otros sitios',
    code_2: 'Q01',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q019',
    level: 3,
    description: 'Encefalocele, no especificado',
    code_2: 'Q01',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q000',
    level: 3,
    description: 'Anencefalia',
    code_2: 'Q00',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q001',
    level: 3,
    description: 'Craneorraquisquisis',
    code_2: 'Q00',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q002',
    level: 3,
    description: 'Iniencefalia',
    code_2: 'Q00',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q120',
    level: 3,
    description: 'Catarata cong\u00e9nita',
    code_2: 'Q12',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q121',
    level: 3,
    description: 'Desplazamiento cong\u00e9nito del cristalino',
    code_2: 'Q12',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q122',
    level: 3,
    description: 'Coloboma del cristalino',
    code_2: 'Q12',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q123',
    level: 3,
    description: 'Afaquia cong\u00e9nita',
    code_2: 'Q12',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q124',
    level: 3,
    description: 'Esferofaquia',
    code_2: 'Q12',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q128',
    level: 3,
    description: 'Otras malformaciones cong\u00e9nitas del cristalino',
    code_2: 'Q12',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q129',
    level: 3,
    description:
      'Malformaci\u00f3n cong\u00e9nita del cristalino, no especificada',
    code_2: 'Q12',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q110',
    level: 3,
    description: 'Globo ocular qu\u00edstico',
    code_2: 'Q11',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q111',
    level: 3,
    description: 'Otras anoftalm\u00edas',
    code_2: 'Q11',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q112',
    level: 3,
    description: 'Microftalm\u00eda',
    code_2: 'Q11',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q113',
    level: 3,
    description: 'Macroftalm\u00eda',
    code_2: 'Q11',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'I728',
    level: 3,
    description: 'Aneurisma de otras arterias especificadas',
    code_2: 'I72',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'I729',
    level: 3,
    description: 'Aneurisma de sitio no especificado',
    code_2: 'I72',
    code_0: 'I00-I99',
    code_1: 'I70-I79'
  },
  {
    code: 'Q100',
    level: 3,
    description: 'Blefaroptosis cong\u00e9nita',
    code_2: 'Q10',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q101',
    level: 3,
    description: 'Ectropi\u00f3n cong\u00e9nito',
    code_2: 'Q10',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q102',
    level: 3,
    description: 'Entropi\u00f3n cong\u00e9nito',
    code_2: 'Q10',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q103',
    level: 3,
    description: 'Otras malformaciones cong\u00e9nitas de los p\u00e1rpados',
    code_2: 'Q10',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q104',
    level: 3,
    description: 'Ausencia y agenesia del aparato lagrimal',
    code_2: 'Q10',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q105',
    level: 3,
    description: 'Estenosis y estrechez cong\u00e9nitas del conducto lagrimal',
    code_2: 'Q10',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q106',
    level: 3,
    description: 'Otras malformaciones cong\u00e9nitas del aparato lagrimal',
    code_2: 'Q10',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q107',
    level: 3,
    description: 'Malformaci\u00f3n cong\u00e9nita de la \u00f3rbita',
    code_2: 'Q10',
    code_0: 'Q00-Q99',
    code_1: 'Q10-Q18'
  },
  {
    code: 'Q250',
    level: 3,
    description: 'Conducto arterioso permeable',
    code_2: 'Q25',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q251',
    level: 3,
    description: 'Coartaci\u00f3n de la aorta',
    code_2: 'Q25',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q252',
    level: 3,
    description: 'Atresia de la aorta',
    code_2: 'Q25',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q253',
    level: 3,
    description: 'Estenosis de la aorta',
    code_2: 'Q25',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q254',
    level: 3,
    description: 'Otras malformaciones cong\u00e9nitas de la aorta',
    code_2: 'Q25',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q255',
    level: 3,
    description: 'Atresia de la arteria pulmonar',
    code_2: 'Q25',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q256',
    level: 3,
    description: 'Estenosis de la arteria pulmonar',
    code_2: 'Q25',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q257',
    level: 3,
    description: 'Otras malformaciones cong\u00e9nitas de la arteria pulmonar',
    code_2: 'Q25',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q258',
    level: 3,
    description: 'Otras malformaciones cong\u00e9nitas de las grandes arterias',
    code_2: 'Q25',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q259',
    level: 3,
    description:
      'Malformaci\u00f3n cong\u00e9nita de las grandes arterias, no especificada',
    code_2: 'Q25',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q240',
    level: 3,
    description: 'Dextrocardia',
    code_2: 'Q24',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q241',
    level: 3,
    description: 'Levocardia',
    code_2: 'Q24',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q242',
    level: 3,
    description: 'Coraz\u00f3n triauricular',
    code_2: 'Q24',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q243',
    level: 3,
    description: 'Estenosis del infund\u00edbulo pulmonar',
    code_2: 'Q24',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q244',
    level: 3,
    description: 'Estenosis suba\u00f3rtica cong\u00e9nita',
    code_2: 'Q24',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q245',
    level: 3,
    description: 'Malformaci\u00f3n de los vasos coronarios',
    code_2: 'Q24',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q246',
    level: 3,
    description: 'Bloqueo card\u00edaco cong\u00e9nito',
    code_2: 'Q24',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q248',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas del coraz\u00f3n, especificadas',
    code_2: 'Q24',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q249',
    level: 3,
    description:
      'Malformaci\u00f3n cong\u00e9nita del coraz\u00f3n, no especificada',
    code_2: 'Q24',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q230',
    level: 3,
    description: 'Estenosis cong\u00e9nita de la v\u00e1lvula a\u00f3rtica',
    code_2: 'Q23',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q231',
    level: 3,
    description: 'Insuficiencia cong\u00e9nita de la v\u00e1lvula a\u00f3rtica',
    code_2: 'Q23',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q232',
    level: 3,
    description: 'Estenosis mitral cong\u00e9nita',
    code_2: 'Q23',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q233',
    level: 3,
    description: 'Insuficiencia mitral cong\u00e9nita',
    code_2: 'Q23',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q234',
    level: 3,
    description: 'S\u00edndrome de hipoplasia del coraz\u00f3n izquierdo',
    code_2: 'Q23',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q238',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas de las v\u00e1lvulas a\u00f3rtica y mitral',
    code_2: 'Q23',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q239',
    level: 3,
    description:
      'Malformaci\u00f3n cong\u00e9nita de las v\u00e1lvulas a\u00f3rtica y mitral, no especificada',
    code_2: 'Q23',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q220',
    level: 3,
    description: 'Atresia de la v\u00e1lvula pulmonar',
    code_2: 'Q22',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q221',
    level: 3,
    description: 'Estenosis cong\u00e9nita de la v\u00e1lvula pulmonar',
    code_2: 'Q22',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q222',
    level: 3,
    description: 'Insuficiencia cong\u00e9nita de la v\u00e1lvula pulmonar',
    code_2: 'Q22',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q223',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas de la v\u00e1lvula pulmonar',
    code_2: 'Q22',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q224',
    level: 3,
    description: 'Estenosis cong\u00e9nita de la v\u00e1lvula tric\u00faspide',
    code_2: 'Q22',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q225',
    level: 3,
    description: 'Anomal\u00eda de Ebstein',
    code_2: 'Q22',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q226',
    level: 3,
    description: 'S\u00edndrome de hipoplasia del coraz\u00f3n derecho',
    code_2: 'Q22',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q228',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas de la v\u00e1lvula tric\u00faspide',
    code_2: 'Q22',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q229',
    level: 3,
    description:
      'Malformaci\u00f3n cong\u00e9nita de la v\u00e1lvula tric\u00faspide, no especificada',
    code_2: 'Q22',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q210',
    level: 3,
    description: 'Defecto del tabique ventricular',
    code_2: 'Q21',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q211',
    level: 3,
    description: 'Defecto del tabique auricular',
    code_2: 'Q21',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q212',
    level: 3,
    description: 'Defecto del tabique auriculoventricular',
    code_2: 'Q21',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q213',
    level: 3,
    description: 'Tetralog\u00eda de Fallot',
    code_2: 'Q21',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q214',
    level: 3,
    description: 'Defecto del tabique aortopulmonar',
    code_2: 'Q21',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q218',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas de los tabiques card\u00edacos',
    code_2: 'Q21',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q200',
    level: 3,
    description: 'Tronco arterioso com\u00fan',
    code_2: 'Q20',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q201',
    level: 3,
    description:
      'Transposici\u00f3n de los grandes vasos en ventr\u00edculo derecho',
    code_2: 'Q20',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q202',
    level: 3,
    description:
      'Transposici\u00f3n de los grandes vasos en ventr\u00edculo izquierdo',
    code_2: 'Q20',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q203',
    level: 3,
    description: 'Discordancia de la conexi\u00f3n ventriculoarterial',
    code_2: 'Q20',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q204',
    level: 3,
    description: 'Ventr\u00edculo con doble entrada',
    code_2: 'Q20',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q205',
    level: 3,
    description: 'Discordancia de la conexi\u00f3n auriculoventricular',
    code_2: 'Q20',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q206',
    level: 3,
    description: 'Isomerismo de los ap\u00e9ndices auriculares',
    code_2: 'Q20',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q208',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas de las c\u00e1maras card\u00edacas y sus conexiones',
    code_2: 'Q20',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'Q209',
    level: 3,
    description:
      'Malformaci\u00f3n cong\u00e9nita de las c\u00e1maras card\u00edacas y sus conexiones, no especificada',
    code_2: 'Q20',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'G470',
    level: 3,
    description:
      'Trastornos del inicio y del mantenimiento del sue\u00f1o [insomnios]',
    code_2: 'G47',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G471',
    level: 3,
    description: 'Trastornos de somnolencia excesiva [hipersomnios]',
    code_2: 'G47',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G472',
    level: 3,
    description: 'Trastornos del ritmo nictameral',
    code_2: 'G47',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G473',
    level: 3,
    description: 'Apnea del sue\u00f1o',
    code_2: 'G47',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G474',
    level: 3,
    description: 'Narcolepsia y cataplexia',
    code_2: 'G47',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G478',
    level: 3,
    description: 'Otros trastornos del sue\u00f1o',
    code_2: 'G47',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G479',
    level: 3,
    description: 'Trastorno del sue\u00f1o, no especificado',
    code_2: 'G47',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G460',
    level: 3,
    description: 'S\u00edndrome de la arteria cerebral media (I66.0)',
    code_2: 'G46',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G461',
    level: 3,
    description: 'S\u00edndrome de la arteria cerebral anterior (I66.1)',
    code_2: 'G46',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G462',
    level: 3,
    description: 'S\u00edndrome de la arteria cerebral posterior (I66.2)',
    code_2: 'G46',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G463',
    level: 3,
    description:
      'S\u00edndromes apopl\u00e9ticos del tallo encef\u00e1lico (I60\u2013I67)',
    code_2: 'G46',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G464',
    level: 3,
    description: 'S\u00edndrome de infarto cerebeloso (I60\u2013I67)',
    code_2: 'G46',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G465',
    level: 3,
    description: 'S\u00edndrome lacunar motor puro (I60\u2013I67)',
    code_2: 'G46',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G466',
    level: 3,
    description: 'S\u00edndrome lacunar sensorial puro (I60\u2013I67)',
    code_2: 'G46',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G467',
    level: 3,
    description: 'Otros s\u00edndromes lacunares (I60\u2013I67)',
    code_2: 'G46',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G468',
    level: 3,
    description:
      'Otros s\u00edndromes vasculares encef\u00e1licos en enfermedades cerebrovasculares (I60\u2013I67)',
    code_2: 'G46',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G450',
    level: 3,
    description: 'S\u00edndrome arterial v\u00e9rtebro-basilar',
    code_2: 'G45',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G451',
    level: 3,
    description: 'S\u00edndrome de la arteria car\u00f3tida (hemisf\u00e9rico)',
    code_2: 'G45',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G452',
    level: 3,
    description:
      'S\u00edndromes arteriales precerebrales bilaterales y m\u00faltiples',
    code_2: 'G45',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G453',
    level: 3,
    description: 'Amaurosis fugaz',
    code_2: 'G45',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G454',
    level: 3,
    description: 'Amnesia global transitoria',
    code_2: 'G45',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G458',
    level: 3,
    description:
      'Otras isquemias cerebrales transitorias y s\u00edndromes afines',
    code_2: 'G45',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G459',
    level: 3,
    description: 'Isquemia cerebral transitoria, sin otra especificaci\u00f3n',
    code_2: 'G45',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G440',
    level: 3,
    description: 'S\u00edndrome de cefalea en racimos',
    code_2: 'G44',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G441',
    level: 3,
    description: 'Cefalea vascular, NCOP',
    code_2: 'G44',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G442',
    level: 3,
    description: 'Cefalea debida a tensi\u00f3n',
    code_2: 'G44',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G443',
    level: 3,
    description: 'Cefalea postraum\u00e1tica cr\u00f3nica',
    code_2: 'G44',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G444',
    level: 3,
    description: 'Cefalea inducida por drogas, no clasificada en otra parte',
    code_2: 'G44',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G448',
    level: 3,
    description: 'Otros s\u00edndromes de cefalea especificados',
    code_2: 'G44',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G430',
    level: 3,
    description: 'Migra\u00f1a sin aura [migra\u00f1a com\u00fan]',
    code_2: 'G43',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G431',
    level: 3,
    description: 'Migra\u00f1a con aura [migra\u00f1a cl\u00e1sica]',
    code_2: 'G43',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G432',
    level: 3,
    description: 'Estado migra\u00f1oso',
    code_2: 'G43',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G433',
    level: 3,
    description: 'Migra\u00f1a complicada',
    code_2: 'G43',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G438',
    level: 3,
    description: 'Otras migra\u00f1as',
    code_2: 'G43',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G439',
    level: 3,
    description: 'Migra\u00f1a, no especificada',
    code_2: 'G43',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'E550',
    level: 3,
    description: 'Raquitismo activo',
    code_2: 'E55',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E559',
    level: 3,
    description: 'Deficiencia de vitamina D, no especificada',
    code_2: 'E55',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E530',
    level: 3,
    description: 'Deficiencia de riboflavina',
    code_2: 'E53',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E531',
    level: 3,
    description: 'Deficiencia de piridoxina',
    code_2: 'E53',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E538',
    level: 3,
    description: 'Deficiencia de otras vitaminas del grupo B',
    code_2: 'E53',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E539',
    level: 3,
    description: 'Deficiencia de vitamina B, no especificada',
    code_2: 'E53',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E511',
    level: 3,
    description: 'Beriberi',
    code_2: 'E51',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E512',
    level: 3,
    description: 'Encefalopat\u00eda de Wernicke',
    code_2: 'E51',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E518',
    level: 3,
    description: 'Otras manifestaciones de la deficiencia de tiamina',
    code_2: 'E51',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E519',
    level: 3,
    description: 'Deficiencia de tiamina, no especificada',
    code_2: 'E51',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E500',
    level: 3,
    description: 'Deficiencia de vitamina A con xerosis conjuntival',
    code_2: 'E50',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E501',
    level: 3,
    description:
      'Deficiencia de vitamina A con mancha de Bitot y xerosis conjuntival',
    code_2: 'E50',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E502',
    level: 3,
    description: 'Deficiencia de vitamina A con xerosis corneal',
    code_2: 'E50',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E503',
    level: 3,
    description:
      'Deficiencia de vitamina A con ulceraci\u00f3n corneal y xerosis',
    code_2: 'E50',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E504',
    level: 3,
    description: 'Deficiencia de vitamina A con queratomalacia',
    code_2: 'E50',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E505',
    level: 3,
    description: 'Deficiencia de vitamina A con ceguera nocturna',
    code_2: 'E50',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E506',
    level: 3,
    description:
      'Deficiencia de vitamina A con cicatrices xeroft\u00e1lmicas de la c\u00f3rnea',
    code_2: 'E50',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E507',
    level: 3,
    description: 'Otras manifestaciones oculares de deficiencia de vitamina A',
    code_2: 'E50',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E508',
    level: 3,
    description: 'Otras manifestaciones de deficiencia de vitamina A',
    code_2: 'E50',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E509',
    level: 3,
    description: 'Deficiencia de vitamina A, no especificada',
    code_2: 'E50',
    code_0: 'E00-E89',
    code_1: 'E50-E64'
  },
  {
    code: 'E670',
    level: 3,
    description: 'Hipervitaminosis A',
    code_2: 'E67',
    code_0: 'E00-E89',
    code_1: 'E65-E68'
  },
  {
    code: 'E671',
    level: 3,
    description: 'Hipercarotinemia',
    code_2: 'E67',
    code_0: 'E00-E89',
    code_1: 'E65-E68'
  },
  {
    code: 'E672',
    level: 3,
    description: 'S\u00edndrome de megavitamina B6',
    code_2: 'E67',
    code_0: 'E00-E89',
    code_1: 'E65-E68'
  },
  {
    code: 'E673',
    level: 3,
    description: 'Hipervitaminosis D',
    code_2: 'E67',
    code_0: 'E00-E89',
    code_1: 'E65-E68'
  },
  {
    code: 'E678',
    level: 3,
    description: 'Otros tipos de hiperalimentaci\u00f3n especificados',
    code_2: 'E67',
    code_0: 'E00-E89',
    code_1: 'E65-E68'
  },
  {
    code: 'T139',
    level: 3,
    description:
      'Traumatismo no especificado de miembro inferior, nivel no especificado',
    code_2: 'T13',
    code_0: 'S00-T88',
    code_1: 'T08-T14'
  },
  {
    code: 'T31',
    level: 3,
    description:
      'Quemaduras clasificadas seg\u00fan la extensi\u00f3n de la superficie del cuerpo afectada',
    code_2: 'T29-T32',
    code_0: 'S00-T88',
    code_1: 'T20-T32'
  },
  {
    code: 'T32',
    level: 3,
    description:
      'Corrosiones clasificadas seg\u00fan la extensi\u00f3n de la superficie del cuerpo afectada',
    code_2: 'T29-T32',
    code_0: 'S00-T88',
    code_1: 'T20-T32'
  },
  {
    code: 'T24',
    level: 3,
    description:
      'Quemadura y corrosi\u00f3n de la cadera y miembro inferior, excepto tobillo y pie',
    code_2: 'T20-T25',
    code_0: 'S00-T88',
    code_1: 'T20-T32'
  },
  {
    code: 'T25',
    level: 3,
    description: 'Quemadura y corrosi\u00f3n del tobillo y del pie',
    code_2: 'T20-T25',
    code_0: 'S00-T88',
    code_1: 'T20-T32'
  },
  {
    code: 'T335',
    level: 3,
    description: 'Congelamiento superficial de la mu\u00f1eca y de la mano',
    code_2: 'T33',
    code_0: 'S00-T88',
    code_1: 'T33-T35'
  },
  {
    code: 'T336',
    level: 3,
    description: 'Congelamiento superficial de la cadera y del muslo',
    code_2: 'T33',
    code_0: 'S00-T88',
    code_1: 'T33-T35'
  },
  {
    code: 'T337',
    level: 3,
    description: 'Congelamiento superficial de la rodilla y de la pierna',
    code_2: 'T33',
    code_0: 'S00-T88',
    code_1: 'T33-T35'
  },
  {
    code: 'T338',
    level: 3,
    description: 'Congelamiento superficial del tobillo y del pie',
    code_2: 'T33',
    code_0: 'S00-T88',
    code_1: 'T33-T35'
  },
  {
    code: 'T339',
    level: 3,
    description:
      'Congelamiento superficial de otros sitios y de los no especificados',
    code_2: 'T33',
    code_0: 'S00-T88',
    code_1: 'T33-T35'
  },
  {
    code: 'T385',
    level: 3,
    description: 'Otros estr\u00f3genos y progest\u00f3genos',
    code_2: 'T38',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T386',
    level: 3,
    description:
      'Antigonadotrofinas, antiestr\u00f3genos y antiandr\u00f3genos, no clasificados en otra parte',
    code_2: 'T38',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T387',
    level: 3,
    description: 'Andr\u00f3genos y sus cong\u00e9neres anab\u00f3licos',
    code_2: 'T38',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T388',
    level: 3,
    description:
      'Otras hormonas y sustitutos sint\u00e9ticos y los no especificados',
    code_2: 'T38',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T389',
    level: 3,
    description: 'Otros antagonistas de las hormonas y los no especificados',
    code_2: 'T38',
    code_0: 'S00-T88',
    code_1: 'T36-T50'
  },
  {
    code: 'T676',
    level: 3,
    description: 'Fatiga por calor, transitoria',
    code_2: 'T67',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T677',
    level: 3,
    description: 'Edema por calor',
    code_2: 'T67',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T678',
    level: 3,
    description: 'Otros efectos del calor y de la luz',
    code_2: 'T67',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'T679',
    level: 3,
    description: 'Efecto del calor y de la luz, no especificado',
    code_2: 'T67',
    code_0: 'S00-T88',
    code_1: 'T66-T78'
  },
  {
    code: 'Z413',
    level: 3,
    description: 'Perforaci\u00f3n de la oreja',
    code_2: 'Z41',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z418',
    level: 3,
    description:
      'Otros procedimientos para otros prop\u00f3sitos que no sean los de mejorar el estado de salud',
    code_2: 'Z41',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z419',
    level: 3,
    description:
      'Procedimiento no especificado para otros prop\u00f3sitos que no sean los de mejorar el estado de salud',
    code_2: 'Z41',
    code_0: 'Z00-Z99',
    code_1: 'Z40-Z54'
  },
  {
    code: 'Z604',
    level: 3,
    description: 'Problemas relacionados con exclusi\u00f3n y rechazo social',
    code_2: 'Z60',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z605',
    level: 3,
    description:
      'Problemas relacionados con la discriminaci\u00f3n y persecuci\u00f3n percibidas',
    code_2: 'Z60',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z608',
    level: 3,
    description: 'Otros problemas relacionados con el ambiente social',
    code_2: 'Z60',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z609',
    level: 3,
    description: 'Problema no especificado relacionado con el ambiente social',
    code_2: 'Z60',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z594',
    level: 3,
    description: 'Problemas relacionados con la falta de alimentos adecuados',
    code_2: 'Z59',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z595',
    level: 3,
    description: 'Problemas relacionados con pobreza extrema',
    code_2: 'Z59',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z596',
    level: 3,
    description: 'Problemas relacionados con bajos ingresos',
    code_2: 'Z59',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z597',
    level: 3,
    description:
      'Problemas relacionados con seguridad social y sostenimiento insuficientes para el bienestar',
    code_2: 'Z59',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z598',
    level: 3,
    description:
      'Otros problemas relacionados con la vivienda y las circunstancias econ\u00f3micas',
    code_2: 'Z59',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z599',
    level: 3,
    description:
      'Problemas no especificados relacionados con la vivienda y las circunstancias econ\u00f3micas',
    code_2: 'Z59',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z582',
    level: 3,
    description: 'Exposici\u00f3n al agua contaminada',
    code_2: 'Z58',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z583',
    level: 3,
    description: 'Exposici\u00f3n al suelo contaminado',
    code_2: 'Z58',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z584',
    level: 3,
    description: 'Exposici\u00f3n a la radiaci\u00f3n',
    code_2: 'Z58',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z585',
    level: 3,
    description:
      'Exposici\u00f3n a otras contaminaciones del ambiente f\u00edsico',
    code_2: 'Z58',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z586',
    level: 3,
    description: 'Suministro inadecuado de agua potable',
    code_2: 'Z58',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z587',
    level: 3,
    description: 'Exposici\u00f3n al humo del tabaco',
    code_2: 'Z58',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z588',
    level: 3,
    description: 'Otros problemas relacionados con el ambiente f\u00edsico',
    code_2: 'Z58',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z589',
    level: 3,
    description:
      'Problema no especificado relacionado con el ambiente f\u00edsico',
    code_2: 'Z58',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z575',
    level: 3,
    description:
      'Exposici\u00f3n ocupacional a agentes t\u00f3xicos en otras industrias',
    code_2: 'Z57',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z576',
    level: 3,
    description: 'Exposici\u00f3n ocupacional a temperatura extrema',
    code_2: 'Z57',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z577',
    level: 3,
    description: 'Exposici\u00f3n ocupacional a la vibraci\u00f3n',
    code_2: 'Z57',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z578',
    level: 3,
    description: 'Exposici\u00f3n ocupacional a otros factores de riesgo',
    code_2: 'Z57',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z579',
    level: 3,
    description:
      'Exposici\u00f3n ocupacional a factor de riesgo no especificado',
    code_2: 'Z57',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z565',
    level: 3,
    description: 'Problemas relacionados con el trabajo incompatible',
    code_2: 'Z56',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z566',
    level: 3,
    description:
      'Otros problemas de tensi\u00f3n f\u00edsica o mental relacionadas con el trabajo',
    code_2: 'Z56',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z567',
    level: 3,
    description:
      'Otros problemas y los no especificados relacionados con el empleo',
    code_2: 'Z56',
    code_0: 'Z00-Z99',
    code_1: 'Z55-Z65'
  },
  {
    code: 'Z768',
    level: 3,
    description:
      'Persona en contacto con los servicios de salud en otras circunstancias especificadas',
    code_2: 'Z76',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z769',
    level: 3,
    description:
      'Personas en contacto con los servicios de salud en circunstancias no especificadas',
    code_2: 'Z76',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z734',
    level: 3,
    description:
      'Problemas relacionados con habilidades sociales inadecuadas, no clasificados en otra parte',
    code_2: 'Z73',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z735',
    level: 3,
    description:
      'Problemas relacionados con el conflicto del rol social, no clasificados en otra parte',
    code_2: 'Z73',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z736',
    level: 3,
    description:
      'Problemas relacionados con la limitaci\u00f3n de las actividades debido a discapacidad',
    code_2: 'Z73',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z738',
    level: 3,
    description:
      'Otros problemas relacionados con dificultades con el modo de vida',
    code_2: 'Z73',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z739',
    level: 3,
    description:
      'Problemas no especificados relacionados con dificultades con el modo de vida',
    code_2: 'Z73',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z728',
    level: 3,
    description: 'Otros problemas relacionados con el estilo de vida',
    code_2: 'Z72',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z729',
    level: 3,
    description: 'Problema no especificado relacionado con el estilo de vida',
    code_2: 'Z72',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z717',
    level: 3,
    description:
      'Consulta para asesor\u00eda sobre el virus de la inmunodeficiencia humana [VIH]',
    code_2: 'Z71',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z718',
    level: 3,
    description: 'Otras consultas especificadas',
    code_2: 'Z71',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'Z719',
    level: 3,
    description: 'Consulta, no especificada',
    code_2: 'Z71',
    code_0: 'Z00-Z99',
    code_1: 'Z70-Z76'
  },
  {
    code: 'E660',
    level: 3,
    description: 'Obesidad debida a exceso de calor\u00edas',
    code_2: 'E66',
    code_0: 'E00-E89',
    code_1: 'E65-E68'
  },
  {
    code: 'E661',
    level: 3,
    description: 'Obesidad inducida por drogas',
    code_2: 'E66',
    code_0: 'E00-E89',
    code_1: 'E65-E68'
  },
  {
    code: 'E662',
    level: 3,
    description: 'Obesidad extrema con hipoventilaci\u00f3n alveolar',
    code_2: 'E66',
    code_0: 'E00-E89',
    code_1: 'E65-E68'
  },
  {
    code: 'E668',
    level: 3,
    description: 'Otros tipos de obesidad',
    code_2: 'E66',
    code_0: 'E00-E89',
    code_1: 'E65-E68'
  },
  {
    code: 'E669',
    level: 3,
    description: 'Obesidad, no especificada',
    code_2: 'E66',
    code_0: 'E00-E89',
    code_1: 'E65-E68'
  },
  {
    code: 'E710',
    level: 3,
    description: 'Enfermedad de la orina en jarabe de arce',
    code_2: 'E71',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E711',
    level: 3,
    description:
      'Otros trastornos del metabolismo de los amino\u00e1cidos de cadena ramificada',
    code_2: 'E71',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E712',
    level: 3,
    description:
      'Otros trastornos del metabolismo de los amino\u00e1cidos de cadena ramificada, no especificados',
    code_2: 'E71',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E713',
    level: 3,
    description: 'Trastornos del metabolismo de los \u00e1cidos grasos',
    code_2: 'E71',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E700',
    level: 3,
    description: 'Fenilcetonuria cl\u00e1sica',
    code_2: 'E70',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E701',
    level: 3,
    description: 'Otras hiperfenilalaninemias',
    code_2: 'E70',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E702',
    level: 3,
    description: 'Trastornos del metabolismo de la tirosina',
    code_2: 'E70',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'G590',
    level: 3,
    description:
      'Mononeuropat\u00eda diab\u00e9tica (E10\u2013E14 con cuarto car\u00e1cter com\u00fan .4)',
    code_2: 'G59',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G598',
    level: 3,
    description:
      'Otras mononeuropat\u00edas en enfermedades clasificadas en otra parte',
    code_2: 'G59',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G580',
    level: 3,
    description: 'Neuropat\u00eda intercostal',
    code_2: 'G58',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G587',
    level: 3,
    description: 'Mononeuritis m\u00faltiple',
    code_2: 'G58',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G588',
    level: 3,
    description: 'Otras mononeuropat\u00edas especificadas',
    code_2: 'G58',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G589',
    level: 3,
    description: 'Mononeuropat\u00eda, no especificada',
    code_2: 'G58',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G570',
    level: 3,
    description: 'Lesi\u00f3n del nervio ci\u00e1tico',
    code_2: 'G57',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G571',
    level: 3,
    description: 'Meralgia parest\u00e9sica',
    code_2: 'G57',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G572',
    level: 3,
    description: 'Lesi\u00f3n del nervio crural',
    code_2: 'G57',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G573',
    level: 3,
    description: 'Lesi\u00f3n del nervio ci\u00e1tico popl\u00edteo externo',
    code_2: 'G57',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G560',
    level: 3,
    description: 'S\u00edndrome del t\u00fanel carpiano',
    code_2: 'G56',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G561',
    level: 3,
    description: 'Otras lesiones del nervio mediano',
    code_2: 'G56',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G550',
    level: 3,
    description:
      'Compresiones de las ra\u00edces y plexos nerviosos en enfermedades neopl\u00e1sicas (C00\u2013D48)',
    code_2: 'G55',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G551',
    level: 3,
    description:
      'Compresiones de las ra\u00edces y plexos nerviosos en trastornos de los discos intervertebrales (M50\u2013M51)',
    code_2: 'G55',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G552',
    level: 3,
    description:
      'Compresiones de las ra\u00edces y plexos nerviosos en la espondilosis (M47.\u2013)',
    code_2: 'G55',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G553',
    level: 3,
    description:
      'Compresiones de las ra\u00edces y plexos nerviosos en otras dorsopat\u00edas (M45\u2013M46, M48.\u2013, M53\u2013M54)',
    code_2: 'G55',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G558',
    level: 3,
    description:
      'Compresiones de las ra\u00edces y plexos nerviosos en otras enfermedades clasificadas en otra parte',
    code_2: 'G55',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G540',
    level: 3,
    description: 'Trastornos del plexo braquial',
    code_2: 'G54',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G541',
    level: 3,
    description: 'Trastornos del plexo lumbosacro',
    code_2: 'G54',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G542',
    level: 3,
    description:
      'Trastornos de la ra\u00edz cervical, no clasificados en otra parte',
    code_2: 'G54',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G543',
    level: 3,
    description:
      'Trastornos de la ra\u00edz tor\u00e1cica, no clasificados en otra parte',
    code_2: 'G54',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G544',
    level: 3,
    description:
      'Trastornos de la ra\u00edz lumbosacra, no clasificados en otra parte',
    code_2: 'G54',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G545',
    level: 3,
    description: 'Amiotrofia neur\u00e1lgica',
    code_2: 'G54',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G530',
    level: 3,
    description: 'Neuralgia postherpes zoster (B02.2)',
    code_2: 'G53',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G531',
    level: 3,
    description:
      'Par\u00e1lisis m\u00faltiple de los nervios craneales en enfermedades infecciosas y parasitarias clasificadas en otra parte (A00\u2013B99)',
    code_2: 'G53',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G532',
    level: 3,
    description:
      'Par\u00e1lisis m\u00faltiple de los nervios craneales, en la sarcoidosis (D86.8)',
    code_2: 'G53',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G533',
    level: 3,
    description:
      'Par\u00e1lisis m\u00faltiple de los nervios craneales, en enfermedades neopl\u00e1sicas (C00\u2013D48)',
    code_2: 'G53',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G538',
    level: 3,
    description:
      'Otros trastornos de los nervios craneales en otras enfermedades clasificadas en otra parte',
    code_2: 'G53',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'P040',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por anestesia y analgesia materna en el embarazo, en el trabajo de parto y en el parto',
    code_2: 'P04',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P041',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por otras medicaciones maternas',
    code_2: 'P04',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P042',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por tabaquismo de la madre',
    code_2: 'P04',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P043',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por alcoholismo de la madre',
    code_2: 'P04',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P044',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por drogadicci\u00f3n materna',
    code_2: 'P04',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P045',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por el uso materno de sustancias qu\u00edmicas nutricionales',
    code_2: 'P04',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P046',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por exposici\u00f3n materna a sustancias qu\u00edmicas ambientales',
    code_2: 'P04',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P048',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por otras influencias nocivas de la madre',
    code_2: 'P04',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P030',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por parto y extracci\u00f3n de nalgas',
    code_2: 'P03',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P031',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por otra presentaci\u00f3n an\u00f3mala, posici\u00f3n an\u00f3mala y desproporci\u00f3n durante el trabajo de parto y el parto',
    code_2: 'P03',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P032',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por parto con f\u00f3rceps',
    code_2: 'P03',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P033',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por parto con ventosa extractora',
    code_2: 'P03',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P034',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por parto por ces\u00e1rea',
    code_2: 'P03',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P035',
    level: 3,
    description: 'Feto y reci\u00e9n nacido afectados por parto precipitado',
    code_2: 'P03',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P036',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por contracciones uterinas anormales',
    code_2: 'P03',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P020',
    level: 3,
    description: 'Feto y reci\u00e9n nacido afectados por placenta previa',
    code_2: 'P02',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P021',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por otras formas de desprendimiento y de hemorragia placentarios',
    code_2: 'P02',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P022',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por otras anormalidades morfol\u00f3gicas y funcionales de la placenta y las no especificadas',
    code_2: 'P02',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P023',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por s\u00edndromes de transfusi\u00f3n placentaria',
    code_2: 'P02',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P024',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por prolapso del cord\u00f3n umbilical',
    code_2: 'P02',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P025',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por otra compresi\u00f3n del cord\u00f3n umbilical',
    code_2: 'P02',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P026',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por otras complicaciones del cord\u00f3n umbilical y las no especificadas',
    code_2: 'P02',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P010',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por incompetencia del cuello uterino',
    code_2: 'P01',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P011',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por ruptura prematura de las membranas',
    code_2: 'P01',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P012',
    level: 3,
    description: 'Feto y reci\u00e9n nacido afectados por oligohidramnios',
    code_2: 'P01',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P013',
    level: 3,
    description: 'Feto y reci\u00e9n nacido afectados por polihidramnios',
    code_2: 'P01',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P014',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por embarazo ect\u00f3pico',
    code_2: 'P01',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P015',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por embarazo m\u00faltiple',
    code_2: 'P01',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P016',
    level: 3,
    description: 'Feto y reci\u00e9n nacido afectados por muerte materna',
    code_2: 'P01',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P017',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por presentaci\u00f3n an\u00f3mala antes del trabajo de parto',
    code_2: 'P01',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P018',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por otras complicaciones maternas del embarazo',
    code_2: 'P01',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P000',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por trastornos hipertensivos de la madre',
    code_2: 'P00',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P001',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por enfermedades renales y de las v\u00edas urinarias de la madre',
    code_2: 'P00',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P002',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por enfermedades infecciosas y parasitarias de la madre',
    code_2: 'P00',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P003',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por otras enfermedades circulatorias y respiratorias de la madre',
    code_2: 'P00',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P004',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por trastornos nutricionales de la madre',
    code_2: 'P00',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P005',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por traumatismo de la madre',
    code_2: 'P00',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P006',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por procedimiento quir\u00fargico en la madre',
    code_2: 'P00',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P007',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por otro procedimiento m\u00e9dico en la madre, no clasificado en otra parte',
    code_2: 'P00',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P008',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por otras afecciones maternas',
    code_2: 'P00',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P050',
    level: 3,
    description: 'Bajo peso para la edad gestacional',
    code_2: 'P05',
    code_0: 'P00-P96',
    code_1: 'P05-P08'
  },
  {
    code: 'P051',
    level: 3,
    description: 'Peque\u00f1o para la edad gestacional',
    code_2: 'P05',
    code_0: 'P00-P96',
    code_1: 'P05-P08'
  },
  {
    code: 'P052',
    level: 3,
    description:
      'Desnutrici\u00f3n fetal, sin menci\u00f3n de peso o talla bajos para la edad gestacional',
    code_2: 'P05',
    code_0: 'P00-P96',
    code_1: 'P05-P08'
  },
  {
    code: 'P059',
    level: 3,
    description: 'Retardo del crecimiento fetal, no especificado',
    code_2: 'P05',
    code_0: 'P00-P96',
    code_1: 'P05-P08'
  },
  {
    code: 'G990',
    level: 3,
    description:
      'Neuropat\u00eda auton\u00f3mica en enfermedades metab\u00f3licas y endocrinas',
    code_2: 'G99',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G991',
    level: 3,
    description:
      'Otros trastornos del sistema nervioso aut\u00f3nomo en otras enfermedades clasificadas en otra parte',
    code_2: 'G99',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G992',
    level: 3,
    description: 'Mielopat\u00eda en enfermedades clasificadas en otra parte',
    code_2: 'G99',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G998',
    level: 3,
    description:
      'Otros trastornos especificados del sistema nervioso en enfermedades clasificadas en otra parte',
    code_2: 'G99',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G970',
    level: 3,
    description:
      'P\u00e9rdida de l\u00edquido cefalorraqu\u00eddeo por punci\u00f3n espinal',
    code_2: 'G97',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G971',
    level: 3,
    description: 'Otra reacci\u00f3n a la punci\u00f3n espinal y lumbar',
    code_2: 'G97',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G972',
    level: 3,
    description:
      'Hipotensi\u00f3n intracraneal posterior a anastomosis ventricular',
    code_2: 'G97',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G978',
    level: 3,
    description:
      'Otros trastornos del sistema nervioso consecutivos a procedimientos',
    code_2: 'G97',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G979',
    level: 3,
    description:
      'Trastornos no especificados del sistema nervioso, consecutivos a procedimientos',
    code_2: 'G97',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'A080',
    level: 3,
    description: 'Enteritis debida a rotavirus',
    code_2: 'A08',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A081',
    level: 3,
    description: 'Gastroenteropat\u00eda aguda debida al agente de Norwalk',
    code_2: 'A08',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A082',
    level: 3,
    description: 'Enteritis debida a adenovirus',
    code_2: 'A08',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A083',
    level: 3,
    description: 'Otras enteritis virales',
    code_2: 'A08',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A084',
    level: 3,
    description:
      'Infecci\u00f3n intestinal viral, sin otra especificaci\u00f3n',
    code_2: 'A08',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A085',
    level: 3,
    description: 'Otras infecciones intestinales especificadas',
    code_2: 'A08',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A070',
    level: 3,
    description: 'Balantidiasis',
    code_2: 'A07',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A071',
    level: 3,
    description: 'Giardiasis [lambliasis]',
    code_2: 'A07',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A072',
    level: 3,
    description: 'Criptosporidiosis',
    code_2: 'A07',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A073',
    level: 3,
    description: 'Isosporiasis',
    code_2: 'A07',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A078',
    level: 3,
    description:
      'Otras enfermedades intestinales especificadas debidas a protozoarios',
    code_2: 'A07',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A079',
    level: 3,
    description: 'Enfermedad intestinal debida a protozoarios, no especificada',
    code_2: 'A07',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'P150',
    level: 3,
    description: 'Lesi\u00f3n del h\u00edgado durante el nacimiento',
    code_2: 'P15',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P151',
    level: 3,
    description: 'Lesi\u00f3n del bazo durante el nacimiento',
    code_2: 'P15',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P152',
    level: 3,
    description:
      'Traumatismo del m\u00fasculo esternocleidomastoideo durante el nacimiento',
    code_2: 'P15',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P153',
    level: 3,
    description: 'Traumatismo ocular durante el nacimiento',
    code_2: 'P15',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P154',
    level: 3,
    description: 'Traumatismo facial durante el nacimiento',
    code_2: 'P15',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P155',
    level: 3,
    description: 'Traumatismo de los genitales externos durante el nacimiento',
    code_2: 'P15',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P156',
    level: 3,
    description:
      'Necrosis grasa subcut\u00e1nea debida a traumatismo del nacimiento',
    code_2: 'P15',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P158',
    level: 3,
    description: 'Otros traumatismos especificados, durante el nacimiento',
    code_2: 'P15',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P159',
    level: 3,
    description: 'Traumatismo no especificado, durante el nacimiento',
    code_2: 'P15',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P140',
    level: 3,
    description: 'Par\u00e1lisis de Erb debida a traumatismo del nacimiento',
    code_2: 'P14',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P141',
    level: 3,
    description:
      'Par\u00e1lisis de Klumpke debida a traumatismo del nacimiento',
    code_2: 'P14',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P142',
    level: 3,
    description:
      'Par\u00e1lisis del nervio fr\u00e9nico debida a traumatismo del nacimiento',
    code_2: 'P14',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P143',
    level: 3,
    description: 'Otro traumatismo del plexo braquial durante el nacimiento',
    code_2: 'P14',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P148',
    level: 3,
    description:
      'Traumatismo durante el nacimiento en otras partes del sistema nervioso perif\u00e9rico',
    code_2: 'P14',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P149',
    level: 3,
    description:
      'Traumatismo no especificado del sistema nervioso perif\u00e9rico durante el nacimiento',
    code_2: 'P14',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P130',
    level: 3,
    description: 'Fractura del cr\u00e1neo debida a traumatismo del nacimiento',
    code_2: 'P13',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P131',
    level: 3,
    description: 'Otros traumatismos del cr\u00e1neo durante el nacimiento',
    code_2: 'P13',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P132',
    level: 3,
    description: 'Traumatismo del f\u00e9mur durante el nacimiento',
    code_2: 'P13',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P133',
    level: 3,
    description: 'Traumatismo de otros huesos largos durante el nacimiento',
    code_2: 'P13',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P134',
    level: 3,
    description:
      'Fractura de la clav\u00edcula debida a traumatismo del nacimiento',
    code_2: 'P13',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P138',
    level: 3,
    description: 'Traumatismo del nacimiento en otras partes del esqueleto',
    code_2: 'P13',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P139',
    level: 3,
    description:
      'Traumatismo no especificado del esqueleto durante el nacimiento',
    code_2: 'P13',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P120',
    level: 3,
    description: 'Cefalohematoma debido a traumatismo del nacimiento',
    code_2: 'P12',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P121',
    level: 3,
    description: 'Caput succedaneum debido a traumatismo del nacimiento',
    code_2: 'P12',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P122',
    level: 3,
    description:
      'Hemorragia epicraneal subaponeur\u00f3tica debida a traumatismo del nacimiento',
    code_2: 'P12',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P123',
    level: 3,
    description:
      'Equimosis del cuero cabelludo debida a traumatismo del nacimiento',
    code_2: 'P12',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P124',
    level: 3,
    description:
      'Traumatismo en el cuero cabelludo del reci\u00e9n nacido por monitoreo fetal',
    code_2: 'P12',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P128',
    level: 3,
    description: 'Otros traumatismos del nacimiento en el cuero cabelludo',
    code_2: 'P12',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P129',
    level: 3,
    description:
      'Traumatismo del nacimiento en el cuero cabelludo, no especificado',
    code_2: 'P12',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P110',
    level: 3,
    description: 'Edema cerebral debido a traumatismo del nacimiento',
    code_2: 'P11',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P111',
    level: 3,
    description:
      'Otras lesiones especificadas del enc\u00e9falo, debidas a traumatismo del nacimiento',
    code_2: 'P11',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P112',
    level: 3,
    description:
      'Lesi\u00f3n no especificada del enc\u00e9falo, debida a traumatismo del nacimiento',
    code_2: 'P11',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P113',
    level: 3,
    description: 'Traumatismo del nacimiento en el nervio facial',
    code_2: 'P11',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P114',
    level: 3,
    description: 'Traumatismo del nacimiento en otros nervios craneales',
    code_2: 'P11',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P115',
    level: 3,
    description:
      'Traumatismo del nacimiento en la columna vertebral y en la m\u00e9dula espinal',
    code_2: 'P11',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P119',
    level: 3,
    description:
      'Traumatismo del nacimiento en el sistema nervioso central, no especificado',
    code_2: 'P11',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P100',
    level: 3,
    description: 'Hemorragia subdural debida a traumatismo del nacimiento',
    code_2: 'P10',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P101',
    level: 3,
    description: 'Hemorragia cerebral debida a traumatismo del nacimiento',
    code_2: 'P10',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P102',
    level: 3,
    description:
      'Hemorragia intraventricular debida a traumatismo del nacimiento',
    code_2: 'P10',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P103',
    level: 3,
    description: 'Hemorragia subaracnoidea debida a traumatismo del nacimiento',
    code_2: 'P10',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P104',
    level: 3,
    description: 'Desgarro tentorial debido a traumatismo del nacimiento',
    code_2: 'P10',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P108',
    level: 3,
    description:
      'Otras hemorragias y laceraciones intracraneales debidas a traumatismo del nacimiento',
    code_2: 'P10',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'P109',
    level: 3,
    description:
      'Hemorragia y laceraci\u00f3n intracraneales no especificadas, debidas a traumatismo del nacimiento',
    code_2: 'P10',
    code_0: 'P00-P96',
    code_1: 'P10-P15'
  },
  {
    code: 'F680',
    level: 3,
    description:
      'Elaboraci\u00f3n de s\u00edntomas f\u00edsicos por causas psicol\u00f3gicas',
    code_2: 'F68',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F681',
    level: 3,
    description:
      'Producci\u00f3n intencional o simulaci\u00f3n de s\u00edntomas o de incapacidades, tanto f\u00edsicas como psicol\u00f3gicas [trastorno facticio]',
    code_2: 'F68',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F688',
    level: 3,
    description:
      'Otros trastornos especificados de la personalidad y del comportamiento en adultos',
    code_2: 'F68',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F660',
    level: 3,
    description: 'Trastorno de la maduraci\u00f3n sexual',
    code_2: 'F66',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F661',
    level: 3,
    description: 'Orientaci\u00f3n sexual egodist\u00f3nica',
    code_2: 'F66',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F662',
    level: 3,
    description: 'Trastorno de la relaci\u00f3n sexual',
    code_2: 'F66',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F668',
    level: 3,
    description: 'Otros trastornos del desarrollo psicosexual',
    code_2: 'F66',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F669',
    level: 3,
    description: 'Trastorno del desarrollo psicosexual, no especificado',
    code_2: 'F66',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F650',
    level: 3,
    description: 'Fetichismo',
    code_2: 'F65',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F651',
    level: 3,
    description: 'Transvestismo fetichista',
    code_2: 'F65',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F652',
    level: 3,
    description: 'Exhibicionismo',
    code_2: 'F65',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F653',
    level: 3,
    description: 'Voyeurismo',
    code_2: 'F65',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F654',
    level: 3,
    description: 'Pedofilia',
    code_2: 'F65',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F655',
    level: 3,
    description: 'Sadomasoquismo',
    code_2: 'F65',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F656',
    level: 3,
    description: 'Trastornos m\u00faltiples de la preferencia sexual',
    code_2: 'F65',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F658',
    level: 3,
    description: 'Otros trastornos de la preferencia sexual',
    code_2: 'F65',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F659',
    level: 3,
    description: 'Trastorno de la preferencia sexual, no especificado',
    code_2: 'F65',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F640',
    level: 3,
    description: 'Transexualismo',
    code_2: 'F64',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F641',
    level: 3,
    description: 'Transvestismo de rol dual',
    code_2: 'F64',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F642',
    level: 3,
    description: 'Trastorno de la identidad de g\u00e9nero en la ni\u00f1ez',
    code_2: 'F64',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F648',
    level: 3,
    description: 'Otros trastornos de la identidad de g\u00e9nero',
    code_2: 'F64',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F649',
    level: 3,
    description: 'Trastorno de la identidad de g\u00e9nero, no especificado',
    code_2: 'F64',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F630',
    level: 3,
    description: 'Juego patol\u00f3gico',
    code_2: 'F63',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F631',
    level: 3,
    description: 'Piroman\u00eda',
    code_2: 'F63',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F632',
    level: 3,
    description: 'Hurto patol\u00f3gico [cleptoman\u00eda]',
    code_2: 'F63',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F633',
    level: 3,
    description: 'Tricotiloman\u00eda',
    code_2: 'F63',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F638',
    level: 3,
    description: 'Otros trastornos de los h\u00e1bitos y de los impulsos',
    code_2: 'F63',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F639',
    level: 3,
    description:
      'Trastorno de los h\u00e1bitos y de los impulsos, no especificado',
    code_2: 'F63',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F620',
    level: 3,
    description:
      'Cambio perdurable de la personalidad despu\u00e9s de una experiencia catastr\u00f3fica',
    code_2: 'F62',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F621',
    level: 3,
    description:
      'Cambio perdurable de la personalidad consecutivo a una enfermedad psiqui\u00e1trica',
    code_2: 'F62',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F628',
    level: 3,
    description: 'Otros cambios perdurables de la personalidad',
    code_2: 'F62',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F629',
    level: 3,
    description: 'Cambio perdurable de la personalidad, no especificado',
    code_2: 'F62',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'P220',
    level: 3,
    description:
      'S\u00edndrome de dificultad respiratoria del reci\u00e9n nacido',
    code_2: 'P22',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P221',
    level: 3,
    description: 'Taquipnea transitoria del reci\u00e9n nacido',
    code_2: 'P22',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P228',
    level: 3,
    description: 'Otras dificultades respiratorias del reci\u00e9n nacido',
    code_2: 'P22',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P229',
    level: 3,
    description:
      'Dificultad respiratoria del reci\u00e9n nacido, no especificada',
    code_2: 'P22',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P210',
    level: 3,
    description: 'Asfixia del nacimiento, severa',
    code_2: 'P21',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P211',
    level: 3,
    description: 'Asfixia del nacimiento, leve y moderada',
    code_2: 'P21',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P219',
    level: 3,
    description: 'Asfixia del nacimiento, no especificada',
    code_2: 'P21',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P200',
    level: 3,
    description:
      'Hipoxia intrauterina notada por primera vez antes del inicio del trabajo de parto',
    code_2: 'P20',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P201',
    level: 3,
    description:
      'Hipoxia intrauterina notada por primera vez durante el trabajo de parto y el parto',
    code_2: 'P20',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P209',
    level: 3,
    description: 'Hipoxia intrauterina, no especificada',
    code_2: 'P20',
    code_0: 'P00-P96',
    code_1: 'P20-P29'
  },
  {
    code: 'P390',
    level: 3,
    description: 'Mastitis infecciosa neonatal',
    code_2: 'P39',
    code_0: 'P00-P96',
    code_1: 'P35-P39'
  },
  {
    code: 'P391',
    level: 3,
    description: 'Conjuntivitis y dacriocistitis neonatales',
    code_2: 'P39',
    code_0: 'P00-P96',
    code_1: 'P35-P39'
  },
  {
    code: 'P392',
    level: 3,
    description:
      'Infecci\u00f3n intraamni\u00f3tica del feto, no clasificada en otra parte',
    code_2: 'P39',
    code_0: 'P00-P96',
    code_1: 'P35-P39'
  },
  {
    code: 'P393',
    level: 3,
    description: 'Infecci\u00f3n neonatal de las v\u00edas urinarias',
    code_2: 'P39',
    code_0: 'P00-P96',
    code_1: 'P35-P39'
  },
  {
    code: 'P394',
    level: 3,
    description: 'Infecci\u00f3n cut\u00e1nea neonatal',
    code_2: 'P39',
    code_0: 'P00-P96',
    code_1: 'P35-P39'
  },
  {
    code: 'P398',
    level: 3,
    description:
      'Otras infecciones especificadas propias del per\u00edodo perinatal',
    code_2: 'P39',
    code_0: 'P00-P96',
    code_1: 'P35-P39'
  },
  {
    code: 'P399',
    level: 3,
    description:
      'Infecci\u00f3n propia del per\u00edodo perinatal, no especificada',
    code_2: 'P39',
    code_0: 'P00-P96',
    code_1: 'P35-P39'
  },
  {
    code: 'P370',
    level: 3,
    description: 'Tuberculosis cong\u00e9nita',
    code_2: 'P37',
    code_0: 'P00-P96',
    code_1: 'P35-P39'
  },
  {
    code: 'P371',
    level: 3,
    description: 'Toxoplasmosis cong\u00e9nita',
    code_2: 'P37',
    code_0: 'P00-P96',
    code_1: 'P35-P39'
  },
  {
    code: 'P372',
    level: 3,
    description: 'Listeriosis cong\u00e9nita (diseminada)',
    code_2: 'P37',
    code_0: 'P00-P96',
    code_1: 'P35-P39'
  },
  {
    code: 'P373',
    level: 3,
    description: 'Paludismo cong\u00e9nito por Plasmodium falciparum',
    code_2: 'P37',
    code_0: 'P00-P96',
    code_1: 'P35-P39'
  },
  {
    code: 'P374',
    level: 3,
    description: 'Otros paludismos cong\u00e9nitos',
    code_2: 'P37',
    code_0: 'P00-P96',
    code_1: 'P35-P39'
  },
  {
    code: 'P360',
    level: 3,
    description:
      'Sepsis del reci\u00e9n nacido debida a estreptococo del grupo B',
    code_2: 'P36',
    code_0: 'P00-P96',
    code_1: 'P35-P39'
  },
  {
    code: 'P361',
    level: 3,
    description:
      'Sepsis del reci\u00e9n nacido debida a otros estreptococos y a los no especificados',
    code_2: 'P36',
    code_0: 'P00-P96',
    code_1: 'P35-P39'
  },
  {
    code: 'P362',
    level: 3,
    description: 'Sepsis del reci\u00e9n nacido debida a Staphylococcus aureus',
    code_2: 'P36',
    code_0: 'P00-P96',
    code_1: 'P35-P39'
  },
  {
    code: 'P363',
    level: 3,
    description:
      'Sepsis del reci\u00e9n nacido debida a otros estafilococos y a los no especificados',
    code_2: 'P36',
    code_0: 'P00-P96',
    code_1: 'P35-P39'
  },
  {
    code: 'P364',
    level: 3,
    description: 'Sepsis del reci\u00e9n nacido debida a Escherichia coli',
    code_2: 'P36',
    code_0: 'P00-P96',
    code_1: 'P35-P39'
  },
  {
    code: 'P365',
    level: 3,
    description: 'Sepsis del reci\u00e9n nacido debida a anaerobios',
    code_2: 'P36',
    code_0: 'P00-P96',
    code_1: 'P35-P39'
  },
  {
    code: 'P368',
    level: 3,
    description: 'Sepsis del reci\u00e9n nacido debida a otras bacterias',
    code_2: 'P36',
    code_0: 'P00-P96',
    code_1: 'P35-P39'
  },
  {
    code: 'P350',
    level: 3,
    description: 'S\u00edndrome de rub\u00e9ola cong\u00e9nita',
    code_2: 'P35',
    code_0: 'P00-P96',
    code_1: 'P35-P39'
  },
  {
    code: 'P351',
    level: 3,
    description: 'Infecci\u00f3n citomegalov\u00edrica cong\u00e9nita',
    code_2: 'P35',
    code_0: 'P00-P96',
    code_1: 'P35-P39'
  },
  {
    code: 'P352',
    level: 3,
    description: 'Infecciones cong\u00e9nitas por virus del herpes simple',
    code_2: 'P35',
    code_0: 'P00-P96',
    code_1: 'P35-P39'
  },
  {
    code: 'P353',
    level: 3,
    description: 'Hepatitis viral cong\u00e9nita',
    code_2: 'P35',
    code_0: 'P00-P96',
    code_1: 'P35-P39'
  },
  {
    code: 'P358',
    level: 3,
    description: 'Otras enfermedades virales cong\u00e9nitas',
    code_2: 'P35',
    code_0: 'P00-P96',
    code_1: 'P35-P39'
  },
  {
    code: 'P359',
    level: 3,
    description:
      'Enfermedad viral cong\u00e9nita, sin otra especificaci\u00f3n',
    code_2: 'P35',
    code_0: 'P00-P96',
    code_1: 'P35-P39'
  },
  {
    code: 'P520',
    level: 3,
    description:
      'Hemorragia intraventricular (no traum\u00e1tica) grado 1, del feto y del reci\u00e9n nacido',
    code_2: 'P52',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P521',
    level: 3,
    description:
      'Hemorragia intraventricular (no traum\u00e1tica) grado 2, del feto y del reci\u00e9n nacido',
    code_2: 'P52',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P522',
    level: 3,
    description:
      'Hemorragia intraventricular (no traum\u00e1tica) grado 3, del feto y del reci\u00e9n nacido',
    code_2: 'P52',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P523',
    level: 3,
    description:
      'Hemorragia intraventricular (no traum\u00e1tica) del feto y del reci\u00e9n nacido, sin otra especificaci\u00f3n',
    code_2: 'P52',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P510',
    level: 3,
    description: 'Hemorragia umbilical masiva del reci\u00e9n nacido',
    code_2: 'P51',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P518',
    level: 3,
    description: 'Otras hemorragias umbilicales del reci\u00e9n nacido',
    code_2: 'P51',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P519',
    level: 3,
    description:
      'Hemorragia umbilical del reci\u00e9n nacido, sin otra especificaci\u00f3n',
    code_2: 'P51',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'R296',
    level: 3,
    description: 'Tendencia a caer, no clasificada en otra parte',
    code_2: 'R29',
    code_0: 'R00-R99',
    code_1: 'R25-R29'
  },
  {
    code: 'R298',
    level: 3,
    description:
      'Otros s\u00edntomas y signos que involucran los sistemas nervioso y osteomuscular y los no especificados',
    code_2: 'R29',
    code_0: 'R00-R99',
    code_1: 'R25-R29'
  },
  {
    code: 'P500',
    level: 3,
    description: 'P\u00e9rdida de sangre fetal por vasa previa',
    code_2: 'P50',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P501',
    level: 3,
    description:
      'P\u00e9rdida de sangre fetal por ruptura del cord\u00f3n umbilical',
    code_2: 'P50',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P502',
    level: 3,
    description: 'P\u00e9rdida de sangre fetal por la placenta',
    code_2: 'P50',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P503',
    level: 3,
    description: 'Hemorragia fetal hacia el otro gemelo',
    code_2: 'P50',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P504',
    level: 3,
    description: 'Hemorragia fetal hacia la circulaci\u00f3n materna',
    code_2: 'P50',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P505',
    level: 3,
    description:
      'P\u00e9rdida de sangre fetal por el corte del cord\u00f3n umbilical en el otro gemelo',
    code_2: 'P50',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P508',
    level: 3,
    description: 'Otras p\u00e9rdidas de sangre fetal',
    code_2: 'P50',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P509',
    level: 3,
    description: 'P\u00e9rdida de sangre fetal, no especificada',
    code_2: 'P50',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P740',
    level: 3,
    description: 'Acidosis metab\u00f3lica tard\u00eda del reci\u00e9n nacido',
    code_2: 'P74',
    code_0: 'P00-P96',
    code_1: 'P70-P74'
  },
  {
    code: 'P741',
    level: 3,
    description: 'Deshidrataci\u00f3n del reci\u00e9n nacido',
    code_2: 'P74',
    code_0: 'P00-P96',
    code_1: 'P70-P74'
  },
  {
    code: 'P742',
    level: 3,
    description:
      'Alteraciones del equilibrio del sodio en el reci\u00e9n nacido',
    code_2: 'P74',
    code_0: 'P00-P96',
    code_1: 'P70-P74'
  },
  {
    code: 'P743',
    level: 3,
    description:
      'Alteraciones del equilibrio del potasio en el reci\u00e9n nacido',
    code_2: 'P74',
    code_0: 'P00-P96',
    code_1: 'P70-P74'
  },
  {
    code: 'P744',
    level: 3,
    description:
      'Otras alteraciones electrol\u00edticas transitorias del reci\u00e9n nacido',
    code_2: 'P74',
    code_0: 'P00-P96',
    code_1: 'P70-P74'
  },
  {
    code: 'P745',
    level: 3,
    description: 'Tirosinemia transitoria del reci\u00e9n nacido',
    code_2: 'P74',
    code_0: 'P00-P96',
    code_1: 'P70-P74'
  },
  {
    code: 'P748',
    level: 3,
    description:
      'Otras alteraciones metab\u00f3licas transitorias del reci\u00e9n nacido',
    code_2: 'P74',
    code_0: 'P00-P96',
    code_1: 'P70-P74'
  },
  {
    code: 'P749',
    level: 3,
    description:
      'Trastorno metab\u00f3lico transitorio del reci\u00e9n nacido, no especificado',
    code_2: 'P74',
    code_0: 'P00-P96',
    code_1: 'P70-P74'
  },
  {
    code: 'P720',
    level: 3,
    description: 'Bocio neonatal, no clasificado en otra parte',
    code_2: 'P72',
    code_0: 'P00-P96',
    code_1: 'P70-P74'
  },
  {
    code: 'P721',
    level: 3,
    description: 'Hipertiroidismo neonatal transitorio',
    code_2: 'P72',
    code_0: 'P00-P96',
    code_1: 'P70-P74'
  },
  {
    code: 'P722',
    level: 3,
    description:
      'Otros trastornos neonatales transitorios de la funci\u00f3n tiroidea, no clasificados en otra parte',
    code_2: 'P72',
    code_0: 'P00-P96',
    code_1: 'P70-P74'
  },
  {
    code: 'P728',
    level: 3,
    description:
      'Otros trastornos endocrinos neonatales transitorios especificados',
    code_2: 'P72',
    code_0: 'P00-P96',
    code_1: 'P70-P74'
  },
  {
    code: 'P729',
    level: 3,
    description: 'Trastorno endocrino neonatal transitorio, no especificado',
    code_2: 'P72',
    code_0: 'P00-P96',
    code_1: 'P70-P74'
  },
  {
    code: 'P710',
    level: 3,
    description:
      'Hipocalcemia del reci\u00e9n nacido debida a la leche de vaca',
    code_2: 'P71',
    code_0: 'P00-P96',
    code_1: 'P70-P74'
  },
  {
    code: 'P711',
    level: 3,
    description: 'Otra hipocalcemia neonatal',
    code_2: 'P71',
    code_0: 'P00-P96',
    code_1: 'P70-P74'
  },
  {
    code: 'P712',
    level: 3,
    description: 'Hipomagnesemia neonatal',
    code_2: 'P71',
    code_0: 'P00-P96',
    code_1: 'P70-P74'
  },
  {
    code: 'P713',
    level: 3,
    description:
      'Tetania neonatal sin menci\u00f3n de deficiencia de calcio o de magnesio',
    code_2: 'P71',
    code_0: 'P00-P96',
    code_1: 'P70-P74'
  },
  {
    code: 'P714',
    level: 3,
    description: 'Hipoparatiroidismo neonatal transitorio',
    code_2: 'P71',
    code_0: 'P00-P96',
    code_1: 'P70-P74'
  },
  {
    code: 'P718',
    level: 3,
    description:
      'Otros trastornos neonatales transitorios del metabolismo del calcio y del magnesio',
    code_2: 'P71',
    code_0: 'P00-P96',
    code_1: 'P70-P74'
  },
  {
    code: 'P719',
    level: 3,
    description:
      'Trastorno neonatal transitorio no especificado del metabolismo del calcio y del magnesio',
    code_2: 'P71',
    code_0: 'P00-P96',
    code_1: 'P70-P74'
  },
  {
    code: 'P700',
    level: 3,
    description:
      'S\u00edndrome del reci\u00e9n nacido de madre con diabetes gestacional',
    code_2: 'P70',
    code_0: 'P00-P96',
    code_1: 'P70-P74'
  },
  {
    code: 'P701',
    level: 3,
    description: 'S\u00edndrome del reci\u00e9n nacido de madre diab\u00e9tica',
    code_2: 'P70',
    code_0: 'P00-P96',
    code_1: 'P70-P74'
  },
  {
    code: 'P702',
    level: 3,
    description: 'Diabetes mellitus neonatal',
    code_2: 'P70',
    code_0: 'P00-P96',
    code_1: 'P70-P74'
  },
  {
    code: 'P703',
    level: 3,
    description: 'Hipoglicemia neonatal yatrog\u00e9nica',
    code_2: 'P70',
    code_0: 'P00-P96',
    code_1: 'P70-P74'
  },
  {
    code: 'P704',
    level: 3,
    description: 'Otras hipoglicemias neonatales',
    code_2: 'P70',
    code_0: 'P00-P96',
    code_1: 'P70-P74'
  },
  {
    code: 'P708',
    level: 3,
    description:
      'Otros trastornos transitorios del metabolismo de los carbohidratos en el feto y el reci\u00e9n nacido',
    code_2: 'P70',
    code_0: 'P00-P96',
    code_1: 'P70-P74'
  },
  {
    code: 'P709',
    level: 3,
    description:
      'Trastorno transitorio no especificado del metabolismo de los carbohidratos en el feto y el reci\u00e9n nacido',
    code_2: 'P70',
    code_0: 'P00-P96',
    code_1: 'P70-P74'
  },
  {
    code: 'Q044',
    level: 3,
    description: 'Displasia opticoseptal',
    code_2: 'Q04',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q045',
    level: 3,
    description: 'Megalencefalia',
    code_2: 'Q04',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q046',
    level: 3,
    description: 'Quistes cerebrales cong\u00e9nitos',
    code_2: 'Q04',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q048',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas del enc\u00e9falo, especificadas',
    code_2: 'Q04',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'Q049',
    level: 3,
    description:
      'Malformaci\u00f3n cong\u00e9nita del enc\u00e9falo, no especificada',
    code_2: 'Q04',
    code_0: 'Q00-Q99',
    code_1: 'Q00-Q07'
  },
  {
    code: 'D890',
    level: 3,
    description: 'Hipergammaglobulinemia policlonal',
    code_2: 'D89',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D891',
    level: 3,
    description: 'Crioglobulinemia',
    code_2: 'D89',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D892',
    level: 3,
    description: 'Hipergammaglobulinemia, no especificada',
    code_2: 'D89',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D898',
    level: 3,
    description:
      'Otros trastornos especificados que afectan el mecanismo de la inmunidad, no clasificados en otra parte',
    code_2: 'D89',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D899',
    level: 3,
    description:
      'Trastorno que afecta al mecanismo de la inmunidad, no especificado',
    code_2: 'D89',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D860',
    level: 3,
    description: 'Sarcoidosis del pulm\u00f3n',
    code_2: 'D86',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D861',
    level: 3,
    description: 'Sarcoidosis de los ganglios linf\u00e1ticos',
    code_2: 'D86',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D862',
    level: 3,
    description:
      'Sarcoidosis del pulm\u00f3n y de los ganglios linf\u00e1ticos',
    code_2: 'D86',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D863',
    level: 3,
    description: 'Sarcoidosis de la piel',
    code_2: 'D86',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D868',
    level: 3,
    description:
      'Sarcoidosis de otros sitios especificados o de sitios combinados',
    code_2: 'D86',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D869',
    level: 3,
    description: 'Sarcoidosis de sitio no especificado',
    code_2: 'D86',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D840',
    level: 3,
    description:
      'Defecto de la funci\u00f3n del ant\u00edgeno-1 del linfocito [LFA-1]',
    code_2: 'D84',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D841',
    level: 3,
    description: 'Defecto del sistema del complemento',
    code_2: 'D84',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D848',
    level: 3,
    description: 'Otras inmunodeficiencias especificadas',
    code_2: 'D84',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D849',
    level: 3,
    description: 'Inmunodeficiencia, no especificada',
    code_2: 'D84',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D830',
    level: 3,
    description:
      'Inmunodeficiencia variable com\u00fan con predominio de anormalidades en el n\u00famero y la funci\u00f3n de los linfocitos B',
    code_2: 'D83',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D831',
    level: 3,
    description:
      'Inmunodeficiencia variable com\u00fan con predominio de trastornos inmunorreguladores de los linfocitos T',
    code_2: 'D83',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D832',
    level: 3,
    description:
      'Inmunodeficiencia variable com\u00fan con autoanticuerpos anti-B o anti-T',
    code_2: 'D83',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D838',
    level: 3,
    description: 'Otras inmunodeficiencias variables comunes',
    code_2: 'D83',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D839',
    level: 3,
    description: 'Inmunodeficiencia variable com\u00fan, no especificada',
    code_2: 'D83',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D820',
    level: 3,
    description: 'S\u00edndrome de Wiskott\u2013Aldrich',
    code_2: 'D82',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D821',
    level: 3,
    description: 'S\u00edndrome de Di George',
    code_2: 'D82',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D822',
    level: 3,
    description:
      'Inmunodeficiencia con enanismo microm\u00e9lico [miembros cortos]',
    code_2: 'D82',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D823',
    level: 3,
    description:
      'Inmunodeficiencia consecutiva a respuesta defectuosa hereditaria contra el virus de Epstein\u2013Barr',
    code_2: 'D82',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D810',
    level: 3,
    description:
      'Inmunodeficiencia combinada severa [IDCS] con disgenesia reticular',
    code_2: 'D81',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D811',
    level: 3,
    description:
      'Inmunodeficiencia combinada severa [IDCS] con linfocitopenia T y B',
    code_2: 'D81',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D812',
    level: 3,
    description:
      'Inmunodeficiencia combinada severa [IDCS] con cifra baja o normal de linfocitos B',
    code_2: 'D81',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D813',
    level: 3,
    description: 'Deficiencia de la adenosina deaminasa [ADA]',
    code_2: 'D81',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D814',
    level: 3,
    description: 'S\u00edndrome de Nezelof',
    code_2: 'D81',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D815',
    level: 3,
    description: 'Deficiencia de la fosforilasa purinonucle\u00f3sida [FPN]',
    code_2: 'D81',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D816',
    level: 3,
    description:
      'Deficiencia de la clase I del complejo de histocompatibilidad mayor',
    code_2: 'D81',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D817',
    level: 3,
    description:
      'Deficiencia de la clase II del complejo de histocompatibilidad mayor',
    code_2: 'D81',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D800',
    level: 3,
    description: 'Hipogammaglobulinemia hereditaria',
    code_2: 'D80',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D801',
    level: 3,
    description: 'Hipogammaglobulinemia no familiar',
    code_2: 'D80',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D802',
    level: 3,
    description: 'Deficiencia selectiva de inmunoglobulina A [IgA]',
    code_2: 'D80',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D803',
    level: 3,
    description:
      'Deficiencia selectiva de subclases de la inmunoglobulina G [IgG]',
    code_2: 'D80',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D804',
    level: 3,
    description: 'Deficiencia selectiva de inmunoglobulina M [IgM]',
    code_2: 'D80',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D805',
    level: 3,
    description: 'Inmunodeficiencia con incremento de inmunoglobulina M [IgM]',
    code_2: 'D80',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D806',
    level: 3,
    description:
      'Deficiencia de anticuerpos con inmunoglobulinas casi normales o con hiperinmunoglobulinemia',
    code_2: 'D80',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D807',
    level: 3,
    description: 'Hipogammaglobulinemia transitoria de la infancia',
    code_2: 'D80',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D808',
    level: 3,
    description:
      'Otras inmunodeficiencias con predominio de defectos de los anticuerpos',
    code_2: 'D80',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D809',
    level: 3,
    description:
      'Inmunodeficiencia con predominio de defectos de los anticuerpos, no especificada',
    code_2: 'D80',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'O020',
    level: 3,
    description:
      'Detenci\u00f3n del desarrollo del huevo y mola no hidatiforme',
    code_2: 'O02',
    code_0: 'O00-O9A',
    code_1: 'O00-O08'
  },
  {
    code: 'O021',
    level: 3,
    description: 'Aborto retenido',
    code_2: 'O02',
    code_0: 'O00-O9A',
    code_1: 'O00-O08'
  },
  {
    code: 'O028',
    level: 3,
    description:
      'Otros productos anormales especificados de la concepci\u00f3n',
    code_2: 'O02',
    code_0: 'O00-O9A',
    code_1: 'O00-O08'
  },
  {
    code: 'O029',
    level: 3,
    description: 'Producto anormal de la concepci\u00f3n, no especificado',
    code_2: 'O02',
    code_0: 'O00-O9A',
    code_1: 'O00-O08'
  },
  {
    code: 'O010',
    level: 3,
    description: 'Mola hidatiforme cl\u00e1sica',
    code_2: 'O01',
    code_0: 'O00-O9A',
    code_1: 'O00-O08'
  },
  {
    code: 'O011',
    level: 3,
    description: 'Mola hidatiforme, incompleta o parcial',
    code_2: 'O01',
    code_0: 'O00-O9A',
    code_1: 'O00-O08'
  },
  {
    code: 'O019',
    level: 3,
    description: 'Mola hidatiforme, no especificada',
    code_2: 'O01',
    code_0: 'O00-O9A',
    code_1: 'O00-O08'
  },
  {
    code: 'O000',
    level: 3,
    description: 'Embarazo abdominal',
    code_2: 'O00',
    code_0: 'O00-O9A',
    code_1: 'O00-O08'
  },
  {
    code: 'O001',
    level: 3,
    description: 'Embarazo tub\u00e1rico',
    code_2: 'O00',
    code_0: 'O00-O9A',
    code_1: 'O00-O08'
  },
  {
    code: 'O002',
    level: 3,
    description: 'Embarazo ov\u00e1rico',
    code_2: 'O00',
    code_0: 'O00-O9A',
    code_1: 'O00-O08'
  },
  {
    code: 'O008',
    level: 3,
    description: 'Otros embarazos ect\u00f3picos',
    code_2: 'O00',
    code_0: 'O00-O9A',
    code_1: 'O00-O08'
  },
  {
    code: 'O009',
    level: 3,
    description: 'Embarazo ect\u00f3pico, no especificado',
    code_2: 'O00',
    code_0: 'O00-O9A',
    code_1: 'O00-O08'
  },
  {
    code: 'F840',
    level: 3,
    description: 'Autismo en la ni\u00f1ez',
    code_2: 'F84',
    code_0: 'F01-F99',
    code_1: 'F80-F89'
  },
  {
    code: 'F841',
    level: 3,
    description: 'Autismo at\u00edpico',
    code_2: 'F84',
    code_0: 'F01-F99',
    code_1: 'F80-F89'
  },
  {
    code: 'F842',
    level: 3,
    description: 'S\u00edndrome de Rett',
    code_2: 'F84',
    code_0: 'F01-F99',
    code_1: 'F80-F89'
  },
  {
    code: 'F843',
    level: 3,
    description: 'Otro trastorno desintegrativo de la ni\u00f1ez',
    code_2: 'F84',
    code_0: 'F01-F99',
    code_1: 'F80-F89'
  },
  {
    code: 'F844',
    level: 3,
    description:
      'Trastorno hiperactivo asociado con retraso mental y movimientos estereotipados',
    code_2: 'F84',
    code_0: 'F01-F99',
    code_1: 'F80-F89'
  },
  {
    code: 'F845',
    level: 3,
    description: 'S\u00edndrome de Asperger',
    code_2: 'F84',
    code_0: 'F01-F99',
    code_1: 'F80-F89'
  },
  {
    code: 'F848',
    level: 3,
    description: 'Otros trastornos generalizados del desarrollo',
    code_2: 'F84',
    code_0: 'F01-F99',
    code_1: 'F80-F89'
  },
  {
    code: 'F849',
    level: 3,
    description: 'Trastorno generalizado del desarrollo no especificado',
    code_2: 'F84',
    code_0: 'F01-F99',
    code_1: 'F80-F89'
  },
  {
    code: 'O140',
    level: 3,
    description: 'Preeclampsia moderada',
    code_2: 'O14',
    code_0: 'O00-O9A',
    code_1: 'O10-O16'
  },
  {
    code: 'O141',
    level: 3,
    description: 'Preeclampsia severa',
    code_2: 'O14',
    code_0: 'O00-O9A',
    code_1: 'O10-O16'
  },
  {
    code: 'O149',
    level: 3,
    description: 'Preeclampsia, no especificada',
    code_2: 'O14',
    code_0: 'O00-O9A',
    code_1: 'O10-O16'
  },
  {
    code: 'Q219',
    level: 3,
    description:
      'Malformaci\u00f3n cong\u00e9nita del tabique card\u00edaco, no especificada',
    code_2: 'Q21',
    code_0: 'Q00-Q99',
    code_1: 'Q20-Q28'
  },
  {
    code: 'T230',
    level: 4,
    description:
      'Quemadura de la mu\u00f1eca y de la mano, grado no especificado',
    code_3: 'T23',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T231',
    level: 4,
    description: 'Quemadura de la mu\u00f1eca y de la mano, de primer grado',
    code_3: 'T23',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T232',
    level: 4,
    description: 'Quemadura de la mu\u00f1eca y de la mano, de segundo grado',
    code_3: 'T23',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T233',
    level: 4,
    description: 'Quemadura de la mu\u00f1eca y de la mano, de tercer grado',
    code_3: 'T23',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T234',
    level: 4,
    description:
      'Corrosi\u00f3n de la mu\u00f1eca y de la mano, grado no especificado',
    code_3: 'T23',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T220',
    level: 4,
    description:
      'Quemadura del hombro y miembro superior, grado no especificado, excepto de la mu\u00f1eca y de la mano',
    code_3: 'T22',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T221',
    level: 4,
    description:
      'Quemadura del hombro y miembro superior, de primer grado, excepto de la mu\u00f1eca y de la mano',
    code_3: 'T22',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T222',
    level: 4,
    description:
      'Quemadura del hombro y miembro superior, de segundo grado, excepto de la mu\u00f1eca y de la mano',
    code_3: 'T22',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T223',
    level: 4,
    description:
      'Quemadura del hombro y miembro superior, de tercer grado, excepto de la mu\u00f1eca y de la mano',
    code_3: 'T22',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T224',
    level: 4,
    description:
      'Corrosi\u00f3n del hombro y miembro superior, grado no especificado, excepto de la mu\u00f1eca y de la mano',
    code_3: 'T22',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T225',
    level: 4,
    description:
      'Corrosi\u00f3n del hombro y miembro superior, de primer grado, excepto de la mu\u00f1eca y de la mano',
    code_3: 'T22',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T210',
    level: 4,
    description: 'Quemadura del tronco, grado no especificado',
    code_3: 'T21',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T211',
    level: 4,
    description: 'Quemadura del tronco, de primer grado',
    code_3: 'T21',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T212',
    level: 4,
    description: 'Quemadura del tronco, de segundo grado',
    code_3: 'T21',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T213',
    level: 4,
    description: 'Quemadura del tronco, de tercer grado',
    code_3: 'T21',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T214',
    level: 4,
    description: 'Corrosi\u00f3n del tronco, grado no especificado',
    code_3: 'T21',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T215',
    level: 4,
    description: 'Corrosi\u00f3n del tronco, de primer grado',
    code_3: 'T21',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T216',
    level: 4,
    description: 'Corrosi\u00f3n del tronco, de segundo grado',
    code_3: 'T21',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T217',
    level: 4,
    description: 'Corrosi\u00f3n del tronco, de tercer grado',
    code_3: 'T21',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T200',
    level: 4,
    description: 'Quemadura de la cabeza y del cuello, grado no especificado',
    code_3: 'T20',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T201',
    level: 4,
    description: 'Quemadura de la cabeza y del cuello, de primer grado',
    code_3: 'T20',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T202',
    level: 4,
    description: 'Quemadura de la cabeza y del cuello, de segundo grado',
    code_3: 'T20',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T203',
    level: 4,
    description: 'Quemadura de la cabeza y del cuello, de tercer grado',
    code_3: 'T20',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T204',
    level: 4,
    description:
      'Corrosi\u00f3n de la cabeza y del cuello, grado no especificado',
    code_3: 'T20',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T205',
    level: 4,
    description: 'Corrosi\u00f3n de la cabeza y del cuello, de primer grado',
    code_3: 'T20',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T206',
    level: 4,
    description: 'Corrosi\u00f3n de la cabeza y del cuello, de segundo grado',
    code_3: 'T20',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T207',
    level: 4,
    description: 'Corrosi\u00f3n de la cabeza y del cuello, de tercer grado',
    code_3: 'T20',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T280',
    level: 4,
    description: 'Quemadura de la boca y de la faringe',
    code_3: 'T28',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T26-T28'
  },
  {
    code: 'T281',
    level: 4,
    description: 'Quemadura del es\u00f3fago',
    code_3: 'T28',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T26-T28'
  },
  {
    code: 'T282',
    level: 4,
    description: 'Quemadura de otras partes del tubo digestivo',
    code_3: 'T28',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T26-T28'
  },
  {
    code: 'T283',
    level: 4,
    description: 'Quemadura de \u00f3rganos genitourinarios internos',
    code_3: 'T28',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T26-T28'
  },
  {
    code: 'T284',
    level: 4,
    description:
      'Quemadura de otros \u00f3rganos internos y de los no especificados',
    code_3: 'T28',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T26-T28'
  },
  {
    code: 'T285',
    level: 4,
    description: 'Corrosi\u00f3n de la boca y de la faringe',
    code_3: 'T28',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T26-T28'
  },
  {
    code: 'T286',
    level: 4,
    description: 'Corrosi\u00f3n del es\u00f3fago',
    code_3: 'T28',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T26-T28'
  },
  {
    code: 'T287',
    level: 4,
    description: 'Corrosi\u00f3n de otras partes del tubo digestivo',
    code_3: 'T28',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T26-T28'
  },
  {
    code: 'T270',
    level: 4,
    description: 'Quemadura de la laringe y de la tr\u00e1quea',
    code_3: 'T27',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T26-T28'
  },
  {
    code: 'T271',
    level: 4,
    description:
      'Quemadura que afecta la laringe y la tr\u00e1quea con el pulm\u00f3n',
    code_3: 'T27',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T26-T28'
  },
  {
    code: 'T272',
    level: 4,
    description: 'Quemadura de otras partes de las v\u00edas respiratorias',
    code_3: 'T27',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T26-T28'
  },
  {
    code: 'T273',
    level: 4,
    description:
      'Quemadura de las v\u00edas respiratorias, parte no especificada',
    code_3: 'T27',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T26-T28'
  },
  {
    code: 'T274',
    level: 4,
    description: 'Corrosi\u00f3n de la laringe y de la tr\u00e1quea',
    code_3: 'T27',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T26-T28'
  },
  {
    code: 'T275',
    level: 4,
    description:
      'Corrosi\u00f3n que afecta la laringe y la tr\u00e1quea con el pulm\u00f3n',
    code_3: 'T27',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T26-T28'
  },
  {
    code: 'T260',
    level: 4,
    description: 'Quemadura del p\u00e1rpado y \u00e1rea periocular',
    code_3: 'T26',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T26-T28'
  },
  {
    code: 'T261',
    level: 4,
    description: 'Quemadura de la c\u00f3rnea y saco conjuntival',
    code_3: 'T26',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T26-T28'
  },
  {
    code: 'T262',
    level: 4,
    description:
      'Quemadura con ruptura y destrucci\u00f3n resultantes del globo ocular',
    code_3: 'T26',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T26-T28'
  },
  {
    code: 'T263',
    level: 4,
    description: 'Quemadura de otras partes del ojo y sus anexos',
    code_3: 'T26',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T26-T28'
  },
  {
    code: 'T264',
    level: 4,
    description: 'Quemadura del ojo y anexos, parte no especificada',
    code_3: 'T26',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T26-T28'
  },
  {
    code: 'T265',
    level: 4,
    description: 'Corrosi\u00f3n del p\u00e1rpado y \u00e1rea periocular',
    code_3: 'T26',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T26-T28'
  },
  {
    code: 'T266',
    level: 4,
    description: 'Corrosi\u00f3n de la c\u00f3rnea y saco conjuntival',
    code_3: 'T26',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T26-T28'
  },
  {
    code: 'T267',
    level: 4,
    description:
      'Corrosi\u00f3n con ruptura y destrucci\u00f3n resultantes del globo ocular',
    code_3: 'T26',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T26-T28'
  },
  {
    code: 'T268',
    level: 4,
    description: 'Corrosi\u00f3n de otras partes del ojo y sus anexos',
    code_3: 'T26',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T26-T28'
  },
  {
    code: 'T300',
    level: 4,
    description: 'Quemadura de regi\u00f3n del cuerpo y grado no especificados',
    code_3: 'T30',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T29-T32'
  },
  {
    code: 'T301',
    level: 4,
    description:
      'Quemadura de primer grado, regi\u00f3n del cuerpo no especificada',
    code_3: 'T30',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T29-T32'
  },
  {
    code: 'T302',
    level: 4,
    description:
      'Quemadura de segundo grado, regi\u00f3n del cuerpo no especificada',
    code_3: 'T30',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T29-T32'
  },
  {
    code: 'T303',
    level: 4,
    description:
      'Quemadura de tercer grado, regi\u00f3n del cuerpo no especificada',
    code_3: 'T30',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T29-T32'
  },
  {
    code: 'T304',
    level: 4,
    description:
      'Corrosi\u00f3n de regi\u00f3n del cuerpo y grado no especificados',
    code_3: 'T30',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T29-T32'
  },
  {
    code: 'T305',
    level: 4,
    description:
      'Corrosi\u00f3n de primer grado, regi\u00f3n del cuerpo no especificada',
    code_3: 'T30',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T29-T32'
  },
  {
    code: 'T306',
    level: 4,
    description:
      'Corrosi\u00f3n de segundo grado, regi\u00f3n del cuerpo no especificada',
    code_3: 'T30',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T29-T32'
  },
  {
    code: 'T307',
    level: 4,
    description:
      'Corrosi\u00f3n de tercer grado, regi\u00f3n del cuerpo no especificada',
    code_3: 'T30',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T29-T32'
  },
  {
    code: 'T290',
    level: 4,
    description: 'Quemaduras de m\u00faltiples regiones, grado no especificado',
    code_3: 'T29',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T29-T32'
  },
  {
    code: 'T291',
    level: 4,
    description:
      'Quemaduras de m\u00faltiples regiones, mencionadas como de no m\u00e1s de primer grado',
    code_3: 'T29',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T29-T32'
  },
  {
    code: 'T292',
    level: 4,
    description:
      'Quemaduras de m\u00faltiples regiones, mencionadas como de no m\u00e1s de segundo grado',
    code_3: 'T29',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T29-T32'
  },
  {
    code: 'T293',
    level: 4,
    description:
      'Quemaduras m\u00faltiples, con menci\u00f3n al menos de una quemadura de tercer grado',
    code_3: 'T29',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T29-T32'
  },
  {
    code: 'T294',
    level: 4,
    description:
      'Corrosiones de m\u00faltiples regiones, grado no especificado',
    code_3: 'T29',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T29-T32'
  },
  {
    code: 'T295',
    level: 4,
    description:
      'Corrosiones m\u00faltiples, mencionadas como de no m\u00e1s de primer grado',
    code_3: 'T29',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T29-T32'
  },
  {
    code: 'T296',
    level: 4,
    description:
      'Corrosiones m\u00faltiples, mencionadas como de no m\u00e1s de segundo grado',
    code_3: 'T29',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T29-T32'
  },
  {
    code: 'T297',
    level: 4,
    description:
      'Corrosiones m\u00faltiples, con menci\u00f3n al menos de una corrosi\u00f3n de tercer grado',
    code_3: 'T29',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T29-T32'
  },
  {
    code: 'O120',
    level: 3,
    description: 'Edema gestacional',
    code_2: 'O12',
    code_0: 'O00-O9A',
    code_1: 'O10-O16'
  },
  {
    code: 'O121',
    level: 3,
    description: 'Proteinuria gestacional',
    code_2: 'O12',
    code_0: 'O00-O9A',
    code_1: 'O10-O16'
  },
  {
    code: 'O122',
    level: 3,
    description: 'Edema gestacional con proteinuria',
    code_2: 'O12',
    code_0: 'O00-O9A',
    code_1: 'O10-O16'
  },
  {
    code: 'O100',
    level: 3,
    description:
      'Hipertensi\u00f3n esencial preexistente que complica el embarazo, el parto y el puerperio',
    code_2: 'O10',
    code_0: 'O00-O9A',
    code_1: 'O10-O16'
  },
  {
    code: 'O101',
    level: 3,
    description:
      'Enfermedad card\u00edaca hipertensiva preexistente que complica el embarazo, el parto y el puerperio',
    code_2: 'O10',
    code_0: 'O00-O9A',
    code_1: 'O10-O16'
  },
  {
    code: 'O102',
    level: 3,
    description:
      'Enfermedad renal hipertensiva preexistente que complica el embarazo, el parto y el puerperio',
    code_2: 'O10',
    code_0: 'O00-O9A',
    code_1: 'O10-O16'
  },
  {
    code: 'O103',
    level: 3,
    description:
      'Enfermedad cardiorrenal hipertensiva preexistente que complica el embarazo, el parto y el puerperio',
    code_2: 'O10',
    code_0: 'O00-O9A',
    code_1: 'O10-O16'
  },
  {
    code: 'O104',
    level: 3,
    description:
      'Hipertensi\u00f3n secundaria preexistente que complica el embarazo, el parto y el puerperio',
    code_2: 'O10',
    code_0: 'O00-O9A',
    code_1: 'O10-O16'
  },
  {
    code: 'O109',
    level: 3,
    description:
      'Hipertensi\u00f3n preexistente no especificada, que complica el embarazo, el parto y el puerperio',
    code_2: 'O10',
    code_0: 'O00-O9A',
    code_1: 'O10-O16'
  },
  {
    code: 'S090',
    level: 3,
    description:
      'Traumatismo de los vasos sangu\u00edneos de la cabeza no clasificados en otra parte',
    code_2: 'S09',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S091',
    level: 3,
    description: 'Traumatismo de tend\u00f3n y m\u00fasculos de la cabeza',
    code_2: 'S09',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S092',
    level: 3,
    description: 'Ruptura traum\u00e1tica del t\u00edmpano del o\u00eddo',
    code_2: 'S09',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S097',
    level: 3,
    description: 'Traumatismos m\u00faltiples de la cabeza',
    code_2: 'S09',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S098',
    level: 3,
    description: 'Otros traumatismos de la cabeza, especificados',
    code_2: 'S09',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S099',
    level: 3,
    description: 'Traumatismo de la cabeza, no especificado',
    code_2: 'S09',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S080',
    level: 3,
    description: 'Avulsi\u00f3n del cuero cabelludo',
    code_2: 'S08',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S081',
    level: 3,
    description: 'Amputaci\u00f3n traum\u00e1tica de la oreja',
    code_2: 'S08',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S088',
    level: 3,
    description: 'Amputaci\u00f3n traum\u00e1tica de otras partes de la cabeza',
    code_2: 'S08',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S089',
    level: 3,
    description:
      'Amputaci\u00f3n traum\u00e1tica de parte no especificada de la cabeza',
    code_2: 'S08',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S070',
    level: 3,
    description: 'Traumatismo por aplastamiento de la cara',
    code_2: 'S07',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S071',
    level: 3,
    description: 'Traumatismo por aplastamiento del cr\u00e1neo',
    code_2: 'S07',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S078',
    level: 3,
    description: 'Traumatismo por aplastamiento de otras partes de la cabeza',
    code_2: 'S07',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S079',
    level: 3,
    description:
      'Traumatismo por aplastamiento de la cabeza, parte no especificada',
    code_2: 'S07',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S060',
    level: 3,
    description: 'Concusi\u00f3n',
    code_2: 'S06',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S061',
    level: 3,
    description: 'Edema cerebral traum\u00e1tico',
    code_2: 'S06',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S062',
    level: 3,
    description: 'Traumatismo cerebral difuso',
    code_2: 'S06',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S063',
    level: 3,
    description: 'Traumatismo cerebral focal',
    code_2: 'S06',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S064',
    level: 3,
    description: 'Hemorragia epidural',
    code_2: 'S06',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S065',
    level: 3,
    description: 'Hemorragia subdural traum\u00e1tica',
    code_2: 'S06',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S066',
    level: 3,
    description: 'Hemorragia subaracnoidea traum\u00e1tica',
    code_2: 'S06',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S067',
    level: 3,
    description: 'Traumatismo intracraneal con coma prolongado',
    code_2: 'S06',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S068',
    level: 3,
    description: 'Otros traumatismos intracraneales',
    code_2: 'S06',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S069',
    level: 3,
    description: 'Traumatismo intracraneal, no especificado',
    code_2: 'S06',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S050',
    level: 3,
    description:
      'Traumatismo de la conjuntiva y abrasi\u00f3n corneal sin menci\u00f3n de cuerpo extra\u00f1o',
    code_2: 'S05',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S051',
    level: 3,
    description: 'Contusi\u00f3n del globo ocular y del tejido orbitario',
    code_2: 'S05',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S040',
    level: 3,
    description:
      'Traumatismo del nervio \u00f3ptico [II par] y de las v\u00edas \u00f3pticas',
    code_2: 'S04',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S041',
    level: 3,
    description: 'Traumatismo del nervio motor ocular com\u00fan [III par]',
    code_2: 'S04',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S042',
    level: 3,
    description: 'Traumatismo del nervio pat\u00e9tico [IV par]',
    code_2: 'S04',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S197',
    level: 3,
    description: 'Traumatismos m\u00faltiples del cuello',
    code_2: 'S19',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S198',
    level: 3,
    description: 'Otros traumatismos del cuello, especificados',
    code_2: 'S19',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S199',
    level: 3,
    description: 'Traumatismo del cuello, no especificado',
    code_2: 'S19',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S170',
    level: 3,
    description:
      'Traumatismo por aplastamiento de la laringe y de la tr\u00e1quea',
    code_2: 'S17',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S178',
    level: 3,
    description: 'Traumatismo por aplastamiento de otras partes del cuello',
    code_2: 'S17',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S179',
    level: 3,
    description:
      'Traumatismo por aplastamiento del cuello, parte no especificada',
    code_2: 'S17',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S150',
    level: 3,
    description: 'Traumatismo de la arteria car\u00f3tida',
    code_2: 'S15',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S151',
    level: 3,
    description: 'Traumatismo de la arteria vertebral',
    code_2: 'S15',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S152',
    level: 3,
    description: 'Traumatismo de la vena yugular externa',
    code_2: 'S15',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S153',
    level: 3,
    description: 'Traumatismo de la vena yugular interna',
    code_2: 'S15',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S157',
    level: 3,
    description:
      'Traumatismo de m\u00faltiples vasos sangu\u00edneos a nivel del cuello',
    code_2: 'S15',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S140',
    level: 3,
    description: 'Concusi\u00f3n y edema de la m\u00e9dula espinal cervical',
    code_2: 'S14',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S141',
    level: 3,
    description:
      'Otros traumatismos de la m\u00e9dula espinal cervical y los no especificados',
    code_2: 'S14',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S142',
    level: 3,
    description: 'Traumatismo de ra\u00edz nerviosa de columna cervical',
    code_2: 'S14',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S143',
    level: 3,
    description: 'Traumatismo del plexo braquial',
    code_2: 'S14',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S144',
    level: 3,
    description: 'Traumatismo de nervios perif\u00e9ricos del cuello',
    code_2: 'S14',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S145',
    level: 3,
    description: 'Traumatismo de nervios cervicales simp\u00e1ticos',
    code_2: 'S14',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S130',
    level: 3,
    description: 'Ruptura traum\u00e1tica de disco cervical intervertebral',
    code_2: 'S13',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S131',
    level: 3,
    description: 'Luxaci\u00f3n de v\u00e9rtebra cervical',
    code_2: 'S13',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S132',
    level: 3,
    description:
      'Luxaciones de otras partes y de las no especificadas del cuello',
    code_2: 'S13',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S133',
    level: 3,
    description: 'Luxaciones m\u00faltiples del cuello',
    code_2: 'S13',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S134',
    level: 3,
    description: 'Esguinces y torceduras de la columna cervical',
    code_2: 'S13',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S135',
    level: 3,
    description: 'Esguinces y torceduras de la regi\u00f3n tiroidea',
    code_2: 'S13',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S136',
    level: 3,
    description:
      'Esguinces y torceduras de articulaciones y ligamentos de otros sitios especificados y de los no especificados del cuello',
    code_2: 'S13',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S120',
    level: 3,
    description: 'Fractura de la primera v\u00e9rtebra cervical',
    code_2: 'S12',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S121',
    level: 3,
    description: 'Fractura de la segunda v\u00e9rtebra cervical',
    code_2: 'S12',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S122',
    level: 3,
    description: 'Fractura de otras v\u00e9rtebras cervicales especificadas',
    code_2: 'S12',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S127',
    level: 3,
    description: 'Fracturas m\u00faltiples de columna cervical',
    code_2: 'S12',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S128',
    level: 3,
    description: 'Fractura de otras partes del cuello',
    code_2: 'S12',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S129',
    level: 3,
    description: 'Fractura del cuello, parte no especificada',
    code_2: 'S12',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'O260',
    level: 3,
    description: 'Aumento excesivo de peso en el embarazo',
    code_2: 'O26',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O261',
    level: 3,
    description: 'Aumento peque\u00f1o de peso en el embarazo',
    code_2: 'O26',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O262',
    level: 3,
    description: 'Atenci\u00f3n del embarazo en una abortadora habitual',
    code_2: 'O26',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O263',
    level: 3,
    description:
      'Retenci\u00f3n de dispositivo anticonceptivo intrauterino en el embarazo',
    code_2: 'O26',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O240',
    level: 3,
    description:
      'Diabetes mellitus preexistente insulinodependiente, en el embarazo',
    code_2: 'O24',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O241',
    level: 3,
    description:
      'Diabetes mellitus preexistente no insulinodependiente, en el embarazo',
    code_2: 'O24',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O242',
    level: 3,
    description:
      'Diabetes mellitus preexistente relacionada con desnutrici\u00f3n, en el embarazo',
    code_2: 'O24',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O243',
    level: 3,
    description:
      'Diabetes mellitus preexistente, sin otra especificaci\u00f3n, en el embarazo',
    code_2: 'O24',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O244',
    level: 3,
    description: 'Diabetes mellitus que se origina con el embarazo',
    code_2: 'O24',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O230',
    level: 3,
    description: 'Infecci\u00f3n del ri\u00f1\u00f3n en el embarazo',
    code_2: 'O23',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O231',
    level: 3,
    description: 'Infecci\u00f3n de la vejiga urinaria en el embarazo',
    code_2: 'O23',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O232',
    level: 3,
    description: 'Infecci\u00f3n de la uretra en el embarazo',
    code_2: 'O23',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O233',
    level: 3,
    description:
      'Infecci\u00f3n de otras partes de las v\u00edas urinarias en el embarazo',
    code_2: 'O23',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O234',
    level: 3,
    description:
      'Infecci\u00f3n no especificada de las v\u00edas urinarias en el embarazo',
    code_2: 'O23',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O235',
    level: 3,
    description: 'Infecci\u00f3n genital en el embarazo',
    code_2: 'O23',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O239',
    level: 3,
    description:
      'Otras infecciones y las no especificadas de las v\u00edas genitourinarias en el embarazo',
    code_2: 'O23',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O220',
    level: 3,
    description: 'Venas varicosas de los miembros inferiores en el embarazo',
    code_2: 'O22',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O221',
    level: 3,
    description: 'V\u00e1rices genitales en el embarazo',
    code_2: 'O22',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O222',
    level: 3,
    description: 'Tromboflebitis superficial en el embarazo',
    code_2: 'O22',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O223',
    level: 3,
    description: 'Flebotrombosis profunda en el embarazo',
    code_2: 'O22',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O224',
    level: 3,
    description: 'Hemorroides en el embarazo',
    code_2: 'O22',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O225',
    level: 3,
    description: 'Trombosis venosa cerebral en el embarazo',
    code_2: 'O22',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O228',
    level: 3,
    description: 'Otras complicaciones venosas en el embarazo',
    code_2: 'O22',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O229',
    level: 3,
    description: 'Complicaci\u00f3n venosa no especificada en el embarazo',
    code_2: 'O22',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O210',
    level: 3,
    description: 'Hiperemesis grav\u00eddica leve',
    code_2: 'O21',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O211',
    level: 3,
    description: 'Hiperemesis grav\u00eddica con trastornos metab\u00f3licos',
    code_2: 'O21',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O212',
    level: 3,
    description: 'Hiperemesis grav\u00eddica tard\u00eda',
    code_2: 'O21',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O218',
    level: 3,
    description: 'Otros v\u00f3mitos que complican el embarazo',
    code_2: 'O21',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O219',
    level: 3,
    description: 'V\u00f3mitos del embarazo, no especificados',
    code_2: 'O21',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O200',
    level: 3,
    description: 'Amenaza de aborto',
    code_2: 'O20',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O208',
    level: 3,
    description: 'Otras hemorragias precoces del embarazo',
    code_2: 'O20',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O209',
    level: 3,
    description: 'Hemorragia precoz del embarazo, sin otra especificaci\u00f3n',
    code_2: 'O20',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'S290',
    level: 3,
    description:
      'Traumatismo de tend\u00f3n y m\u00fasculos a nivel del t\u00f3rax',
    code_2: 'S29',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S297',
    level: 3,
    description: 'Traumatismos m\u00faltiples del t\u00f3rax',
    code_2: 'S29',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S298',
    level: 3,
    description: 'Otros traumatismos del t\u00f3rax, especificados',
    code_2: 'S29',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S299',
    level: 3,
    description: 'Traumatismo del t\u00f3rax, no especificado',
    code_2: 'S29',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S280',
    level: 3,
    description: 'Aplastamiento del t\u00f3rax',
    code_2: 'S28',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S281',
    level: 3,
    description: 'Amputaci\u00f3n traum\u00e1tica de parte del t\u00f3rax',
    code_2: 'S28',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S270',
    level: 3,
    description: 'Neumot\u00f3rax traum\u00e1tico',
    code_2: 'S27',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S271',
    level: 3,
    description: 'Hemot\u00f3rax traum\u00e1tico',
    code_2: 'S27',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S272',
    level: 3,
    description: 'Hemoneumot\u00f3rax traum\u00e1tico',
    code_2: 'S27',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S273',
    level: 3,
    description: 'Otros traumatismos del pulm\u00f3n',
    code_2: 'S27',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S274',
    level: 3,
    description: 'Traumatismo de los bronquios',
    code_2: 'S27',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S275',
    level: 3,
    description: 'Traumatismo de la tr\u00e1quea tor\u00e1cica',
    code_2: 'S27',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S276',
    level: 3,
    description: 'Traumatismo de la pleura',
    code_2: 'S27',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S277',
    level: 3,
    description:
      'Traumatismos m\u00faltiples de \u00f3rganos intrator\u00e1cicos',
    code_2: 'S27',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S278',
    level: 3,
    description:
      'Traumatismo de otros \u00f3rganos intrator\u00e1cicos, especificados',
    code_2: 'S27',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S260',
    level: 3,
    description: 'Traumatismo del coraz\u00f3n con hemopericardio',
    code_2: 'S26',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S268',
    level: 3,
    description: 'Otros traumatismos del coraz\u00f3n',
    code_2: 'S26',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S269',
    level: 3,
    description: 'Traumatismo del coraz\u00f3n, no especificado',
    code_2: 'S26',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S250',
    level: 3,
    description: 'Traumatismo de la aorta tor\u00e1cica',
    code_2: 'S25',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S251',
    level: 3,
    description: 'Traumatismo de la arteria innominada o subclavia',
    code_2: 'S25',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S252',
    level: 3,
    description: 'Traumatismo de vena cava superior',
    code_2: 'S25',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S253',
    level: 3,
    description: 'Traumatismo de la vena innominada o subclavia',
    code_2: 'S25',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S254',
    level: 3,
    description: 'Traumatismo de vasos sangu\u00edneos pulmonares',
    code_2: 'S25',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S255',
    level: 3,
    description: 'Traumatismo de vasos sangu\u00edneos intercostales',
    code_2: 'S25',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S257',
    level: 3,
    description:
      'Traumatismo de m\u00faltiples vasos sangu\u00edneos del t\u00f3rax',
    code_2: 'S25',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S258',
    level: 3,
    description: 'Traumatismo de otros vasos sangu\u00edneos del t\u00f3rax',
    code_2: 'S25',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S259',
    level: 3,
    description:
      'Traumatismo de vasos sangu\u00edneos no especificados del t\u00f3rax',
    code_2: 'S25',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S240',
    level: 3,
    description:
      'Concusi\u00f3n y edema de la m\u00e9dula espinal tor\u00e1cica',
    code_2: 'S24',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S241',
    level: 3,
    description:
      'Otros traumatismos y los no especificados de la m\u00e9dula espinal tor\u00e1cica',
    code_2: 'S24',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S242',
    level: 3,
    description:
      'Traumatismo de ra\u00edces nerviosas de la columna tor\u00e1cica',
    code_2: 'S24',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S243',
    level: 3,
    description: 'Traumatismo de nervios perif\u00e9ricos del t\u00f3rax',
    code_2: 'S24',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S244',
    level: 3,
    description: 'Traumatismo de nervios simp\u00e1ticos tor\u00e1cicos',
    code_2: 'S24',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S245',
    level: 3,
    description: 'Traumatismo de otros nervios del t\u00f3rax',
    code_2: 'S24',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S246',
    level: 3,
    description: 'Traumatismo de nervio no especificado del t\u00f3rax',
    code_2: 'S24',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S380',
    level: 3,
    description:
      'Traumatismo por aplastamiento de \u00f3rganos genitales externos',
    code_2: 'S38',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S381',
    level: 3,
    description:
      'Traumatismo por aplastamiento de otras partes y de las no especificadas del abdomen, de la regi\u00f3n lumbosacra y de la pelvis',
    code_2: 'S38',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S382',
    level: 3,
    description:
      'Amputaci\u00f3n traum\u00e1tica de \u00f3rganos genitales externos',
    code_2: 'S38',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S383',
    level: 3,
    description:
      'Amputaci\u00f3n traum\u00e1tica de otras partes y de las no especificadas del abdomen, regi\u00f3n lumbosacra y pelvis',
    code_2: 'S38',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S370',
    level: 3,
    description: 'Traumatismo del ri\u00f1\u00f3n',
    code_2: 'S37',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S371',
    level: 3,
    description: 'Traumatismo del ur\u00e9ter',
    code_2: 'S37',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S372',
    level: 3,
    description: 'Traumatismo de la vejiga',
    code_2: 'S37',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S373',
    level: 3,
    description: 'Traumatismo de la uretra',
    code_2: 'S37',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S374',
    level: 3,
    description: 'Traumatismo del ovario',
    code_2: 'S37',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S375',
    level: 3,
    description: 'Traumatismo de la trompa de Falopio',
    code_2: 'S37',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S376',
    level: 3,
    description: 'Traumatismo del \u00fatero',
    code_2: 'S37',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S377',
    level: 3,
    description: 'Traumatismo de m\u00faltiples \u00f3rganos p\u00e9lvicos',
    code_2: 'S37',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S378',
    level: 3,
    description: 'Traumatismo de otros \u00f3rganos p\u00e9lvicos',
    code_2: 'S37',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S379',
    level: 3,
    description: 'Traumatismo de \u00f3rgano p\u00e9lvico no especificado',
    code_2: 'S37',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S360',
    level: 3,
    description: 'Traumatismo del bazo',
    code_2: 'S36',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S361',
    level: 3,
    description: 'Traumatismo del h\u00edgado y de la ves\u00edcula biliar',
    code_2: 'S36',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S362',
    level: 3,
    description: 'Traumatismo del p\u00e1ncreas',
    code_2: 'S36',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S363',
    level: 3,
    description: 'Traumatismo del est\u00f3mago',
    code_2: 'S36',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S364',
    level: 3,
    description: 'Traumatismo del intestino delgado',
    code_2: 'S36',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S365',
    level: 3,
    description: 'Traumatismo del colon',
    code_2: 'S36',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S366',
    level: 3,
    description: 'Traumatismo del recto',
    code_2: 'S36',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S367',
    level: 3,
    description: 'Traumatismo de m\u00faltiples \u00f3rganos intraabdominales',
    code_2: 'S36',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S368',
    level: 3,
    description: 'Traumatismo de otros \u00f3rganos intraabdominales',
    code_2: 'S36',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S369',
    level: 3,
    description: 'Traumatismo de \u00f3rgano intraabdominal no especificado',
    code_2: 'S36',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S350',
    level: 3,
    description: 'Traumatismo de la aorta abdominal',
    code_2: 'S35',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S351',
    level: 3,
    description: 'Traumatismo de la vena cava inferior',
    code_2: 'S35',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S352',
    level: 3,
    description: 'Traumatismo de arterias cel\u00edacas y mesent\u00e9ricas',
    code_2: 'S35',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S353',
    level: 3,
    description: 'Traumatismo de venas porta y espl\u00e9nica',
    code_2: 'S35',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S354',
    level: 3,
    description: 'Traumatismo de vasos sangu\u00edneos renales',
    code_2: 'S35',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S355',
    level: 3,
    description: 'Traumatismo de vasos sangu\u00edneos iliacos',
    code_2: 'S35',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S357',
    level: 3,
    description:
      'Traumatismo de m\u00faltiples vasos sangu\u00edneos a nivel del abdomen, de la regi\u00f3n lumbosacra y de la pelvis',
    code_2: 'S35',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S358',
    level: 3,
    description:
      'Traumatismo de otros vasos sangu\u00edneos a nivel del abdomen, de la regi\u00f3n lumbosacra y de la pelvis',
    code_2: 'S35',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S359',
    level: 3,
    description:
      'Traumatismo de vasos sangu\u00edneos no especificados a nivel del abdomen, de la regi\u00f3n lumbosacra y de la pelvis',
    code_2: 'S35',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'E703',
    level: 3,
    description: 'Albinismo',
    code_2: 'E70',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E708',
    level: 3,
    description:
      'Otros trastornos del metabolismo de los amino\u00e1cidos arom\u00e1ticos',
    code_2: 'E70',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'E709',
    level: 3,
    description:
      'Trastorno del metabolismo de los amino\u00e1cidos arom\u00e1ticos, no especificado',
    code_2: 'E70',
    code_0: 'E00-E89',
    code_1: 'E70-E90'
  },
  {
    code: 'S340',
    level: 3,
    description: 'Concusi\u00f3n y edema de la m\u00e9dula espinal lumbar',
    code_2: 'S34',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S341',
    level: 3,
    description: 'Otro traumatismo de la m\u00e9dula espinal lumbar',
    code_2: 'S34',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S342',
    level: 3,
    description:
      'Traumatismo de ra\u00edz nerviosa de la columna lumbar y sacra',
    code_2: 'S34',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S343',
    level: 3,
    description: 'Traumatismo de la cola de caballo',
    code_2: 'S34',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S344',
    level: 3,
    description: 'Traumatismo del plexo lumbosacro',
    code_2: 'S34',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S345',
    level: 3,
    description:
      'Traumatismo de nervios(s) simp\u00e1tico(s) lumbar(es), sacro(s) y p\u00e9lvico(s)',
    code_2: 'S34',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S346',
    level: 3,
    description:
      'Traumatismo de nervio(s) perif\u00e9rico(s) del abdomen, de la regi\u00f3n lumbosacra y de la pelvis',
    code_2: 'S34',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S348',
    level: 3,
    description:
      'Traumatismo de otros nervios a nivel del abdomen, de la regi\u00f3n lumbosacra y de la pelvis y de los no especificados',
    code_2: 'S34',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'G574',
    level: 3,
    description: 'Lesi\u00f3n del nervio ci\u00e1tico popl\u00edteo interno',
    code_2: 'G57',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G575',
    level: 3,
    description: 'S\u00edndrome del t\u00fanel calc\u00e1neo',
    code_2: 'G57',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G576',
    level: 3,
    description: 'Lesi\u00f3n del nervio plantar',
    code_2: 'G57',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G578',
    level: 3,
    description: 'Otras mononeuropat\u00edas del miembro inferior',
    code_2: 'G57',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G579',
    level: 3,
    description:
      'Mononeuropat\u00eda del miembro inferior, sin otra especificaci\u00f3n',
    code_2: 'G57',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G562',
    level: 3,
    description: 'Lesi\u00f3n del nervio cubital',
    code_2: 'G56',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G563',
    level: 3,
    description: 'Lesi\u00f3n del nervio radial',
    code_2: 'G56',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G564',
    level: 3,
    description: 'Causalgia',
    code_2: 'G56',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G568',
    level: 3,
    description: 'Otras mononeuropat\u00edas del miembro superior',
    code_2: 'G56',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G569',
    level: 3,
    description:
      'Mononeuropat\u00eda del miembro superior, sin otra especificaci\u00f3n',
    code_2: 'G56',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'S330',
    level: 3,
    description: 'Ruptura traum\u00e1tica de disco intervertebral lumbar',
    code_2: 'S33',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S331',
    level: 3,
    description: 'Luxaci\u00f3n de v\u00e9rtebra lumbar',
    code_2: 'S33',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S332',
    level: 3,
    description:
      'Luxaci\u00f3n de articulaci\u00f3n sacrococc\u00edgea y sacroiliaca',
    code_2: 'S33',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S333',
    level: 3,
    description:
      'Luxaci\u00f3n de otras partes y de las no especificadas de la columna lumbar y de la pelvis',
    code_2: 'S33',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S334',
    level: 3,
    description: 'Ruptura traum\u00e1tica de la s\u00ednfisis del pubis',
    code_2: 'S33',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'G546',
    level: 3,
    description: 'S\u00edndrome del miembro fantasma con dolor',
    code_2: 'G54',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G547',
    level: 3,
    description: 'S\u00edndrome del miembro fantasma sin dolor',
    code_2: 'G54',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G548',
    level: 3,
    description: 'Otros trastornos de las ra\u00edces y plexos nerviosos',
    code_2: 'G54',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G549',
    level: 3,
    description:
      'Trastorno de la ra\u00edz y plexos nerviosos, no especificado',
    code_2: 'G54',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'P049',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por influencias nocivas de la madre, no especificadas',
    code_2: 'P04',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'S320',
    level: 3,
    description: 'Fractura de v\u00e9rtebra lumbar',
    code_2: 'S32',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S321',
    level: 3,
    description: 'Fractura del sacro',
    code_2: 'S32',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S322',
    level: 3,
    description: 'Fractura del c\u00f3ccix',
    code_2: 'S32',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S323',
    level: 3,
    description: 'Fractura del hueso iliaco',
    code_2: 'S32',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S324',
    level: 3,
    description: 'Fractura del acet\u00e1bulo',
    code_2: 'S32',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S325',
    level: 3,
    description: 'Fractura del pubis',
    code_2: 'S32',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S327',
    level: 3,
    description: 'Fracturas m\u00faltiples de la columna lumbar y de la pelvis',
    code_2: 'S32',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S328',
    level: 3,
    description:
      'Fractura de otras partes y de las no especificadas de la columna lumbar y de la pelvis',
    code_2: 'S32',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'P038',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por otras complicaciones especificadas del trabajo de parto y del parto',
    code_2: 'P03',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P039',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por complicaciones no especificadas del trabajo de parto y del parto',
    code_2: 'P03',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P027',
    level: 3,
    description: 'Feto y reci\u00e9n nacido afectados por corioamnionitis',
    code_2: 'P02',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P028',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por otras anormalidades de las membranas',
    code_2: 'P02',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P029',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por anormalidad no especificada de las membranas',
    code_2: 'P02',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P019',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por complicaciones maternas no especificadas del embarazo',
    code_2: 'P01',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'P009',
    level: 3,
    description:
      'Feto y reci\u00e9n nacido afectados por afecci\u00f3n materna no especificada',
    code_2: 'P00',
    code_0: 'P00-P96',
    code_1: 'P00-P04'
  },
  {
    code: 'G060',
    level: 3,
    description: 'Absceso y granuloma intracraneal',
    code_2: 'G06',
    code_0: 'G00-G99',
    code_1: 'G00-G09'
  },
  {
    code: 'G061',
    level: 3,
    description: 'Absceso y granuloma intrarraqu\u00eddeo',
    code_2: 'G06',
    code_0: 'G00-G99',
    code_1: 'G00-G09'
  },
  {
    code: 'G062',
    level: 3,
    description: 'Absceso extradural y subdural, no especificado',
    code_2: 'G06',
    code_0: 'G00-G99',
    code_1: 'G00-G09'
  },
  {
    code: 'G050',
    level: 3,
    description:
      'Encefalitis, mielitis y encefalomielitis en enfermedades bacterianas clasificadas en otra parte',
    code_2: 'G05',
    code_0: 'G00-G99',
    code_1: 'G00-G09'
  },
  {
    code: 'G051',
    level: 3,
    description:
      'Encefalitis, mielitis y encefalomielitis en enfermedades virales clasificadas en otra parte',
    code_2: 'G05',
    code_0: 'G00-G99',
    code_1: 'G00-G09'
  },
  {
    code: 'G052',
    level: 3,
    description:
      'Encefalitis, mielitis y encefalomielitis en otras enfermedades infecciosas y parasitarias clasificadas en otra parte',
    code_2: 'G05',
    code_0: 'G00-G99',
    code_1: 'G00-G09'
  },
  {
    code: 'G058',
    level: 3,
    description:
      'Encefalitis, mielitis y encefalomielitis en enfermedades clasificadas en otra parte',
    code_2: 'G05',
    code_0: 'G00-G99',
    code_1: 'G00-G09'
  },
  {
    code: 'O340',
    level: 3,
    description:
      'Atenci\u00f3n materna por anomal\u00eda cong\u00e9nita del \u00fatero',
    code_2: 'O34',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O341',
    level: 3,
    description: 'Atenci\u00f3n materna por tumor del cuerpo del \u00fatero',
    code_2: 'O34',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O342',
    level: 3,
    description:
      'Atenci\u00f3n materna por cicatriz uterina debida a cirug\u00eda previa',
    code_2: 'O34',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O343',
    level: 3,
    description: 'Atenci\u00f3n materna por incompetencia del cuello uterino',
    code_2: 'O34',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O344',
    level: 3,
    description:
      'Atenci\u00f3n materna por otra anormalidad del cuello uterino',
    code_2: 'O34',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O345',
    level: 3,
    description:
      'Atenci\u00f3n materna por otras anormalidades del \u00fatero gr\u00e1vido',
    code_2: 'O34',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O330',
    level: 3,
    description:
      'Atenci\u00f3n materna por desproporci\u00f3n debida a deformidad de la pelvis \u00f3sea en la madre',
    code_2: 'O33',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O331',
    level: 3,
    description:
      'Atenci\u00f3n materna por desproporci\u00f3n debida a estrechez general de la pelvis',
    code_2: 'O33',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O332',
    level: 3,
    description:
      'Atenci\u00f3n materna por desproporci\u00f3n debida a disminuci\u00f3n del estrecho superior de la pelvis',
    code_2: 'O33',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O333',
    level: 3,
    description:
      'Atenci\u00f3n materna por desproporci\u00f3n debida a disminuci\u00f3n del estrecho inferior de la pelvis',
    code_2: 'O33',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O334',
    level: 3,
    description:
      'Atenci\u00f3n materna por desproporci\u00f3n fetopelviana de origen mixto, materno y fetal',
    code_2: 'O33',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O335',
    level: 3,
    description:
      'Atenci\u00f3n materna por desproporci\u00f3n debida a feto demasiado grande',
    code_2: 'O33',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O336',
    level: 3,
    description:
      'Atenci\u00f3n materna por desproporci\u00f3n debida a feto hidrocef\u00e1lico',
    code_2: 'O33',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O337',
    level: 3,
    description:
      'Atenci\u00f3n materna por desproporci\u00f3n debida a otra deformidad fetal',
    code_2: 'O33',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O338',
    level: 3,
    description: 'Atenci\u00f3n materna por desproporci\u00f3n de otro origen',
    code_2: 'O33',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O320',
    level: 3,
    description: 'Atenci\u00f3n materna por posici\u00f3n fetal inestable',
    code_2: 'O32',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O321',
    level: 3,
    description: 'Atenci\u00f3n materna por presentaci\u00f3n de nalgas',
    code_2: 'O32',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O322',
    level: 3,
    description:
      'Atenci\u00f3n materna por posici\u00f3n fetal oblicua o transversa',
    code_2: 'O32',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O323',
    level: 3,
    description:
      'Atenci\u00f3n materna por presentaci\u00f3n de cara, de frente o de ment\u00f3n',
    code_2: 'O32',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O324',
    level: 3,
    description:
      'Atenci\u00f3n materna por cabeza alta en gestaci\u00f3n a t\u00e9rmino',
    code_2: 'O32',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O325',
    level: 3,
    description:
      'Atenci\u00f3n materna por embarazo m\u00faltiple con presentaci\u00f3n anormal de un feto o m\u00e1s',
    code_2: 'O32',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O326',
    level: 3,
    description: 'Atenci\u00f3n materna por presentaci\u00f3n compuesta',
    code_2: 'O32',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O328',
    level: 3,
    description:
      'Atenci\u00f3n materna por otras presentaciones anormales del feto',
    code_2: 'O32',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O329',
    level: 3,
    description:
      'Atenci\u00f3n materna por presentaci\u00f3n anormal no especificada del feto',
    code_2: 'O32',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O310',
    level: 3,
    description: 'Feto papir\u00e1ceo',
    code_2: 'O31',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O311',
    level: 3,
    description:
      'Embarazo que contin\u00faa despu\u00e9s del aborto de un feto o m\u00e1s',
    code_2: 'O31',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O312',
    level: 3,
    description:
      'Embarazo que contin\u00faa despu\u00e9s de la muerte intrauterina de un feto o m\u00e1s',
    code_2: 'O31',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O318',
    level: 3,
    description:
      'Otras complicaciones espec\u00edficas del embarazo m\u00faltiple',
    code_2: 'O31',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O300',
    level: 3,
    description: 'Embarazo doble',
    code_2: 'O30',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O301',
    level: 3,
    description: 'Embarazo triple',
    code_2: 'O30',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O302',
    level: 3,
    description: 'Embarazo cu\u00e1druple',
    code_2: 'O30',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O308',
    level: 3,
    description: 'Otros embarazos m\u00faltiples',
    code_2: 'O30',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O309',
    level: 3,
    description: 'Embarazo m\u00faltiple, no especificado',
    code_2: 'O30',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'N130',
    level: 3,
    description:
      'Hidronefrosis con obstrucci\u00f3n de la uni\u00f3n ur\u00e9tero\u2013p\u00e9lvica',
    code_2: 'N13',
    code_0: 'N00-N99',
    code_1: 'N10-N16'
  },
  {
    code: 'N131',
    level: 3,
    description:
      'Hidronefrosis con estrechez ureteral, no clasificada en otra parte',
    code_2: 'N13',
    code_0: 'N00-N99',
    code_1: 'N10-N16'
  },
  {
    code: 'N132',
    level: 3,
    description:
      'Hidronefrosis con obstrucci\u00f3n por c\u00e1lculos del ri\u00f1\u00f3n y del ur\u00e9ter',
    code_2: 'N13',
    code_0: 'N00-N99',
    code_1: 'N10-N16'
  },
  {
    code: 'N133',
    level: 3,
    description: 'Otras hidronefrosis y las no especificadas',
    code_2: 'N13',
    code_0: 'N00-N99',
    code_1: 'N10-N16'
  },
  {
    code: 'N134',
    level: 3,
    description: 'Hidrour\u00e9ter',
    code_2: 'N13',
    code_0: 'N00-N99',
    code_1: 'N10-N16'
  },
  {
    code: 'N135',
    level: 3,
    description: 'Torsi\u00f3n y estrechez del ur\u00e9ter sin hidronefrosis',
    code_2: 'N13',
    code_0: 'N00-N99',
    code_1: 'N10-N16'
  },
  {
    code: 'N136',
    level: 3,
    description: 'Pionefrosis',
    code_2: 'N13',
    code_0: 'N00-N99',
    code_1: 'N10-N16'
  },
  {
    code: 'N137',
    level: 3,
    description: 'Uropat\u00eda asociada con reflujo vesicoureteral',
    code_2: 'N13',
    code_0: 'N00-N99',
    code_1: 'N10-N16'
  },
  {
    code: 'N138',
    level: 3,
    description: 'Otras uropat\u00edas obstructivas y por reflujo',
    code_2: 'N13',
    code_0: 'N00-N99',
    code_1: 'N10-N16'
  },
  {
    code: 'N139',
    level: 3,
    description:
      'Uropat\u00eda obstructiva y por reflujo, sin otra especificaci\u00f3n',
    code_2: 'N13',
    code_0: 'N00-N99',
    code_1: 'N10-N16'
  },
  {
    code: 'N110',
    level: 3,
    description:
      'Pielonefritis cr\u00f3nica no obstructiva asociada con reflujo',
    code_2: 'N11',
    code_0: 'N00-N99',
    code_1: 'N10-N16'
  },
  {
    code: 'N111',
    level: 3,
    description: 'Pielonefritis cr\u00f3nica obstructiva',
    code_2: 'N11',
    code_0: 'N00-N99',
    code_1: 'N10-N16'
  },
  {
    code: 'N118',
    level: 3,
    description: 'Otras nefritis tubulointersticiales cr\u00f3nicas',
    code_2: 'N11',
    code_0: 'N00-N99',
    code_1: 'N10-N16'
  },
  {
    code: 'N119',
    level: 3,
    description:
      'Nefritis tubulointersticial cr\u00f3nica, sin otra especificaci\u00f3n',
    code_2: 'N11',
    code_0: 'N00-N99',
    code_1: 'N10-N16'
  },
  {
    code: 'N180',
    level: 3,
    description: 'Insuficiencia renal terminal',
    code_2: 'N18',
    code_0: 'N00-N99',
    code_1: 'N17-N19'
  },
  {
    code: 'P375',
    level: 3,
    description: 'Candidiasis neonatal',
    code_2: 'P37',
    code_0: 'P00-P96',
    code_1: 'P35-P39'
  },
  {
    code: 'P378',
    level: 3,
    description:
      'Otras enfermedades neonatales infecciosas o parasitarias especificadas',
    code_2: 'P37',
    code_0: 'P00-P96',
    code_1: 'P35-P39'
  },
  {
    code: 'P379',
    level: 3,
    description:
      'Enfermedad infecciosa y parasitaria cong\u00e9nita, no especificada',
    code_2: 'P37',
    code_0: 'P00-P96',
    code_1: 'P35-P39'
  },
  {
    code: 'P369',
    level: 3,
    description: 'Sepsis bacteriana del reci\u00e9n nacido, no especificada',
    code_2: 'P36',
    code_0: 'P00-P96',
    code_1: 'P35-P39'
  },
  {
    code: 'P524',
    level: 3,
    description:
      'Hemorragia intracerebral (no traum\u00e1tica) del feto y del reci\u00e9n nacido',
    code_2: 'P52',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P525',
    level: 3,
    description:
      'Hemorragia subaracnoidea (no traum\u00e1tica) del feto y del reci\u00e9n nacido',
    code_2: 'P52',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P526',
    level: 3,
    description:
      'Hemorragia cerebelosa y de la fosa posterior (no traum\u00e1tica) del feto y del reci\u00e9n nacido',
    code_2: 'P52',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P528',
    level: 3,
    description:
      'Otras hemorragias intracraneales (no traum\u00e1ticas) del feto y del reci\u00e9n nacido',
    code_2: 'P52',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'P529',
    level: 3,
    description:
      'Hemorragia intracraneal (no traum\u00e1tica) del feto y del reci\u00e9n nacido, sin otra especificaci\u00f3n',
    code_2: 'P52',
    code_0: 'P00-P96',
    code_1: 'P50-P61'
  },
  {
    code: 'D824',
    level: 3,
    description: 'S\u00edndrome de hiperinmunoglobulina E [IgE]',
    code_2: 'D82',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D828',
    level: 3,
    description:
      'Inmunodeficiencia asociada con otros defectos mayores especificados',
    code_2: 'D82',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D829',
    level: 3,
    description:
      'Inmunodeficiencia asociada con defectos mayores no especificados',
    code_2: 'D82',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D818',
    level: 3,
    description: 'Otras inmunodeficiencias combinadas',
    code_2: 'D81',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'D819',
    level: 3,
    description: 'Inmunodeficiencia combinada, no especificada',
    code_2: 'D81',
    code_0: 'D50-D89',
    code_1: 'D80-D89'
  },
  {
    code: 'T250',
    level: 4,
    description: 'Quemadura del tobillo y del pie, grado no especificado',
    code_3: 'T25',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T251',
    level: 4,
    description: 'Quemadura del tobillo y del pie, de primer grado',
    code_3: 'T25',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T252',
    level: 4,
    description: 'Quemadura del tobillo y del pie, de segundo grado',
    code_3: 'T25',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T240',
    level: 4,
    description:
      'Quemadura de la cadera y miembro inferior, grado no especificado, excepto tobillo y pie',
    code_3: 'T24',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T241',
    level: 4,
    description:
      'Quemadura de la cadera y miembro inferior, de primer grado, excepto tobillo y pie',
    code_3: 'T24',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T242',
    level: 4,
    description:
      'Quemadura de la cadera y miembro inferior, de segundo grado, excepto tobillo y pie',
    code_3: 'T24',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T320',
    level: 4,
    description:
      'Corrosiones que afectan menos del 10% de la superficie del cuerpo',
    code_3: 'T32',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T29-T32'
  },
  {
    code: 'T321',
    level: 4,
    description:
      'Corrosiones que afectan del 10 al 19% de la superficie del cuerpo',
    code_3: 'T32',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T29-T32'
  },
  {
    code: 'T322',
    level: 4,
    description:
      'Corrosiones que afectan del 20 al 29% de la superficie del cuerpo',
    code_3: 'T32',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T29-T32'
  },
  {
    code: 'T323',
    level: 4,
    description:
      'Corrosiones que afectan del 30 al 39% de la superficie del cuerpo',
    code_3: 'T32',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T29-T32'
  },
  {
    code: 'T310',
    level: 4,
    description:
      'Quemaduras que afectan menos del 10% de la superficie del cuerpo',
    code_3: 'T31',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T29-T32'
  },
  {
    code: 'T311',
    level: 4,
    description:
      'Quemaduras que afectan del 10 al 19% de la superficie del cuerpo',
    code_3: 'T31',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T29-T32'
  },
  {
    code: 'T312',
    level: 4,
    description:
      'Quemaduras que afectan del 20 al 29% de la superficie del cuerpo',
    code_3: 'T31',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T29-T32'
  },
  {
    code: 'N170',
    level: 3,
    description: 'Insuficiencia renal aguda con necrosis tubular',
    code_2: 'N17',
    code_0: 'N00-N99',
    code_1: 'N17-N19'
  },
  {
    code: 'N171',
    level: 3,
    description: 'Insuficiencia renal aguda con necrosis cortical aguda',
    code_2: 'N17',
    code_0: 'N00-N99',
    code_1: 'N17-N19'
  },
  {
    code: 'N172',
    level: 3,
    description: 'Insuficiencia renal aguda con necrosis medular',
    code_2: 'N17',
    code_0: 'N00-N99',
    code_1: 'N17-N19'
  },
  {
    code: 'N178',
    level: 3,
    description: 'Otras insuficiencias renales agudas',
    code_2: 'N17',
    code_0: 'N00-N99',
    code_1: 'N17-N19'
  },
  {
    code: 'N220',
    level: 3,
    description:
      'Litiasis urinaria en esquistosomiasis [bilharziasis] (B65.\u2013)',
    code_2: 'N22',
    code_0: 'N00-N99',
    code_1: 'N20-N23'
  },
  {
    code: 'N228',
    level: 3,
    description:
      'C\u00e1lculo de las v\u00edas urinarias en otras enfermedades clasificadas en otra parte',
    code_2: 'N22',
    code_0: 'N00-N99',
    code_1: 'N20-N23'
  },
  {
    code: 'N210',
    level: 3,
    description: 'C\u00e1lculo en la vejiga',
    code_2: 'N21',
    code_0: 'N00-N99',
    code_1: 'N20-N23'
  },
  {
    code: 'N211',
    level: 3,
    description: 'C\u00e1lculo en la uretra',
    code_2: 'N21',
    code_0: 'N00-N99',
    code_1: 'N20-N23'
  },
  {
    code: 'N218',
    level: 3,
    description: 'Otros c\u00e1lculos de las v\u00edas urinarias inferiores',
    code_2: 'N21',
    code_0: 'N00-N99',
    code_1: 'N20-N23'
  },
  {
    code: 'N219',
    level: 3,
    description:
      'C\u00e1lculo de las v\u00edas urinarias inferiores, no especificado',
    code_2: 'N21',
    code_0: 'N00-N99',
    code_1: 'N20-N23'
  },
  {
    code: 'N200',
    level: 3,
    description: 'C\u00e1lculo del ri\u00f1\u00f3n',
    code_2: 'N20',
    code_0: 'N00-N99',
    code_1: 'N20-N23'
  },
  {
    code: 'N201',
    level: 3,
    description: 'C\u00e1lculo del ur\u00e9ter',
    code_2: 'N20',
    code_0: 'N00-N99',
    code_1: 'N20-N23'
  },
  {
    code: 'N202',
    level: 3,
    description:
      'C\u00e1lculo del ri\u00f1\u00f3n con c\u00e1lculo del ur\u00e9ter',
    code_2: 'N20',
    code_0: 'N00-N99',
    code_1: 'N20-N23'
  },
  {
    code: 'N209',
    level: 3,
    description: 'C\u00e1lculo urinario, no especificado',
    code_2: 'N20',
    code_0: 'N00-N99',
    code_1: 'N20-N23'
  },
  {
    code: 'A190',
    level: 3,
    description: 'Tuberculosis miliar aguda de un solo sitio especificado',
    code_2: 'A19',
    code_0: 'A00-B99',
    code_1: 'A15-A19'
  },
  {
    code: 'A191',
    level: 3,
    description: 'Tuberculosis miliar aguda de sitios m\u00faltiples',
    code_2: 'A19',
    code_0: 'A00-B99',
    code_1: 'A15-A19'
  },
  {
    code: 'A192',
    level: 3,
    description: 'Tuberculosis miliar aguda, no especificada',
    code_2: 'A19',
    code_0: 'A00-B99',
    code_1: 'A15-A19'
  },
  {
    code: 'A198',
    level: 3,
    description: 'Otras tuberculosis miliares',
    code_2: 'A19',
    code_0: 'A00-B99',
    code_1: 'A15-A19'
  },
  {
    code: 'A199',
    level: 3,
    description: 'Tuberculosis miliar, sin otra especificaci\u00f3n',
    code_2: 'A19',
    code_0: 'A00-B99',
    code_1: 'A15-A19'
  },
  {
    code: 'A180',
    level: 3,
    description: 'Tuberculosis de huesos y articulaciones',
    code_2: 'A18',
    code_0: 'A00-B99',
    code_1: 'A15-A19'
  },
  {
    code: 'A181',
    level: 3,
    description: 'Tuberculosis del aparato genitourinario',
    code_2: 'A18',
    code_0: 'A00-B99',
    code_1: 'A15-A19'
  },
  {
    code: 'A182',
    level: 3,
    description: 'Linfadenopat\u00eda perif\u00e9rica tuberculosa',
    code_2: 'A18',
    code_0: 'A00-B99',
    code_1: 'A15-A19'
  },
  {
    code: 'A183',
    level: 3,
    description:
      'Tuberculosis de los intestinos, el peritoneo y los ganglios mesent\u00e9ricos',
    code_2: 'A18',
    code_0: 'A00-B99',
    code_1: 'A15-A19'
  },
  {
    code: 'A184',
    level: 3,
    description: 'Tuberculosis de la piel y el tejido subcut\u00e1neo',
    code_2: 'A18',
    code_0: 'A00-B99',
    code_1: 'A15-A19'
  },
  {
    code: 'A185',
    level: 3,
    description: 'Tuberculosis del ojo',
    code_2: 'A18',
    code_0: 'A00-B99',
    code_1: 'A15-A19'
  },
  {
    code: 'A186',
    level: 3,
    description: 'Tuberculosis del o\u00eddo',
    code_2: 'A18',
    code_0: 'A00-B99',
    code_1: 'A15-A19'
  },
  {
    code: 'A187',
    level: 3,
    description: 'Tuberculosis de gl\u00e1ndulas suprarrenales (E35.1)',
    code_2: 'A18',
    code_0: 'A00-B99',
    code_1: 'A15-A19'
  },
  {
    code: 'A188',
    level: 3,
    description: 'Tuberculosis de otros \u00f3rganos especificados',
    code_2: 'A18',
    code_0: 'A00-B99',
    code_1: 'A15-A19'
  },
  {
    code: 'A170',
    level: 3,
    description: 'Meningitis tuberculosa (G01)',
    code_2: 'A17',
    code_0: 'A00-B99',
    code_1: 'A15-A19'
  },
  {
    code: 'A171',
    level: 3,
    description: 'Tuberculoma men\u00edngeo (G07)',
    code_2: 'A17',
    code_0: 'A00-B99',
    code_1: 'A15-A19'
  },
  {
    code: 'A178',
    level: 3,
    description: 'Otras tuberculosis del sistema nervioso',
    code_2: 'A17',
    code_0: 'A00-B99',
    code_1: 'A15-A19'
  },
  {
    code: 'A179',
    level: 3,
    description: 'Tuberculosis del sistema nervioso, no especificada (G99.8)',
    code_2: 'A17',
    code_0: 'A00-B99',
    code_1: 'A15-A19'
  },
  {
    code: 'A160',
    level: 3,
    description:
      'Tuberculosis del pulm\u00f3n, con examen bacteriol\u00f3gico e histol\u00f3gico negativos',
    code_2: 'A16',
    code_0: 'A00-B99',
    code_1: 'A15-A19'
  },
  {
    code: 'A161',
    level: 3,
    description:
      'Tuberculosis de pulm\u00f3n, sin examen bacteriol\u00f3gico e histol\u00f3gico',
    code_2: 'A16',
    code_0: 'A00-B99',
    code_1: 'A15-A19'
  },
  {
    code: 'A162',
    level: 3,
    description:
      'Tuberculosis de pulm\u00f3n, sin menci\u00f3n de confirmaci\u00f3n bacteriol\u00f3gica o histol\u00f3gica',
    code_2: 'A16',
    code_0: 'A00-B99',
    code_1: 'A15-A19'
  },
  {
    code: 'A163',
    level: 3,
    description:
      'Tuberculosis de ganglios linf\u00e1ticos intrator\u00e1cicos, sin menci\u00f3n de confirmaci\u00f3n bacteriol\u00f3gica o histol\u00f3gica',
    code_2: 'A16',
    code_0: 'A00-B99',
    code_1: 'A15-A19'
  },
  {
    code: 'A164',
    level: 3,
    description:
      'Tuberculosis de laringe, tr\u00e1quea y bronquios, sin menci\u00f3n de confirmaci\u00f3n bacteriol\u00f3gica o histol\u00f3gica',
    code_2: 'A16',
    code_0: 'A00-B99',
    code_1: 'A15-A19'
  },
  {
    code: 'A165',
    level: 3,
    description:
      'Pleures\u00eda tuberculosa, sin menci\u00f3n de confirmaci\u00f3n bacteriol\u00f3gica o histol\u00f3gica',
    code_2: 'A16',
    code_0: 'A00-B99',
    code_1: 'A15-A19'
  },
  {
    code: 'A167',
    level: 3,
    description:
      'Tuberculosis respiratoria primaria, sin menci\u00f3n de confirmaci\u00f3n bacteriol\u00f3gica o histol\u00f3gica',
    code_2: 'A16',
    code_0: 'A00-B99',
    code_1: 'A15-A19'
  },
  {
    code: 'A168',
    level: 3,
    description:
      'Otras tuberculosis respiratorias, sin menci\u00f3n de confirmaci\u00f3n',
    code_2: 'A16',
    code_0: 'A00-B99',
    code_1: 'A15-A19'
  },
  {
    code: 'A169',
    level: 3,
    description:
      'Tuberculosis respiratoria no especificada, sin menci\u00f3n de confirmaci\u00f3n bacteriol\u00f3gica o histol\u00f3gica',
    code_2: 'A16',
    code_0: 'A00-B99',
    code_1: 'A15-A19'
  },
  {
    code: 'A150',
    level: 3,
    description:
      'Tuberculosis del pulm\u00f3n, confirmada por hallazgo microsc\u00f3pico del bacilo tuberculoso en esputo, con o sin cultivo',
    code_2: 'A15',
    code_0: 'A00-B99',
    code_1: 'A15-A19'
  },
  {
    code: 'A151',
    level: 3,
    description:
      'Tuberculosis del pulm\u00f3n, confirmada \u00fanicamente por cultivo',
    code_2: 'A15',
    code_0: 'A00-B99',
    code_1: 'A15-A19'
  },
  {
    code: 'A152',
    level: 3,
    description:
      'Tuberculosis del pulm\u00f3n, confirmada histol\u00f3gicamente',
    code_2: 'A15',
    code_0: 'A00-B99',
    code_1: 'A15-A19'
  },
  {
    code: 'A153',
    level: 3,
    description:
      'Tuberculosis del pulm\u00f3n, confirmada por medios no especificados',
    code_2: 'A15',
    code_0: 'A00-B99',
    code_1: 'A15-A19'
  },
  {
    code: 'A154',
    level: 3,
    description:
      'Tuberculosis de ganglios linf\u00e1ticos intrator\u00e1cicos, confirmada bacteriol\u00f3gica e histol\u00f3gicamente',
    code_2: 'A15',
    code_0: 'A00-B99',
    code_1: 'A15-A19'
  },
  {
    code: 'A155',
    level: 3,
    description:
      'Tuberculosis de laringe, tr\u00e1quea y bronquios, confirmada bacteriol\u00f3gica e histol\u00f3gicamente',
    code_2: 'A15',
    code_0: 'A00-B99',
    code_1: 'A15-A19'
  },
  {
    code: 'A156',
    level: 3,
    description:
      'Pleures\u00eda tuberculosa, confirmada bacteriol\u00f3gica e histol\u00f3gicamente',
    code_2: 'A15',
    code_0: 'A00-B99',
    code_1: 'A15-A19'
  },
  {
    code: 'A157',
    level: 3,
    description:
      'Tuberculosis respiratoria primaria, confirmada bacteriol\u00f3gica e histol\u00f3gicamente',
    code_2: 'A15',
    code_0: 'A00-B99',
    code_1: 'A15-A19'
  },
  {
    code: 'A230',
    level: 3,
    description: 'Brucelosis debida a Brucella melitensis',
    code_2: 'A23',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A231',
    level: 3,
    description: 'Brucelosis debida a Brucella abortus',
    code_2: 'A23',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A232',
    level: 3,
    description: 'Brucelosis debida a Brucella suis',
    code_2: 'A23',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A233',
    level: 3,
    description: 'Brucelosis debida a Brucella canis',
    code_2: 'A23',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A238',
    level: 3,
    description: 'Otras brucelosis',
    code_2: 'A23',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A239',
    level: 3,
    description: 'Brucelosis, no especificada',
    code_2: 'A23',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A220',
    level: 3,
    description: 'Carbunco cut\u00e1neo',
    code_2: 'A22',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A221',
    level: 3,
    description: 'Carbunco pulmonar',
    code_2: 'A22',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A222',
    level: 3,
    description: 'Carbunco gastrointestinal',
    code_2: 'A22',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A227',
    level: 3,
    description: 'Carbunco septic\u00e9mico',
    code_2: 'A22',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A228',
    level: 3,
    description: 'Otras formas de carbunco',
    code_2: 'A22',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A229',
    level: 3,
    description: 'Carbunco, no especificado',
    code_2: 'A22',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A210',
    level: 3,
    description: 'Tularemia ulceroglandular',
    code_2: 'A21',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A211',
    level: 3,
    description: 'Tularemia oculoglandular',
    code_2: 'A21',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A212',
    level: 3,
    description: 'Tularemia pulmonar',
    code_2: 'A21',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A213',
    level: 3,
    description: 'Tularemia gastrointestinal',
    code_2: 'A21',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A217',
    level: 3,
    description: 'Tularemia generalizada',
    code_2: 'A21',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A218',
    level: 3,
    description: 'Otras formas de tularemia',
    code_2: 'A21',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A219',
    level: 3,
    description: 'Tularemia, no especificada',
    code_2: 'A21',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A200',
    level: 3,
    description: 'Peste bub\u00f3nica',
    code_2: 'A20',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A201',
    level: 3,
    description: 'Peste celulocut\u00e1nea',
    code_2: 'A20',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A202',
    level: 3,
    description: 'Peste neum\u00f3nica',
    code_2: 'A20',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A203',
    level: 3,
    description: 'Meningitis por peste',
    code_2: 'A20',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A207',
    level: 3,
    description: 'Peste septic\u00e9mica',
    code_2: 'A20',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A208',
    level: 3,
    description: 'Otras formas de peste',
    code_2: 'A20',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A209',
    level: 3,
    description: 'Peste, no especificada',
    code_2: 'A20',
    code_0: 'A00-B99',
    code_1: 'A20-A28'
  },
  {
    code: 'A320',
    level: 3,
    description: 'Listeriosis cut\u00e1nea',
    code_2: 'A32',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A321',
    level: 3,
    description: 'Meningitis y meningoencefalitis listeriana',
    code_2: 'A32',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A327',
    level: 3,
    description: 'Septicemia listeriana',
    code_2: 'A32',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A310',
    level: 3,
    description: 'Infecciones por micobacterias pulmonares',
    code_2: 'A31',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A311',
    level: 3,
    description: 'Infecci\u00f3n cut\u00e1nea por micobacterias',
    code_2: 'A31',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A318',
    level: 3,
    description: 'Otras infecciones por micobacterias',
    code_2: 'A31',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A300',
    level: 3,
    description: 'Lepra indeterminada',
    code_2: 'A30',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A301',
    level: 3,
    description: 'Lepra tuberculoide',
    code_2: 'A30',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A302',
    level: 3,
    description: 'Lepra tuberculoide lim\u00edtrofe',
    code_2: 'A30',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A530',
    level: 3,
    description:
      'S\u00edfilis latente, no especificada como precoz o tard\u00eda',
    code_2: 'A53',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A539',
    level: 3,
    description: 'S\u00edfilis, no especificada',
    code_2: 'A53',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A520',
    level: 3,
    description: 'S\u00edfilis cardiovascular',
    code_2: 'A52',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A521',
    level: 3,
    description: 'Neuros\u00edfilis sintom\u00e1tica',
    code_2: 'A52',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A522',
    level: 3,
    description: 'Neuros\u00edfilis asintom\u00e1tica',
    code_2: 'A52',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A523',
    level: 3,
    description: 'Neuros\u00edfilis no especificada',
    code_2: 'A52',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A527',
    level: 3,
    description: 'Otras s\u00edfilis tard\u00edas sintom\u00e1ticas',
    code_2: 'A52',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A510',
    level: 3,
    description: 'S\u00edfilis genital primaria',
    code_2: 'A51',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A511',
    level: 3,
    description: 'S\u00edfilis primaria anal',
    code_2: 'A51',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A512',
    level: 3,
    description: 'S\u00edfilis primaria en otros sitios',
    code_2: 'A51',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A513',
    level: 3,
    description: 'S\u00edfilis secundaria de piel y membranas mucosas',
    code_2: 'A51',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A514',
    level: 3,
    description: 'Otras s\u00edfilis secundarias',
    code_2: 'A51',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A515',
    level: 3,
    description: 'S\u00edfilis precoz, latente',
    code_2: 'A51',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A500',
    level: 3,
    description: 'S\u00edfilis cong\u00e9nita precoz, sintom\u00e1tica',
    code_2: 'A50',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A501',
    level: 3,
    description: 'S\u00edfilis cong\u00e9nita precoz, latente',
    code_2: 'A50',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A502',
    level: 3,
    description:
      'S\u00edfilis cong\u00e9nita precoz, sin otra especificaci\u00f3n',
    code_2: 'A50',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A503',
    level: 3,
    description: 'Oculopat\u00eda sifil\u00edtica cong\u00e9nita tard\u00eda',
    code_2: 'A50',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A690',
    level: 3,
    description: 'Estomatitis ulcerativa necrotizante',
    code_2: 'A69',
    code_0: 'A00-B99',
    code_1: 'A65-A69'
  },
  {
    code: 'A691',
    level: 3,
    description: 'Otras infecciones de Vincent',
    code_2: 'A69',
    code_0: 'A00-B99',
    code_1: 'A65-A69'
  },
  {
    code: 'A692',
    level: 3,
    description: 'Enfermedad de Lyme',
    code_2: 'A69',
    code_0: 'A00-B99',
    code_1: 'A65-A69'
  },
  {
    code: 'A698',
    level: 3,
    description: 'Otras infecciones especificadas por espiroquetas',
    code_2: 'A69',
    code_0: 'A00-B99',
    code_1: 'A65-A69'
  },
  {
    code: 'A699',
    level: 3,
    description: 'Infecci\u00f3n por espiroqueta, no especificada',
    code_2: 'A69',
    code_0: 'A00-B99',
    code_1: 'A65-A69'
  },
  {
    code: 'A680',
    level: 3,
    description: 'Fiebre recurrente transmitida por piojos',
    code_2: 'A68',
    code_0: 'A00-B99',
    code_1: 'A65-A69'
  },
  {
    code: 'A681',
    level: 3,
    description: 'Fiebre recurrente transmitida por garrapatas',
    code_2: 'A68',
    code_0: 'A00-B99',
    code_1: 'A65-A69'
  },
  {
    code: 'A689',
    level: 3,
    description: 'Fiebre recurrente, no especificada',
    code_2: 'A68',
    code_0: 'A00-B99',
    code_1: 'A65-A69'
  },
  {
    code: 'A670',
    level: 3,
    description: 'Lesiones primarias de la pinta',
    code_2: 'A67',
    code_0: 'A00-B99',
    code_1: 'A65-A69'
  },
  {
    code: 'A671',
    level: 3,
    description: 'Lesiones intermedias de la pinta',
    code_2: 'A67',
    code_0: 'A00-B99',
    code_1: 'A65-A69'
  },
  {
    code: 'A672',
    level: 3,
    description: 'Lesiones tard\u00edas de la pinta',
    code_2: 'A67',
    code_0: 'A00-B99',
    code_1: 'A65-A69'
  },
  {
    code: 'A673',
    level: 3,
    description: 'Lesiones mixtas de la pinta',
    code_2: 'A67',
    code_0: 'A00-B99',
    code_1: 'A65-A69'
  },
  {
    code: 'A679',
    level: 3,
    description: 'Pinta, no especificada',
    code_2: 'A67',
    code_0: 'A00-B99',
    code_1: 'A65-A69'
  },
  {
    code: 'A660',
    level: 3,
    description: 'Lesiones iniciales de frambesia',
    code_2: 'A66',
    code_0: 'A00-B99',
    code_1: 'A65-A69'
  },
  {
    code: 'A661',
    level: 3,
    description:
      'Lesiones papilomatosas m\u00faltiples y frambesia con paso de cangrejo',
    code_2: 'A66',
    code_0: 'A00-B99',
    code_1: 'A65-A69'
  },
  {
    code: 'A662',
    level: 3,
    description: 'Otras lesiones precoces de la piel en la frambesia',
    code_2: 'A66',
    code_0: 'A00-B99',
    code_1: 'A65-A69'
  },
  {
    code: 'A663',
    level: 3,
    description: 'Hiperqueratosis de frambesia',
    code_2: 'A66',
    code_0: 'A00-B99',
    code_1: 'A65-A69'
  },
  {
    code: 'A664',
    level: 3,
    description: 'Goma y \u00falceras de frambesia',
    code_2: 'A66',
    code_0: 'A00-B99',
    code_1: 'A65-A69'
  },
  {
    code: 'A665',
    level: 3,
    description: 'Gangosa',
    code_2: 'A66',
    code_0: 'A00-B99',
    code_1: 'A65-A69'
  },
  {
    code: 'A666',
    level: 3,
    description:
      'Lesiones framb\u00e9sicas de los huesos y de las articulaciones',
    code_2: 'A66',
    code_0: 'A00-B99',
    code_1: 'A65-A69'
  },
  {
    code: 'A740',
    level: 3,
    description: 'Conjuntivitis por clamidias (H13.1)',
    code_2: 'A74',
    code_0: 'A00-B99',
    code_1: 'A70-A74'
  },
  {
    code: 'A748',
    level: 3,
    description: 'Otras enfermedades por clamidias',
    code_2: 'A74',
    code_0: 'A00-B99',
    code_1: 'A70-A74'
  },
  {
    code: 'A749',
    level: 3,
    description: 'Infecci\u00f3n por clamidias, no especificada',
    code_2: 'A74',
    code_0: 'A00-B99',
    code_1: 'A70-A74'
  },
  {
    code: 'A710',
    level: 3,
    description: 'Estado inicial de tracoma',
    code_2: 'A71',
    code_0: 'A00-B99',
    code_1: 'A70-A74'
  },
  {
    code: 'A711',
    level: 3,
    description: 'Estado activo de tracoma',
    code_2: 'A71',
    code_0: 'A00-B99',
    code_1: 'A70-A74'
  },
  {
    code: 'A719',
    level: 3,
    description: 'Tracoma, no especificado',
    code_2: 'A71',
    code_0: 'A00-B99',
    code_1: 'A70-A74'
  },
  {
    code: 'A790',
    level: 3,
    description: 'Fiebre de las trincheras',
    code_2: 'A79',
    code_0: 'A00-B99',
    code_1: 'A75-A79'
  },
  {
    code: 'A791',
    level: 3,
    description: 'Rickettsiosis pustulosa debida a Rickettsia akari',
    code_2: 'A79',
    code_0: 'A00-B99',
    code_1: 'A75-A79'
  },
  {
    code: 'A798',
    level: 3,
    description: 'Otras rickettsiosis especificadas',
    code_2: 'A79',
    code_0: 'A00-B99',
    code_1: 'A75-A79'
  },
  {
    code: 'A799',
    level: 3,
    description: 'Rickettsiosis, no especificada',
    code_2: 'A79',
    code_0: 'A00-B99',
    code_1: 'A75-A79'
  },
  {
    code: 'A770',
    level: 3,
    description: 'Fiebre maculosa debida a Rickettsia rickettsii',
    code_2: 'A77',
    code_0: 'A00-B99',
    code_1: 'A75-A79'
  },
  {
    code: 'A771',
    level: 3,
    description: 'Fiebre maculosa debida a Rickettsia conorii',
    code_2: 'A77',
    code_0: 'A00-B99',
    code_1: 'A75-A79'
  },
  {
    code: 'A772',
    level: 3,
    description: 'Fiebre maculosa debida a Rickettsia siberica',
    code_2: 'A77',
    code_0: 'A00-B99',
    code_1: 'A75-A79'
  },
  {
    code: 'A773',
    level: 3,
    description: 'Fiebre maculosa debida a Rickettsia australis',
    code_2: 'A77',
    code_0: 'A00-B99',
    code_1: 'A75-A79'
  },
  {
    code: 'A778',
    level: 3,
    description: 'Otras fiebres maculosas',
    code_2: 'A77',
    code_0: 'A00-B99',
    code_1: 'A75-A79'
  },
  {
    code: 'A779',
    level: 3,
    description: 'Fiebre maculosa, no especificada',
    code_2: 'A77',
    code_0: 'A00-B99',
    code_1: 'A75-A79'
  },
  {
    code: 'A750',
    level: 3,
    description:
      'Tifus epid\u00e9mico debido a Rickettsia prowazekii transmitido por piojos',
    code_2: 'A75',
    code_0: 'A00-B99',
    code_1: 'A75-A79'
  },
  {
    code: 'A751',
    level: 3,
    description: 'Tifus recrudescente [enfermedad de Brill]',
    code_2: 'A75',
    code_0: 'A00-B99',
    code_1: 'A75-A79'
  },
  {
    code: 'A752',
    level: 3,
    description: 'Tifus debido a Rickettsia typhi',
    code_2: 'A75',
    code_0: 'A00-B99',
    code_1: 'A75-A79'
  },
  {
    code: 'A753',
    level: 3,
    description: 'Tifus debido a Rickettsia tsutsugamushi',
    code_2: 'A75',
    code_0: 'A00-B99',
    code_1: 'A75-A79'
  },
  {
    code: 'A759',
    level: 3,
    description: 'Tifus, no especificado',
    code_2: 'A75',
    code_0: 'A00-B99',
    code_1: 'A75-A79'
  },
  {
    code: 'A850',
    level: 3,
    description: 'Encefalitis enteroviral (G05.1)',
    code_2: 'A85',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A851',
    level: 3,
    description: 'Encefalitis por adenovirus (G05.1)',
    code_2: 'A85',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A852',
    level: 3,
    description:
      'Encefalitis viral transmitida por artr\u00f3podos, sin otra especificaci\u00f3n',
    code_2: 'A85',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A858',
    level: 3,
    description: 'Otras encefalitis virales especificadas',
    code_2: 'A85',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A840',
    level: 3,
    description:
      'Encefalitis del Lejano Oriente transmitida por garrapatas [encefalitis primaveroestival rusa]',
    code_2: 'A84',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A841',
    level: 3,
    description: 'Encefalitis centroeuropea transmitida por garrapatas',
    code_2: 'A84',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A848',
    level: 3,
    description: 'Otras encefalitis virales transmitidas por garrapatas',
    code_2: 'A84',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A849',
    level: 3,
    description:
      'Encefalitis viral transmitida por garrapatas, sin otra especificaci\u00f3n',
    code_2: 'A84',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A830',
    level: 3,
    description: 'Encefalitis japonesa',
    code_2: 'A83',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A831',
    level: 3,
    description: 'Encefalitis equina del oeste',
    code_2: 'A83',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A832',
    level: 3,
    description: 'Encefalitis equina del este',
    code_2: 'A83',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A833',
    level: 3,
    description: 'Encefalitis de San Luis',
    code_2: 'A83',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A834',
    level: 3,
    description: 'Encefalitis australiana',
    code_2: 'A83',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A835',
    level: 3,
    description: 'Encefalitis de California',
    code_2: 'A83',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A836',
    level: 3,
    description: 'Enfermedad por virus Roc\u00edo',
    code_2: 'A83',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A838',
    level: 3,
    description: 'Otras encefalitis virales transmitidas por mosquitos',
    code_2: 'A83',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A839',
    level: 3,
    description:
      'Encefalitis viral transmitida por mosquitos, sin otra especificaci\u00f3n',
    code_2: 'A83',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A820',
    level: 3,
    description: 'Rabia selv\u00e1tica',
    code_2: 'A82',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A821',
    level: 3,
    description: 'Rabia urbana',
    code_2: 'A82',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A829',
    level: 3,
    description: 'Rabia, sin otra especificaci\u00f3n',
    code_2: 'A82',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A810',
    level: 3,
    description: 'Enfermedad de Creutzfeldt-Jakob',
    code_2: 'A81',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A811',
    level: 3,
    description: 'Panencefalitis esclerosante subaguda',
    code_2: 'A81',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A812',
    level: 3,
    description: 'Leucoencefalopat\u00eda multifocal progresiva',
    code_2: 'A81',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A818',
    level: 3,
    description:
      'Otras infecciones del sistema nervioso central por virus at\u00edpico',
    code_2: 'A81',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A819',
    level: 3,
    description:
      'Infecciones del sistema nervioso central por virus at\u00edpico, sin otra especificaci\u00f3n',
    code_2: 'A81',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A800',
    level: 3,
    description: 'Poliomielitis aguda paral\u00edtica, asociada a vacuna',
    code_2: 'A80',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A801',
    level: 3,
    description:
      'Poliomielitis aguda paral\u00edtica debida a virus salvaje importado',
    code_2: 'A80',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A802',
    level: 3,
    description:
      'Poliomielitis aguda paral\u00edtica debida a virus salvaje aut\u00f3ctono',
    code_2: 'A80',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A803',
    level: 3,
    description:
      'Otras poliomielitis agudas paral\u00edticas, y las no especificadas',
    code_2: 'A80',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A804',
    level: 3,
    description: 'Poliomielitis aguda no paral\u00edtica',
    code_2: 'A80',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A809',
    level: 3,
    description: 'Poliomielitis aguda, sin otra especificaci\u00f3n',
    code_2: 'A80',
    code_0: 'A00-B99',
    code_1: 'A80-A89'
  },
  {
    code: 'A920',
    level: 3,
    description: 'Enfermedad por virus Chikungunya',
    code_2: 'A92',
    code_0: 'A00-B99',
    code_1: 'A90-A99'
  },
  {
    code: 'A921',
    level: 3,
    description: 'Fiebre de O\u2019nyong-nyong',
    code_2: 'A92',
    code_0: 'A00-B99',
    code_1: 'A90-A99'
  },
  {
    code: 'A922',
    level: 3,
    description: 'Fiebre equina venezolana',
    code_2: 'A92',
    code_0: 'A00-B99',
    code_1: 'A90-A99'
  },
  {
    code: 'A923',
    level: 3,
    description: 'Enfermedad viral del oeste del Nilo',
    code_2: 'A92',
    code_0: 'A00-B99',
    code_1: 'A90-A99'
  },
  {
    code: 'A924',
    level: 3,
    description: 'Fiebre del valle del Rift',
    code_2: 'A92',
    code_0: 'A00-B99',
    code_1: 'A90-A99'
  },
  {
    code: 'A928',
    level: 3,
    description:
      'Otras fiebres virales especificadas transmitidas por mosquitos',
    code_2: 'A92',
    code_0: 'A00-B99',
    code_1: 'A90-A99'
  },
  {
    code: 'A929',
    level: 3,
    description:
      'Fiebre viral transmitida por mosquito, sin otra especificaci\u00f3n',
    code_2: 'A92',
    code_0: 'A00-B99',
    code_1: 'A90-A99'
  },
  {
    code: 'M20',
    level: 3,
    description: 'Deformidades adquiridas de los dedos de la mano y del pie',
    code_2: 'M20-M25',
    code_0: 'M00-M99',
    code_1: 'M00-M25'
  },
  {
    code: 'M21',
    level: 3,
    description: 'Otras deformidades adquiridas de los miembros',
    code_2: 'M20-M25',
    code_0: 'M00-M99',
    code_1: 'M00-M25'
  },
  {
    code: 'M22',
    level: 3,
    description: 'Trastornos de la r\u00f3tula',
    code_2: 'M20-M25',
    code_0: 'M00-M99',
    code_1: 'M00-M25'
  },
  {
    code: 'M23',
    level: 3,
    description: 'Trastorno interno de la rodilla',
    code_2: 'M20-M25',
    code_0: 'M00-M99',
    code_1: 'M00-M25'
  },
  {
    code: 'M24',
    level: 3,
    description: 'Otros trastornos articulares espec\u00edficos',
    code_2: 'M20-M25',
    code_0: 'M00-M99',
    code_1: 'M00-M25'
  },
  {
    code: 'M25',
    level: 3,
    description: 'Otros trastornos articulares, no clasificados en otra parte',
    code_2: 'M20-M25',
    code_0: 'M00-M99',
    code_1: 'M00-M25'
  },
  {
    code: 'M15',
    level: 3,
    description: 'Poliartrosis',
    code_2: 'M15-M19',
    code_0: 'M00-M99',
    code_1: 'M00-M25'
  },
  {
    code: 'M16',
    level: 3,
    description: 'Coxartrosis [artrosis de la cadera]',
    code_2: 'M15-M19',
    code_0: 'M00-M99',
    code_1: 'M00-M25'
  },
  {
    code: 'M17',
    level: 3,
    description: 'Gonartrosis [artrosis de la rodilla]',
    code_2: 'M15-M19',
    code_0: 'M00-M99',
    code_1: 'M00-M25'
  },
  {
    code: 'M18',
    level: 3,
    description: 'Artrosis de la primera articulaci\u00f3n carpometacarpiana',
    code_2: 'M15-M19',
    code_0: 'M00-M99',
    code_1: 'M00-M25'
  },
  {
    code: 'M05',
    level: 3,
    description: 'Artritis reumatoide seropositiva',
    code_2: 'M05-M14',
    code_0: 'M00-M99',
    code_1: 'M00-M25'
  },
  {
    code: 'M06',
    level: 3,
    description: 'Otras artritis reumatoides',
    code_2: 'M05-M14',
    code_0: 'M00-M99',
    code_1: 'M00-M25'
  },
  {
    code: 'M07',
    level: 3,
    description: 'Artropat\u00edas psori\u00e1sicas y enterop\u00e1ticas',
    code_2: 'M05-M14',
    code_0: 'M00-M99',
    code_1: 'M00-M25'
  },
  {
    code: 'M08',
    level: 3,
    description: 'Artritis juvenil',
    code_2: 'M05-M14',
    code_0: 'M00-M99',
    code_1: 'M00-M25'
  },
  {
    code: 'M09',
    level: 3,
    description: 'Artritis juvenil en enfermedades clasificadas en otra parte',
    code_2: 'M05-M14',
    code_0: 'M00-M99',
    code_1: 'M00-M25'
  },
  {
    code: 'M10',
    level: 3,
    description: 'Gota',
    code_2: 'M05-M14',
    code_0: 'M00-M99',
    code_1: 'M00-M25'
  },
  {
    code: 'M11',
    level: 3,
    description: 'Otras artropat\u00edas por cristales',
    code_2: 'M05-M14',
    code_0: 'M00-M99',
    code_1: 'M00-M25'
  },
  {
    code: 'T235',
    level: 4,
    description:
      'Corrosi\u00f3n de la mu\u00f1eca y de la mano, de primer grado',
    code_3: 'T23',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T236',
    level: 4,
    description:
      'Corrosi\u00f3n de la mu\u00f1eca y de la mano, de segundo grado',
    code_3: 'T23',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T237',
    level: 4,
    description:
      'Corrosi\u00f3n de la mu\u00f1eca y de la mano, de tercer grado',
    code_3: 'T23',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'M00',
    level: 3,
    description: 'Artritis pi\u00f3gena',
    code_2: 'M00-M03',
    code_0: 'M00-M99',
    code_1: 'M00-M25'
  },
  {
    code: 'M01',
    level: 3,
    description:
      'Infecciones directas de la articulaci\u00f3n en enfermedades infecciosas y parasitarias clasificadas en otra parte',
    code_2: 'M00-M03',
    code_0: 'M00-M99',
    code_1: 'M00-M25'
  },
  {
    code: 'M02',
    level: 3,
    description: 'Artropat\u00edas reactivas',
    code_2: 'M00-M03',
    code_0: 'M00-M99',
    code_1: 'M00-M25'
  },
  {
    code: 'M03',
    level: 3,
    description:
      'Artropat\u00edas postinfecciosas y reactivas en enfermedades clasificadas en otra parte',
    code_2: 'M00-M03',
    code_0: 'M00-M99',
    code_1: 'M00-M25'
  },
  {
    code: 'T226',
    level: 4,
    description:
      'Corrosi\u00f3n del hombro y miembro superior, de segundo grado, excepto de la mu\u00f1eca y de la mano',
    code_3: 'T22',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T227',
    level: 4,
    description:
      'Corrosi\u00f3n del hombro y miembro superior, de tercer grado, excepto de la mu\u00f1eca y de la mano',
    code_3: 'T22',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'M350',
    level: 3,
    description: 'S\u00edndrome seco [Sj\u00f6gren]',
    code_2: 'M35',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M351',
    level: 3,
    description: 'Otros s\u00edndromes superpuestos',
    code_2: 'M35',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M352',
    level: 3,
    description: 'Enfermedad de Beh\u00e7et',
    code_2: 'M35',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M353',
    level: 3,
    description: 'Polimialgia reum\u00e1tica',
    code_2: 'M35',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M354',
    level: 3,
    description: 'Fascitis difusa (eosinof\u00edlica)',
    code_2: 'M35',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M355',
    level: 3,
    description: 'Fibrosclerosis multifocal',
    code_2: 'M35',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M356',
    level: 3,
    description: 'Paniculitis recidivante [Weber-Christian]',
    code_2: 'M35',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M357',
    level: 3,
    description: 'S\u00edndrome de hipermovilidad',
    code_2: 'M35',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M358',
    level: 3,
    description:
      'Otras enfermedades especificadas con compromiso sist\u00e9mico del tejido conjuntivo',
    code_2: 'M35',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M359',
    level: 3,
    description:
      'Compromiso sist\u00e9mico del tejido conjuntivo, no especificado',
    code_2: 'M35',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'T288',
    level: 4,
    description: 'Corrosi\u00f3n de \u00f3rganos genitourinarios internos',
    code_3: 'T28',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T26-T28'
  },
  {
    code: 'T289',
    level: 4,
    description:
      'Corrosi\u00f3n de otros \u00f3rganos internos y de los no especificados',
    code_3: 'T28',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T26-T28'
  },
  {
    code: 'T276',
    level: 4,
    description:
      'Corrosi\u00f3n de otras partes de las v\u00edas respiratorias',
    code_3: 'T27',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T26-T28'
  },
  {
    code: 'T277',
    level: 4,
    description:
      'Corrosi\u00f3n de las v\u00edas respiratorias, parte no especificada',
    code_3: 'T27',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T26-T28'
  },
  {
    code: 'T269',
    level: 4,
    description: 'Corrosi\u00f3n del ojo y sus anexos, parte no especificada',
    code_3: 'T26',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T26-T28'
  },
  {
    code: 'M340',
    level: 3,
    description: 'Esclerosis sist\u00e9mica progresiva',
    code_2: 'M34',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M341',
    level: 3,
    description: 'S\u00edndrome CR(E)ST',
    code_2: 'M34',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M342',
    level: 3,
    description:
      'Esclerosis sist\u00e9mica inducida por drogas o productos qu\u00edmicos',
    code_2: 'M34',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M348',
    level: 3,
    description: 'Otras formas de esclerosis sist\u00e9mica',
    code_2: 'M34',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M349',
    level: 3,
    description: 'Esclerosis sist\u00e9mica, no especificada',
    code_2: 'M34',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M330',
    level: 3,
    description: 'Dermatomiositis juvenil',
    code_2: 'M33',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M331',
    level: 3,
    description: 'Otras dermatomiositis',
    code_2: 'M33',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M332',
    level: 3,
    description: 'Polimiositis',
    code_2: 'M33',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M339',
    level: 3,
    description: 'Dermatopolimiositis, no especificada',
    code_2: 'M33',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M320',
    level: 3,
    description: 'Lupus eritematoso sist\u00e9mico, inducido por drogas',
    code_2: 'M32',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M321',
    level: 3,
    description:
      'Lupus eritematoso sist\u00e9mico con compromiso de \u00f3rganos o sistemas',
    code_2: 'M32',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M328',
    level: 3,
    description: 'Otras formas de lupus eritematoso sist\u00e9mico',
    code_2: 'M32',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M329',
    level: 3,
    description:
      'Lupus eritematoso sist\u00e9mico, sin otra especificaci\u00f3n',
    code_2: 'M32',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M310',
    level: 3,
    description: 'Angi\u00edtis debida a hipersensibilidad',
    code_2: 'M31',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M311',
    level: 3,
    description: 'Microangiopat\u00eda tromb\u00f3tica',
    code_2: 'M31',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M312',
    level: 3,
    description: 'Granuloma letal de la l\u00ednea media',
    code_2: 'M31',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M313',
    level: 3,
    description: 'Granulomatosis de Wegener',
    code_2: 'M31',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M314',
    level: 3,
    description: 'S\u00edndrome del cayado de la aorta [Takayasu]',
    code_2: 'M31',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'S052',
    level: 3,
    description:
      'Laceraci\u00f3n y ruptura ocular con prolapso o p\u00e9rdida del tejido intraocular',
    code_2: 'S05',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S053',
    level: 3,
    description:
      'Laceraci\u00f3n ocular sin prolapso o p\u00e9rdida del tejido intraocular',
    code_2: 'S05',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S054',
    level: 3,
    description:
      'Herida penetrante de la \u00f3rbita con o sin cuerpo extra\u00f1o',
    code_2: 'S05',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S055',
    level: 3,
    description: 'Herida penetrante del globo ocular con cuerpo extra\u00f1o',
    code_2: 'S05',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S056',
    level: 3,
    description: 'Herida penetrante de globo ocular sin cuerpo extra\u00f1o',
    code_2: 'S05',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S057',
    level: 3,
    description: 'Avulsi\u00f3n de ojo',
    code_2: 'S05',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S058',
    level: 3,
    description: 'Otros traumatismos del ojo y de la \u00f3rbita',
    code_2: 'S05',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S059',
    level: 3,
    description: 'Traumatismo del ojo y de la \u00f3rbita, no especificado',
    code_2: 'S05',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S043',
    level: 3,
    description: 'Traumatismo del nervio trig\u00e9mino [V par]',
    code_2: 'S04',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S044',
    level: 3,
    description: 'Traumatismo del nervio motor ocular externo [VI par]',
    code_2: 'S04',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S045',
    level: 3,
    description: 'Traumatismo del nervio facial [VII par]',
    code_2: 'S04',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S046',
    level: 3,
    description: 'Traumatismo del nervio ac\u00fastico [VIII par]',
    code_2: 'S04',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S047',
    level: 3,
    description: 'Traumatismo del nervio espinal [XI par]',
    code_2: 'S04',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S048',
    level: 3,
    description: 'Traumatismo de otros nervios craneales',
    code_2: 'S04',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S049',
    level: 3,
    description: 'Traumatismo de nervios craneales, no especificado',
    code_2: 'S04',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'M300',
    level: 3,
    description: 'Poliarteritis nudosa',
    code_2: 'M30',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M301',
    level: 3,
    description: 'Poliarteritis con compromiso pulmonar [Churg-Strauss]',
    code_2: 'M30',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M302',
    level: 3,
    description: 'Poliarteritis juvenil',
    code_2: 'M30',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M303',
    level: 3,
    description: 'S\u00edndrome mucocut\u00e1neo linfonodular [Kawasaki]',
    code_2: 'M30',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M308',
    level: 3,
    description: 'Otras afecciones relacionadas con la poliarteritis nudosa',
    code_2: 'M30',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M50',
    level: 3,
    description: 'Trastornos de disco cervical',
    code_2: 'M50-M54',
    code_0: 'M00-M99',
    code_1: 'M40-M54'
  },
  {
    code: 'M51',
    level: 3,
    description: 'Otros trastornos de los discos intervertebrales',
    code_2: 'M50-M54',
    code_0: 'M00-M99',
    code_1: 'M40-M54'
  },
  {
    code: 'M53',
    level: 3,
    description: 'Otras dorsopat\u00edas, no clasificadas en otra parte',
    code_2: 'M50-M54',
    code_0: 'M00-M99',
    code_1: 'M40-M54'
  },
  {
    code: 'M54',
    level: 3,
    description: 'Dorsalgia',
    code_2: 'M50-M54',
    code_0: 'M00-M99',
    code_1: 'M40-M54'
  },
  {
    code: 'M45',
    level: 3,
    description: 'Espondilitis anquilosante',
    code_2: 'M45-M49',
    code_0: 'M00-M99',
    code_1: 'M40-M54'
  },
  {
    code: 'M46',
    level: 3,
    description: 'Otras espondilopat\u00edas inflamatorias',
    code_2: 'M45-M49',
    code_0: 'M00-M99',
    code_1: 'M40-M54'
  },
  {
    code: 'M47',
    level: 3,
    description: 'Espondilosis',
    code_2: 'M45-M49',
    code_0: 'M00-M99',
    code_1: 'M40-M54'
  },
  {
    code: 'M48',
    level: 3,
    description: 'Otras espondilopat\u00edas',
    code_2: 'M45-M49',
    code_0: 'M00-M99',
    code_1: 'M40-M54'
  },
  {
    code: 'M49',
    level: 3,
    description:
      'Espondilopat\u00edas en enfermedades clasificadas en otra parte',
    code_2: 'M45-M49',
    code_0: 'M00-M99',
    code_1: 'M40-M54'
  },
  {
    code: 'M40',
    level: 3,
    description: 'Cifosis y lordosis',
    code_2: 'M40-M43',
    code_0: 'M00-M99',
    code_1: 'M40-M54'
  },
  {
    code: 'M41',
    level: 3,
    description: 'Escoliosis',
    code_2: 'M40-M43',
    code_0: 'M00-M99',
    code_1: 'M40-M54'
  },
  {
    code: 'M42',
    level: 3,
    description: 'Osteocondrosis de la columna vertebral',
    code_2: 'M40-M43',
    code_0: 'M00-M99',
    code_1: 'M40-M54'
  },
  {
    code: 'M43',
    level: 3,
    description: 'Otras dorsopat\u00edas deformantes',
    code_2: 'M40-M43',
    code_0: 'M00-M99',
    code_1: 'M40-M54'
  },
  {
    code: 'M70',
    level: 3,
    description:
      'Trastornos de los tejidos blandos relacionados con el uso, el uso excesivo y la presi\u00f3n',
    code_2: 'M70-M79',
    code_0: 'M00-M99',
    code_1: 'M60-M79'
  },
  {
    code: 'M71',
    level: 3,
    description: 'Otras bursopat\u00edas',
    code_2: 'M70-M79',
    code_0: 'M00-M99',
    code_1: 'M60-M79'
  },
  {
    code: 'M72',
    level: 3,
    description: 'Trastornos fibrobl\u00e1sticos',
    code_2: 'M70-M79',
    code_0: 'M00-M99',
    code_1: 'M60-M79'
  },
  {
    code: 'M73',
    level: 3,
    description:
      'Trastornos de los tejidos blandos en enfermedades clasificadas en otra parte',
    code_2: 'M70-M79',
    code_0: 'M00-M99',
    code_1: 'M60-M79'
  },
  {
    code: 'M65',
    level: 3,
    description: 'Sinovitis y tenosinovitis',
    code_2: 'M65-M68',
    code_0: 'M00-M99',
    code_1: 'M60-M79'
  },
  {
    code: 'M66',
    level: 3,
    description: 'Ruptura espont\u00e1nea de la sinovia y del tend\u00f3n',
    code_2: 'M65-M68',
    code_0: 'M00-M99',
    code_1: 'M60-M79'
  },
  {
    code: 'M67',
    level: 3,
    description: 'Otros trastornos de la sinovia y del tend\u00f3n',
    code_2: 'M65-M68',
    code_0: 'M00-M99',
    code_1: 'M60-M79'
  },
  {
    code: 'M68',
    level: 3,
    description:
      'Trastornos de los tendones y de la sinovia en enfermedades clasificadas en otra parte',
    code_2: 'M65-M68',
    code_0: 'M00-M99',
    code_1: 'M60-M79'
  },
  {
    code: 'M60',
    level: 3,
    description: 'Miositis',
    code_2: 'M60-M63',
    code_0: 'M00-M99',
    code_1: 'M60-M79'
  },
  {
    code: 'M61',
    level: 3,
    description: 'Calcificaci\u00f3n y osificaci\u00f3n del m\u00fasculo',
    code_2: 'M60-M63',
    code_0: 'M00-M99',
    code_1: 'M60-M79'
  },
  {
    code: 'M62',
    level: 3,
    description: 'Otros trastornos de los m\u00fasculos',
    code_2: 'M60-M63',
    code_0: 'M00-M99',
    code_1: 'M60-M79'
  },
  {
    code: 'M91',
    level: 3,
    description: 'Osteocondrosis juvenil de la cadera y de la pelvis',
    code_2: 'M91-M94',
    code_0: 'M00-M99',
    code_1: 'M80-M94'
  },
  {
    code: 'M92',
    level: 3,
    description: 'Otras osteocondrosis juveniles',
    code_2: 'M91-M94',
    code_0: 'M00-M99',
    code_1: 'M80-M94'
  },
  {
    code: 'M93',
    level: 3,
    description: 'Otras osteocondropat\u00edas',
    code_2: 'M91-M94',
    code_0: 'M00-M99',
    code_1: 'M80-M94'
  },
  {
    code: 'M86',
    level: 3,
    description: 'Osteomielitis',
    code_2: 'M86-M90',
    code_0: 'M00-M99',
    code_1: 'M80-M94'
  },
  {
    code: 'M87',
    level: 3,
    description: 'Osteonecrosis',
    code_2: 'M86-M90',
    code_0: 'M00-M99',
    code_1: 'M80-M94'
  },
  {
    code: 'M88',
    level: 3,
    description: 'Enfermedad de Paget de los huesos [oste\u00edtis deformante]',
    code_2: 'M86-M90',
    code_0: 'M00-M99',
    code_1: 'M80-M94'
  },
  {
    code: 'M89',
    level: 3,
    description: 'Otros trastornos del hueso',
    code_2: 'M86-M90',
    code_0: 'M00-M99',
    code_1: 'M80-M94'
  },
  {
    code: 'M90',
    level: 3,
    description: 'Osteopat\u00edas en enfermedades clasificadas en otra parte',
    code_2: 'M86-M90',
    code_0: 'M00-M99',
    code_1: 'M80-M94'
  },
  {
    code: 'M80',
    level: 3,
    description: 'Osteoporosis con fractura patol\u00f3gica',
    code_2: 'M80-M85',
    code_0: 'M00-M99',
    code_1: 'M80-M94'
  },
  {
    code: 'M81',
    level: 3,
    description: 'Osteoporosis sin fractura patol\u00f3gica',
    code_2: 'M80-M85',
    code_0: 'M00-M99',
    code_1: 'M80-M94'
  },
  {
    code: 'M82',
    level: 3,
    description: 'Osteoporosis en enfermedades clasificadas en otra parte',
    code_2: 'M80-M85',
    code_0: 'M00-M99',
    code_1: 'M80-M94'
  },
  {
    code: 'M83',
    level: 3,
    description: 'Osteomalacia del adulto',
    code_2: 'M80-M85',
    code_0: 'M00-M99',
    code_1: 'M80-M94'
  },
  {
    code: 'M84',
    level: 3,
    description: 'Trastornos de la continuidad del hueso',
    code_2: 'M80-M85',
    code_0: 'M00-M99',
    code_1: 'M80-M94'
  },
  {
    code: 'L040',
    level: 3,
    description: 'Linfadenitis aguda de cara, cabeza y cuello',
    code_2: 'L04',
    code_0: 'L00-L99',
    code_1: 'L00-L08'
  },
  {
    code: 'L041',
    level: 3,
    description: 'Linfadenitis aguda del tronco',
    code_2: 'L04',
    code_0: 'L00-L99',
    code_1: 'L00-L08'
  },
  {
    code: 'L042',
    level: 3,
    description: 'Linfadenitis aguda del miembro superior',
    code_2: 'L04',
    code_0: 'L00-L99',
    code_1: 'L00-L08'
  },
  {
    code: 'L043',
    level: 3,
    description: 'Linfadenitis aguda del miembro inferior',
    code_2: 'L04',
    code_0: 'L00-L99',
    code_1: 'L00-L08'
  },
  {
    code: 'L048',
    level: 3,
    description: 'Linfadenitis aguda de otros sitios',
    code_2: 'L04',
    code_0: 'L00-L99',
    code_1: 'L00-L08'
  },
  {
    code: 'L049',
    level: 3,
    description: 'Linfadenitis aguda de sitio no especificado',
    code_2: 'L04',
    code_0: 'L00-L99',
    code_1: 'L00-L08'
  },
  {
    code: 'L030',
    level: 3,
    description: 'Celulitis de los dedos de la mano y del pie',
    code_2: 'L03',
    code_0: 'L00-L99',
    code_1: 'L00-L08'
  },
  {
    code: 'L031',
    level: 3,
    description: 'Celulitis de otras partes de los miembros',
    code_2: 'L03',
    code_0: 'L00-L99',
    code_1: 'L00-L08'
  },
  {
    code: 'L032',
    level: 3,
    description: 'Celulitis de la cara',
    code_2: 'L03',
    code_0: 'L00-L99',
    code_1: 'L00-L08'
  },
  {
    code: 'L033',
    level: 3,
    description: 'Celulitis del tronco',
    code_2: 'L03',
    code_0: 'L00-L99',
    code_1: 'L00-L08'
  },
  {
    code: 'L038',
    level: 3,
    description: 'Celulitis de otros sitios',
    code_2: 'L03',
    code_0: 'L00-L99',
    code_1: 'L00-L08'
  },
  {
    code: 'L039',
    level: 3,
    description: 'Celulitis de sitio no especificado',
    code_2: 'L03',
    code_0: 'L00-L99',
    code_1: 'L00-L08'
  },
  {
    code: 'L020',
    level: 3,
    description: 'Absceso cut\u00e1neo, fur\u00fanculo y carbunco de la cara',
    code_2: 'L02',
    code_0: 'L00-L99',
    code_1: 'L00-L08'
  },
  {
    code: 'L021',
    level: 3,
    description: 'Absceso cut\u00e1neo, fur\u00fanculo y carbunco del cuello',
    code_2: 'L02',
    code_0: 'L00-L99',
    code_1: 'L00-L08'
  },
  {
    code: 'L022',
    level: 3,
    description: 'Absceso cut\u00e1neo, fur\u00fanculo y carbunco del tronco',
    code_2: 'L02',
    code_0: 'L00-L99',
    code_1: 'L00-L08'
  },
  {
    code: 'L023',
    level: 3,
    description:
      'Absceso cut\u00e1neo, fur\u00fanculo y carbunco de gl\u00fateos',
    code_2: 'L02',
    code_0: 'L00-L99',
    code_1: 'L00-L08'
  },
  {
    code: 'L024',
    level: 3,
    description: 'Absceso cut\u00e1neo, fur\u00fanculo y carbunco de miembro',
    code_2: 'L02',
    code_0: 'L00-L99',
    code_1: 'L00-L08'
  },
  {
    code: 'L028',
    level: 3,
    description:
      'Absceso cut\u00e1neo, fur\u00fanculo y carbunco de otros sitios',
    code_2: 'L02',
    code_0: 'L00-L99',
    code_1: 'L00-L08'
  },
  {
    code: 'L029',
    level: 3,
    description:
      'Absceso cut\u00e1neo, fur\u00fanculo y carbunco de sitio no especificado',
    code_2: 'L02',
    code_0: 'L00-L99',
    code_1: 'L00-L08'
  },
  {
    code: 'L010',
    level: 3,
    description:
      'Imp\u00e9tigo [cualquier sitio anat\u00f3mico] [cualquier organismo]',
    code_2: 'L01',
    code_0: 'L00-L99',
    code_1: 'L00-L08'
  },
  {
    code: 'L011',
    level: 3,
    description: 'Impetiginizaci\u00f3n de otras dermatosis',
    code_2: 'L01',
    code_0: 'L00-L99',
    code_1: 'L00-L08'
  },
  {
    code: 'L120',
    level: 3,
    description: 'Penfigoide flictenular',
    code_2: 'L12',
    code_0: 'L00-L99',
    code_1: 'L10-L14'
  },
  {
    code: 'L121',
    level: 3,
    description: 'Penfigoide cicatricial',
    code_2: 'L12',
    code_0: 'L00-L99',
    code_1: 'L10-L14'
  },
  {
    code: 'L122',
    level: 3,
    description: 'Enfermedad flictenular cr\u00f3nica de la infancia',
    code_2: 'L12',
    code_0: 'L00-L99',
    code_1: 'L10-L14'
  },
  {
    code: 'L123',
    level: 3,
    description: 'Epiderm\u00f3lisis bullosa adquirida',
    code_2: 'L12',
    code_0: 'L00-L99',
    code_1: 'L10-L14'
  },
  {
    code: 'L128',
    level: 3,
    description: 'Otros penfigoides',
    code_2: 'L12',
    code_0: 'L00-L99',
    code_1: 'L10-L14'
  },
  {
    code: 'L129',
    level: 3,
    description: 'Penfigoide, no especificado',
    code_2: 'L12',
    code_0: 'L00-L99',
    code_1: 'L10-L14'
  },
  {
    code: 'L110',
    level: 3,
    description: 'Queratosis folicular adquirida',
    code_2: 'L11',
    code_0: 'L00-L99',
    code_1: 'L10-L14'
  },
  {
    code: 'L111',
    level: 3,
    description: 'Dermatosis acantol\u00edtica transitoria [Grover]',
    code_2: 'L11',
    code_0: 'L00-L99',
    code_1: 'L10-L14'
  },
  {
    code: 'L118',
    level: 3,
    description: 'Otros trastornos acantol\u00edticos especificados',
    code_2: 'L11',
    code_0: 'L00-L99',
    code_1: 'L10-L14'
  },
  {
    code: 'L119',
    level: 3,
    description: 'Trastorno acantol\u00edtico, no especificado',
    code_2: 'L11',
    code_0: 'L00-L99',
    code_1: 'L10-L14'
  },
  {
    code: 'L100',
    level: 3,
    description: 'P\u00e9nfigo vulgar',
    code_2: 'L10',
    code_0: 'L00-L99',
    code_1: 'L10-L14'
  },
  {
    code: 'L101',
    level: 3,
    description: 'P\u00e9nfigo vegetante',
    code_2: 'L10',
    code_0: 'L00-L99',
    code_1: 'L10-L14'
  },
  {
    code: 'L102',
    level: 3,
    description: 'P\u00e9nfigo foli\u00e1ceo',
    code_2: 'L10',
    code_0: 'L00-L99',
    code_1: 'L10-L14'
  },
  {
    code: 'L103',
    level: 3,
    description: 'P\u00e9nfigo brasile\u00f1o [fogo selvagem]',
    code_2: 'L10',
    code_0: 'L00-L99',
    code_1: 'L10-L14'
  },
  {
    code: 'L104',
    level: 3,
    description: 'P\u00e9nfigo eritematoso',
    code_2: 'L10',
    code_0: 'L00-L99',
    code_1: 'L10-L14'
  },
  {
    code: 'L105',
    level: 3,
    description: 'P\u00e9nfigo inducido por drogas',
    code_2: 'L10',
    code_0: 'L00-L99',
    code_1: 'L10-L14'
  },
  {
    code: 'L108',
    level: 3,
    description: 'Otros p\u00e9nfigos',
    code_2: 'L10',
    code_0: 'L00-L99',
    code_1: 'L10-L14'
  },
  {
    code: 'L109',
    level: 3,
    description: 'P\u00e9nfigo, no especificado',
    code_2: 'L10',
    code_0: 'L00-L99',
    code_1: 'L10-L14'
  },
  {
    code: 'S158',
    level: 3,
    description:
      'Traumatismo de otros vasos sangu\u00edneos a nivel del cuello',
    code_2: 'S15',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S159',
    level: 3,
    description:
      'Traumatismo de vasos sangu\u00edneos no especificados a nivel del cuello',
    code_2: 'S15',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S146',
    level: 3,
    description:
      'Traumatismo de otros nervios y de los no especificados del cuello',
    code_2: 'S14',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'O264',
    level: 3,
    description: 'Herpes gestacional',
    code_2: 'O26',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O265',
    level: 3,
    description: 'S\u00edndrome de hipotensi\u00f3n materna',
    code_2: 'O26',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O266',
    level: 3,
    description:
      'Trastornos del h\u00edgado en el embarazo, el parto y el puerperio',
    code_2: 'O26',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O267',
    level: 3,
    description:
      'Subluxaci\u00f3n de la s\u00ednfisis (del pubis) en el embarazo, el parto y el puerperio',
    code_2: 'O26',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O268',
    level: 3,
    description:
      'Otras complicaciones especificadas relacionadas con el embarazo',
    code_2: 'O26',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O269',
    level: 3,
    description:
      'Complicaci\u00f3n relacionada con el embarazo, no especificada',
    code_2: 'O26',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'O249',
    level: 3,
    description: 'Diabetes mellitus no especificada, en el embarazo',
    code_2: 'O24',
    code_0: 'O00-O9A',
    code_1: 'O20-O29'
  },
  {
    code: 'S279',
    level: 3,
    description:
      'Traumatismo de \u00f3rgano intrator\u00e1cico, no especificado',
    code_2: 'S27',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S335',
    level: 3,
    description: 'Esguinces y torceduras de la columna lumbar',
    code_2: 'S33',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S336',
    level: 3,
    description: 'Esguinces y torceduras de la articulaci\u00f3n sacroiliaca',
    code_2: 'S33',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S337',
    level: 3,
    description:
      'Esguinces y torceduras de otras partes y de las no especificadas de la columna lumbar y de la pelvis',
    code_2: 'S33',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'O346',
    level: 3,
    description: 'Atenci\u00f3n materna por anormalidad de la vagina',
    code_2: 'O34',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O347',
    level: 3,
    description:
      'Atenci\u00f3n materna por anormalidad de la vulva y del perineo',
    code_2: 'O34',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O348',
    level: 3,
    description:
      'Atenci\u00f3n materna por otras anormalidades de los \u00f3rganos pelvianos',
    code_2: 'O34',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O349',
    level: 3,
    description:
      'Atenci\u00f3n materna por anormalidad no especificada de \u00f3rgano pelviano',
    code_2: 'O34',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'O339',
    level: 3,
    description:
      'Atenci\u00f3n materna por desproporci\u00f3n de origen no especificado',
    code_2: 'O33',
    code_0: 'O00-O9A',
    code_1: 'O30-O48'
  },
  {
    code: 'N188',
    level: 3,
    description: 'Otras insuficiencias renales cr\u00f3nicas',
    code_2: 'N18',
    code_0: 'N00-N99',
    code_1: 'N17-N19'
  },
  {
    code: 'N189',
    level: 3,
    description: 'Insuficiencia renal cr\u00f3nica, no especificada',
    code_2: 'N18',
    code_0: 'N00-N99',
    code_1: 'N17-N19'
  },
  {
    code: 'L250',
    level: 3,
    description:
      'Dermatitis de contacto, forma no especificada, debida a cosm\u00e9ticos',
    code_2: 'L25',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L251',
    level: 3,
    description:
      'Dermatitis de contacto, forma no especificada, debida a drogas en contacto con la piel',
    code_2: 'L25',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L252',
    level: 3,
    description:
      'Dermatitis de contacto, forma no especificada, debida a colorantes',
    code_2: 'L25',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L240',
    level: 3,
    description: 'Dermatitis de contacto por irritantes, debida a detergentes',
    code_2: 'L24',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L230',
    level: 3,
    description: 'Dermatitis al\u00e9rgica de contacto debida a metales',
    code_2: 'L23',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L210',
    level: 3,
    description: 'Seborrea capitis',
    code_2: 'L21',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L200',
    level: 3,
    description: 'Prurigo de Besnier',
    code_2: 'L20',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L208',
    level: 3,
    description: 'Otras dermatitis at\u00f3picas',
    code_2: 'L20',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L209',
    level: 3,
    description: 'Dermatitis at\u00f3pica, no especificada',
    code_2: 'L20',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L440',
    level: 3,
    description: 'Pitiriasis rubra pilaris',
    code_2: 'L44',
    code_0: 'L00-L99',
    code_1: 'L40-L45'
  },
  {
    code: 'L441',
    level: 3,
    description: 'Liquen n\u00edtido',
    code_2: 'L44',
    code_0: 'L00-L99',
    code_1: 'L40-L45'
  },
  {
    code: 'L442',
    level: 3,
    description: 'Liquen estriado',
    code_2: 'L44',
    code_0: 'L00-L99',
    code_1: 'L40-L45'
  },
  {
    code: 'L443',
    level: 3,
    description: 'Liquen rojo moniliforme',
    code_2: 'L44',
    code_0: 'L00-L99',
    code_1: 'L40-L45'
  },
  {
    code: 'L430',
    level: 3,
    description: 'Liquen plano hipertr\u00f3fico',
    code_2: 'L43',
    code_0: 'L00-L99',
    code_1: 'L40-L45'
  },
  {
    code: 'L431',
    level: 3,
    description: 'Liquen plano flictenular',
    code_2: 'L43',
    code_0: 'L00-L99',
    code_1: 'L40-L45'
  },
  {
    code: 'L432',
    level: 3,
    description: 'Reacci\u00f3n liquenoide debida a drogas',
    code_2: 'L43',
    code_0: 'L00-L99',
    code_1: 'L40-L45'
  },
  {
    code: 'L433',
    level: 3,
    description: 'Liquen plano subagudo (activo)',
    code_2: 'L43',
    code_0: 'L00-L99',
    code_1: 'L40-L45'
  },
  {
    code: 'L438',
    level: 3,
    description: 'Otros l\u00edquenes planos',
    code_2: 'L43',
    code_0: 'L00-L99',
    code_1: 'L40-L45'
  },
  {
    code: 'L439',
    level: 3,
    description: 'Liquen plano, no especificado',
    code_2: 'L43',
    code_0: 'L00-L99',
    code_1: 'L40-L45'
  },
  {
    code: 'L410',
    level: 3,
    description: 'Pitiriasis liquenoide y varioliforme aguda',
    code_2: 'L41',
    code_0: 'L00-L99',
    code_1: 'L40-L45'
  },
  {
    code: 'L411',
    level: 3,
    description: 'Pitiriasis liquenoide cr\u00f3nica',
    code_2: 'L41',
    code_0: 'L00-L99',
    code_1: 'L40-L45'
  },
  {
    code: 'L412',
    level: 3,
    description: 'Papulosis linfomatoide',
    code_2: 'L41',
    code_0: 'L00-L99',
    code_1: 'L40-L45'
  },
  {
    code: 'L413',
    level: 3,
    description: 'Parapsoriasis en placas peque\u00f1as',
    code_2: 'L41',
    code_0: 'L00-L99',
    code_1: 'L40-L45'
  },
  {
    code: 'L400',
    level: 3,
    description: 'Psoriasis vulgar',
    code_2: 'L40',
    code_0: 'L00-L99',
    code_1: 'L40-L45'
  },
  {
    code: 'L401',
    level: 3,
    description: 'Psoriasis pustulosa generalizada',
    code_2: 'L40',
    code_0: 'L00-L99',
    code_1: 'L40-L45'
  },
  {
    code: 'L402',
    level: 3,
    description: 'Acrodermatitis continua',
    code_2: 'L40',
    code_0: 'L00-L99',
    code_1: 'L40-L45'
  },
  {
    code: 'L403',
    level: 3,
    description: 'Pustulosis palmar y plantar',
    code_2: 'L40',
    code_0: 'L00-L99',
    code_1: 'L40-L45'
  },
  {
    code: 'L404',
    level: 3,
    description: 'Psoriasis guttata',
    code_2: 'L40',
    code_0: 'L00-L99',
    code_1: 'L40-L45'
  },
  {
    code: 'L405',
    level: 3,
    description: 'Artropat\u00eda psori\u00e1sica (M07.0\u2013M07.3, M09.0)',
    code_2: 'L40',
    code_0: 'L00-L99',
    code_1: 'L40-L45'
  },
  {
    code: 'L408',
    level: 3,
    description: 'Otras psoriasis',
    code_2: 'L40',
    code_0: 'L00-L99',
    code_1: 'L40-L45'
  },
  {
    code: 'L409',
    level: 3,
    description: 'Psoriasis, no especificada',
    code_2: 'L40',
    code_0: 'L00-L99',
    code_1: 'L40-L45'
  },
  {
    code: 'K050',
    level: 3,
    description: 'Gingivitis aguda',
    code_2: 'K05',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K051',
    level: 3,
    description: 'Gingivitis cr\u00f3nica',
    code_2: 'K05',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K052',
    level: 3,
    description: 'Periodontitis aguda',
    code_2: 'K05',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K053',
    level: 3,
    description: 'Periodontitis cr\u00f3nica',
    code_2: 'K05',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K054',
    level: 3,
    description: 'Periodontosis',
    code_2: 'K05',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K055',
    level: 3,
    description: 'Otras enfermedades periodontales',
    code_2: 'K05',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K056',
    level: 3,
    description: 'Enfermedad del periodonto, no especificada',
    code_2: 'K05',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K040',
    level: 3,
    description: 'Pulpitis',
    code_2: 'K04',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K041',
    level: 3,
    description: 'Necrosis de la pulpa',
    code_2: 'K04',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K042',
    level: 3,
    description: 'Degeneraci\u00f3n de la pulpa',
    code_2: 'K04',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K043',
    level: 3,
    description: 'Formaci\u00f3n anormal de tejido duro en la pulpa',
    code_2: 'K04',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K044',
    level: 3,
    description: 'Periodontitis apical aguda originada en la pulpa',
    code_2: 'K04',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K045',
    level: 3,
    description: 'Periodontitis apical cr\u00f3nica',
    code_2: 'K04',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K046',
    level: 3,
    description: 'Absceso periapical con f\u00edstula',
    code_2: 'K04',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K047',
    level: 3,
    description: 'Absceso periapical sin f\u00edstula',
    code_2: 'K04',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K030',
    level: 3,
    description: 'Atrici\u00f3n excesiva de los dientes',
    code_2: 'K03',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K031',
    level: 3,
    description: 'Abrasi\u00f3n de los dientes',
    code_2: 'K03',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K032',
    level: 3,
    description: 'Erosi\u00f3n de los dientes',
    code_2: 'K03',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K033',
    level: 3,
    description: 'Reabsorci\u00f3n patol\u00f3gica de los dientes',
    code_2: 'K03',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K034',
    level: 3,
    description: 'Hipercementosis',
    code_2: 'K03',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K035',
    level: 3,
    description: 'Anquilosis dental',
    code_2: 'K03',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K036',
    level: 3,
    description: 'Dep\u00f3sitos [acreciones] en los dientes',
    code_2: 'K03',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K037',
    level: 3,
    description:
      'Cambios posteruptivos del color de los tejidos dentales duros',
    code_2: 'K03',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K020',
    level: 3,
    description: 'Caries limitada al esmalte',
    code_2: 'K02',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K021',
    level: 3,
    description: 'Caries de la dentina',
    code_2: 'K02',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K022',
    level: 3,
    description: 'Caries del cemento',
    code_2: 'K02',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K023',
    level: 3,
    description: 'Caries dentaria detenida',
    code_2: 'K02',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K024',
    level: 3,
    description: 'Odontoclasia',
    code_2: 'K02',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K028',
    level: 3,
    description: 'Otras caries dentales',
    code_2: 'K02',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K029',
    level: 3,
    description: 'Caries dental, no especificada',
    code_2: 'K02',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K010',
    level: 3,
    description: 'Dientes incluidos',
    code_2: 'K01',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K011',
    level: 3,
    description: 'Dientes impactados',
    code_2: 'K01',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K000',
    level: 3,
    description: 'Anodoncia',
    code_2: 'K00',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K001',
    level: 3,
    description: 'Dientes supernumerarios',
    code_2: 'K00',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K002',
    level: 3,
    description: 'Anomal\u00edas del tama\u00f1o y de la forma del diente',
    code_2: 'K00',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K003',
    level: 3,
    description: 'Dientes moteados',
    code_2: 'K00',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K004',
    level: 3,
    description: 'Alteraciones en la formaci\u00f3n dentaria',
    code_2: 'K00',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K005',
    level: 3,
    description:
      'Alteraciones hereditarias de la estructura dentaria, no clasificadas en otra parte',
    code_2: 'K00',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K006',
    level: 3,
    description: 'Alteraciones en la erupci\u00f3n dentaria',
    code_2: 'K00',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K220',
    level: 3,
    description: 'Acalasia del cardias',
    code_2: 'K22',
    code_0: 'K00-K95',
    code_1: 'K20-K31'
  },
  {
    code: 'K221',
    level: 3,
    description: '\u00dalcera del es\u00f3fago',
    code_2: 'K22',
    code_0: 'K00-K95',
    code_1: 'K20-K31'
  },
  {
    code: 'K222',
    level: 3,
    description: 'Obstrucci\u00f3n del es\u00f3fago',
    code_2: 'K22',
    code_0: 'K00-K95',
    code_1: 'K20-K31'
  },
  {
    code: 'K223',
    level: 3,
    description: 'Perforaci\u00f3n del es\u00f3fago',
    code_2: 'K22',
    code_0: 'K00-K95',
    code_1: 'K20-K31'
  },
  {
    code: 'K224',
    level: 3,
    description: 'Disquinesia del es\u00f3fago',
    code_2: 'K22',
    code_0: 'K00-K95',
    code_1: 'K20-K31'
  },
  {
    code: 'K225',
    level: 3,
    description: 'Divert\u00edculo del es\u00f3fago, adquirido',
    code_2: 'K22',
    code_0: 'K00-K95',
    code_1: 'K20-K31'
  },
  {
    code: 'K226',
    level: 3,
    description:
      'S\u00edndrome de laceraci\u00f3n y hemorragia gastroesof\u00e1gicas',
    code_2: 'K22',
    code_0: 'K00-K95',
    code_1: 'K20-K31'
  },
  {
    code: 'K210',
    level: 3,
    description: 'Enfermedad del reflujo gastroesof\u00e1gico con esofagitis',
    code_2: 'K21',
    code_0: 'K00-K95',
    code_1: 'K20-K31'
  },
  {
    code: 'K219',
    level: 3,
    description: 'Enfermedad del reflujo gastroesof\u00e1gico sin esofagitis',
    code_2: 'K21',
    code_0: 'K00-K95',
    code_1: 'K20-K31'
  },
  {
    code: 'K380',
    level: 3,
    description: 'Hiperplasia del ap\u00e9ndice',
    code_2: 'K38',
    code_0: 'K00-K95',
    code_1: 'K35-K38'
  },
  {
    code: 'K381',
    level: 3,
    description: 'Concreciones apendiculares ',
    code_2: 'K38',
    code_0: 'K00-K95',
    code_1: 'K35-K38'
  },
  {
    code: 'K382',
    level: 3,
    description: 'Divert\u00edculo del ap\u00e9ndice',
    code_2: 'K38',
    code_0: 'K00-K95',
    code_1: 'K35-K38'
  },
  {
    code: 'K383',
    level: 3,
    description: 'F\u00edstula del ap\u00e9ndice',
    code_2: 'K38',
    code_0: 'K00-K95',
    code_1: 'K35-K38'
  },
  {
    code: 'K388',
    level: 3,
    description: 'Otras enfermedades especificadas del ap\u00e9ndice',
    code_2: 'K38',
    code_0: 'K00-K95',
    code_1: 'K35-K38'
  },
  {
    code: 'K389',
    level: 3,
    description: 'Enfermedad del ap\u00e9ndice, no especificada',
    code_2: 'K38',
    code_0: 'K00-K95',
    code_1: 'K35-K38'
  },
  {
    code: 'K350',
    level: 3,
    description: 'Apendicitis aguda con peritonitis generalizada',
    code_2: 'K35',
    code_0: 'K00-K95',
    code_1: 'K35-K38'
  },
  {
    code: 'K351',
    level: 3,
    description: 'Apendicitis aguda con absceso peritoneal',
    code_2: 'K35',
    code_0: 'K00-K95',
    code_1: 'K35-K38'
  },
  {
    code: 'K359',
    level: 3,
    description: 'Apendicitis aguda, no especificada',
    code_2: 'K35',
    code_0: 'K00-K95',
    code_1: 'K35-K38'
  },
  {
    code: 'K430',
    level: 3,
    description: 'Hernia ventral con obstrucci\u00f3n, sin gangrena',
    code_2: 'K43',
    code_0: 'K00-K95',
    code_1: 'K40-K46'
  },
  {
    code: 'K431',
    level: 3,
    description: 'Hernia ventral con gangrena',
    code_2: 'K43',
    code_0: 'K00-K95',
    code_1: 'K40-K46'
  },
  {
    code: 'K439',
    level: 3,
    description: 'Hernia ventral sin obstrucci\u00f3n ni gangrena',
    code_2: 'K43',
    code_0: 'K00-K95',
    code_1: 'K40-K46'
  },
  {
    code: 'K420',
    level: 3,
    description: 'Hernia umbilical con obstrucci\u00f3n, sin gangrena',
    code_2: 'K42',
    code_0: 'K00-K95',
    code_1: 'K40-K46'
  },
  {
    code: 'K421',
    level: 3,
    description: 'Hernia umbilical con gangrena',
    code_2: 'K42',
    code_0: 'K00-K95',
    code_1: 'K40-K46'
  },
  {
    code: 'K429',
    level: 3,
    description: 'Hernia umbilical sin obstrucci\u00f3n ni gangrena',
    code_2: 'K42',
    code_0: 'K00-K95',
    code_1: 'K40-K46'
  },
  {
    code: 'K410',
    level: 3,
    description: 'Hernia femoral bilateral, con obstrucci\u00f3n, sin gangrena',
    code_2: 'K41',
    code_0: 'K00-K95',
    code_1: 'K40-K46'
  },
  {
    code: 'K411',
    level: 3,
    description: 'Hernia femoral bilateral, con gangrena',
    code_2: 'K41',
    code_0: 'K00-K95',
    code_1: 'K40-K46'
  },
  {
    code: 'K412',
    level: 3,
    description: 'Hernia femoral bilateral, sin obstrucci\u00f3n ni gangrena',
    code_2: 'K41',
    code_0: 'K00-K95',
    code_1: 'K40-K46'
  },
  {
    code: 'K413',
    level: 3,
    description:
      'Hernia femoral unilateral o no especificada, con obstrucci\u00f3n, sin gangrena',
    code_2: 'K41',
    code_0: 'K00-K95',
    code_1: 'K40-K46'
  },
  {
    code: 'K414',
    level: 3,
    description: 'Hernia femoral unilateral o no especificada, con gangrena',
    code_2: 'K41',
    code_0: 'K00-K95',
    code_1: 'K40-K46'
  },
  {
    code: 'K419',
    level: 3,
    description:
      'Hernia femoral unilateral o no especificada, sin obstrucci\u00f3n ni gangrena',
    code_2: 'K41',
    code_0: 'K00-K95',
    code_1: 'K40-K46'
  },
  {
    code: 'K400',
    level: 3,
    description: 'Hernia inguinal bilateral con obstrucci\u00f3n, sin gangrena',
    code_2: 'K40',
    code_0: 'K00-K95',
    code_1: 'K40-K46'
  },
  {
    code: 'K401',
    level: 3,
    description: 'Hernia inguinal bilateral, con gangrena',
    code_2: 'K40',
    code_0: 'K00-K95',
    code_1: 'K40-K46'
  },
  {
    code: 'K402',
    level: 3,
    description: 'Hernia inguinal bilateral, sin obstrucci\u00f3n ni gangrena',
    code_2: 'K40',
    code_0: 'K00-K95',
    code_1: 'K40-K46'
  },
  {
    code: 'K403',
    level: 3,
    description:
      'Hernia inguinal unilateral o no especificada, con obstrucci\u00f3n, sin gangrena',
    code_2: 'K40',
    code_0: 'K00-K95',
    code_1: 'K40-K46'
  },
  {
    code: 'K404',
    level: 3,
    description: 'Hernia inguinal unilateral o no especificada, con gangrena',
    code_2: 'K40',
    code_0: 'K00-K95',
    code_1: 'K40-K46'
  },
  {
    code: 'K409',
    level: 3,
    description:
      'Hernia inguinal unilateral o no especificada, sin obstrucci\u00f3n ni gangrena',
    code_2: 'K40',
    code_0: 'K00-K95',
    code_1: 'K40-K46'
  },
  {
    code: 'K520',
    level: 3,
    description: 'Colitis y gastroenteritis debidas a radiaci\u00f3n',
    code_2: 'K52',
    code_0: 'K00-K95',
    code_1: 'K50-K52'
  },
  {
    code: 'K521',
    level: 3,
    description: 'Colitis y gastroenteritis t\u00f3xicas',
    code_2: 'K52',
    code_0: 'K00-K95',
    code_1: 'K50-K52'
  },
  {
    code: 'K522',
    level: 3,
    description: 'Colitis y gastroenteritis al\u00e9rgicas y diet\u00e9ticas',
    code_2: 'K52',
    code_0: 'K00-K95',
    code_1: 'K50-K52'
  },
  {
    code: 'K528',
    level: 3,
    description: 'Otras colitis y gastroenteritis no infecciosas especificadas',
    code_2: 'K52',
    code_0: 'K00-K95',
    code_1: 'K50-K52'
  },
  {
    code: 'K529',
    level: 3,
    description: 'Colitis y gastroenteritis no infecciosas, no especificadas',
    code_2: 'K52',
    code_0: 'K00-K95',
    code_1: 'K50-K52'
  },
  {
    code: 'K510',
    level: 3,
    description: 'Enterocolitis (cr\u00f3nica) ulcerativa',
    code_2: 'K51',
    code_0: 'K00-K95',
    code_1: 'K50-K52'
  },
  {
    code: 'K511',
    level: 3,
    description: 'Ileocolitis (cr\u00f3nica) ulcerativa',
    code_2: 'K51',
    code_0: 'K00-K95',
    code_1: 'K50-K52'
  },
  {
    code: 'K512',
    level: 3,
    description: 'Proctitis (cr\u00f3nica) ulcerativa',
    code_2: 'K51',
    code_0: 'K00-K95',
    code_1: 'K50-K52'
  },
  {
    code: 'K513',
    level: 3,
    description: 'Rectosigmoiditis (cr\u00f3nica) ulcerativa',
    code_2: 'K51',
    code_0: 'K00-K95',
    code_1: 'K50-K52'
  },
  {
    code: 'K514',
    level: 3,
    description: 'Seudopoliposis del colon',
    code_2: 'K51',
    code_0: 'K00-K95',
    code_1: 'K50-K52'
  },
  {
    code: 'K515',
    level: 3,
    description: 'Proctocolitis mucosa',
    code_2: 'K51',
    code_0: 'K00-K95',
    code_1: 'K50-K52'
  },
  {
    code: 'K518',
    level: 3,
    description: 'Otras colitis ulcerativas',
    code_2: 'K51',
    code_0: 'K00-K95',
    code_1: 'K50-K52'
  },
  {
    code: 'K519',
    level: 3,
    description: 'Colitis ulcerativa, sin otra especificaci\u00f3n',
    code_2: 'K51',
    code_0: 'K00-K95',
    code_1: 'K50-K52'
  },
  {
    code: 'T253',
    level: 4,
    description: 'Quemadura del tobillo y del pie, de tercer grado',
    code_3: 'T25',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T254',
    level: 4,
    description: 'Corrosi\u00f3n del tobillo y del pie, grado no especificado',
    code_3: 'T25',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T255',
    level: 4,
    description: 'Corrosi\u00f3n del tobillo y del pie, de primer grado',
    code_3: 'T25',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T256',
    level: 4,
    description: 'Corrosi\u00f3n del tobillo y del pie, de segundo grado',
    code_3: 'T25',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T257',
    level: 4,
    description: 'Corrosi\u00f3n del tobillo y del pie, de tercer grado',
    code_3: 'T25',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'K500',
    level: 3,
    description: 'Enfermedad de Crohn del intestino delgado',
    code_2: 'K50',
    code_0: 'K00-K95',
    code_1: 'K50-K52'
  },
  {
    code: 'K501',
    level: 3,
    description: 'Enfermedad de Crohn del intestino grueso',
    code_2: 'K50',
    code_0: 'K00-K95',
    code_1: 'K50-K52'
  },
  {
    code: 'K508',
    level: 3,
    description: 'Otros tipos de enfermedad de Crohn',
    code_2: 'K50',
    code_0: 'K00-K95',
    code_1: 'K50-K52'
  },
  {
    code: 'K509',
    level: 3,
    description: 'Enfermedad de Crohn, no especificada',
    code_2: 'K50',
    code_0: 'K00-K95',
    code_1: 'K50-K52'
  },
  {
    code: 'T243',
    level: 4,
    description:
      'Quemadura de la cadera y miembro inferior, de tercer grado, excepto tobillo y pie',
    code_3: 'T24',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T244',
    level: 4,
    description:
      'Corrosi\u00f3n de la cadera y miembro inferior, grado no especificado, excepto tobillo y pie',
    code_3: 'T24',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T245',
    level: 4,
    description:
      'Corrosi\u00f3n de la cadera y miembro inferior, de primer grado, excepto tobillo y pie',
    code_3: 'T24',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T246',
    level: 4,
    description:
      'Corrosi\u00f3n de la cadera y miembro inferior, de segundo grado, excepto tobillo y pie',
    code_3: 'T24',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T247',
    level: 4,
    description:
      'Corrosi\u00f3n de la cadera y miembro inferior, de tercer grado, excepto tobillo y pie',
    code_3: 'T24',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T20-T25'
  },
  {
    code: 'T324',
    level: 4,
    description:
      'Corrosiones que afectan del 40 al 49% de la superficie del cuerpo',
    code_3: 'T32',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T29-T32'
  },
  {
    code: 'T325',
    level: 4,
    description:
      'Corrosiones que afectan del 50 al 59% de la superficie del cuerpo',
    code_3: 'T32',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T29-T32'
  },
  {
    code: 'T326',
    level: 4,
    description:
      'Corrosiones que afectan del 60 al 69% de la superficie del cuerpo',
    code_3: 'T32',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T29-T32'
  },
  {
    code: 'T327',
    level: 4,
    description:
      'Corrosiones que afectan del 70 al 79% de la superficie del cuerpo',
    code_3: 'T32',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T29-T32'
  },
  {
    code: 'T328',
    level: 4,
    description:
      'Corrosiones que afectan del 80 al 89% de la superficie del cuerpo',
    code_3: 'T32',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T29-T32'
  },
  {
    code: 'T329',
    level: 4,
    description:
      'Corrosiones que afectan el 90% o m\u00e1s de la superficie del cuerpo',
    code_3: 'T32',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T29-T32'
  },
  {
    code: 'T313',
    level: 4,
    description:
      'Quemaduras que afectan del 30 al 39% de la superficie del cuerpo',
    code_3: 'T31',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T29-T32'
  },
  {
    code: 'T314',
    level: 4,
    description:
      'Quemaduras que afectan del 40 al 49% de la superficie del cuerpo',
    code_3: 'T31',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T29-T32'
  },
  {
    code: 'T315',
    level: 4,
    description:
      'Quemaduras que afectan del 50 al 59% de la superficie del cuerpo',
    code_3: 'T31',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T29-T32'
  },
  {
    code: 'T316',
    level: 4,
    description:
      'Quemaduras que afectan del 60 al 69% de la superficie del cuerpo',
    code_3: 'T31',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T29-T32'
  },
  {
    code: 'T317',
    level: 4,
    description:
      'Quemaduras que afectan del 70 al 79% de la superficie del cuerpo',
    code_3: 'T31',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T29-T32'
  },
  {
    code: 'T318',
    level: 4,
    description:
      'Quemaduras que afectan del 80 al 89% de la superficie del cuerpo',
    code_3: 'T31',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T29-T32'
  },
  {
    code: 'T319',
    level: 4,
    description:
      'Quemaduras que afectan el 90% o m\u00e1s de la superficie del cuerpo',
    code_3: 'T31',
    code_0: 'S00-T88',
    code_1: 'T20-T32',
    code_2: 'T29-T32'
  },
  {
    code: 'K610',
    level: 3,
    description: 'Absceso anal',
    code_2: 'K61',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K611',
    level: 3,
    description: 'Absceso rectal',
    code_2: 'K61',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K612',
    level: 3,
    description: 'Absceso anorrectal',
    code_2: 'K61',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K613',
    level: 3,
    description: 'Absceso isquiorrectal',
    code_2: 'K61',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K614',
    level: 3,
    description: 'Absceso intraesfinteriano',
    code_2: 'K61',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'N179',
    level: 3,
    description: 'Insuficiencia renal aguda, no especificada',
    code_2: 'N17',
    code_0: 'N00-N99',
    code_1: 'N17-N19'
  },
  {
    code: 'K600',
    level: 3,
    description: 'Fisura anal aguda',
    code_2: 'K60',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K601',
    level: 3,
    description: 'Fisura anal cr\u00f3nica',
    code_2: 'K60',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K602',
    level: 3,
    description: 'Fisura anal, no especificada',
    code_2: 'K60',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K603',
    level: 3,
    description: 'F\u00edstula anal',
    code_2: 'K60',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K604',
    level: 3,
    description: 'F\u00edstula rectal',
    code_2: 'K60',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K605',
    level: 3,
    description: 'F\u00edstula anorrectal',
    code_2: 'K60',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K590',
    level: 3,
    description: 'Constipaci\u00f3n',
    code_2: 'K59',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K591',
    level: 3,
    description: 'Diarrea funcional',
    code_2: 'K59',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K592',
    level: 3,
    description: 'Intestino neurog\u00e9nico, no clasificado en otra parte',
    code_2: 'K59',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K593',
    level: 3,
    description: 'Megacolon, no clasificado en otra parte',
    code_2: 'K59',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K594',
    level: 3,
    description: 'Espasmo anal',
    code_2: 'K59',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K598',
    level: 3,
    description: 'Otros trastornos funcionales especificados del intestino',
    code_2: 'K59',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K599',
    level: 3,
    description: 'Trastorno funcional intestinal, no especificado',
    code_2: 'K59',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K580',
    level: 3,
    description: 'S\u00edndrome del colon irritable con diarrea',
    code_2: 'K58',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K589',
    level: 3,
    description: 'S\u00edndrome del colon irritable sin diarrea',
    code_2: 'K58',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K570',
    level: 3,
    description:
      'Enfermedad diverticular del intestino delgado con perforaci\u00f3n y absceso',
    code_2: 'K57',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K571',
    level: 3,
    description:
      'Enfermedad diverticular del intestino delgado sin perforaci\u00f3n ni absceso',
    code_2: 'K57',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K572',
    level: 3,
    description:
      'Enfermedad diverticular del intestino grueso con perforaci\u00f3n y absceso',
    code_2: 'K57',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K573',
    level: 3,
    description:
      'Enfermedad diverticular del intestino grueso sin perforaci\u00f3n ni absceso',
    code_2: 'K57',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K574',
    level: 3,
    description:
      'Enfermedad diverticular de ambos intestinos con perforaci\u00f3n y absceso',
    code_2: 'K57',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K575',
    level: 3,
    description:
      'Enfermedad diverticular de ambos intestinos, sin perforaci\u00f3n ni absceso',
    code_2: 'K57',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K578',
    level: 3,
    description:
      'Enfermedad diverticular del intestino, parte no especificada, con perforaci\u00f3n y absceso',
    code_2: 'K57',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K579',
    level: 3,
    description:
      'Enfermedad diverticular del intestino, parte no especificada, sin perforaci\u00f3n ni absceso',
    code_2: 'K57',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K560',
    level: 3,
    description: '\u00cdleo paral\u00edtico',
    code_2: 'K56',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K561',
    level: 3,
    description: 'Invaginaci\u00f3n',
    code_2: 'K56',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K562',
    level: 3,
    description: 'V\u00f3lvulo',
    code_2: 'K56',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K563',
    level: 3,
    description: '\u00cdleo por c\u00e1lculo biliar',
    code_2: 'K56',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K564',
    level: 3,
    description: 'Otras obstrucciones del intestino',
    code_2: 'K56',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K565',
    level: 3,
    description: 'Adherencias [bridas] intestinales con obstrucci\u00f3n',
    code_2: 'K56',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K566',
    level: 3,
    description: 'Otras obstrucciones intestinales y las no especificadas',
    code_2: 'K56',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K567',
    level: 3,
    description: '\u00cdleo, no especificado',
    code_2: 'K56',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K550',
    level: 3,
    description: 'Trastorno vascular agudo de los intestinos',
    code_2: 'K55',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K551',
    level: 3,
    description: 'Trastorno vascular cr\u00f3nico del intestino',
    code_2: 'K55',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K552',
    level: 3,
    description: 'Angiodisplasia del colon',
    code_2: 'K55',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K558',
    level: 3,
    description: 'Otros trastornos vasculares del intestino',
    code_2: 'K55',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'K559',
    level: 3,
    description: 'Trastorno vascular del intestino, no especificado',
    code_2: 'K55',
    code_0: 'K00-K95',
    code_1: 'K55-K63'
  },
  {
    code: 'J040',
    level: 3,
    description: 'Laringitis aguda',
    code_2: 'J04',
    code_0: 'J00-J99',
    code_1: 'J00-J06'
  },
  {
    code: 'J041',
    level: 3,
    description: 'Traque\u00edtis aguda',
    code_2: 'J04',
    code_0: 'J00-J99',
    code_1: 'J00-J06'
  },
  {
    code: 'J042',
    level: 3,
    description: 'Laringotraque\u00edtis aguda',
    code_2: 'J04',
    code_0: 'J00-J99',
    code_1: 'J00-J06'
  },
  {
    code: 'J030',
    level: 3,
    description: 'Amigdalitis estreptoc\u00f3cica',
    code_2: 'J03',
    code_0: 'J00-J99',
    code_1: 'J00-J06'
  },
  {
    code: 'J038',
    level: 3,
    description:
      'Amigdalitis aguda debida a otros microorganismos especificados',
    code_2: 'J03',
    code_0: 'J00-J99',
    code_1: 'J00-J06'
  },
  {
    code: 'J039',
    level: 3,
    description: 'Amigdalitis aguda, no especificada',
    code_2: 'J03',
    code_0: 'J00-J99',
    code_1: 'J00-J06'
  },
  {
    code: 'J020',
    level: 3,
    description: 'Faringitis estreptoc\u00f3cica',
    code_2: 'J02',
    code_0: 'J00-J99',
    code_1: 'J00-J06'
  },
  {
    code: 'J028',
    level: 3,
    description:
      'Faringitis aguda debida a otros microorganismos especificados',
    code_2: 'J02',
    code_0: 'J00-J99',
    code_1: 'J00-J06'
  },
  {
    code: 'J029',
    level: 3,
    description: 'Faringitis aguda, no especificada',
    code_2: 'J02',
    code_0: 'J00-J99',
    code_1: 'J00-J06'
  },
  {
    code: 'J010',
    level: 3,
    description: 'Sinusitis maxilar aguda',
    code_2: 'J01',
    code_0: 'J00-J99',
    code_1: 'J00-J06'
  },
  {
    code: 'J011',
    level: 3,
    description: 'Sinusitis frontal aguda',
    code_2: 'J01',
    code_0: 'J00-J99',
    code_1: 'J00-J06'
  },
  {
    code: 'J012',
    level: 3,
    description: 'Sinusitis etmoidal aguda',
    code_2: 'J01',
    code_0: 'J00-J99',
    code_1: 'J00-J06'
  },
  {
    code: 'J110',
    level: 3,
    description:
      'Influenza con neumon\u00eda, virus no identificado (Bronco)neumon\u00eda gripal, no especificada o sin identificaci\u00f3n del virus espec\u00edfico',
    code_2: 'J11',
    code_0: 'J00-J99',
    code_1: 'J09-J18 '
  },
  {
    code: 'J111',
    level: 3,
    description:
      'Influenza con otras manifestaciones respiratorias, virus no identificado',
    code_2: 'J11',
    code_0: 'J00-J99',
    code_1: 'J09-J18 '
  },
  {
    code: 'J118',
    level: 3,
    description: 'Influenza con otras manifestaciones, virus no identificado',
    code_2: 'J11',
    code_0: 'J00-J99',
    code_1: 'J09-J18 '
  },
  {
    code: 'J100',
    level: 3,
    description:
      'Influenza con neumon\u00eda, debida a otro virus de la influenza identificado',
    code_2: 'J10',
    code_0: 'J00-J99',
    code_1: 'J09-J18 '
  },
  {
    code: 'J101',
    level: 3,
    description:
      'Influenza con otras manifestaciones respiratorias, debida a otro virus de la influenza identificado',
    code_2: 'J10',
    code_0: 'J00-J99',
    code_1: 'J09-J18 '
  },
  {
    code: 'J108',
    level: 3,
    description:
      'Influenza, con otras manifestaciones, debida a otro virus de la influenza identificado',
    code_2: 'J10',
    code_0: 'J00-J99',
    code_1: 'J09-J18 '
  },
  {
    code: 'J210',
    level: 3,
    description: 'Bronquiolitis aguda debida a virus sincitial respiratorio',
    code_2: 'J21',
    code_0: 'J00-J99',
    code_1: 'J20-J22'
  },
  {
    code: 'J218',
    level: 3,
    description:
      'Bronquiolitis aguda debida a otros microorganismos especificados',
    code_2: 'J21',
    code_0: 'J00-J99',
    code_1: 'J20-J22'
  },
  {
    code: 'J219',
    level: 3,
    description: 'Bronquiolitis aguda, no especificada',
    code_2: 'J21',
    code_0: 'J00-J99',
    code_1: 'J20-J22'
  },
  {
    code: 'J200',
    level: 3,
    description: 'Bronquitis aguda debida a Mycoplasma pneumoniae',
    code_2: 'J20',
    code_0: 'J00-J99',
    code_1: 'J20-J22'
  },
  {
    code: 'J201',
    level: 3,
    description: 'Bronquitis aguda debida a Haemophilus influenzae',
    code_2: 'J20',
    code_0: 'J00-J99',
    code_1: 'J20-J22'
  },
  {
    code: 'J202',
    level: 3,
    description: 'Bronquitis aguda debida a estreptococos',
    code_2: 'J20',
    code_0: 'J00-J99',
    code_1: 'J20-J22'
  },
  {
    code: 'J203',
    level: 3,
    description: 'Bronquitis aguda debida a virus Coxsackie',
    code_2: 'J20',
    code_0: 'J00-J99',
    code_1: 'J20-J22'
  },
  {
    code: 'J204',
    level: 3,
    description: 'Bronquitis aguda debida a virus parainfluenza',
    code_2: 'J20',
    code_0: 'J00-J99',
    code_1: 'J20-J22'
  },
  {
    code: 'J320',
    level: 3,
    description: 'Sinusitis maxilar cr\u00f3nica',
    code_2: 'J32',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J321',
    level: 3,
    description: 'Sinusitis frontal cr\u00f3nica',
    code_2: 'J32',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J322',
    level: 3,
    description: 'Sinusitis etmoidal cr\u00f3nica',
    code_2: 'J32',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J323',
    level: 3,
    description: 'Sinusitis esfenoidal cr\u00f3nica',
    code_2: 'J32',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J324',
    level: 3,
    description: 'Pansinusitis cr\u00f3nica',
    code_2: 'J32',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J328',
    level: 3,
    description: 'Otras sinusitis cr\u00f3nicas',
    code_2: 'J32',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J329',
    level: 3,
    description: 'Sinusitis cr\u00f3nica, no especificada',
    code_2: 'J32',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J310',
    level: 3,
    description: 'Rinitis cr\u00f3nica',
    code_2: 'J31',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J311',
    level: 3,
    description: 'Rinofaringitis cr\u00f3nica',
    code_2: 'J31',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J312',
    level: 3,
    description: 'Faringitis cr\u00f3nica',
    code_2: 'J31',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J300',
    level: 3,
    description: 'Rinitis vasomotora',
    code_2: 'J30',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J301',
    level: 3,
    description: 'Rinitis al\u00e9rgica debida al polen',
    code_2: 'J30',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J302',
    level: 3,
    description: 'Otra rinitis al\u00e9rgica estacional',
    code_2: 'J30',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J303',
    level: 3,
    description: 'Otras rinitis al\u00e9rgicas',
    code_2: 'J30',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'J304',
    level: 3,
    description: 'Rinitis al\u00e9rgica, no especificada',
    code_2: 'J30',
    code_0: 'J00-J99',
    code_1: 'J30-J39 '
  },
  {
    code: 'I020',
    level: 3,
    description: 'Corea reum\u00e1tica con complicaci\u00f3n card\u00edaca',
    code_2: 'I02',
    code_0: 'I00-I99',
    code_1: 'I00-I02'
  },
  {
    code: 'I029',
    level: 3,
    description:
      'Corea reum\u00e1tica sin menci\u00f3n de complicaci\u00f3n card\u00edaca',
    code_2: 'I02',
    code_0: 'I00-I99',
    code_1: 'I00-I02'
  },
  {
    code: 'I010',
    level: 3,
    description: 'Pericarditis reum\u00e1tica aguda',
    code_2: 'I01',
    code_0: 'I00-I99',
    code_1: 'I00-I02'
  },
  {
    code: 'I011',
    level: 3,
    description: 'Endocarditis reum\u00e1tica aguda',
    code_2: 'I01',
    code_0: 'I00-I99',
    code_1: 'I00-I02'
  },
  {
    code: 'I012',
    level: 3,
    description: 'Miocarditis reum\u00e1tica aguda',
    code_2: 'I01',
    code_0: 'I00-I99',
    code_1: 'I00-I02'
  },
  {
    code: 'I018',
    level: 3,
    description: 'Otras enfermedades reum\u00e1ticas agudas del coraz\u00f3n',
    code_2: 'I01',
    code_0: 'I00-I99',
    code_1: 'I00-I02'
  },
  {
    code: 'I019',
    level: 3,
    description:
      'Enfermedad reum\u00e1tica aguda del coraz\u00f3n, no especificada',
    code_2: 'I01',
    code_0: 'I00-I99',
    code_1: 'I00-I02'
  },
  {
    code: 'I080',
    level: 3,
    description: 'Trastornos de las v\u00e1lvulas mitral y a\u00f3rtica',
    code_2: 'I08',
    code_0: 'I00-I99',
    code_1: 'I05-I09'
  },
  {
    code: 'I081',
    level: 3,
    description: 'Trastornos de las v\u00e1lvulas mitral y tric\u00faspide',
    code_2: 'I08',
    code_0: 'I00-I99',
    code_1: 'I05-I09'
  },
  {
    code: 'I082',
    level: 3,
    description:
      'Trastornos de las v\u00e1lvulas a\u00f3rtica y tric\u00faspide',
    code_2: 'I08',
    code_0: 'I00-I99',
    code_1: 'I05-I09'
  },
  {
    code: 'I083',
    level: 3,
    description:
      'Trastornos combinados de las v\u00e1lvulas mitral, tric\u00faspide y a\u00f3rtica',
    code_2: 'I08',
    code_0: 'I00-I99',
    code_1: 'I05-I09'
  },
  {
    code: 'I088',
    level: 3,
    description: 'Otras enfermedades de m\u00faltiples v\u00e1lvulas',
    code_2: 'I08',
    code_0: 'I00-I99',
    code_1: 'I05-I09'
  },
  {
    code: 'I089',
    level: 3,
    description: 'Enfermedad de m\u00faltiples v\u00e1lvulas, no especificada',
    code_2: 'I08',
    code_0: 'I00-I99',
    code_1: 'I05-I09'
  },
  {
    code: 'A158',
    level: 3,
    description:
      'Otras tuberculosis respiratorias, confirmadas bacteriol\u00f3gica e histol\u00f3gicamente',
    code_2: 'A15',
    code_0: 'A00-B99',
    code_1: 'A15-A19'
  },
  {
    code: 'A159',
    level: 3,
    description:
      'Tuberculosis respiratoria no especificada, confirmada bacteriol\u00f3gica e histol\u00f3gicamente',
    code_2: 'A15',
    code_0: 'A00-B99',
    code_1: 'A15-A19'
  },
  {
    code: 'A328',
    level: 3,
    description: 'Otras formas de listeriosis',
    code_2: 'A32',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A329',
    level: 3,
    description: 'Listeriosis, no especificada',
    code_2: 'A32',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A319',
    level: 3,
    description: 'Infecci\u00f3n por micobacteria, no especificada',
    code_2: 'A31',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A303',
    level: 3,
    description: 'Lepra lim\u00edtrofe',
    code_2: 'A30',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A304',
    level: 3,
    description: 'Lepra lepromatosa lim\u00edtrofe',
    code_2: 'A30',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A305',
    level: 3,
    description: 'Lepra lepromatosa',
    code_2: 'A30',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A308',
    level: 3,
    description: 'Otras formas de lepra',
    code_2: 'A30',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A309',
    level: 3,
    description: 'Lepra, no especificada',
    code_2: 'A30',
    code_0: 'A00-B99',
    code_1: 'A30-A49'
  },
  {
    code: 'A528',
    level: 3,
    description: 'S\u00edfilis tard\u00eda, latente',
    code_2: 'A52',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A529',
    level: 3,
    description: 'S\u00edfilis tard\u00eda, no especificada',
    code_2: 'A52',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A519',
    level: 3,
    description: 'S\u00edfilis precoz, sin otra especificaci\u00f3n',
    code_2: 'A51',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A504',
    level: 3,
    description:
      'Neuros\u00edfilis cong\u00e9nita tard\u00eda [neuros\u00edfilis juvenil]',
    code_2: 'A50',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A505',
    level: 3,
    description:
      'Otras formas de s\u00edfilis cong\u00e9nita tard\u00eda, sintom\u00e1tica',
    code_2: 'A50',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A506',
    level: 3,
    description: 'S\u00edfilis cong\u00e9nita tard\u00eda, latente',
    code_2: 'A50',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A507',
    level: 3,
    description:
      'S\u00edfilis cong\u00e9nita tard\u00eda, sin otra especificaci\u00f3n',
    code_2: 'A50',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A509',
    level: 3,
    description: 'S\u00edfilis cong\u00e9nita, sin otra especificaci\u00f3n',
    code_2: 'A50',
    code_0: 'A00-B99',
    code_1: 'A50-A64'
  },
  {
    code: 'A667',
    level: 3,
    description: 'Otras manifestaciones de frambesia',
    code_2: 'A66',
    code_0: 'A00-B99',
    code_1: 'A65-A69'
  },
  {
    code: 'A668',
    level: 3,
    description: 'Frambesia latente',
    code_2: 'A66',
    code_0: 'A00-B99',
    code_1: 'A65-A69'
  },
  {
    code: 'A669',
    level: 3,
    description: 'Frambesia, no especificada',
    code_2: 'A66',
    code_0: 'A00-B99',
    code_1: 'A65-A69'
  },
  {
    code: 'M19',
    level: 3,
    description: 'Otras artrosis',
    code_2: 'M15-M19',
    code_0: 'M00-M99',
    code_1: 'M00-M25'
  },
  {
    code: 'M12',
    level: 3,
    description: 'Otras artropat\u00edas espec\u00edficas',
    code_2: 'M05-M14',
    code_0: 'M00-M99',
    code_1: 'M00-M25'
  },
  {
    code: 'M13',
    level: 3,
    description: 'Otras artritis',
    code_2: 'M05-M14',
    code_0: 'M00-M99',
    code_1: 'M00-M25'
  },
  {
    code: 'M14',
    level: 3,
    description:
      'Artropat\u00eda en otras enfermedades clasificadas en otra parte',
    code_2: 'M05-M14',
    code_0: 'M00-M99',
    code_1: 'M00-M25'
  },
  {
    code: 'M315',
    level: 3,
    description:
      'Arteritis de c\u00e9lulas gigantes con polimialgia reum\u00e1tica',
    code_2: 'M31',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M316',
    level: 3,
    description: 'Otras arteritis de c\u00e9lulas gigantes',
    code_2: 'M31',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M317',
    level: 3,
    description: 'Poliangi\u00edtis microsc\u00f3pica',
    code_2: 'M31',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M318',
    level: 3,
    description: 'Otras vasculopat\u00edas necrotizantes especificadas',
    code_2: 'M31',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M319',
    level: 3,
    description: 'Vasculopat\u00eda necrotizante, no especificada',
    code_2: 'M31',
    code_0: 'M00-M99',
    code_1: 'M30-M36'
  },
  {
    code: 'M75',
    level: 3,
    description: 'Lesiones del hombro',
    code_2: 'M70-M79',
    code_0: 'M00-M99',
    code_1: 'M60-M79'
  },
  {
    code: 'M76',
    level: 3,
    description: 'Entesopat\u00edas del miembro inferior, excluido el pie',
    code_2: 'M70-M79',
    code_0: 'M00-M99',
    code_1: 'M60-M79'
  },
  {
    code: 'M77',
    level: 3,
    description: 'Otras entesopat\u00edas',
    code_2: 'M70-M79',
    code_0: 'M00-M99',
    code_1: 'M60-M79'
  },
  {
    code: 'M79',
    level: 3,
    description:
      'Otros trastornos de los tejidos blandos, no clasificados en otra parte',
    code_2: 'M70-M79',
    code_0: 'M00-M99',
    code_1: 'M60-M79'
  },
  {
    code: 'M63',
    level: 3,
    description:
      'Trastornos de los m\u00fasculos en enfermedades clasificadas en otra parte',
    code_2: 'M60-M63',
    code_0: 'M00-M99',
    code_1: 'M60-M79'
  },
  {
    code: 'M94',
    level: 3,
    description: 'Otros trastornos del cart\u00edlago',
    code_2: 'M91-M94',
    code_0: 'M00-M99',
    code_1: 'M80-M94'
  },
  {
    code: 'M85',
    level: 3,
    description:
      'Otros trastornos de la densidad y de la estructura \u00f3seas',
    code_2: 'M80-M85',
    code_0: 'M00-M99',
    code_1: 'M80-M94'
  },
  {
    code: 'I070',
    level: 3,
    description: 'Estenosis tric\u00faspide',
    code_2: 'I07',
    code_0: 'I00-I99',
    code_1: 'I05-I09'
  },
  {
    code: 'I071',
    level: 3,
    description: 'Insuficiencia tric\u00faspide',
    code_2: 'I07',
    code_0: 'I00-I99',
    code_1: 'I05-I09'
  },
  {
    code: 'I072',
    level: 3,
    description: 'Estenosis e insuficiencia tric\u00faspide',
    code_2: 'I07',
    code_0: 'I00-I99',
    code_1: 'I05-I09'
  },
  {
    code: 'I078',
    level: 3,
    description: 'Otras enfermedades de la v\u00e1lvula tric\u00faspide',
    code_2: 'I07',
    code_0: 'I00-I99',
    code_1: 'I05-I09'
  },
  {
    code: 'I079',
    level: 3,
    description:
      'Enfermedad de la v\u00e1lvula tric\u00faspide, no especificada',
    code_2: 'I07',
    code_0: 'I00-I99',
    code_1: 'I05-I09'
  },
  {
    code: 'I060',
    level: 3,
    description: 'Estenosis a\u00f3rtica reum\u00e1tica',
    code_2: 'I06',
    code_0: 'I00-I99',
    code_1: 'I05-I09'
  },
  {
    code: 'I061',
    level: 3,
    description: 'Insuficiencia a\u00f3rtica reum\u00e1tica',
    code_2: 'I06',
    code_0: 'I00-I99',
    code_1: 'I05-I09'
  },
  {
    code: 'I062',
    level: 3,
    description: 'Estenosis a\u00f3rtica reum\u00e1tica con insuficiencia',
    code_2: 'I06',
    code_0: 'I00-I99',
    code_1: 'I05-I09'
  },
  {
    code: 'I068',
    level: 3,
    description:
      'Otras enfermedades reum\u00e1ticas de la v\u00e1lvula a\u00f3rtica',
    code_2: 'I06',
    code_0: 'I00-I99',
    code_1: 'I05-I09'
  },
  {
    code: 'I069',
    level: 3,
    description:
      'Enfermedad valvular a\u00f3rtica reum\u00e1tica, no especificada',
    code_2: 'I06',
    code_0: 'I00-I99',
    code_1: 'I05-I09'
  },
  {
    code: 'I050',
    level: 3,
    description: 'Estenosis mitral',
    code_2: 'I05',
    code_0: 'I00-I99',
    code_1: 'I05-I09'
  },
  {
    code: 'I051',
    level: 3,
    description: 'Insuficiencia mitral reum\u00e1tica',
    code_2: 'I05',
    code_0: 'I00-I99',
    code_1: 'I05-I09'
  },
  {
    code: 'I052',
    level: 3,
    description: 'Estenosis mitral con insuficiencia',
    code_2: 'I05',
    code_0: 'I00-I99',
    code_1: 'I05-I09'
  },
  {
    code: 'I058',
    level: 3,
    description: 'Otras enfermedades de la v\u00e1lvula mitral',
    code_2: 'I05',
    code_0: 'I00-I99',
    code_1: 'I05-I09'
  },
  {
    code: 'I059',
    level: 3,
    description: 'Enfermedad valvular mitral, no especificada',
    code_2: 'I05',
    code_0: 'I00-I99',
    code_1: 'I05-I09'
  },
  {
    code: 'I110',
    level: 3,
    description:
      'Enfermedad card\u00edaca hipertensiva con insuficiencia card\u00edaca (congestiva)',
    code_2: 'I11',
    code_0: 'I00-I99',
    code_1: 'I10-I15'
  },
  {
    code: 'I119',
    level: 3,
    description:
      'Enfermedad card\u00edaca hipertensiva sin insuficiencia card\u00edaca (congestiva)',
    code_2: 'I11',
    code_0: 'I00-I99',
    code_1: 'I10-I15'
  },
  {
    code: 'I220',
    level: 3,
    description: 'Infarto subsecuente del miocardio de la pared anterior',
    code_2: 'I22',
    code_0: 'I00-I99',
    code_1: 'I20-I25'
  },
  {
    code: 'I221',
    level: 3,
    description: 'Infarto subsecuente del miocardio de la pared inferior',
    code_2: 'I22',
    code_0: 'I00-I99',
    code_1: 'I20-I25'
  },
  {
    code: 'I228',
    level: 3,
    description: 'Infarto subsecuente del miocardio de otros sitios',
    code_2: 'I22',
    code_0: 'I00-I99',
    code_1: 'I20-I25'
  },
  {
    code: 'I229',
    level: 3,
    description: 'Infarto subsecuente del miocardio, de parte no especificada',
    code_2: 'I22',
    code_0: 'I00-I99',
    code_1: 'I20-I25'
  },
  {
    code: 'I210',
    level: 3,
    description: 'Infarto transmural agudo del miocardio de la pared anterior',
    code_2: 'I21',
    code_0: 'I00-I99',
    code_1: 'I20-I25'
  },
  {
    code: 'I211',
    level: 3,
    description: 'Infarto transmural agudo del miocardio de la pared inferior',
    code_2: 'I21',
    code_0: 'I00-I99',
    code_1: 'I20-I25'
  },
  {
    code: 'I212',
    level: 3,
    description: 'Infarto agudo transmural del miocardio de otros sitios',
    code_2: 'I21',
    code_0: 'I00-I99',
    code_1: 'I20-I25'
  },
  {
    code: 'I213',
    level: 3,
    description:
      'Infarto transmural agudo del miocardio, de sitio no especificado',
    code_2: 'I21',
    code_0: 'I00-I99',
    code_1: 'I20-I25'
  },
  {
    code: 'I214',
    level: 3,
    description: 'Infarto subendoc\u00e1rdico agudo del miocardio',
    code_2: 'I21',
    code_0: 'I00-I99',
    code_1: 'I20-I25'
  },
  {
    code: 'I219',
    level: 3,
    description: 'Infarto agudo del miocardio, sin otra especificaci\u00f3n',
    code_2: 'I21',
    code_0: 'I00-I99',
    code_1: 'I20-I25'
  },
  {
    code: 'I200',
    level: 3,
    description: 'Angina inestable',
    code_2: 'I20',
    code_0: 'I00-I99',
    code_1: 'I20-I25'
  },
  {
    code: 'I201',
    level: 3,
    description: 'Angina de pecho con espasmo documentado',
    code_2: 'I20',
    code_0: 'I00-I99',
    code_1: 'I20-I25'
  },
  {
    code: 'I208',
    level: 3,
    description: 'Otras formas especificadas de angina de pecho',
    code_2: 'I20',
    code_0: 'I00-I99',
    code_1: 'I20-I25'
  },
  {
    code: 'I209',
    level: 3,
    description: 'Angina de pecho, no especificada',
    code_2: 'I20',
    code_0: 'I00-I99',
    code_1: 'I20-I25'
  },
  {
    code: 'S430',
    level: 3,
    description: 'Luxaci\u00f3n de la articulaci\u00f3n del hombro',
    code_2: 'S43',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S431',
    level: 3,
    description: 'Luxaci\u00f3n de la articulaci\u00f3n acromioclavicular',
    code_2: 'S43',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S432',
    level: 3,
    description: 'Luxaci\u00f3n de la articulaci\u00f3n esternoclavicular',
    code_2: 'S43',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S433',
    level: 3,
    description:
      'Luxaci\u00f3n de otras partes de la cintura escapular y de las no especificadas',
    code_2: 'S43',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S434',
    level: 3,
    description: 'Esguinces y torceduras de la articulaci\u00f3n del hombro',
    code_2: 'S43',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S420',
    level: 3,
    description: 'Fractura de la clav\u00edcula',
    code_2: 'S42',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S421',
    level: 3,
    description: 'Fractura del om\u00f3plato',
    code_2: 'S42',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S422',
    level: 3,
    description: 'Fractura de la ep\u00edfisis superior del h\u00famero',
    code_2: 'S42',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S423',
    level: 3,
    description: 'Fractura de la di\u00e1fisis del h\u00famero',
    code_2: 'S42',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S424',
    level: 3,
    description: 'Fractura de la ep\u00edfisis inferior del h\u00famero',
    code_2: 'S42',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S427',
    level: 3,
    description:
      'Fracturas m\u00faltiples de la clav\u00edcula, del om\u00f3plato y del h\u00famero',
    code_2: 'S42',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S428',
    level: 3,
    description: 'Fractura de otras partes del hombro y del brazo',
    code_2: 'S42',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S429',
    level: 3,
    description: 'Fractura del hombro y del brazo, parte no especificada',
    code_2: 'S42',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S410',
    level: 3,
    description: 'Herida del hombro',
    code_2: 'S41',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S411',
    level: 3,
    description: 'Herida del brazo',
    code_2: 'S41',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S417',
    level: 3,
    description: 'Heridas m\u00faltiples del hombro y del brazo',
    code_2: 'S41',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S418',
    level: 3,
    description:
      'Herida de otras partes y de las no especificadas del hombro y del brazo',
    code_2: 'S41',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S400',
    level: 3,
    description: 'Contusi\u00f3n del hombro y del brazo',
    code_2: 'S40',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S407',
    level: 3,
    description:
      'Traumatismos superficiales m\u00faltiples del hombro y del brazo',
    code_2: 'S40',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S408',
    level: 3,
    description: 'Otros traumatismos superficiales del hombro y del brazo',
    code_2: 'S40',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S540',
    level: 3,
    description: 'Traumatismo del nervio cubital a nivel del antebrazo',
    code_2: 'S54',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S541',
    level: 3,
    description: 'Traumatismo del nervio mediano a nivel del antebrazo',
    code_2: 'S54',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S542',
    level: 3,
    description: 'Traumatismo del nervio radial a nivel del antebrazo',
    code_2: 'S54',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S543',
    level: 3,
    description:
      'Traumatismo del nervio sensorial cut\u00e1neo a nivel del antebrazo',
    code_2: 'S54',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S547',
    level: 3,
    description: 'Traumatismo de m\u00faltiples nervios a nivel del antebrazo',
    code_2: 'S54',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S548',
    level: 3,
    description: 'Traumatismo de otros nervios a nivel del antebrazo',
    code_2: 'S54',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S549',
    level: 3,
    description: 'Traumatismo de nervio no especificado a nivel del antebrazo',
    code_2: 'S54',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S530',
    level: 3,
    description: 'Luxaci\u00f3n de la cabeza del radio',
    code_2: 'S53',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S531',
    level: 3,
    description: 'Luxaci\u00f3n del codo, no especificada',
    code_2: 'S53',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S532',
    level: 3,
    description: 'Ruptura traum\u00e1tica del ligamento lateral del radio',
    code_2: 'S53',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S533',
    level: 3,
    description:
      'Ruptura traum\u00e1tica del ligamento lateral del c\u00fabito',
    code_2: 'S53',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S534',
    level: 3,
    description: 'Esguinces y torceduras del codo',
    code_2: 'S53',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S520',
    level: 3,
    description: 'Fractura de la ep\u00edfisis superior del c\u00fabito',
    code_2: 'S52',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S521',
    level: 3,
    description: 'Fractura de la ep\u00edfisis superior del radio',
    code_2: 'S52',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S522',
    level: 3,
    description: 'Fractura de la di\u00e1fisis del c\u00fabito',
    code_2: 'S52',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S523',
    level: 3,
    description: 'Fractura de la di\u00e1fisis del radio',
    code_2: 'S52',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S524',
    level: 3,
    description: 'Fractura de la di\u00e1fisis del c\u00fabito y del radio',
    code_2: 'S52',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S510',
    level: 3,
    description: 'Herida del codo',
    code_2: 'S51',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S517',
    level: 3,
    description: 'Heridas m\u00faltiples del antebrazo',
    code_2: 'S51',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S518',
    level: 3,
    description: 'Herida de otras partes del antebrazo',
    code_2: 'S51',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S519',
    level: 3,
    description: 'Herida del antebrazo, parte no especificada',
    code_2: 'S51',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S500',
    level: 3,
    description: 'Contusi\u00f3n del codo',
    code_2: 'S50',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S501',
    level: 3,
    description:
      'Contusi\u00f3n de otras partes del antebrazo y de las no especificadas',
    code_2: 'S50',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S507',
    level: 3,
    description: 'Traumatismos superficiales m\u00faltiples del antebrazo',
    code_2: 'S50',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S508',
    level: 3,
    description: 'Otros traumatismos superficiales del antebrazo',
    code_2: 'S50',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S509',
    level: 3,
    description: 'Traumatismo superficial del antebrazo, no especificado',
    code_2: 'S50',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S610',
    level: 3,
    description:
      'Herida de dedo(s) de la mano, sin da\u00f1o de la(s) u\u00f1a(s)',
    code_2: 'S61',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S611',
    level: 3,
    description:
      'Herida de dedo(s) de la mano, con da\u00f1o de la(s) u\u00f1a(s)',
    code_2: 'S61',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S617',
    level: 3,
    description: 'Heridas m\u00faltiples de la mu\u00f1eca y de la mano',
    code_2: 'S61',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S618',
    level: 3,
    description: 'Herida de otras partes de la mu\u00f1eca y de la mano',
    code_2: 'S61',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S619',
    level: 3,
    description: 'Herida de la mu\u00f1eca y de la mano, parte no especificada',
    code_2: 'S61',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S600',
    level: 3,
    description:
      'Contusi\u00f3n de dedo(s) de la mano, sin da\u00f1o de la(s) u\u00f1a(s)',
    code_2: 'S60',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S601',
    level: 3,
    description:
      'Contusi\u00f3n de dedo(s) de la mano con da\u00f1o de la(s) u\u00f1a(s)',
    code_2: 'S60',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S602',
    level: 3,
    description:
      'Contusi\u00f3n de otras partes de la mu\u00f1eca y de la mano',
    code_2: 'S60',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S607',
    level: 3,
    description:
      'Traumatismos superficiales m\u00faltiples de la mu\u00f1eca y de la mano',
    code_2: 'S60',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S608',
    level: 3,
    description:
      'Otros traumatismos superficiales de la mu\u00f1eca y de la mano',
    code_2: 'S60',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S609',
    level: 3,
    description:
      'Traumatismo superficial de la mu\u00f1eca y de la mano, no especificado',
    code_2: 'S60',
    code_0: 'S00-T88',
    code_1: 'S60-S69'
  },
  {
    code: 'S720',
    level: 3,
    description: 'Fractura del cuello de f\u00e9mur',
    code_2: 'S72',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S721',
    level: 3,
    description: 'Fractura pertrocanteriana',
    code_2: 'S72',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S722',
    level: 3,
    description: 'Fractura subtrocanteriana',
    code_2: 'S72',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S723',
    level: 3,
    description: 'Fractura de la di\u00e1fisis del f\u00e9mur',
    code_2: 'S72',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S710',
    level: 3,
    description: 'Herida de la cadera',
    code_2: 'S71',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S711',
    level: 3,
    description: 'Herida del muslo',
    code_2: 'S71',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S717',
    level: 3,
    description: 'Heridas m\u00faltiples de la cadera y del muslo',
    code_2: 'S71',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S718',
    level: 3,
    description:
      'Herida de otras partes y de las no especificadas de la cintura p\u00e9lvica',
    code_2: 'S71',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S700',
    level: 3,
    description: 'Contusi\u00f3n de la cadera',
    code_2: 'S70',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S701',
    level: 3,
    description: 'Contusi\u00f3n del muslo',
    code_2: 'S70',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S707',
    level: 3,
    description:
      'Traumatismos superficiales m\u00faltiples de la cadera y del muslo',
    code_2: 'S70',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S708',
    level: 3,
    description: 'Otros traumatismos superficiales de la cadera y del muslo',
    code_2: 'S70',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S709',
    level: 3,
    description:
      'Traumatismo superficial de la cadera y del muslo, no especificado',
    code_2: 'S70',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S830',
    level: 3,
    description: 'Luxaci\u00f3n de la r\u00f3tula',
    code_2: 'S83',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S831',
    level: 3,
    description: 'Luxaci\u00f3n de la rodilla',
    code_2: 'S83',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S832',
    level: 3,
    description: 'Desgarro de meniscos, presente',
    code_2: 'S83',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S833',
    level: 3,
    description:
      'Desgarro del cart\u00edlago articular de la rodilla, presente',
    code_2: 'S83',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S834',
    level: 3,
    description:
      'Esguinces y torceduras que comprometen los ligamentos laterales (externo) (interno) de la rodilla',
    code_2: 'S83',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S835',
    level: 3,
    description:
      'Esguinces y torceduras que comprometen el ligamento cruzado (anterior) (posterior) de la rodilla',
    code_2: 'S83',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S836',
    level: 3,
    description:
      'Esguinces y torceduras de otras partes y las no especificadas de la rodilla',
    code_2: 'S83',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S820',
    level: 3,
    description: 'Fractura de la r\u00f3tula',
    code_2: 'S82',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S821',
    level: 3,
    description: 'Fractura de la ep\u00edfisis superior de la tibia',
    code_2: 'S82',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S822',
    level: 3,
    description: 'Fractura de la di\u00e1fisis de la tibia',
    code_2: 'S82',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S823',
    level: 3,
    description: 'Fractura de la ep\u00edfisis inferior de la tibia',
    code_2: 'S82',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S824',
    level: 3,
    description: 'Fractura del peron\u00e9 solamente',
    code_2: 'S82',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S825',
    level: 3,
    description: 'Fractura del mal\u00e9olo interno',
    code_2: 'S82',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S826',
    level: 3,
    description: 'Fractura del mal\u00e9olo externo',
    code_2: 'S82',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S827',
    level: 3,
    description: 'Fracturas m\u00faltiples de la pierna',
    code_2: 'S82',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S828',
    level: 3,
    description: 'Fractura de otras partes de la pierna',
    code_2: 'S82',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S829',
    level: 3,
    description: 'Fractura de la pierna, parte no especificada',
    code_2: 'S82',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S810',
    level: 3,
    description: 'Herida de la rodilla',
    code_2: 'S81',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S817',
    level: 3,
    description: 'Heridas m\u00faltiples de la pierna',
    code_2: 'S81',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S818',
    level: 3,
    description: 'Herida de otras partes de la pierna',
    code_2: 'S81',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S819',
    level: 3,
    description: 'Herida de la pierna, parte no especificada',
    code_2: 'S81',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S800',
    level: 3,
    description: 'Contusi\u00f3n de la rodilla',
    code_2: 'S80',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S801',
    level: 3,
    description:
      'Contusi\u00f3n de otras partes y las no especificadas de la pierna',
    code_2: 'S80',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S807',
    level: 3,
    description: 'Traumatismos superficiales m\u00faltiples de la pierna',
    code_2: 'S80',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S808',
    level: 3,
    description: 'Otros traumatismos superficiales de la pierna',
    code_2: 'S80',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S809',
    level: 3,
    description: 'Traumatismo superficial de la pierna, no especificado',
    code_2: 'S80',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'S930',
    level: 3,
    description: 'Luxaci\u00f3n de la articulaci\u00f3n del tobillo',
    code_2: 'S93',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S931',
    level: 3,
    description: 'Luxaci\u00f3n de dedo(s) del pie',
    code_2: 'S93',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S932',
    level: 3,
    description: 'Ruptura de ligamentos a nivel del tobillo y del pie',
    code_2: 'S93',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S933',
    level: 3,
    description: 'Luxaci\u00f3n de otros sitios y los no especificados del pie',
    code_2: 'S93',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S934',
    level: 3,
    description: 'Esguinces y torceduras del tobillo',
    code_2: 'S93',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S935',
    level: 3,
    description: 'Esguinces y torceduras de dedo(s) del pie',
    code_2: 'S93',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S936',
    level: 3,
    description:
      'Esguinces y torceduras de otros sitios y de los no especificados del pie',
    code_2: 'S93',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S920',
    level: 3,
    description: 'Fractura del calc\u00e1neo',
    code_2: 'S92',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S921',
    level: 3,
    description: 'Fractura del astr\u00e1galo',
    code_2: 'S92',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S922',
    level: 3,
    description: 'Fractura de otro(s) hueso(s) del tarso',
    code_2: 'S92',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S923',
    level: 3,
    description: 'Fractura de hueso del metatarso',
    code_2: 'S92',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S924',
    level: 3,
    description: 'Fractura de los huesos del dedo gordo del pie',
    code_2: 'S92',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S925',
    level: 3,
    description: 'Fractura de los huesos de otro(s) dedo(s) del pie',
    code_2: 'S92',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S927',
    level: 3,
    description: 'Fracturas m\u00faltiples del pie',
    code_2: 'S92',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S929',
    level: 3,
    description: 'Fractura del pie, no especificada',
    code_2: 'S92',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S910',
    level: 3,
    description: 'Herida del tobillo',
    code_2: 'S91',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S911',
    level: 3,
    description: 'Herida de dedo(s) del pie sin da\u00f1o de la(s) u\u00f1a(s)',
    code_2: 'S91',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S912',
    level: 3,
    description: 'Herida de dedo(s) del pie con da\u00f1o de la(s) u\u00f1a(s)',
    code_2: 'S91',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S913',
    level: 3,
    description: 'Herida de otras partes del pie',
    code_2: 'S91',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S917',
    level: 3,
    description: 'Heridas m\u00faltiples del tobillo y del pie',
    code_2: 'S91',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S900',
    level: 3,
    description: 'Contusi\u00f3n del tobillo',
    code_2: 'S90',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S901',
    level: 3,
    description:
      'Contusi\u00f3n de dedo(s) del pie sin da\u00f1o de la(s) u\u00f1a(s)',
    code_2: 'S90',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S902',
    level: 3,
    description:
      'Contusi\u00f3n de dedo(s) del pie con da\u00f1o de la(s) u\u00f1a(s)',
    code_2: 'S90',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S903',
    level: 3,
    description:
      'Contusi\u00f3n de otras partes y de las no especificadas del pie',
    code_2: 'S90',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S907',
    level: 3,
    description:
      'Traumatismos superficiales m\u00faltiples del pie y del tobillo',
    code_2: 'S90',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S908',
    level: 3,
    description: 'Otros traumatismos superficiales del pie y del tobillo',
    code_2: 'S90',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'S909',
    level: 3,
    description:
      'Traumatismo superficial del pie y del tobillo, no especificado',
    code_2: 'S90',
    code_0: 'S00-T88',
    code_1: 'S90-S99'
  },
  {
    code: 'T010',
    level: 3,
    description: 'Heridas que afectan la cabeza con el cuello',
    code_2: 'T01',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T011',
    level: 3,
    description:
      'Heridas que afectan el t\u00f3rax con el abdomen, la regi\u00f3n lumbosacra y la pelvis',
    code_2: 'T01',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T012',
    level: 3,
    description:
      'Heridas que afectan m\u00faltiples regiones del (de los) miembro(s) superior(es)',
    code_2: 'T01',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T013',
    level: 3,
    description:
      'Heridas que afectan m\u00faltiples regiones del (de los) miembro(s) inferior(es)',
    code_2: 'T01',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T016',
    level: 3,
    description:
      'Heridas que afectan m\u00faltiples regiones del (de los) miembro(s) superior(es) con miembro(s) inferior(es)',
    code_2: 'T01',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T018',
    level: 3,
    description:
      'Heridas que afectan otras combinaciones de las regiones del cuerpo',
    code_2: 'T01',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T019',
    level: 3,
    description: 'Heridas m\u00faltiples, no especificadas',
    code_2: 'T01',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T000',
    level: 3,
    description:
      'Traumatismos superficiales que afectan la cabeza con el cuello',
    code_2: 'T00',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T001',
    level: 3,
    description:
      'Traumatismos superficiales que afectan el t\u00f3rax con el abdomen, la regi\u00f3n lumbosacra y la pelvis',
    code_2: 'T00',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T002',
    level: 3,
    description:
      'Traumatismos superficiales que afectan m\u00faltiples regiones del(os) miembro(s) superior(es)',
    code_2: 'T00',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T003',
    level: 3,
    description:
      'Traumatismos superficiales que afectan m\u00faltiples regiones del (de los) miembro(s) inferior(es)',
    code_2: 'T00',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T006',
    level: 3,
    description:
      'Traumatismos superficiales que afectan m\u00faltiples regiones del (de los) miembro(s) superior(es) con miembro(s) inferior(es)',
    code_2: 'T00',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T008',
    level: 3,
    description:
      'Traumatismos superficiales que afectan otras combinaciones de regiones del cuerpo',
    code_2: 'T00',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'T009',
    level: 3,
    description: 'Traumatismos superficiales m\u00faltiples, no especificados',
    code_2: 'T00',
    code_0: 'S00-T88',
    code_1: 'T00-T07'
  },
  {
    code: 'Z080',
    level: 3,
    description:
      'Examen de seguimiento consecutivo a cirug\u00eda por tumor maligno',
    code_2: 'Z08',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z081',
    level: 3,
    description:
      'Examen de seguimiento consecutivo a radioterapia por tumor maligno',
    code_2: 'Z08',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z082',
    level: 3,
    description:
      'Examen de seguimiento consecutivo a quimioterapia por tumor maligno',
    code_2: 'Z08',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z087',
    level: 3,
    description:
      'Examen de seguimiento consecutivo a tratamiento combinado por tumor maligno',
    code_2: 'Z08',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z088',
    level: 3,
    description:
      'Examen de seguimiento consecutivo a otro tratamiento por tumor maligno',
    code_2: 'Z08',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z089',
    level: 3,
    description:
      'Examen de seguimiento consecutivo a tratamiento no especificado por tumor maligno',
    code_2: 'Z08',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z040',
    level: 3,
    description: 'Prueba de alcohol o drogas en la sangre',
    code_2: 'Z04',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z041',
    level: 3,
    description:
      'Examen y observaci\u00f3n consecutivos a accidente de transporte',
    code_2: 'Z04',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z042',
    level: 3,
    description:
      'Examen y observaci\u00f3n consecutivos a accidente de trabajo',
    code_2: 'Z04',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z043',
    level: 3,
    description: 'Examen y observaci\u00f3n consecutivos a otro accidente',
    code_2: 'Z04',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z044',
    level: 3,
    description:
      'Examen y observaci\u00f3n consecutivos a denuncia de violaci\u00f3n y seducci\u00f3n',
    code_2: 'Z04',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z045',
    level: 3,
    description:
      'Examen y observaci\u00f3n consecutivos a otra lesi\u00f3n infligida',
    code_2: 'Z04',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z046',
    level: 3,
    description:
      'Examen psiqui\u00e1trico general, solicitado por una autoridad',
    code_2: 'Z04',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z048',
    level: 3,
    description: 'Examen y observaci\u00f3n por otras razones especificadas',
    code_2: 'Z04',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z049',
    level: 3,
    description: 'Examen y observaci\u00f3n por razones no especificadas',
    code_2: 'Z04',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'L253',
    level: 3,
    description:
      'Dermatitis de contacto, forma no especificada, debida a otros productos qu\u00edmicos',
    code_2: 'L25',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L254',
    level: 3,
    description:
      'Dermatitis de contacto, forma no especificada, debida a alimentos en contacto con la piel',
    code_2: 'L25',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L255',
    level: 3,
    description:
      'Dermatitis de contacto, forma no especificada, debida a plantas, excepto las alimenticias',
    code_2: 'L25',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L258',
    level: 3,
    description:
      'Dermatitis de contacto, forma no especificada, debida a otros agentes',
    code_2: 'L25',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L259',
    level: 3,
    description: 'Dermatitis de contacto, forma y causa no especificadas',
    code_2: 'L25',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L241',
    level: 3,
    description:
      'Dermatitis de contacto por irritantes, debida a aceites y grasas',
    code_2: 'L24',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L242',
    level: 3,
    description: 'Dermatitis de contacto por irritantes, debida a disolventes',
    code_2: 'L24',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L243',
    level: 3,
    description:
      'Dermatitis de contacto por irritantes, debida a cosm\u00e9ticos',
    code_2: 'L24',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L244',
    level: 3,
    description:
      'Dermatitis de contacto por irritantes, debida a drogas en contacto con la piel',
    code_2: 'L24',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L245',
    level: 3,
    description:
      'Dermatitis de contacto por irritantes, debida a otros productos qu\u00edmicos',
    code_2: 'L24',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L246',
    level: 3,
    description:
      'Dermatitis de contacto por irritantes, debida a alimentos en contacto con la piel',
    code_2: 'L24',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L247',
    level: 3,
    description:
      'Dermatitis de contacto por irritantes, debida a plantas, excepto las alimenticias',
    code_2: 'L24',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L248',
    level: 3,
    description:
      'Dermatitis de contacto por irritantes, debida a otros agentes',
    code_2: 'L24',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L249',
    level: 3,
    description:
      'Dermatitis de contacto por irritantes, de causa no especificada',
    code_2: 'L24',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L231',
    level: 3,
    description: 'Dermatitis al\u00e9rgica de contacto debida a adhesivos',
    code_2: 'L23',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L232',
    level: 3,
    description:
      'Dermatitis al\u00e9rgica de contacto debida a cosm\u00e9ticos',
    code_2: 'L23',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L233',
    level: 3,
    description:
      'Dermatitis al\u00e9rgica de contacto debida a drogas en contacto con la piel',
    code_2: 'L23',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L234',
    level: 3,
    description: 'Dermatitis al\u00e9rgica de contacto debida a colorantes',
    code_2: 'L23',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L235',
    level: 3,
    description:
      'Dermatitis al\u00e9rgica de contacto debida a otros productos qu\u00edmicos',
    code_2: 'L23',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L236',
    level: 3,
    description:
      'Dermatitis al\u00e9rgica de contacto debida a alimentos en contacto con la piel',
    code_2: 'L23',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L237',
    level: 3,
    description:
      'Dermatitis al\u00e9rgica de contacto debida a plantas, excepto las alimenticias',
    code_2: 'L23',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L238',
    level: 3,
    description: 'Dermatitis al\u00e9rgica de contacto debida a otros agentes',
    code_2: 'L23',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L239',
    level: 3,
    description:
      'Dermatitis al\u00e9rgica de contacto, de causa no especificada',
    code_2: 'L23',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'Z030',
    level: 3,
    description: 'Observaci\u00f3n por sospecha de tuberculosis',
    code_2: 'Z03',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z031',
    level: 3,
    description: 'Observaci\u00f3n por sospecha de tumor maligno',
    code_2: 'Z03',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z032',
    level: 3,
    description:
      'Observaci\u00f3n por sospecha de trastorno mental y del comportamiento',
    code_2: 'Z03',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z033',
    level: 3,
    description:
      'Observaci\u00f3n por sospecha de trastorno del sistema nervioso',
    code_2: 'Z03',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z034',
    level: 3,
    description: 'Observaci\u00f3n por sospecha de infarto de miocardio',
    code_2: 'Z03',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'L211',
    level: 3,
    description: 'Dermatitis seborreica infantil',
    code_2: 'L21',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L218',
    level: 3,
    description: 'Otras dermatitis seborreicas',
    code_2: 'L21',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'L219',
    level: 3,
    description: 'Dermatitis seborreica, no especificada',
    code_2: 'L21',
    code_0: 'L00-L99',
    code_1: 'L20-L30'
  },
  {
    code: 'Z020',
    level: 3,
    description: 'Examen para admisi\u00f3n a instituciones educativas',
    code_2: 'Z02',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z021',
    level: 3,
    description: 'Examen preempleo',
    code_2: 'Z02',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z022',
    level: 3,
    description: 'Examen para admisi\u00f3n a instituciones residenciales',
    code_2: 'Z02',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z023',
    level: 3,
    description: 'Examen para reclutamiento en las fuerzas armadas',
    code_2: 'Z02',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z024',
    level: 3,
    description: 'Examen para obtenci\u00f3n de licencia de conducir',
    code_2: 'Z02',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z025',
    level: 3,
    description: 'Examen para participaci\u00f3n en competencias deportivas',
    code_2: 'Z02',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z026',
    level: 3,
    description: 'Examen para fines de seguros',
    code_2: 'Z02',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z027',
    level: 3,
    description: 'Extensi\u00f3n de certificado m\u00e9dico',
    code_2: 'Z02',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z028',
    level: 3,
    description: 'Otros ex\u00e1menes para fines administrativos',
    code_2: 'Z02',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z029',
    level: 3,
    description: 'Examen para fines administrativos, no especificado',
    code_2: 'Z02',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'L444',
    level: 3,
    description: 'Acrodermatitis papular infantil [Giannotti\u2013Crosti]',
    code_2: 'L44',
    code_0: 'L00-L99',
    code_1: 'L40-L45'
  },
  {
    code: 'L448',
    level: 3,
    description: 'Otros trastornos papuloescamosos especificados',
    code_2: 'L44',
    code_0: 'L00-L99',
    code_1: 'L40-L45'
  },
  {
    code: 'L449',
    level: 3,
    description: 'Trastorno papuloescamoso, no especificado',
    code_2: 'L44',
    code_0: 'L00-L99',
    code_1: 'L40-L45'
  },
  {
    code: 'Z010',
    level: 3,
    description: 'Examen de ojos y de la visi\u00f3n',
    code_2: 'Z01',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z011',
    level: 3,
    description: 'Examen de o\u00eddos y de la audici\u00f3n',
    code_2: 'Z01',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z012',
    level: 3,
    description: 'Examen odontol\u00f3gico',
    code_2: 'Z01',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z013',
    level: 3,
    description: 'Examen de la presi\u00f3n sangu\u00ednea',
    code_2: 'Z01',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z014',
    level: 3,
    description: 'Examen ginecol\u00f3gico (general) (de rutina)',
    code_2: 'Z01',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z015',
    level: 3,
    description:
      'Pruebas de sensibilizaci\u00f3n y diagn\u00f3stico cut\u00e1neo',
    code_2: 'Z01',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z000',
    level: 3,
    description: 'Examen m\u00e9dico general',
    code_2: 'Z00',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z001',
    level: 3,
    description: 'Control de salud de rutina del ni\u00f1o',
    code_2: 'Z00',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'L414',
    level: 3,
    description: 'Parapsoriasis en placas grandes',
    code_2: 'L41',
    code_0: 'L00-L99',
    code_1: 'L40-L45'
  },
  {
    code: 'L415',
    level: 3,
    description: 'Parapsoriasis retiforme',
    code_2: 'L41',
    code_0: 'L00-L99',
    code_1: 'L40-L45'
  },
  {
    code: 'L418',
    level: 3,
    description: 'Otras parapsoriasis',
    code_2: 'L41',
    code_0: 'L00-L99',
    code_1: 'L40-L45'
  },
  {
    code: 'L419',
    level: 3,
    description: 'Parapsoriasis, no especificada',
    code_2: 'L41',
    code_0: 'L00-L99',
    code_1: 'L40-L45'
  },
  {
    code: 'Z220',
    level: 3,
    description: 'Portador del agente de la fiebre tifoidea',
    code_2: 'Z22',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z221',
    level: 3,
    description:
      'Portador de agentes de otras enfermedades infecciosas intestinales',
    code_2: 'Z22',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z222',
    level: 3,
    description: 'Portador del agente de la difteria',
    code_2: 'Z22',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z223',
    level: 3,
    description:
      'Portador de agentes de otras enfermedades bacterianas especificadas',
    code_2: 'Z22',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z224',
    level: 3,
    description:
      'Portador de agentes de enfermedades infecciosas con un modo de transmisi\u00f3n predominantemente sexual',
    code_2: 'Z22',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'K048',
    level: 3,
    description: 'Quiste radicular',
    code_2: 'K04',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K049',
    level: 3,
    description:
      'Otras enfermedades y las no especificadas de la pulpa y del tejido periapical',
    code_2: 'K04',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K038',
    level: 3,
    description:
      'Otras enfermedades especificadas de los tejidos duros de los dientes',
    code_2: 'K03',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K039',
    level: 3,
    description: 'Enfermedad no especificada de los tejidos dentales duros',
    code_2: 'K03',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'Z200',
    level: 3,
    description:
      'Contacto con y exposici\u00f3n a enfermedades infecciosas intestinales',
    code_2: 'Z20',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z201',
    level: 3,
    description: 'Contacto con y exposici\u00f3n a tuberculosis',
    code_2: 'Z20',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z202',
    level: 3,
    description:
      'Contacto con y exposici\u00f3n a enfermedades infecciosas con un modo de transmisi\u00f3n predominantemente sexual',
    code_2: 'Z20',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z203',
    level: 3,
    description: 'Contacto con y exposici\u00f3n a rabia',
    code_2: 'Z20',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'K007',
    level: 3,
    description: 'S\u00edndrome de la erupci\u00f3n dentaria',
    code_2: 'K00',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K008',
    level: 3,
    description: 'Otros trastornos del desarrollo de los dientes',
    code_2: 'K00',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K009',
    level: 3,
    description: 'Trastorno del desarrollo de los dientes, no especificado',
    code_2: 'K00',
    code_0: 'K00-K95',
    code_1: 'K00-K14'
  },
  {
    code: 'K227',
    level: 3,
    description: 'Es\u00f3fago de Barrett',
    code_2: 'K22',
    code_0: 'K00-K95',
    code_1: 'K20-K31'
  },
  {
    code: 'K228',
    level: 3,
    description: 'Otras enfermedades especificadas del es\u00f3fago',
    code_2: 'K22',
    code_0: 'K00-K95',
    code_1: 'K20-K31'
  },
  {
    code: 'K229',
    level: 3,
    description: 'Enfermedad del es\u00f3fago, no especificada',
    code_2: 'K22',
    code_0: 'K00-K95',
    code_1: 'K20-K31'
  },
  {
    code: 'Z340',
    level: 3,
    description: 'Supervisi\u00f3n de primer embarazo normal',
    code_2: 'Z34',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z348',
    level: 3,
    description: 'Supervisi\u00f3n de otros embarazos normales',
    code_2: 'Z34',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z349',
    level: 3,
    description: 'Supervisi\u00f3n de embarazo normal no especificado',
    code_2: 'Z34',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z320',
    level: 3,
    description: 'Embarazo (a\u00fan) no confirmado',
    code_2: 'Z32',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z321',
    level: 3,
    description: 'Embarazo confirmado',
    code_2: 'Z32',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z310',
    level: 3,
    description: 'Tuboplastia o vasoplastia posterior a esterilizaci\u00f3n',
    code_2: 'Z31',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z311',
    level: 3,
    description: 'Inseminaci\u00f3n artificial',
    code_2: 'Z31',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z312',
    level: 3,
    description: 'Fecundaci\u00f3n in vitro',
    code_2: 'Z31',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z313',
    level: 3,
    description: 'Otros m\u00e9todos de atenci\u00f3n para la fecundaci\u00f3n',
    code_2: 'Z31',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z314',
    level: 3,
    description: 'Investigaci\u00f3n y prueba para la procreaci\u00f3n',
    code_2: 'Z31',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z315',
    level: 3,
    description: 'Asesoramiento gen\u00e9tico',
    code_2: 'Z31',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z300',
    level: 3,
    description: 'Consejo y asesoramiento general sobre la anticoncepci\u00f3n',
    code_2: 'Z30',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z301',
    level: 3,
    description: 'Inserci\u00f3n de dispositivo anticonceptivo (intrauterino)',
    code_2: 'Z30',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z302',
    level: 3,
    description: 'Esterilizaci\u00f3n',
    code_2: 'Z30',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z303',
    level: 3,
    description: 'Extracci\u00f3n menstrual',
    code_2: 'Z30',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z304',
    level: 3,
    description: 'Supervisi\u00f3n del uso de drogas anticonceptivas',
    code_2: 'Z30',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'E030',
    level: 3,
    description: 'Hipotiroidismo cong\u00e9nito con bocio difuso',
    code_2: 'E03',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E031',
    level: 3,
    description: 'Hipotiroidismo cong\u00e9nito sin bocio',
    code_2: 'E03',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E032',
    level: 3,
    description:
      'Hipotiroidismo debido a medicamentos y a otras sustancias ex\u00f3genas',
    code_2: 'E03',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E033',
    level: 3,
    description: 'Hipotiroidismo postinfeccioso',
    code_2: 'E03',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E034',
    level: 3,
    description: 'Atrofia de tiroides (adquirida)',
    code_2: 'E03',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E035',
    level: 3,
    description: 'Coma mixedematoso',
    code_2: 'E03',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E038',
    level: 3,
    description: 'Otros hipotiroidismos especificados',
    code_2: 'E03',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E039',
    level: 3,
    description: 'Hipotiroidismo, no especificado',
    code_2: 'E03',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E010',
    level: 3,
    description:
      'Bocio difuso (end\u00e9mico) relacionado con deficiencia de yodo',
    code_2: 'E01',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E011',
    level: 3,
    description:
      'Bocio multinodular (end\u00e9mico) relacionado con deficiencia de yodo',
    code_2: 'E01',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E012',
    level: 3,
    description:
      'Bocio (end\u00e9mico) relacionado con deficiencia de yodo, no especificado',
    code_2: 'E01',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E018',
    level: 3,
    description:
      'Otros trastornos de la tiroides relacionados con deficiencia de yodo y afecciones similares',
    code_2: 'E01',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E000',
    level: 3,
    description:
      'S\u00edndrome cong\u00e9nito de deficiencia de yodo, tipo neurol\u00f3gico',
    code_2: 'E00',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E001',
    level: 3,
    description:
      'S\u00edndrome de deficiencia cong\u00e9nita de yodo, tipo mixedematoso',
    code_2: 'E00',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E002',
    level: 3,
    description:
      'S\u00edndrome cong\u00e9nito de deficiencia de yodo, tipo mixto',
    code_2: 'E00',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E009',
    level: 3,
    description:
      'S\u00edndrome cong\u00e9nito de deficiencia de yodo, no especificado',
    code_2: 'E00',
    code_0: 'E00-E89',
    code_1: 'E00-E07'
  },
  {
    code: 'E160',
    level: 3,
    description: 'Hipoglicemia sin coma, inducida por drogas',
    code_2: 'E16',
    code_0: 'E00-E89',
    code_1: 'E15-E16'
  },
  {
    code: 'E161',
    level: 3,
    description: 'Otras hipoglicemias',
    code_2: 'E16',
    code_0: 'E00-E89',
    code_1: 'E15-E16'
  },
  {
    code: 'E162',
    level: 3,
    description: 'Hipoglicemia, no especificada',
    code_2: 'E16',
    code_0: 'E00-E89',
    code_1: 'E15-E16'
  },
  {
    code: 'E163',
    level: 3,
    description: 'Secreci\u00f3n exagerada del glucag\u00f3n',
    code_2: 'E16',
    code_0: 'E00-E89',
    code_1: 'E15-E16'
  },
  {
    code: 'E164',
    level: 3,
    description: 'Secreci\u00f3n anormal de gastrina',
    code_2: 'E16',
    code_0: 'E00-E89',
    code_1: 'E15-E16'
  },
  {
    code: 'E168',
    level: 3,
    description:
      'Otros trastornos especificados de la secreci\u00f3n interna del p\u00e1ncreas',
    code_2: 'E16',
    code_0: 'E00-E89',
    code_1: 'E15-E16'
  },
  {
    code: 'E169',
    level: 3,
    description:
      'Trastornos de la secreci\u00f3n interna del p\u00e1ncreas, sin otra especificaci\u00f3n',
    code_2: 'E16',
    code_0: 'E00-E89',
    code_1: 'E15-E16'
  },
  {
    code: 'E240',
    level: 3,
    description: 'Enfermedad de Cushing dependiente de la hip\u00f3fisis',
    code_2: 'E24',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E241',
    level: 3,
    description: 'S\u00edndrome de Nelson',
    code_2: 'E24',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E242',
    level: 3,
    description: 'S\u00edndrome de Cushing inducido por drogas',
    code_2: 'E24',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E243',
    level: 3,
    description: 'S\u00edndrome de ACTH ect\u00f3pico',
    code_2: 'E24',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E244',
    level: 3,
    description: 'S\u00edndrome de seudo\u2013Cushing inducido por alcohol',
    code_2: 'E24',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E248',
    level: 3,
    description: 'Otros tipos de s\u00edndrome de Cushing',
    code_2: 'E24',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E249',
    level: 3,
    description: 'S\u00edndrome de Cushing, no especificado',
    code_2: 'E24',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E230',
    level: 3,
    description: 'Hipopituitarismo',
    code_2: 'E23',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E231',
    level: 3,
    description: 'Hipopituitarismo inducido por drogas',
    code_2: 'E23',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E232',
    level: 3,
    description: 'Diabetes ins\u00edpida',
    code_2: 'E23',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E233',
    level: 3,
    description:
      'Disfunci\u00f3n hipotal\u00e1mica, no clasificada en otra parte',
    code_2: 'E23',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E236',
    level: 3,
    description: 'Otros trastornos de la gl\u00e1ndula hip\u00f3fisis',
    code_2: 'E23',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E237',
    level: 3,
    description:
      'Trastorno de la gl\u00e1ndula hip\u00f3fisis, no especificado',
    code_2: 'E23',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E220',
    level: 3,
    description: 'Acromegalia y gigantismo hipofisario',
    code_2: 'E22',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E221',
    level: 3,
    description: 'Hiperprolactinemia',
    code_2: 'E22',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E222',
    level: 3,
    description:
      'S\u00edndrome de secreci\u00f3n inapropiada de hormona antidiur\u00e9tica',
    code_2: 'E22',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E228',
    level: 3,
    description: 'Otras hiperfunciones de la gl\u00e1ndula hip\u00f3fisis',
    code_2: 'E22',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E229',
    level: 3,
    description:
      'Hiperfunci\u00f3n de la gl\u00e1ndula hip\u00f3fisis, no especificada',
    code_2: 'E22',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'J013',
    level: 3,
    description: 'Sinusitis esfenoidal aguda',
    code_2: 'J01',
    code_0: 'J00-J99',
    code_1: 'J00-J06'
  },
  {
    code: 'J014',
    level: 3,
    description: 'Pansinusitis aguda',
    code_2: 'J01',
    code_0: 'J00-J99',
    code_1: 'J00-J06'
  },
  {
    code: 'J018',
    level: 3,
    description: 'Otras sinusitis agudas',
    code_2: 'J01',
    code_0: 'J00-J99',
    code_1: 'J00-J06'
  },
  {
    code: 'J019',
    level: 3,
    description: 'Sinusitis aguda, no especificada',
    code_2: 'J01',
    code_0: 'J00-J99',
    code_1: 'J00-J06'
  },
  {
    code: 'J205',
    level: 3,
    description: 'Bronquitis aguda debida a virus sincitial respiratorio',
    code_2: 'J20',
    code_0: 'J00-J99',
    code_1: 'J20-J22'
  },
  {
    code: 'J206',
    level: 3,
    description: 'Bronquitis aguda debida a rinovirus',
    code_2: 'J20',
    code_0: 'J00-J99',
    code_1: 'J20-J22'
  },
  {
    code: 'J207',
    level: 3,
    description: 'Bronquitis aguda debida a virus Echo',
    code_2: 'J20',
    code_0: 'J00-J99',
    code_1: 'J20-J22'
  },
  {
    code: 'J208',
    level: 3,
    description:
      'Bronquitis aguda debida a otros microorganismos especificados',
    code_2: 'J20',
    code_0: 'J00-J99',
    code_1: 'J20-J22'
  },
  {
    code: 'J209',
    level: 3,
    description: 'Bronquitis aguda, no especificada',
    code_2: 'J20',
    code_0: 'J00-J99',
    code_1: 'J20-J22'
  },
  {
    code: 'M840',
    level: 4,
    description: 'Consolidaci\u00f3n defectuosa de fractura',
    code_3: 'M84',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M841',
    level: 4,
    description: 'Falta de consolidaci\u00f3n de fractura [seudoartrosis]',
    code_3: 'M84',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M842',
    level: 4,
    description: 'Consolidaci\u00f3n retardada de fractura',
    code_3: 'M84',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M843',
    level: 4,
    description: 'Fractura por tensi\u00f3n, no clasificada en otra parte',
    code_3: 'M84',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M844',
    level: 4,
    description: 'Fractura patol\u00f3gica, no clasificada en otra parte',
    code_3: 'M84',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M848',
    level: 4,
    description: 'Otros trastornos de la continuidad del hueso',
    code_3: 'M84',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M849',
    level: 4,
    description: 'Trastorno de la continuidad del hueso, no especificado',
    code_3: 'M84',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M830',
    level: 4,
    description: 'Osteomalacia puerperal',
    code_3: 'M83',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M831',
    level: 4,
    description: 'Osteomalacia senil',
    code_3: 'M83',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M832',
    level: 4,
    description: 'Osteomalacia del adulto debida a malabsorci\u00f3n',
    code_3: 'M83',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M833',
    level: 4,
    description: 'Osteomalacia del adulto debida a desnutrici\u00f3n',
    code_3: 'M83',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M834',
    level: 4,
    description: 'Enfermedad de los huesos por aluminio',
    code_3: 'M83',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M835',
    level: 4,
    description: 'Otras osteomalacias del adulto inducidas por drogas',
    code_3: 'M83',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M838',
    level: 4,
    description: 'Otras osteomalacias del adulto',
    code_3: 'M83',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M839',
    level: 4,
    description: 'Osteomalacia del adulto, no especificada',
    code_3: 'M83',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M820',
    level: 4,
    description: 'Osteoporosis en mielomatosis m\u00faltiple (C90.0)',
    code_3: 'M82',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M821',
    level: 4,
    description: 'Osteoporosis en trastornos endocrinos (E00\u2013E34)',
    code_3: 'M82',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M828',
    level: 4,
    description:
      'Osteoporosis en otras enfermedades clasificadas en otra parte',
    code_3: 'M82',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M810',
    level: 4,
    description:
      'Osteoporosis postmenop\u00e1usica, sin fractura patol\u00f3gica',
    code_3: 'M81',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M811',
    level: 4,
    description:
      'Osteoporosis postooforectom\u00eda, sin fractura patol\u00f3gica',
    code_3: 'M81',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M812',
    level: 4,
    description: 'Osteoporosis por desuso, sin fractura patol\u00f3gica',
    code_3: 'M81',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M813',
    level: 4,
    description:
      'Osteoporosis por malabsorci\u00f3n postquir\u00fargica, sin fractura patol\u00f3gica',
    code_3: 'M81',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M814',
    level: 4,
    description:
      'Osteoporosis inducida por drogas, sin fractura patol\u00f3gica',
    code_3: 'M81',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M800',
    level: 4,
    description:
      'Osteoporosis postmenop\u00e1usica, con fractura patol\u00f3gica',
    code_3: 'M80',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M801',
    level: 4,
    description:
      'Osteoporosis postooforectom\u00eda, con fractura patol\u00f3gica',
    code_3: 'M80',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M802',
    level: 4,
    description: 'Osteoporosis por desuso, con fractura patol\u00f3gica',
    code_3: 'M80',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M803',
    level: 4,
    description:
      'Osteoporosis por malabsorci\u00f3n postquir\u00fargica, con fractura patol\u00f3gica',
    code_3: 'M80',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M804',
    level: 4,
    description:
      'Osteoporosis inducida por drogas, con fractura patol\u00f3gica',
    code_3: 'M80',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M805',
    level: 4,
    description: 'Osteoporosis idiop\u00e1tica, con fractura patol\u00f3gica',
    code_3: 'M80',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M808',
    level: 4,
    description: 'Otras osteoporosis, con fractura patol\u00f3gica',
    code_3: 'M80',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M809',
    level: 4,
    description: 'Osteoporosis no especificada, con fractura patol\u00f3gica',
    code_3: 'M80',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M900',
    level: 4,
    description: 'Tuberculosis \u00f3sea (A18.0)',
    code_3: 'M90',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M86-M90'
  },
  {
    code: 'M901',
    level: 4,
    description:
      'Periostitis en otras enfermedades infecciosas clasificadas en otra parte',
    code_3: 'M90',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M86-M90'
  },
  {
    code: 'M902',
    level: 4,
    description:
      'Osteopat\u00eda en otras enfermedades infecciosas clasificadas en otra parte',
    code_3: 'M90',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M86-M90'
  },
  {
    code: 'M903',
    level: 4,
    description:
      'Osteonecrosis en la enfermedad causada por descompresi\u00f3n (T70.3)',
    code_3: 'M90',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M86-M90'
  },
  {
    code: 'M904',
    level: 4,
    description: 'Osteonecrosis debida a hemoglobinopat\u00eda (D50\u2013D64)',
    code_3: 'M90',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M86-M90'
  },
  {
    code: 'M905',
    level: 4,
    description:
      'Osteonecrosis en otras enfermedades clasificadas en otra parte',
    code_3: 'M90',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M86-M90'
  },
  {
    code: 'M906',
    level: 4,
    description:
      'Oste\u00edtis deformante en enfermedad neopl\u00e1sica (C00\u2013D48)',
    code_3: 'M90',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M86-M90'
  },
  {
    code: 'M907',
    level: 4,
    description:
      'Fractura \u00f3sea en enfermedad neopl\u00e1sica (C00\u2013D48)',
    code_3: 'M90',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M86-M90'
  },
  {
    code: 'M908',
    level: 4,
    description:
      'Osteopat\u00eda en otras enfermedades clasificadas en otra parte',
    code_3: 'M90',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M86-M90'
  },
  {
    code: 'M890',
    level: 4,
    description: 'Algoneurodistrofia',
    code_3: 'M89',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M86-M90'
  },
  {
    code: 'M891',
    level: 4,
    description: 'Detenci\u00f3n del crecimiento epifisario',
    code_3: 'M89',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M86-M90'
  },
  {
    code: 'M892',
    level: 4,
    description: 'Otros trastornos del desarrollo y crecimiento \u00f3seo',
    code_3: 'M89',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M86-M90'
  },
  {
    code: 'M893',
    level: 4,
    description: 'Hipertrofia del hueso',
    code_3: 'M89',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M86-M90'
  },
  {
    code: 'M894',
    level: 4,
    description: 'Otras osteoartropat\u00edas hipertr\u00f3ficas',
    code_3: 'M89',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M86-M90'
  },
  {
    code: 'M895',
    level: 4,
    description: 'Oste\u00f3lisis',
    code_3: 'M89',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M86-M90'
  },
  {
    code: 'M880',
    level: 4,
    description: 'Enfermedad de Paget del cr\u00e1neo',
    code_3: 'M88',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M86-M90'
  },
  {
    code: 'M888',
    level: 4,
    description: 'Enfermedad de Paget de otros huesos',
    code_3: 'M88',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M86-M90'
  },
  {
    code: 'M889',
    level: 4,
    description: 'Enfermedad \u00f3sea de Paget, huesos no especificados',
    code_3: 'M88',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M86-M90'
  },
  {
    code: 'M870',
    level: 4,
    description: 'Necrosis as\u00e9ptica idiop\u00e1tica \u00f3sea',
    code_3: 'M87',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M86-M90'
  },
  {
    code: 'M871',
    level: 4,
    description: 'Osteonecrosis debida a drogas',
    code_3: 'M87',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M86-M90'
  },
  {
    code: 'M872',
    level: 4,
    description: 'Osteonecrosis debida a traumatismo previo',
    code_3: 'M87',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M86-M90'
  },
  {
    code: 'M873',
    level: 4,
    description: 'Otras osteonecrosis secundarias',
    code_3: 'M87',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M86-M90'
  },
  {
    code: 'M878',
    level: 4,
    description: 'Otras osteonecrosis',
    code_3: 'M87',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M86-M90'
  },
  {
    code: 'M860',
    level: 4,
    description: 'Osteomielitis hemat\u00f3gena aguda',
    code_3: 'M86',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M86-M90'
  },
  {
    code: 'M861',
    level: 4,
    description: 'Otras osteomielitis agudas',
    code_3: 'M86',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M86-M90'
  },
  {
    code: 'M862',
    level: 4,
    description: 'Osteomielitis subaguda',
    code_3: 'M86',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M86-M90'
  },
  {
    code: 'M863',
    level: 4,
    description: 'Osteomielitis multifocal cr\u00f3nica',
    code_3: 'M86',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M86-M90'
  },
  {
    code: 'M920',
    level: 4,
    description: 'Osteocondrosis juvenil del h\u00famero',
    code_3: 'M92',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M91-M94'
  },
  {
    code: 'M921',
    level: 4,
    description: 'Osteocondrosis juvenil del c\u00fabito y del radio',
    code_3: 'M92',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M91-M94'
  },
  {
    code: 'M922',
    level: 4,
    description: 'Osteocondrosis juvenil de la mano',
    code_3: 'M92',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M91-M94'
  },
  {
    code: 'M923',
    level: 4,
    description: 'Otras osteocondrosis juveniles del miembro superior',
    code_3: 'M92',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M91-M94'
  },
  {
    code: 'M924',
    level: 4,
    description: 'Osteocondrosis juvenil de la r\u00f3tula',
    code_3: 'M92',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M91-M94'
  },
  {
    code: 'M925',
    level: 4,
    description: 'Osteocondrosis juvenil de la tibia y del peron\u00e9',
    code_3: 'M92',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M91-M94'
  },
  {
    code: 'M926',
    level: 4,
    description: 'Osteocondrosis juvenil del tarso',
    code_3: 'M92',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M91-M94'
  },
  {
    code: 'M927',
    level: 4,
    description: 'Osteocondrosis juvenil del metatarso',
    code_3: 'M92',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M91-M94'
  },
  {
    code: 'M928',
    level: 4,
    description: 'Otras osteocondrosis juveniles especificadas',
    code_3: 'M92',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M91-M94'
  },
  {
    code: 'M929',
    level: 4,
    description: 'Osteocondrosis juvenil, no especificada',
    code_3: 'M92',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M91-M94'
  },
  {
    code: 'M910',
    level: 4,
    description: 'Osteocondrosis juvenil de la pelvis',
    code_3: 'M91',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M91-M94'
  },
  {
    code: 'M911',
    level: 4,
    description:
      'Osteocondrosis juvenil de la cabeza del f\u00e9mur [Legg\u2013Calv\u00e9\u2013Perthes]',
    code_3: 'M91',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M91-M94'
  },
  {
    code: 'M912',
    level: 4,
    description: 'Coxa plana',
    code_3: 'M91',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M91-M94'
  },
  {
    code: 'M913',
    level: 4,
    description: 'Pseudocoxalgia',
    code_3: 'M91',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M91-M94'
  },
  {
    code: 'M918',
    level: 4,
    description: 'Otras osteocondrosis juveniles de la cadera y de la pelvis',
    code_3: 'M91',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M91-M94'
  },
  {
    code: 'M919',
    level: 4,
    description:
      'Osteocondrosis juvenil de la cadera y de la pelvis, sin otra especificaci\u00f3n',
    code_3: 'M91',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M91-M94'
  },
  {
    code: 'M620',
    level: 4,
    description: 'Di\u00e1stasis del m\u00fasculo',
    code_3: 'M62',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M60-M63'
  },
  {
    code: 'M621',
    level: 4,
    description: 'Otros desgarros (no traum\u00e1ticos) del m\u00fasculo',
    code_3: 'M62',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M60-M63'
  },
  {
    code: 'M622',
    level: 4,
    description: 'Infarto isqu\u00e9mico del m\u00fasculo',
    code_3: 'M62',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M60-M63'
  },
  {
    code: 'M623',
    level: 4,
    description: 'S\u00edndrome de inmovilidad (parapl\u00e9jico)',
    code_3: 'M62',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M60-M63'
  },
  {
    code: 'M624',
    level: 4,
    description: 'Contractura muscular',
    code_3: 'M62',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M60-M63'
  },
  {
    code: 'M625',
    level: 4,
    description: 'Atrofia y desgaste musculares, no clasificados en otra parte',
    code_3: 'M62',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M60-M63'
  },
  {
    code: 'M610',
    level: 4,
    description: 'Miositis osificante traum\u00e1tica',
    code_3: 'M61',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M60-M63'
  },
  {
    code: 'M611',
    level: 4,
    description: 'Miositis osificante progresiva',
    code_3: 'M61',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M60-M63'
  },
  {
    code: 'M612',
    level: 4,
    description:
      'Calcificaci\u00f3n y osificaci\u00f3n paral\u00edtica del m\u00fasculo',
    code_3: 'M61',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M60-M63'
  },
  {
    code: 'M613',
    level: 4,
    description:
      'Calcificaci\u00f3n y osificaci\u00f3n de los m\u00fasculos asociadas con quemaduras',
    code_3: 'M61',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M60-M63'
  },
  {
    code: 'M614',
    level: 4,
    description: 'Otras calcificaciones del m\u00fasculo',
    code_3: 'M61',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M60-M63'
  },
  {
    code: 'M615',
    level: 4,
    description: 'Otras osificaciones del m\u00fasculo',
    code_3: 'M61',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M60-M63'
  },
  {
    code: 'M619',
    level: 4,
    description:
      'Calcificaci\u00f3n y osificaci\u00f3n del m\u00fasculo, no especificada',
    code_3: 'M61',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M60-M63'
  },
  {
    code: 'M600',
    level: 4,
    description: 'Miositis infecciosa',
    code_3: 'M60',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M60-M63'
  },
  {
    code: 'M601',
    level: 4,
    description: 'Miositis intersticial',
    code_3: 'M60',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M60-M63'
  },
  {
    code: 'M602',
    level: 4,
    description:
      'Granuloma por cuerpo extra\u00f1o en tejido blando, no clasificado en otra parte',
    code_3: 'M60',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M60-M63'
  },
  {
    code: 'M608',
    level: 4,
    description: 'Otras miositis',
    code_3: 'M60',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M60-M63'
  },
  {
    code: 'M680',
    level: 4,
    description:
      'Sinovitis y tenosinovitis en enfermedades bacterianas clasificadas en otra parte',
    code_3: 'M68',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M65-M68'
  },
  {
    code: 'M688',
    level: 4,
    description:
      'Otros trastornos sinoviales y tendinosos en enfermedades clasificadas en otra parte',
    code_3: 'M68',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M65-M68'
  },
  {
    code: 'M670',
    level: 4,
    description: 'Acortamiento del tend\u00f3n de Aquiles (adquirido)',
    code_3: 'M67',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M65-M68'
  },
  {
    code: 'M671',
    level: 4,
    description: 'Otras contracturas de tend\u00f3n (vaina)',
    code_3: 'M67',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M65-M68'
  },
  {
    code: 'M672',
    level: 4,
    description: 'Hipertrofia sinovial, no clasificada en otra parte',
    code_3: 'M67',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M65-M68'
  },
  {
    code: 'M673',
    level: 4,
    description: 'Sinovitis transitoria',
    code_3: 'M67',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M65-M68'
  },
  {
    code: 'M674',
    level: 4,
    description: 'Gangli\u00f3n',
    code_3: 'M67',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M65-M68'
  },
  {
    code: 'M678',
    level: 4,
    description:
      'Otros trastornos especificados de la sinovia y del tend\u00f3n',
    code_3: 'M67',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M65-M68'
  },
  {
    code: 'M679',
    level: 4,
    description: 'Trastorno sinovial y tendinoso, no especificado',
    code_3: 'M67',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M65-M68'
  },
  {
    code: 'M660',
    level: 4,
    description: 'Ruptura de quiste sinovial popl\u00edteo',
    code_3: 'M66',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M65-M68'
  },
  {
    code: 'M661',
    level: 4,
    description: 'Ruptura de la sinovia',
    code_3: 'M66',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M65-M68'
  },
  {
    code: 'M662',
    level: 4,
    description: 'Ruptura espont\u00e1nea de tendones extensores',
    code_3: 'M66',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M65-M68'
  },
  {
    code: 'M663',
    level: 4,
    description: 'Ruptura espont\u00e1nea de tendones flexores',
    code_3: 'M66',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M65-M68'
  },
  {
    code: 'M664',
    level: 4,
    description: 'Ruptura espont\u00e1nea de otros tendones',
    code_3: 'M66',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M65-M68'
  },
  {
    code: 'M665',
    level: 4,
    description: 'Ruptura espont\u00e1nea de tend\u00f3n no especificado',
    code_3: 'M66',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M65-M68'
  },
  {
    code: 'M650',
    level: 4,
    description: 'Absceso de vaina tendinosa',
    code_3: 'M65',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M65-M68'
  },
  {
    code: 'M651',
    level: 4,
    description: 'Otras (teno)sinovitis infecciosas',
    code_3: 'M65',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M65-M68'
  },
  {
    code: 'M652',
    level: 4,
    description: 'Tendinitis calcificada',
    code_3: 'M65',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M65-M68'
  },
  {
    code: 'M653',
    level: 4,
    description: 'Dedo en gatillo',
    code_3: 'M65',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M65-M68'
  },
  {
    code: 'M654',
    level: 4,
    description: 'Tenosinovitis de estiloides radial [de Quervain]',
    code_3: 'M65',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M65-M68'
  },
  {
    code: 'M658',
    level: 4,
    description: 'Otras sinovitis y tenosinovitis',
    code_3: 'M65',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M65-M68'
  },
  {
    code: 'M659',
    level: 4,
    description: 'Sinovitis y tenosinovitis, no especificada',
    code_3: 'M65',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M65-M68'
  },
  {
    code: 'M720',
    level: 4,
    description: 'Fibromatosis de la aponeurosis palmar [Dupuytren]',
    code_3: 'M72',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M721',
    level: 4,
    description: 'N\u00f3dulos interfal\u00e1ngicos',
    code_3: 'M72',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M722',
    level: 4,
    description: 'Fibromatosis de la aponeurosis plantar',
    code_3: 'M72',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M724',
    level: 4,
    description: 'Fibromatosis seudosarcomatosa',
    code_3: 'M72',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M726',
    level: 4,
    description: 'Fascitis necrotizante',
    code_3: 'M72',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M728',
    level: 4,
    description: 'Otros trastornos fibrobl\u00e1sticos',
    code_3: 'M72',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M729',
    level: 4,
    description: 'Trastorno fibrobl\u00e1stico, no especificado',
    code_3: 'M72',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M710',
    level: 4,
    description: 'Absceso de la bolsa sinovial',
    code_3: 'M71',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M711',
    level: 4,
    description: 'Otras bursitis infecciosas',
    code_3: 'M71',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M712',
    level: 4,
    description: 'Quiste sinovial del hueco popl\u00edteo [de Baker]',
    code_3: 'M71',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M713',
    level: 4,
    description: 'Otros quistes de la bolsa serosa',
    code_3: 'M71',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M714',
    level: 4,
    description: 'Dep\u00f3sito de calcio en la bolsa serosa',
    code_3: 'M71',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M715',
    level: 4,
    description: 'Otras bursitis, no clasificadas en otra parte',
    code_3: 'M71',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M718',
    level: 4,
    description: 'Otros trastornos especificados de la bolsa serosa',
    code_3: 'M71',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M719',
    level: 4,
    description: 'Bursopat\u00eda, no especificada',
    code_3: 'M71',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M700',
    level: 4,
    description:
      'Sinovitis crepitante cr\u00f3nica de la mano y de la mu\u00f1eca',
    code_3: 'M70',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M701',
    level: 4,
    description: 'Bursitis de la mano',
    code_3: 'M70',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M702',
    level: 4,
    description: 'Bursitis del ol\u00e9cranon',
    code_3: 'M70',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M703',
    level: 4,
    description: 'Otras bursitis del codo',
    code_3: 'M70',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M704',
    level: 4,
    description: 'Otras bursitis prerrotulianas',
    code_3: 'M70',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M705',
    level: 4,
    description: 'Otras bursitis de la rodilla',
    code_3: 'M70',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M706',
    level: 4,
    description: 'Bursitis del troc\u00e1nter',
    code_3: 'M70',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M707',
    level: 4,
    description: 'Otras bursitis de la cadera',
    code_3: 'M70',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M708',
    level: 4,
    description:
      'Otros trastornos de los tejidos blandos relacionados con el uso, el uso excesivo y la presi\u00f3n',
    code_3: 'M70',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M709',
    level: 4,
    description:
      'Trastorno no especificado de los tejidos blandos relacionado con el uso, el uso excesivo y la presi\u00f3n',
    code_3: 'M70',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M430',
    level: 4,
    description: 'Espondil\u00f3lisis',
    code_3: 'M43',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M40-M43'
  },
  {
    code: 'M431',
    level: 4,
    description: 'Espondilolistesis',
    code_3: 'M43',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M40-M43'
  },
  {
    code: 'M432',
    level: 4,
    description: 'Otras fusiones de la columna vertebral',
    code_3: 'M43',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M40-M43'
  },
  {
    code: 'M433',
    level: 4,
    description:
      'Subluxaci\u00f3n atlanto\u2013axoidea recurrente, con mielopat\u00eda',
    code_3: 'M43',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M40-M43'
  },
  {
    code: 'M434',
    level: 4,
    description: 'Otras subluxaciones atlanto\u2013axoideas recurrentes',
    code_3: 'M43',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M40-M43'
  },
  {
    code: 'M435',
    level: 4,
    description: 'Otras subluxaciones vertebrales recurrentes',
    code_3: 'M43',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M40-M43'
  },
  {
    code: 'M436',
    level: 4,
    description: 'Tort\u00edcolis',
    code_3: 'M43',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M40-M43'
  },
  {
    code: 'M438',
    level: 4,
    description:
      'Otras dorsopat\u00edas deformantes de la columna vertebral especificadas',
    code_3: 'M43',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M40-M43'
  },
  {
    code: 'M439',
    level: 4,
    description: 'Dorsopat\u00eda deformante, no especificada',
    code_3: 'M43',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M40-M43'
  },
  {
    code: 'M420',
    level: 4,
    description: 'Osteocondrosis juvenil de la columna vertebral',
    code_3: 'M42',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M40-M43'
  },
  {
    code: 'M421',
    level: 4,
    description: 'Osteocondrosis de la columna vertebral del adulto',
    code_3: 'M42',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M40-M43'
  },
  {
    code: 'M429',
    level: 4,
    description: 'Osteocondrosis vertebral, no especificada',
    code_3: 'M42',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M40-M43'
  },
  {
    code: 'M410',
    level: 4,
    description: 'Escoliosis idiop\u00e1tica infantil',
    code_3: 'M41',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M40-M43'
  },
  {
    code: 'M411',
    level: 4,
    description: 'Escoliosis idiop\u00e1tica juvenil',
    code_3: 'M41',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M40-M43'
  },
  {
    code: 'M412',
    level: 4,
    description: 'Otras escoliosis idiop\u00e1ticas',
    code_3: 'M41',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M40-M43'
  },
  {
    code: 'M413',
    level: 4,
    description: 'Escoliosis toracog\u00e9nica',
    code_3: 'M41',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M40-M43'
  },
  {
    code: 'M414',
    level: 4,
    description: 'Escoliosis neuromuscular',
    code_3: 'M41',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M40-M43'
  },
  {
    code: 'M415',
    level: 4,
    description: 'Otras escoliosis secundarias',
    code_3: 'M41',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M40-M43'
  },
  {
    code: 'M418',
    level: 4,
    description: 'Otras formas de escoliosis',
    code_3: 'M41',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M40-M43'
  },
  {
    code: 'M419',
    level: 4,
    description: 'Escoliosis, no especificada',
    code_3: 'M41',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M40-M43'
  },
  {
    code: 'M400',
    level: 4,
    description: 'Cifosis postural',
    code_3: 'M40',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M40-M43'
  },
  {
    code: 'M401',
    level: 4,
    description: 'Otras cifosis secundarias',
    code_3: 'M40',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M40-M43'
  },
  {
    code: 'M402',
    level: 4,
    description: 'Otras cifosis y las no especificadas',
    code_3: 'M40',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M40-M43'
  },
  {
    code: 'M403',
    level: 4,
    description: 'S\u00edndrome de espalda plana',
    code_3: 'M40',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M40-M43'
  },
  {
    code: 'M404',
    level: 4,
    description: 'Otras lordosis',
    code_3: 'M40',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M40-M43'
  },
  {
    code: 'M405',
    level: 4,
    description: 'Lordosis, no especificada',
    code_3: 'M40',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M40-M43'
  },
  {
    code: 'M490',
    level: 4,
    description: 'Tuberculosis de la columna vertebral (A18.0)',
    code_3: 'M49',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M45-M49'
  },
  {
    code: 'M491',
    level: 4,
    description: 'Espondilitis por brucelosis (A23.\u2013)',
    code_3: 'M49',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M45-M49'
  },
  {
    code: 'M492',
    level: 4,
    description: 'Espondilitis por enterobacterias (A01\u2013A04)',
    code_3: 'M49',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M45-M49'
  },
  {
    code: 'M493',
    level: 4,
    description:
      'Espondilopat\u00eda en otras enfermedades infecciosas y parasitarias clasificadas en otra parte',
    code_3: 'M49',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M45-M49'
  },
  {
    code: 'M494',
    level: 4,
    description: 'Espondilopat\u00eda neurop\u00e1tica',
    code_3: 'M49',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M45-M49'
  },
  {
    code: 'M495',
    level: 4,
    description:
      'V\u00e9rtebra colapsada en enfermedades clasificadas en otra parte',
    code_3: 'M49',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M45-M49'
  },
  {
    code: 'M498',
    level: 4,
    description:
      'Espondilopat\u00eda en otras enfermedades clasificadas en otra parte',
    code_3: 'M49',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M45-M49'
  },
  {
    code: 'M480',
    level: 4,
    description: 'Estenosis espinal',
    code_3: 'M48',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M45-M49'
  },
  {
    code: 'M481',
    level: 4,
    description: 'Hiperostosis anquilosante [Forestier]',
    code_3: 'M48',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M45-M49'
  },
  {
    code: 'M482',
    level: 4,
    description:
      'Espondilopat\u00eda interespinosa (v\u00e9rtebras \u201cen beso\u201d)',
    code_3: 'M48',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M45-M49'
  },
  {
    code: 'M483',
    level: 4,
    description: 'Espondilopat\u00eda traum\u00e1tica',
    code_3: 'M48',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M45-M49'
  },
  {
    code: 'M484',
    level: 4,
    description: 'Fractura de v\u00e9rtebra por fatiga',
    code_3: 'M48',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M45-M49'
  },
  {
    code: 'M485',
    level: 4,
    description: 'V\u00e9rtebra colapsada, no clasificada en otra parte',
    code_3: 'M48',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M45-M49'
  },
  {
    code: 'M488',
    level: 4,
    description: 'Otras espondilopat\u00edas especificadas',
    code_3: 'M48',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M45-M49'
  },
  {
    code: 'M470',
    level: 4,
    description:
      'S\u00edndromes de compresi\u00f3n de la arteria espinal o vertebral anterior (G99.2)',
    code_3: 'M47',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M45-M49'
  },
  {
    code: 'M471',
    level: 4,
    description: 'Otras espondilosis con mielopat\u00eda',
    code_3: 'M47',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M45-M49'
  },
  {
    code: 'M472',
    level: 4,
    description: 'Otras espondilosis con radiculopat\u00eda',
    code_3: 'M47',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M45-M49'
  },
  {
    code: 'M478',
    level: 4,
    description: 'Otras espondilosis',
    code_3: 'M47',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M45-M49'
  },
  {
    code: 'M479',
    level: 4,
    description: 'Espondilosis, no especificada',
    code_3: 'M47',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M45-M49'
  },
  {
    code: 'M460',
    level: 4,
    description: 'Entesopat\u00eda vertebral',
    code_3: 'M46',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M45-M49'
  },
  {
    code: 'M461',
    level: 4,
    description: 'Sacroili\u00edtis, no clasificada en otra parte',
    code_3: 'M46',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M45-M49'
  },
  {
    code: 'M462',
    level: 4,
    description: 'Osteomielitis de v\u00e9rtebra',
    code_3: 'M46',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M45-M49'
  },
  {
    code: 'M463',
    level: 4,
    description: 'Infecci\u00f3n de disco intervertebral (pi\u00f3gena)',
    code_3: 'M46',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M45-M49'
  },
  {
    code: 'M464',
    level: 4,
    description: 'Discitis, no especificada',
    code_3: 'M46',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M45-M49'
  },
  {
    code: 'M465',
    level: 4,
    description: 'Otras espondilopat\u00edas infecciosas',
    code_3: 'M46',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M45-M49'
  },
  {
    code: 'M468',
    level: 4,
    description: 'Otras espondilopat\u00edas inflamatorias especificadas',
    code_3: 'M46',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M45-M49'
  },
  {
    code: 'M469',
    level: 4,
    description: 'Espondilopat\u00eda inflamatoria, no especificada',
    code_3: 'M46',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M45-M49'
  },
  {
    code: 'M540',
    level: 4,
    description: 'Paniculitis que afecta regiones del cuello y de la espalda',
    code_3: 'M54',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M50-M54'
  },
  {
    code: 'M541',
    level: 4,
    description: 'Radiculopat\u00eda',
    code_3: 'M54',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M50-M54'
  },
  {
    code: 'M542',
    level: 4,
    description: 'Cervicalgia',
    code_3: 'M54',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M50-M54'
  },
  {
    code: 'M543',
    level: 4,
    description: 'Ci\u00e1tica',
    code_3: 'M54',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M50-M54'
  },
  {
    code: 'M544',
    level: 4,
    description: 'Lumbago con ci\u00e1tica',
    code_3: 'M54',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M50-M54'
  },
  {
    code: 'M545',
    level: 4,
    description: 'Lumbago no especificado',
    code_3: 'M54',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M50-M54'
  },
  {
    code: 'M546',
    level: 4,
    description: 'Dolor en la columna dorsal',
    code_3: 'M54',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M50-M54'
  },
  {
    code: 'M548',
    level: 4,
    description: 'Otras dorsalgias',
    code_3: 'M54',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M50-M54'
  },
  {
    code: 'M549',
    level: 4,
    description: 'Dorsalgia, no especificada',
    code_3: 'M54',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M50-M54'
  },
  {
    code: 'M530',
    level: 4,
    description: 'S\u00edndrome cervicocraneal',
    code_3: 'M53',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M50-M54'
  },
  {
    code: 'M531',
    level: 4,
    description: 'S\u00edndrome cervicobraquial',
    code_3: 'M53',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M50-M54'
  },
  {
    code: 'M532',
    level: 4,
    description: 'Inestabilidad de la columna vertebral',
    code_3: 'M53',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M50-M54'
  },
  {
    code: 'M533',
    level: 4,
    description:
      'Trastornos sacrococc\u00edgeos, no clasificados en otra parte',
    code_3: 'M53',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M50-M54'
  },
  {
    code: 'M538',
    level: 4,
    description: 'Otras dorsopat\u00edas especificadas',
    code_3: 'M53',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M50-M54'
  },
  {
    code: 'M539',
    level: 4,
    description: 'Dorsopat\u00eda, no especificada',
    code_3: 'M53',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M50-M54'
  },
  {
    code: 'M510',
    level: 4,
    description:
      'Trastornos de discos intervertebrales lumbares y otros, con mielopat\u00eda (G99.2)',
    code_3: 'M51',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M50-M54'
  },
  {
    code: 'M511',
    level: 4,
    description:
      'Trastornos de disco lumbar y otros, con radiculopat\u00eda (G55.1)',
    code_3: 'M51',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M50-M54'
  },
  {
    code: 'M512',
    level: 4,
    description: 'Otros desplazamientos especificados de disco intervertebral',
    code_3: 'M51',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M50-M54'
  },
  {
    code: 'M513',
    level: 4,
    description: 'Otras degeneraciones especificadas de disco intervertebral',
    code_3: 'M51',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M50-M54'
  },
  {
    code: 'M514',
    level: 4,
    description: 'N\u00f3dulos de Schmorl',
    code_3: 'M51',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M50-M54'
  },
  {
    code: 'M500',
    level: 4,
    description: 'Trastorno de disco cervical con mielopat\u00eda (G99.2)',
    code_3: 'M50',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M50-M54'
  },
  {
    code: 'M501',
    level: 4,
    description: 'Trastorno de disco cervical con radiculopat\u00eda',
    code_3: 'M50',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M50-M54'
  },
  {
    code: 'M502',
    level: 4,
    description: 'Otros desplazamientos de disco cervical',
    code_3: 'M50',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M50-M54'
  },
  {
    code: 'M503',
    level: 4,
    description: 'Otras degeneraciones de disco cervical',
    code_3: 'M50',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M50-M54'
  },
  {
    code: 'M508',
    level: 4,
    description: 'Otros trastornos de disco cervical',
    code_3: 'M50',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M50-M54'
  },
  {
    code: 'M509',
    level: 4,
    description: 'Trastorno de disco cervical, no especificado',
    code_3: 'M50',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M50-M54'
  },
  {
    code: 'M030',
    level: 4,
    description: 'Artritis postmeningoc\u00f3cica (A39.8)',
    code_3: 'M03',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M00-M03'
  },
  {
    code: 'M031',
    level: 4,
    description: 'Artropat\u00eda postinfecciosa en s\u00edfilis',
    code_3: 'M03',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M00-M03'
  },
  {
    code: 'M032',
    level: 4,
    description:
      'Otras artropat\u00edas postinfecciosas en enfermedades clasificadas en otra parte',
    code_3: 'M03',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M00-M03'
  },
  {
    code: 'M036',
    level: 4,
    description:
      'Artropat\u00eda reactiva en otras enfermedades clasificadas en otra parte',
    code_3: 'M03',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M00-M03'
  },
  {
    code: 'M020',
    level: 4,
    description: 'Artropat\u00eda consecutiva a derivaci\u00f3n intestinal',
    code_3: 'M02',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M00-M03'
  },
  {
    code: 'M021',
    level: 4,
    description: 'Artropat\u00eda postdisent\u00e9rica',
    code_3: 'M02',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M00-M03'
  },
  {
    code: 'M022',
    level: 4,
    description: 'Artropat\u00eda postinmunizaci\u00f3n',
    code_3: 'M02',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M00-M03'
  },
  {
    code: 'M023',
    level: 4,
    description: 'Enfermedad de Reiter',
    code_3: 'M02',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M00-M03'
  },
  {
    code: 'M028',
    level: 4,
    description: 'Otras artropat\u00edas reactivas',
    code_3: 'M02',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M00-M03'
  },
  {
    code: 'M029',
    level: 4,
    description: 'Artropat\u00eda reactiva, no especificada',
    code_3: 'M02',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M00-M03'
  },
  {
    code: 'M010',
    level: 4,
    description: 'Artritis meningoc\u00f3cica (A39.8)',
    code_3: 'M01',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M00-M03'
  },
  {
    code: 'M011',
    level: 4,
    description: 'Artritis tuberculosa (A18.0)',
    code_3: 'M01',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M00-M03'
  },
  {
    code: 'M012',
    level: 4,
    description: 'Artritis en la enfermedad de Lyme (A69.2)',
    code_3: 'M01',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M00-M03'
  },
  {
    code: 'M013',
    level: 4,
    description:
      'Artritis en otras enfermedades bacterianas clasificadas en otra parte',
    code_3: 'M01',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M00-M03'
  },
  {
    code: 'M014',
    level: 4,
    description: 'Artritis en rub\u00e9ola (B06.8)',
    code_3: 'M01',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M00-M03'
  },
  {
    code: 'M015',
    level: 4,
    description:
      'Artritis en otras enfermedades virales clasificadas en otra parte',
    code_3: 'M01',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M00-M03'
  },
  {
    code: 'M016',
    level: 4,
    description: 'Artritis en micosis (B35\u2013B49)',
    code_3: 'M01',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M00-M03'
  },
  {
    code: 'M018',
    level: 4,
    description:
      'Artritis en otras enfermedades infecciosas y parasitarias clasificadas en otra parte',
    code_3: 'M01',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M00-M03'
  },
  {
    code: 'M000',
    level: 4,
    description: 'Artritis y poliartritis estafiloc\u00f3cica',
    code_3: 'M00',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M00-M03'
  },
  {
    code: 'M001',
    level: 4,
    description: 'Artritis y poliartritis neumoc\u00f3cica',
    code_3: 'M00',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M00-M03'
  },
  {
    code: 'M002',
    level: 4,
    description: 'Otras artritis y poliartritis estreptoc\u00f3cicas',
    code_3: 'M00',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M00-M03'
  },
  {
    code: 'M008',
    level: 4,
    description:
      'Artritis y poliartritis debidas a otros agentes bacterianos especificados',
    code_3: 'M00',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M00-M03'
  },
  {
    code: 'M009',
    level: 4,
    description: 'Artritis pi\u00f3gena, no especificada',
    code_3: 'M00',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M00-M03'
  },
  {
    code: 'M110',
    level: 4,
    description: 'Enfermedad por dep\u00f3sito de hidroxiapatita',
    code_3: 'M11',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M111',
    level: 4,
    description: 'Condrocalcinosis familiar',
    code_3: 'M11',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M112',
    level: 4,
    description: 'Otras condrocalcinosis',
    code_3: 'M11',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M118',
    level: 4,
    description: 'Otras artropat\u00edas por cristales, especificadas',
    code_3: 'M11',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M119',
    level: 4,
    description: 'Artropat\u00eda por cristales, no especificada',
    code_3: 'M11',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M100',
    level: 4,
    description: 'Gota idiop\u00e1tica',
    code_3: 'M10',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M101',
    level: 4,
    description: 'Gota saturnina',
    code_3: 'M10',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M102',
    level: 4,
    description: 'Gota inducida por drogas',
    code_3: 'M10',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M103',
    level: 4,
    description: 'Gota debida a alteraci\u00f3n renal',
    code_3: 'M10',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M104',
    level: 4,
    description: 'Otras gotas secundarias',
    code_3: 'M10',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M109',
    level: 4,
    description: 'Gota, no especificada',
    code_3: 'M10',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M090',
    level: 4,
    description: 'Artritis juvenil en la psoriasis (L40.5)',
    code_3: 'M09',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M091',
    level: 4,
    description:
      'Artritis juvenil en la enfermedad de Crohn [enteritis regional] (K50.\u2013)',
    code_3: 'M09',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M092',
    level: 4,
    description: 'Artritis juvenil en la colitis ulcerativa (K51.\u2013)',
    code_3: 'M09',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M098',
    level: 4,
    description:
      'Artritis juvenil en otras enfermedades clasificadas en otra parte',
    code_3: 'M09',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M080',
    level: 4,
    description: 'Artritis reumatoide juvenil',
    code_3: 'M08',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M081',
    level: 4,
    description: 'Espondilitis anquilosante juvenil',
    code_3: 'M08',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M082',
    level: 4,
    description: 'Artritis juvenil de comienzo generalizado',
    code_3: 'M08',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M083',
    level: 4,
    description: 'Poliartritis juvenil (seronegativa)',
    code_3: 'M08',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M084',
    level: 4,
    description: 'Artritis juvenil pauciarticular',
    code_3: 'M08',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M088',
    level: 4,
    description: 'Otras artritis juveniles',
    code_3: 'M08',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M089',
    level: 4,
    description: 'Artritis juvenil, no especificada',
    code_3: 'M08',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M070',
    level: 4,
    description:
      'Artropat\u00eda psori\u00e1sica interfal\u00e1ngica distal (L40.5)',
    code_3: 'M07',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M071',
    level: 4,
    description: 'Artritis mutilante (L40.5)',
    code_3: 'M07',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M072',
    level: 4,
    description: 'Espondilitis psori\u00e1sica (L40.5)',
    code_3: 'M07',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M073',
    level: 4,
    description: 'Otras artropat\u00edas psori\u00e1sicas (L40.5)',
    code_3: 'M07',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M074',
    level: 4,
    description:
      'Artropat\u00eda en la enfermedad de Crohn [enteritis regional] (K50.\u2013)',
    code_3: 'M07',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M075',
    level: 4,
    description: 'Artropat\u00eda en la colitis ulcerativa (K51.\u2013)',
    code_3: 'M07',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M076',
    level: 4,
    description: 'Otras artropat\u00edas enterop\u00e1ticas',
    code_3: 'M07',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M060',
    level: 4,
    description: 'Artritis reumatoide seronegativa',
    code_3: 'M06',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M061',
    level: 4,
    description: 'Enfermedad de Still de comienzo en el adulto',
    code_3: 'M06',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M062',
    level: 4,
    description: 'Bursitis reumatoide',
    code_3: 'M06',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M063',
    level: 4,
    description: 'N\u00f3dulo reumatoide',
    code_3: 'M06',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M064',
    level: 4,
    description: 'Poliartropat\u00eda inflamatoria',
    code_3: 'M06',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M068',
    level: 4,
    description: 'Otras artritis reumatoides especificadas',
    code_3: 'M06',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M069',
    level: 4,
    description: 'Artritis reumatoide, no especificada',
    code_3: 'M06',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M050',
    level: 4,
    description: 'S\u00edndrome de Felty',
    code_3: 'M05',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M051',
    level: 4,
    description: 'Enfermedad reumatoide del pulm\u00f3n (J99.0)',
    code_3: 'M05',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M052',
    level: 4,
    description: 'Vasculitis reumatoide',
    code_3: 'M05',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M053',
    level: 4,
    description:
      'Artritis reumatoide con compromiso de otros \u00f3rganos o sistemas',
    code_3: 'M05',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M058',
    level: 4,
    description: 'Otras artritis reumatoideas seropositivas',
    code_3: 'M05',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M059',
    level: 4,
    description:
      'Artritis reumatoidea seropositiva, sin otra especificaci\u00f3n',
    code_3: 'M05',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M180',
    level: 4,
    description:
      'Artrosis primaria de la primera articulaci\u00f3n carpometacarpiana, bilateral',
    code_3: 'M18',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M15-M19'
  },
  {
    code: 'M181',
    level: 4,
    description:
      'Otras artrosis primarias de la primera articulaci\u00f3n carpometacarpiana',
    code_3: 'M18',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M15-M19'
  },
  {
    code: 'M182',
    level: 4,
    description:
      'Artrosis postraum\u00e1tica de la primera articulaci\u00f3n carpometacarpiana, bilateral',
    code_3: 'M18',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M15-M19'
  },
  {
    code: 'M183',
    level: 4,
    description:
      'Otras artrosis postraum\u00e1ticas de la primera articulaci\u00f3n carpometacarpiana',
    code_3: 'M18',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M15-M19'
  },
  {
    code: 'M184',
    level: 4,
    description:
      'Otras artrosis secundarias de la primera articulaci\u00f3n carpometacarpiana, bilaterales',
    code_3: 'M18',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M15-M19'
  },
  {
    code: 'M185',
    level: 4,
    description:
      'Otras artrosis secundarias de la primera articulaci\u00f3n carpometacarpiana',
    code_3: 'M18',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M15-M19'
  },
  {
    code: 'M189',
    level: 4,
    description:
      'Artrosis de la primera articulaci\u00f3n carpometacarpiana, sin otra especificaci\u00f3n',
    code_3: 'M18',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M15-M19'
  },
  {
    code: 'M170',
    level: 4,
    description: 'Gonartrosis primaria, bilateral',
    code_3: 'M17',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M15-M19'
  },
  {
    code: 'M171',
    level: 4,
    description: 'Otras gonartrosis primarias',
    code_3: 'M17',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M15-M19'
  },
  {
    code: 'M172',
    level: 4,
    description: 'Gonartrosis postraum\u00e1tica, bilateral',
    code_3: 'M17',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M15-M19'
  },
  {
    code: 'M173',
    level: 4,
    description: 'Otras gonartrosis postraum\u00e1ticas:',
    code_3: 'M17',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M15-M19'
  },
  {
    code: 'M174',
    level: 4,
    description: 'Otras gonartrosis secundarias, bilaterales',
    code_3: 'M17',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M15-M19'
  },
  {
    code: 'M175',
    level: 4,
    description: 'Otras gonartrosis secundarias',
    code_3: 'M17',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M15-M19'
  },
  {
    code: 'M179',
    level: 4,
    description: 'Gonartrosis, no especificada',
    code_3: 'M17',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M15-M19'
  },
  {
    code: 'M160',
    level: 4,
    description: 'Coxartrosis primaria, bilateral',
    code_3: 'M16',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M15-M19'
  },
  {
    code: 'M161',
    level: 4,
    description: 'Otras coxartrosis primarias',
    code_3: 'M16',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M15-M19'
  },
  {
    code: 'M162',
    level: 4,
    description: 'Coxartrosis a consecuencia de displasia, bilateral',
    code_3: 'M16',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M15-M19'
  },
  {
    code: 'M163',
    level: 4,
    description: 'Otras coxartrosis displ\u00e1sicas',
    code_3: 'M16',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M15-M19'
  },
  {
    code: 'M164',
    level: 4,
    description: 'Coxartrosis postraum\u00e1tica, bilateral',
    code_3: 'M16',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M15-M19'
  },
  {
    code: 'M165',
    level: 4,
    description: 'Otra coxartrosis postraum\u00e1tica',
    code_3: 'M16',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M15-M19'
  },
  {
    code: 'M166',
    level: 4,
    description: 'Otra coxartrosis secundaria, bilateral',
    code_3: 'M16',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M15-M19'
  },
  {
    code: 'M167',
    level: 4,
    description: 'Otras coxartrosis secundarias',
    code_3: 'M16',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M15-M19'
  },
  {
    code: 'M169',
    level: 4,
    description: 'Coxartrosis, no especificada',
    code_3: 'M16',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M15-M19'
  },
  {
    code: 'M150',
    level: 4,
    description: '(Osteo)artrosis primaria generalizada',
    code_3: 'M15',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M15-M19'
  },
  {
    code: 'M151',
    level: 4,
    description: 'N\u00f3dulos de Heberden (con artropat\u00eda)',
    code_3: 'M15',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M15-M19'
  },
  {
    code: 'M152',
    level: 4,
    description: 'N\u00f3dulos de Bouchard (con artropat\u00eda)',
    code_3: 'M15',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M15-M19'
  },
  {
    code: 'M153',
    level: 4,
    description: 'Artrosis secundaria m\u00faltiple',
    code_3: 'M15',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M15-M19'
  },
  {
    code: 'M154',
    level: 4,
    description: '(Osteo)artrosis erosiva',
    code_3: 'M15',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M15-M19'
  },
  {
    code: 'M158',
    level: 4,
    description: 'Otras poliartrosis',
    code_3: 'M15',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M15-M19'
  },
  {
    code: 'M159',
    level: 4,
    description: 'Poliartrosis, no especificada',
    code_3: 'M15',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M15-M19'
  },
  {
    code: 'M250',
    level: 4,
    description: 'Hemartrosis',
    code_3: 'M25',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M251',
    level: 4,
    description: 'F\u00edstula articular',
    code_3: 'M25',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M252',
    level: 4,
    description: 'Articulaci\u00f3n inestable',
    code_3: 'M25',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M253',
    level: 4,
    description: 'Otras inestabilidades articulares',
    code_3: 'M25',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M254',
    level: 4,
    description: 'Derrame articular',
    code_3: 'M25',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M255',
    level: 4,
    description: 'Dolor en articulaci\u00f3n',
    code_3: 'M25',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M240',
    level: 4,
    description: 'Cuerpo flotante articular',
    code_3: 'M24',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M241',
    level: 4,
    description: 'Otros trastornos del cart\u00edlago articular',
    code_3: 'M24',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M242',
    level: 4,
    description: 'Trastorno del ligamento',
    code_3: 'M24',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M243',
    level: 4,
    description:
      'Luxaci\u00f3n y subluxaci\u00f3n patol\u00f3gica de la articulaci\u00f3n, no clasificada en otra parte',
    code_3: 'M24',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M244',
    level: 4,
    description:
      'Luxaci\u00f3n y subluxaci\u00f3n recidivante de la articulaci\u00f3n',
    code_3: 'M24',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M245',
    level: 4,
    description: 'Contractura articular',
    code_3: 'M24',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M246',
    level: 4,
    description: 'Anquilosis articular',
    code_3: 'M24',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M247',
    level: 4,
    description: 'Protrusi\u00f3n de acet\u00e1bulo',
    code_3: 'M24',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M230',
    level: 4,
    description: 'Menisco qu\u00edstico',
    code_3: 'M23',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M231',
    level: 4,
    description: 'Menisco discoide (cong\u00e9nito)',
    code_3: 'M23',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M232',
    level: 4,
    description: 'Trastorno de menisco debido a desgarro o lesi\u00f3n antigua',
    code_3: 'M23',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M233',
    level: 4,
    description: 'Otros trastornos de los meniscos',
    code_3: 'M23',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M234',
    level: 4,
    description: 'Cuerpo flotante en la rodilla',
    code_3: 'M23',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M235',
    level: 4,
    description: 'Inestabilidad cr\u00f3nica de la rodilla',
    code_3: 'M23',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M236',
    level: 4,
    description:
      'Otra ruptura espont\u00e1nea del (de los) ligamento(s) de la rodilla',
    code_3: 'M23',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M238',
    level: 4,
    description: 'Otros trastornos internos de la rodilla',
    code_3: 'M23',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M220',
    level: 4,
    description: 'Luxaci\u00f3n recidivante de la r\u00f3tula',
    code_3: 'M22',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M221',
    level: 4,
    description: 'Subluxaci\u00f3n recidivante de la r\u00f3tula',
    code_3: 'M22',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M222',
    level: 4,
    description: 'Trastornos rotulofemorales',
    code_3: 'M22',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M223',
    level: 4,
    description: 'Otros desarreglos de la r\u00f3tula',
    code_3: 'M22',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M224',
    level: 4,
    description: 'Condromalacia de la r\u00f3tula',
    code_3: 'M22',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M228',
    level: 4,
    description: 'Otros trastornos de la r\u00f3tula',
    code_3: 'M22',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M229',
    level: 4,
    description: 'Trastorno de la r\u00f3tula, no especificado',
    code_3: 'M22',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M210',
    level: 4,
    description: 'Deformidad en valgo, no clasificada en otra parte',
    code_3: 'M21',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M211',
    level: 4,
    description: 'Deformidad en varo, no clasificada en otra parte',
    code_3: 'M21',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M212',
    level: 4,
    description: 'Deformidad en flexi\u00f3n',
    code_3: 'M21',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M213',
    level: 4,
    description: 'Mu\u00f1eca o pie en p\u00e9ndulo (adquirido)',
    code_3: 'M21',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M214',
    level: 4,
    description: 'Pie plano [pes planus] (adquirido)',
    code_3: 'M21',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M215',
    level: 4,
    description:
      'Mano o pie en garra o en talipes, pie equinovaro o zambo adquiridos',
    code_3: 'M21',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M216',
    level: 4,
    description: 'Otras deformidades adquiridas del tobillo y del pie',
    code_3: 'M21',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M217',
    level: 4,
    description: 'Longitud desigual de los miembros (adquirida)',
    code_3: 'M21',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M218',
    level: 4,
    description: 'Otras deformidades adquiridas de los miembros, especificadas',
    code_3: 'M21',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M219',
    level: 4,
    description: 'Deformidad adquirida del miembro, no especificada',
    code_3: 'M21',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M200',
    level: 4,
    description: 'Deformidad de dedo(s) de la mano',
    code_3: 'M20',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M201',
    level: 4,
    description: 'Hallux valgus (adquirido)',
    code_3: 'M20',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M202',
    level: 4,
    description: 'Hallux rigidus',
    code_3: 'M20',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M203',
    level: 4,
    description: 'Otras deformidades del hallux (adquiridas)',
    code_3: 'M20',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'E210',
    level: 3,
    description: 'Hiperparatiroidismo primario',
    code_2: 'E21',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E211',
    level: 3,
    description: 'Hiperparatiroidismo secundario no clasificado en otra parte',
    code_2: 'E21',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E200',
    level: 3,
    description: 'Hipoparatiroidismo idiop\u00e1tico',
    code_2: 'E20',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E201',
    level: 3,
    description: 'Pseudohipoparatiroidismo',
    code_2: 'E20',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E208',
    level: 3,
    description: 'Otros tipos de hipoparatiroidismo',
    code_2: 'E20',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E209',
    level: 3,
    description: 'Hipoparatiroidismo, no especificado',
    code_2: 'E20',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'D530',
    level: 3,
    description: 'Anemia por deficiencia de prote\u00ednas',
    code_2: 'D53',
    code_0: 'D50-D89',
    code_1: 'D50-D53'
  },
  {
    code: 'D531',
    level: 3,
    description:
      'Otras anemias megalobl\u00e1sticas, no clasificadas en otra parte',
    code_2: 'D53',
    code_0: 'D50-D89',
    code_1: 'D50-D53'
  },
  {
    code: 'D532',
    level: 3,
    description: 'Anemia escorb\u00fatica',
    code_2: 'D53',
    code_0: 'D50-D89',
    code_1: 'D50-D53'
  },
  {
    code: 'D538',
    level: 3,
    description: 'Otras anemias nutricionales especificadas',
    code_2: 'D53',
    code_0: 'D50-D89',
    code_1: 'D50-D53'
  },
  {
    code: 'D520',
    level: 3,
    description: 'Anemia por deficiencia diet\u00e9tica de folatos',
    code_2: 'D52',
    code_0: 'D50-D89',
    code_1: 'D50-D53'
  },
  {
    code: 'D521',
    level: 3,
    description: 'Anemia por deficiencia de folatos inducida por drogas',
    code_2: 'D52',
    code_0: 'D50-D89',
    code_1: 'D50-D53'
  },
  {
    code: 'D528',
    level: 3,
    description: 'Otras anemias por deficiencia de folatos',
    code_2: 'D52',
    code_0: 'D50-D89',
    code_1: 'D50-D53'
  },
  {
    code: 'D529',
    level: 3,
    description:
      'Anemia por deficiencia de folatos, sin otra especificaci\u00f3n',
    code_2: 'D52',
    code_0: 'D50-D89',
    code_1: 'D50-D53'
  },
  {
    code: 'D510',
    level: 3,
    description:
      'Anemia por deficiencia de vitamina B12 debida a deficiencia del factor intr\u00ednseco',
    code_2: 'D51',
    code_0: 'D50-D89',
    code_1: 'D50-D53'
  },
  {
    code: 'D511',
    level: 3,
    description:
      'Anemia por deficiencia de vitamina B12 debida a mala absorci\u00f3n selectiva de vitamina B12 con proteinuria',
    code_2: 'D51',
    code_0: 'D50-D89',
    code_1: 'D50-D53'
  },
  {
    code: 'D512',
    level: 3,
    description: 'Deficiencia de trascobalamina II',
    code_2: 'D51',
    code_0: 'D50-D89',
    code_1: 'D50-D53'
  },
  {
    code: 'D513',
    level: 3,
    description: 'Otras anemias por deficiencia diet\u00e9tica de vitamina B12',
    code_2: 'D51',
    code_0: 'D50-D89',
    code_1: 'D50-D53'
  },
  {
    code: 'D518',
    level: 3,
    description: 'Otras anemias por deficiencia de vitamina B12',
    code_2: 'D51',
    code_0: 'D50-D89',
    code_1: 'D50-D53'
  },
  {
    code: 'D500',
    level: 3,
    description:
      'Anemia por deficiencia de hierro secundaria a p\u00e9rdida de sangre (cr\u00f3nica)',
    code_2: 'D50',
    code_0: 'D50-D89',
    code_1: 'D50-D53'
  },
  {
    code: 'D501',
    level: 3,
    description: 'Disfagia siderop\u00e9nica',
    code_2: 'D50',
    code_0: 'D50-D89',
    code_1: 'D50-D53'
  },
  {
    code: 'D508',
    level: 3,
    description: 'Otras anemias por deficiencia de hierro',
    code_2: 'D50',
    code_0: 'D50-D89',
    code_1: 'D50-D53'
  },
  {
    code: 'D590',
    level: 3,
    description: 'Anemia hemol\u00edtica autoinmune inducida por drogas',
    code_2: 'D59',
    code_0: 'D50-D89',
    code_1: 'D55-D59'
  },
  {
    code: 'D591',
    level: 3,
    description: 'Otras anemias hemol\u00edticas autoinmunes',
    code_2: 'D59',
    code_0: 'D50-D89',
    code_1: 'D55-D59'
  },
  {
    code: 'D592',
    level: 3,
    description: 'Anemia hemol\u00edtica no autoinmune inducida por drogas',
    code_2: 'D59',
    code_0: 'D50-D89',
    code_1: 'D55-D59'
  },
  {
    code: 'D593',
    level: 3,
    description: 'S\u00edndrome hemol\u00edtico-ur\u00e9mico',
    code_2: 'D59',
    code_0: 'D50-D89',
    code_1: 'D55-D59'
  },
  {
    code: 'D580',
    level: 3,
    description: 'Esferocitosis hereditaria',
    code_2: 'D58',
    code_0: 'D50-D89',
    code_1: 'D55-D59'
  },
  {
    code: 'D581',
    level: 3,
    description: 'Eliptocitosis hereditaria',
    code_2: 'D58',
    code_0: 'D50-D89',
    code_1: 'D55-D59'
  },
  {
    code: 'D582',
    level: 3,
    description: 'Otras hemoglobinopat\u00edas',
    code_2: 'D58',
    code_0: 'D50-D89',
    code_1: 'D55-D59'
  },
  {
    code: 'D588',
    level: 3,
    description: 'Otras anemias hemol\u00edticas hereditarias especificadas',
    code_2: 'D58',
    code_0: 'D50-D89',
    code_1: 'D55-D59'
  },
  {
    code: 'D589',
    level: 3,
    description:
      'Anemia hemol\u00edtica hereditaria, sin otra especificaci\u00f3n',
    code_2: 'D58',
    code_0: 'D50-D89',
    code_1: 'D55-D59'
  },
  {
    code: 'D570',
    level: 3,
    description: 'Anemia falciforme con crisis',
    code_2: 'D57',
    code_0: 'D50-D89',
    code_1: 'D55-D59'
  },
  {
    code: 'D571',
    level: 3,
    description: 'Anemia falciforme sin crisis',
    code_2: 'D57',
    code_0: 'D50-D89',
    code_1: 'D55-D59'
  },
  {
    code: 'D572',
    level: 3,
    description: 'Trastornos falciformes heterocigotos dobles',
    code_2: 'D57',
    code_0: 'D50-D89',
    code_1: 'D55-D59'
  },
  {
    code: 'D573',
    level: 3,
    description: 'Rasgo drepanoc\u00edtico',
    code_2: 'D57',
    code_0: 'D50-D89',
    code_1: 'D55-D59'
  },
  {
    code: 'D578',
    level: 3,
    description: 'Otros trastornos falciformes',
    code_2: 'D57',
    code_0: 'D50-D89',
    code_1: 'D55-D59'
  },
  {
    code: 'D560',
    level: 3,
    description: 'Alfa talasemia',
    code_2: 'D56',
    code_0: 'D50-D89',
    code_1: 'D55-D59'
  },
  {
    code: 'D561',
    level: 3,
    description: 'Beta talasemia',
    code_2: 'D56',
    code_0: 'D50-D89',
    code_1: 'D55-D59'
  },
  {
    code: 'D562',
    level: 3,
    description: 'Delta-beta talasemia',
    code_2: 'D56',
    code_0: 'D50-D89',
    code_1: 'D55-D59'
  },
  {
    code: 'D563',
    level: 3,
    description: 'Rasgo talas\u00e9mico',
    code_2: 'D56',
    code_0: 'D50-D89',
    code_1: 'D55-D59'
  },
  {
    code: 'D564',
    level: 3,
    description: 'Persistencia hereditaria de la hemoglobina fetal [PHHF]',
    code_2: 'D56',
    code_0: 'D50-D89',
    code_1: 'D55-D59'
  },
  {
    code: 'D568',
    level: 3,
    description: 'Otras talasemias',
    code_2: 'D56',
    code_0: 'D50-D89',
    code_1: 'D55-D59'
  },
  {
    code: 'D550',
    level: 3,
    description:
      'Anemia debida a deficiencia de glucosa-6-fosfato deshidrogenasa [G6FD]',
    code_2: 'D55',
    code_0: 'D50-D89',
    code_1: 'D55-D59'
  },
  {
    code: 'D551',
    level: 3,
    description:
      'Anemia debida a otros trastornos del metabolismo del glutati\u00f3n',
    code_2: 'D55',
    code_0: 'D50-D89',
    code_1: 'D55-D59'
  },
  {
    code: 'D552',
    level: 3,
    description: 'Anemia debida a trastornos de las enzimas glucol\u00edticas',
    code_2: 'D55',
    code_0: 'D50-D89',
    code_1: 'D55-D59'
  },
  {
    code: 'D553',
    level: 3,
    description:
      'Anemia debida a trastornos del metabolismo de los nucle\u00f3tidos',
    code_2: 'D55',
    code_0: 'D50-D89',
    code_1: 'D55-D59'
  },
  {
    code: 'D558',
    level: 3,
    description: 'Otras anemias debidas a trastornos enzim\u00e1ticos',
    code_2: 'D55',
    code_0: 'D50-D89',
    code_1: 'D55-D59'
  },
  {
    code: 'D559',
    level: 3,
    description:
      'Anemia debida a trastornos enzim\u00e1ticos, sin otra especificaci\u00f3n',
    code_2: 'D55',
    code_0: 'D50-D89',
    code_1: 'D55-D59'
  },
  {
    code: 'D640',
    level: 3,
    description: 'Anemia siderobl\u00e1stica hereditaria',
    code_2: 'D64',
    code_0: 'D50-D89',
    code_1: 'D60-D64'
  },
  {
    code: 'D641',
    level: 3,
    description: 'Anemia siderobl\u00e1stica secundaria a otra enfermedad',
    code_2: 'D64',
    code_0: 'D50-D89',
    code_1: 'D60-D64'
  },
  {
    code: 'D642',
    level: 3,
    description:
      'Anemia siderobl\u00e1stica secundaria, debida a drogas y toxinas',
    code_2: 'D64',
    code_0: 'D50-D89',
    code_1: 'D60-D64'
  },
  {
    code: 'D643',
    level: 3,
    description: 'Otras anemias siderobl\u00e1sticas',
    code_2: 'D64',
    code_0: 'D50-D89',
    code_1: 'D60-D64'
  },
  {
    code: 'D644',
    level: 3,
    description: 'Anemia diseritropoy\u00e9tica cong\u00e9nita',
    code_2: 'D64',
    code_0: 'D50-D89',
    code_1: 'D60-D64'
  },
  {
    code: 'D648',
    level: 3,
    description: 'Otras anemias especificadas',
    code_2: 'D64',
    code_0: 'D50-D89',
    code_1: 'D60-D64'
  },
  {
    code: 'D649',
    level: 3,
    description: 'Anemia de tipo no especificado',
    code_2: 'D64',
    code_0: 'D50-D89',
    code_1: 'D60-D64'
  },
  {
    code: 'D630',
    level: 3,
    description: 'Anemia en enfermedad neopl\u00e1sica (C00\u2013D48)',
    code_2: 'D63',
    code_0: 'D50-D89',
    code_1: 'D60-D64'
  },
  {
    code: 'D638',
    level: 3,
    description:
      'Anemia en otras enfermedades cr\u00f3nicas clasificadas en otra parte',
    code_2: 'D63',
    code_0: 'D50-D89',
    code_1: 'D60-D64'
  },
  {
    code: 'D610',
    level: 3,
    description: 'Anemia apl\u00e1stica constitucional',
    code_2: 'D61',
    code_0: 'D50-D89',
    code_1: 'D60-D64'
  },
  {
    code: 'D611',
    level: 3,
    description: 'Anemia apl\u00e1stica inducida por drogas',
    code_2: 'D61',
    code_0: 'D50-D89',
    code_1: 'D60-D64'
  },
  {
    code: 'D612',
    level: 3,
    description: 'Anemia apl\u00e1stica debida a otros agentes externos',
    code_2: 'D61',
    code_0: 'D50-D89',
    code_1: 'D60-D64'
  },
  {
    code: 'D613',
    level: 3,
    description: 'Anemia apl\u00e1stica idiop\u00e1tica',
    code_2: 'D61',
    code_0: 'D50-D89',
    code_1: 'D60-D64'
  },
  {
    code: 'D618',
    level: 3,
    description: 'Otras anemias apl\u00e1sticas especificadas',
    code_2: 'D61',
    code_0: 'D50-D89',
    code_1: 'D60-D64'
  },
  {
    code: 'D619',
    level: 3,
    description: 'Anemia apl\u00e1stica, sin otra especificaci\u00f3n',
    code_2: 'D61',
    code_0: 'D50-D89',
    code_1: 'D60-D64'
  },
  {
    code: 'D600',
    level: 3,
    description: 'Aplasia cr\u00f3nica adquirida, exclusiva de la serie roja',
    code_2: 'D60',
    code_0: 'D50-D89',
    code_1: 'D60-D64'
  },
  {
    code: 'D601',
    level: 3,
    description: 'Aplasia transitoria adquirida, exclusiva de la serie roja',
    code_2: 'D60',
    code_0: 'D50-D89',
    code_1: 'D60-D64'
  },
  {
    code: 'D608',
    level: 3,
    description: 'Otras aplasias adquiridas, exclusivas de la serie roja',
    code_2: 'D60',
    code_0: 'D50-D89',
    code_1: 'D60-D64'
  },
  {
    code: 'D609',
    level: 3,
    description:
      'Aplasia adquirida, exclusiva de la serie roja, no especificada',
    code_2: 'D60',
    code_0: 'D50-D89',
    code_1: 'D60-D64'
  },
  {
    code: 'D690',
    level: 3,
    description: 'P\u00farpura al\u00e9rgica',
    code_2: 'D69',
    code_0: 'D50-D89',
    code_1: 'D65-D69'
  },
  {
    code: 'D691',
    level: 3,
    description: 'Defectos cualitativos de las plaquetas',
    code_2: 'D69',
    code_0: 'D50-D89',
    code_1: 'D65-D69'
  },
  {
    code: 'D692',
    level: 3,
    description: 'Otras p\u00farpuras no trombocitop\u00e9nicas',
    code_2: 'D69',
    code_0: 'D50-D89',
    code_1: 'D65-D69'
  },
  {
    code: 'D693',
    level: 3,
    description: 'P\u00farpura trombocitop\u00e9nica idiop\u00e1tica',
    code_2: 'D69',
    code_0: 'D50-D89',
    code_1: 'D65-D69'
  },
  {
    code: 'D694',
    level: 3,
    description: 'Otras trombocitopenias primarias',
    code_2: 'D69',
    code_0: 'D50-D89',
    code_1: 'D65-D69'
  },
  {
    code: 'D695',
    level: 3,
    description: 'Trombocitopenia secundaria',
    code_2: 'D69',
    code_0: 'D50-D89',
    code_1: 'D65-D69'
  },
  {
    code: 'D696',
    level: 3,
    description: 'Trombocitopenia no especificada',
    code_2: 'D69',
    code_0: 'D50-D89',
    code_1: 'D65-D69'
  },
  {
    code: 'D698',
    level: 3,
    description: 'Otras afecciones hemorr\u00e1gicas especificadas',
    code_2: 'D69',
    code_0: 'D50-D89',
    code_1: 'D65-D69'
  },
  {
    code: 'D699',
    level: 3,
    description: 'Afecci\u00f3n hemorr\u00e1gica, no especificada',
    code_2: 'D69',
    code_0: 'D50-D89',
    code_1: 'D65-D69'
  },
  {
    code: 'D680',
    level: 3,
    description: 'Enfermedad de von Willebrand',
    code_2: 'D68',
    code_0: 'D50-D89',
    code_1: 'D65-D69'
  },
  {
    code: 'D681',
    level: 3,
    description: 'Deficiencia hereditaria del factor XI',
    code_2: 'D68',
    code_0: 'D50-D89',
    code_1: 'D65-D69'
  },
  {
    code: 'D682',
    level: 3,
    description:
      'Deficiencia hereditaria de otros factores de la coagulaci\u00f3n',
    code_2: 'D68',
    code_0: 'D50-D89',
    code_1: 'D65-D69'
  },
  {
    code: 'D683',
    level: 3,
    description:
      'Trastorno hemorr\u00e1gico debido a anticoagulantes circulantes',
    code_2: 'D68',
    code_0: 'D50-D89',
    code_1: 'D65-D69'
  },
  {
    code: 'D684',
    level: 3,
    description: 'Deficiencia adquirida de factores de la coagulaci\u00f3n',
    code_2: 'D68',
    code_0: 'D50-D89',
    code_1: 'D65-D69'
  },
  {
    code: 'D688',
    level: 3,
    description: 'Otros defectos especificados de la coagulaci\u00f3n',
    code_2: 'D68',
    code_0: 'D50-D89',
    code_1: 'D65-D69'
  },
  {
    code: 'D689',
    level: 3,
    description: 'Defecto de la coagulaci\u00f3n, no especificado',
    code_2: 'D68',
    code_0: 'D50-D89',
    code_1: 'D65-D69'
  },
  {
    code: 'S435',
    level: 3,
    description:
      'Esguinces y torceduras de la articulaci\u00f3n acromioclavicular',
    code_2: 'S43',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S436',
    level: 3,
    description:
      'Esguinces y torceduras de la articulaci\u00f3n esternoclavicular',
    code_2: 'S43',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S437',
    level: 3,
    description:
      'Esguinces y torceduras de otras partes y de las no especificadas de la cintura escapular',
    code_2: 'S43',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S409',
    level: 3,
    description:
      'Traumatismo superficial no especificado del hombro y del brazo',
    code_2: 'S40',
    code_0: 'S00-T88',
    code_1: 'S40-S49'
  },
  {
    code: 'S525',
    level: 3,
    description: 'Fractura de la ep\u00edfisis inferior del radio',
    code_2: 'S52',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S526',
    level: 3,
    description:
      'Fractura de la ep\u00edfisis inferior del c\u00fabito y del radio',
    code_2: 'S52',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S527',
    level: 3,
    description: 'Fracturas m\u00faltiples del antebrazo',
    code_2: 'S52',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S528',
    level: 3,
    description: 'Fractura de otras partes del antebrazo',
    code_2: 'S52',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S529',
    level: 3,
    description: 'Fractura del antebrazo, parte no especificada',
    code_2: 'S52',
    code_0: 'S00-T88',
    code_1: 'S50-S59'
  },
  {
    code: 'S724',
    level: 3,
    description: 'Fractura de la ep\u00edfisis inferior del f\u00e9mur',
    code_2: 'S72',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S727',
    level: 3,
    description: 'Fracturas m\u00faltiples del f\u00e9mur',
    code_2: 'S72',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S728',
    level: 3,
    description: 'Fracturas de otras partes del f\u00e9mur',
    code_2: 'S72',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S729',
    level: 3,
    description: 'Fractura del f\u00e9mur, parte no especificada',
    code_2: 'S72',
    code_0: 'S00-T88',
    code_1: 'S70-S79'
  },
  {
    code: 'S837',
    level: 3,
    description: 'Traumatismo de estructuras m\u00faltiples de la rodilla',
    code_2: 'S83',
    code_0: 'S00-T88',
    code_1: 'S80-S89'
  },
  {
    code: 'Z035',
    level: 3,
    description:
      'Observaci\u00f3n por sospecha de otras enfermedades cardiovasculares',
    code_2: 'Z03',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z036',
    level: 3,
    description:
      'Observaci\u00f3n por sospecha de efectos t\u00f3xicos de sustancias ingeridas',
    code_2: 'Z03',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z038',
    level: 3,
    description:
      'Observaci\u00f3n por sospecha de otras enfermedades y afecciones',
    code_2: 'Z03',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z039',
    level: 3,
    description:
      'Observaci\u00f3n por sospecha de enfermedad o afecci\u00f3n no especificada',
    code_2: 'Z03',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z016',
    level: 3,
    description: 'Examen radiol\u00f3gico, no clasificado en otra parte',
    code_2: 'Z01',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z017',
    level: 3,
    description: 'Examen de laboratorio',
    code_2: 'Z01',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z018',
    level: 3,
    description: 'Otros ex\u00e1menes especiales especificados',
    code_2: 'Z01',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z019',
    level: 3,
    description: 'Examen especial no especificado',
    code_2: 'Z01',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z002',
    level: 3,
    description:
      'Examen durante el per\u00edodo de crecimiento r\u00e1pido en la infancia',
    code_2: 'Z00',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z003',
    level: 3,
    description: 'Examen del estado de desarrollo del adolescente',
    code_2: 'Z00',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z004',
    level: 3,
    description:
      'Examen psiqui\u00e1trico general, no clasificado en otra parte',
    code_2: 'Z00',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z005',
    level: 3,
    description: 'Examen de donante potencial de \u00f3rgano o tejido',
    code_2: 'Z00',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z006',
    level: 3,
    description:
      'Examen para comparaci\u00f3n y control normales en programa de investigaci\u00f3n cl\u00ednica',
    code_2: 'Z00',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z008',
    level: 3,
    description: 'Otros ex\u00e1menes generales',
    code_2: 'Z00',
    code_0: 'Z00-Z99',
    code_1: 'Z00-Z13'
  },
  {
    code: 'Z225',
    level: 3,
    description: 'Portador de agente de hepatitis viral',
    code_2: 'Z22',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z226',
    level: 3,
    description:
      'Portador del virus humano T-linfotr\u00f3pico tipo 1 [VHTL-1]',
    code_2: 'Z22',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z228',
    level: 3,
    description: 'Portador de agentes de otras enfermedades infecciosas',
    code_2: 'Z22',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z229',
    level: 3,
    description: 'Portador de agente de enfermedad infecciosa no especificada',
    code_2: 'Z22',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z204',
    level: 3,
    description: 'Contacto con y exposici\u00f3n a rub\u00e9ola',
    code_2: 'Z20',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z205',
    level: 3,
    description: 'Contacto con y exposici\u00f3n a hepatitis viral',
    code_2: 'Z20',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z206',
    level: 3,
    description:
      'Contacto con y exposici\u00f3n al virus de la inmunodeficiencia humana [VIH]',
    code_2: 'Z20',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z207',
    level: 3,
    description:
      'Contacto con y exposici\u00f3n a pediculosis, acariasis y otras infestaciones',
    code_2: 'Z20',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z208',
    level: 3,
    description:
      'Contacto con y exposici\u00f3n a otras enfermedades transmisibles',
    code_2: 'Z20',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z209',
    level: 3,
    description:
      'Contacto con y exposici\u00f3n a enfermedades transmisibles no especificadas',
    code_2: 'Z20',
    code_0: 'Z00-Z99',
    code_1: 'Z20-Z29'
  },
  {
    code: 'Z316',
    level: 3,
    description: 'Consejo y asesoramiento general sobre la procreaci\u00f3n',
    code_2: 'Z31',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z318',
    level: 3,
    description: 'Otra atenci\u00f3n especificada para la procreaci\u00f3n',
    code_2: 'Z31',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z319',
    level: 3,
    description:
      'Atenci\u00f3n no especificada relacionada con la procreaci\u00f3n',
    code_2: 'Z31',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z305',
    level: 3,
    description:
      'Supervisi\u00f3n del uso de dispositivo anticonceptivo (intrauterino)',
    code_2: 'Z30',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z308',
    level: 3,
    description: 'Otras atenciones especificadas para la anticoncepci\u00f3n',
    code_2: 'Z30',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'Z309',
    level: 3,
    description: 'Asistencia para la anticoncepci\u00f3n, no especificada',
    code_2: 'Z30',
    code_0: 'Z00-Z99',
    code_1: 'Z30-Z39'
  },
  {
    code: 'M850',
    level: 4,
    description: 'Displasia fibrosa (monost\u00f3tica)',
    code_3: 'M85',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M851',
    level: 4,
    description: 'Fluorosis del esqueleto',
    code_3: 'M85',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M852',
    level: 4,
    description: 'Hiperostosis del cr\u00e1neo',
    code_3: 'M85',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M853',
    level: 4,
    description: 'Oste\u00edtis condensante',
    code_3: 'M85',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M854',
    level: 4,
    description: 'Quiste \u00f3seo solitario',
    code_3: 'M85',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M855',
    level: 4,
    description: 'Quiste \u00f3seo aneurism\u00e1tico',
    code_3: 'M85',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M856',
    level: 4,
    description: 'Otros quistes \u00f3seos',
    code_3: 'M85',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M858',
    level: 4,
    description:
      'Otros trastornos especificados de la densidad y de la estructura \u00f3seas',
    code_3: 'M85',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M940',
    level: 4,
    description: 'S\u00edndrome de la articulaci\u00f3n condrocostal [Tietze]',
    code_3: 'M94',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M91-M94'
  },
  {
    code: 'M941',
    level: 4,
    description: 'Policondritis recidivante',
    code_3: 'M94',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M91-M94'
  },
  {
    code: 'M942',
    level: 4,
    description: 'Condromalacia',
    code_3: 'M94',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M91-M94'
  },
  {
    code: 'M943',
    level: 4,
    description: 'Condr\u00f3lisis',
    code_3: 'M94',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M91-M94'
  },
  {
    code: 'M948',
    level: 4,
    description: 'Otros trastornos especificados del cart\u00edlago',
    code_3: 'M94',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M91-M94'
  },
  {
    code: 'M949',
    level: 4,
    description: 'Trastorno del cart\u00edlago, no especificado',
    code_3: 'M94',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M91-M94'
  },
  {
    code: 'M930',
    level: 4,
    description:
      'Deslizamiento de la ep\u00edfisis femoral superior (no traum\u00e1tico)',
    code_3: 'M93',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M91-M94'
  },
  {
    code: 'M931',
    level: 4,
    description: 'Enfermedad de Kienb\u00f6ck del adulto',
    code_3: 'M93',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M91-M94'
  },
  {
    code: 'M932',
    level: 4,
    description: 'Osteocondritis disecante',
    code_3: 'M93',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M91-M94'
  },
  {
    code: 'M938',
    level: 4,
    description: 'Otras osteocondropat\u00edas especificadas',
    code_3: 'M93',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M91-M94'
  },
  {
    code: 'M939',
    level: 4,
    description: 'Osteocondropat\u00eda, no especificada',
    code_3: 'M93',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M91-M94'
  },
  {
    code: 'M630',
    level: 4,
    description:
      'Miositis en enfermedades bacterianas clasificadas en otra parte',
    code_3: 'M63',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M60-M63'
  },
  {
    code: 'M631',
    level: 4,
    description:
      'Miositis en infecciones por protozoarios y par\u00e1sitos clasificadas en otra parte',
    code_3: 'M63',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M60-M63'
  },
  {
    code: 'M632',
    level: 4,
    description:
      'Miositis en otras enfermedades infecciosas clasificadas en otra parte',
    code_3: 'M63',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M60-M63'
  },
  {
    code: 'M633',
    level: 4,
    description: 'Miositis en sarcoidosis (D86.8)',
    code_3: 'M63',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M60-M63'
  },
  {
    code: 'M790',
    level: 4,
    description: 'Reumatismo, no especificado',
    code_3: 'M79',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M770',
    level: 4,
    description: 'Epicondilitis media',
    code_3: 'M77',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M760',
    level: 4,
    description: 'Tendinitis del gl\u00fateo',
    code_3: 'M76',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M750',
    level: 4,
    description: 'Capsulitis adhesiva del hombro',
    code_3: 'M75',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M751',
    level: 4,
    description: 'S\u00edndrome del manguito rotatorio',
    code_3: 'M75',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M730',
    level: 4,
    description: 'Bursitis gonoc\u00f3cica (A54.4)',
    code_3: 'M73',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M731',
    level: 4,
    description: 'Bursitis sifil\u00edtica (A52.7)',
    code_3: 'M73',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M140',
    level: 4,
    description:
      'Artropat\u00eda gotosa debida a defectos enzim\u00e1ticos y a otros trastornos hereditarios, clasificados en otra parte',
    code_3: 'M14',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M141',
    level: 4,
    description:
      'Artropat\u00eda por cristales en otros trastornos metab\u00f3licos',
    code_3: 'M14',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M142',
    level: 4,
    description:
      'Artropat\u00eda diab\u00e9tica (E10\u2013E14 con cuarto car\u00e1cter com\u00fan .6)',
    code_3: 'M14',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M130',
    level: 4,
    description: 'Poliartritis, no especificada',
    code_3: 'M13',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M131',
    level: 4,
    description: 'Monoartritis, no clasificada en otra parte',
    code_3: 'M13',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M138',
    level: 4,
    description: 'Otras artritis especificadas',
    code_3: 'M13',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M139',
    level: 4,
    description: 'Artritis, no especificada',
    code_3: 'M13',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M120',
    level: 4,
    description: 'Artropat\u00eda postreum\u00e1tica cr\u00f3nica [de Jaccoud]',
    code_3: 'M12',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M121',
    level: 4,
    description: 'Enfermedad de Kaschin-Beck',
    code_3: 'M12',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M122',
    level: 4,
    description: 'Sinovitis vellonodular (pigmentada)',
    code_3: 'M12',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M123',
    level: 4,
    description: 'Reumatismo palindr\u00f3mico',
    code_3: 'M12',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M124',
    level: 4,
    description: 'Hidrartrosis intermitente',
    code_3: 'M12',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M125',
    level: 4,
    description: 'Artropat\u00eda traum\u00e1tica',
    code_3: 'M12',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M128',
    level: 4,
    description:
      'Otras artropat\u00edas espec\u00edficas, no clasificadas en otra parte',
    code_3: 'M12',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M190',
    level: 4,
    description: 'Artrosis primaria de otras articulaciones',
    code_3: 'M19',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M15-M19'
  },
  {
    code: 'M191',
    level: 4,
    description: 'Artrosis postraum\u00e1tica de otras articulaciones',
    code_3: 'M19',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M15-M19'
  },
  {
    code: 'M192',
    level: 4,
    description: 'Otras artrosis secundarias',
    code_3: 'M19',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M15-M19'
  },
  {
    code: 'M198',
    level: 4,
    description: 'Otras artrosis especificadas',
    code_3: 'M19',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M15-M19'
  },
  {
    code: 'M199',
    level: 4,
    description: 'Artrosis, no especificada',
    code_3: 'M19',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M15-M19'
  },
  {
    code: 'D730',
    level: 3,
    description: 'Hipoesplenismo',
    code_2: 'D73',
    code_0: 'D50-D89',
    code_1: 'D70-D77'
  },
  {
    code: 'D731',
    level: 3,
    description: 'Hiperesplenismo',
    code_2: 'D73',
    code_0: 'D50-D89',
    code_1: 'D70-D77'
  },
  {
    code: 'D732',
    level: 3,
    description: 'Esplenomegalia congestiva cr\u00f3nica',
    code_2: 'D73',
    code_0: 'D50-D89',
    code_1: 'D70-D77'
  },
  {
    code: 'D733',
    level: 3,
    description: 'Absceso del bazo',
    code_2: 'D73',
    code_0: 'D50-D89',
    code_1: 'D70-D77'
  },
  {
    code: 'D734',
    level: 3,
    description: 'Quiste del bazo',
    code_2: 'D73',
    code_0: 'D50-D89',
    code_1: 'D70-D77'
  },
  {
    code: 'D735',
    level: 3,
    description: 'Infarto del bazo',
    code_2: 'D73',
    code_0: 'D50-D89',
    code_1: 'D70-D77'
  },
  {
    code: 'D720',
    level: 3,
    description: 'Anomal\u00edas gen\u00e9ticas de los leucocitos',
    code_2: 'D72',
    code_0: 'D50-D89',
    code_1: 'D70-D77'
  },
  {
    code: 'D721',
    level: 3,
    description: 'Eosinofilia',
    code_2: 'D72',
    code_0: 'D50-D89',
    code_1: 'D70-D77'
  },
  {
    code: 'D728',
    level: 3,
    description: 'Otros trastornos especificados de los leucocitos',
    code_2: 'D72',
    code_0: 'D50-D89',
    code_1: 'D70-D77'
  },
  {
    code: 'D729',
    level: 3,
    description: 'Trastorno de los leucocitos, no especificado',
    code_2: 'D72',
    code_0: 'D50-D89',
    code_1: 'D70-D77'
  },
  {
    code: 'C81',
    level: 3,
    description: 'Enfermedad de Hodgkin',
    code_2: 'C81-C96',
    code_0: 'C00-D49',
    code_1: 'C00-C97'
  },
  {
    code: 'C82',
    level: 3,
    description: 'Linfoma no Hodgkin folicular [nodular]',
    code_2: 'C81-C96',
    code_0: 'C00-D49',
    code_1: 'C00-C97'
  },
  {
    code: 'C83',
    level: 3,
    description: 'Linfoma no Hodgkin difuso',
    code_2: 'C81-C96',
    code_0: 'C00-D49',
    code_1: 'C00-C97'
  },
  {
    code: 'C76',
    level: 3,
    description: 'Tumor maligno de otros sitios y de sitios mal definidos',
    code_2: 'C76-C80',
    code_0: 'C00-D49',
    code_1: 'C00-C97'
  },
  {
    code: 'C77',
    level: 3,
    description:
      'Tumor maligno secundario y el no especificado de los ganglios linf\u00e1ticos',
    code_2: 'C76-C80',
    code_0: 'C00-D49',
    code_1: 'C00-C97'
  },
  {
    code: 'C00-C14',
    level: 3,
    description: 'y de la faringe',
    code_2: 'C00-C75',
    code_0: 'C00-D49',
    code_1: 'C00-C97'
  },
  {
    code: 'C15-C26',
    level: 3,
    description: 'Tumores malignos de los \u00f3rganos digestivos',
    code_2: 'C00-C75',
    code_0: 'C00-D49',
    code_1: 'C00-C97'
  },
  {
    code: 'C30-C39',
    level: 3,
    description: 'e intrator\u00e1cicos',
    code_2: 'C00-C75',
    code_0: 'C00-D49',
    code_1: 'C00-C97'
  },
  {
    code: 'C40-C41',
    level: 3,
    description:
      'Tumores malignos de los huesos y de los cart\u00edlagos articulares',
    code_2: 'C00-C75',
    code_0: 'C00-D49',
    code_1: 'C00-C97'
  },
  {
    code: 'C43-C44',
    level: 3,
    description: 'Melanoma y otros tumores malignos de la piel',
    code_2: 'C00-C75',
    code_0: 'C00-D49',
    code_1: 'C00-C97'
  },
  {
    code: 'D060',
    level: 3,
    description: 'Carcinoma in situ del endoc\u00e9rvix',
    code_2: 'D06',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D061',
    level: 3,
    description: 'Carcinoma in situ del exoc\u00e9rvix',
    code_2: 'D06',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D067',
    level: 3,
    description:
      'Carcinoma in situ de otras partes especificadas del cuello del \u00fatero',
    code_2: 'D06',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D069',
    level: 3,
    description:
      'Carcinoma in situ del cuello del \u00fatero, parte no especificada',
    code_2: 'D06',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D050',
    level: 3,
    description: 'Carcinoma in situ lobular',
    code_2: 'D05',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D051',
    level: 3,
    description: 'Carcinoma in situ intracanalicular',
    code_2: 'D05',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D057',
    level: 3,
    description: 'Otros carcinomas in situ de la mama',
    code_2: 'D05',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D059',
    level: 3,
    description: 'Carcinoma in situ de la mama, parte no especificada',
    code_2: 'D05',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D040',
    level: 3,
    description: 'Carcinoma in situ de la piel del labio',
    code_2: 'D04',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D041',
    level: 3,
    description:
      'Carcinoma in situ de la piel del p\u00e1rpado y de la comisura palpebral',
    code_2: 'D04',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D042',
    level: 3,
    description:
      'Carcinoma in situ de la piel de la oreja y del conducto auditivo externo',
    code_2: 'D04',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D043',
    level: 3,
    description:
      'Carcinoma in situ de la piel de otras partes y de las no especificadas de la cara',
    code_2: 'D04',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D044',
    level: 3,
    description: 'Carcinoma in situ de la piel del cuero cabelludo y cuello',
    code_2: 'D04',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D045',
    level: 3,
    description: 'Carcinoma in situ de la piel del tronco',
    code_2: 'D04',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D030',
    level: 3,
    description: 'Melanoma in situ del labio',
    code_2: 'D03',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D031',
    level: 3,
    description: 'Melanoma in situ del p\u00e1rpado y de la comisura palpebral',
    code_2: 'D03',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D032',
    level: 3,
    description: 'Melanoma in situ de la oreja y del conducto auditivo externo',
    code_2: 'D03',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D033',
    level: 3,
    description:
      'Melanoma in situ de otras partes y de las no especificadas de la cara',
    code_2: 'D03',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D034',
    level: 3,
    description: 'Melanoma in situ del cuero cabelludo y del cuello',
    code_2: 'D03',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D035',
    level: 3,
    description: 'Melanoma in situ del tronco',
    code_2: 'D03',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D036',
    level: 3,
    description: 'Melanoma in situ del miembro superior, incluido el hombro',
    code_2: 'D03',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D037',
    level: 3,
    description: 'Melanoma in situ del miembro inferior, incluida la cadera',
    code_2: 'D03',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D038',
    level: 3,
    description: 'Melanoma in situ de otros sitios',
    code_2: 'D03',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D020',
    level: 3,
    description: 'Carcinoma in situ de la laringe',
    code_2: 'D02',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D021',
    level: 3,
    description: 'Carcinoma in situ de la tr\u00e1quea',
    code_2: 'D02',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D022',
    level: 3,
    description: 'Carcinoma in situ del bronquio y del pulm\u00f3n',
    code_2: 'D02',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D023',
    level: 3,
    description: 'Carcinoma in situ de otras partes del sistema respiratorio',
    code_2: 'D02',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D024',
    level: 3,
    description:
      'Carcinoma in situ de \u00f3rganos respiratorios no especificados',
    code_2: 'D02',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D010',
    level: 3,
    description: 'Carcinoma in situ del colon',
    code_2: 'D01',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D011',
    level: 3,
    description: 'Carcinoma in situ de la uni\u00f3n rectosigmoidea',
    code_2: 'D01',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D012',
    level: 3,
    description: 'Carcinoma in situ del recto',
    code_2: 'D01',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D013',
    level: 3,
    description: 'Carcinoma in situ del ano y del conducto anal',
    code_2: 'D01',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D014',
    level: 3,
    description:
      'Carcinoma in situ de otras partes y de las no especificadas del intestino',
    code_2: 'D01',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D000',
    level: 3,
    description:
      'Carcinoma in situ del labio, de la cavidad bucal y de la faringe',
    code_2: 'D00',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D001',
    level: 3,
    description: 'Carcinoma in situ del es\u00f3fago',
    code_2: 'D00',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D002',
    level: 3,
    description: 'Carcinoma in situ del est\u00f3mago',
    code_2: 'D00',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D120',
    level: 3,
    description: 'Tumor benigno del ciego',
    code_2: 'D12',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D121',
    level: 3,
    description: 'Tumor benigno del ap\u00e9ndice',
    code_2: 'D12',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D122',
    level: 3,
    description: 'Tumor benigno del colon ascendente',
    code_2: 'D12',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D123',
    level: 3,
    description: 'Tumor benigno del colon transverso',
    code_2: 'D12',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D124',
    level: 3,
    description: 'Tumor benigno del colon descendente',
    code_2: 'D12',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D125',
    level: 3,
    description: 'Tumor benigno del colon sigmoide',
    code_2: 'D12',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D126',
    level: 3,
    description: 'Tumor benigno del colon, parte no especificada',
    code_2: 'D12',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D127',
    level: 3,
    description: 'Tumor benigno de la uni\u00f3n rectosigmoidea',
    code_2: 'D12',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D110',
    level: 3,
    description: 'Tumor benigno de la gl\u00e1ndula par\u00f3tida',
    code_2: 'D11',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D117',
    level: 3,
    description:
      'Tumor benigno de otras gl\u00e1ndulas salivales mayores especificadas',
    code_2: 'D11',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D119',
    level: 3,
    description:
      'Tumor benigno de la gl\u00e1ndula salival mayor, sin otra especificaci\u00f3n',
    code_2: 'D11',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D100',
    level: 3,
    description: 'Tumor benigno del labio',
    code_2: 'D10',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D101',
    level: 3,
    description: 'Tumor benigno de la lengua',
    code_2: 'D10',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D102',
    level: 3,
    description: 'Tumor benigno del piso de la boca',
    code_2: 'D10',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D103',
    level: 3,
    description:
      'Tumor benigno de otras partes y de las no especificadas de la boca',
    code_2: 'D10',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D104',
    level: 3,
    description: 'Tumor benigno de la am\u00edgdala',
    code_2: 'D10',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D105',
    level: 3,
    description: 'Tumor benigno de otras partes de la orofaringe',
    code_2: 'D10',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D106',
    level: 3,
    description: 'Tumor benigno de la nasofaringe',
    code_2: 'D10',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D107',
    level: 3,
    description: 'Tumor benigno de la hipofaringe',
    code_2: 'D10',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D109',
    level: 3,
    description: 'Tumor benigno de la faringe, parte no especificada',
    code_2: 'D10',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D420',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido de las meninges cerebrales',
    code_2: 'D42',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D421',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido de las meninges raqu\u00eddeas',
    code_2: 'D42',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D429',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido de las meninges, parte no especificada',
    code_2: 'D42',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D410',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido del ri\u00f1\u00f3n',
    code_2: 'D41',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D411',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido de la pelvis renal',
    code_2: 'D41',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D412',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido del ur\u00e9ter',
    code_2: 'D41',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D413',
    level: 3,
    description: 'Tumor de comportamiento incierto o desconocido de la uretra',
    code_2: 'D41',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D414',
    level: 3,
    description: 'Tumor de comportamiento incierto o desconocido de la vejiga',
    code_2: 'D41',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D417',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido de otros \u00f3rganos urinarios',
    code_2: 'D41',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D419',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido de \u00f3rgano urinario no especificado',
    code_2: 'D41',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D400',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido de la pr\u00f3stata',
    code_2: 'D40',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D401',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido del test\u00edculo',
    code_2: 'D40',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D407',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido de otros \u00f3rganos genitales masculinos',
    code_2: 'D40',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D409',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido de \u00f3rgano genital masculino no especificado',
    code_2: 'D40',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D390',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido del \u00fatero',
    code_2: 'D39',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D391',
    level: 3,
    description: 'Tumor de comportamiento incierto o desconocido del ovario',
    code_2: 'D39',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D392',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido de la placenta',
    code_2: 'D39',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D397',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido de otros \u00f3rganos genitales femeninos',
    code_2: 'D39',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D399',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido de \u00f3rgano genital femenino no especificado',
    code_2: 'D39',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D380',
    level: 3,
    description: 'Tumor de comportamiento incierto o desconocido de laringe',
    code_2: 'D38',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D381',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido de la tr\u00e1quea, de los bronquios y del pulm\u00f3n',
    code_2: 'D38',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D382',
    level: 3,
    description: 'Tumor de comportamiento incierto o desconocido de la pleura',
    code_2: 'D38',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D370',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido del labio, de la cavidad bucal y de la faringe',
    code_2: 'D37',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D371',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido del est\u00f3mago',
    code_2: 'D37',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D372',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido del intestino delgado',
    code_2: 'D37',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D373',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido del ap\u00e9ndice',
    code_2: 'D37',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D374',
    level: 3,
    description: 'Tumor de comportamiento incierto o desconocido del colon',
    code_2: 'D37',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D375',
    level: 3,
    description: 'Tumor de comportamiento incierto o desconocido del recto',
    code_2: 'D37',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D376',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido del h\u00edgado, de la ves\u00edcula biliar y del conducto biliar',
    code_2: 'D37',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D377',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido de otros \u00f3rganos digestivos especificados',
    code_2: 'D37',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'G320',
    level: 3,
    description:
      'Degeneraci\u00f3n combinada subaguda de la m\u00e9dula espinal en enfermedades clasificadas en otra parte',
    code_2: 'G32',
    code_0: 'G00-G99',
    code_1: 'G30-G32'
  },
  {
    code: 'G328',
    level: 3,
    description:
      'Otros trastornos degenerativos especificados del sistema nervioso en enfermedades clasificadas en otra parte',
    code_2: 'G32',
    code_0: 'G00-G99',
    code_1: 'G30-G32'
  },
  {
    code: 'G310',
    level: 3,
    description: 'Atrofia cerebral circunscrita',
    code_2: 'G31',
    code_0: 'G00-G99',
    code_1: 'G30-G32'
  },
  {
    code: 'G311',
    level: 3,
    description:
      'Degeneraci\u00f3n cerebral senil no clasificada en otra parte',
    code_2: 'G31',
    code_0: 'G00-G99',
    code_1: 'G30-G32'
  },
  {
    code: 'G312',
    level: 3,
    description: 'Degeneraci\u00f3n del sistema nervioso debida al alcohol',
    code_2: 'G31',
    code_0: 'G00-G99',
    code_1: 'G30-G32'
  },
  {
    code: 'G318',
    level: 3,
    description:
      'Otras enfermedades degenerativas especificadas del sistema nervioso',
    code_2: 'G31',
    code_0: 'G00-G99',
    code_1: 'G30-G32'
  },
  {
    code: 'G319',
    level: 3,
    description: 'Degeneraci\u00f3n del sistema nervioso, no especificada',
    code_2: 'G31',
    code_0: 'G00-G99',
    code_1: 'G30-G32'
  },
  {
    code: 'G300',
    level: 3,
    description: 'Enfermedad de Alzheimer de comienzo temprano',
    code_2: 'G30',
    code_0: 'G00-G99',
    code_1: 'G30-G32'
  },
  {
    code: 'G301',
    level: 3,
    description: 'Enfermedad de Alzheimer de comienzo tard\u00edo',
    code_2: 'G30',
    code_0: 'G00-G99',
    code_1: 'G30-G32'
  },
  {
    code: 'G308',
    level: 3,
    description: 'Otros tipos de enfermedad de Alzheimer',
    code_2: 'G30',
    code_0: 'G00-G99',
    code_1: 'G30-G32'
  },
  {
    code: 'G309',
    level: 3,
    description: 'Enfermedad de Alzheimer, no especificada',
    code_2: 'G30',
    code_0: 'G00-G99',
    code_1: 'G30-G32'
  },
  {
    code: 'M815',
    level: 4,
    description: 'Osteoporosis idiop\u00e1tica, sin fractura patol\u00f3gica',
    code_3: 'M81',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M816',
    level: 4,
    description:
      'Osteoporosis localizada [Lequesne], sin fractura patol\u00f3gica',
    code_3: 'M81',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M818',
    level: 4,
    description: 'Otras osteoporosis, sin fractura patol\u00f3gica',
    code_3: 'M81',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'M819',
    level: 4,
    description: 'Osteoporosis no especificada, sin fractura patol\u00f3gica',
    code_3: 'M81',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'G370',
    level: 3,
    description: 'Esclerosis difusa',
    code_2: 'G37',
    code_0: 'G00-G99',
    code_1: 'G35-G37'
  },
  {
    code: 'G371',
    level: 3,
    description: 'Desmielinizaci\u00f3n central del cuerpo calloso',
    code_2: 'G37',
    code_0: 'G00-G99',
    code_1: 'G35-G37'
  },
  {
    code: 'G372',
    level: 3,
    description: 'Mielin\u00f3lisis central pontina',
    code_2: 'G37',
    code_0: 'G00-G99',
    code_1: 'G35-G37'
  },
  {
    code: 'G373',
    level: 3,
    description:
      'Mielitis transversa aguda en enfermedad desmielinizante del sistema nervioso central',
    code_2: 'G37',
    code_0: 'G00-G99',
    code_1: 'G35-G37'
  },
  {
    code: 'G374',
    level: 3,
    description: 'Mielitis necrotizante subaguda',
    code_2: 'G37',
    code_0: 'G00-G99',
    code_1: 'G35-G37'
  },
  {
    code: 'G375',
    level: 3,
    description: 'Esclerosis conc\u00e9ntrica [Bal\u00f3]',
    code_2: 'G37',
    code_0: 'G00-G99',
    code_1: 'G35-G37'
  },
  {
    code: 'G378',
    level: 3,
    description:
      'Otras enfermedades desmielinizantes del sistema nervioso central, especificadas',
    code_2: 'G37',
    code_0: 'G00-G99',
    code_1: 'G35-G37'
  },
  {
    code: 'G379',
    level: 3,
    description:
      'Enfermedad desmielinizante del sistema nervioso central, no especificada',
    code_2: 'G37',
    code_0: 'G00-G99',
    code_1: 'G35-G37'
  },
  {
    code: 'M896',
    level: 4,
    description: 'Osteopat\u00eda a consecuencia de poliomielitis',
    code_3: 'M89',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M86-M90'
  },
  {
    code: 'M898',
    level: 4,
    description: 'Otros trastornos especificados del hueso',
    code_3: 'M89',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M86-M90'
  },
  {
    code: 'M899',
    level: 4,
    description: 'Trastorno del hueso, no especificado',
    code_3: 'M89',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M86-M90'
  },
  {
    code: 'M879',
    level: 4,
    description: 'Osteonecrosis, no especificada',
    code_3: 'M87',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M86-M90'
  },
  {
    code: 'G360',
    level: 3,
    description: 'Neuromielitis \u00f3ptica [Devic]',
    code_2: 'G36',
    code_0: 'G00-G99',
    code_1: 'G35-G37'
  },
  {
    code: 'G361',
    level: 3,
    description: 'Leucoencefalitis hemorr\u00e1gica aguda y subaguda [Hurst]',
    code_2: 'G36',
    code_0: 'G00-G99',
    code_1: 'G35-G37'
  },
  {
    code: 'G368',
    level: 3,
    description: 'Otras desmielinizaciones agudas diseminadas especificadas',
    code_2: 'G36',
    code_0: 'G00-G99',
    code_1: 'G35-G37'
  },
  {
    code: 'G369',
    level: 3,
    description:
      'Desmielinizaci\u00f3n diseminada aguda, sin otra especificaci\u00f3n',
    code_2: 'G36',
    code_0: 'G00-G99',
    code_1: 'G35-G37'
  },
  {
    code: 'M864',
    level: 4,
    description: 'Osteomielitis cr\u00f3nica con drenaje del seno',
    code_3: 'M86',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M86-M90'
  },
  {
    code: 'M865',
    level: 4,
    description: 'Otras osteomielitis hemat\u00f3genas cr\u00f3nicas',
    code_3: 'M86',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M86-M90'
  },
  {
    code: 'M866',
    level: 4,
    description: 'Otras osteomielitis cr\u00f3nicas',
    code_3: 'M86',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M86-M90'
  },
  {
    code: 'M868',
    level: 4,
    description: 'Otras osteomielitis',
    code_3: 'M86',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M86-M90'
  },
  {
    code: 'M869',
    level: 4,
    description: 'Osteomielitis, no especificada',
    code_3: 'M86',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M86-M90'
  },
  {
    code: 'M626',
    level: 4,
    description: 'Distensi\u00f3n muscular',
    code_3: 'M62',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M60-M63'
  },
  {
    code: 'M628',
    level: 4,
    description: 'Otros trastornos especificados de los m\u00fasculos',
    code_3: 'M62',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M60-M63'
  },
  {
    code: 'M629',
    level: 4,
    description: 'Trastorno muscular, no especificado',
    code_3: 'M62',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M60-M63'
  },
  {
    code: 'M609',
    level: 4,
    description: 'Miositis, no especificada',
    code_3: 'M60',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M60-M63'
  },
  {
    code: 'H220',
    level: 3,
    description:
      'Iridociclitis en enfermedades infecciosas y parasitarias clasificadas en otra parte',
    code_2: 'H22',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H221',
    level: 3,
    description:
      'Iridociclitis en otras enfermedades clasificadas en otra parte',
    code_2: 'H22',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H228',
    level: 3,
    description:
      'Otros trastornos del iris y del cuerpo ciliar en enfermedades clasificadas en otra parte',
    code_2: 'H22',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H750',
    level: 3,
    description:
      'Mastoiditis en enfermedades infecciosas y parasitarias clasificadas en otra parte',
    code_2: 'H75',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'H758',
    level: 3,
    description:
      'Otros trastornos especificados del o\u00eddo medio y de la ap\u00f3fisis mastoides en enfermedades clasificadas en otra parte',
    code_2: 'H75',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'H740',
    level: 3,
    description: 'Timpanosclerosis',
    code_2: 'H74',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'H741',
    level: 3,
    description: 'Enfermedad adhesiva del o\u00eddo medio',
    code_2: 'H74',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'H742',
    level: 3,
    description:
      'Discontinuidad y dislocaci\u00f3n de los huesecillos del o\u00eddo',
    code_2: 'H74',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'H743',
    level: 3,
    description:
      'Otras anormalidades adquiridas de los huesecillos del o\u00eddo',
    code_2: 'H74',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'H744',
    level: 3,
    description: 'P\u00f3lipo del o\u00eddo medio',
    code_2: 'H74',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'H748',
    level: 3,
    description:
      'Otros trastornos especificados del o\u00eddo medio y de la ap\u00f3fisis mastoides',
    code_2: 'H74',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'H749',
    level: 3,
    description:
      'Trastorno del o\u00eddo medio y de la ap\u00f3fisis mastoides, no especificado',
    code_2: 'H74',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'H730',
    level: 3,
    description: 'Miringitis aguda',
    code_2: 'H73',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'H731',
    level: 3,
    description: 'Miringitis cr\u00f3nica',
    code_2: 'H73',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'H738',
    level: 3,
    description: 'Otros trastornos especificados de la membrana timp\u00e1nica',
    code_2: 'H73',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'H739',
    level: 3,
    description: 'Trastorno de la membrana timp\u00e1nica, no especificado',
    code_2: 'H73',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'M489',
    level: 4,
    description: 'Espondilopat\u00eda, no especificada',
    code_3: 'M48',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M45-M49'
  },
  {
    code: 'H720',
    level: 3,
    description: 'Perforaci\u00f3n central de la membrana timp\u00e1nica',
    code_2: 'H72',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'H721',
    level: 3,
    description: 'Perforaci\u00f3n \u00e1tica de la membrana timp\u00e1nica',
    code_2: 'H72',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'H722',
    level: 3,
    description: 'Otras perforaciones marginales de la membrana timp\u00e1nica',
    code_2: 'H72',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'H728',
    level: 3,
    description: 'Otras perforaciones de la membrana timp\u00e1nica',
    code_2: 'H72',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'H729',
    level: 3,
    description:
      'Perforaci\u00f3n de la membrana timp\u00e1nica, sin otra especificaci\u00f3n',
    code_2: 'H72',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'M518',
    level: 4,
    description:
      'Otros trastornos especificados de los discos intervertebrales',
    code_3: 'M51',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M50-M54'
  },
  {
    code: 'M519',
    level: 4,
    description: 'Trastorno de los discos intervertebrales, no especificado',
    code_3: 'M51',
    code_0: 'M00-M99',
    code_1: 'M40-M54',
    code_2: 'M50-M54'
  },
  {
    code: 'H700',
    level: 3,
    description: 'Mastoiditis aguda',
    code_2: 'H70',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'H701',
    level: 3,
    description: 'Mastoiditis cr\u00f3nica',
    code_2: 'H70',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'H702',
    level: 3,
    description: 'Petrositis',
    code_2: 'H70',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'H708',
    level: 3,
    description: 'Otras mastoiditis y afecciones relacionadas',
    code_2: 'H70',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'H709',
    level: 3,
    description: 'Mastoiditis, no especificada',
    code_2: 'H70',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'H690',
    level: 3,
    description: 'Distensi\u00f3n de la trompa de Eustaquio',
    code_2: 'H69',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'H698',
    level: 3,
    description: 'Otros trastornos especificados de la trompa de Eustaquio',
    code_2: 'H69',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'H699',
    level: 3,
    description: 'Trastorno de la trompa de Eustaquio, no especificado',
    code_2: 'H69',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'H680',
    level: 3,
    description: 'Salpingitis eustaquiana',
    code_2: 'H68',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'H681',
    level: 3,
    description: 'Obstrucci\u00f3n de la trompa de Eustaquio',
    code_2: 'H68',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'H670',
    level: 3,
    description:
      'Otitis media en enfermedades bacterianas clasificadas en otra parte',
    code_2: 'H67',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'H671',
    level: 3,
    description:
      'Otitis media en enfermedades virales clasificadas en otra parte',
    code_2: 'H67',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'H678',
    level: 3,
    description:
      'Otitis media en otras enfermedades clasificadas en otra parte',
    code_2: 'H67',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'G410',
    level: 3,
    description: 'Estado de gran mal epil\u00e9ptico',
    code_2: 'G41',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G411',
    level: 3,
    description: 'Estado de peque\u00f1o mal epil\u00e9ptico',
    code_2: 'G41',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G412',
    level: 3,
    description: 'Estado de mal epil\u00e9ptico parcial complejo',
    code_2: 'G41',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G418',
    level: 3,
    description: 'Otros estados epil\u00e9pticos',
    code_2: 'G41',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G419',
    level: 3,
    description: 'Estado de mal epil\u00e9ptico de tipo no especificado',
    code_2: 'G41',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G400',
    level: 3,
    description:
      'Epilepsia y s\u00edndromes epil\u00e9pticos idiop\u00e1ticos relacionados con localizaciones (focales) (parciales) y con ataques de inicio localizado',
    code_2: 'G40',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G401',
    level: 3,
    description:
      'Epilepsia y s\u00edndromes epil\u00e9pticos sintom\u00e1ticos relacionados con localizaciones (focales) (parciales) y con ataques parciales simples',
    code_2: 'G40',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G402',
    level: 3,
    description:
      'Epilepsia y s\u00edndromes epil\u00e9pticos sintom\u00e1ticos relacionados con localizaciones (focales) (parciales) y con ataques parciales complejos',
    code_2: 'G40',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G403',
    level: 3,
    description:
      'Epilepsia y s\u00edndromes epil\u00e9pticos idiop\u00e1ticos generalizados',
    code_2: 'G40',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G404',
    level: 3,
    description:
      'Otras epilepsias y s\u00edndromes epil\u00e9pticos generalizados',
    code_2: 'G40',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G405',
    level: 3,
    description: 'S\u00edndromes epil\u00e9pticos especiales',
    code_2: 'G40',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G406',
    level: 3,
    description:
      'Ataques de gran mal, no especificados (con o sin peque\u00f1o mal)',
    code_2: 'G40',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G407',
    level: 3,
    description: 'Peque\u00f1o mal, no especificado (sin ataque de gran mal)',
    code_2: 'G40',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G408',
    level: 3,
    description: 'Otras epilepsias',
    code_2: 'G40',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G409',
    level: 3,
    description: 'Epilepsia, tipo no especificado',
    code_2: 'G40',
    code_0: 'G00-G99',
    code_1: 'G40-G47'
  },
  {
    code: 'G520',
    level: 3,
    description: 'Trastornos del nervio olfatorio',
    code_2: 'G52',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G521',
    level: 3,
    description: 'Trastornos del nervio glosofar\u00edngeo',
    code_2: 'G52',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G522',
    level: 3,
    description: 'Trastornos del nervio vago',
    code_2: 'G52',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G523',
    level: 3,
    description: 'Trastornos del nervio hipogloso',
    code_2: 'G52',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G527',
    level: 3,
    description: 'Trastornos de m\u00faltiples nervios craneales',
    code_2: 'G52',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G528',
    level: 3,
    description: 'Trastornos de otros nervios craneales especificados',
    code_2: 'G52',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G529',
    level: 3,
    description: 'Trastorno de nervio craneal, no especificado',
    code_2: 'G52',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G510',
    level: 3,
    description: 'Par\u00e1lisis de Bell',
    code_2: 'G51',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G511',
    level: 3,
    description: 'Ganglionitis geniculada',
    code_2: 'G51',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G512',
    level: 3,
    description: 'S\u00edndrome de Melkersson',
    code_2: 'G51',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G513',
    level: 3,
    description: 'Espasmo hemifacial cl\u00f3nico',
    code_2: 'G51',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G514',
    level: 3,
    description: 'Mioquimia facial',
    code_2: 'G51',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G518',
    level: 3,
    description: 'Otros trastornos del nervio facial',
    code_2: 'G51',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G500',
    level: 3,
    description: 'Neuralgia del trig\u00e9mino',
    code_2: 'G50',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G501',
    level: 3,
    description: 'Dolor facial at\u00edpico',
    code_2: 'G50',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G508',
    level: 3,
    description: 'Otros trastornos del trig\u00e9mino',
    code_2: 'G50',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G509',
    level: 3,
    description: 'Trastorno del trig\u00e9mino, no especificado',
    code_2: 'G50',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'G630',
    level: 3,
    description:
      'Polineuropat\u00eda en enfermedades infecciosas y parasitarias clasificadas en otra parte',
    code_2: 'G63',
    code_0: 'G00-G99',
    code_1: 'G60-G64'
  },
  {
    code: 'G631',
    level: 3,
    description:
      'Polineuropat\u00eda en enfermedad neopl\u00e1sica (C00\u2013D48)',
    code_2: 'G63',
    code_0: 'G00-G99',
    code_1: 'G60-G64'
  },
  {
    code: 'G632',
    level: 3,
    description:
      'Polineuropat\u00eda diab\u00e9tica (E10\u2013E14 con cuarto car\u00e1cter com\u00fan .4)',
    code_2: 'G63',
    code_0: 'G00-G99',
    code_1: 'G60-G64'
  },
  {
    code: 'G633',
    level: 3,
    description:
      'Polineuropat\u00eda en otras enfermedades endocrinas y metab\u00f3licas (E00\u2013E07, E15\u2013E16, E20\u2013E34, E70\u2013E89)',
    code_2: 'G63',
    code_0: 'G00-G99',
    code_1: 'G60-G64'
  },
  {
    code: 'G634',
    level: 3,
    description:
      'Polineuropat\u00eda en deficiencia nutricional (E40\u2013E64)',
    code_2: 'G63',
    code_0: 'G00-G99',
    code_1: 'G60-G64'
  },
  {
    code: 'G635',
    level: 3,
    description:
      'Polineuropat\u00eda en trastornos del tejido conectivo sist\u00e9mico (M30\u2013M35)',
    code_2: 'G63',
    code_0: 'G00-G99',
    code_1: 'G60-G64'
  },
  {
    code: 'G636',
    level: 3,
    description:
      'Polineuropat\u00eda en otros trastornos osteomusculares (M00\u2013M25, M40\u2013M96)',
    code_2: 'G63',
    code_0: 'G00-G99',
    code_1: 'G60-G64'
  },
  {
    code: 'G638',
    level: 3,
    description:
      'Polineuropat\u00eda en otras enfermedades clasificadas en otra parte',
    code_2: 'G63',
    code_0: 'G00-G99',
    code_1: 'G60-G64'
  },
  {
    code: 'G620',
    level: 3,
    description: 'Polineuropat\u00eda inducida por drogas',
    code_2: 'G62',
    code_0: 'G00-G99',
    code_1: 'G60-G64'
  },
  {
    code: 'G621',
    level: 3,
    description: 'Polineuropat\u00eda alcoh\u00f3lica',
    code_2: 'G62',
    code_0: 'G00-G99',
    code_1: 'G60-G64'
  },
  {
    code: 'G622',
    level: 3,
    description: 'Polineuropat\u00eda debida a otro agente t\u00f3xico',
    code_2: 'G62',
    code_0: 'G00-G99',
    code_1: 'G60-G64'
  },
  {
    code: 'G628',
    level: 3,
    description: 'Otras polineuropat\u00edas especificadas',
    code_2: 'G62',
    code_0: 'G00-G99',
    code_1: 'G60-G64'
  },
  {
    code: 'G629',
    level: 3,
    description: 'Polineuropat\u00eda, no especificada',
    code_2: 'G62',
    code_0: 'G00-G99',
    code_1: 'G60-G64'
  },
  {
    code: 'G610',
    level: 3,
    description: 'S\u00edndrome de Guillain\u2013Barr\u00e9',
    code_2: 'G61',
    code_0: 'G00-G99',
    code_1: 'G60-G64'
  },
  {
    code: 'G611',
    level: 3,
    description: 'Neuropat\u00eda al suero',
    code_2: 'G61',
    code_0: 'G00-G99',
    code_1: 'G60-G64'
  },
  {
    code: 'G618',
    level: 3,
    description: 'Otras polineuropat\u00edas inflamatorias',
    code_2: 'G61',
    code_0: 'G00-G99',
    code_1: 'G60-G64'
  },
  {
    code: 'G619',
    level: 3,
    description: 'Polineuropat\u00eda inflamatoria, no especificada',
    code_2: 'G61',
    code_0: 'G00-G99',
    code_1: 'G60-G64'
  },
  {
    code: 'G600',
    level: 3,
    description: 'Neuropat\u00eda hereditaria motora y sensorial',
    code_2: 'G60',
    code_0: 'G00-G99',
    code_1: 'G60-G64'
  },
  {
    code: 'G601',
    level: 3,
    description: 'Enfermedad de Refsum',
    code_2: 'G60',
    code_0: 'G00-G99',
    code_1: 'G60-G64'
  },
  {
    code: 'G602',
    level: 3,
    description: 'Neuropat\u00eda asociada con ataxia hereditaria',
    code_2: 'G60',
    code_0: 'G00-G99',
    code_1: 'G60-G64'
  },
  {
    code: 'G603',
    level: 3,
    description: 'Neuropat\u00eda progresiva idiop\u00e1tica',
    code_2: 'G60',
    code_0: 'G00-G99',
    code_1: 'G60-G64'
  },
  {
    code: 'G608',
    level: 3,
    description: 'Otras neuropat\u00edas hereditarias e idiop\u00e1ticas',
    code_2: 'G60',
    code_0: 'G00-G99',
    code_1: 'G60-G64'
  },
  {
    code: 'G609',
    level: 3,
    description:
      'Neuropat\u00eda hereditaria e idiop\u00e1tica, sin otra especificaci\u00f3n',
    code_2: 'G60',
    code_0: 'G00-G99',
    code_1: 'G60-G64'
  },
  {
    code: 'G720',
    level: 3,
    description: 'Miopat\u00eda inducida por drogas',
    code_2: 'G72',
    code_0: 'G00-G99',
    code_1: 'G70-G73'
  },
  {
    code: 'G721',
    level: 3,
    description: 'Miopat\u00eda alcoh\u00f3lica',
    code_2: 'G72',
    code_0: 'G00-G99',
    code_1: 'G70-G73'
  },
  {
    code: 'G722',
    level: 3,
    description: 'Miopat\u00eda debida a otros agentes t\u00f3xicos',
    code_2: 'G72',
    code_0: 'G00-G99',
    code_1: 'G70-G73'
  },
  {
    code: 'G723',
    level: 3,
    description: 'Par\u00e1lisis peri\u00f3dica',
    code_2: 'G72',
    code_0: 'G00-G99',
    code_1: 'G70-G73'
  },
  {
    code: 'G724',
    level: 3,
    description: 'Miopat\u00eda inflamatoria, no clasificada en otra parte',
    code_2: 'G72',
    code_0: 'G00-G99',
    code_1: 'G70-G73'
  },
  {
    code: 'G728',
    level: 3,
    description: 'Otras miopat\u00edas especificadas',
    code_2: 'G72',
    code_0: 'G00-G99',
    code_1: 'G70-G73'
  },
  {
    code: 'G729',
    level: 3,
    description: 'Miopat\u00eda, no especificada',
    code_2: 'G72',
    code_0: 'G00-G99',
    code_1: 'G70-G73'
  },
  {
    code: 'M256',
    level: 4,
    description: 'Rigidez articular, no clasificada en otra parte',
    code_3: 'M25',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M257',
    level: 4,
    description: 'Osteofito',
    code_3: 'M25',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M258',
    level: 4,
    description: 'Otros trastornos articulares especificados',
    code_3: 'M25',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M259',
    level: 4,
    description: 'Trastorno articular, no especificado',
    code_3: 'M25',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M248',
    level: 4,
    description:
      'Otras lesiones articulares espec\u00edficas, no clasificadas en otra parte',
    code_3: 'M24',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M249',
    level: 4,
    description: 'Desarreglo articular, no especificado',
    code_3: 'M24',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M239',
    level: 4,
    description: 'Trastorno interno de la rodilla, no especificado',
    code_3: 'M23',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M204',
    level: 4,
    description: 'Otro(s) dedo(s) del pie en martillo (adquiridos)',
    code_3: 'M20',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M205',
    level: 4,
    description: 'Otras deformidades (adquiridas) del (de los) dedo(s) del pie',
    code_3: 'M20',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'M206',
    level: 4,
    description:
      'Deformidades adquiridas de los dedos del pie, no especificadas',
    code_3: 'M20',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M20-M25'
  },
  {
    code: 'E212',
    level: 3,
    description: 'Otros tipos de hiperparatiroidismo',
    code_2: 'E21',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E213',
    level: 3,
    description: 'Hiperparatiroidismo, sin otra especificaci\u00f3n',
    code_2: 'E21',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E214',
    level: 3,
    description:
      'Otros trastornos especificados de la gl\u00e1ndula paratiroides',
    code_2: 'E21',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'E215',
    level: 3,
    description: 'Trastorno de la gl\u00e1ndula paratiroides, no especificado',
    code_2: 'E21',
    code_0: 'E00-E89',
    code_1: 'E20-E35'
  },
  {
    code: 'D539',
    level: 3,
    description: 'Anemia nutricional, no especificada',
    code_2: 'D53',
    code_0: 'D50-D89',
    code_1: 'D50-D53'
  },
  {
    code: 'D519',
    level: 3,
    description:
      'Anemia por deficiencia de vitamina B12, sin otra especificaci\u00f3n',
    code_2: 'D51',
    code_0: 'D50-D89',
    code_1: 'D50-D53'
  },
  {
    code: 'D509',
    level: 3,
    description:
      'Anemia por deficiencia de hierro sin otra especificaci\u00f3n',
    code_2: 'D50',
    code_0: 'D50-D89',
    code_1: 'D50-D53'
  },
  {
    code: 'D594',
    level: 3,
    description: 'Otras anemias hemol\u00edticas no autoinmunes',
    code_2: 'D59',
    code_0: 'D50-D89',
    code_1: 'D55-D59'
  },
  {
    code: 'D595',
    level: 3,
    description:
      'Hemoglobinuria parox\u00edstica nocturna [Marchiafava\u2013Micheli]',
    code_2: 'D59',
    code_0: 'D50-D89',
    code_1: 'D55-D59'
  },
  {
    code: 'D596',
    level: 3,
    description:
      'Hemoglobinuria debida a hem\u00f3lisis por otras causas externas',
    code_2: 'D59',
    code_0: 'D50-D89',
    code_1: 'D55-D59'
  },
  {
    code: 'D598',
    level: 3,
    description: 'Otras anemias hemol\u00edticas adquiridas',
    code_2: 'D59',
    code_0: 'D50-D89',
    code_1: 'D55-D59'
  },
  {
    code: 'D599',
    level: 3,
    description:
      'Anemia hemol\u00edtica adquirida, sin otra especificaci\u00f3n',
    code_2: 'D59',
    code_0: 'D50-D89',
    code_1: 'D55-D59'
  },
  {
    code: 'D569',
    level: 3,
    description: 'Talasemia, no especificada',
    code_2: 'D56',
    code_0: 'D50-D89',
    code_1: 'D55-D59'
  },
  {
    code: 'G710',
    level: 3,
    description: 'Distrofia muscular',
    code_2: 'G71',
    code_0: 'G00-G99',
    code_1: 'G70-G73'
  },
  {
    code: 'G711',
    level: 3,
    description: 'Trastornos miot\u00f3nicos',
    code_2: 'G71',
    code_0: 'G00-G99',
    code_1: 'G70-G73'
  },
  {
    code: 'G712',
    level: 3,
    description: 'Miopat\u00edas cong\u00e9nitas',
    code_2: 'G71',
    code_0: 'G00-G99',
    code_1: 'G70-G73'
  },
  {
    code: 'G713',
    level: 3,
    description:
      'Miopat\u00eda mitoc\u00f3ndrica, no clasificada en otra parte',
    code_2: 'G71',
    code_0: 'G00-G99',
    code_1: 'G70-G73'
  },
  {
    code: 'G718',
    level: 3,
    description: 'Otros trastornos primarios de los m\u00fasculos',
    code_2: 'G71',
    code_0: 'G00-G99',
    code_1: 'G70-G73'
  },
  {
    code: 'G700',
    level: 3,
    description: 'Miastenia gravis',
    code_2: 'G70',
    code_0: 'G00-G99',
    code_1: 'G70-G73'
  },
  {
    code: 'G701',
    level: 3,
    description: 'Trastornos t\u00f3xicos neuromusculares',
    code_2: 'G70',
    code_0: 'G00-G99',
    code_1: 'G70-G73'
  },
  {
    code: 'G702',
    level: 3,
    description: 'Miastenia cong\u00e9nita o del desarrollo',
    code_2: 'G70',
    code_0: 'G00-G99',
    code_1: 'G70-G73'
  },
  {
    code: 'G708',
    level: 3,
    description: 'Otros trastornos neuromusculares especificados',
    code_2: 'G70',
    code_0: 'G00-G99',
    code_1: 'G70-G73'
  },
  {
    code: 'G709',
    level: 3,
    description: 'Trastorno neuromuscular, no especificado',
    code_2: 'G70',
    code_0: 'G00-G99',
    code_1: 'G70-G73'
  },
  {
    code: 'G830',
    level: 3,
    description: 'Diplej\u00eda de los miembros superiores',
    code_2: 'G83',
    code_0: 'G00-G99',
    code_1: 'G80-G83'
  },
  {
    code: 'G831',
    level: 3,
    description: 'Monoplej\u00eda de miembro inferior',
    code_2: 'G83',
    code_0: 'G00-G99',
    code_1: 'G80-G83'
  },
  {
    code: 'G832',
    level: 3,
    description: 'Monoplej\u00eda de miembro superior',
    code_2: 'G83',
    code_0: 'G00-G99',
    code_1: 'G80-G83'
  },
  {
    code: 'G833',
    level: 3,
    description: 'Monoplej\u00eda, no especificada',
    code_2: 'G83',
    code_0: 'G00-G99',
    code_1: 'G80-G83'
  },
  {
    code: 'G834',
    level: 3,
    description: 'S\u00edndrome de la cola de caballo',
    code_2: 'G83',
    code_0: 'G00-G99',
    code_1: 'G80-G83'
  },
  {
    code: 'G838',
    level: 3,
    description: 'Otros s\u00edndromes paral\u00edticos especificados',
    code_2: 'G83',
    code_0: 'G00-G99',
    code_1: 'G80-G83'
  },
  {
    code: 'G839',
    level: 3,
    description: 'S\u00edndrome paral\u00edtico, no especificado',
    code_2: 'G83',
    code_0: 'G00-G99',
    code_1: 'G80-G83'
  },
  {
    code: 'G820',
    level: 3,
    description: 'Paraplej\u00eda fl\u00e1cida',
    code_2: 'G82',
    code_0: 'G00-G99',
    code_1: 'G80-G83'
  },
  {
    code: 'G821',
    level: 3,
    description: 'Paraplej\u00eda esp\u00e1stica',
    code_2: 'G82',
    code_0: 'G00-G99',
    code_1: 'G80-G83'
  },
  {
    code: 'G822',
    level: 3,
    description: 'Paraplej\u00eda, no especificada',
    code_2: 'G82',
    code_0: 'G00-G99',
    code_1: 'G80-G83'
  },
  {
    code: 'G823',
    level: 3,
    description: 'Cuadriplej\u00eda fl\u00e1cida',
    code_2: 'G82',
    code_0: 'G00-G99',
    code_1: 'G80-G83'
  },
  {
    code: 'G824',
    level: 3,
    description: 'Cuadriplej\u00eda esp\u00e1stica',
    code_2: 'G82',
    code_0: 'G00-G99',
    code_1: 'G80-G83'
  },
  {
    code: 'G825',
    level: 3,
    description: 'Cuadriplej\u00eda, no especificada',
    code_2: 'G82',
    code_0: 'G00-G99',
    code_1: 'G80-G83'
  },
  {
    code: 'G810',
    level: 3,
    description: 'Hemiplej\u00eda fl\u00e1cida',
    code_2: 'G81',
    code_0: 'G00-G99',
    code_1: 'G80-G83'
  },
  {
    code: 'G811',
    level: 3,
    description: 'Hemiplej\u00eda esp\u00e1stica',
    code_2: 'G81',
    code_0: 'G00-G99',
    code_1: 'G80-G83'
  },
  {
    code: 'G819',
    level: 3,
    description: 'Hemiplej\u00eda, no especificada',
    code_2: 'G81',
    code_0: 'G00-G99',
    code_1: 'G80-G83'
  },
  {
    code: 'G800',
    level: 3,
    description: 'Par\u00e1lisis cerebral esp\u00e1stica cuadripl\u00e9jica',
    code_2: 'G80',
    code_0: 'G00-G99',
    code_1: 'G80-G83'
  },
  {
    code: 'G801',
    level: 3,
    description: 'Par\u00e1lisis cerebral esp\u00e1stica dipl\u00e9jica',
    code_2: 'G80',
    code_0: 'G00-G99',
    code_1: 'G80-G83'
  },
  {
    code: 'G802',
    level: 3,
    description: 'Par\u00e1lisis cerebral esp\u00e1stica hemipl\u00e9jica',
    code_2: 'G80',
    code_0: 'G00-G99',
    code_1: 'G80-G83'
  },
  {
    code: 'G803',
    level: 3,
    description: 'Par\u00e1lisis cerebral discin\u00e9tica',
    code_2: 'G80',
    code_0: 'G00-G99',
    code_1: 'G80-G83'
  },
  {
    code: 'G804',
    level: 3,
    description: 'Par\u00e1lisis cerebral at\u00e1xica',
    code_2: 'G80',
    code_0: 'G00-G99',
    code_1: 'G80-G83'
  },
  {
    code: 'G808',
    level: 3,
    description: 'Otros tipos de par\u00e1lisis cerebral',
    code_2: 'G80',
    code_0: 'G00-G99',
    code_1: 'G80-G83'
  },
  {
    code: 'G809',
    level: 3,
    description: 'Par\u00e1lisis cerebral, sin otra especificaci\u00f3n',
    code_2: 'G80',
    code_0: 'G00-G99',
    code_1: 'G80-G83'
  },
  {
    code: 'G960',
    level: 3,
    description: 'P\u00e9rdida de l\u00edquido cefalorraqu\u00eddeo',
    code_2: 'G96',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G961',
    level: 3,
    description: 'Trastornos de las meninges, no clasificados en otra parte',
    code_2: 'G96',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G968',
    level: 3,
    description: 'Otros trastornos especificados del sistema nervioso central',
    code_2: 'G96',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G969',
    level: 3,
    description: 'Trastorno del sistema nervioso central, no especificado',
    code_2: 'G96',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G950',
    level: 3,
    description: 'Siringomielia y siringobulbia',
    code_2: 'G95',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G951',
    level: 3,
    description: 'Mielopat\u00edas vasculares',
    code_2: 'G95',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G952',
    level: 3,
    description: 'Compresi\u00f3n medular, no especificada',
    code_2: 'G95',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G958',
    level: 3,
    description: 'Otras enfermedades especificadas de la m\u00e9dula espinal',
    code_2: 'G95',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G959',
    level: 3,
    description: 'Enfermedad de la m\u00e9dula espinal, no especificada',
    code_2: 'G95',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G940',
    level: 3,
    description:
      'Hidroc\u00e9falo en enfermedades infecciosas y parasitarias clasificadas en otra parte (A00\u2013B99)',
    code_2: 'G94',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G930',
    level: 3,
    description: 'Quiste cerebral',
    code_2: 'G93',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G910',
    level: 3,
    description: 'Hidroc\u00e9falo comunicante',
    code_2: 'G91',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G911',
    level: 3,
    description: 'Hidroc\u00e9falo obstructivo',
    code_2: 'G91',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G912',
    level: 3,
    description: 'Hidroc\u00e9falo de presi\u00f3n normal',
    code_2: 'G91',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G913',
    level: 3,
    description:
      'Hidroc\u00e9falo postraum\u00e1tico, sin otra especificaci\u00f3n',
    code_2: 'G91',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G900',
    level: 3,
    description:
      'Neuropat\u00eda aut\u00f3noma perif\u00e9rica idiop\u00e1tica',
    code_2: 'G90',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G901',
    level: 3,
    description: 'Disautonom\u00eda familiar [S\u00edndrome de Riley\u2013Day]',
    code_2: 'G90',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G902',
    level: 3,
    description: 'S\u00edndrome de Horner',
    code_2: 'G90',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G903',
    level: 3,
    description: 'Degeneraci\u00f3n de sistemas m\u00faltiples',
    code_2: 'G90',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G904',
    level: 3,
    description: 'Disreflexia auton\u00f3mica',
    code_2: 'G90',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'A060',
    level: 3,
    description: 'Disenter\u00eda amebiana aguda',
    code_2: 'A06',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A061',
    level: 3,
    description: 'Amebiasis intestinal cr\u00f3nica',
    code_2: 'A06',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A062',
    level: 3,
    description: 'Colitis amebiana no disent\u00e9rica',
    code_2: 'A06',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A063',
    level: 3,
    description: 'Ameboma intestinal',
    code_2: 'A06',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A064',
    level: 3,
    description: 'Absceso amebiano del h\u00edgado',
    code_2: 'A06',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A065',
    level: 3,
    description: 'Absceso amebiano del pulm\u00f3n (J99.8)',
    code_2: 'A06',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A050',
    level: 3,
    description: 'Intoxicaci\u00f3n alimentaria estafiloc\u00f3cica',
    code_2: 'A05',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A051',
    level: 3,
    description: 'Botulismo',
    code_2: 'A05',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A052',
    level: 3,
    description:
      'Intoxicaci\u00f3n alimentaria debida a Clostridium perfringens [Clostridium welchii]',
    code_2: 'A05',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A053',
    level: 3,
    description:
      'Intoxicaci\u00f3n alimentaria debida a Vibrio parahaemolyticus',
    code_2: 'A05',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A054',
    level: 3,
    description: 'Intoxicaci\u00f3n alimentaria debida a Bacillus cereus',
    code_2: 'A05',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A040',
    level: 3,
    description: 'Infecci\u00f3n debida a Escherichia coli enteropat\u00f3gena',
    code_2: 'A04',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A041',
    level: 3,
    description: 'Infecci\u00f3n debida a Escherichia coli enterotox\u00edgena',
    code_2: 'A04',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A042',
    level: 3,
    description: 'Infecci\u00f3n debida a Escherichia coli enteroinvasiva',
    code_2: 'A04',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A043',
    level: 3,
    description:
      'Infecci\u00f3n debida a Escherichia coli enterohemorr\u00e1gica',
    code_2: 'A04',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A044',
    level: 3,
    description: 'Otras infecciones intestinales debidas a Escherichia coli',
    code_2: 'A04',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A030',
    level: 3,
    description: 'Shigelosis debida a Shigella dysenteriae',
    code_2: 'A03',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A031',
    level: 3,
    description: 'Shigelosis debida a Shigella flexneri',
    code_2: 'A03',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A032',
    level: 3,
    description: 'Shigelosis debida a Shigella boydii',
    code_2: 'A03',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A033',
    level: 3,
    description: 'Shigelosis debida a Shigella sonnei',
    code_2: 'A03',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A038',
    level: 3,
    description: 'Otras shigelosis',
    code_2: 'A03',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A020',
    level: 3,
    description: 'Enteritis debida a Salmonella',
    code_2: 'A02',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A021',
    level: 3,
    description: 'Septicemia debida a Salmonella',
    code_2: 'A02',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A022',
    level: 3,
    description: 'Infecciones localizadas debidas a Salmonella',
    code_2: 'A02',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A028',
    level: 3,
    description: 'Otras infecciones especificadas como debidas a Salmonella',
    code_2: 'A02',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A029',
    level: 3,
    description: 'Infecci\u00f3n debida a Salmonella, no especificada',
    code_2: 'A02',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A010',
    level: 3,
    description: 'Fiebre tifoidea',
    code_2: 'A01',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A011',
    level: 3,
    description: 'Fiebre paratifoidea A',
    code_2: 'A01',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A012',
    level: 3,
    description: 'Fiebre paratifoidea B',
    code_2: 'A01',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A013',
    level: 3,
    description: 'Fiebre paratifoidea C',
    code_2: 'A01',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A014',
    level: 3,
    description: 'Fiebre paratifoidea, no especificada',
    code_2: 'A01',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A000',
    level: 3,
    description: 'C\u00f3lera debido a Vibrio cholerae O1, biotipo cholerae',
    code_2: 'A00',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A001',
    level: 3,
    description: 'C\u00f3lera debido a Vibrio cholerae O1, biotipo El Tor',
    code_2: 'A00',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A009',
    level: 3,
    description: 'C\u00f3lera, no especificado',
    code_2: 'A00',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'H590',
    level: 3,
    description:
      'Queratopat\u00eda (bullosa af\u00e1quica) consecutiva a cirug\u00eda de catarata',
    code_2: 'H59',
    code_0: 'H00-H59',
    code_1: 'H55-H59'
  },
  {
    code: 'H598',
    level: 3,
    description:
      'Otros trastornos del ojo y sus anexos, consecutivos a procedimientos',
    code_2: 'H59',
    code_0: 'H00-H59',
    code_1: 'H55-H59'
  },
  {
    code: 'H599',
    level: 3,
    description:
      'Trastorno no especificado del ojo y sus anexos, consecutivo a procedimientos',
    code_2: 'H59',
    code_0: 'H00-H59',
    code_1: 'H55-H59'
  },
  {
    code: 'H580',
    level: 3,
    description:
      'Anomal\u00edas de la funci\u00f3n pupilar en enfermedades clasificadas en otra parte',
    code_2: 'H58',
    code_0: 'H00-H59',
    code_1: 'H55-H59'
  },
  {
    code: 'H581',
    level: 3,
    description:
      'Alteraciones de la visi\u00f3n en enfermedades clasificadas en otra parte',
    code_2: 'H58',
    code_0: 'H00-H59',
    code_1: 'H55-H59'
  },
  {
    code: 'H588',
    level: 3,
    description:
      'Otros trastornos especificados del ojo en enfermedades clasificadas en otra parte',
    code_2: 'H58',
    code_0: 'H00-H59',
    code_1: 'H55-H59'
  },
  {
    code: 'H570',
    level: 3,
    description: 'Anomal\u00edas de la funci\u00f3n pupilar',
    code_2: 'H57',
    code_0: 'H00-H59',
    code_1: 'H55-H59'
  },
  {
    code: 'H571',
    level: 3,
    description: 'Dolor ocular',
    code_2: 'H57',
    code_0: 'H00-H59',
    code_1: 'H55-H59'
  },
  {
    code: 'H578',
    level: 3,
    description: 'Otros trastornos especificados del ojo y sus anexos',
    code_2: 'H57',
    code_0: 'H00-H59',
    code_1: 'H55-H59'
  },
  {
    code: 'H579',
    level: 3,
    description: 'Trastorno del ojo y sus anexos, no especificado',
    code_2: 'H57',
    code_0: 'H00-H59',
    code_1: 'H55-H59'
  },
  {
    code: 'F530',
    level: 3,
    description:
      'Trastornos mentales y del comportamiento leves, asociados con el puerperio, no clasificados en otra parte',
    code_2: 'F53',
    code_0: 'F01-F99',
    code_1: 'F50-F59'
  },
  {
    code: 'F531',
    level: 3,
    description:
      'Trastornos mentales y del comportamiento graves, asociados con el puerperio, no clasificados en otra parte',
    code_2: 'F53',
    code_0: 'F01-F99',
    code_1: 'F50-F59'
  },
  {
    code: 'F538',
    level: 3,
    description:
      'Otros trastornos mentales y del comportamiento asociados con el puerperio, no clasificados en otra parte',
    code_2: 'F53',
    code_0: 'F01-F99',
    code_1: 'F50-F59'
  },
  {
    code: 'F539',
    level: 3,
    description: 'Trastorno mental puerperal, no especificado',
    code_2: 'F53',
    code_0: 'F01-F99',
    code_1: 'F50-F59'
  },
  {
    code: 'F520',
    level: 3,
    description: 'Falta o p\u00e9rdida del deseo sexual',
    code_2: 'F52',
    code_0: 'F01-F99',
    code_1: 'F50-F59'
  },
  {
    code: 'F521',
    level: 3,
    description: 'Aversi\u00f3n al sexo y falta de goce sexual',
    code_2: 'F52',
    code_0: 'F01-F99',
    code_1: 'F50-F59'
  },
  {
    code: 'F522',
    level: 3,
    description: 'Falla de la respuesta genital',
    code_2: 'F52',
    code_0: 'F01-F99',
    code_1: 'F50-F59'
  },
  {
    code: 'F523',
    level: 3,
    description: 'Disfunci\u00f3n org\u00e1smica',
    code_2: 'F52',
    code_0: 'F01-F99',
    code_1: 'F50-F59'
  },
  {
    code: 'F524',
    level: 3,
    description: 'Eyaculaci\u00f3n precoz',
    code_2: 'F52',
    code_0: 'F01-F99',
    code_1: 'F50-F59'
  },
  {
    code: 'F525',
    level: 3,
    description: 'Vaginismo no org\u00e1nico',
    code_2: 'F52',
    code_0: 'F01-F99',
    code_1: 'F50-F59'
  },
  {
    code: 'F526',
    level: 3,
    description: 'Dispareunia no org\u00e1nica',
    code_2: 'F52',
    code_0: 'F01-F99',
    code_1: 'F50-F59'
  },
  {
    code: 'F527',
    level: 3,
    description: 'Impulso sexual excesivo',
    code_2: 'F52',
    code_0: 'F01-F99',
    code_1: 'F50-F59'
  },
  {
    code: 'F528',
    level: 3,
    description:
      'Otras disfunciones sexuales, no ocasionadas por trastorno ni por enfermedad org\u00e1nicos',
    code_2: 'F52',
    code_0: 'F01-F99',
    code_1: 'F50-F59'
  },
  {
    code: 'F529',
    level: 3,
    description:
      'Disfunci\u00f3n sexual no ocasionada por trastorno ni por enfermedad org\u00e1nicos, no especificada',
    code_2: 'F52',
    code_0: 'F01-F99',
    code_1: 'F50-F59'
  },
  {
    code: 'F510',
    level: 3,
    description: 'Insomnio no org\u00e1nico',
    code_2: 'F51',
    code_0: 'F01-F99',
    code_1: 'F50-F59'
  },
  {
    code: 'F511',
    level: 3,
    description: 'Hipersomnio no org\u00e1nico',
    code_2: 'F51',
    code_0: 'F01-F99',
    code_1: 'F50-F59'
  },
  {
    code: 'F512',
    level: 3,
    description: 'Trastorno no org\u00e1nico del ciclo sue\u00f1o-vigilia',
    code_2: 'F51',
    code_0: 'F01-F99',
    code_1: 'F50-F59'
  },
  {
    code: 'F513',
    level: 3,
    description: 'Sonambulismo',
    code_2: 'F51',
    code_0: 'F01-F99',
    code_1: 'F50-F59'
  },
  {
    code: 'F514',
    level: 3,
    description: 'Terrores del sue\u00f1o [terrores nocturnos]',
    code_2: 'F51',
    code_0: 'F01-F99',
    code_1: 'F50-F59'
  },
  {
    code: 'F500',
    level: 3,
    description: 'Anorexia nerviosa',
    code_2: 'F50',
    code_0: 'F01-F99',
    code_1: 'F50-F59'
  },
  {
    code: 'F501',
    level: 3,
    description: 'Anorexia nerviosa at\u00edpica',
    code_2: 'F50',
    code_0: 'F01-F99',
    code_1: 'F50-F59'
  },
  {
    code: 'F502',
    level: 3,
    description: 'Bulimia nerviosa',
    code_2: 'F50',
    code_0: 'F01-F99',
    code_1: 'F50-F59'
  },
  {
    code: 'F503',
    level: 3,
    description: 'Bulimia nerviosa at\u00edpica',
    code_2: 'F50',
    code_0: 'F01-F99',
    code_1: 'F50-F59'
  },
  {
    code: 'F504',
    level: 3,
    description: 'Hiperfagia asociada con otras alteraciones psicol\u00f3gicas',
    code_2: 'F50',
    code_0: 'F01-F99',
    code_1: 'F50-F59'
  },
  {
    code: 'F505',
    level: 3,
    description:
      'V\u00f3mitos asociados con otras alteraciones psicol\u00f3gicas',
    code_2: 'F50',
    code_0: 'F01-F99',
    code_1: 'F50-F59'
  },
  {
    code: 'F508',
    level: 3,
    description: 'Otros trastornos de la ingesti\u00f3n de alimentos',
    code_2: 'F50',
    code_0: 'F01-F99',
    code_1: 'F50-F59'
  },
  {
    code: 'F509',
    level: 3,
    description: 'Trastorno de la ingesti\u00f3n de alimentos, no especificado',
    code_2: 'F50',
    code_0: 'F01-F99',
    code_1: 'F50-F59'
  },
  {
    code: 'F600',
    level: 3,
    description: 'Trastorno paranoide de la personalidad',
    code_2: 'F60',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F601',
    level: 3,
    description: 'Trastorno esquizoide de la personalidad',
    code_2: 'F60',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F602',
    level: 3,
    description: 'Trastorno asocial de la personalidad',
    code_2: 'F60',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F603',
    level: 3,
    description: 'Trastorno de la personalidad emocionalmente inestable',
    code_2: 'F60',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F604',
    level: 3,
    description: 'Trastorno histri\u00f3nico de la personalidad',
    code_2: 'F60',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F605',
    level: 3,
    description: 'Trastorno ananc\u00e1stico de la personalidad',
    code_2: 'F60',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F606',
    level: 3,
    description: 'Trastorno de la personalidad ansiosa (evasiva, elusiva)',
    code_2: 'F60',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F607',
    level: 3,
    description: 'Trastorno de la personalidad dependiente',
    code_2: 'F60',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F608',
    level: 3,
    description: 'Otros trastornos espec\u00edficos de la personalidad',
    code_2: 'F60',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'F609',
    level: 3,
    description: 'Trastorno de la personalidad, no especificado',
    code_2: 'F60',
    code_0: 'F01-F99',
    code_1: 'F60-F69'
  },
  {
    code: 'H950',
    level: 3,
    description:
      'Colesteatoma recurrente de la cavidad resultante de la mastoidectom\u00eda',
    code_2: 'H95',
    code_0: 'H60-H95',
    code_1: 'H90-H95'
  },
  {
    code: 'H951',
    level: 3,
    description: 'Otros trastornos posteriores a la mastoidectom\u00eda',
    code_2: 'H95',
    code_0: 'H60-H95',
    code_1: 'H90-H95'
  },
  {
    code: 'H958',
    level: 3,
    description:
      'Otros trastornos del o\u00eddo y de la ap\u00f3fisis mastoides, consecutivos a procedimientos',
    code_2: 'H95',
    code_0: 'H60-H95',
    code_1: 'H90-H95'
  },
  {
    code: 'H959',
    level: 3,
    description:
      'Trastornos no especificados del o\u00eddo y de la ap\u00f3fisis mastoides, consecutivos a procedimientos',
    code_2: 'H95',
    code_0: 'H60-H95',
    code_1: 'H90-H95'
  },
  {
    code: 'M859',
    level: 4,
    description:
      'Trastorno de la densidad y de la estructura \u00f3seas, no especificado',
    code_3: 'M85',
    code_0: 'M00-M99',
    code_1: 'M80-M94',
    code_2: 'M80-M85'
  },
  {
    code: 'H940',
    level: 3,
    description:
      'Neuritis del nervio auditivo en enfermedades infecciosas y parasitarias clasificadas en otra parte',
    code_2: 'H94',
    code_0: 'H60-H95',
    code_1: 'H90-H95'
  },
  {
    code: 'H948',
    level: 3,
    description:
      'Otros trastornos especificados del o\u00eddo en enfermedades clasificadas en otra parte',
    code_2: 'H94',
    code_0: 'H60-H95',
    code_1: 'H90-H95'
  },
  {
    code: 'H930',
    level: 3,
    description: 'Trastornos degenerativos y vasculares del o\u00eddo',
    code_2: 'H93',
    code_0: 'H60-H95',
    code_1: 'H90-H95'
  },
  {
    code: 'H931',
    level: 3,
    description: 'Tinnitus',
    code_2: 'H93',
    code_0: 'H60-H95',
    code_1: 'H90-H95'
  },
  {
    code: 'H932',
    level: 3,
    description: 'Otras percepciones auditivas anormales',
    code_2: 'H93',
    code_0: 'H60-H95',
    code_1: 'H90-H95'
  },
  {
    code: 'H933',
    level: 3,
    description: 'Trastornos del nervio auditivo',
    code_2: 'H93',
    code_0: 'H60-H95',
    code_1: 'H90-H95'
  },
  {
    code: 'H938',
    level: 3,
    description: 'Otros trastornos especificados del o\u00eddo',
    code_2: 'H93',
    code_0: 'H60-H95',
    code_1: 'H90-H95'
  },
  {
    code: 'H939',
    level: 3,
    description: 'Trastorno del o\u00eddo, no especificado',
    code_2: 'H93',
    code_0: 'H60-H95',
    code_1: 'H90-H95'
  },
  {
    code: 'M638',
    level: 4,
    description:
      'Otros trastornos de los m\u00fasculos en enfermedades clasificadas en otra parte',
    code_3: 'M63',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M60-M63'
  },
  {
    code: 'M791',
    level: 4,
    description: 'Mialgia',
    code_3: 'M79',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M792',
    level: 4,
    description: 'Neuralgia y neuritis, no especificadas',
    code_3: 'M79',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M793',
    level: 4,
    description: 'Paniculitis, no especificada',
    code_3: 'M79',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M794',
    level: 4,
    description: 'Hipertrofia de paquete adiposo (infrarrotuliano)',
    code_3: 'M79',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M795',
    level: 4,
    description: 'Cuerpo extra\u00f1o residual en tejido blando',
    code_3: 'M79',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M796',
    level: 4,
    description: 'Dolor en miembro',
    code_3: 'M79',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M797',
    level: 4,
    description: 'Fibromialgia',
    code_3: 'M79',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M798',
    level: 4,
    description: 'Otros trastornos especificados de los tejidos blandos',
    code_3: 'M79',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M799',
    level: 4,
    description: 'Trastorno de los tejidos blandos, no especificado',
    code_3: 'M79',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M771',
    level: 4,
    description: 'Epicondilitis lateral',
    code_3: 'M77',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M772',
    level: 4,
    description: 'Periartritis de la mu\u00f1eca',
    code_3: 'M77',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M773',
    level: 4,
    description: 'Espol\u00f3n calc\u00e1neo',
    code_3: 'M77',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M774',
    level: 4,
    description: 'Metatarsalgia',
    code_3: 'M77',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M775',
    level: 4,
    description: 'Otras entesopat\u00edas del pie',
    code_3: 'M77',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M778',
    level: 4,
    description: 'Otras entesopat\u00edas, no clasificadas en otra parte',
    code_3: 'M77',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M779',
    level: 4,
    description: 'Entesopat\u00eda, no especificada',
    code_3: 'M77',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M761',
    level: 4,
    description: 'Tendinitis del psoas',
    code_3: 'M76',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M762',
    level: 4,
    description: 'Espol\u00f3n de la cresta iliaca',
    code_3: 'M76',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M763',
    level: 4,
    description: 'S\u00edndrome del tend\u00f3n del tensor de la fascia lata',
    code_3: 'M76',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M764',
    level: 4,
    description: 'Bursitis tibial colateral [Pellegrini-Stieda]',
    code_3: 'M76',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M765',
    level: 4,
    description: 'Tendinitis rotuliana',
    code_3: 'M76',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M766',
    level: 4,
    description: 'Tendinitis aquiliana',
    code_3: 'M76',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M767',
    level: 4,
    description: 'Tendinitis peroneal',
    code_3: 'M76',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M768',
    level: 4,
    description:
      'Otras entesopat\u00edas del miembro inferior, excluido el pie',
    code_3: 'M76',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M769',
    level: 4,
    description: 'Entesopat\u00eda del miembro inferior, no especificada',
    code_3: 'M76',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'H920',
    level: 3,
    description: 'Otalgia',
    code_2: 'H92',
    code_0: 'H60-H95',
    code_1: 'H90-H95'
  },
  {
    code: 'H921',
    level: 3,
    description: 'Otorrea',
    code_2: 'H92',
    code_0: 'H60-H95',
    code_1: 'H90-H95'
  },
  {
    code: 'H922',
    level: 3,
    description: 'Otorragia',
    code_2: 'H92',
    code_0: 'H60-H95',
    code_1: 'H90-H95'
  },
  {
    code: 'M752',
    level: 4,
    description: 'Tendinitis del b\u00edceps',
    code_3: 'M75',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M753',
    level: 4,
    description: 'Tendinitis calcificante del hombro',
    code_3: 'M75',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M754',
    level: 4,
    description: 'S\u00edndrome de abducci\u00f3n dolorosa del hombro',
    code_3: 'M75',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M755',
    level: 4,
    description: 'Bursitis del hombro',
    code_3: 'M75',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M758',
    level: 4,
    description: 'Otras lesiones del hombro',
    code_3: 'M75',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M759',
    level: 4,
    description: 'Lesi\u00f3n del hombro, no especificada',
    code_3: 'M75',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'Y90',
    level: 2,
    description:
      'Evidencia de alcoholismo determinada por el nivel de alcohol en la sangre',
    code_1: 'Y90-Y98',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y91',
    level: 2,
    description:
      'Evidencia de alcoholismo determinada por el nivel de intoxicaci\u00f3n',
    code_1: 'Y90-Y98',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y95',
    level: 2,
    description: 'Afecci\u00f3n nosocomial',
    code_1: 'Y90-Y98',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y96',
    level: 2,
    description: 'Afecci\u00f3n relacionada con el trabajo',
    code_1: 'Y90-Y98',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y97',
    level: 2,
    description:
      'Afecci\u00f3n relacionada con la contaminaci\u00f3n ambiental',
    code_1: 'Y90-Y98',
    code_0: 'V01-Y99'
  },
  {
    code: 'M738',
    level: 4,
    description:
      'Otros trastornos de los tejidos blandos en enfermedades clasificadas en otra parte',
    code_3: 'M73',
    code_0: 'M00-M99',
    code_1: 'M60-M79',
    code_2: 'M70-M79'
  },
  {
    code: 'M143',
    level: 4,
    description: 'Dermatoartritis lipoide (E78.8)',
    code_3: 'M14',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M144',
    level: 4,
    description: 'Artropat\u00eda en la amiloidosis (E85.\u2013)',
    code_3: 'M14',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M145',
    level: 4,
    description:
      'Artropat\u00eda en otros trastornos endocrinos, metab\u00f3licos y nutricionales',
    code_3: 'M14',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M146',
    level: 4,
    description: 'Artropat\u00eda neurop\u00e1tica',
    code_3: 'M14',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'M148',
    level: 4,
    description:
      'Artropat\u00eda en otras enfermedades especificadas, clasificadas en otra parte',
    code_3: 'M14',
    code_0: 'M00-M99',
    code_1: 'M00-M25',
    code_2: 'M05-M14'
  },
  {
    code: 'Y85',
    level: 2,
    description: 'Secuelas de accidentes de transporte',
    code_1: 'Y85-Y89',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y86',
    level: 2,
    description: 'Secuelas de otros accidentes',
    code_1: 'Y85-Y89',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y87',
    level: 2,
    description:
      'Secuelas de lesiones autoinfligidas intencionalmente, agresiones y eventos de intenci\u00f3n no determinada',
    code_1: 'Y85-Y89',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y88',
    level: 2,
    description:
      'Secuelas con atenci\u00f3n m\u00e9dica y quir\u00fargica como causa externa',
    code_1: 'Y85-Y89',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y89',
    level: 2,
    description: 'Secuelas de otras causas externas',
    code_1: 'Y85-Y89',
    code_0: 'V01-Y99'
  },
  {
    code: 'F810',
    level: 3,
    description: 'Trastorno espec\u00edfico de la lectura',
    code_2: 'F81',
    code_0: 'F01-F99',
    code_1: 'F80-F89'
  },
  {
    code: 'F811',
    level: 3,
    description: 'Trastorno espec\u00edfico del deletreo [ortograf\u00eda]',
    code_2: 'F81',
    code_0: 'F01-F99',
    code_1: 'F80-F89'
  },
  {
    code: 'F812',
    level: 3,
    description:
      'Trastorno espec\u00edfico de las habilidades aritm\u00e9ticas',
    code_2: 'F81',
    code_0: 'F01-F99',
    code_1: 'F80-F89'
  },
  {
    code: 'F813',
    level: 3,
    description: 'Trastorno mixto de las habilidades escolares',
    code_2: 'F81',
    code_0: 'F01-F99',
    code_1: 'F80-F89'
  },
  {
    code: 'F818',
    level: 3,
    description: 'Otros trastornos del desarrollo de las habilidades escolares',
    code_2: 'F81',
    code_0: 'F01-F99',
    code_1: 'F80-F89'
  },
  {
    code: 'F819',
    level: 3,
    description:
      'Trastorno del desarrollo de las habilidades escolares, no especificado',
    code_2: 'F81',
    code_0: 'F01-F99',
    code_1: 'F80-F89'
  },
  {
    code: 'F800',
    level: 3,
    description: 'Trastorno espec\u00edfico de la pronunciaci\u00f3n',
    code_2: 'F80',
    code_0: 'F01-F99',
    code_1: 'F80-F89'
  },
  {
    code: 'F801',
    level: 3,
    description: 'Trastorno del lenguaje expresivo',
    code_2: 'F80',
    code_0: 'F01-F99',
    code_1: 'F80-F89'
  },
  {
    code: 'F802',
    level: 3,
    description: 'Trastorno de la recepci\u00f3n del lenguaje',
    code_2: 'F80',
    code_0: 'F01-F99',
    code_1: 'F80-F89'
  },
  {
    code: 'F803',
    level: 3,
    description: 'Afasia adquirida con epilepsia [Landau-Kleffner]',
    code_2: 'F80',
    code_0: 'F01-F99',
    code_1: 'F80-F89'
  },
  {
    code: 'F808',
    level: 3,
    description: 'Otros trastornos del desarrollo del habla y del lenguaje',
    code_2: 'F80',
    code_0: 'F01-F99',
    code_1: 'F80-F89'
  },
  {
    code: 'F809',
    level: 3,
    description:
      'Trastorno del desarrollo del habla y del lenguaje no especificado',
    code_2: 'F80',
    code_0: 'F01-F99',
    code_1: 'F80-F89'
  },
  {
    code: 'F980',
    level: 3,
    description: 'Enuresis no org\u00e1nica',
    code_2: 'F98',
    code_0: 'F01-F99',
    code_1: 'F90-F98'
  },
  {
    code: 'F981',
    level: 3,
    description: 'Encopresis no org\u00e1nica',
    code_2: 'F98',
    code_0: 'F01-F99',
    code_1: 'F90-F98'
  },
  {
    code: 'F982',
    level: 3,
    description:
      'Trastorno de la ingesti\u00f3n alimentaria en la infancia y la ni\u00f1ez',
    code_2: 'F98',
    code_0: 'F01-F99',
    code_1: 'F90-F98'
  },
  {
    code: 'F983',
    level: 3,
    description: 'Pica en la infancia y la ni\u00f1ez',
    code_2: 'F98',
    code_0: 'F01-F99',
    code_1: 'F90-F98'
  },
  {
    code: 'F984',
    level: 3,
    description: 'Trastornos de los movimientos estereotipados',
    code_2: 'F98',
    code_0: 'F01-F99',
    code_1: 'F90-F98'
  },
  {
    code: 'F985',
    level: 3,
    description: 'Tartamudez [espasmofemia]',
    code_2: 'F98',
    code_0: 'F01-F99',
    code_1: 'F90-F98'
  },
  {
    code: 'F986',
    level: 3,
    description: 'Farfulleo',
    code_2: 'F98',
    code_0: 'F01-F99',
    code_1: 'F90-F98'
  },
  {
    code: 'F988',
    level: 3,
    description:
      'Otros trastornos emocionales y del comportamiento que aparecen habitualmente en la ni\u00f1ez y en la adolescencia',
    code_2: 'F98',
    code_0: 'F01-F99',
    code_1: 'F90-F98'
  },
  {
    code: 'F989',
    level: 3,
    description:
      'Trastornos no especificados, emocionales y del comportamiento, que aparecen habitualmente en la ni\u00f1ez y en la adolescencia',
    code_2: 'F98',
    code_0: 'F01-F99',
    code_1: 'F90-F98'
  },
  {
    code: 'F950',
    level: 3,
    description: 'Trastorno por tic transitorio',
    code_2: 'F95',
    code_0: 'F01-F99',
    code_1: 'F90-F98'
  },
  {
    code: 'F951',
    level: 3,
    description: 'Trastorno por tic motor o vocal cr\u00f3nico',
    code_2: 'F95',
    code_0: 'F01-F99',
    code_1: 'F90-F98'
  },
  {
    code: 'F952',
    level: 3,
    description:
      'Trastorno por tics motores y vocales m\u00faltiples combinados [de la Tourette]',
    code_2: 'F95',
    code_0: 'F01-F99',
    code_1: 'F90-F98'
  },
  {
    code: 'F958',
    level: 3,
    description: 'Otros trastornos por tics',
    code_2: 'F95',
    code_0: 'F01-F99',
    code_1: 'F90-F98'
  },
  {
    code: 'F959',
    level: 3,
    description: 'Trastorno por tic, no especificado',
    code_2: 'F95',
    code_0: 'F01-F99',
    code_1: 'F90-F98'
  },
  {
    code: 'F940',
    level: 3,
    description: 'Mutismo electivo',
    code_2: 'F94',
    code_0: 'F01-F99',
    code_1: 'F90-F98'
  },
  {
    code: 'F941',
    level: 3,
    description: 'Trastorno de vinculaci\u00f3n reactiva en la ni\u00f1ez',
    code_2: 'F94',
    code_0: 'F01-F99',
    code_1: 'F90-F98'
  },
  {
    code: 'F942',
    level: 3,
    description: 'Trastorno de vinculaci\u00f3n desinhibida en la ni\u00f1ez',
    code_2: 'F94',
    code_0: 'F01-F99',
    code_1: 'F90-F98'
  },
  {
    code: 'F948',
    level: 3,
    description: 'Otros trastornos del comportamiento social en la ni\u00f1ez',
    code_2: 'F94',
    code_0: 'F01-F99',
    code_1: 'F90-F98'
  },
  {
    code: 'F949',
    level: 3,
    description:
      'Trastorno del comportamiento social en la ni\u00f1ez, no especificado',
    code_2: 'F94',
    code_0: 'F01-F99',
    code_1: 'F90-F98'
  },
  {
    code: 'F930',
    level: 3,
    description: 'Trastorno de ansiedad de separaci\u00f3n en la ni\u00f1ez',
    code_2: 'F93',
    code_0: 'F01-F99',
    code_1: 'F90-F98'
  },
  {
    code: 'F931',
    level: 3,
    description: 'Trastorno de ansiedad f\u00f3bica en la ni\u00f1ez',
    code_2: 'F93',
    code_0: 'F01-F99',
    code_1: 'F90-F98'
  },
  {
    code: 'F932',
    level: 3,
    description: 'Trastorno de ansiedad social en la ni\u00f1ez',
    code_2: 'F93',
    code_0: 'F01-F99',
    code_1: 'F90-F98'
  },
  {
    code: 'F933',
    level: 3,
    description: 'Trastorno de rivalidad entre hermanos',
    code_2: 'F93',
    code_0: 'F01-F99',
    code_1: 'F90-F98'
  },
  {
    code: 'F938',
    level: 3,
    description: 'Otros trastornos emocionales en la ni\u00f1ez',
    code_2: 'F93',
    code_0: 'F01-F99',
    code_1: 'F90-F98'
  },
  {
    code: 'F939',
    level: 3,
    description: 'Trastorno emocional en la ni\u00f1ez, no especificado',
    code_2: 'F93',
    code_0: 'F01-F99',
    code_1: 'F90-F98'
  },
  {
    code: 'F920',
    level: 3,
    description: 'Trastorno depresivo de la conducta',
    code_2: 'F92',
    code_0: 'F01-F99',
    code_1: 'F90-F98'
  },
  {
    code: 'F928',
    level: 3,
    description: 'Otros trastornos mixtos de la conducta y de las emociones',
    code_2: 'F92',
    code_0: 'F01-F99',
    code_1: 'F90-F98'
  },
  {
    code: 'F929',
    level: 3,
    description:
      'Trastorno mixto de la conducta y de las emociones, no especificado',
    code_2: 'F92',
    code_0: 'F01-F99',
    code_1: 'F90-F98'
  },
  {
    code: 'F910',
    level: 3,
    description: 'Trastorno de la conducta limitado al contexto familiar',
    code_2: 'F91',
    code_0: 'F01-F99',
    code_1: 'F90-F98'
  },
  {
    code: 'F911',
    level: 3,
    description: 'Trastorno de la conducta insociable',
    code_2: 'F91',
    code_0: 'F01-F99',
    code_1: 'F90-F98'
  },
  {
    code: 'F912',
    level: 3,
    description: 'Trastorno de la conducta sociable',
    code_2: 'F91',
    code_0: 'F01-F99',
    code_1: 'F90-F98'
  },
  {
    code: 'F913',
    level: 3,
    description: 'Trastorno opositor desafiante',
    code_2: 'F91',
    code_0: 'F01-F99',
    code_1: 'F90-F98'
  },
  {
    code: 'F918',
    level: 3,
    description: 'Otros trastornos de la conducta',
    code_2: 'F91',
    code_0: 'F01-F99',
    code_1: 'F90-F98'
  },
  {
    code: 'F919',
    level: 3,
    description: 'Trastorno de la conducta, no especificado',
    code_2: 'F91',
    code_0: 'F01-F99',
    code_1: 'F90-F98'
  },
  {
    code: 'F900',
    level: 3,
    description: 'Perturbaci\u00f3n de la actividad y de la atenci\u00f3n',
    code_2: 'F90',
    code_0: 'F01-F99',
    code_1: 'F90-F98'
  },
  {
    code: 'F901',
    level: 3,
    description: 'Trastorno hipercin\u00e9tico de la conducta',
    code_2: 'F90',
    code_0: 'F01-F99',
    code_1: 'F90-F98'
  },
  {
    code: 'F908',
    level: 3,
    description: 'Otros trastornos hipercin\u00e9ticos',
    code_2: 'F90',
    code_0: 'F01-F99',
    code_1: 'F90-F98'
  },
  {
    code: 'F909',
    level: 3,
    description: 'Trastorno hipercin\u00e9tico, no especificado',
    code_2: 'F90',
    code_0: 'F01-F99',
    code_1: 'F90-F98'
  },
  {
    code: 'S030',
    level: 3,
    description: 'Luxaci\u00f3n del maxilar',
    code_2: 'S03',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S031',
    level: 3,
    description: 'Luxaci\u00f3n del cart\u00edlago septal de la nariz',
    code_2: 'S03',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S032',
    level: 3,
    description: 'Luxaci\u00f3n de diente',
    code_2: 'S03',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S033',
    level: 3,
    description:
      'Luxaci\u00f3n de otras partes y de las no especificadas de la cabeza',
    code_2: 'S03',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S034',
    level: 3,
    description: 'Esguinces y torceduras del maxilar',
    code_2: 'S03',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S035',
    level: 3,
    description:
      'Esguinces y torceduras de articulaciones y ligamentos de otras partes y las no especificadas de la cabeza',
    code_2: 'S03',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S020',
    level: 3,
    description: 'Fractura de la b\u00f3veda del cr\u00e1neo',
    code_2: 'S02',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S021',
    level: 3,
    description: 'Fractura de la base del cr\u00e1neo',
    code_2: 'S02',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S022',
    level: 3,
    description: 'Fractura de los huesos de la nariz',
    code_2: 'S02',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S023',
    level: 3,
    description: 'Fractura del suelo de la \u00f3rbita',
    code_2: 'S02',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S024',
    level: 3,
    description: 'Fractura del malar y del hueso maxilar superior',
    code_2: 'S02',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S025',
    level: 3,
    description: 'Fractura de los dientes',
    code_2: 'S02',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S026',
    level: 3,
    description: 'Fractura del maxilar inferior',
    code_2: 'S02',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S010',
    level: 3,
    description: 'Herida del cuero cabelludo',
    code_2: 'S01',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S011',
    level: 3,
    description: 'Herida del p\u00e1rpado y de la regi\u00f3n periocular',
    code_2: 'S01',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S012',
    level: 3,
    description: 'Herida de la nariz',
    code_2: 'S01',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S013',
    level: 3,
    description: 'Herida del o\u00eddo',
    code_2: 'S01',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S014',
    level: 3,
    description: 'Herida de la mejilla y de la regi\u00f3n temporomandibular',
    code_2: 'S01',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S015',
    level: 3,
    description: 'Herida del labio y de la cavidad bucal',
    code_2: 'S01',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S017',
    level: 3,
    description: 'Heridas m\u00faltiples de la cabeza',
    code_2: 'S01',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S018',
    level: 3,
    description: 'Herida de otras partes de la cabeza',
    code_2: 'S01',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S019',
    level: 3,
    description: 'Herida de la cabeza, parte no especificada',
    code_2: 'S01',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S000',
    level: 3,
    description: 'Traumatismo superficial del cuero cabelludo',
    code_2: 'S00',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S001',
    level: 3,
    description:
      'Contusi\u00f3n de los p\u00e1rpados y de la regi\u00f3n periocular',
    code_2: 'S00',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S002',
    level: 3,
    description:
      'Otros traumatismos superficiales del p\u00e1rpado y de la regi\u00f3n periocular',
    code_2: 'S00',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S003',
    level: 3,
    description: 'Traumatismo superficial de la nariz',
    code_2: 'S00',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S004',
    level: 3,
    description: 'Traumatismo superficial del o\u00eddo',
    code_2: 'S00',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S005',
    level: 3,
    description: 'Traumatismo superficial del labio y de la cavidad bucal',
    code_2: 'S00',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S007',
    level: 3,
    description: 'Traumatismos superficiales m\u00faltiples de la cabeza',
    code_2: 'S00',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S008',
    level: 3,
    description: 'Traumatismo superficial de otras partes de la cabeza',
    code_2: 'S00',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S009',
    level: 3,
    description: 'Traumatismo superficial de la cabeza, parte no especificada',
    code_2: 'S00',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S110',
    level: 3,
    description: 'Herida que compromete la laringe y la tr\u00e1quea',
    code_2: 'S11',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S111',
    level: 3,
    description: 'Herida que compromete la gl\u00e1ndula tiroides',
    code_2: 'S11',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S112',
    level: 3,
    description: 'Herida que compromete la faringe y el es\u00f3fago cervical',
    code_2: 'S11',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S117',
    level: 3,
    description: 'Heridas m\u00faltiples del cuello',
    code_2: 'S11',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S118',
    level: 3,
    description: 'Heridas de otras partes del cuello',
    code_2: 'S11',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S119',
    level: 3,
    description: 'Herida de cuello, parte no especificada',
    code_2: 'S11',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S100',
    level: 3,
    description: 'Contusi\u00f3n de la garganta',
    code_2: 'S10',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S101',
    level: 3,
    description:
      'Otros traumatismos superficiales y los no especificados de la garganta',
    code_2: 'S10',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S107',
    level: 3,
    description: 'Traumatismo superficial m\u00faltiple del cuello',
    code_2: 'S10',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S108',
    level: 3,
    description: 'Traumatismo superficial de otras partes del cuello',
    code_2: 'S10',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S109',
    level: 3,
    description: 'Traumatismo superficial del cuello, parte no especificada',
    code_2: 'S10',
    code_0: 'S00-T88',
    code_1: 'S10-S19'
  },
  {
    code: 'S230',
    level: 3,
    description:
      'Ruptura traum\u00e1tica de disco intervertebral tor\u00e1cico',
    code_2: 'S23',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S231',
    level: 3,
    description: 'Luxaci\u00f3n de v\u00e9rtebra tor\u00e1cica',
    code_2: 'S23',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S232',
    level: 3,
    description:
      'Luxaci\u00f3n de otras partes y de las no especificadas del t\u00f3rax',
    code_2: 'S23',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S233',
    level: 3,
    description: 'Esguinces y torceduras de columna tor\u00e1cica',
    code_2: 'S23',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S234',
    level: 3,
    description: 'Esguinces y torceduras de costillas y estern\u00f3n',
    code_2: 'S23',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S235',
    level: 3,
    description:
      'Esguinces y torceduras de otras partes y de las no especificadas del t\u00f3rax',
    code_2: 'S23',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S220',
    level: 3,
    description: 'Fractura de v\u00e9rtebra tor\u00e1cica',
    code_2: 'S22',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S221',
    level: 3,
    description: 'Fracturas m\u00faltiples de columna tor\u00e1cica',
    code_2: 'S22',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S222',
    level: 3,
    description: 'Fractura del estern\u00f3n',
    code_2: 'S22',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S223',
    level: 3,
    description: 'Fractura de costilla',
    code_2: 'S22',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S224',
    level: 3,
    description: 'Fracturas m\u00faltiples de costillas',
    code_2: 'S22',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S225',
    level: 3,
    description: 'T\u00f3rax azotado',
    code_2: 'S22',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S228',
    level: 3,
    description: 'Fractura de otras partes del t\u00f3rax \u00f3seo',
    code_2: 'S22',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S229',
    level: 3,
    description: 'Fractura del t\u00f3rax \u00f3seo, parte no especificada',
    code_2: 'S22',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S210',
    level: 3,
    description: 'Herida de la mama',
    code_2: 'S21',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S211',
    level: 3,
    description: 'Herida de la pared anterior del t\u00f3rax',
    code_2: 'S21',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S212',
    level: 3,
    description: 'Herida de la pared posterior del t\u00f3rax',
    code_2: 'S21',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S217',
    level: 3,
    description: 'Herida m\u00faltiple de la pared tor\u00e1cica',
    code_2: 'S21',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S218',
    level: 3,
    description: 'Herida de otras partes del t\u00f3rax',
    code_2: 'S21',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S219',
    level: 3,
    description: 'Herida del t\u00f3rax, parte no especificada',
    code_2: 'S21',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S200',
    level: 3,
    description: 'Contusi\u00f3n de la mama',
    code_2: 'S20',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S201',
    level: 3,
    description:
      'Otros traumatismos superficiales y los no especificados de la mama',
    code_2: 'S20',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S202',
    level: 3,
    description: 'Contusi\u00f3n del t\u00f3rax',
    code_2: 'S20',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S203',
    level: 3,
    description:
      'Otros traumatismos superficiales de la pared anterior del t\u00f3rax',
    code_2: 'S20',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S204',
    level: 3,
    description:
      'Otros traumatismos superficiales de la pared posterior del t\u00f3rax',
    code_2: 'S20',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S207',
    level: 3,
    description: 'Traumatismos superficiales m\u00faltiples del t\u00f3rax',
    code_2: 'S20',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'S208',
    level: 3,
    description:
      'Traumatismo superficial de otras partes y de las no especificadas del t\u00f3rax',
    code_2: 'S20',
    code_0: 'S00-T88',
    code_1: 'S20-S29'
  },
  {
    code: 'D738',
    level: 3,
    description: 'Otras enfermedades del bazo',
    code_2: 'D73',
    code_0: 'D50-D89',
    code_1: 'D70-D77'
  },
  {
    code: 'D739',
    level: 3,
    description: 'Enfermedad del bazo, no especificada',
    code_2: 'D73',
    code_0: 'D50-D89',
    code_1: 'D70-D77'
  },
  {
    code: 'C84',
    level: 3,
    description: 'Linfoma de c\u00e9lulas T, perif\u00e9rico y cut\u00e1neo',
    code_2: 'C81-C96',
    code_0: 'C00-D49',
    code_1: 'C00-C97'
  },
  {
    code: 'C85',
    level: 3,
    description: 'Linfoma no Hodgkin de otro tipo y el no especificado',
    code_2: 'C81-C96',
    code_0: 'C00-D49',
    code_1: 'C00-C97'
  },
  {
    code: 'C88',
    level: 3,
    description: 'Enfermedades inmunoproliferativas malignas',
    code_2: 'C81-C96',
    code_0: 'C00-D49',
    code_1: 'C00-C97'
  },
  {
    code: 'C90',
    level: 3,
    description:
      'Mieloma m\u00faltiple y tumores malignos de c\u00e9lulas plasm\u00e1ticas',
    code_2: 'C81-C96',
    code_0: 'C00-D49',
    code_1: 'C00-C97'
  },
  {
    code: 'C91',
    level: 3,
    description: 'Leucemia linfoide',
    code_2: 'C81-C96',
    code_0: 'C00-D49',
    code_1: 'C00-C97'
  },
  {
    code: 'C92',
    level: 3,
    description: 'Leucemia mieloide',
    code_2: 'C81-C96',
    code_0: 'C00-D49',
    code_1: 'C00-C97'
  },
  {
    code: 'C93',
    level: 3,
    description: 'Leucemia monoc\u00edtica',
    code_2: 'C81-C96',
    code_0: 'C00-D49',
    code_1: 'C00-C97'
  },
  {
    code: 'C94',
    level: 3,
    description: 'Otras leucemias de tipo celular especificado',
    code_2: 'C81-C96',
    code_0: 'C00-D49',
    code_1: 'C00-C97'
  },
  {
    code: 'C78',
    level: 3,
    description:
      'Tumor maligno secundario de los \u00f3rganos respiratorios y digestivos',
    code_2: 'C76-C80',
    code_0: 'C00-D49',
    code_1: 'C00-C97'
  },
  {
    code: 'C79',
    level: 3,
    description: 'Tumor maligno secundario de otros sitios',
    code_2: 'C76-C80',
    code_0: 'C00-D49',
    code_1: 'C00-C97'
  },
  {
    code: 'C80',
    level: 3,
    description: 'Tumor maligno de sitios no especificados',
    code_2: 'C76-C80',
    code_0: 'C00-D49',
    code_1: 'C00-C97'
  },
  {
    code: 'C45-C49',
    level: 3,
    description:
      'Tumores malignos de los tejidos mesoteliales y de los tejidos blandos',
    code_2: 'C00-C75',
    code_0: 'C00-D49',
    code_1: 'C00-C97'
  },
  {
    code: 'C50',
    level: 3,
    description: 'Tumor maligno de la mama',
    code_2: 'C00-C75',
    code_0: 'C00-D49',
    code_1: 'C00-C97'
  },
  {
    code: 'C51-C58',
    level: 3,
    description: 'Tumores malignos de los \u00f3rganos genitales femeninos',
    code_2: 'C00-C75',
    code_0: 'C00-D49',
    code_1: 'C00-C97'
  },
  {
    code: 'C60-C63',
    level: 3,
    description: 'Tumores malignos de los \u00f3rganos genitales masculinos',
    code_2: 'C00-C75',
    code_0: 'C00-D49',
    code_1: 'C00-C97'
  },
  {
    code: 'C64-C68',
    level: 3,
    description: 'Tumores malignos de las v\u00edas urinarias',
    code_2: 'C00-C75',
    code_0: 'C00-D49',
    code_1: 'C00-C97'
  },
  {
    code: 'C69-C72',
    level: 3,
    description:
      'Tumores malignos del ojo, del enc\u00e9falo y de otras partes del sistema nervioso central',
    code_2: 'C00-C75',
    code_0: 'C00-D49',
    code_1: 'C00-C97'
  },
  {
    code: 'C73-C75',
    level: 3,
    description:
      'Tumores malignos de la gl\u00e1ndula tiroides y de otras gl\u00e1ndulas endocrinas',
    code_2: 'C00-C75',
    code_0: 'C00-D49',
    code_1: 'C00-C97'
  },
  {
    code: 'D046',
    level: 3,
    description:
      'Carcinoma in situ de la piel del miembro superior, incluido el hombro',
    code_2: 'D04',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D047',
    level: 3,
    description:
      'Carcinoma in situ de la piel del miembro inferior, incluida la cadera',
    code_2: 'D04',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D048',
    level: 3,
    description: 'Carcinoma in situ de la piel de otros sitios especificados',
    code_2: 'D04',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D049',
    level: 3,
    description: 'Carcinoma in situ de la piel, sitio no especificado',
    code_2: 'D04',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D039',
    level: 3,
    description: 'Melanoma in situ, sitio no especificado',
    code_2: 'D03',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D015',
    level: 3,
    description:
      'Carcinoma in situ del h\u00edgado, de la ves\u00edcula biliar y del conducto biliar',
    code_2: 'D01',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D017',
    level: 3,
    description:
      'Carcinoma in situ de otras partes especificadas de \u00f3rganos digestivos',
    code_2: 'D01',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D019',
    level: 3,
    description:
      'Carcinoma in situ de \u00f3rganos digestivos no especificados',
    code_2: 'D01',
    code_0: 'C00-D49',
    code_1: 'D00-D09'
  },
  {
    code: 'D128',
    level: 3,
    description: 'Tumor benigno del recto',
    code_2: 'D12',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D129',
    level: 3,
    description: 'Tumor benigno del conducto anal y del ano',
    code_2: 'D12',
    code_0: 'C00-D49',
    code_1: 'D10-D36'
  },
  {
    code: 'D383',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido del mediastino',
    code_2: 'D38',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D384',
    level: 3,
    description: 'Tumor de comportamiento incierto o desconocido del timo',
    code_2: 'D38',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D385',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido de otros \u00f3rganos respiratorios y del o\u00eddo medio',
    code_2: 'D38',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D386',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido de \u00f3rganos respiratorios, sitio no especificado',
    code_2: 'D38',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'D379',
    level: 3,
    description:
      'Tumor de comportamiento incierto o desconocido de \u00f3rganos digestivos, sitio no especificado',
    code_2: 'D37',
    code_0: 'C00-D49',
    code_1: 'D37-D48'
  },
  {
    code: 'G519',
    level: 3,
    description: 'Trastorno del nervio facial, no especificado',
    code_2: 'G51',
    code_0: 'G00-G99',
    code_1: 'G50-G59'
  },
  {
    code: 'S310',
    level: 3,
    description: 'Herida de la regi\u00f3n lumbosacra y de la pelvis',
    code_2: 'S31',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S311',
    level: 3,
    description: 'Herida de la pared abdominal',
    code_2: 'S31',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S312',
    level: 3,
    description: 'Herida del pene',
    code_2: 'S31',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S313',
    level: 3,
    description: 'Herida del escroto y de los test\u00edculos',
    code_2: 'S31',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S314',
    level: 3,
    description: 'Herida de la vagina y de la vulva',
    code_2: 'S31',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S315',
    level: 3,
    description:
      'Herida de otros \u00f3rganos genitales externos y de los no especificados',
    code_2: 'S31',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S317',
    level: 3,
    description:
      'Heridas m\u00faltiples del abdomen, de la regi\u00f3n lumbosacra y de la pelvis',
    code_2: 'S31',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S318',
    level: 3,
    description:
      'Heridas de otras partes y de las no especificadas del abdomen',
    code_2: 'S31',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S300',
    level: 3,
    description: 'Contusi\u00f3n de la regi\u00f3n lumbosacra y de la pelvis',
    code_2: 'S30',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S301',
    level: 3,
    description: 'Contusi\u00f3n de la pared abdominal',
    code_2: 'S30',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S302',
    level: 3,
    description: 'Contusi\u00f3n de \u00f3rganos genitales externos',
    code_2: 'S30',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S307',
    level: 3,
    description:
      'Traumatismos superficiales m\u00faltiples del abdomen, de la regi\u00f3n lumbosacra y de la pelvis',
    code_2: 'S30',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S308',
    level: 3,
    description:
      'Otros traumatismos superficiales del abdomen, de la regi\u00f3n lumbosacra y de la pelvis',
    code_2: 'S30',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'S309',
    level: 3,
    description:
      'Traumatismo superficial del abdomen, de la regi\u00f3n lumbosacra y de la pelvis, parte no especificada',
    code_2: 'S30',
    code_0: 'S00-T88',
    code_1: 'S30-S39'
  },
  {
    code: 'G040',
    level: 3,
    description: 'Encefalitis aguda diseminada',
    code_2: 'G04',
    code_0: 'G00-G99',
    code_1: 'G00-G09'
  },
  {
    code: 'G041',
    level: 3,
    description: 'Paraplej\u00eda esp\u00e1stica tropical',
    code_2: 'G04',
    code_0: 'G00-G99',
    code_1: 'G00-G09'
  },
  {
    code: 'G042',
    level: 3,
    description:
      'Meningoencefalitis y meningomielitis bacterianas, no clasificadas en otra parte',
    code_2: 'G04',
    code_0: 'G00-G99',
    code_1: 'G00-G09'
  },
  {
    code: 'G048',
    level: 3,
    description: 'Otras encefalitis, mielitis y encefalomielitis',
    code_2: 'G04',
    code_0: 'G00-G99',
    code_1: 'G00-G09'
  },
  {
    code: 'G049',
    level: 3,
    description: 'Encefalitis, mielitis y encefalomielitis, no especificadas',
    code_2: 'G04',
    code_0: 'G00-G99',
    code_1: 'G00-G09'
  },
  {
    code: 'G030',
    level: 3,
    description: 'Meningitis api\u00f3gena',
    code_2: 'G03',
    code_0: 'G00-G99',
    code_1: 'G00-G09'
  },
  {
    code: 'G031',
    level: 3,
    description: 'Meningitis cr\u00f3nica',
    code_2: 'G03',
    code_0: 'G00-G99',
    code_1: 'G00-G09'
  },
  {
    code: 'G032',
    level: 3,
    description: 'Meningitis recurrente benigna [Mollaret]',
    code_2: 'G03',
    code_0: 'G00-G99',
    code_1: 'G00-G09'
  },
  {
    code: 'G038',
    level: 3,
    description: 'Meningitis debidas a otras causas especificadas',
    code_2: 'G03',
    code_0: 'G00-G99',
    code_1: 'G00-G09'
  },
  {
    code: 'G039',
    level: 3,
    description: 'Meningitis, no especificada',
    code_2: 'G03',
    code_0: 'G00-G99',
    code_1: 'G00-G09'
  },
  {
    code: 'G020',
    level: 3,
    description:
      'Meningitis en enfermedades virales clasificadas en otra parte',
    code_2: 'G02',
    code_0: 'G00-G99',
    code_1: 'G00-G09'
  },
  {
    code: 'G021',
    level: 3,
    description: 'Meningitis en micosis',
    code_2: 'G02',
    code_0: 'G00-G99',
    code_1: 'G00-G09'
  },
  {
    code: 'G028',
    level: 3,
    description:
      'Meningitis en otras enfermedades infecciosas y parasitarias especificadas clasificadas en otra parte',
    code_2: 'G02',
    code_0: 'G00-G99',
    code_1: 'G00-G09'
  },
  {
    code: 'G000',
    level: 3,
    description: 'Meningitis por hem\u00f3filos',
    code_2: 'G00',
    code_0: 'G00-G99',
    code_1: 'G00-G09'
  },
  {
    code: 'G001',
    level: 3,
    description: 'Meningitis neumoc\u00f3cica',
    code_2: 'G00',
    code_0: 'G00-G99',
    code_1: 'G00-G09'
  },
  {
    code: 'G002',
    level: 3,
    description: 'Meningitis estreptoc\u00f3cica',
    code_2: 'G00',
    code_0: 'G00-G99',
    code_1: 'G00-G09'
  },
  {
    code: 'G003',
    level: 3,
    description: 'Meningitis estafiloc\u00f3cica',
    code_2: 'G00',
    code_0: 'G00-G99',
    code_1: 'G00-G09'
  },
  {
    code: 'G008',
    level: 3,
    description: 'Otras meningitis bacterianas',
    code_2: 'G00',
    code_0: 'G00-G99',
    code_1: 'G00-G09'
  },
  {
    code: 'G009',
    level: 3,
    description: 'Meningitis bacteriana, no especificada',
    code_2: 'G00',
    code_0: 'G00-G99',
    code_1: 'G00-G09'
  },
  {
    code: 'F400',
    level: 3,
    description: 'Agorafobia',
    code_2: 'F40',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F401',
    level: 3,
    description: 'Fobias sociales',
    code_2: 'F40',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F402',
    level: 3,
    description: 'Fobias espec\u00edficas (aisladas)',
    code_2: 'F40',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F408',
    level: 3,
    description: 'Otros trastornos f\u00f3bicos de ansiedad',
    code_2: 'F40',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'F409',
    level: 3,
    description: 'Trastorno f\u00f3bico de ansiedad, no especificado',
    code_2: 'F40',
    code_0: 'F01-F99',
    code_1: 'F40-F48'
  },
  {
    code: 'O94',
    level: 2,
    description:
      'Secuelas de complicaciones del embarazo, del parto y del puerperio',
    code_1: 'O94-O99',
    code_0: 'O00-O9A'
  },
  {
    code: 'O95',
    level: 2,
    description: 'Muerte obst\u00e9trica de causa no especificada',
    code_1: 'O94-O99',
    code_0: 'O00-O9A'
  },
  {
    code: 'O96',
    level: 2,
    description:
      'Muerte materna debida a cualquier causa obst\u00e9trica que ocurre despu\u00e9s de 42 d\u00edas pero antes de un a\u00f1o del parto',
    code_1: 'O94-O99',
    code_0: 'O00-O9A'
  },
  {
    code: 'O97',
    level: 2,
    description: 'Muerte por secuelas de causas obst\u00e9tricas directas',
    code_1: 'O94-O99',
    code_0: 'O00-O9A'
  },
  {
    code: 'O85',
    level: 2,
    description: 'Sepsis puerperal',
    code_1: 'O85-O92',
    code_0: 'O00-O9A'
  },
  {
    code: 'O86',
    level: 2,
    description: 'Otras infecciones puerperales',
    code_1: 'O85-O92',
    code_0: 'O00-O9A'
  },
  {
    code: 'O87',
    level: 2,
    description: 'Complicaciones venosas en el puerperio',
    code_1: 'O85-O92',
    code_0: 'O00-O9A'
  },
  {
    code: 'O88',
    level: 2,
    description: 'Embolia obst\u00e9trica',
    code_1: 'O85-O92',
    code_0: 'O00-O9A'
  },
  {
    code: 'O89',
    level: 2,
    description:
      'Complicaciones de la anestesia administrada durante el puerperio',
    code_1: 'O85-O92',
    code_0: 'O00-O9A'
  },
  {
    code: 'O90',
    level: 2,
    description: 'Complicaciones del puerperio, no clasificadas en otra parte',
    code_1: 'O85-O92',
    code_0: 'O00-O9A'
  },
  {
    code: 'O80',
    level: 2,
    description: 'Parto \u00fanico espont\u00e1neo',
    code_1: 'O80-O84',
    code_0: 'O00-O9A'
  },
  {
    code: 'O81',
    level: 2,
    description: 'Parto \u00fanico con f\u00f3rceps y ventosa extractora',
    code_1: 'O80-O84',
    code_0: 'O00-O9A'
  },
  {
    code: 'O82',
    level: 2,
    description: 'Parto \u00fanico por ces\u00e1rea',
    code_1: 'O80-O84',
    code_0: 'O00-O9A'
  },
  {
    code: 'O83',
    level: 2,
    description: 'Otros partos \u00fanicos asistidos',
    code_1: 'O80-O84',
    code_0: 'O00-O9A'
  },
  {
    code: 'O84',
    level: 2,
    description: 'Parto m\u00faltiple',
    code_1: 'O80-O84',
    code_0: 'O00-O9A'
  },
  {
    code: 'O60',
    level: 2,
    description: 'Trabajo de parto prematuro',
    code_1: 'O60-O75',
    code_0: 'O00-O9A'
  },
  {
    code: 'O61',
    level: 2,
    description: 'Fracaso de la inducci\u00f3n del trabajo de parto',
    code_1: 'O60-O75',
    code_0: 'O00-O9A'
  },
  {
    code: 'O62',
    level: 2,
    description: 'Anormalidades de la din\u00e1mica del trabajo de parto',
    code_1: 'O60-O75',
    code_0: 'O00-O9A'
  },
  {
    code: 'O63',
    level: 2,
    description: 'Trabajo de parto prolongado',
    code_1: 'O60-O75',
    code_0: 'O00-O9A'
  },
  {
    code: 'O64',
    level: 2,
    description:
      'Trabajo de parto obstruido debido a mala posici\u00f3n y presentaci\u00f3n anormal del feto',
    code_1: 'O60-O75',
    code_0: 'O00-O9A'
  },
  {
    code: 'O65',
    level: 2,
    description:
      'Trabajo de parto obstruido debido a anormalidad de la pelvis materna',
    code_1: 'O60-O75',
    code_0: 'O00-O9A'
  },
  {
    code: 'P90',
    level: 2,
    description: 'Convulsiones del reci\u00e9n nacido',
    code_1: 'P90-P96',
    code_0: 'P00-P96'
  },
  {
    code: 'P91',
    level: 2,
    description: 'Otras alteraciones cerebrales del reci\u00e9n nacido',
    code_1: 'P90-P96',
    code_0: 'P00-P96'
  },
  {
    code: 'P92',
    level: 2,
    description:
      'Problemas de la ingesti\u00f3n de alimentos del reci\u00e9n nacido',
    code_1: 'P90-P96',
    code_0: 'P00-P96'
  },
  {
    code: 'P93',
    level: 2,
    description:
      'Reacciones e intoxicaciones debidas a drogas administradas al feto y al reci\u00e9n nacido',
    code_1: 'P90-P96',
    code_0: 'P00-P96'
  },
  {
    code: 'P94',
    level: 2,
    description: 'Trastornos del tono muscular en el reci\u00e9n nacido',
    code_1: 'P90-P96',
    code_0: 'P00-P96'
  },
  {
    code: 'P95',
    level: 2,
    description: 'Muerte fetal de causa no especificada',
    code_1: 'P90-P96',
    code_0: 'P00-P96'
  },
  {
    code: 'P80',
    level: 2,
    description: 'Hipotermia del reci\u00e9n nacido',
    code_1: 'P80-P83',
    code_0: 'P00-P96'
  },
  {
    code: 'P81',
    level: 2,
    description:
      'Otras alteraciones de la regulaci\u00f3n de la temperatura en el reci\u00e9n nacido',
    code_1: 'P80-P83',
    code_0: 'P00-P96'
  },
  {
    code: 'P83',
    level: 2,
    description:
      'Otras afecciones de la piel espec\u00edficas del feto y del reci\u00e9n nacido',
    code_1: 'P80-P83',
    code_0: 'P00-P96'
  },
  {
    code: 'P75',
    level: 2,
    description: '\u00cdleo meconial (E84.1)',
    code_1: 'P75-P78',
    code_0: 'P00-P96'
  },
  {
    code: 'P76',
    level: 2,
    description: 'Otras obstrucciones intestinales del reci\u00e9n nacido',
    code_1: 'P75-P78',
    code_0: 'P00-P96'
  },
  {
    code: 'P77',
    level: 2,
    description: 'Enterocolitis necrotizante del feto y del reci\u00e9n nacido',
    code_1: 'P75-P78',
    code_0: 'P00-P96'
  },
  {
    code: 'P78',
    level: 2,
    description: 'Otros trastornos perinatales del sistema digestivo',
    code_1: 'P75-P78',
    code_0: 'P00-P96'
  },
  {
    code: 'H060',
    level: 3,
    description:
      'Trastornos del aparato lagrimal en enfermedades clasificadas en otra parte',
    code_2: 'H06',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'H061',
    level: 3,
    description:
      'Infecci\u00f3n e infestaci\u00f3n parasitarias de la \u00f3rbita en enfermedades clasificadas en otra parte',
    code_2: 'H06',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'H062',
    level: 3,
    description: 'Exoftalmia hipertiroidea (E05.\u2013)',
    code_2: 'H06',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'H063',
    level: 3,
    description:
      'Otros trastornos de la \u00f3rbita en enfermedades clasificadas en otra parte',
    code_2: 'H06',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'H050',
    level: 3,
    description: 'Inflamaci\u00f3n aguda de la \u00f3rbita',
    code_2: 'H05',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'H051',
    level: 3,
    description: 'Trastornos inflamatorios cr\u00f3nicos de la \u00f3rbita',
    code_2: 'H05',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'H052',
    level: 3,
    description: 'Afecciones exoft\u00e1lmicas',
    code_2: 'H05',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'H053',
    level: 3,
    description: 'Deformidad de la \u00f3rbita',
    code_2: 'H05',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'H054',
    level: 3,
    description: 'Enoftalmia',
    code_2: 'H05',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'H055',
    level: 3,
    description:
      'Retenci\u00f3n de cuerpo extra\u00f1o (antiguo), consecutiva a herida penetrante de la \u00f3rbita',
    code_2: 'H05',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'H058',
    level: 3,
    description: 'Otros trastornos de la \u00f3rbita',
    code_2: 'H05',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'H059',
    level: 3,
    description: 'Trastorno de la \u00f3rbita, no especificado',
    code_2: 'H05',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'H040',
    level: 3,
    description: 'Dacrioadenitis',
    code_2: 'H04',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'H041',
    level: 3,
    description: 'Otros trastornos de la gl\u00e1ndula lagrimal',
    code_2: 'H04',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'H042',
    level: 3,
    description: 'Ep\u00edfora',
    code_2: 'H04',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'H043',
    level: 3,
    description:
      'Inflamaci\u00f3n aguda y la no especificada de las v\u00edas lagrimales',
    code_2: 'H04',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'H044',
    level: 3,
    description: 'Inflamaci\u00f3n cr\u00f3nica de las v\u00edas lagrimales',
    code_2: 'H04',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'H030',
    level: 3,
    description:
      'Infecci\u00f3n e infestaci\u00f3n parasitarias del p\u00e1rpado en',
    code_2: 'H03',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'H031',
    level: 3,
    description: 'Compromiso del p\u00e1rpado en enfermedades infecciosas',
    code_2: 'H03',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'H038',
    level: 3,
    description:
      'Compromiso del p\u00e1rpado en enfermedades clasificadas en otra parte',
    code_2: 'H03',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'H020',
    level: 3,
    description: 'Entropi\u00f3n y triquiasis palpebral',
    code_2: 'H02',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'H021',
    level: 3,
    description: 'Ectropi\u00f3n del p\u00e1rpado',
    code_2: 'H02',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'H022',
    level: 3,
    description: 'Lagoftalmos',
    code_2: 'H02',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'H023',
    level: 3,
    description: 'Blefarocalasia',
    code_2: 'H02',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'H024',
    level: 3,
    description: 'Blefaroptosis',
    code_2: 'H02',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'H025',
    level: 3,
    description: 'Otros trastornos funcionales del p\u00e1rpado',
    code_2: 'H02',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'H026',
    level: 3,
    description: 'Xantelasma del p\u00e1rpado',
    code_2: 'H02',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'H027',
    level: 3,
    description:
      'Otros trastornos degenerativos del p\u00e1rpado y del \u00e1rea periocular',
    code_2: 'H02',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'H028',
    level: 3,
    description: 'Otros trastornos especificados del p\u00e1rpado',
    code_2: 'H02',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'H029',
    level: 3,
    description: 'Trastorno del p\u00e1rpado, no especificado',
    code_2: 'H02',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'H010',
    level: 3,
    description: 'Blefaritis',
    code_2: 'H01',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'H011',
    level: 3,
    description: 'Dermatosis no infecciosa del p\u00e1rpado',
    code_2: 'H01',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'H018',
    level: 3,
    description: 'Otras inflamaciones especificadas del p\u00e1rpado',
    code_2: 'H01',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'H019',
    level: 3,
    description: 'Inflamaci\u00f3n del p\u00e1rpado, no especificada',
    code_2: 'H01',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'H000',
    level: 3,
    description: 'Orzuelo y otras inflamaciones profundas del p\u00e1rpado',
    code_2: 'H00',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'H001',
    level: 3,
    description: 'Calacio [chalazi\u00f3n]',
    code_2: 'H00',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'Q90',
    level: 2,
    description: 'S\u00edndrome de Down',
    code_1: 'Q90-Q99',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q91',
    level: 2,
    description: 'S\u00edndrome de Edwards y s\u00edndrome de Patau',
    code_1: 'Q90-Q99',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q92',
    level: 2,
    description:
      'Otras trisom\u00edas y trisom\u00edas parciales de los autosomas, no clasificadas en otra parte',
    code_1: 'Q90-Q99',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q93',
    level: 2,
    description:
      'Monosom\u00edas y supresiones de los autosomas, no clasificadas en otra parte',
    code_1: 'Q90-Q99',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q95',
    level: 2,
    description:
      'Reordenamientos equilibrados y marcadores estructurales, no clasificados en otra parte',
    code_1: 'Q90-Q99',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q96',
    level: 2,
    description: 'S\u00edndrome de Turner',
    code_1: 'Q90-Q99',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q97',
    level: 2,
    description:
      'Otras anomal\u00edas de los cromosomas sexuales, con fenotipo femenino, no clasificadas en otra parte',
    code_1: 'Q90-Q99',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q80',
    level: 2,
    description: 'Ictiosis cong\u00e9nita',
    code_1: 'Q80-Q89',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q81',
    level: 2,
    description: 'Epiderm\u00f3lisis bullosa',
    code_1: 'Q80-Q89',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q82',
    level: 2,
    description: 'Otras malformaciones cong\u00e9nitas de la piel',
    code_1: 'Q80-Q89',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q83',
    level: 2,
    description: 'Malformaciones cong\u00e9nitas de la mama',
    code_1: 'Q80-Q89',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q65',
    level: 2,
    description: 'Deformidades cong\u00e9nitas de la cadera',
    code_1: 'Q65-Q79',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q66',
    level: 2,
    description: 'Deformidades cong\u00e9nitas de los pies',
    code_1: 'Q65-Q79',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q67',
    level: 2,
    description:
      'Deformidades osteomusculares cong\u00e9nitas de la cabeza, de la cara, de la columna vertebral y del t\u00f3rax',
    code_1: 'Q65-Q79',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q68',
    level: 2,
    description: 'Otras deformidades osteomusculares cong\u00e9nitas',
    code_1: 'Q65-Q79',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q69',
    level: 2,
    description: 'Polidactilia',
    code_1: 'Q65-Q79',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q70',
    level: 2,
    description: 'Sindactilia',
    code_1: 'Q65-Q79',
    code_0: 'Q00-Q99'
  },
  {
    code: 'G719',
    level: 3,
    description: 'Trastorno primario del m\u00fasculo, tipo no especificado',
    code_2: 'G71',
    code_0: 'G00-G99',
    code_1: 'G70-G73'
  },
  {
    code: 'Q60',
    level: 2,
    description:
      'Agenesia renal y otras malformaciones hipopl\u00e1sicas del ri\u00f1\u00f3n',
    code_1: 'Q60-Q64',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q61',
    level: 2,
    description: 'Enfermedad qu\u00edstica del ri\u00f1\u00f3n',
    code_1: 'Q60-Q64',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q62',
    level: 2,
    description:
      'Defectos obstructivos cong\u00e9nitos de la pelvis renal y malformaciones cong\u00e9nitas del ur\u00e9ter',
    code_1: 'Q60-Q64',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q63',
    level: 2,
    description: 'Otras malformaciones cong\u00e9nitas del ri\u00f1\u00f3n',
    code_1: 'Q60-Q64',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q64',
    level: 2,
    description: 'Otras malformaciones cong\u00e9nitas del sistema urinario',
    code_1: 'Q60-Q64',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q50',
    level: 2,
    description:
      'Malformaciones cong\u00e9nitas de los ovarios, de las trompas de Falopio y de los ligamentos anchos',
    code_1: 'Q50-Q56',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q51',
    level: 2,
    description:
      'Malformaciones cong\u00e9nitas del \u00fatero y del cuello uterino',
    code_1: 'Q50-Q56',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q52',
    level: 2,
    description:
      'Otras malformaciones cong\u00e9nitas de los \u00f3rganos genitales femeninos',
    code_1: 'Q50-Q56',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q53',
    level: 2,
    description: 'Test\u00edculo no descendido',
    code_1: 'Q50-Q56',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q54',
    level: 2,
    description: 'Hipospadias',
    code_1: 'Q50-Q56',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q55',
    level: 2,
    description:
      'Otras malformaciones cong\u00e9nitas de los \u00f3rganos genitales masculinos',
    code_1: 'Q50-Q56',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q56',
    level: 2,
    description: 'Sexo indeterminado y seudohermafroditismo',
    code_1: 'Q50-Q56',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q38',
    level: 2,
    description:
      'Otras malformaciones cong\u00e9nitas de la lengua, de la boca y de la faringe',
    code_1: 'Q38-Q45',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q39',
    level: 2,
    description: 'Malformaciones cong\u00e9nitas del es\u00f3fago',
    code_1: 'Q38-Q45',
    code_0: 'Q00-Q99'
  },
  {
    code: 'G941',
    level: 3,
    description:
      'Hidroc\u00e9falo en enfermedad neopl\u00e1sica (C00\u2013D48)',
    code_2: 'G94',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G942',
    level: 3,
    description:
      'Hidroc\u00e9falo en otras enfermedades clasificadas en otra parte',
    code_2: 'G94',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G948',
    level: 3,
    description:
      'Otros trastornos encef\u00e1licos especificados en enfermedades clasificadas en otra parte',
    code_2: 'G94',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G931',
    level: 3,
    description:
      'Lesi\u00f3n cerebral an\u00f3xica, no clasificada en otra parte',
    code_2: 'G93',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G932',
    level: 3,
    description: 'Hipertensi\u00f3n intracraneal benigna',
    code_2: 'G93',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G933',
    level: 3,
    description: 'S\u00edndrome de fatiga postviral',
    code_2: 'G93',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G934',
    level: 3,
    description: 'Encefalopat\u00eda no especificada',
    code_2: 'G93',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G935',
    level: 3,
    description: 'Compresi\u00f3n del enc\u00e9falo',
    code_2: 'G93',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G936',
    level: 3,
    description: 'Edema cerebral',
    code_2: 'G93',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G937',
    level: 3,
    description: 'S\u00edndrome de Reye',
    code_2: 'G93',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G938',
    level: 3,
    description: 'Otros trastornos especificados del enc\u00e9falo',
    code_2: 'G93',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G939',
    level: 3,
    description: 'Trastorno del enc\u00e9falo, no especificado',
    code_2: 'G93',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'Q35',
    level: 2,
    description: 'Fisura del paladar',
    code_1: 'Q35-Q37',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q36',
    level: 2,
    description: 'Labio leporino',
    code_1: 'Q35-Q37',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q37',
    level: 2,
    description: 'Fisura del paladar con labio leporino',
    code_1: 'Q35-Q37',
    code_0: 'Q00-Q99'
  },
  {
    code: 'G918',
    level: 3,
    description: 'Otros tipos de hidroc\u00e9falo',
    code_2: 'G91',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G919',
    level: 3,
    description: 'Hidroc\u00e9falo, no especificado',
    code_2: 'G91',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G908',
    level: 3,
    description: 'Otros trastornos del sistema nervioso aut\u00f3nomo',
    code_2: 'G90',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'G909',
    level: 3,
    description:
      'Trastorno del sistema nervioso aut\u00f3nomo, no especificado',
    code_2: 'G90',
    code_0: 'G00-G99',
    code_1: 'G90-G99'
  },
  {
    code: 'A066',
    level: 3,
    description: 'Absceso amebiano del cerebro (G07)',
    code_2: 'A06',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A067',
    level: 3,
    description: 'Amebiasis cut\u00e1nea',
    code_2: 'A06',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A068',
    level: 3,
    description: 'Infecci\u00f3n amebiana de otras localizaciones',
    code_2: 'A06',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A069',
    level: 3,
    description: 'Amebiasis, no especificada',
    code_2: 'A06',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'Q30',
    level: 2,
    description: 'Malformaciones cong\u00e9nitas de la nariz',
    code_1: 'Q30-Q34',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q31',
    level: 2,
    description: 'Malformaciones cong\u00e9nitas de la laringe',
    code_1: 'Q30-Q34',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q32',
    level: 2,
    description:
      'Malformaciones cong\u00e9nitas de la tr\u00e1quea y de los bronquios',
    code_1: 'Q30-Q34',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q33',
    level: 2,
    description: 'Malformaciones cong\u00e9nitas del pulm\u00f3n',
    code_1: 'Q30-Q34',
    code_0: 'Q00-Q99'
  },
  {
    code: 'A058',
    level: 3,
    description:
      'Otras intoxicaciones alimentarias debidas a bacterias especificadas',
    code_2: 'A05',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A059',
    level: 3,
    description: 'Intoxicaci\u00f3n alimentaria bacteriana, no especificada',
    code_2: 'A05',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A045',
    level: 3,
    description: 'Enteritis debida a Campylobacter',
    code_2: 'A04',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A046',
    level: 3,
    description: 'Enteritis debida a Yersinia enterocolitica',
    code_2: 'A04',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A047',
    level: 3,
    description: 'Enterocolitis debida a Clostridium difficile',
    code_2: 'A04',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A048',
    level: 3,
    description: 'Otras infecciones intestinales bacterianas especificadas',
    code_2: 'A04',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A049',
    level: 3,
    description: 'Infecci\u00f3n intestinal bacteriana, no especificada',
    code_2: 'A04',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'A039',
    level: 3,
    description: 'Shigelosis de tipo no especificado',
    code_2: 'A03',
    code_0: 'A00-B99',
    code_1: 'A00-A09'
  },
  {
    code: 'H130',
    level: 3,
    description: 'Infecci\u00f3n fil\u00e1rica de la conjuntiva (B74.\u2013)',
    code_2: 'H13',
    code_0: 'H00-H59',
    code_1: 'H10-H13'
  },
  {
    code: 'H131',
    level: 3,
    description:
      'Conjuntivitis en enfermedades infecciosas y parasitarias clasificadas en otra parte',
    code_2: 'H13',
    code_0: 'H00-H59',
    code_1: 'H10-H13'
  },
  {
    code: 'H132',
    level: 3,
    description:
      'Conjuntivitis en otras enfermedades clasificadas en otra parte',
    code_2: 'H13',
    code_0: 'H00-H59',
    code_1: 'H10-H13'
  },
  {
    code: 'H133',
    level: 3,
    description: 'Penfigoide ocular (L12.\u2013)',
    code_2: 'H13',
    code_0: 'H00-H59',
    code_1: 'H10-H13'
  },
  {
    code: 'H138',
    level: 3,
    description:
      'Otros trastornos de la conjuntiva en enfermedades clasificadas en otra parte',
    code_2: 'H13',
    code_0: 'H00-H59',
    code_1: 'H10-H13'
  },
  {
    code: 'H110',
    level: 3,
    description: 'Pterigi\u00f3n',
    code_2: 'H11',
    code_0: 'H00-H59',
    code_1: 'H10-H13'
  },
  {
    code: 'H111',
    level: 3,
    description: 'Degeneraciones y dep\u00f3sitos conjuntivales',
    code_2: 'H11',
    code_0: 'H00-H59',
    code_1: 'H10-H13'
  },
  {
    code: 'H112',
    level: 3,
    description: 'Cicatrices conjuntivales',
    code_2: 'H11',
    code_0: 'H00-H59',
    code_1: 'H10-H13'
  },
  {
    code: 'H113',
    level: 3,
    description: 'Hemorragia conjuntival',
    code_2: 'H11',
    code_0: 'H00-H59',
    code_1: 'H10-H13'
  },
  {
    code: 'H114',
    level: 3,
    description: 'Otros trastornos vasculares y quistes conjuntivales',
    code_2: 'H11',
    code_0: 'H00-H59',
    code_1: 'H10-H13'
  },
  {
    code: 'H118',
    level: 3,
    description: 'Otros trastornos especificados de la conjuntiva',
    code_2: 'H11',
    code_0: 'H00-H59',
    code_1: 'H10-H13'
  },
  {
    code: 'H119',
    level: 3,
    description: 'Trastorno de la conjuntiva, no especificado',
    code_2: 'H11',
    code_0: 'H00-H59',
    code_1: 'H10-H13'
  },
  {
    code: 'H100',
    level: 3,
    description: 'Conjuntivitis mucopurulenta',
    code_2: 'H10',
    code_0: 'H00-H59',
    code_1: 'H10-H13'
  },
  {
    code: 'H101',
    level: 3,
    description: 'Conjuntivitis at\u00f3pica aguda',
    code_2: 'H10',
    code_0: 'H00-H59',
    code_1: 'H10-H13'
  },
  {
    code: 'H102',
    level: 3,
    description: 'Otras conjuntivitis agudas',
    code_2: 'H10',
    code_0: 'H00-H59',
    code_1: 'H10-H13'
  },
  {
    code: 'H103',
    level: 3,
    description: 'Conjuntivitis aguda, no especificada',
    code_2: 'H10',
    code_0: 'H00-H59',
    code_1: 'H10-H13'
  },
  {
    code: 'H104',
    level: 3,
    description: 'Conjuntivitis cr\u00f3nica',
    code_2: 'H10',
    code_0: 'H00-H59',
    code_1: 'H10-H13'
  },
  {
    code: 'H105',
    level: 3,
    description: 'Blefaroconjuntivitis',
    code_2: 'H10',
    code_0: 'H00-H59',
    code_1: 'H10-H13'
  },
  {
    code: 'H108',
    level: 3,
    description: 'Otras conjuntivitis',
    code_2: 'H10',
    code_0: 'H00-H59',
    code_1: 'H10-H13'
  },
  {
    code: 'R95',
    level: 2,
    description: 'S\u00edndrome de la muerte s\u00fabita infantil',
    code_1: 'R95-R99',
    code_0: 'R00-R99'
  },
  {
    code: 'R96',
    level: 2,
    description: 'Otras muertes s\u00fabitas de causa desconocida',
    code_1: 'R95-R99',
    code_0: 'R00-R99'
  },
  {
    code: 'R90',
    level: 2,
    description:
      'Hallazgos anormales en diagn\u00f3stico por imagen del sistema nervioso central',
    code_1: 'R90-R94',
    code_0: 'R00-R99'
  },
  {
    code: 'R91',
    level: 2,
    description:
      'Hallazgos anormales en diagn\u00f3stico por imagen del pulm\u00f3n',
    code_1: 'R90-R94',
    code_0: 'R00-R99'
  },
  {
    code: 'R92',
    level: 2,
    description:
      'Hallazgos anormales en diagn\u00f3stico por imagen de la mama',
    code_1: 'R90-R94',
    code_0: 'R00-R99'
  },
  {
    code: 'R93',
    level: 2,
    description:
      'Hallazgos anormales en diagn\u00f3stico por imagen de otras estructuras del cuerpo',
    code_1: 'R90-R94',
    code_0: 'R00-R99'
  },
  {
    code: 'R94',
    level: 2,
    description: 'Resultados anormales de estudios funcionales',
    code_1: 'R90-R94',
    code_0: 'R00-R99'
  },
  {
    code: 'F515',
    level: 3,
    description: 'Pesadillas',
    code_2: 'F51',
    code_0: 'F01-F99',
    code_1: 'F50-F59'
  },
  {
    code: 'F518',
    level: 3,
    description: 'Otros trastornos no org\u00e1nicos del sue\u00f1o',
    code_2: 'F51',
    code_0: 'F01-F99',
    code_1: 'F50-F59'
  },
  {
    code: 'F519',
    level: 3,
    description: 'Trastorno no org\u00e1nico del sue\u00f1o, no especificado',
    code_2: 'F51',
    code_0: 'F01-F99',
    code_1: 'F50-F59'
  },
  {
    code: 'R83',
    level: 2,
    description: 'Hallazgos anormales en el l\u00edquido cefalorraqu\u00eddeo',
    code_1: 'R83-R89',
    code_0: 'R00-R99'
  },
  {
    code: 'R84',
    level: 2,
    description:
      'Hallazgos anormales en muestras tomadas de \u00f3rganos respiratorios y tor\u00e1cicos',
    code_1: 'R83-R89',
    code_0: 'R00-R99'
  },
  {
    code: 'R85',
    level: 2,
    description:
      'Hallazgos anormales en muestras tomadas de \u00f3rganos digestivos y de la cavidad abdominal',
    code_1: 'R83-R89',
    code_0: 'R00-R99'
  },
  {
    code: 'R86',
    level: 2,
    description:
      'Hallazgos anormales en muestras tomadas de \u00f3rganos genitales masculinos',
    code_1: 'R83-R89',
    code_0: 'R00-R99'
  },
  {
    code: 'R80',
    level: 2,
    description: 'Proteinuria aislada',
    code_1: 'R80-R82',
    code_0: 'R00-R99'
  },
  {
    code: 'R81',
    level: 2,
    description: 'Glucosuria',
    code_1: 'R80-R82',
    code_0: 'R00-R99'
  },
  {
    code: 'R82',
    level: 2,
    description: 'Otros hallazgos anormales en la orina',
    code_1: 'R80-R82',
    code_0: 'R00-R99'
  },
  {
    code: 'R70',
    level: 2,
    description:
      'Velocidad de eritrosedimentaci\u00f3n elevada y otras anormalidades de la viscosidad del plasma',
    code_1: 'R70-R79',
    code_0: 'R00-R99'
  },
  {
    code: 'R71',
    level: 2,
    description: 'Anormalidad de los eritrocitos',
    code_1: 'R70-R79',
    code_0: 'R00-R99'
  },
  {
    code: 'R72',
    level: 2,
    description:
      'Anormalidades de los leucocitos, no clasificadas en otra parte',
    code_1: 'R70-R79',
    code_0: 'R00-R99'
  },
  {
    code: 'R73',
    level: 2,
    description: 'Nivel elevado de glucosa en sangre',
    code_1: 'R70-R79',
    code_0: 'R00-R99'
  },
  {
    code: 'R74',
    level: 2,
    description: 'Nivel anormal de enzimas en suero',
    code_1: 'R70-R79',
    code_0: 'R00-R99'
  },
  {
    code: 'R50',
    level: 2,
    description: 'Fiebre de otro origen y de origen desconocido',
    code_1: 'R50-R69',
    code_0: 'R00-R99'
  },
  {
    code: 'R51',
    level: 2,
    description: 'Cefalea',
    code_1: 'R50-R69',
    code_0: 'R00-R99'
  },
  {
    code: 'R52',
    level: 2,
    description: 'Dolor, no clasificado en otra parte',
    code_1: 'R50-R69',
    code_0: 'R00-R99'
  },
  {
    code: 'R53',
    level: 2,
    description: 'Malestar y fatiga',
    code_1: 'R50-R69',
    code_0: 'R00-R99'
  },
  {
    code: 'R54',
    level: 2,
    description: 'Senilidad',
    code_1: 'R50-R69',
    code_0: 'R00-R99'
  },
  {
    code: 'R55',
    level: 2,
    description: 'S\u00edncope y colapso',
    code_1: 'R50-R69',
    code_0: 'R00-R99'
  },
  {
    code: 'H210',
    level: 3,
    description: 'Hifema',
    code_2: 'H21',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H211',
    level: 3,
    description: 'Otros trastornos vasculares del iris y del cuerpo ciliar',
    code_2: 'H21',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H212',
    level: 3,
    description: 'Degeneraci\u00f3n del iris y del cuerpo ciliar',
    code_2: 'H21',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H213',
    level: 3,
    description:
      'Quiste del iris, del cuerpo ciliar y de la c\u00e1mara anterior',
    code_2: 'H21',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H214',
    level: 3,
    description: 'Membranas pupilares',
    code_2: 'H21',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H215',
    level: 3,
    description: 'Otras adherencias y desgarros del iris y del cuerpo ciliar',
    code_2: 'H21',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H200',
    level: 3,
    description: 'Iridociclitis aguda y subaguda',
    code_2: 'H20',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H201',
    level: 3,
    description: 'Iridociclitis cr\u00f3nica',
    code_2: 'H20',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H202',
    level: 3,
    description: 'Iridociclitis inducida por trastorno del cristalino',
    code_2: 'H20',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H208',
    level: 3,
    description: 'Otras iridociclitis especificadas',
    code_2: 'H20',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H209',
    level: 3,
    description: 'Iridociclitis, no especificada',
    code_2: 'H20',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H190',
    level: 3,
    description:
      'Escleritis y episcleritis en enfermedades clasificadas en otra parte',
    code_2: 'H19',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H191',
    level: 3,
    description: 'Queratitis y queratoconjuntivitis por herpes simple (B00.5)',
    code_2: 'H19',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H192',
    level: 3,
    description:
      'Queratitis y queratoconjuntivitis en enfermedades infecciosas y parasitarias, clasificadas en otra parte',
    code_2: 'H19',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H193',
    level: 3,
    description:
      'Queratitis y queratoconjuntivitis en otras enfermedades clasificadas en otra parte',
    code_2: 'H19',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H198',
    level: 3,
    description:
      'Otros trastornos de la escler\u00f3tica y de la c\u00f3rnea en enfermedades clasificadas en otra parte',
    code_2: 'H19',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H180',
    level: 3,
    description: 'Pigmentaciones y dep\u00f3sitos en la c\u00f3rnea',
    code_2: 'H18',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H181',
    level: 3,
    description: 'Queratopat\u00eda vesicular',
    code_2: 'H18',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H182',
    level: 3,
    description: 'Otros edemas de la c\u00f3rnea',
    code_2: 'H18',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H170',
    level: 3,
    description: 'Leucoma adherente',
    code_2: 'H17',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H171',
    level: 3,
    description: 'Otras opacidades centrales de la c\u00f3rnea',
    code_2: 'H17',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H178',
    level: 3,
    description: 'Otras opacidades o cicatrices de la c\u00f3rnea',
    code_2: 'H17',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H179',
    level: 3,
    description: 'Cicatriz u opacidad de la c\u00f3rnea, no especificada',
    code_2: 'H17',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H160',
    level: 3,
    description: '\u00dalcera de la c\u00f3rnea',
    code_2: 'H16',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H161',
    level: 3,
    description: 'Otras queratitis superficiales sin conjuntivitis',
    code_2: 'H16',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H162',
    level: 3,
    description: 'Queratoconjuntivitis',
    code_2: 'H16',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H163',
    level: 3,
    description: 'Queratitis intersticial y profunda',
    code_2: 'H16',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H150',
    level: 3,
    description: 'Escleritis',
    code_2: 'H15',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H151',
    level: 3,
    description: 'Episcleritis',
    code_2: 'H15',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H158',
    level: 3,
    description: 'Otros trastornos de la escler\u00f3tica',
    code_2: 'H15',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H159',
    level: 3,
    description: 'Trastorno de la escler\u00f3tica, no especificado',
    code_2: 'H15',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H620',
    level: 3,
    description:
      'Otitis externa en enfermedades bacterianas clasificadas en otra parte',
    code_2: 'H62',
    code_0: 'H60-H95',
    code_1: 'H60-H62'
  },
  {
    code: 'H621',
    level: 3,
    description:
      'Otitis externa en enfermedades virales clasificadas en otra parte',
    code_2: 'H62',
    code_0: 'H60-H95',
    code_1: 'H60-H62'
  },
  {
    code: 'H622',
    level: 3,
    description: 'Otitis externa en micosis',
    code_2: 'H62',
    code_0: 'H60-H95',
    code_1: 'H60-H62'
  },
  {
    code: 'H623',
    level: 3,
    description:
      'Otitis externa en otras enfermedades infecciosas y parasitarias clasificadas en otra parte',
    code_2: 'H62',
    code_0: 'H60-H95',
    code_1: 'H60-H62'
  },
  {
    code: 'H610',
    level: 3,
    description: 'Pericondritis del o\u00eddo externo',
    code_2: 'H61',
    code_0: 'H60-H95',
    code_1: 'H60-H62'
  },
  {
    code: 'H611',
    level: 3,
    description: 'Afecciones no infecciosas del pabell\u00f3n auditivo',
    code_2: 'H61',
    code_0: 'H60-H95',
    code_1: 'H60-H62'
  },
  {
    code: 'H612',
    level: 3,
    description: 'Cerumen impactado',
    code_2: 'H61',
    code_0: 'H60-H95',
    code_1: 'H60-H62'
  },
  {
    code: 'H613',
    level: 3,
    description: 'Estenosis adquirida del conducto auditivo externo',
    code_2: 'H61',
    code_0: 'H60-H95',
    code_1: 'H60-H62'
  },
  {
    code: 'H600',
    level: 3,
    description: 'Absceso del o\u00eddo externo',
    code_2: 'H60',
    code_0: 'H60-H95',
    code_1: 'H60-H62'
  },
  {
    code: 'H601',
    level: 3,
    description: 'Celulitis del o\u00eddo externo',
    code_2: 'H60',
    code_0: 'H60-H95',
    code_1: 'H60-H62'
  },
  {
    code: 'H602',
    level: 3,
    description: 'Otitis externa maligna',
    code_2: 'H60',
    code_0: 'H60-H95',
    code_1: 'H60-H62'
  },
  {
    code: 'H603',
    level: 3,
    description: 'Otras otitis externas infecciosas',
    code_2: 'H60',
    code_0: 'H60-H95',
    code_1: 'H60-H62'
  },
  {
    code: 'H604',
    level: 3,
    description: 'Colesteatoma del o\u00eddo externo',
    code_2: 'H60',
    code_0: 'H60-H95',
    code_1: 'H60-H62'
  },
  {
    code: 'H605',
    level: 3,
    description: 'Otitis externa aguda, no infecciosa',
    code_2: 'H60',
    code_0: 'H60-H95',
    code_1: 'H60-H62'
  },
  {
    code: 'H608',
    level: 3,
    description: 'Otras otitis externas',
    code_2: 'H60',
    code_0: 'H60-H95',
    code_1: 'H60-H62'
  },
  {
    code: 'H660',
    level: 3,
    description: 'Otitis media supurativa aguda',
    code_2: 'H66',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'H661',
    level: 3,
    description: 'Otitis media tubotimp\u00e1nica supurativa cr\u00f3nica',
    code_2: 'H66',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'H662',
    level: 3,
    description: 'Otitis media supurativa cr\u00f3nica aticoantral',
    code_2: 'H66',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'H663',
    level: 3,
    description: 'Otras otitis medias cr\u00f3nicas supurativas',
    code_2: 'H66',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'H664',
    level: 3,
    description: 'Otitis media supurativa, sin otra especificaci\u00f3n',
    code_2: 'H66',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'Y98',
    level: 2,
    description: 'Afecci\u00f3n relacionada con el estilo de vida',
    code_1: 'Y90-Y98',
    code_0: 'V01-Y99'
  },
  {
    code: 'S027',
    level: 3,
    description:
      'Fracturas m\u00faltiples que comprometen el cr\u00e1neo y los huesos de la cara',
    code_2: 'S02',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S028',
    level: 3,
    description: 'Fractura de otros huesos del cr\u00e1neo y de la cara',
    code_2: 'S02',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'S029',
    level: 3,
    description:
      'Fractura del cr\u00e1neo y de los huesos de la cara, parte no especificada',
    code_2: 'S02',
    code_0: 'S00-T88',
    code_1: 'S00-S09'
  },
  {
    code: 'C95',
    level: 3,
    description: 'Leucemia de c\u00e9lulas de tipo no especificado',
    code_2: 'C81-C96',
    code_0: 'C00-D49',
    code_1: 'C00-C97'
  },
  {
    code: 'C96',
    level: 3,
    description:
      'Otros tumores malignos y los no especificados del tejido linf\u00e1tico, de los \u00f3rganos hematopoy\u00e9ticos y de tejidos afines',
    code_2: 'C81-C96',
    code_0: 'C00-D49',
    code_1: 'C00-C97'
  },
  {
    code: 'O98',
    level: 2,
    description:
      'Enfermedades maternas infecciosas y parasitarias clasificables en otra parte, pero que complican el embarazo, el parto y el puerperio',
    code_1: 'O94-O99',
    code_0: 'O00-O9A'
  },
  {
    code: 'O99',
    level: 2,
    description:
      'Otras enfermedades maternas clasificables en otra parte, pero que complican el embarazo, el parto y el puerperio',
    code_1: 'O94-O99',
    code_0: 'O00-O9A'
  },
  {
    code: 'O91',
    level: 2,
    description: 'Infecciones de la mama asociadas con el parto',
    code_1: 'O85-O92',
    code_0: 'O00-O9A'
  },
  {
    code: 'O92',
    level: 2,
    description:
      'Otros trastornos de la mama y de la lactancia asociados con el parto',
    code_1: 'O85-O92',
    code_0: 'O00-O9A'
  },
  {
    code: 'O66',
    level: 2,
    description: 'Otras obstrucciones del trabajo de parto',
    code_1: 'O60-O75',
    code_0: 'O00-O9A'
  },
  {
    code: 'O67',
    level: 2,
    description:
      'Trabajo de parto y parto complicados por hemorragia intraparto, no clasificados en otra parte',
    code_1: 'O60-O75',
    code_0: 'O00-O9A'
  },
  {
    code: 'O68',
    level: 2,
    description: 'Trabajo de parto y parto complicados por sufrimiento fetal',
    code_1: 'O60-O75',
    code_0: 'O00-O9A'
  },
  {
    code: 'O69',
    level: 2,
    description:
      'Trabajo de parto y parto complicados por problemas del cord\u00f3n umbilical',
    code_1: 'O60-O75',
    code_0: 'O00-O9A'
  },
  {
    code: 'O70',
    level: 2,
    description: 'Desgarro perineal durante el parto',
    code_1: 'O60-O75',
    code_0: 'O00-O9A'
  },
  {
    code: 'O71',
    level: 2,
    description: 'Otro trauma obst\u00e9trico',
    code_1: 'O60-O75',
    code_0: 'O00-O9A'
  },
  {
    code: 'P96',
    level: 2,
    description: 'Otras afecciones originadas en el per\u00edodo perinatal',
    code_1: 'P90-P96',
    code_0: 'P00-P96'
  },
  {
    code: 'C40',
    level: 4,
    description:
      'Tumor maligno de los huesos y de los cart\u00edlagos articulares de los miembros',
    code_3: 'C40-C41',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C41',
    level: 4,
    description:
      'Tumor maligno de los huesos y de los cart\u00edlagos articulares, de otros sitios y de sitios no especificados',
    code_3: 'C40-C41',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C30',
    level: 4,
    description: 'Tumor maligno de las fosas nasales y del o\u00eddo medio',
    code_3: 'C30-C39',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C31',
    level: 4,
    description: 'Tumor maligno de los senos paranasales',
    code_3: 'C30-C39',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C32',
    level: 4,
    description: 'Tumor maligno de la laringe',
    code_3: 'C30-C39',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C33',
    level: 4,
    description: 'Tumor maligno de la tr\u00e1quea',
    code_3: 'C30-C39',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C34',
    level: 4,
    description: 'Tumor maligno de los bronquios y del pulm\u00f3n',
    code_3: 'C30-C39',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C37',
    level: 4,
    description: 'Tumor maligno del timo',
    code_3: 'C30-C39',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C38',
    level: 4,
    description:
      'Tumor maligno del coraz\u00f3n, del mediastino y de la pleura',
    code_3: 'C30-C39',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C15',
    level: 4,
    description: 'Tumor maligno del es\u00f3fago',
    code_3: 'C15-C26',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C16',
    level: 4,
    description: 'Tumor maligno del est\u00f3mago',
    code_3: 'C15-C26',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C17',
    level: 4,
    description: 'Tumor maligno del intestino delgado',
    code_3: 'C15-C26',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'H045',
    level: 3,
    description: 'Estenosis e insuficiencia de las v\u00edas lagrimales',
    code_2: 'H04',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'H046',
    level: 3,
    description: 'Otros cambios de las v\u00edas lagrimales',
    code_2: 'H04',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'H048',
    level: 3,
    description: 'Otros trastornos especificados del aparato lagrimal',
    code_2: 'H04',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'H049',
    level: 3,
    description: 'Trastorno del aparato lagrimal, no especificado',
    code_2: 'H04',
    code_0: 'H00-H59',
    code_1: 'H00-H06'
  },
  {
    code: 'C00',
    level: 4,
    description: 'Tumor maligno del labio',
    code_3: 'C00-C14',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C01',
    level: 4,
    description: 'Tumor maligno de la base de la lengua',
    code_3: 'C00-C14',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C02',
    level: 4,
    description:
      'Tumor maligno de otras partes y de las no especificadas de la lengua',
    code_3: 'C00-C14',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'Q98',
    level: 2,
    description:
      'Otras anomal\u00edas de los cromosomas sexuales, con fenotipo masculino, no clasificadas en otra parte',
    code_1: 'Q90-Q99',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q99',
    level: 2,
    description:
      'Otras anomal\u00edas cromos\u00f3micas, no clasificadas en otra parte',
    code_1: 'Q90-Q99',
    code_0: 'Q00-Q99'
  },
  {
    code: 'C770',
    level: 4,
    description:
      'Tumor maligno de los ganglios linf\u00e1ticos de la cabeza, cara y cuello',
    code_3: 'C77',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C76-C80'
  },
  {
    code: 'C771',
    level: 4,
    description:
      'Tumor maligno de los ganglios linf\u00e1ticos intrator\u00e1cicos',
    code_3: 'C77',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C76-C80'
  },
  {
    code: 'C772',
    level: 4,
    description:
      'Tumor maligno de los ganglios linf\u00e1ticos intraabdominales',
    code_3: 'C77',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C76-C80'
  },
  {
    code: 'C773',
    level: 4,
    description:
      'Tumor maligno de los ganglios linf\u00e1ticos de la axila y del miembro superior',
    code_3: 'C77',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C76-C80'
  },
  {
    code: 'C774',
    level: 4,
    description:
      'Tumor maligno de los ganglios linf\u00e1ticos de la regi\u00f3n inguinal y del miembro inferior',
    code_3: 'C77',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C76-C80'
  },
  {
    code: 'C775',
    level: 4,
    description: 'Tumor maligno de los ganglios linf\u00e1ticos de la pelvis',
    code_3: 'C77',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C76-C80'
  },
  {
    code: 'C778',
    level: 4,
    description:
      'Tumor maligno de los ganglios linf\u00e1ticos de regiones m\u00faltiples',
    code_3: 'C77',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C76-C80'
  },
  {
    code: 'C779',
    level: 4,
    description:
      'Tumor maligno del ganglio linf\u00e1tico, sitio no especificado',
    code_3: 'C77',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C76-C80'
  },
  {
    code: 'Q84',
    level: 2,
    description: 'Otras malformaciones cong\u00e9nitas de las faneras',
    code_1: 'Q80-Q89',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q85',
    level: 2,
    description: 'Facomatosis, no clasificada en otra parte',
    code_1: 'Q80-Q89',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q86',
    level: 2,
    description:
      'S\u00edndromes de malformaciones cong\u00e9nitas debidos a causas ex\u00f3genas conocidas, no clasificados en otra parte',
    code_1: 'Q80-Q89',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q87',
    level: 2,
    description:
      'Otros s\u00edndromes de malformaciones cong\u00e9nitas especificados que afectan m\u00faltiples sistemas',
    code_1: 'Q80-Q89',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q89',
    level: 2,
    description:
      'Otras malformaciones cong\u00e9nitas, no clasificadas en otra parte',
    code_1: 'Q80-Q89',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q71',
    level: 2,
    description: 'Defectos por reducci\u00f3n del miembro superior',
    code_1: 'Q65-Q79',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q72',
    level: 2,
    description: 'Defectos por reducci\u00f3n del miembro inferior',
    code_1: 'Q65-Q79',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q73',
    level: 2,
    description: 'Defectos por reducci\u00f3n de miembro no especificado',
    code_1: 'Q65-Q79',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q74',
    level: 2,
    description: 'Otras anomal\u00edas cong\u00e9nitas del (de los) miembro(s)',
    code_1: 'Q65-Q79',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q75',
    level: 2,
    description:
      'Otras malformaciones cong\u00e9nitas de los huesos del cr\u00e1neo y de la cara',
    code_1: 'Q65-Q79',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q76',
    level: 2,
    description:
      'Malformaciones cong\u00e9nitas de la columna vertebral y t\u00f3rax \u00f3seo',
    code_1: 'Q65-Q79',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q77',
    level: 2,
    description:
      'Osteocondrodisplasia con defecto del crecimiento de los huesos largos y de la columna vertebral',
    code_1: 'Q65-Q79',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q78',
    level: 2,
    description: 'Otras osteocondrodisplasias',
    code_1: 'Q65-Q79',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q79',
    level: 2,
    description:
      'Malformaciones cong\u00e9nitas del sistema osteomuscular, no clasificadas en otra parte',
    code_1: 'Q65-Q79',
    code_0: 'Q00-Q99'
  },
  {
    code: 'C760',
    level: 4,
    description: 'Tumor maligno de la cabeza, cara y cuello',
    code_3: 'C76',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C76-C80'
  },
  {
    code: 'C761',
    level: 4,
    description: 'Tumor maligno del t\u00f3rax',
    code_3: 'C76',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C76-C80'
  },
  {
    code: 'C762',
    level: 4,
    description: 'Tumor maligno del abdomen',
    code_3: 'C76',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C76-C80'
  },
  {
    code: 'C763',
    level: 4,
    description: 'Tumor maligno de la pelvis',
    code_3: 'C76',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C76-C80'
  },
  {
    code: 'C764',
    level: 4,
    description: 'Tumor maligno del miembro superior',
    code_3: 'C76',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C76-C80'
  },
  {
    code: 'C765',
    level: 4,
    description: 'Tumor maligno del miembro inferior',
    code_3: 'C76',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C76-C80'
  },
  {
    code: 'C767',
    level: 4,
    description: 'Tumor maligno de otros sitios mal definidos',
    code_3: 'C76',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C76-C80'
  },
  {
    code: 'C768',
    level: 4,
    description: 'Lesi\u00f3n de sitios contiguos mal definidos',
    code_3: 'C76',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C76-C80'
  },
  {
    code: 'C830',
    level: 4,
    description: 'Linfoma no Hodgkin de c\u00e9lulas peque\u00f1as (difuso)',
    code_3: 'C83',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C831',
    level: 4,
    description:
      'Linfoma no Hodgkin de c\u00e9lulas peque\u00f1as hendidas (difuso)',
    code_3: 'C83',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C832',
    level: 4,
    description:
      'Linfoma no Hodgkin mixto, de c\u00e9lulas peque\u00f1as y grandes (difuso)',
    code_3: 'C83',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C833',
    level: 4,
    description: 'Linfoma no Hodgkin de c\u00e9lulas grandes (difuso)',
    code_3: 'C83',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C834',
    level: 4,
    description: 'Linfoma no Hodgkin inmunobl\u00e1stico (difuso)',
    code_3: 'C83',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C835',
    level: 4,
    description: 'Linfoma no Hodgkin linfobl\u00e1stico (difuso)',
    code_3: 'C83',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C836',
    level: 4,
    description: 'Linfoma no Hodgkin indiferenciado (difuso)',
    code_3: 'C83',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C837',
    level: 4,
    description: 'Tumor de Burkitt',
    code_3: 'C83',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C838',
    level: 4,
    description: 'Otros tipos especificados de linfoma no Hodgkin difuso',
    code_3: 'C83',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C839',
    level: 4,
    description: 'Linfoma no Hodgkin difuso, sin otra especificaci\u00f3n',
    code_3: 'C83',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C820',
    level: 4,
    description:
      'Linfoma no Hodgkin de c\u00e9lulas peque\u00f1as hendidas, folicular',
    code_3: 'C82',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C821',
    level: 4,
    description:
      'Linfoma no Hodkin mixto, de peque\u00f1as c\u00e9lulas hendidas y de grandes c\u00e9lulas, folicular',
    code_3: 'C82',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C822',
    level: 4,
    description: 'Linfoma no Hodgkin de c\u00e9lulas grandes, folicular',
    code_3: 'C82',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C810',
    level: 4,
    description: 'Enfermedad de Hodgkin con predominio linfoc\u00edtico',
    code_3: 'C81',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C811',
    level: 4,
    description: 'Enfermedad de Hodgkin con esclerosis nodular',
    code_3: 'C81',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C812',
    level: 4,
    description: 'Enfermedad de Hodgkin con celularidad mixta',
    code_3: 'C81',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'H650',
    level: 3,
    description: 'Otitis media aguda serosa',
    code_2: 'H65',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'H651',
    level: 3,
    description: 'Otra otitis media aguda, no supurativa',
    code_2: 'H65',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'H652',
    level: 3,
    description: 'Otitis media cr\u00f3nica serosa',
    code_2: 'H65',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'H653',
    level: 3,
    description: 'Otitis media cr\u00f3nica mucoide',
    code_2: 'H65',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'H830',
    level: 3,
    description: 'Laberintitis',
    code_2: 'H83',
    code_0: 'H60-H95',
    code_1: 'H80-H83'
  },
  {
    code: 'H831',
    level: 3,
    description: 'F\u00edstula del laberinto',
    code_2: 'H83',
    code_0: 'H60-H95',
    code_1: 'H80-H83'
  },
  {
    code: 'H832',
    level: 3,
    description: 'Disfunci\u00f3n del laberinto',
    code_2: 'H83',
    code_0: 'H60-H95',
    code_1: 'H80-H83'
  },
  {
    code: 'H833',
    level: 3,
    description: 'Efectos del ruido sobre el o\u00eddo interno',
    code_2: 'H83',
    code_0: 'H60-H95',
    code_1: 'H80-H83'
  },
  {
    code: 'H810',
    level: 3,
    description: 'Enfermedad de M\u00e9ni\u00e8re',
    code_2: 'H81',
    code_0: 'H60-H95',
    code_1: 'H80-H83'
  },
  {
    code: 'H811',
    level: 3,
    description: 'V\u00e9rtigo parox\u00edstico benigno',
    code_2: 'H81',
    code_0: 'H60-H95',
    code_1: 'H80-H83'
  },
  {
    code: 'H812',
    level: 3,
    description: 'Neuronitis vestibular',
    code_2: 'H81',
    code_0: 'H60-H95',
    code_1: 'H80-H83'
  },
  {
    code: 'H813',
    level: 3,
    description: 'Otros v\u00e9rtigos perif\u00e9ricos',
    code_2: 'H81',
    code_0: 'H60-H95',
    code_1: 'H80-H83'
  },
  {
    code: 'H800',
    level: 3,
    description: 'Otosclerosis que afecta la ventana oval, no obliterante',
    code_2: 'H80',
    code_0: 'H60-H95',
    code_1: 'H80-H83'
  },
  {
    code: 'H801',
    level: 3,
    description: 'Otosclerosis que afecta la ventana oval, obliterante',
    code_2: 'H80',
    code_0: 'H60-H95',
    code_1: 'H80-H83'
  },
  {
    code: 'H802',
    level: 3,
    description: 'Otosclerosis coclear',
    code_2: 'H80',
    code_0: 'H60-H95',
    code_1: 'H80-H83'
  },
  {
    code: 'H808',
    level: 3,
    description: 'Otras otosclerosis',
    code_2: 'H80',
    code_0: 'H60-H95',
    code_1: 'H80-H83'
  },
  {
    code: 'H809',
    level: 3,
    description: 'Otosclerosis, no especificada',
    code_2: 'H80',
    code_0: 'H60-H95',
    code_1: 'H80-H83'
  },
  {
    code: 'H910',
    level: 3,
    description: 'Hipoacusia otot\u00f3xica',
    code_2: 'H91',
    code_0: 'H60-H95',
    code_1: 'H90-H95'
  },
  {
    code: 'H911',
    level: 3,
    description: 'Presbiacusia',
    code_2: 'H91',
    code_0: 'H60-H95',
    code_1: 'H90-H95'
  },
  {
    code: 'H912',
    level: 3,
    description: 'Hipoacusia s\u00fabita idiop\u00e1tica',
    code_2: 'H91',
    code_0: 'H60-H95',
    code_1: 'H90-H95'
  },
  {
    code: 'H913',
    level: 3,
    description: 'Sordomudez, no clasificada en otra parte',
    code_2: 'H91',
    code_0: 'H60-H95',
    code_1: 'H90-H95'
  },
  {
    code: 'H918',
    level: 3,
    description: 'Otras hipoacusias especificadas',
    code_2: 'H91',
    code_0: 'H60-H95',
    code_1: 'H90-H95'
  },
  {
    code: 'H900',
    level: 3,
    description: 'Hipoacusia conductiva bilateral',
    code_2: 'H90',
    code_0: 'H60-H95',
    code_1: 'H90-H95'
  },
  {
    code: 'H901',
    level: 3,
    description:
      'Hipoacusia conductiva, unilateral con audici\u00f3n irrestricta',
    code_2: 'H90',
    code_0: 'H60-H95',
    code_1: 'H90-H95'
  },
  {
    code: 'H902',
    level: 3,
    description: 'Hipoacusia conductiva, sin otra especificaci\u00f3n',
    code_2: 'H90',
    code_0: 'H60-H95',
    code_1: 'H90-H95'
  },
  {
    code: 'H903',
    level: 3,
    description: 'Hipoacusia neurosensorial, bilateral',
    code_2: 'H90',
    code_0: 'H60-H95',
    code_1: 'H90-H95'
  },
  {
    code: 'H904',
    level: 3,
    description:
      'Hipoacusia neurosensorial, unilateral con audici\u00f3n irrestricta contralateral',
    code_2: 'H90',
    code_0: 'H60-H95',
    code_1: 'H90-H95'
  },
  {
    code: 'H905',
    level: 3,
    description: 'Hipoacusia neurosensorial, sin otra especificaci\u00f3n',
    code_2: 'H90',
    code_0: 'H60-H95',
    code_1: 'H90-H95'
  },
  {
    code: 'Y40-Y59',
    level: 2,
    description:
      'Drogas, medicamentos y sustancias biol\u00f3gicas causantes de efectos adversos en su uso terap\u00e9utico',
    code_1: 'Y40-Y84',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y60-Y69',
    level: 2,
    description:
      'Incidentes ocurridos al paciente durante la atenci\u00f3n m\u00e9dica y quir\u00fargica',
    code_1: 'Y40-Y84',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y70-Y82',
    level: 2,
    description:
      'Dispositivos m\u00e9dicos de diagn\u00f3stico y de uso terap\u00e9utico asociados con incidentes adversos',
    code_1: 'Y40-Y84',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y35',
    level: 2,
    description: 'Intervenci\u00f3n legal',
    code_1: 'Y35-Y36',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y36',
    level: 2,
    description: 'Operaciones de guerra',
    code_1: 'Y35-Y36',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y10',
    level: 2,
    description:
      'Envenenamiento por, y exposici\u00f3n a analg\u00e9sicos no narc\u00f3ticos, antipir\u00e9ticos y antirreum\u00e1ticos, de intenci\u00f3n no determinada',
    code_1: 'Y10-Y34',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y11',
    level: 2,
    description:
      'Envenenamiento por, y exposici\u00f3n a drogas antiepil\u00e9pticas, sedantes, hipn\u00f3ticas, antiparkinsonianas y psicotr\u00f3picas, no clasificadas en otra parte, de intenci\u00f3n no determinada',
    code_1: 'Y10-Y34',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y12',
    level: 2,
    description:
      'Envenenamiento por, y exposici\u00f3n a narc\u00f3ticos y psicodisl\u00e9pticos [alucin\u00f3genos], no clasificados en otra parte, de intenci\u00f3n no determinada',
    code_1: 'Y10-Y34',
    code_0: 'V01-Y99'
  },
  {
    code: 'X85',
    level: 2,
    description:
      'Agresi\u00f3n con drogas, medicamentos y sustancias biol\u00f3gicas',
    code_1: 'X85-Y09',
    code_0: 'V01-Y99'
  },
  {
    code: 'X86',
    level: 2,
    description: 'Agresi\u00f3n con sustancia corrosiva',
    code_1: 'X85-Y09',
    code_0: 'V01-Y99'
  },
  {
    code: 'X87',
    level: 2,
    description: 'Agresi\u00f3n con plaguicidas',
    code_1: 'X85-Y09',
    code_0: 'V01-Y99'
  },
  {
    code: 'X60',
    level: 2,
    description:
      'Envenenamiento autoinfligido intencionalmente por, y exposici\u00f3n a analg\u00e9sicos no narc\u00f3ticos, antipir\u00e9ticos y antirreum\u00e1ticos',
    code_1: 'X60-X84',
    code_0: 'V01-Y99'
  },
  {
    code: 'X61',
    level: 2,
    description:
      'Envenenamiento autoinfligido intencionalmente por, y exposici\u00f3n a drogas antiepil\u00e9pticas, sedantes, hipn\u00f3ticas, antiparkinsonianas y psicotr\u00f3picas, no clasificadas en otra parte',
    code_1: 'X60-X84',
    code_0: 'V01-Y99'
  },
  {
    code: 'X62',
    level: 2,
    description:
      'Envenenamiento autoinfligido intencionalmente por, y exposici\u00f3n a narc\u00f3ticos y psicodisl\u00e9pticos [alucin\u00f3genos], no clasificados en otra parte',
    code_1: 'X60-X84',
    code_0: 'V01-Y99'
  },
  {
    code: 'V01-V09',
    level: 2,
    description: 'Peat\u00f3n lesionado en accidente de transporte',
    code_1: 'V01-X59',
    code_0: 'V01-Y99'
  },
  {
    code: 'V10-V19',
    level: 2,
    description: 'Ciclista lesionado en accidente de transporte',
    code_1: 'V01-X59',
    code_0: 'V01-Y99'
  },
  {
    code: 'V20-V29',
    level: 2,
    description: 'Motociclista lesionado en accidente de transporte',
    code_1: 'V01-X59',
    code_0: 'V01-Y99'
  },
  {
    code: 'V30-V39',
    level: 2,
    description:
      'Ocupante de veh\u00edculo de motor de tres ruedas lesionado en accidente de transporte',
    code_1: 'V01-X59',
    code_0: 'V01-Y99'
  },
  {
    code: 'Q40',
    level: 2,
    description:
      'Otras malformaciones cong\u00e9nitas de la parte superior del tubo digestivo',
    code_1: 'Q38-Q45',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q41',
    level: 2,
    description:
      'Ausencia, atresia y estenosis cong\u00e9nita del intestino delgado',
    code_1: 'Q38-Q45',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q42',
    level: 2,
    description:
      'Ausencia, atresia y estenosis cong\u00e9nita del intestino grueso',
    code_1: 'Q38-Q45',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q43',
    level: 2,
    description: 'Otras malformaciones cong\u00e9nitas del intestino',
    code_1: 'Q38-Q45',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q44',
    level: 2,
    description:
      'Malformaciones cong\u00e9nitas de la ves\u00edcula biliar, de los conductos biliares y del h\u00edgado',
    code_1: 'Q38-Q45',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q45',
    level: 2,
    description: 'Otras malformaciones cong\u00e9nitas del sistema digestivo',
    code_1: 'Q38-Q45',
    code_0: 'Q00-Q99'
  },
  {
    code: 'Q34',
    level: 2,
    description:
      'Otras malformaciones cong\u00e9nitas del sistema respiratorio',
    code_1: 'Q30-Q34',
    code_0: 'Q00-Q99'
  },
  {
    code: 'H109',
    level: 3,
    description: 'Conjuntivitis, no especificada',
    code_2: 'H10',
    code_0: 'H00-H59',
    code_1: 'H10-H13'
  },
  {
    code: 'R98',
    level: 2,
    description: 'Muerte sin asistencia',
    code_1: 'R95-R99',
    code_0: 'R00-R99'
  },
  {
    code: 'R99',
    level: 2,
    description:
      'Otras causas mal definidas y las no especificadas de mortalidad',
    code_1: 'R95-R99',
    code_0: 'R00-R99'
  },
  {
    code: 'R87',
    level: 2,
    description:
      'Hallazgos anormales en muestras tomadas de \u00f3rganos genitales femeninos',
    code_1: 'R83-R89',
    code_0: 'R00-R99'
  },
  {
    code: 'R89',
    level: 2,
    description:
      'Hallazgos anormales en muestras tomadas de otros \u00f3rganos, sistemas y tejidos',
    code_1: 'R83-R89',
    code_0: 'R00-R99'
  },
  {
    code: 'R75',
    level: 2,
    description:
      'Evidencias de laboratorio del virus de la inmunodeficiencia humana [VIH]',
    code_1: 'R70-R79',
    code_0: 'R00-R99'
  },
  {
    code: 'R76',
    level: 2,
    description: 'Otros hallazgos inmunol\u00f3gicos anormales en suero',
    code_1: 'R70-R79',
    code_0: 'R00-R99'
  },
  {
    code: 'R77',
    level: 2,
    description: 'Otras anormalidades de las prote\u00ednas plasm\u00e1ticas',
    code_1: 'R70-R79',
    code_0: 'R00-R99'
  },
  {
    code: 'R78',
    level: 2,
    description:
      'Hallazgo de drogas y otras sustancias que normalmente no se encuentran en la sangre',
    code_1: 'R70-R79',
    code_0: 'R00-R99'
  },
  {
    code: 'R79',
    level: 2,
    description: 'Otros hallazgos anormales en la qu\u00edmica sangu\u00ednea',
    code_1: 'R70-R79',
    code_0: 'R00-R99'
  },
  {
    code: 'R56',
    level: 2,
    description: 'Convulsiones, no clasificadas en otra parte',
    code_1: 'R50-R69',
    code_0: 'R00-R99'
  },
  {
    code: 'R57',
    level: 2,
    description: 'Choque, no clasificado en otra parte',
    code_1: 'R50-R69',
    code_0: 'R00-R99'
  },
  {
    code: 'R58',
    level: 2,
    description: 'Hemorragia, no clasificada en otra parte',
    code_1: 'R50-R69',
    code_0: 'R00-R99'
  },
  {
    code: 'R59',
    level: 2,
    description: 'Adenomegalia',
    code_1: 'R50-R69',
    code_0: 'R00-R99'
  },
  {
    code: 'R60',
    level: 2,
    description: 'Edema, no clasificado en otra parte',
    code_1: 'R50-R69',
    code_0: 'R00-R99'
  },
  {
    code: 'R61',
    level: 2,
    description: 'Hiperhidrosis',
    code_1: 'R50-R69',
    code_0: 'R00-R99'
  },
  {
    code: 'R62',
    level: 2,
    description: 'Falta del desarrollo fisiol\u00f3gico normal esperado',
    code_1: 'R50-R69',
    code_0: 'R00-R99'
  },
  {
    code: 'R63',
    level: 2,
    description:
      'S\u00edntomas y signos concernientes a la alimentaci\u00f3n y a la ingesti\u00f3n de l\u00edquidos',
    code_1: 'R50-R69',
    code_0: 'R00-R99'
  },
  {
    code: 'H218',
    level: 3,
    description: 'Otros trastornos especificados del iris y del cuerpo ciliar',
    code_2: 'H21',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H219',
    level: 3,
    description: 'Trastorno del iris y del cuerpo ciliar, no especificado',
    code_2: 'H21',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H183',
    level: 3,
    description: 'Cambios en las membranas de la c\u00f3rnea',
    code_2: 'H18',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H184',
    level: 3,
    description: 'Degeneraci\u00f3n de la c\u00f3rnea',
    code_2: 'H18',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H185',
    level: 3,
    description: 'Distrofia hereditaria de la c\u00f3rnea',
    code_2: 'H18',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H186',
    level: 3,
    description: 'Queratocono',
    code_2: 'H18',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H187',
    level: 3,
    description: 'Otras deformidades de la c\u00f3rnea',
    code_2: 'H18',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H188',
    level: 3,
    description: 'Otros trastornos especificados de la c\u00f3rnea',
    code_2: 'H18',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H189',
    level: 3,
    description: 'Trastorno de la c\u00f3rnea, no especificado',
    code_2: 'H18',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H164',
    level: 3,
    description: 'Neovascularizaci\u00f3n de la c\u00f3rnea',
    code_2: 'H16',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H168',
    level: 3,
    description: 'Otras queratitis',
    code_2: 'H16',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H169',
    level: 3,
    description: 'Queratitis, no especificada',
    code_2: 'H16',
    code_0: 'H00-H59',
    code_1: 'H15-H22'
  },
  {
    code: 'H624',
    level: 3,
    description:
      'Otitis externa en otras enfermedades clasificadas en otra parte',
    code_2: 'H62',
    code_0: 'H60-H95',
    code_1: 'H60-H62'
  },
  {
    code: 'H628',
    level: 3,
    description:
      'Otros trastornos del o\u00eddo externo en enfermedades clasificadas en otra parte',
    code_2: 'H62',
    code_0: 'H60-H95',
    code_1: 'H60-H62'
  },
  {
    code: 'H618',
    level: 3,
    description: 'Otros trastornos especificados del o\u00eddo externo',
    code_2: 'H61',
    code_0: 'H60-H95',
    code_1: 'H60-H62'
  },
  {
    code: 'H619',
    level: 3,
    description: 'Trastorno del o\u00eddo externo, no especificado',
    code_2: 'H61',
    code_0: 'H60-H95',
    code_1: 'H60-H62'
  },
  {
    code: 'H609',
    level: 3,
    description: 'Otitis externa, sin otra especificaci\u00f3n',
    code_2: 'H60',
    code_0: 'H60-H95',
    code_1: 'H60-H62'
  },
  {
    code: 'H669',
    level: 3,
    description: 'Otitis media, no especificada',
    code_2: 'H66',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'C73',
    level: 4,
    description: 'Tumor maligno de la gl\u00e1ndula tiroides',
    code_3: 'C73-C75',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C74',
    level: 4,
    description: 'Tumor maligno de la gl\u00e1ndula suprarrenal',
    code_3: 'C73-C75',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C75',
    level: 4,
    description:
      'Tumor maligno de otras gl\u00e1ndulas endocrinas y de estructuras afines',
    code_3: 'C73-C75',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C69',
    level: 4,
    description: 'Tumor maligno del ojo y sus anexos',
    code_3: 'C69-C72',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C70',
    level: 4,
    description: 'Tumor maligno de las meninges',
    code_3: 'C69-C72',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C71',
    level: 4,
    description: 'Tumor maligno del enc\u00e9falo',
    code_3: 'C69-C72',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C72',
    level: 4,
    description:
      'Tumor maligno de la m\u00e9dula espinal, de los nervios craneales y de otras partes del sistema nervioso central',
    code_3: 'C69-C72',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C64',
    level: 4,
    description:
      'Tumor maligno del ri\u00f1\u00f3n, excepto de la pelvis renal',
    code_3: 'C64-C68',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C65',
    level: 4,
    description: 'Tumor maligno de la pelvis renal',
    code_3: 'C64-C68',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C66',
    level: 4,
    description: 'Tumor maligno del ur\u00e9ter',
    code_3: 'C64-C68',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C67',
    level: 4,
    description: 'Tumor maligno de la vejiga urinaria',
    code_3: 'C64-C68',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C60',
    level: 4,
    description: 'Tumor maligno del pene',
    code_3: 'C60-C63',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C61',
    level: 4,
    description: 'Tumor maligno de la pr\u00f3stata',
    code_3: 'C60-C63',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C62',
    level: 4,
    description: 'Tumor maligno del test\u00edculo',
    code_3: 'C60-C63',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C63',
    level: 4,
    description:
      'Tumor maligno de otros \u00f3rganos genitales masculinos y de los no especificados',
    code_3: 'C60-C63',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C51',
    level: 4,
    description: 'Tumor maligno de la vulva',
    code_3: 'C51-C58',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C52',
    level: 4,
    description: 'Tumor maligno de la vagina',
    code_3: 'C51-C58',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C53',
    level: 4,
    description: 'Tumor maligno del cuello del \u00fatero',
    code_3: 'C51-C58',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C54',
    level: 4,
    description: 'Tumor maligno del cuerpo del \u00fatero',
    code_3: 'C51-C58',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C55',
    level: 4,
    description: 'Tumor maligno del \u00fatero, parte no especificada',
    code_3: 'C51-C58',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C56',
    level: 4,
    description: 'Tumor maligno del ovario',
    code_3: 'C51-C58',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C57',
    level: 4,
    description:
      'Tumor maligno de otros \u00f3rganos genitales femeninos y de los no especificados',
    code_3: 'C51-C58',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C500',
    level: 4,
    description: 'Tumor maligno del pez\u00f3n y ar\u00e9ola mamaria',
    code_3: 'C50',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C501',
    level: 4,
    description: 'Tumor maligno de la porci\u00f3n central de la mama',
    code_3: 'C50',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C502',
    level: 4,
    description: 'Tumor maligno del cuadrante superior interno de la mama',
    code_3: 'C50',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C503',
    level: 4,
    description: 'Tumor maligno del cuadrante inferior interno de la mama',
    code_3: 'C50',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C504',
    level: 4,
    description: 'Tumor maligno del cuadrante superior externo de la mama',
    code_3: 'C50',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C505',
    level: 4,
    description: 'Tumor maligno del cuadrante inferior externo de la mama',
    code_3: 'C50',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C506',
    level: 4,
    description: 'Tumor maligno de la prolongaci\u00f3n axilar de la mama',
    code_3: 'C50',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C508',
    level: 4,
    description: 'Lesi\u00f3n de sitios contiguos de la mama',
    code_3: 'C50',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C509',
    level: 4,
    description: 'Tumor maligno de la mama, parte no especificada',
    code_3: 'C50',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C45',
    level: 4,
    description: 'Mesotelioma',
    code_3: 'C45-C49',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C46',
    level: 4,
    description: 'Sarcoma de Kaposi',
    code_3: 'C45-C49',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C47',
    level: 4,
    description: 'Tumor maligno de los nervios perif\u00e9ricos y del sistema',
    code_3: 'C45-C49',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C43',
    level: 4,
    description: 'Melanoma maligno de la piel',
    code_3: 'C43-C44',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C44',
    level: 4,
    description: 'Otros tumores malignos de la piel',
    code_3: 'C43-C44',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C790',
    level: 4,
    description:
      'Tumor maligno secundario del ri\u00f1\u00f3n y de la pelvis renal',
    code_3: 'C79',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C76-C80'
  },
  {
    code: 'C791',
    level: 4,
    description:
      'Tumor maligno secundario de la vejiga, y de otros \u00f3rganos y los no especificados de las v\u00edas urinarias',
    code_3: 'C79',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C76-C80'
  },
  {
    code: 'C792',
    level: 4,
    description: 'Tumor maligno secundario de la piel',
    code_3: 'C79',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C76-C80'
  },
  {
    code: 'C793',
    level: 4,
    description:
      'Tumor maligno secundario del enc\u00e9falo y de las meninges cerebrales',
    code_3: 'C79',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C76-C80'
  },
  {
    code: 'C794',
    level: 4,
    description:
      'Tumor maligno secundario de otras partes del sistema nervioso y de las no especificadas',
    code_3: 'C79',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C76-C80'
  },
  {
    code: 'C795',
    level: 4,
    description:
      'Tumor maligno secundario de los huesos y de la m\u00e9dula \u00f3sea',
    code_3: 'C79',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C76-C80'
  },
  {
    code: 'C796',
    level: 4,
    description: 'Tumor maligno secundario del ovario',
    code_3: 'C79',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C76-C80'
  },
  {
    code: 'C797',
    level: 4,
    description: 'Tumor maligno secundario de la gl\u00e1ndula suprarrenal',
    code_3: 'C79',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C76-C80'
  },
  {
    code: 'C798',
    level: 4,
    description: 'Tumor maligno secundario de otros sitios especificados',
    code_3: 'C79',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C76-C80'
  },
  {
    code: 'C780',
    level: 4,
    description: 'Tumor maligno secundario del pulm\u00f3n',
    code_3: 'C78',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C76-C80'
  },
  {
    code: 'C781',
    level: 4,
    description: 'Tumor maligno secundario del mediastino',
    code_3: 'C78',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C76-C80'
  },
  {
    code: 'C782',
    level: 4,
    description: 'Tumor maligno secundario de la pleura',
    code_3: 'C78',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C76-C80'
  },
  {
    code: 'C783',
    level: 4,
    description:
      'Tumor maligno secundario de otros \u00f3rganos respiratorios y de los no especificados',
    code_3: 'C78',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C76-C80'
  },
  {
    code: 'C930',
    level: 4,
    description: 'Leucemia monoc\u00edtica aguda',
    code_3: 'C93',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C931',
    level: 4,
    description: 'Leucemia monoc\u00edtica cr\u00f3nica',
    code_3: 'C93',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C932',
    level: 4,
    description: 'Leucemia monoc\u00edtica subaguda',
    code_3: 'C93',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C937',
    level: 4,
    description: 'Otras leucemias monoc\u00edticas',
    code_3: 'C93',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C939',
    level: 4,
    description: 'Leucemia monoc\u00edtica, sin otra especificaci\u00f3n',
    code_3: 'C93',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C920',
    level: 4,
    description: 'Leucemia mieloide aguda',
    code_3: 'C92',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C921',
    level: 4,
    description: 'Leucemia mieloide cr\u00f3nica',
    code_3: 'C92',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C922',
    level: 4,
    description: 'Leucemia mieloide subaguda',
    code_3: 'C92',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C923',
    level: 4,
    description: 'Sarcoma mieloide',
    code_3: 'C92',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C924',
    level: 4,
    description: 'Leucemia promieloc\u00edtica aguda',
    code_3: 'C92',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C925',
    level: 4,
    description: 'Leucemia mielomonoc\u00edtica aguda',
    code_3: 'C92',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C927',
    level: 4,
    description: 'Otras leucemias mieloides',
    code_3: 'C92',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C929',
    level: 4,
    description: 'Leucemia mieloide, sin otra especificaci\u00f3n',
    code_3: 'C92',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C910',
    level: 4,
    description: 'Leucemia linfobl\u00e1stica aguda',
    code_3: 'C91',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C911',
    level: 4,
    description: 'Leucemia linfoc\u00edtica cr\u00f3nica',
    code_3: 'C91',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C912',
    level: 4,
    description: 'Leucemia linfoc\u00edtica subaguda',
    code_3: 'C91',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C913',
    level: 4,
    description: 'Leucemia prolinfoc\u00edtica',
    code_3: 'C91',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C914',
    level: 4,
    description: 'Leucemia de c\u00e9lulas vellosas',
    code_3: 'C91',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C915',
    level: 4,
    description: 'Leucemia de c\u00e9lulas T adultas',
    code_3: 'C91',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C917',
    level: 4,
    description: 'Otras leucemias linfoides',
    code_3: 'C91',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C919',
    level: 4,
    description: 'Leucemia linfoide, sin otra especificaci\u00f3n',
    code_3: 'C91',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C900',
    level: 4,
    description: 'Mieloma m\u00faltiple',
    code_3: 'C90',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C901',
    level: 4,
    description: 'Leucemia de c\u00e9lulas plasm\u00e1ticas',
    code_3: 'C90',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C902',
    level: 4,
    description: 'Plasmocitoma, extramedular',
    code_3: 'C90',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C880',
    level: 4,
    description: 'Macroglobulinemia de Waldenstr\u00f6m',
    code_3: 'C88',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C881',
    level: 4,
    description: 'Enfermedad de cadena pesada alfa',
    code_3: 'C88',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C882',
    level: 4,
    description: 'Enfermedad de cadena pesada gamma',
    code_3: 'C88',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C883',
    level: 4,
    description: 'Enfermedad inmunoproliferativa del intestino delgado',
    code_3: 'C88',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C887',
    level: 4,
    description: 'Otras enfermedades inmunoproliferativas malignas',
    code_3: 'C88',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C889',
    level: 4,
    description:
      'Enfermedad inmunoproliferativa maligna, sin otra especificaci\u00f3n',
    code_3: 'C88',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C850',
    level: 4,
    description: 'Linfosarcoma',
    code_3: 'C85',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C851',
    level: 4,
    description: 'Linfoma de c\u00e9lulas B, sin otra especificaci\u00f3n',
    code_3: 'C85',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C857',
    level: 4,
    description: 'Otros tipos especificados de linfoma no Hodgkin',
    code_3: 'C85',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C859',
    level: 4,
    description: 'Linfoma no Hodgkin, no especificado',
    code_3: 'C85',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C840',
    level: 4,
    description: 'Micosis fungoide',
    code_3: 'C84',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C841',
    level: 4,
    description: 'Enfermedad de S\u00e9zary',
    code_3: 'C84',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C842',
    level: 4,
    description: 'Linfoma de zona T',
    code_3: 'C84',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C843',
    level: 4,
    description: 'Linfoma linfoepitelioide',
    code_3: 'C84',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C844',
    level: 4,
    description: 'Linfoma de c\u00e9lulas T perif\u00e9rico',
    code_3: 'C84',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'Y880',
    level: 3,
    description:
      'Secuelas de efectos adversos causados por drogas, medicamentos y sustancias biol\u00f3gicas en su uso terap\u00e9utico',
    code_2: 'Y88',
    code_0: 'V01-Y99',
    code_1: 'Y85-Y89'
  },
  {
    code: 'Y881',
    level: 3,
    description:
      'Secuelas de incidentes ocurridos al paciente durante procedimientos m\u00e9dicos y quir\u00fargicos',
    code_2: 'Y88',
    code_0: 'V01-Y99',
    code_1: 'Y85-Y89'
  },
  {
    code: 'Y882',
    level: 3,
    description:
      'Secuelas de incidentes adversos asociados con dispositivos m\u00e9dicos en uso diagn\u00f3stico y terap\u00e9utico',
    code_2: 'Y88',
    code_0: 'V01-Y99',
    code_1: 'Y85-Y89'
  },
  {
    code: 'Y883',
    level: 3,
    description:
      'Secuelas de procedimientos m\u00e9dicos y quir\u00fargicos como la causa de reacci\u00f3n anormal del paciente o de complicaci\u00f3n posterior, sin menci\u00f3n de incidente en el momento de efectuar el procedimiento',
    code_2: 'Y88',
    code_0: 'V01-Y99',
    code_1: 'Y85-Y89'
  },
  {
    code: 'Y870',
    level: 3,
    description: 'Secuelas de lesiones autoinfligidas',
    code_2: 'Y87',
    code_0: 'V01-Y99',
    code_1: 'Y85-Y89'
  },
  {
    code: 'Y871',
    level: 3,
    description: 'Secuelas de agresiones',
    code_2: 'Y87',
    code_0: 'V01-Y99',
    code_1: 'Y85-Y89'
  },
  {
    code: 'Y872',
    level: 3,
    description: 'Secuelas de eventos de intenci\u00f3n no determinada',
    code_2: 'Y87',
    code_0: 'V01-Y99',
    code_1: 'Y85-Y89'
  },
  {
    code: 'Y850',
    level: 3,
    description: 'Secuelas de accidente de veh\u00edculo de motor',
    code_2: 'Y85',
    code_0: 'V01-Y99',
    code_1: 'Y85-Y89'
  },
  {
    code: 'Y859',
    level: 3,
    description:
      'Secuelas de otros accidentes de transporte, y los no especificados',
    code_2: 'Y85',
    code_0: 'V01-Y99',
    code_1: 'Y85-Y89'
  },
  {
    code: 'Y910',
    level: 3,
    description: 'Intoxicaci\u00f3n alcoh\u00f3lica leve',
    code_2: 'Y91',
    code_0: 'V01-Y99',
    code_1: 'Y90-Y98'
  },
  {
    code: 'Y911',
    level: 3,
    description: 'Intoxicaci\u00f3n alcoh\u00f3lica moderada',
    code_2: 'Y91',
    code_0: 'V01-Y99',
    code_1: 'Y90-Y98'
  },
  {
    code: 'Y912',
    level: 3,
    description: 'Intoxicaci\u00f3n alcoh\u00f3lica severa',
    code_2: 'Y91',
    code_0: 'V01-Y99',
    code_1: 'Y90-Y98'
  },
  {
    code: 'Y913',
    level: 3,
    description: 'Intoxicaci\u00f3n alcoh\u00f3lica muy severa',
    code_2: 'Y91',
    code_0: 'V01-Y99',
    code_1: 'Y90-Y98'
  },
  {
    code: 'Y919',
    level: 3,
    description: 'Alcoholismo, nivel de intoxicaci\u00f3n no especificado',
    code_2: 'Y91',
    code_0: 'V01-Y99',
    code_1: 'Y90-Y98'
  },
  {
    code: 'Y900',
    level: 3,
    description: 'Nivel de alcohol en la sangre menor de 20 mg/100 ml',
    code_2: 'Y90',
    code_0: 'V01-Y99',
    code_1: 'Y90-Y98'
  },
  {
    code: 'Y901',
    level: 3,
    description: 'Nivel de alcohol en la sangre de 20 a 39 mg/100 ml',
    code_2: 'Y90',
    code_0: 'V01-Y99',
    code_1: 'Y90-Y98'
  },
  {
    code: 'Y902',
    level: 3,
    description: 'Nivel de alcohol en la sangre de 40 a 59 mg/100 ml',
    code_2: 'Y90',
    code_0: 'V01-Y99',
    code_1: 'Y90-Y98'
  },
  {
    code: 'Y903',
    level: 3,
    description: 'Nivel de alcohol en la sangre de 60 a 79 mg/100 ml',
    code_2: 'Y90',
    code_0: 'V01-Y99',
    code_1: 'Y90-Y98'
  },
  {
    code: 'Y904',
    level: 3,
    description: 'Nivel de alcohol en la sangre de 80 a 99 mg/100 ml',
    code_2: 'Y90',
    code_0: 'V01-Y99',
    code_1: 'Y90-Y98'
  },
  {
    code: 'Y905',
    level: 3,
    description: 'Nivel de alcohol en la sangre de 100 a 119 mg/100 ml',
    code_2: 'Y90',
    code_0: 'V01-Y99',
    code_1: 'Y90-Y98'
  },
  {
    code: 'Y906',
    level: 3,
    description: 'Nivel de alcohol en la sangre de 120 a 199 mg/100 ml',
    code_2: 'Y90',
    code_0: 'V01-Y99',
    code_1: 'Y90-Y98'
  },
  {
    code: 'Y907',
    level: 3,
    description: 'Nivel de alcohol en la sangre de 200 a 239 mg/100 ml',
    code_2: 'Y90',
    code_0: 'V01-Y99',
    code_1: 'Y90-Y98'
  },
  {
    code: 'Y908',
    level: 3,
    description: 'Nivel de alcohol en la sangre de 240 mg/100 ml o m\u00e1s',
    code_2: 'Y90',
    code_0: 'V01-Y99',
    code_1: 'Y90-Y98'
  },
  {
    code: 'Y909',
    level: 3,
    description: 'Presencia de alcohol en la sangre, nivel no especificado',
    code_2: 'Y90',
    code_0: 'V01-Y99',
    code_1: 'Y90-Y98'
  },
  {
    code: 'O72',
    level: 2,
    description: 'Hemorragia postparto',
    code_1: 'O60-O75',
    code_0: 'O00-O9A'
  },
  {
    code: 'O73',
    level: 2,
    description:
      'Retenci\u00f3n de la placenta o de las membranas, sin hemorragia',
    code_1: 'O60-O75',
    code_0: 'O00-O9A'
  },
  {
    code: 'O74',
    level: 2,
    description:
      'Complicaciones de la anestesia administrada durante el trabajo de parto y el parto',
    code_1: 'O60-O75',
    code_0: 'O00-O9A'
  },
  {
    code: 'O75',
    level: 2,
    description:
      'Otras complicaciones del trabajo de parto y del parto, no clasificadas en otra parte',
    code_1: 'O60-O75',
    code_0: 'O00-O9A'
  },
  {
    code: 'C39',
    level: 4,
    description:
      'Tumor maligno de otros sitios y de los mal definidos del sistema respiratorio y de los \u00f3rganos intrator\u00e1cicos',
    code_3: 'C30-C39',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C18',
    level: 4,
    description: 'Tumor maligno del colon',
    code_3: 'C15-C26',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C19',
    level: 4,
    description: 'Tumor maligno de la uni\u00f3n rectosigmoidea',
    code_3: 'C15-C26',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C20',
    level: 4,
    description: 'Tumor maligno del recto',
    code_3: 'C15-C26',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C21',
    level: 4,
    description: 'Tumor maligno del ano y del conducto anal',
    code_3: 'C15-C26',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C22',
    level: 4,
    description:
      'Tumor maligno del h\u00edgado y de las v\u00edas biliares intrahep\u00e1ticas',
    code_3: 'C15-C26',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C23',
    level: 4,
    description: 'Tumor maligno de la ves\u00edcula biliar',
    code_3: 'C15-C26',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C24',
    level: 4,
    description:
      'Tumor maligno de otras partes y de las no especificadas de las v\u00edas biliares',
    code_3: 'C15-C26',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C25',
    level: 4,
    description: 'Tumor maligno del p\u00e1ncreas',
    code_3: 'C15-C26',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C26',
    level: 4,
    description:
      'Tumor maligno de otros sitios y de los mal definidos de los \u00f3rganos digestivos',
    code_3: 'C15-C26',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C03',
    level: 4,
    description: 'Tumor maligno de la enc\u00eda',
    code_3: 'C00-C14',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C04',
    level: 4,
    description: 'Tumor maligno del piso de la boca',
    code_3: 'C00-C14',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C05',
    level: 4,
    description: 'Tumor maligno del paladar',
    code_3: 'C00-C14',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C06',
    level: 4,
    description:
      'Tumor maligno de otras partes y de las no especificadas de la boca',
    code_3: 'C00-C14',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C07',
    level: 4,
    description: 'Tumor maligno de la gl\u00e1ndula par\u00f3tida',
    code_3: 'C00-C14',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C08',
    level: 4,
    description:
      'Tumor maligno de otras gl\u00e1ndulas salivales mayores y de las no especificadas',
    code_3: 'C00-C14',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C09',
    level: 4,
    description: 'Tumor maligno de la am\u00edgdala',
    code_3: 'C00-C14',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C10',
    level: 4,
    description: 'Tumor maligno de la orofaringe',
    code_3: 'C00-C14',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C11',
    level: 4,
    description: 'Tumor maligno de la nasofaringe',
    code_3: 'C00-C14',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C12',
    level: 4,
    description: 'Tumor maligno del seno piriforme',
    code_3: 'C00-C14',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C827',
    level: 4,
    description: 'Otros tipos especificados de linfoma no Hodgkin folicular',
    code_3: 'C82',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C829',
    level: 4,
    description: 'Linfoma no Hodgkin folicular, sin otra especificaci\u00f3n',
    code_3: 'C82',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C813',
    level: 4,
    description: 'Enfermedad de Hodgkin con depleci\u00f3n linfoc\u00edtica',
    code_3: 'C81',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C817',
    level: 4,
    description: 'Otros tipos de enfermedad de Hodgkin',
    code_3: 'C81',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C819',
    level: 4,
    description: 'Enfermedad de Hodgkin, no especificada',
    code_3: 'C81',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'H654',
    level: 3,
    description: 'Otras otitis medias cr\u00f3nicas no supurativas',
    code_2: 'H65',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'H659',
    level: 3,
    description: 'Otitis media no supurativa, sin otra especificaci\u00f3n',
    code_2: 'H65',
    code_0: 'H60-H95',
    code_1: 'H65-H75'
  },
  {
    code: 'H838',
    level: 3,
    description: 'Otros trastornos especificados del o\u00eddo interno',
    code_2: 'H83',
    code_0: 'H60-H95',
    code_1: 'H80-H83'
  },
  {
    code: 'H839',
    level: 3,
    description: 'Trastorno del o\u00eddo interno, no especificado',
    code_2: 'H83',
    code_0: 'H60-H95',
    code_1: 'H80-H83'
  },
  {
    code: 'H814',
    level: 3,
    description: 'V\u00e9rtigo de origen central',
    code_2: 'H81',
    code_0: 'H60-H95',
    code_1: 'H80-H83'
  },
  {
    code: 'H818',
    level: 3,
    description: 'Otros trastornos de la funci\u00f3n vestibular',
    code_2: 'H81',
    code_0: 'H60-H95',
    code_1: 'H80-H83'
  },
  {
    code: 'H819',
    level: 3,
    description: 'Trastorno de la funci\u00f3n vestibular, no especificado',
    code_2: 'H81',
    code_0: 'H60-H95',
    code_1: 'H80-H83'
  },
  {
    code: 'H919',
    level: 3,
    description: 'Hipoacusia, no especificada',
    code_2: 'H91',
    code_0: 'H60-H95',
    code_1: 'H90-H95'
  },
  {
    code: 'H906',
    level: 3,
    description: 'Hipoacusia mixta conductiva y neurosensorial, bilateral',
    code_2: 'H90',
    code_0: 'H60-H95',
    code_1: 'H90-H95'
  },
  {
    code: 'H907',
    level: 3,
    description:
      'Hipoacusia mixta conductiva y neurosensorial, unilateral con audici\u00f3n irrestricta contralateral',
    code_2: 'H90',
    code_0: 'H60-H95',
    code_1: 'H90-H95'
  },
  {
    code: 'H908',
    level: 3,
    description:
      'Hipoacusia mixta conductiva y neurosensorial, no especificada',
    code_2: 'H90',
    code_0: 'H60-H95',
    code_1: 'H90-H95'
  },
  {
    code: 'Y83-Y84',
    level: 2,
    description:
      'Procedimientos quir\u00fargicos y otros procedimientos m\u00e9dicos como la causa de reacci\u00f3n anormal del paciente o de complicaci\u00f3n posterior, sin menci\u00f3n de incidente en el momento de efectuar el procedimiento',
    code_1: 'Y40-Y84',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y13',
    level: 2,
    description:
      'Envenenamiento por, y exposici\u00f3n a otras drogas que act\u00faan sobre el sistema nervioso aut\u00f3nomo, de intenci\u00f3n no determinada',
    code_1: 'Y10-Y34',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y14',
    level: 2,
    description:
      'Envenenamiento por, y exposici\u00f3n a otras drogas, medicamentos y sustancias biol\u00f3gicas, y las no especificadas, de intenci\u00f3n no determinada',
    code_1: 'Y10-Y34',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y15',
    level: 2,
    description:
      'Envenenamiento por, y exposici\u00f3n al alcohol, de intenci\u00f3n no determinada',
    code_1: 'Y10-Y34',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y16',
    level: 2,
    description:
      'Envenenamiento por, y exposici\u00f3n a disolventes org\u00e1nicos e hidrocarburos halogenados y sus vapores, de intenci\u00f3n no determinada',
    code_1: 'Y10-Y34',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y17',
    level: 2,
    description:
      'Envenenamiento por, y exposici\u00f3n a otros gases y vapores, de intenci\u00f3n no determinada',
    code_1: 'Y10-Y34',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y18',
    level: 2,
    description:
      'Envenenamiento por, y exposici\u00f3n a plaguicidas, de intenci\u00f3n no determinada',
    code_1: 'Y10-Y34',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y19',
    level: 2,
    description:
      'Envenenamiento por, y exposici\u00f3n a otros productos qu\u00edmicos y sustancias nocivas, y los no especificados, de intenci\u00f3n no determinada',
    code_1: 'Y10-Y34',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y20',
    level: 2,
    description:
      'Ahorcamiento, estrangulamiento y sofocaci\u00f3n, de intenci\u00f3n no determinada',
    code_1: 'Y10-Y34',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y21',
    level: 2,
    description:
      'Ahogamiento y sumersi\u00f3n, de intenci\u00f3n no determinada',
    code_1: 'Y10-Y34',
    code_0: 'V01-Y99'
  },
  {
    code: 'X88',
    level: 2,
    description: 'Agresi\u00f3n con gases y vapores',
    code_1: 'X85-Y09',
    code_0: 'V01-Y99'
  },
  {
    code: 'X89',
    level: 2,
    description:
      'Agresi\u00f3n con otros productos qu\u00edmicos y sustancias nocivas especificadas',
    code_1: 'X85-Y09',
    code_0: 'V01-Y99'
  },
  {
    code: 'X90',
    level: 2,
    description:
      'Agresi\u00f3n con productos qu\u00edmicos y sustancias nocivas no especificadas',
    code_1: 'X85-Y09',
    code_0: 'V01-Y99'
  },
  {
    code: 'X91',
    level: 2,
    description:
      'Agresi\u00f3n por ahorcamiento, estrangulamiento y sofocaci\u00f3n',
    code_1: 'X85-Y09',
    code_0: 'V01-Y99'
  },
  {
    code: 'X92',
    level: 2,
    description: 'Agresi\u00f3n por ahogamiento y sumersi\u00f3n',
    code_1: 'X85-Y09',
    code_0: 'V01-Y99'
  },
  {
    code: 'X93',
    level: 2,
    description: 'Agresi\u00f3n con disparo de arma corta',
    code_1: 'X85-Y09',
    code_0: 'V01-Y99'
  },
  {
    code: 'X94',
    level: 2,
    description: 'Agresi\u00f3n con disparo de rifle, escopeta y arma larga',
    code_1: 'X85-Y09',
    code_0: 'V01-Y99'
  },
  {
    code: 'X95',
    level: 2,
    description:
      'Agresi\u00f3n con disparo de otras armas de fuego, y las no especificadas',
    code_1: 'X85-Y09',
    code_0: 'V01-Y99'
  },
  {
    code: 'X96',
    level: 2,
    description: 'Agresi\u00f3n con material explosivo',
    code_1: 'X85-Y09',
    code_0: 'V01-Y99'
  },
  {
    code: 'X97',
    level: 2,
    description: 'Agresi\u00f3n con humo, fuego y llamas',
    code_1: 'X85-Y09',
    code_0: 'V01-Y99'
  },
  {
    code: 'X63',
    level: 2,
    description:
      'Envenenamiento autoinfligido intencionalmente por, y exposici\u00f3n a otras drogas que act\u00faan sobre el sistema nervioso aut\u00f3nomo',
    code_1: 'X60-X84',
    code_0: 'V01-Y99'
  },
  {
    code: 'X64',
    level: 2,
    description:
      'Envenenamiento autoinfligido intencionalmente por, y exposici\u00f3n a otras drogas, medicamentos y sustancias biol\u00f3gicas, y los no especificados',
    code_1: 'X60-X84',
    code_0: 'V01-Y99'
  },
  {
    code: 'X65',
    level: 2,
    description:
      'Envenenamiento autoinfligido intencionalmente por, y exposici\u00f3n al alcohol',
    code_1: 'X60-X84',
    code_0: 'V01-Y99'
  },
  {
    code: 'X66',
    level: 2,
    description:
      'Envenenamiento autoinfligido intencionalmente por, y exposici\u00f3n a disolventes org\u00e1nicos e hidrocarburos halogenados y sus vapores',
    code_1: 'X60-X84',
    code_0: 'V01-Y99'
  },
  {
    code: 'X67',
    level: 2,
    description:
      'Envenenamiento autoinfligido intencionalmente por, y exposici\u00f3n a otros gases y vapores',
    code_1: 'X60-X84',
    code_0: 'V01-Y99'
  },
  {
    code: 'X68',
    level: 2,
    description:
      'Envenenamiento autoinfligido intencionalmente por, y exposici\u00f3n a plaguicidas',
    code_1: 'X60-X84',
    code_0: 'V01-Y99'
  },
  {
    code: 'V40-V49',
    level: 2,
    description:
      'Ocupante de autom\u00f3vil lesionado en accidente de transporte',
    code_1: 'V01-X59',
    code_0: 'V01-Y99'
  },
  {
    code: 'V50-V59',
    level: 2,
    description:
      'Ocupante de camioneta o furgoneta lesionado en accidente de transporte',
    code_1: 'V01-X59',
    code_0: 'V01-Y99'
  },
  {
    code: 'V60-V69',
    level: 2,
    description:
      'Ocupante de veh\u00edculo de transporte pesado lesionado en accidente de transporte',
    code_1: 'V01-X59',
    code_0: 'V01-Y99'
  },
  {
    code: 'V70-V79',
    level: 2,
    description:
      'Ocupante de autob\u00fas lesionado en accidente de transporte',
    code_1: 'V01-X59',
    code_0: 'V01-Y99'
  },
  {
    code: 'V80-V89',
    level: 2,
    description: 'Otros accidentes de transporte terrestre',
    code_1: 'V01-X59',
    code_0: 'V01-Y99'
  },
  {
    code: 'V90-V94',
    level: 2,
    description: 'Accidentes de transporte por agua',
    code_1: 'V01-X59',
    code_0: 'V01-Y99'
  },
  {
    code: 'V95-V97',
    level: 2,
    description: 'Accidentes de transporte a\u00e9reo y espacial',
    code_1: 'V01-X59',
    code_0: 'V01-Y99'
  },
  {
    code: 'R64',
    level: 2,
    description: 'Caquexia',
    code_1: 'R50-R69',
    code_0: 'R00-R99'
  },
  {
    code: 'R68',
    level: 2,
    description: 'Otros s\u00edntomas y signos generales',
    code_1: 'R50-R69',
    code_0: 'R00-R99'
  },
  {
    code: 'R69',
    level: 2,
    description: 'Causas de morbilidad desconocidas y no especificadas',
    code_1: 'R50-R69',
    code_0: 'R00-R99'
  },
  {
    code: 'C960',
    level: 4,
    description: 'Enfermedad de Letterer-Siwe',
    code_3: 'C96',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C961',
    level: 4,
    description: 'Histiocitosis maligna',
    code_3: 'C96',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C962',
    level: 4,
    description: 'Tumor maligno de mastocitos',
    code_3: 'C96',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C963',
    level: 4,
    description: 'Linfoma histioc\u00edtico verdadero',
    code_3: 'C96',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C967',
    level: 4,
    description:
      'Otros tumores malignos especificados del tejido linf\u00e1tico, hematopoy\u00e9tico y tejidos afines',
    code_3: 'C96',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C969',
    level: 4,
    description:
      'Tumor maligno del tejido linf\u00e1tico, hematopoy\u00e9tico y tejidos afines, sin otra especificaci\u00f3n',
    code_3: 'C96',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C950',
    level: 4,
    description: 'Leucemia aguda, c\u00e9lulas de tipo no especificado',
    code_3: 'C95',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C951',
    level: 4,
    description: 'Leucemia cr\u00f3nica, c\u00e9lulas de tipo no especificado',
    code_3: 'C95',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C952',
    level: 4,
    description: 'Leucemia subaguda, c\u00e9lulas de tipo no especificado',
    code_3: 'C95',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C957',
    level: 4,
    description: 'Otras leucemias de c\u00e9lulas de tipo no especificado',
    code_3: 'C95',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C959',
    level: 4,
    description: 'Leucemia, no especificada',
    code_3: 'C95',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C940',
    level: 4,
    description: 'Eritremia aguda y eritroleucemia',
    code_3: 'C94',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C941',
    level: 4,
    description: 'Eritremia cr\u00f3nica',
    code_3: 'C94',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C942',
    level: 4,
    description: 'Leucemia megacariobl\u00e1stica aguda',
    code_3: 'C94',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C943',
    level: 4,
    description: 'Leucemia de mastocitos',
    code_3: 'C94',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C944',
    level: 4,
    description: 'Panmielosis aguda',
    code_3: 'C94',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C945',
    level: 4,
    description: 'Mielofibrosis aguda',
    code_3: 'C94',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C947',
    level: 4,
    description: 'Otras leucemias especificadas',
    code_3: 'C94',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'Y890',
    level: 3,
    description: 'Secuelas de intervenci\u00f3n legal',
    code_2: 'Y89',
    code_0: 'V01-Y99',
    code_1: 'Y85-Y89'
  },
  {
    code: 'Y891',
    level: 3,
    description: 'Secuelas de operaciones de guerra',
    code_2: 'Y89',
    code_0: 'V01-Y99',
    code_1: 'Y85-Y89'
  },
  {
    code: 'Y899',
    level: 3,
    description: 'Secuelas de causa externa no especificada',
    code_2: 'Y89',
    code_0: 'V01-Y99',
    code_1: 'Y85-Y89'
  },
  {
    code: 'R520',
    level: 3,
    description: 'Dolor agudo',
    code_2: 'R52',
    code_0: 'R00-R99',
    code_1: 'R50-R69'
  },
  {
    code: 'R521',
    level: 3,
    description: 'Dolor cr\u00f3nico intratable',
    code_2: 'R52',
    code_0: 'R00-R99',
    code_1: 'R50-R69'
  },
  {
    code: 'R522',
    level: 3,
    description: 'Otro dolor cr\u00f3nico',
    code_2: 'R52',
    code_0: 'R00-R99',
    code_1: 'R50-R69'
  },
  {
    code: 'R529',
    level: 3,
    description: 'Dolor, no especificado',
    code_2: 'R52',
    code_0: 'R00-R99',
    code_1: 'R50-R69'
  },
  {
    code: 'R502',
    level: 3,
    description: 'Fiebre inducida por drogas',
    code_2: 'R50',
    code_0: 'R00-R99',
    code_1: 'R50-R69'
  },
  {
    code: 'R508',
    level: 3,
    description: 'Otras fiebres especificadas',
    code_2: 'R50',
    code_0: 'R00-R99',
    code_1: 'R50-R69'
  },
  {
    code: 'R509',
    level: 3,
    description: 'Fiebre, no especificada',
    code_2: 'R50',
    code_0: 'R00-R99',
    code_1: 'R50-R69'
  },
  {
    code: 'R740',
    level: 3,
    description:
      'Elevaci\u00f3n de los niveles de transaminasas o deshidrogenasa l\u00e1ctica [DHL]',
    code_2: 'R74',
    code_0: 'R00-R99',
    code_1: 'R70-R79'
  },
  {
    code: 'R748',
    level: 3,
    description: 'Niveles anormales de otras enzimas en suero',
    code_2: 'R74',
    code_0: 'R00-R99',
    code_1: 'R70-R79'
  },
  {
    code: 'R749',
    level: 3,
    description: 'Nivel anormal de enzimas en suero, no especificado',
    code_2: 'R74',
    code_0: 'R00-R99',
    code_1: 'R70-R79'
  },
  {
    code: 'R730',
    level: 3,
    description: 'Anormalidades en la prueba de tolerancia a la glucosa',
    code_2: 'R73',
    code_0: 'R00-R99',
    code_1: 'R70-R79'
  },
  {
    code: 'R739',
    level: 3,
    description: 'Hiperglicemia, no especificada',
    code_2: 'R73',
    code_0: 'R00-R99',
    code_1: 'R70-R79'
  },
  {
    code: 'R700',
    level: 3,
    description: 'Velocidad de eritrosedimentaci\u00f3n elevada',
    code_2: 'R70',
    code_0: 'R00-R99',
    code_1: 'R70-R79'
  },
  {
    code: 'R701',
    level: 3,
    description: 'Viscosidad plasm\u00e1tica anormal',
    code_2: 'R70',
    code_0: 'R00-R99',
    code_1: 'R70-R79'
  },
  {
    code: 'R820',
    level: 3,
    description: 'Quiluria',
    code_2: 'R82',
    code_0: 'R00-R99',
    code_1: 'R80-R82'
  },
  {
    code: 'R821',
    level: 3,
    description: 'Mioglobinuria',
    code_2: 'R82',
    code_0: 'R00-R99',
    code_1: 'R80-R82'
  },
  {
    code: 'R822',
    level: 3,
    description: 'Biliuria',
    code_2: 'R82',
    code_0: 'R00-R99',
    code_1: 'R80-R82'
  },
  {
    code: 'R823',
    level: 3,
    description: 'Hemoglobinuria',
    code_2: 'R82',
    code_0: 'R00-R99',
    code_1: 'R80-R82'
  },
  {
    code: 'R824',
    level: 3,
    description: 'Acetonuria',
    code_2: 'R82',
    code_0: 'R00-R99',
    code_1: 'R80-R82'
  },
  {
    code: 'R825',
    level: 3,
    description:
      'Elevaci\u00f3n de los niveles de drogas, medicamentos y sustancias biol\u00f3gicas en la orina',
    code_2: 'R82',
    code_0: 'R00-R99',
    code_1: 'R80-R82'
  },
  {
    code: 'R826',
    level: 3,
    description:
      'Niveles anormales en la orina de sustancias de origen principalmente no medicinal',
    code_2: 'R82',
    code_0: 'R00-R99',
    code_1: 'R80-R82'
  },
  {
    code: 'R827',
    level: 3,
    description:
      'Hallazgos anormales en el examen microbiol\u00f3gico de la orina',
    code_2: 'R82',
    code_0: 'R00-R99',
    code_1: 'R80-R82'
  },
  {
    code: 'R828',
    level: 3,
    description:
      'Hallazgos anormales en el examen citol\u00f3gico e histol\u00f3gico de la orina',
    code_2: 'R82',
    code_0: 'R00-R99',
    code_1: 'R80-R82'
  },
  {
    code: 'R930',
    level: 3,
    description:
      'Hallazgos anormales en diagn\u00f3stico por imagen del cr\u00e1neo y de la cabeza, no clasificados en otra parte',
    code_2: 'R93',
    code_0: 'R00-R99',
    code_1: 'R90-R94'
  },
  {
    code: 'R931',
    level: 3,
    description:
      'Hallazgos anormales en diagn\u00f3stico por imagen del coraz\u00f3n y de la circulaci\u00f3n coronaria',
    code_2: 'R93',
    code_0: 'R00-R99',
    code_1: 'R90-R94'
  },
  {
    code: 'R932',
    level: 3,
    description:
      'Hallazgos anormales en diagn\u00f3stico por imagen del h\u00edgado y de las v\u00edas biliares',
    code_2: 'R93',
    code_0: 'R00-R99',
    code_1: 'R90-R94'
  },
  {
    code: 'R933',
    level: 3,
    description:
      'Hallazgos anormales en diagn\u00f3stico por imagen de otras partes de las v\u00edas digestivas',
    code_2: 'R93',
    code_0: 'R00-R99',
    code_1: 'R90-R94'
  },
  {
    code: 'R934',
    level: 3,
    description:
      'Hallazgos anormales en diagn\u00f3stico por imagen de los \u00f3rganos urinarios',
    code_2: 'R93',
    code_0: 'R00-R99',
    code_1: 'R90-R94'
  },
  {
    code: 'R935',
    level: 3,
    description:
      'Hallazgos anormales en diagn\u00f3stico por imagen de otras regiones abdominales, incluido el retroperitoneo',
    code_2: 'R93',
    code_0: 'R00-R99',
    code_1: 'R90-R94'
  },
  {
    code: 'R936',
    level: 3,
    description:
      'Hallazgos anormales en diagn\u00f3stico por imagen de los miembros',
    code_2: 'R93',
    code_0: 'R00-R99',
    code_1: 'R90-R94'
  },
  {
    code: 'R937',
    level: 3,
    description:
      'Hallazgos anormales en diagn\u00f3stico por imagen de otras partes del sistema osteomuscular',
    code_2: 'R93',
    code_0: 'R00-R99',
    code_1: 'R90-R94'
  },
  {
    code: 'R938',
    level: 3,
    description:
      'Hallazgos anormales en diagn\u00f3stico por imagen de otras estructuras especificadas del cuerpo',
    code_2: 'R93',
    code_0: 'R00-R99',
    code_1: 'R90-R94'
  },
  {
    code: 'R900',
    level: 3,
    description: 'Lesi\u00f3n que ocupa el espacio intracraneal',
    code_2: 'R90',
    code_0: 'R00-R99',
    code_1: 'R90-R94'
  },
  {
    code: 'R908',
    level: 3,
    description:
      'Otros hallazgos anormales en diagn\u00f3stico por imagen del sistema nervioso central',
    code_2: 'R90',
    code_0: 'R00-R99',
    code_1: 'R90-R94'
  },
  {
    code: 'Q320',
    level: 3,
    description: 'Traqueomalacia cong\u00e9nita',
    code_2: 'Q32',
    code_0: 'Q00-Q99',
    code_1: 'Q30-Q34'
  },
  {
    code: 'Q321',
    level: 3,
    description: 'Otras malformaciones cong\u00e9nitas de la tr\u00e1quea',
    code_2: 'Q32',
    code_0: 'Q00-Q99',
    code_1: 'Q30-Q34'
  },
  {
    code: 'Q322',
    level: 3,
    description: 'Broncomalacia cong\u00e9nita',
    code_2: 'Q32',
    code_0: 'Q00-Q99',
    code_1: 'Q30-Q34'
  },
  {
    code: 'Q323',
    level: 3,
    description: 'Estenosis cong\u00e9nita de los bronquios',
    code_2: 'Q32',
    code_0: 'Q00-Q99',
    code_1: 'Q30-Q34'
  },
  {
    code: 'Q324',
    level: 3,
    description: 'Otras malformaciones cong\u00e9nitas de los bronquios',
    code_2: 'Q32',
    code_0: 'Q00-Q99',
    code_1: 'Q30-Q34'
  },
  {
    code: 'Q310',
    level: 3,
    description: 'Pterigi\u00f3n de la laringe',
    code_2: 'Q31',
    code_0: 'Q00-Q99',
    code_1: 'Q30-Q34'
  },
  {
    code: 'Q311',
    level: 3,
    description: 'Estenosis subgl\u00f3tica cong\u00e9nita',
    code_2: 'Q31',
    code_0: 'Q00-Q99',
    code_1: 'Q30-Q34'
  },
  {
    code: 'Q312',
    level: 3,
    description: 'Hipoplasia lar\u00edngea',
    code_2: 'Q31',
    code_0: 'Q00-Q99',
    code_1: 'Q30-Q34'
  },
  {
    code: 'Q300',
    level: 3,
    description: 'Atresia de las coanas',
    code_2: 'Q30',
    code_0: 'Q00-Q99',
    code_1: 'Q30-Q34'
  },
  {
    code: 'Q301',
    level: 3,
    description: 'Agenesia o hipoplasia de la nariz',
    code_2: 'Q30',
    code_0: 'Q00-Q99',
    code_1: 'Q30-Q34'
  },
  {
    code: 'Q302',
    level: 3,
    description: 'Hendidura, fisura o muesca de la nariz',
    code_2: 'Q30',
    code_0: 'Q00-Q99',
    code_1: 'Q30-Q34'
  },
  {
    code: 'Q303',
    level: 3,
    description: 'Perforaci\u00f3n cong\u00e9nita del tabique nasal',
    code_2: 'Q30',
    code_0: 'Q00-Q99',
    code_1: 'Q30-Q34'
  },
  {
    code: 'Q360',
    level: 3,
    description: 'Labio leporino, bilateral',
    code_2: 'Q36',
    code_0: 'Q00-Q99',
    code_1: 'Q35-Q37'
  },
  {
    code: 'Q361',
    level: 3,
    description: 'Labio leporino, l\u00ednea media',
    code_2: 'Q36',
    code_0: 'Q00-Q99',
    code_1: 'Q35-Q37'
  },
  {
    code: 'Q369',
    level: 3,
    description: 'Labio leporino, unilateral',
    code_2: 'Q36',
    code_0: 'Q00-Q99',
    code_1: 'Q35-Q37'
  },
  {
    code: 'Q351',
    level: 3,
    description: 'Fisura del paladar duro',
    code_2: 'Q35',
    code_0: 'Q00-Q99',
    code_1: 'Q35-Q37'
  },
  {
    code: 'Q353',
    level: 3,
    description: 'Fisura del paladar blando',
    code_2: 'Q35',
    code_0: 'Q00-Q99',
    code_1: 'Q35-Q37'
  },
  {
    code: 'Q355',
    level: 3,
    description: 'Fisura del paladar duro y del paladar blando',
    code_2: 'Q35',
    code_0: 'Q00-Q99',
    code_1: 'Q35-Q37'
  },
  {
    code: 'Q357',
    level: 3,
    description: 'Fisura de la \u00favula',
    code_2: 'Q35',
    code_0: 'Q00-Q99',
    code_1: 'Q35-Q37'
  },
  {
    code: 'Q359',
    level: 3,
    description: 'Fisura del paladar, sin otra especificaci\u00f3n',
    code_2: 'Q35',
    code_0: 'Q00-Q99',
    code_1: 'Q35-Q37'
  },
  {
    code: 'Q380',
    level: 3,
    description:
      'Malformaciones cong\u00e9nitas de los labios, no clasificadas en otra parte',
    code_2: 'Q38',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q381',
    level: 3,
    description: 'Anquiloglosia',
    code_2: 'Q38',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q382',
    level: 3,
    description: 'Macroglosia',
    code_2: 'Q38',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q383',
    level: 3,
    description: 'Otras malformaciones cong\u00e9nitas de la lengua',
    code_2: 'Q38',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q384',
    level: 3,
    description:
      'Malformaciones cong\u00e9nitas de las gl\u00e1ndulas y de los conductos salivales',
    code_2: 'Q38',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q385',
    level: 3,
    description:
      'Malformaciones cong\u00e9nitas del paladar, no clasificadas en otra parte',
    code_2: 'Q38',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q386',
    level: 3,
    description: 'Otras malformaciones cong\u00e9nitas de la boca',
    code_2: 'Q38',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q550',
    level: 3,
    description: 'Ausencia y aplasia del test\u00edculo',
    code_2: 'Q55',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q551',
    level: 3,
    description: 'Hipoplasia del test\u00edculo y del escroto',
    code_2: 'Q55',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q552',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas de los test\u00edculos y del escroto',
    code_2: 'Q55',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q553',
    level: 3,
    description: 'Atresia del conducto deferente',
    code_2: 'Q55',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q554',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas de los conductos deferentes, del epid\u00eddimo, de las ves\u00edculas seminales y de la pr\u00f3stata',
    code_2: 'Q55',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q555',
    level: 3,
    description: 'Aplasia y ausencia cong\u00e9nita del pene',
    code_2: 'Q55',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q556',
    level: 3,
    description: 'Otras malformaciones cong\u00e9nitas del pene',
    code_2: 'Q55',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q558',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas de los \u00f3rganos genitales masculinos, especificadas',
    code_2: 'Q55',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q559',
    level: 3,
    description:
      'Malformaci\u00f3n cong\u00e9nita de los \u00f3rganos genitales masculinos, no especificada',
    code_2: 'Q55',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q540',
    level: 3,
    description: 'Hipospadias del glande',
    code_2: 'Q54',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q541',
    level: 3,
    description: 'Hipospadias peneana',
    code_2: 'Q54',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q542',
    level: 3,
    description: 'Hipospadias penoscrotal',
    code_2: 'Q54',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q543',
    level: 3,
    description: 'Hipospadias perineal',
    code_2: 'Q54',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q544',
    level: 3,
    description: 'Encordamiento cong\u00e9nito del pene',
    code_2: 'Q54',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q548',
    level: 3,
    description: 'Otras hipospadias',
    code_2: 'Q54',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q549',
    level: 3,
    description: 'Hipospadias, no especificada',
    code_2: 'Q54',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q530',
    level: 3,
    description: 'Ectopia testicular',
    code_2: 'Q53',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q531',
    level: 3,
    description: 'Test\u00edculo no descendido, unilateral',
    code_2: 'Q53',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q532',
    level: 3,
    description: 'Test\u00edculo no descendido, bilateral',
    code_2: 'Q53',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q539',
    level: 3,
    description: 'Test\u00edculo no descendido, sin otra especificaci\u00f3n',
    code_2: 'Q53',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q520',
    level: 3,
    description: 'Ausencia cong\u00e9nita de la vagina',
    code_2: 'Q52',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q521',
    level: 3,
    description: 'Duplicaci\u00f3n de la vagina',
    code_2: 'Q52',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q522',
    level: 3,
    description: 'F\u00edstula rectovaginal cong\u00e9nita',
    code_2: 'Q52',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q523',
    level: 3,
    description: 'Himen imperforado',
    code_2: 'Q52',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q524',
    level: 3,
    description: 'Otras malformaciones cong\u00e9nitas de la vagina',
    code_2: 'Q52',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q525',
    level: 3,
    description: 'Fusi\u00f3n de labios de la vulva',
    code_2: 'Q52',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q526',
    level: 3,
    description: 'Malformaci\u00f3n cong\u00e9nita del cl\u00edtoris',
    code_2: 'Q52',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q527',
    level: 3,
    description: 'Otras malformaciones cong\u00e9nitas de la vulva',
    code_2: 'Q52',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q510',
    level: 3,
    description: 'Agenesia y aplasia del \u00fatero',
    code_2: 'Q51',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q511',
    level: 3,
    description:
      'Duplicaci\u00f3n del \u00fatero con duplicaci\u00f3n del cuello uterino y de la vagina',
    code_2: 'Q51',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q512',
    level: 3,
    description: 'Otra duplicaci\u00f3n del \u00fatero',
    code_2: 'Q51',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q513',
    level: 3,
    description: '\u00datero bicorne',
    code_2: 'Q51',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q514',
    level: 3,
    description: '\u00datero unicorne',
    code_2: 'Q51',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q515',
    level: 3,
    description: 'Agenesia y aplasia del cuello uterino',
    code_2: 'Q51',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q516',
    level: 3,
    description: 'Quiste embrionario del cuello uterino',
    code_2: 'Q51',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q517',
    level: 3,
    description:
      'F\u00edstula cong\u00e9nita entre el \u00fatero y el tracto digestivo y urinario',
    code_2: 'Q51',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q500',
    level: 3,
    description: 'Ausencia cong\u00e9nita de ovario',
    code_2: 'Q50',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q501',
    level: 3,
    description: 'Quiste en desarrollo del ovario',
    code_2: 'Q50',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q502',
    level: 3,
    description: 'Torsi\u00f3n cong\u00e9nita del ovario',
    code_2: 'Q50',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q503',
    level: 3,
    description: 'Otras malformaciones cong\u00e9nitas de los ovarios',
    code_2: 'Q50',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q504',
    level: 3,
    description: 'Quiste embrionario de la trompa de Falopio',
    code_2: 'Q50',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q505',
    level: 3,
    description: 'Quiste embrionario del ligamento ancho',
    code_2: 'Q50',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q506',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas de la trompa de Falopio y del ligamento ancho',
    code_2: 'Q50',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q640',
    level: 3,
    description: 'Epispadias',
    code_2: 'Q64',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q641',
    level: 3,
    description: 'Extrofia de la vejiga urinaria',
    code_2: 'Q64',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q642',
    level: 3,
    description: 'V\u00e1lvulas uretrales posteriores cong\u00e9nitas',
    code_2: 'Q64',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q643',
    level: 3,
    description:
      'Otras atresias y estenosis de la uretra y del cuello de la vejiga',
    code_2: 'Q64',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q644',
    level: 3,
    description: 'Malformaci\u00f3n del uraco',
    code_2: 'Q64',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q645',
    level: 3,
    description: 'Ausencia cong\u00e9nita de la vejiga y de la uretra',
    code_2: 'Q64',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q646',
    level: 3,
    description: 'Divert\u00edculo cong\u00e9nito de la vejiga',
    code_2: 'Q64',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q647',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas de la vejiga y de la uretra',
    code_2: 'Q64',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q648',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas del aparato urinario, especificadas',
    code_2: 'Q64',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q649',
    level: 3,
    description:
      'Malformaci\u00f3n cong\u00e9nita del aparato urinario, no especificada',
    code_2: 'Q64',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q630',
    level: 3,
    description: 'Ri\u00f1\u00f3n supernumerario',
    code_2: 'Q63',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q631',
    level: 3,
    description: 'Ri\u00f1\u00f3n lobulado, fusionado y en herradura',
    code_2: 'Q63',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q632',
    level: 3,
    description: 'Ri\u00f1\u00f3n ect\u00f3pico',
    code_2: 'Q63',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q633',
    level: 3,
    description: 'Hiperplasia renal y ri\u00f1\u00f3n gigante',
    code_2: 'Q63',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q638',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas del ri\u00f1\u00f3n, especificadas',
    code_2: 'Q63',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q620',
    level: 3,
    description: 'Hidronefrosis cong\u00e9nita',
    code_2: 'Q62',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q621',
    level: 3,
    description: 'Atresia y estenosis del ur\u00e9ter',
    code_2: 'Q62',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q622',
    level: 3,
    description: 'Megalour\u00e9ter cong\u00e9nito',
    code_2: 'Q62',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q623',
    level: 3,
    description:
      'Otros defectos obstructivos de la pelvis renal y del ur\u00e9ter',
    code_2: 'Q62',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q624',
    level: 3,
    description: 'Agenesia del ur\u00e9ter',
    code_2: 'Q62',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q625',
    level: 3,
    description: 'Duplicaci\u00f3n del ur\u00e9ter',
    code_2: 'Q62',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q626',
    level: 3,
    description: 'Mala posici\u00f3n del ur\u00e9ter',
    code_2: 'Q62',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q627',
    level: 3,
    description:
      'Reflujo v\u00e9sico\u2013ur\u00e9tero\u2013renal cong\u00e9nito',
    code_2: 'Q62',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q610',
    level: 3,
    description: 'Quiste renal solitario cong\u00e9nito',
    code_2: 'Q61',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q611',
    level: 3,
    description: 'Ri\u00f1\u00f3n poliqu\u00edstico, autos\u00f3mico recesivo',
    code_2: 'Q61',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q612',
    level: 3,
    description: 'Ri\u00f1\u00f3n poliqu\u00edstico, autos\u00f3mico dominante',
    code_2: 'Q61',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q613',
    level: 3,
    description: 'Ri\u00f1\u00f3n poliqu\u00edstico, tipo no especificado',
    code_2: 'Q61',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q614',
    level: 3,
    description: 'Displasia renal',
    code_2: 'Q61',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q615',
    level: 3,
    description: 'Ri\u00f1\u00f3n qu\u00edstico medular',
    code_2: 'Q61',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q618',
    level: 3,
    description: 'Otras enfermedades renales qu\u00edsticas',
    code_2: 'Q61',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q619',
    level: 3,
    description:
      'Enfermedad qu\u00edstica del ri\u00f1\u00f3n, no especificada',
    code_2: 'Q61',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q600',
    level: 3,
    description: 'Agenesia renal, unilateral',
    code_2: 'Q60',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q601',
    level: 3,
    description: 'Agenesia renal, bilateral',
    code_2: 'Q60',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q602',
    level: 3,
    description: 'Agenesia renal, sin otra especificaci\u00f3n',
    code_2: 'Q60',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q603',
    level: 3,
    description: 'Hipoplasia renal, unilateral',
    code_2: 'Q60',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q604',
    level: 3,
    description: 'Hipoplasia renal, bilateral',
    code_2: 'Q60',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q605',
    level: 3,
    description: 'Hipoplasia renal, no especificada',
    code_2: 'Q60',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q606',
    level: 3,
    description: 'S\u00edndrome de Potter',
    code_2: 'Q60',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q690',
    level: 3,
    description: 'Dedo(s) supernumerario(s) de la mano',
    code_2: 'Q69',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q691',
    level: 3,
    description: 'Pulgar(es) supernumerario(s)',
    code_2: 'Q69',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q692',
    level: 3,
    description: 'Dedo(s) supernumerario(s) del pie',
    code_2: 'Q69',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q699',
    level: 3,
    description: 'Polidactilia, no especificada',
    code_2: 'Q69',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q680',
    level: 3,
    description:
      'Deformidad cong\u00e9nita del m\u00fasculo esternocleidomastoideo',
    code_2: 'Q68',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q681',
    level: 3,
    description: 'Deformidad cong\u00e9nita de la mano',
    code_2: 'Q68',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q682',
    level: 3,
    description: 'Deformidad cong\u00e9nita de la rodilla',
    code_2: 'Q68',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q683',
    level: 3,
    description: 'Curvatura cong\u00e9nita del f\u00e9mur',
    code_2: 'Q68',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q684',
    level: 3,
    description: 'Curvatura cong\u00e9nita de la tibia y del peron\u00e9',
    code_2: 'Q68',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q685',
    level: 3,
    description:
      'Curvatura cong\u00e9nita de hueso(s) largo(s) del miembro inferior, sin otra especificaci\u00f3n',
    code_2: 'Q68',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q688',
    level: 3,
    description:
      'Otras deformidades cong\u00e9nitas osteomusculares, especificadas',
    code_2: 'Q68',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q670',
    level: 3,
    description: 'Asimetr\u00eda facial',
    code_2: 'Q67',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q671',
    level: 3,
    description: 'Facies comprimida',
    code_2: 'Q67',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q672',
    level: 3,
    description: 'Dolicocefalia',
    code_2: 'Q67',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q673',
    level: 3,
    description: 'Plagiocefalia',
    code_2: 'Q67',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q674',
    level: 3,
    description:
      'Otras deformidades cong\u00e9nitas del cr\u00e1neo, de la cara y de la mand\u00edbula',
    code_2: 'Q67',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q675',
    level: 3,
    description: 'Deformidad cong\u00e9nita de la columna vertebral',
    code_2: 'Q67',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q660',
    level: 3,
    description: 'Talipes equinovarus',
    code_2: 'Q66',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q661',
    level: 3,
    description: 'Talipes calcaneovarus',
    code_2: 'Q66',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q662',
    level: 3,
    description: 'Metatarsus varus',
    code_2: 'Q66',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q650',
    level: 3,
    description: 'Luxaci\u00f3n cong\u00e9nita de la cadera, unilateral',
    code_2: 'Q65',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q651',
    level: 3,
    description: 'Luxaci\u00f3n cong\u00e9nita de la cadera, bilateral',
    code_2: 'Q65',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q652',
    level: 3,
    description: 'Luxaci\u00f3n cong\u00e9nita de la cadera, no especificada',
    code_2: 'Q65',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q653',
    level: 3,
    description: 'Subluxaci\u00f3n cong\u00e9nita de la cadera, unilateral',
    code_2: 'Q65',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q820',
    level: 3,
    description: 'Linfedema hereditario',
    code_2: 'Q82',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q821',
    level: 3,
    description: 'Xeroderma pigmentoso',
    code_2: 'Q82',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q822',
    level: 3,
    description: 'Mastocitosis',
    code_2: 'Q82',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q823',
    level: 3,
    description: 'Incontinencia pigmentaria',
    code_2: 'Q82',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q810',
    level: 3,
    description: 'Epiderm\u00f3lisis bullosa simple',
    code_2: 'Q81',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q811',
    level: 3,
    description: 'Epiderm\u00f3lisis bullosa letal',
    code_2: 'Q81',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q812',
    level: 3,
    description: 'Epiderm\u00f3lisis bullosa distr\u00f3fica',
    code_2: 'Q81',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q818',
    level: 3,
    description: 'Otras epiderm\u00f3lisis bullosas',
    code_2: 'Q81',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q800',
    level: 3,
    description: 'Ictiosis vulgar',
    code_2: 'Q80',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q801',
    level: 3,
    description: 'Ictiosis ligada al cromosoma X',
    code_2: 'Q80',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q802',
    level: 3,
    description: 'Ictiosis lamelar',
    code_2: 'Q80',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q803',
    level: 3,
    description: 'Eritrodermia ictiosiforme vesicular cong\u00e9nita',
    code_2: 'Q80',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q960',
    level: 3,
    description: 'Cariotipo 45,X',
    code_2: 'Q96',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q961',
    level: 3,
    description: 'Cariotipo 46,X iso (Xq)',
    code_2: 'Q96',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q962',
    level: 3,
    description: 'Cariotipo 46,X con cromosoma sexual anormal excepto iso (Xq)',
    code_2: 'Q96',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q963',
    level: 3,
    description: 'Mosaico 45,X/46,XX o XY',
    code_2: 'Q96',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q964',
    level: 3,
    description:
      'Mosaico 45,X/otra(s) l\u00ednea(s) celular(es) con cromosoma sexual anormal',
    code_2: 'Q96',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q968',
    level: 3,
    description: 'Otras variantes del s\u00edndrome de Turner',
    code_2: 'Q96',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q950',
    level: 3,
    description:
      'Translocaci\u00f3n equilibrada e inserci\u00f3n en individuo normal',
    code_2: 'Q95',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q951',
    level: 3,
    description: 'Inversi\u00f3n cromos\u00f3mica en individuo normal',
    code_2: 'Q95',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q952',
    level: 3,
    description:
      'Reordenamiento autos\u00f3mico equilibrado en individuo anormal',
    code_2: 'Q95',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q953',
    level: 3,
    description:
      'Reordenamiento autos\u00f3mico/sexual equilibrado en individuo anormal',
    code_2: 'Q95',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q954',
    level: 3,
    description: 'Individuos con heterocromatina marcadora',
    code_2: 'Q95',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q955',
    level: 3,
    description: 'Individuos con sitio fr\u00e1gil autos\u00f3mico',
    code_2: 'Q95',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q958',
    level: 3,
    description:
      'Otros reordenamientos equilibrados y marcadores estructurales',
    code_2: 'Q95',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q930',
    level: 3,
    description:
      'Monosom\u00eda completa de un cromosoma, por falta de disyunci\u00f3n mei\u00f3tica',
    code_2: 'Q93',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q931',
    level: 3,
    description:
      'Monosom\u00eda completa de un cromosoma, mosaico (por falta de disyunci\u00f3n mit\u00f3tica)',
    code_2: 'Q93',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q932',
    level: 3,
    description: 'Cromosoma reemplazado por anillo o dic\u00e9ntrico',
    code_2: 'Q93',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q933',
    level: 3,
    description: 'Supresi\u00f3n del brazo corto del cromosoma 4',
    code_2: 'Q93',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q920',
    level: 3,
    description:
      'Trisom\u00eda de un cromosoma completo, por falta de disyunci\u00f3n mei\u00f3tica',
    code_2: 'Q92',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q921',
    level: 3,
    description:
      'Trisom\u00eda de un cromosoma completo, mosaico (por falta de disyunci\u00f3n mit\u00f3tica)',
    code_2: 'Q92',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q922',
    level: 3,
    description: 'Trisom\u00eda parcial mayor',
    code_2: 'Q92',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q923',
    level: 3,
    description: 'Trisom\u00eda parcial menor',
    code_2: 'Q92',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q924',
    level: 3,
    description: 'Duplicaciones visibles s\u00f3lo en la prometafase',
    code_2: 'Q92',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q925',
    level: 3,
    description: 'Duplicaciones con otros reordenamientos complejos',
    code_2: 'Q92',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q910',
    level: 3,
    description: 'Trisom\u00eda 18, por falta de disyunci\u00f3n mei\u00f3tica',
    code_2: 'Q91',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q911',
    level: 3,
    description:
      'Trisom\u00eda 18, mosaico (por falta de disyunci\u00f3n mit\u00f3tica)',
    code_2: 'Q91',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q912',
    level: 3,
    description: 'Trisom\u00eda 18, por translocaci\u00f3n',
    code_2: 'Q91',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q913',
    level: 3,
    description: 'S\u00edndrome de Edwards, no especificado',
    code_2: 'Q91',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q914',
    level: 3,
    description: 'Trisom\u00eda 13, por falta de disyunci\u00f3n mei\u00f3tica',
    code_2: 'Q91',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q915',
    level: 3,
    description:
      'Trisom\u00eda 13, mosaico (por falta de disyunci\u00f3n mit\u00f3tica)',
    code_2: 'Q91',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q916',
    level: 3,
    description: 'Trisom\u00eda 13, por translocaci\u00f3n',
    code_2: 'Q91',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q900',
    level: 3,
    description: 'Trisom\u00eda 21, por falta de disyunci\u00f3n mei\u00f3tica',
    code_2: 'Q90',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q901',
    level: 3,
    description:
      'Trisom\u00eda 21, mosaico (por falta de disyunci\u00f3n mit\u00f3tica)',
    code_2: 'Q90',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q902',
    level: 3,
    description: 'Trisom\u00eda 21, por translocaci\u00f3n',
    code_2: 'Q90',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q909',
    level: 3,
    description: 'S\u00edndrome de Down, no especificado',
    code_2: 'Q90',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'P780',
    level: 3,
    description: 'Perforaci\u00f3n intestinal perinatal',
    code_2: 'P78',
    code_0: 'P00-P96',
    code_1: 'P75-P78'
  },
  {
    code: 'P781',
    level: 3,
    description: 'Otras peritonitis neonatales',
    code_2: 'P78',
    code_0: 'P00-P96',
    code_1: 'P75-P78'
  },
  {
    code: 'P782',
    level: 3,
    description:
      'Hematemesis y melena neonatales debidas a la degluci\u00f3n de sangre materna',
    code_2: 'P78',
    code_0: 'P00-P96',
    code_1: 'P75-P78'
  },
  {
    code: 'P783',
    level: 3,
    description: 'Diarrea neonatal no infecciosa',
    code_2: 'P78',
    code_0: 'P00-P96',
    code_1: 'P75-P78'
  },
  {
    code: 'P788',
    level: 3,
    description:
      'Otros trastornos perinatales espec\u00edficos del sistema digestivo',
    code_2: 'P78',
    code_0: 'P00-P96',
    code_1: 'P75-P78'
  },
  {
    code: 'P760',
    level: 3,
    description: 'S\u00edndrome del tap\u00f3n de meconio',
    code_2: 'P76',
    code_0: 'P00-P96',
    code_1: 'P75-P78'
  },
  {
    code: 'P761',
    level: 3,
    description: '\u00cdleo transitorio del reci\u00e9n nacido',
    code_2: 'P76',
    code_0: 'P00-P96',
    code_1: 'P75-P78'
  },
  {
    code: 'P762',
    level: 3,
    description: 'Obstrucci\u00f3n intestinal debida a la leche espesa',
    code_2: 'P76',
    code_0: 'P00-P96',
    code_1: 'P75-P78'
  },
  {
    code: 'P768',
    level: 3,
    description:
      'Otras obstrucciones intestinales especificadas del reci\u00e9n nacido',
    code_2: 'P76',
    code_0: 'P00-P96',
    code_1: 'P75-P78'
  },
  {
    code: 'P769',
    level: 3,
    description:
      'Obstrucci\u00f3n intestinal del reci\u00e9n nacido, no especificada',
    code_2: 'P76',
    code_0: 'P00-P96',
    code_1: 'P75-P78'
  },
  {
    code: 'P830',
    level: 3,
    description: 'Esclerema neonatal',
    code_2: 'P83',
    code_0: 'P00-P96',
    code_1: 'P80-P83'
  },
  {
    code: 'P831',
    level: 3,
    description: 'Eritema t\u00f3xico neonatal',
    code_2: 'P83',
    code_0: 'P00-P96',
    code_1: 'P80-P83'
  },
  {
    code: 'P832',
    level: 3,
    description: 'Hidropes\u00eda fetal no debida a enfermedad hemol\u00edtica',
    code_2: 'P83',
    code_0: 'P00-P96',
    code_1: 'P80-P83'
  },
  {
    code: 'P833',
    level: 3,
    description:
      'Otros edemas y los no especificados, propios del feto y del reci\u00e9n nacido',
    code_2: 'P83',
    code_0: 'P00-P96',
    code_1: 'P80-P83'
  },
  {
    code: 'P834',
    level: 3,
    description: 'Ingurgitaci\u00f3n mamaria del reci\u00e9n nacido',
    code_2: 'P83',
    code_0: 'P00-P96',
    code_1: 'P80-P83'
  },
  {
    code: 'P835',
    level: 3,
    description: 'Hidrocele cong\u00e9nito',
    code_2: 'P83',
    code_0: 'P00-P96',
    code_1: 'P80-P83'
  },
  {
    code: 'P836',
    level: 3,
    description: 'P\u00f3lipo umbilical del reci\u00e9n nacido',
    code_2: 'P83',
    code_0: 'P00-P96',
    code_1: 'P80-P83'
  },
  {
    code: 'P838',
    level: 3,
    description:
      'Otras afecciones especificadas de la piel, propias del feto y del reci\u00e9n nacido',
    code_2: 'P83',
    code_0: 'P00-P96',
    code_1: 'P80-P83'
  },
  {
    code: 'P839',
    level: 3,
    description:
      'Afecci\u00f3n no especificada de la piel, propia del feto y del reci\u00e9n nacido',
    code_2: 'P83',
    code_0: 'P00-P96',
    code_1: 'P80-P83'
  },
  {
    code: 'P810',
    level: 3,
    description:
      'Hipertermia del reci\u00e9n nacido inducida por las condiciones ambientales',
    code_2: 'P81',
    code_0: 'P00-P96',
    code_1: 'P80-P83'
  },
  {
    code: 'P818',
    level: 3,
    description:
      'Otras alteraciones especificadas de la regulaci\u00f3n de la temperatura del reci\u00e9n nacido',
    code_2: 'P81',
    code_0: 'P00-P96',
    code_1: 'P80-P83'
  },
  {
    code: 'P819',
    level: 3,
    description:
      'Alteraci\u00f3n no especificada de la regulaci\u00f3n de la temperatura en el reci\u00e9n nacido',
    code_2: 'P81',
    code_0: 'P00-P96',
    code_1: 'P80-P83'
  },
  {
    code: 'P800',
    level: 3,
    description: 'S\u00edndrome del enfriamiento',
    code_2: 'P80',
    code_0: 'P00-P96',
    code_1: 'P80-P83'
  },
  {
    code: 'P808',
    level: 3,
    description: 'Otras hipotermias del reci\u00e9n nacido',
    code_2: 'P80',
    code_0: 'P00-P96',
    code_1: 'P80-P83'
  },
  {
    code: 'P809',
    level: 3,
    description: 'Hipotermia del reci\u00e9n nacido, no especificada',
    code_2: 'P80',
    code_0: 'P00-P96',
    code_1: 'P80-P83'
  },
  {
    code: 'C68',
    level: 4,
    description:
      'Tumor maligno de otros \u00f3rganos urinarios y de los no especificados',
    code_3: 'C64-C68',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'P940',
    level: 3,
    description: 'Miastenia grave neonatal transitoria',
    code_2: 'P94',
    code_0: 'P00-P96',
    code_1: 'P90-P96'
  },
  {
    code: 'P941',
    level: 3,
    description: 'Hiperton\u00eda cong\u00e9nita',
    code_2: 'P94',
    code_0: 'P00-P96',
    code_1: 'P90-P96'
  },
  {
    code: 'P942',
    level: 3,
    description: 'Hipoton\u00eda cong\u00e9nita',
    code_2: 'P94',
    code_0: 'P00-P96',
    code_1: 'P90-P96'
  },
  {
    code: 'P948',
    level: 3,
    description: 'Otros trastornos del tono muscular en el reci\u00e9n nacido',
    code_2: 'P94',
    code_0: 'P00-P96',
    code_1: 'P90-P96'
  },
  {
    code: 'P949',
    level: 3,
    description:
      'Trastorno no especificado del tono muscular en el reci\u00e9n nacido',
    code_2: 'P94',
    code_0: 'P00-P96',
    code_1: 'P90-P96'
  },
  {
    code: 'C58',
    level: 4,
    description: 'Tumor maligno de la placenta',
    code_3: 'C51-C58',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C48',
    level: 4,
    description: 'Tumor maligno del peritoneo y del retroperitoneo',
    code_3: 'C45-C49',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C49',
    level: 4,
    description:
      'Tumor maligno de otros tejidos conjuntivos y de tejidos blandos',
    code_3: 'C45-C49',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'P920',
    level: 3,
    description: 'V\u00f3mitos del reci\u00e9n nacido',
    code_2: 'P92',
    code_0: 'P00-P96',
    code_1: 'P90-P96'
  },
  {
    code: 'P921',
    level: 3,
    description: 'Regurgitaci\u00f3n y rumiaci\u00f3n del reci\u00e9n nacido',
    code_2: 'P92',
    code_0: 'P00-P96',
    code_1: 'P90-P96'
  },
  {
    code: 'P922',
    level: 3,
    description:
      'Lentitud en la ingesti\u00f3n de alimentos del reci\u00e9n nacido',
    code_2: 'P92',
    code_0: 'P00-P96',
    code_1: 'P90-P96'
  },
  {
    code: 'P923',
    level: 3,
    description: 'Hipoalimentaci\u00f3n del reci\u00e9n nacido',
    code_2: 'P92',
    code_0: 'P00-P96',
    code_1: 'P90-P96'
  },
  {
    code: 'P924',
    level: 3,
    description: 'Hiperalimentaci\u00f3n del reci\u00e9n nacido',
    code_2: 'P92',
    code_0: 'P00-P96',
    code_1: 'P90-P96'
  },
  {
    code: 'P925',
    level: 3,
    description: 'Dificultad neonatal en la lactancia materna',
    code_2: 'P92',
    code_0: 'P00-P96',
    code_1: 'P90-P96'
  },
  {
    code: 'C784',
    level: 4,
    description: 'Tumor maligno secundario del intestino delgado',
    code_3: 'C78',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C76-C80'
  },
  {
    code: 'C785',
    level: 4,
    description: 'Tumor maligno secundario del intestino grueso y del recto',
    code_3: 'C78',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C76-C80'
  },
  {
    code: 'C786',
    level: 4,
    description: 'Tumor maligno secundario del peritoneo y del retroperitoneo',
    code_3: 'C78',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C76-C80'
  },
  {
    code: 'C787',
    level: 4,
    description: 'Tumor maligno secundario del h\u00edgado',
    code_3: 'C78',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C76-C80'
  },
  {
    code: 'C788',
    level: 4,
    description:
      'Tumor maligno secundario de otros \u00f3rganos digestivos y de los no especificados',
    code_3: 'C78',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C76-C80'
  },
  {
    code: 'P910',
    level: 3,
    description: 'Isquemia cerebral neonatal',
    code_2: 'P91',
    code_0: 'P00-P96',
    code_1: 'P90-P96'
  },
  {
    code: 'P911',
    level: 3,
    description: 'Quistes periventriculares adquiridos del reci\u00e9n nacido',
    code_2: 'P91',
    code_0: 'P00-P96',
    code_1: 'P90-P96'
  },
  {
    code: 'P912',
    level: 3,
    description: 'Leucomalacia cerebral neonatal',
    code_2: 'P91',
    code_0: 'P00-P96',
    code_1: 'P90-P96'
  },
  {
    code: 'P913',
    level: 3,
    description: 'Irritabilidad cerebral neonatal',
    code_2: 'P91',
    code_0: 'P00-P96',
    code_1: 'P90-P96'
  },
  {
    code: 'P914',
    level: 3,
    description: 'Depresi\u00f3n cerebral neonatal',
    code_2: 'P91',
    code_0: 'P00-P96',
    code_1: 'P90-P96'
  },
  {
    code: 'P915',
    level: 3,
    description: 'Coma neonatal',
    code_2: 'P91',
    code_0: 'P00-P96',
    code_1: 'P90-P96'
  },
  {
    code: 'P916',
    level: 3,
    description:
      'Encefalopat\u00eda hip\u00f3xico-isqu\u00e9mica del reci\u00e9n nacido',
    code_2: 'P91',
    code_0: 'P00-P96',
    code_1: 'P90-P96'
  },
  {
    code: 'P918',
    level: 3,
    description:
      'Otras alteraciones cerebrales especificadas del reci\u00e9n nacido',
    code_2: 'P91',
    code_0: 'P00-P96',
    code_1: 'P90-P96'
  },
  {
    code: 'O640',
    level: 3,
    description:
      'Trabajo de parto obstruido debido a rotaci\u00f3n incompleta de la cabeza fetal',
    code_2: 'O64',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O641',
    level: 3,
    description:
      'Trabajo de parto obstruido debido a presentaci\u00f3n de nalgas',
    code_2: 'O64',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O642',
    level: 3,
    description:
      'Trabajo de parto obstruido debido a presentaci\u00f3n de cara',
    code_2: 'O64',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O643',
    level: 3,
    description:
      'Trabajo de parto obstruido debido a presentaci\u00f3n de frente',
    code_2: 'O64',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O644',
    level: 3,
    description:
      'Trabajo de parto obstruido debido a presentaci\u00f3n de hombro',
    code_2: 'O64',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O645',
    level: 3,
    description:
      'Trabajo de parto obstruido debido a presentaci\u00f3n compuesta',
    code_2: 'O64',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O648',
    level: 3,
    description:
      'Trabajo de parto obstruido debido a otras presentaciones anormales del feto',
    code_2: 'O64',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O649',
    level: 3,
    description:
      'Trabajo de parto obstruido debido a presentaci\u00f3n anormal del feto no especificada',
    code_2: 'O64',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O630',
    level: 3,
    description:
      'Prolongaci\u00f3n del primer per\u00edodo (del trabajo de parto)',
    code_2: 'O63',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O631',
    level: 3,
    description:
      'Prolongaci\u00f3n del segundo per\u00edodo (del trabajo de parto)',
    code_2: 'O63',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O632',
    level: 3,
    description:
      'Retraso de la expulsi\u00f3n del segundo gemelo, del tercero, etc.',
    code_2: 'O63',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O639',
    level: 3,
    description: 'Trabajo de parto prolongado, no especificado',
    code_2: 'O63',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O620',
    level: 3,
    description: 'Contracciones primarias inadecuadas',
    code_2: 'O62',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O621',
    level: 3,
    description: 'Inercia uterina secundaria',
    code_2: 'O62',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O622',
    level: 3,
    description: 'Otras inercias uterinas',
    code_2: 'O62',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O623',
    level: 3,
    description: 'Trabajo de parto precipitado',
    code_2: 'O62',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O624',
    level: 3,
    description:
      'Contracciones uterinas hipert\u00f3nicas, incoordinadas y prolongadas',
    code_2: 'O62',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O628',
    level: 3,
    description: 'Otras anomal\u00edas din\u00e1micas del trabajo de parto',
    code_2: 'O62',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O629',
    level: 3,
    description:
      'Anomal\u00eda din\u00e1mica del trabajo de parto, no especificada',
    code_2: 'O62',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O610',
    level: 3,
    description:
      'Fracaso de la inducci\u00f3n m\u00e9dica del trabajo de parto',
    code_2: 'O61',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O611',
    level: 3,
    description:
      'Fracaso de la inducci\u00f3n instrumental del trabajo de parto',
    code_2: 'O61',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O618',
    level: 3,
    description: 'Otros fracasos de la inducci\u00f3n del trabajo de parto',
    code_2: 'O61',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O619',
    level: 3,
    description:
      'Fracaso no especificado de la inducci\u00f3n del trabajo de parto',
    code_2: 'O61',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O600',
    level: 3,
    description: 'Trabajo de parto prematuro sin parto',
    code_2: 'O60',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O601',
    level: 3,
    description: 'Trabajo de parto prematuro con parto prematuro',
    code_2: 'O60',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O602',
    level: 3,
    description: 'Trabajo de parto prematuro con parto a t\u00e9rmino',
    code_2: 'O60',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O840',
    level: 3,
    description: 'Parto m\u00faltiple, todos espont\u00e1neos',
    code_2: 'O84',
    code_0: 'O00-O9A',
    code_1: 'O80-O84'
  },
  {
    code: 'O841',
    level: 3,
    description:
      'Parto m\u00faltiple, todos por f\u00f3rceps y ventosa extractora',
    code_2: 'O84',
    code_0: 'O00-O9A',
    code_1: 'O80-O84'
  },
  {
    code: 'O842',
    level: 3,
    description: 'Parto m\u00faltiple, todos por ces\u00e1rea',
    code_2: 'O84',
    code_0: 'O00-O9A',
    code_1: 'O80-O84'
  },
  {
    code: 'O848',
    level: 3,
    description: 'Otros partos m\u00faltiples',
    code_2: 'O84',
    code_0: 'O00-O9A',
    code_1: 'O80-O84'
  },
  {
    code: 'O849',
    level: 3,
    description: 'Parto m\u00faltiple, no especificado',
    code_2: 'O84',
    code_0: 'O00-O9A',
    code_1: 'O80-O84'
  },
  {
    code: 'O830',
    level: 3,
    description: 'Extracci\u00f3n de nalgas',
    code_2: 'O83',
    code_0: 'O00-O9A',
    code_1: 'O80-O84'
  },
  {
    code: 'O831',
    level: 3,
    description: 'Otros partos \u00fanicos asistidos, de nalgas',
    code_2: 'O83',
    code_0: 'O00-O9A',
    code_1: 'O80-O84'
  },
  {
    code: 'O832',
    level: 3,
    description:
      'Otros partos \u00fanicos con ayuda de manipulaci\u00f3n obst\u00e9trica',
    code_2: 'O83',
    code_0: 'O00-O9A',
    code_1: 'O80-O84'
  },
  {
    code: 'O833',
    level: 3,
    description: 'Parto de feto viable en embarazo abdominal',
    code_2: 'O83',
    code_0: 'O00-O9A',
    code_1: 'O80-O84'
  },
  {
    code: 'O834',
    level: 3,
    description: 'Operaci\u00f3n destructiva para facilitar el parto',
    code_2: 'O83',
    code_0: 'O00-O9A',
    code_1: 'O80-O84'
  },
  {
    code: 'O838',
    level: 3,
    description: 'Otros partos \u00fanicos asistidos especificados',
    code_2: 'O83',
    code_0: 'O00-O9A',
    code_1: 'O80-O84'
  },
  {
    code: 'O839',
    level: 3,
    description: 'Parto \u00fanico asistido, sin otra especificaci\u00f3n',
    code_2: 'O83',
    code_0: 'O00-O9A',
    code_1: 'O80-O84'
  },
  {
    code: 'O820',
    level: 3,
    description: 'Parto por ces\u00e1rea electiva',
    code_2: 'O82',
    code_0: 'O00-O9A',
    code_1: 'O80-O84'
  },
  {
    code: 'O821',
    level: 3,
    description: 'Parto por ces\u00e1rea de emergencia',
    code_2: 'O82',
    code_0: 'O00-O9A',
    code_1: 'O80-O84'
  },
  {
    code: 'O822',
    level: 3,
    description: 'Parto por ces\u00e1rea con histerectom\u00eda',
    code_2: 'O82',
    code_0: 'O00-O9A',
    code_1: 'O80-O84'
  },
  {
    code: 'O828',
    level: 3,
    description: 'Otros partos \u00fanicos por ces\u00e1rea',
    code_2: 'O82',
    code_0: 'O00-O9A',
    code_1: 'O80-O84'
  },
  {
    code: 'O829',
    level: 3,
    description: 'Parto por ces\u00e1rea, sin otra especificaci\u00f3n',
    code_2: 'O82',
    code_0: 'O00-O9A',
    code_1: 'O80-O84'
  },
  {
    code: 'O810',
    level: 3,
    description: 'Parto con f\u00f3rceps bajo',
    code_2: 'O81',
    code_0: 'O00-O9A',
    code_1: 'O80-O84'
  },
  {
    code: 'O811',
    level: 3,
    description: 'Parto con f\u00f3rceps medio',
    code_2: 'O81',
    code_0: 'O00-O9A',
    code_1: 'O80-O84'
  },
  {
    code: 'O812',
    level: 3,
    description: 'Parto con f\u00f3rceps medio con rotaci\u00f3n',
    code_2: 'O81',
    code_0: 'O00-O9A',
    code_1: 'O80-O84'
  },
  {
    code: 'O813',
    level: 3,
    description: 'Parto con f\u00f3rceps de otros tipos y los no especificados',
    code_2: 'O81',
    code_0: 'O00-O9A',
    code_1: 'O80-O84'
  },
  {
    code: 'O814',
    level: 3,
    description: 'Parto con ventosa extractora',
    code_2: 'O81',
    code_0: 'O00-O9A',
    code_1: 'O80-O84'
  },
  {
    code: 'O815',
    level: 3,
    description:
      'Parto con combinaci\u00f3n de f\u00f3rceps y ventosa extractora',
    code_2: 'O81',
    code_0: 'O00-O9A',
    code_1: 'O80-O84'
  },
  {
    code: 'O800',
    level: 3,
    description:
      'Parto \u00fanico espont\u00e1neo, presentaci\u00f3n cef\u00e1lica de v\u00e9rtice',
    code_2: 'O80',
    code_0: 'O00-O9A',
    code_1: 'O80-O84'
  },
  {
    code: 'O801',
    level: 3,
    description:
      'Parto \u00fanico espont\u00e1neo, presentaci\u00f3n de nalgas o pod\u00e1lica',
    code_2: 'O80',
    code_0: 'O00-O9A',
    code_1: 'O80-O84'
  },
  {
    code: 'O808',
    level: 3,
    description: 'Parto \u00fanico espont\u00e1neo, otras presentaciones',
    code_2: 'O80',
    code_0: 'O00-O9A',
    code_1: 'O80-O84'
  },
  {
    code: 'O809',
    level: 3,
    description:
      'Parto \u00fanico espont\u00e1neo, sin otra especificaci\u00f3n',
    code_2: 'O80',
    code_0: 'O00-O9A',
    code_1: 'O80-O84'
  },
  {
    code: 'O890',
    level: 3,
    description:
      'Complicaciones pulmonares de la anestesia administrada durante el puerperio',
    code_2: 'O89',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O891',
    level: 3,
    description:
      'Complicaciones card\u00edacas de la anestesia administrada durante el puerperio',
    code_2: 'O89',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O892',
    level: 3,
    description:
      'Complicaciones del sistema nervioso central debidas a la anestesia administrada durante el puerperio',
    code_2: 'O89',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O893',
    level: 3,
    description:
      'Reacci\u00f3n t\u00f3xica a la anestesia local administrada durante el puerperio',
    code_2: 'O89',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O880',
    level: 3,
    description: 'Embolia gaseosa, obst\u00e9trica',
    code_2: 'O88',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O870',
    level: 3,
    description: 'Tromboflebitis superficial en el puerperio',
    code_2: 'O87',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O860',
    level: 3,
    description: 'nfecci\u00f3n de herida quir\u00fargica obst\u00e9trica',
    code_2: 'O86',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'C845',
    level: 4,
    description: 'Otros linfomas de c\u00e9lulas T y los no especificados',
    code_3: 'C84',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C81-C96'
  },
  {
    code: 'C13',
    level: 4,
    description: 'Tumor maligno de la hipofaringe',
    code_3: 'C00-C14',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'C14',
    level: 4,
    description:
      'Tumor maligno de otros sitios y de los mal definidos del labio, de la cavidad bucal y de la faringe',
    code_3: 'C00-C14',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75'
  },
  {
    code: 'Y22',
    level: 2,
    description: 'Disparo de arma corta, de intenci\u00f3n no determinada',
    code_1: 'Y10-Y34',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y23',
    level: 2,
    description:
      'Disparo de rifle, escopeta y arma larga, de intenci\u00f3n no determinada',
    code_1: 'Y10-Y34',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y24',
    level: 2,
    description:
      'Disparo de otras armas de fuego, y las no especificadas, de intenci\u00f3n no determinada',
    code_1: 'Y10-Y34',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y25',
    level: 2,
    description:
      'Contacto traum\u00e1tico con material explosivo, de intenci\u00f3n no determinada',
    code_1: 'Y10-Y34',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y26',
    level: 2,
    description:
      'Exposici\u00f3n al humo, fuego y llamas, de intenci\u00f3n no determinada',
    code_1: 'Y10-Y34',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y27',
    level: 2,
    description:
      'Contacto con vapor de agua, vapores y objetos calientes, de intenci\u00f3n no determinada',
    code_1: 'Y10-Y34',
    code_0: 'V01-Y99'
  },
  {
    code: 'X98',
    level: 2,
    description: 'Agresi\u00f3n con vapor de agua, vapores y objetos calientes',
    code_1: 'X85-Y09',
    code_0: 'V01-Y99'
  },
  {
    code: 'X99',
    level: 2,
    description: 'Agresi\u00f3n con objeto cortante',
    code_1: 'X85-Y09',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y00',
    level: 2,
    description: 'Agresi\u00f3n con objeto romo o sin filo',
    code_1: 'X85-Y09',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y01',
    level: 2,
    description: 'Agresi\u00f3n por empuj\u00f3n desde un lugar elevado',
    code_1: 'X85-Y09',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y02',
    level: 2,
    description:
      'Agresi\u00f3n por empujar o colocar a la v\u00edctima delante de objeto en movimiento',
    code_1: 'X85-Y09',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y03',
    level: 2,
    description: 'Agresi\u00f3n por colisi\u00f3n de veh\u00edculo de motor',
    code_1: 'X85-Y09',
    code_0: 'V01-Y99'
  },
  {
    code: 'X69',
    level: 2,
    description:
      'Envenenamiento autoinfligido intencionalmente por, y exposici\u00f3n a otros productos qu\u00edmicos y sustancias nocivas, y los no especificados',
    code_1: 'X60-X84',
    code_0: 'V01-Y99'
  },
  {
    code: 'X70',
    level: 2,
    description:
      'Lesi\u00f3n autoinfligida intencionalmente por ahorcamiento, estrangulamiento o sofocaci\u00f3n',
    code_1: 'X60-X84',
    code_0: 'V01-Y99'
  },
  {
    code: 'X71',
    level: 2,
    description:
      'Lesi\u00f3n autoinfligida intencionalmente por ahogamiento y sumersi\u00f3n',
    code_1: 'X60-X84',
    code_0: 'V01-Y99'
  },
  {
    code: 'X72',
    level: 2,
    description:
      'Lesi\u00f3n autoinfligida intencionalmente por disparo de arma corta',
    code_1: 'X60-X84',
    code_0: 'V01-Y99'
  },
  {
    code: 'X73',
    level: 2,
    description:
      'Lesi\u00f3n autoinfligida intencionalmente por disparo de rifle, escopeta y arma larga',
    code_1: 'X60-X84',
    code_0: 'V01-Y99'
  },
  {
    code: 'X74',
    level: 2,
    description:
      'Lesi\u00f3n autoinfligida intencionalmente por disparo de otras armas de fuego, y las no especificadas',
    code_1: 'X60-X84',
    code_0: 'V01-Y99'
  },
  {
    code: 'X75',
    level: 2,
    description:
      'Lesi\u00f3n autoinfligida intencionalmente por material explosivo',
    code_1: 'X60-X84',
    code_0: 'V01-Y99'
  },
  {
    code: 'V98-V99',
    level: 2,
    description: 'Otros accidentes de transporte, y los no especificados',
    code_1: 'V01-X59',
    code_0: 'V01-Y99'
  },
  {
    code: 'W00-X59',
    level: 2,
    description: 'Otras causas externas de traumatismos accidentales',
    code_1: 'V01-X59',
    code_0: 'V01-Y99'
  },
  {
    code: 'R620',
    level: 3,
    description: 'Retardo del desarrollo',
    code_2: 'R62',
    code_0: 'R00-R99',
    code_1: 'R50-R69'
  },
  {
    code: 'R628',
    level: 3,
    description: 'Otras faltas del desarrollo fisiol\u00f3gico normal esperado',
    code_2: 'R62',
    code_0: 'R00-R99',
    code_1: 'R50-R69'
  },
  {
    code: 'R629',
    level: 3,
    description:
      'Falta del desarrollo fisiol\u00f3gico normal esperado, sin otra especificaci\u00f3n',
    code_2: 'R62',
    code_0: 'R00-R99',
    code_1: 'R50-R69'
  },
  {
    code: 'R610',
    level: 3,
    description: 'Hiperhidrosis localizada',
    code_2: 'R61',
    code_0: 'R00-R99',
    code_1: 'R50-R69'
  },
  {
    code: 'R611',
    level: 3,
    description: 'Hiperhidrosis generalizada',
    code_2: 'R61',
    code_0: 'R00-R99',
    code_1: 'R50-R69'
  },
  {
    code: 'R619',
    level: 3,
    description: 'Hiperhidrosis, no especificada',
    code_2: 'R61',
    code_0: 'R00-R99',
    code_1: 'R50-R69'
  },
  {
    code: 'R600',
    level: 3,
    description: 'Edema localizado',
    code_2: 'R60',
    code_0: 'R00-R99',
    code_1: 'R50-R69'
  },
  {
    code: 'R601',
    level: 3,
    description: 'Edema generalizado',
    code_2: 'R60',
    code_0: 'R00-R99',
    code_1: 'R50-R69'
  },
  {
    code: 'R609',
    level: 3,
    description: 'Edema, no especificado',
    code_2: 'R60',
    code_0: 'R00-R99',
    code_1: 'R50-R69'
  },
  {
    code: 'R590',
    level: 3,
    description: 'Adenomegalia localizada',
    code_2: 'R59',
    code_0: 'R00-R99',
    code_1: 'R50-R69'
  },
  {
    code: 'R591',
    level: 3,
    description: 'Adenomegalia generalizada',
    code_2: 'R59',
    code_0: 'R00-R99',
    code_1: 'R50-R69'
  },
  {
    code: 'R599',
    level: 3,
    description: 'Adenomegalia, no especificada',
    code_2: 'R59',
    code_0: 'R00-R99',
    code_1: 'R50-R69'
  },
  {
    code: 'R570',
    level: 3,
    description: 'Choque cardiog\u00e9nico',
    code_2: 'R57',
    code_0: 'R00-R99',
    code_1: 'R50-R69'
  },
  {
    code: 'R571',
    level: 3,
    description: 'Choque hipovol\u00e9mico',
    code_2: 'R57',
    code_0: 'R00-R99',
    code_1: 'R50-R69'
  },
  {
    code: 'R578',
    level: 3,
    description: 'Otras formas de choque',
    code_2: 'R57',
    code_0: 'R00-R99',
    code_1: 'R50-R69'
  },
  {
    code: 'R579',
    level: 3,
    description: 'Choque, no especificado',
    code_2: 'R57',
    code_0: 'R00-R99',
    code_1: 'R50-R69'
  },
  {
    code: 'R560',
    level: 3,
    description: 'Convulsiones febriles',
    code_2: 'R56',
    code_0: 'R00-R99',
    code_1: 'R50-R69'
  },
  {
    code: 'R568',
    level: 3,
    description: 'Otras convulsiones y las no especificadas',
    code_2: 'R56',
    code_0: 'R00-R99',
    code_1: 'R50-R69'
  },
  {
    code: 'R790',
    level: 3,
    description: 'Nivel anoral de mineral en la sangre',
    code_2: 'R79',
    code_0: 'R00-R99',
    code_1: 'R70-R79'
  },
  {
    code: 'R798',
    level: 3,
    description:
      'Otros hallazgos anormales especificados en la qu\u00edmica sangu\u00ednea',
    code_2: 'R79',
    code_0: 'R00-R99',
    code_1: 'R70-R79'
  },
  {
    code: 'R799',
    level: 3,
    description:
      'Hallazgo anormal en la qu\u00edmica sangu\u00ednea, sin otra especificaci\u00f3n',
    code_2: 'R79',
    code_0: 'R00-R99',
    code_1: 'R70-R79'
  },
  {
    code: 'R780',
    level: 3,
    description: 'Hallazgo de alcohol en la sangre',
    code_2: 'R78',
    code_0: 'R00-R99',
    code_1: 'R70-R79'
  },
  {
    code: 'R781',
    level: 3,
    description: 'Hallazgo de drogas opi\u00e1ceas en la sangre',
    code_2: 'R78',
    code_0: 'R00-R99',
    code_1: 'R70-R79'
  },
  {
    code: 'R782',
    level: 3,
    description: 'Hallazgo de coca\u00edna en la sangre',
    code_2: 'R78',
    code_0: 'R00-R99',
    code_1: 'R70-R79'
  },
  {
    code: 'R783',
    level: 3,
    description: 'Hallazgo de alucin\u00f3genos en la sangre',
    code_2: 'R78',
    code_0: 'R00-R99',
    code_1: 'R70-R79'
  },
  {
    code: 'R784',
    level: 3,
    description:
      'Hallazgo de otras drogas potencialmente adictivas en la sangre',
    code_2: 'R78',
    code_0: 'R00-R99',
    code_1: 'R70-R79'
  },
  {
    code: 'R785',
    level: 3,
    description: 'Hallazgo de drogas psicotr\u00f3picas en la sangre',
    code_2: 'R78',
    code_0: 'R00-R99',
    code_1: 'R70-R79'
  },
  {
    code: 'R786',
    level: 3,
    description: 'Hallazgo de agentes esteroides en la sangre',
    code_2: 'R78',
    code_0: 'R00-R99',
    code_1: 'R70-R79'
  },
  {
    code: 'R787',
    level: 3,
    description:
      'Hallazgo de niveles anormales de metales pesados en la sangre',
    code_2: 'R78',
    code_0: 'R00-R99',
    code_1: 'R70-R79'
  },
  {
    code: 'R770',
    level: 3,
    description: 'Anormalidad de la alb\u00famina',
    code_2: 'R77',
    code_0: 'R00-R99',
    code_1: 'R70-R79'
  },
  {
    code: 'R771',
    level: 3,
    description: 'Anormalidad de la globulina',
    code_2: 'R77',
    code_0: 'R00-R99',
    code_1: 'R70-R79'
  },
  {
    code: 'R772',
    level: 3,
    description: 'Anormalidad de la alfafetoprote\u00edna',
    code_2: 'R77',
    code_0: 'R00-R99',
    code_1: 'R70-R79'
  },
  {
    code: 'R778',
    level: 3,
    description:
      'Otras anormalidades especificadas de las prote\u00ednas plasm\u00e1ticas',
    code_2: 'R77',
    code_0: 'R00-R99',
    code_1: 'R70-R79'
  },
  {
    code: 'R779',
    level: 3,
    description:
      'Anormalidades no especificadas de las prote\u00ednas plasm\u00e1ticas',
    code_2: 'R77',
    code_0: 'R00-R99',
    code_1: 'R70-R79'
  },
  {
    code: 'R760',
    level: 3,
    description: 'Titulaci\u00f3n elevada de anticuerpos',
    code_2: 'R76',
    code_0: 'R00-R99',
    code_1: 'R70-R79'
  },
  {
    code: 'R761',
    level: 3,
    description: 'Reacci\u00f3n anormal a la prueba con tuberculina',
    code_2: 'R76',
    code_0: 'R00-R99',
    code_1: 'R70-R79'
  },
  {
    code: 'R762',
    level: 3,
    description:
      'Falso positivo en la prueba serol\u00f3gica para s\u00edfilis',
    code_2: 'R76',
    code_0: 'R00-R99',
    code_1: 'R70-R79'
  },
  {
    code: 'R768',
    level: 3,
    description:
      'Otros hallazgos inmunol\u00f3gicos anormales especificados en suero',
    code_2: 'R76',
    code_0: 'R00-R99',
    code_1: 'R70-R79'
  },
  {
    code: 'R769',
    level: 3,
    description:
      'Hallazgos inmunol\u00f3gicos anormales no especificados en suero',
    code_2: 'R76',
    code_0: 'R00-R99',
    code_1: 'R70-R79'
  },
  {
    code: 'R940',
    level: 3,
    description:
      'Resultados anormales en estudios funcionales del sistema nervioso central',
    code_2: 'R94',
    code_0: 'R00-R99',
    code_1: 'R90-R94'
  },
  {
    code: 'R941',
    level: 3,
    description:
      'Resultados anormales en estudios funcionales del sistema nervioso perif\u00e9rico y sentidos especiales',
    code_2: 'R94',
    code_0: 'R00-R99',
    code_1: 'R90-R94'
  },
  {
    code: 'R942',
    level: 3,
    description: 'Resultados anormales en estudios funcionales del pulm\u00f3n',
    code_2: 'R94',
    code_0: 'R00-R99',
    code_1: 'R90-R94'
  },
  {
    code: 'R943',
    level: 3,
    description:
      'Resultados anormales en estudios funcionales cardiovasculares',
    code_2: 'R94',
    code_0: 'R00-R99',
    code_1: 'R90-R94'
  },
  {
    code: 'R944',
    level: 3,
    description:
      'Resultados anormales en estudios funcionales del ri\u00f1\u00f3n',
    code_2: 'R94',
    code_0: 'R00-R99',
    code_1: 'R90-R94'
  },
  {
    code: 'R945',
    level: 3,
    description: 'Resultados anormales en estudios funcionales del h\u00edgado',
    code_2: 'R94',
    code_0: 'R00-R99',
    code_1: 'R90-R94'
  },
  {
    code: 'R946',
    level: 3,
    description: 'Resultados anormales en estudios funcionales de la tiroides',
    code_2: 'R94',
    code_0: 'R00-R99',
    code_1: 'R90-R94'
  },
  {
    code: 'R960',
    level: 3,
    description: 'Muerte instant\u00e1nea',
    code_2: 'R96',
    code_0: 'R00-R99',
    code_1: 'R95-R99'
  },
  {
    code: 'R961',
    level: 3,
    description:
      'Muerte que ocurre en menos de 24 horas del inicio de los s\u00edntomas, no explicada de otra forma',
    code_2: 'R96',
    code_0: 'R00-R99',
    code_1: 'R95-R99'
  },
  {
    code: 'Q340',
    level: 3,
    description: 'Anomal\u00eda de la pleura',
    code_2: 'Q34',
    code_0: 'Q00-Q99',
    code_1: 'Q30-Q34'
  },
  {
    code: 'Q341',
    level: 3,
    description: 'Quiste cong\u00e9nito del mediastino',
    code_2: 'Q34',
    code_0: 'Q00-Q99',
    code_1: 'Q30-Q34'
  },
  {
    code: 'Q348',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas especificadas del sistema respiratorio',
    code_2: 'Q34',
    code_0: 'Q00-Q99',
    code_1: 'Q30-Q34'
  },
  {
    code: 'Q349',
    level: 3,
    description:
      'Malformaci\u00f3n cong\u00e9nita del sistema respiratorio, no especificada',
    code_2: 'Q34',
    code_0: 'Q00-Q99',
    code_1: 'Q30-Q34'
  },
  {
    code: 'Q330',
    level: 3,
    description: 'Quiste pulmonar cong\u00e9nito',
    code_2: 'Q33',
    code_0: 'Q00-Q99',
    code_1: 'Q30-Q34'
  },
  {
    code: 'Q331',
    level: 3,
    description: 'L\u00f3bulo pulmonar supernumerario',
    code_2: 'Q33',
    code_0: 'Q00-Q99',
    code_1: 'Q30-Q34'
  },
  {
    code: 'Q332',
    level: 3,
    description: 'Secuestro del pulm\u00f3n',
    code_2: 'Q33',
    code_0: 'Q00-Q99',
    code_1: 'Q30-Q34'
  },
  {
    code: 'Q333',
    level: 3,
    description: 'Agenesia del pulm\u00f3n',
    code_2: 'Q33',
    code_0: 'Q00-Q99',
    code_1: 'Q30-Q34'
  },
  {
    code: 'Q334',
    level: 3,
    description: 'Bronquiectasia cong\u00e9nita',
    code_2: 'Q33',
    code_0: 'Q00-Q99',
    code_1: 'Q30-Q34'
  },
  {
    code: 'Q335',
    level: 3,
    description: 'Tejido ect\u00f3pico en el pulm\u00f3n',
    code_2: 'Q33',
    code_0: 'Q00-Q99',
    code_1: 'Q30-Q34'
  },
  {
    code: 'Q336',
    level: 3,
    description: 'Hipoplasia y displasia pulmonar',
    code_2: 'Q33',
    code_0: 'Q00-Q99',
    code_1: 'Q30-Q34'
  },
  {
    code: 'Q338',
    level: 3,
    description: 'Otras malformaciones cong\u00e9nitas del pulm\u00f3n',
    code_2: 'Q33',
    code_0: 'Q00-Q99',
    code_1: 'Q30-Q34'
  },
  {
    code: 'Q339',
    level: 3,
    description:
      'Malformaci\u00f3n cong\u00e9nita del pulm\u00f3n, no especificada',
    code_2: 'Q33',
    code_0: 'Q00-Q99',
    code_1: 'Q30-Q34'
  },
  {
    code: 'Q370',
    level: 3,
    description: 'Fisura del paladar duro con labio leporino bilateral',
    code_2: 'Q37',
    code_0: 'Q00-Q99',
    code_1: 'Q35-Q37'
  },
  {
    code: 'Q371',
    level: 3,
    description: 'Fisura del paladar duro con labio leporino unilateral',
    code_2: 'Q37',
    code_0: 'Q00-Q99',
    code_1: 'Q35-Q37'
  },
  {
    code: 'Q372',
    level: 3,
    description: 'Fisura del paladar blando con labio leporino bilateral',
    code_2: 'Q37',
    code_0: 'Q00-Q99',
    code_1: 'Q35-Q37'
  },
  {
    code: 'Q373',
    level: 3,
    description: 'Fisura del paladar blando con labio leporino unilateral',
    code_2: 'Q37',
    code_0: 'Q00-Q99',
    code_1: 'Q35-Q37'
  },
  {
    code: 'Q374',
    level: 3,
    description:
      'Fisura del paladar duro y del paladar blando con labio leporino bilateral',
    code_2: 'Q37',
    code_0: 'Q00-Q99',
    code_1: 'Q35-Q37'
  },
  {
    code: 'Q375',
    level: 3,
    description:
      'Fisura del paladar duro y del paladar blando con labio leporino unilateral',
    code_2: 'Q37',
    code_0: 'Q00-Q99',
    code_1: 'Q35-Q37'
  },
  {
    code: 'Q378',
    level: 3,
    description:
      'Fisura del paladar con labio leporino bilateral, sin otra especificaci\u00f3n',
    code_2: 'Q37',
    code_0: 'Q00-Q99',
    code_1: 'Q35-Q37'
  },
  {
    code: 'Q379',
    level: 3,
    description:
      'Fisura del paladar con labio leporino unilateral, sin otra especificaci\u00f3n',
    code_2: 'Q37',
    code_0: 'Q00-Q99',
    code_1: 'Q35-Q37'
  },
  {
    code: 'Q450',
    level: 3,
    description: 'Agenesia, aplasia e hipoplasia del p\u00e1ncreas',
    code_2: 'Q45',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q451',
    level: 3,
    description: 'P\u00e1ncreas anular',
    code_2: 'Q45',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q452',
    level: 3,
    description: 'Quiste cong\u00e9nito del p\u00e1ncreas',
    code_2: 'Q45',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q453',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas del p\u00e1ncreas y del conducto pancre\u00e1tico',
    code_2: 'Q45',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q458',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas del sistema digestivo, especificadas',
    code_2: 'Q45',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q459',
    level: 3,
    description:
      'Malformaci\u00f3n cong\u00e9nita del sistema digestivo, no especificada',
    code_2: 'Q45',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q440',
    level: 3,
    description: 'Agenesia, aplasia e hipoplasia de la ves\u00edcula biliar',
    code_2: 'Q44',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q441',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas de la ves\u00edcula biliar',
    code_2: 'Q44',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q442',
    level: 3,
    description: 'Atresia de los conductos biliares',
    code_2: 'Q44',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q443',
    level: 3,
    description:
      'Estrechez y estenosis cong\u00e9nita de los conductos biliares',
    code_2: 'Q44',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q444',
    level: 3,
    description: 'Quiste del col\u00e9doco',
    code_2: 'Q44',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q445',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas de los conductos biliares',
    code_2: 'Q44',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q446',
    level: 3,
    description: 'Enfermedad qu\u00edstica del h\u00edgado',
    code_2: 'Q44',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q447',
    level: 3,
    description: 'Otras malformaciones cong\u00e9nitas del h\u00edgado',
    code_2: 'Q44',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q430',
    level: 3,
    description: 'Divert\u00edculo de Meckel',
    code_2: 'Q43',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q431',
    level: 3,
    description: 'Enfermedad de Hirschsprung',
    code_2: 'Q43',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q432',
    level: 3,
    description: 'Otros trastornos funcionales cong\u00e9nitos del colon',
    code_2: 'Q43',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q433',
    level: 3,
    description:
      'Malformaciones cong\u00e9nitas de la fijaci\u00f3n del intestino',
    code_2: 'Q43',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q434',
    level: 3,
    description: 'Duplicaci\u00f3n del intestino',
    code_2: 'Q43',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q435',
    level: 3,
    description: 'Ano ect\u00f3pico',
    code_2: 'Q43',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q436',
    level: 3,
    description: 'F\u00edstula cong\u00e9nita del recto y del ano',
    code_2: 'Q43',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q437',
    level: 3,
    description: 'Persistencia de la cloaca',
    code_2: 'Q43',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q438',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas del intestino, especificadas',
    code_2: 'Q43',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q439',
    level: 3,
    description:
      'Malformaci\u00f3n cong\u00e9nita del intestino, no especificada',
    code_2: 'Q43',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q420',
    level: 3,
    description:
      'Ausencia, atresia y estenosis cong\u00e9nita del recto, con f\u00edstula',
    code_2: 'Q42',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q421',
    level: 3,
    description:
      'Ausencia, atresia y estenosis cong\u00e9nita del recto, sin f\u00edstula',
    code_2: 'Q42',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q422',
    level: 3,
    description:
      'Ausencia, atresia y estenosis cong\u00e9nita del ano, con f\u00edstula',
    code_2: 'Q42',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q423',
    level: 3,
    description:
      'Ausencia, atresia y estenosis cong\u00e9nita del ano, sin f\u00edstula',
    code_2: 'Q42',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q428',
    level: 3,
    description:
      'Ausencia, atresia y estenosis cong\u00e9nita de otras partes del intestino grueso',
    code_2: 'Q42',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q429',
    level: 3,
    description:
      'Ausencia, atresia y estenosis cong\u00e9nita del intestino grueso, parte no especificada',
    code_2: 'Q42',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q410',
    level: 3,
    description: 'Ausencia, atresia y estenosis cong\u00e9nita del duodeno',
    code_2: 'Q41',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q411',
    level: 3,
    description: 'Ausencia, atresia y estenosis cong\u00e9nita del yeyuno',
    code_2: 'Q41',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q412',
    level: 3,
    description: 'Ausencia, atresia y estenosis cong\u00e9nita del \u00edleon',
    code_2: 'Q41',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q418',
    level: 3,
    description:
      'Ausencia, atresia y estenosis cong\u00e9nita de otras partes especificadas del intestino delgado',
    code_2: 'Q41',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q419',
    level: 3,
    description:
      'Ausencia, atresia y estenosis cong\u00e9nita del intestino delgado, parte no especificada',
    code_2: 'Q41',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q400',
    level: 3,
    description: 'Estenosis hipertr\u00f3fica cong\u00e9nita del p\u00edloro',
    code_2: 'Q40',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q401',
    level: 3,
    description: 'Hernia hiatal cong\u00e9nita',
    code_2: 'Q40',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q402',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas del est\u00f3mago, especificadas',
    code_2: 'Q40',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q403',
    level: 3,
    description:
      'Malformaci\u00f3n cong\u00e9nita del est\u00f3mago, no especificada',
    code_2: 'Q40',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q408',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas de la parte superior del tubo digestivo',
    code_2: 'Q40',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q409',
    level: 3,
    description:
      'Malformaci\u00f3n cong\u00e9nita de la parte superior del tubo digestivo, no especificada',
    code_2: 'Q40',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q390',
    level: 3,
    description: 'Atresia del es\u00f3fago sin menci\u00f3n de f\u00edstula',
    code_2: 'Q39',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q391',
    level: 3,
    description:
      'Atresia del es\u00f3fago con f\u00edstula traqueoesof\u00e1gica',
    code_2: 'Q39',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q392',
    level: 3,
    description:
      'F\u00edstula traqueoesof\u00e1gica cong\u00e9nita sin menci\u00f3n de atresia',
    code_2: 'Q39',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q393',
    level: 3,
    description: 'Estrechez o estenosis cong\u00e9nita del es\u00f3fago',
    code_2: 'Q39',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q394',
    level: 3,
    description: 'Pterigi\u00f3n del es\u00f3fago',
    code_2: 'Q39',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q395',
    level: 3,
    description: 'Dilataci\u00f3n cong\u00e9nita del es\u00f3fago',
    code_2: 'Q39',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q396',
    level: 3,
    description: 'Divert\u00edculo del es\u00f3fago',
    code_2: 'Q39',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q398',
    level: 3,
    description: 'Otras malformaciones cong\u00e9nitas del es\u00f3fago',
    code_2: 'Q39',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q399',
    level: 3,
    description:
      'Malformaci\u00f3n cong\u00e9nita del es\u00f3fago, no especificada',
    code_2: 'Q39',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'V20',
    level: 3,
    description:
      'Motociclista lesionado por colisi\u00f3n con peat\u00f3n o animal',
    code_2: 'V20-V29',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V21',
    level: 3,
    description:
      'Motociclista lesionado por colisi\u00f3n con veh\u00edculo de pedal',
    code_2: 'V20-V29',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V22',
    level: 3,
    description:
      'Motociclista lesionado por colisi\u00f3n con veh\u00edculo de motor de dos o tres ruedas',
    code_2: 'V20-V29',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V23',
    level: 3,
    description:
      'Motociclista lesionado por colisi\u00f3n con autom\u00f3vil, camioneta o furgoneta',
    code_2: 'V20-V29',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V10',
    level: 3,
    description:
      'Ciclista lesionado por colisi\u00f3n con peat\u00f3n o animal',
    code_2: 'V10-V19',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V11',
    level: 3,
    description: 'Ciclista lesionado por colisi\u00f3n con otro ciclista',
    code_2: 'V10-V19',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V12',
    level: 3,
    description:
      'Ciclista lesionado por colisi\u00f3n con veh\u00edculo de motor de dos o tres ruedas',
    code_2: 'V10-V19',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V13',
    level: 3,
    description:
      'Ciclista lesionado por colisi\u00f3n con autom\u00f3vil, camioneta o furgoneta',
    code_2: 'V10-V19',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V14',
    level: 3,
    description:
      'Ciclista lesionado por colisi\u00f3n con veh\u00edculo de transporte pesado o autob\u00fas',
    code_2: 'V10-V19',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V15',
    level: 3,
    description:
      'Ciclista lesionado por colisi\u00f3n con tren o veh\u00edculo de rieles',
    code_2: 'V10-V19',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V16',
    level: 3,
    description:
      'Ciclista lesionado por colisi\u00f3n con otros veh\u00edculos sin motor',
    code_2: 'V10-V19',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V01',
    level: 3,
    description:
      'Peat\u00f3n lesionado por colisi\u00f3n con veh\u00edculo de pedal',
    code_2: 'V01-V09',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V02',
    level: 3,
    description:
      'Peat\u00f3n lesionado por colisi\u00f3n con veh\u00edculo de motor de dos o tres ruedas',
    code_2: 'V01-V09',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V03',
    level: 3,
    description:
      'Peat\u00f3n lesionado por colisi\u00f3n con autom\u00f3vil, camioneta o furgoneta',
    code_2: 'V01-V09',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V04',
    level: 3,
    description:
      'Peat\u00f3n lesionado por colisi\u00f3n con veh\u00edculo de transporte pesado o autob\u00fas',
    code_2: 'V01-V09',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V05',
    level: 3,
    description:
      'Peat\u00f3n lesionado por colisi\u00f3n con tren o veh\u00edculo de rieles',
    code_2: 'V01-V09',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V06',
    level: 3,
    description:
      'Peat\u00f3n lesionado por colisi\u00f3n con otros veh\u00edculos sin motor',
    code_2: 'V01-V09',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V09',
    level: 3,
    description:
      'Peat\u00f3n lesionado en otros accidentes de transporte, y en los no especificados',
    code_2: 'V01-V09',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'Q560',
    level: 3,
    description: 'Hermafroditismo, no clasificado en otra parte',
    code_2: 'Q56',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q561',
    level: 3,
    description: 'Seudohermafroditismo masculino, no clasificado en otra parte',
    code_2: 'Q56',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q562',
    level: 3,
    description: 'Seudohermafroditismo femenino, no clasificado en otra parte',
    code_2: 'Q56',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q563',
    level: 3,
    description: 'Seudohermafroditismo, no especificado',
    code_2: 'Q56',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q564',
    level: 3,
    description: 'Sexo indeterminado, sin otra especificaci\u00f3n',
    code_2: 'Q56',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Y360',
    level: 3,
    description: 'Operaciones de guerra con explosi\u00f3n de armamento naval',
    code_2: 'Y36',
    code_0: 'V01-Y99',
    code_1: 'Y35-Y36'
  },
  {
    code: 'Y361',
    level: 3,
    description: 'Operaciones de guerra con destrucci\u00f3n de aeronave',
    code_2: 'Y36',
    code_0: 'V01-Y99',
    code_1: 'Y35-Y36'
  },
  {
    code: 'Y362',
    level: 3,
    description: 'Operaciones de guerra con otras explosiones y esquirlas',
    code_2: 'Y36',
    code_0: 'V01-Y99',
    code_1: 'Y35-Y36'
  },
  {
    code: 'Y363',
    level: 3,
    description:
      'Operaciones de guerra con fuego y sustancias incendiarias y calientes',
    code_2: 'Y36',
    code_0: 'V01-Y99',
    code_1: 'Y35-Y36'
  },
  {
    code: 'Y364',
    level: 3,
    description:
      'Operaciones de guerra con disparo de arma de fuego y otras formas de guerra convencional',
    code_2: 'Y36',
    code_0: 'V01-Y99',
    code_1: 'Y35-Y36'
  },
  {
    code: 'Y350',
    level: 3,
    description: 'Intervenci\u00f3n legal con disparo de arma de fuego',
    code_2: 'Y35',
    code_0: 'V01-Y99',
    code_1: 'Y35-Y36'
  },
  {
    code: 'Y351',
    level: 3,
    description: 'Intervenci\u00f3n legal con explosivos',
    code_2: 'Y35',
    code_0: 'V01-Y99',
    code_1: 'Y35-Y36'
  },
  {
    code: 'Y352',
    level: 3,
    description: 'Intervenci\u00f3n legal con gas',
    code_2: 'Y35',
    code_0: 'V01-Y99',
    code_1: 'Y35-Y36'
  },
  {
    code: 'Y60',
    level: 3,
    description:
      'Corte, punci\u00f3n, perforaci\u00f3n o hemorragia no intencional durante la atenci\u00f3n m\u00e9dica y quir\u00fargica',
    code_2: 'Y60-Y69',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y61',
    level: 3,
    description:
      'Objeto extra\u00f1o dejado accidentalmente en el cuerpo durante la atenci\u00f3n m\u00e9dica y quir\u00fargica',
    code_2: 'Y60-Y69',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y40',
    level: 3,
    description: 'Efectos adversos de antibi\u00f3ticos sist\u00e9micos',
    code_2: 'Y40-Y59',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y41',
    level: 3,
    description:
      'Efectos adversos de otros antiinfecciosos y antiparasitarios sist\u00e9micos',
    code_2: 'Y40-Y59',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Q780',
    level: 3,
    description: 'Osteog\u00e9nesis imperfecta',
    code_2: 'Q78',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q781',
    level: 3,
    description: 'Displasia poliost\u00f3tica fibrosa',
    code_2: 'Q78',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q782',
    level: 3,
    description: 'Osteopetrosis',
    code_2: 'Q78',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q783',
    level: 3,
    description: 'Displasia diafisaria progresiva',
    code_2: 'Q78',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q784',
    level: 3,
    description: 'Encondromatosis',
    code_2: 'Q78',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q770',
    level: 3,
    description: 'Acondrog\u00e9nesis',
    code_2: 'Q77',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q771',
    level: 3,
    description: 'Enanismo tanatof\u00f3rico',
    code_2: 'Q77',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q772',
    level: 3,
    description: 'S\u00edndrome de costilla corta',
    code_2: 'Q77',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q773',
    level: 3,
    description: 'Condrodisplasia punctata',
    code_2: 'Q77',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q760',
    level: 3,
    description: 'Espina b\u00edfida oculta',
    code_2: 'Q76',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q761',
    level: 3,
    description: 'S\u00edndrome de Klippel\u2013Feil',
    code_2: 'Q76',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q762',
    level: 3,
    description: 'Espondilolistesis cong\u00e9nita',
    code_2: 'Q76',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q763',
    level: 3,
    description:
      'Escoliosis cong\u00e9nita debida a malformaci\u00f3n cong\u00e9nita \u00f3sea',
    code_2: 'Q76',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q764',
    level: 3,
    description:
      'Otra malformacion congenita de la columna vertebral, no asociada con escoliosis',
    code_2: 'Q76',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q765',
    level: 3,
    description: 'Costilla cervical',
    code_2: 'Q76',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q750',
    level: 3,
    description: 'Craneosinostosis',
    code_2: 'Q75',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q751',
    level: 3,
    description: 'Disostosis craneofacial',
    code_2: 'Q75',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q752',
    level: 3,
    description: 'Hipertelorismo',
    code_2: 'Q75',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q753',
    level: 3,
    description: 'Macrocefalia',
    code_2: 'Q75',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q754',
    level: 3,
    description: 'Disostosis maxilofacial',
    code_2: 'Q75',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q740',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas del (de los) miembro(s) superior(es), incluida la cintura escapular',
    code_2: 'Q74',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q741',
    level: 3,
    description: 'Malformaci\u00f3n cong\u00e9nita de la rodilla',
    code_2: 'Q74',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q742',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas del (de los) miembro(s) inferior(es), incluida la cintura pelviana',
    code_2: 'Q74',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q743',
    level: 3,
    description: 'Artrogriposis m\u00faltiple cong\u00e9nita',
    code_2: 'Q74',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q748',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas especificadas del (de los) miembro(s)',
    code_2: 'Q74',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q749',
    level: 3,
    description:
      'Malformaci\u00f3n cong\u00e9nita de miembro(s), no especificada',
    code_2: 'Q74',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q730',
    level: 3,
    description: 'Ausencia completa de miembro(s) no especificado(s)',
    code_2: 'Q73',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q731',
    level: 3,
    description: 'Focomelia, miembro(s) no especificado(s)',
    code_2: 'Q73',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q738',
    level: 3,
    description:
      'Otros defectos por reducci\u00f3n de miembro(s) no especificado(s)',
    code_2: 'Q73',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q720',
    level: 3,
    description:
      'Ausencia cong\u00e9nita completa del (de los) miembro(s) inferior(es)',
    code_2: 'Q72',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q721',
    level: 3,
    description:
      'Ausencia cong\u00e9nita del muslo y de la pierna con presencia del pie',
    code_2: 'Q72',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q722',
    level: 3,
    description: 'Ausencia cong\u00e9nita de la pierna y del pie',
    code_2: 'Q72',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q723',
    level: 3,
    description: 'Ausencia cong\u00e9nita del pie y dedo(s) del pie',
    code_2: 'Q72',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q710',
    level: 3,
    description:
      'Ausencia cong\u00e9nita completa del (de los) miembro(s) superior(es)',
    code_2: 'Q71',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q711',
    level: 3,
    description:
      'Ausencia cong\u00e9nita del brazo y del antebrazo con presencia de la mano',
    code_2: 'Q71',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q712',
    level: 3,
    description: 'Ausencia cong\u00e9nita del antebrazo y de la mano',
    code_2: 'Q71',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q713',
    level: 3,
    description: 'Ausencia cong\u00e9nita de la mano y el (los) dedo(s)',
    code_2: 'Q71',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q714',
    level: 3,
    description: 'Defecto por reducci\u00f3n longitudinal del radio',
    code_2: 'Q71',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q715',
    level: 3,
    description: 'Defecto por reducci\u00f3n longitudinal del c\u00fabito',
    code_2: 'Q71',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q716',
    level: 3,
    description: 'Mano en pinza de langosta',
    code_2: 'Q71',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q718',
    level: 3,
    description:
      'Otros defectos por reducci\u00f3n del (de los) miembro(s) superior(es)',
    code_2: 'Q71',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q700',
    level: 3,
    description: 'Fusi\u00f3n de los dedos de la mano',
    code_2: 'Q70',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q701',
    level: 3,
    description: 'Membrana interdigital de la mano',
    code_2: 'Q70',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q702',
    level: 3,
    description: 'Fusi\u00f3n de los dedos del pie',
    code_2: 'Q70',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q703',
    level: 3,
    description: 'Membrana interdigital del pie',
    code_2: 'Q70',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q704',
    level: 3,
    description: 'Polisindactilia',
    code_2: 'Q70',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q709',
    level: 3,
    description: 'Sindactilia, no especificada',
    code_2: 'Q70',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q890',
    level: 3,
    description: 'Malformaciones cong\u00e9nitas del bazo',
    code_2: 'Q89',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q891',
    level: 3,
    description:
      'Malformaciones cong\u00e9nitas de la gl\u00e1ndula suprarrenal',
    code_2: 'Q89',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q892',
    level: 3,
    description:
      'Malformaciones cong\u00e9nitas de otras gl\u00e1ndulas endocrinas',
    code_2: 'Q89',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q893',
    level: 3,
    description: 'Situs inversus',
    code_2: 'Q89',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q894',
    level: 3,
    description: 'Gemelos siameses',
    code_2: 'Q89',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q897',
    level: 3,
    description:
      'Malformaciones cong\u00e9nitas m\u00faltiples, no clasificadas en otra parte',
    code_2: 'Q89',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q898',
    level: 3,
    description: 'Otras malformaciones cong\u00e9nitas, especificadas',
    code_2: 'Q89',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q899',
    level: 3,
    description: 'Malformaci\u00f3n cong\u00e9nita, no especificada',
    code_2: 'Q89',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q870',
    level: 3,
    description:
      'S\u00edndromes de malformaciones cong\u00e9nitas que afectan principalmente la apariencia facial',
    code_2: 'Q87',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q871',
    level: 3,
    description:
      'S\u00edndromes de malformaciones cong\u00e9nitas asociadas principalmente con estatura baja:',
    code_2: 'Q87',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q872',
    level: 3,
    description:
      'S\u00edndromes de malformaciones cong\u00e9nitas que afectan principalmente los miembros',
    code_2: 'Q87',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q873',
    level: 3,
    description:
      'S\u00edndromes de malformaciones cong\u00e9nitas con exceso de crecimiento precoz',
    code_2: 'Q87',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q874',
    level: 3,
    description: 'S\u00edndrome de Marfan',
    code_2: 'Q87',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q875',
    level: 3,
    description:
      'Otros s\u00edndromes de malformaciones cong\u00e9nitas con otros cambios esquel\u00e9ticos',
    code_2: 'Q87',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q878',
    level: 3,
    description:
      'Otros s\u00edndromes de malformaciones cong\u00e9nitas especificados, no clasificados en otra parte',
    code_2: 'Q87',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q860',
    level: 3,
    description: 'S\u00edndrome fetal (dism\u00f3rfico) debido al alcohol',
    code_2: 'Q86',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q861',
    level: 3,
    description: 'S\u00edndrome de hidanto\u00edna fetal',
    code_2: 'Q86',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q862',
    level: 3,
    description: 'Dismorfismo debido a warfarina',
    code_2: 'Q86',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q868',
    level: 3,
    description:
      'Otros s\u00edndromes de malformaciones cong\u00e9nitas debidos a causas ex\u00f3genas conocidas',
    code_2: 'Q86',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q850',
    level: 3,
    description: 'Neurofibromatosis (no maligna)',
    code_2: 'Q85',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q851',
    level: 3,
    description: 'Esclerosis tuberosa',
    code_2: 'Q85',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q858',
    level: 3,
    description: 'Otras facomatosis, no clasificadas en otra parte',
    code_2: 'Q85',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q859',
    level: 3,
    description: 'Facomatosis, no especificada',
    code_2: 'Q85',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q840',
    level: 3,
    description: 'Alopecia cong\u00e9nita',
    code_2: 'Q84',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q841',
    level: 3,
    description:
      'Alteraciones morfol\u00f3gicas cong\u00e9nitas del pelo, no clasificadas en otra parte',
    code_2: 'Q84',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q842',
    level: 3,
    description: 'Otras malformaciones cong\u00e9nitas del pelo',
    code_2: 'Q84',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q843',
    level: 3,
    description: 'Anoniquia',
    code_2: 'Q84',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q844',
    level: 3,
    description: 'Leuconiquia cong\u00e9nita',
    code_2: 'Q84',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q845',
    level: 3,
    description: 'Agrandamiento e hipertrofia de las u\u00f1as',
    code_2: 'Q84',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q846',
    level: 3,
    description: 'Otras malformaciones cong\u00e9nitas de las u\u00f1as',
    code_2: 'Q84',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q848',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas de las faneras, especificadas',
    code_2: 'Q84',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q849',
    level: 3,
    description:
      'Malformaci\u00f3n cong\u00e9nita de las faneras, no especificada',
    code_2: 'Q84',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q830',
    level: 3,
    description:
      'Ausencia cong\u00e9nita de la mama con ausencia del pez\u00f3n',
    code_2: 'Q83',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q831',
    level: 3,
    description: 'Mama supernumeraria',
    code_2: 'Q83',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q832',
    level: 3,
    description: 'Ausencia de pez\u00f3n',
    code_2: 'Q83',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q833',
    level: 3,
    description: 'Pez\u00f3n supernumerario',
    code_2: 'Q83',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q838',
    level: 3,
    description: 'Otras malformaciones cong\u00e9nitas de la mama',
    code_2: 'Q83',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q839',
    level: 3,
    description: 'Malformaci\u00f3n cong\u00e9nita de la mama, no especificad',
    code_2: 'Q83',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q990',
    level: 3,
    description: 'Quimera 46,XX/46,XY',
    code_2: 'Q99',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q991',
    level: 3,
    description: 'Hermafrodita verdadero 46,XX',
    code_2: 'Q99',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q992',
    level: 3,
    description: 'Cromosoma X fr\u00e1gil',
    code_2: 'Q99',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q998',
    level: 3,
    description: 'Otras anomal\u00edas de los cromosomas, especificadas',
    code_2: 'Q99',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q999',
    level: 3,
    description: 'Anomal\u00eda cromos\u00f3mica, no especificada',
    code_2: 'Q99',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q980',
    level: 3,
    description: 'S\u00edndrome de Klinefelter, cariotipo 47,XXY',
    code_2: 'Q98',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q981',
    level: 3,
    description:
      'S\u00edndrome de Klinefelter, hombre con m\u00e1s de dos cromosomas X',
    code_2: 'Q98',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q982',
    level: 3,
    description: 'S\u00edndrome de Klinefelter, hombre con cariotipo 46,XX',
    code_2: 'Q98',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q983',
    level: 3,
    description: 'Otro hombre con cariotipo 46,XX',
    code_2: 'Q98',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q984',
    level: 3,
    description: 'S\u00edndrome de Klinefelter, no especificado',
    code_2: 'Q98',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q985',
    level: 3,
    description: 'Cariotipo 47,XYY',
    code_2: 'Q98',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q986',
    level: 3,
    description: 'Hombre con cromosoma sexual estructuralmente anormal',
    code_2: 'Q98',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q987',
    level: 3,
    description: 'Hombre con mosaico de cromosomas sexuales',
    code_2: 'Q98',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q988',
    level: 3,
    description:
      'Otras anomal\u00edas de los cromosomas sexuales, con fenotipo masculino, especificadas',
    code_2: 'Q98',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q970',
    level: 3,
    description: 'Cariotipo 47,XXX',
    code_2: 'Q97',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q971',
    level: 3,
    description: 'Mujer con m\u00e1s de tres cromosomas X',
    code_2: 'Q97',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q972',
    level: 3,
    description:
      'Mosaico, l\u00edneas con n\u00famero variable de cromosomas X',
    code_2: 'Q97',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q973',
    level: 3,
    description: 'Mujer con cariotipo 46,XY',
    code_2: 'Q97',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q978',
    level: 3,
    description:
      'Otras anomal\u00edas de los cromosomas sexuales, con fenotipo femenino, especificadas',
    code_2: 'Q97',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q979',
    level: 3,
    description:
      'Anomal\u00eda de los cromosomas sexuales, con fenotipo femenino, sin otra especificaci\u00f3n',
    code_2: 'Q97',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'C020',
    level: 5,
    description: 'Tumor maligno de la cara dorsal de la lengua',
    code_4: 'C02',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C021',
    level: 5,
    description: 'Tumor maligno del borde de la lengua',
    code_4: 'C02',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C022',
    level: 5,
    description: 'Tumor maligno de la cara ventral de la lengua',
    code_4: 'C02',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C023',
    level: 5,
    description:
      'Tumor maligno de los dos tercios anteriores de la lengua, parte no especificada',
    code_4: 'C02',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C024',
    level: 5,
    description: 'Tumor maligno de la am\u00edgdala lingual',
    code_4: 'C02',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C028',
    level: 5,
    description: 'Lesi\u00f3n de sitios contiguos de la lengua',
    code_4: 'C02',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C029',
    level: 5,
    description: 'Tumor maligno de la lengua, parte no especificada',
    code_4: 'C02',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C000',
    level: 5,
    description: 'Tumor maligno del labio superior, cara externa',
    code_4: 'C00',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C001',
    level: 5,
    description: 'Tumor maligno del labio inferior, cara externa',
    code_4: 'C00',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C002',
    level: 5,
    description:
      'Tumor maligno del labio, cara externa, sin otra especificaci\u00f3n',
    code_4: 'C00',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C003',
    level: 5,
    description: 'Tumor maligno del labio superior, cara interna',
    code_4: 'C00',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C004',
    level: 5,
    description: 'Tumor maligno del labio inferior, cara interna',
    code_4: 'C00',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C005',
    level: 5,
    description:
      'Tumor maligno del labio, cara interna, sin otra especificaci\u00f3n',
    code_4: 'C00',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C006',
    level: 5,
    description: 'Tumor maligno de la comisura labial',
    code_4: 'C00',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C008',
    level: 5,
    description: 'Lesi\u00f3n de sitios contiguos del labio',
    code_4: 'C00',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C009',
    level: 5,
    description: 'Tumor maligno del labio, parte no especificada',
    code_4: 'C00',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C170',
    level: 5,
    description: 'Tumor maligno del duodeno',
    code_4: 'C17',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C171',
    level: 5,
    description: 'Tumor maligno del yeyuno',
    code_4: 'C17',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C172',
    level: 5,
    description: 'Tumor maligno del \u00edleon',
    code_4: 'C17',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C173',
    level: 5,
    description: 'Tumor maligno del divert\u00edculo de Meckel',
    code_4: 'C17',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C178',
    level: 5,
    description: 'Lesi\u00f3n de sitios contiguos del intestino delgado',
    code_4: 'C17',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C179',
    level: 5,
    description: 'Tumor maligno del intestino delgado, parte no especificada',
    code_4: 'C17',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C160',
    level: 5,
    description: 'Tumor maligno del cardias',
    code_4: 'C16',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C161',
    level: 5,
    description: 'Tumor maligno del fundus g\u00e1strico',
    code_4: 'C16',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C162',
    level: 5,
    description: 'Tumor maligno del cuerpo del est\u00f3mago',
    code_4: 'C16',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C163',
    level: 5,
    description: 'Tumor maligno del antro pil\u00f3rico',
    code_4: 'C16',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C150',
    level: 5,
    description: 'Tumor maligno del es\u00f3fago, porci\u00f3n cervical',
    code_4: 'C15',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C151',
    level: 5,
    description: 'Tumor maligno del es\u00f3fago, porci\u00f3n tor\u00e1cica',
    code_4: 'C15',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C152',
    level: 5,
    description: 'Tumor maligno del es\u00f3fago, porci\u00f3n abdominal',
    code_4: 'C15',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C153',
    level: 5,
    description: 'Tumor maligno del tercio superior del es\u00f3fago',
    code_4: 'C15',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C154',
    level: 5,
    description: 'Tumor maligno del tercio medio del es\u00f3fago',
    code_4: 'C15',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C155',
    level: 5,
    description: 'Tumor maligno del tercio inferior del es\u00f3fago',
    code_4: 'C15',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C158',
    level: 5,
    description: 'Lesi\u00f3n de sitios contiguos del es\u00f3fago',
    code_4: 'C15',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C159',
    level: 5,
    description: 'Tumor maligno del es\u00f3fago, parte no especificada',
    code_4: 'C15',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C380',
    level: 5,
    description: 'Tumor maligno del coraz\u00f3n',
    code_4: 'C38',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C30-C39'
  },
  {
    code: 'C381',
    level: 5,
    description: 'Tumor maligno del mediastino anterior',
    code_4: 'C38',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C30-C39'
  },
  {
    code: 'C382',
    level: 5,
    description: 'Tumor maligno del mediastino posterior',
    code_4: 'C38',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C30-C39'
  },
  {
    code: 'C383',
    level: 5,
    description: 'Tumor maligno del mediastino, parte no especificada',
    code_4: 'C38',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C30-C39'
  },
  {
    code: 'C384',
    level: 5,
    description: 'Tumor maligno de la pleura',
    code_4: 'C38',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C30-C39'
  },
  {
    code: 'C340',
    level: 5,
    description: 'Tumor maligno del bronquio principal',
    code_4: 'C34',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C30-C39'
  },
  {
    code: 'C341',
    level: 5,
    description:
      'Tumor maligno del l\u00f3bulo superior, bronquio o pulm\u00f3n',
    code_4: 'C34',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C30-C39'
  },
  {
    code: 'C342',
    level: 5,
    description: 'Tumor maligno del l\u00f3bulo medio, bronquio o pulm\u00f3n',
    code_4: 'C34',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C30-C39'
  },
  {
    code: 'C343',
    level: 5,
    description:
      'Tumor maligno del l\u00f3bulo inferior, bronquio o pulm\u00f3n',
    code_4: 'C34',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C30-C39'
  },
  {
    code: 'C348',
    level: 5,
    description:
      'Lesi\u00f3n de sitios contiguos de los bronquios y del pulm\u00f3n',
    code_4: 'C34',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C30-C39'
  },
  {
    code: 'C349',
    level: 5,
    description:
      'Tumor maligno de los bronquios o del pulm\u00f3n, parte no especificada',
    code_4: 'C34',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C30-C39'
  },
  {
    code: 'R829',
    level: 3,
    description: 'Otros hallazgos anormales en la orina y los no especificados',
    code_2: 'R82',
    code_0: 'R00-R99',
    code_1: 'R80-R82'
  },
  {
    code: 'C320',
    level: 5,
    description: 'Tumor maligno de la glotis',
    code_4: 'C32',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C30-C39'
  },
  {
    code: 'C321',
    level: 5,
    description: 'Tumor maligno de la regi\u00f3n supragl\u00f3tica',
    code_4: 'C32',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C30-C39'
  },
  {
    code: 'C322',
    level: 5,
    description: 'Tumor maligno de la regi\u00f3n subgl\u00f3tica',
    code_4: 'C32',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C30-C39'
  },
  {
    code: 'C323',
    level: 5,
    description: 'Tumor maligno del cart\u00edlago lar\u00edngeo',
    code_4: 'C32',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C30-C39'
  },
  {
    code: 'C328',
    level: 5,
    description: 'Lesi\u00f3n de sitios contiguos de la laringe',
    code_4: 'C32',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C30-C39'
  },
  {
    code: 'C329',
    level: 5,
    description: 'Tumor maligno de la laringe, parte no especificada',
    code_4: 'C32',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C30-C39'
  },
  {
    code: 'C310',
    level: 5,
    description: 'Tumor maligno del seno maxilar',
    code_4: 'C31',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C30-C39'
  },
  {
    code: 'C311',
    level: 5,
    description: 'Tumor maligno del seno etmoidal',
    code_4: 'C31',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C30-C39'
  },
  {
    code: 'C312',
    level: 5,
    description: 'Tumor maligno del seno frontal',
    code_4: 'C31',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C30-C39'
  },
  {
    code: 'C313',
    level: 5,
    description: 'Tumor maligno del seno esfenoidal',
    code_4: 'C31',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C30-C39'
  },
  {
    code: 'C318',
    level: 5,
    description: 'Lesi\u00f3n de sitios contiguos de los senos paranasales',
    code_4: 'C31',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C30-C39'
  },
  {
    code: 'C319',
    level: 5,
    description: 'Tumor maligno de seno paranasal no especificado',
    code_4: 'C31',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C30-C39'
  },
  {
    code: 'C300',
    level: 5,
    description: 'Tumor maligno de la fosa nasal',
    code_4: 'C30',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C30-C39'
  },
  {
    code: 'C301',
    level: 5,
    description: 'Tumor maligno del o\u00eddo medio',
    code_4: 'C30',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C30-C39'
  },
  {
    code: 'C410',
    level: 5,
    description: 'Tumor maligno de los huesos del cr\u00e1neo y de la cara',
    code_4: 'C41',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C40-C41'
  },
  {
    code: 'C411',
    level: 5,
    description: 'Tumor maligno del hueso del maxilar inferior',
    code_4: 'C41',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C40-C41'
  },
  {
    code: 'C412',
    level: 5,
    description: 'Tumor maligno de la columna vertebral',
    code_4: 'C41',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C40-C41'
  },
  {
    code: 'C413',
    level: 5,
    description: 'Tumor maligno de la costilla, estern\u00f3n y clav\u00edcula',
    code_4: 'C41',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C40-C41'
  },
  {
    code: 'C414',
    level: 5,
    description:
      'Tumor maligno de los huesos de la pelvis, sacro y c\u00f3ccix',
    code_4: 'C41',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C40-C41'
  },
  {
    code: 'C418',
    level: 5,
    description:
      'Lesi\u00f3n de sitios contiguos del hueso y del cart\u00edlago articular',
    code_4: 'C41',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C40-C41'
  },
  {
    code: 'C419',
    level: 5,
    description:
      'Tumor maligno del hueso y del cart\u00edlago articular, no especificado',
    code_4: 'C41',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C40-C41'
  },
  {
    code: 'C400',
    level: 5,
    description:
      'Tumor maligno del om\u00f3plato y de los huesos largos del miembro superior',
    code_4: 'C40',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C40-C41'
  },
  {
    code: 'C401',
    level: 5,
    description: 'Tumor maligno de los huesos cortos del miembro superior',
    code_4: 'C40',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C40-C41'
  },
  {
    code: 'C402',
    level: 5,
    description: 'Tumor maligno de los huesos largos del miembro inferior',
    code_4: 'C40',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C40-C41'
  },
  {
    code: 'C403',
    level: 5,
    description: 'Tumor maligno de los huesos cortos del miembro inferior',
    code_4: 'C40',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C40-C41'
  },
  {
    code: 'C408',
    level: 5,
    description:
      'Lesi\u00f3n de sitios contiguos de los huesos y de los cart\u00edlagos articulares de los miembros',
    code_4: 'C40',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C40-C41'
  },
  {
    code: 'C409',
    level: 5,
    description:
      'Tumor maligno de los huesos y de los cart\u00edlagos articulares de los miembros, sin otra especificaci\u00f3n',
    code_4: 'C40',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C40-C41'
  },
  {
    code: 'Q313',
    level: 3,
    description: 'Laringocele',
    code_2: 'Q31',
    code_0: 'Q00-Q99',
    code_1: 'Q30-Q34'
  },
  {
    code: 'Q315',
    level: 3,
    description: 'Laringomalacia cong\u00e9nita',
    code_2: 'Q31',
    code_0: 'Q00-Q99',
    code_1: 'Q30-Q34'
  },
  {
    code: 'Q318',
    level: 3,
    description: 'Otras malformaciones cong\u00e9nitas de la laringe',
    code_2: 'Q31',
    code_0: 'Q00-Q99',
    code_1: 'Q30-Q34'
  },
  {
    code: 'Q319',
    level: 3,
    description:
      'Malformaci\u00f3n cong\u00e9nita de la laringe, no especificada',
    code_2: 'Q31',
    code_0: 'Q00-Q99',
    code_1: 'Q30-Q34'
  },
  {
    code: 'P960',
    level: 3,
    description: 'Insuficiencia renal cong\u00e9nita',
    code_2: 'P96',
    code_0: 'P00-P96',
    code_1: 'P90-P96'
  },
  {
    code: 'P961',
    level: 3,
    description:
      'S\u00edntomas neonatales de abstinencia por drogadicci\u00f3n materna',
    code_2: 'P96',
    code_0: 'P00-P96',
    code_1: 'P90-P96'
  },
  {
    code: 'P962',
    level: 3,
    description:
      'S\u00edntomas de abstinencia por el uso terap\u00e9utico de drogas en el reci\u00e9n nacido',
    code_2: 'P96',
    code_0: 'P00-P96',
    code_1: 'P90-P96'
  },
  {
    code: 'P963',
    level: 3,
    description: 'Amplitud de las suturas craneales del reci\u00e9n nacido',
    code_2: 'P96',
    code_0: 'P00-P96',
    code_1: 'P90-P96'
  },
  {
    code: 'P964',
    level: 3,
    description:
      'Terminaci\u00f3n del embarazo, afectando al feto y reci\u00e9n nacido',
    code_2: 'P96',
    code_0: 'P00-P96',
    code_1: 'P90-P96'
  },
  {
    code: 'P965',
    level: 3,
    description:
      'Complicaciones de procedimientos intrauterinos, no clasificados en otra parte',
    code_2: 'P96',
    code_0: 'P00-P96',
    code_1: 'P90-P96'
  },
  {
    code: 'P968',
    level: 3,
    description:
      'Otras afecciones especificadas originadas en el per\u00edodo perinatal',
    code_2: 'P96',
    code_0: 'P00-P96',
    code_1: 'P90-P96'
  },
  {
    code: 'P969',
    level: 3,
    description:
      'Afecci\u00f3n no especificada originada en el per\u00edodo perinatal',
    code_2: 'P96',
    code_0: 'P00-P96',
    code_1: 'P90-P96'
  },
  {
    code: 'Q308',
    level: 3,
    description: 'Otras malformaciones cong\u00e9nitas de la nariz',
    code_2: 'Q30',
    code_0: 'Q00-Q99',
    code_1: 'Q30-Q34'
  },
  {
    code: 'Q309',
    level: 3,
    description:
      'Malformaci\u00f3n cong\u00e9nita de la nariz, no especificada',
    code_2: 'Q30',
    code_0: 'Q00-Q99',
    code_1: 'Q30-Q34'
  },
  {
    code: 'O700',
    level: 3,
    description: 'Desgarro perineal de primer grado durante el parto',
    code_2: 'O70',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O701',
    level: 3,
    description: 'Desgarro perineal de segundo grado durante el parto',
    code_2: 'O70',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O702',
    level: 3,
    description: 'Desgarro perineal de tercer grado durante el parto',
    code_2: 'O70',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O703',
    level: 3,
    description: 'Desgarro perineal de cuarto grado durante el parto',
    code_2: 'O70',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O709',
    level: 3,
    description: 'Desgarro perineal durante el parto, de grado no especificado',
    code_2: 'O70',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O690',
    level: 3,
    description:
      'Trabajo de parto y parto complicados por prolapso del cord\u00f3n umbilical',
    code_2: 'O69',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O691',
    level: 3,
    description:
      'Trabajo de parto y parto complicados por circular pericervical del cord\u00f3n, con compresi\u00f3n',
    code_2: 'O69',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O692',
    level: 3,
    description:
      'Trabajo de parto y parto complicados por otros enredos del cord\u00f3n',
    code_2: 'O69',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O693',
    level: 3,
    description:
      'Trabajo de parto y parto complicados por cord\u00f3n umbilical corto',
    code_2: 'O69',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O694',
    level: 3,
    description: 'Trabajo de parto y parto complicados por vasa previa',
    code_2: 'O69',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O695',
    level: 3,
    description:
      'Trabajo de parto y parto complicados por lesion vascular del cordon',
    code_2: 'O69',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O698',
    level: 3,
    description:
      'Trabajo de parto y parto complicados por otros problemas del cord\u00f3n umbilical',
    code_2: 'O69',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O699',
    level: 3,
    description:
      'Trabajo de parto y parto complicados por problemas no especificados del cord\u00f3n umbilical',
    code_2: 'O69',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O680',
    level: 3,
    description: 'Trabajo de parto y parto complicados por anomal\u00eda de la',
    code_2: 'O68',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O681',
    level: 3,
    description:
      'Trabajo de parto y parto complicados por la presencia de meconio en el l\u00edquido amni\u00f3tico',
    code_2: 'O68',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O682',
    level: 3,
    description:
      'Trabajo de parto y parto complicados por anomal\u00eda de la frecuencia card\u00edaca fetal asociada con presencia de meconio en el l\u00edquido amni\u00f3tico',
    code_2: 'O68',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O683',
    level: 3,
    description:
      'Trabajo de parto y parto complicados por evidencia bioqu\u00edmica de sufrimiento fetal',
    code_2: 'O68',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O688',
    level: 3,
    description:
      'Trabajo de parto y parto complicados por otras evidencias de sufrimiento fetal',
    code_2: 'O68',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O670',
    level: 3,
    description: 'Hemorragia intraparto con defectos de la coagulaci\u00f3n',
    code_2: 'O67',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O678',
    level: 3,
    description: 'Otras hemorragias intraparto',
    code_2: 'O67',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O679',
    level: 3,
    description: 'Hemorragia intraparto, no especificada',
    code_2: 'O67',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O660',
    level: 3,
    description: 'Trabajo de parto obstruido debido a distocia de hombros',
    code_2: 'O66',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O661',
    level: 3,
    description: 'Trabajo de parto obstruido debido a distocia gemelar',
    code_2: 'O66',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O662',
    level: 3,
    description:
      'Trabajo de parto obstruido debido a distocia por feto inusualmente grande',
    code_2: 'O66',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O663',
    level: 3,
    description:
      'Trabajo de parto obstruido debido a otras anormalidades del feto',
    code_2: 'O66',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O664',
    level: 3,
    description: 'Fracaso de la prueba del trabajo de parto, no especificada',
    code_2: 'O66',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O665',
    level: 3,
    description:
      'Fracaso no especificado de la aplicaci\u00f3n de f\u00f3rceps o de ventosa extractora',
    code_2: 'O66',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O668',
    level: 3,
    description: 'Otras obstrucciones especificadas del trabajo de parto',
    code_2: 'O66',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O669',
    level: 3,
    description: 'Trabajo de parto obstruido, sin otra especificaci\u00f3n',
    code_2: 'O66',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O650',
    level: 3,
    description: 'Trabajo de parto obstruido debido a deformidad de la pelvis',
    code_2: 'O65',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O651',
    level: 3,
    description:
      'Trabajo de parto obstruido debido a estrechez general de la pelvis',
    code_2: 'O65',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O652',
    level: 3,
    description:
      'Trabajo de parto obstruido debido a disminuci\u00f3n del estrecho superior de la pelvis',
    code_2: 'O65',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O653',
    level: 3,
    description:
      'Trabajo de parto obstruido debido a disminuci\u00f3n del estrecho inferior de la pelvis',
    code_2: 'O65',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O654',
    level: 3,
    description:
      'Trabajo de parto obstruido debido a desproporci\u00f3n fetopelviana, sin otra especificaci\u00f3n',
    code_2: 'O65',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O920',
    level: 3,
    description: 'Retracci\u00f3n del pez\u00f3n asociada con el parto',
    code_2: 'O92',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O921',
    level: 3,
    description: 'Fisuras del pez\u00f3n asociadas con el parto',
    code_2: 'O92',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O922',
    level: 3,
    description:
      'Otros trastornos de la mama y los no especificados asociados con el parto',
    code_2: 'O92',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O923',
    level: 3,
    description: 'Agalactia',
    code_2: 'O92',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O924',
    level: 3,
    description: 'Hipogalactia',
    code_2: 'O92',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O925',
    level: 3,
    description: 'Supresi\u00f3n de la lactancia',
    code_2: 'O92',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O926',
    level: 3,
    description: 'Galactorrea',
    code_2: 'O92',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O927',
    level: 3,
    description: 'Otros trastornos y los no especificados de la lactancia',
    code_2: 'O92',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O910',
    level: 3,
    description: 'Infecciones del pez\u00f3n asociadas con el parto',
    code_2: 'O91',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O911',
    level: 3,
    description: 'Absceso de la mama asociado con el parto',
    code_2: 'O91',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O912',
    level: 3,
    description: 'Mastitis no purulenta asociada con el parto',
    code_2: 'O91',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O900',
    level: 3,
    description: 'Dehiscencia de sutura de ces\u00e1rea',
    code_2: 'O90',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O901',
    level: 3,
    description: 'Dehiscencia de sutura obst\u00e9trica perineal',
    code_2: 'O90',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O902',
    level: 3,
    description: 'Hematoma de herida quir\u00fargica obst\u00e9trica',
    code_2: 'O90',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O903',
    level: 3,
    description: 'Cardiomiopat\u00eda en el puerperio',
    code_2: 'O90',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O904',
    level: 3,
    description: 'Insuficiencia renal aguda postparto',
    code_2: 'O90',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O905',
    level: 3,
    description: 'Tiroiditis postparto',
    code_2: 'O90',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O908',
    level: 3,
    description:
      'Otras complicaciones puerperales, no clasificadas en otra parte',
    code_2: 'O90',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O909',
    level: 3,
    description: 'Complicaci\u00f3n puerperal, no especificada',
    code_2: 'O90',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O990',
    level: 3,
    description: 'Anemia que complica el embarazo, el parto y el puerperio',
    code_2: 'O99',
    code_0: 'O00-O9A',
    code_1: 'O94-O99'
  },
  {
    code: 'O991',
    level: 3,
    description:
      'Otras enfermedades de la sangre y de los \u00f3rganos hematopoy\u00e9ticos y ciertos trastornos que afectan el sistema inmunitario cuando complican el embarazo, el parto y el puerperio',
    code_2: 'O99',
    code_0: 'O00-O9A',
    code_1: 'O94-O99'
  },
  {
    code: 'O992',
    level: 3,
    description:
      'Enfermedades endocrinas, de la nutrici\u00f3n y del metabolismo que complican el embarazo, el parto y el puerperio',
    code_2: 'O99',
    code_0: 'O00-O9A',
    code_1: 'O94-O99'
  },
  {
    code: 'O993',
    level: 3,
    description:
      'Trastornos mentales y enfermedades del sistema nervioso que complican el embarazo, el parto y el puerperio',
    code_2: 'O99',
    code_0: 'O00-O9A',
    code_1: 'O94-O99'
  },
  {
    code: 'O994',
    level: 3,
    description:
      'Enfermedades del sistema circulatorio que complican el embarazo, el parto y el puerperio',
    code_2: 'O99',
    code_0: 'O00-O9A',
    code_1: 'O94-O99'
  },
  {
    code: 'O995',
    level: 3,
    description:
      'Enfermedades del sistema respiratorio que complican el embarazo, el parto y el puerperio',
    code_2: 'O99',
    code_0: 'O00-O9A',
    code_1: 'O94-O99'
  },
  {
    code: 'O996',
    level: 3,
    description:
      'Enfermedades del sistema digestivo que complican el embarazo, el parto y el puerperio',
    code_2: 'O99',
    code_0: 'O00-O9A',
    code_1: 'O94-O99'
  },
  {
    code: 'O997',
    level: 3,
    description:
      'Enfermedades de la piel y del tejido subcut\u00e1neo que complican el embarazo, el parto y el puerperio',
    code_2: 'O99',
    code_0: 'O00-O9A',
    code_1: 'O94-O99'
  },
  {
    code: 'O998',
    level: 3,
    description:
      'Otras enfermedades especificadas y afecciones que complican el embarazo, el parto y el puerperio',
    code_2: 'O99',
    code_0: 'O00-O9A',
    code_1: 'O94-O99'
  },
  {
    code: 'O980',
    level: 3,
    description:
      'Tuberculosis que complica el embarazo, el parto y el puerperio',
    code_2: 'O98',
    code_0: 'O00-O9A',
    code_1: 'O94-O99'
  },
  {
    code: 'O981',
    level: 3,
    description:
      'S\u00edfilis que complica el embarazo, el parto y el puerperio',
    code_2: 'O98',
    code_0: 'O00-O9A',
    code_1: 'O94-O99'
  },
  {
    code: 'O982',
    level: 3,
    description: 'Gonorrea que complica el embarazo, el parto y el puerperio',
    code_2: 'O98',
    code_0: 'O00-O9A',
    code_1: 'O94-O99'
  },
  {
    code: 'O983',
    level: 3,
    description:
      'Otras infecciones con un modo de transmisi\u00f3n predominantemente sexual que complican el embarazo, el parto y el puerperio',
    code_2: 'O98',
    code_0: 'O00-O9A',
    code_1: 'O94-O99'
  },
  {
    code: 'O984',
    level: 3,
    description:
      'Hepatitis viral que complica el embarazo, el parto y el puerperio',
    code_2: 'O98',
    code_0: 'O00-O9A',
    code_1: 'O94-O99'
  },
  {
    code: 'O985',
    level: 3,
    description:
      'Otras enfermedades virales que complican el embarazo, el parto y el puerperio',
    code_2: 'O98',
    code_0: 'O00-O9A',
    code_1: 'O94-O99'
  },
  {
    code: 'O986',
    level: 3,
    description:
      'Enfermedades causadas por protozoarios que complican el embarazo, el parto y el puerperio',
    code_2: 'O98',
    code_0: 'O00-O9A',
    code_1: 'O94-O99'
  },
  {
    code: 'O988',
    level: 3,
    description:
      'Otras enfermedades infecciosas y parasitarias maternas que complican el embarazo, el parto y el puerperio',
    code_2: 'O98',
    code_0: 'O00-O9A',
    code_1: 'O94-O99'
  },
  {
    code: 'Q387',
    level: 3,
    description: 'Divert\u00edculo far\u00edngeo',
    code_2: 'Q38',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q388',
    level: 3,
    description: 'Otras malformaciones cong\u00e9nitas de la faringe',
    code_2: 'Q38',
    code_0: 'Q00-Q99',
    code_1: 'Q38-Q45'
  },
  {
    code: 'Q528',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas de los \u00f3rganos genitales femeninos, especificadas',
    code_2: 'Q52',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q529',
    level: 3,
    description:
      'Malformaci\u00f3n cong\u00e9nita de los genitales femeninos, no especificada',
    code_2: 'Q52',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q518',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas del \u00fatero y del cuello uterino',
    code_2: 'Q51',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q519',
    level: 3,
    description:
      'Malformaci\u00f3n cong\u00e9nita del \u00fatero y del cuello uterino, no especificada',
    code_2: 'Q51',
    code_0: 'Q00-Q99',
    code_1: 'Q50-Q56'
  },
  {
    code: 'Q639',
    level: 3,
    description:
      'Malformaci\u00f3n cong\u00e9nita del ri\u00f1\u00f3n, no especificada',
    code_2: 'Q63',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q628',
    level: 3,
    description: 'Otras malformaciones cong\u00e9nitas del ur\u00e9ter',
    code_2: 'Q62',
    code_0: 'Q00-Q99',
    code_1: 'Q60-Q64'
  },
  {
    code: 'Q676',
    level: 3,
    description: 'T\u00f3rax excavado',
    code_2: 'Q67',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q677',
    level: 3,
    description: 'T\u00f3rax en quilla',
    code_2: 'Q67',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q678',
    level: 3,
    description: 'Otras deformidades cong\u00e9nitas del t\u00f3rax',
    code_2: 'Q67',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q663',
    level: 3,
    description: 'Otras deformidades varus cong\u00e9nitas de los pies',
    code_2: 'Q66',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q664',
    level: 3,
    description: 'Talipes calcaneovalgus',
    code_2: 'Q66',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q665',
    level: 3,
    description: 'Pie plano cong\u00e9nito',
    code_2: 'Q66',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q666',
    level: 3,
    description: 'Otras deformidades valgus cong\u00e9nitas de los pies',
    code_2: 'Q66',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q667',
    level: 3,
    description: 'Pie cavus',
    code_2: 'Q66',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q668',
    level: 3,
    description: 'Otras deformidades cong\u00e9nitas de los pies',
    code_2: 'Q66',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q669',
    level: 3,
    description: 'Deformidad cong\u00e9nita de los pies, no especificada',
    code_2: 'Q66',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q654',
    level: 3,
    description: 'Subluxaci\u00f3n cong\u00e9nita de la cadera, bilateral',
    code_2: 'Q65',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q655',
    level: 3,
    description:
      'Subluxaci\u00f3n cong\u00e9nita de la cadera, no especificada',
    code_2: 'Q65',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q656',
    level: 3,
    description: 'Cadera inestable',
    code_2: 'Q65',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q658',
    level: 3,
    description: 'Otras deformidades cong\u00e9nitas de la cadera',
    code_2: 'Q65',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q659',
    level: 3,
    description: 'Deformidad cong\u00e9nita de la cadera, no especificada',
    code_2: 'Q65',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q824',
    level: 3,
    description: 'Displasia ectod\u00e9rmica (anhidr\u00f3tica)',
    code_2: 'Q82',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q825',
    level: 3,
    description: 'Nevo no neopl\u00e1sico, cong\u00e9nito',
    code_2: 'Q82',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q828',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas de la piel, especificadas',
    code_2: 'Q82',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q829',
    level: 3,
    description: 'Malformaci\u00f3n cong\u00e9nita de la piel, no especificada',
    code_2: 'Q82',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q819',
    level: 3,
    description: 'Epiderm\u00f3lisis bullosa, no especificada',
    code_2: 'Q81',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q804',
    level: 3,
    description: 'Feto arlequ\u00edn',
    code_2: 'Q80',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q808',
    level: 3,
    description: 'Otras ictiosis cong\u00e9nitas',
    code_2: 'Q80',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q809',
    level: 3,
    description: 'Ictiosis cong\u00e9nita, no especificada',
    code_2: 'Q80',
    code_0: 'Q00-Q99',
    code_1: 'Q80-Q89'
  },
  {
    code: 'Q969',
    level: 3,
    description: 'S\u00edndrome de Turner, no especificado',
    code_2: 'Q96',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q959',
    level: 3,
    description:
      'Reordenamiento equilibrado y marcador estructural, sin otra especificaci\u00f3n',
    code_2: 'Q95',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q934',
    level: 3,
    description: 'Supresi\u00f3n del brazo corto del cromosoma 5',
    code_2: 'Q93',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q935',
    level: 3,
    description: 'Otras supresiones de parte de un cromosoma',
    code_2: 'Q93',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q936',
    level: 3,
    description: 'Supresiones visibles s\u00f3lo en la prometafase',
    code_2: 'Q93',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q937',
    level: 3,
    description: 'Supresiones con otros reordenamientos complejos',
    code_2: 'Q93',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q938',
    level: 3,
    description: 'Otras supresiones de los autosomas',
    code_2: 'Q93',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q939',
    level: 3,
    description: 'Supresi\u00f3n de los autosomas, no especificada',
    code_2: 'Q93',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q926',
    level: 3,
    description: 'Cromosomas marcadores suplementarios',
    code_2: 'Q92',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q927',
    level: 3,
    description: 'Triploid\u00eda y poliploid\u00eda',
    code_2: 'Q92',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q928',
    level: 3,
    description:
      'Otras trisom\u00edas y trisom\u00edas parciales de los autosomas, especificadas',
    code_2: 'Q92',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q929',
    level: 3,
    description:
      'Trisom\u00eda y trisom\u00eda parcial de los autosomas, sin otra especificaci\u00f3n',
    code_2: 'Q92',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'Q917',
    level: 3,
    description: 'S\u00edndrome de Patau, no especificado',
    code_2: 'Q91',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'P789',
    level: 3,
    description: 'Trastorno perinatal del sistema digestivo, no especificado',
    code_2: 'P78',
    code_0: 'P00-P96',
    code_1: 'P75-P78'
  },
  {
    code: 'P928',
    level: 3,
    description: 'Otros problemas de alimentaci\u00f3n del reci\u00e9n nacido',
    code_2: 'P92',
    code_0: 'P00-P96',
    code_1: 'P90-P96'
  },
  {
    code: 'P929',
    level: 3,
    description:
      'Problema no especificado de la alimentaci\u00f3n del reci\u00e9n nacido',
    code_2: 'P92',
    code_0: 'P00-P96',
    code_1: 'P90-P96'
  },
  {
    code: 'P919',
    level: 3,
    description:
      'Alteraci\u00f3n cerebral no especificada del reci\u00e9n nacido',
    code_2: 'P91',
    code_0: 'P00-P96',
    code_1: 'P90-P96'
  },
  {
    code: 'O894',
    level: 3,
    description:
      'Cefalalgia inducida por la anestesia espinal o epidural administradas durante el puerperio',
    code_2: 'O89',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O895',
    level: 3,
    description:
      'Otras complicaciones de la anestesia espinal o epidural administradas durante el puerperio',
    code_2: 'O89',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O896',
    level: 3,
    description: 'Falla o dificultad de intubaci\u00f3n durante el puerperio',
    code_2: 'O89',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O898',
    level: 3,
    description:
      'Otras complicaciones de la anestesia administrada durante el puerperio',
    code_2: 'O89',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O899',
    level: 3,
    description:
      'Complicaci\u00f3n no especificada de la anestesia administrada durante el puerperio',
    code_2: 'O89',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O881',
    level: 3,
    description: 'Embolia de l\u00edquido amni\u00f3tico',
    code_2: 'O88',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O882',
    level: 3,
    description: 'Embolia de co\u00e1gulo sangu\u00edneo, obst\u00e9trica',
    code_2: 'O88',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O883',
    level: 3,
    description: 'Embolia s\u00e9ptica y pi\u00e9mica, obst\u00e9trica',
    code_2: 'O88',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O888',
    level: 3,
    description: 'Otras embolias obst\u00e9tricas',
    code_2: 'O88',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O871',
    level: 3,
    description: 'Flebotrombosis profunda en el puerperio',
    code_2: 'O87',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O872',
    level: 3,
    description: 'Hemorroides en el puerperio',
    code_2: 'O87',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O873',
    level: 3,
    description: 'Trombosis venosa cerebral en el puerperio',
    code_2: 'O87',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O878',
    level: 3,
    description: 'Otras complicaciones venosas en el puerperio',
    code_2: 'O87',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O879',
    level: 3,
    description: 'Complicaci\u00f3n venosa en el puerperio, no especificada',
    code_2: 'O87',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O861',
    level: 3,
    description: 'Otras infecciones genitales consecutivas al parto',
    code_2: 'O86',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O862',
    level: 3,
    description:
      'Infecci\u00f3n de las v\u00edas urinarias consecutiva al parto',
    code_2: 'O86',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O863',
    level: 3,
    description:
      'Otras infecciones de las v\u00edas genitourinarias consecutivas al parto',
    code_2: 'O86',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O864',
    level: 3,
    description: 'Pirexia de origen desconocido consecutiva al parto',
    code_2: 'O86',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'O868',
    level: 3,
    description: 'Otras infecciones puerperales especificadas',
    code_2: 'O86',
    code_0: 'O00-O9A',
    code_1: 'O85-O92'
  },
  {
    code: 'Y28',
    level: 2,
    description:
      'Contacto traum\u00e1tico con objeto cortante, de intenci\u00f3n no determinada',
    code_1: 'Y10-Y34',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y29',
    level: 2,
    description:
      ' Contacto traum\u00e1tico con objeto romo o sin filo, de intenci\u00f3n no determinada',
    code_1: 'Y10-Y34',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y30',
    level: 2,
    description:
      'Ca\u00edda, salto o empuj\u00f3n desde lugar elevado, de intenci\u00f3n no determinada',
    code_1: 'Y10-Y34',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y31',
    level: 2,
    description:
      'Ca\u00edda, permanencia o carrera delante o hacia objeto en movimiento, de intenci\u00f3n no determinada',
    code_1: 'Y10-Y34',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y32',
    level: 2,
    description:
      'Colisi\u00f3n de veh\u00edculo de motor, de intenci\u00f3n no determinada',
    code_1: 'Y10-Y34',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y04',
    level: 2,
    description: 'Agresi\u00f3n con fuerza corporal',
    code_1: 'X85-Y09',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y05',
    level: 2,
    description: 'Agresi\u00f3n sexual con fuerza corporal',
    code_1: 'X85-Y09',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y06',
    level: 2,
    description: 'Negligencia y abandono',
    code_1: 'X85-Y09',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y07',
    level: 2,
    description: 'Otros s\u00edndromes de maltrato',
    code_1: 'X85-Y09',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y08',
    level: 2,
    description: 'Agresi\u00f3n por otros medios especificados',
    code_1: 'X85-Y09',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y09',
    level: 2,
    description: 'Agresi\u00f3n por medios no especificados',
    code_1: 'X85-Y09',
    code_0: 'V01-Y99'
  },
  {
    code: 'X76',
    level: 2,
    description:
      'Lesi\u00f3n autoinfligida intencionalmente por humo, fuego y llamas',
    code_1: 'X60-X84',
    code_0: 'V01-Y99'
  },
  {
    code: 'X77',
    level: 2,
    description:
      'Lesi\u00f3n autoinfligida intencionalmente por vapor de agua, vapores y objetos calientes',
    code_1: 'X60-X84',
    code_0: 'V01-Y99'
  },
  {
    code: 'X78',
    level: 2,
    description:
      'Lesi\u00f3n autoinfligida intencionalmente por objeto cortante',
    code_1: 'X60-X84',
    code_0: 'V01-Y99'
  },
  {
    code: 'X79',
    level: 2,
    description:
      'Lesi\u00f3n autoinfligida intencionalmente por objeto romo o sin filo',
    code_1: 'X60-X84',
    code_0: 'V01-Y99'
  },
  {
    code: 'X80',
    level: 2,
    description:
      'Lesi\u00f3n autoinfligida intencionalmente al saltar desde un lugar elevado',
    code_1: 'X60-X84',
    code_0: 'V01-Y99'
  },
  {
    code: 'X81',
    level: 2,
    description:
      'Lesi\u00f3n autoinfligida intencionalmente por arrojarse o colocarse delante de objeto en movimiento',
    code_1: 'X60-X84',
    code_0: 'V01-Y99'
  },
  {
    code: 'R680',
    level: 3,
    description: 'Hipotermia no asociada con baja temperatura del ambiente',
    code_2: 'R68',
    code_0: 'R00-R99',
    code_1: 'R50-R69'
  },
  {
    code: 'R681',
    level: 3,
    description: 'S\u00edntomas no espec\u00edficos propios de la infancia',
    code_2: 'R68',
    code_0: 'R00-R99',
    code_1: 'R50-R69'
  },
  {
    code: 'R682',
    level: 3,
    description: 'Boca seca, no especificada',
    code_2: 'R68',
    code_0: 'R00-R99',
    code_1: 'R50-R69'
  },
  {
    code: 'R683',
    level: 3,
    description: 'Dedos de la mano deformes',
    code_2: 'R68',
    code_0: 'R00-R99',
    code_1: 'R50-R69'
  },
  {
    code: 'R688',
    level: 3,
    description: 'Otros s\u00edntomas y signos generales especificados',
    code_2: 'R68',
    code_0: 'R00-R99',
    code_1: 'R50-R69'
  },
  {
    code: 'R630',
    level: 3,
    description: 'Anorexia',
    code_2: 'R63',
    code_0: 'R00-R99',
    code_1: 'R50-R69'
  },
  {
    code: 'R631',
    level: 3,
    description: 'Polidipsia',
    code_2: 'R63',
    code_0: 'R00-R99',
    code_1: 'R50-R69'
  },
  {
    code: 'R632',
    level: 3,
    description: 'Polifagia',
    code_2: 'R63',
    code_0: 'R00-R99',
    code_1: 'R50-R69'
  },
  {
    code: 'R633',
    level: 3,
    description:
      'Dificultades y mala administraci\u00f3n de la alimentaci\u00f3n',
    code_2: 'R63',
    code_0: 'R00-R99',
    code_1: 'R50-R69'
  },
  {
    code: 'R634',
    level: 3,
    description: 'P\u00e9rdida anormal de peso',
    code_2: 'R63',
    code_0: 'R00-R99',
    code_1: 'R50-R69'
  },
  {
    code: 'R635',
    level: 3,
    description: 'Aumento anormal de peso',
    code_2: 'R63',
    code_0: 'R00-R99',
    code_1: 'R50-R69'
  },
  {
    code: 'R638',
    level: 3,
    description:
      'Otros s\u00edntomas y signos concernientes a la alimentaci\u00f3n y a la ingesti\u00f3n de l\u00edquidos',
    code_2: 'R63',
    code_0: 'R00-R99',
    code_1: 'R50-R69'
  },
  {
    code: 'V95',
    level: 3,
    description: 'Accidente de aeronave de motor, con ocupante lesionado',
    code_2: 'V95-V97',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V96',
    level: 3,
    description: 'Accidente de aeronave sin motor, con ocupante lesionado',
    code_2: 'V95-V97',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V97',
    level: 3,
    description: 'Otros accidentes de transporte a\u00e9reo especificados',
    code_2: 'V95-V97',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V90',
    level: 3,
    description:
      'Accidente de embarcaci\u00f3n que causa ahogamiento y sumersi\u00f3n',
    code_2: 'V90-V94',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V91',
    level: 3,
    description:
      'Accidente de embarcaci\u00f3n que causa otros tipos de traumatismo',
    code_2: 'V90-V94',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V92',
    level: 3,
    description:
      'Ahogamiento y sumersi\u00f3n relacionados con transporte por agua, sin accidente a la embarcaci\u00f3n',
    code_2: 'V90-V94',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V93',
    level: 3,
    description:
      'Accidente en una embarcaci\u00f3n, sin accidente a la embarcaci\u00f3n, que no causa ahogamiento o sumersi\u00f3n',
    code_2: 'V90-V94',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V80',
    level: 3,
    description:
      'Jinete u ocupante de veh\u00edculo de tracci\u00f3n animal lesionado en accidente de transporte',
    code_2: 'V80-V89',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V81',
    level: 3,
    description:
      'Ocupante de tren o veh\u00edculo de rieles lesionado en accidente de transporte',
    code_2: 'V80-V89',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V82',
    level: 3,
    description:
      'Ocupante de tranv\u00eda lesionado en accidente de transporte',
    code_2: 'V80-V89',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V83',
    level: 3,
    description:
      'Ocupante de veh\u00edculo especial (de motor) para uso principalmente en plantas industriales lesionado en accidente de transporte',
    code_2: 'V80-V89',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V84',
    level: 3,
    description:
      'Ocupante de veh\u00edculo especial (de motor) para uso principalmente en agricultura lesionado en accidente de transporte',
    code_2: 'V80-V89',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V85',
    level: 3,
    description:
      'Ocupante de veh\u00edculo especial (de motor) para construcci\u00f3n lesionado en accidente de transporte',
    code_2: 'V80-V89',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V70',
    level: 3,
    description:
      'Ocupante de autob\u00fas lesionado por colisi\u00f3n con peat\u00f3n o animal',
    code_2: 'V70-V79',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V71',
    level: 3,
    description:
      'Ocupante de autob\u00fas lesionado por colisi\u00f3n con veh\u00edculo de pedal',
    code_2: 'V70-V79',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V72',
    level: 3,
    description:
      'Ocupante de autob\u00fas lesionado por colisi\u00f3n con veh\u00edculo de motor de dos o tres ruedas',
    code_2: 'V70-V79',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V73',
    level: 3,
    description:
      'Ocupante de autob\u00fas lesionado por colisi\u00f3n con autom\u00f3vil, camioneta o furgoneta',
    code_2: 'V70-V79',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V60',
    level: 3,
    description:
      'Ocupante de veh\u00edculo de transporte pesado lesionado por colisi\u00f3n con peat\u00f3n o animal',
    code_2: 'V60-V69',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V61',
    level: 3,
    description:
      'Ocupante de veh\u00edculo de transporte pesado lesionado por colisi\u00f3n con veh\u00edculo de pedal',
    code_2: 'V60-V69',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V62',
    level: 3,
    description:
      'Ocupante de veh\u00edculo de transporte pesado lesionado por colisi\u00f3n con veh\u00edculo de motor de dos o tres ruedas',
    code_2: 'V60-V69',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V63',
    level: 3,
    description:
      'Ocupante de veh\u00edculo de transporte pesado lesionado por colisi\u00f3n con autom\u00f3vil, camioneta o furgoneta',
    code_2: 'V60-V69',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V64',
    level: 3,
    description:
      'Ocupante de veh\u00edculo de transporte pesado lesionado por colisi\u00f3n con otro veh\u00edculo de transporte pesado o autob\u00fas',
    code_2: 'V60-V69',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V65',
    level: 3,
    description:
      'Ocupante de veh\u00edculo de transporte pesado lesionado por colisi\u00f3n con tren o veh\u00edculo de rieles',
    code_2: 'V60-V69',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V50',
    level: 3,
    description:
      'Ocupante de camioneta o furgoneta lesionado por colisi\u00f3n con peat\u00f3n o animal',
    code_2: 'V50-V59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V51',
    level: 3,
    description:
      'Ocupante de camioneta o furgoneta lesionado por colisi\u00f3n con veh\u00edculo de pedal',
    code_2: 'V50-V59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V52',
    level: 3,
    description:
      'Ocupante de camioneta o furgoneta lesionado por colisi\u00f3n con veh\u00edculo de motor de dos o tres ruedas',
    code_2: 'V50-V59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V53',
    level: 3,
    description:
      'Ocupante de camioneta o furgoneta lesionado por colisi\u00f3n con autom\u00f3vil, camioneta o furgoneta',
    code_2: 'V50-V59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V54',
    level: 3,
    description:
      'Ocupante de camioneta o furgoneta lesionado por colisi\u00f3n con veh\u00edculo de transporte pesado o autob\u00fas',
    code_2: 'V50-V59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V55',
    level: 3,
    description:
      'Ocupante de camioneta o furgoneta lesionado por colisi\u00f3n con tren o veh\u00edculo de rieles',
    code_2: 'V50-V59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V56',
    level: 3,
    description:
      'Ocupante de camioneta o furgoneta lesionado por colisi\u00f3n con otros veh\u00edculos sin motor',
    code_2: 'V50-V59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'R788',
    level: 3,
    description:
      'Hallazgo de otras sustancias especificadas que normalmente no se encuentran en la sangre',
    code_2: 'R78',
    code_0: 'R00-R99',
    code_1: 'R70-R79'
  },
  {
    code: 'R789',
    level: 3,
    description:
      'Hallazgo de sustancia no especificada que normalmente no se encuentra en la sangre',
    code_2: 'R78',
    code_0: 'R00-R99',
    code_1: 'R70-R79'
  },
  {
    code: 'V40',
    level: 3,
    description:
      'Ocupante de autom\u00f3vil lesionado por colisi\u00f3n con peat\u00f3n o animal',
    code_2: 'V40-V49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V41',
    level: 3,
    description:
      'Ocupante de autom\u00f3vil lesionado por colisi\u00f3n con veh\u00edculo de pedal',
    code_2: 'V40-V49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V42',
    level: 3,
    description:
      'Ocupante de autom\u00f3vil lesionado por colisi\u00f3n con veh\u00edculo de motor de dos o tres ruedas',
    code_2: 'V40-V49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V43',
    level: 3,
    description:
      'Ocupante de autom\u00f3vil lesionado por colisi\u00f3n con otro autom\u00f3vil, camioneta o furgoneta',
    code_2: 'V40-V49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V44',
    level: 3,
    description:
      'Ocupante de autom\u00f3vil lesionado por colisi\u00f3n con veh\u00edculo de transporte pesado o autob\u00fas',
    code_2: 'V40-V49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V30',
    level: 3,
    description:
      'Ocupante de veh\u00edculo de motor de tres ruedas lesionado por colisi\u00f3n con peat\u00f3n o animal',
    code_2: 'V30-V39',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V31',
    level: 3,
    description:
      'Ocupante de veh\u00edculo de motor de tres ruedas lesionado por colisi\u00f3n con veh\u00edculo de pedal',
    code_2: 'V30-V39',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V32',
    level: 3,
    description:
      'Ocupante de veh\u00edculo de motor de tres ruedas lesionado por colisi\u00f3n con otro veh\u00edculo de motor de dos o tres ruedas',
    code_2: 'V30-V39',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V33',
    level: 3,
    description:
      'Ocupante de veh\u00edculo de motor de tres ruedas lesionado por colisi\u00f3n con autom\u00f3vil, camioneta o furgoneta',
    code_2: 'V30-V39',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V34',
    level: 3,
    description:
      'Ocupante de veh\u00edculo de motor de tres ruedas lesionado por colisi\u00f3n con veh\u00edculo de transporte pesado o autob\u00fas',
    code_2: 'V30-V39',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V35',
    level: 3,
    description:
      'Ocupante de veh\u00edculo de motor de tres ruedas lesionado por colisi\u00f3n con tren o veh\u00edculo de rieles',
    code_2: 'V30-V39',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'R947',
    level: 3,
    description:
      'Resultados anormales en otros estudios funcionales endocrinos',
    code_2: 'R94',
    code_0: 'R00-R99',
    code_1: 'R90-R94'
  },
  {
    code: 'R948',
    level: 3,
    description:
      'Resultados anormales en los estudios funcionales de otros \u00f3rganos y sistemas',
    code_2: 'R94',
    code_0: 'R00-R99',
    code_1: 'R90-R94'
  },
  {
    code: 'V24',
    level: 3,
    description:
      'Motociclista lesionado por colisi\u00f3n con veh\u00edculo de transporte pesado o autob\u00fas',
    code_2: 'V20-V29',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V25',
    level: 3,
    description:
      'Motociclista lesionado por colisi\u00f3n con tren o veh\u00edculo de rieles',
    code_2: 'V20-V29',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V26',
    level: 3,
    description:
      'Motociclista lesionado por colisi\u00f3n con otros veh\u00edculos sin motor',
    code_2: 'V20-V29',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V27',
    level: 3,
    description:
      'Motociclista lesionado por colisi\u00f3n con objeto fijo o estacionado',
    code_2: 'V20-V29',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V28',
    level: 3,
    description:
      'Motociclista lesionado en accidente de transporte sin colisi\u00f3n',
    code_2: 'V20-V29',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V29',
    level: 3,
    description:
      'Motociclista lesionado en otros accidentes de transporte, y en los no especificados',
    code_2: 'V20-V29',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V17',
    level: 3,
    description:
      'Ciclista lesionado por colisi\u00f3n con objeto estacionado o fijo',
    code_2: 'V10-V19',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V18',
    level: 3,
    description:
      'Ciclista lesionado en accidente de transporte sin colisi\u00f3n',
    code_2: 'V10-V19',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V19',
    level: 3,
    description:
      'Ciclista lesionado en otros accidentes de transporte, y en los no especificados',
    code_2: 'V10-V19',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'Y365',
    level: 3,
    description: 'Operaciones de guerra con armas nucleares',
    code_2: 'Y36',
    code_0: 'V01-Y99',
    code_1: 'Y35-Y36'
  },
  {
    code: 'Y366',
    level: 3,
    description: 'Operaciones de guerra con armas biol\u00f3gicas',
    code_2: 'Y36',
    code_0: 'V01-Y99',
    code_1: 'Y35-Y36'
  },
  {
    code: 'Y367',
    level: 3,
    description:
      'Operaciones de guerra con armas qu\u00edmicas y otras formas de guerra no convencional',
    code_2: 'Y36',
    code_0: 'V01-Y99',
    code_1: 'Y35-Y36'
  },
  {
    code: 'Y368',
    level: 3,
    description:
      'Operaciones de guerra que ocurren despu\u00e9s del cese de hostilidades',
    code_2: 'Y36',
    code_0: 'V01-Y99',
    code_1: 'Y35-Y36'
  },
  {
    code: 'Y369',
    level: 3,
    description: 'Operaci\u00f3n de guerra no especificada',
    code_2: 'Y36',
    code_0: 'V01-Y99',
    code_1: 'Y35-Y36'
  },
  {
    code: 'Y353',
    level: 3,
    description: 'Intervenci\u00f3n legal con objetos romos o sin filo',
    code_2: 'Y35',
    code_0: 'V01-Y99',
    code_1: 'Y35-Y36'
  },
  {
    code: 'Y354',
    level: 3,
    description: 'Intervenci\u00f3n legal con objetos cortantes',
    code_2: 'Y35',
    code_0: 'V01-Y99',
    code_1: 'Y35-Y36'
  },
  {
    code: 'Y355',
    level: 3,
    description: 'Ejecuci\u00f3n legal',
    code_2: 'Y35',
    code_0: 'V01-Y99',
    code_1: 'Y35-Y36'
  },
  {
    code: 'Y356',
    level: 3,
    description: 'Intervenci\u00f3n legal con otros medios especificados',
    code_2: 'Y35',
    code_0: 'V01-Y99',
    code_1: 'Y35-Y36'
  },
  {
    code: 'Y357',
    level: 3,
    description: 'Intervenci\u00f3n legal, medios no especificados',
    code_2: 'Y35',
    code_0: 'V01-Y99',
    code_1: 'Y35-Y36'
  },
  {
    code: 'Y62',
    level: 3,
    description:
      'Fallas en la esterilizaci\u00f3n durante la atenci\u00f3n m\u00e9dica y quir\u00fargica',
    code_2: 'Y60-Y69',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y63',
    level: 3,
    description:
      'Falla en la dosificaci\u00f3n durante la atenci\u00f3n m\u00e9dica y quir\u00fargica',
    code_2: 'Y60-Y69',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y64',
    level: 3,
    description: 'Medicamentos o sustancias biol\u00f3gicas contaminados',
    code_2: 'Y60-Y69',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y65',
    level: 3,
    description:
      'Otros incidentes durante la atenci\u00f3n m\u00e9dica y quir\u00fargica',
    code_2: 'Y60-Y69',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y66',
    level: 3,
    description:
      'No administraci\u00f3n de la atenci\u00f3n m\u00e9dica y quir\u00fargica',
    code_2: 'Y60-Y69',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y69',
    level: 3,
    description:
      'Incidentes no especificados durante la atenci\u00f3n m\u00e9dica y quir\u00fargica',
    code_2: 'Y60-Y69',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y42',
    level: 3,
    description:
      'Efectos adversos de hormonas y sus sustitutos sint\u00e9ticos y antagonistas, no clasificados en otra parte',
    code_2: 'Y40-Y59',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y43',
    level: 3,
    description: 'Efectos adversos de agentes sist\u00e9micos primarios',
    code_2: 'Y40-Y59',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y44',
    level: 3,
    description:
      'Efectos adversos de agentes que afectan primariamente los constituyentes de la sangre',
    code_2: 'Y40-Y59',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y45',
    level: 3,
    description:
      'Efectos adversos de drogas analg\u00e9sicas, antipir\u00e9ticas y antiinflamatorias',
    code_2: 'Y40-Y59',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y46',
    level: 3,
    description:
      'Efectos adversos de drogas antiepil\u00e9pticas y antiparkinsonianas',
    code_2: 'Y40-Y59',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y47',
    level: 3,
    description:
      'Efectos adversos de drogas sedantes, hipn\u00f3ticas y ansiol\u00edticas',
    code_2: 'Y40-Y59',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y48',
    level: 3,
    description:
      'Efectos adversos de gases anest\u00e9sicos y terap\u00e9uticos',
    code_2: 'Y40-Y59',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y49',
    level: 3,
    description:
      'Efectos adversos de drogas psicotr\u00f3picas, no clasificadas en otra parte',
    code_2: 'Y40-Y59',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y50',
    level: 3,
    description:
      'Efectos adversos de estimulantes del sistema nervioso central, no clasificados en otra parte',
    code_2: 'Y40-Y59',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y51',
    level: 3,
    description:
      'Efectos adversos de drogas que afectan primariamente el sistema nervioso aut\u00f3nomo',
    code_2: 'Y40-Y59',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Q785',
    level: 3,
    description: 'Displasia metafisaria',
    code_2: 'Q78',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q786',
    level: 3,
    description: 'Exostosis cong\u00e9nita m\u00faltiple',
    code_2: 'Q78',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q788',
    level: 3,
    description: 'Otras osteocondrodisplasias especificadas',
    code_2: 'Q78',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q789',
    level: 3,
    description: 'Osteocondrodisplasia, no especificada',
    code_2: 'Q78',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q774',
    level: 3,
    description: 'Acondroplasia',
    code_2: 'Q77',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q775',
    level: 3,
    description: 'Displasia distr\u00f3fica',
    code_2: 'Q77',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q776',
    level: 3,
    description: 'Displasia condroectod\u00e9rmica',
    code_2: 'Q77',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q777',
    level: 3,
    description: 'Displasia espondiloepifisaria',
    code_2: 'Q77',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q778',
    level: 3,
    description:
      'Otras osteocondrodisplasias con defectos del crecimiento de los huesos largos y de la columna vertebral',
    code_2: 'Q77',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q779',
    level: 3,
    description:
      'Osteocondrodisplasia con defectos del crecimiento de los huesos largos y de la columna vertebral, sin otra especificaci\u00f3n',
    code_2: 'Q77',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q766',
    level: 3,
    description: 'Otras malformaciones congenitas de las costillas',
    code_2: 'Q76',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q767',
    level: 3,
    description: 'Malformaci\u00f3n cong\u00e9nita del estern\u00f3n',
    code_2: 'Q76',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q768',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas del t\u00f3rax \u00f3seo',
    code_2: 'Q76',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q769',
    level: 3,
    description:
      'Malformaci\u00f3n cong\u00e9nita del t\u00f3rax \u00f3seo, no especificada',
    code_2: 'Q76',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q755',
    level: 3,
    description: 'Disostosis oculomaxilar',
    code_2: 'Q75',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q758',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas especificadas de los huesos del cr\u00e1neo y de la cara',
    code_2: 'Q75',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q759',
    level: 3,
    description:
      'Malformaci\u00f3n cong\u00e9nita no especificada de los huesos del cr\u00e1neo y de la cara',
    code_2: 'Q75',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q724',
    level: 3,
    description: 'Defecto por reducci\u00f3n longitudinal del f\u00e9mur',
    code_2: 'Q72',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q725',
    level: 3,
    description: 'Defecto por reducci\u00f3n longitudinal de la tibia',
    code_2: 'Q72',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q726',
    level: 3,
    description: 'Defecto por reducci\u00f3n longitudinal del peron\u00e9',
    code_2: 'Q72',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q727',
    level: 3,
    description: 'Pie hendido',
    code_2: 'Q72',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q728',
    level: 3,
    description:
      'Otros defectos por reducci\u00f3n del (de los) miembro(s) inferior(es)',
    code_2: 'Q72',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q729',
    level: 3,
    description:
      'Defecto por reducci\u00f3n del miembro inferior, no especificado',
    code_2: 'Q72',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q719',
    level: 3,
    description:
      'Defecto por reducci\u00f3n del miembro superior, no especificado',
    code_2: 'Q71',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q989',
    level: 3,
    description:
      'Anomal\u00eda de los cromosomas sexuales, fenotipo masculino, sin otra especificaci\u00f3n',
    code_2: 'Q98',
    code_0: 'Q00-Q99',
    code_1: 'Q90-Q99'
  },
  {
    code: 'C164',
    level: 5,
    description: 'Tumor maligno del p\u00edloro',
    code_4: 'C16',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C165',
    level: 5,
    description:
      'Tumor maligno de la curvatura menor del est\u00f3mago, sin otra especificaci\u00f3n',
    code_4: 'C16',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C166',
    level: 5,
    description:
      'Tumor maligno de la curvatura mayor del est\u00f3mago, sin otra especificaci\u00f3n',
    code_4: 'C16',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C168',
    level: 5,
    description: 'Lesi\u00f3n de sitios contiguos del est\u00f3mago',
    code_4: 'C16',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C169',
    level: 5,
    description: 'Tumor maligno del est\u00f3mago, parte no especificada',
    code_4: 'C16',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C388',
    level: 5,
    description:
      'Lesi\u00f3n de sitios contiguos del coraz\u00f3n, del mediastino y de la pleura',
    code_4: 'C38',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C30-C39'
  },
  {
    code: 'O689',
    level: 3,
    description:
      'Trabajo de parto y parto complicados por sufrimiento fetal, sin otra especificaci\u00f3n',
    code_2: 'O68',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O655',
    level: 3,
    description:
      'Trabajo de parto obstruido debido a anomal\u00edas de los \u00f3rganos pelvianos maternos',
    code_2: 'O65',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O658',
    level: 3,
    description:
      'Trabajo de parto obstruido debido a otras anomal\u00edas pelvianas maternas',
    code_2: 'O65',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O659',
    level: 3,
    description:
      'Trabajo de parto obstruido debido a anomal\u00eda pelviana no especificada',
    code_2: 'O65',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O989',
    level: 3,
    description:
      'Enfermedad infecciosa y parasitaria materna no especificada que complica el embarazo, el parto y el puerperio',
    code_2: 'O98',
    code_0: 'O00-O9A',
    code_1: 'O94-O99'
  },
  {
    code: 'Y33',
    level: 2,
    description:
      'Otros eventos especificados, de intenci\u00f3n no determinada',
    code_1: 'Y10-Y34',
    code_0: 'V01-Y99'
  },
  {
    code: 'Y34',
    level: 2,
    description: 'Evento no especificado, de intenci\u00f3n no determinada',
    code_1: 'Y10-Y34',
    code_0: 'V01-Y99'
  },
  {
    code: 'X82',
    level: 2,
    description:
      'Lesi\u00f3n autoinfligida intencionalmente por colisi\u00f3n de veh\u00edculo de motor',
    code_1: 'X60-X84',
    code_0: 'V01-Y99'
  },
  {
    code: 'X83',
    level: 2,
    description:
      'Lesi\u00f3n autoinfligida intencionalmente por otros medios especificados',
    code_1: 'X60-X84',
    code_0: 'V01-Y99'
  },
  {
    code: 'X84',
    level: 2,
    description:
      'Lesi\u00f3n autoinfligida intencionalmente por medios no especificados',
    code_1: 'X60-X84',
    code_0: 'V01-Y99'
  },
  {
    code: 'W00-W19',
    level: 3,
    description: 'Ca\u00eddas',
    code_2: 'W00-X59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'W00',
    level: 3,
    description: 'Ca\u00edda en el mismo nivel por hielo o nieve',
    code_2: 'W00-X59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'W01',
    level: 3,
    description:
      'Ca\u00edda en el mismo nivel por deslizamiento, tropez\u00f3n y traspi\u00e9',
    code_2: 'W00-X59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'W02',
    level: 3,
    description:
      'Ca\u00edda por patines para hielo, esqu\u00eds, patines de ruedas o patineta',
    code_2: 'W00-X59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'W03',
    level: 3,
    description:
      'Otras ca\u00eddas en el mismo nivel por colisi\u00f3n con o por empuj\u00f3n de otra persona',
    code_2: 'W00-X59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V98',
    level: 3,
    description: 'Otros accidentes de transporte especificados',
    code_2: 'V98-V99',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V99',
    level: 3,
    description: 'Accidente de transporte no especificado',
    code_2: 'V98-V99',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'C140',
    level: 5,
    description: 'Tumor maligno de la faringe, parte no especificada',
    code_4: 'C14',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C142',
    level: 5,
    description: 'Tumor maligno del anillo de Waldeyer',
    code_4: 'C14',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C148',
    level: 5,
    description:
      'Lesi\u00f3n de sitios contiguos del labio, de la cavidad bucal y de la faringe',
    code_4: 'C14',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C130',
    level: 5,
    description: 'Tumor maligno de la regi\u00f3n postcricoidea',
    code_4: 'C13',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C131',
    level: 5,
    description:
      'Tumor maligno del pliegue aritenoepigl\u00f3tico, cara hipofar\u00edngea',
    code_4: 'C13',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C132',
    level: 5,
    description: 'Tumor maligno de la pared posterior de la hipofaringe',
    code_4: 'C13',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C138',
    level: 5,
    description: 'Lesi\u00f3n de sitios contiguos de la hipofaringe',
    code_4: 'C13',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C139',
    level: 5,
    description: 'Tumor maligno de la hipofaringe, parte no especificada',
    code_4: 'C13',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C490',
    level: 5,
    description:
      'Tumor maligno del tejido conjuntivo y tejido blando de la cabeza, cara y cuello',
    code_4: 'C49',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C45-C49'
  },
  {
    code: 'C491',
    level: 5,
    description:
      'Tumor maligno del tejido conjuntivo y tejido blando del miembro superior, incluido el hombro',
    code_4: 'C49',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C45-C49'
  },
  {
    code: 'C492',
    level: 5,
    description:
      'Tumor maligno del tejido conjuntivo y tejido blando del miembro inferior, incluida la cadera',
    code_4: 'C49',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C45-C49'
  },
  {
    code: 'C493',
    level: 5,
    description:
      'Tumor maligno del tejido conjuntivo y tejido blando del t\u00f3rax',
    code_4: 'C49',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C45-C49'
  },
  {
    code: 'C494',
    level: 5,
    description:
      'Tumor maligno del tejido conjuntivo y tejido blando del abdomen',
    code_4: 'C49',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C45-C49'
  },
  {
    code: 'C495',
    level: 5,
    description:
      'Tumor maligno del tejido conjuntivo y tejido blando de la pelvis',
    code_4: 'C49',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C45-C49'
  },
  {
    code: 'C496',
    level: 5,
    description:
      'Tumor maligno del tejido conjuntivo y tejido blando del tronco, sin otra especificaci\u00f3n',
    code_4: 'C49',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C45-C49'
  },
  {
    code: 'C498',
    level: 5,
    description:
      'Lesi\u00f3n de sitios contiguos del tejido conjuntivo y del tejido blando',
    code_4: 'C49',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C45-C49'
  },
  {
    code: 'C499',
    level: 5,
    description:
      'Tumor maligno del tejido conjuntivo y tejido blando, de sitio no especificado',
    code_4: 'C49',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C45-C49'
  },
  {
    code: 'C480',
    level: 5,
    description: 'Tumor maligno del retroperitoneo',
    code_4: 'C48',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C45-C49'
  },
  {
    code: 'C481',
    level: 5,
    description: 'Tumor maligno de parte especificada del peritoneo',
    code_4: 'C48',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C45-C49'
  },
  {
    code: 'C482',
    level: 5,
    description: 'Tumor maligno del peritoneo, sin otra especificaci\u00f3n',
    code_4: 'C48',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C45-C49'
  },
  {
    code: 'C488',
    level: 5,
    description:
      'Lesi\u00f3n de sitios contiguos del peritoneo y del retroperitoneo',
    code_4: 'C48',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C45-C49'
  },
  {
    code: 'C470',
    level: 5,
    description:
      'Tumor maligno de los nervios perif\u00e9ricos de la cabeza, cara y cuello',
    code_4: 'C47',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C45-C49'
  },
  {
    code: 'C471',
    level: 5,
    description:
      'Tumor maligno de los nervios perif\u00e9ricos del miembro superior, incluido el hombro',
    code_4: 'C47',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C45-C49'
  },
  {
    code: 'C472',
    level: 5,
    description:
      'Tumor maligno de los nervios perif\u00e9ricos del miembro inferior, incluida la cadera',
    code_4: 'C47',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C45-C49'
  },
  {
    code: 'C473',
    level: 5,
    description: 'Tumor maligno de los nervios perif\u00e9ricos del t\u00f3rax',
    code_4: 'C47',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C45-C49'
  },
  {
    code: 'C474',
    level: 5,
    description: 'Tumor maligno de los nervios perif\u00e9ricos del abdomen',
    code_4: 'C47',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C45-C49'
  },
  {
    code: 'C475',
    level: 5,
    description: 'Tumor maligno de los nervios perif\u00e9ricos de la pelvis',
    code_4: 'C47',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C45-C49'
  },
  {
    code: 'C570',
    level: 5,
    description: 'Tumor maligno de la trompa de Falopio',
    code_4: 'C57',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C51-C58'
  },
  {
    code: 'C571',
    level: 5,
    description: 'Tumor maligno del ligamento ancho',
    code_4: 'C57',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C51-C58'
  },
  {
    code: 'C572',
    level: 5,
    description: 'Tumor maligno del ligamento redondo',
    code_4: 'C57',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C51-C58'
  },
  {
    code: 'C573',
    level: 5,
    description: 'Tumor maligno del parametrio',
    code_4: 'C57',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C51-C58'
  },
  {
    code: 'C574',
    level: 5,
    description:
      'Tumor maligno de los anexos uterinos, sin otra especificaci\u00f3n',
    code_4: 'C57',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C51-C58'
  },
  {
    code: 'C577',
    level: 5,
    description:
      'Tumor maligno de otras partes especificadas de los \u00f3rganos genitales femeninos',
    code_4: 'C57',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C51-C58'
  },
  {
    code: 'C578',
    level: 5,
    description:
      'Lesi\u00f3n de sitios contiguos de los \u00f3rganos genitales femeninos',
    code_4: 'C57',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C51-C58'
  },
  {
    code: 'C579',
    level: 5,
    description:
      'Tumor maligno de \u00f3rgano genital femenino, parte no especificada',
    code_4: 'C57',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C51-C58'
  },
  {
    code: 'C680',
    level: 5,
    description: 'Tumor maligno de la uretra',
    code_4: 'C68',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C64-C68'
  },
  {
    code: 'C681',
    level: 5,
    description: 'Tumor maligno de las gl\u00e1ndulas parauretrales',
    code_4: 'C68',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C64-C68'
  },
  {
    code: 'C688',
    level: 5,
    description:
      'Lesi\u00f3n de sitios contiguos de los \u00f3rganos urinarios',
    code_4: 'C68',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C64-C68'
  },
  {
    code: 'C689',
    level: 5,
    description: 'Tumor maligno de \u00f3rgano urinario no especificado',
    code_4: 'C68',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C64-C68'
  },
  {
    code: 'C720',
    level: 5,
    description: 'Tumor maligno de la m\u00e9dula espinal',
    code_4: 'C72',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C69-C72'
  },
  {
    code: 'C721',
    level: 5,
    description: 'Tumor maligno de la cola de caballo',
    code_4: 'C72',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C69-C72'
  },
  {
    code: 'C722',
    level: 5,
    description: 'Tumor maligno del nervio olfatorio',
    code_4: 'C72',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C69-C72'
  },
  {
    code: 'C723',
    level: 5,
    description: 'Tumor maligno del nervio \u00f3ptico',
    code_4: 'C72',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C69-C72'
  },
  {
    code: 'C724',
    level: 5,
    description: 'Tumor maligno del nervio ac\u00fastico',
    code_4: 'C72',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C69-C72'
  },
  {
    code: 'C725',
    level: 5,
    description:
      'Tumor maligno de otros nervios craneales y los no especificados',
    code_4: 'C72',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C69-C72'
  },
  {
    code: 'C728',
    level: 5,
    description:
      'Lesi\u00f3n de sitios contiguos del enc\u00e9falo y otras partes del sistema nervioso central',
    code_4: 'C72',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C69-C72'
  },
  {
    code: 'C729',
    level: 5,
    description:
      'Tumor maligno del sistema nervioso central, sin otra especificaci\u00f3n',
    code_4: 'C72',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C69-C72'
  },
  {
    code: 'Y83',
    level: 3,
    description:
      'Cirug\u00eda y otros procedimientos quir\u00fargicos como la causa de reacci\u00f3n anormal del paciente o de complicaci\u00f3n posterior, sin menci\u00f3n de incidente en el momento de efectuar el procedimiento',
    code_2: 'Y83-Y84',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y84',
    level: 3,
    description:
      'Otros procedimientos m\u00e9dicos como la causa de reacci\u00f3n anormal del paciente o de complicaci\u00f3n posterior, sin menci\u00f3n de incidente en el momento de efectuar el procedimiento',
    code_2: 'Y83-Y84',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y70',
    level: 3,
    description:
      'Dispositivos de anestesiolog\u00eda asociados con incidentes adversos',
    code_2: 'Y70-Y82',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y71',
    level: 3,
    description:
      'Dispositivos cardiovasculares asociados con incidentes adversos',
    code_2: 'Y70-Y82',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y72',
    level: 3,
    description:
      'Dispositivos otorrinolaringol\u00f3gicos asociados con incidentes adversos',
    code_2: 'Y70-Y82',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y73',
    level: 3,
    description:
      'Dispositivos de gastroenterolog\u00eda y urolog\u00eda asociados con incidentes adversos',
    code_2: 'Y70-Y82',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y74',
    level: 3,
    description:
      'Dispositivos para uso hospitalario general y personal asociados con incidentes adversos',
    code_2: 'Y70-Y82',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y75',
    level: 3,
    description:
      'Dispositivos neurol\u00f3gicos asociados con incidentes adversos',
    code_2: 'Y70-Y82',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Q790',
    level: 3,
    description: 'Hernia diafragm\u00e1tica cong\u00e9nita',
    code_2: 'Q79',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q791',
    level: 3,
    description: 'Otras malformaciones cong\u00e9nitas del diafragma',
    code_2: 'Q79',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q792',
    level: 3,
    description: 'Ex\u00f3nfalos',
    code_2: 'Q79',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q793',
    level: 3,
    description: 'Gastrosquisis',
    code_2: 'Q79',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q794',
    level: 3,
    description: 'S\u00edndrome del abdomen en ciruela pasa',
    code_2: 'Q79',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'C110',
    level: 5,
    description: 'Tumor maligno de la pared superior de la nasofaringe',
    code_4: 'C11',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C111',
    level: 5,
    description: 'Tumor maligno de la pared posterior de la nasofaringe',
    code_4: 'C11',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C112',
    level: 5,
    description: 'Tumor maligno de la pared lateral de la nasofaringe',
    code_4: 'C11',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C113',
    level: 5,
    description: 'Tumor maligno de la pared anterior de la nasofaringe',
    code_4: 'C11',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C118',
    level: 5,
    description: 'Lesi\u00f3n de sitios contiguos de la nasofaringe',
    code_4: 'C11',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C119',
    level: 5,
    description: 'Tumor maligno de la nasofaringe, parte no especificada',
    code_4: 'C11',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C100',
    level: 5,
    description: 'Tumor maligno de la val\u00e9cula',
    code_4: 'C10',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C101',
    level: 5,
    description: 'Tumor maligno de la cara anterior de la epiglotis',
    code_4: 'C10',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C102',
    level: 5,
    description: 'Tumor maligno de la pared lateral de la orofaringe',
    code_4: 'C10',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C103',
    level: 5,
    description: 'Tumor maligno de la pared posterior de la orofaringe',
    code_4: 'C10',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C104',
    level: 5,
    description: 'Tumor maligno de la hendidura branquial',
    code_4: 'C10',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C108',
    level: 5,
    description: 'Lesi\u00f3n de sitios contiguos de la orofaringe',
    code_4: 'C10',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C109',
    level: 5,
    description: 'Tumor maligno de la orofaringe, parte no especificada',
    code_4: 'C10',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C090',
    level: 5,
    description: 'Tumor maligno de la fosa amigdalina',
    code_4: 'C09',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C091',
    level: 5,
    description: 'Tumor maligno del pilar amigdalino (anterior) (posterior)',
    code_4: 'C09',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C098',
    level: 5,
    description: 'Lesi\u00f3n de sitios contiguos de la am\u00edgdala',
    code_4: 'C09',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C099',
    level: 5,
    description: 'Tumor maligno de la am\u00edgdala, parte no especificada',
    code_4: 'C09',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C080',
    level: 5,
    description: 'Tumor maligno de la gl\u00e1ndula submaxilar',
    code_4: 'C08',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C081',
    level: 5,
    description: 'Tumor maligno de la gl\u00e1ndula sublingual',
    code_4: 'C08',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C088',
    level: 5,
    description:
      'Lesi\u00f3n de sitios contiguos de las gl\u00e1ndulas salivales mayores',
    code_4: 'C08',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C089',
    level: 5,
    description:
      'Tumor maligno de gl\u00e1ndula salival mayor, no especificada',
    code_4: 'C08',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'V94',
    level: 3,
    description:
      'Otros accidentes de transporte por agua, y los no especificados',
    code_2: 'V90-V94',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V86',
    level: 3,
    description:
      'Ocupante de veh\u00edculo especial para todo terreno o de otro veh\u00edculo de motor para uso fuera de la carretera lesionado en accidente de transporte',
    code_2: 'V80-V89',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V87',
    level: 3,
    description:
      'Accidente de tr\u00e1nsito de tipo especificado, pero donde se desconoce el modo de transporte de la v\u00edctima',
    code_2: 'V80-V89',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V88',
    level: 3,
    description:
      'Accidente no de tr\u00e1nsito de tipo especificado, pero donde se desconoce el modo de transporte de la v\u00edctima',
    code_2: 'V80-V89',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V89',
    level: 3,
    description:
      'Accidente de veh\u00edculo de motor o sin motor, tipo de veh\u00edculo no especificado',
    code_2: 'V80-V89',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'C060',
    level: 5,
    description: 'Tumor maligno de la mucosa de la mejilla',
    code_4: 'C06',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C061',
    level: 5,
    description: 'Tumor maligno del vest\u00edbulo de la boca',
    code_4: 'C06',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C062',
    level: 5,
    description: 'Tumor maligno del \u00e1rea retromolar',
    code_4: 'C06',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C068',
    level: 5,
    description:
      'Lesi\u00f3n de sitios contiguos de otras partes y de las no especificadas de la boca',
    code_4: 'C06',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C069',
    level: 5,
    description: 'Tumor maligno de la boca, parte no especificada',
    code_4: 'C06',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C050',
    level: 5,
    description: 'Tumor maligno del paladar duro',
    code_4: 'C05',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C051',
    level: 5,
    description: 'Tumor maligno del paladar blando',
    code_4: 'C05',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C052',
    level: 5,
    description: 'Tumor maligno de la \u00favula',
    code_4: 'C05',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C058',
    level: 5,
    description: 'Lesi\u00f3n de sitios contiguos del paladar',
    code_4: 'C05',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C059',
    level: 5,
    description: 'Tumor maligno del paladar, parte no especificada',
    code_4: 'C05',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C040',
    level: 5,
    description: 'Tumor maligno de la parte anterior del piso de la boca',
    code_4: 'C04',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C041',
    level: 5,
    description: 'Tumor maligno de la parte lateral del piso de la boca',
    code_4: 'C04',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C048',
    level: 5,
    description: 'Lesi\u00f3n de sitios contiguos del piso de la boca',
    code_4: 'C04',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C049',
    level: 5,
    description: 'Tumor maligno del piso de la boca, parte no especificada',
    code_4: 'C04',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C030',
    level: 5,
    description: 'Tumor maligno de la enc\u00eda superior',
    code_4: 'C03',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C031',
    level: 5,
    description: 'Tumor maligno de la enc\u00eda inferior',
    code_4: 'C03',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'C039',
    level: 5,
    description: 'Tumor maligno de la enc\u00eda, parte no especificada',
    code_4: 'C03',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C00-C14'
  },
  {
    code: 'V74',
    level: 3,
    description:
      'Ocupante de autob\u00fas lesionado por colisi\u00f3n con veh\u00edculo de transporte pesado o autob\u00fas',
    code_2: 'V70-V79',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V75',
    level: 3,
    description:
      'Ocupante de autob\u00fas lesionado por colisi\u00f3n con tren o veh\u00edculo de rieles',
    code_2: 'V70-V79',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V76',
    level: 3,
    description:
      'Ocupante de autob\u00fas lesionado por colisi\u00f3n con otros veh\u00edculos sin motor',
    code_2: 'V70-V79',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V77',
    level: 3,
    description:
      'Ocupante de autob\u00fas lesionado por colisi\u00f3n con objeto fijo o estacionado',
    code_2: 'V70-V79',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V78',
    level: 3,
    description:
      'Ocupante de autob\u00fas lesionado en accidente de transporte sin colisi\u00f3n',
    code_2: 'V70-V79',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V79',
    level: 3,
    description:
      'Ocupante de autob\u00fas lesionado en otros accidentes de transporte, y en los no especificados',
    code_2: 'V70-V79',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'C260',
    level: 5,
    description: 'Tumor maligno del intestino, parte no especificada',
    code_4: 'C26',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C261',
    level: 5,
    description: 'Tumor maligno del bazo',
    code_4: 'C26',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C268',
    level: 5,
    description:
      'Lesi\u00f3n de sitios contiguos de los \u00f3rganos digestivos',
    code_4: 'C26',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C269',
    level: 5,
    description:
      'Tumor maligno de sitios mal definidos de los \u00f3rganos digestivos',
    code_4: 'C26',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C250',
    level: 5,
    description: 'Tumor maligno de la cabeza del p\u00e1ncreas',
    code_4: 'C25',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C251',
    level: 5,
    description: 'Tumor maligno del cuerpo del p\u00e1ncreas',
    code_4: 'C25',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C252',
    level: 5,
    description: 'Tumor maligno de la cola del p\u00e1ncreas',
    code_4: 'C25',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C253',
    level: 5,
    description: 'Tumor maligno del conducto pancre\u00e1tico',
    code_4: 'C25',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C254',
    level: 5,
    description: 'Tumor maligno del p\u00e1ncreas endocrino',
    code_4: 'C25',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C257',
    level: 5,
    description:
      'Tumor maligno de otras partes especificadas del p\u00e1ncreas',
    code_4: 'C25',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C258',
    level: 5,
    description: 'Lesi\u00f3n de sitios contiguos del p\u00e1ncreas',
    code_4: 'C25',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C259',
    level: 5,
    description: 'Tumor maligno del p\u00e1ncreas, parte no especificada',
    code_4: 'C25',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C240',
    level: 5,
    description: 'Tumor maligno de las v\u00edas biliares extrahep\u00e1ticas',
    code_4: 'C24',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C241',
    level: 5,
    description: 'Tumor maligno de la ampolla de Vater',
    code_4: 'C24',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C248',
    level: 5,
    description: 'Lesi\u00f3n de sitios contiguos de las v\u00edas biliares',
    code_4: 'C24',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C249',
    level: 5,
    description:
      'Tumor maligno de las v\u00edas biliares, parte no especificada',
    code_4: 'C24',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C220',
    level: 5,
    description: 'Carcinoma de c\u00e9lulas hep\u00e1ticas',
    code_4: 'C22',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C221',
    level: 5,
    description: 'Carcinoma de v\u00edas biliares intrahep\u00e1ticas',
    code_4: 'C22',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C222',
    level: 5,
    description: 'Hepatoblastoma',
    code_4: 'C22',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C223',
    level: 5,
    description: 'Angiosarcoma del h\u00edgado',
    code_4: 'C22',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C224',
    level: 5,
    description: 'Otros sarcomas del h\u00edgado',
    code_4: 'C22',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C227',
    level: 5,
    description: 'Otros carcinomas especificados del h\u00edgado',
    code_4: 'C22',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C229',
    level: 5,
    description: 'Tumor maligno del h\u00edgado, no especificado',
    code_4: 'C22',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C210',
    level: 5,
    description: 'Tumor maligno del ano, parte no especificada',
    code_4: 'C21',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'V66',
    level: 3,
    description:
      'Ocupante de veh\u00edculo de transporte pesado lesionado por colisi\u00f3n con otros veh\u00edculos sin motor',
    code_2: 'V60-V69',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V67',
    level: 3,
    description:
      'Ocupante de veh\u00edculo de transporte pesado lesionado por colisi\u00f3n con objeto fijo o estacionado',
    code_2: 'V60-V69',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V68',
    level: 3,
    description:
      'Ocupante de veh\u00edculo de transporte pesado lesionado en accidente de transporte sin colisi\u00f3n',
    code_2: 'V60-V69',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'C180',
    level: 5,
    description: 'Tumor maligno del ciego',
    code_4: 'C18',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C390',
    level: 5,
    description:
      'Tumor maligno de las v\u00edas respiratorias superiores, parte no especificada',
    code_4: 'C39',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C30-C39'
  },
  {
    code: 'C398',
    level: 5,
    description:
      'Lesi\u00f3n de sitios contiguos de los \u00f3rganos respiratorios e intrator\u00e1cicos',
    code_4: 'C39',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C30-C39'
  },
  {
    code: 'O750',
    level: 3,
    description: 'Sufrimiento materno durante el trabajo de parto y el parto',
    code_2: 'O75',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O751',
    level: 3,
    description:
      'Choque durante o despu\u00e9s del trabajo de parto y el parto',
    code_2: 'O75',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O752',
    level: 3,
    description:
      'Pirexia durante el trabajo de parto, no clasificada en otra parte',
    code_2: 'O75',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'V57',
    level: 3,
    description:
      'Ocupante de camioneta o furgoneta lesionado por colisi\u00f3n con objeto fijo o estacionado',
    code_2: 'V50-V59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V58',
    level: 3,
    description:
      'Ocupante de camioneta o furgoneta lesionado en accidente de transporte sin colisi\u00f3n',
    code_2: 'V50-V59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V59',
    level: 3,
    description:
      'Ocupante de camioneta o furgoneta lesionado en otros accidentes de transporte, y en los no especificados',
    code_2: 'V50-V59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'O740',
    level: 3,
    description:
      'Neumonitis por aspiraci\u00f3n debida a la anestesia adminis\u00adtrada durante el trabajo de parto y el parto',
    code_2: 'O74',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O741',
    level: 3,
    description:
      'Otras complicaciones pulmonares debidas a la anestesia administrada durante el trabajo de parto y el parto',
    code_2: 'O74',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O742',
    level: 3,
    description:
      'Complicaciones card\u00edacas de la anestesia administrada durante el trabajo de parto y el parto',
    code_2: 'O74',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O730',
    level: 3,
    description: 'Retenci\u00f3n de la placenta sin hemorragia',
    code_2: 'O73',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O731',
    level: 3,
    description:
      'Retenci\u00f3n de fragmentos de la placenta o de las membranas, sin hemorragia',
    code_2: 'O73',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O720',
    level: 3,
    description: 'Hemorragia del tercer per\u00edodo del parto',
    code_2: 'O72',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O721',
    level: 3,
    description: 'Otras hemorragias postparto inmediatas',
    code_2: 'O72',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O722',
    level: 3,
    description: 'Hemorragia postparto secundaria o tard\u00eda',
    code_2: 'O72',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O723',
    level: 3,
    description: 'Defecto de la coagulaci\u00f3n postparto',
    code_2: 'O72',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O710',
    level: 3,
    description: 'Ruptura del \u00fatero antes del inicio del trabajo de parto',
    code_2: 'O71',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O711',
    level: 3,
    description: 'Ruptura del \u00fatero durante el trabajo de parto',
    code_2: 'O71',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O712',
    level: 3,
    description: 'Inversi\u00f3n del \u00fatero, postparto',
    code_2: 'O71',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O713',
    level: 3,
    description: 'Desgarro obst\u00e9trico del cuello uterino',
    code_2: 'O71',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O714',
    level: 3,
    description: 'Desgarro vaginal obst\u00e9trico alto, s\u00f3lo',
    code_2: 'O71',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'C440',
    level: 5,
    description: 'Tumor maligno de la piel del labio',
    code_4: 'C44',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C43-C44'
  },
  {
    code: 'C441',
    level: 5,
    description:
      'Tumor maligno de la piel del p\u00e1rpado, incluida la comisura palpebral',
    code_4: 'C44',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C43-C44'
  },
  {
    code: 'C442',
    level: 5,
    description:
      'Tumor maligno de la piel de la oreja y del conducto auditivo externo',
    code_4: 'C44',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C43-C44'
  },
  {
    code: 'C443',
    level: 5,
    description:
      'Tumor maligno de la piel de otras partes y de las no especificadas de la cara',
    code_4: 'C44',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C43-C44'
  },
  {
    code: 'C444',
    level: 5,
    description: 'Tumor maligno de la piel del cuero cabelludo y del cuello',
    code_4: 'C44',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C43-C44'
  },
  {
    code: 'C445',
    level: 5,
    description: 'Tumor maligno de la piel del tronco',
    code_4: 'C44',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C43-C44'
  },
  {
    code: 'C430',
    level: 5,
    description: 'Melanoma maligno del labio',
    code_4: 'C43',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C43-C44'
  },
  {
    code: 'C431',
    level: 5,
    description:
      'Melanoma maligno del p\u00e1rpado, incluida la comisura palpebral',
    code_4: 'C43',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C43-C44'
  },
  {
    code: 'C432',
    level: 5,
    description: 'Melanoma maligno de la oreja y del conducto auditivo externo',
    code_4: 'C43',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C43-C44'
  },
  {
    code: 'C433',
    level: 5,
    description:
      'Melanoma maligno de las otras partes y las no especificadas de la cara',
    code_4: 'C43',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C43-C44'
  },
  {
    code: 'C460',
    level: 5,
    description: 'Sarcoma de Kaposi de la piel',
    code_4: 'C46',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C45-C49'
  },
  {
    code: 'C461',
    level: 5,
    description: 'Sarcoma de Kaposi del tejido blando',
    code_4: 'C46',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C45-C49'
  },
  {
    code: 'C462',
    level: 5,
    description: 'Sarcoma de Kaposi del paladar',
    code_4: 'C46',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C45-C49'
  },
  {
    code: 'C463',
    level: 5,
    description: 'Sarcoma de Kaposi de los ganglios linf\u00e1ticos',
    code_4: 'C46',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C45-C49'
  },
  {
    code: 'V45',
    level: 3,
    description:
      'Ocupante de autom\u00f3vil lesionado por colisi\u00f3n con tren o veh\u00edculo de rieles',
    code_2: 'V40-V49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V46',
    level: 3,
    description:
      'Ocupante de autom\u00f3vil lesionado por colisi\u00f3n con otros veh\u00edculos sin motor',
    code_2: 'V40-V49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V47',
    level: 3,
    description:
      'Ocupante de autom\u00f3vil lesionado por colisi\u00f3n con objeto fijo o estacionado',
    code_2: 'V40-V49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V48',
    level: 3,
    description:
      'Ocupante de autom\u00f3vil lesionado en accidente de transporte sin colisi\u00f3n',
    code_2: 'V40-V49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V49',
    level: 3,
    description:
      'Ocupante de autom\u00f3vil lesionado en otros accidentes de transporte, y en los no especificados',
    code_2: 'V40-V49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'C450',
    level: 5,
    description: 'Mesotelioma de la pleura',
    code_4: 'C45',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C45-C49'
  },
  {
    code: 'C451',
    level: 5,
    description: 'Mesotelioma del peritoneo',
    code_4: 'C45',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C45-C49'
  },
  {
    code: 'C452',
    level: 5,
    description: 'Mesotelioma del pericardio',
    code_4: 'C45',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C45-C49'
  },
  {
    code: 'C457',
    level: 5,
    description: 'Mesotelioma de otros sitios especificados',
    code_4: 'C45',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C45-C49'
  },
  {
    code: 'C459',
    level: 5,
    description: 'Mesotelioma, de sitio no especificado',
    code_4: 'C45',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C45-C49'
  },
  {
    code: 'V36',
    level: 3,
    description:
      'Ocupante de veh\u00edculo de motor de tres ruedas lesionado por colisi\u00f3n con otros veh\u00edculos sin motor',
    code_2: 'V30-V39',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V37',
    level: 3,
    description:
      'Ocupante de veh\u00edculo de motor de tres ruedas lesionado por colisi\u00f3n con objeto fijo o estacionado',
    code_2: 'V30-V39',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V38',
    level: 3,
    description:
      'Ocupante de veh\u00edculo de motor de tres ruedas lesionado en accidente de transporte sin colisi\u00f3n',
    code_2: 'V30-V39',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V39',
    level: 3,
    description:
      'Ocupante de veh\u00edculo de motor de tres ruedas lesionado en otros accidentes de transporte, y en los no especificados',
    code_2: 'V30-V39',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'Y52',
    level: 3,
    description:
      'Efectos adversos de agentes que afectan primariamente el sistema cardiovascular',
    code_2: 'Y40-Y59',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y53',
    level: 3,
    description:
      'Efectos adversos de agentes que afectan primariamente el sistema gastrointestinal',
    code_2: 'Y40-Y59',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y54',
    level: 3,
    description:
      'Efectos adversos de agentes que afectan primariamente el equilibrio h\u00eddrico y el metabolismo mineral y del \u00e1cido \u00farico',
    code_2: 'Y40-Y59',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y55',
    level: 3,
    description:
      'Efectos adversos de agentes que act\u00faan primariamente sobre los m\u00fasculos lisos y estriados y sobre el sistema respiratorio',
    code_2: 'Y40-Y59',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y56',
    level: 3,
    description:
      'Efectos adversos de agentes t\u00f3picos que afectan primariamente la piel y las membranas mucosas, y drogas oftalmol\u00f3gicas, otorrinolaringol\u00f3gicas y dentales',
    code_2: 'Y40-Y59',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y57',
    level: 3,
    description:
      'Efectos adversos de otras drogas y medicamentos, y los no especificados',
    code_2: 'Y40-Y59',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y58',
    level: 3,
    description: 'Efectos adversos de vacunas bacterianas',
    code_2: 'Y40-Y59',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y59',
    level: 3,
    description:
      'Efectos adversos de otras vacunas y sustancias biol\u00f3gicas, y las no especificadas',
    code_2: 'Y40-Y59',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y070',
    level: 3,
    description: 'Por esposo o pareja',
    code_2: 'Y07',
    code_0: 'V01-Y99',
    code_1: 'X85-Y09'
  },
  {
    code: 'Y071',
    level: 3,
    description: 'Por padre o madre',
    code_2: 'Y07',
    code_0: 'V01-Y99',
    code_1: 'X85-Y09'
  },
  {
    code: 'Y072',
    level: 3,
    description: 'Por conocido o amigo',
    code_2: 'Y07',
    code_0: 'V01-Y99',
    code_1: 'X85-Y09'
  },
  {
    code: 'Y073',
    level: 3,
    description: 'Por autoridades oficiales',
    code_2: 'Y07',
    code_0: 'V01-Y99',
    code_1: 'X85-Y09'
  },
  {
    code: 'Y078',
    level: 3,
    description: 'Por otra persona especificada',
    code_2: 'Y07',
    code_0: 'V01-Y99',
    code_1: 'X85-Y09'
  },
  {
    code: 'Y079',
    level: 3,
    description: 'Por persona no especificada',
    code_2: 'Y07',
    code_0: 'V01-Y99',
    code_1: 'X85-Y09'
  },
  {
    code: 'Y060',
    level: 3,
    description: 'Por esposo o pareja',
    code_2: 'Y06',
    code_0: 'V01-Y99',
    code_1: 'X85-Y09'
  },
  {
    code: 'Y061',
    level: 3,
    description: 'Por padre o madre',
    code_2: 'Y06',
    code_0: 'V01-Y99',
    code_1: 'X85-Y09'
  },
  {
    code: 'Y062',
    level: 3,
    description: 'Por conocido o amigo',
    code_2: 'Y06',
    code_0: 'V01-Y99',
    code_1: 'X85-Y09'
  },
  {
    code: 'Y068',
    level: 3,
    description: 'Por otra persona especificada',
    code_2: 'Y06',
    code_0: 'V01-Y99',
    code_1: 'X85-Y09'
  },
  {
    code: 'Y069',
    level: 3,
    description: 'Por persona no especificada',
    code_2: 'Y06',
    code_0: 'V01-Y99',
    code_1: 'X85-Y09'
  },
  {
    code: 'Y400',
    level: 4,
    description: 'Efectos adversos de penicilinas',
    code_3: 'Y40',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y401',
    level: 4,
    description:
      'Efectos adversos de cefalosporinas y otros antibi\u00f3ticos beta-lact\u00e1micos',
    code_3: 'Y40',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y402',
    level: 4,
    description: 'Efectos adversos del grupo de cloramfenicol',
    code_3: 'Y40',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y403',
    level: 4,
    description: 'Efectos adversos de los macr\u00f3lidos',
    code_3: 'Y40',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y404',
    level: 4,
    description: 'Efectos adversos de tetraciclinas',
    code_3: 'Y40',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y610',
    level: 4,
    description:
      'Objeto extra\u00f1o dejado accidentalmente en el cuerpo durante operaci\u00f3n quir\u00fargica',
    code_3: 'Y61',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y611',
    level: 4,
    description:
      'Objeto extra\u00f1o dejado accidentalmente en el cuerpo durante infusi\u00f3n o transfusi\u00f3n',
    code_3: 'Y61',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y612',
    level: 4,
    description:
      'Objeto extra\u00f1o dejado accidentalmente en el cuerpo durante di\u00e1lisis renal u otra perfusi\u00f3n',
    code_3: 'Y61',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y613',
    level: 4,
    description:
      'Objeto extra\u00f1o dejado accidentalmente en el cuerpo durante inyecci\u00f3n o inmunizaci\u00f3n',
    code_3: 'Y61',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y614',
    level: 4,
    description:
      'Objeto extra\u00f1o dejado accidentalmente en el cuerpo durante examen endosc\u00f3pico',
    code_3: 'Y61',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y615',
    level: 4,
    description:
      'Objeto extra\u00f1o dejado accidentalmente en el cuerpo durante cateterizaci\u00f3n card\u00edaca',
    code_3: 'Y61',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y600',
    level: 4,
    description: 'Incidente durante operaci\u00f3n quir\u00fargica',
    code_3: 'Y60',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y601',
    level: 4,
    description: 'Incidente durante infusi\u00f3n o transfusi\u00f3n',
    code_3: 'Y60',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y602',
    level: 4,
    description: 'Incidente durante di\u00e1lisis renal u otra perfusi\u00f3n',
    code_3: 'Y60',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y603',
    level: 4,
    description: 'Incidente durante inyecci\u00f3n o inmunizaci\u00f3n',
    code_3: 'Y60',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y604',
    level: 4,
    description: 'Incidente durante examen endosc\u00f3pico',
    code_3: 'Y60',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y605',
    level: 4,
    description: 'Incidente durante cateterizaci\u00f3n card\u00edaca',
    code_3: 'Y60',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y606',
    level: 4,
    description:
      'Incidente durante aspiraci\u00f3n, punci\u00f3n y otra cateterizaci\u00f3n',
    code_3: 'Y60',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'W04',
    level: 3,
    description: 'Ca\u00edda al ser trasladado o sostenido por otras personas',
    code_2: 'W00-X59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'W05',
    level: 3,
    description: 'Ca\u00edda que implica silla de ruedas',
    code_2: 'W00-X59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'W06',
    level: 3,
    description: 'Ca\u00edda que implica cama',
    code_2: 'W00-X59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'W07',
    level: 3,
    description: 'Ca\u00edda que implica silla',
    code_2: 'W00-X59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'W08',
    level: 3,
    description: 'Ca\u00edda que implica otro mueble',
    code_2: 'W00-X59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'W09',
    level: 3,
    description: 'Ca\u00edda que implica equipos para juegos infantiles',
    code_2: 'W00-X59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'C540',
    level: 5,
    description: 'Tumor maligno del istmo uterino',
    code_4: 'C54',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C51-C58'
  },
  {
    code: 'C541',
    level: 5,
    description: 'Tumor maligno del endometrio',
    code_4: 'C54',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C51-C58'
  },
  {
    code: 'C530',
    level: 5,
    description: 'Tumor maligno del endoc\u00e9rvix',
    code_4: 'C53',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C51-C58'
  },
  {
    code: 'C531',
    level: 5,
    description: 'Tumor maligno del exoc\u00e9rvix',
    code_4: 'C53',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C51-C58'
  },
  {
    code: 'C538',
    level: 5,
    description: 'Lesi\u00f3n de sitios contiguos del cuello del \u00fatero',
    code_4: 'C53',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C51-C58'
  },
  {
    code: 'C510',
    level: 5,
    description: 'Tumor maligno del labio mayor',
    code_4: 'C51',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C51-C58'
  },
  {
    code: 'C511',
    level: 5,
    description: 'Tumor maligno del labio menor',
    code_4: 'C51',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C51-C58'
  },
  {
    code: 'C512',
    level: 5,
    description: 'Tumor maligno del cl\u00edtoris',
    code_4: 'C51',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C51-C58'
  },
  {
    code: 'C518',
    level: 5,
    description: 'Lesi\u00f3n de sitios contiguos de la vulva',
    code_4: 'C51',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C51-C58'
  },
  {
    code: 'C630',
    level: 5,
    description: 'Tumor maligno del epid\u00eddimo',
    code_4: 'C63',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C60-C63'
  },
  {
    code: 'C631',
    level: 5,
    description: 'Tumor maligno del cord\u00f3n esperm\u00e1tico',
    code_4: 'C63',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C60-C63'
  },
  {
    code: 'C632',
    level: 5,
    description: 'Tumor maligno del escroto',
    code_4: 'C63',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C60-C63'
  },
  {
    code: 'C637',
    level: 5,
    description:
      'Tumor maligno de otras partes especificadas de los \u00f3rganos genitales masculinos',
    code_4: 'C63',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C60-C63'
  },
  {
    code: 'C620',
    level: 5,
    description: 'Tumor maligno del test\u00edculo no descendido',
    code_4: 'C62',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C60-C63'
  },
  {
    code: 'C621',
    level: 5,
    description: 'Tumor maligno del test\u00edculo descendido',
    code_4: 'C62',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C60-C63'
  },
  {
    code: 'C629',
    level: 5,
    description: 'Tumor maligno del test\u00edculo, no especificado',
    code_4: 'C62',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C60-C63'
  },
  {
    code: 'C600',
    level: 5,
    description: 'Tumor maligno del prepucio',
    code_4: 'C60',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C60-C63'
  },
  {
    code: 'C601',
    level: 5,
    description: 'Tumor maligno del glande',
    code_4: 'C60',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C60-C63'
  },
  {
    code: 'C602',
    level: 5,
    description: 'Tumor maligno del cuerpo del pene',
    code_4: 'C60',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C60-C63'
  },
  {
    code: 'C608',
    level: 5,
    description: 'Lesi\u00f3n de sitios contiguos del pene',
    code_4: 'C60',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C60-C63'
  },
  {
    code: 'C609',
    level: 5,
    description: 'Tumor maligno del pene, parte no especificada',
    code_4: 'C60',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C60-C63'
  },
  {
    code: 'C670',
    level: 5,
    description: 'Tumor maligno del tr\u00edgono vesical',
    code_4: 'C67',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C64-C68'
  },
  {
    code: 'C671',
    level: 5,
    description: 'Tumor maligno de la c\u00fapula vesical',
    code_4: 'C67',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C64-C68'
  },
  {
    code: 'C672',
    level: 5,
    description: 'Tumor maligno de la pared lateral de la vejiga',
    code_4: 'C67',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C64-C68'
  },
  {
    code: 'C673',
    level: 5,
    description: 'Tumor maligno de la pared anterior de la vejiga',
    code_4: 'C67',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C64-C68'
  },
  {
    code: 'C674',
    level: 5,
    description: 'Tumor maligno de la pared posterior de la vejiga',
    code_4: 'C67',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C64-C68'
  },
  {
    code: 'C675',
    level: 5,
    description: 'Tumor maligno del cuello de la vejiga',
    code_4: 'C67',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C64-C68'
  },
  {
    code: 'C710',
    level: 5,
    description:
      'Tumor maligno del cerebro, excepto l\u00f3bulos y ventr\u00edculos',
    code_4: 'C71',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C69-C72'
  },
  {
    code: 'C711',
    level: 5,
    description: 'Tumor maligno del l\u00f3bulo frontal',
    code_4: 'C71',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C69-C72'
  },
  {
    code: 'C712',
    level: 5,
    description: 'Tumor maligno del l\u00f3bulo temporal',
    code_4: 'C71',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C69-C72'
  },
  {
    code: 'C713',
    level: 5,
    description: 'Tumor maligno del l\u00f3bulo parietal',
    code_4: 'C71',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C69-C72'
  },
  {
    code: 'C714',
    level: 5,
    description: 'Tumor maligno del l\u00f3bulo occipital',
    code_4: 'C71',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C69-C72'
  },
  {
    code: 'C715',
    level: 5,
    description: 'Tumor maligno del ventr\u00edculo cerebral',
    code_4: 'C71',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C69-C72'
  },
  {
    code: 'C700',
    level: 5,
    description: 'Tumor maligno de las meninges cerebrales',
    code_4: 'C70',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C69-C72'
  },
  {
    code: 'C701',
    level: 5,
    description: 'Tumor maligno de las meninges raqu\u00eddeas',
    code_4: 'C70',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C69-C72'
  },
  {
    code: 'C709',
    level: 5,
    description: 'Tumor maligno de las meninges, parte no especificada',
    code_4: 'C70',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C69-C72'
  },
  {
    code: 'C690',
    level: 5,
    description: 'Tumor maligno de la conjuntiva',
    code_4: 'C69',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C69-C72'
  },
  {
    code: 'C691',
    level: 5,
    description: 'Tumor maligno de la c\u00f3rnea',
    code_4: 'C69',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C69-C72'
  },
  {
    code: 'C692',
    level: 5,
    description: 'Tumor maligno de la retina',
    code_4: 'C69',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C69-C72'
  },
  {
    code: 'C693',
    level: 5,
    description: 'Tumor maligno de la coroides',
    code_4: 'C69',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C69-C72'
  },
  {
    code: 'C694',
    level: 5,
    description: 'Tumor maligno del cuerpo ciliar',
    code_4: 'C69',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C69-C72'
  },
  {
    code: 'C695',
    level: 5,
    description: 'Tumor maligno de la gl\u00e1ndula y conducto lagrimales',
    code_4: 'C69',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C69-C72'
  },
  {
    code: 'C696',
    level: 5,
    description: 'Tumor maligno de la \u00f3rbita',
    code_4: 'C69',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C69-C72'
  },
  {
    code: 'C750',
    level: 5,
    description: 'Tumor maligno de la gl\u00e1ndula paratiroides',
    code_4: 'C75',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C73-C75'
  },
  {
    code: 'C751',
    level: 5,
    description: 'Tumor maligno de la hip\u00f3fisis',
    code_4: 'C75',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C73-C75'
  },
  {
    code: 'C752',
    level: 5,
    description: 'Tumor maligno del conducto craneofar\u00edngeo',
    code_4: 'C75',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C73-C75'
  },
  {
    code: 'C753',
    level: 5,
    description: 'Tumor maligno de la gl\u00e1ndula pineal',
    code_4: 'C75',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C73-C75'
  },
  {
    code: 'C754',
    level: 5,
    description: 'Tumor maligno del cuerpo carot\u00eddeo',
    code_4: 'C75',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C73-C75'
  },
  {
    code: 'C755',
    level: 5,
    description:
      'Tumor maligno del cuerpo a\u00f3rtico y otros cuerpos cromafines',
    code_4: 'C75',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C73-C75'
  },
  {
    code: 'C758',
    level: 5,
    description: 'Tumor maligno pluriglandular, no especificado',
    code_4: 'C75',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C73-C75'
  },
  {
    code: 'C759',
    level: 5,
    description: 'Tumor maligno de gl\u00e1ndula endocrina no especificada',
    code_4: 'C75',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C73-C75'
  },
  {
    code: 'C740',
    level: 5,
    description: 'Tumor maligno de la corteza de la gl\u00e1ndula suprarrenal',
    code_4: 'C74',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C73-C75'
  },
  {
    code: 'C741',
    level: 5,
    description:
      'Tumor maligno de la m\u00e9dula de la gl\u00e1ndula suprarrenal',
    code_4: 'C74',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C73-C75'
  },
  {
    code: 'C749',
    level: 5,
    description:
      'Tumor maligno de la gl\u00e1ndula suprarrenal, parte no especificada',
    code_4: 'C74',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C73-C75'
  },
  {
    code: 'C476',
    level: 5,
    description:
      'Tumor maligno de los nervios perif\u00e9ricos del tronco, sin otra especificaci\u00f3n',
    code_4: 'C47',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C45-C49'
  },
  {
    code: 'C478',
    level: 5,
    description:
      'Lesi\u00f3n de sitios contiguos de los nervios perif\u00e9ricos y del sistema nervioso aut\u00f3nomo',
    code_4: 'C47',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C45-C49'
  },
  {
    code: 'C479',
    level: 5,
    description:
      'Tumor maligno de los nervios perif\u00e9ricos y del sistema nervioso aut\u00f3nomo, parte no especificada',
    code_4: 'C47',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C45-C49'
  },
  {
    code: 'Y76',
    level: 3,
    description:
      'Dispositivos ginecol\u00f3gicos y obst\u00e9tricos asociados con incidentes adversos',
    code_2: 'Y70-Y82',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y77',
    level: 3,
    description:
      'Dispositivos oft\u00e1lmicos asociados con incidentes adversos',
    code_2: 'Y70-Y82',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y78',
    level: 3,
    description: 'Aparatos radiol\u00f3gicos asociados con incidentes adversos',
    code_2: 'Y70-Y82',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y79',
    level: 3,
    description:
      'Dispositivos ortop\u00e9dicos asociados con incidentes adversos',
    code_2: 'Y70-Y82',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y80',
    level: 3,
    description:
      'Aparatos de medicina f\u00edsica asociados con incidentes adversos',
    code_2: 'Y70-Y82',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y81',
    level: 3,
    description:
      'Dispositivos de cirug\u00eda general y pl\u00e1stica asociados con incidentes adversos',
    code_2: 'Y70-Y82',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Y82',
    level: 3,
    description:
      'Otros dispositivos m\u00e9dicos, y los no especificados, asociados con incidentes adversos',
    code_2: 'Y70-Y82',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84'
  },
  {
    code: 'Q795',
    level: 3,
    description: 'Otras malformaciones cong\u00e9nitas de la pared abdominal',
    code_2: 'Q79',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q796',
    level: 3,
    description: 'S\u00edndrome de Ehlers\u2013Danlos',
    code_2: 'Q79',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q798',
    level: 3,
    description:
      'Otras malformaciones cong\u00e9nitas del sistema osteomuscular',
    code_2: 'Q79',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'Q799',
    level: 3,
    description:
      'Malformaci\u00f3n cong\u00e9nita del sistema osteomuscular, no especificada',
    code_2: 'Q79',
    code_0: 'Q00-Q99',
    code_1: 'Q65-Q79'
  },
  {
    code: 'C211',
    level: 5,
    description: 'Tumor maligno del conducto anal',
    code_4: 'C21',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C212',
    level: 5,
    description: 'Tumor maligno de la zona cloacog\u00e9nica',
    code_4: 'C21',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C218',
    level: 5,
    description:
      'Lesi\u00f3n de sitios contiguos del ano, del conducto anal y del recto',
    code_4: 'C21',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'V69',
    level: 3,
    description:
      'Ocupante de veh\u00edculo de transporte pesado lesionado en otros accidentes de transporte, y en los no especificados',
    code_2: 'V60-V69',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'C181',
    level: 5,
    description: 'Tumor maligno del ap\u00e9ndice',
    code_4: 'C18',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C182',
    level: 5,
    description: 'Tumor maligno del colon ascendente',
    code_4: 'C18',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C183',
    level: 5,
    description: 'Tumor maligno del \u00e1ngulo hep\u00e1tico',
    code_4: 'C18',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C184',
    level: 5,
    description: 'Tumor maligno del colon transverso',
    code_4: 'C18',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C185',
    level: 5,
    description: 'Tumor maligno del \u00e1ngulo espl\u00e9nico',
    code_4: 'C18',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C186',
    level: 5,
    description: 'Tumor maligno del colon descendente',
    code_4: 'C18',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C187',
    level: 5,
    description: 'Tumor maligno del colon sigmoide',
    code_4: 'C18',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C188',
    level: 5,
    description: 'Lesi\u00f3n de sitios contiguos del colon',
    code_4: 'C18',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C189',
    level: 5,
    description: 'Tumor maligno del colon, parte no especificada',
    code_4: 'C18',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C15-C26'
  },
  {
    code: 'C399',
    level: 5,
    description:
      'Tumor maligno de sitios mal definidos del sistema respiratorio',
    code_4: 'C39',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C30-C39'
  },
  {
    code: 'O753',
    level: 3,
    description: 'Otras infecciones durante el trabajo de parto',
    code_2: 'O75',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O754',
    level: 3,
    description:
      'Otras complicaciones de la cirug\u00eda y de otros procedimientos obst\u00e9tricos',
    code_2: 'O75',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O755',
    level: 3,
    description:
      'Retraso del parto despu\u00e9s de la ruptura artificial de las membranas',
    code_2: 'O75',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O756',
    level: 3,
    description:
      'Retraso del parto despu\u00e9s de la ruptura espont\u00e1nea o no especificada de las membranas',
    code_2: 'O75',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O757',
    level: 3,
    description: 'Parto vaginal posterior a una ces\u00e1rea previa',
    code_2: 'O75',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O758',
    level: 3,
    description:
      'Otras complicaciones especificadas del trabajo de parto y del parto',
    code_2: 'O75',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O759',
    level: 3,
    description:
      'Complicaci\u00f3n no especificada del trabajo de parto y del parto',
    code_2: 'O75',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O743',
    level: 3,
    description:
      'Complicaciones del sistema nervioso central por la anestesia administrada durante el trabajo de parto y el parto',
    code_2: 'O74',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O744',
    level: 3,
    description:
      'Reacci\u00f3n t\u00f3xica a la anestesia local administrada durante el trabajo de parto y el parto',
    code_2: 'O74',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O745',
    level: 3,
    description:
      'Cefalalgia inducida por la anestesia espinal o epidural administradas durante el trabajo de parto y el parto',
    code_2: 'O74',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O746',
    level: 3,
    description:
      'Otras complicaciones de la anestesia espinal o epidural administradas durante el trabajo de parto y el parto',
    code_2: 'O74',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O747',
    level: 3,
    description:
      'Falla o dificultad en la intubaci\u00f3n durante el trabajo de parto y el parto',
    code_2: 'O74',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O748',
    level: 3,
    description:
      'Otras complicaciones de la anestesia administrada durante el trabajo de parto y el parto',
    code_2: 'O74',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O749',
    level: 3,
    description:
      'Complicaci\u00f3n no especificada de la anestesia administrada durante el trabajo de parto y el parto',
    code_2: 'O74',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O715',
    level: 3,
    description:
      'Otros traumatismos obst\u00e9tricos de los \u00f3rganos pelvianos',
    code_2: 'O71',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O716',
    level: 3,
    description:
      'Traumatismo obst\u00e9trico de los ligamentos y articulaciones de la pelvis',
    code_2: 'O71',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O717',
    level: 3,
    description: 'Hematoma obst\u00e9trico de la pelvis',
    code_2: 'O71',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O718',
    level: 3,
    description: 'Otros traumas obst\u00e9tricos especificados',
    code_2: 'O71',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'O719',
    level: 3,
    description: 'Trauma obst\u00e9trico, no especificado',
    code_2: 'O71',
    code_0: 'O00-O9A',
    code_1: 'O60-O75'
  },
  {
    code: 'C446',
    level: 5,
    description:
      'Tumor maligno de la piel del miembro superior, incluido el hombro',
    code_4: 'C44',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C43-C44'
  },
  {
    code: 'C447',
    level: 5,
    description:
      'Tumor maligno de la piel del miembro inferior, incluida la cadera',
    code_4: 'C44',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C43-C44'
  },
  {
    code: 'C448',
    level: 5,
    description: 'Lesi\u00f3n de sitios contiguos de la piel',
    code_4: 'C44',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C43-C44'
  },
  {
    code: 'C449',
    level: 5,
    description: 'Tumor maligno de la piel, sitio no especificado',
    code_4: 'C44',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C43-C44'
  },
  {
    code: 'C434',
    level: 5,
    description: 'Melanoma maligno del cuero cabelludo y del cuello',
    code_4: 'C43',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C43-C44'
  },
  {
    code: 'C435',
    level: 5,
    description: 'Melanoma maligno del tronco',
    code_4: 'C43',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C43-C44'
  },
  {
    code: 'C436',
    level: 5,
    description: 'Melanoma maligno del miembro superior, incluido el hombro',
    code_4: 'C43',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C43-C44'
  },
  {
    code: 'C437',
    level: 5,
    description: 'Melanoma maligno del miembro inferior, incluida la cadera',
    code_4: 'C43',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C43-C44'
  },
  {
    code: 'C438',
    level: 5,
    description: 'Melanoma maligno de sitios contiguos de la piel',
    code_4: 'C43',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C43-C44'
  },
  {
    code: 'C439',
    level: 5,
    description: 'Melanoma maligno de piel, sitio no especificado',
    code_4: 'C43',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C43-C44'
  },
  {
    code: 'C467',
    level: 5,
    description: 'Sarcoma de Kaposi de otros sitios especificados',
    code_4: 'C46',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C45-C49'
  },
  {
    code: 'C468',
    level: 5,
    description: 'Sarcoma de Kaposi de m\u00faltiples \u00f3rganos',
    code_4: 'C46',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C45-C49'
  },
  {
    code: 'C469',
    level: 5,
    description: 'Sarcoma de Kaposi, de sitio no especificado',
    code_4: 'C46',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C45-C49'
  },
  {
    code: 'Y510',
    level: 4,
    description: 'Efectos adversos de agentes anticolinesterasa',
    code_3: 'Y51',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y511',
    level: 4,
    description:
      'Efectos adversos de otros parasimpaticomim\u00e9ticos [colin\u00e9rgicos]',
    code_3: 'Y51',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y512',
    level: 4,
    description:
      'Efectos adversos de drogas bloqueadoras ganglionares, no clasificadas en otra parte',
    code_3: 'Y51',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y513',
    level: 4,
    description:
      'Efectos adversos de otros parasimpaticol\u00edticos [anticolin\u00e9rgicos y antimuscar\u00ednicos] y espasmol\u00edticos, no clasificados en otra parte',
    code_3: 'Y51',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y514',
    level: 4,
    description:
      'Efectos adversos de agonistas [estimulantes] predominantemente alfa-adren\u00e9rgicos, no clasificados en otra parte',
    code_3: 'Y51',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y515',
    level: 4,
    description:
      'Efectos adversos de agonistas [estimulantes] predominantemente beta-adren\u00e9rgicos, no clasificados en otra parte',
    code_3: 'Y51',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y516',
    level: 4,
    description:
      'Efectos adversos de antagonistas [bloqueadores] alfa-adren\u00e9rgicos, no clasificados en otra parte',
    code_3: 'Y51',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y517',
    level: 4,
    description:
      'Efectos adversos de antagonistas [bloqueadores] beta-adren\u00e9rgicos, no clasificados en otra parte',
    code_3: 'Y51',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y500',
    level: 4,
    description: 'Efectos adversos de anal\u00e9pticos',
    code_3: 'Y50',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y501',
    level: 4,
    description: 'Efectos adversos de antagonistas de opi\u00e1ceos',
    code_3: 'Y50',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y502',
    level: 4,
    description:
      'Efectos adversos de metilxantinas, no clasificadas en otra parte',
    code_3: 'Y50',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y508',
    level: 4,
    description:
      'Efectos adversos de otros estimulantes del sistema nervioso central',
    code_3: 'Y50',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y509',
    level: 4,
    description:
      'Efectos adversos de estimulante no especificado del sistema nervioso central',
    code_3: 'Y50',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y490',
    level: 4,
    description:
      'Efectos adversos de antidepresivos tric\u00edclicos y tetrac\u00edclicos',
    code_3: 'Y49',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y491',
    level: 4,
    description:
      'Efectos adversos de antidepresivos inhibidores de la monoaminooxidasa',
    code_3: 'Y49',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y492',
    level: 4,
    description:
      'Efectos adversos de otros antidepresivos, y los no especificados',
    code_3: 'Y49',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y493',
    level: 4,
    description:
      'Efectos adversos de antipsic\u00f3ticos y neurol\u00e9pticos fenotiaz\u00ednicos',
    code_3: 'Y49',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y494',
    level: 4,
    description:
      'Efectos adversos de neurol\u00e9pticos de la butirofenona y tioxantina',
    code_3: 'Y49',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y495',
    level: 4,
    description:
      'Efectos adversos de otros antipsic\u00f3ticos y neurol\u00e9pticos',
    code_3: 'Y49',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y496',
    level: 4,
    description:
      'Efectos adversos de psicodisl\u00e9pticos [alucin\u00f3genos]',
    code_3: 'Y49',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y497',
    level: 4,
    description: 'Efectos adversos de psicoestimulantes con abuso potencial',
    code_3: 'Y49',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y498',
    level: 4,
    description:
      'Efectos adversos de otras drogas psicotr\u00f3picas, no clasificadas en otra parte',
    code_3: 'Y49',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y499',
    level: 4,
    description:
      'Efectos adversos de drogas psicotr\u00f3picas no especificadas',
    code_3: 'Y49',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y480',
    level: 4,
    description:
      'Efectos adversos de gases anest\u00e9sicos por inhalaci\u00f3n',
    code_3: 'Y48',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y481',
    level: 4,
    description: 'Efectos adversos de gases anest\u00e9sicos parenterales',
    code_3: 'Y48',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y482',
    level: 4,
    description:
      'Efectos adversos de otros gases anest\u00e9sicos generales, y los no especificados',
    code_3: 'Y48',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y483',
    level: 4,
    description: 'Efectos adversos de gases anest\u00e9sicos locales',
    code_3: 'Y48',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y484',
    level: 4,
    description: 'Efectos adversos de anest\u00e9sicos no especificados',
    code_3: 'Y48',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y485',
    level: 4,
    description: 'Efectos adversos de gases terap\u00e9uticos',
    code_3: 'Y48',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y470',
    level: 4,
    description:
      'Efectos adversos de barbit\u00faricos, no clasificados en otra parte',
    code_3: 'Y47',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y471',
    level: 4,
    description: 'Efectos adversos de benzodiazepinas',
    code_3: 'Y47',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y472',
    level: 4,
    description: 'Efectos adversos de derivados clorales',
    code_3: 'Y47',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y473',
    level: 4,
    description: 'Efectos adversos de paraldeh\u00eddo',
    code_3: 'Y47',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y474',
    level: 4,
    description: 'Efectos adversos de compuestos del bromo',
    code_3: 'Y47',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y460',
    level: 4,
    description: 'Efectos adversos de succinamidas',
    code_3: 'Y46',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y461',
    level: 4,
    description: 'Efectos adversos de oxazolidinadionas',
    code_3: 'Y46',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y462',
    level: 4,
    description: 'Efectos adversos de derivados de la hidanto\u00edna',
    code_3: 'Y46',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y463',
    level: 4,
    description: 'Efectos adversos de desoxibarbit\u00faricos',
    code_3: 'Y46',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y464',
    level: 4,
    description: 'Efectos adversos de iminoestilbenos',
    code_3: 'Y46',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y465',
    level: 4,
    description: 'Efectos adversos del \u00e1cido valproico',
    code_3: 'Y46',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y466',
    level: 4,
    description:
      'Efectos adversos de otros antiepil\u00e9pticos, y los no especificados',
    code_3: 'Y46',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y467',
    level: 4,
    description: 'Efectos adversos de drogas antiparkinsonianas',
    code_3: 'Y46',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y468',
    level: 4,
    description: 'Efectos adversos de drogas antiesp\u00e1sticas',
    code_3: 'Y46',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y450',
    level: 4,
    description:
      'Efectos adversos de opi\u00e1ceos y analg\u00e9sicos relacionados',
    code_3: 'Y45',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y451',
    level: 4,
    description: 'Efectos adversos de salicilatos',
    code_3: 'Y45',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y452',
    level: 4,
    description: 'Efectos adversos de derivados del \u00e1cido propi\u00f3nico',
    code_3: 'Y45',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y453',
    level: 4,
    description:
      'Efectos adversos de otras drogas antiinflamatorias no esteroides [DAINE]',
    code_3: 'Y45',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y454',
    level: 4,
    description: 'Efectos adversos de los antirreum\u00e1ticos',
    code_3: 'Y45',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y455',
    level: 4,
    description: 'Efectos adversos de los derivados del 4\u2013aminofenol',
    code_3: 'Y45',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y458',
    level: 4,
    description:
      'Efectos adversos de otros analg\u00e9sicos y antipir\u00e9ticos',
    code_3: 'Y45',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y459',
    level: 4,
    description:
      'Efectos adversos de drogas analg\u00e9sicas, antipir\u00e9ticas y antiinflamatorias no especificadas',
    code_3: 'Y45',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y440',
    level: 4,
    description:
      'Efectos adversos de preparaciones con hierro y otros preparados contra la anemia hipocr\u00f3mica',
    code_3: 'Y44',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y441',
    level: 4,
    description:
      'Efectos adversos de vitamina B12, \u00e1cido f\u00f3lico y otros preparados contra la anemia megalobl\u00e1stica',
    code_3: 'Y44',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y442',
    level: 4,
    description: 'Efectos adversos de anticoagulantes',
    code_3: 'Y44',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y443',
    level: 4,
    description:
      'Efectos adversos de antagonistas de anticoagulantes, vitamina K y otros coagulantes',
    code_3: 'Y44',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y444',
    level: 4,
    description:
      'Efectos adversos de drogas antitromb\u00f3ticas [inhibidoras de la agregaci\u00f3n plaquetaria]',
    code_3: 'Y44',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y445',
    level: 4,
    description: 'Efectos adversos de drogas trombol\u00edticas',
    code_3: 'Y44',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y446',
    level: 4,
    description:
      'Efectos adversos de sangre natural y productos sangu\u00edneos',
    code_3: 'Y44',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y447',
    level: 4,
    description: 'Efectos adversos de los sustitutos del plasma',
    code_3: 'Y44',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y449',
    level: 4,
    description:
      'Efectos adversos de otros agentes que afectan los constituyentes de la sangre, y los no especificados',
    code_3: 'Y44',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y430',
    level: 4,
    description: 'Efectos adversos de antial\u00e9rgicos y antiem\u00e9ticos',
    code_3: 'Y43',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y431',
    level: 4,
    description: 'Efectos adversos de antimetabolitos antineopl\u00e1sicos',
    code_3: 'Y43',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y432',
    level: 4,
    description: 'Efectos adversos de productos naturales antineopl\u00e1sicos',
    code_3: 'Y43',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y433',
    level: 4,
    description: 'Efectos adversos de otras drogas antineopl\u00e1sicas',
    code_3: 'Y43',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y434',
    level: 4,
    description: 'Efectos adversos de agentes inmunosupresores',
    code_3: 'Y43',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y420',
    level: 4,
    description:
      'Efectos adversos de glucocorticoides y an\u00e1logos sint\u00e9ticos',
    code_3: 'Y42',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y421',
    level: 4,
    description: 'Efectos adversos de hormonas tiroideas y sustitutos',
    code_3: 'Y42',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y422',
    level: 4,
    description: 'Efectos adversos de drogas antitiroideas',
    code_3: 'Y42',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y423',
    level: 4,
    description:
      'Efectos adversos de drogas hipoglucemiantes orales e insulina [antidiab\u00e9ticas]',
    code_3: 'Y42',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y424',
    level: 4,
    description: 'Efectos adversos de anticonceptivos orales',
    code_3: 'Y42',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y425',
    level: 4,
    description:
      'Efectos adversos de otros estr\u00f3genos y progest\u00e1genos',
    code_3: 'Y42',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y410',
    level: 4,
    description: 'Efectos adversos de sulfonamidas',
    code_3: 'Y41',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y411',
    level: 4,
    description: 'Efectos adversos de drogas antimicobacterianas',
    code_3: 'Y41',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y412',
    level: 4,
    description:
      'Efectos adversos de drogas antipal\u00fadicas y agentes que act\u00faan sobre otros protozoarios de la sangre',
    code_3: 'Y41',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y413',
    level: 4,
    description: 'Efectos adversos de otras drogas antiprotozoarias',
    code_3: 'Y41',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y414',
    level: 4,
    description: 'Efectos adversos de antihelm\u00ednticos',
    code_3: 'Y41',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y415',
    level: 4,
    description: 'Efectos adversos de drogas antivirales',
    code_3: 'Y41',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y418',
    level: 4,
    description:
      'Efectos adversos de otros antiinfecciosos y antiparasitarios sist\u00e9micos especificados',
    code_3: 'Y41',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y419',
    level: 4,
    description:
      'Efectos adversos de antiinfecciosos y antiparasitarios sist\u00e9micos no especificados',
    code_3: 'Y41',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y650',
    level: 4,
    description: 'Sangre incompatible usada en transfusi\u00f3n',
    code_3: 'Y65',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y651',
    level: 4,
    description: 'L\u00edquido err\u00f3neo usado en infusi\u00f3n',
    code_3: 'Y65',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y652',
    level: 4,
    description:
      'Falla en la sutura o ligadura durante operaci\u00f3n quir\u00fargica',
    code_3: 'Y65',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y653',
    level: 4,
    description:
      'Tubo endotraqueal colocado err\u00f3neamente durante procedimiento anest\u00e9sico',
    code_3: 'Y65',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y654',
    level: 4,
    description:
      'Falla en la introducci\u00f3n o remoci\u00f3n de otro tubo o instrumento',
    code_3: 'Y65',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y655',
    level: 4,
    description: 'Realizaci\u00f3n de una operaci\u00f3n inadecuada',
    code_3: 'Y65',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y658',
    level: 4,
    description:
      'Otros incidentes especificados durante la atenci\u00f3n m\u00e9dica y quir\u00fargica',
    code_3: 'Y65',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y640',
    level: 4,
    description:
      'Medicamento o sustancia biol\u00f3gica contaminado en infusi\u00f3n o transfusi\u00f3n',
    code_3: 'Y64',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y641',
    level: 4,
    description:
      'Medicamento o sustancia biol\u00f3gica contaminado, inyectado o usado para inmunizaci\u00f3n',
    code_3: 'Y64',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y648',
    level: 4,
    description:
      'Medicamento o sustancia biol\u00f3gica contaminado, administrado por otros medios',
    code_3: 'Y64',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y649',
    level: 4,
    description:
      'Medicamento o sustancia biol\u00f3gica contaminado, administrado por medios no especificados',
    code_3: 'Y64',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y630',
    level: 4,
    description:
      'Excesiva cantidad de sangre u otro l\u00edquido administrado durante una infusi\u00f3n o transfusi\u00f3n',
    code_3: 'Y63',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y631',
    level: 4,
    description:
      'Diluci\u00f3n incorrecta de l\u00edquido durante una infusi\u00f3n',
    code_3: 'Y63',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y632',
    level: 4,
    description: 'Sobredosis de radiaci\u00f3n administrada durante terapia',
    code_3: 'Y63',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y633',
    level: 4,
    description:
      'Exposici\u00f3n inadvertida del paciente a radiaci\u00f3n durante la atenci\u00f3n m\u00e9dica',
    code_3: 'Y63',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y634',
    level: 4,
    description:
      'Falla en la dosificaci\u00f3n en electrochoque o en choque insul\u00ednico',
    code_3: 'Y63',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y635',
    level: 4,
    description:
      'Falla en el control de la temperatura, en taponamientos y aplicaciones locales',
    code_3: 'Y63',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y636',
    level: 4,
    description:
      'No administraci\u00f3n de drogas, medicamentos o sustancias biol\u00f3gicas necesarias',
    code_3: 'Y63',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y638',
    level: 4,
    description:
      'Falla en la dosificaci\u00f3n durante otras atenciones m\u00e9dicas y quir\u00fargicas',
    code_3: 'Y63',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y639',
    level: 4,
    description:
      'Falla en la dosificaci\u00f3n durante atenci\u00f3n m\u00e9dica y quir\u00fargica no especificada',
    code_3: 'Y63',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y620',
    level: 4,
    description:
      'Fallas en la esterilizaci\u00f3n durante operaci\u00f3n quir\u00fargica',
    code_3: 'Y62',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y621',
    level: 4,
    description:
      'Fallas en la esterilizaci\u00f3n durante infusi\u00f3n o transfusi\u00f3n',
    code_3: 'Y62',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y622',
    level: 4,
    description:
      'Fallas en la esterilizaci\u00f3n durante di\u00e1lisis renal u otra perfusi\u00f3n',
    code_3: 'Y62',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y623',
    level: 4,
    description:
      'Fallas en la esterilizaci\u00f3n durante inyecci\u00f3n o inmunizaci\u00f3n',
    code_3: 'Y62',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y624',
    level: 4,
    description:
      'Fallas en la esterilizaci\u00f3n durante examen endosc\u00f3pico',
    code_3: 'Y62',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y625',
    level: 4,
    description:
      'Fallas en la esterilizaci\u00f3n durante cateterizaci\u00f3n card\u00edaca',
    code_3: 'Y62',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y626',
    level: 4,
    description:
      'Fallas en la esterilizaci\u00f3n durante aspiraci\u00f3n, punci\u00f3n y otra cateterizaci\u00f3n',
    code_3: 'Y62',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y628',
    level: 4,
    description:
      'Fallas en la esterilizaci\u00f3n durante otras atenciones m\u00e9dicas y quir\u00fargicas',
    code_3: 'Y62',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y629',
    level: 4,
    description:
      'Fallas en la esterilizaci\u00f3n durante atenci\u00f3n m\u00e9dica y quir\u00fargica no especificada',
    code_3: 'Y62',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'V090',
    level: 4,
    description:
      'Peat\u00f3n lesionado en accidente no de tr\u00e1nsito que involucra otros veh\u00edculos de motor, y los no especificados',
    code_3: 'V09',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V01-V09'
  },
  {
    code: 'V091',
    level: 4,
    description:
      'Peat\u00f3n lesionado en accidente no de tr\u00e1nsito no especificado',
    code_3: 'V09',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V01-V09'
  },
  {
    code: 'V092',
    level: 4,
    description:
      'Peat\u00f3n lesionado en accidente de tr\u00e1nsito que involucra otros veh\u00edculos de motor, y los no especificados',
    code_3: 'V09',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V01-V09'
  },
  {
    code: 'V093',
    level: 4,
    description:
      'Peat\u00f3n lesionado en accidente de tr\u00e1nsito no especificado',
    code_3: 'V09',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V01-V09'
  },
  {
    code: 'V099',
    level: 4,
    description:
      'Peat\u00f3n lesionado en accidente de transporte no especificado',
    code_3: 'V09',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V01-V09'
  },
  {
    code: 'V190',
    level: 4,
    description:
      'Conductor de veh\u00edculo de pedal lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente no de tr\u00e1nsito',
    code_3: 'V19',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V10-V19'
  },
  {
    code: 'V191',
    level: 4,
    description:
      'Pasajero de veh\u00edculo de pedal lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente no de tr\u00e1nsito',
    code_3: 'V19',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V10-V19'
  },
  {
    code: 'V192',
    level: 4,
    description:
      'Ciclista no especificado lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente no de tr\u00e1nsito',
    code_3: 'V19',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V10-V19'
  },
  {
    code: 'V193',
    level: 4,
    description:
      'Ciclista [cualquiera] lesionado en accidente no de tr\u00e1nsito, no especificado',
    code_3: 'V19',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V10-V19'
  },
  {
    code: 'V194',
    level: 4,
    description:
      'Conductor de veh\u00edculo de pedal lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente de tr\u00e1nsito',
    code_3: 'V19',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V10-V19'
  },
  {
    code: 'V195',
    level: 4,
    description:
      'Pasajero de veh\u00edculo de pedal lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente de tr\u00e1nsito',
    code_3: 'V19',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V10-V19'
  },
  {
    code: 'V196',
    level: 4,
    description:
      'Ciclista no especificado lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente de tr\u00e1nsito',
    code_3: 'V19',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V10-V19'
  },
  {
    code: 'V290',
    level: 4,
    description:
      'Conductor de motocicleta lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente no de tr\u00e1nsito',
    code_3: 'V29',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V20-V29'
  },
  {
    code: 'V291',
    level: 4,
    description:
      'Pasajero de motocicleta lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente no de tr\u00e1nsito',
    code_3: 'V29',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V20-V29'
  },
  {
    code: 'V292',
    level: 4,
    description:
      'Motociclista no especificado lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente no de tr\u00e1nsito',
    code_3: 'V29',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V20-V29'
  },
  {
    code: 'Y405',
    level: 4,
    description: 'Efectos adversos de aminogluc\u00f3sidos',
    code_3: 'Y40',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y406',
    level: 4,
    description: 'Efectos adversos de rifamicinas',
    code_3: 'Y40',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y407',
    level: 4,
    description:
      'Efectos adversos de antibi\u00f3ticos antimic\u00f3ticos usados sist\u00e9micamente',
    code_3: 'Y40',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y408',
    level: 4,
    description: 'Efectos adversos de otros antibi\u00f3ticos sist\u00e9micos',
    code_3: 'Y40',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y409',
    level: 4,
    description:
      'Efectos adversos de antibi\u00f3tico sist\u00e9mico no especificado',
    code_3: 'Y40',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y616',
    level: 4,
    description:
      'Objeto extra\u00f1o dejado accidentalmente en el cuerpo durante aspiraci\u00f3n, punci\u00f3n y otra cateterizaci\u00f3n',
    code_3: 'Y61',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y617',
    level: 4,
    description:
      'Objeto extra\u00f1o dejado accidentalmente en el cuerpo durante remoci\u00f3n de cat\u00e9ter o taponamiento',
    code_3: 'Y61',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y618',
    level: 4,
    description:
      'Objeto extra\u00f1o dejado accidentalmente en el cuerpo durante otras atenciones m\u00e9dicas y quir\u00fargicas',
    code_3: 'Y61',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y619',
    level: 4,
    description:
      'Objeto extra\u00f1o dejado accidentalmente en el cuerpo durante atenci\u00f3n m\u00e9dica y quir\u00fargica no especificada',
    code_3: 'Y61',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y607',
    level: 4,
    description: 'Incidente durante administraci\u00f3n de enema',
    code_3: 'Y60',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y608',
    level: 4,
    description:
      'Incidente durante otras atenciones m\u00e9dicas y quir\u00fargicas',
    code_3: 'Y60',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'Y609',
    level: 4,
    description:
      'Incidente durante atenci\u00f3n m\u00e9dica y quir\u00fargica no especificada',
    code_3: 'Y60',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y60-Y69'
  },
  {
    code: 'W10',
    level: 3,
    description: 'Ca\u00edda en o desde escalera y escalones',
    code_2: 'W00-X59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'W11',
    level: 3,
    description: 'Ca\u00edda en o desde escaleras manuales',
    code_2: 'W00-X59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'W12',
    level: 3,
    description: 'Ca\u00edda en o desde andamio',
    code_2: 'W00-X59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'W13',
    level: 3,
    description:
      'Ca\u00edda desde, fuera o a trav\u00e9s de un edificio u otra construcci\u00f3n',
    code_2: 'W00-X59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'W14',
    level: 3,
    description: 'Ca\u00edda desde un \u00e1rbol',
    code_2: 'W00-X59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V840',
    level: 4,
    description:
      'Conductor de veh\u00edculo agr\u00edcola especial lesionado en accidente de tr\u00e1nsito',
    code_3: 'V84',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V841',
    level: 4,
    description:
      'Pasajero de veh\u00edculo agr\u00edcola especial lesionado en accidente de tr\u00e1nsito',
    code_3: 'V84',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V842',
    level: 4,
    description:
      'Persona que viaja fuera del veh\u00edculo agr\u00edcola especial lesionada en accidente de tr\u00e1nsito',
    code_3: 'V84',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V843',
    level: 4,
    description:
      'Ocupante no especificado de veh\u00edculo agr\u00edcola especial lesionado en accidente de tr\u00e1nsito',
    code_3: 'V84',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V844',
    level: 4,
    description:
      'Persona lesionada al subir o bajar del veh\u00edculo agr\u00edcola especial',
    code_3: 'V84',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V845',
    level: 4,
    description:
      'Conductor de veh\u00edculo agr\u00edcola especial lesionado en accidente no de tr\u00e1nsito',
    code_3: 'V84',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V846',
    level: 4,
    description:
      'Pasajero de veh\u00edculo agr\u00edcola especial lesionado en accidente no de tr\u00e1nsito',
    code_3: 'V84',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V847',
    level: 4,
    description:
      'Persona que viaja fuera del veh\u00edculo agr\u00edcola especial lesionada en accidente no de tr\u00e1nsito',
    code_3: 'V84',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V830',
    level: 4,
    description:
      'Conductor de veh\u00edculo industrial especial lesionado en accidente de tr\u00e1nsito',
    code_3: 'V83',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V831',
    level: 4,
    description:
      'Pasajero de veh\u00edculo industrial especial lesionado en accidente de tr\u00e1nsito',
    code_3: 'V83',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V832',
    level: 4,
    description:
      'Persona que viaja fuera de veh\u00edculo industrial especial lesionada en accidente de tr\u00e1nsito',
    code_3: 'V83',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V833',
    level: 4,
    description:
      'Ocupante no especificado de veh\u00edculo industrial especial lesionado en accidente de tr\u00e1nsito',
    code_3: 'V83',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V834',
    level: 4,
    description:
      'Persona lesionada al subir o bajar del veh\u00edculo industrial especial',
    code_3: 'V83',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V835',
    level: 4,
    description:
      'Conductor de veh\u00edculo industrial especial lesionado en accidente no de tr\u00e1nsito',
    code_3: 'V83',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V836',
    level: 4,
    description:
      'Pasajero de veh\u00edculo industrial especial lesionado en accidente no de tr\u00e1nsito',
    code_3: 'V83',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V837',
    level: 4,
    description:
      'Persona que viaja fuera del veh\u00edculo industrial especial lesionada en accidente no de tr\u00e1nsito',
    code_3: 'V83',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V839',
    level: 4,
    description:
      'Ocupante no especificado del veh\u00edculo industrial especial lesionado en accidente no de tr\u00e1nsito',
    code_3: 'V83',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V820',
    level: 4,
    description:
      'Ocupante de tranv\u00eda lesionado por colisi\u00f3n con veh\u00edculo de motor, en accidente no de tr\u00e1nsito',
    code_3: 'V82',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V821',
    level: 4,
    description:
      'Ocupante de tranv\u00eda lesionado por colisi\u00f3n con veh\u00edculo de motor, en accidente de tr\u00e1nsito',
    code_3: 'V82',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V822',
    level: 4,
    description:
      'Ocupante de tranv\u00eda lesionado por colisi\u00f3n con, o golpeado por vag\u00f3n',
    code_3: 'V82',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V823',
    level: 4,
    description:
      'Ocupante de tranv\u00eda lesionado por colisi\u00f3n con otros objetos',
    code_3: 'V82',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V824',
    level: 4,
    description: 'Persona lesionada al subir o bajar del tranv\u00eda',
    code_3: 'V82',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V825',
    level: 4,
    description:
      'Ocupante de tranv\u00eda lesionado por ca\u00edda dentro del tranv\u00eda',
    code_3: 'V82',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V826',
    level: 4,
    description:
      'Ocupante de tranv\u00eda lesionado por ca\u00edda desde el tranv\u00eda',
    code_3: 'V82',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V827',
    level: 4,
    description:
      'Ocupante de tranv\u00eda lesionado por descarrilamiento, sin colisi\u00f3n anterior',
    code_3: 'V82',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V828',
    level: 4,
    description:
      'Ocupante de tranv\u00eda lesionado en otros accidentes de transporte, especificados',
    code_3: 'V82',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V829',
    level: 4,
    description:
      'Ocupante de tranv\u00eda lesionado en accidente de tr\u00e1nsito no especificado',
    code_3: 'V82',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V810',
    level: 4,
    description:
      'Ocupante de tren o veh\u00edculo de rieles lesionado por colisi\u00f3n con veh\u00edculo de motor, en accidente no de tr\u00e1nsito',
    code_3: 'V81',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V811',
    level: 4,
    description:
      'Ocupante de tren o veh\u00edculo de rieles lesionado por colisi\u00f3n con veh\u00edculo de motor, en accidente de tr\u00e1nsito',
    code_3: 'V81',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V812',
    level: 4,
    description:
      'Ocupante de tren o veh\u00edculo de rieles lesionado por colisi\u00f3n con, o golpeado por vag\u00f3n',
    code_3: 'V81',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V813',
    level: 4,
    description:
      'Ocupante de tren o veh\u00edculo de rieles lesionado por colisi\u00f3n con otros objetos',
    code_3: 'V81',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V814',
    level: 4,
    description:
      'Persona lesionada al subir o bajar del tren o veh\u00edculo de rieles',
    code_3: 'V81',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V815',
    level: 4,
    description:
      'Ocupante de tren o veh\u00edculo de rieles lesionado por ca\u00edda dentro del tren o veh\u00edculo de rieles',
    code_3: 'V81',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V816',
    level: 4,
    description:
      'Ocupante de tren o veh\u00edculo de rieles lesionado por ca\u00edda desde el tren o veh\u00edculo de rieles',
    code_3: 'V81',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V817',
    level: 4,
    description:
      'Ocupante de tren o veh\u00edculo de rieles lesionado en descarrilamiento sin colisi\u00f3n anterior',
    code_3: 'V81',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V818',
    level: 4,
    description:
      'Ocupante de tren o veh\u00edculo de rieles lesionado en otros accidentes ferroviarios especificados',
    code_3: 'V81',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V819',
    level: 4,
    description:
      'Ocupante de tren o veh\u00edculo de rieles lesionado en accidente ferroviario no especificado',
    code_3: 'V81',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V800',
    level: 4,
    description:
      'Jinete u ocupante de veh\u00edculo de tracci\u00f3n animal lesionado por ca\u00edda (o por ser despedido) del animal o del veh\u00edculo de tracci\u00f3n animal, en accidente sin colisi\u00f3n',
    code_3: 'V80',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V801',
    level: 4,
    description:
      'Jinete u ocupante de veh\u00edculo de tracci\u00f3n animal lesionado por colisi\u00f3n con peat\u00f3n o animal',
    code_3: 'V80',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V802',
    level: 4,
    description:
      'Jinete u ocupante de veh\u00edculo de tracci\u00f3n animal lesionado por colisi\u00f3n con veh\u00edculo de pedal',
    code_3: 'V80',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V803',
    level: 4,
    description:
      'Jinete u ocupante de veh\u00edculo de tracci\u00f3n animal lesionado por colisi\u00f3n con veh\u00edculo de motor de dos o tres ruedas',
    code_3: 'V80',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V804',
    level: 4,
    description:
      'Jinete u ocupante de veh\u00edculo de tracci\u00f3n animal lesionado por colisi\u00f3n con autom\u00f3vil, camioneta o furgoneta, veh\u00edculo de transporte pesado, o autob\u00fas',
    code_3: 'V80',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V805',
    level: 4,
    description:
      'Jinete u ocupante de veh\u00edculo de tracci\u00f3n animal lesionado por colisi\u00f3n con otros veh\u00edculos de motor especificados',
    code_3: 'V80',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V806',
    level: 4,
    description:
      'Jinete u ocupante de veh\u00edculo de tracci\u00f3n animal lesionado por colisi\u00f3n con tren o veh\u00edculo de rieles',
    code_3: 'V80',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V807',
    level: 4,
    description:
      'Jinete u ocupante de veh\u00edculo de tracci\u00f3n animal lesionado por colisi\u00f3n con otros veh\u00edculos sin motor',
    code_3: 'V80',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V808',
    level: 4,
    description:
      'Jinete u ocupante de veh\u00edculo de tracci\u00f3n animal lesionado por colisi\u00f3n con objeto fijo o estacionado',
    code_3: 'V80',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V809',
    level: 4,
    description:
      'Jinete u ocupante de veh\u00edculo de tracci\u00f3n animal lesionado en otros accidentes de transporte, y en los no especificados',
    code_3: 'V80',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V970',
    level: 4,
    description:
      'Ocupante de aeronave lesionado en otros accidentes especificados de transporte a\u00e9reo',
    code_3: 'V97',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V95-V97'
  },
  {
    code: 'V971',
    level: 4,
    description: 'Persona lesionada al subir o bajar de una aeronave',
    code_3: 'V97',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V95-V97'
  },
  {
    code: 'V972',
    level: 4,
    description: 'Paracaidista lesionado en accidente de transporte a\u00e9reo',
    code_3: 'V97',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V95-V97'
  },
  {
    code: 'V973',
    level: 4,
    description:
      'Persona en tierra lesionada por accidente de transporte a\u00e9reo',
    code_3: 'V97',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V95-V97'
  },
  {
    code: 'V978',
    level: 4,
    description:
      'Otros accidentes de transporte a\u00e9reo, no clasificados en otra parte',
    code_3: 'V97',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V95-V97'
  },
  {
    code: 'V960',
    level: 4,
    description: 'Accidente de globo aerost\u00e1tico, con ocupante lesionado',
    code_3: 'V96',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V95-V97'
  },
  {
    code: 'V961',
    level: 4,
    description: 'Accidente de ala delta, con ocupante lesionado',
    code_3: 'V96',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V95-V97'
  },
  {
    code: 'V962',
    level: 4,
    description: 'Accidente de planeador (sin motor), con ocupante lesionado',
    code_3: 'V96',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V95-V97'
  },
  {
    code: 'V968',
    level: 4,
    description:
      'Accidente de otras aeronaves sin motor, con ocupante lesionado',
    code_3: 'V96',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V95-V97'
  },
  {
    code: 'V969',
    level: 4,
    description:
      'Accidente de aeronave sin motor no especificada, con ocupante lesionado',
    code_3: 'V96',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V95-V97'
  },
  {
    code: 'V950',
    level: 4,
    description: 'Accidente de helic\u00f3ptero con ocupante lesionado',
    code_3: 'V95',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V95-V97'
  },
  {
    code: 'V951',
    level: 4,
    description:
      'Accidente de planeador ultra liviano, micro liviano o motorizado, con ocupante lesionado',
    code_3: 'V95',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V95-V97'
  },
  {
    code: 'V952',
    level: 4,
    description:
      'Accidente de otros veh\u00edculos a\u00e9reos de alas fijas, privados, con ocupante lesionado',
    code_3: 'V95',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V95-V97'
  },
  {
    code: 'V953',
    level: 4,
    description:
      'Accidente de veh\u00edculo a\u00e9reo de alas fijas, comercial, con ocupante lesionado',
    code_3: 'V95',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V95-V97'
  },
  {
    code: 'V954',
    level: 4,
    description: 'Accidente de nave espacial, con ocupante lesionado',
    code_3: 'V95',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V95-V97'
  },
  {
    code: 'V958',
    level: 4,
    description: 'Accidente de otras aeronaves, con ocupante lesionado',
    code_3: 'V95',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V95-V97'
  },
  {
    code: 'V959',
    level: 4,
    description:
      'Accidente de aeronave no especificada, con ocupante lesionado',
    code_3: 'V95',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V95-V97'
  },
  {
    code: 'C542',
    level: 5,
    description: 'Tumor maligno del miometrio',
    code_4: 'C54',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C51-C58'
  },
  {
    code: 'C543',
    level: 5,
    description: 'Tumor maligno del fondo del \u00fatero',
    code_4: 'C54',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C51-C58'
  },
  {
    code: 'C548',
    level: 5,
    description: 'Lesi\u00f3n de sitios contiguos del cuerpo del \u00fatero',
    code_4: 'C54',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C51-C58'
  },
  {
    code: 'C549',
    level: 5,
    description:
      'Tumor maligno del cuerpo del \u00fatero, parte no especificada',
    code_4: 'C54',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C51-C58'
  },
  {
    code: 'C539',
    level: 5,
    description:
      'Tumor maligno del cuello del \u00fatero, sin otra especificaci\u00f3n',
    code_4: 'C53',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C51-C58'
  },
  {
    code: 'C519',
    level: 5,
    description: 'Tumor maligno de la vulva, parte no especificada',
    code_4: 'C51',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C51-C58'
  },
  {
    code: 'C638',
    level: 5,
    description:
      'Lesi\u00f3n de sitios contiguos de los \u00f3rganos genitales masculinos',
    code_4: 'C63',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C60-C63'
  },
  {
    code: 'C639',
    level: 5,
    description:
      'Tumor maligno de \u00f3rgano genital masculino, parte no especificada',
    code_4: 'C63',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C60-C63'
  },
  {
    code: 'C676',
    level: 5,
    description: 'Tumor maligno del orificio ureteral',
    code_4: 'C67',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C64-C68'
  },
  {
    code: 'C677',
    level: 5,
    description: 'Tumor maligno del uraco',
    code_4: 'C67',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C64-C68'
  },
  {
    code: 'C678',
    level: 5,
    description: 'Lesi\u00f3n de sitios contiguos de la vejiga',
    code_4: 'C67',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C64-C68'
  },
  {
    code: 'C679',
    level: 5,
    description: 'Tumor maligno de la vejiga urinaria, parte no especificada',
    code_4: 'C67',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C64-C68'
  },
  {
    code: 'C716',
    level: 5,
    description: 'Tumor maligno del cerebelo',
    code_4: 'C71',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C69-C72'
  },
  {
    code: 'C717',
    level: 5,
    description: 'Tumor maligno del ped\u00fanculo cerebral',
    code_4: 'C71',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C69-C72'
  },
  {
    code: 'C718',
    level: 5,
    description: 'Lesi\u00f3n de sitios contiguos del enc\u00e9falo',
    code_4: 'C71',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C69-C72'
  },
  {
    code: 'C719',
    level: 5,
    description: 'Tumor maligno del enc\u00e9falo, parte no especificada',
    code_4: 'C71',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C69-C72'
  },
  {
    code: 'C698',
    level: 5,
    description: 'Lesi\u00f3n de sitios contiguos del ojo y sus anexos',
    code_4: 'C69',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C69-C72'
  },
  {
    code: 'C699',
    level: 5,
    description: 'Tumor maligno del ojo, parte no especificada',
    code_4: 'C69',
    code_0: 'C00-D49',
    code_1: 'C00-C97',
    code_2: 'C00-C75',
    code_3: 'C69-C72'
  },
  {
    code: 'Y590',
    level: 4,
    description: 'Efectos adversos de vacunas virales',
    code_3: 'Y59',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y591',
    level: 4,
    description: 'Efectos adversos de vacunas contra rickettsias',
    code_3: 'Y59',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y592',
    level: 4,
    description: 'Efectos adversos de vacunas antiprotozoarias',
    code_3: 'Y59',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y593',
    level: 4,
    description: 'Efectos adversos de la inmunoglobulina',
    code_3: 'Y59',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y598',
    level: 4,
    description:
      'Efectos adversos de otras vacunas y sustancias biol\u00f3gicas especificadas',
    code_3: 'Y59',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y599',
    level: 4,
    description:
      'Efectos adversos de vacunas o sustancias biol\u00f3gicas no especificadas',
    code_3: 'Y59',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y580',
    level: 4,
    description: 'Efectos adversos de la vacuna BCG',
    code_3: 'Y58',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y581',
    level: 4,
    description: 'Efectos adversos de la vacuna tifoidea y paratifoidea',
    code_3: 'Y58',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y582',
    level: 4,
    description: 'Efectos adversos de la vacuna contra el c\u00f3lera',
    code_3: 'Y58',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y583',
    level: 4,
    description: 'Efectos adversos de la vacuna contra la peste',
    code_3: 'Y58',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y584',
    level: 4,
    description: 'Efectos adversos de la vacuna contra el t\u00e9tanos',
    code_3: 'Y58',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y585',
    level: 4,
    description: 'Efectos adversos de la vacuna contra la difteria',
    code_3: 'Y58',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y586',
    level: 4,
    description:
      'Efectos adversos de la vacuna contra la tos ferina, inclusive combinaciones con un componente pertusis',
    code_3: 'Y58',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y588',
    level: 4,
    description:
      'Efectos adversos de vacunas bacterianas mixtas, excepto combinaciones con un componente pertusis',
    code_3: 'Y58',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y589',
    level: 4,
    description:
      'Efectos adversos de otras vacunas bacterianas, y las no especificadas',
    code_3: 'Y58',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y570',
    level: 4,
    description: 'Efectos adversos de depresores del apetito [anor\u00e9xicos]',
    code_3: 'Y57',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y571',
    level: 4,
    description: 'Efectos adversos de drogas lipotr\u00f3picas',
    code_3: 'Y57',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y572',
    level: 4,
    description:
      'Efectos adversos de ant\u00eddotos y agentes quelantes, no clasificados en otra parte',
    code_3: 'Y57',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y573',
    level: 4,
    description: 'Efectos adversos de disuasivos del alcohol',
    code_3: 'Y57',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y574',
    level: 4,
    description: 'Efectos adversos de excipientes farmac\u00e9uticos',
    code_3: 'Y57',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y575',
    level: 4,
    description: 'Efectos adversos de medios de contraste para rayos X',
    code_3: 'Y57',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y576',
    level: 4,
    description: 'Efectos adversos de otros agentes diagn\u00f3sticos',
    code_3: 'Y57',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y577',
    level: 4,
    description: 'Efectos adversos de vitaminas, no clasificadas en otra parte',
    code_3: 'Y57',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y560',
    level: 4,
    description:
      'Efectos adversos de drogas antimic\u00f3ticas, antiinfecciosas y antiinflamatorias de uso local, no clasificadas en otra parte',
    code_3: 'Y56',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y561',
    level: 4,
    description: 'Efectos adversos de antipruriginosos',
    code_3: 'Y56',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y562',
    level: 4,
    description: 'Efectos adversos de astringentes y detergentes locales',
    code_3: 'Y56',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y563',
    level: 4,
    description: 'Efectos adversos de emolientes, demulcentes y protectores',
    code_3: 'Y56',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y564',
    level: 4,
    description:
      'Efectos adversos de drogas y preparados queratol\u00edticos, queratopl\u00e1sticos y otros para el tratamiento del cabello',
    code_3: 'Y56',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y565',
    level: 4,
    description: 'Efectos adversos de drogas y preparados oftalmol\u00f3gicos',
    code_3: 'Y56',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y566',
    level: 4,
    description:
      'Efectos adversos de drogas y preparados otorrinolaringol\u00f3gicos',
    code_3: 'Y56',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y567',
    level: 4,
    description:
      'Efectos adversos de drogas dentales, de aplicaci\u00f3n t\u00f3pica',
    code_3: 'Y56',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y550',
    level: 4,
    description: 'Efectos adversos de drogas oxit\u00f3cicas',
    code_3: 'Y55',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y551',
    level: 4,
    description:
      'Efectos adversos de relajantes de los m\u00fasculos estriados [agentes bloqueadores neuromusculares]',
    code_3: 'Y55',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y552',
    level: 4,
    description:
      'Efectos adversos de otros agentes que act\u00faan primariamente sobre los m\u00fasculos, y los no especificados',
    code_3: 'Y55',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y553',
    level: 4,
    description: 'Efectos adversos de antitus\u00edgenos',
    code_3: 'Y55',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y554',
    level: 4,
    description: 'Efectos adversos de expectorantes',
    code_3: 'Y55',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y555',
    level: 4,
    description: 'Efectos adversos de drogas contra el resfriado com\u00fan',
    code_3: 'Y55',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y556',
    level: 4,
    description:
      'Efectos adversos de antiasm\u00e1ticos, no clasificados en otra parte',
    code_3: 'Y55',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y557',
    level: 4,
    description:
      'Efectos adversos de otros agentes que act\u00faan primariamente sobre el sistema respiratorio, y los no especificados',
    code_3: 'Y55',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y540',
    level: 4,
    description: 'Efectos adversos de mineralocorticoides',
    code_3: 'Y54',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y541',
    level: 4,
    description:
      'Efectos adversos de los bloqueadores de mineralocorticoides [antagonistas de la aldosterona]',
    code_3: 'Y54',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y542',
    level: 4,
    description:
      'Efectos adversos de los inhibidores de la anhidrasa carb\u00f3nica',
    code_3: 'Y54',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y543',
    level: 4,
    description: 'Efectos adversos de los derivados de la benzotiadiazina',
    code_3: 'Y54',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y544',
    level: 4,
    description:
      'Efectos adversos de diur\u00e9ticos de asa [\u201chigh-ceiling\u201d]',
    code_3: 'Y54',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y545',
    level: 4,
    description: 'Efectos adversos de otros diur\u00e9ticos',
    code_3: 'Y54',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y546',
    level: 4,
    description:
      'Efectos adversos de agentes electrol\u00edticos, cal\u00f3ricos y del equilibrio h\u00eddrico',
    code_3: 'Y54',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y547',
    level: 4,
    description:
      'Efectos adversos de agentes que afectan la calcificaci\u00f3n',
    code_3: 'Y54',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y548',
    level: 4,
    description:
      'Efectos adversos de agentes que afectan el metabolismo del \u00e1cido \u00farico',
    code_3: 'Y54',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y549',
    level: 4,
    description:
      'Efectos adversos de sales minerales, no clasificadas en otra parte',
    code_3: 'Y54',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y530',
    level: 4,
    description:
      'Efectos adversos de bloqueadores de los receptores H2 de histamina',
    code_3: 'Y53',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y531',
    level: 4,
    description:
      'Efectos adversos de otras drogas anti\u00e1cidas e inhibidoras de la secreci\u00f3n g\u00e1strica',
    code_3: 'Y53',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y532',
    level: 4,
    description: 'Efectos adversos de laxantes estimulantes',
    code_3: 'Y53',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y533',
    level: 4,
    description: 'Efectos adversos de laxantes salinos y osm\u00f3ticos',
    code_3: 'Y53',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y534',
    level: 4,
    description: 'Efectos adversos de otros laxantes',
    code_3: 'Y53',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y520',
    level: 4,
    description:
      'Efectos adversos de gluc\u00f3sidos cardiot\u00f3nicos y drogas de acci\u00f3n similar',
    code_3: 'Y52',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y521',
    level: 4,
    description: 'Efectos adversos de bloqueadores del canal del calcio',
    code_3: 'Y52',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y522',
    level: 4,
    description:
      'Efectos adversos de otras drogas antiarr\u00edtmicas, no clasificadas en otra parte',
    code_3: 'Y52',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y523',
    level: 4,
    description:
      'Efectos adversos de vasodilatadores coronarios, no clasificados en otra parte',
    code_3: 'Y52',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y524',
    level: 4,
    description:
      'Efectos adversos de inhibidores de la enzima convertidora de angiotensina',
    code_3: 'Y52',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y525',
    level: 4,
    description:
      'Efectos adversos de otras drogas antihipertensivas, no clasificadas en otra parte',
    code_3: 'Y52',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y526',
    level: 4,
    description:
      'Efectos adversos de drogas antihiperlipid\u00e9micas y antiarterioscler\u00f3ticas',
    code_3: 'Y52',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y527',
    level: 4,
    description: 'Efectos adversos de vasodilatadores perif\u00e9ricos',
    code_3: 'Y52',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'V390',
    level: 4,
    description:
      'Conductor de veh\u00edculo de motor de tres ruedas lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente no de tr\u00e1nsito',
    code_3: 'V39',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V30-V39'
  },
  {
    code: 'V391',
    level: 4,
    description:
      'Pasajero de veh\u00edculo de motor de tres ruedas lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente no de tr\u00e1nsito',
    code_3: 'V39',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V30-V39'
  },
  {
    code: 'V392',
    level: 4,
    description:
      'Ocupante no especificado de veh\u00edculo de motor de tres ruedas lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en',
    code_3: 'V39',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V30-V39'
  },
  {
    code: 'V393',
    level: 4,
    description:
      'Ocupante [cualquiera] de veh\u00edculo de motor de tres ruedas lesionado en accidente no de tr\u00e1nsito, no especificado',
    code_3: 'V39',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V30-V39'
  },
  {
    code: 'V394',
    level: 4,
    description:
      'Conductor de veh\u00edculo de motor de tres ruedas lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente de tr\u00e1nsito',
    code_3: 'V39',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V30-V39'
  },
  {
    code: 'V395',
    level: 4,
    description:
      'Pasajero de veh\u00edculo de motor de tres ruedas lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente de tr\u00e1nsito',
    code_3: 'V39',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V30-V39'
  },
  {
    code: 'V396',
    level: 4,
    description:
      'Ocupante no especificado de veh\u00edculo de motor de tres ruedas lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en',
    code_3: 'V39',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V30-V39'
  },
  {
    code: 'V398',
    level: 4,
    description:
      'Ocupante [cualquiera] de veh\u00edculo de motor de tres ruedas lesionado en otros accidentes de transporte especificados',
    code_3: 'V39',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V30-V39'
  },
  {
    code: 'V399',
    level: 4,
    description:
      'Ocupante [cualquiera] de veh\u00edculo de motor de tres ruedas lesionado en accidente de tr\u00e1nsito no especificado',
    code_3: 'V39',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V30-V39'
  },
  {
    code: 'V490',
    level: 4,
    description:
      'Conductor de autom\u00f3vil lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente no de tr\u00e1nsito',
    code_3: 'V49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V40-V49'
  },
  {
    code: 'V491',
    level: 4,
    description:
      'Pasajero de autom\u00f3vil lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente no de tr\u00e1nsito',
    code_3: 'V49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V40-V49'
  },
  {
    code: 'V492',
    level: 4,
    description:
      'Ocupante no especificado de autom\u00f3vil lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente no de tr\u00e1nsito',
    code_3: 'V49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V40-V49'
  },
  {
    code: 'V493',
    level: 4,
    description:
      'Ocupante [cualquiera] de autom\u00f3vil lesionado en accidente no de tr\u00e1nsito, no especificado',
    code_3: 'V49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V40-V49'
  },
  {
    code: 'V494',
    level: 4,
    description:
      'Conductor de autom\u00f3vil lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente de tr\u00e1nsito',
    code_3: 'V49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V40-V49'
  },
  {
    code: 'V495',
    level: 4,
    description:
      'Pasajero de autom\u00f3vil lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente de tr\u00e1nsito',
    code_3: 'V49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V40-V49'
  },
  {
    code: 'V496',
    level: 4,
    description:
      'Ocupante no especificado de autom\u00f3vil lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente de tr\u00e1nsito',
    code_3: 'V49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V40-V49'
  },
  {
    code: 'V590',
    level: 4,
    description:
      'Conductor de camioneta o furgoneta lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente no de tr\u00e1nsito',
    code_3: 'V59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V50-V59'
  },
  {
    code: 'V591',
    level: 4,
    description:
      'Pasajero de camioneta o furgoneta lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente no de tr\u00e1nsito',
    code_3: 'V59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V50-V59'
  },
  {
    code: 'V592',
    level: 4,
    description:
      'Ocupante no especificado de camioneta o furgoneta lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente no de tr\u00e1nsito',
    code_3: 'V59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V50-V59'
  },
  {
    code: 'V593',
    level: 4,
    description:
      'Ocupante [cualquiera] de camioneta o furgoneta lesionado en accidente no de tr\u00e1nsito, no especificado',
    code_3: 'V59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V50-V59'
  },
  {
    code: 'V594',
    level: 4,
    description:
      'Conductor de camioneta o furgoneta lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente de tr\u00e1nsito',
    code_3: 'V59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V50-V59'
  },
  {
    code: 'V595',
    level: 4,
    description:
      'Pasajero de camioneta o furgoneta lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente de tr\u00e1nsito',
    code_3: 'V59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V50-V59'
  },
  {
    code: 'V596',
    level: 4,
    description:
      'Ocupante no especificado de camioneta o furgoneta lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente de tr\u00e1nsito',
    code_3: 'V59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V50-V59'
  },
  {
    code: 'V598',
    level: 4,
    description:
      'Ocupante [cualquiera] de camioneta o furgoneta lesionado en otros accidentes de transporte especificados',
    code_3: 'V59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V50-V59'
  },
  {
    code: 'V599',
    level: 4,
    description:
      'Ocupante [cualquiera] de camioneta o furgoneta lesionado en accidente de tr\u00e1nsito no especificado',
    code_3: 'V59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V50-V59'
  },
  {
    code: 'V790',
    level: 4,
    description:
      'Conductor de autob\u00fas lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente no de tr\u00e1nsito',
    code_3: 'V79',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V70-V79'
  },
  {
    code: 'V791',
    level: 4,
    description:
      'Pasajero de autob\u00fas lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente no de tr\u00e1nsito',
    code_3: 'V79',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V70-V79'
  },
  {
    code: 'V792',
    level: 4,
    description:
      'Ocupante no especificado de autob\u00fas lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente no de tr\u00e1nsito',
    code_3: 'V79',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V70-V79'
  },
  {
    code: 'V793',
    level: 4,
    description:
      'Ocupante [cualquiera] de autob\u00fas lesionado en accidente no de tr\u00e1nsito, no especificado',
    code_3: 'V79',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V70-V79'
  },
  {
    code: 'V794',
    level: 4,
    description:
      'Conductor de autob\u00fas lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente de tr\u00e1nsito',
    code_3: 'V79',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V70-V79'
  },
  {
    code: 'V795',
    level: 4,
    description:
      'Pasajero de autob\u00fas lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente de tr\u00e1nsito',
    code_3: 'V79',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V70-V79'
  },
  {
    code: 'V796',
    level: 4,
    description:
      'Ocupante no especificado de autob\u00fas lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente de tr\u00e1nsito',
    code_3: 'V79',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V70-V79'
  },
  {
    code: 'V798',
    level: 4,
    description:
      'Ocupante [cualquiera] de autob\u00fas lesionado en otros accidentes de transporte especificados',
    code_3: 'V79',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V70-V79'
  },
  {
    code: 'V799',
    level: 4,
    description:
      'Ocupante [cualquiera] de autob\u00fas lesionado en accidente de tr\u00e1nsito no especificado',
    code_3: 'V79',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V70-V79'
  },
  {
    code: 'Y518',
    level: 4,
    description:
      'Efectos adversos de agentes bloqueadores neuro-adren\u00e9rgicos que act\u00faan centralmente, no clasificados en otra parte',
    code_3: 'Y51',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y519',
    level: 4,
    description:
      'Efectos adversos de otras drogas que afectan primariamente el sistema nervioso aut\u00f3nomo, y las no especificadas',
    code_3: 'Y51',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y475',
    level: 4,
    description:
      'Efectos adversos de mezclas sedantes e hipn\u00f3ticas, no clasificadas en otra parte',
    code_3: 'Y47',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y478',
    level: 4,
    description:
      'Efectos adversos de otras drogas sedantes, hipn\u00f3ticas y ansiol\u00edticas',
    code_3: 'Y47',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y479',
    level: 4,
    description:
      'Efectos adversos de drogas sedantes, hipn\u00f3ticas y ansiol\u00edticas no especificadas',
    code_3: 'Y47',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y435',
    level: 4,
    description: 'Efectos adversos de agentes acidificantes y alcalinizantes',
    code_3: 'Y43',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y436',
    level: 4,
    description: 'Efectos adversos de enzimas no clasificadas en otra parte',
    code_3: 'Y43',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y438',
    level: 4,
    description:
      'Efectos adversos de otros agentes sist\u00e9micos primarios no clasificados en otra parte',
    code_3: 'Y43',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y439',
    level: 4,
    description:
      'Efectos adversos de agente sist\u00e9mico primario no especificado',
    code_3: 'Y43',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y426',
    level: 4,
    description:
      'Efectos adversos de antigonadotropinas, antiestr\u00f3genos y antiandr\u00f3genos, no clasificados en otra parte',
    code_3: 'Y42',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y427',
    level: 4,
    description:
      'Efectos adversos de andr\u00f3genos y cong\u00e9neres anab\u00f3licos',
    code_3: 'Y42',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y428',
    level: 4,
    description:
      'Efectos adversos de otras hormonas y sus sustitutos sint\u00e9ticos, y las no especificadas',
    code_3: 'Y42',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y429',
    level: 4,
    description:
      'Efectos adversos de otras hormonas antagonistas, y las no especificadas',
    code_3: 'Y42',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'V890',
    level: 4,
    description:
      'Persona lesionada en accidente no de tr\u00e1nsito, de veh\u00edculo de motor no especificado',
    code_3: 'V89',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V891',
    level: 4,
    description:
      'Persona lesionada en accidente no de tr\u00e1nsito, de veh\u00edculo sin motor no especificado',
    code_3: 'V89',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V892',
    level: 4,
    description:
      'Persona lesionada en accidente de tr\u00e1nsito, de veh\u00edculo de motor no especificado',
    code_3: 'V89',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V893',
    level: 4,
    description:
      'Persona lesionada en accidente de tr\u00e1nsito, de veh\u00edculo sin motor no especificado',
    code_3: 'V89',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V899',
    level: 4,
    description:
      'Persona lesionada en accidente de veh\u00edculo no especificado',
    code_3: 'V89',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V880',
    level: 4,
    description:
      'Persona lesionada por colisi\u00f3n entre autom\u00f3vil y veh\u00edculo de motor de dos o tres ruedas, no de tr\u00e1nsito',
    code_3: 'V88',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V881',
    level: 4,
    description:
      'Persona lesionada por colisi\u00f3n entre otros veh\u00edculos de motor y un veh\u00edculo de motor de dos o tres ruedas, no de tr\u00e1nsito',
    code_3: 'V88',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V882',
    level: 4,
    description:
      'Persona lesionada por colisi\u00f3n entre autom\u00f3vil y camioneta o furgoneta, no de tr\u00e1nsito',
    code_3: 'V88',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V883',
    level: 4,
    description:
      'Persona lesionada por colisi\u00f3n entre autom\u00f3vil y autob\u00fas, no de tr\u00e1nsito',
    code_3: 'V88',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V884',
    level: 4,
    description:
      'Persona lesionada por colisi\u00f3n entre autom\u00f3vil y veh\u00edculo de transporte pesado, no de tr\u00e1nsito',
    code_3: 'V88',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V885',
    level: 4,
    description:
      'Persona lesionada por colisi\u00f3n entre veh\u00edculo de transporte pesado y autob\u00fas, no de tr\u00e1nsito',
    code_3: 'V88',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V886',
    level: 4,
    description:
      'Persona lesionada por colisi\u00f3n entre tren o veh\u00edculo de rieles y autom\u00f3vil, no de tr\u00e1nsito',
    code_3: 'V88',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V887',
    level: 4,
    description:
      'Persona lesionada por colisi\u00f3n entre otros veh\u00edculos de motor especificados, no de tr\u00e1nsito',
    code_3: 'V88',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V888',
    level: 4,
    description:
      'Persona lesionada en otros accidentes especificados de transporte de veh\u00edculo de motor sin colisi\u00f3n, no de tr\u00e1nsito',
    code_3: 'V88',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V889',
    level: 4,
    description:
      'Persona lesionada en otros accidentes especificados de transporte de veh\u00edculo sin motor (con colisi\u00f3n) (sin colisi\u00f3n), no de tr\u00e1nsito',
    code_3: 'V88',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V198',
    level: 4,
    description:
      'Ciclista [cualquiera] lesionado en otros accidentes de transporte especificados',
    code_3: 'V19',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V10-V19'
  },
  {
    code: 'V199',
    level: 4,
    description:
      'Ciclista [cualquiera] lesionado en accidente de tr\u00e1nsito no especificado',
    code_3: 'V19',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V10-V19'
  },
  {
    code: 'V870',
    level: 4,
    description:
      'Persona lesionada por colisi\u00f3n entre autom\u00f3vil y veh\u00edculo de motor de dos o tres ruedas (tr\u00e1nsito)',
    code_3: 'V87',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V871',
    level: 4,
    description:
      'Persona lesionada por colisi\u00f3n entre otros veh\u00edculos de motor y un veh\u00edculo de motor de dos o tres ruedas (tr\u00e1nsito)',
    code_3: 'V87',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V872',
    level: 4,
    description:
      'Persona lesionada por colisi\u00f3n entre autom\u00f3vil y camioneta o furgoneta (tr\u00e1nsito)',
    code_3: 'V87',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V873',
    level: 4,
    description:
      'Persona lesionada por colisi\u00f3n entre autom\u00f3vil y autob\u00fas (tr\u00e1nsito)',
    code_3: 'V87',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V860',
    level: 4,
    description:
      'Conductor de veh\u00edculo para todo terreno o de otro veh\u00edculo de motor para uso fuera de la carretera lesionado en accidente de tr\u00e1nsito',
    code_3: 'V86',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V861',
    level: 4,
    description:
      'Pasajero de veh\u00edculo para todo terreno o de otro veh\u00edculo de motor para uso fuera de la carretera lesionado en accidente de tr\u00e1nsito',
    code_3: 'V86',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V862',
    level: 4,
    description:
      'Persona que viaja fuera del veh\u00edculo para todo terreno o de otro veh\u00edculo de motor para uso fuera de la carretera lesionada en accidente de tr\u00e1nsito',
    code_3: 'V86',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V863',
    level: 4,
    description:
      'Ocupante no especificado de veh\u00edculo para todo terreno o de otro veh\u00edculo de motor para uso fuera de la carretera lesionado en accidente de tr\u00e1nsito',
    code_3: 'V86',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V864',
    level: 4,
    description:
      'Persona lesionada al subir o bajar de veh\u00edculo para todo terreno o de otro veh\u00edculo de motor para uso fuera de la carretera',
    code_3: 'V86',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V865',
    level: 4,
    description:
      'Conductor de veh\u00edculo para todo terreno o de otro veh\u00edculo de motor para uso fuera de la carretera lesionado en accidente no de tr\u00e1nsito',
    code_3: 'V86',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V866',
    level: 4,
    description:
      'Pasajero de veh\u00edculo para todo terreno o de otro veh\u00edculo de motor para uso fuera de la carretera lesionado en accidente no de tr\u00e1nsito',
    code_3: 'V86',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V867',
    level: 4,
    description:
      'Persona que viaja fuera de veh\u00edculo para todo terreno o de otro veh\u00edculo de motor para uso fuera de la carretera lesionada en accidente no de tr\u00e1nsito',
    code_3: 'V86',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V869',
    level: 4,
    description:
      'Ocupante no especificado de veh\u00edculo para todo terreno o de otro veh\u00edculo de motor para uso fuera de la carretera lesionado en accidente no de tr\u00e1nsito',
    code_3: 'V86',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V850',
    level: 4,
    description:
      'Conductor de veh\u00edculo especial para construcci\u00f3n lesionado en accidente de tr\u00e1nsito',
    code_3: 'V85',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V851',
    level: 4,
    description:
      'Pasajero de veh\u00edculo especial para construcci\u00f3n lesionado en accidente de tr\u00e1nsito',
    code_3: 'V85',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V852',
    level: 4,
    description:
      'Persona que viaja fuera del veh\u00edculo especial para construcci\u00f3n lesionada en accidente de tr\u00e1nsito',
    code_3: 'V85',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V853',
    level: 4,
    description:
      'Ocupante no especificado de veh\u00edculo especial para construcci\u00f3n lesionado en accidente de tr\u00e1nsito',
    code_3: 'V85',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V854',
    level: 4,
    description:
      'Persona lesionada al subir o bajar del veh\u00edculo especial para construcci\u00f3n',
    code_3: 'V85',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V855',
    level: 4,
    description:
      'Conductor de veh\u00edculo especial para construcci\u00f3n lesionado en accidente no de tr\u00e1nsito',
    code_3: 'V85',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V856',
    level: 4,
    description:
      'Pasajero de veh\u00edculo especial para construcci\u00f3n lesionado en accidente no de tr\u00e1nsito',
    code_3: 'V85',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V857',
    level: 4,
    description:
      'Persona que viaja fuera del veh\u00edculo especial para construcci\u00f3n lesionada en accidente no de tr\u00e1nsito',
    code_3: 'V85',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V859',
    level: 4,
    description:
      'Ocupante no especificado de veh\u00edculo especial para construcci\u00f3n lesionado en accidente no de tr\u00e1nsito',
    code_3: 'V85',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'Y840',
    level: 4,
    description: 'Cateterizaci\u00f3n card\u00edaca',
    code_3: 'Y84',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y83-Y84'
  },
  {
    code: 'Y841',
    level: 4,
    description: 'Di\u00e1lisis renal',
    code_3: 'Y84',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y83-Y84'
  },
  {
    code: 'Y842',
    level: 4,
    description: 'Procedimiento radiol\u00f3gico y radioterapia',
    code_3: 'Y84',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y83-Y84'
  },
  {
    code: 'Y843',
    level: 4,
    description: 'Terapia por choque',
    code_3: 'Y84',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y83-Y84'
  },
  {
    code: 'Y844',
    level: 4,
    description: 'Aspiraci\u00f3n de l\u00edquidos',
    code_3: 'Y84',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y83-Y84'
  },
  {
    code: 'Y845',
    level: 4,
    description: 'Inserci\u00f3n de sonda g\u00e1strica o duodenal',
    code_3: 'Y84',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y83-Y84'
  },
  {
    code: 'Y830',
    level: 4,
    description:
      'Operaci\u00f3n quir\u00fargica con trasplante de un \u00f3rgano completo',
    code_3: 'Y83',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y83-Y84'
  },
  {
    code: 'Y831',
    level: 4,
    description:
      'Operaci\u00f3n quir\u00fargica con implante de un dispositivo artificial interno',
    code_3: 'Y83',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y83-Y84'
  },
  {
    code: 'Y832',
    level: 4,
    description:
      'Operaci\u00f3n quir\u00fargica con anastomosis, derivaci\u00f3n o injerto',
    code_3: 'Y83',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y83-Y84'
  },
  {
    code: 'Y833',
    level: 4,
    description:
      'Operaci\u00f3n quir\u00fargica con formaci\u00f3n de estoma externo',
    code_3: 'Y83',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y83-Y84'
  },
  {
    code: 'Y834',
    level: 4,
    description: 'Otra cirug\u00eda reconstructiva',
    code_3: 'Y83',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y83-Y84'
  },
  {
    code: 'Y835',
    level: 4,
    description: 'Amputaci\u00f3n de miembro(s)',
    code_3: 'Y83',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y83-Y84'
  },
  {
    code: 'Y836',
    level: 4,
    description: 'Remoci\u00f3n de otro \u00f3rgano (parcial) (total)',
    code_3: 'Y83',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y83-Y84'
  },
  {
    code: 'Y838',
    level: 4,
    description: 'Otros procedimientos quir\u00fargicos',
    code_3: 'Y83',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y83-Y84'
  },
  {
    code: 'Y839',
    level: 4,
    description: 'Procedimiento quir\u00fargico no especificado',
    code_3: 'Y83',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y83-Y84'
  },
  {
    code: 'V293',
    level: 4,
    description:
      'Motociclista [cualquiera] lesionado en accidente no de tr\u00e1nsito, no especificado',
    code_3: 'V29',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V20-V29'
  },
  {
    code: 'V294',
    level: 4,
    description:
      'Conductor de motocicleta lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente de tr\u00e1nsito',
    code_3: 'V29',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V20-V29'
  },
  {
    code: 'V295',
    level: 4,
    description:
      'Pasajero de motocicleta lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente de tr\u00e1nsito',
    code_3: 'V29',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V20-V29'
  },
  {
    code: 'V296',
    level: 4,
    description:
      'Motociclista no especificado lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente de tr\u00e1nsito',
    code_3: 'V29',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V20-V29'
  },
  {
    code: 'V298',
    level: 4,
    description:
      'Motociclista [cualquiera] lesionado en otros accidentes de transporte especificados',
    code_3: 'V29',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V20-V29'
  },
  {
    code: 'V299',
    level: 4,
    description:
      'Motociclista [cualquiera] lesionado en accidente de tr\u00e1nsito no especificado',
    code_3: 'V29',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V20-V29'
  },
  {
    code: 'W15',
    level: 3,
    description: 'Ca\u00edda desde pe\u00f1asco',
    code_2: 'W00-X59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'W16',
    level: 3,
    description:
      'Salto o zambullida dentro del agua que causa otro traumatismo sin sumersi\u00f3n o ahogamiento',
    code_2: 'W00-X59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'W17',
    level: 3,
    description: 'Otras ca\u00eddas de un nivel a otro',
    code_2: 'W00-X59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'W18',
    level: 3,
    description: 'Otras ca\u00eddas en el mismo nivel',
    code_2: 'W00-X59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'W19',
    level: 3,
    description: 'Ca\u00edda no especificada',
    code_2: 'W00-X59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'W20-W49',
    level: 3,
    description: 'Exposici\u00f3n a fuerzas mec\u00e1nicas inanimadas',
    code_2: 'W00-X59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'W50-W64',
    level: 3,
    description: 'Exposici\u00f3n a fuerzas mec\u00e1nicas animadas',
    code_2: 'W00-X59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'W65-W74',
    level: 3,
    description: 'Ahogamiento y sumersi\u00f3n accidentales',
    code_2: 'W00-X59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'W75-W84',
    level: 3,
    description: 'Otros accidentes que obstruyen la respiraci\u00f3n',
    code_2: 'W00-X59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'W85-W99',
    level: 3,
    description:
      'Exposici\u00f3n a la corriente el\u00e9ctrica, radiaci\u00f3n y temperatura, y presi\u00f3n del aire ambientales extremas',
    code_2: 'W00-X59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V849',
    level: 4,
    description:
      'Ocupante no especificado de veh\u00edculo agr\u00edcola especial lesionado en accidente no de tr\u00e1nsito',
    code_3: 'V84',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'Y578',
    level: 4,
    description: 'Efectos adversos de otras drogas y medicamentos',
    code_3: 'Y57',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y579',
    level: 4,
    description: 'Efectos adversos de drogas o medicamentos no especificados',
    code_3: 'Y57',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y568',
    level: 4,
    description: 'Efectos adversos de otros agentes t\u00f3picos',
    code_3: 'Y56',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y569',
    level: 4,
    description:
      'Efectos adversos de otros agentes t\u00f3picos no especificados',
    code_3: 'Y56',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y535',
    level: 4,
    description: 'Efectos adversos de digestivos',
    code_3: 'Y53',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y536',
    level: 4,
    description: 'Efectos adversos de drogas antidiarreicas',
    code_3: 'Y53',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y537',
    level: 4,
    description: 'Efectos adversos de em\u00e9ticos',
    code_3: 'Y53',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y538',
    level: 4,
    description:
      'Efectos adversos de otros agentes que afectan primariamente el sistema gastrointestinal',
    code_3: 'Y53',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y539',
    level: 4,
    description:
      'Efectos adversos de agentes que afectan el sistema gastrointestinal, no especificados',
    code_3: 'Y53',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y528',
    level: 4,
    description:
      'Efectos adversos de drogas antivaricosas, inclusive agentes esclerosantes',
    code_3: 'Y52',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'Y529',
    level: 4,
    description:
      'Efectos adversos de otros agentes que afectan primariamente el sistema cardiovascular, y los no especificados',
    code_3: 'Y52',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y40-Y59'
  },
  {
    code: 'V498',
    level: 4,
    description:
      'Ocupante [cualquiera] de autom\u00f3vil lesionado en otros accidentes de transporte especificados',
    code_3: 'V49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V40-V49'
  },
  {
    code: 'V499',
    level: 4,
    description:
      'Ocupante [cualquiera] de autom\u00f3vil lesionado en accidente de tr\u00e1nsito no especificado',
    code_3: 'V49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V40-V49'
  },
  {
    code: 'V690',
    level: 4,
    description:
      'Conductor de veh\u00edculo de transporte pesado lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente no de tr\u00e1nsito',
    code_3: 'V69',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V60-V69'
  },
  {
    code: 'V691',
    level: 4,
    description:
      'Pasajero de veh\u00edculo de transporte pesado lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente no de tr\u00e1nsito',
    code_3: 'V69',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V60-V69'
  },
  {
    code: 'V692',
    level: 4,
    description:
      'Ocupante no especificado de veh\u00edculo de transporte pesado lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente no de tr\u00e1nsito',
    code_3: 'V69',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V60-V69'
  },
  {
    code: 'V693',
    level: 4,
    description:
      'Ocupante [cualquiera] de veh\u00edculo de transporte pesado lesionado en accidente no de tr\u00e1nsito, no especificado',
    code_3: 'V69',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V60-V69'
  },
  {
    code: 'V874',
    level: 4,
    description:
      'Persona lesionada por colisi\u00f3n entre autom\u00f3vil y veh\u00edculo de transporte pesado (tr\u00e1nsito)',
    code_3: 'V87',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V875',
    level: 4,
    description:
      'Persona lesionada por colisi\u00f3n entre veh\u00edculo de transporte pesado y autob\u00fas (tr\u00e1nsito)',
    code_3: 'V87',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V876',
    level: 4,
    description:
      'Persona lesionada por colisi\u00f3n entre tren o veh\u00edculo de rieles y autom\u00f3vil (tr\u00e1nsito)',
    code_3: 'V87',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V877',
    level: 4,
    description:
      'Persona lesionada por colisi\u00f3n entre otros veh\u00edculos de motor especificados (tr\u00e1nsito)',
    code_3: 'V87',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V878',
    level: 4,
    description:
      'Persona lesionada en otros accidentes especificados de transporte de veh\u00edculo de motor sin colisi\u00f3n (tr\u00e1nsito)',
    code_3: 'V87',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'V879',
    level: 4,
    description:
      'Persona lesionada en otros accidentes especificados de transporte de veh\u00edculo sin motor (con colisi\u00f3n) (sin colisi\u00f3n) (tr\u00e1nsito)',
    code_3: 'V87',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V80-V89'
  },
  {
    code: 'Y846',
    level: 4,
    description: 'Cateterizaci\u00f3n urinaria',
    code_3: 'Y84',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y83-Y84'
  },
  {
    code: 'Y847',
    level: 4,
    description: 'Muestra de sangre',
    code_3: 'Y84',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y83-Y84'
  },
  {
    code: 'Y848',
    level: 4,
    description: 'Otros procedimientos m\u00e9dicos',
    code_3: 'Y84',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y83-Y84'
  },
  {
    code: 'Y849',
    level: 4,
    description: 'Procedimiento m\u00e9dico no especificado',
    code_3: 'Y84',
    code_0: 'V01-Y99',
    code_1: 'Y40-Y84',
    code_2: 'Y83-Y84'
  },
  {
    code: 'X00-X09',
    level: 3,
    description: 'Exposici\u00f3n al humo, fuego y llamas',
    code_2: 'W00-X59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'X10-X19',
    level: 3,
    description: 'Contacto con calor y sustancias calientes',
    code_2: 'W00-X59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'X20-X29',
    level: 3,
    description: 'Contacto traum\u00e1tico con animales y plantas venenosos',
    code_2: 'W00-X59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'X30-X39',
    level: 3,
    description: 'Exposici\u00f3n a fuerzas de la naturaleza',
    code_2: 'W00-X59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'X40-X49',
    level: 3,
    description:
      'Envenenamiento accidental por, y exposici\u00f3n a sustancias nocivas',
    code_2: 'W00-X59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'X50-X57',
    level: 3,
    description: 'Exceso de esfuerzo, viajes y privaci\u00f3n',
    code_2: 'W00-X59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'X58-X59',
    level: 3,
    description:
      'Exposici\u00f3n accidental a otros factores y a los no especificados',
    code_2: 'W00-X59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59'
  },
  {
    code: 'V694',
    level: 4,
    description:
      'Conductor de veh\u00edculo de transporte pesado lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente de tr\u00e1nsito',
    code_3: 'V69',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V60-V69'
  },
  {
    code: 'V695',
    level: 4,
    description:
      'Pasajero de veh\u00edculo de transporte pesado lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente de tr\u00e1nsito',
    code_3: 'V69',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V60-V69'
  },
  {
    code: 'V696',
    level: 4,
    description:
      'Ocupante no especificado de veh\u00edculo de transporte pesado lesionado por colisi\u00f3n con otros veh\u00edculos de motor, y con los no especificados, en accidente de tr\u00e1nsito',
    code_3: 'V69',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V60-V69'
  },
  {
    code: 'V698',
    level: 4,
    description:
      'Ocupante [cualquiera] de veh\u00edculo de transporte pesado lesionado en otros accidentes de transporte especificados',
    code_3: 'V69',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V60-V69'
  },
  {
    code: 'V699',
    level: 4,
    description:
      'Ocupante [cualquiera] de veh\u00edculo de transporte pesado lesionado en accidente de tr\u00e1nsito no especificado',
    code_3: 'V69',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'V60-V69'
  },
  {
    code: 'W75',
    level: 4,
    description: 'Sofocaci\u00f3n y estrangulamiento accidental en la cama',
    code_3: 'W75-W84',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W76',
    level: 4,
    description: 'Otros estrangulamientos y ahorcamientos accidentales',
    code_3: 'W75-W84',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W77',
    level: 4,
    description:
      'Obstrucci\u00f3n de la respiraci\u00f3n debida a hundimiento, ca\u00edda de tierra u otras sustancias',
    code_3: 'W75-W84',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W78',
    level: 4,
    description: 'Inhalaci\u00f3n de contenidos g\u00e1stricos',
    code_3: 'W75-W84',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W79',
    level: 4,
    description:
      'Inhalaci\u00f3n e ingesti\u00f3n de alimento que causa obstrucci\u00f3n de las v\u00edas respiratorias',
    code_3: 'W75-W84',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W65',
    level: 4,
    description:
      'Ahogamiento y sumersi\u00f3n mientras se est\u00e1 en la ba\u00f1era',
    code_3: 'W65-W74',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W66',
    level: 4,
    description:
      'Ahogamiento y sumersi\u00f3n consecutivos a ca\u00edda en la ba\u00f1era',
    code_3: 'W65-W74',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W67',
    level: 4,
    description:
      'Ahogamiento y sumersi\u00f3n mientras se est\u00e1 en una piscina',
    code_3: 'W65-W74',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W68',
    level: 4,
    description:
      'Ahogamiento y sumersi\u00f3n consecutivos a ca\u00edda en una piscina',
    code_3: 'W65-W74',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W50',
    level: 4,
    description:
      'Aporreo, golpe, mordedura, patada, rasgu\u00f1o o torcedura infligidos por otra persona',
    code_3: 'W50-W64',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W51',
    level: 4,
    description: 'Choque o empell\u00f3n contra otra persona',
    code_3: 'W50-W64',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W52',
    level: 4,
    description:
      'Persona aplastada, empujada o pisoteada por una multitud o estampida humana',
    code_3: 'W50-W64',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W53',
    level: 4,
    description: 'Mordedura de rata',
    code_3: 'W50-W64',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W54',
    level: 4,
    description: 'Mordedura o ataque de perro',
    code_3: 'W50-W64',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W55',
    level: 4,
    description: 'Mordedura o ataque de otros mam\u00edferos',
    code_3: 'W50-W64',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W56',
    level: 4,
    description: 'Contacto traum\u00e1tico con animales marinos',
    code_3: 'W50-W64',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W20',
    level: 4,
    description: 'Golpe por objeto arrojado, proyectado o que cae',
    code_3: 'W20-W49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W21',
    level: 4,
    description: 'Golpe contra o golpeado por equipo para deportes',
    code_3: 'W20-W49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W22',
    level: 4,
    description: 'Golpe contra o golpeado por otros objetos',
    code_3: 'W20-W49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W23',
    level: 4,
    description: 'Atrapado, aplastado, trabado o apretado en o entre objetos',
    code_3: 'W20-W49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W24',
    level: 4,
    description:
      'Contacto traum\u00e1tico con dispositivos de eleva\u00adci\u00f3n y transmisi\u00f3n, no clasificados en otra parte',
    code_3: 'W20-W49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W25',
    level: 4,
    description: 'Contacto traum\u00e1tico con vidrio cortante',
    code_3: 'W20-W49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W80',
    level: 4,
    description:
      'Inhalaci\u00f3n e ingesti\u00f3n de otros objetos que causan obstrucci\u00f3n de las v\u00edas respiratorias',
    code_3: 'W75-W84',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W81',
    level: 4,
    description:
      'Confinado o atrapado en un ambiente con bajo contenido de ox\u00edgeno',
    code_3: 'W75-W84',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W83',
    level: 4,
    description: 'Otras obstrucciones especificadas de la respiraci\u00f3n',
    code_3: 'W75-W84',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W84',
    level: 4,
    description: 'Obstrucci\u00f3n no especificada de la respiraci\u00f3n',
    code_3: 'W75-W84',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W69',
    level: 4,
    description:
      'Ahogamiento y sumersi\u00f3n mientras se est\u00e1 en aguas naturales',
    code_3: 'W65-W74',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W70',
    level: 4,
    description:
      'Ahogamiento y sumersi\u00f3n posterior a ca\u00edda en aguas naturales',
    code_3: 'W65-W74',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W73',
    level: 4,
    description: 'Otros ahogamientos y sumersiones especificados',
    code_3: 'W65-W74',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W74',
    level: 4,
    description: 'Ahogamiento y sumersi\u00f3n no especificados',
    code_3: 'W65-W74',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W57',
    level: 4,
    description:
      'Mordedura o picadura de insectos y otros artr\u00f3podos no venenosos',
    code_3: 'W50-W64',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W58',
    level: 4,
    description: 'Mordedura o ataque de cocodrilo o caim\u00e1n',
    code_3: 'W50-W64',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W59',
    level: 4,
    description: 'Mordedura o aplastamiento por otros reptiles',
    code_3: 'W50-W64',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W60',
    level: 4,
    description:
      'Contacto traum\u00e1tico con aguijones, espinas u hojas cortantes de plantas',
    code_3: 'W50-W64',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W64',
    level: 4,
    description:
      'Exposici\u00f3n a otras fuerzas mec\u00e1nicas animadas, y las no especificadas',
    code_3: 'W50-W64',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W26',
    level: 4,
    description:
      'Contacto traum\u00e1tico con cuchillo, espada, daga o pu\u00f1al',
    code_3: 'W20-W49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W27',
    level: 4,
    description: 'Contacto traum\u00e1tico con herramientas manuales sin motor',
    code_3: 'W20-W49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W28',
    level: 4,
    description:
      'Contacto traum\u00e1tico con cortadora de c\u00e9sped, con motor',
    code_3: 'W20-W49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W29',
    level: 4,
    description:
      'Contacto traum\u00e1tico con otras herramientas manuales y artefactos del hogar, con motor',
    code_3: 'W20-W49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W30',
    level: 4,
    description: 'Contacto traum\u00e1tico con maquinaria agr\u00edcola',
    code_3: 'W20-W49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W31',
    level: 4,
    description:
      'Contacto traum\u00e1tico con otras maquinarias, y las no especificadas',
    code_3: 'W20-W49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W32',
    level: 4,
    description: 'Disparo de arma corta',
    code_3: 'W20-W49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W33',
    level: 4,
    description: 'Disparo de rifle, escopeta y arma larga',
    code_3: 'W20-W49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W34',
    level: 4,
    description: 'Disparo de otras armas de fuego, y las no especificadas',
    code_3: 'W20-W49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W35',
    level: 4,
    description: 'Explosi\u00f3n y rotura de caldera',
    code_3: 'W20-W49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W36',
    level: 4,
    description: 'Explosi\u00f3n y rotura de cilindro con gas',
    code_3: 'W20-W49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X58',
    level: 4,
    description: 'Exposici\u00f3n a otros factores especificados',
    code_3: 'X58-X59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X59',
    level: 4,
    description: 'Exposici\u00f3n a factores no especificados',
    code_3: 'X58-X59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X50',
    level: 4,
    description: 'Exceso de esfuerzo y movimientos extenuantes y repetitivos',
    code_3: 'X50-X57',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X51',
    level: 4,
    description: 'Viajes y desplazamientos',
    code_3: 'X50-X57',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X52',
    level: 4,
    description: 'Permanencia prolongada en ambiente sin gravedad',
    code_3: 'X50-X57',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X53',
    level: 4,
    description: 'Privaci\u00f3n de alimentos',
    code_3: 'X50-X57',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X54',
    level: 4,
    description: 'Privaci\u00f3n de agua',
    code_3: 'X50-X57',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X57',
    level: 4,
    description: 'Privaci\u00f3n no especificada',
    code_3: 'X50-X57',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X40',
    level: 4,
    description:
      'Envenenamiento accidental por, y exposici\u00f3n a analg\u00e9sicos no narc\u00f3ticos, antipir\u00e9ticos y antirreum\u00e1ticos',
    code_3: 'X40-X49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X41',
    level: 4,
    description:
      'Envenenamiento accidental por, y exposici\u00f3n a drogas antiepil\u00e9pticas, sedantes, hipn\u00f3ticas, antiparkinsonianas y psicotr\u00f3picas, no clasificadas en otra parte',
    code_3: 'X40-X49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X42',
    level: 4,
    description:
      'Envenenamiento accidental por, y exposici\u00f3n a narc\u00f3ticos y psicodisl\u00e9pticos [alucin\u00f3genos], no clasificados en otra parte',
    code_3: 'X40-X49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X43',
    level: 4,
    description:
      'Envenenamiento accidental por, y exposici\u00f3n a otras drogas que act\u00faan sobre el sistema nervioso aut\u00f3nomo',
    code_3: 'X40-X49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X44',
    level: 4,
    description:
      'Envenenamiento accidental por, y exposici\u00f3n a otras drogas, medicamentos y sustancias biol\u00f3gicas, y los no especificados',
    code_3: 'X40-X49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X45',
    level: 4,
    description: 'Envenenamiento accidental por, y exposici\u00f3n al alcohol',
    code_3: 'X40-X49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X30',
    level: 4,
    description: 'Exposici\u00f3n al calor natural excesivo',
    code_3: 'X30-X39',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X31',
    level: 4,
    description: 'Exposici\u00f3n al fr\u00edo natural excesivo',
    code_3: 'X30-X39',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X32',
    level: 4,
    description: 'Exposici\u00f3n a rayos solares',
    code_3: 'X30-X39',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X33',
    level: 4,
    description: 'V\u00edctima de rayo',
    code_3: 'X30-X39',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W37',
    level: 4,
    description:
      'Explosi\u00f3n y rotura de neum\u00e1tico, tubo o manguera de goma presurizada',
    code_3: 'W20-W49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W38',
    level: 4,
    description:
      'Explosi\u00f3n y rotura de otros dispositivos presurizados especificados',
    code_3: 'W20-W49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W39',
    level: 4,
    description: 'Explosi\u00f3n de fuegos artificiales',
    code_3: 'W20-W49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W40',
    level: 4,
    description: 'Explosi\u00f3n de otros materiales',
    code_3: 'W20-W49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W41',
    level: 4,
    description: 'Exposici\u00f3n a chorro de alta presi\u00f3n',
    code_3: 'W20-W49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W42',
    level: 4,
    description: 'Exposici\u00f3n al ruido',
    code_3: 'W20-W49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W43',
    level: 4,
    description: 'Exposici\u00f3n a vibraciones',
    code_3: 'W20-W49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W44',
    level: 4,
    description:
      'Cuerpo extra\u00f1o que penetra por el ojo u orificio natural',
    code_3: 'W20-W49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X20',
    level: 4,
    description: 'Contacto traum\u00e1tico con serpientes y lagartos venenosos',
    code_3: 'X20-X29',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X21',
    level: 4,
    description: 'Contacto traum\u00e1tico con ara\u00f1as venenosas',
    code_3: 'X20-X29',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X22',
    level: 4,
    description: 'Contacto traum\u00e1tico con escorpi\u00f3n',
    code_3: 'X20-X29',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X23',
    level: 4,
    description: 'Contacto traum\u00e1tico con avispones, avispas y abejas',
    code_3: 'X20-X29',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X24',
    level: 4,
    description:
      'Contacto traum\u00e1tico con cent\u00edpodos y miri\u00e1podos venenosos (tropicales)',
    code_3: 'X20-X29',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X25',
    level: 4,
    description: 'Contacto traum\u00e1tico con otros artr\u00f3podos venenosos',
    code_3: 'X20-X29',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X10',
    level: 4,
    description:
      'Contacto con bebidas, alimentos, grasas y aceites para cocinar, calientes',
    code_3: 'X10-X19',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X11',
    level: 4,
    description: 'Contacto con agua caliente corriente',
    code_3: 'X10-X19',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X12',
    level: 4,
    description: 'Contacto con otros l\u00edquidos calientes',
    code_3: 'X10-X19',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X13',
    level: 4,
    description: 'Contacto con vapor de agua y otros vapores calientes',
    code_3: 'X10-X19',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X14',
    level: 4,
    description: 'Contacto con aire y gases calientes',
    code_3: 'X10-X19',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X15',
    level: 4,
    description: 'Contacto con utensilios dom\u00e9sticos calientes',
    code_3: 'X10-X19',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X16',
    level: 4,
    description:
      'Contacto con radiadores, ca\u00f1er\u00edas y artefactos para calefacci\u00f3n, calientes',
    code_3: 'X10-X19',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X00',
    level: 4,
    description:
      'Exposici\u00f3n a fuego no controlado en edificio u otra construcci\u00f3n',
    code_3: 'X00-X09',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X01',
    level: 4,
    description:
      'Exposici\u00f3n a fuego no controlado en lugar que no es edificio u otra construcci\u00f3n',
    code_3: 'X00-X09',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X02',
    level: 4,
    description:
      'Exposici\u00f3n a fuego controlado en edificio u otra construcci\u00f3n',
    code_3: 'X00-X09',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W85',
    level: 4,
    description:
      'Exposici\u00f3n a l\u00edneas de transmisi\u00f3n el\u00e9ctrica',
    code_3: 'W85-W99',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W86',
    level: 4,
    description:
      'Exposici\u00f3n a otras corrientes el\u00e9ctricas especificadas',
    code_3: 'W85-W99',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W87',
    level: 4,
    description: 'Exposici\u00f3n a corriente el\u00e9ctrica no especificada',
    code_3: 'W85-W99',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W88',
    level: 4,
    description: 'Exposici\u00f3n a radiaci\u00f3n ionizante',
    code_3: 'W85-W99',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X46',
    level: 4,
    description:
      'Envenenamiento accidental por, y exposici\u00f3n a disolventes org\u00e1nicos e hidrocarburos halogenados y sus vapores',
    code_3: 'X40-X49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X47',
    level: 4,
    description:
      'Envenenamiento accidental por, y exposici\u00f3n a otros gases y vapores',
    code_3: 'X40-X49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X48',
    level: 4,
    description:
      'Envenenamiento accidental por, y exposici\u00f3n a plaguicidas',
    code_3: 'X40-X49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X49',
    level: 4,
    description:
      'Envenenamiento accidental por, y exposici\u00f3n a otros productos qu\u00edmicos y sustancias nocivas, y los no especificados',
    code_3: 'X40-X49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X34',
    level: 4,
    description: 'V\u00edctima de terremoto',
    code_3: 'X30-X39',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X35',
    level: 4,
    description: 'V\u00edctima de erupci\u00f3n volc\u00e1nica',
    code_3: 'X30-X39',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X36',
    level: 4,
    description:
      'V\u00edctima de avalancha, derrumbe y otros movimientos de tierra',
    code_3: 'X30-X39',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W45',
    level: 4,
    description: 'Cuerpo extra\u00f1o que penetra a trav\u00e9s de la piel',
    code_3: 'W20-W49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W46',
    level: 4,
    description: 'Contacto traum\u00e1tico con aguja hipod\u00e9rmica',
    code_3: 'W20-W49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X26',
    level: 4,
    description:
      'Contacto traum\u00e1tico con animales y plantas marinas venenosos',
    code_3: 'X20-X29',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X27',
    level: 4,
    description:
      'Contacto traum\u00e1tico con otros animales venenosos especificados',
    code_3: 'X20-X29',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X28',
    level: 4,
    description:
      'Contacto traum\u00e1tico con otras plantas venenosas especificadas',
    code_3: 'X20-X29',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X29',
    level: 4,
    description:
      'Contacto traum\u00e1tico con animales y plantas venenosos no especificados',
    code_3: 'X20-X29',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X17',
    level: 4,
    description: 'Contacto con m\u00e1quinas, motores y herramientas calientes',
    code_3: 'X10-X19',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X18',
    level: 4,
    description: 'Contacto con otros metales calientes',
    code_3: 'X10-X19',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X19',
    level: 4,
    description:
      'Contacto con otras sustancias calientes, y las no especificadas',
    code_3: 'X10-X19',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X03',
    level: 4,
    description:
      'Exposici\u00f3n a fuego controlado en lugar que no es edificio u otra construcci\u00f3n',
    code_3: 'X00-X09',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X04',
    level: 4,
    description:
      'Exposici\u00f3n a ignici\u00f3n de material altamente inflamable',
    code_3: 'X00-X09',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X05',
    level: 4,
    description:
      'Exposici\u00f3n a ignici\u00f3n o fusi\u00f3n de ropas de dormir',
    code_3: 'X00-X09',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X06',
    level: 4,
    description:
      'Exposici\u00f3n a ignici\u00f3n o fusi\u00f3n de otras ropas y accesorios',
    code_3: 'X00-X09',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X08',
    level: 4,
    description: 'Exposici\u00f3n a otros humos, fuegos o llamas especificados',
    code_3: 'X00-X09',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X09',
    level: 4,
    description: 'Exposici\u00f3n a humos, fuegos o llamas no especificados',
    code_3: 'X00-X09',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W89',
    level: 4,
    description:
      'Exposici\u00f3n a fuente de luz visible y ultravioleta, de origen artificial',
    code_3: 'W85-W99',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W90',
    level: 4,
    description: 'Exposici\u00f3n a otros tipos de radiaci\u00f3n no ionizante',
    code_3: 'W85-W99',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W91',
    level: 4,
    description: 'Exposici\u00f3n a radiaci\u00f3n de tipo no especificado',
    code_3: 'W85-W99',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W92',
    level: 4,
    description: 'Exposici\u00f3n a calor excesivo de origen artificial',
    code_3: 'W85-W99',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W93',
    level: 4,
    description: 'Exposici\u00f3n a fr\u00edo excesivo de origen artificial',
    code_3: 'W85-W99',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W94',
    level: 4,
    description:
      'Exposici\u00f3n a presi\u00f3n de aire alta y baja y a cambios en la presi\u00f3n del aire',
    code_3: 'W85-W99',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X37',
    level: 4,
    description: 'V\u00edctima de tormenta catacl\u00edsmica',
    code_3: 'X30-X39',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X38',
    level: 4,
    description: 'V\u00edctima de inundaci\u00f3n',
    code_3: 'X30-X39',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X39',
    level: 4,
    description:
      'Exposici\u00f3n a otras fuerzas de la naturaleza, y las no especificadas',
    code_3: 'X30-X39',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W49',
    level: 4,
    description:
      'Exposici\u00f3n a otras fuerzas mec\u00e1nicas inanimadas, y las no especificadas',
    code_3: 'W20-W49',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'W99',
    level: 4,
    description:
      'Exposici\u00f3n a otros factores ambientales y a los no especificados, de origen artificial',
    code_3: 'W85-W99',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59'
  },
  {
    code: 'X590',
    level: 5,
    description:
      'Exposici\u00f3n a factores no especificados que causan fractura',
    code_4: 'X59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59',
    code_3: 'X58-X59'
  },
  {
    code: 'X599',
    level: 5,
    description:
      'Exposici\u00f3n a factores no especificados que causan otras lesiones y las no especificadas',
    code_4: 'X59',
    code_0: 'V01-Y99',
    code_1: 'V01-X59',
    code_2: 'W00-X59',
    code_3: 'X58-X59'
  }
];
